/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length)
/******/ 			resolves.shift()();
/******/ 		if(executeModules) {
/******/ 			for(i=0; i < executeModules.length; i++) {
/******/ 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		64: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return Promise.resolve();
/******/
/******/ 		// an Promise means "currently loading".
/******/ 		if(installedChunks[chunkId]) {
/******/ 			return installedChunks[chunkId][2];
/******/ 		}
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"AuthModal","3":"dibs-trade-onboarding","4":"favoritesCallout","5":"newPdp.es","6":"messageCenter.es","7":"dealers.es","8":"checkout","9":"finding-v2.es","10":"finding.es","11":"favorites.es","12":"projectEdit.es","13":"favoritesMain","14":"bomt.es","15":"account","16":"pdpPrint.es","17":"profileEdit.es","18":"invoice.es","19":"confirmation","20":"profile.es","21":"styleGuide.es","22":"cart.es","23":"home.es","24":"photos.es","25":"nydc.es","26":"dealerApplication","27":"project.es","28":"tradeSourcing.es","29":"about","30":"genericSplashPage.es","31":"gallery.es","32":"saturdayShopper","33":"buy.es","34":"enabler.es","35":"tradeReferral.es","36":"trade.es","37":"pdpSuspended.es","38":"registration","39":"creators.es","40":"contemporary.es","41":"shop","42":"collections","43":"projectPreview.es","44":"browse","45":"designersLanding.es","46":"careerApply.es","47":"sitemap","48":"designersDirectory.es","49":"error500.es","50":"error404.es","51":"errorGeneric.es","52":"dealerPostcard.es","53":"ampPdp.es","54":"ampBrowse.es","55":"apps","56":"genericContext.es","57":"findingDealer-v2","58":"findingDealer-v1","59":"checkin.es","60":"connect.es","61":"storefrontPreview.es","62":"baseStyles","63":"pdpControlP.es"}[chunkId]||chunkId) + "." + {"0":"db35a45815b9b8d5b8f9","1":"0b3d0d1a57028fda2855","2":"3d1833914d6a252ad2e5","3":"0ba01d6076dda9eb7e2f","4":"9ad971e00ad707809984","5":"94a1a804c466ad38c1a5","6":"55b1d2bfe24e9bf8c1c4","7":"38b490f7a516c3902c66","8":"02ba8d835ba1a372c616","9":"73766ac489de795fbfa1","10":"a16331c279828dc03462","11":"cee5610f14848e7dda84","12":"d707c8bbed31ba865f11","13":"1ad7b4a81bec873805ac","14":"e868acc5473ca1ef662b","15":"709864df926a641bb7c3","16":"c2fff53a1f576d67564c","17":"763fc670f1328c0bd119","18":"730f34ced76995b2d350","19":"4db8a32e55a63205c2f4","20":"112c9503638f7201dc47","21":"17d2be559bb002306df9","22":"049ad50328c6f8210523","23":"e6484d7585293f76088a","24":"17bb7bad138b0e35f0e4","25":"b8d89163e10ee0406518","26":"f1dfd0bafc2a8db230e2","27":"52055522b4a695282e59","28":"b5e3c1023621d7826c92","29":"e377d23d77d1dc420098","30":"aa1188d996d0a12e9af2","31":"8073b2fa8152f447d080","32":"945213157990ac2a4074","33":"516fd7078a2fd287ba13","34":"17472f76182b01d5fb86","35":"10558a0a0293a2321d03","36":"3e6d9ae5ee0b233dbc2b","37":"796be693c3c0c97dbb84","38":"9a19c2112431c9a4619a","39":"da12193317bf4582de98","40":"c9dbd96731127fd970c9","41":"9f01f6e62783aeb4c0fc","42":"1ec99e35beb19844e94d","43":"c41704632a4f3d6dd792","44":"4eb926ad08d3680aab48","45":"baa2dc58e63f36b87a89","46":"60a1a41212c525d0dc09","47":"d5d1dfb8bdacb21b65d4","48":"59c35c7eaaccffadf4fe","49":"91e1dd987b30558a57bf","50":"b35ec513bdfc972d310d","51":"1cf9a4a7fbe0641f3146","52":"7d477322d416b62a626f","53":"bd1ee608fa6f3b79ab77","54":"2fa62f936cc26da4d53d","55":"51c4706c4ad8ff2b7c93","56":"bf355b34499baaf1ab82","57":"6060c08ba51a8128af87","58":"f747f905110680235675","59":"5874c2282af9cbbdc849","60":"1d2c4257aa698010c0d7","61":"a737e9071e1eaddcac62","62":"9c1fad1d4c1a261ed59c","63":"5e36cdd62daad85af703"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunks[chunkId][2] = promise;
/******/
/******/ 		head.appendChild(script);
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://a.1stdibscdn.com/assets/c/cjs/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4313);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(26);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * 1stdibs
 * User: James
 * Date: 2/19/13
 */


/**
 * Standard extension Backbone.AssociatedModel with functionality
 * to make your life easier working with services. 
 *
 * @class SoaModel
 * @extends Backbone.AssociatedModel
 *
 * @property {string} currentAction
 *      The current action is a public property that is set when
 *      fetch / save / delete is invoked on the model. This is used with the urls map to find the
 *      appropriate endpoint. TEST 1
 * @property {object} urls
 *      In inherited models, this should be a hash map of actions to URLs.
 *      For example, urls['fetch'] = "/path/to/GET/thing".
 * @property {object} transformer
 *      An optional object of mapping you can include in your models to configure
 *      differences between a client side and server side contract. To take advantage
 *      of this, init you instance of SoaModel with an instance of bunsen.contractTransformer.
 *      For example, transformer = new bunsen.contractTransformer(mapOrFunction)
 * @property {boolean} dotNotation
 *      enable dot notation for gets
 * @property {boolean} removeStoreDupes
 *      When you call "set", if you are changing the id of a model, then this property tells
 *      the set method to remove the likely duplicate model from the Backbone.Relational.store
 *      instance.
 */
(function (root, factory) {
    "use strict";
    var _;
    var _exports;
    var Backbone;
    var _module;
    /**
     * Gets called automatically on initialization. We call the parent and then
     * bind an event to 'sync' so that we can save a copy of the last sync attributes
     */
    var constructor = function (attributes, options) {
        var relations = _.result(this, 'relations');
        this.relations = relations;
        Backbone.AssociatedModel.prototype.constructor.call(this, attributes, options);
        this._lastSyncAttrs = this.toJSON();
        this.on('sync', function () {
            this._lastSyncAttrs = this.toJSON();
        });

        // Set the transformer:
        if (options) {
            this.transformer = options.transformer ? options.transformer : null;
        } else {
            this.transformer = null;
        }
    };

    if (true) {
        Backbone = __webpack_require__(3);
        _ = __webpack_require__(0);
        module.exports = _exports = Backbone.AssociatedModel.extend({constructor: constructor});
        // CommonJS
        factory(
            module,
            __webpack_require__(3), // exports Backbone
            _,
            __webpack_require__(5),
            __webpack_require__(21)
        );
        _exports = module.exports;
    } else {
        Backbone = root.Backbone;
        _ = root._;
        _exports = Backbone.AssociatedModel.extend({constructor: constructor});
        // Use different var name to prevent hoisting
        _module = { exports: _exports };
        // Browser globals
        factory(_module,
            root.Backbone,
            root._,
            root.$,
            root.bunsen
        );
        _exports = _module.exports;
    }

    root.bunsen = root.bunsen || {};
    root.bunsen.SoaModel = _exports;
}(typeof window === 'undefined' ? global : window, function (module, Backbone, _, $, bunsenLib) {
    "use strict";

    var createRel, omitToJSON;

    //noinspection JSClosureCompilerSyntax

    var SoaModel = module.exports;

    _.extend(SoaModel.prototype, /** @ignore */{
        _lastSyncAttrs: {},

        // The current action is a public property that is set when fetch / save / delete is invoked on the model. This
        // is used with the urls map to find the appropriate endpoint.
        currentAction: 'fetch',

        // In inherited models, this should be a hash map of actions to URLs.
        // For example: "fetch" : "/path/to/GET/thing"
        urls: {},

        /**
         * Instead of specifying one URL property on SOA model, we use a function based on
         * the URLs map to determine the right endpoint
         * @memberOf SoaModel#
         */
        url: function () {
            return this.urls[this.currentAction];
        },

        // An optional object or mapping you can include in your models to configure differences between a client side
        // and server side contract. To take advantage of this, init your instance of SoaModel with an instance of
        // bunsen.contractTransformer, ie. {transformer : new bunsen.contractTransformer(mapOrFunction)}

        transformer : null,

        // Enable dot notation for gets
        dotNotation : true,

        // When you call 'set', if you are changing the id of a model, then this property tells
        // the set method to remove the likely duplicate model from the Backbone.Relational.store instance
        removeStoreDupes : true,

        /**
         * @param {object} [options]
         * @param {string} [actionName] Sets the current action
         * @memberOf SoaModel#
         * @returns {$.Deferred.promise}
         */
        fetch: function (options, actionName) {
            this.currentAction = actionName || 'fetch';
            return SoaModel.__super__.fetch.call(this, options);
        },

        /**
         * @param attributes
         * @param options
         * @param {string} [actionName='save'] - sets the current action
         * @memberOf SoaModel#
         * @returns {$.Deferred.promise}
         */
        save: function (attributes, options, actionName) {
            this.currentAction = actionName || 'save';

            return SoaModel.__super__.save.call(this, attributes, options);
        },
        /**
         * @param {string} method
         *      if not a GET or PATCH, use regular sync, but add the attrs to the
         *      options, which will force this to send the JSON specified
         * @param {Backbone.Model} model
         * @param {object} passedOptions
         * @memberOf SoaModel#
         * @returns {$.Deferred.promise}
         */
        sync : function (method, model, passedOptions) {
            var tokenObj;
            var options = _.extend({}, passedOptions);

            // Add query params to the URL
            if (options.queries) {
                options.url = bunsenLib.extendURL(options.url || _.result(this, 'url'), options.queries);
            }

            // Append the user token to the URL.
            if ((tokenObj = this.getTokenObj())) {
                if (method === 'read') {
                    _.defaults(options, {data: {}});
                    options.data = _.defaults({}, options.data, tokenObj);
                } else {
                    options.url = bunsenLib.extendURL(options.url || _.result(model, 'url'), tokenObj);
                }
            }

            // If custom attributes were not specified and this is a POST or PUT, use omitToJSON
            // to automatically remove attributes that the models specify to not be sent with
            // the 'omitFromSave' and 'saveJSONFields' relation options
            if ((!options || !options.attrs) && (method === 'create' || method === 'update')) {
                if (!options) { options = {}; }
                options.attrs = omitToJSON.call(this, this);
            }

            return SoaModel.__super__.sync.call(this, method, model, options);
        },

        /**
         * @deprecated Just use save and pass queries object
         * @memberOf SoaModel#
         * @returns {$.Deferred.promise}
         */
        saveWithQueryParameters : function (attributes, options, actionName) {
            return this.save(attributes, options, actionName);
        },

        /**
         * Find a parent the first instance matching a constructor
         * @param construct
         * @memberOf SoaModel#
         * @returns {Backbone.AssociatedModel}
         */
        findParent : function (construct) {
            construct = (typeof construct === 'string') ? bunsenLib.getNamespacedValue(construct) : construct;

            // If the parents array is empty, then check for a collection with parents:
            if ((!this.parents.length) && (this.collection) && (this.collection.parents.length)) {
                return _.findWhere(this.collection.parents, { constructor  : construct });

            // Otherwise, check the parents of the model iteself.
            }
            return _.findWhere(this.parents, { constructor  : construct });
        },

        /**
         * If the parents is a single length array, return the instance, otherwise return
         * the array of parents
         * @memberOf SoaModel#
         * @returns {Backbone.AssociatedModel|Backbone.AssociatedModel[]}
         */
        getParent: function () {
            if (this.parents && this.parents.length === 1) {
                return this.parents[0];
            }
            return this.parents;
        },

        /**
         * Same as Backbone.Model.prototype.set, except that if the key has a
         * '.' (dot notation) this will attempt to set the property on a nested
         * submodule where the pattern is '<submodel_name>.<submodel_key>'
         * So for, example item.set('pricing.currency', 'US') would be equivalent
         * to item.get('pricing').set('currency', 'US'). Additionally, a new
         * option for mergeHasOne is allowed, which will set merge a nested
         * object in your value or attributes param with an existing attribute
         * instead of overwriting it.
         * @param {string|object} key
         *      A string key to set or an object map of the attributes to set
         * @param {*} [val]
         * @param {object} [options]
         * @memberOf SoaModel#
         * @returns {SoaModel}
         */
        set: function (key, val, options) {
            var segs, model, opts, obj = {};
            if (typeof key === 'string' && key.indexOf('.') !== -1) {
                segs = key.split('.');
                model = this;

                while (segs.length > 1 && model) {
                    model = model.get(segs.shift());
                }

                model.set(segs.shift(), val, options);

                return this;
            }
            opts = options || ((key && val && typeof key === "object" && typeof val === "object") ? val : {});
            if (typeof key === "object") { obj = key; } else { obj[key] = val; }
            return SoaModel.__super__.set.call(this, obj, opts);
        },
        /**
         * Return a copy of the model attributes at the time of the last
         * 'sync' event. Useful for reverting a model to it's state at the
         * time of the last sync with the api when your application
         * @memberOf SoaModel#
         * @returns {object}
         */
        lastSyncAttributes : function () {
            return this._lastSyncAttrs;
        },

        /**
         * Determine if model has changed since last sync. if attrs is passed,
         * only compare the passed attrs. Return list of changed attrs.
         * @memberOf SoaModel#
         * @param {string[]} [attrs]
         * @return {boolean}
         */
        changedSinceLastSync: function (attrs) {
            var comparingAttrs = attrs || _.keys(this.attributes),
                changed = [],
                self = this;
            _.each(comparingAttrs, function (attr) {
                var modelProperty = self.get(attr);

                if (modelProperty instanceof Backbone.Model) {
                    modelProperty = modelProperty.toJSON();
                }
                if (!_.isEqual(modelProperty, self._lastSyncAttrs[attr])) {
                    changed.push(attr);
                }
            });
            return _.isEmpty(changed) ? false : changed;
        },

        /**
         * Retrieves the token query params
         * object for the current user. If
         * no token object has been set, defers
         * to the bunsen.getToken function.
         * @return {object}
         */
        getTokenObj: function () {
            return this._tokenObject || bunsenLib.getToken();
        },

        /**
         * Sometimes the token needs to be set
         * manually, instead of relying on a 
         * cookie. This can be done with this
         * method.
         * @param {string} token The user's token
         * @param {string} [key=userToken]
         *        The query param name for the token
         * @returns {SoaModel}
         */
        setToken: function (token, key) {
            key = key || 'userToken';
            if (!token) {
                this._tokenObject = null;
                return this;
            }
            this._tokenObject = {};
            this._tokenObject[key] = token;
            return this;
        },

        /**
         * Special parse function for SOA model does 2 things:
         *      1- Retreive the data object from the server response (usually nested under a "result" attribute)
         *      2- Apply an optional mapping to the JSON data.
         *
         * @param data
         * @memberOf SoaModel#
         * @returns {object}
         */
        parse : function (data) {
            var result = {};
            var isServiceWrapper;

            // If the response was empty, return an empty object
            if (_.isEmpty(data)) {
                return {};
            }

            // New style service response uses the result property :
            isServiceWrapper = typeof data.result !== 'undefined' || data.apiType === 'serviceResponse';

            if (isServiceWrapper) {
                result = this._getServiceData(data);

            } else {
                result = this._getLegacyServiceData(data);

                // If we didn't find the result in the location specified by service response, then use the top level
                // object. Takes care of BB Associations parse called on nested models / collections.
                if (_.isEmpty(result)) {
                    return data;
                }
            }

            if (this.transformer) {
                result = this.transformer(result, 'read');
            }

            return result;
        },

        /**
         * Private function to get service response data from the expected location which is the "result" property.
         * @param data
         * @returns {*}
         * @private
         */
        _getServiceData : function (data) {
            var result;

            // Look out for responses nested an extraneous layer, like "dataList"
            if (_.size(data.result) === 1 && !data.result.apiType && _.isObject(data.result[_.keys(data.result)[0]])) {
                result = data.result[_.keys(data.result)[0]];
            } else {
                result = data.result;
            }

            return result || {};
        },

        /**
         * Private function to get service response data from legacy contracts such as the form service or query
         * service. These old services would use the property "form" or "row" for data.
         * @param data
         * @returns {{}}
         * @private
         */
        _getLegacyServiceData : function (data) {
            var rowKey;
            var result = {};

            var keys = (data && typeof data === 'object') ? _.keys(data) : false;

            // If there was a "form" attribute (from the form service) - then use that...
            if (data.form && data.formCode) {
                result = data.form;
            }

            // If the result is under the "row" attribute (query service)
            else if (data.row) {
                if (_.size(data.row) === 1) {
                    result = data.row[_.keys(data.row)[0]];
                } else {
                    result = data.row;
                }
            }

            // If the result object is still empty, attempt to look through the data attributes one by one for the "row"
            // attribute
            if (_.isEmpty(result) && keys) {
                rowKey = keys.shift();
                while (rowKey) {
                    if (data[rowKey] && data[rowKey].row) {
                        result = data[rowKey].row;
                    }
                    rowKey = keys.shift();
                }
            }
            return result;
        },

        /**
         * Same thing as toJSON, except it goes through relations and looks for an
         * 'omitFromSave' boolean property on the relation object. If true, this
         * field will not be added to the output. Additionally, looks
         * at a relation's 'saveJSONFields' property, if present, and grabs only
         * those objects for the output.
         * @private
         * @memberOf SoaModel#
         * @returns {object}
         */
        _omitToJSON : function () {
            return omitToJSON.call(this, this);
        },

        /**
         * @description Returns true if all fields are present and holding
         * truthy values. If a field can legitimately hold `false` or 0 or ''
         * don't use this function to check it's presence.
         * @param {Array} fields An array of field names to test
         * @returns {boolean}
         */
        hasTruthyFields: function (fields) {
            return _.every(fields, function (field) {
                return this.get(field) || false;
            }, this);
        }
    });

    /**
     * Create a basic relation from strings.
     * A string is converted into a one-to-one
     * relation and uses the 'SoaModel' as
     * the relatedModel.
     * If one of the relations passed is an
     * object, that object will be used.
     * @memberOf SoaModel
     * @param rels
     * @returns {Array}
     */
    SoaModel.createRelations = function (rels) {
        var i = 0, len = rels.length, newRels = [];
        for (i; i < len; i++) {
            newRels[i] = createRel(rels[i]);
        }
        return newRels;
    };

    createRel = function (rel) {
        var key, val, res = {}, isStd = false;
        if (_.isObject(rel)) {
            for (key in rel) {
                if (rel.hasOwnProperty(key)) {
                    val = rel[key];
                    if (_.isArray(val)) {
                        res.key = key;
                        res.relatedModel = SoaModel.extend({
                            relations: SoaModel.createRelations(val)
                        });
                        break;
                    }
                    isStd = true;
                    break;
                }
            }
            if (isStd) { return rel; }
        }

        res.type = Backbone.One;
        if (typeof rel === 'string') {
            res.key = rel;
            res.relatedModel = SoaModel;
        }
        return res;
    };
    omitToJSON = function (model) {
        var key, attr, omitLen,
            i = -1,
            relations = model.relations,
            len = relations ? relations.length : 0,
            omitKeys = [],
            attrs = model.attributes,
            pickFields = {},
            fieldJson = {},
            json = {};
        while (++i < len) {
            if (relations[i].omitFromSave) {
                omitKeys.push(relations[i].key);
            }
            if (relations[i].saveJSONFields) {
                pickFields[relations[i].key] = relations[i].saveJSONFields;
            }
        }
        omitLen = omitKeys.length;
        for (key in attrs) {
            if (attrs.hasOwnProperty(key)) {
                attr = attrs[key];
                if (typeof attr === 'object' && attr !== null) {
                    if (!omitLen || _.indexOf(omitKeys, key) === -1) {
                        if (attr instanceof Backbone.AssociatedModel) {
                            fieldJson = omitToJSON.call(this, attr);
                            json[key] = (pickFields[key]) ? _.pick(fieldJson, pickFields[key]) : fieldJson;
                        } else if (attr instanceof Backbone.Collection) {
                            json[key] = [];
                            i = -1;
                            len = attr.models.length;
                            while (++i < len) {
                                fieldJson = omitToJSON.call(this, attr.models[i]);
                                json[key].push(pickFields[key] ? _.pick(fieldJson, pickFields[key]) : fieldJson);
                            }
                        } else {
                            json[key] = _.clone(attr);
                        }
                    }
                } else {
                    json[key] = attr;
                }
            }
        }
        return json;
    };

}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(70)(module)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2702);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(101);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = window.jQuery;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * These endpoints are paths only
 * Consumers of these endpoints are responsible for adding any needed queryString
 *
 * @memberof bunsen
 * @namespace endpoints
 */



var ends = {};
var soa = '/soa';
var services = '/services';
var query = 'queryservice';
var json = 'json';
var usercomm = 'usercomm/1';
var usercommv3 = 'usercomm/3';
var form = 'formservice';
var cms = 'cms';
var portfolio = 'portfolio';
var portfolios = 'portfolios';
var creator = 'creator';
var boss11 = 'boss/1.1';
var userservice = 'userservice';
var item = 'itemservice';
var masqueradeSeller = 'masquerade_seller';
var Qs = __webpack_require__(42);
var isArray = __webpack_require__(64);
var isEmpty = __webpack_require__(2657);
var versions = __webpack_require__(2659);
var latest = versions.latest;
var latestServices = versions.latestServices;

function uriJoin() {
    return Array.prototype.slice.call(arguments).join('/');
}

ends.cmsUpload = function (type, dir) {
    var args = [soa, boss11, 'upload'];

    if (type) {
        args.push(type);
    }
    if (dir) {
        args.push(dir);
    }
    return uriJoin.apply(null, args);
};

/**
 * Newer endpoint to upload images for items.
 * @returns {string|boolean}
 */
ends.itemImageUpload = function () {
    return uriJoin(soa, latest.inventoryFileUpload, 'images', 'upload');
};

ends.sellerStatuses = function () {
    return uriJoin(soa, latest.identity, 'seller', 'statuses');
};

/**
 * Endpoint to upload images. You must pass a type (e.g. "general" or "dealers")
 * NOTE: If you use this endpoint in .com, keep in mind that Array.prototype.indexOf
 * is not fully supported in IE8.
 * @param {string} type
 * @param {number} sellerId
 * @returns {string|boolean}
 * @throws Will throw an error if no `sellerId` argument is passed and `type` = 'dealers' || 'dealer_logo'
 */
ends.uploadImages = function (type, sellerId) {
    var types = ['general', 'cms', 'editorial', 'dealers', 'dealer_logo'];

    if ((types.indexOf(type)) !== -1) {
        if ((type === 'dealers' || type === 'dealer_logo')) {
            if (!sellerId) {
                throw new Error('seller Legacy Id required to create endpoint if type is "dealers"');
            }

            type = (type === 'dealers') ? 'dealer_image_upload' : 'general_image_upload/' + type;
            return '/image/ajax/' + type + '?seller_id=' + sellerId;
        }
        return '/image/ajax/general_image_upload/' + type;
    } else {
        return false;
    }
};

/**
 * Returns message contact imaging endpoint.
 * @returns {string}
 */
ends.contactImaging = function () {
    return '/old-dealer-admin/libraries/ajax/imaging_contact.php';
};

/**
 * Modify image (rotate, eventually crop).
 */
ends.processImage = function (itemId, photoId) {
    return uriJoin(ends.item(itemId), 'image', photoId, 'process');
};

/**
 * Download an image. Accepts the path to the image as a get param.
 * @param itemId
 * @param imageId
 * @param imgUrl
 * @returns {string}
 */
ends.downloadOriginal = function (itemId, imageId) {
    return uriJoin(soa, latest.inventoryFileUpload, 'image', imageId, 'download');
};

/**
 * Add, remove or reorder photos and images.
 */
ends.photos = function (itemId) {
    return uriJoin(soa, latest.inventory, 'item', itemId, 'images');
};

/**
 * Save item images (different permissions)
 */
ends.updateItemImages = function () {
    return uriJoin(services, item, 'save_item_images');
};

ends.process = function () {
    return uriJoin(soa, boss11, 'process');
};

ends.getSingleProcess = function (id) {
    return uriJoin(soa, boss11, 'process', id);
};

ends.getAllProcesses = function () {
    return uriJoin(soa, boss11, 'process');
};

ends.getProcessTypes = function () {
    return uriJoin(soa, boss11, 'process', 'types');
};

ends.messageGET = function (options) {
    console.assert(options.message, "messageGET endpoint expects an argument like {message: messageId}");
    return [soa, latest.messagecenter, 'message', options.message].join('/');
};
ends.messagePOST = function (options) {
    console.assert(options.conversation, "messagePOST endpoint expects an argument like {conversation: conversationId}");
    return [soa, latest.messagecenter, 'message', 'web', options.conversation].join('/');
};
ends.messageNewConversation = function () {
    return [soa, latest.messagecenter, 'message'].join('/');
};
ends.conversations = [soa, latestServices.messagecenter + '/2', 'conversations'].join('/');
ends.markReadUnread = [soa, latest.messagecenter, 'message', 'markReadUnread'].join('/'); //?conversationIds=201
ends.flagMessage = [soa, latest.mcFlagMessage, 'message', 'flag'].join('/');
ends.conversation = function (id, options) {
    options = options || {};
    return uriJoin(soa, latestServices.messagecenter + '/2', 'conversation', id) + (isEmpty(options.params) ? '' : '?' + Qs.stringify(options.params));
};
ends.conversationFilter = function () {
    return [soa, latestServices.messagecenter, '2', 'conversation', 'filter'].join('/');
};

ends.pushNotification = function (isBulk) {
    if (isBulk) {
        return uriJoin(soa, usercomm, 'push', 'bulk');
    }
    return uriJoin(soa, usercomm, 'push');
};

ends.dealerNotification = function (isBulk) {
    var endpoint = uriJoin(soa, latest.usercomm, 'send');
    if (isBulk) {
        endpoint = uriJoin(endpoint, 'bulk');
    }
    return endpoint;
};

ends.conversationMembers = function (ids) {
    if (undefined !== ids && !isArray(ids)) {
        ids = [ids];
    }
    return [soa, latest.messagecenter, 'member?'].join('/') + Qs.param({memberIds: ids.join(',')});
};
ends.conversationUnsubscribe = function () {
    return [soa, latest.messagecenter, 'member', 'unsubscribe'].join('/');
};
ends.note = function (id, service) {
    service = service || latest.identity;
    return uriJoin(soa, service, 'note', id);
};

ends.notes = function (service) {
    service = service || latest.identity;
    return uriJoin(soa, service, 'notes');
};

ends.notesByAnchor = function (anchor, service) {
    service = service || latest.identity;
    return uriJoin(soa, service, 'notes', anchor);
};

ends.address = function (id) {
    return uriJoin(soa, latest.identity, 'address', id);
};

ends.zipCode = function () {
    return uriJoin(soa, latest.identity, 'address', 'resolve', 'zip');
};

ends.addressBook = function (userId, addressType, addressId) {
    var uriArgs;
    if (!userId) {
        return false;
    }
    uriArgs = [soa, latest.identity, 'user', userId, 'addressBook'];

    if (addressType) {
        uriArgs.push(addressType);
        //nested because addressId depends on addressType being there first
        if (addressId) {
            uriArgs.push(addressId);
        }
    }

    return uriJoin.apply(this, uriArgs);
};

ends.returnPolicy = function (id) {
    return uriJoin(soa, latest.identity, 'returnPolicy', id);
};

ends.itemsReturnPolicy = function () {
    return uriJoin(soa, latest.inventoryItem, 'items', 'returnPolicy');
};

ends.sellerReturnPolicy = function (sellerId) {
    return uriJoin(ends.seller(sellerId), 'returnPolicy');
};

ends.adjustmentsForItemByType = function (itemId, type) {
    return uriJoin(soa, latest.ecom, 'adjustments', type, itemId);
};

ends.computeAdjustments = function () {
    return uriJoin(soa, latest.ecomTransaction, 'transaction', 'computeAdjustments');
};

ends.currencyConversion = function () {
    return uriJoin(soa, latest.ecom, 'currency', 'conversion');
};

ends.currencyConvert = function () {
    return uriJoin(soa, latest.ecomCurrency, 'currency', 'convert');
};

ends.currentRates = function () {
    return uriJoin(soa, latest.ecomCurrency, 'currency', 'conversionRateEvent', 'currentRates');
};

ends.feeStructure = function (feeStructureId) {
    return uriJoin(soa, latest.ecomCurrency, 'feeStructure', feeStructureId, 'anchors');
};

ends.feeStructures = function () {
    return uriJoin(soa, latest.ecomCurrency, 'feeStructures');
};

ends.feeStructureUpdate = function (feeStructureId, sellerId) {
    return uriJoin(soa, latest.ecomCurrency, 'feeStructure', feeStructureId, 'seller', sellerId);
};

ends.savedCard = function (userId, hashedCardNumber) {
    return uriJoin(soa, latest.identity, 'user', userId, 'creditCard', hashedCardNumber);
};

/**
 * @code /services/queryservice/item_creator_shipping.dibs
 * @memberof bunsen.endpoints
 */
ends.getItemCreatorShipping = function () {
    return uriJoin(services, query, 'item_creator_shipping.dibs');
};

/**
 * @code /services/queryservice/item_creator_woc.dibs
 * get a single item json based on iid
 */
ends.getItemByIid = function () {
    return uriJoin(services, query, 'item_creator_woc.dibs');
};

ends.dealerAnnouncements = function () {
    return uriJoin(soa, query, json, 'dealer_announcement.dibs');
};
/**
 * QueryService reference_set query.
 * used to get display values for enums
 * formerly "referenceSetJSON" from adminv2
 */
ends.referenceSet = function () {
    return uriJoin(soa, query, json, 'reference_set.dibs');
};

ends.FashionCategoryToTechnique = function () {
    return uriJoin(soa, query, json, 'fashion_cat_techniques_2.dibs');
};

ends.fashionInflatedTechniques = function () {
    return uriJoin(soa, query, json, 'fashion_techniques.dibs');
};

/**
 * Get the dealer's country id based on their seller ID.
 *
 */
ends.getDealerCountryId = function () {
    return uriJoin(soa, query, json, 'seller_geo_v2.dibs');
};

ends.transactionsSolr = function () {
    return uriJoin(soa, latest.ecomTransaction, 'transactions', 'search');
};

ends.transactionSummary = function () {
    return uriJoin(soa, latest.ecomSummary, 'transaction', 'summary');
};

ends.transaction = function () {
    return uriJoin(soa, latest.ecomTransaction, 'transaction');
};

/**
 * /soa/ecom-4/transaction/[transactionId]/history
 */
ends.transactionHistory = function (id) {
    return uriJoin(soa, latest.ecomTransaction, 'transaction', id, 'history');
};

ends.transactionDisplayCodes = function () {
    return uriJoin(ends.transaction(), 'displayCodes');
};

ends.transactionPing = function () {
    return uriJoin(ends.transaction(), 'ping');
};

ends.transactionKount = function () {
    return uriJoin(ends.transaction(), 'data.gif');
};

ends.paymentProviderClientToken = function () {
    return uriJoin(soa, latest.ecom, 'paymentProviderTransaction', 'clientToken');
};

ends.shipment = function (id) {
    return uriJoin(soa, latest.ecomLogistics, 'shipment', id);
};

ends.ecomShipmentQuote = function (id) {
    return uriJoin(soa, latest.ecomLogistics, 'shipmentQuote', id);
};
ends.shipmentQuote = function (id) {
    return uriJoin(soa, latest.logisticsShipping, 'shipmentQuote', id);
};

ends.shipmentQuotes = function () {
    return uriJoin(soa, latest.logisticsShipping, 'shipmentQuotes');
};

ends.shippingCosts = function () {
    return uriJoin(soa, latest.logisticsShipping, 'shippingCosts');
};

ends.computeShipmentQuoteSubTotal = function () {
    return uriJoin(soa, latest.logisticsShipping, 'shipmentQuote', 'compute');
};

ends.availableOptions = function () {
    return uriJoin(soa, latest.logisticsShipping, 'shipmentQuote', 'availableOptions');
};

/**
 * /soa/ecom-t2/2/shipmentQuote/determineRegion
 * @memberof bunsen.endpoints
 */
ends.determineRegion = function () {
    return uriJoin(soa, latest.ecom, 'shipmentQuote', 'determineRegion');
};

ends.serviceMethod = function (id) {
    return uriJoin(soa, latest.ecom, 'serviceMethod', id);
};

/**
 * @memberof bunsen.endpoints
 * @param offerId
 * @returns {string}
 */
ends.offer = function (offerId) {
    return uriJoin(soa, latest.ecom, 'offer', offerId);
};

ends.paymentAuthorization = function (id) {
    return uriJoin(soa, latest.ecom, 'paymentAuthorization', id);
};

ends.paymentMethod = function () {
    return uriJoin(soa, latest.ecom, 'paymentMethod');
};

ends.review = function (id) {
    return uriJoin(soa, latest.ecom, 'review', id);
};

ends.refund = function (id) {
    return uriJoin(soa, latest.ecom, 'refund', id);
};

ends.inventoryReview = function (id) {
    return uriJoin(soa, latest.inventoryReviews, 'review', id);
};

ends.designFirmsList = function () {
    return uriJoin(soa, latest.trade, 'design', 'firms');
};

ends.designProjectsList = function () {
    return uriJoin(soa, latest.trade, 'design', 'projects');
};

ends.designFirm = function (id) {
    return uriJoin(soa, latest.trade, 'design', 'firm', id);
};

ends.designFirmIndex = function (id) {
    return uriJoin(soa, latest.trade, 'design', 'firms', 'index', id);
};

function baseDesignFirm (id, type) {
    return uriJoin(soa, latest.trade, 'design', 'firm', id, type);
};

ends.designFirmBasic = function (id) {
    return baseDesignFirm(id, 'basic');
};

ends.designFirmAddress = function (id) {
    return baseDesignFirm(id, 'address');
};

ends.designFirmArticles = function (id) {
    return baseDesignFirm(id, 'articles');
};

ends.designFirmProject = function (id) {
    return baseDesignFirm(id, 'project');
};

ends.designFirmProjects = function (id) {
    return baseDesignFirm(id, 'projects');
};

ends.designFirmAwards = function (id) {
    return baseDesignFirm(id, 'awards');
};

ends.designFirmEmployees = function (id) {
    return baseDesignFirm(id, 'employees');
};

ends.designFirmMedia = function (id) {
    return baseDesignFirm(id, 'media');
};

ends.designFirmPortfolios = function (id) {
    return baseDesignFirm(id, 'portfolios');
};

ends.designFirmProfile = function (id) {
    return baseDesignFirm(id, 'profile');
};

ends.designFirmWeblinks = function (id) {
    return baseDesignFirm(id, 'weblinks');
};

ends.designFirmInstagram = function (id) {
    return baseDesignFirm(id, 'instagram');
};

ends.designAwards = function () {
    return uriJoin(soa, latest.trade, 'awards');
};

ends.designProject = function (id) {
    return uriJoin(soa, latest.trade, 'design', 'project', id);
};

function baseDesignProject (id, type) {
    return uriJoin(soa, latest.trade, 'design', 'project', id, type);
};

ends.designProjectBasic = function (id) {
    return baseDesignProject(id, 'basic');
};

ends.designProjectAddress = function (id) {
    return baseDesignProject(id, 'address');
};

ends.designProjectProfile = function (id) {
    return baseDesignProject(id, 'profile');
};

ends.designAttributes = function (id) {
    return uriJoin(soa, latest.inventory, 'attribute');
};

ends.tradeAssociations = function () {
    return uriJoin(soa, latest.identityTrade, 'tradeAssociations');
};

ends.sellerTradeAssociations = function (id) {
    return uriJoin(soa, latest.identityTrade, 'seller', id, 'tradeAssociations');
};

ends.invoice = function (id) {
    return uriJoin(soa, latest.ecom, 'invoice', id);
};

ends.disbursement = function (id) {
    return uriJoin(soa, latest.ecom, 'disbursement', id);
};

ends.registerSeller = function (vertical) {
    return uriJoin(soa, latest.identity, 'seller', vertical);
};

/**
 * Identity endpoints
 * @memberof bunsen.endpoints
 * @param id
 * @return {string}
 */
ends.seller = function (id) {
    return uriJoin(soa, latest.identityShipping, 'seller', id);
};

ends.sellerTwentyFirstCenturyStatus = function (id) {
    return uriJoin(ends.seller(id), 'twentyFirstCenturyStatus');
};

ends.seller31 = function (id) {
    return uriJoin(soa, latest.identityLogistics, 'seller', id);
};

ends.userLogin = function () {
    return uriJoin(soa, latest.identity, 'user', 'login');
};

ends.userRegister = function (email) {
    var uri = uriJoin(soa, latest.identity, 'user');
    if (email) {
        uri += '?' + Qs.stringify({email: email});
    }
    return uri;
};

ends.wallet = function (id) {
    return uriJoin(soa, latest.identityShipping, 'user', id, 'wallet');
};

ends.walletPaymentMethod = function (userId) {
    return uriJoin(ends.wallet(userId), 'paymentMethod');
};

ends.vault = function (id) {
    return uriJoin(ends.wallet(id), 'paymentMethod', 'vault');
};

ends.sellerWallet = function (id) {
    return uriJoin(soa, latest.identityShipping, 'seller', id, 'wallet');
};

ends.sellerVault = function (id) {
    return uriJoin(ends.sellerWallet(id), 'paymentMethod', 'vault');
};

ends.sellerPaymentProfile = function (sellerID) {
    return uriJoin(soa, latest.identityHyperwallet, 'seller', sellerID, 'paymentProfile');
};

ends.report = function () {
    return uriJoin(soa, latest.boss, 'report');
};

//TODO remove after dibs-cms-dealer-storefront goes live
ends.updateDealerStorefrontProfile = function (sellerId) {
    return uriJoin(soa, latest.identityShipping, 'seller', sellerId, 'storefrontProfile');
};

ends.storefrontProfile = function (sellerId, storefrontId) {
    return uriJoin(soa, latest.identityShipping, 'seller', sellerId, 'storefrontProfile', storefrontId);
};

/**
 * Save a shipmentQuote at the seller level :
 * @param id
 * @returns {*}
 */
ends.sellerQuote = function (id) {
    return uriJoin(soa, latest.identityLogistics, 'seller', id, 'shipmentQuotes');
};

ends.sellers = function () {
    return uriJoin(soa, latest.identityShipping, 'sellers');
};

ends.sellerLogin = function () {
    return uriJoin(soa, latest.identity, 'seller', 'login');
};

/**
 * soa/identity/2.1/seller/{vertical_sellerid}/profile
 * @memberof bunsen.endpoints
 * @param id
 * return {string}
 */
ends.sellerProfile = function (id) {
    return uriJoin(soa, latest.identity, 'seller', id, 'profile');
};

ends.billItemsBySeller = function (sellerId) {
    return uriJoin(ends.seller(sellerId), 'bill');
};

ends.charges = function () {
    return uriJoin(soa, latest.identity, 'seller', 'charges');
};

ends.charge = function (sellerId) {
    return uriJoin(soa, latest.identityShipping, 'seller', sellerId, 'charge');
};

ends.updateCharge = function (chargeId) {
    return uriJoin(soa, latest.identityShipping, 'seller', 'charge', chargeId);
};

ends.statement = function () {
    return uriJoin(soa, latest.identityShipping, 'seller', 'charges');
};


/**
 * /soa/identity[version]/user/[id]
 * Note: we should always be using the /soa/identity[version]/user/[id] endpoint
 * @memberof bunsen.endpoints
 */
ends.user = function (id) {
    return uriJoin(soa, latest.identity, 'user', id);
};

/**
 * @memberof bunsen.endpoints
 * @param id
 * @returns {string}
 */
ends.buyer = ends.user;

ends.userById = function (id) {
    return uriJoin(soa, latest.identity, 'user', id);
};

ends.users = function () {
    return uriJoin(soa, latest.identity, 'users');
};

ends.userProfile = function (userId) {
    return uriJoin(ends.user(userId), 'profile');
};

ends.userProProfile = function (userId) {
    return uriJoin(ends.user(userId), 'proProfile');
};

ends.userNewsletters = function (userId) {
    return uriJoin(ends.user(userId), 'newsletters');
};

ends.userSourceAttribution = function (userId) {
    return uriJoin(ends.user(userId), 'sourceAttribution');
};

ends.userPassword = function (userId, options) {
    var uri = uriJoin(ends.user(userId), 'password');
    options = options || {};

    if (options.email) {
        uri += '?' + Qs.stringify({email: options.email});
    } else if (options.passwordToken) {
        uri += '?' + Qs.stringify({passwordToken: options.passwordToken});
    }

    return uri;
};

ends.sellerPassword = function (sellerId, options) {
    var uri = uriJoin(ends.seller(sellerId), 'password');
    options = options || {};

    if (options.email) {
        uri += '?email=' + options.email;
    } else if (options.passwordToken) {
        uri += '?passwordToken=' + options.passwordToken;
    }

    return uri;
};

// ------------------
// Logistics - aka Shipping 2
// ------------------
// Logistics - aka Shipping 2
ends.shipmentServiceMethod = function () {
    return uriJoin(soa, latest.logistics, 'shipmentServiceMethod');
};

ends.shipmentServiceMethods = function () {
    return uriJoin(soa, latest.logistics, 'shipmentServiceMethods');
};

ends.carriersBase = function () {
    return uriJoin(soa, latest.logistics, 'carriers');
};

ends.carrier = function () {
    return uriJoin(soa, latest.logistics, 'carrier');
};

ends.loadTracking = function () {
    return uriJoin(soa, latest.logisticsShipping, 'shipment', 'loadTracking');
};

ends.region = function (regionId) {
    return uriJoin(soa, latest.logistics, 'region', regionId);
};

ends.regions = function () {
    return uriJoin(soa, latest.logistics, 'regions');
};

ends.regionsForAddress = function () {
    return uriJoin(soa, latest.logistics, 'regionsForAddress');
};

/**
 * soa/identity/user/me
 * @memberof bunsen.endpoints
 */
ends.userMe = function () {
    return uriJoin(soa, latest.identity, 'user', 'me');
};

/**
 * soa/identity/user/me/profile
 * @memberof bunsen.endpoints
 */
ends.userMeProfile = function () {
    return uriJoin(soa, latest.identity, 'user', 'me', 'profile');
};

/**
 * soa/identity/1/role
 */
ends.roles = function () {
    return uriJoin(soa, latest.identity, 'role');
};

ends.role = function (id) {
    return uriJoin(ends.roles(), id);
};

/**
 * soa/identity/1/permission
 */
ends.permissions = function () {
    return uriJoin(soa, latest.identity, 'permission');
};

ends.permission = function (id) {
    return uriJoin(soa, latest.identity, 'permission', id);
};

ends.category = function (verticalId) {
    return uriJoin(soa, latest.inventoryCategories, 'category', verticalId);
};

ends.categories = function () {
    return uriJoin(soa, latest.inventoryCategories, 'categories');
};

ends.creator = function () {
    return uriJoin(soa, latest.inventoryCreators, creator);
};

ends.creatorById = function (creatorId) {
    return uriJoin(soa, latest.inventoryCreators, creator, creatorId);
};

ends.creatorList = function () {
    return uriJoin(soa, latest.inventoryCreators, 'creators');
};

ends.creatorRoles = function () {
    return uriJoin(soa, latest.inventoryCreators, creator, 'creatorRoles');
};

ends.getCreators = function () {
    return uriJoin(services, query, 'new_creators_all.dibs');
};

/**
 * Find creators based on some parameters, such as status = Approved, etc.
 */
ends.findCreators = function () {
    return uriJoin(services, query, 'find_creators.dibs');
};

/**
 * Find creators by id
 */
ends.findCreatorsById = function () {
    return uriJoin(services, query, 'creator_by_id.dibs');
};

/**
 * The following 2 endpoints get creators filtering on a string matched against the creator name.
 * Accepts either "starts_with" or "contains" parameters
 */
ends.getCreatorsNonAlphaInitials = function () {
    return uriJoin(services, query, 'creators_non_alpha_initial.dibs');
};

ends.getCreatorsByPhrase = function () {
    return uriJoin(services, query, 'creators_by_phrase.dibs');
};

ends.getCreatorsByPhraseNoCache = function () {
    return uriJoin(services, query, 'creators_by_phrase_woc.dibs');
};

/**
 * Saving an item-creator relationship. Item id with an array of objects with 'creator_id', 'attribution', 'roles' etc.
 */
ends.saveItemCreator = function () {
    return uriJoin(services, form, 'item.saveCreator');
};

/**
 * Saving a creator (name, status, url_tag, has_page) with no relationships, or a new creator
 */
ends.saveCreator = function () {
    return uriJoin(services, 'creatorservice', 'save_creator');
};

// item unknown creator endpoint
ends.unknownCreator = function () {
    return uriJoin(soa, latest.inventoryCreators, creator, 'unknown');
};

ends.inventoryRoot = function () {
    return uriJoin(soa, latest.inventory);
};

ends.changeCreator = function (previousCreator) {
    return uriJoin(soa, latest.inventoryCreators, creator, 'changeCreator', previousCreator);
};

/**
 * /soa/inventory-3/1/dimensionSet/
 * @param {number} [id]
 */
ends.dimensionSets = function (id) {
    return uriJoin(soa, latest.inventoryAttributes, 'dimensionSet') + (id ? '/' + id : '');
};

ends.materials = function (id) {
    return uriJoin(soa, latest.inventoryAttributes, 'material') + (id ? '/' + id : '');
};

ends.styles = function (id) {
    return uriJoin(soa, latest.inventoryAttributes, 'style') + (id ? '/' + id : '');
};

ends.attributesByCategory = function () {
    return uriJoin(soa, latest.inventoryAttributes, 'attribute/category');
};

ends.item = function (pk) {
    return uriJoin(soa, latest.inventoryItem, 'item', pk);
};

ends.items = function () {
    return uriJoin(soa, latest.inventoryItem, 'item');
};

ends.itemListings = function (pk) {
    return uriJoin(ends.item(pk), 'listings');
};

// IMPORTANT! THIS IS A HACK TO WORK AROUND THE WAY ITEM UPLOAD SAVES LISTINGS. DO NOT USE THIS UNLESS YOU KNOW WHAT
// YOU ARE DOING!!!
ends.cleanUpListingsAfterFailure = function (pk) {
    return uriJoin(soa, latest.inventoryItem, 'item', pk, 'cleanUpListingsAfterFailure');
};

//netPrice bulk update endpoint
ends.batchPrices = function (batchId) {
    return uriJoin(soa, latest.inventoryItem, 'prices', 'batch') + (batchId ? '/' + batchId : '');
}

/**
 * /soa/inventory/3/item
 * @param pk
 * @memberof bunsen.endpoints
 */
ends.itemWithReviews = function (pk) {
    return uriJoin(soa, latest.inventoryReviews, 'item', pk);
};

ends.itemsWithReviews = function () {
    return uriJoin(soa, latest.inventoryReviews, 'items');
};

/**
 * /soa/inventory/3/reviews
 * Retrieve reviews using filter params like itemId, type, status
 * @memberof bunsen.endpoints
 */
ends.reviews = function () {
    return uriJoin(soa, latest.inventoryReviews, 'reviews');
};

/**
 * There are no references to this method in .com, bunsen, or v2.  Will leave it here just in case.
 * @deprecated
 */
ends.getServiceMethods = function () {
    return uriJoin(soa, latest.inventory, 'shipmentQuote', 'serviceMethod');
};

ends.mailer = function (id) {
    return uriJoin(soa, latest.inventoryItem, 'item', id, 'mailer');
};

ends.itemStorefrontPreferences = function (id) {
    return uriJoin(soa, latest.inventoryItem, 'item', id, 'storefrontPreferences');
};

/**
 * There are no references to this in v2 or bunsen.  Will leave it here just in case
 * @deprecated
 */
ends.saveBulkShipping = function () {
    return uriJoin(soa, latest.inventory, 'shipmentQuotes');
};

ends.itemShipmentQuotes = function (itemId) {
    return uriJoin(soa, latest.inventoryLogistics, 'item', itemId, 'shipmentQuotes');
};

ends.solrItems = function () {
    return uriJoin(soa, latest.inventory, 'item');
};

ends.solrItem = function () {
    return uriJoin(soa, latestServices.inventory, '1', 'solr', 'items');
};

ends.release = function () {
    return uriJoin(soa, latest.inventoryCreators, 'release');
};
/**
 * @memberof bunsen.endpoints
 * @param userId
 * @returns {string}
 */
ends.permissionsByUser = function (userId) {
    return uriJoin(ends.user(userId), 'permission');
};

ends.permissionsByRole = function (roleId, permissionId) {
    return uriJoin(ends.roles(), roleId, 'permission', permissionId);
};

ends.clump = function () {
    return uriJoin(soa, form, '1', 'clump');
};

/**
 * @memberof bunsen.endpoints
 * @param template
 * @returns {string}
 */
ends.sendEmailResponsys = function (template) {
    return uriJoin(soa, usercomm, 'email', template);
};
ends.usercommToken = function () {
    return uriJoin(soa, usercomm, 'token');
};
ends.sendEmail = function (template) {
    return uriJoin(soa, latest.usercomm, 'email', template);
};
ends.geography = function () {
    return uriJoin(soa, latest.identity, 'geography');
};

ends.portfolio = function (portfolioId) {
    return uriJoin(soa, latest.identity, portfolio, portfolioId);
};

ends.portfolioItem = function (portfolioItemId) {
    return uriJoin(soa, latest.identity, portfolio, 'item', portfolioItemId);
};

ends.portfoliosByUser = function (userId) {
    return uriJoin(soa, latest.identity, 'user', userId, 'portfolio');
};
ends.portfolios = function () {
    return uriJoin(soa, latest.identity, portfolios);
};
ends.portfoliosByItem = function (itemPk) {
    return uriJoin(soa, latest.identity, portfolios, 'item', itemPk);
};
ends.portfolioItemsByPortfolio = function (portfolioId) {
    return uriJoin(soa, latest.identity, portfolio, portfolioId);
};

ends.portfolioAddItem = function (portfolioId, itemPk) {
    return uriJoin(soa, latest.identity, portfolio, portfolioId, 'item', itemPk);
};

ends.portfolioAddItemToDefault = function (userId, itemPk) {
    return uriJoin(soa, latest.identity, 'user', userId, portfolio, 'default', 'item', itemPk);
};

ends.portfolioSort = function (portfolioId) {
    return uriJoin(soa, latest.identity, portfolio, portfolioId, 'reorderItemPage');
};

ends.sharePortfolio = function (id) {
    return uriJoin(soa, latest.identity, portfolio, id, 'share');
};

ends.cmsPortfolio = function (id) {
    return uriJoin(soa, latest.identity, portfolio, cms, id);
};

ends.cartPortfolio = function (userId) {
    return uriJoin(soa, latest.identity, 'user', userId, portfolio);
};

ends.cartPortfolioAddItem = function (itemPk) {
    return uriJoin(soa, latest.identity, 'rootPortfolio', 'CART', 'item', itemPk);
};

ends.unknownCreator = function () {
    return uriJoin(soa, latest.inventoryCreators, creator, 'unknown');
};

ends.userRegionalInfo = function () {
    return uriJoin(soa, latest.identity, 'currency', 'resolve', 'ip');
};

ends.dealerAllContacts = function (vertical, legacyId, type) {
    var url = uriJoin(soa, query, json, 'seller_contacts.dibs');
    url = url + '?id=' + legacyId + '&' + vertical;
    if (type) {
        url = url + '&' + type;
    }
    return url;
};

ends.nydcSoldCount = function (legacyId) {
    var url = uriJoin(soa, query, json, 'seller_nydc_sold_count.dibs');
    url = url + '?id=' + legacyId;
    return url;
};

ends.nydcHoldCount = function (legacyId) {
    var url = uriJoin(soa, query, json, 'seller_nydc_hold_count.dibs');
    url = url + '?id=' + legacyId;
    return url;
};

ends.toggleNYDC = function (itemPk) {
    return uriJoin(soa, latest.inventoryShipping, 'item', itemPk, 'nydc');
};
ends.toggleNYDCv3 = function (itemPk) {
    return uriJoin(soa, latest.inventoryItem, 'item', itemPk, 'nydc');
};

// Used for count on dealer dashboard. Probably wrong and needs to be
// reassessed when dealer itemlist pages are done through v2
ends.twentiethCenturyCount = function (legacyId) {
    var url = uriJoin(soa, query, json, 'seller_twentieth_century_count_v1.dibs');
    url = url + '?id=' + legacyId;
    return url;
};

ends.exhibitionsCount = function (legacyId) {
    var url = uriJoin(soa, query, json, 'seller_exhibitions_count.dibs');
    url = url + '?id=' + legacyId;
    return url;
};

ends.regionMap = function (vertical) {
    return uriJoin(soa, latest.identity, 'seller', 'stores', vertical);
};

ends.favSeller = function (userId, urlLabel) {
    var baseUrl = userId ? uriJoin(soa, latest.identity, 'user', userId, 'favSeller') : '';
    var urlParam = urlLabel ? '?urlLabel=' + urlLabel : '';

    return baseUrl + urlParam;
};

ends.favorites = function () {
    return uriJoin(soa, latest.identity, 'user', 'favorites');
};

ends.favorite = function (id) {
    var url = uriJoin(soa, latest.identity, 'user', 'favorite');
    if (id) {
        url = uriJoin(url, id);
    }
    return url;
};

ends.accountManager = function (sellerID) {
    return uriJoin(soa, latest.identity, 'seller', sellerID, 'accountManager');
};

ends.userRelationships = function () {
    return uriJoin(soa, latest.identityTrade, 'userRelationships');
};

//get the current time
ends.currentTime = function () {
    return '/dealers/ajax/current_time';
};

// ------------------
// Saturday Shopper Endpoints
// we may still want this if we can delete cms portfolio based on portfolio id
ends.deleteSaturdayShopper = function () {
    return uriJoin(services, form, 'saturday_shopper.delete');
};

/**
 * Publication Management
 * endpoints
 * @type {{:)}}
 */

ends.publications = function () {
    return uriJoin(soa, latest.inventoryCreators, 'publications');
};

ends.publication = function (id) {
    return uriJoin(soa, latest.inventoryCreators, 'publication', id);
};

ends.makeTestPublication = function (id) {
    return uriJoin(soa, latest.inventoryCreators, 'publication', id, 'process');
};

ends.publicationType = function (id) {
    return uriJoin(soa, latest.inventoryCreators, 'publicationType', id);
};

ends.workflowStates = function (id) {
    return uriJoin(soa, latest.inventoryCreators, 'publication', id, 'workflowStates');
};

/**
 * can be types or subTypes
 * @param type
 */
ends.publicationType = function () {
    return uriJoin(soa, latest.inventoryCreators, 'publicationType');
};
ends.publicationTypes = function () {
    return uriJoin(soa, latest.inventoryCreators, 'publicationTypes');
};

ends.listings = function () {
    return uriJoin(soa, latest.inventoryCreators, 'listings');
};

ends.createFromSearch = function () {
    return uriJoin(soa, latest.inventoryCreators, 'listings', 'createFromSearch');
};

ends.singleListing = function (id) {
    return uriJoin(soa, latest.inventoryCreators, 'listing', id);
};

ends.listingsReorder = function () {
    return uriJoin(soa, latest.inventoryCreators, 'listingsOrder');
};

ends.listingAttach = function (id) {
    return uriJoin(this.singleListing(id), 'publication');
};

ends.workflowStates = function (id) {
    return uriJoin(soa, latest.inventoryCreators, 'listing', id, 'workflowStates');
};

ends.promotion = function (id) {
    return uriJoin(soa, latest.ecom, 'promotion', id);
};

ends.promotionRuleAnchor = function (id) {
    return uriJoin(soa, latest.ecomPromotion, 'promotionRule', id, 'anchorListMembers');
};

ends.cms = function (id) {
    return uriJoin(soa, latest.cms, id);
};

ends.conversationsForBuyerAndItemUrl = function (options) {
    return uriJoin(soa, latestServices.messagecenter, '2', 'conversation', 'buyer', options.buyerId, 'item', options.itemId);
};

ends.anchorLists = function () {
    return uriJoin(soa, latest.identityShipping, 'anchorList');
};

ends.anchorList = function (listType, listName) {
    return uriJoin(ends.anchorLists(), listType, listName, 'anchors');
};

// Media service
ends.uploadPhoto = function (photoTypeName) {
    return uriJoin(soa, latest.media, 'photo', photoTypeName);
};

ends.uploadPhotoByUrl = function (photoTypeName) {
    return uriJoin(soa, latest.media, 'photo', photoTypeName, 'url');
};

ends.replacePhoto = function (photoId) {
    return uriJoin(soa, latest.media, 'photo', photoId, 'replace');
};

ends.resizePhoto = function (photoId) {
    return uriJoin(soa, latest.media, 'photo', photoId, 'resize');
};

ends.processPhoto = function (photoId) {
    return uriJoin(soa, latest.media, 'photo', photoId, 'process');
};

ends.addPhotoTag = function (photoId) {
    return uriJoin(soa, latest.media, 'photo', photoId, 'photoTag');
};

ends.editPhotoTag = function (tagId) {
    return uriJoin(soa, latest.media, 'photoTag', tagId);
};

ends.mediaAlbum = function (albumId) {
    return uriJoin(soa, latest.media, 'mediaAlbum', albumId);
};

ends.getPhoto = function (photoId) {
    return uriJoin(soa, latest.media, 'photo', photoId);
};

// Analytics
ends.recommendations = function () {
    return uriJoin(soa, latest.analytics, 'recommendations');
};

ends.trending = function () {
    return uriJoin(soa, latest.analytics, 'trending');
};

ends.bulkAttachListings = function (id) {
    return uriJoin(ends.publication(id), 'process');
};
ends.socialNetworks = function () {
    return uriJoin(soa, latest.identitySocialNetworks, 'socialNetworks');
};

ends.userSocialNetworks = function (userId) {
    return uriJoin(soa, latest.identitySocialNetworks, 'user', userId, 'socialNetworks');
};

ends.addUserSocialNetwork = function (userId) {
    return uriJoin(soa, latest.identitySocialNetworks, 'user', userId, 'socialNetwork');
};

ends.userSocialNetwork = function (id) {
    return uriJoin(soa, latest.identitySocialNetworks, 'userSocialNetwork', id);
};

ends.oauth = function (sellerId) {
    return uriJoin(soa, latest.identityOauth, 'seller', sellerId, 'oauth', 'code');
};

ends.graphQL = function () {
    return uriJoin(soa, 'graphql');
};

ends.inventoryHold = [soa, latest.inventory, 'hold'].join('/');

ends.inventoryHoldById = function (id) {
    return uriJoin(soa, latest.inventory, 'hold', id);
};

ends.latest = latest;
ends.latestServices = latestServices;
ends.soa = soa;
module.exports = ends;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(4055)();
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/16/14
 * Time: 1:58 PM
 */



var _ = __webpack_require__(0);
var SoaModel = __webpack_require__(2);
var Backbone = __webpack_require__(3);

/**
 * @class Party
 * @extends SoaModel
 */
var Party = SoaModel.extend(/** @lends Party.prototype */{
    relations: [{
        type: Backbone.One,
        relatedModel: SoaModel,
        key: 'entity'
    }],
    getRole: function () {
        return this.get('role');
    },
    isRole: function (role) {
        return this.get('role') === role;
    }
});

Party.prototype.isInternal = Party.prototype.is1stdibs = function () {
    return this.isRole(Party.ROLE_INTERNAL);
};
Party.prototype.isLSP = Party.prototype.isShipper = function () {
    return this.isRole(Party.ROLE_LSP);
};
Party.prototype.isDealer = Party.prototype.isSeller = function () {
    return this.isRole(Party.ROLE_SELLER);
};
Party.prototype.isBuyer = Party.prototype.isCustomer = function () {
    return this.isRole(Party.ROLE_BUYER);
};

_.extend(Party, /** @lends Party */{
    ROLE_INTERNAL: 'INTERNAL',
    ROLE_LSP: 'LSP',
    ROLE_BUYER: 'BUYER',
    ROLE_SELLER: 'SELLER'
});

module.exports = Party;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 1stdibs
 * User: James
 * Date: 2/19/13
 */


/**
 * Base extension for Backbone.Collection, intended to
 * provide functionality common to all collections to
 * make working with 1stdibs services easier.
 *
 * @class SoaCollection
 * @extends Backbone.Collection
 *
 * @property {string} currentAction Defaults to 'fetch'
 * @property {boolean} cacheBust Defaults to false
 * @property {object} urls Defaults to an empty object empty
 * @property {number} totalResults
 *      Set by parse method and getTotalResultsForParams method
 *
 */


var Backbone = __webpack_require__(3);
var assign = __webpack_require__(60);
var _ = __webpack_require__(0);
var $ = __webpack_require__(5);
var bunsenLib = __webpack_require__(21);

// ---------------------------------------------------
// Define Module Constructor Function

var SoaCollection = module.exports =  Backbone.Collection.extend({ constructor: function (models, options) {
    _.defaults(this, {
        params: {},
        defaultParams: {},
        urls: {},
        _urlArgs: [],
        options: options
    });
    Backbone.Collection.prototype.constructor.call(this, models, options);
}});

_.extend(SoaCollection.prototype, {
    currentAction: 'fetch',
    cacheBust:     false,


    /**
     * Used to reset the params object to the default state.
     * Also call this in your initialize to set any passed
     * params from options onto this.params.
     * @memberOf SoaCollection#
     */
    resetParams: function () {
        this.params = {};
        _.defaults(this.params, this.defaultParams);
        if (this.options && this.options.params) {
            _.extend(this.params, this.options.params);
        }
        this.trigger('SoaCollection:updateParams', [this]);
    },

    /**
     * Call this function to fetch data using the query params in
     * this.params.
     * @param {object} passedOptions
     *      passed to fetch. options.data will
     *      override parameters in this.params
     * @memberOf SoaCollection#
     * @returns {$.Deferred.promise}
     */
    fetchWithParameters: function (options) {
        options = assign({data: {}, reset: true}, options);
        options.data = assign({}, this.params, options.data);
        return this.fetch(options);
    },

    /**
     * Sets the param on the collection. Note* To remove the param pass a falsy "value" argument.
     * @param {string} param
     * @param {*} value
     */
    setParam: function (param, value) {
        var paramObj = {
            name:  param,
            value: value
        };

        if (value || value === 0) {
            this.params[param] = value;
            this.trigger('SoaCollection:addParam', paramObj, this);
        } else {
            delete this.params[param];
            this.trigger('SoaCollection:removeParam', paramObj, this);
        }

        this.trigger('SoaCollection:updateParams', this.params, this);
        return this;
    },

    /**
     * @memberOf SoaCollection#
     * @param {string} param
     * @returns {*}
     */
    getParam: function (param) {
        return this.params[param];
    },

    /**
     * @memberof SoaCollection
     * @returns the current url associated with the current action
     */
    url:   function () {
        if (typeof this.urls[this.currentAction] === 'function') {
            return this.urls[this.currentAction].apply(this, this._urlArgs);
        }
        return this.urls[this.currentAction];
    },
    /**
     * @memberOf SoaCollection#
     * @param {array}  [options]
     * @param {string} [actionName] - defaults to 'fetch'
     * @returns {$.Deferred.promise}
     */
    fetch: function (options, actionName) {
        this.currentAction = actionName || 'fetch';
        if (this.cacheBust) {
            options = options || {};
            options.data = _.extend(options.data || {}, {bypassCache: true, _t: new Date().getTime()});
        }
        return SoaCollection.__super__.fetch.call(this, options);
    },

    /**
     * @memberOf SoaCollection#
     * @param {string} method
     * @param {Backbone.Collection} collection
     * @param {object} passedOptions
     * @returns {$.Deferred.promise}
     */
    sync:  function (method, collection, passedOptions) {
        var tokenObj = this.getTokenObj();
        var options = passedOptions || {};

        // Append the user token to the URL.
        if (tokenObj) {
            if (method === 'read') {
                _.defaults(options, {data: {}});
                _.defaults(options.data, tokenObj);
            } else {
                options.url = bunsenLib.extendURL(options.url || _.result(collection, 'url'), tokenObj);
            }
        }
        return SoaCollection.__super__.sync.call(this, method, collection, options);
    },

    /**
     * Retrieves the token query params
     * object for the current user. If
     * no token object has been set, defers
     * to the bunsen.getToken function.
     * @return {object}
     */
    getTokenObj: function () {
        return this._tokenObject || bunsenLib.getToken();
    },

    /**
     * Sometimes the token needs to be set
     * manually, instead of relying on a
     * cookie. This can be done with this
     * method.
     * @param {string} token The user's token
     * @param {string} [key=userToken]
     *        The query param name for the token
     * @returns {SoaCollection}
     */
    setToken: function (token, key) {
        key = key || 'userToken';
        if (!token) {
            this._tokenObject = null;
            return this;
        }
        this._tokenObject = {};
        this._tokenObject[key] = token;
        return this;
    },


    /**
     * The parse function looks first to see if the response is an array, then it checks
     * to see if there is a 'result' attribute
     * for the row attribute inside of the returned response, disregarding the top level
     * attributes such as "created" and "totalSize"
     * @memberOf SoaCollection#
     *
     * @param data
     *
     * @returns {object}
     */
    parse: function (data) {
        var key;
        var keys;
        var l1Key;
        var l2Key;

        this.totalResults = null;

        if (!data) {
            return [];
        }
        if (_.isArray(data)) {
            return data;
        }

        // Total size of paginated list.
        if (_.isNumber(data.totalResults)) {
            this.totalResults = data.totalResults;
        }

        // If the collection is nested under an object called "result"
        if (data.result) {
            // Within the new service responses, lists come back serialized within `RESPONSE.result.dataList`
            //Removing apiType restriction - With Logistics, we get apiTypes like `shipmentQuotes`
            if (data.result.dataList) {// && data.result.apiType && data.result.apiType === 'list'
                return data.result.dataList;
            }
            if (_.size(data.result) === 1) {
                // Sometimes service responses are wrapped in an arbitrary wrapper object. If the collection array
                // is 2 levels below the "response" object - then fish it out. Otherwise return whatever is
                // directly under "response"
                l1Key = _.keys(data.result)[0];

                if (_.size(data.result) === 1 && ($.isPlainObject(data.result[l1Key])) && _.size(data.result[l1Key]) === 1) {
                    l2Key = _.keys(data.result[l1Key])[0];
                    return data.result[l1Key][l2Key];
                } else if (_.isObject(data.result[l1Key]) && _.isEmpty(data.result[l1Key])) {
                    //empty object means no results
                    return null;
                } else {
                    return data.result[l1Key];
                }
            } else {
                return data.result;
            }
        }
        // If the collection is under the "form" attribute (via the form service)
        if (data.form && data.formCode) {
            return data.form;
        }

        // If the collection is under the "row" attribute (query service)
        if (data.row) {
            return data.row;
        }
        keys = _.keys(data);
        key = keys.shift();
        while (key) {
            if (data[key] && data[key].row) {
                return data[key].row;
            }
            key = keys.shift();
        }
        return data;
    },

    /**
     * Filters the collection where, for the given field/property,
     * the model's value is in the given array
     *
     * @memberOf SoaCollection#
     * @param {string} field The name of a field
     * @param {array} arr An array of allowed values.
     * @param {boolean} [asJSON]
     *      True if return array of models should be in toJSON format
     * @returns {Backbone.Model[]|object[]}
     *      An array of models or and array of models as json
     */
    whereIn: function (field, arr, asJSON) {

        var whereArr = [];
        var models = this.models;
        var i = 0;
        var y;
        var yLen;
        var len = this.models.length;

        arr = _.isArray(arr) ? arr : [arr];
        yLen = arr.length;

        for (i; i < len; i++) {
            for (y = 0; y < yLen; y++) {
                if (models[i].attributes[field] === arr[y]) {
                    whereArr.push(asJSON ? models[i].toJSON() : models[i]);
                }
            }
        }

        return whereArr;
    },

    /**
     * Filters the collection where, for the given field/property,
     * the model's value is not in the given array
     *
     * @memberOf SoaCollection#
     * @param {String} field - The name of a field
     * @param {Array} arr - An array of allowed values.
     * @param {boolean} [asJSON] - True if return array of models should be in toJSON format
     * @returns {Backbone.Model[]|object[]}
     *      An array of models or and array of models as json
     */
    whereNotIn: function (field, arr, asJSON) {

        var whereNotArr = [];
        var models = this.models;
        var i = 0;
        var len = models.length;
        var isIn;
        var y;
        var yLen;

        arr = _.isArray(arr) ? arr : [arr];
        yLen = arr.length;

        for (i; i < len; i++) {
            isIn = false;
            for (y = 0; y < yLen; y++) {
                isIn = isIn || models[i].attributes[field] === arr[y];
            }
            if (!isIn) {
                whereNotArr.push(asJSON ? models[i].toJSON() : models[i]);
            }
        }

        return whereNotArr;
    },

    /**
     * Will pass the callback the total number of results the service has for provided params.
     * This is useful for bucketFilters which need to display the total results
     *
     * @param {object} passedParams Params to pass to the service as a query string
     * @param {function} callback Function to call when the results are known. totalResults is first and only argument
     * @param {object} options Additional options to pass to the fetchWithParameters request
     *
     * @return {$.Deferred}
     *      For some reason this function returns a deferred object instead of a promise
     */
    getTotalResultsForParams: function (passedParams, callback, options) {
        var params = passedParams || this.params;
        // create a new instance of the same collection we are
        var totalCollection = new SoaCollection();
        totalCollection.url = _.result(this, 'url');

        params = _.extend(bunsenLib.deepClone(params), {
            pageStart:          0,
            pageSize:           0,
            returnTotalResults: true
        });

        // Don't pass this in since it may filter results
        if (params.orderBy) {
            delete params.orderBy;
        }
        if (params.sort) {
            delete params.sort;
        }
        totalCollection.params = params;
        return $.when(totalCollection.fetchWithParameters(options)).then(function () {
            if (callback) {
                callback(totalCollection.totalResults);
            }
            return totalCollection.totalResults;
        });
    }
});



/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Rob Richard
 * Date: 8/7/14
 * Time: 12:01 PM
 */



var $ = __webpack_require__(5);
var SoaModel = __webpack_require__(2);
var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};
var FinancialAmount = module.exports = root.bunsen.FinancialAmount = SoaModel.extend();
var price = __webpack_require__(2638);
var numberConversions = __webpack_require__(326);
var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var CurrencyConversionRateEvent = __webpack_require__(337);
var currencies = __webpack_require__(2059);
var getCurrencySymbol = __webpack_require__(2653);
var currencyConstants = __webpack_require__(1220).currencies;

_.extend(FinancialAmount, {
    getCurrencies: function () {
        return currencies;
    },
    getCurrencySymbol: getCurrencySymbol
}, currencyConstants);

_.extend(FinancialAmount.prototype, {
    initialize: function () {
        this.on('change:amount', this.updateConvertedAmounts, this);
        if (!this.get('convertedAmounts')) {
            this.updateConvertedAmounts();
        }

        _.each(currencies, function (currency) {
            this['is' + currency] = _.partial(this.isCurrency, currency);
        }, this);
    },
    relations: SoaModel.createRelations([
        'convertedAmounts',
        {
            key: 'conversionRateEvent',
            type: Backbone.One,
            relatedModel: CurrencyConversionRateEvent
        }
    ]),
    getCurrency: function () {
        return this.get('currency');
    },
    isCurrency: function (currency) {
        return this.get('currency') === currency;
    },
    getAmountIn: function (currency) {
        // we don't need converted amounts when it's zero
        if (this.get('amount') === 0) {
            return 0;
        }
        return this.get('convertedAmounts.' + currency);
    },
    updateConvertedAmounts: function (options) {
        var convertedAmountsObj = {};
        options = _.defaults(options || {}, {
            removeConvertedAmounts: true
        });
        if (!options.removeConvertedAmounts) {
            return;
        }
        if ($.isNumeric(this.get('amount')) && !$.isEmptyObject(this.get('currency'))) {
            convertedAmountsObj[this.get('currency')] = this.get('amount');
            this.set('convertedAmounts', convertedAmountsObj);
        } else {
            this.unset('convertedAmounts');
        }
    },
    getDisplayPrice: function(currency) {
        currency = currency || this.getCurrency();
        return price.formatPrice(this.getAmountIn(currency), currency);
    },
    getStatementAmount: function () {
        var currency = this.get('currency');
        var numericAmount = this.safeNegate().getAmountIn(currency);
        return numberConversions.intelligentFormat(numericAmount, currency);
    },
    /**
     * formats item price with currency and local thousands and decimal separators.
     * @param {string} options.currency currency to which this item's price will be formatted.
     * @param {boolean} options.includeCurrencySymbol if false, the currency symbol will be omitted from the return value.
     * @returns {string} local-formatted price string, when options is {currency: "EUR", includeCurrencySymbol: true} and item price is 123456.78, returns "€123.456,78".
     */
    localizedAmount: function (options) {
        var convertedAmounts = this.get('convertedAmounts');
        if (!convertedAmounts) {
            return;
        }
        options = _.extend({
            currency: this.getCurrency(),
            includeCurrencySymbol: true
        }, options);
        return numberConversions.intelligentFormat(
            convertedAmounts.toJSON()[options.currency],
            options.currency,
            options
        );
    },
    negate: function () {
        var convertedAmounts = this.get('convertedAmounts').toJSON();
        this.set('amount', this.get('amount') * -1, { removeConvertedAmounts: false });
        _.each(convertedAmounts, function (val, currency) {
            this.get('convertedAmounts').set(currency, val * -1);
        }, this);
        return this;
    },
    safeNegate: function () {
        return this.clone().negate();
    }
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _ = __webpack_require__(0);
var SoaModel = __webpack_require__(2);
var extendCompose = __webpack_require__(44);
var Anchor = module.exports = extendCompose.call(SoaModel, null, {
    TYPE_ITEM: 'ITEM',
    TYPE_USER: 'USER',
    TYPE_SELLER: 'SELLER',
    TYPE_OFFER: 'OFFER',
    TYPE_SHIPMENT: 'SHIPMENT',
    TYPE_SHIPMENT_QUOTE: 'SHIPMENT_QUOTE',
    TYPE_TRANSACTION: 'TRANSACTION',
    TYPE_PROMOTION: 'PROMOTION',
    TYPE_VERTICAL: 'VERTICAL',
    TYPE_ITEM_LISTING: 'ITEM_LISTING'
});

var isSourceType = function (type) {
    return this.get('sourceType') === type;
};
var ANCHOR_API_TYPE = 'anchor';

Anchor.extendSelf({
    initialize: function (attributes) {
        attributes = attributes || {};
        attributes.apiType = ANCHOR_API_TYPE;
        this.set('apiType', ANCHOR_API_TYPE);
        return Anchor.__super__.initialize.call(this, attributes);
    },
    isPromotion: _.partial(isSourceType, Anchor.TYPE_PROMOTION)
});


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


module.exports = __webpack_require__(334);


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {/**
 * lodash 4.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to determine if values are of the language type `Object`. */
var objectTypes = {
  'function': true,
  'object': true
};

/** Detect free variable `exports`. */
var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType) ? exports : null;

/** Detect free variable `module`. */
var freeModule = (objectTypes[typeof module] && module && !module.nodeType) ? module : null;

/** Detect free variable `global` from Node.js. */
var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);

/** Detect free variable `self`. */
var freeSelf = checkGlobal(objectTypes[typeof self] && self);

/** Detect free variable `window`. */
var freeWindow = checkGlobal(objectTypes[typeof window] && window);

/** Detect `this` as the global object. */
var thisGlobal = checkGlobal(objectTypes[typeof this] && this);

/**
 * Used as a reference to the global object.
 *
 * The `this` value is used if it's the global object to avoid Greasemonkey's
 * restricted `window` object, otherwise the `window` object is used.
 */
var root = freeGlobal || ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) || freeSelf || thisGlobal || Function('return this')();

/**
 * Checks if `value` is a global object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
 */
function checkGlobal(value) {
  return (value && value.Object === Object) ? value : null;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = Symbol ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path + ''] : baseToPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[path[index++]];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.toPath` which only converts `value` to a
 * path if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Array} Returns the property path array.
 */
function baseToPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (typeof value == 'number') {
    return true;
  }
  return !isArray(value) &&
    (reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
      (object != null && value in Object(object)));
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
function stringToPath(string) {
  var result = [];
  toString(string).replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (value == null) {
    return '';
  }
  if (isSymbol(value)) {
    return Symbol ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined` the `defaultValue` is used in its place.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module), __webpack_require__(4)))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Gedas
 * Date: 4/10/15
 * Time: 11:00 AM
 * Copyright 1stdibs.com, Inc. 2015. All Rights Reserved.
 */



// ---------------------------------------------------
// Load Super Class

var BunsenUser = __webpack_require__(28);

// ---------------------------------------------------
// Module Definition

/**
 * @class User
 * @extends SoaModel
 */
var User = module.exports = BunsenUser.extend();

// ---------------------------------------------------
// Dependencies

var $ = __webpack_require__(5);
var _ = __webpack_require__(22);
var guidGenerator = __webpack_require__(2583);
var storage = __webpack_require__(282);
var localStorage = storage.localStorage;
var sessionStorage = storage.sessionStorage;
var defaultCookieSettings = __webpack_require__(754).defaultCookieSettings;
var Permission = __webpack_require__(940);
var ContextProvider = __webpack_require__(293);
var loginActions = __webpack_require__(659);
var portfolioActions = __webpack_require__(895);
var uri = __webpack_require__(137);

var contains = __webpack_require__(842);
var isEmpty = __webpack_require__(267);

// ---------------------------------------------------
// Local Variables

var root = typeof window === 'undefined' ? global : window;
var deferred = $.Deferred();
var ajaxMade = false;
var emailTokenPromise;
var loginState;

var CUSTOMER_TYPE_VIP = 'VIP';
var CUSTOMER_TYPE_TRADE = 'Trade';
var CUSTOMER_TYPE_CONSUMER = 'Consumer';

__webpack_require__(677); // jQuery.fn.cookie

function reloadPage() {
    if (root && root.location) {
        root.location.reload(true);
    }
}

/**
 * Sets initial user related cookies
 */
function setCookies() {
    var currentUser = User.getCurrentUser();

    if (currentUser) {
        $.cookie(User.COOKIE_USER_LEGACY, currentUser.get('legacyCookie'), User.getCookieSettings(182));
        $.cookie(User.COOKIE_USER, currentUser.get('token'), User.getCookieSettings(182));
    }
}

/**
 * Sets additional user related cookies
 */
function setAdditionalCookies() {
    var currentUser = User.getCurrentUser();
    var userType;

    if (currentUser) {
        userType = (currentUser.isVerifiedTradeBuyer() ? CUSTOMER_TYPE_TRADE : CUSTOMER_TYPE_CONSUMER).toLowerCase();

        if ($.cookie(User.COOKIE_USER_TYPE) !== userType) {
            $.cookie(User.COOKIE_USER_TYPE, userType, User.getCookieSettings(182));
            $.cookie(User.COOKIE_EVER_LOGGED_IN, userType, User.getCookieSettings(365 * 5));
        }
    }
}

/**
 * Removes cookies by given arguments/keys
 */
function removeCookies() {
    var length = arguments.length;
    var i;

    for (i = 0; i < length; i++) {
        $.cookie(arguments[i], '', User.getCookieSettings(new Date(-1)));
        $.removeCookie(arguments[i]);
    }
}

/**
 * Initializes User:
 * 1. Sets cookies
 * 2. Triggers login state update
 * 3. Stores data in local storage
 * 4. Manages guest id
 */
function initUser() {
    setCookies();
    User.updateLoginState();
    User.setStorage();

    if (User.getGuestId()) {
        User.getCurrentUser().saveGuestId(User.getGuestId());
        User.removeGuestId();
    }
}

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(User.prototype, {
    initialized: false,

    /**
     * @param {String} email
     * @param {String} password
     * @returns {Promise}
     */
    login: function () {
        return User.__super__.login.apply(this, arguments).done(initUser);
    },

    /**
     * @param {String} email
     * @param {String} password
     * @returns {Promise}
     */
    register: function () {
        var self = this;
        return User.__super__.register.apply(this, arguments)
            .done(function () {
                initUser();
                // Set this flag to identify that the user has just created his account,
                // used in currencyActions.
                self.set('newUser', true);
            });
    },

    /**
     * @param {String} email
     * @param {String} password
     * @param {String} role
     * @returns {Promise}
     */
    registerWithRole: function () {
        return User.__super__.registerWithRole.apply(this, arguments).done(initUser);
    },

    /**
     * @param {String} password
     * @returns {Promise}
     */
    resetPassword: function () {
        return User.__super__.resetPassword.apply(this, arguments).done(initUser);
    },

    /**
     * @param {String} currentPassword
     * @param {String} newPassword
     * @returns {Promise}
     */
    updatePassword: function () {
        var self = this;
        return User.__super__.updatePassword.apply(this, arguments).done(function () {
            self.once('change:token', setCookies);
        });
    }
});

// ---------------------------------------------------
// Define Module Static Properties

_.extend(User, {
    STORAGE_KEY_USER_EMAIL: 'userEmail',
    STORAGE_KEY_USER_EMAIL_TOKEN: 'userEmailToken',

    /**
     * @param {Object} attrs
     * @returns {User}
     * @private
     */
    _createInstance: function (attrs) {
        return new User(attrs);
    },

    /**
     * @param {String} key
     * @returns {User}
     * @private
     */
    _getUser: function (key) {
        var user = BunsenUser._getUser.apply(this, arguments);

        if (!user.initialized) {
            User.prototype.initialized = true;
            user = BunsenUser._getUser.call(this, key, true);

            ContextProvider.getContext().then(function (context) {
                user.once('login:change', function () {
                    context.executeAction(loginActions.handleLoginChange, {user: user});
                });

                context.executeAction(loginActions.handleLoginChange, {user: user});
            });
        }

        return user;
    },

    /**
     * @param {Integer} expires
     * @returns {Object}
     */
    getCookieSettings: function (expires) {
        expires = expires || null;
        return _.extend({}, defaultCookieSettings, {expires: expires});
    },

    /**
     * Sets user params to local storage
     */
    setStorage: function () {
        var user = User.getCurrentUser();

        localStorage.setItem(User.STORAGE_KEY_USER_EMAIL, user.get('profile.email'));
        localStorage.setItem(User.STORAGE_KEY_USER_EMAIL_TOKEN, user.get('emailToken'));
    },

    /**
     * Deletes user params from local storage
     */
    deleteStorage: function () {
        localStorage.deleteItem(User.STORAGE_KEY_USER_EMAIL);
    },

    /**
     * @param {Boolean} isTrade
     */
    setEverLoggedInCookie: function (isTrade) {
        var type = isTrade ? CUSTOMER_TYPE_TRADE : CUSTOMER_TYPE_CONSUMER;
        $.cookie(User.COOKIE_EVER_LOGGED_IN, type.toLowerCase(), this.getCookieSettings(365 * 5));
    },

    /**
     * @returns {Boolean}
     */
    everLoggedInAsTrade: function () {
        return $.cookie(User.COOKIE_EVER_LOGGED_IN) === CUSTOMER_TYPE_TRADE.toLowerCase();
    },

    /**
     * @param {Object} attrs
     */
    updateLoginState: function (attrs) {
        var curState = this.loggedIn();

        if (loginState !== undefined && curState !== loginState) {
            $.publish('login:change', _.extend({}, attrs || {}, {loggedIn: curState}));
            this.getCurrentUser().trigger('login:change');
        }

        loginState = curState;
    },

    /**
     * @param {Boolean} reload
     */
    logout: function (reload) {
        reload = reload || false;

        if (this.isMasquerading()) {
            removeCookies(User.COOKIE_USER_MASQUERADE, User.COOKIE_USER_TYPE);
        } else {
            removeCookies(User.COOKIE_USER, User.COOKIE_USER_LEGACY, User.COOKIE_USER_TYPE);
        }

        if (reload) {
            setTimeout(function () {
                if (root.location.pathname === '/' && root.location.href.indexOf('?modal=reset') !== -1) {
                    // FINDING-2746 - Make this check just on homepage
                    root.location.href = location.origin;
                } else if (root.location.pathname.indexOf('checkout/confirmation') >= 0) {
                    // MONEY-1964 - redirect to home page upon logout from checkout confirmation page
                    root.location.href = location.origin;
                } else {
                    reloadPage();
                }
            }, 100);
        } else {
            this.updateLoginState();
            ajaxMade = false;
        }
    },

    /**
     * @returns {Promise}
     */
    load: function () {
        var self = this;
        var fields = [
            User.FIELD_FULL_PROFILE,
            User.FIELD_CONVERSATION,
            User.FIELD_CART,
            User.FIELD_PERMISSIONS,
            User.FIELD_ADDRESS,
            User.FIELD_ROLES,
            User.FIELD_SOCIAL_NETWORKS
        ];

        // Not logged in, set guest id
        if (!self.loggedIn()) {
            if (!self.getGuestId()) {
                self.setNewGuestId();
            }
            deferred = deferred.state() === 'resolved' ? $.Deferred() : deferred;
            return deferred.reject({type: 'NOT_LOGGED_IN', result: null}).promise();
        }

        // Get user data
        if (!ajaxMade) {
            ajaxMade = true;
            deferred = deferred.state() === 'rejected' ? $.Deferred() : deferred;

            self.getCurrentUserPromise(true, {
                data: {
                    fields: fields.join(',')
                }
            }).done(function () {
                setAdditionalCookies();
                deferred.resolve(self.getCurrentUser().toJSON());
                ContextProvider.getContext().then(function (context) {
                    context.executeAction(portfolioActions.syncLocal);
                });
            }).fail(function (result) {
                // 401 Unauthorized - invalid user token
                if (result && result.status === 401) {
                    self.logout(true);
                }
                deferred.reject({type: 'ERROR', result: result});
            });
        }

        return deferred.promise();
    },

    /**
     * @returns {Object|*}
     */
    getUserProfile: function () {
        return this.getCurrentUser().get('profile');
    },

    /**
     * @param {Object} attrs
     * @returns {Promise}
     */
    updateProfile: function (attrs) {
        return this.getUserProfile().set(attrs).save();
    },

    /**
     * When updating currency need to send just currency, to update other profile values we need 24h fresh token
     *
     * @param {String} currency
     * @returns {Promise}
     */
    updateCurrency: function (currency) {
        var clonedUser = this.getCurrentUser().clone();
        var payload = {currency: currency};

        this.getUserProfile().set(payload); // Update actual profile
        return clonedUser.get('profile').clear().set(payload).save();
    },

    /**
     * @param {Boolean} - useProfileValue true: Use the profile value? defaults to false: localStorage value
     * @returns {String}
     */
    getEmail: function (useProfileValue) {
        return useProfileValue && this.getCurrentUser().get('profile.email') || localStorage.getItem(User.STORAGE_KEY_USER_EMAIL);
    },

    /**
     * @returns {String}
     */
    getEmailToken: function () {
        return localStorage.getItem(User.STORAGE_KEY_USER_EMAIL_TOKEN);
    },

    /**
     * @returns {String}
     */
    getFullName: function () {
        var name = '';
        var profile = this.getUserProfile();
        if (profile) {
            name = (profile.get('firstName') || '') + ' ' + (profile.get('lastName') || '');
            name = $.trim(name);
        }
        return name;
    },

    getCustomerType: function () {
        var customerType = [];
        var permissions = [];

        if (this.getCurrentUser() && this.getCurrentUser().get('permissions.permissionList')) {
            permissions = this.getCurrentUser().get('permissions.permissionList').pluck('name');
        }

        if (contains(permissions, Permission.PERMISSION_B_TRADE_CHECKOUT)) {
            customerType.push(CUSTOMER_TYPE_TRADE);
        }

        if (contains(permissions, Permission.PERMISSION_B_VIP_CHECKOUT)) {
            customerType.push(CUSTOMER_TYPE_VIP);
        }

        if (isEmpty(customerType)) {
            return CUSTOMER_TYPE_CONSUMER;
        }

        return customerType.length ? customerType.join(' and ') : undefined;
    },

    /**
     * @returns {String}
     */
    getZipCode: function () {
        return this.getCurrentUser().get('profile.zipCode');
    },

    /**
     * @returns {string}
     */
    getInitials: function () {
        var initials = '';
        var splitName = _.without(this.getFullName().split(' '), '');

        if (splitName.length > 0) {
            initials = _.reduce(splitName, function (memo, partName) {
                return memo + partName[0];
            }, '');
        }

        return initials;
    },

    /**
     * @returns {String|*}
     */
    getCurrency: function () {
        return this.getCurrentUser() && this.getCurrentUser().get('profile.currency');
    },

    /**
     * @returns {String|*}
     */
    getGuestId: function () {
        return $.cookie(User.COOKIE_GUEST_ID);
    },

    removeGuestId: function () {
        removeCookies(User.COOKIE_GUEST_ID);
    },

    setNewGuestId: function () {
        $.cookie(User.COOKIE_GUEST_ID, guidGenerator.getGuid(), this.getCookieSettings());
    },

    /**
     * Checks to see if the current user
     * has permission to view net/trade prices
     * @returns {boolean}
     */
    canRequestNetPrice: function () {
        var currentUser = this.getCurrentUser();
        return currentUser
            && currentUser.hasTradeBuyerPermission()
            && $.cookie(User.COOKIE_USER_TYPE) === CUSTOMER_TYPE_TRADE.toLowerCase();
    },

    handleEmailToken: function () {
        var self = this;
        var emailToken = uri.URL.queryKey.emailToken;
        var source = uri.URL.queryKey.source;

        if (emailTokenPromise) {
            return emailTokenPromise;
        }

        if (self.loggedIn() || !emailToken) {
            return $.Deferred().resolve().promise();
        }

        emailTokenPromise = self.fetchCurrentUser(true, {
            data: {emailToken: emailToken}
        })
        .done(function () {
            var email = self.getEmail(true);
            var isTrade = source && source.indexOf(CUSTOMER_TYPE_TRADE.toLowerCase()) !== -1;

            if (email) {
                sessionStorage.setItem('email', email);
                localStorage.setItem(User.STORAGE_KEY_USER_EMAIL_TOKEN, emailToken);
                self.setEverLoggedInCookie(isTrade);
            }
        });

        return emailTokenPromise;
    }
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes += ' ' + arg;
			} else if (Array.isArray(arg)) {
				classes += ' ' + classNames.apply(null, arg);
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes += ' ' + key;
					}
				}
			}
		}

		return classes.substr(1);
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(586);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* global require:false, module:true */


var root = 'undefined' === typeof window ? global : window;
var SV = module.exports = root.__SERVER_VARS__ = root.__SERVER_VARS__ || {};
var Container = __webpack_require__(4157);
var container = new Container(SV);
SV.get = function () {
    // container.get may be swapped by a jasmine spy, so we can't just set SV.get to container.get.bind(container) here.
    return container.get.apply(container, arguments);
};
SV._api = container;
SV._data = SV;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _ = __webpack_require__(0);
var $ = __webpack_require__(5);
var SV = __webpack_require__(18);
var tokenReplace = __webpack_require__(2633);
var formatPhoneNumber = __webpack_require__(2801);
var currencyConstants = __webpack_require__(1220);
var root = typeof window === 'undefined' ? global : window;
var bunsen;

__webpack_require__(677);

module.exports = bunsen = root.bunsen = root.bunsen || {};

// note: tokenReplace is passed in so that `bunsen.tokenReplace` is aliased to the actual module
bunsen.getMasqueradeAsUserId = function (cookieName) {
    var masquerader;
    var params;

    if (cookieName !== 'masqueradeSeller' && cookieName !== 'masqueradeBuyer') {
        throw new Error('cookieName must equal "masqueradeBuyer" or "masqueradeSeller"');
    }

    masquerader = $.cookie(cookieName);
    params = {};
    if (masquerader) {
        masquerader = masquerader.split('_');
        masquerader = masquerader[0] === 'S' ? masquerader[2].toLowerCase() + '_' + masquerader[1] : masquerader[1];
        params.userId = masquerader;
    }

    return params;
};
bunsen.whenArray = function (arr) {
    return $.when.apply($, arr);
};
bunsen.gotFiles = function (acceptTypes) {
    var gotFiles = $.Deferred();
    var $input = $("<input type='file'multiple>");
    var fileInput = $input.hide().appendTo(document.body)[0];
    if (acceptTypes) {
        $input.attr('accept', acceptTypes);
    }
    if (undefined === fileInput.files) {
        console.error("file API is not present in your browser");
        gotFiles.failWith(this);
    } else {
        fileInput.onchange = $.proxy(function () {
            gotFiles.resolveWith(this, [fileInput.files]);
        }, this);
    }
    fileInput.click();
    return gotFiles;
};
bunsen.getOn = function (name) {
    return function () {
        return this[name];
    };
};
bunsen.property = function (name) {
    return function (o) {
        return o[name];
    };
};
bunsen.gandalf = function (f, n) { // you shall not pass (more than n arguments to f)!
    if (undefined === n) {
        n = 0;
    }
    return function () {
        Array.prototype.slice.call(arguments, 0, n);
        return f.apply();
    };
};
bunsen.flip = function (f) {
    return function () {
        return f.call(this, arguments[1], arguments[0]);
    };
};
bunsen.callon = function (methodName) {
    var args = _.rest(arguments, 1);
    return function (o) {
        return o[methodName].apply(o, args);
    };
};
bunsen.lshiftargs = function (f) {
    return function () {
        return f.apply(this, _.rest(arguments, 1));
    };
};
// returns a function that returns val. Useful for passing a
// callback to $.Deferred.prototype.then when you know what
// the object is before the deferred finishes
bunsen.ret = function (val) {
    return function () {
        return val;
    };
};
/**
 * Takes in a string and finds the namespaced object or value it represents.
 * Say you have an object obj.super.sub = {val1 : 'something'}
 * Then this function call:
 *      obj.getNamespacedValue('object obj.super.sub.val1')
 * ... should return "something"
 * @param str
 * @returns {object}
 */
bunsen.getNamespacedValue = function (str) {
    var arr = str.split('.');
    var obj = window;

    findObject:
    for (var i = 0; i < arr.length; i++) {
        if (obj[arr[i]]) {
            // If you find the next object in the sequence, then set the obj to it.
            obj = obj[arr[i]];
        } else {
            // The object at this level does not exist. Set to null and break up the loop:
            obj = null;
            break findObject;
        }
    }
    return obj;
};

/**
 * Very simple utility function to kill an event.
 * @param e
 */
bunsen.killE = function (e) {
    if (e && e.preventDefault && e.stopPropagation) {
        e.preventDefault();
        e.stopPropagation();
    }
};

// Sorts an object as opposed to an array and preserves the keys. (Perhaps this belongs in Bunsen.)
bunsen.sortObject = function (obj, compare) {
    return _.object(_.zip(_.keys(obj), _.values(obj)).sort(function (a, b) {
        return compare(a[1], b[1]);
    }));
};
/**
 * Adds dashes to a phone number if in US format
 * @deprecated use dibs-format-phone-number instead
 */
bunsen.formatPhoneNumber = formatPhoneNumber;

/**
 * @param code
 * @returns {string}
 */
bunsen.getCurrencySymbol = function (code) {
    var symbol = code === 'PND' ? 'GBP' : code;
    return currencyConstants.symbols[symbol] || '';
};

// converts "camelCase" to "camel case"
bunsen.camel2spaceCase = function (str, capitalize) {
    return $.trim(str.replace(/^.|[A-Z]/g, function ($1) {
        return " " + $1[capitalize ? 'toUpperCase' : 'toLowerCase']();
    }));
};
// converts "camelCase" to "dealer-camel-case-container"
bunsen.camel2snakeCase = function (str) {
    return str.replace(/[A-Z]/g, function ($1) {
            return "-" + $1.toLowerCase();
        }) + "-container";
};
// converts "snake-case" to "snakeCase"
bunsen.snake2camelCase = function (str) {
    return str.replace(/(-([a-z]))/gi, function ($0, $1, $2) {
        return $2.toUpperCase();
    });
};
// converts "snake_case" to "snake case"
bunsen.snake2spaceCase = function (str) {
    return str.replace(/_/g, ' ');
};

/**
 * Will return any string into a kebab
 * @param  {String} str - String to kebab
 * @return {String}
 */
bunsen.kebab = function(str) {
    var regex = /[^a-zA-Z]|[A-Z]/g;
    return (str || '').toString().replace(regex, function($0) {
        return /[a-zA-Z]/.test($0) ? '-' + $0 : '-';
    }).toLowerCase().
        replace(/\-+/g, '-').
        replace(/^\-*|\-*$/g, '');
};

/**
 * Converts any string into camel case
 * @param  {String} str - String to camel
 * @return {String}
 */
bunsen.camel = function(str) {
    var regex = /[\s_\-\W](.)/g;
    return (str || '').toString().replace(/\w/, function($0) {
            // lowercase first letter
            return $0.toLowerCase();
        }).replace(regex, function(_, $1) {
            return /[a-zA-Z]/.test($1) ? $1.toUpperCase() : '';
        });
};

// lint ignore taken from internet
/* eslint-disable */
/*
 * Title Caps
 *
 * Ported to JavaScript By John Resig - http://ejohn.org/ - 21 May 2008
 * Original by John Gruber - http://daringfireball.net/ - 10 May 2008
 * License: http://www.opensource.org/licenses/mit-license.php
 */
var small = "(a|an|and|as|at|but|by|en|for|if|in|of|on|or|the|to|v[.]?|via|vs[.]?)";
var punct = "([!\"#$%&'()*+,./:;<=>?@[\\\\\\]^_`{|}~-]*)";

bunsen.titleCaps = function (title) {
    var parts = [], split = /[:.;?!] |(?: |^)["Ò]/g, index = 0;

    if (!title) {
        return null;
    }

    // Convert to all lowercase and remove underscores
    title = title.toLowerCase().replace(/_/g, " ");

    while (true) {
        var m = split.exec(title);

        parts.push(title.substring(index, m ? m.index : title.length)
            .replace(/\b([A-Za-z][a-z.'Õ]*)\b/g, function (all) {
                return /[A-Za-z]\.[A-Za-z]/.test(all) ? all : _upper(all);
            })
            .replace(new RegExp("\\b" + small + "\\b", "ig"), _lower)
            .replace(new RegExp("^" + punct + small + "\\b", "ig"), function (all, punct, word) {
                return punct + _upper(word);
            })
            .replace(new RegExp("\\b" + small + punct + "$", "ig"), _upper));

        index = split.lastIndex;

        if (m) {
            parts.push(m[0]);
        }
        else {
            break;
        }
    }

    return parts.join("").replace(/ V(s?)\. /ig, " v$1. ")
        .replace(/(['Õ])S\b/ig, "$1s")
        .replace(/\b(AT&T|Q&A)\b/ig, function (all) {
            return all.toUpperCase();
        });
};

function _lower(word) {
    return word.toLowerCase();
}

function _upper(word) {
    return word.substr(0, 1).toUpperCase() + word.substr(1);
}
/*
 jQuery deparam is an extraction of the deparam method from Ben Alman's jQuery BBQ
 http://benalman.com/projects/jquery-bbq-plugin/
 https://github.com/chrissrogers/jquery-deparam/blob/master/jquery-deparam.js
 */
bunsen.deparam = function (params, coerce) {
    var obj = {},
        coerce_types = { 'true': !0, 'false': !1, 'null': null };

    if (!params) {
        return obj;
    }

    // Iterate over all name=value pairs.
    _.each(params.replace(/\+/g, ' ').split('&'), function (v, j) {
        var param = v.split('='),
            key = decodeURIComponent(param[0]),
            val,
            cur = obj,
            i = 0,

        // If key is more complex than 'foo', like 'a[]' or 'a[b][c]', split it
        // into its component parts.
            keys = key.split(']['),
            keys_last = keys.length - 1;

        // If the first keys part contains [ and the last ends with ], then []
        // are correctly balanced.
        if (/\[/.test(keys[0]) && /\]$/.test(keys[keys_last])) {
            // Remove the trailing ] from the last keys part.
            keys[keys_last] = keys[keys_last].replace(/\]$/, '');

            // Split first keys part into two parts on the [ and add them back onto
            // the beginning of the keys array.
            keys = keys.shift().split('[').concat(keys);

            keys_last = keys.length - 1;
        } else {
            // Basic 'foo' style key.
            keys_last = 0;
        }

        // Are we dealing with a name=value pair, or just a name?
        if (param.length === 2) {
            val = decodeURIComponent(param[1]);

            // Coerce values.
            if (coerce) {
                val = val && !isNaN(val)              ? +val              // number
                    : val === 'undefined'             ? undefined         // undefined
                    : coerce_types[val] !== undefined ? coerce_types[val] // true, false, null
                    : val;                                                // string
            }

            if (keys_last) {
                // Complex key, build deep object structure based on a few rules:
                // * The 'cur' pointer starts at the object top-level.
                // * [] = array push (n is set to array length), [n] = array if n is
                //   numeric, otherwise object.
                // * If at the last keys part, set the value.
                // * For each keys part, if the current level is undefined create an
                //   object or array based on the type of the next keys part.
                // * Move the 'cur' pointer to the next level.
                // * Rinse & repeat.
                for (; i <= keys_last; i++) {
                    key = keys[i] === '' ? cur.length : keys[i];
                    cur = cur[key] = i < keys_last ? cur[key] || (keys[i + 1] && isNaN(keys[i + 1]) ? {} : []) : val;
                }

            } else {
                // Simple key, even simpler rules, since only scalars and shallow
                // arrays are allowed.

                if (_.isArray(obj[key])) {
                    // val is already an array, so push on the next value.
                    obj[key].push(val);

                } else if (obj[key] !== undefined) {
                    // val isn't an array, but since a second value has been specified,
                    // convert val into an array.
                    obj[key] = [obj[key], val];

                } else {
                    // val is a scalar.
                    obj[key] = val;
                }
            }

        } else if (key) {
            // No value was defined, so set something meaningful.
            obj[key] = coerce ? undefined : '';
        }
    });

    return obj;
};
/* eslint-enable */

/**
 * Defers to jQuery.param, however, if jQuery is
 * not present, mimics the functionality for
 * most use cases.
 * @param {object} obj
 * @param {boolean} [traditional=false]
 * @returns {string}
 */
bunsen.queryStringFromObj = function (obj, traditional) {
    if ($ && $.param) {
        return $.param(obj, traditional);
    }
    var params = [];
    var add = function (val, key) {
        var i = 0;
        if (_.isArray(val)) {
            for (i; i < val.length; i++) {
                add(val[i], (traditional ? key : key + '[]'));
            }
        } else if (val && typeof val === 'object') {
            console.error('bunsen.queryStringFromObject does not support nested objects if jQuery.param is unavailable');
        } else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
        }
    };
    _.each(obj, add);
    return params.join('&').replace(/%20/g, '+');
};

/**
 * add URL params to backbone model or backbone collection URL
 * @param model - backbone model or backbone collection
 * @param object - a map of key/value pairs to be appended to the URL
 * @param [traditional] {boolean} use the traditional method of serializing arrays and objects to query params
 */
bunsen.extendURL = function (url, object, traditional) {
    var urlArray = url.split('?');
    var queries;

    queries = urlArray[1] ? bunsen.deparam(urlArray[1]) : {};
    _.extend(queries, object);
    return urlArray[0] + '?' + bunsen.queryStringFromObj(queries, traditional);
};

bunsen.replaceURLQueryParams = function (url, object, traditional) {
    var innerUrl = url.split('?')[0];

    return innerUrl + '?' + bunsen.queryStringFromObj(object, traditional);
};

bunsen.getToken = function () {
    var token;
    var tokenObj = {};
    var userData = bunsen.getAdminUserData();
    var sellerData = bunsen.getSellerData();

    if (typeof window === 'undefined') {
        return {};
    }

    //Set user token for masquerade
    if (sellerData && userData) {
        token = $.cookie('userToken') ? $.cookie('userToken') : userData.token;
        tokenObj.userToken = token;
    //Be extra sure we only send the sellerToken when we're on an Admin page
    } else if (sellerData) {
        token = sellerData.token;
        tokenObj.sellerToken = token;
    } else if ($.cookie('userToken')) {
        token = $.cookie('userToken');
        tokenObj.userToken = token;
    }
    return token ? tokenObj : null;
};

bunsen.getAdminUserData = function () {
    return SV.get('userData');
};

bunsen.getSellerData = function () {
    return SV.get('sellerData');
};

/**
 * @see {@link tokenReplace}
 * @deprecated
 */
bunsen.tokenReplace = tokenReplace;

/**
 * strips html tags from a string
 * modified from php.js - http://phpjs.org/functions/strip_tags/ - [insecure] whitelist
 *  functionality and php comment support was removed.
 * @param input {string} the string to remove tags in
 * @returns {string} the string with tags removed
 */
bunsen.stripTags = function (input) {
    input = typeof input === 'string' ? input : '';
    return input.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, '');
};


/**
 * Shortcut for jquery's deep clone
 * @param obj {Object} the object to clone
 */
bunsen.deepClone = function (obj) {
    return $.extend(true, {}, obj);
};

/**
 * Like _.result but lets you pass in a context
 * @param obj
 * @param prop
 * @param context
 * @returns {*}
 */
bunsen.result = function (obj, prop, context) {
    if (!obj) {
        return;
    }
    if (_.isFunction(obj[prop])) {
        return obj[prop].call(context || obj);
    }
    return obj[prop];
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.6.0
//     http://underscorejs.org
//     (c) 2009-2014 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Establish the object that gets returned to break out of a loop iteration.
  var breaker = {};

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    concat           = ArrayProto.concat,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeForEach      = ArrayProto.forEach,
    nativeMap          = ArrayProto.map,
    nativeReduce       = ArrayProto.reduce,
    nativeReduceRight  = ArrayProto.reduceRight,
    nativeFilter       = ArrayProto.filter,
    nativeEvery        = ArrayProto.every,
    nativeSome         = ArrayProto.some,
    nativeIndexOf      = ArrayProto.indexOf,
    nativeLastIndexOf  = ArrayProto.lastIndexOf,
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind;

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object via a string identifier,
  // for Closure Compiler "advanced" mode.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.6.0';

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles objects with the built-in `forEach`, arrays, and raw objects.
  // Delegates to **ECMAScript 5**'s native `forEach` if available.
  var each = _.each = _.forEach = function(obj, iterator, context) {
    if (obj == null) return obj;
    if (nativeForEach && obj.forEach === nativeForEach) {
      obj.forEach(iterator, context);
    } else if (obj.length === +obj.length) {
      for (var i = 0, length = obj.length; i < length; i++) {
        if (iterator.call(context, obj[i], i, obj) === breaker) return;
      }
    } else {
      var keys = _.keys(obj);
      for (var i = 0, length = keys.length; i < length; i++) {
        if (iterator.call(context, obj[keys[i]], keys[i], obj) === breaker) return;
      }
    }
    return obj;
  };

  // Return the results of applying the iterator to each element.
  // Delegates to **ECMAScript 5**'s native `map` if available.
  _.map = _.collect = function(obj, iterator, context) {
    var results = [];
    if (obj == null) return results;
    if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
    each(obj, function(value, index, list) {
      results.push(iterator.call(context, value, index, list));
    });
    return results;
  };

  var reduceError = 'Reduce of empty array with no initial value';

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`. Delegates to **ECMAScript 5**'s native `reduce` if available.
  _.reduce = _.foldl = _.inject = function(obj, iterator, memo, context) {
    var initial = arguments.length > 2;
    if (obj == null) obj = [];
    if (nativeReduce && obj.reduce === nativeReduce) {
      if (context) iterator = _.bind(iterator, context);
      return initial ? obj.reduce(iterator, memo) : obj.reduce(iterator);
    }
    each(obj, function(value, index, list) {
      if (!initial) {
        memo = value;
        initial = true;
      } else {
        memo = iterator.call(context, memo, value, index, list);
      }
    });
    if (!initial) throw new TypeError(reduceError);
    return memo;
  };

  // The right-associative version of reduce, also known as `foldr`.
  // Delegates to **ECMAScript 5**'s native `reduceRight` if available.
  _.reduceRight = _.foldr = function(obj, iterator, memo, context) {
    var initial = arguments.length > 2;
    if (obj == null) obj = [];
    if (nativeReduceRight && obj.reduceRight === nativeReduceRight) {
      if (context) iterator = _.bind(iterator, context);
      return initial ? obj.reduceRight(iterator, memo) : obj.reduceRight(iterator);
    }
    var length = obj.length;
    if (length !== +length) {
      var keys = _.keys(obj);
      length = keys.length;
    }
    each(obj, function(value, index, list) {
      index = keys ? keys[--length] : --length;
      if (!initial) {
        memo = obj[index];
        initial = true;
      } else {
        memo = iterator.call(context, memo, obj[index], index, list);
      }
    });
    if (!initial) throw new TypeError(reduceError);
    return memo;
  };

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var result;
    any(obj, function(value, index, list) {
      if (predicate.call(context, value, index, list)) {
        result = value;
        return true;
      }
    });
    return result;
  };

  // Return all the elements that pass a truth test.
  // Delegates to **ECMAScript 5**'s native `filter` if available.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    if (obj == null) return results;
    if (nativeFilter && obj.filter === nativeFilter) return obj.filter(predicate, context);
    each(obj, function(value, index, list) {
      if (predicate.call(context, value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, function(value, index, list) {
      return !predicate.call(context, value, index, list);
    }, context);
  };

  // Determine whether all of the elements match a truth test.
  // Delegates to **ECMAScript 5**'s native `every` if available.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate || (predicate = _.identity);
    var result = true;
    if (obj == null) return result;
    if (nativeEvery && obj.every === nativeEvery) return obj.every(predicate, context);
    each(obj, function(value, index, list) {
      if (!(result = result && predicate.call(context, value, index, list))) return breaker;
    });
    return !!result;
  };

  // Determine if at least one element in the object matches a truth test.
  // Delegates to **ECMAScript 5**'s native `some` if available.
  // Aliased as `any`.
  var any = _.some = _.any = function(obj, predicate, context) {
    predicate || (predicate = _.identity);
    var result = false;
    if (obj == null) return result;
    if (nativeSome && obj.some === nativeSome) return obj.some(predicate, context);
    each(obj, function(value, index, list) {
      if (result || (result = predicate.call(context, value, index, list))) return breaker;
    });
    return !!result;
  };

  // Determine if the array or object contains a given value (using `===`).
  // Aliased as `include`.
  _.contains = _.include = function(obj, target) {
    if (obj == null) return false;
    if (nativeIndexOf && obj.indexOf === nativeIndexOf) return obj.indexOf(target) != -1;
    return any(obj, function(value) {
      return value === target;
    });
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      return (isFunc ? method : value[method]).apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matches(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matches(attrs));
  };

  // Return the maximum element or (element-based computation).
  // Can't optimize arrays of integers longer than 65,535 elements.
  // See [WebKit Bug 80797](https://bugs.webkit.org/show_bug.cgi?id=80797)
  _.max = function(obj, iterator, context) {
    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
      return Math.max.apply(Math, obj);
    }
    var result = -Infinity, lastComputed = -Infinity;
    each(obj, function(value, index, list) {
      var computed = iterator ? iterator.call(context, value, index, list) : value;
      if (computed > lastComputed) {
        result = value;
        lastComputed = computed;
      }
    });
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iterator, context) {
    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
      return Math.min.apply(Math, obj);
    }
    var result = Infinity, lastComputed = Infinity;
    each(obj, function(value, index, list) {
      var computed = iterator ? iterator.call(context, value, index, list) : value;
      if (computed < lastComputed) {
        result = value;
        lastComputed = computed;
      }
    });
    return result;
  };

  // Shuffle an array, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var rand;
    var index = 0;
    var shuffled = [];
    each(obj, function(value) {
      rand = _.random(index++);
      shuffled[index - 1] = shuffled[rand];
      shuffled[rand] = value;
    });
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (obj.length !== +obj.length) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // An internal function to generate lookup iterators.
  var lookupIterator = function(value) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return value;
    return _.property(value);
  };

  // Sort the object's values by a criterion produced by an iterator.
  _.sortBy = function(obj, iterator, context) {
    iterator = lookupIterator(iterator);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iterator.call(context, value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iterator, context) {
      var result = {};
      iterator = lookupIterator(iterator);
      each(obj, function(value, index) {
        var key = iterator.call(context, value, index, obj);
        behavior(result, key, value);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, key, value) {
    _.has(result, key) ? result[key].push(value) : result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, key, value) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, key) {
    _.has(result, key) ? result[key]++ : result[key] = 1;
  });

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iterator, context) {
    iterator = lookupIterator(iterator);
    var value = iterator.call(context, obj);
    var low = 0, high = array.length;
    while (low < high) {
      var mid = (low + high) >>> 1;
      iterator.call(context, array[mid]) < value ? low = mid + 1 : high = mid;
    }
    return low;
  };

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (obj.length === +obj.length) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return (obj.length === +obj.length) ? obj.length : _.keys(obj).length;
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if ((n == null) || guard) return array[0];
    if (n < 0) return [];
    return slice.call(array, 0, n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N. The **guard** check allows it to work with
  // `_.map`.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, array.length - ((n == null) || guard ? 1 : n));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array. The **guard** check allows it to work with `_.map`.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if ((n == null) || guard) return array[array.length - 1];
    return slice.call(array, Math.max(array.length - n, 0));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array. The **guard**
  // check allows it to work with `_.map`.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, (n == null) || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, output) {
    if (shallow && _.every(input, _.isArray)) {
      return concat.apply(output, input);
    }
    each(input, function(value) {
      if (_.isArray(value) || _.isArguments(value)) {
        shallow ? push.apply(output, value) : flatten(value, shallow, output);
      } else {
        output.push(value);
      }
    });
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, []);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Split an array into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(array, predicate) {
    var pass = [], fail = [];
    each(array, function(elem) {
      (predicate(elem) ? pass : fail).push(elem);
    });
    return [pass, fail];
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iterator, context) {
    if (_.isFunction(isSorted)) {
      context = iterator;
      iterator = isSorted;
      isSorted = false;
    }
    var initial = iterator ? _.map(array, iterator, context) : array;
    var results = [];
    var seen = [];
    each(initial, function(value, index) {
      if (isSorted ? (!index || seen[seen.length - 1] !== value) : !_.contains(seen, value)) {
        seen.push(value);
        results.push(array[index]);
      }
    });
    return results;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(_.flatten(arguments, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var rest = slice.call(arguments, 1);
    return _.filter(_.uniq(array), function(item) {
      return _.every(rest, function(other) {
        return _.contains(other, item);
      });
    });
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = concat.apply(ArrayProto, slice.call(arguments, 1));
    return _.filter(array, function(value){ return !_.contains(rest, value); });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    var length = _.max(_.pluck(arguments, 'length').concat(0));
    var results = new Array(length);
    for (var i = 0; i < length; i++) {
      results[i] = _.pluck(arguments, '' + i);
    }
    return results;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    if (list == null) return {};
    var result = {};
    for (var i = 0, length = list.length; i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // If the browser doesn't supply us with indexOf (I'm looking at you, **MSIE**),
  // we need this function. Return the position of the first occurrence of an
  // item in an array, or -1 if the item is not included in the array.
  // Delegates to **ECMAScript 5**'s native `indexOf` if available.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = function(array, item, isSorted) {
    if (array == null) return -1;
    var i = 0, length = array.length;
    if (isSorted) {
      if (typeof isSorted == 'number') {
        i = (isSorted < 0 ? Math.max(0, length + isSorted) : isSorted);
      } else {
        i = _.sortedIndex(array, item);
        return array[i] === item ? i : -1;
      }
    }
    if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item, isSorted);
    for (; i < length; i++) if (array[i] === item) return i;
    return -1;
  };

  // Delegates to **ECMAScript 5**'s native `lastIndexOf` if available.
  _.lastIndexOf = function(array, item, from) {
    if (array == null) return -1;
    var hasIndex = from != null;
    if (nativeLastIndexOf && array.lastIndexOf === nativeLastIndexOf) {
      return hasIndex ? array.lastIndexOf(item, from) : array.lastIndexOf(item);
    }
    var i = (hasIndex ? from : array.length);
    while (i--) if (array[i] === item) return i;
    return -1;
  };

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (arguments.length <= 1) {
      stop = start || 0;
      start = 0;
    }
    step = arguments[2] || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var idx = 0;
    var range = new Array(length);

    while(idx < length) {
      range[idx++] = start;
      start += step;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Reusable constructor function for prototype setting.
  var ctor = function(){};

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    var args, bound;
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError;
    args = slice.call(arguments, 2);
    return bound = function() {
      if (!(this instanceof bound)) return func.apply(context, args.concat(slice.call(arguments)));
      ctor.prototype = func.prototype;
      var self = new ctor;
      ctor.prototype = null;
      var result = func.apply(self, args.concat(slice.call(arguments)));
      if (Object(result) === result) return result;
      return self;
    };
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    return function() {
      var position = 0;
      var args = boundArgs.slice();
      for (var i = 0, length = args.length; i < length; i++) {
        if (args[i] === _) args[i] = arguments[position++];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return func.apply(this, args);
    };
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var funcs = slice.call(arguments, 1);
    if (funcs.length === 0) throw new Error('bindAll must be passed function names');
    each(funcs, function(f) { obj[f] = _.bind(obj[f], obj); });
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memo = {};
    hasher || (hasher = _.identity);
    return function() {
      var key = hasher.apply(this, arguments);
      return _.has(memo, key) ? memo[key] : (memo[key] = func.apply(this, arguments));
    };
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){ return func.apply(null, args); }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = function(func) {
    return _.delay.apply(_, [func, 1].concat(slice.call(arguments, 1)));
  };

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    options || (options = {});
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0) {
        clearTimeout(timeout);
        timeout = null;
        previous = now;
        result = func.apply(context, args);
        context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;
      if (last < wait) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) {
        timeout = setTimeout(later, wait);
      }
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = function(func) {
    var ran = false, memo;
    return function() {
      if (ran) return memo;
      ran = true;
      memo = func.apply(this, arguments);
      func = null;
      return memo;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var funcs = arguments;
    return function() {
      var args = arguments;
      for (var i = funcs.length - 1; i >= 0; i--) {
        args = [funcs[i].apply(this, args)];
      }
      return args[0];
    };
  };

  // Returns a function that will only be executed after being called N times.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Object Functions
  // ----------------

  // Retrieve the names of an object's properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = new Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = new Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = function(obj) {
    each(slice.call(arguments, 1), function(source) {
      if (source) {
        for (var prop in source) {
          obj[prop] = source[prop];
        }
      }
    });
    return obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(obj) {
    var copy = {};
    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
    each(keys, function(key) {
      if (key in obj) copy[key] = obj[key];
    });
    return copy;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj) {
    var copy = {};
    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
    for (var key in obj) {
      if (!_.contains(keys, key)) copy[key] = obj[key];
    }
    return copy;
  };

  // Fill in a given object with default properties.
  _.defaults = function(obj) {
    each(slice.call(arguments, 1), function(source) {
      if (source) {
        for (var prop in source) {
          if (obj[prop] === void 0) obj[prop] = source[prop];
        }
      }
    });
    return obj;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a == 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className != toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, dates, and booleans are compared by value.
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return a == String(b);
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive. An `egal` comparison is performed for
        // other numeric values.
        return a != +a ? b != +b : (a == 0 ? 1 / a == 1 / b : a == +b);
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a == +b;
      // RegExps are compared by their source patterns and flags.
      case '[object RegExp]':
        return a.source == b.source &&
               a.global == b.global &&
               a.multiline == b.multiline &&
               a.ignoreCase == b.ignoreCase;
    }
    if (typeof a != 'object' || typeof b != 'object') return false;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] == a) return bStack[length] == b;
    }
    // Objects with different constructors are not equivalent, but `Object`s
    // from different frames are.
    var aCtor = a.constructor, bCtor = b.constructor;
    if (aCtor !== bCtor && !(_.isFunction(aCtor) && (aCtor instanceof aCtor) &&
                             _.isFunction(bCtor) && (bCtor instanceof bCtor))
                        && ('constructor' in a && 'constructor' in b)) {
      return false;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    var size = 0, result = true;
    // Recursively compare objects and arrays.
    if (className == '[object Array]') {
      // Compare array lengths to determine if a deep comparison is necessary.
      size = a.length;
      result = size == b.length;
      if (result) {
        // Deep compare the contents, ignoring non-numeric properties.
        while (size--) {
          if (!(result = eq(a[size], b[size], aStack, bStack))) break;
        }
      }
    } else {
      // Deep compare objects.
      for (var key in a) {
        if (_.has(a, key)) {
          // Count the expected number of properties.
          size++;
          // Deep compare each member.
          if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack))) break;
        }
      }
      // Ensure that both objects contain the same number of properties.
      if (result) {
        for (key in b) {
          if (_.has(b, key) && !(size--)) break;
        }
        result = !size;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return result;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b, [], []);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (_.isArray(obj) || _.isString(obj)) return obj.length === 0;
    for (var key in obj) if (_.has(obj, key)) return false;
    return true;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) == '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    return obj === Object(obj);
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.
  each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) == '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return !!(obj && _.has(obj, 'callee'));
    };
  }

  // Optimize `isFunction` if appropriate.
  if (true) {
    _.isFunction = function(obj) {
      return typeof obj === 'function';
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj != +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) == '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iterators.
  _.identity = function(value) {
    return value;
  };

  _.constant = function(value) {
    return function () {
      return value;
    };
  };

  _.property = function(key) {
    return function(obj) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of `key:value` pairs.
  _.matches = function(attrs) {
    return function(obj) {
      if (obj === attrs) return true; //avoid comparing an object to itself.
      for (var key in attrs) {
        if (attrs[key] !== obj[key])
          return false;
      }
      return true;
    }
  };

  // Run a function **n** times.
  _.times = function(n, iterator, context) {
    var accum = Array(Math.max(0, n));
    for (var i = 0; i < n; i++) accum[i] = iterator.call(context, i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() { return new Date().getTime(); };

  // List of HTML entities for escaping.
  var entityMap = {
    escape: {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#x27;'
    }
  };
  entityMap.unescape = _.invert(entityMap.escape);

  // Regexes containing the keys and values listed immediately above.
  var entityRegexes = {
    escape:   new RegExp('[' + _.keys(entityMap.escape).join('') + ']', 'g'),
    unescape: new RegExp('(' + _.keys(entityMap.unescape).join('|') + ')', 'g')
  };

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  _.each(['escape', 'unescape'], function(method) {
    _[method] = function(string) {
      if (string == null) return '';
      return ('' + string).replace(entityRegexes[method], function(match) {
        return entityMap[method][match];
      });
    };
  });

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property) {
    if (object == null) return void 0;
    var value = object[property];
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result.call(this, func.apply(_, args));
      };
    });
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\t':     't',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g;

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  _.template = function(text, data, settings) {
    var render;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = new RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset)
        .replace(escaper, function(match) { return '\\' + escapes[match]; });

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      }
      if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      }
      if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }
      index = offset + match.length;
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + "return __p;\n";

    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    if (data) return render(data, _);
    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled function source as a convenience for precompilation.
    template.source = 'function(' + (settings.variable || 'obj') + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function, which will delegate to the wrapper.
  _.chain = function(obj) {
    return _(obj).chain();
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(obj) {
    return this._chain ? _(obj).chain() : obj;
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name == 'shift' || name == 'splice') && obj.length === 0) delete obj[0];
      return result.call(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result.call(this, method.apply(this._wrapped, arguments));
    };
  });

  _.extend(_.prototype, {

    // Start chaining a wrapped Underscore object.
    chain: function() {
      this._chain = true;
      return this;
    },

    // Extracts the result from a wrapped and chained object.
    value: function() {
      return this._wrapped;
    }

  });

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}).call(this);


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 12/21/13
 */


var Backbone = __webpack_require__(3);
var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var bunsenLibs = __webpack_require__(21);
var requ = __webpack_require__(1159);
var endpoints = __webpack_require__(6);
var getDeferredMethods = __webpack_require__(299);
var log = __webpack_require__(295);
var SV = __webpack_require__(18);

// ---------------------------------------------------
// Local vars

var pathregex = /(.+?\:\/\/[^/]+)?(.*$)/;
var DEFAULT_TRANSPORT = requ;
var Deferred = getDeferredMethods().Deferred;
var globalAutoclumpForceDisable = SV.get('settings.enabler.global_autoclump_force_disable');
var Clump;
var globalAutoEnabled;
var backboneSync;
var clumpBackboneSync;

// ---------------------------------------------------
// Module Definition

/**
 * Clump library:
 *
 * Add a request using clump.add. This will not actually submit the http request
 * but add it to a queue. This function takes a subset of the same options you
 * would pass to $.ajax and returns a promise that is resolved when the request
 * is completed.
 *
 * @class Clump
 *
 * @example
 * // Create a new instance of a clumper
 * var clump = new Clump();
 *
 * promise1 = clump.add({
 *    url: ‘/soa/identity/user/123’,
 *    type: ‘GET’,
 *    data: { foo: bar }
 * });
 *
 * promise2 = clump.add({
 *    url: ‘/soa/identity/user/456’,
 *    type: ‘POST’,
 *    data: { foo: bar }
 * });
 *
 * // Actually submit the HTTP request now. Returns a promise that is resolved
 * // when the actual HTTP request is complete. promise1 and promise2 will be
 * // resolved/rejected when this completes based on the HTTP status from the
 * // clump service response
 * clumpPromise = clump.run();
 *
 */
globalAutoEnabled = function () {
    return !globalAutoclumpForceDisable && _.result(Clump.global, 'auto');
};
Clump = module.exports = function (options) {
    options = options || {};
    this.auto = options.auto || false;
    this.transport = options.transport || Clump.transport;
    this.url = endpoints.clump();
    this.queue = [];
    this._deferreds = [];
    this._requestOptions = [];
};
Clump.MODE_SEQ = 'SYNC_SEQ';
Clump.MODE_PARALLEL = 'SYNC_PARALLEL';

Clump.prototype = {
    clear: function () {
        this._deferreds.length = 0;
        this.queue.length = 0;
        this._requestOptions.length = 0;
    },
    /**
     * @param {function} transport
     */
    setTransport: function (transport) {
        this.transport = transport;
    },
    /**
     * @param {object} passedOptions
     * @returns {$.Deferred.promise}
     */
    run: function (passedOptions) {
        var options = passedOptions || {};
        var self = this;
        var deferreds = _.clone(this._deferreds);
        var xhr = new Deferred();
        var queue = _.clone(this.queue);
        var madeSingleRequest;
        var firstDeferred;
        var data;
        var requestDataJSON;

        _.defaults(options, {
            mode: 'SYNC_SEQ'
        });

        if (0 === _.size(queue)) {
            // Nothing to send so just return a resolved deferred
            xhr.resolve();
        } else if (1 === _.size(queue) && (false !== this.auto)) {
            // fall back to a non-clumped request if:
            //  - there is only one element in the clump queue, and
            //  - this clump is in auto mode
            firstDeferred = _.first(this._deferreds);
            madeSingleRequest = this._makeRequest(_.first(this._requestOptions));
            madeSingleRequest
                .done(function () {
                    firstDeferred.resolveWith(madeSingleRequest, arguments);
                })
                .fail(function () {
                    firstDeferred.rejectWith(madeSingleRequest, arguments);
                });
            xhr.resolve();
        } else {
            data = {
                mode: options.mode,
                abortOnError: (options.abortOnError === true || options.abortOnError === 'Y') ? 'Y' : 'N',
                elements: queue
            };

            if (options.dynaOptions) {
                data.dynaOptions = options.dynaOptions;
            }

            requestDataJSON = JSON.stringify(data);
            xhr = this._makeRequest({
                url: _.result(this, 'url'),
                data: requestDataJSON,
                type: 'post',
                dataType: 'json',
                contentType: 'application/json',
                context: this
            });

            xhr.done(function (returnedData) {
                _.each(returnedData.result.clumpResponse.elements, function (element, index) {
                    var responseURL = element.url;
                    var requestURL = queue[index].url;
                    var thisDeferred = deferreds[index];
                    var status = element.httpCode;
                    var badClump;
                    var errorMessage;
                    if ('?' === responseURL.substr(-1)) {
                        responseURL = responseURL.slice(0, -1);
                    }
                    if ('?' === requestURL.substr(-1)) {
                        requestURL = requestURL.slice(0, -1);
                    }
                    requestURL = pathregex.exec(requestURL)[2];
                    responseURL = pathregex.exec(responseURL)[2];
                    if (requestURL !== responseURL) {
                        errorMessage = "Clump expected to dispatch a response from " + requestURL + " but instead received a response from " + responseURL + ". Index was " + index + ".\n";
                        badClump = true;
                    } else if (queue[index].method && element.method !== queue[index].method) {
                        errorMessage = "Clump expected to dispatch a response for a " + queue[index].method + " request but was instead given a response to a " + element.method + " request. Index was " + index + ".";
                        badClump = true;
                    }
                    if (badClump) {
                        errorMessage += "Entire request from clump service was: " + requestDataJSON + "\n";
                        errorMessage += "Entire response from clump service was: " + JSON.stringify(returnedData) + "\n";
                        log.remote.error(errorMessage);
                        return thisDeferred.rejectWith(thisDeferred, [thisDeferred, "error", errorMessage]);
                    }
                    _.extend(thisDeferred, {
                        clumpIndex: index,
                        status: element.httpCode,
                        statusText: _.isObject(element.payload) ? element.payload.message : null,
                        responseJSON: _.isObject(element.payload) ? element.payload.result : null
                    });
                    // Only 200 error codes will resolve. 304 is technically not an error
                    // but we can't handle that.
                    if (status >= 200 && status < 300) {
                        thisDeferred.resolve(element.payload, element.message, thisDeferred);
                    } else {
                        _.extend(thisDeferred, {
                            statusText: "Error " + element.httpCode,
                            responseText: self._getResponseTextFromPayload(element.payload),
                            responseJSON: element.payload,
                            url: element.url,
                            type: element.method,
                            data: data.elements[index].payload
                        });
                        thisDeferred.rejectWith(thisDeferred, [thisDeferred, "error", thisDeferred.statusText]);
                    }
                }, self);
            }).fail(function (jqXHR) {
                // The clump service failed so reject all of the queued deferreds
                var xhrFailArgs = arguments;
                _.each(deferreds, function (thisDeferred) {
                    _.each([
                        'status',
                        'statusText',
                        'responseJSON',
                        'responseText'
                    ], function (k) {
                        thisDeferred[k] = jqXHR[k];
                    });
                    thisDeferred.reject.apply(thisDeferred, [thisDeferred].concat(Array.prototype.slice.call(xhrFailArgs, 1)));
                }, self);
            });
        }
        this.clear();

        return xhr;
    },
    /**
     * @param {object} settings
     *      jQuery.ajax style options
     * @returns {$.Deferred.promise}
     *      A promise for this specific config's
     *      resolved data
     */
    add: function (settings) {
        var deferred = new Deferred();
        var queueObj = {};
        var wait;

        // Invoke the static _beforeAddCallback function,
        // if present.
        if (_.isFunction(Clump._beforeAddCallback)) {
            settings = Clump._beforeAddCallback(settings) || settings;
        }


        if (this.auto) {
            wait = 0;
            if ("number" === typeof this.auto) {
                wait = this.auto;
            }
            _.delay(_.bind(this.run, this), wait);
        }
        queueObj.method = settings.type ? settings.type.toUpperCase() : 'GET';
        if (settings.clumpName) {
            queueObj.name = settings.clumpName;
        }
        if (settings.clumpProfile) {
            queueObj.profile = settings.clumpProfile;
        }

        if (queueObj.method === 'GET') {
            queueObj.url = bunsenLibs.extendURL(settings.url, settings.data, true);
        } else {
            queueObj.url = settings.url;
            queueObj.payload = settings.data;
        }

        this.queue.push(queueObj);
        this._deferreds.push(deferred);
        this._requestOptions.push(settings);

        // Support for $.ajax success, error, complete options
        if (settings.success) {
            deferred.done(settings.success);
        }
        if (settings.error) {
            deferred.fail(settings.error);
        }
        if (settings.complete) {
            deferred.always(settings.complete);
        }

        return deferred.promise();
    },
    _getResponseTextFromPayload: function (payload) {
        var text;
        if (_.isString(payload)) {
            return payload;
        }
        try {
            text = JSON.stringify(payload);
        } catch (e) {
            // do nothing
        }
        if (!text) {
            return payload;
        }
        return text;
    },
    _makeRequest: function (options) {
        return this.transport(options);
    }
};

Clump.transport = DEFAULT_TRANSPORT;

Clump.global = new Clump(); // set Clump.global.auto = true to use global clump implicitly via auto

/**
 * Resets the static transport property to the default
 */
Clump.resetTransport = function () {
    Clump.transport = DEFAULT_TRANSPORT;
};

/**
 * Sets the static transport propery temporarily, then resets it once the given
 * function is finished executing.
 * @param fn {function}
 * @param transport {function}
 */
Clump.executeWithTemporaryTransport = function (fn, transport) {
    Clump.transport = transport;
    $.when(fn()).then(function () {
        Clump.resetTransport();
    });
};

/**
 * Make a request with the global clump
 * instance (accessed through Clump.global)
 * @returns {$.Deferred.promise}
 */
Clump.ajax = function () { // use Clump.global to make a request if it exists and is set to auto, otherwise use $.ajax
    var clump;

    if (Clump.global && globalAutoEnabled()) {
        return Clump.global.add.apply(Clump.global, arguments);
    }

    clump = new Clump();
    return clump._makeRequest.apply(clump, arguments);
};

/**
 * Set a callback that is invoked every time
 * 'add' is called. Either through Backbone or
 * through manually adding to a clump instance.
 * You can do this to modify options for a
 * particular clump call element.
 * @param {function} callback
 * @return {function} Clump constructor
 */
Clump.setBeforeAddCallback = function (callback) {
    Clump._beforeAddCallback = callback;
    return Clump;
};

// TODO: remove the lines below that modify backbone directly and implement a system that doesn't rely on use side-effects requiring this package, e.g. middleware

backboneSync = Backbone.sync;

/**
 * Patch Backbone.sync to add clump support. Overrides Backbone.sync
 * and gives you the ability to add a 'clump' option to save/fetch calls.
 * @inner
 * @memberOf Clump
 * @param {string} method
 * @param {Backbone.Collection|Backbone.Model} model
 * @param {object} options
 * @return {$.Deferred.promise}
 *
 * @example
 * // Create a clump instance and some Backbone Objects
 * var clump = new Clump(),
 *     transactions = new bunsen.Transactions(), // Collection
 *     note = new bunsen.Note({content: ‘my content’}); // Model
 *
 * // pass the clump instance as an option to any of the
 * // backbone sync methods (save, fetch, destroy, etc)
 * transactions.fetch({clump: clump});
 * note.save(null, {clump: clump});
 *
 * // Request is actually submitted now. Sync events are triggered on
 * Backbone objects when this completes.
 * clump.run();
 *
 */
clumpBackboneSync = function (method, model, options) {
    var clump = options && options.clump;
    var xhr;
    var oldAjax;
    clump = clump || false !== clump && (globalAutoEnabled() ? Clump.global : false); // use global clump if no clump is passed, and auto is enabled for the global clump
    // If we are not using a clump, use backboneSync
    if (!clump) {
        return backboneSync.apply(this, arguments);
    }
    // Temporarily swap out Backbone ajax for clump.add
    oldAjax = Backbone.ajax;
    Backbone.ajax = _.bind(clump.add, clump);
    // Now call the original backbone sync
    xhr = backboneSync.apply(this, arguments);
    // Set Backbone.ajax back to the original value for the next call.
    Backbone.ajax = oldAjax;
    return xhr;
};


/**
 * Force clump to replace the clump version
 * of Backbone.sync with the custom one
 */
Clump.restoreOrigBackboneSync = function () {
    Backbone.sync = backboneSync;
};
/**
 * If using the original Backbone.sync function,
 * you can replace it with the clump Backbone.sync
 * function with this method.
 */
Clump.useClumpBackboneSync = function () {
    Backbone.sync = clumpBackboneSync;
};

// Use the clump backbone sync by default and override Backbone.sync
Clump.useClumpBackboneSync();


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * 1stdibs
 * User: Rob
 * Date: 8/22/13
 */

/**
 * @mixes bunsen.SoaCollection
 * @class
 * @property {bunsen.Offer} model - {@link bunsen.Offer}
 * @property {endpoints.offers} url -
 */
var SoaCollection = __webpack_require__(9);
var root = typeof window === 'undefined' ? global : window;
var Notes = module.exports = root.bunsen.Notes = SoaCollection.extend();


/**
 * @class Notes
 * @extends SoaCollection
 */

var endpoints     = __webpack_require__(6);
var Note          = __webpack_require__(33);
var moment        = __webpack_require__(30);
var User          = __webpack_require__(28);
var _             = __webpack_require__(0);
var $             = __webpack_require__(5);
var Party         = __webpack_require__(8);

var filterNoteByFn = function (fn) {
    return this.filter(function (note) {
        return note[fn]();
    });
};

root.bunsen = root.bunsen || {};

_.extend(Notes, {
    /**
     * Create a new Note instance
     * @param {object} [options]
     * @param {string} [options.role=INTERNAL]
     * @param {string} [options.type=ADMIN]
     * @param {string} [options.level=INFO]
     * @param {string|number} [options.creatorId] Defaults to current user id
     * @param {string} [options.content] Defaults to empty string
     * @param {anchors} [options.anchors] Defaults to empty array
     * @returns {Note}
     */
    newNote: function (options) {
        var user = User.getCurrentUserSV() || {};
        options = _.defaults(options || {}, {
            role: Party.ROLE_INTERNAL,
            type: Note.TYPE_ADMIN,
            level: 'INFO',
            creatorId: user.id,
            content: '',
            service: endpoints.latest.identity
        });

        return new Note({
            type: options.type,
            content: options.content,
            level: options.level,
            anchors: options.anchors,
            createdBy: {
                role: options.role,
                id: options.creatorId
            }
        }, {
            service: options.service
        });
    },
    /**
     * Partial application of newNote that defaults
     * the note role and sets the type to BUYER_SELLER
     * @param {object} [newNoteOptions]
     *      Same as Note.newNote options except for role and type
     * @param {string} [newNoteOptions.role=SELLER]
     * @param {string} [newNoteOptions.level=INFO]
     * @param {string|number} [newNoteOptions.creatorId] Defaults to current user id
     * @param {string} [newNoteOptions.content] Defaults to empty string
     * @param {anchors} [newNoteOptions.anchors] Defaults to empty array
     * @returns {Note}
     */
    newBuyerSellerNote: function (newNoteOptions) {
        newNoteOptions = _.extend({
            role: Party.ROLE_SELLER
        }, newNoteOptions, { type: Note.TYPE_BUYER_SELLER });
        return Notes.newNote(newNoteOptions);
    }
});

_.extend(Notes.prototype, {
    model: Note,
    url : endpoints.note(null, this.service),
    initialize : function (models, options) {
        this.service = options.service || endpoints.latest.identity;
        return Notes.__super__.initialize.call(this, models, options);
    },
    comparator: function (note) {
        return parseInt(moment(new Date(note.get("createdDate"))).format("X"), 10) || -1;
    },
    getOldest : function () {
        var oldest;
        if (moment) {
            this.each(function (note) {
                if (!oldest || parseInt(moment(new Date(oldest.get('createdDate'))).format('X'), 10) > parseInt(moment(note.get('createdDate')).format('X'), 10)) {
                    oldest = note;
                }
            });
        }
        return oldest;
    },
    getBuyerSellerNotes: _.partial(filterNoteByFn, 'isBuyerSellerType'),
    getUnanchoredBuyerSellerNotes: _.partial(filterNoteByFn, 'isUnanchoredBuyerSellerType'),
    /**
     * Get the FIRST note in the collection which was created
     * by someone matching the passed in role
     * @param role
     * @returns {*}
     */
    getByCreatorRole : function (role) {
        return this.find(function (note) {
            return note.get('createdBy') && note.get('createdBy.role') === role;
        });
    },

    fetchNotesByAnchor : function (anchor, options) {
        var fetchOptions = {
            url: endpoints.notesByAnchor(anchor)
        };

        _.extend(fetchOptions, options);

        return this.fetch(fetchOptions);
    },
    /**
     * Fetch the anchor models from the id (e.g. fetch a seller model
     * for the anchor with the sourceType seller) and store them
     * on the inflatedAnchors property of each Note model in the collection
     * @param sourceTypes
     * @returns {$.promise}
     */
    fetchAnchors : function (sourceTypes) {
        var dfd = $.Deferred();
        var len = this.length;
        var proms = [];
        var i = -1;
        var self = this;

        while (++i < len) {
            proms.push(this.models[i].fetchAnchors(sourceTypes));
        }
        $.when.apply($, proms).done(function () {
            dfd.resolveWith(self, _.toArray(arguments));
        }).fail(function () {
            dfd.rejectWith(self, _.toArray(arguments));
        });
        return dfd.promise();
    },
    newNote: function (passedOptions) {
        return Notes.newNote(passedOptions);
    },
    newBuyerSellerNote: function (newNoteOptions) {
        return Notes.newBuyerSellerNote(newNoteOptions);
    },
    addNewNote: function (noteOptions, syncOptions) {
        var note = this.newNote(noteOptions);
        this.add(note);
        return note.save(null, syncOptions);
    }
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(1983);

var serverVars = __webpack_require__(18);
var _gas = __webpack_require__(2084);
var gtmDataLayer = __webpack_require__(2085);
var parseurl = __webpack_require__(4053);
var jsCookie = __webpack_require__(1456);
var Deferred = __webpack_require__(29).Deferred;
var merge = __webpack_require__(3964);

var undefined = void(0);
var root = typeof window === 'undefined' ? global : window;
var location = root.document ? root.document.location : {hostname: ''};
var cookieSettings = {
    path : '/',
    domain : location.hostname.split('.').slice(-2).join('.')
};

function isEmpty(value) {
    return value ? !Object.keys(value).length : true;
}

function pick(data, dataKeys) {
    var newObject = {};
    Object.keys(data).forEach(function (key) {
        if (dataKeys.indexOf(key) !== -1) {
            newObject[key] = data[key];
        }
    });
    return newObject;
}

function omit(data, dataKeys) {
    var newObject = {};
    Object.keys(data).forEach(function (key) {
        if (dataKeys.indexOf(key) === -1) {
            newObject[key] = data[key];
        }
    });
    return newObject;
}

/*
 *
 * SETUP 1STDIBS-SPECIFIC TRACKING HERE, DON'T PUT OUTSIDE DEPENDENCIES IN GAS.SETUP
 *
 */

// serverVars is undefined on legacy pages
// TODO: May have to do this for data layers
serverVars = serverVars || {};
var serverVarsTracking = serverVars.tracking;
var customVarLoginStr = 'login='; // used for tracking.getLoggedInStatus
var tracking = {};
var defaults = {
    'opt_label': undefined,
    'opt_value': undefined,
    'opt_noninteraction': undefined
};

// provide backward-compatibility for the legacy
// dibs.tracking.customVars array
if (serverVarsTracking) {
    tracking.customVars = serverVarsTracking.customVars || [];
}

// Boolean flags and methods used to ensure events are fired to Google Tag Manager in the correct order
// (see startTrackingEvents method description)
var gtmInitialInfoFired     = false;
var gtmInitialPageViewFired = false;
var startTrackingEvents;

var ecomParseUrl;
var ecomGetProducts;
var mergeAdditionalData;
var useShippingStatusData;
var shippingStatusDfd       = Deferred();
var gtmEventQueue           = [];
var gtmPageInfo             = serverVars.get('tracking.initialDataLayerInfo');
var gtmUserAttributeKeys    = [
    'loginStatus',
    'registrationStatus',
    'userID',
    'guestID',
    'userEmail',
    'userEmailAddress',
    'emailToken',
    'userZip',
    'defaultCurrency',
    'firstSessionDate',
    'contactDealerStatus',
    'buyerStatus',
    'firstPurchaseDate',
    'firstPurchasePrice',
    'tradeStatus',
    'customerType'
];
var gtmContentGroupKeys     = ['pageType', 'pageSubType', 'pageLevel', 'pageSection', 'pageCategory'];
var comCustomDimensionMap = {
    dimension1  : 'timePeriod',
    dimension2  : 'creator',
    dimension8  : 'onSale',
    dimension9  : 'newListing',
    dimension11 : 'dealerName',
    dimension12 : 'dealerID',
    dimension13 : 'dealerLocation',
    dimension20 : 'itemPostingLocation',
    dimension37 : 'purchaseStatus',
    dimension38 : 'askingPrice',
    dimension76 : 'priceType'
};

/**
 * For Google Tag Manager to work properly the order in which data is added to the dataLayer is important
 *  1. initial page data/user info
 *  2. initial page view event
 *  3. any ga events fired on the page
 * This is a private function which is called by either tracking.trackPageView or tracking.addUserAttributes and
 * controls this flow of how events are fired.
 * @private
 */
startTrackingEvents = function () {
    // need to check that we aren't already tracking events so that forEach call
    // doesn't accidentally put us in an infinite loop
    if (gtmEventQueue === gtmDataLayer) {
        return;
    }

    // add each of the events in the queue to the gtmDataLayer (in fifo order)
    gtmEventQueue.forEach(function (event, index) {
        gtmDataLayer.push(event);
    });

    // change reference
    gtmEventQueue = gtmDataLayer;
};

/**
 * helper method used to parse a pdp url for an item's category level (L1/L2/L3), name and id
 * @param url
 * @returns {*}
 */
ecomParseUrl = function (url) {
    var pathArr;
    if (typeof url !== 'string') {
        return {};
    }
    // given a pdp url of the form -->
    //      https://www.1stdibs.com/{L1}/{l2}/{L3}/{product name}/id-{item pk}/?{random params}
    // set pathArr to
    //      [path, {L1/L2/L3}, {L1}, {L2}, {L3}, {product name}, {item pk}]
    pathArr = /^\/(?:([^\/]*)\/([^\/]*)(?:(?:\/([^\/]*)(?:\/([^\/]*)))|(?:\/([^\/]*))?))\/id-([^/]+)\/?$/i.exec(parseurl({url: url}).pathname);
    if (isEmpty(pathArr)) {
        return {};
    }
    // grab the item id, the product name and the uri substring for the categories
    return {
        category: [pathArr[1], pathArr[2], pathArr[3]].filter(function (elem) {
            return !!elem;
        }).join('/'),  // {L1/L2/L3}
        name: (pathArr[4] || pathArr[5] || '').split('-').join(' '),
        id: pathArr[6]
    };
};

/**
 * helper method (used in ecommerceProduct) that takes the trackObj products array and returns a product array
 * formatted for the GTM tracking object.
 * @param prodArr
 * @returns {Array}
 */
ecomGetProducts = function (productArray) {
    var outArr = [];
    var productData;
    if (productArray !== undefined && productArray.length) {
        productArray.forEach(function (product, index) {
            productData = merge(ecomParseUrl(product.url), product);
            productData = mergeAdditionalData(productData, product);
            productData = omit(productData, ['url', 'additional']);
            outArr.push(productData);
        });
    }
    return outArr;
};

/**
 * this helper function is used in tracking.trackPageView, tracking.trackSocial, and tracking.trackEvent
 * to merge additional data into the trackObject that is pushed to the dataLayer
 * @param gtmData
 * @param trackObj
 */
mergeAdditionalData = function (gtmData, trackObj) {
    var additionalData = trackObj ? trackObj.additional : {};
    return merge({}, gtmData, additionalData);
};

/**
 * Sets flag to ensure we wait for shipping status data to resolve before we track it
 */
tracking.setupShippingStatusTracking = function () {
    useShippingStatusData = true;
};

/**
 * Resolves the shippingStatusDfd singleton with the passed data
 */
tracking.resolveShippingStatusDfdWith = function (data) {
    shippingStatusDfd.resolve(data);
};

/**
 * check for this value at run time instead of setting it once at run time
 * @returns {boolean}
 */
tracking.isGaAllowed = function () {
    // phpstorm says this condition can be simplified
    // but it makes it less readable IMO
    // return !(serverVars.settings && serverVars.settings.allowGa === false);
    // is what it like instead
    if (serverVars.settings && serverVars.settings.allowGa === false) {
        return false;
    }
    return true;
};

/**
 * returns the logged in status of the user
 * @param {boolean} status Whether the user is logged in or not
 * @returns {string}
 */
tracking.getLoggedInStatus = function (status) {
    if (typeof status !== 'boolean') {
        return customVarLoginStr + 'n';
    }
    return customVarLoginStr + (status ? 'y' : 'n');
};

/**
 * pushes userAttributes into the dataLayer (along with the gtmPageInfo)
 * @param trackObj
 */
tracking.addUserAttributes = function addUserAttributes(trackObj) {
    var gtmUserAttributes;
    if (!isEmpty(trackObj) && !gtmInitialInfoFired) {
        // filters out invalid userAttribute keys
        gtmUserAttributes = pick(trackObj, gtmUserAttributeKeys);

        // Once the shipping status data is available, proceed setting attributes to the gtmDataLayer
        // If not using shipping status data, go forward and resolve the deferred object
        if (!useShippingStatusData) {
            shippingStatusDfd.resolve();
        }
        shippingStatusDfd.done(function (userQuoteData) {

            // pushing the initial dataLayerInfo directly to the dataLayer
            gtmDataLayer.push(merge(gtmUserAttributes, gtmPageInfo, userQuoteData));
            gtmInitialInfoFired = true;

            // if the pageView has not been fired then we want to wait for it to be fired to start tracking events
            if (gtmInitialPageViewFired) {
                startTrackingEvents();
            }
        });

    }
};

tracking.resetGTMPageView = function resetGTMPageView() {
    gtmInitialPageViewFired = false;
    gtmEventQueue           = [];
};

/**
 * resets the google tag manager tracking by setting all the flags back to false, recreating the event queue
 * ** FOR TESTING **
 */
tracking.resetGtmTracking = function resetGtmTracking() {
    gtmInitialInfoFired     = false;
    gtmPageInfo             = serverVars.get('tracking.initialDataLayerInfo');
    this.resetGTMPageView();
};

/**
 * when tracking object is not known in client, there has to be a way
 * around setting it without using server-vars.
 */
tracking.setGtmPageInfo = function setGtmPageInfo(trackingObj) {
    gtmPageInfo = trackingObj;
};

/**
 * sets te google tag manager tracking flags to true and calls startTrackingEvents()
 * ** FOR TESTING **
 */
tracking.setGtmFlagsTrue = function setGtmFlagsTrue() {
    gtmInitialInfoFired     = true;
    gtmInitialPageViewFired = true;
    startTrackingEvents();
};

/**
 * The main page view tracking call
 * @param {string || object} trackObj       Can either be the literal url or an object with a url key
 *                                          (can also be undefined in which case GTM will internally grab
 *                                          the url from the page)
 * @param {string} trackObj.url
 * @param {object} [trackObj.additional]    An object with any additional key/value pairs to pass to GTM
 *                                          added to gtmData in mergeAdditionalData(gtmData, trackObj)
 */
tracking.trackPageview = function trackPageview(trackObj) {
    var gtmData;

    // this is necessary for stale logins on checkout
    // so that the page view tracking doesn't fire twice
    if (this.isGaAllowed()) {

        gtmData = {
            'event'         : 'e_ga_pageview',
            'opt_pageURL'   : (typeof trackObj === 'object') ? trackObj.url : trackObj
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);
        gtmData.opt_pageURL = gtmData.opt_pageURL || undefined; // eslint-disable-line

        // If this is not the initial page view then just push it like a regular event
        if (gtmInitialPageViewFired) {
            gtmEventQueue.push(gtmData);

            // If it is the initial page view then add it to the beginning of the queue, switch flag
        } else {
            gtmEventQueue.unshift(gtmData);
            gtmInitialPageViewFired = true;

            // if the initial dataLayer info has not been added then we want to wait to start tracking events
            if (gtmInitialInfoFired) {
                startTrackingEvents();
            }
        }
    }
};

// TODO: REMOVE CUSTOM VARIABLE STUFF BECAUSE GA IS NO LONGER USING CUSTOM VARIABLES IN UNIVERSAL ANALYTICS
/**
 * set a custom var for google analytics.  Having one spot to set this allows for better control of determining
 * when to fire and when not to fire these events
 * FINDING-2644 - do not allow browser "previews" from firing tracking
 * https://developers.google.com/analytics/devguides/collection/gajs/gaTrackingCustomVariables
 *
 * @param {object}  trackObj        The tracking object used by google analytics
 * @param {int}     trackObj.slot   The slot number for the custom var. Defaults to 1
 * @param {string}  trackObj.name   The 2nd-level name for your online content categories
 * @param {string}  trackObj.value  The value to set trackObj.name to
 * @param {int}     trackObj.scope  The scope of the page level based on the GA docs (1, 2 or 3).  Defaults to 1
 */
tracking.setCustomVar = function setCustomVar(trackObj) {
    if (this.isGaAllowed() && !isEmpty(trackObj)) {
        _gas.push([
            '_setCustomVar',
            trackObj.slot || 1,
            trackObj.name || 'No Page Name',
            trackObj.value || 'No Page Value',
            trackObj.scope || 1
        ]);
        this.setCustomVarLocal(trackObj);
    }
};

/**
 * Sets the tracking object to a 'local' cookie representing the
 * current state of custom vars in GA
 * @param {object} trackingObj The tracking object used by google analytics
 */
tracking.setCustomVarLocal = function setCustomVarLocal(trackingObj) {
    var localCustomVars;
    jsCookie.json = true;
    localCustomVars = jsCookie.getJSON('lcv') || {};
    localCustomVars[trackingObj.slot] = trackingObj;
    jsCookie.set('lcv', localCustomVars, cookieSettings);
    delete jsCookie.json;
};

/**
 * Gets the "local" copy of the GA custom vars for the given slot
 * @param {int}     slotNumber
 *
 * @returns {object}
 */
tracking.getCustomVar = function getCustomVar(slotNumber) {
    var localCustomVars;

    jsCookie.json = true;
    localCustomVars = jsCookie.get('lcv') || {};
    delete jsCookie.json;

    return localCustomVars[slotNumber];
};

/**
 * Event tracking using Google Tag Manager
 * @param {object} trackObj
 * @param {string} trackObj.category    The tracking category - a way to group objects to track
 * @param {string} trackObj.action      The tracking action - typically the type of event or interaction
 * @param {string} [trackObj.label]     The tracking label - additional dimension to use for tracking
 * @param {number} [trackObj.value]     The tracking value
 * @param {boolean} [trackObj.noninteraction] Affects bounce rate (must be explicitly passed in to trigger a page view)
 *                                            - `true` (default) will not count as another page view which will mean if a user visits one page, interacts, and leaves, a bounce will be triggered (expected)
 *                                            - `false` will essentially treat the interaction as a page view and not trigger a bounce if the user leaves the page
 * @param {object} [trackObj.additional] An object with any additional key/value pairs to pass to GTM
 */
tracking.trackEvent = function trackEvent(trackObj) {
    var gtmData;
    if (!isEmpty(trackObj)) {
        trackObj.value          = (trackObj.value !== undefined) ? trackObj.value : 0;
        trackObj.noninteraction = (trackObj.noninteraction !== undefined) ? trackObj.noninteraction : 1;

        gtmData = {
            'event'         : 'e_ga_event',
            'category'      : (trackObj.category || 'no category').toLowerCase(),
            'action'        : trackObj.action || 'no action',
            'label'         : trackObj.label || 'none',
            'value'         : trackObj.value,
            'noninteraction': trackObj.noninteraction
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);

        gtmEventQueue.push(gtmData);
    }
};
/**
 * Form Error tracking using Google Tag Manager
 * @param trackObj
 */
tracking.trackFormError = function (trackObj) {
    var gtmData;
    if (!isEmpty(trackObj)) {
        trackObj.value          = (trackObj.value !== undefined) ? trackObj.value : 0;
        trackObj.noninteraction = (trackObj.noninteraction !== undefined) ? trackObj.noninteraction : 1;

        gtmData = {
            'event'         : 'e_form_error',
            'category'      : 'form error',
            'action'        : trackObj.action || 'no action',
            'label'         : trackObj.label || 'none',
            'value'         : trackObj.value,
            'noninteraction': trackObj.noninteraction
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);

        gtmEventQueue.push(gtmData);
    }
};

/**
 * Social tracking using Google Tag Manager
 * @param {object} trackObj
 * @param {string} trackObj.name            The social network name
 * @param {string} trackObj.event           The type of event it is firing
 * @param {object} [trackObj.additional]    An object with any additional key/value pairs to pass to GTM
 */
tracking.trackSocial = function trackSocial(trackObj) {
    var gtmData;

    if (trackObj.name && trackObj.event) {
        gtmData = {
            'event'         : 'e_ga_social',
            'network'       : trackObj.name,
            'socialAction'  : trackObj.event,
            'opt_target'    : trackObj.opt_target   || undefined,
            'opt_pagePath'  : trackObj.opt_pagePath || undefined
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);

        gtmEventQueue.push(gtmData);
    }
};

/**
 * Ecommerce Tracking used in Google Tag Manager
 * @param {object} trackObj
 * @param {string} trackObj.type            - productImpression/productClick/productDetail
 * @param {Array}  trackObj.products        - an array of objects, each containing one product's info
 *                                              {   url     : product url,
 *                                                  brand   : dealer id,
 *                                                  price   : USD price     ... }
 * @param {object} [trackObj.actionField]   - an object containing additional information specific to each tracking type
 *                                          { list : list,
 *                                            step : 1      ... }
 */
tracking.trackEcommerce = function ecommerceProduct(trackObj) {
    var products;
    var ecommerce = {};

    if (!isEmpty(trackObj) && trackObj.type) {
        products = ecomGetProducts(trackObj.products);
        switch (trackObj.type) {
            case 'productImpression' :
                if (products.length) {
                    ecommerce.impressions = products;
                } else {
                    ecommerce = undefined;
                }
                break;
            case 'productClick':
                if (trackObj.actionField && trackObj.actionField.list && products.length) {
                    ecommerce.click = {
                        'actionField' : { list : trackObj.actionField.list },
                        'products'    : products
                    };
                }
                break;
            case 'productDetail':
                if (products.length) {
                    ecommerce.detail = { 'products' : products };
                } else {
                    ecommerce = undefined;
                }
                break;
            case 'addToCart':
                if (products.length) {
                    ecommerce.add = { 'products'  : products };
                }
                break;
            case 'checkout':
                if (trackObj.actionField && trackObj.actionField.step && products.length) {
                    ecommerce.checkout = {
                        'actionField'   : { 'step' : trackObj.actionField.step },
                        'products'      : products
                    };
                    if (trackObj.option) {
                        ecommerce.checkout.option = trackObj.option;
                    }
                }
                break;
            case 'promotionImpression' :
                if (trackObj.promotions && trackObj.promotions.length) {
                    ecommerce.promoView = { promotions : trackObj.promotions };
                }
                break;
            case 'promoClick' :
                if (trackObj.promotions && trackObj.promotions.length) {
                    ecommerce.promoClick = { promotions : trackObj.promotions };
                }
                break;
        }
        // FINDING-8606 allow ecommerce === undefined because when ecommerce
        // is undefined it removes the event from the data layer. Which stops it from
        // being tracked on every vpv
        if (!isEmpty(ecommerce) || ecommerce === undefined) {
            gtmEventQueue.push({
                'event'     : 'ecommerce_' + trackObj.type,
                'ecommerce' : ecommerce
            });
        }
    }
};

/**
 * Maps the data values to the appropriate custom dimension indexes used by google analytics
 * (e.g. returns object { dimension1 : '1900s', dimension38 : '1000' } which ga will then map on their end
 * to 'timePeriod' and 'askingPrice' respectively).
 * @param   {object} data
 * @param   {array}  [dataKeys]         optional parameter to specify which specific keys in the
 *                                      data param should be tracked.
 * @returns {object} customDimensions
 */
tracking.getCustomDimensions = function (data, dataKeys) {
    var customDimensions = {};

    if (data !== undefined) {
        // removes any key/values that are not wanted
        data = dataKeys ? pick(data, dataKeys) : data;

        // returns an object with the data object values associated with the correct dimension key
        var keys = Object.keys(comCustomDimensionMap);
        keys.forEach(function (key) {
            if (data[comCustomDimensionMap[key]] !== undefined) {
                customDimensions[key] = data[comCustomDimensionMap[key]];
            }
        });
    }

    return customDimensions;
};

/**
 * Ecommerce tracking function (specifically for tracking transactions)
 * This need to be sent to Google before userAttributes, gtmPageInfo or pageview is fired.
 * @param {object} trackObj
 * @param {array} trackObj.products
 * @param {object} trackObj.actionField
 */
tracking.trackEcommercePurchase = function (trackObj) {
    var products = ecomGetProducts(trackObj.products);
    var ecommerce = {};

    if (trackObj.actionField && products.length) {
        ecommerce.purchase = {
            'actionField'   : trackObj.actionField,
            'products'      : products
        };
    }

    if (!isEmpty(ecommerce)) {
        gtmDataLayer.push({
            'event'     : 'ecommerce_' + trackObj.type,
            'ecommerce' : ecommerce
        });
    }
};

tracking.addGTMMessage = function (message) {
    gtmDataLayer.push(message);
};

/**
 * Grabs a page's current content groupings
 * (This is needed when modals are opened and closed so that events are attributed to the correct page without firing
 * pageviews that will inflate GA's page hit numbers)
 * @return {object} contentGroupings
 */
tracking.getOriginContentGroupings = function () {
    return pick(gtmPageInfo || {}, gtmContentGroupKeys);
};

tracking.fireDummyEvent = function () {
    //we need to fire a dummy trackEvent in order to send the custom variable to the GA server
    //http://stackoverflow.com/questions/10038450/setting-a-custom-variable-in-google-analytics-after-trackpageview-is-called
    this.trackEvent({
        category: 'Dummy Event',
        action: 'Dummy Event',
        label: ''
    });
};

tracking.setDefault = function setDefault(what, toWhat) {
    var i;
    if (what && typeof what === 'object') {
        for (i in what) {
            if (what.hasOwnProperty(i)) {
                this.setDefault(i, what[i]);
            }
        }
    }
    what = '' + what;
    if (defaults.hasOwnProperty(what)) {
        defaults[what] = toWhat;
    }
};

tracking.clearDefault = function (what) {
    return this.setDefault(what, undefined);
};

module.exports = tracking;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Gedas
 * Date: 4/9/15
 * Time: 3:00 PM
 * Copyright 1stdibs.com, Inc. 2015. All Rights Reserved.
 */



var get = __webpack_require__(2661);
var includes = __webpack_require__(843);

// ---------------------------------------------------
// Load Super Class

var SoaModel = __webpack_require__(2);

// ---------------------------------------------------
// Module Definition

/**
 * @class User
 * @extends SoaModel
 */
var User = module.exports = SoaModel.extend();
var root = typeof window === 'undefined' ? global : window;

// ---------------------------------------------------
// Local Variables

var users = {};
var promises = {};
var triedGettingUserFromSV;

// ---------------------------------------------------
// Dependencies

var $                   = __webpack_require__(5);
var _                   = __webpack_require__(0);
var Backbone            = __webpack_require__(3);
var endpoints           = __webpack_require__(6);
var Role                = __webpack_require__(1623);
var Roles               = __webpack_require__(2040);
var UserSocialNetworks  = __webpack_require__(3827);
var Permissions         = __webpack_require__(2641);
var Permission          = __webpack_require__(940);
var UserProfile         = __webpack_require__(1218);
var UserProProfile      = __webpack_require__(2052);
var Newsletters         = __webpack_require__(1621);
var AddressBook         = __webpack_require__(2050);
var Note                = __webpack_require__(33);
var moment              = __webpack_require__(30);
var SV                  = __webpack_require__(18);
var Portfolio           = __webpack_require__(292);
var PortfolioCollection = __webpack_require__(866);
var Notes               = __webpack_require__(24);
var log                 = __webpack_require__(295);
var defaultCurrency     = __webpack_require__(10).CURRENCY_USD;

__webpack_require__(677); // jQuery.fn.cookie

// ---------------------------------------------------

if (root.bunsen) {
    root.bunsen.User = root.User = User;
}

// ---------------------------------------------------
// Define Module Constants

_.extend(User, {
    COOKIE_USER             : 'userToken',
    COOKIE_USER_LEGACY      : 'userreg',
    COOKIE_USER_MASQUERADE  : 'masqueradeBuyer',
    COOKIE_USER_TYPE        : 'userType',
    COOKIE_GUEST_ID         : 'guestId',
    COOKIE_EVER_LOGGED_IN   : 'eli',
    COOKIE_PASSWORD_RESET   : 'passwordToken',
    FIELD_FULL_PROFILE      : 'fullProfile',
    FIELD_MIN_PROFILE       : 'minProfile',
    FIELD_ADDRESS           : 'address',
    FIELD_CONVERSATION      : 'CONVERSATION_SUMMARY',
    FIELD_PERMISSIONS       : 'permissions',
    FIELD_WALLET            : 'wallet',
    FIELD_CART              : 'CART',
    FIELD_ROLES             : 'roles',
    FIELD_SOCIAL_NETWORKS   : 'SOCIAL_NETWORK',
    MAX_AGE_ECOM            : 'ECOM_OFFER',
    MAX_AGE_ECOM_WITH_OFFSET: 'ECOM_OFFER.minus(480)',
    MAX_AGE_SAVE_PASSWORD   : 'SAVE_PASSWORD.minus(120)',
    TYPE_SELLER             : 'seller',
    TYPE_INTERNAL           : 'internal',
    BUYER_TRADE             : 'B_TRADE_BUYER',
    BUYER_VIP               : 'B_VIP_BUYER',
    USER_CURRENT            : 'current',
    USER_REAL               : 'real',
    TRADE_STATUSES          : {
        N_A: 'N_A',
        SUSPECTED: 'SUSPECTED',
        APPLIED_IN_REVIEW: 'APPLIED_IN_REVIEW',
        APPLIED_NOT_ENOUGH_INFORMATION: 'APPLIED_NOT_ENOUGH_INFORMATION',
        APPLIED_REJECTED: 'APPLIED_REJECTED',
        VERIFIED_PRE_APPROVED: 'VERIFIED_PRE_APPROVED',
        VERIFIED_VETTED: 'VERIFIED_VETTED'
    }
});

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(User.prototype, {

    idAttribute: 'id',

    url: function () {
        return endpoints.userById(this.get(this.idAttribute));
    },

    relations: function () {
        return [
            {
                key: 'profile',
                relatedModel : UserProfile,
                type: Backbone.One
            },
            {
                key: 'proProfile',
                relatedModel: UserProProfile,
                type: Backbone.One
            },
            {
                key: 'addressBook',
                relatedModel: AddressBook,
                type: Backbone.One
            },
            {
                key: 'newsletters',
                relatedModel: Newsletters,
                type: Backbone.One
            },
            {
                key: 'portfolio',
                relatedModel: Portfolio,
                type: Backbone.One
            },
            {
                key: 'roles',
                collectionType: Roles,
                type: Backbone.Many,
                omitFromSave: true
            },
            {
                key: 'permissions',
                relatedModel: Permissions,
                type: Backbone.One,
                omitFromSave: true
            },
            {
                key: 'wallet',
                type: Backbone.One,
                omitFromSave: true,
                relatedModel: SoaModel
            },
            {
                key: 'conversationSummary',
                relatedModel: SoaModel,
                type: Backbone.One
            },
            {
                key: 'socialNetworks',
                collectionType: UserSocialNetworks,
                type: Backbone.Many
            }
        ];
    },

    /**
     * @param {String} url
     * @param {String} email
     * @param {String} password
     * @param {String} [role]
     * @returns {Promise}
     * @private
     */
    _authenticate: function (url, email, password, roleName) {
        var data = this.toJSON();

        var userData = {
            email: email,
            password: password
        };

        /* roleName should only be defined when registering with a pre-set role */
        if (roleName) {
            userData.role = { name: roleName };
        }

        return this.clear().save(null, {
            url: url,
            attrs: userData
        }).always(function () {
            this.set(_.extend(data, this.toJSON()));
        }.bind(this));
    },

    isInitialized: function () {
        var id = this.get('id');
        return id && id !== 'me';
    },

    /**
     * @returns {Object}
     */
    getValuesForDetailDisplayString: function () {
        var profile = this.get('profile');
        return {
            profile: profile,
            displayName: profile.getDisplayName(),
            id: this.get('id'),
            email: profile.get('email'),
            registeredLabel: 'Registered',
            registeredDateString: moment(this.get('createdDate')).format('l')
        };
    },

    /**
     * @param {*} perm - a single permission or array of permissions
     * @returns {*}
     */
    hasPermission: function (perm) {
        var permissions = this.get('permissions');
        if (permissions) {
            return permissions.checkPermissions(perm);
        } else {
            return null;
        }
    },

    /**
     * @param {String} roleName
     * @returns {Boolean|null}
     */
    hasRole: function (roleName) {
        var roles = this.get('roles');
        if (!roles) {
            // We don't know this user's roles
            return null;
        } else {
            // Returns true if user has a role with this name
            return roles.some(function (role) {
                return role.get('name') === roleName;
            });
        }
    },

    /**
     * @param {String} roleName
     * @param {Object} options
     * @returns {*}
     */
    addRole: function (roleName, options) {
        var role = new Role({name: roleName});
        this.get('roles').add(role);
        return role.saveRoleForUser(options);
    },

    /**
     * @param {String} roleName
     * @param {Object} options
     * @returns {*}
     */
    removeRole: function (roleName, options) {
        var role = this.get('roles').findWhere({name: roleName});
        return role.removeRoleFromUser(options);
    },

    hasTradeBuyerPermission: function () {
        return this.hasPermission(Permission.PERMISSION_B_NET_PRICE) || this.hasPermission(Permission.PERMISSION_B_TRADE_CHECKOUT);
    },

    /**
     * @returns {String|null}
     */
    getTradeStatus: function () {
        var roles = this.get('roles');
        var tradeRole;

        if (!roles) {
            return null;
        } else {
            tradeRole = roles.find(function (role) {
                return role.get('name') === User.BUYER_TRADE;
            });

            if (tradeRole && tradeRole.get) {
                return get(tradeRole.get('userData'), 'userStatus.name', User.TRADE_STATUSES.N_A);
            }

            return User.TRADE_STATUSES.N_A;
        }
    },

    /**
     * @returns {Boolean|null}
     */
    isVerifiedTradeBuyer: function () {
        var tradeStatus = this.getTradeStatus();
        var verifiedStatuses = [User.TRADE_STATUSES.VERIFIED_PRE_APPROVED, User.TRADE_STATUSES.VERIFIED_VETTED];

        if (tradeStatus === null) {
            return null;
        } else {
            return includes(verifiedStatuses, tradeStatus);
        }
    },

    /**
     * @returns {Boolean|null}
     */
    isVipBuyer: function () {
        return this.hasRole(User.BUYER_VIP);
    },
    /**
     * @param {String} itemPk
     * @returns {*}
     */
    getPortfoliosWithItem: function (itemPk) {
        var portfolios = new PortfolioCollection();
        return portfolios.fetch({data : {userId : this.get('id'), itemId : itemPk}});
    },

    /**
     * @param {String} itemPk
     * @param {String} section
     * @returns {*}
     */
    addItemToDefaultPortfolio: function (itemPk, section) {
        var portfolio = this.get('portfolio');
        if (!portfolio) {
            portfolio = new Portfolio({id:0});
        }
        return portfolio.addItem(itemPk, section, {queries: {userId: this.get('id')}});
    },

    /**
     * @param {String} itemPk
     * @param {String} section
     * @returns {*}
     */
    removeItemFromDefaultPortfolio: function (itemPk, section) {
        var portfolio = this.get('portfolio');
        if (!portfolio) {
            portfolio = new Portfolio({id:0});
        }
        return portfolio.removeItem(itemPk, section, {queries: {userId: this.get('id')}});
    },

    /**
     * @param {Object} passedOptions
     * @returns {*}
     */
    newAccountNote: function (passedOptions) {
        _.defaults(passedOptions, {
            type: Note.TYPE_ADMIN_BUYER_ACCOUNT,
            anchors: [
                {
                    sourceId: this.id,
                    sourceType: 'USER'
                }
            ]
        });
        return Notes.newNote(passedOptions);
    },

    /**
     * @param {Object} noteOptions
     * @param {Object} syncOptions
     * @returns {*}
     */
    addNewAccountNote: function (noteOptions, syncOptions) {
        var note = this.newAccountNote(noteOptions);
        return note.save(null, syncOptions);
    },

    /**
     * @returns {Boolean}
     */
    isSeller: function () {
        return this.get('type') === User.TYPE_SELLER;
    },

    /**
     * @param {String} email
     * @param {String} password
     * @returns {Promise}
     */
    login: function (email, password) {
        return this._authenticate(endpoints.userLogin(), email, password);
    },

    /**
     * @param {String} email
     * @returns {Promise}
     */
    checkEmail: function (email) {
        return this.fetch({
            url: endpoints.userRegister(email),
            type: 'HEAD'
        });
    },

    /**
     * @param {String} email
     * @param {String} password
     * @returns {Promise}
     */
    register: function (email, password) {
        return this._authenticate(endpoints.userRegister(), email, password);
    },

    /**
     * @param {String} email
     * @param {String} password
     * @param {String} role
     * @returns {Promise}
     */
    registerWithRole: function (email, password, role) {
        return this._authenticate(endpoints.userRegister(), email, password, role);
    },

    /**
     * @param {String} email
     * @returns {Promise}
     */
    forgotPassword: function (email) {
        return this.destroy({
            url: endpoints.userPassword(User.getUserIdMe(), {
                email: email
            })
        });
    },

    /**
     * @param {String} password
     * @returns {Promise}
     */
    resetPassword: function (password) {
        return this.save(null, {
            url: endpoints.userPassword(User.getUserIdMe(), {
                passwordToken: $.cookie(User.COOKIE_PASSWORD_RESET)
            }),
            attrs: {
                password: password
            }
        });
    },

    /**
     * @param {String} currentPassword
     * @param {String} newPassword
     * @returns {Promise}
     */
    updatePassword: function (currentPassword, newPassword) {
        var self = this;

        return User.getCurrentUserPromise().then(function () {
            return self.login(self.get('profile.email'), currentPassword).then(function () {
                self.save(null, {
                    url: endpoints.userPassword(User.getUserIdMe(), {
                        userToken: self.get('token')
                    }),
                    attrs: {
                        password: newPassword
                    }
                }).then(function (response) {
                    if (response.result && response.result.user) {
                        self.set(response.result.user);
                    }
                    return response;
                });
            });
        });
    },

    /**
     * @param {String} guestId
     * @returns {Promise}
     */
    saveGuestId: function (guestId) {
        this.sync('create', this, {
            url: endpoints.userSourceAttribution(this.get('id')),
            attrs: {
                elementList: [{
                    type: 'GUEST_USER',
                    date: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                    utmParams: { guestUserId: guestId }
                }]
            }
        });
    },
    getProCompanyName: function () {
        var addressBook = this.get('addressBook');
        var proAddress;
        if (!addressBook) {
            return '';
        }
        proAddress = addressBook.getProAddress();
        if (proAddress) {
            return proAddress.get('company');
        }
    },
    getCityState: function () {
        var addressBook = this.get('addressBook');
        var addresses = [];
        var addressList;
        var address;
        if (addressBook) {
            addressList = addressBook.get('addressList');
            if (addressList) {
                addresses.push(addressBook.getPersonalAddress());
                addresses.push(addressList.first());
            }
        }
        addresses.push(this.get('profile'));
        address = _.chain(addresses).compact().first().value();
        if (!address || address.get('country') === "-1") {
            return '';
        }
        return address.getDisplayLocation();
    }
});

// ---------------------------------------------------
// Define Module Static Properties

_.extend(User, {
    /**
     * @param {Object} attrs
     * @returns {User}
     * @private
     */
    _createInstance: function (attrs) {
        return new User(attrs);
    },

    /**
     * @param {String} key
     * @param {Boolean} force
     * @returns {User}
     * @private
     */
    _getUser: function (key, force) {
        var id;
        if (!users[key] || force) {
            id = this.getUserIdMe(key === User.USER_REAL);
            users[key] = this._createInstance({id: id});
        }

        return users[key];
    },

    /**
     * @param {String} key
     * @private
     */
    _clearUser: function (key) {
        if (users[key]) {
            users[key] = null;
        }
    },

    /**
     * @param {String} key
     * @param {Object} options
     * @returns {Promise}
     * @private
     */
    _fetchUser: function (key, options) {
        var user = this._getUser(key);
        options = options || {};

        return user.fetch(options)
            .then(function () {
                return user;
            });
    },
    /**
     * @param {String} key
     * @param {Boolean} force
     * @param {Object} options
     * @returns {Promise}
     * @private
     */
    _getUserPromise: function (key, force, options) {
        if (!key) {
            return null;
        }

        if (!promises[key] || force) {
            promises[key] = this._fetchUser(key, options);
        }

        return promises[key];
    },

    /**
     * @param {String} key
     * @private
     */
    _clearUserPromise: function (key) {
        if (promises[key]) {
            promises[key] = null;
        }
    },

    /**
     * @param {Boolean} [getRealUser] - skip masquerading
     * @returns {String}
     */
    getUserId: function (getRealUser) {
        // jank work-around for GOODS-2407
        // todo User model needs to be made Universal (isomorphic)
        if (!$.cookie || typeof document === 'undefined') {
            return null;
        }

        var userMasqueradeCookie = $.cookie(User.COOKIE_USER_MASQUERADE); // eslint-disable-line vars-on-top
        var userCookie = $.cookie(User.COOKIE_USER); // eslint-disable-line vars-on-top

        if (userMasqueradeCookie && !getRealUser) {
            return userMasqueradeCookie.slice(2);
        } else {
            return userCookie ? userCookie.substr(0, userCookie.indexOf('_')) : null;
        }
    },

    /**
     * @param {Boolean} getRealUser - skip masquerading
     * @returns {String}
     */
    getUserIdMe: function (getRealUser) {
        return this.getUserId(getRealUser) || 'me';
    },

    /**
     * Return user token
     *
     * @returns {string}
     */
    getUserToken: function () {
        return $.cookie(User.COOKIE_USER);
    },

    /**
     * @returns {Boolean}
     */
    loggedIn: function () {
        return !!this.getUserToken();
    },

    /**
     * @returns {Boolean}
     */
    everLoggedIn: function () {
        return !!$.cookie(User.COOKIE_EVER_LOGGED_IN);
    },

    /**
     * @returns {Boolean}
     */
    isMasquerading: function () {
        return !!$.cookie(User.COOKIE_USER_MASQUERADE);
    },

    /**
     * @param {Boolean} force
     * @param {Object} options
     * @returns {Promise}
     */
    getCurrentUserPromise: function (force, options) {
        return this._getUserPromise(User.USER_CURRENT, force, options);
    },

    /**
     * Null out the current user promise. Should be mostly helpful for testing
     */
    clearCurrentUserPromise: function () {
        this._clearUserPromise(User.USER_CURRENT);
    },

    /**
     * Return the current user singleton
     * @returns {User}
     */
    getCurrentUser: function () {
        return this._getUser(User.USER_CURRENT);
    },

    /**
     * Null out the current user. Should be mostly helpful for testing
     */
    clearCurrentUser: function () {
        this._clearUser(User.USER_CURRENT);
    },

    /**
     * @returns {Promise}
     */
    getRealUserPromise: function () {
        return this._getUserPromise(User.USER_REAL);
    },

    /**
     * Null out the real user promise. Should be mostly helpful for testing
     */
    clearRealUserPromise: function () {
        this._clearUserPromise(User.USER_REAL);
    },

    /**
     * Return the real user singleton.
     * @returns {User}
     */
    getRealUser: function () {
        return this._getUser(User.USER_REAL);
    },

    /**
     * Null out the real user. Should be mostly helpful for testing
     */
    clearRealUser: function () {
        this._clearUser(User.USER_REAL);
    },

    /**
     * Returns the current user singleton.
     * Will instantiate it if an `attrs` hash is passed and there it hasn't been instantiated yet.
     *
     * @param {Object} attrs - An attributes hash to instantiate a new user singleton
     * @returns {User|null}
     */
    getCurrentUserInit: function (attrs) {
        if (!users[User.USER_CURRENT] && attrs) {
            users[User.USER_CURRENT] = this._createInstance(attrs);
        }
        return users[User.USER_CURRENT];
    },

    /**
     * Returns the current user singleton.
     * Will instantiate it from __SERVER_VARS__.userData hash if it hasn't been instantiated yet.
     * @returns {User}
     */
    getCurrentUserSV: function () {
        return this.getCurrentUserInit(SV.userData);
    },

    /**
     * Returns a promise that will resolve to the current user.
     * @returns {Promise}
     */
    gotCurrentUser: function () {
        var currentUserPromise = promises[User.USER_CURRENT];
        var userFromSV;

        if (currentUserPromise) {
            return currentUserPromise;
        }
        if (!triedGettingUserFromSV) {
            triedGettingUserFromSV = true;
            userFromSV = this.getCurrentUserSV();
            if (userFromSV) {
                promises[User.USER_CURRENT] = $.Deferred().resolve(userFromSV);
            }
        }
        if (!currentUserPromise) {
            currentUserPromise = this.getCurrentUserPromise();
        }
        return currentUserPromise;
    },

    /**
     * @param {Boolean} force - Force fetching current user from the server
     * @returns {Promise|*}
     */
    fetchCurrentUser : function (force, options) {
        var user = this._getUser(User.USER_CURRENT, force);

        return user.fetch(options).then(function (data) {
            if (!user.get('profile')) {
                log.remote.error(
                    JSON.stringify({
                        "User object from services does not have a profile property; something is awry" : data
                    })
                );
            }
            return user;
        });
    },

    /**
     * Tests if the user token is "fresh" enough to checkout
     * @returns {Promise}
     */
    canCurrentUserCheckout: function (options) {
        options = _.extend({}, options);
        options.data = _.extend(options.data || {}, {
            maxAge: User.MAX_AGE_ECOM_WITH_OFFSET
        });

        return User.fetchCurrentUser(false, options);
    },

    /**
     * @returns {String}
     */
    getCurrentUserCurrency: function () {
        var user = User.getCurrentUser();
        return user && user.get('profile.currency') || defaultCurrency;
    }
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.6.3
(function() {
  var Deferred, PENDING, REJECTED, RESOLVED, VERSION, after, execute, flatten, has, installInto, isArguments, isPromise, wrap, _when,
    __slice = [].slice;

  VERSION = '3.0.0';

  PENDING = "pending";

  RESOLVED = "resolved";

  REJECTED = "rejected";

  has = function(obj, prop) {
    return obj != null ? obj.hasOwnProperty(prop) : void 0;
  };

  isArguments = function(obj) {
    return has(obj, 'length') && has(obj, 'callee');
  };

  isPromise = function(obj) {
    return has(obj, 'promise') && typeof (obj != null ? obj.promise : void 0) === 'function';
  };

  flatten = function(array) {
    if (isArguments(array)) {
      return flatten(Array.prototype.slice.call(array));
    }
    if (!Array.isArray(array)) {
      return [array];
    }
    return array.reduce(function(memo, value) {
      if (Array.isArray(value)) {
        return memo.concat(flatten(value));
      }
      memo.push(value);
      return memo;
    }, []);
  };

  after = function(times, func) {
    if (times <= 0) {
      return func();
    }
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  wrap = function(func, wrapper) {
    return function() {
      var args;
      args = [func].concat(Array.prototype.slice.call(arguments, 0));
      return wrapper.apply(this, args);
    };
  };

  execute = function(callbacks, args, context) {
    var callback, _i, _len, _ref, _results;
    _ref = flatten(callbacks);
    _results = [];
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      callback = _ref[_i];
      _results.push(callback.call.apply(callback, [context].concat(__slice.call(args))));
    }
    return _results;
  };

  Deferred = function() {
    var candidate, close, closingArguments, doneCallbacks, failCallbacks, progressCallbacks, state;
    state = PENDING;
    doneCallbacks = [];
    failCallbacks = [];
    progressCallbacks = [];
    closingArguments = {
      'resolved': {},
      'rejected': {},
      'pending': {}
    };
    this.promise = function(candidate) {
      var pipe, storeCallbacks;
      candidate = candidate || {};
      candidate.state = function() {
        return state;
      };
      storeCallbacks = function(shouldExecuteImmediately, holder, holderState) {
        return function() {
          if (state === PENDING) {
            holder.push.apply(holder, flatten(arguments));
          }
          if (shouldExecuteImmediately()) {
            execute(arguments, closingArguments[holderState]);
          }
          return candidate;
        };
      };
      candidate.done = storeCallbacks((function() {
        return state === RESOLVED;
      }), doneCallbacks, RESOLVED);
      candidate.fail = storeCallbacks((function() {
        return state === REJECTED;
      }), failCallbacks, REJECTED);
      candidate.progress = storeCallbacks((function() {
        return state !== PENDING;
      }), progressCallbacks, PENDING);
      candidate.always = function() {
        var _ref;
        return (_ref = candidate.done.apply(candidate, arguments)).fail.apply(_ref, arguments);
      };
      pipe = function(doneFilter, failFilter, progressFilter) {
        var filter, master;
        master = new Deferred();
        filter = function(source, funnel, callback) {
          if (!callback) {
            return candidate[source](master[funnel]);
          }
          return candidate[source](function() {
            var args, value;
            args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
            value = callback.apply(null, args);
            if (isPromise(value)) {
              return value.done(master.resolve).fail(master.reject).progress(master.notify);
            } else {
              return master[funnel](value);
            }
          });
        };
        filter('done', 'resolve', doneFilter);
        filter('fail', 'reject', failFilter);
        filter('progress', 'notify', progressFilter);
        return master;
      };
      candidate.pipe = pipe;
      candidate.then = pipe;
      if (candidate.promise == null) {
        candidate.promise = function() {
          return candidate;
        };
      }
      return candidate;
    };
    this.promise(this);
    candidate = this;
    close = function(finalState, callbacks, context) {
      return function() {
        if (state === PENDING) {
          state = finalState;
          closingArguments[finalState] = arguments;
          execute(callbacks, closingArguments[finalState], context);
          return candidate;
        }
        return this;
      };
    };
    this.resolve = close(RESOLVED, doneCallbacks);
    this.reject = close(REJECTED, failCallbacks);
    this.notify = close(PENDING, progressCallbacks);
    this.resolveWith = function(context, args) {
      return close(RESOLVED, doneCallbacks, context).apply(null, args);
    };
    this.rejectWith = function(context, args) {
      return close(REJECTED, failCallbacks, context).apply(null, args);
    };
    this.notifyWith = function(context, args) {
      return close(PENDING, progressCallbacks, context).apply(null, args);
    };
    return this;
  };

  _when = function() {
    var def, defs, finish, resolutionArgs, trigger, _i, _len;
    defs = flatten(arguments);
    if (defs.length === 1) {
      if (isPromise(defs[0])) {
        return defs[0];
      } else {
        return (new Deferred()).resolve(defs[0]).promise();
      }
    }
    trigger = new Deferred();
    if (!defs.length) {
      return trigger.resolve().promise();
    }
    resolutionArgs = [];
    finish = after(defs.length, function() {
      return trigger.resolve.apply(trigger, resolutionArgs);
    });
    defs.forEach(function(def, index) {
      if (isPromise(def)) {
        return def.done(function() {
          var args;
          args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
          resolutionArgs[index] = args.length > 1 ? args : args[0];
          return finish();
        });
      } else {
        resolutionArgs[index] = def;
        return finish();
      }
    });
    for (_i = 0, _len = defs.length; _i < _len; _i++) {
      def = defs[_i];
      isPromise(def) && def.fail(trigger.reject);
    }
    return trigger.promise();
  };

  installInto = function(fw) {
    fw.Deferred = function() {
      return new Deferred();
    };
    fw.ajax = wrap(fw.ajax, function(ajax, options) {
      var createWrapper, def, promise, xhr;
      if (options == null) {
        options = {};
      }
      def = new Deferred();
      createWrapper = function(wrapped, finisher) {
        return wrap(wrapped, function() {
          var args, func;
          func = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
          if (func) {
            func.apply(null, args);
          }
          return finisher.apply(null, args);
        });
      };
      options.success = createWrapper(options.success, def.resolve);
      options.error = createWrapper(options.error, def.reject);
      xhr = ajax(options);
      promise = def.promise();
      promise.abort = function() {
        return xhr.abort();
      };
      return promise;
    });
    return fw.when = _when;
  };

  if (true) {
    exports.Deferred = function() {
      return new Deferred();
    };
    exports.when = _when;
    exports.installInto = installInto;
  } else if (typeof define === 'function' && define.amd) {
    define(function() {
      if (typeof Zepto !== 'undefined') {
        return installInto(Zepto);
      } else {
        Deferred.when = _when;
        Deferred.installInto = installInto;
        return Deferred;
      }
    });
  } else if (typeof Zepto !== 'undefined') {
    installInto(Zepto);
  } else {
    this.Deferred = function() {
      return new Deferred();
    };
    this.Deferred.when = _when;
    this.Deferred.installInto = installInto;
  }

}).call(this);


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
//! version : 2.10.6
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, function () { 'use strict';

    var hookCallback;

    function utils_hooks__hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return Object.prototype.toString.call(input) === '[object Array]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function create_utc__createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    function valid__isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            m._isValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated;

            if (m._strict) {
                m._isValid = m._isValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        return m._isValid;
    }

    function valid__createInvalid (flags) {
        var m = create_utc__createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    var momentProperties = utils_hooks__hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (typeof from._isAMomentObject !== 'undefined') {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (typeof from._i !== 'undefined') {
            to._i = from._i;
        }
        if (typeof from._f !== 'undefined') {
            to._f = from._f;
        }
        if (typeof from._l !== 'undefined') {
            to._l = from._l;
        }
        if (typeof from._strict !== 'undefined') {
            to._strict = from._strict;
        }
        if (typeof from._tzm !== 'undefined') {
            to._tzm = from._tzm;
        }
        if (typeof from._isUTC !== 'undefined') {
            to._isUTC = from._isUTC;
        }
        if (typeof from._offset !== 'undefined') {
            to._offset = from._offset;
        }
        if (typeof from._pf !== 'undefined') {
            to._pf = getParsingFlags(from);
        }
        if (typeof from._locale !== 'undefined') {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i in momentProperties) {
                prop = momentProperties[i];
                val = from[prop];
                if (typeof val !== 'undefined') {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            utils_hooks__hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            return Math.ceil(number);
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function Locale() {
    }

    var locales = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return null;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && typeof module !== 'undefined' &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND';; throw e; }());
                // because defineLocale currently also sets the global locale, we
                // want to undo that for lazy loaded locales
                locale_locales__getSetGlobalLocale(oldLocale);
            } catch (e) { }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function locale_locales__getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (typeof values === 'undefined') {
                data = locale_locales__getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, values) {
        if (values !== null) {
            values.abbr = name;
            locales[name] = locales[name] || new Locale();
            locales[name].set(values);

            // backwards compat for now: also set the locale
            locale_locales__getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    // returns locale data
    function locale_locales__getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                get_set__set(this, unit, value);
                utils_hooks__hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get_set__get(this, unit);
            }
        };
    }

    function get_set__get (mom, unit) {
        return mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]();
    }

    function get_set__set (mom, unit, value) {
        return mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }

    // MOMENTS

    function getSet (units, value) {
        var unit;
        if (typeof units === 'object') {
            for (unit in units) {
                this.set(unit, units[unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (typeof this[units] === 'function') {
                return this[units](value);
            }
        }
        return this;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Q|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '';
            for (i = 0; i < length; i++) {
                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;

    var regexes = {};

    function isFunction (sth) {
        // https://github.com/moment/moment/issues/2325
        return typeof sth === 'function' &&
            Object.prototype.toString.call(sth) === '[object Function]';
    }


    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (typeof callback === 'number') {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  matchWord);
    addRegexToken('MMMM', matchWord);

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m) {
        return this._months[m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m) {
        return this._monthsShort[m.month()];
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        // TODO: Move this out of here!
        if (typeof value === 'string') {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (typeof value !== 'number') {
                return mom;
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            utils_hooks__hooks.updateOffset(this, true);
            return this;
        } else {
            return get_set__get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    function warn(msg) {
        if (utils_hooks__hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (firstTime) {
                warn(msg + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    utils_hooks__hooks.suppressDeprecationWarnings = false;

    var from_string__isoRegex = /^\s*(?:[+-]\d{6}|\d{4})-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d{2}-\d{2}/],
        ['YYYY-MM-DD', /\d{4}-\d{2}-\d{2}/],
        ['GGGG-[W]WW-E', /\d{4}-W\d{2}-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d{2}/],
        ['YYYY-DDD', /\d{4}-\d{3}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /(T| )\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss', /(T| )\d\d:\d\d:\d\d/],
        ['HH:mm', /(T| )\d\d:\d\d/],
        ['HH', /(T| )\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = from_string__isoRegex.exec(string);

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(string)) {
                    config._f = isoDates[i][0];
                    break;
                }
            }
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(string)) {
                    // match[6] should be 'T' or space
                    config._f += (match[6] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (string.match(matchOffset)) {
                config._f += 'Z';
            }
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    utils_hooks__hooks.createFromInputFallback = deprecate(
        'moment construction falls back to js Date. This is ' +
        'discouraged and will be removed in upcoming major ' +
        'release. Please refer to ' +
        'https://github.com/moment/moment/issues/1407 for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    function createDate (y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);

        //the date constructor doesn't accept years < 1970
        if (y < 1970) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));
        if (y < 1970) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    utils_hooks__hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', false);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // firstDayOfWeek       0 = sun, 6 = sat
    //                      the day of the week that starts the week
    //                      (usually sunday or monday)
    // firstDayOfWeekOfYear 0 = sun, 6 = sat
    //                      the first week is the week that contains the first
    //                      of this day of the week
    //                      (eg. ISO weeks use thursday (4))
    function weekOfYear(mom, firstDayOfWeek, firstDayOfWeekOfYear) {
        var end = firstDayOfWeekOfYear - firstDayOfWeek,
            daysToDayOfWeek = firstDayOfWeekOfYear - mom.day(),
            adjustedMoment;


        if (daysToDayOfWeek > end) {
            daysToDayOfWeek -= 7;
        }

        if (daysToDayOfWeek < end - 7) {
            daysToDayOfWeek += 7;
        }

        adjustedMoment = local__createLocal(mom).add(daysToDayOfWeek, 'd');
        return {
            week: Math.ceil(adjustedMoment.dayOfYear() / 7),
            year: adjustedMoment.year()
        };
    }

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, firstDayOfWeekOfYear, firstDayOfWeek) {
        var week1Jan = 6 + firstDayOfWeek - firstDayOfWeekOfYear, janX = createUTCDate(year, 0, 1 + week1Jan), d = janX.getUTCDay(), dayOfYear;
        if (d < firstDayOfWeek) {
            d += 7;
        }

        weekday = weekday != null ? 1 * weekday : firstDayOfWeek;

        dayOfYear = 1 + week1Jan + 7 * (week - 1) - d + weekday;

        return {
            year: dayOfYear > 0 ? year : year - 1,
            dayOfYear: dayOfYear > 0 ?  dayOfYear : daysInYear(year - 1) + dayOfYear
        };
    }

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        var now = new Date();
        if (config._useUTC) {
            return [now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()];
        }
        return [now.getFullYear(), now.getMonth(), now.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse)) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
            week = defaults(w.w, 1);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < dow) {
                    ++week;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        temp = dayOfYearFromWeeks(weekYear, week, weekday, doy, dow);

        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }

    utils_hooks__hooks.ISO_8601 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === utils_hooks__hooks.ISO_8601) {
            configFromISO(config);
            return;
        }

        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (getParsingFlags(config).bigHour === true &&
                config._a[HOUR] <= 12 &&
                config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!valid__isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = [i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond];

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || locale_locales__getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return valid__createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else if (isDate(input)) {
            config._d = input;
        } else {
            configFromInput(config);
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (input === undefined) {
            config._d = new Date();
        } else if (isDate(input)) {
            config._d = new Date(+input);
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (typeof(input) === 'object') {
            configFromObject(config);
        } else if (typeof(input) === 'number') {
            // from milliseconds
            config._d = new Date(input);
        } else {
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (typeof(locale) === 'boolean') {
            strict = locale;
            locale = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function local__createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
         'moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',
         function () {
             var other = local__createLocal.apply(null, arguments);
             return other < this ? this : other;
         }
     );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',
        function () {
            var other = local__createLocal.apply(null, arguments);
            return other > this ? this : other;
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return local__createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 36e5; // 1000 * 60 * 60
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = locale_locales__getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchOffset);
    addRegexToken('ZZ', matchOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(string) {
        var matches = ((string || '').match(matchOffset) || []);
        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? +input : +local__createLocal(input)) - (+res);
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(+res._d + diff);
            utils_hooks__hooks.updateOffset(res, false);
            return res;
        } else {
            return local__createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    utils_hooks__hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime) {
        var offset = this._offset || 0,
            localAdjust;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(input);
            }
            if (Math.abs(input) < 16) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    utils_hooks__hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm) {
            this.utcOffset(this._tzm);
        } else if (typeof this._i === 'string') {
            this.utcOffset(offsetFromString(this._i));
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        input = input ? local__createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (typeof this._isDSTShifted !== 'undefined') {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return !this._isUTC;
    }

    function isUtcOffset () {
        return this._isUTC;
    }

    function isUtc () {
        return this._isUTC && this._offset === 0;
    }

    var aspNetRegex = /(\-)?(?:(\d*)\.)?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    var create__isoRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/;

    function create__createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (typeof input === 'number') {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])        * sign,
                h  : toInt(match[HOUR])        * sign,
                m  : toInt(match[MINUTE])      * sign,
                s  : toInt(match[SECOND])      * sign,
                ms : toInt(match[MILLISECOND]) * sign
            };
        } else if (!!(match = create__isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                d : parseIso(match[4], sign),
                h : parseIso(match[5], sign),
                m : parseIso(match[6], sign),
                s : parseIso(match[7], sign),
                w : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    create__createDuration.fn = Duration.prototype;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = create__createDuration(val, period);
            add_subtract__addSubtract(this, dur, direction);
            return this;
        };
    }

    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = duration._days,
            months = duration._months;
        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(+mom._d + milliseconds * isAdding);
        }
        if (days) {
            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
        }
        if (months) {
            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            utils_hooks__hooks.updateOffset(mom, days || months);
        }
    }

    var add_subtract__add      = createAdder(1, 'add');
    var add_subtract__subtract = createAdder(-1, 'subtract');

    function moment_calendar__calendar (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || local__createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            diff = this.diff(sod, 'days', true),
            format = diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
        return this.format(formats && formats[format] || this.localeData().calendar(format, this, local__createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var inputMs;
        units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
        if (units === 'millisecond') {
            input = isMoment(input) ? input : local__createLocal(input);
            return +this > +input;
        } else {
            inputMs = isMoment(input) ? +input : +local__createLocal(input);
            return inputMs < +this.clone().startOf(units);
        }
    }

    function isBefore (input, units) {
        var inputMs;
        units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
        if (units === 'millisecond') {
            input = isMoment(input) ? input : local__createLocal(input);
            return +this < +input;
        } else {
            inputMs = isMoment(input) ? +input : +local__createLocal(input);
            return +this.clone().endOf(units) < inputMs;
        }
    }

    function isBetween (from, to, units) {
        return this.isAfter(from, units) && this.isBefore(to, units);
    }

    function isSame (input, units) {
        var inputMs;
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            input = isMoment(input) ? input : local__createLocal(input);
            return +this === +input;
        } else {
            inputMs = +local__createLocal(input);
            return +(this.clone().startOf(units)) <= inputMs && inputMs <= +(this.clone().endOf(units));
        }
    }

    function diff (input, units, asFloat) {
        var that = cloneWithOffset(input, this),
            zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4,
            delta, output;

        units = normalizeUnits(units);

        if (units === 'year' || units === 'month' || units === 'quarter') {
            output = monthDiff(this, that);
            if (units === 'quarter') {
                output = output / 3;
            } else if (units === 'year') {
                output = output / 12;
            }
        } else {
            delta = this - that;
            output = units === 'second' ? delta / 1e3 : // 1000
                units === 'minute' ? delta / 6e4 : // 1000 * 60
                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                delta;
        }
        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        return -(wholeMonthDiff + adjust);
    }

    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function moment_format__toISOString () {
        var m = this.clone().utc();
        if (0 < m.year() && m.year() <= 9999) {
            if ('function' === typeof Date.prototype.toISOString) {
                // native implementation is ~50x faster, use it when we can
                return this.toDate().toISOString();
            } else {
                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        } else {
            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        }
    }

    function format (inputString) {
        var output = formatMoment(this, inputString || utils_hooks__hooks.defaultFormat);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }
        return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    }

    function fromNow (withoutSuffix) {
        return this.from(local__createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }
        return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    }

    function toNow (withoutSuffix) {
        return this.to(local__createLocal(), withoutSuffix);
    }

    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = locale_locales__getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }
        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function to_type__valueOf () {
        return +this._d - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(+this / 1000);
    }

    function toDate () {
        return this._offset ? new Date(+this) : this._d;
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function moment_valid__isValid () {
        return valid__isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
    });

    // HELPERS

    function weeksInYear(year, dow, doy) {
        return weekOfYear(local__createLocal([year, 11, 31 + dow - doy]), dow, doy).week;
    }

    // MOMENTS

    function getSetWeekYear (input) {
        var year = weekOfYear(this, this.localeData()._week.dow, this.localeData()._week.doy).year;
        return input == null ? year : this.add((input - year), 'y');
    }

    function getSetISOWeekYear (input) {
        var year = weekOfYear(this, 1, 4).year;
        return input == null ? year : this.add((input - year), 'y');
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    addFormatToken('Q', 0, 0, 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0], 10);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   matchWord);
    addRegexToken('ddd',  matchWord);
    addRegexToken('dddd', matchWord);

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config) {
        var weekday = config._locale.weekdaysParse(input);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m) {
        return this._weekdays[m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return this._weekdaysShort[m.day()];
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return this._weekdaysMin[m.day()];
    }

    function localeWeekdaysParse (weekdayName) {
        var i, mom, regex;

        this._weekdaysParse = this._weekdaysParse || [];

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            if (!this._weekdaysParse[i]) {
                mom = local__createLocal([2000, 1]).day(i);
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, function () {
        return this.hours() % 12 || 12;
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var momentPrototype__proto = Moment.prototype;

    momentPrototype__proto.add          = add_subtract__add;
    momentPrototype__proto.calendar     = moment_calendar__calendar;
    momentPrototype__proto.clone        = clone;
    momentPrototype__proto.diff         = diff;
    momentPrototype__proto.endOf        = endOf;
    momentPrototype__proto.format       = format;
    momentPrototype__proto.from         = from;
    momentPrototype__proto.fromNow      = fromNow;
    momentPrototype__proto.to           = to;
    momentPrototype__proto.toNow        = toNow;
    momentPrototype__proto.get          = getSet;
    momentPrototype__proto.invalidAt    = invalidAt;
    momentPrototype__proto.isAfter      = isAfter;
    momentPrototype__proto.isBefore     = isBefore;
    momentPrototype__proto.isBetween    = isBetween;
    momentPrototype__proto.isSame       = isSame;
    momentPrototype__proto.isValid      = moment_valid__isValid;
    momentPrototype__proto.lang         = lang;
    momentPrototype__proto.locale       = locale;
    momentPrototype__proto.localeData   = localeData;
    momentPrototype__proto.max          = prototypeMax;
    momentPrototype__proto.min          = prototypeMin;
    momentPrototype__proto.parsingFlags = parsingFlags;
    momentPrototype__proto.set          = getSet;
    momentPrototype__proto.startOf      = startOf;
    momentPrototype__proto.subtract     = add_subtract__subtract;
    momentPrototype__proto.toArray      = toArray;
    momentPrototype__proto.toObject     = toObject;
    momentPrototype__proto.toDate       = toDate;
    momentPrototype__proto.toISOString  = moment_format__toISOString;
    momentPrototype__proto.toJSON       = moment_format__toISOString;
    momentPrototype__proto.toString     = toString;
    momentPrototype__proto.unix         = unix;
    momentPrototype__proto.valueOf      = to_type__valueOf;

    // Year
    momentPrototype__proto.year       = getSetYear;
    momentPrototype__proto.isLeapYear = getIsLeapYear;

    // Week Year
    momentPrototype__proto.weekYear    = getSetWeekYear;
    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;

    // Quarter
    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;

    // Month
    momentPrototype__proto.month       = getSetMonth;
    momentPrototype__proto.daysInMonth = getDaysInMonth;

    // Week
    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
    momentPrototype__proto.weeksInYear    = getWeeksInYear;
    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;

    // Day
    momentPrototype__proto.date       = getSetDayOfMonth;
    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
    momentPrototype__proto.dayOfYear  = getSetDayOfYear;

    // Hour
    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;

    // Minute
    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;

    // Second
    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;

    // Millisecond
    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;

    // Offset
    momentPrototype__proto.utcOffset            = getSetOffset;
    momentPrototype__proto.utc                  = setOffsetToUTC;
    momentPrototype__proto.local                = setOffsetToLocal;
    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
    momentPrototype__proto.isDST                = isDaylightSavingTime;
    momentPrototype__proto.isDSTShifted         = isDaylightSavingTimeShifted;
    momentPrototype__proto.isLocal              = isLocal;
    momentPrototype__proto.isUtcOffset          = isUtcOffset;
    momentPrototype__proto.isUtc                = isUtc;
    momentPrototype__proto.isUTC                = isUtc;

    // Timezone
    momentPrototype__proto.zoneAbbr = getZoneAbbr;
    momentPrototype__proto.zoneName = getZoneName;

    // Deprecations
    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779', getSetZone);

    var momentPrototype = momentPrototype__proto;

    function moment__createUnix (input) {
        return local__createLocal(input * 1000);
    }

    function moment__createInZone () {
        return local__createLocal.apply(null, arguments).parseZone();
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function locale_calendar__calendar (key, mom, now) {
        var output = this._calendar[key];
        return typeof output === 'function' ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    function preParsePostFormat (string) {
        return string;
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (typeof output === 'function') ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return typeof format === 'function' ? format(output) : format.replace(/%s/i, output);
    }

    function locale_set__set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (typeof prop === 'function') {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _ordinalParseLenient.
        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
    }

    var prototype__proto = Locale.prototype;

    prototype__proto._calendar       = defaultCalendar;
    prototype__proto.calendar        = locale_calendar__calendar;
    prototype__proto._longDateFormat = defaultLongDateFormat;
    prototype__proto.longDateFormat  = longDateFormat;
    prototype__proto._invalidDate    = defaultInvalidDate;
    prototype__proto.invalidDate     = invalidDate;
    prototype__proto._ordinal        = defaultOrdinal;
    prototype__proto.ordinal         = ordinal;
    prototype__proto._ordinalParse   = defaultOrdinalParse;
    prototype__proto.preparse        = preParsePostFormat;
    prototype__proto.postformat      = preParsePostFormat;
    prototype__proto._relativeTime   = defaultRelativeTime;
    prototype__proto.relativeTime    = relative__relativeTime;
    prototype__proto.pastFuture      = pastFuture;
    prototype__proto.set             = locale_set__set;

    // Month
    prototype__proto.months       =        localeMonths;
    prototype__proto._months      = defaultLocaleMonths;
    prototype__proto.monthsShort  =        localeMonthsShort;
    prototype__proto._monthsShort = defaultLocaleMonthsShort;
    prototype__proto.monthsParse  =        localeMonthsParse;

    // Week
    prototype__proto.week = localeWeek;
    prototype__proto._week = defaultLocaleWeek;
    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;

    // Day of Week
    prototype__proto.weekdays       =        localeWeekdays;
    prototype__proto._weekdays      = defaultLocaleWeekdays;
    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
    prototype__proto._weekdaysMin   = defaultLocaleWeekdaysMin;
    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
    prototype__proto._weekdaysShort = defaultLocaleWeekdaysShort;
    prototype__proto.weekdaysParse  =        localeWeekdaysParse;

    // Hours
    prototype__proto.isPM = localeIsPM;
    prototype__proto._meridiemParse = defaultLocaleMeridiemParse;
    prototype__proto.meridiem = localeMeridiem;

    function lists__get (format, index, field, setter) {
        var locale = locale_locales__getLocale();
        var utc = create_utc__createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function list (format, index, field, count, setter) {
        if (typeof format === 'number') {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return lists__get(format, index, field, setter);
        }

        var i;
        var out = [];
        for (i = 0; i < count; i++) {
            out[i] = lists__get(format, i, field, setter);
        }
        return out;
    }

    function lists__listMonths (format, index) {
        return list(format, index, 'months', 12, 'month');
    }

    function lists__listMonthsShort (format, index) {
        return list(format, index, 'monthsShort', 12, 'month');
    }

    function lists__listWeekdays (format, index) {
        return list(format, index, 'weekdays', 7, 'day');
    }

    function lists__listWeekdaysShort (format, index) {
        return list(format, index, 'weekdaysShort', 7, 'day');
    }

    function lists__listWeekdaysMin (format, index) {
        return list(format, index, 'weekdaysMin', 7, 'day');
    }

    locale_locales__getSetGlobalLocale('en', {
        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports
    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);

    var mathAbs = Math.abs;

    function duration_abs__abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function duration_add_subtract__addSubtract (duration, input, value, direction) {
        var other = create__createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function duration_add_subtract__add (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function duration_add_subtract__subtract (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function duration_as__valueOf () {
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function duration_get__get (units) {
        units = normalizeUnits(units);
        return this[units + 's']();
    }

    function makeGetter(name) {
        return function () {
            return this._data[name];
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        s: 45,  // seconds to minute
        m: 45,  // minutes to hour
        h: 22,  // hours to day
        d: 26,  // days to month
        M: 11   // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
        var duration = create__createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds < thresholds.s && ['s', seconds]  ||
                minutes === 1          && ['m']           ||
                minutes < thresholds.m && ['mm', minutes] ||
                hours   === 1          && ['h']           ||
                hours   < thresholds.h && ['hh', hours]   ||
                days    === 1          && ['d']           ||
                days    < thresholds.d && ['dd', days]    ||
                months  === 1          && ['M']           ||
                months  < thresholds.M && ['MM', months]  ||
                years   === 1          && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set a threshold for relative time strings
    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        return true;
    }

    function humanize (withSuffix) {
        var locale = this.localeData();
        var output = duration_humanize__relativeTime(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var iso_string__abs = Math.abs;

    function iso_string__toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        var seconds = iso_string__abs(this._milliseconds) / 1000;
        var days         = iso_string__abs(this._days);
        var months       = iso_string__abs(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds;
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        return (total < 0 ? '-' : '') +
            'P' +
            (Y ? Y + 'Y' : '') +
            (M ? M + 'M' : '') +
            (D ? D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? h + 'H' : '') +
            (m ? m + 'M' : '') +
            (s ? s + 'S' : '');
    }

    var duration_prototype__proto = Duration.prototype;

    duration_prototype__proto.abs            = duration_abs__abs;
    duration_prototype__proto.add            = duration_add_subtract__add;
    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
    duration_prototype__proto.as             = as;
    duration_prototype__proto.asMilliseconds = asMilliseconds;
    duration_prototype__proto.asSeconds      = asSeconds;
    duration_prototype__proto.asMinutes      = asMinutes;
    duration_prototype__proto.asHours        = asHours;
    duration_prototype__proto.asDays         = asDays;
    duration_prototype__proto.asWeeks        = asWeeks;
    duration_prototype__proto.asMonths       = asMonths;
    duration_prototype__proto.asYears        = asYears;
    duration_prototype__proto.valueOf        = duration_as__valueOf;
    duration_prototype__proto._bubble        = bubble;
    duration_prototype__proto.get            = duration_get__get;
    duration_prototype__proto.milliseconds   = milliseconds;
    duration_prototype__proto.seconds        = seconds;
    duration_prototype__proto.minutes        = minutes;
    duration_prototype__proto.hours          = hours;
    duration_prototype__proto.days           = days;
    duration_prototype__proto.weeks          = weeks;
    duration_prototype__proto.months         = months;
    duration_prototype__proto.years          = years;
    duration_prototype__proto.humanize       = humanize;
    duration_prototype__proto.toISOString    = iso_string__toISOString;
    duration_prototype__proto.toString       = iso_string__toISOString;
    duration_prototype__proto.toJSON         = iso_string__toISOString;
    duration_prototype__proto.locale         = locale;
    duration_prototype__proto.localeData     = localeData;

    // Deprecations
    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
    duration_prototype__proto.lang = lang;

    // Side effect imports

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    utils_hooks__hooks.version = '2.10.6';

    setHookCallback(local__createLocal);

    utils_hooks__hooks.fn                    = momentPrototype;
    utils_hooks__hooks.min                   = min;
    utils_hooks__hooks.max                   = max;
    utils_hooks__hooks.utc                   = create_utc__createUTC;
    utils_hooks__hooks.unix                  = moment__createUnix;
    utils_hooks__hooks.months                = lists__listMonths;
    utils_hooks__hooks.isDate                = isDate;
    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
    utils_hooks__hooks.invalid               = valid__createInvalid;
    utils_hooks__hooks.duration              = create__createDuration;
    utils_hooks__hooks.isMoment              = isMoment;
    utils_hooks__hooks.weekdays              = lists__listWeekdays;
    utils_hooks__hooks.parseZone             = moment__createInZone;
    utils_hooks__hooks.localeData            = locale_locales__getLocale;
    utils_hooks__hooks.isDuration            = isDuration;
    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
    utils_hooks__hooks.defineLocale          = defineLocale;
    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;

    var _moment = utils_hooks__hooks;

    return _moment;

}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);
var hasNoWindow = typeof window === "undefined";
var root = hasNoWindow ? global : window;

// ---------------------------------------------------
// Module Definition
module.exports = function () {};

/* develblock:start */
// THIS IS ONLY AN ISSUE IN `DEVELOPMENT` MODE

// but still have to fix this for fucking IE9...
// shit bags define console functions as
// fucking objects...WHAT.THE.FUCK?!?!?
if (!root.console) {
    // just make sure the console exists
    root.console = {};
}
if (!root.console.assert || typeof root.console.assert === 'object') {
    // in fucking IE9 (or various broken implementations)
    // or do we just let it fail? just apply a no op
    root.console.assert = function () {};
}
/**
 * @module assert
 * @type {function}
 * @param {boolean} condition Condition to test
 * @param {string} failureMessage Error message to display if condition is falsy
 */
module.exports = hasNoWindow ? __webpack_require__(1617).ok : _.bind(root.console.assert, root.console);
/* develblock:end */

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Shad
 * Date: 8/13/13
 */



var SoaModel = __webpack_require__(2);
var root = typeof window === 'undefined' ? global : window;
var bunsen = root.bunsen = root.bunsen || {};

var Address = module.exports = bunsen.Address = SoaModel.extend();


var Addresses = __webpack_require__(1463);
var Backbone = __webpack_require__(3);
var SoaModelLabelAndValueTransformer = __webpack_require__(1622);
var endpoints = __webpack_require__(6);
var countryCodes = __webpack_require__(2637); // TODO: use geography service instead
var User = __webpack_require__(28);
var compact = __webpack_require__(1155);
var _ = __webpack_require__(0);

var validFor = function (type) {
    return this.get('validation.' + type + '.valid') === 'Y';
};

/**
 * @mixes SoaModel
 * @class
 * @property idAttribute {string} - "id"
 * @property urlRoot - endpoints.address
 * @property url - Backbone.Model.prototype.url
 * @type {*}
 */
_.extend(Address.prototype, SoaModelLabelAndValueTransformer, {
    idAttribute: "id",
    displayLabels: {
        countryCode: 'Country',
        contact: 'Name',
        fullName: 'Name',
        zipCode: 'ZIP/Postal Code',
        phoneNumber: 'Telephone',
        line1: 'Address 1',
        line2: 'Address 2',
        state: 'State/Province/Region',
        usState: 'State/Province/Region',
        payEmail: 'Payee Email Address',
        activationCode: 'Hyperwallet Account Activation ID'
    },

    relations: SoaModel.createRelations([
        {
            key: 'validation',
            type: Backbone.One,
            relatedModel: SoaModel.extend({
                relations: SoaModel.createRelations([
                    'buyerShipping',
                    'buyerBilling'
                ])
            }),
            omitFromSave: true
        }
    ]),

    initialize: function () {
        this.url = function () {
            return endpoints.address(this.id);
        };
    },

    /**
     * Currently, you can only create new addresses on the addressBook endpoint, while
     * deletes and updates can only be done through the address endpoint. Sync override
     * handles picking the correct endpoint
     */
    sync: function (method, model, options) {
        var self = this;
        if (method === 'create') {
            return User.gotCurrentUser().then(function (currentUser) {
                options.url = endpoints.addressBook(currentUser.id);
                return SoaModel.prototype.sync.call(self, method, model, options);
            });
        }
        return SoaModel.prototype.sync.call(this, method, model, options);
    },
    defaults: {
    },
    displayTransforms: {
        country: function (val) {
            return countryCodes[val];
        },
        countryCode: function () {
            return this.get('country');
        }
    },
    schemas: {
        country: {
            type: 'Select',
            options: {
                placeholder: 'Select a Country...',
                possibleVals: countryCodes
            }
        }
    },
    isValidShippingAddress: _.partial(validFor, 'buyerShipping'),
    isValidBillingAddress: _.partial(validFor, 'buyerBilling'),
    isCountryUS: function () {
        return this.get('country') === 'US';
    },
    getDisplayLocation: function () {
        var parts = compact([this.get('city'), this.get('state')]);
        if (parts.length < 2) {
            parts.push(this.get('country'));
        }
        return compact(parts).join(', ');
    },
    setStateFromZip: function () {
        var addresses = new Addresses();
        return addresses.fetchByZip(
            this.get('zipCode'),
            this.get('country')
        ).then(function () {
            var location = addresses.first();
            if (!location) {
                return this;
            }
            this.set('state', location.get('state'));
            return this;
        }.bind(this));
    }
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Shad
 * Date: 8/13/13
 */


var SoaModel = __webpack_require__(2);
var Note = SoaModel.extend();
var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

module.exports = root.bunsen.Note = Note;

var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var User = __webpack_require__(28);
var Seller = __webpack_require__(105);
var Backbone = __webpack_require__(3);
var bunsenLib = __webpack_require__(21);
var Anchors = __webpack_require__(335);
var Anchor = __webpack_require__(12);
var anchorMixin = __webpack_require__(2651);
var Party = __webpack_require__(8);
var NOTE_API_TYPE = 'note';
var isType = function (type) {
    return this.get('type') === type;
};

_.extend(Note, {
    // Note Type Tracking:
    // https://docs.google.com/a/1stdibs.com/spreadsheet/ccc?key=0ArUbR02BJMU6dGYya3ZjY2N3YU1PRFFUZFdxc3FtWUE&usp=drive_web#gid=1
    TYPE_ADMIN: 'ADMIN',
    TYPE_BUYER_SELLER: 'BUYER_SELLER',
    TYPE_FIRST_SELLER_OFFER: 'FIRST_SELLER_OFFER',
    TYPE_SELLER_ADMIN: 'SELLER_ADMIN',
    TYPE_SHIPMENT_QUOTE_REQUEST: 'SHIPMENT_QUOTE_REQUEST',
    TYPE_ADMIN_BUYER_ACCOUNT: 'ADMIN_BUYER_ACCOUNT',
    TYPE_ADMIN_SELLER_ACCOUNT: 'ADMIN_SELLER_ACCOUNT',
    TYPE_LISTING_BOOKMARK: 'LISTING_BOOKMARK',
    TYPE_LISTING_PUBLISHING: 'LISTING_PUBLISHING',
    TYPE_ITEM_IMAGING: 'ITEM_IMAGING',
    TYPE_DEALER_IMAGING: 'DEALER_IMAGING',
    TYPE_EXPERT_REVIEW_REJECTION: 'EXPERT_REVIEW_REJECTION',
    TYPE_SELLER_INTERNAL_NOTE: 'SELLER_INTERNAL_NOTE',
    getTypes : function () {
        return [
            Note.TYPE_ADMIN,
            Note.TYPE_BUYER_SELLER,
            Note.TYPE_FIRST_SELLER_OFFER,
            Note.TYPE_SELLER_ADMIN,
            Note.TYPE_SHIPMENT_QUOTE_REQUEST,
            Note.TYPE_ADMIN_BUYER_ACCOUNT,
            Note.TYPE_ADMIN_SELLER_ACCOUNT,
            Note.TYPE_LISTING_BOOKMARK,
            Note.TYPE_ITEM_IMAGING,
            Note.TYPE_DEALER_IMAGING,
            Note.TYPE_EXPERT_REVIEW_REJECTION,
            Note.TYPE_SELLER_INTERNAL_NOTE
        ];
    }
});

_.extend(Note.prototype, {
    idAttribute: "id",
    urlRoot : endpoints.note(),
    defaults: {
        apiType: 'note',
        anchors: []
    },
    url : Backbone.Model.prototype.url,
    initialize: function (attrs, options) {
        attrs = attrs || {};
        this.service = options.service;
        // Leave this here, otherwise a bug in Backbone will overwrite it when they
        // are fetched from the Notes collection.
        // https://github.com/jashkenas/backbone/pull/2426
        this.url = function () {
            return endpoints.note(this.get(this.idAttribute), this.service);
        };
        attrs.apiType = NOTE_API_TYPE;
        this.set('apiType', NOTE_API_TYPE);
        this.stripTags();
        this.on('change:content', this.stripTags);
    },
    relations: function () {
        return [
            {
                key : 'modifiedBy',
                type : Backbone.One,
                relatedModel : SoaModel
            },
            {
                key : 'createdBy',
                type : Backbone.One,
                relatedModel : User
            },
            {
                key: 'anchors',
                collectionType: Anchors,
                type: Backbone.Many
            }
        ];
    },
    stripTags: function () {
        var content = this.get('content');
        if (content) {
            this.set('content', bunsenLib.stripTags(content), { silent: true });
        }
    },
    isFlagged: function () {
        return this.get('flagged') === 'Y';
    },
    getCreatorRole: function () {
        return this.get('createdBy.role');
    },
    createdByBuyer: function () {
        return this.getCreatorRole() === Party.ROLE_BUYER;
    },
    createdBySeller: function () {
        return this.getCreatorRole() === Party.ROLE_SELLER;
    },
    isBuyerSellerType: _.partial(isType, Note.TYPE_BUYER_SELLER),
    isUnanchoredBuyerSellerType: function () {
        return this.isBuyerSellerType() && !this.hasAnchor(Anchor.TYPE_SHIPMENT);
    },
    getCreatorName: function () {
        var profile = this.get('createdBy.profile');
        if (profile) {
            return profile.getDisplayName();
        } else {
            return this.get('createdBy.id');
        }
    },

    /**
     * Get the note's content escaped and ready to put into HTML
     * @param [flaggedCopy] - Replace the note content with this string if it has been flagged
     * @param [tokenReplaceMap] - token replace map for the flagged copy
     */
    getEscapedContent: function (flaggedCopy, copyMap) {
        var noteContent = this.get('content');
        if (!noteContent) {
            return null;
        }

        if (this.isFlagged() && flaggedCopy) {
            if (copyMap) {
                return bunsenLib.tokenReplace(flaggedCopy, copyMap);
            }
            return flaggedCopy;
        }
        return _.escape(noteContent);
    },
    fetchBuyerOrSeller: function (options) {
        if (this.getCreatorRole() === Party.ROLE_SELLER) {
            this.seller = new Seller({id: this.getAnchorIdByType(Party.ROLE_SELLER)});
            return this.seller.fetch(options);
        } else if (this.get('createdBy.id')) {
            return this.get('createdBy').fetch(options);
        }
    }
}, anchorMixin);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// ---------------------------------------------------
// Dependencies

var SoaModel = __webpack_require__(2);
var root = typeof window === 'undefined' ? global : window;

root.bunsen = root.bunsen || {};
/**
 * Backbone model describing a 1stdibs product.
 * @typedef {object} ItemModel
 */
/* eslint-disable vars-on-top */
var Item = root.bunsen.Item = module.exports =  SoaModel.extend();

var SoaCollection = __webpack_require__(9);
var Items = __webpack_require__(130);
var Backbone = __webpack_require__(3);
var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var assert = __webpack_require__(31);
var Seller = __webpack_require__(105);
// Leave this named `ImageModel` since the html5 spec has a new `Image` global
var ImageModel = __webpack_require__(2647);
var Photo = __webpack_require__(1528);
var endpoints = __webpack_require__(6);
var ShipmentQuotes = __webpack_require__(319);
var ItemAttributesModel = __webpack_require__(2055);
var ItemAttributesCollection = __webpack_require__(1015);
var ItemCreator = __webpack_require__(1466);
var ItemCreators = __webpack_require__(1619);
var StorefrontPreferences = __webpack_require__(2058);
var ReturnPolicy = __webpack_require__(321);
var Condition = __webpack_require__(2053);
var Party = __webpack_require__(8);
var Mailer = __webpack_require__(2056);
var legacyId = __webpack_require__(2043);
var Clump = __webpack_require__(23);
var ItemCategories = __webpack_require__(2041);
var Category = __webpack_require__(1377);
var ItemPricing = __webpack_require__(2208);
var transitionMixin = __webpack_require__(315);
var shard = __webpack_require__(702);
var verticals = __webpack_require__(416);
var FinancialAmount = __webpack_require__(10);
var Measurement = __webpack_require__(656);
var Holds = __webpack_require__(2204);

// ---------------------------------------------------
// Local Vars

var HasOne = Backbone.One;
var HasMany = Backbone.Many;
var getDefaults;
var relations;
/* eslint-disable vars-on-top */

// graphql transforms all Y/N's into true/false
// make sure we can accomodate both
function isYes(prop) {
    return prop === 'Y' || prop === true;
}

// ---------------------------------------------------
// Module Definition

getDefaults = function () {
    var currentSeller = Seller.getCurrentSeller();
    var defaults;

    defaults = {
        creators: [],
        seller: {},
        shipmentQuotes: []
    };

    if (currentSeller && currentSeller.get('id')) {
        defaults.seller.id = currentSeller.get('id');
        defaults.apiType = Item.getApiType(currentSeller.getVerticalFromID());
    }

    return defaults;
};

relations = [
    {
        key: 'creators',
        relatedModel: ItemCreator,
        type: HasMany,
        collectionType: ItemCreators
    },
    {
        key: 'classification',
        type: HasOne,
        relatedModel: SoaModel.extend({
            relations: [{
                key: 'style',
                type: HasOne,
                relatedModel: SoaModel
            }, {
                key: 'categories',
                type: HasMany,
                collectionType: ItemCategories
            }]
        })
    },
    {
        key : 'attributes',
        relatedModel: ItemAttributesModel,
        type: HasOne
    },
    {
        key: 'materialsTechniques',
        collectionType: ItemAttributesCollection,
        type: HasMany,
        omitFromSave: true
    },
    {
        key: 'measurement',
        relatedModel: Measurement,
        type: HasOne
    },
    {
        key: 'shipmentQuotes',
        collectionType: ShipmentQuotes,
        type: HasMany,
        omitFromSave: true
    },
    {
        key: 'pricing',
        relatedModel: ItemPricing,
        type: HasOne
    },
    {
        key: 'condition',
        relatedModel: Condition,
        type: HasOne
    },
    {
        key: 'publishOptions',
        type: HasOne,
        relatedModel: SoaModel
    },
    {
        key: 'customMaterial',
        type: HasOne,
        relatedModel: SoaModel
    },
    {
        key: 'updateRestrictionList',
        type: HasOne,
        relatedModel: SoaModel
    },
    {
        key: 'store',
        type: HasOne,
        relatedModel: SoaModel
    },
    {
        key: 'seller',
        relatedModel: Seller,
        type: HasOne
    },
    {
        key: 'images',
        relatedModel: ImageModel,
        type: HasMany
    },
    {
        type: HasMany,
        key: 'photos',
        relatedModel: Photo
    },
    {
        key: 'returnPolicy',
        relatedModel: ReturnPolicy,
        type: HasOne
    },
    {
        key: 'status',
        relatedModel: SoaModel,
        type: HasOne
    },
    {
        key: 'mailer',
        type: HasOne,
        relatedModel: Mailer
    },
    {
        key: 'storefrontPreferences',
        type: HasOne,
        relatedModel: StorefrontPreferences
    },
    {
        key: 'versions',
        type: Backbone.Many,
        collectionType: SoaCollection.extend({
            model: SoaModel.extend({
                relations: [{
                    key: 'price',
                    type: HasOne,
                    relatedModel: FinancialAmount
                }]
            })
        })
    },
    {
        key: 'holds',
        type: HasMany,
        collectionType: Holds
    }
];

_.extend(Item.prototype, {
    getLegacyId : legacyId.modelHelper,

    defaults: getDefaults,
    relations: relations,
    // set the iid of the item so that Backbone knows this item is not new (see the .isNew() method) - hence,
    // Backbone will use a PUT create instead of a POST, triggering an "update" request, and not a "create" if the
    // item has an iid.
    idAttribute: "id",
    /**
     * On init, parse the item id. Depending on the source, the item ID may be prepended with a single letter
     * definint the vertical, eg. f_123 for item 123 in "furniure"
     * @param d
     */
    // save a copy of techniques during view switching
    savedTechniques: [],
    //Used in Image Upload
    verticalPrefixes : verticals.prefixMap,

    // In Backbone JS - the parse function is automatically called whenever you get model data back from the server. It
    // should return a hash map of attributes to be set on the model. In our case, we use 2 different end points for
    // fetch and save, so this function figures out which endpoint was hit, and grabs the correct data:
    parse: function parseItemModel(data) {
        var getDefaultsMap = {
            fashion: Item.getFashionDefaults,
            jewelry: Item.getJewelryDefaults,
            art: Item.getArtDefaults
        };

        data = SoaModel.prototype.parse.apply(this, arguments);

        if (data) {
            if (data.vertical && getDefaultsMap[data.vertical]) {
                data = $.extend(true, {}, getDefaultsMap[data.vertical](), data);
            }
        }
        return data;
    },

    /**
     * set a publish option to 'Y' and all others to 'N'
     * @param option
     * @param value
     */
    setOnePublishOption: function (option) {
        if (!_.contains(Item.PUBLISH_OPTION, option)) {
            throw Error('Invalid publishOption "' + option + '"');
        }
        _.each(Item.PUBLISH_OPTION, function (opt) {
            this.setPublishingOption(opt, false);
        }, this);

        this.setPublishingOption(option, true);
    },

    /**
     * set a publish option to 'Y' and all others to 'N'
     * @param option
     * @param value
     */
    setPublishOption: function (option) {
        if (Item.publishOptions.indexOf(option) === -1) {
            throw Error('Invalid publishOption "' + option + '"');
        }
        Item.publishOptions.forEach(_.bind(function (opt) {
            this.set('publishOptions.' + opt, 'N');
        }, this));

        this.set('publishOptions.' + option, 'Y');
    },

    /**
     * Save an item
     * Retry hack because of vertical confusion between solr and service model.  This cannot be used with clump because
     * there is no way to make a retry clump that is aware of all other items in the collection (we shouldn't know
     * about collections in the model here) and then call clump.run again.
     * @returns {Promise}
     */
    save: function (attrs, options) {
        var promise = $.Deferred();
        var self = this;
        var args = arguments;
        var retryVerticals = new RegExp(verticals.VERTICAL_JEWELRY + '|' + verticals.VERTICAL_FASHION);
        var save = Item.__super__.save.apply(this, arguments);
        options = options  || {};

        if (this.isNew()) {
            return save;
        }

        save.fail(function (jqXHR) {
            // retry if it's a 500, a retry vertical, and not in a clump
            // retries with clumps are handled in the Items collection saveAll method
            if (jqXHR.status === 500 && retryVerticals.test(self.get('vertical')) && !options.clump) {
                var prevVertical = self.get('vertical');
                var prevApiType = self.get('apiType');
                self.set('vertical', prevVertical === verticals.VERTICAL_FASHION ? verticals.VERTICAL_JEWELRY : verticals.VERTICAL_FASHION);
                self.set('apiType', self.get('vertical') + 'Item');

                Item.__super__.save.apply(self, args)
                    .then(_.bind(promise.resolve, promise))
                    .fail(_.bind(promise.reject, promise));

                self.set('vertical', prevVertical);
                self.set('apiType', prevApiType);
            }
            else {
                promise.reject.apply(promise, arguments);
            }
        })
        .then(_.bind(promise.resolve, promise));

        return promise;
    },

    // Methods from 1stdibs.com Item model:
    getIntegerId : function () {
        var id = this.get('id') || '0';
        return parseInt(String(id).replace(/\D+/g, ''), 10);
    },
    getAmountPerItem : function (currency) {
        var quantity = parseInt(this.get('pieces') || 0, 10);
        var pricing = this.get('pricing');
        var amount;

        if (!pricing) {
            return undefined;
        }

        amount = pricing.getTotalAmount(currency);
        if (this.isSoldIndividually()) {
            return amount / quantity;
        }
        return amount;
    },
    canMultipleQuantityBePurchased: function () {
        return isYes(this.get('pricing.pricePerPiece')) && this.get('pieces') > 1;
    },
    isSubmittedListing: function () {
        return this.isSubmittedToCategoryListing() || this.isSubmittedToFeaturedListing();
    },
    isSubmittedToCategoryListing: function () {
        return this.get('status.publishingStatus') === Item.statuses.SUBMITTED_TO_CATEGORY_SEARCH;
    },
    isSubmittedToFeaturedListing: function () {
        return this.get('status.publishingStatus') === Item.statuses.SUBMITTED_TO_NEW_LISTINGS;
    },
    isStorefrontListing: function () {
        return this.get('status.publishingStatus') === Item.statuses.STOREFRONT_ONLY;
    },
    isCategoryListing: function () {
        return this.get('status.publishingStatus') === Item.statuses.PUBLISHED_TO_CATEGORY_SEARCH;
    },
    isFeaturedListing: function () {
        return this.get('status.publishingStatus') === Item.statuses.PUBLISHED_TO_NEW_LISTINGS;
    },
    isOnHoldListing: function () {
        return this.get('status.publishingStatus') === Item.statuses.ON_HOLD;
    },
    isSoldListing: function () {
        return this.get('status.publishingStatus') === Item.statuses.SOLD;
    },
    isAddTextListing: function () {
        return this.get('status.publishingStatus') === Item.statuses.NEW;
    },
    isWorkInProgressListing: function () {
        return this.get('status.publishingStatus') === Item.statuses.WORK_IN_PROGRESS;
    },
    isUnpublishedListing: function () {
        return this.get('status.publishingStatus') === Item.statuses.UNPUBLISHED;
    },
    isPublishedListing: function () {
        return this.isStorefrontListing() ||
            this.isCategoryListing() ||
            this.isFeaturedListing();
    },
    isRejectedListing: function () {
        return this.get('status.publishingStatus') === Item.statuses.REJECTED;
    },
    isQueuedForCategoryListing: function () {
        return this.get('status.publishingStatus') === Item.statuses.QUEUED_FOR_CATEGORY_SEARCH;
    },
    isQueuedForFeaturedListing: function () {
        return this.get('status.publishingStatus') === Item.statuses.QUEUED_FOR_NEW_LISTINGS;
    },
    isQueuedListing: function () {
        return this.isQueuedForCategoryListing() || this.isQueuedForFeaturedListing();
    },
    isTradeReturnAvailable: function () {
        return (this.isFurniture() || this.isArt()) &&
            this.getConvertedPriceAmount(FinancialAmount.CURRENCY_USD) <= 35000 &&
            this.get('seller.shippingAddress.country') === 'US';
    },
    isPriceUponRequest: function () {
        return this.hidePrice() || this.getAmountIn(FinancialAmount.CURRENCY_USD) === 0;
    },
    canMoveToPending: function () {
        return this.isItemUnlisted() || this.isQueuedListing() || this.isSubmittedListing();
    },
    canMarkOnHold: function () {
        return this.isPublishedListing() || this.isQueuedListing() || this.isSubmittedListing();
    },
    canMarkDeleted: function () {
        return this.isAddTextListing() || this.isWorkInProgressListing() || this.isUnpublishedListing();
    },
    //workflow complete or unavailable, where is this used? check with finding about PDP
    canMarkSold: function () {
        return this.isPublishedListing() ||
            this.isOnHoldListing() ||
            this.isQueuedListing() ||
            this.isSubmittedListing();
    },
    dealerSuspended: function () {
        return this.get('seller') && this.get('seller').isStatusSuspended();
    },
    dealerClosed: function () {
        return this.get('seller') && this.get('seller').isStatusClosed();
    },
    dealerPending: function () {
        return this.get('seller') && this.get('seller').isStatusPending();
    },
    /**
     * @deprecated
     * @returns {*|boolean}
     */
    hidePrice: function () {
        return this.isPriceHidden();
    },
    isPriceHidden: function () {
        var price = this.getPrice();
        return (this.get('pricing') && isYes(this.get('pricing.hidePrice'))) || !price || price < 0.01;
    },
    isPriceHiddenByType: function (type) {
        var price = this.getPriceByType(type);
        return (price && isYes(price.get('hidePrice'))) || !price || price < 0.01;
    },
    canMakePurchase:  function (transaction) {
        var buyerCanAcceptPrivateOffer = transaction && transaction.buyerCanAcceptPrivateOffer();
        var canPurchaseOnHoldItem = this.isItemOnHold() && buyerCanAcceptPrivateOffer;
        return (
            (!this.isItemOnHold() || canPurchaseOnHoldItem) &&
            !this.isItemDeleted() &&
            !this.dealerSuspended() &&
            !this.dealerClosed() &&
            !this.dealerPending() &&
            !this.isItemSold() &&
            (!this.hidingPrice() || buyerCanAcceptPrivateOffer) &&
            !this.isItemUnlisted()
        );
    },
    canMakeBuyerOffer: function () {
        return this.isNegotiablePrice() &&
            !this.isItemSold() &&
            !this.isItemOnHold() &&
            !this.hidingPrice() &&
            !this.dealerSuspended() &&
            !this.isItemDeleted();
    },
    getDisplayStatus: function () {
        var status = this.get('status.publishingStatus');
        return Item.displayStatuses[status];
    },
    getDealerDisplayStatus: function () {
        var status = this.get('status.publishingStatus');
        var displayStatus;
        if (this.isArt()) {
            displayStatus = Item.artDisplayStatuses[status];
        }
        if (!displayStatus) {
            displayStatus = Item.displayStatuses[status];
        }
        return displayStatus;
    },
    /**
     * Returns the string for statuses that should show when price should
     * be hidden. Returns null otherwise.
     */
    getItemHidePriceStatus: function () {
        if (this.isItemSold()) {
            return Item.displayStatuses.SOLD;
        } else if (this.isItemOnHold()) {
            return Item.displayStatuses.ON_HOLD;
        } else if (this.isPriceUponRequest()) {
            return 'Price Upon Request';
        }
        return null;
    },
    /**
     * proxies call localizedAmount out to pricing.totalAmount when present
     */
    localizedAmount: function (options) {
        var totalAmount = this.get('pricing.totalAmount');
        if (totalAmount) {
            return totalAmount.localizedAmount(options);
        }
    },
    getConvertedPriceAmount: function (currency) {
        var prop = 'pricing.totalAmount.convertedAmounts.' + currency;
        return this.get(prop);
    },
    getCurrency: function () {
        return this.get('pricing.totalAmount.currency');
    },
    getPrice: function () {
        return this.get('pricing.totalAmount.amount');
    },
    getPriceByType: function (type) {
        var pricing = this.get('pricing');
        return pricing && pricing.getPriceByType(type);
    },
    getPriceIn: function (type, currency) {
        var price = this.getPriceByType(type);
        var amount;
        currency = currency || 'USD';
        if (price) {
            // FinancialAmount model
            amount = price.get('amount');
            if (amount) {
                return amount.getAmountIn(currency);
            }
        }
        // return null so that it's easy
        // to detect whether or not there is a price
        return null;
    },
    getConvertedPriceAmounts: function (type) {
        var prices = this.getPriceByType(type);
        return prices ? prices.get('amount.convertedAmounts') : null;
    },
    hidingPrice: function () {
        var price = this.getPrice();
        return !price || price < 0.01 || this.hidePrice();
    },
    getNumberOfPieces: function () {
        return this.get('pieces');
    },
    /**
     * use isSoldIndividually method
     * @deprecated
     * @returns {*}
     */
    soldIndividually: function () {
        return this.isSoldIndividually();
    },
    fetchKeyFields: function (options) {
        var self = this;

        options = options || {};
        options.data = _.extend({}, {
            fields: 'key',
            shipmentQuotesView: 'PDP'
        }, options.data);

        /* eslint-disable camelcase */
        if (!this._fetchKeyFields_P) {
            this._fetchKeyFields_P = this.fetch(options).fail(function () {
                self._fetchKeyFields_P = null;
            });
        }
        return this._fetchKeyFields_P;
        /* eslint-disable camelcase */
    },
    _isVertical: function (vertical) {
        return this.get('vertical') === vertical;
    },
    isArt: function () {
        return this._isVertical(verticals.VERTICAL_ART);
    },
    isFashion: function () {
        return this._isVertical(verticals.VERTICAL_FASHION);
    },
    isFurniture: function () {
        return this._isVertical(verticals.VERTICAL_FURNITURE);
    },
    isJewelry: function () {
        return this._isVertical(verticals.VERTICAL_JEWELRY);
    },
    //Should be used on POST only. Should already be on the model during a PUT
    getApiType: function (vertical) {
        return Item.getApiType(vertical);
    },
    setApiType: function (vertical) {
        this.set('apiType', this.getApiType(vertical));
    },
    getTotalAmounts: function () {
        return this.get('pricing.totalAmount.convertedAmounts');
    },
    getPriceLocksByType: function (type) {
        var pricing = this.get('pricing');
        return pricing.getPriceLockByType(type);
    },
    getPriceLocksIn: function (type, currency) {
        var priceLock = this.getPriceLocksByType(type);
        var amount;
        currency = currency || 'USD';
        if (priceLock) {
            // FinancialAmount model
            amount = priceLock.getOriginalPriceIn(currency);
            if (amount) {
                return amount;
            }
        }
        // return null so that it's easy
        // to detect whether or not there is a price
        return null;
    },
    getInitialPriceAmounts: function () {
        return this.get('pricing.initialPrice.convertedAmounts');
    },
    getAmountIn: function (currency) {
        return this.get('pricing.totalAmount').getAmountIn(currency);
    },
    isNegotiablePriceByType: function (type) {
        var price = this.getPriceByType(type);
        if (price) {
            return isYes(price.get('negotiable'));
        }
        return null;
    },
    isNegotiablePrice: function () {
        return isYes(this.get('pricing.negotiable'));
    },
    isBargainPrice: function () {
        return isYes(this.get('pricing.bargain'));
    },
    isNewListing: function () {
        return isYes(this.get('status.newListing'));
    },
    isSaturdaySale: function () {
        return isYes(this.get('status.inSaturdaySale'));
    },
    isAvailable: function () {
        return isYes(this.get('status.isAvailable'));
    },
    isItemMarketplaceEver: function () {
        return this.getPublishingOption(Item.PUBLISH_OPTION.MARKETPLACE);
    },
    isItemMarketplace: function () {
        return this.getPublishingOption(Item.PUBLISH_OPTION.MARKET);
    },
    isItemStorefront: function () {
        return this.getPublishingOption(Item.PUBLISH_OPTION.STOREFRONT);
    },
    isItemRepost : function () {
        return this.getPublishingOption(Item.PUBLISH_OPTION.REPOST);
    },
    getNumImages: function () {
        var images = this.get('images');
        var count = 0;

        images.each(function (image) {
            if (image.get('large') && image.get('large') !== '') {
                count += 1;
            }
        });

        return count;
    },
    /**
     * @deprecated
     */
    getShardedImageUrl: function (index, size, imageHosts) {
        var image = this.get('images[' + index + '].' + size);
        if (image) {
            return shard.getUrl(image, imageHosts);
        }
    },
    /**
     * @param options
     * @param [options.position=1] {number} the image position
     * @param [options.size=small] {string} the image size
     * @return {string|undefined}
     */
    getImageUrl: function (options) {
        var images = this.get('images');
        var image;

        options = options || {};
        options.position = options.position || 1;
        options.size = options.size || 'small';

        image = images && images.findWhere({position: options.position});
        if (!image) {
            return;
        }
        return image.get(options.size);  // eslint-disable-line consistent-return
    },
    supports21stCenturyData: function () {
        return this.isFurniture();
    },
    getPeriod: function () {
        return this.get('attributes.period[0].value');
    },
    getCreator: function () {
        return this.get('creators[0].creator.name');
    },

    /**
     * Returns array of creator names.
     * @return {Array} array of strings
     */
    getCreators: function () {
        var creators = this.get('creators');
        var creatorDisplayNames = [];
        var creatorIdentifierField;

        if (this.isFashion() || this.isJewelry()) {
            creatorIdentifierField = 'name';
        } else {
            creatorIdentifierField = 'displayName';
        }

        // check if the creators collection is defined, and if so,
        // send the creator display names (if any) to the template
        if (creators) {
            // iterate over the creators collection
            creators.each(function (creatorModel) {
                var displayName = creatorModel.get('creator.' + creatorIdentifierField);
                if (!_.isUndefined(displayName) && !_.contains(creatorDisplayNames, displayName)) {
                    creatorDisplayNames.push(displayName);
                }
            });
        }

        return creatorDisplayNames;
    },

    getLargeImages: function () {
        var images = this.get('images') || [];
        return images.filter(function (image) {
            return image.get('large');
        });
    },

    getCategory: function (level) {
        var categories = this.get('classification.inflatedCategories');
        if (_.isArray(categories) && categories[0] && categories[0][level - 1]) {
            return categories[0][level - 1].label;
        }
    },

    /**
     * @returns {ItemCategories}
     */
    getItemCategories : function () {
        return this.get('classification.categories');
    },

    /**
     * Return the primary item category, if one exists
     * @returns {ItemCategory}
     */
    getPrimaryItemCategory: function () {
        var itemCategories = this.getItemCategories();
        if (itemCategories) {
            return itemCategories.getPrimary();
        }
        return null;
    },

    /**
     * @param {string} itemCategoryKey
     * @returns {ItemCategory}
     */
    findItemCategoryByKey: function (itemCategoryKey) {
        var itemCategories = this.getItemCategories();
        if (itemCategories) {
            return itemCategories.findByCategoryKey(itemCategoryKey);
        }
        return null;
    },

    _ensureHasItemCategories : function () {
        var itemCategories = this.getItemCategories();
        if (itemCategories) {
            return itemCategories;
        }
        var classification = this.get('classification');
        if (!classification) {
            this.set('classification', { categories: [] });
        } else {
            classification.set('categories', []);
        }
        return this.getItemCategories();
    },

    /**
     * Add a new item category to the end
     * of the item categories collections.
     * @param {string} itemCategoryKey
     * @returns {Item}
     */
    addItemCategoryWithKey: function (itemCategoryKey) {
        var itemCategories = this.getItemCategories();
        if (!itemCategories) {
            itemCategories = this._ensureHasItemCategories();
        }
        itemCategories.addWithKey(itemCategoryKey);
        return this;
    },

    /**
     * Creates ItemCategories models based on the keys
     * passed in, and in the same order.
     * @param {string[]} keys
     * @returns {Item}
     */
    setItemCategoriesWithKeys: function (keys) {
        var itemCategories = this._ensureHasItemCategories();
        itemCategories.resetWithKeys(keys);
        return this;
    },

    /**
     * Searches the full vertical {@link Category} singleton
     * for the model that matches the key of the primary
     * {@link ItemCategory} for this item.
     * @returns {Category}
     */
    findPrimaryCategoryInVerticalCategory : function () {
        var primaryItemCategory = this.getPrimaryItemCategory();
        var categoryKey;
        var vertical;
        var verticalCategory;
        if (!primaryItemCategory) {
            return null;
        }
        categoryKey = primaryItemCategory.getCategoryKey();
        vertical = this.get('vertical');
        if (!vertical) {
            return null;
        }
        verticalCategory = Category.verticalCategoryInstance(vertical);
        return verticalCategory.findChildByKey(categoryKey);
    },

    getCategories: function () {
        var inflatedCategories = this.get('classification.inflatedCategories');
        return (inflatedCategories) ? inflatedCategories[0] : [];
    },

    /**
     * Category URL
     * @returns {string}
     */
    getCategoryURL: function () {
        var categories = this.getCategories();
        var parts = _.pluck(categories, 'label');
        if (parts.length) {
            return '/' + parts.join('/') + '/';
        }
        return '/';
    },

    /**
     * Get name of most specific category
     * @returns {string}
     */
    getLowestCategory: function () {
        var categories = this.getCategories();
        if (categories.length) {
            return (categories[categories.length - 1]).name;
        }
        return '';
    },
    /**
     * If the model is not published and the publish properties are 'Y', then
     * that means that this is a new item to publish.
     * @returns {boolean}
     */
    isNewPosting: function () {
        return (!this.isItemPublished() && this.testPublish());
    },
    //Publish options helper methods
    /**
     * Check if the item is deleted
     * @returns {boolean}
     */
    isItemDeleted: function () {
        return this.getPublishingOption(Item.PUBLISH_OPTION.DELETED);
    },
    /**
     * Check if the item is NYDC
     * @returns {boolean}
     */
    isItemNYDC: function () {
        return this.getPublishingOption(Item.PUBLISH_OPTION.NYDC);
    },
    /**
     * @param {string} value Either 'Y' or 'N' to indicate NYDC status
     * @param {Object} options
     * @returns {Promise}
     * @private
     */
    _updateNYDCStatus: function (value, options) {
        var self = this;
        return this.save(null, _.extend({
            url: endpoints.toggleNYDC(this.get('id')),
            type: 'PUT',
            patch: true,
            data: {
                isNydc: value
            }
        }, options)).done(function () {
            value = value === 'Y';
            self.setPublishingOption(Item.PUBLISH_OPTION.NYDC, value);
        });
    },
    /**
     * Add item to NYDC
     * @param {Object} options
     * @returns {Promise}
     */
    addToNYDC: function (options) {
        this._updateNYDCStatus('Y', options);
    },
    /**
     * Remove item from NYDC
     * @param {Object} options
     * @returns {Promise}
     */
    removeFromNYDC: function (options) {
        this._updateNYDCStatus('N', options);
    },
    /**
     * Check if the item is on hold
     * @returns {boolean}
     * @deprecated
     */
    isItemOnHold: function () {
        return this.getPublishingOption(Item.PUBLISH_OPTION.ON_HOLD);
    },
    /**
     * Check if the item is on hold
     * API parity with Item-v3 model
     * @returns {boolean}
     */
    isOnHold: function () {
        return this.isItemOnHold();
    },
    /**
     * Check if the item is sold
     * @returns {boolean}
     * @deprecated
     */
    isItemSold: function () {
        return this.getPublishingOption(Item.PUBLISH_OPTION.SOLD);
    },
    /**
     * Check if the item is sold
     * API parity with Item-v3 model
     * @returns {boolean}
     */
    isSold: function () {
        return this.isItemSold();
    },
    /**
     * Check if the item is unpublished
     * @returns {boolean}
     */
    isItemUnlisted: function () {
        return this.getPublishingOption(Item.PUBLISH_OPTION.UNPUBLISHED);
    },
    /**
     * Check if the item is Work In Progress
     * @returns {boolean}
     */
    isItemWorkInProgress: function () {
        return this.getPublishingOption(Item.PUBLISH_OPTION.WIP);
    },
    /**
     * Check if the item is featured
     * @returns {boolean}
     */
    isItemFeatured: function () {
        return this.getPublishingOption(Item.PUBLISH_OPTION.FEATURED);
    },
    /**
     * Check if the item is published
     * @returns {boolean}
     */
    isItemPublished: function () {
        return this.testPublish(this.get('publishOptions').toJSON());
    },

    /**
     * Check if the item is queued for Posting
     * @returns {boolean}
     */
    isItemQueuedForPosting: function () {
        return this.getPublishingOption(Item.PUBLISH_OPTION.QUEUED_FOR_POSTING);
    },

    /**
     * Check if the item will be marked as unavailable
     * @return {boolean}
     */
    isItemUnavailable: function () {
        return this.isItemDeleted() ||
            this.isItemUnlisted() ||
            this.dealerClosed() ||
            this.dealerPending() ||
            this.dealerSuspended();
    },

    /**
     * Add item to mailer
     * @returns {Deferred}
     */
    addMailer: function (options) {
        var mailer = new Mailer(null, { itemId: this.id });
        this.set('mailer', mailer);
        return mailer.add(options);
    },

    /**
     * Remove item from mailer
     * @returns {Deferred}
     */
    removeMailer: function (options) {
        var mailer = new Mailer(null, { itemId: this.id });
        this.set('mailer', mailer);
        return mailer.remove(options);
    },

    isInMailer: function () {
        return isYes(this.get('mailer.inMailer'));
    },

    /**
     * Saves storefront preferences to show the item on the storefront after it is sold
     * @param  {Object}
     * @return {Deferred}
     */
    showOnStorefrontWhenSold: function (options) {
        var storefrontPreferences = new StorefrontPreferences({}, { itemId: this.id });
        this.set('storefrontPreferences', storefrontPreferences);
        return storefrontPreferences.showWhenSold(options);
    },

    /**
     * Saves storefront preferences to hide the item on the storefront after it is sold
     * @param  {Object}
     * @return {Deferred}
     */
    hideOnStorefrontWhenSold: function (options) {
        var storefrontPreferences = new StorefrontPreferences({}, { itemId: this.id });
        this.set('storefrontPreferences', storefrontPreferences);
        return storefrontPreferences.hideWhenSold(options);
    },

    /**
     * Indicates if item is shown on storefront after sold
     * @return {Boolean}
     */
    isOnStorefrontWhenSold: function () {
        return isYes(this.get('storefrontPreferences.showOnStorefrontWhenSold'));
    },

    urlRoot: endpoints.inventoryRoot(),

    url: function urlItemModel() {
        // url is composed of the urlRoot, the vertical name, 'item', and the iid.
        var subStr = this.id ? this.id.toString().substr(0, 2) : null;
        var prefix = verticals.getVertical(subStr) || '';
        var vertical = this.get('vertical') || verticals.getVertical(prefix);
        var path = (vertical ? vertical + '/' : '') + 'item/' + (prefix ? this.id.substr(2) : this.id || '');
        return [this.urlRoot, path].join('/');
    },

    /**
     * Returns true if one of the publishOptions other than workInProgress, addText,
     * listedFrenchItem, unpublished or previouslySold is 'Y'
     * @returns {boolean}
     */
    testPublish : function (data) {
        var opts = data || (this.attributes.publishOptions ? this.get('publishOptions').attributes : null);
        if (!opts) {
            return undefined;
        }
        opts = _.omit(opts, ['workInProgress', 'addText', 'listedFrenchItem', 'unpublished', 'previouslySold']);
        return _.some(opts, function (val) {
            return isYes(val);
        });
    },

    /**
     * Change the id prefix of the item (if you are switching the item type.
     * @param newVertical {string} Name of the new vertical (e.g. fashion)
     * @returns {bunsen.Item}
     */
    changeIdPref: function (newVertical) {
        var id = this.get('id');
        var pref;
        var newPref;
        if (!id) {
            return this;
        }
        pref = id.substring(0, 2) || null;
        newPref = verticals.getPrefix(newVertical || this.get('vertical'));
        if (!verticals.getVertical(pref)) {
            return this.set('id', newPref + id, { silent: true });
        }
        return this.set('id', newPref + id.substring(2), { silent : true });
    },

    /**
     * Unsell an item
     * @param options - jQuery ajax options
     * @returns {ajaxPromise}
     */
    unsell: function (options) {
        return this.save(null, _.extend({}, options, {
            url: endpoints.unsellItem(this),
            type: 'PATCH'
        }));
    },

    /**
     * Put item on hold
     * @param options - jQuery ajax options
     * @returns {ajaxPromise}
     */
    hold: function (options) {
        return this.save(null, _.extend({}, options, {
            url:  endpoints.holdItem(this),
            type: 'PATCH'
        }));
    },

    /**
     * Mark item as deleted
     * @param options - Backbone.js options
     * @returns {ajaxPromise}
     */
    markDeleted: function (options) {
        return this.save(null, _.extend({}, options, {
            url:  endpoints.markDeleted(this.id),
            type: 'PATCH'
        }));
    },

    moveItemToSold: function () {
        this.setOnePublishOption(Item.PUBLISH_OPTION.SOLD);
    },

    removeItemFromSold: function () {
        this.setPublishingOption(Item.PUBLISH_OPTION.SOLD, false);
    },

    moveItemToPending: function () {
        this.setOnePublishOption(Item.PUBLISH_OPTION.WIP);
    },

    removeItemFromWIP : function () {
        this.setPublishingOption(Item.PUBLISH_OPTION.WIP, false);
    },

    moveItemToUnpublished: function () {
        this.setOnePublishOption(Item.PUBLISH_OPTION.UNPUBLISHED);
    },

    removeItemFromUnpublished : function () {
        this.setPublishingOption(Item.PUBLISH_OPTION.UNPUBLISHED, false);
    },

    addStorefrontListing : function () {
        this.setPublishingOption(Item.PUBLISH_OPTION.STOREFRONT, true);
    },

    addStorefrontListingOnly : function () {
        this.setOnePublishOption(Item.PUBLISH_OPTION.STOREFRONT);
    },

    removeStorefrontListing : function () {
        this.setPublishingOption(Item.PUBLISH_OPTION.STOREFRONT, false);
    },

    addFeaturedListing : function () {
        this.setPublishingOption(Item.PUBLISH_OPTION.FEATURED, true);
    },

    removeFeaturedListing : function () {
        this.setPublishingOption(Item.PUBLISH_OPTION.FEATURED, false);
    },

    moveItemToRepost : function () {
        this.setPublishingOption(Item.PUBLISH_OPTION.REPOST, true);
    },

    addMarketplaceListing : function () {
        this.setPublishingOption(Item.PUBLISH_OPTION.MARKETPLACE, true);
    },

    removeMarketplaceListing : function () {
        this.setPublishingOption(Item.PUBLISH_OPTION.MARKETPLACE, false);
    },

    hasChangedListings : function () {
        this.get('publishOptions').changedSinceLastSync([Item.PUBLISH_OPTION.UNPUBLISHED]);
    },

    /**
     * Determines if this item was storefront only as of last sync
     * @returns {boolean}
     */
    wasOnlyStorefrontListing : function () {
        var savedAttrs = this.lastSyncAttributes();
        return isYes(savedAttrs.publishOptions.storefront) && !isYes(savedAttrs.publishOptions.dibs);
    },

    /**
     * Determines where this item is published to
     * @returns [*]
     */
    getListings : function () {
        return _.reduce(Item.PUBLISH_OPTION, function (memo, value) {
            if (this.model.getPublishingOption(value)) {
                memo.push(value);
            }
            return memo;
        }, []);
    },

    /**
     * Take item off hold
     * @param options - jQuery ajax options
     * @returns {ajaxPromise}
     */
    unhold: function (options) {
        return this.save(null, _.extend({}, options, {
            url: endpoints.unholdItem(this),
            type: 'PATCH'
        }));
    },

    /**
     * Save an item's shipment quotes. Item is required
     * to have an id and a seller object.
     * @param {object} [saveOptions]
     * @returns {$.Deferred.promise.xhr}
     */
    saveShipmentQuotes: function (saveOptions) {
        var url = endpoints.itemShipmentQuotes(this.id);
        var shipmentQuotesJson;
        var self = this;
        saveOptions = _.extend({}, {
            url: url
        }, saveOptions);
        self.get('shipmentQuotes').each(function (quote) {
            if (!quote.get('author')) {
                quote.set('author', {
                    role: Party.ROLE_SELLER,
                    id: self.get('seller.id')
                });
            }
            quote.set({
                type: 'INVENTORY_POSTING'
            });
        }, self);
        shipmentQuotesJson = this.get('shipmentQuotes').toJSON();
        saveOptions.attrs = { dataList: shipmentQuotesJson };
        return self.save(null, saveOptions);
    },

    /**
     * Use clump service to save item and item
     * shipment quotes in one call
     * @returns {$.Deferred.promise}
     */
    saveItemAndShipmentQuotes: function (itemSaveOptions, quotesSaveOptions, clump) {
        itemSaveOptions = itemSaveOptions ? _.clone(itemSaveOptions) : {};
        quotesSaveOptions = quotesSaveOptions ? _.clone(quotesSaveOptions) : {};

        var usingOwnClump = _.isUndefined(clump);
        clump = !usingOwnClump ? clump : new Clump();

        itemSaveOptions.clump = !_.isUndefined(itemSaveOptions.clump) ?
            itemSaveOptions.clump : clump;
        quotesSaveOptions.clump = !_.isUndefined(quotesSaveOptions.clump) ?
            quotesSaveOptions.clump : clump;

        // todo: james b to move these references to the appropriate place in this scope (ie. to the top)
        var self = this;
        var dfd = $.Deferred();

        var quotesSave = this.saveShipmentQuotes(quotesSaveOptions).fail(function (xhr) {
            self.trigger('clumpSaveFailure:shipmentQuotes', xhr);
        });

        var itemSave = this.save(null, itemSaveOptions).fail(function (xhr) {
            self.trigger('clumpSaveFailure:item', xhr);
        });

        $.when(quotesSave, itemSave).done(function () {
            dfd.resolve.apply(dfd, arguments);
        }).fail(function () {
            dfd.reject.apply(dfd, arguments);
        });

        if (usingOwnClump) {
            clump.run({ abortOnError: true });
        }
        return dfd.promise();
    },

    /**
     * Return a PDP url path (e.g. /id-f_1234/ or /furniture/storage-case-pieces/credenzas/id-f_1234/)
     * @param {boolean} isIncludeCategories
     * @returns {string}
     */
    getPDPURL: function (isIncludeCategories) {
        return (isIncludeCategories ? this.getCategoryURL().slice(0, -1) : '') + '/id-' + this.id + '/';
    },

    getPdpUrls : function () {
        return this.get('pdpUrls') || [];
    },

    /**
     * @param {number} nth
     * @returns {string|null}
     */
    getNthPdpUrl : function (nth) {
        var urls = this.getPdpUrls();
        var url = null;
        nth = nth || 0;

        if (urls.length && urls[nth]) {
            url = urls[nth];
        }
        return url;
    },

    isSoldIndividually: function () {
        return this.get('pricing') && isYes(this.get('pricing.pricePerPiece'));
    },
    /**
     * fetches all available options for this item. Does not take shipment address
     * into consideration
     * @returns {*}
     */
    fetchAvailableOptions: function () {
        var availableOptions = new ShipmentQuotes();

        // Cancel any outstanding requests
        if (this._availableOptionsDeferred) {
            this._availableOptionsDeferred.reject();
        }

        this._availableOptionsDeferred = new $.Deferred();
        availableOptions.fetchAvailableOptions(this).done(_.bind(function () {
            this.availableOptions = availableOptions;
            this.selectFirstAvailableOption();
            this._availableOptionsDeferred.resolve(availableOptions);
        }, this)).fail(_.bind(function () {
            this._availableOptionsDeferred.reject();
        }, this));
        return this._availableOptionsDeferred.promise();
    },
    /**
     * Returns a promise that resolves with the available options.
     * Only fetches if they have not already been fetched
     */
    getAvailableOptionsPromise: function () {
        if (this._availableOptionsDeferred && this._availableOptionsDeferred.promise()) {
            return this._availableOptionsDeferred.promise();
        } else {
            return this.fetchAvailableOptions();
        }
    },

    /**
     * Re-order an item's images -- moving the image from the "fromPos" to the "toPos" -- works by manipulating the
     * "position" attribute of the item image sub-model
     * @param fromPos
     * @param toPos
     */
    reOrderImages : function (fromPos, toPos) {
        var img1 = this.get('images').findWhere({position : fromPos}).get('large');
        var img2 = this.get('images').findWhere({position : toPos}).get('large');
        assert((img1 && img2), 'Item does not have sufficient images to re-oreder');

        this.get('images').findWhere({position : fromPos}).set('position', toPos);
        this.get('images').findWhere({position : toPos}).set('position', fromPos);
    },

    /**
     * Return a specified publishOption
     * @param option
     * @returns boolean
     */
    getPublishingOption : function (option) {
        if (_.contains(Item.PUBLISH_OPTION, option)) {
            return isYes(this.get('publishOptions.' + option));
        }
        console.log("Error: Invalid publish option", option);
    },

    /**
     * Sets a publish option to a given value
     * @param option
     * @param bool
     */
    setPublishingOption : function (option, bool) {
        var value = bool ? 'Y' : 'N';
        if (!this.get('publishOptions')) {
            this.set('publishOptions', {});
        }
        if (_.contains(Item.PUBLISH_OPTION, option)) {
            this.set('publishOptions.' + option, value);
        } else {
            console.log('Error: Invalid publish option', option);
        }
    },

    /**
     * Sets one or more publishing options
     * @param optionsObject
     */
    setPublishingOptions : function (optionsObject) {
        _.each(optionsObject, function (value, key) {
            this.setPublishingOption(key, value);
        }, this);
    }

}, transitionMixin);


// Static functions
_.extend(Item, {
    //For ItemBaseView.js validation
    noValidateCondition : 'change:publishOptions',
    displayStatuses: {
        DELETED : "Deleted",
        NEW : "Add Text",
        ON_HOLD : "On Hold",
        PUBLISHED_TO_CATEGORY_SEARCH : "Published - Marketplace",
        PUBLISHED_TO_NEW_LISTINGS : "Published - Featured",
        QUEUED_FOR_CATEGORY_SEARCH : "Queued - Marketplace",
        QUEUED_FOR_NEW_LISTINGS : "Queued - Featured",
        SOLD : "Sold",
        STOREFRONT_ONLY : "Storefront Only",
        SUBMITTED_TO_CATEGORY_SEARCH : "Submitted - Marketplace",
        SUBMITTED_TO_NEW_LISTINGS : "Submitted - Featured",
        UNPUBLISHED : "Unlisted",
        WORK_IN_PROGRESS : "Work in Progress",
        REJECTED: "Action Required"
    },
    statuses: {
        DELETED : "DELETED",
        NEW : "NEW",
        ON_HOLD : "ON_HOLD",
        PUBLISHED_TO_CATEGORY_SEARCH : "PUBLISHED_TO_CATEGORY_SEARCH",
        PUBLISHED_TO_NEW_LISTINGS : "PUBLISHED_TO_NEW_LISTINGS",
        QUEUED_FOR_CATEGORY_SEARCH : "QUEUED_FOR_CATEGORY_SEARCH",
        QUEUED_FOR_NEW_LISTINGS : "QUEUED_FOR_NEW_LISTINGS",
        SOLD : "SOLD",
        STOREFRONT_ONLY : "STOREFRONT_ONLY",
        SUBMITTED_TO_CATEGORY_SEARCH : "SUBMITTED_TO_CATEGORY_SEARCH",
        SUBMITTED_TO_NEW_LISTINGS : "SUBMITTED_TO_NEW_LISTINGS",
        UNPUBLISHED : "UNPUBLISHED",
        WORK_IN_PROGRESS : "WORK_IN_PROGRESS",
        REJECTED: "REJECTED"
    },
    publishOptions: [
        "dibs", "featured", "nydc", "storefront", "workInProgress", "listedFrenchItem",
        "addText", "queuedForPosting", "rejected", "approved", "onHold", "deleted",
        "sold", "photoRepair", "previouslySold", "unpublished", "repost"
    ],
    PUBLISH_OPTION : {
        FEATURED : 'featured',
        MARKETPLACE : 'dibs',
        MARKET : 'marketplace',
        NYDC : 'nydc',
        STOREFRONT : 'storefront',
        WIP : 'workInProgress',
        ADD_TEXT : 'addText',
        REJECTED : 'rejected',
        APPROVED : 'approved',
        UNPUBLISHED : 'unpublished',
        REPOST : 'repost',
        SOLD : 'sold',
        DELETED : 'deleted',
        ON_HOLD : 'onHold',
        QUEUED_FOR_POSTING : 'queuedForPosting',
        PREVIOUSLY_SOLD: 'previouslySold',
        PHOTO_REPAIR : 'photoRepair',
        FRENCH_LISTING : 'listedFrenchItem'
    },
    IMAGES_API : {
        IMAGES_API_TYPE : 'images',
        IMAGES_ROTATION_API_TYPE : 'imageRotationRequest',
        IMAGES_ROTATION_TYPE : 'ROTATION'
    },
    defaultCollection : Items,
    getBaseDefaults: getDefaults,
    /**
     * @param {string} vertical
     * @returns {string}
     */
    getApiType: function (vertical) {
        return vertical + 'Item';
    },
    artDisplayStatuses: {
        PUBLISHED_TO_CATEGORY_SEARCH : "Published",
        PUBLISHED_TO_NEW_LISTINGS : "Published"
    }
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var serverVars = __webpack_require__(18);
var assign = __webpack_require__(2671);
var reduceRight = __webpack_require__(3967);
var template = __webpack_require__(3970);
var GLOBALCOPYKEY = '__COPYTEXT_GLOBAL_COPY__';
var SVPATHSKEY = '__COPYTEXT_SV_COPY_PATHS__';
var globalCopy = global[GLOBALCOPYKEY] = global[GLOBALCOPYKEY] || {};
var svCopyPaths = global[SVPATHSKEY] = global[SVPATHSKEY] || [];
var CopyText = function (options) {
    options = assign({
        copy: {}
    }, options);
    this._copy = options.copy;
    return this;
};
CopyText.prototype = {
    get: function (copyKey, options) {
        var text;
        var templateVars;
        options = assign({
            passthrough: true
        }, options);
        text = this._copy[copyKey] || globalCopy[copyKey];
        if (undefined === text) {
            text = reduceRight(svCopyPaths, function (text, keyPrefix) {
                return text || serverVars.get(keyPrefix + '.' + copyKey);
            }, text) || options.passthrough && copyKey;
        }
        if ('string' !== typeof text) {
            return false;
        }
        templateVars = assign({}, options.obj, {
            _copy: this.get.bind(this)
        });
        text = template(text)(templateVars);
        return text;
    },
    object: function () {
        return this._copy;
    },
    extend: function (morecopy) {
        return new CopyText({copy: assign({}, this._copy, morecopy)});
    }
};

module.exports = function () {
    return new CopyText();
};
module.exports.addGlobalSVPath = function (svCopyPath) {
    svCopyPaths.push(svCopyPath);
    return module.exports;
};
module.exports.addGlobalCopy = function (copyObj) {
    assign(globalCopy, copyObj);
    return module.exports;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(266);

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Stringify = __webpack_require__(4058);
var Parse = __webpack_require__(4057);

module.exports = {
    stringify: Stringify,
    parse: Parse
};


/***/ }),
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var bbExtend = Backbone.View.extend;
var composeWith = function composeWith(parent, sub, newproperties, staticProperties) {
    _.extend(sub, staticProperties);
    _.extend(sub.prototype, newproperties);
    _.each(sub.prototype, function (method, name) {
        var composed;
        if (undefined === method) {
            return; // already handled
        }
        if ("__" === name.substr(-2)) {
            sub.prototype[name] = undefined;
            name = name.slice(0, -2);
            if (_.isArray(method)) {
                composed = sub.prototype[name].concat(method);
            } else if ("object" === (typeof method === 'undefined' ? 'undefined' : _typeof(method))) {
                composed = _.extend({}, sub.prototype[name], method);
            } else {
                composed = function composed() {
                    var preMethod;
                    var postMethod;
                    var preValue;
                    if (parent.prototype[name]) {
                        preMethod = parent.prototype[name];
                    }
                    postMethod = method;
                    if (preMethod) {
                        preValue = preMethod.apply(this, arguments);
                    }
                    return postMethod.call(this, preValue);
                };
            }
        } else if ("__" === name.substr(0, 2)) {
            sub.prototype[name] = undefined;
            name = name.slice(2);
            if (_.isArray(method)) {
                composed = method.concat(sub.prototype[name]);
            } else if ("object" === (typeof method === 'undefined' ? 'undefined' : _typeof(method))) {
                composed = _.extend({}, method, sub.prototype[name]);
            } else {
                composed = function composed() {
                    var preMethod = method;
                    var methodReturnVal = preMethod.apply(this, arguments);
                    var postMethod;
                    if (parent.prototype[name]) {
                        postMethod = parent.prototype[name];
                    } else {
                        return methodReturnVal;
                    }
                    return postMethod.call(this, methodReturnVal);
                };
            }
        } else {
            return;
        }
        sub.prototype[name] = composed;
    });
};

/**
 * @mixin extendCompose
 * extendCompose is a drop-in replacement for Backbone.[Model|View|Router|etc...].extend that
 * suports automatic composing of child methods with parent methods.
 * extendCompose offers an alternative to the pattern of calling the parent method directly from a method
 * in your subclass, which can be pretty verbose, for example:
 *
 * <your subclass name>.__super__.<your method name>.apply(this, arguments) // pffew!
 *
 * When you call a method (sans underscore suffix) on a class that's been created using extendCompose:
 *
 * subClassInstance.myMethod(sub, arguments, here)
 *
 * this will happen behind the scenes:
 *
 * subClassInstance.myMethod__(subclassInstance.__super__.myMethod.apply(subClassInstance, [some, arguments, here]))
 *
 * To use it, replace the static extend method of your parent class with extendCompose.
 * Then, in the subclass, for each method that you would like to be automatically composed with
 * the parent's method of the same name (sans unerscore), add a suffix of two underscores to the method's name.
 *
 * example:
 *
 * var extendCompose = require('bunsen/libraries/extendCompose');
 * var ParentClass = Backbone.View.extend({
 *    myMethod : function (firstName, lastName) {
 *       console.log("running ParentClass's myMethod. Arguments are: '" + arguments + "'");
 *       return Array.prototype.slice.call(arguments, 0).join(' ');
 *    }
 * }, { // this section extends static methods
 *    extend: extendCompose
 * });
 * var SubClass = ParentClass.extend({
 *    myMethod__ : function (fullName) { // gets composed with ParentClass.prototype.myMethod
 *       console.log("running SubClass's myMethod. Return value form parent was '" + fullName + "'")
 *    }
 * });
 * var subClass = new SubClass();
 * subClass.myMethod('thomas', 'hallock');
 *
 * the above code will output:
 *
 * running ParentClass's myMethod. Arguments were 'thomas' and 'hallock'
 * running SubClass's myMethod. Return value from Parent was 'thomas hallock'
 *
 * Note: in this example, subclasses of SubClass will inherit extendCompose as well
 *
 */
var ExtendCompose = function ExtendCompose() {};
ExtendCompose.prototype.middleware = {
    afterPrototype: function afterPrototype(parentPrototype, childPrototypeBefore, childPrototypeAfter) {
        return childPrototypeAfter; // noop
    }
};
ExtendCompose.prototype.exportBuilder = function () {
    var self = this;
    var ecExport = Object.assign(function (protos, statics) {
        var parent = this;
        var sub = void 0;
        if (protos instanceof Array) {
            protos = _.extend.apply(_, [{}].concat(protos));
        }
        sub = bbExtend.call(parent, protos, statics);
        sub.extend = ecExport;
        sub.extendSelf = function () {
            composeWith.apply(this, [parent, sub].concat(Array.prototype.slice.apply(arguments))); // mutates sub
            sub.prototype = self.middleware.afterPrototype(parent.prototype, protos, sub.prototype);
            return sub;
        };
        sub.extendSelf(sub.prototype);
        return sub;
    }, {
        withMiddleware: this.withMiddleware.bind(this)
    });
    return ecExport;
};
ExtendCompose.prototype.withMiddleware = function (middleware) {
    var parentEc = this;
    var NewExtendCompose = Object.assign(function () {}, {
        prototype: this
    });
    var newEc = new NewExtendCompose();
    if (middleware.afterPrototype) {
        newEc.middleware = Object.assign({}, Object.assign({}, parentEc.middleware, {
            afterPrototype: function afterPrototype(parentPrototype, childPrototypeBefore, childPrototypeAfter) {
                return middleware.afterPrototype(parentPrototype, childPrototypeBefore, parentEc.middleware.afterPrototype(parentPrototype, childPrototypeBefore, childPrototypeAfter));
            }
        }));
    }
    return newEc.exportBuilder();
};
module.exports = new ExtendCompose().exportBuilder();

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = dibs_vendor;

/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(264);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 9/23/14
 * Time: 10:47 AM
 */


var _ = __webpack_require__(0);

module.exports = {
    _getFinancialAmount: function (prop, currency) {
        var amount = this.get(prop);
        var number;

        if (amount) {
            number = Number(amount.getAmountIn(currency));

            if (!_.isNaN(number)) {
                return number;
            }
        }

    },
    getSubTotal: function (currency) {
        return this._getFinancialAmount('subTotalAmount', currency);
    },
    getSubTotalNum: function () {
        return this.get('subTotalAmount.amount');
    },
    getTotalAmount: function (currency) {
        return this._getFinancialAmount('totalAmount', currency);
    }
};


/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseAssign = __webpack_require__(2232),
    createAssigner = __webpack_require__(2237),
    keys = __webpack_require__(297);

/**
 * A specialized version of `_.assign` for customizing assigned values without
 * support for argument juggling, multiple sources, and `this` binding `customizer`
 * functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 */
function assignWith(object, source, customizer) {
  var index = -1,
      props = keys(source),
      length = props.length;

  while (++index < length) {
    var key = props[index],
        value = object[key],
        result = customizer(value, source[key], key, object, source);

    if ((result === result ? (result !== value) : (value === value)) ||
        (value === undefined && !(key in object))) {
      object[key] = result;
    }
  }
  return object;
}

/**
 * Assigns own enumerable properties of source object(s) to the destination
 * object. Subsequent sources overwrite property assignments of previous sources.
 * If `customizer` is provided it is invoked to produce the assigned values.
 * The `customizer` is bound to `thisArg` and invoked with five arguments:
 * (objectValue, sourceValue, key, object, source).
 *
 * **Note:** This method mutates `object` and is based on
 * [`Object.assign`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign).
 *
 * @static
 * @memberOf _
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {*} [thisArg] The `this` binding of `customizer`.
 * @returns {Object} Returns `object`.
 * @example
 *
 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
 * // => { 'user': 'fred', 'age': 40 }
 *
 * // using a customizer callback
 * var defaults = _.partialRight(_.assign, function(value, other) {
 *   return _.isUndefined(value) ? other : value;
 * });
 *
 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
 * // => { 'user': 'barney', 'age': 36 }
 */
var assign = createAssigner(function(object, source, customizer) {
  return customizer
    ? assignWith(object, source, customizer)
    : baseAssign(object, source);
});

module.exports = assign;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by john on 8/5/15.
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var PropTypes = __webpack_require__(7);

/**
 * This is a convenience class which provides the contextTypes property
 * for anything that extends it. It's used by Fluxible to give child
 * components access to the getStore and executeAction methods of the context.
 */

var ContextComponent = function (_React$Component) {
    _inherits(ContextComponent, _React$Component);

    function ContextComponent(props) {
        _classCallCheck(this, ContextComponent);

        return _possibleConstructorReturn(this, (ContextComponent.__proto__ || Object.getPrototypeOf(ContextComponent)).call(this, props));
    }

    return ContextComponent;
}(React.Component);

ContextComponent.contextTypes = {
    getStore: PropTypes.func.isRequired,
    executeAction: PropTypes.func.isRequired
};

module.exports = ContextComponent;

/***/ }),
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: gedas
 * Date: 2/25/16
 * Time: 4:00 PM
 */


var SV = __webpack_require__(18);

module.exports = {
  /**
   * @returns {Object}
   * @private
   */
  _getConfig: function _getConfig() {
    return SV.get('settings.enabler') || {};
  },


  /**
   * Checks if key in config is set and its `true`
   *
   * @param {String} key
   * @returns {Boolean}
   */
  isEnabled: function isEnabled() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var config = this._getConfig();
    return typeof config[key] !== 'undefined' && config[key] === true;
  }
};

/***/ }),
/* 64 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseFlatten = __webpack_require__(317),
    bindCallback = __webpack_require__(123),
    pickByArray = __webpack_require__(340),
    pickByCallback = __webpack_require__(341),
    restParam = __webpack_require__(279);

/**
 * Creates an object composed of the picked `object` properties. Property
 * names may be specified as individual arguments or as arrays of property
 * names. If `predicate` is provided it is invoked for each property of `object`
 * picking the properties `predicate` returns truthy for. The predicate is
 * bound to `thisArg` and invoked with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {Function|...(string|string[])} [predicate] The function invoked per
 *  iteration or property names to pick, specified as individual property
 *  names or arrays of property names.
 * @param {*} [thisArg] The `this` binding of `predicate`.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'user': 'fred', 'age': 40 };
 *
 * _.pick(object, 'user');
 * // => { 'user': 'fred' }
 *
 * _.pick(object, _.isString);
 * // => { 'user': 'fred' }
 */
var pick = restParam(function(object, props) {
  if (object == null) {
    return {};
  }
  return typeof props[0] == 'function'
    ? pickByCallback(object, bindCallback(props[0], props[1], 3))
    : pickByArray(object, baseFlatten(props));
});

module.exports = pick;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var Price = SoaModel.extend();
var FinancialAmount = __webpack_require__(10);

// graphql transforms all Y/N's into true/false
// make sure we can accomodate both
function isYes(prop) {
    return prop === 'Y' || prop === true;
}

_.extend(Price, {
    TYPE_NET: 'NET',
    TYPE_RETAIL: 'RETAIL',
    TYPE_SALE: 'WEEKLY_SALE',
    STATUS_ACTIVE: 'ACTIVE'
});

_.extend(Price.prototype, {
    relations: [{
        key: 'amount',
        relatedModel: FinancialAmount,
        type: Backbone.One
    }],
    isSoldIndividually: function isSoldIndividually() {
        return isYes(this.get('pricePerPiece'));
    },
    isNegotiable: function isNegotiable() {
        return isYes(this.get('negotiable'));
    },
    shouldHidePrice: function shouldHidePrice() {
        return isYes(this.get('hidePrice'));
    },

    isActive: function isActive() {
        return this.get('status') === Price.STATUS_ACTIVE;
    },
    isRetail: function isRetail() {
        return this.get('type') === Price.TYPE_RETAIL;
    },
    isSale: function isSale() {
        return this.get('type') === Price.TYPE_SALE;
    }
});

module.exports = Price;

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseGet = __webpack_require__(3934),
    baseSlice = __webpack_require__(3936),
    toPath = __webpack_require__(3943),
    isArray = __webpack_require__(64),
    isFunction = __webpack_require__(104);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  var type = typeof value;
  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
    return true;
  }
  if (isArray(value)) {
    return false;
  }
  var result = !reIsDeepProp.test(value);
  return result || (object != null && value in toObject(object));
}

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array ? array.length : 0;
  return length ? array[length - 1] : undefined;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * This method is like `_.get` except that if the resolved value is a function
 * it is invoked with the `this` binding of its parent object and its result
 * is returned.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to resolve.
 * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
 *
 * _.result(object, 'a[0].b.c1');
 * // => 3
 *
 * _.result(object, 'a[0].b.c2');
 * // => 4
 *
 * _.result(object, 'a.b.c', 'default');
 * // => 'default'
 *
 * _.result(object, 'a.b.c', _.constant('default'));
 * // => 'default'
 */
function result(object, path, defaultValue) {
  var result = object == null ? undefined : object[path];
  if (result === undefined) {
    if (object != null && !isKey(path, object)) {
      path = toPath(path);
      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
      result = object == null ? undefined : object[last(path)];
    }
    result = result === undefined ? defaultValue : result;
  }
  return isFunction(result) ? result.call(object) : result;
}

module.exports = result;


/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by james on 4/30/14.
 */


// ---------------------------------------------------
// Load Super Pseudo Class

var SoaModel = __webpack_require__(2);

// ---------------------------------------------------
// Define Module

/**
 * @class ShipmentQuote
 */
var ShipmentQuote = module.exports = SoaModel.extend();

// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);
var ServiceMethod = __webpack_require__(316);
var ShippingCosts = __webpack_require__(2206);
var ShippingCost = __webpack_require__(2209);
var Backbone = __webpack_require__(3);
var endpoints = __webpack_require__(6);
var Party = __webpack_require__(8);
var Period = __webpack_require__(116);
var periodMixin = __webpack_require__(338);
var SV = __webpack_require__(18);
var Carrier = __webpack_require__(322);
var FinancialAmount = __webpack_require__(10);
var financialAmountMixin = __webpack_require__(48);
var Region = __webpack_require__(1625);
var assert = __webpack_require__(31);
var stringNumHelper = __webpack_require__(2632);

// ---------------------------------------------------
// Define Module Static Properties

_.extend(ShipmentQuote, {
    /** @type {string} */
    TYPE_SELLER_PREFERENCES : 'SELLER_PREFERENCES',
    /** @type {string} */
    TYPE_INVENTORY_POSTING : 'INVENTORY_POSTING',
    /** @type {string} */
    TYPE_TRANSACTION : 'TRANSACTION',
    /** @type {string} */
    PRICING_TYPE_ACCOUNTING: 'ACCOUNTING',
    /** @type {string} */
    PRICING_TYPE_COMMERCIAL: 'COMMERCIAL',
    /** @type {string} */
    SERVICE_ERROR_RESOLVE_IP: 'UNABLE_TO_RESOLVE_COUNTRY_FROM_IP_ADDRESS',
    /** @type {object} */
    validationRules: {
        /** @type {string} */
        CANNOT_BE_GREATER_THAN: 'CANNOT_BE_GREATER_THAN',
        /** @type {string} */
        CANNOT_BE_LESS_THAN: 'CANNOT_BE_LESS_THAN'
    },
    /**
     * @returns {string[]}
     */
    getPreQuoteTypes : function () {
        return [
            ShipmentQuote.TYPE_SELLER_PREFERENCES,
            ShipmentQuote.TYPE_INVENTORY_POSTING
        ];
    },
    /**
     * @param {object} attrs
     * @returns {ShipmentQuote}
     */
    createLocalPickupQuote: function (attrs) {
        attrs = attrs ? _.clone(attrs) : {};
        attrs.serviceMethod = _.extend({
            serviceMethodType: ServiceMethod.METHOD_LOCAL_PICKUP
        }, attrs.serviceMethod);
        return new ShipmentQuote(attrs);
    }
});

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(ShipmentQuote.prototype, {
    urlRoot: endpoints.shipmentQuote(),
    url: function () {
        var urlRoot = this.urlRoot;
        return this.id ? (urlRoot + '/' + this.id) : urlRoot;
    },
    defaults: {
        apiType: 'shipmentQuote',
        serviceMethod: {},
        author: {},
        billTo: {},
        costs: []
    },
    relations: SoaModel.createRelations([
        {
            key: 'author',
            type: Backbone.One,
            relatedModel: Party
        },
        {
            key: 'billTo',
            type: Backbone.One,
            relatedModel: Party
        },
        {
            key: 'handlingTime',
            type: Backbone.One,
            relatedModel: Period
        },
        {
            key: 'serviceMethod',
            type: Backbone.One,
            relatedModel: ServiceMethod
        },
        {
            key: 'costs',
            type: Backbone.Many,
            collectionType: ShippingCosts
        },
        {
            type : Backbone.One,
            key : 'carrier',
            relatedModel : Carrier
        },
        {
            type: Backbone.One,
            key: 'subTotalAmount',
            relatedModel: FinancialAmount
        },
        {
            type: Backbone.One,
            key: 'totalAmount',
            relatedModel: FinancialAmount
        }
    ]),
    initialize: function (attrs, opts) {
        opts = opts || {};
        this.serviceMethodRequiredFields = opts.serviceMethodRequiredFields || [
            'serviceMethodType', 'serviceType', 'windowMin.numberOfUnits', 'windowMax.numberOfUnits'
        ];
        opts.validateRequiredFields = _.isBoolean(opts.validateRequiredFields) ?
                opts.validateRequiredFields : this.validateRequiredFields;

        ShipmentQuote.__super__.initialize.call(this, attrs, opts);
    },
    /**
     * @returns {boolean}
     */
    is1stdibsQuote: function () {
        return this.is1stdibsBilledQuote() && !this.isAccountingQuote();
    },
    /**
     * @returns {boolean}
     */
    is1stdibsAuthoredQuote: function () {
        var author = this.get('author');
        return author && author.is1stdibs();
    },
    /**
     * @returns {boolean}
     */
    isDealerAuthoredQuote: function () {
        var author = this.get('author');
        return author && author.isDealer() && !this.isLocalPickup();
    },
    /**
     * @returns {boolean}
     */
    is1stdibsBilledQuote: function () {
        var billToParty = this.get('billTo');
        return billToParty && billToParty.is1stdibs();
    },
    /**
     * @returns {boolean}
     */
    isDealerBilledQuote: function () {
        var billToParty = this.get('billTo');
        return billToParty && billToParty.isDealer();
    },

    /**
     * Returns true if the dealer is shipping an item
     * with an auto-generated quote that is subsized
     * by 1stdibs. Right now the test for that is simply
     * that the quote is a 1stdibs Parcel quote and also
     * a prequote. Prequotes will not be generated by
     * 1stdibs for this program.
     * @returns {boolean}
     */
    is1stdibsSubsidizedDealerQuote: function () {
        return this.is1stdibsParcelQuote() && this.isPreQuote();
    },

    /**
     * @returns {boolean}
     */
    is1stdibsParcelQuote: function () {
        return this.is1stdibsQuote() && this.isParcelServiceType();
    },

    /**
     * @returns {boolean}
     */
    is1stdibsWhiteGloveQuote: function () {
        return this.is1stdibsQuote() && this.isWhiteGloveServiceType();
    },

    /**
     * @returns {boolean}
     */
    isParcelServiceType: function () {
        return this.get('serviceMethod').isParcel();
    },

    /**
     * @returns {boolean}
     */
    isWhiteGloveServiceType: function () {
        return this.get('serviceMethod').isWhiteGlove();
    },

    /**
     * @returns {boolean}
     */
    hasPreQuoteType: function () {
        return _.contains(ShipmentQuote.getPreQuoteTypes(), this.get('type'));
    },
    /**
     * @returns {boolean}
     */
    isPreQuote: function () {
        return this.hasPreQuoteType() && !this.isLocalPickup();
    },
    /**
     * @returns {boolean}
     */
    isCommercialQuote: function () {
        return this.get('pricingType') === ShipmentQuote.PRICING_TYPE_COMMERCIAL;
    },
    /**
     * @returns {boolean}
     */
    isAccountingQuote: function () {
        return this.get('pricingType') === ShipmentQuote.PRICING_TYPE_ACCOUNTING;
    },
    /**
     * @returns {boolean}
     */
    is1stdibsPreQuote: function () {
        return this.is1stdibsQuote() && this.isPreQuote();
    },
    /**
     * @returns {boolean}
     */
    isDealerPreQuote: function () {
        return this.isDealerBilledQuote() && this.isPreQuote();
    },
    /**
     * @returns {boolean}
     */
    isComplimentaryShipping: function () {
        return this.get('complimentaryShipping') === 'Y';
    },
    /**
     * @returns {boolean}
     */
    isLocalPickup: function () {
        var serviceMethod = this.get('serviceMethod');
        return serviceMethod && serviceMethod.isLocalPickup();
    },
    getRole: function () {
        return this.get('author.role');
    },
    /**
     * @returns {boolean}
     */
    regionIsWorld: function () {
        return Region.regionCodeIsWorld(this.get('serviceMethod.region.code'));
    },
    /**
     * Returns an array of attribute keys for missing
     * fields, and null if there aren't any
     * @returns {string[]}
     */
    validate: function () {
        var missingFields;
        if (this.validateRequiredFields) {
            missingFields = this.missingRequiredFields();
            return missingFields.length ? missingFields : null;
        }
        return null;
    },
    /**
     * @returns {string}
     */
    describeDuration: function () {
        var handlingTimeDays;
        var min;
        var max;

        //TRANACT-2371 - Hide duration for local pickup
        if (this.isLocalPickup()) {
            return '';
        }
        handlingTimeDays = this.getHandlingTimeDays();
        min = this.getMinShippingDays() + (handlingTimeDays || 0);
        max = this.getMaxShippingDays() + (handlingTimeDays || 0);
        return this._describeRange(min, max);
    },

    /**
     * @returns {string}
     */
    describeShippingWindow: function () {
        return this._describeRange(this.getMinShippingDays(), this.getMaxShippingDays());
    },

    /**
     * @returns {string}
     */
    getBuyerServiceMethodDisplayValue: function () {
        var quoteAuthorRole = this.get('author.role');
        var type = this.get('serviceMethod.serviceType');
        var methodType = this.get('serviceMethod.serviceMethodType');
        var names = SV.get('serviceMethodNames.' + quoteAuthorRole);

        if (!type || !methodType || !names) {
            return '';
        }
        return names[type][methodType].name;
    },

    /**
     * @returns {number}
     */
    getMaxShippingDays: function () {
        return this.getPeriodInDays('serviceMethod.windowMax');
    },

    /**
     * @returns {number}
     */
    getMinShippingDays : function () {
        return this.getPeriodInDays('serviceMethod.windowMin');
    },

    /**
     * @returns {number}
     */
    getHandlingTimeDays : function () {
        return this.getPeriodInDays('handlingTime');
    },

    /**
     * @returns {string}
     */
    getDisplayHandlingTimeDays: function () {
        return this.getPeriodDisplayVal('handlingTime');
    },

    /**
     * @returns {string}
     */
    _describeRange: function (minDays, maxDays) {
        var unit = "day";
        if (!maxDays) {
            return "";
        }
        if (minDays >= 10) {
            minDays = Math.floor(minDays / 7);
            maxDays = Math.ceil(maxDays / 7);
            unit = "week";
        }
        if (minDays === maxDays) {
            return [minDays, ' ', unit, minDays === 1 ? '' : 's'].join('');
        }
        return [minDays, ' to ', maxDays, ' ', unit, 's'].join('');
    },


    /**
     * Returns the shipping price to be displayed from totalAmount.  If it is complimentary, returns null
     * @param  {String} currency - Optional - 3 character currency code.  Defaults to currency attribute of totalAmount
     * @return {String|null} - null if complimentary.  Otherwise formatted price.
     */
    getDisplayPrice: function (currency) {
        if (this.isComplimentaryShipping()) {
            return null;
        }
        return this.get('totalAmount').getDisplayPrice(currency);
    },

    /**
     * Returns an array with the keys for
     * any missing required fields
     * @param {string} [requiredCostType]
     * @returns {string[]}
     */
    missingRequiredFields: function (requiredCostType) {
        var serviceMethod = this.get('serviceMethod');
        var missingFields = [];
        var field;
        var val;
        var subTotal;
        var i = 0;
        for (i; i < this.serviceMethodRequiredFields.length; i++) {
            field = this.serviceMethodRequiredFields[i];
            val = serviceMethod.get(field);
            if (val === undefined || val === '' || val === null || (typeof val === 'number' && val < 0)) {
                missingFields.push(field);
            }
        }
        if (!this.get('serviceMethod.region.id') && !this.get('serviceMethod.region.regionName')) {
            missingFields.push('region');
        }
        if (requiredCostType) {
            subTotal = parseFloat(this.getSubTotalNumForCostType(requiredCostType));
            // There must be a price, or this must be a free shipping quote
            if ((!subTotal || subTotal < 0) && !this.isComplimentaryShipping()) {
                missingFields.push('subTotalAmount');
            }
        }
        return missingFields;
    },

    /**
     * @returns {object}
     */
    getAmountCurrencies: function () {
        var amountCurrencies = this.get('totalAmount');
        var ret = null;

        //to handle case where complimentaryShipping == 'N' but prices are 0...
        if (amountCurrencies && amountCurrencies.getAmountIn('USD')) {
            ret = amountCurrencies.get('convertedAmounts').toJSON();
        }

        return ret;
    },

    /**
     * @returns {FinancialAmount}
     */
    getSubTotalAmount: function () {
        return this.get('subTotalAmount');
    },

    /**
     * @returns {ShippingCosts}
     */
    getShippingCosts: function () {
        return this.get('costs');
    },

    /**
     * @param {number} subTotal
     * @param {string} costType
     * @returns {ShipmentQuote}
     */
    setSubTotalForCostType: function (subTotal, costType) {
        var costs = this._ensureShippingCosts();
        costs.setSubTotalForType(costType, subTotal);
        return this;
    },

    /**
     * Returns true if any of the quote's costs
     * have a subtotal greater than zero.
     * @returns {boolean}
     */
    hasCostGreaterThanZero: function () {
        var costs = this.getShippingCosts();
        if (!costs) {
            return false;
        }
        return costs.any(function (cost) {
            var val = stringNumHelper.safeConvertNumberVal(cost.getSubTotalNum());
            return val !== null && val > 0;
        });
    },

    /**
     * Get a ShippingCost for a costType from
     * the quotes shipping cost collection. If
     * that cost doesn't exist yet, then it
     * will be created.
     * @param {string} costType
     * @returns {ShippingCost}
     */
    ensureShippingCostForType: function (costType) {
        var costs = this._ensureShippingCosts();
        var cost = costs.findByCostType(costType);
        if (cost) {
            return cost;
        }
        costs.setSubTotalForType(costType, null);
        return costs.findByCostType(costType);
    },

    /**
     * @param {number} subTotal
     * @returns {ShipmentQuote}
     */
    setUnknownCostSubTotal: function (subTotal) {
        return this.setSubTotalForCostType(subTotal, ShippingCost.COST_TYPE_UNKNOWN);
    },

    /**
     * @param {string} costType
     * @returns {ShippingCost}
     */
    findShippingCostForType : function (costType) {
        var costs = this.getShippingCosts();
        if (!costs) {
            return null;
        }
        return costs.findByCostType(costType);
    },

    /**
     * @param {string} costType
     * @returns {FinancialAmount}
     */
    getSubTotalAmountForCostType: function (costType) {
        var costs = this.getShippingCosts();
        if (!costs) {
            return null;
        }
        return costs.getSubTotalAmountForType(costType);
    },

    /**
     * gets the numeric subtotal amount for the given costType in the given
     * currency, defaulting to USD if no currency is supplied
     * @param {string} costType
     * @param {string} [currency]
     * @returns {number}
     */
    getSubTotalAmountForCostTypeIn: function (costType, currency) {
        var subTotalAmount;
        currency = currency || 'USD';
        subTotalAmount = this.getSubTotalAmountForCostType(costType);
        return subTotalAmount ? subTotalAmount.getAmountIn(currency) : null;
    },

    /**
     * @param {string} costType
     * @returns {number}
     */
    getSubTotalNumForCostType: function (costType) {
        var costs = this.getShippingCosts();
        if (!costs) {
            return null;
        }
        return costs.getSubTotalNumForType(costType);
    },

    /**
     * @param {string} costType
     * @param {string} currency
     * @returns {number}
     */
    getSubTotalInCurrForCostType: function (costType, currency) {
        var subTotalAmount = this.getSubTotalAmountForCostType(costType);
        return subTotalAmount ? subTotalAmount.getAmountIn(currency) : null;
    },

    /**
     * Return the currency of the first shipment cost
     * @returns {string}
     */
    getFirstCostCurrency: function () {
        var costs = this.getShippingCosts();
        return (costs && costs.length) ? costs.first().getCurrency() : null;
    },

    /**
     * @param {string} currency
     * @returns {ShipmentQuote}
     */
    setDefaultCurrency: function (currency) {
        var costs = this._ensureShippingCosts();
        costs.setDefaultCurrency(currency);
        return this;
    },

    /**
     * @param {string} costType
     * @param {Carrier} carrier
     * @returns {ShipmentQuote}
     */
    setCarrierForCostType: function (costType, carrier) {
        var costs = this._ensureShippingCosts();
        assert(carrier instanceof Carrier, 'carrier must be an instance of Carrier');
        costs.setBillToForType(costType, Party.ROLE_LSP, carrier.get('id'));
        return this;
    },

    /**
     * @param {string} costType
     * @returns {number|string}
     */
    getBillToIdForCostType: function (costType) {
        var cost = this.findShippingCostForType(costType);
        if (!cost) {
            return null;
        }
        return cost.getBillToId();
    },

    /**
     * @param {string} costType
     * @returns {string}
     */
    getCarrierNameForCostType: function (costType) {
        var costs = this.getShippingCosts();
        return costs ? costs.findBillToCarrierNameForType(costType) : null;
    },

    /**
     * @param {string} costType
     * @returns {string}
     */
    getCarrierCodeForCostType: function (costType) {
        var costs = this.getShippingCosts();
        return costs ? costs.findBillToCarrierCodeForType(costType) : null;
    },

    /**
     * Returns the 'UNKNOWN' shipping cost if present, otherwise
     * returns the 'TRANSIT' shipping cost if present, otherwise
     * returns null.
     * @returns {ShippingCost}
     */
    findDefaultShippingCost : function () {
        var costs = this.getShippingCosts();
        return costs ? costs.findDefaultCost() : null;
    },

    /**
     * @returns {string}
     */
    findDefaultCostCarrierName: function () {
        var cost = this.findDefaultShippingCost();
        return (cost && cost.billToIsLSP()) ? cost.findBillToCarrierName() : null;
    },

    /**
     * @param {string} costType
     * @returns {boolean}
     */
    carrierIsOtherForCostType: function (costType) {
        var cost = this.findShippingCostForType(costType);
        return cost ? cost.billToCarrierIsOther() : null;
    },

    /**
     * Returns true only if there is
     * @returns {boolean}
     */
    defaultCostCarrierIsOther: function () {
        var cost = this.findDefaultShippingCost();
        return cost ? cost.billToCarrierIsOther() : null;
    },

    /**
     * @returns {string|number}
     */
    getDefaultCostCarrierId : function () {
        var cost = this.findDefaultShippingCost();
        return (cost && cost.billToIsLSP()) ? cost.getBillToId() : null;
    },

    /**
     * @returns {Deferred.promise}
     */
    computeSubTotal: function () {
        var self = this;
        var oldUrl = self.url;
        var prom;
        self.url = endpoints.computeShipmentQuoteSubTotal();
        prom = self.sync('create', self);
        prom.done(function (data) {
            var parsedData = self.parse(data);
            if (!self.getSubTotalAmount()) {
                self.set('subTotalAmount', {});
            }
            if (!self.get('totalAmount')) {
                self.set('totalAmount', {});
            }
            self.set('subTotalAmount.amount', parsedData.subTotalAmount.amount);
            self.set('subTotalAmount.convertedAmounts', parsedData.subTotalAmount.convertedAmounts);
            self.set('totalAmount.amount', parsedData.totalAmount.amount);
            self.set('totalAmount.convertedAmounts', parsedData.totalAmount.convertedAmounts);
        });
        self.url = oldUrl;
        return prom;
    },

    _ensureShippingCosts: function () {
        var costs = this.getShippingCosts();
        if (costs) {
            return costs;
        }
        this.set('costs', []);
        return this.getShippingCosts();
    }
}, periodMixin, financialAmountMixin);


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Replaces keys with actual values as long as the key is inside curly braces: {key}
 * @module tokenReplace
 * @param {String} str The string to replace values in
 * @param {Object} o JSON Object containing key/value pairs to replace and use
 * @param {String} delim one or two character string expressing open / close delimiter(s) for the tokens. Defaults to '{}'
 * @returns String with tokens replaced
 * @example: tokenReplace("My name is {name}.  I work at {company}.", { name: "Dale", company: "1stdibs" });
 */
module.exports = function tokenReplace(str, o, delim) {
    var pattern;
    delim = undefined === delim ? '{}' : delim;
    pattern = new RegExp('\\' + delim.slice(0, 1) + '+([^' + '\\' + delim.split('').join('\\') + ']*)' + '\\' + delim.slice(-1) + '+', 'g');

    if (typeof str !== 'string') {
        return str;
    }

    return str.replace(pattern,
        function (a, b) {
            var r = o[b];
            return typeof r === 'string' || typeof r === 'number' ? r : a;
        }
    );
};

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: daletan
 * Date: 3/24/15
 * Time: 6:41 PM
 * Copyright 1stdibs.com, Inc. 2015. All Rights Reserved.
 */



module.exports = typeof window === 'undefined' ? global : window;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 103 */,
/* 104 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array constructors, and
  // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isFunction;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var SoaModel = __webpack_require__(2);
var root = typeof window === 'undefined' ? global : window;

/**
 * @typedef {object} SellerModel
 */
var Seller = module.exports = SoaModel.extend();
var Agreement                         = __webpack_require__(3836);
var Dealers                           = __webpack_require__(2620);
var User                              = __webpack_require__(28);
var Backbone                          = __webpack_require__(3);
var moment                            = __webpack_require__(30);
var SoaModelLabelAndValueTransformer  = __webpack_require__(1622);
var SoaCollection                     = __webpack_require__(9);
var UserProfile                       = __webpack_require__(1218);
var ShipmentQuote                     = __webpack_require__(74);
var Period                            = __webpack_require__(116);
var fetchRelationMixin                = __webpack_require__(2652);
var SellerAdjustment                  = __webpack_require__(2049);
var SellerBillingProfile              = __webpack_require__(2642);
var SellerPaymentProfile              = __webpack_require__(2643);
var TradeAssociation                  = __webpack_require__(2051);
var TradeAssociations                 = __webpack_require__(2621);
var ReturnPolicy                      = __webpack_require__(321);
//var Shipping = require('bunsen/models/Shipping'); // TODO: refactor to use new shipping models
//var ShippingCollection = require('bunsen/collections/ShippingCollection');
var ShipmentQuotes                    = __webpack_require__(319);
var Address                           = __webpack_require__(32);
var dataProvider                      = __webpack_require__(780);
var verticals                         = __webpack_require__(416);
var endpoints                         = __webpack_require__(6);
var legacyId                          = __webpack_require__(2043);
var _                                 = __webpack_require__(0);
var $                                 = __webpack_require__(5);
var Notes                             = __webpack_require__(24);
var Note                              = __webpack_require__(33);
var SellerPreferences                 = __webpack_require__(2644);
var AnchorLists                       = __webpack_require__(119);
var FeeStructure                      = __webpack_require__(2047);
var FeeStructures                     = __webpack_require__(2616);
var TwentyFirstCenturyStatus          = __webpack_require__(3839);

var sellers = [];

/**
 * Defining relatedModel collection to stateTaxAdjustments
 * @typedef {object} AdjustmentsModel
 */
var StateTaxAdjustments = SoaModel.extend({
    url : function () {
        var url = _.result(this.findParent(Seller), 'url') + '/taxAdjustment';
        return url;
    },
    relations : [{
        key : 'adjustments',
        collectionType: SoaCollection.extend({
            model: SellerAdjustment
        }),
        type: Backbone.Many
    }]
});

/**
 * Hold all agreements for the seller
 * @type {*}
 */
var SellerAgreements = SoaModel.extend({
    model: SoaModel,
    url : function () {
        return _.result(this.findParent(Seller), 'url') + '/agreement';
    },
    relations : [{
        key : 'agreementList',
        collectionType: SoaCollection.extend({
            model: Agreement
        }),
        type: Backbone.Many
    }]
});

var SellerStore = SoaModel.extend({
    // Assign the URL to the store using the path to the parent Seller's URL (with the correct ID)
    url : function () {
        var url = _.result(this.findParent(Seller), 'url') + '/store';
        return url;
    },
    defaults: {
        address : {},
        district : {},
        country : {},
        state : {},
        continent: {},
        region : {}
    },
    // Since the distinct and address sub-models are simple one to one relationships at this level, use the
    // createRelations method to do it quickly... this assumes SoaModel as the related model, and
    // Backbone.One relationship type.
    relations : function () {
        return SoaModel.createRelations(['district', 'address', 'country', 'state', 'region', 'continent']);
    }

});

var SellerProfile = UserProfile.extend({
    getDisplayName: function () {
        return this.get('company') || SellerProfile.__super__.getDisplayName.apply(this, arguments);
    },
    displayLabels: {
        trackedPhoneNumber: 'Dedicated Phone Number'
    },
    url: function () {
        return _.result(this.findParent(Seller), 'url') + '/profile';
    }
});

var PriceProfile = SoaModel.extend({
    url: function () {
        return _.result(this.findParent(Seller), 'url') + '/priceProfile';
    }
});

var getSellerAddressModel = function (endpoint) {
    return Address.extend({
        // Assign the url in initialize to overwrite the default
        // url set in the Address model
        initialize: function (options) {
            Address.__super__.initialize.call(this, options);

            this.url = function () {
                return _.result(this.findParent(Seller), 'url') + '/address/' + endpoint;
            };
        },
        //The Address Model syncs new addresses using the addressBook endpoint of buyers,
        //so this needs to be overridden for the seller address sync
        sync: function () {
            return Address.__super__.sync.apply(this, arguments);
        }
    });
};

/**
 * Relations array - For passing all the relations as list to Seller
 * @type {Array}
 */
var relations = [
    {
        key: 'score',
        relatedModel: SoaModel,
        type: Backbone.One
    },
    {
        key: 'priceProfile',
        relatedModel: PriceProfile,
        type: Backbone.One
    },
    {
        key: 'sellerPreferences',
        relatedModel: SellerPreferences,
        type: Backbone.One
    },
    {
        key: 'sellerProfile',
        relatedModel: SellerProfile,
        type: Backbone.One
    },
    {
        key : 'stores',
        collectionType: SoaCollection.extend({
            model: SellerStore
        }),
        type: Backbone.Many
    },
    {
        key: 'stateTaxAdjustments',
        relatedModel : StateTaxAdjustments,
        type: Backbone.One
    },
    {
        key: 'shippingAddress',
        relatedModel: getSellerAddressModel('shipping'),
        type: Backbone.One
    },
    {
        key: 'billingAddress',
        relatedModel: getSellerAddressModel('billing'),
        type: Backbone.One
    },
    {
        key: 'payAddress',
        relatedModel: getSellerAddressModel('pay'),
        type: Backbone.One
    },
    {
        key: 'billingProfile',
        relatedModel: SellerBillingProfile,
        type: Backbone.One,
        omitFromSave: true
    },
    {
        key: 'paymentProfile',
        relatedModel: SellerPaymentProfile,
        type: Backbone.One,
        omitFromSave: true
    },
    {
        key: 'agreements',
        relatedModel: SellerAgreements,
        type: Backbone.One
    },
    {
        key: 'returnPolicies',
        relatedModel: ReturnPolicy,
        type: Backbone.Many
    },
    {
        key: 'shipmentQuotes',
        collectionType: ShipmentQuotes,
        type: Backbone.Many
    },
    {
        key: 'accountManager',
        relatedModel: User,
        type: Backbone.One
    },
    // @deprecated - use tradeAssociations for everything but nydc
    {
        key: 'associations',
        relatedModel: TradeAssociation,
        type: Backbone.One
    },
    {
        key: 'tradeAssociations',
        collectionType: TradeAssociations,
        type: Backbone.Many
    },
    {
        key: 'anchorLists',
        collectionType: AnchorLists,
        type: Backbone.Many
    }
];

root.bunsen = root.bunsen || {};

/**
 * SoaModel
 * @type {*}
 */
_.extend(Seller, { // static methods
    SELLER_ID: 'seller_id',
    STATUS_ACTIVE: 'active',
    STATUS_PENDING: 'pending',
    STATUS_SUSPENDED : 'suspended',
    STATUS_NO_PAY: 'no_pay',
    STATUS_CLOSED: 'closed',
    STATUS_INTERNAL: 'internal',

    // TODO add more (billing profile, account manager, etc)
    // used as fetchRelation flags
    FIELD_SHIPMENT_QUOTE: 'shipmentQuote',
    FIELD_RETURN_POLICY: 'returnPolicy',
    FIELD_PREFERENCE: 'preference',
    SELLER_CURRENT: 'current',

    defaultCollection: Dealers,
    getStatuses: function () {
        return [
            Seller.STATUS_ACTIVE,
            Seller.STATUS_PENDING,
            Seller.STATUS_SUSPENDED,
            Seller.STATUS_NO_PAY,
            Seller.STATUS_CLOSED,
            Seller.STATUS_INTERNAL
        ];
    },
    /**
     * Initialize an empty seller with the correct data structure:
     */
    _initEmptySeller: function () {
        return new Seller({
            'sellerProfile': {},
            sellerPreferences: {},
            stores: [{}],
            billingProfile: {},
            agreements: {},
            shippingAddress: {},
            payAddress: {},
            billingAddress: {}
        });
    },
    /**
     * @param {Object} attrs
     * @returns {Seller}
     * @private
     */
    _createInstance: function (attrs) {
        return new Seller(attrs);
    },
    /**
     * Returns the current seller singleton.
     * Will instantiate it if an `attrs` hash is passed and there it hasn't been instantiated yet.
     *
     * @param {Object} attrs - An attributes hash to instantiate a new seller singleton
     * @returns {Seller|null}
     */
    getCurrentSellerInit: function (attrs) {
        if (!sellers[Seller.SELLER_CURRENT] && attrs) {
            sellers[Seller.SELLER_CURRENT] = this._createInstance(attrs);
        }
        return sellers[Seller.SELLER_CURRENT];
    },

    CONTEMPORARY_NA: 'NOT_APPLICABLE',
    CONTEMPORARY_GALLERY: 'GALLERY',
    CONTEMPORARY_MAKER: 'MAKER_OR_MANUFACTURER',
    CONTEMPORARY_HYBRID: 'HYBRID',
    getContemporaryTypes: function () {
        return [
            Seller.CONTEMPORARY_NA,
            Seller.CONTEMPORARY_GALLERY,
            Seller.CONTEMPORARY_MAKER,
            Seller.CONTEMPORARY_HYBRID
        ];
    }
});
_.extend(Seller.prototype, SoaModelLabelAndValueTransformer, {
    /**
     * @param {String} url
     * @param {String} email
     * @param {String} password
     * @param {Object} oauth - optional
     * @returns {Promise}
     * @private
     */
    _authenticate: function (url, email, password, oauth) {
        var data = this.toJSON();

        return this.clear().save(null, {
            url: url,
            attrs: {
                email: email,
                password: password,
                oauth: oauth
            }
        }).always(function () {
            this.set(_.extend(data, this.toJSON()));
        }.bind(this));
    },
    /**
     * @param {String} email
     * @param {String} password
     * @param {Object} oauth - optional {clientId, redirectUri, state}
     * @returns {Promise}
     */
    login: function (email, password, oauth) {
        return this._authenticate(endpoints.sellerLogin(), email, password, oauth);
    },
    getLegacyId : legacyId.modelHelper,
    displayLabels: {
        id: 'ID'
    },
    schemas: {
        status: {
            type: 'RadioList',
            options: {
                possibleVals: {
                    active: 'Active',
                    inactive: 'Inactive'
                }
            }
        }
    },
    displayTransforms: {
        agreementStart: function (val) {
            return moment(val).format('l');
        },
        createdDate: function (val) {
            return moment(val).format('l');
        }
    },
    getValuesForDetailDisplayString: function () {
        return {
            vertical: this.getVerticalFromID(),
            profile: this.get('sellerProfile'),
            displayName: this.get('sellerProfile').getDisplayName(),
            id: this.get('id'),
            email: this.get('sellerProfile.email')
        };
    },
    idAttribute: 'id',
    /**
     * Passing all relations
     */
    relations: relations,
    /**view
     * @memberof Seller
     * @returns {string}
     * @returns {string}
     */
    url: function () {
        return endpoints.seller(this.get('id'));
    },

    /**
     * Checks if the seller's vertical included in the updated copy pricing verticals list
     * Important: adding a vertical to the list will effect what the dealer see
     * @returns {boolean}
     */
    hasUpdatedPricing: function () {
        var verticalArr = [
            verticals.VERTICAL_FURNITURE
        ];
        return _.contains(verticalArr, this.getVerticalFromID());
    },

    /**
     * Gets the seller's vertical from their ID (the identity service does not return a vertical...
     * @returns {*}
     */
    getVerticalFromID : function () {
        return verticals.getVertical(this.get('id'));
    },
    isVertical: function (vertical) {
        return this.getVerticalFromID() === vertical;
    },
    /*
     * Functions for identifying seller verticals
     * Maybe one day a seller will be in more than one vertical and these will be usefull
     */
    isFurnitureSeller: function () {
        return this.isVertical('furniture');
    },
    isFashionSeller: function () {
        return this.isVertical('fashion');
    },
    isJewelrySeller: function () {
        return this.isVertical('jewelry');
    },
    isArtSeller: function () {
        return this.isVertical('art');
    },
    isStatusSuspended: function () {
        return this.get('status') === Seller.STATUS_SUSPENDED;
    },
    isStatusClosed: function () {
        return this.get('status') === Seller.STATUS_CLOSED;
    },
    isStatusPending: function () {
        return this.get('status') === Seller.STATUS_PENDING;
    },
    /*
     * Function to identify dealers eligible for negotiations 2.0
     */
    isN2Seller: function () {
        // TODO: remove this check altogether if decision is made to permanently scrap n2
        return false;
        //return this.isFashionSeller();
    },
    registerSeller: function (passedOptions, password, vertical) {
        var def = new $.Deferred().resolve();
        var self = this;
        var options = _.defaults({}, passedOptions, {
            attrs: {
                password: password,
                email: this.get('sellerProfile.email')
            },
            url: endpoints.registerSeller(vertical)
        });
        def = def.then(function () {
            var seller;
            if (self.isNew()) {
                // cloning to prevent setting / overriding the url property
                seller = self.clone();
                return seller.save(null, options).then(function () {
                    self.set({id: seller.id});
                    return self.fetch();
                });
            }
        });

        return def;
    },
    getSellerLocation: function () {
        return this.get('stores[0].region.name');
    },
    /**
     * Creates a shipping model -- filled out with local shipping info - and saves to the seller endpoint so that
     * newly created sellers have a default shipping method for local.
     */
    saveSellerLocalShipping : function (options) {
        var shipmentQuote = ShipmentQuote.createLocalPickupQuote({
            handlingTime: {
                numberOfUnits: 2,
                timeUnit: Period.UNIT_BUSINESS_DAY
            },
            type : ShipmentQuote.TYPE_SELLER_PREFERENCES
        });
        var collection = new SoaCollection();
        var shipmentQuoteModel = new SoaModel({
            dataList: collection
        });

        // annoyingly, the service expects data formatted with " dataList : [{...}] " wrapper to accept shipment
        // quote - so we must wrap our data in both a generic SoaModel AND SoaCollection
        collection.add(shipmentQuote);
        shipmentQuoteModel.url = endpoints.sellerQuote(this.get('id'));
        return shipmentQuoteModel.save(null, options);
    },
    /**
     * When new dealers are created this sets a fake legacy key so that they are not automatically instantiated as 1stdibs paris dealers
     * @param passedOptions
     * @returns {*}
     */
    setFakeLegacyKey : function (passedOptions) {
        var options = _.defaults({}, passedOptions, {
            attrs: {
                legacyKey: 'newdealerstub'
            }
        });
        return this.sync('update', this, options);
    },
    /**
     * This saves a agreementStart via PUT
     * @param passedOptions
     * @returns {*}
     */
    saveSellerAgreement : function (passedOptions) {
        var options = _.defaults({}, passedOptions, {
            attrs : this.pick('agreementStart')
        });
        return this.sync('update', this, options);
    },
    newAccountNote: function (passedOptions) {
        _.defaults(passedOptions, {
            type: Note.TYPE_ADMIN_SELLER_ACCOUNT,
            anchors: [
                {
                    sourceId: this.id,
                    sourceType: 'SELLER'
                }
            ]
        });
        return Notes.newNote(passedOptions);
    },
    addNewAccountNote: function (noteOptions, syncOptions) {
        var note = this.newAccountNote(noteOptions);
        return note.save(null, syncOptions);
    },
    saveAccountManager: function (user, saveOptions) {
        var options = {
            url: endpoints.accountManager(this.get('id'))
        };

        _.extend(options, saveOptions);
        return user.save(null, options);
    },

    saveTwentyFirstCenturyStatus: function (options) {
        var status = new TwentyFirstCenturyStatus({
            id: this.id
        });
        return status.save(null, _.extend({
            contentType: 'application/json',
            data: JSON.stringify(this.get('twentyFirstCenturyStatus'))
        }, options));
    },

    /**
     * Checks whether the seller is a member of the given association.
     * @param {String} association name (aadla, adaa, etc...)
     * @returns {Boolean} True if the seller is a member of the association, false otherwise.
     */
    isMemberOf: function (association) {
        var isMember = false;
        var tradeAssociations = this.get('tradeAssociations');
        if (association === TradeAssociation.NAMES.NYDC) {
            isMember = this.get('associations.nydcStatus') === 'Y';
        } else {
            association = (association || '').toUpperCase();
            isMember = tradeAssociations ? tradeAssociations.isAssociationMember(association) : false;
        }
        return isMember;
    },

    /**
     * Returns all associations to which the seller belongs
     * @returns {String[]}
     */
    getAllAssociations: function () {
        return this.get('tradeAssociations').pluck('name');
    },

    /**
     * Checks whether the seller is a member of the given association and corresponding vertical.
     * @param {String} fn Method on the seller model to call to verify vertical (e.g. ADAA members must be art sellers)
     * @param {String} association
     * @returns {Boolean} True if seller is a member of the specified vertical and association, false otherwise.
     * @private
     */
    _isVerticalRestrictedAssociation: function (fn, association) {
        return this[fn]() && this.isMemberOf(association);
    },

    /**
     * Checks whether the seller is a member of AADLA.
     * @returns {Boolean} True if the seller is a furniture seller and a member of AADLA, false otherwise.
     */
    isAntiquesAssociationMember: function () {
        return this._isVerticalRestrictedAssociation('isFurnitureSeller', TradeAssociation.NAMES.AADLA);
    },

    /**
     * Checks whether the seller is a member of 20th Century Specialists.
     * @returns {Boolean} True if the seller is a furniture seller and a member of 20th Century Specialists, false otherwise.
     */
    is20thCenturySpecialist: function () {
        return this._isVerticalRestrictedAssociation('isFurnitureSeller', TradeAssociation.NAMES.TWCS);
    },

    /**
     * Checks whether the seller is a member of NYDC.
     * @returns {Boolean} True if the seller is a member of NYDC, false otherwise.
     */
    isNYDCMember: function () {
        return this._isVerticalRestrictedAssociation('isFurnitureSeller', TradeAssociation.NAMES.NYDC);
    },

    /**
     * Checks whether the seller is a member of ADAA (Art Dealers Association of America).
     * @returns {Boolean} True if the seller is an art seller and a member of ADAA, false otherwise.
     */
    isArtDealersAssociationMember: function () {
        return this._isVerticalRestrictedAssociation('isArtSeller', TradeAssociation.NAMES.ADAA);
    },

    /**
     * Checks whether the seller is a member of AIPAD (Association of International Photography Art Dealers).
     * @returns {Boolean} True if the seller is an art seller and a member of AIPAD, false otherwise.
     */
    isAIPADMember: function () {
        return this._isVerticalRestrictedAssociation('isArtSeller', TradeAssociation.NAMES.AIPAD);
    },
    isDistinguished: function () {
        return this.get('score.distinguishedStatus') === 'DISTINGUISHED';
    },

    /**
     * Returns the antiques association (AADLA) league that the seller belongs to.
     * @returns {String} The AADLA league name.
     */
    getAntiquesAssociationLeague: function () {
        return this.get('tradeAssociations').getAntiquesAssociationLeague();
    },

    /**
     * Checks if seller is a seller in this country.
     * @param {String} countryCode - ISO two char country code
     * @return {Boolean}
     */
    isFromCountry: function (countryCode) {
        return this.get('shippingAddress.country') === countryCode;
    },

    /**
     * Checks if seller is in US
     * @return {Boolean}
     */
    isUSSeller: function () {
        return this.isFromCountry('US');
    },

    /**
     * Checks if seller is on whitelist
     * @param {String} listName - Anchor list name
     * @returns {Boolean}
     */
    isOnWhiteList: function (listType, listName) {
        return this.get('anchorLists') &&
            _(this.get('anchorLists').getListNames(listType)).contains(listName);
    },

    /**
     * Checks if seller is affected by aug 2015 policy changes
     * @return {Boolean}
     */
    isPostAug2015Policy: function () {
        return this.get('anchorLists') &&
            _(this.get('anchorLists').getPolicyNames(false)).contains(AnchorLists.listNames.OPOP);
    },

    /**
     * Performs a request to see if user is on OPOP
     * @return {Promise}
     */
    isOnNewPolicy: function () {
        var anchorLists = new AnchorLists();
        return anchorLists.fetchListForSellerPolicy(this.id).then(function (data) {
            if (data.result.length) {
                return !!_.findWhere(data.result, {name: AnchorLists.listNames.OPOP});
            }
        });
    },

    /**
     * Returns the default return policy.  If undefined, there is no default return policy.
     * @return {Model|null} default policy if found, undefined if not found
     */
    getDefaultReturnPolicy: function () {
        var policy;
        var policies = this.get('returnPolicies');
        if (policies) {
            policy = policies.find(function (p) {
                return p.isDefault();
            });
        }
        return policy;
    },

    /**
     * Returns the fee structures (by id) that can be set for this seller.
     * @param {integer} options.currentFeeStructureId - If editing fee structure, take current id into account
     * @returns {Array|String}
     */
    getFeeStructureOptions: function (options) {
        var currentFeeStructureId;
        var values = [];
        var feeStructureKey;
        options = options || {};
        currentFeeStructureId = options.currentFeeStructureId;

        if (this.get('vertical') === verticals.VERTICAL_FURNITURE) {
            // for furniture seller, options are all flat rate options
            for (feeStructureKey in FeeStructure.feeStructureIds) {
                if (FeeStructure.feeStructureIds.hasOwnProperty(feeStructureKey)) {
                    if (feeStructureKey.startsWith('FLAT_RATE')) {
                        values.push(FeeStructure.feeStructureIds[feeStructureKey]);
                    }
                }
            }

            // if seller already has a fee structure id and it is not one of the regular furniture options,
            // add as first option
            if (currentFeeStructureId && values.indexOf(currentFeeStructureId) === -1) {
                values.unshift(currentFeeStructureId);
            }
        } else {
            // cannot edit fee structure for these verticals, so just return id if one exists
            // otherwise, return default value as single option
            values.push(currentFeeStructureId ? currentFeeStructureId : this.getDefaultFeeStructure());
        }

        return values;
    },

    /**
     * Returns default fee structure for seller. Is TIERED for North American Art sellers, FLAT_RATE_10 for others.
     * @returns {string}
     */
    getDefaultFeeStructure: function () {
        var isNorthAmericanArt = (this.get('vertical') === verticals.VERTICAL_ART && this.get('stores[0].continent.id') === 1);
        return isNorthAmericanArt ? FeeStructure.feeStructureIds.TIERED : FeeStructure.feeStructureIds.FLAT_RATE_10;
    },

    /**
     * Return call to get fee structures for a seller.
     * @returns {Promise}
     */
    getFeeStructures: function () {
        var feeStructures = new FeeStructures();
        var data = {anchors: 'SELLER-' + this.get('id')};
        return Promise.resolve(feeStructures.fetch({data: data})).then(function () {
            return feeStructures;
        });
    },

    /**
     * Checks if seller's payout account status is pre_activated (registered)
     * @returns {boolean}
     */
    isPayoutRegistered: function () {
        return this.get('paymentProfile.status') === 'PRE_ACTIVATED';
    },

    /**
     * Checks if seller's payout account status is activated
     * @returns {boolean}
     */
    isPayoutActivated: function () {
        return this.get('paymentProfile.status') === 'ACTIVATED';
    },

    /**
     * Gets seller's payout account activation code
     * @returns {boolean}
     */
    getPayoutActivationCode: function () {
        return this.get('paymentProfile.activationCode') || '';
    }


}, fetchRelationMixin);

// Static method to retrieve singleton seller
Seller.getCurrentSeller = function () {
    if (!Seller._currentSeller && dataProvider.get('sellerData')) {
        Seller._currentSeller = new Seller(dataProvider.get('sellerData'));
    }
    return Seller._currentSeller;
};

// Static method to send DELETE request to endpoint that sends password reset email
Seller.forgotPassword = function (email, vertical) {
    var SellerPasswordModel = SoaModel.extend({
        url: endpoints.sellerPassword(vertical, {email: encodeURIComponent(email)})
    });
    var model = new SellerPasswordModel();

    return model.sync('delete', model);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var assign = __webpack_require__(2670);
module.exports = function (left, right) {
    var composed;
    left = left || {};
    right = right || {};
    composed = assign({}, left);
    Object.keys(right).forEach(function (name) {
        composed[name] = (composed[name] ? composed[name] + ' ' : '') + right[name];
    });
    return composed;
};


/***/ }),
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by: Lior Elrom
 * Date: 1/15/16
 * Time: 11:42 AM
 */



var PAGES = {
    PAGE_ACCOUNT: 'account',
    PAGE_CHECKOUT: 'checkout',
    PAGE_BALANCE_DUE: 'balanceDue',
    PAGE_CONFIRMATION: 'confirmation'
};

var PANES = {
    PANE_OFFER: 'offer',
    PANE_SIDEMARK: 'sidemark',
    PANE_SHIPPING: 'shipping',
    PANE_DELIVERY: 'delivery',
    PANE_PAYMENT: 'payment',
    PANE_REVIEW: 'review',
    PANE_SUMMARY: 'summary'
};

var STEPS = {
    STEP_SHIPPING: 'shipping',
    STEP_DELIVERY: 'delivery',
    STEP_PAYMENT: 'payment',
    STEP_REVIEW: 'review'
};

var STATES = {
    STATE_NEW: 'new',
    STATE_EDIT: 'edit',
    STATE_SAVED: 'saved',
    STATE_VERIFY: 'verify'
};

var TABS = {
    TAB_CREDIT_CARD: 'creditCard',
    TAB_PAYPAL_ACCOUNT: 'payPalAccount',
    TAB_WIRE_TRANSFER: 'wireTransfer',
    TAB_CHECK: 'check',
    TAB_APPLE_PAY: 'applePay'
};

var ACTIONS = {
    ACTION_EDIT: 'edit',
    ACTION_DELETE: 'delete',
    ACTION_CANCEL: 'cancel'
};

var MODELS = {
    MODEL_ADDRESS: 'address',
    MODEL_CARD: 'creditCard'
};

var METHODS = {
    METHOD_CREDIT_CARD: 'creditCard',
    METHOD_PAYPAL_ACCOUNT: 'payPalAccount',
    METHOD_WIRE_TRANSFER: 'wireTransfer',
    METHOD_CHECK: 'check',
    METHOD_APPLE_PAY: 'applePay'
};

var PAYMENTS = {
    TYPE_CREDIT_CARD: 'CreditCard',
    TYPE_PAYPAL_ACCOUNT: 'PayPalAccount',
    TYPE_WIRE_TRANSFER: 'WireTransfer',
    TYPE_CHECK: 'Check',
    TYPE_APPLE_PAY: 'ApplePay'
};

var VARS = {
    RESERVE_AMOUNT: 1,
    MAX_APP_AD_VIEWS: 3,
    MAX_ITEM_PRE_QUOTES: 2,
    MAX_PAYPAL_AMOUNT: 55000,
    MAX_WIRE_AMOUNT: 5000,
    MAX_RETURN_AMOUNT: 35000,
    ALLOW_CUSTOM_QUOTE: 10000,
    MAX_NOTE_LENGTH: 256,
    MAX_SIDEMARK_ERROR: 35,
    ZOOM_MOBILE_GUTTER: '5%',
    ZOOM_DESKTOP_GUTTER: '12%',
    SAVED_SCROLL_OFFSET: -16,
    STORAGE_PREFIX: 'trans_',
    COUNTRIES_NEEDS_ARTICLE: ['US', 'UK', 'GB', 'NL']
};

var CHAT = {
    FULL_PRICE: 'fullPrice',
    NEGOTIATED: 'negotiated',
    PRIVATE_OFFER: 'privateOffer',
    RETAIL: 'listPrice',
    WEEKLY_SALE: 'saturdaySale',
    NET: 'netPrice',
    BUYER_ID: 'buyerId',
    ITEM_PK: 'itemPk',
    DEALER_TRACKED_PHONE: 'dealerTrackedPhone',
    DEALER_UNTRACKED_PHONE: 'dealerUntrackedPhone',
    DEALER_NO_PHONE: 'dealerNoPhone',
    PREQUOTE_AVAILABLE: 'prequote_available',
    QUOTE_NEEDED: 'shippingQuoteNeeded'
};

var ERRORS = {
    ERROR_401: 401,
    ERROR_409: 409,
    ERROR_412: 412,
    ERROR_500: 500,
    ERROR_USER_EXISTS: 'USER_EXISTS',
    ERROR_VAULT: 'VAULT',
    ERROR_DENIED: 'DENIED',
    ERROR_EXPIRED: 'EXPIRED',
    ERROR_USER_CHANGED: 'USER_CHANGED',
    ERROR_ITEM_NOT_AVAILABLE: 'ITEM_NOT_AVAILABLE',
    ERROR_ITEM_QUANTITY_NOT_AVAILABLE: 'ITEM_QUANTITY_NOT_AVAILABLE'
};

module.exports = {
    PAGES: PAGES,
    PANES: PANES,
    STEPS: STEPS,
    STATES: STATES,
    TABS: TABS,
    ACTIONS: ACTIONS,
    MODELS: MODELS,
    METHODS: METHODS,
    PAYMENTS: PAYMENTS,
    VARS: VARS,
    CHAT: CHAT,
    ERRORS: ERRORS
};

/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by daletan on 7/6/16.
 */



var _reducers;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var loginActions = __webpack_require__(659);
var currencyActionConstants = __webpack_require__(291);

var UserStore = {
    storeName: 'UserStore',
    initialState: {
        isLoggedIn: false,
        canRequestNetPrice: false,
        fullProfile: null,
        currency: 'USD',
        isCurrencyLoaded: false,
        tradeSalesRep: null
    },
    reducers: (_reducers = {}, _defineProperty(_reducers, loginActions.ACTION_NET_PRICE, function (state, _ref) {
        var userCanRequestNetPrice = _ref.userCanRequestNetPrice;

        return Object.assign({}, state, {
            canRequestNetPrice: userCanRequestNetPrice
        });
    }), _defineProperty(_reducers, loginActions.ACTION_FULL_PROFILE, function (state, _ref2) {
        var profile = _ref2.profile;

        profile = profile || {};
        return Object.assign({}, state, {
            // convert the model to a json object so the backbone model is not stored
            fullProfile: typeof profile.toJSON === 'function' ? profile.toJSON() : profile,
            isLoggedIn: true
        });
    }), _defineProperty(_reducers, loginActions.ACTION_LOGGED_OUT_USER, function (state, _ref3) {
        var profile = _ref3.profile;

        profile = profile || {};
        return Object.assign({}, state, {
            // convert the model to a json object so the backbone model is not stored
            fullProfile: typeof profile.toJSON === 'function' ? profile.toJSON() : profile,
            isLoggedIn: false
        });
    }), _defineProperty(_reducers, loginActions.ACTION_TRADE_SALES_REP, function (state, _ref4) {
        var tradeSalesRep = _ref4.tradeSalesRep;

        return Object.assign({}, state, { tradeSalesRep: tradeSalesRep });
    }), _defineProperty(_reducers, loginActions.ACTION_VIP_SALES_REP, function (state, _ref5) {
        var vipSalesRep = _ref5.vipSalesRep;

        return Object.assign({}, state, { vipSalesRep: vipSalesRep });
    }), _defineProperty(_reducers, currencyActionConstants.CURRENCY_CHANGED, function (state, _ref6) {
        var currency = _ref6.currency;

        return Object.assign({}, state, {
            currency: currency,
            isCurrencyLoaded: true
        });
    }), _reducers),
    getters: {
        getNetPriceStatus: function getNetPriceStatus(state) {
            return state.canRequestNetPrice;
        },
        getFullProfile: function getFullProfile(state) {
            return state.fullProfile;
        },
        getCurrency: function getCurrency(state) {
            return state.currency;
        },
        isCurrencyLoaded: function isCurrencyLoaded(state) {
            return state.isCurrencyLoaded;
        },
        getTradeSalesRep: function getTradeSalesRep(state) {
            return state.tradeSalesRep;
        },
        getVipSalesRep: function getVipSalesRep(state) {
            return state.vipSalesRep;
        }
    }
};

module.exports = UserStore;

/***/ }),
/* 115 */,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 6/6/14
 * Time: 11:37 AM
 */



var SoaModel = __webpack_require__(2);
var Period = module.exports = SoaModel.extend();

var _ = __webpack_require__(0);

var unitDisplayVals = {};

_.extend(Period, {
    UNIT_SECOND: 'SECOND',
    UNIT_MINUTE: 'MINUTE',
    UNIT_DAY: 'DAY',
    UNIT_BUSINESS_DAY: 'BUSINESS_DAY',
    UNIT_WEEK: 'WEEK',
    UNIT_MONTH: 'MONTH',
    UNIT_YEAR: 'YEAR',
    unitDisplayVals: unitDisplayVals,
    MONTHS_IN_QUARTER: 3
});

unitDisplayVals[Period.UNIT_SECOND] = {
    one: 'second',
    many: 'seconds'
};
unitDisplayVals[Period.UNIT_MINUTE] = {
    one: 'minute',
    many: 'minutes'
};
unitDisplayVals[Period.UNIT_DAY] = {
    one: 'day',
    many: 'days'
};
unitDisplayVals[Period.UNIT_BUSINESS_DAY] = {
    one: 'business day',
    many: 'business days'
};
unitDisplayVals[Period.UNIT_WEEK] = {
    one: 'week',
    many: 'weeks'
};
unitDisplayVals[Period.UNIT_MONTH] = {
    one: 'month',
    many: 'months'
};
unitDisplayVals[Period.UNIT_YEAR] = {
    one: 'year',
    many: 'years'
};

_.extend(Period.prototype, {
    getInDays: function () {
        // TODO make work with units other than days and weeks
        var days = parseInt(this.get('numberOfUnits'), 10) || 0;
        if (this.get('timeUnit') === Period.UNIT_WEEK) {
            days *= 7;
        }
        return days;
    },
    getDisplayUnit: function () {
        var displayVals = Period.unitDisplayVals[this.get('timeUnit')];
        if (this.get('numberOfUnits') === 1) {
            return displayVals && displayVals.one;
        }

        return displayVals && displayVals.many;
    },
    getDisplayVal: function () {
        var num = this.get('numberOfUnits');
        if (_.isNumber(num)) {
            return this.get('numberOfUnits') + ' ' + this.getDisplayUnit();
        } else {
            return '';
        }
    },
    isQuarter: function () {
        var num = this.get('numberOfUnits');
        return parseInt(num, 10) === Period.MONTHS_IN_QUARTER;
    }
});


/***/ }),
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaCollection = __webpack_require__(9);
var AnchorList = __webpack_require__(336);
var endpoints = __webpack_require__(6);
var assert = __webpack_require__(31);
var _ = __webpack_require__(0);
var constants = {
    listTypes: {
        SELLER_POLICY: 'SELLER_POLICY',
        SELLER_WHITELIST: 'SELLER_WHITELIST'
    },

    listNames: {
        PRE_AUG_2015: 'PRE_AUG_2015',
        OPOP: 'OPOP',
        LISTING_CREDIT_WHITELIST: 'LISTING_CREDIT_WHITELIST'
    },

    listDisplayNames : {
        PRE_AUG_2015: 'Original 1stdibs policy',
        OPOP: 'OPOP'
    }
};

module.exports = SoaCollection.extend({
    url: endpoints.anchorLists,
    model: AnchorList,

    /**
     * Fetches anchor list models for a given seller, list type and name. For example, use this method to search for
     * anchor lists that associate sellers to policies.
     * @param sellerId - ID of seller you are searching for.
         * @param listName - the name of the list searched for. eg. SELLER_POLICY list has "PRE_AUG_2015"
     * @param listType - constant value for the fetched list type. eg. SELLER_POLICY
     * @returns {*}
     */
    fetchSellerOnList: function (sellerId, listName, listType) {
        assert(listType, 'list type is required to use this method');
        assert(listName, 'list name is required to use this method');
        return this._drySellerFetch(sellerId, listType, listName);
    },

    /**
     * Fetch anchor list models for a given seller to dealer policies. Fetches all anchor lists between a seller any
     * seller policies that seller is anchored to. Useful for figuring out which seller policy a seller has.
     * @param sellerId - <string> seller ID
     * @param fetchOptions - BB options to be passed to fetch() method.
     * @returns {*}
     */
    fetchListForSellerPolicy : function (sellerId, fetchOptions) {
        return this._drySellerFetch(sellerId, constants.listTypes.SELLER_POLICY, null, fetchOptions);
    },

    _drySellerFetch : function (sellerId, listType, listName, fetchOptions) {
        assert(sellerId, 'seller ID is required to use this method');
        var data = { anchors: 'SELLER-' + sellerId };
        if (listType) {
            data.listTypes = listType;
        }
        if (listName) {
            data.listNames = listName;
        }
        return this.fetch(_.extend(fetchOptions || {}, { data: data }));
    },

    /**
     * Gets an array of all the policy names contained in this anchor list ... list. Pass getDisplayNames as true if
     * you want the display name instad of the list name code.
     * @param getDisplayNames - <bool> - true if you want display names, else code will be returned.
     * @returns {*}
     */
    getPolicyNames : function (getDisplayNames) {
        return this.where({type : constants.listTypes.SELLER_POLICY}).map(function (model) {
            var name = model.get('name');
            return getDisplayNames ? constants.listDisplayNames[name] : name;
        });
    },

    /**
     * Gets an array of list names contained in specified anchor list type
     * @param {String} listType
     */
    getListNames: function (listType) {
        return this.where({type : listType}).map(function (model) {
            return model.get('name');
        });
    }

}, constants);


/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * A specialized version of `baseCallback` which only supports `this` binding
 * and specifying the number of arguments to provide to `func`.
 *
 * @private
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */
function bindCallback(func, thisArg, argCount) {
  if (typeof func != 'function') {
    return identity;
  }
  if (thisArg === undefined) {
    return func;
  }
  switch (argCount) {
    case 1: return function(value) {
      return func.call(thisArg, value);
    };
    case 3: return function(value, index, collection) {
      return func.call(thisArg, value, index, collection);
    };
    case 4: return function(accumulator, value, index, collection) {
      return func.call(thisArg, accumulator, value, index, collection);
    };
    case 5: return function(value, other, key, object, source) {
      return func.call(thisArg, value, other, key, object, source);
    };
  }
  return function() {
    return func.apply(thisArg, arguments);
  };
}

/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = bindCallback;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var SoaCollection = __webpack_require__(9);
var endpoints = __webpack_require__(6);
var PortfolioItem = __webpack_require__(294);

module.exports = SoaCollection.extend({

    model: PortfolioItem,

    url: function () {
        return endpoints.portfolioItemsByPortfolio(this.options.portfolioId);
    },

    initialize: function (models, options) {
        this.options = options || {};
        this.resetParams();
    },

    parse: function (data) {
        if (!data.result || !data.result.portfolio || !_.isArray(data.result.portfolio.items)) {
            return null;
        }
        if (_.isNumber(data.totalResults)) {
            this.totalResults = data.totalResults;
        }
        return data.result.portfolio.items;
    },

    sortById: function (idArray) {
        return this.reset(_.map(idArray, function (id) {
            return this.get(id);
        }, this));
    },

    saveSort: function () {
        var saveData = { items: [] };

        // create data structure
        this.each(function (portfolioItem) {
            var item = portfolioItem.get('item');
            saveData.items.push({
                id: portfolioItem.id,
                item: {
                    id: item.get('id'),
                    vertical: item.get('vertical'),
                    apiType: item.get('vertical') + 'Item'
                }
            });
        });

        // save to service
        return this.sync('update', this, {
            url: endpoints.portfolioSort(this.options.portfolioId),
            contentType: 'application/json',
            data: JSON.stringify(saveData)
        });
    }
});


/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * The base implementation of `baseForIn` and `baseForOwn` which iterates
 * over `object` properties returned by `keysFunc` invoking `iteratee` for
 * each property. Iteratee functions may exit iteration early by explicitly
 * returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * Creates a base function for methods like `_.forIn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = baseFor;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var bunsen = __webpack_require__(21);
var SolrCollection = __webpack_require__(1215);
var fetchDiscrete = __webpack_require__(2042);
var Items = module.exports = bunsen.Items = SolrCollection.extend({}, fetchDiscrete);
var Item = __webpack_require__(34);
var Clump = __webpack_require__(23);
var verticals = __webpack_require__(416);
var endpoints = __webpack_require__(6);
var ConversionCalculation = __webpack_require__(1464);
var CurrencyConversion = __webpack_require__(2045);

// bunsen.Items
var solrItemsURI = endpoints.solrItems();
_.extend(Items.prototype, {

    model: Item, // bunsen.Item,

    url: function () {
        if (!this._discreteIds) {
            return solrItemsURI;
        }
        return solrItemsURI + 's?' + $.param({itemId : this._discreteIds.join(',')});
    },

    initialize: function () {
        this.resetParams();
        return this;
    },

    parse: function (data) {
        var keys;
        data = SolrCollection.prototype.parse.call(this, data);
        // strip out toplevel key. e.g. FurnitureItem, FashionItem
        _.each(data, function (item, index) {
            keys = _.keys(item);
            if (keys.length === 1) {
                item = item[keys[0]];
                data[index] = item;
                // TODO : Here we add the api type (ie. "futnitureItem" or "fashionItem" as the apiType property to item JSON.
                // TODO : This is a work-around for the SOLR inventory endpoint not returning the correct apiType
                // TODO : Please remove this temporary work-around in the future as per GOODS-1139
                if (_.isUndefined(data[index].apiType)) {
                    data[index].apiType = keys[0];
                }
            }
        });
        return data;
    },

    /**
     * Saves all items in the collection
     * @param options - jquery options
     * @param saveFunction - optional.  This is part of the vertical retry hack, otherwise it should be removed
     * @returns {*}
     */
    saveAll: function (options, saveFunction) {
        var promise = $.Deferred();
        var clump = new Clump();
        var failedItems = new Items();
        var retryVerticals = new RegExp(verticals.VERTICAL_JEWELRY + '|' + verticals.VERTICAL_FASHION);
        this.each(function (item) {
            var save = saveFunction || item.save;
            save.call(item, null, $.extend({ clump: clump }, options)).fail(function (jqXHR) {
                if (jqXHR.status === 500 && retryVerticals.test(item.get('vertical'))) {
                    failedItems.add(item);
                }
            });
        });

        this._saveAllVerticalHack(clump, failedItems, promise, options, saveFunction);

        return promise;
    },

    /**
     * TODO !!!!!!!!!! Delete the following function all of it's uses once the BE team fixes verticals in SOLR inventory
     * TODO !!!!!!!!!! This code was placed here as a temporary work-around and must be removed as per ticket :
     * https://1stdibs.atlassian.net/browse/GOODS-806
     */
    _saveAllVerticalHack: function (clump, failedItems, promise, options, saveFunction) {
        clump.run({ mode: 'SYNC_PARALLEL' }).then(function (jXHR) {
            var clump;
            if (failedItems.length) {
                clump = new Clump();
                failedItems.each(function (model) {
                    var prevVertical = model.get('vertical');
                    var save = saveFunction || model.save;
                    model.set('vertical', prevVertical === verticals.VERTICAL_FASHION ? verticals.VERTICAL_JEWELRY : verticals.VERTICAL_FASHION);
                    model.set('apiType', model.get('vertical') + 'Item');
                    save.call(model, null, $.extend({ clump: clump }, options));
                    model.set('vertical', prevVertical);
                    model.set('apiType', prevVertical + 'Item');
                });
                clump.run({ mode: 'SYNC_PARALLEL' }).then(function (jXHR) {
                    promise.resolve(jXHR);
                }).fail(function (jXHR) {
                    promise.reject(jXHR);
                });
            }
            else {
                promise.resolve(jXHR);
            }
        }).fail(function (jXHR) {
            promise.reject(jXHR);
        });
    },

    saveAllItemsWithPublishOptions: function (publishOptions, options) {
        this.each(function (item) {
            item.setPublishingOptions(publishOptions);
        });
        return this.saveAll($.extend({patch: true}, options));
    },

    convertToUsd: function () {
        var self = this;
        var dfd = new $.Deferred();
        var conversions = [];
        var calculation = new ConversionCalculation(); // bunsen.ConversionCalculation();

        // find items that need to be converted
        self.each(function (item) {
            if (item.getCurrency() !== 'USD' && !item.hidePrice()) {
                conversions.push(new CurrencyConversion({
                    label: item.get('id'),
                    fromCurrency: item.getCurrency(),
                    toCurrency: 'USD',
                    fromAmount: item.getPrice(),
                    toAmount: null
                }));
            }
        });

        // run conversions
        if (conversions.length) {
            calculation.set('conversions', conversions);
            calculation.save().then(function () {

                // update items
                calculation.get('conversions').each(function (conversion) {
                    var item = self.get(conversion.get('label'));
                    item.get('pricing').currency = conversion.get('toCurrency');
                    item.get('pricing').amount = conversion.get('toAmount');
                });
                dfd.resolve();

                // currency conversion failed
            }, function () {
                dfd.reject();
            });

            // no conversions to run, all prices in usd or empty collection
        } else {
            dfd.resolve();
        }

        return dfd.promise();
    }
});


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Shad
 * Date: 9/4/13
 */


var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);
var root = typeof window === 'undefined' ? global : window;
var Adjustment;
root.bunsen = root.bunsen || {};

Adjustment = module.exports = root.bunsen.Adjustment = SoaModel.extend({
    constructor: function (data, options) {
        // These are down here because of circular dependencies
        var FlatAdjustment = __webpack_require__(2639);
        var PercentAdjustment = __webpack_require__(2048);
        // Adjustment has different relations based on the api type
        if (data.apiType === Adjustment.APITYPE_FLAT) {
            return new FlatAdjustment(data, options);
        }
        return new PercentAdjustment(data, options);
    }
});

_.extend(Adjustment, {
    REFERENCE_MERCHANDISE_TAX: 'MERCHANDISE_TAX',
    REFERENCE_SHIPPING_TAX: 'SHIPPING_TAX',
    REFERENCE_COMMISSION: 'COMMISSION',
    REFERENCE_PAYMENT_PROCESSING_FEE: 'PAYMENT_PROCESSING_FEE',
    REFERENCE_LISTING_CREDIT: 'LISTING_CREDIT',
    REFERENCE_FIRSTDIBS_PROMOTION_OFFER_DISCOUNT: 'FIRSTDIBS_PROMOTION_OFFER_DISCOUNT',
    REFERENCE_COMPLIMENTARY_SHIPPING: 'COMPLIMENTARY_SHIPPING',
    REFERENCE_DEALER_CHARGE: 'DEALER_CHARGE',
    PROPERTY_RELEASE_DATE: 'releaseDate',
    PROPERTY_STARTING_DATE: 'creditStartingDate',
    PROPERTY_CREDIT_PERIOD: 'creditPeriod.timeUnit',
    PROPERTY_NUMBER_OF_UNITS: 'creditPeriod.numberOfUnits',
    PROPERTY_ELIGIBLE_CREDIT_PERIOD: 'eligibleCreditPeriod.numberOfUnits',
    APITYPE_PERCENT: 'percentAdjustmentRate',
    APITYPE_FLAT: 'flatAdjustmentRate'
});

// more to come
Adjustment.promotionReferences = [
    Adjustment.REFERENCE_FIRSTDIBS_PROMOTION_OFFER_DISCOUNT
];

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


module.exports = {
    batchedUpdatePlugin: __webpack_require__(3223),
    connectToStores: __webpack_require__(289),
    createElementWithContext: __webpack_require__(3224),
    FluxibleComponent: __webpack_require__(2121),
    FluxibleMixin: __webpack_require__(3222),
    provideContext: __webpack_require__(287)
};


/***/ }),
/* 136 */,
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: hella
 * Date: 4/6/14
 * Time: 1:15 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 *
 * formerly:
 * js/global/core/dibs.js#baseDomain
 * js/global/core/dibs.js#parseUri
 * js/global/core/dibs.js#URL
 * dibs.baseDomain
 * dibs.parseUri
 * dibs.URL
 */


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var http = __webpack_require__(3831);
var qs = __webpack_require__(42);

/**
 * @param {string} url
 * @private
 */
function throwError(url) {
    throw new Error('options.url required. `' + url + '` with typeof `' + (typeof url === 'undefined' ? 'undefined' : _typeof(url)) + '` was passed in');
}

/**
 * Returns a query param stripped of delimiters.
 * @private
 * @returns {*}
 */
function stripDelimiters(param) {
    var delimiters = /[\+-]/g;
    var replacement = ' ';
    return param.replace(delimiters, replacement);
}

/**
 * Parse the url path into an array
 * @param {string} path
 * @private
 * @returns {Array}
 */
function parsePathSegments(path) {
    var segments = path.split('/');
    while (segments.indexOf('') !== -1) {
        segments.splice(segments.indexOf(''), 1);
    }
    return segments;
}

/**
 * Remove any blacklisted params
 * @param {object} queryParams Key/value pairs of query params
 * @param {Array} blacklistParams Array of query params to remove
 * @private
 */
function removeRestrictedParams(queryParams, blacklistParams) {
    // do not modify original object
    var params = Object.assign({}, queryParams);
    Object.keys(params).forEach(function (param) {
        // if the param is in the blacklist,
        // delete it from the params object
        if (Array.isArray(blacklistParams) && blacklistParams.indexOf(param) > -1) {
            delete params[param];
        }
    });
    return exports.buildQueryString(params);
}

/**
 * Create a clean url that can be used as a value of a query parameter
 * ie. /?modal=login&redirect=%2ffavorites%2fitems%2f
 * @param {object} options
 * @param {string} options.url The url to base everything off of
 * @param {Array} [options.blacklistParams] Array of blacklisted query params to remove
 * @covers removeRestrictedParams
 * @covers throwError
 * @returns {string}
 */
exports.createCleanUrl = function (options) {
    options = options || {};
    var url = options.url;
    if (!url || typeof url !== 'string') {
        throwError(url);
    }

    var blacklist = options.blacklistParams || [];
    var urlParts = exports.parseUri(url);
    var queryString = urlParts.queryKey;
    var cleanQueryString = removeRestrictedParams(queryString, blacklist);

    var toPush = [urlParts.protocol ? urlParts.protocol + '://' : '',
    // only add `host` if `protocol` is present
    urlParts.protocol ? urlParts.host : '', urlParts.path, cleanQueryString];
    var parts = toPush.reduce(function (accum, value) {
        if (value) {
            accum.push(value);
        }
        return accum;
    }, []);

    return parts.join('');
};

/**
 *
 * @param {string} str The url to parse
 * @param {object} [parseOptions] Options to parse the url parts against
 * @param {boolean} [parseOptions.mode="loose"] Regex to use when parsing the url
 * @param {boolean} [parseOptions.decode=false] Decode the query param value
 * @covers stripDelimiters
 * @covers parsePathSegments
 * @returns {{}} Returns an object of properties in the `options.key` property
 */
exports.parseUri = function parseUri(str, parseOptions) {
    parseOptions = parseOptions || {};
    var uri = {};
    var options = {
        key: ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"],
        q: {
            name: "queryKey",
            parser: /(?:^|&)([^&=]*)=?([^&]*)/g
        },
        parser: {
            strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
            loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
        }
    };
    var m = options.parser[parseOptions.mode || 'loose'].exec(str);
    var i = options.key.length;

    while (i--) {
        uri[options.key[i]] = m[i] || "";
    }

    uri[options.q.name] = {};
    // options.key[12] = options.key['query']
    //
    /**
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#Specifying_a_function_as_a_parameter
     * @param {string} $0 is the substring match for that iteration
     * @param {string} $1 is the 1st capturing group (the param name)
     * @param {string} $2 is the second group (the param value)
     */
    uri[options.key[12]].replace(options.q.parser, function ($0, $1, $2) {
        var params = uri[options.q.name];
        var newVal = parseOptions.decode ? decodeURIComponent($2) : $2;

        if (parseOptions.stripDelimiters) {
            newVal = stripDelimiters(newVal);
        }

        if ($1) {
            // store values as arrays so that the same param can be used to specify multiple values
            if (parseOptions.toArrays) {
                // if there is already a value, make sure it's an array
                if (params.hasOwnProperty($1)) {
                    if (!Array.isArray(params[$1])) {
                        params[$1] = [params[$1]];
                    }

                    // add new value
                    params[$1].push(newVal);
                } else {
                    params[$1] = newVal; // no value yet, set as single value
                }
            } else {
                params[$1] = newVal; // otherwise just set value, even if overriding previous value
            }
        }
    });

    uri.pathSegments = parsePathSegments(uri.path);

    return uri;
};

/**
 * Returns you a query string from params set.
 * @param {object} params
 * @returns {string} Either the query param string with `?` prepend or an empty string
 */
exports.buildQueryString = function (params) {
    var result = [];
    Object.keys(params).forEach(function (key) {
        var vals = params[key];
        if (Array.isArray(vals)) {
            // do not reassign `result` here
            vals.reduce(function (accum, val) {
                accum.push(key + '=' + encodeURIComponent(val));
                // can't return while doing push otherwise
                // returns numbers, not the array
                return accum;
            }, result);
        } else if (typeof vals !== 'undefined') {
            // just a single value, add to url
            result.push(key + '=' + encodeURIComponent(vals));
        }
    });

    return result.length ? '?' + result.join('&') : '';
};

// make the parsed URL of the current page available on the global dibs namespace
// handy to have around
exports.URL = exports.parseUri(global.location);

/**
 * use http#redirect
 * @deprecated
 */
exports.redirect = function (options) {
    console.warn('this method is deprecated. use http#redirect instead');
    http.redirect(options);
};

/**
 * Returns you a url with specified query params removed
 * @param {string} url is the full url with query params
 * @param {array|string} paramKeysToRemove is an array or string of query param keys to be removed from url
 * @returns {string} new url
 */
exports.removeQueryParams = function (url, paramKeysToRemove) {
    var urlSplit = url.split('?');
    var basePath = urlSplit[0];
    var queryString = urlSplit[1];
    var qsObject = qs.parse(queryString);

    if (!Array.isArray(paramKeysToRemove)) {
        paramKeysToRemove = [paramKeysToRemove];
    }

    paramKeysToRemove.forEach(function (paramKey) {
        return qsObject[paramKey] = undefined;
    });
    var qsString = qs.stringify(qsObject, { encode: false });

    return qsString ? basePath.concat('?', qsString) : basePath;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _authModalLoader;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(39);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRelay = __webpack_require__(17);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _yaDeferred = __webpack_require__(2307);

var _yaDeferred2 = _interopRequireDefault(_yaDeferred);

var _constants = __webpack_require__(555);

var constants = _interopRequireWildcard(_constants);

var _lodash = __webpack_require__(14);

var _lodash2 = _interopRequireDefault(_lodash);

var _User = __webpack_require__(15);

var _User2 = _interopRequireDefault(_User);

var _relayClientNetworkLayer = __webpack_require__(743);

var _relayClientNetworkLayer2 = _interopRequireDefault(_relayClientNetworkLayer);

__webpack_require__(2116);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var relayEnvironment = new _reactRelay2.default.Environment();
relayEnvironment.injectNetworkLayer((0, _relayClientNetworkLayer2.default)());

var Auth = void 0;
var wrapperElement = void 0;

function getWrapperElement() {
    if (!wrapperElement) {
        wrapperElement = document.createElement('div');
        wrapperElement.classList.add('authModalContainer');
        document.body.appendChild(wrapperElement);
    }
    return wrapperElement;
};

var authModalLoader = (_authModalLoader = {
    _onLoaded: (0, _yaDeferred2.default)(),
    /**
     * Splits the AuthModal to a separate chunk during build time. Loads the authModal when called.
     * For now there's no way to handle errors. Should be possible when we switch to webpack 2.
     * This is mostly an espace hatch if you need direct access to the authModal instance.
     *
     * @example
     * authModalLoader.load().then(AuthModal => DO STUFF)
     *
     * @returns {Promise} - A promise that resolves with the AuthModal module.
     */
    load: function load() {
        __webpack_require__.e/* require.ensure */(0).then((function () {
            Auth = __webpack_require__(932);
            authModalLoader._onLoaded.resolve(Auth);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

        return authModalLoader._onLoaded;
    },


    /**
     * Usefull when you don't want to load the AuthModal but want to get the instance.
     *
     * @example
     * authModalLoader.getLoadPromise().then(AuthModal => DO STUFF)
     *
     * @returns {Promise} - A promise that resolves with the AuthModal module.
     */
    getLoadPromise: function getLoadPromise() {
        return authModalLoader._onLoaded;
    },


    /**
     * Shortcut to AuthModal.show.
     *
     * @example
     * authModalLoader.show(options).then((authResponse) => if (authResponse.err) FAILURE else SUCCESS);
     * authResponse.user will be an object containing user data: user.userId, user.userToken, user.profile {}.
     * authResponse.err will be an object with shape {err: 'closed'}.
     * it will contain the reason for authentication failure. which is most likely because the user closed the modal.
     * @returns {Promise}
     */
    show: function show() {
        var _this = this;

        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var environment = options.relayEnvironment || relayEnvironment;
        return new Promise(function (resolve) {
            _this.load().then(function (AuthModal) {
                _reactDom2.default.render(_react2.default.createElement(AuthModal.AuthModal, { environment: environment }), getWrapperElement());
                switch (options.action) {
                    case constants.LOGIN:
                        Auth.launchLogin(_extends({}, options, { resolve: resolve }));
                        break;
                    case constants.RESET_PASSWORD:
                        Auth.launchResetPassword(_extends({}, options, { resolve: resolve }));
                        break;
                    case constants.UPDATE_PASSWORD:
                        Auth.launchUpdatePassword(_extends({}, options, { resolve: resolve }));
                        break;
                    case constants.RESET_INVALID:
                        Auth.launchResetInvalid(_extends({}, options, { resolve: resolve }));
                        break;
                    default:
                        Auth.launchRegistration(_extends({}, options, { resolve: resolve }));
                        break;
                }
            });
        }).then(function (authResult) {
            var isRegister = authResult.modal === constants.REGISTER;
            var isLogin = authResult.modal === constants.LOGIN;

            if (!authResult.err) {
                _User2.default.updateLoginState();

                var _require = __webpack_require__(2191),
                    postLogin = _require.postLogin,
                    postRegistration = _require.postRegistration;

                var isVerifiedTrade = (0, _lodash2.default)(authResult, 'user.isVerifiedTrade');

                if (isLogin) {
                    postLogin({ flow: options.flow, environment: environment });
                } else if (isRegister && !isVerifiedTrade) {
                    postRegistration({ flow: options.flow, environment: environment });
                }
            }
            return _extends({}, authResult, { newUser: isRegister });
        });
    }
}, _defineProperty(_authModalLoader, 'getLoadPromise', function getLoadPromise() {
    return authModalLoader._onLoaded;
}), _defineProperty(_authModalLoader, '_clearAuthModal', function _clearAuthModal() {
    Auth = undefined;
    authModalLoader._onLoaded = (0, _yaDeferred2.default)();
}), _defineProperty(_authModalLoader, '_setAuthModal', function _setAuthModal(m) {
    Auth = m;
}), _authModalLoader);

authModalLoader = Object.assign(authModalLoader, { constants: constants });

exports.default = authModalLoader;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArguments = __webpack_require__(1094),
    isArray = __webpack_require__(64),
    isFunction = __webpack_require__(104),
    isString = __webpack_require__(3963),
    keys = __webpack_require__(297);

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is empty. A value is considered empty unless it is an
 * `arguments` object, array, string, or jQuery-like collection with a length
 * greater than `0` or an object with own enumerable properties.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {Array|Object|string} value The value to inspect.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
      (isObjectLike(value) && isFunction(value.splice)))) {
    return !value.length;
  }
  return !keys(value).length;
}

module.exports = isEmpty;


/***/ }),
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _chat;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

__webpack_require__(3060);

var SV = __webpack_require__(18);
var get = __webpack_require__(14);
var moment = __webpack_require__(30);
var enabler = __webpack_require__(63);
var FavoriteModel = __webpack_require__(378);

var _require = __webpack_require__(282),
    sessionStorage = _require.sessionStorage;

var root = __webpack_require__(102);

var isPrintPDP = SV.get('settings.isPrintPDP');
var isEnabled = enabler.isEnabled('chat_intercom') && !isPrintPDP;
var widgetLoader = __webpack_require__(2178);

var _require2 = __webpack_require__(536),
    isPageType = _require2.isPageType;

var _require3 = __webpack_require__(398),
    PAGE_TYPE = _require3.PAGE_TYPE,
    BROWSE_TYPES = _require3.BROWSE_TYPES;

var User = __webpack_require__(15);

var _require4 = __webpack_require__(137),
    tradePromoDate = _require4.URL.queryKey.tradePromoDate;

var CHAT_STARTED_STORAGE_KEY = '__chatStarted';
var ARGUMENTS_STORAGE_KEY = '__chatArguments';
var CHECKOUT_UNLOAD_KEY = '__checkoutUnload';
var CHECKOUT_TYPE_KEY = '__checkoutTransactionType';

var TRADE_PROMO_DATE_FROM = tradePromoDate || '2017-01-16';

var PAGE_TYPE_WHITELIST = [BROWSE_TYPES, PAGE_TYPE.CHECKOUT, PAGE_TYPE.FAVORITES, // Cart + Favorites has same pageType
PAGE_TYPE.HOME, PAGE_TYPE.INVOICE, PAGE_TYPE.PDP, PAGE_TYPE.SEARCH];

function getDate() {
    var date = new Date();
    return moment(date).format();
}

function getIntercomDate(date) {
    date = new Date(date);
    return date.getTime() / 1000; // get UTC seconds
}

function applyArgumentQueue(intercom) {
    var argumentQueue = sessionStorage.getItem(ARGUMENTS_STORAGE_KEY) || [];

    if (argumentQueue.length) {
        argumentQueue.forEach(function (args) {
            intercom.apply(intercom, args);
        });
    }

    sessionStorage.setItem(ARGUMENTS_STORAGE_KEY, []);
}

function load() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    var chatStarted = sessionStorage.getItem(CHAT_STARTED_STORAGE_KEY);
    var pageTypeValid = isPageType(PAGE_TYPE_WHITELIST);

    if (chatStarted && isEnabled && pageTypeValid) {
        return widgetLoader.load('intercom').then(function (intercom) {
            applyArgumentQueue(intercom);
            if (args.length) {
                intercom.apply(intercom, args);
            }
        });
    } else if (isEnabled) {
        var argumentQueue = sessionStorage.getItem(ARGUMENTS_STORAGE_KEY) || [];
        argumentQueue.push(args);
        sessionStorage.setItem(ARGUMENTS_STORAGE_KEY, argumentQueue);
    }

    // if `chat_intercom` is not enabled resolve
    return Promise.resolve();
}

function trackEvent() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
    }

    return load.apply(undefined, ['trackEvent'].concat(args));
}

function update(data) {
    return load('update', data);
}

function getUserTestGroup(_ref) {
    var user = _ref.user,
        tradeUserCreateDate = _ref.tradeUserCreateDate;

    var userId = user.id;
    var lastIdNumber = Number.parseInt(userId.slice(-1));
    var testGroupData = {};

    // User ids end up with 1 or 2, ~20% of users
    if ([1, 2].indexOf(lastIdNumber) > -1) {
        testGroupData.user_test_group = 'Holdout'; // eslint-disable-line camelcase
    }

    testGroupData.user_test_group = 'Test'; // eslint-disable-line camelcase

    if (tradeUserCreateDate) {
        var secontToLastIdNumber = Number.parseInt(userId.slice(-2, -1));
        if ([4, 5].indexOf(secontToLastIdNumber) > -1 && moment(tradeUserCreateDate) > moment(TRADE_PROMO_DATE_FROM)) {
            testGroupData.user_trade_promo_group = 'Test'; // eslint-disable-line camelcase
        } else {
            testGroupData.user_trade_promo_group = 'Control'; // eslint-disable-line camelcase
        }
    }

    return testGroupData;
};

var chat = (_chat = {
    start: function start() {
        sessionStorage.setItem(CHAT_STARTED_STORAGE_KEY, true);
        return load();
    },
    show: function show() {
        return load('show');
    },
    fillUserData: function fillUserData(_ref2) {
        var user = _ref2.user,
            tradeSalesRep = _ref2.tradeSalesRep,
            tradeUserCreateDate = _ref2.tradeUserCreateDate,
            vipSalesRep = _ref2.vipSalesRep;

        if (!User.loggedIn()) {
            return Promise.resolve();
        }

        var userType = User.getCustomerType();
        var id = user.id,
            createdDate = user.createdDate,
            _user$profile = user.profile,
            firstName = _user$profile.firstName,
            lastName = _user$profile.lastName,
            email = _user$profile.email;


        var userData = Object.assign({
            'user_id': id,
            name: ((firstName || '') + ' ' + (lastName || '')).trim(),
            email: email,
            'user_type': userType,
            'registered_at': getIntercomDate(createdDate),
            'trade_account_manager': get(tradeSalesRep, 'email'),
            'vip_account_manager': get(vipSalesRep, 'email')
        }, getUserTestGroup({ user: user, tradeUserCreateDate: tradeUserCreateDate }));

        return update(userData);
    }
}, _defineProperty(_chat, 'show', function show() {
    return load('show');
}), _defineProperty(_chat, 'customAttribute', {
    transactionsStatus: function transactionsStatus(_ref3) {
        var buyerStatus = _ref3.buyerStatus,
            totalTransactions = _ref3.totalTransactions;

        return update({
            'buyer_status': buyerStatus,
            'total_transactions': totalTransactions
        });
    },
    tradeStatus: function tradeStatus(status) {
        return update({ 'trade_status': status });
    },
    verifiedTradeDate: function verifiedTradeDate(date) {
        return update({ 'verified_trade_at': getIntercomDate(date) });
    },
    itemsInCart: function itemsInCart(itemCount) {
        return update({ 'items_in_cart': itemCount });
    },
    registeredOnPage: function registeredOnPage() {
        var pathname = document.location.pathname;

        return update({ 'registered_on_page': pathname });
    }
}), _defineProperty(_chat, 'track', {
    abandonFavorite: function abandonFavorite(type) {
        switch (type) {
            case FavoriteModel.TYPE_SEARCH:
                return trackEvent('abandon_follow_search');

            case FavoriteModel.TYPE_DEALER:
                return trackEvent('abandon_follow_dealer');
        }

        return Promise.resolve();
    },
    abandonRequestNetPrice: function abandonRequestNetPrice() {
        return trackEvent('abandon_request_net_price', {
            'fired_at': getDate()
        });
    },
    requestNetPrice: function requestNetPrice() {
        return trackEvent('success_request_net_price', {
            'fired_at': getDate()
        });
    },
    abandonMakeOffer: function abandonMakeOffer() {
        return trackEvent('make_offer_abandon', {
            'fired_at': getDate()
        });
    },
    makeOfferComplete: function makeOfferComplete() {
        return trackEvent('make_offer_complete', {
            'fired_at': getDate()
        });
    },
    abandonContactDealer: function abandonContactDealer() {
        return trackEvent('abandon_contact_dealer', {
            'fired_at': getDate()
        });
    },
    contactDealer: function contactDealer() {
        return trackEvent('contact_dealer', {
            'fired_at': getDate()
        });
    },
    addToCart: function addToCart() {
        return trackEvent('item_added_to_cart', {
            'fired_at': getDate()
        });
    },
    itemSaved: function itemSaved() {
        return trackEvent('success_save_item');
    },
    shippingDetailsClick: function shippingDetailsClick() {
        return trackEvent('view_shipping_details');
    },
    buyerAssuranceClick: function buyerAssuranceClick() {
        return trackEvent('buyer_protection');
    },
    checkoutReached: function checkoutReached(data, isNegotiable) {
        sessionStorage.setItem(CHECKOUT_TYPE_KEY, { isNegotiable: isNegotiable });
        return trackEvent('checkout_reached', data);
    },
    checkoutComplete: function checkoutComplete() {
        return trackEvent('checkout_completed');
    },
    checkoutAbandon: function checkoutAbandon() {
        return trackEvent('checkout_abandon');
    },
    checkoutSurveySubmitted: function checkoutSurveySubmitted(data) {
        return trackEvent('checkout_survey_submitted', data);
    },
    tradeBasicInfoCompleted: function tradeBasicInfoCompleted(noWebsite) {
        var prefix = noWebsite ? 'no ' : '';
        return trackEvent('trade application step 1 - ' + prefix + 'website');
    }
}), _chat);

function checkAbandonCheckout() {
    var pathname = document.location.pathname;

    var isCheckoutPage = pathname.indexOf('checkout') > -1;
    var isCheckoutConfirmationPage = pathname.indexOf('checkout/confirmation') > -1;
    var isMyOrdersPage = pathname.indexOf('my/orders') > -1;

    if (isCheckoutPage && !isCheckoutConfirmationPage) {
        root.onbeforeunload = function () {
            sessionStorage.setItem(CHECKOUT_UNLOAD_KEY, true);
        };
    } else if (!isCheckoutConfirmationPage && !isMyOrdersPage && sessionStorage.getItem(CHECKOUT_UNLOAD_KEY)) {
        var isNegotiable = get(sessionStorage.getItem(CHECKOUT_TYPE_KEY), 'isNegotiable');

        if (isNegotiable) {
            chat.track.abandonMakeOffer();
        } else {
            chat.track.checkoutAbandon();
        }
    }

    sessionStorage.deleteItem(CHECKOUT_UNLOAD_KEY);
};

function checkConductSearch() {
    var _document$location = document.location,
        pathname = _document$location.pathname,
        search = _document$location.search;


    if (pathname.indexOf('/search') === 0 && search.indexOf('?q=') === 0) {
        update({ 'user_conduct_search': 'Yes' });
    }
};

function checkPdp() {
    if (isPageType(PAGE_TYPE.PDP)) {
        var pk = SV.get('item.pk');
        trackEvent('pdp_view', { pk: pk });
    }
};

checkAbandonCheckout();
checkConductSearch();
checkPdp();

module.exports = chat;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(330);

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Native method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeNow = getNative(Date, 'now');

/**
 * Gets the number of milliseconds that have elapsed since the Unix epoch
 * (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @category Date
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => logs the number of milliseconds it took for the deferred function to be invoked
 */
var now = nativeNow || function() {
  return new Date().getTime();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed invocations. Provide an options object to indicate that `func`
 * should be invoked on the leading and/or trailing edge of the `wait` timeout.
 * Subsequent calls to the debounced function return the result of the last
 * `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
 * on the trailing edge of the timeout only if the the debounced function is
 * invoked more than once during the `wait` timeout.
 *
 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.leading=false] Specify invoking on the leading
 *  edge of the timeout.
 * @param {number} [options.maxWait] The maximum time `func` is allowed to be
 *  delayed before it is invoked.
 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
 *  edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // avoid costly calculations while the window size is in flux
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
 * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // ensure `batchLog` is invoked once after 1 second of debounced calls
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', _.debounce(batchLog, 250, {
 *   'maxWait': 1000
 * }));
 *
 * // cancel a debounced call
 * var todoChanges = _.debounce(batchLog, 1000);
 * Object.observe(models.todo, todoChanges);
 *
 * Object.observe(models, function(changes) {
 *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
 *     todoChanges.cancel();
 *   }
 * }, ['delete']);
 *
 * // ...at some point `models.todo` is changed
 * models.todo.completed = true;
 *
 * // ...before 1 second has passed `models.todo` is deleted
 * // which cancels the debounced `todoChanges` call
 * delete models.todo;
 */
function debounce(func, wait, options) {
  var args,
      maxTimeoutId,
      result,
      stamp,
      thisArg,
      timeoutId,
      trailingCall,
      lastCalled = 0,
      maxWait = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = wait < 0 ? 0 : (+wait || 0);
  if (options === true) {
    var leading = true;
    trailing = false;
  } else if (isObject(options)) {
    leading = !!options.leading;
    maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    if (maxTimeoutId) {
      clearTimeout(maxTimeoutId);
    }
    lastCalled = 0;
    maxTimeoutId = timeoutId = trailingCall = undefined;
  }

  function complete(isCalled, id) {
    if (id) {
      clearTimeout(id);
    }
    maxTimeoutId = timeoutId = trailingCall = undefined;
    if (isCalled) {
      lastCalled = now();
      result = func.apply(thisArg, args);
      if (!timeoutId && !maxTimeoutId) {
        args = thisArg = undefined;
      }
    }
  }

  function delayed() {
    var remaining = wait - (now() - stamp);
    if (remaining <= 0 || remaining > wait) {
      complete(trailingCall, maxTimeoutId);
    } else {
      timeoutId = setTimeout(delayed, remaining);
    }
  }

  function maxDelayed() {
    complete(trailing, timeoutId);
  }

  function debounced() {
    args = arguments;
    stamp = now();
    thisArg = this;
    trailingCall = trailing && (timeoutId || !leading);

    if (maxWait === false) {
      var leadingCall = leading && !timeoutId;
    } else {
      if (!maxTimeoutId && !leading) {
        lastCalled = stamp;
      }
      var remaining = maxWait - (stamp - lastCalled),
          isCalled = remaining <= 0 || remaining > maxWait;

      if (isCalled) {
        if (maxTimeoutId) {
          maxTimeoutId = clearTimeout(maxTimeoutId);
        }
        lastCalled = stamp;
        result = func.apply(thisArg, args);
      }
      else if (!maxTimeoutId) {
        maxTimeoutId = setTimeout(maxDelayed, remaining);
      }
    }
    if (isCalled && timeoutId) {
      timeoutId = clearTimeout(timeoutId);
    }
    else if (!timeoutId && wait !== maxWait) {
      timeoutId = setTimeout(delayed, wait);
    }
    if (leadingCall) {
      isCalled = true;
      result = func.apply(thisArg, args);
    }
    if (isCalled && !timeoutId && !maxTimeoutId) {
      args = thisArg = undefined;
    }
    return result;
  }
  debounced.cancel = cancel;
  return debounced;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = debounce;


/***/ }),
/* 273 */,
/* 274 */,
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.connect = exports.Provider = undefined;

var _Provider = __webpack_require__(4083);

var _Provider2 = _interopRequireDefault(_Provider);

var _connect = __webpack_require__(4084);

var _connect2 = _interopRequireDefault(_connect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports.Provider = _Provider2["default"];
exports.connect = _connect2["default"];

/***/ }),
/* 276 */,
/* 277 */,
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-close'].join(' '), 'data-tn': 'close', viewBox: '0 0 500 500' },
                React.createElement('path', { d: 'M274.1,250L495,470.9c6.7,6.7,6.7,17.5,0,24.1s-17.5,6.7-24.1,0L250,274.1L29.1,495 c-6.7,6.7-17.5,6.7-24.1,0s-6.7-17.5,0-24.1L225.9,250L5,29.1C-1.7,22.4-1.7,11.6,5,5s17.5-6.7,24.1,0L250,225.9L470.9,5 c6.7-6.7,17.5-6.7,24.1,0s6.7,17.5,0,24.1L274.1,250z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 279 */
/***/ (function(module, exports) {

/**
 * lodash 3.6.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Native method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * created function and arguments from `start` and beyond provided as an array.
 *
 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.restParam(function(what, names) {
 *   return what + ' ' + _.initial(names).join(', ') +
 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
 * });
 *
 * say('hello', 'fred', 'barney', 'pebbles');
 * // => 'hello fred, barney, & pebbles'
 */
function restParam(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        rest = Array(length);

    while (++index < length) {
      rest[index] = args[start + index];
    }
    switch (start) {
      case 0: return func.call(this, rest);
      case 1: return func.call(this, args[0], rest);
      case 2: return func.call(this, args[0], args[1], rest);
    }
    var otherArgs = Array(start + 1);
    index = -1;
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = rest;
    return func.apply(this, otherArgs);
  };
}

module.exports = restParam;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var currencies = __webpack_require__(1473);
var constants = {
    currencies: {},
    symbols: {
        GBP: '£',
        EUR: '€',
        USD: '$',
        CAD: '$',
        AUD: '$',
        CHF: '', // Swiss francs don't have a currency symbol
        MXN: '$'
    },
    abbreviations: {
        CAD: 'CAD',
        AUD: 'AUD',
        MXN: 'MXN',
        CHF: 'CHF'
    }
};

currencies.forEach(function (currency) {
    constants.currencies['CURRENCY_' + currency] = currency;
});

module.exports = constants;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** Used to determine if values are of the language type `Object`. */
var objectTypes = {
  'function': true,
  'object': true
};

/** Detect free variable `exports`. */
var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
  ? exports
  : undefined;

/** Detect free variable `module`. */
var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
  ? module
  : undefined;

/** Detect free variable `global` from Node.js. */
var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);

/** Detect free variable `self`. */
var freeSelf = checkGlobal(objectTypes[typeof self] && self);

/** Detect free variable `window`. */
var freeWindow = checkGlobal(objectTypes[typeof window] && window);

/** Detect `this` as the global object. */
var thisGlobal = checkGlobal(objectTypes[typeof this] && this);

/**
 * Used as a reference to the global object.
 *
 * The `this` value is used if it's the global object to avoid Greasemonkey's
 * restricted `window` object, otherwise the `window` object is used.
 */
var root = freeGlobal ||
  ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
    freeSelf || thisGlobal || Function('return this')();

/**
 * Checks if `value` is a global object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
 */
function checkGlobal(value) {
  return (value && value.Object === Object) ? value : null;
}

module.exports = root;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module), __webpack_require__(4)))

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var Cookies = __webpack_require__(1456);

var root = 'undefined' === typeof window ? global : window;
var LocalStorage;
var SessionStorage;
var initializedSessionStorage;

function Storage() {
    this.data = {};
}

Storage.prototype = {
    _storage: {},
    _supported: false,
    initialize: function (storage) {
        this._storage = storage || root.localStorage;
        this._supported = this.isSupported();
        return this;
    },
    isSupported: function () {
        try {
            // FINDING-1393 - trying this first fixes private mode browsing in safari
            // https://github.com/marcuswestin/store.js/issues/42
            this._storage.setItem('dibsy', '');
            this._storage.removeItem('dibsy');
            return true;
        } catch (e) {
            return false;
        }
    },
    /**
     * Sets whether or not local/session storage is supported
     * @param {boolean} supported
     */
    setSupported: function (supported) {
        this._supported = supported;
    },
    getItems: function () {
        if (!this._supported) {
            return 'localStorage is not supported';
        }
        return this._storage;
    },
    /**
     * Set storage value by the key
     *
     * @param key - {string}
     * @param value - {mixed}
     * @returns {Storage}
     */
    setItem: function (key, value) {
        switch (typeof value) {
            case 'object':
                value = JSON.stringify(value);
                break;
            default:
                value += '';
        }

        if (!this._supported) {
            this.data[key] = value;
            Cookies.set(key, value, {path: '/'});
        } else {
            try {
                this._storage.setItem(key, value);
            } catch (e) {
                // do nothing
            }
        }
        return this;
    },
    /**
     * Get storage value by the key
     *
     * @param key - {string}
     * @returns {mixed}
     */
    getItem: function (key) {
        var value;

        if (!key) {
            return false;
        }
        if (!this._supported) {
            value = Cookies.get(key);
            if (!value && this.data[key]) {
                value = this.data[key];
            }
        } else {
            value = this._storage[key];
        }

        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    },
    /**
     * Delete storage by the key
     *
     * @param key - {string}
     * @returns {Storage}
     */
    deleteItem: function (key) {
        if (!this._supported) {
            delete this.data[key];
            Cookies.remove(key, {path: '/'});
        } else {
            try {
                this._storage.removeItem(key);
            } catch (e) {
                // do nothing
            }
        }
        return this;
    }
};

LocalStorage = new Storage();
SessionStorage = new Storage();
initializedSessionStorage = SessionStorage.initialize(root.sessionStorage);

module.exports = {
    localStorage: LocalStorage.initialize(),
    sessionStorage: initializedSessionStorage
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: daletan
 * Date: 6/23/14
 * Time: 10:44 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 *
 * formerly:
 * js/global/core/dibs.js#isMobile
 * js/global/core/dibs.js#isTouchDevice
 * dibs.isMobile
 * dibs.isTouchDevice
 */


var _navigator = global.navigator;

/**
 * Detect if user is on mobile device
 * this is a jenky solution since it relies on the user agent
 * it should rely on feature detection instead
 */
module.exports = {
    Android: function (ua) {
        return (/Android/i).test(ua || _navigator.userAgent);
    },
    BlackBerry: function (ua) {
        return (/BlackBerry/i).test(ua || _navigator.userAgent);
    },
    BlackBerry10: function (ua) {
        return (/BB10/i).test(ua || _navigator.userAgent);
    },
    iPhone: function (ua) {
        return (/iPhone/i).test(ua || _navigator.userAgent);
    },
    iPad: function (ua) {
        return (/iPad/i).test(ua || _navigator.userAgent);
    },
    iPod: function (ua) {
        return (/iPod/i).test(ua || _navigator.userAgent);
    },
    iOS: function (ua) {
        return this.iPhone(ua) || this.iPad(ua) || this.iPod(ua);
    },
    Opera: function (ua) {
        return (/Opera Mobi/i).test(ua || _navigator.userAgent);
    },
    Windows: function (ua) {
        return (/IEMobile/i).test(ua || _navigator.userAgent);
    },
    iOSVersion: function (version, ua) {
        var r = new RegExp('(iPad|iPhone|iPod);.*CPU.*OS ' + version + '_\\d', 'i');
        return r.test(ua || _navigator.userAgent);
    },
    any: function (ua) {
        var isMobile = false;
        var blacklist = [
            'hasTouch',
            'isTouchDevice',
            'any',
            'iOSVersion'
        ];

        for (var p in this) {
            if (this.hasOwnProperty(p) && blacklist.indexOf(p) === -1) {
                isMobile = this[p](ua || _navigator.userAgent);
                if (isMobile) {
                    return isMobile;
                }
            }
        }
        return isMobile;
    },
    hasTouch: function () {
        return this.isTouchDevice();
    },
    /**
     * TODO: delete references to isTouchDevice & move logic to hasTouch
     * @deprecated - use hasTouch instead
     * @returns {boolean}
     */
    isTouchDevice: function () {
        // http://stackoverflow.com/a/4819886
        // reference  GFoley83 Sep 4 '13 at 6:20 comment
        //
        // added non-prefixed maxTouchPoints based on this post:
        // http://msdn.microsoft.com/en-us/library/ie/hh772144%28v=vs.85%29.aspx
        return 'ontouchstart' in global || (!!(_navigator.msMaxTouchPoints) || !!(_navigator.maxTouchPoints));
    }
};


//DETECT TOUCH CAPABILITIES

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * These endpoints are paths only
 * Consumers of these endpoints are responsible for adding any needed queryString
 *
 * @memberof bunsen
 * @namespace endpoints
 */



var ends = {};
var soa = '/soa';
var services = '/services';
var query = 'queryservice';
var json = 'json';
var usercomm = 'usercomm/1';
var usercommv3 = 'usercomm/3';
var form = 'formservice';
var cms = 'cms';
var portfolio = 'portfolio';
var portfolios = 'portfolios';
var creator = 'creator';
var boss11 = 'boss/1.1';
var userservice = 'userservice';
var item = 'itemservice';
var masqueradeSeller = 'masquerade_seller';
var Qs = __webpack_require__(42);
var isArray = __webpack_require__(64);
var isEmpty = __webpack_require__(267);
var versions = __webpack_require__(2800);
var latest = versions.latest;
var latestServices = versions.latestServices;

function uriJoin() {
    return Array.prototype.slice.call(arguments).join('/');
}

ends.cmsUpload = function (type, dir) {
    var args = [soa, boss11, 'upload'];

    if (type) {
        args.push(type);
    }
    if (dir) {
        args.push(dir);
    }
    return uriJoin.apply(null, args);
};

/**
 * Newer endpoint to upload images for items.
 * @returns {string|boolean}
 */
ends.itemImageUpload = function () {
    return uriJoin(soa, latest.inventoryFileUpload, 'images', 'upload');
};

ends.sellerStatuses = function () {
    return uriJoin(soa, latest.identity, 'seller', 'statuses');
};

/**
 * Endpoint to upload images. You must pass a type (e.g. "general" or "dealers")
 * NOTE: If you use this endpoint in .com, keep in mind that Array.prototype.indexOf
 * is not fully supported in IE8.
 * @param {string} type
 * @param {number} sellerId
 * @returns {string|boolean}
 * @throws Will throw an error if no `sellerId` argument is passed and `type` = 'dealers' || 'dealer_logo'
 */
ends.uploadImages = function (type, sellerId) {
    var types = ['general', 'cms', 'editorial', 'dealers', 'dealer_logo'];

    if ((types.indexOf(type)) !== -1) {
        if ((type === 'dealers' || type === 'dealer_logo')) {
            if (!sellerId) {
                throw new Error('seller Legacy Id required to create endpoint if type is "dealers"');
            }

            type = (type === 'dealers') ? 'dealer_image_upload' : 'general_image_upload/' + type;
            return '/image/ajax/' + type + '?seller_id=' + sellerId;
        }
        return '/image/ajax/general_image_upload/' + type;
    } else {
        return false;
    }
};

/**
 * Returns message contact imaging endpoint.
 * @returns {string}
 */
ends.contactImaging = function () {
    return '/old-dealer-admin/libraries/ajax/imaging_contact.php';
};

/**
 * Modify image (rotate, eventually crop).
 */
ends.processImage = function (itemId, photoId) {
    return uriJoin(ends.item(itemId), 'image', photoId, 'process');
};

/**
 * Download an image. Accepts the path to the image as a get param.
 * @param itemId
 * @param imageId
 * @param imgUrl
 * @returns {string}
 */
ends.downloadOriginal = function (itemId, imageId) {
    return uriJoin(soa, latest.inventoryFileUpload, 'image', imageId, 'download');
};

/**
 * Add, remove or reorder photos and images.
 */
ends.photos = function (itemId) {
    return uriJoin(soa, latest.inventory, 'item', itemId, 'images');
};

/**
 * Save item images (different permissions)
 */
ends.updateItemImages = function () {
    return uriJoin(services, item, 'save_item_images');
};

ends.process = function () {
    return uriJoin(soa, boss11, 'process');
};

ends.getSingleProcess = function (id) {
    return uriJoin(soa, boss11, 'process', id);
};

ends.getAllProcesses = function () {
    return uriJoin(soa, boss11, 'process');
};

ends.getProcessTypes = function () {
    return uriJoin(soa, boss11, 'process', 'types');
};

ends.messageGET = function (options) {
    console.assert(options.message, "messageGET endpoint expects an argument like {message: messageId}");
    return [soa, latest.messagecenter, 'message', options.message].join('/');
};
ends.messagePOST = function (options) {
    console.assert(options.conversation, "messagePOST endpoint expects an argument like {conversation: conversationId}");
    return [soa, latest.messagecenter, 'message', 'web', options.conversation].join('/');
};
ends.messageNewConversation = function () {
    return [soa, latest.messagecenter, 'message'].join('/');
};
ends.conversations = [soa, latestServices.messagecenter + '/2', 'conversations'].join('/');
ends.markReadUnread = [soa, latest.messagecenter, 'message', 'markReadUnread'].join('/'); //?conversationIds=201
ends.flagMessage = [soa, latest.mcFlagMessage, 'message', 'flag'].join('/');
ends.conversation = function (id, options) {
    options = options || {};
    return uriJoin(soa, latestServices.messagecenter + '/2', 'conversation', id) + (isEmpty(options.params) ? '' : '?' + Qs.stringify(options.params));
};
ends.conversationFilter = function () {
    return [soa, latestServices.messagecenter, '2', 'conversation', 'filter'].join('/');
};

ends.pushNotification = function (isBulk) {
    if (isBulk) {
        return uriJoin(soa, usercomm, 'push', 'bulk');
    }
    return uriJoin(soa, usercomm, 'push');
};

ends.dealerNotification = function (isBulk) {
    var endpoint = uriJoin(soa, latest.usercomm, 'send');
    if (isBulk) {
        endpoint = uriJoin(endpoint, 'bulk');
    }
    return endpoint;
};

ends.conversationMembers = function (ids) {
    if (undefined !== ids && !isArray(ids)) {
        ids = [ids];
    }
    return [soa, latest.messagecenter, 'member?'].join('/') + Qs.param({memberIds: ids.join(',')});
};
ends.conversationUnsubscribe = function () {
    return [soa, latest.messagecenter, 'member', 'unsubscribe'].join('/');
};
ends.note = function (id, service) {
    service = service || latest.identity;
    return uriJoin(soa, service, 'note', id);
};

ends.notes = function (service) {
    service = service || latest.identity;
    return uriJoin(soa, service, 'notes');
};

ends.notesByAnchor = function (anchor, service) {
    service = service || latest.identity;
    return uriJoin(soa, service, 'notes', anchor);
};

ends.address = function (id) {
    return uriJoin(soa, latest.identity, 'address', id);
};

ends.zipCode = function () {
    return uriJoin(soa, latest.identity, 'address', 'resolve', 'zip');
};

ends.addressBook = function (userId, addressType, addressId) {
    var uriArgs;
    if (!userId) {
        return false;
    }
    uriArgs = [soa, latest.identity, 'user', userId, 'addressBook'];

    if (addressType) {
        uriArgs.push(addressType);
        //nested because addressId depends on addressType being there first
        if (addressId) {
            uriArgs.push(addressId);
        }
    }

    return uriJoin.apply(this, uriArgs);
};

ends.returnPolicy = function (id) {
    return uriJoin(soa, latest.identity, 'returnPolicy', id);
};

ends.itemsReturnPolicy = function () {
    return uriJoin(soa, latest.inventoryItem, 'items', 'returnPolicy');
};

ends.sellerReturnPolicy = function (sellerId) {
    return uriJoin(ends.seller(sellerId), 'returnPolicy');
};

ends.adjustmentsForItemByType = function (itemId, type) {
    return uriJoin(soa, latest.ecom, 'adjustments', type, itemId);
};

ends.computeAdjustments = function () {
    return uriJoin(soa, latest.ecomTransaction, 'transaction', 'computeAdjustments');
};

ends.currencyConversion = function () {
    return uriJoin(soa, latest.ecom, 'currency', 'conversion');
};

ends.currencyConvert = function () {
    return uriJoin(soa, latest.ecomCurrency, 'currency', 'convert');
};

ends.currentRates = function () {
    return uriJoin(soa, latest.ecomCurrency, 'currency', 'conversionRateEvent', 'currentRates');
};

ends.feeStructure = function (feeStructureId) {
    return uriJoin(soa, latest.ecomCurrency, 'feeStructure', feeStructureId, 'anchors');
};

ends.feeStructures = function () {
    return uriJoin(soa, latest.ecomCurrency, 'feeStructures');
};

ends.feeStructureUpdate = function (feeStructureId, sellerId) {
    return uriJoin(soa, latest.ecomCurrency, 'feeStructure', feeStructureId, 'seller', sellerId);
};

ends.savedCard = function (userId, hashedCardNumber) {
    return uriJoin(soa, latest.identity, 'user', userId, 'creditCard', hashedCardNumber);
};

/**
 * @code /services/queryservice/item_creator_shipping.dibs
 * @memberof bunsen.endpoints
 */
ends.getItemCreatorShipping = function () {
    return uriJoin(services, query, 'item_creator_shipping.dibs');
};

/**
 * @code /services/queryservice/item_creator_woc.dibs
 * get a single item json based on iid
 */
ends.getItemByIid = function () {
    return uriJoin(services, query, 'item_creator_woc.dibs');
};

ends.dealerAnnouncements = function () {
    return uriJoin(soa, query, json, 'dealer_announcement.dibs');
};
/**
 * QueryService reference_set query.
 * used to get display values for enums
 * formerly "referenceSetJSON" from adminv2
 */
ends.referenceSet = function () {
    return uriJoin(soa, query, json, 'reference_set.dibs');
};

ends.FashionCategoryToTechnique = function () {
    return uriJoin(soa, query, json, 'fashion_cat_techniques_2.dibs');
};

ends.fashionInflatedTechniques = function () {
    return uriJoin(soa, query, json, 'fashion_techniques.dibs');
};

/**
 * Get the dealer's country id based on their seller ID.
 *
 */
ends.getDealerCountryId = function () {
    return uriJoin(soa, query, json, 'seller_geo_v2.dibs');
};

ends.transactionsSolr = function () {
    return uriJoin(soa, latest.ecomTransaction, 'transactions', 'search');
};

ends.transactionSummary = function () {
    return uriJoin(soa, latest.ecomSummary, 'transaction', 'summary');
};

ends.transaction = function () {
    return uriJoin(soa, latest.ecomTransaction, 'transaction');
};

/**
 * /soa/ecom-4/transaction/[transactionId]/history
 */
ends.transactionHistory = function (id) {
    return uriJoin(soa, latest.ecomTransaction, 'transaction', id, 'history');
};

ends.transactionDisplayCodes = function () {
    return uriJoin(ends.transaction(), 'displayCodes');
};

ends.transactionPing = function () {
    return uriJoin(ends.transaction(), 'ping');
};

ends.transactionKount = function () {
    return uriJoin(ends.transaction(), 'data.gif');
};

ends.paymentProviderClientToken = function () {
    return uriJoin(soa, latest.ecom, 'paymentProviderTransaction', 'clientToken');
};

ends.shipment = function (id) {
    return uriJoin(soa, latest.ecomLogistics, 'shipment', id);
};

ends.ecomShipmentQuote = function (id) {
    return uriJoin(soa, latest.ecomLogistics, 'shipmentQuote', id);
};
ends.shipmentQuote = function (id) {
    return uriJoin(soa, latest.logisticsShipping, 'shipmentQuote', id);
};

ends.shipmentQuotes = function () {
    return uriJoin(soa, latest.logisticsShipping, 'shipmentQuotes');
};

ends.shippingCosts = function () {
    return uriJoin(soa, latest.logisticsShipping, 'shippingCosts');
};

ends.computeShipmentQuoteSubTotal = function () {
    return uriJoin(soa, latest.logisticsShipping, 'shipmentQuote', 'compute');
};

ends.availableOptions = function () {
    return uriJoin(soa, latest.logisticsShipping, 'shipmentQuote', 'availableOptions');
};

/**
 * /soa/ecom-t2/2/shipmentQuote/determineRegion
 * @memberof bunsen.endpoints
 */
ends.determineRegion = function () {
    return uriJoin(soa, latest.ecom, 'shipmentQuote', 'determineRegion');
};

ends.serviceMethod = function (id) {
    return uriJoin(soa, latest.ecom, 'serviceMethod', id);
};

/**
 * @memberof bunsen.endpoints
 * @param offerId
 * @returns {string}
 */
ends.offer = function (offerId) {
    return uriJoin(soa, latest.ecom, 'offer', offerId);
};

ends.paymentAuthorization = function (id) {
    return uriJoin(soa, latest.ecom, 'paymentAuthorization', id);
};

ends.paymentMethod = function () {
    return uriJoin(soa, latest.ecom, 'paymentMethod');
};

ends.review = function (id) {
    return uriJoin(soa, latest.ecom, 'review', id);
};

ends.refund = function (id) {
    return uriJoin(soa, latest.ecom, 'refund', id);
};

ends.inventoryReview = function (id) {
    return uriJoin(soa, latest.inventoryReviews, 'review', id);
};

ends.designFirmsList = function () {
    return uriJoin(soa, latest.trade, 'design', 'firms');
};

ends.designProjectsList = function () {
    return uriJoin(soa, latest.trade, 'design', 'projects');
};

ends.designFirm = function (id) {
    return uriJoin(soa, latest.trade, 'design', 'firm', id);
};

ends.designFirmIndex = function (id) {
    return uriJoin(soa, latest.trade, 'design', 'firms', 'index', id);
};

function baseDesignFirm(id, type) {
    return uriJoin(soa, latest.trade, 'design', 'firm', id, type);
};

ends.designFirmBasic = function (id) {
    return baseDesignFirm(id, 'basic');
};

ends.designFirmAddress = function (id) {
    return baseDesignFirm(id, 'address');
};

ends.designFirmArticles = function (id) {
    return baseDesignFirm(id, 'articles');
};

ends.designFirmProject = function (id) {
    return baseDesignFirm(id, 'project');
};

ends.designFirmProjects = function (id) {
    return baseDesignFirm(id, 'projects');
};

ends.designFirmAwards = function (id) {
    return baseDesignFirm(id, 'awards');
};

ends.designFirmEmployees = function (id) {
    return baseDesignFirm(id, 'employees');
};

ends.designFirmMedia = function (id) {
    return baseDesignFirm(id, 'media');
};

ends.designFirmPortfolios = function (id) {
    return baseDesignFirm(id, 'portfolios');
};

ends.designFirmProfile = function (id) {
    return baseDesignFirm(id, 'profile');
};

ends.designFirmWeblinks = function (id) {
    return baseDesignFirm(id, 'weblinks');
};

ends.designFirmInstagram = function (id) {
    return baseDesignFirm(id, 'instagram');
};

ends.designAwards = function () {
    return uriJoin(soa, latest.trade, 'awards');
};

ends.designProject = function (id) {
    return uriJoin(soa, latest.trade, 'design', 'project', id);
};

function baseDesignProject (id, type) {
    return uriJoin(soa, latest.trade, 'design', 'project', id, type);
};

ends.designProjectBasic = function (id) {
    return baseDesignProject(id, 'basic');
};

ends.designProjectAddress = function (id) {
    return baseDesignProject(id, 'address');
};

ends.designProjectProfile = function (id) {
    return baseDesignProject(id, 'profile');
};

ends.designAttributes = function (id) {
    return uriJoin(soa, latest.inventory, 'attribute');
};

ends.tradeAssociations = function () {
    return uriJoin(soa, latest.identityTrade, 'tradeAssociations');
};

ends.sellerTradeAssociations = function (id) {
    return uriJoin(soa, latest.identityTrade, 'seller', id, 'tradeAssociations');
};

ends.invoice = function (id) {
    return uriJoin(soa, latest.ecom, 'invoice', id);
};

ends.disbursement = function (id) {
    return uriJoin(soa, latest.ecom, 'disbursement', id);
};

ends.registerSeller = function (vertical) {
    return uriJoin(soa, latest.identity, 'seller', vertical);
};

/**
 * Identity endpoints
 * @memberof bunsen.endpoints
 * @param id
 * @return {string}
 */
ends.seller = function (id) {
    return uriJoin(soa, latest.identityShipping, 'seller', id);
};

ends.sellerTwentyFirstCenturyStatus = function (id) {
    return uriJoin(ends.seller(id), 'twentyFirstCenturyStatus');
};

ends.seller31 = function (id) {
    return uriJoin(soa, latest.identityLogistics, 'seller', id);
};

ends.userLogin = function () {
    return uriJoin(soa, latest.identity, 'user', 'login');
};

ends.userRegister = function (email) {
    var uri = uriJoin(soa, latest.identity, 'user');
    if (email) {
        uri += '?' + Qs.stringify({email: email});
    }
    return uri;
};

ends.wallet = function (id) {
    return uriJoin(soa, latest.identityShipping, 'user', id, 'wallet');
};

ends.walletPaymentMethod = function (userId) {
    return uriJoin(ends.wallet(userId), 'paymentMethod');
};

ends.vault = function (id) {
    return uriJoin(ends.wallet(id), 'paymentMethod', 'vault');
};

ends.sellerWallet = function (id) {
    return uriJoin(soa, latest.identityShipping, 'seller', id, 'wallet');
};

ends.sellerVault = function (id) {
    return uriJoin(ends.sellerWallet(id), 'paymentMethod', 'vault');
};

ends.sellerPaymentProfile = function (sellerID) {
    return uriJoin(soa, latest.identityHyperwallet, 'seller', sellerID, 'paymentProfile');
};

ends.report = function () {
    return uriJoin(soa, latest.boss, 'report');
};

//TODO remove after dibs-cms-dealer-storefront goes live
ends.updateDealerStorefrontProfile = function (sellerId) {
    return uriJoin(soa, latest.identityShipping, 'seller', sellerId, 'storefrontProfile');
};

ends.storefrontProfile = function (sellerId, storefrontId) {
    return uriJoin(soa, latest.identityShipping, 'seller', sellerId, 'storefrontProfile', storefrontId);
};

/**
 * Save a shipmentQuote at the seller level :
 * @param id
 * @returns {*}
 */
ends.sellerQuote = function (id) {
    return uriJoin(soa, latest.identityLogistics, 'seller', id, 'shipmentQuotes');
};

ends.sellers = function () {
    return uriJoin(soa, latest.identityShipping, 'sellers');
};

ends.sellerLogin = function () {
    return uriJoin(soa, latest.identity, 'seller', 'login');
};

/**
 * soa/identity/2.1/seller/{vertical_sellerid}/profile
 * @memberof bunsen.endpoints
 * @param id
 * return {string}
 */
ends.sellerProfile = function (id) {
    return uriJoin(soa, latest.identity, 'seller', id, 'profile');
};

ends.billItemsBySeller = function (sellerId) {
    return uriJoin(ends.seller(sellerId), 'bill');
};

ends.charges = function () {
    return uriJoin(soa, latest.identity, 'seller', 'charges');
};

ends.charge = function (sellerId) {
    return uriJoin(soa, latest.identityShipping, 'seller', sellerId, 'charge');
};

ends.updateCharge = function (chargeId) {
    return uriJoin(soa, latest.identityShipping, 'seller', 'charge', chargeId);
};

ends.statement = function () {
    return uriJoin(soa, latest.identityShipping, 'seller', 'charges');
};


/**
 * /soa/identity[version]/user/[id]
 * Note: we should always be using the /soa/identity[version]/user/[id] endpoint
 * @memberof bunsen.endpoints
 */
ends.user = function (id) {
    return uriJoin(soa, latest.identity, 'user', id);
};

/**
 * @memberof bunsen.endpoints
 * @param id
 * @returns {string}
 */
ends.buyer = ends.user;

ends.userById = function (id) {
    return uriJoin(soa, latest.identity, 'user', id);
};

ends.users = function () {
    return uriJoin(soa, latest.identity, 'users');
};

ends.userProfile = function (userId) {
    return uriJoin(ends.user(userId), 'profile');
};

ends.userProProfile = function (userId) {
    return uriJoin(ends.user(userId), 'proProfile');
};

ends.userNewsletters = function (userId) {
    return uriJoin(ends.user(userId), 'newsletters');
};

ends.userSourceAttribution = function (userId) {
    return uriJoin(ends.user(userId), 'sourceAttribution');
};

ends.userPassword = function (userId, options) {
    var uri = uriJoin(ends.user(userId), 'password');
    options = options || {};

    if (options.email) {
        uri += '?' + Qs.stringify({email: options.email});
    } else if (options.passwordToken) {
        uri += '?' + Qs.stringify({passwordToken: options.passwordToken});
    }

    return uri;
};

ends.sellerPassword = function (sellerId, options) {
    var uri = uriJoin(ends.seller(sellerId), 'password');
    options = options || {};

    if (options.email) {
        uri += '?email=' + options.email;
    } else if (options.passwordToken) {
        uri += '?passwordToken=' + options.passwordToken;
    }

    return uri;
};

// ------------------
// Logistics - aka Shipping 2
// ------------------
// Logistics - aka Shipping 2
ends.shipmentServiceMethod = function () {
    return uriJoin(soa, latest.logistics, 'shipmentServiceMethod');
};

ends.shipmentServiceMethods = function () {
    return uriJoin(soa, latest.logistics, 'shipmentServiceMethods');
};

ends.carriersBase = function () {
    return uriJoin(soa, latest.logistics, 'carriers');
};

ends.carrier = function () {
    return uriJoin(soa, latest.logistics, 'carrier');
};

ends.loadTracking = function () {
    return uriJoin(soa, latest.logisticsShipping, 'shipment', 'loadTracking');
};

ends.region = function (regionId) {
    return uriJoin(soa, latest.logistics, 'region', regionId);
};

ends.regions = function () {
    return uriJoin(soa, latest.logistics, 'regions');
};

ends.regionsForAddress = function () {
    return uriJoin(soa, latest.logistics, 'regionsForAddress');
};

/**
 * soa/identity/user/me
 * @memberof bunsen.endpoints
 */
ends.userMe = function () {
    return uriJoin(soa, latest.identity, 'user', 'me');
};

/**
 * soa/identity/user/me/profile
 * @memberof bunsen.endpoints
 */
ends.userMeProfile = function () {
    return uriJoin(soa, latest.identity, 'user', 'me', 'profile');
};

/**
 * soa/identity/1/role
 */
ends.roles = function () {
    return uriJoin(soa, latest.identity, 'role');
};

ends.role = function (id) {
    return uriJoin(ends.roles(), id);
};

/**
 * soa/identity/1/permission
 */
ends.permissions = function () {
    return uriJoin(soa, latest.identity, 'permission');
};

ends.permission = function (id) {
    return uriJoin(soa, latest.identity, 'permission', id);
};

ends.category = function (verticalId) {
    return uriJoin(soa, latest.inventoryCategories, 'category', verticalId);
};

ends.categories = function () {
    return uriJoin(soa, latest.inventoryCategories, 'categories');
};

ends.creator = function () {
    return uriJoin(soa, latest.inventoryCreators, creator);
};

ends.creatorById = function (creatorId) {
    return uriJoin(soa, latest.inventoryCreators, creator, creatorId);
};

ends.creatorList = function () {
    return uriJoin(soa, latest.inventoryCreators, 'creators');
};

ends.creatorRoles = function () {
    return uriJoin(soa, latest.inventoryCreators, creator, 'creatorRoles');
};

ends.getCreators = function () {
    return uriJoin(services, query, 'new_creators_all.dibs');
};

/**
 * Find creators based on some parameters, such as status = Approved, etc.
 */
ends.findCreators = function () {
    return uriJoin(services, query, 'find_creators.dibs');
};

/**
 * Find creators by id
 */
ends.findCreatorsById = function () {
    return uriJoin(services, query, 'creator_by_id.dibs');
};

/**
 * The following 2 endpoints get creators filtering on a string matched against the creator name.
 * Accepts either "starts_with" or "contains" parameters
 */
ends.getCreatorsNonAlphaInitials = function () {
    return uriJoin(services, query, 'creators_non_alpha_initial.dibs');
};

ends.getCreatorsByPhrase = function () {
    return uriJoin(services, query, 'creators_by_phrase.dibs');
};

ends.getCreatorsByPhraseNoCache = function () {
    return uriJoin(services, query, 'creators_by_phrase_woc.dibs');
};

/**
 * Saving an item-creator relationship. Item id with an array of objects with 'creator_id', 'attribution', 'roles' etc.
 */
ends.saveItemCreator = function () {
    return uriJoin(services, form, 'item.saveCreator');
};

/**
 * Saving a creator (name, status, url_tag, has_page) with no relationships, or a new creator
 */
ends.saveCreator = function () {
    return uriJoin(services, 'creatorservice', 'save_creator');
};

// item unknown creator endpoint
ends.unknownCreator = function () {
    return uriJoin(soa, latest.inventoryCreators, creator, 'unknown');
};

ends.inventoryRoot = function () {
    return uriJoin(soa, latest.inventory);
};

ends.changeCreator = function (previousCreator) {
    return uriJoin(soa, latest.inventoryCreators, creator, 'changeCreator', previousCreator);
};

/**
 * /soa/inventory-3/1/dimensionSet/
 * @param {number} [id]
 */
ends.dimensionSets = function (id) {
    return uriJoin(soa, latest.inventoryAttributes, 'dimensionSet') + (id ? '/' + id : '');
};

ends.materials = function (id) {
    return uriJoin(soa, latest.inventoryAttributes, 'material') + (id ? '/' + id : '');
};

ends.styles = function (id) {
    return uriJoin(soa, latest.inventoryAttributes, 'style') + (id ? '/' + id : '');
};

ends.attributesByCategory = function () {
    return uriJoin(soa, latest.inventoryAttributes, 'attribute/category');
};

ends.item = function (pk) {
    return uriJoin(soa, latest.inventoryItem, 'item', pk);
};

ends.items = function () {
    return uriJoin(soa, latest.inventoryItem, 'item');
};

ends.itemListings = function (pk) {
    return uriJoin(ends.item(pk), 'listings');
};

// IMPORTANT! THIS IS A HACK TO WORK AROUND THE WAY ITEM UPLOAD SAVES LISTINGS. DO NOT USE THIS UNLESS YOU KNOW WHAT
// YOU ARE DOING!!!
ends.cleanUpListingsAfterFailure = function (pk) {
    return uriJoin(soa, latest.inventoryItem, 'item', pk, 'cleanUpListingsAfterFailure');
};

//netPrice bulk update endpoint
ends.batchPrices = function (batchId) {
    return uriJoin(soa, latest.inventoryItem, 'prices', 'batch') + (batchId ? '/' + batchId : '');
}

/**
 * /soa/inventory/3/item
 * @param pk
 * @memberof bunsen.endpoints
 */
ends.itemWithReviews = function (pk) {
    return uriJoin(soa, latest.inventoryReviews, 'item', pk);
};

ends.itemsWithReviews = function () {
    return uriJoin(soa, latest.inventoryReviews, 'items');
};

/**
 * /soa/inventory/3/reviews
 * Retrieve reviews using filter params like itemId, type, status
 * @memberof bunsen.endpoints
 */
ends.reviews = function () {
    return uriJoin(soa, latest.inventoryReviews, 'reviews');
};

/**
 * There are no references to this method in .com, bunsen, or v2.  Will leave it here just in case.
 * @deprecated
 */
ends.getServiceMethods = function () {
    return uriJoin(soa, latest.inventory, 'shipmentQuote', 'serviceMethod');
};

ends.mailer = function (id) {
    return uriJoin(soa, latest.inventoryItem, 'item', id, 'mailer');
};

ends.itemStorefrontPreferences = function (id) {
    return uriJoin(soa, latest.inventoryItem, 'item', id, 'storefrontPreferences');
};

/**
 * There are no references to this in v2 or bunsen.  Will leave it here just in case
 * @deprecated
 */
ends.saveBulkShipping = function () {
    return uriJoin(soa, latest.inventory, 'shipmentQuotes');
};

ends.itemShipmentQuotes = function (itemId) {
    return uriJoin(soa, latest.inventoryLogistics, 'item', itemId, 'shipmentQuotes');
};

ends.solrItems = function () {
    return uriJoin(soa, latest.inventory, 'item');
};

ends.solrItem = function () {
    return uriJoin(soa, latest.inventory, 'item', 'index');
};

ends.release = function () {
    return uriJoin(soa, latest.inventoryCreators, 'release');
};
/**
 * @memberof bunsen.endpoints
 * @param userId
 * @returns {string}
 */
ends.permissionsByUser = function (userId) {
    return uriJoin(ends.user(userId), 'permission');
};

ends.permissionsByRole = function (roleId, permissionId) {
    return uriJoin(ends.roles(), roleId, 'permission', permissionId);
};

ends.clump = function () {
    return uriJoin(soa, form, '1', 'clump');
};

/**
 * @memberof bunsen.endpoints
 * @param template
 * @returns {string}
 */
ends.sendEmailResponsys = function (template) {
    return uriJoin(soa, usercomm, 'email', template);
};
ends.usercommToken = function () {
    return uriJoin(soa, usercomm, 'token');
};
ends.sendEmail = function (template) {
    return uriJoin(soa, latest.usercomm, 'email', template);
};
ends.geography = function () {
    return uriJoin(soa, latest.identity, 'geography');
};

ends.portfolio = function (portfolioId) {
    return uriJoin(soa, latest.identity, portfolio, portfolioId);
};

ends.portfolioItem = function (portfolioItemId) {
    return uriJoin(soa, latest.identity, portfolio, 'item', portfolioItemId);
};

ends.portfoliosByUser = function (userId) {
    return uriJoin(soa, latest.identity, 'user', userId, 'portfolio');
};
ends.portfolios = function () {
    return uriJoin(soa, latest.identity, portfolios);
};
ends.portfoliosByItem = function (itemPk) {
    return uriJoin(soa, latest.identity, portfolios, 'item', itemPk);
};
ends.portfolioItemsByPortfolio = function (portfolioId) {
    return uriJoin(soa, latest.identity, portfolio, portfolioId);
};

ends.portfolioAddItem = function (portfolioId, itemPk) {
    return uriJoin(soa, latest.identity, portfolio, portfolioId, 'item', itemPk);
};

ends.portfolioAddItemToDefault = function (userId, itemPk) {
    return uriJoin(soa, latest.identity, 'user', userId, portfolio, 'default', 'item', itemPk);
};

ends.portfolioSort = function (portfolioId) {
    return uriJoin(soa, latest.identity, portfolio, portfolioId, 'reorderItemPage');
};

ends.sharePortfolio = function (id) {
    return uriJoin(soa, latest.identity, portfolio, id, 'share');
};

ends.cmsPortfolio = function (id) {
    return uriJoin(soa, latest.identity, portfolio, cms, id);
};

ends.cartPortfolio = function (userId) {
    return uriJoin(soa, latest.identity, 'user', userId, portfolio);
};

ends.cartPortfolioAddItem = function (itemPk) {
    return uriJoin(soa, latest.identity, 'rootPortfolio', 'CART', 'item', itemPk);
};

ends.unknownCreator = function () {
    return uriJoin(soa, latest.inventoryCreators, creator, 'unknown');
};

ends.userRegionalInfo = function () {
    return uriJoin(soa, latest.identity, 'currency', 'resolve', 'ip');
};

ends.dealerAllContacts = function (vertical, legacyId, type) {
    var url = uriJoin(soa, query, json, 'seller_contacts.dibs');
    url = url + '?id=' + legacyId + '&' + vertical;
    if (type) {
        url = url + '&' + type;
    }
    return url;
};

ends.nydcSoldCount = function (legacyId) {
    var url = uriJoin(soa, query, json, 'seller_nydc_sold_count.dibs');
    url = url + '?id=' + legacyId;
    return url;
};

ends.nydcHoldCount = function (legacyId) {
    var url = uriJoin(soa, query, json, 'seller_nydc_hold_count.dibs');
    url = url + '?id=' + legacyId;
    return url;
};

ends.toggleNYDC = function (itemPk) {
    return uriJoin(soa, latest.inventoryShipping, 'item', itemPk, 'nydc');
};
ends.toggleNYDCv3 = function (itemPk) {
    return uriJoin(soa, latest.inventoryItem, 'item', itemPk, 'nydc');
};

// Used for count on dealer dashboard. Probably wrong and needs to be
// reassessed when dealer itemlist pages are done through v2
ends.twentiethCenturyCount = function (legacyId) {
    var url = uriJoin(soa, query, json, 'seller_twentieth_century_count_v1.dibs');
    url = url + '?id=' + legacyId;
    return url;
};

ends.exhibitionsCount = function (legacyId) {
    var url = uriJoin(soa, query, json, 'seller_exhibitions_count.dibs');
    url = url + '?id=' + legacyId;
    return url;
};

ends.regionMap = function (vertical) {
    return uriJoin(soa, latest.identity, 'seller', 'stores', vertical);
};

ends.favSeller = function (userId, urlLabel) {
    var baseUrl = userId ? uriJoin(soa, latest.identity, 'user', userId, 'favSeller') : '';
    var urlParam = urlLabel ? '?urlLabel=' + urlLabel : '';

    return baseUrl + urlParam;
};

ends.favorites = function () {
    return uriJoin(soa, latest.identity, 'user', 'favorites');
};

ends.favorite = function (id) {
    var url = uriJoin(soa, latest.identity, 'user', 'favorite');
    if (id) {
        url = uriJoin(url, id);
    }
    return url;
};

ends.accountManager = function (sellerID) {
    return uriJoin(soa, latest.identity, 'seller', sellerID, 'accountManager');
};

ends.userRelationships = function () {
    return uriJoin(soa, latest.identityTrade, 'userRelationships');
};

//get the current time
ends.currentTime = function () {
    return '/dealers/ajax/current_time';
};

// ------------------
// Saturday Shopper Endpoints
// we may still want this if we can delete cms portfolio based on portfolio id
ends.deleteSaturdayShopper = function () {
    return uriJoin(services, form, 'saturday_shopper.delete');
};

/**
 * Publication Management
 * endpoints
 * @type {{:)}}
 */

ends.publications = function () {
    return uriJoin(soa, latest.inventoryCreators, 'publications');
};

ends.publication = function (id) {
    return uriJoin(soa, latest.inventoryCreators, 'publication', id);
};

ends.makeTestPublication = function (id) {
    return uriJoin(soa, latest.inventoryCreators, 'publication', id, 'process');
};

ends.publicationType = function (id) {
    return uriJoin(soa, latest.inventoryCreators, 'publicationType', id);
};

ends.workflowStates = function (id) {
    return uriJoin(soa, latest.inventoryCreators, 'publication', id, 'workflowStates');
};

/**
 * can be types or subTypes
 * @param type
 */
ends.publicationType = function () {
    return uriJoin(soa, latest.inventoryCreators, 'publicationType');
};
ends.publicationTypes = function () {
    return uriJoin(soa, latest.inventoryCreators, 'publicationTypes');
};

ends.listings = function () {
    return uriJoin(soa, latest.inventoryCreators, 'listings');
};

ends.createFromSearch = function () {
    return uriJoin(soa, latest.inventoryCreators, 'listings', 'createFromSearch');
};

ends.singleListing = function (id) {
    return uriJoin(soa, latest.inventoryCreators, 'listing', id);
};

ends.listingsReorder = function () {
    return uriJoin(soa, latest.inventoryCreators, 'listingsOrder');
};

ends.listingAttach = function (id) {
    return uriJoin(this.singleListing(id), 'publication');
};

ends.workflowStates = function (id) {
    return uriJoin(soa, latest.inventoryCreators, 'listing', id, 'workflowStates');
};

ends.promotion = function (id) {
    return uriJoin(soa, latest.ecom, 'promotion', id);
};

ends.promotionRuleAnchor = function (id) {
    return uriJoin(soa, latest.ecomPromotion, 'promotionRule', id, 'anchorListMembers');
};

ends.cms = function (id) {
    return uriJoin(soa, latest.cms, id);
};

ends.conversationsForBuyerAndItemUrl = function (options) {
    return uriJoin(soa, latestServices.messagecenter, '2', 'conversation', 'buyer', options.buyerId, 'item', options.itemId);
};

ends.anchorLists = function () {
    return uriJoin(soa, latest.identityShipping, 'anchorList');
};

ends.anchorList = function (listType, listName) {
    return uriJoin(ends.anchorLists(), listType, listName, 'anchors');
};

// Media service
ends.uploadPhoto = function (photoTypeName) {
    return uriJoin(soa, latest.media, 'photo', photoTypeName);
};

ends.uploadPhotoByUrl = function (photoTypeName) {
    return uriJoin(soa, latest.media, 'photo', photoTypeName, 'url');
};

ends.replacePhoto = function (photoId) {
    return uriJoin(soa, latest.media, 'photo', photoId, 'replace');
};

ends.resizePhoto = function (photoId) {
    return uriJoin(soa, latest.media, 'photo', photoId, 'resize');
};

ends.processPhoto = function (photoId) {
    return uriJoin(soa, latest.media, 'photo', photoId, 'process');
};

ends.addPhotoTag = function (photoId) {
    return uriJoin(soa, latest.media, 'photo', photoId, 'photoTag');
};

ends.editPhotoTag = function (tagId) {
    return uriJoin(soa, latest.media, 'photoTag', tagId);
};

ends.mediaAlbum = function (albumId) {
    return uriJoin(soa, latest.media, 'mediaAlbum', albumId);
};

ends.getPhoto = function (photoId) {
    return uriJoin(soa, latest.media, 'photo', photoId);
};

ends.uploadVideo = function () {
    return uriJoin(soa, latest.media, 'video');
}

ends.getVideo = function (id) {
    return uriJoin(soa, latest.media, 'video', id);
}

// Analytics
ends.recommendations = function () {
    return uriJoin(soa, latest.analytics, 'recommendations');
};

ends.trending = function () {
    return uriJoin(soa, latest.analytics, 'trending');
};

ends.bulkAttachListings = function (id) {
    return uriJoin(ends.publication(id), 'process');
};
ends.socialNetworks = function () {
    return uriJoin(soa, latest.identitySocialNetworks, 'socialNetworks');
};

ends.userSocialNetworks = function (userId) {
    return uriJoin(soa, latest.identitySocialNetworks, 'user', userId, 'socialNetworks');
};

ends.addUserSocialNetwork = function (userId) {
    return uriJoin(soa, latest.identitySocialNetworks, 'user', userId, 'socialNetwork');
};

ends.userSocialNetwork = function (id) {
    return uriJoin(soa, latest.identitySocialNetworks, 'userSocialNetwork', id);
};

ends.oauth = function (sellerId) {
    return uriJoin(soa, latest.identityOauth, 'seller', sellerId, 'oauth', 'code');
};

ends.graphQL = function () {
    return uriJoin(soa, 'graphql');
};

ends.inventoryHold = [soa, latest.inventory, 'hold'].join('/');

ends.inventoryHoldById = function (id) {
    return uriJoin(soa, latest.inventory, 'hold', id);
};

ends.latest = latest;
ends.latestServices = latestServices;
ends.soa = soa;
module.exports = ends;


/***/ }),
/* 285 */,
/* 286 */,
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var hoistNonReactStatics = __webpack_require__(749);
var inherits = __webpack_require__(59);

function createComponent(Component, customContextTypes) {
    var componentName = Component.displayName || Component.name || 'Component';
    var childContextTypes = Object.assign({
        executeAction: PropTypes.func.isRequired,
        getStore: PropTypes.func.isRequired
    }, customContextTypes || {});

    function ContextProvider(props, context) {
        React.Component.apply(this, arguments);
    }

    inherits(ContextProvider, React.Component);

    ContextProvider.displayName = 'contextProvider(' + componentName + ')';
    ContextProvider.propTypes = {
        context: PropTypes.object.isRequired
    };
    ContextProvider.childContextTypes = childContextTypes;

    Object.assign(ContextProvider.prototype, {
        getChildContext: function () {
            var childContext = {
                executeAction: this.props.context.executeAction,
                getStore: this.props.context.getStore
            };
            if (customContextTypes) {
                Object.keys(customContextTypes).forEach(function (key) {
                    childContext[key] = this.props.context[key];
                }, this);
            }
            return childContext;
        },

        render: function () {
            var props = Component.prototype && Component.prototype.isReactComponent ? {ref: 'wrappedElement'} : null;
            return React.createElement(Component, Object.assign({}, this.props, props));
        }
    });

    hoistNonReactStatics(ContextProvider, Component);

    return ContextProvider;
}

/**
 * Provides context prop to all children as React context
 *
 * Example:
 *   var WrappedComponent = provideContext(Component, {
 *       foo: PropTypes.string
 *   });
 *
 * Also supports the decorator pattern:
 *   @provideContext({
 *       foo: PropTypes.string
 *   })
 *   class ConnectedComponent extends React.Component {
 *       render() {
 *           return <div/>;
 *       }
 *   }
 *
 * @method provideContext
 * @param {React.Component} [Component] component to wrap
 * @param {object} customContextTypes Custom contextTypes to add
 * @returns {React.Component} or {Function} if using decorator pattern
 */
module.exports = function provideContext(Component, customContextTypes) {
    // support decorator pattern
    if (arguments.length === 0 || typeof arguments[0] !== 'function') {
        customContextTypes = arguments[0];
        return function connectToStoresDecorator(ComponentToDecorate) {
            return createComponent(ComponentToDecorate, customContextTypes);
        };
    }

    return createComponent.apply(null, arguments);
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

var lodashClone = __webpack_require__(3945);

/**
 * Finds the value of any given namespace
 * @param {object} options
 * @param {string} options.ns Period delimited string representing the property to search for (ie. "my.name.space")
 * @param {object} [options.parent={}] object to iterate over
 * @param {*} [options.fallback=undefined] the return value if the `options.ns` is not found
 * @param {boolean} [options.clone=false] Clone the returned value if it is an object or an array
 * @returns {*} Whatever the property value is or whatever is defined in the `options.fallback` param
 */
function fns(_ref) {
    var _ref$ns = _ref.ns;
    var ns = _ref$ns === undefined ? '' : _ref$ns;
    var _ref$parent = _ref.parent;
    var parent = _ref$parent === undefined ? {} : _ref$parent;
    var _ref$fallback = _ref.fallback;
    var fallback = _ref$fallback === undefined ? undefined : _ref$fallback;
    var _ref$clone = _ref.clone;
    var clone = _ref$clone === undefined ? false : _ref$clone;

    var namespace = ns.split('.');
    var target = parent;
    var currentNs = undefined;
    if (!target) {
        return fallback;
    }
    while (currentNs = namespace.shift()) {
        if (target === null || target === void 0) {
            // void(0) always returned `undefined`
            // used this since `undefined` can be overwritten
            // `null` and `undefined` do not have `.hasOwnProperty`
            // so short circuit this loop here instead
            return target;
        }
        if (Array.isArray(target) || typeof target === 'string') {
            // if target is an array or a string, ensure that
            // currentNs indexes within the bounds of target
            if (currentNs % 1 !== 0 || currentNs >= target.length || currentNs < 0) {
                return fallback;
            }
        } else if (!target.hasOwnProperty(currentNs)) {
            // if the target is an object but does not have the property
            return fallback;
        }
        target = target[currentNs];
    }

    return ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' || Array.isArray(target)) && clone ? lodashClone(target) : target;
}

module.exports = function findNamespaceValue() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    if (args.length === 1) {
        var arg = args[0];
        if (typeof arg === 'string') {
            // this will ultimately return `undefined`
            // since you always need a `parent`
            return fns({
                ns: arg
            });
        }
        return fns(arg);
    }

    // backwards compat - there was never a "clone" option before es6-ifying this module
    return fns({
        ns: args[0],
        parent: args[1],
        fallback: args[2]
    });
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var inherits = __webpack_require__(59);
var hoistNonReactStatics = __webpack_require__(749);

function createComponent(Component, stores, getStateFromStores, customContextTypes) {
    var componentName = Component.displayName || Component.name;
    var componentContextTypes = Object.assign({
        getStore: PropTypes.func.isRequired
    }, customContextTypes);

    function StoreConnector(props, context) {
        React.Component.apply(this, arguments);
        this.state = this.getStateFromStores();
        this._onStoreChange = null;
        this._isMounted = false;
    }

    inherits(StoreConnector, React.Component);

    StoreConnector.displayName = 'storeConnector(' + componentName + ')';
    StoreConnector.contextTypes = componentContextTypes;

    Object.assign(StoreConnector.prototype, {
        componentDidMount: function componentDidMount() {
            this._isMounted = true;
            this._onStoreChange = this.constructor.prototype._onStoreChange.bind(this);
            stores.forEach(function storesEach(Store) {
                this.context.getStore(Store).on('change', this._onStoreChange);
            }, this);
        },
        componentWillUnmount: function componentWillUnmount() {
            this._isMounted = false;
            stores.forEach(function storesEach(Store) {
                this.context.getStore(Store).removeListener('change', this._onStoreChange);
            }, this);
        },
        componentWillReceiveProps: function componentWillReceiveProps(nextProps){
            this.setState(this.getStateFromStores(nextProps));
        },
        getStateFromStores: function (props) {
            props = props || this.props;
            return getStateFromStores(this.context, props);
        },
        _onStoreChange: function onStoreChange() {
            if (this._isMounted) {
                this.setState(this.getStateFromStores());
            }
        },
        render: function render() {
            var props = Component.prototype && Component.prototype.isReactComponent ? {ref: 'wrappedElement'} : null;
            return React.createElement(Component, Object.assign({}, this.props, this.state, props));
        }
    });

    hoistNonReactStatics(StoreConnector, Component);
    StoreConnector.WrappedComponent = Component;

    return StoreConnector;
}

/**
 * Registers change listeners and retrieves state from stores using the `getStateFromStores`
 * method. Concept provided by Dan Abramov via
 * https://medium.com/@dan_abramov/mixins-are-dead-long-live-higher-order-components-94a0d2f9e750
 *
 * Example:
 *   connectToStores(Component, [FooStore], {
 *       FooStore: function (store, props) {
 *           return {
 *               foo: store.getFoo()
 *           }
 *       }
 *   })
 *
 * Also supports the decorator pattern:
 *   @connectToStores([FooStore],  {
 *       FooStore: function (store, props) {
 *           return {
 *               foo: store.getFoo()
 *           }
 *       }
 *   })
 *   class ConnectedComponent extends React.Component {
 *       render() {
 *           return <div/>;
 *       }
 *   }
 *
 * @method connectToStores
 * @param {React.Component} [Component] component to pass state as props to.
 * @param {array} stores List of stores to listen for changes
 * @param {function} getStateFromStores function that receives all stores and should return
 *      the full state object. Receives `stores` hash and component `props` as arguments
 * @param {Object} [customContextTypes] additional `contextTypes` that could be accessed from your `getStateFromStores`
 *      function
 * @returns {React.Component} or {Function} if using decorator pattern
 */
module.exports = function connectToStores(Component, stores, getStateFromStores, customContextTypes) {

    // support decorator pattern
    if (typeof Component !== 'function') {
        var _stores = Component;
        var _getStateFromStores = stores;
        var _customContextTypes = getStateFromStores;
        return function connectToStoresDecorator(ComponentToDecorate) {
            return createComponent(ComponentToDecorate, _stores, _getStateFromStores, _customContextTypes);
        };
    }

    return createComponent.apply(null, arguments);
};


/***/ }),
/* 290 */,
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    CURRENCY_CHANGED: 'currency:changed',
    CURRENCY_LOADED: 'currency:loaded'
};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var PortfolioModel = SoaModel.extend();
var PortfolioItemModel = __webpack_require__(294);
var Backbone = __webpack_require__(3);
var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);

var relations = function () {
    return [
        {
            key: 'portfolios',
            collectionType: __webpack_require__(866),
            type: Backbone.Many
        },
        {
            key: 'items',
            collectionType: __webpack_require__(124),
            type: Backbone.Many
        },
        {
            key: 'privacySetting',
            relatedModel: SoaModel.extend(),
            type: Backbone.One
        }
    ];
};


// static properties/methods
_.extend(PortfolioModel, {
    PRIVACY_PUBLIC: 'PUBLIC',
    PRIVACY_PRIVATE: 'PRIVATE'
});

_.extend(PortfolioModel.prototype, {

    idAttribute: 'id',

    url: function () {
        return endpoints.portfolio(this.get('id') || this.get('parentId'));
    },

    defaults: {
        name: '',
        items: [],
        portfolios: [],
        itemCount: 0
    },

    relations: relations,

    removeItem: function (itemPk, itemVertical, passedOptions) {
        var portfolioItem = new PortfolioItemModel(
            {
                id : 0,
                item : {
                    id : itemPk,
                    apiType : itemVertical + 'Item'
                }
            }
        );
        portfolioItem.unset('item.seller', {silent: true}); //todo figure out how not to have to do this, null value creates error
        var options = _.extend({}, {
            url: endpoints.portfolioAddItem(this.get('id'), itemPk)
        }, passedOptions || {});
        return portfolioItem.destroy(options);
    },

    addItem: function (itemPk, itemVertical, passedOptions) {
        var portfolioItem = new PortfolioItemModel(
            {
                item : {
                    id : itemPk,
                    apiType: itemVertical + 'Item'
                }
            }
        );
        portfolioItem.unset('item.seller', {silent: true}); //todo figure out how not to have to do this, null value creates error
        var options = _.extend({}, {
            url: endpoints.portfolioAddItem(this.get('id'), itemPk)
        }, passedOptions || {});
        return portfolioItem.save({}, options);
    },

    /**
     * recursively search through 'this' portfolio and all
     * child portfolios until one with passed id is found
     */
    findChildById: function (id) {
        var models;
        var found;
        var i;

        if (this.id === id) {
            return this;
        }

        models = this.get('portfolios').models;
        for (i = 0; i < models.length; i++) {
            found = models[i].findChildById(id);
            if (found) {
                return found;
            }
        }
    },

    isP1: function () {
        return !this.get('parentId');
    },

    getDisplayName: function (p1DisplayName) {
        return this.isP1() && p1DisplayName ? p1DisplayName : this.get('name');
    },

    getNameUrl: function () {
        return this.get('name').toLowerCase().replace(/[\s\/_]+/g, '-').replace(/[^a-z0-9-]/g, '');
    },

    makePublic: function () {
        this._updatePrivacySetting(PortfolioModel.PRIVACY_PUBLIC);
    },

    makePrivate: function () {
        this._updatePrivacySetting(PortfolioModel.PRIVACY_PRIVATE);
    },

    isPublic: function () {
        return this.get('privacySetting.privacyLevel') === PortfolioModel.PRIVACY_PUBLIC;
    },

    _updatePrivacySetting: function (privacyLevel) {
        this.set('privacySetting.privacyLevel', privacyLevel);
    }

});

module.exports = PortfolioModel;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by john on 8/24/15.
 */



/**
 * Provides a way to access the same context from different entry files and the nav bar.
 * Since the nav bar is a separate file than any of the other entries, we need to allow it
 * to reference the same context as the entry files so that they can communicate.
 * @returns {{getContext: Function, setContext: Function}}
 */

function contextProvider() {

    var _setContext = void 0;
    var _reject = void 0;
    var _timeout = void 0;

    /*  Create a promise and expose its methods so they can be called in the returned ContextProvider */
    var reset = function reset() {
        return new Promise(function (resolve, reject) {
            _reject = reject;
            _setContext = function _setContext(ctx) {
                resolve(ctx);
                return ctx;
            };
        });
    };
    var _promise = reset();

    return {
        /**
         * Returns a promise that is resolved when setContext() is called with a context.
         * If the promise isn't resolved within 5 sec, rejects it.
         * @returns {Promise}
         */
        getContext: function getContext() {
            if (!_timeout) {
                _timeout = setTimeout(function () {
                    _reject("Timed out waiting for context to be set.");
                }, 5000); // wait 5sec
            }

            return _promise.then(function (ctx) {
                // clear the timeout if this promise has already been resolved
                clearTimeout(_timeout);
                return ctx;
            });
        },

        /**
         * Sets the context that will be used to resolve the getContext() promise.
         * This should be called from an entry file if not using 'createEntryPointContext()'
         * @param context
         * @returns {FluxibleContext} The original context that was passed to the function.
         */
        setContext: function setContext(context) {
            return _setContext(context);
        },

        /**
         * This should only get called for unit tests, to reset the state since this is a singleton
         * @private
         */
        _reset: function _reset() {
            _promise = reset();
            clearTimeout(_timeout);
            _timeout = null;
        }
    };
}

module.exports = contextProvider();

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SoaModel = __webpack_require__(2);
var PortfolioItem = module.exports = SoaModel.extend();
var Backbone = __webpack_require__(3);
var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var Item = __webpack_require__(34);

_.extend(PortfolioItem.prototype, {

    idAttribute: 'id',

    url: function () {
        if (this.get('id')) {
            return endpoints.portfolioItem(this.get('id'));
        } else {
            return endpoints.portfolioAddItem(0, this.get('item.id')); // requires userId in query param
        }
    },

    defaults: {
        createdDate: '',
        item: {}
    },

    relations: SoaModel.createRelations([
        {
            key: 'item',
            relatedModel: Item,
            type: Backbone.One
        }
    ])
});


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 *
 * @description Wrapper around 3rd party remote logger
 * Should be able to switch the logger out easily enough
 * if it's required in the future
 *
 * IMPORTANT: For remote logging to work, a client access
 * token must be made available
 * via serverVars.settings.clientRemoteAccessToken
 *
 */

// TODO GROWTH-1214: remove rollbar from dotcom
// We are leaving public interface as noop until we implement new relic



/**
 * @description Supported reporting levels
 * @type {string[]}
 */
var levels = ['error', 'warn', 'debug', 'info', 'log'];

exports.configure = function () {};
exports.configureLogUser = function () {};
exports.init = function () {};

/**
 * @description Get the supported log level strings
 * @returns {string[]}
 */
exports.getLevels = function () {
    return levels;
};

exports.logRemote = function () {};

/**
 * @memberOf module:log
 * @property {Function} error
 * @property {Function} warn
 * @property {Function} debug
 * @property {Function} info
 * @property {Function} log
 */
exports.remote = {};

for (var i = 0; i < levels.length; i++) {
    var level = levels[i];
    exports.remote[level] = function () {};
}

// export to global to support legacy modules
if (typeof window !== 'undefined') {
    window.dibsLog = module.exports;
}



/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var localStorageHelper = __webpack_require__(282).localStorage;

var PortfolioStore = function (_BaseStore) {
    _inherits(PortfolioStore, _BaseStore);

    function PortfolioStore(dispatcher) {
        _classCallCheck(this, PortfolioStore);

        var _this = _possibleConstructorReturn(this, (PortfolioStore.__proto__ || Object.getPrototypeOf(PortfolioStore)).call(this, dispatcher));

        _this._localItems = localStorageHelper.getItem('favoriteItems') || {};
        return _this;
    }

    _createClass(PortfolioStore, [{
        key: 'getLocalItems',
        value: function getLocalItems() {
            return this._localItems;
        }
    }, {
        key: 'canSaveLocally',
        value: function canSaveLocally() {
            return Object.keys(this._localItems).length < 3;
        }
    }, {
        key: 'localItemsCount',
        value: function localItemsCount() {
            return Object.keys(this._localItems).length;
        }
    }, {
        key: 'saveItemToStorage',
        value: function saveItemToStorage(_ref) {
            var pk = _ref.pk,
                vertical = _ref.vertical;


            this._localItems[pk] = {
                createdDate: new Date(),
                vertical: vertical
            };

            localStorageHelper.setItem('favoriteItems', this._localItems);
        }
    }, {
        key: 'isItemInStorage',
        value: function isItemInStorage(_ref2) {
            var pk = _ref2.pk;

            return !!this._localItems[pk];
        }
    }, {
        key: 'removeItemFromStorage',
        value: function removeItemFromStorage(_ref3) {
            var pk = _ref3.pk;

            delete this._localItems[pk];

            if (Object.keys(this._localItems).length) {
                localStorageHelper.setItem('favoriteItems', this._localItems);
            } else {
                this.clearItemsInStorage();
            }
        }
    }, {
        key: 'clearItemsInStorage',
        value: function clearItemsInStorage() {
            localStorageHelper.deleteItem('favoriteItems');
            this._localItems = {};
        }
    }]);

    return PortfolioStore;
}(BaseStore);

PortfolioStore.handlers = {
    'favorite:item:storage:save': 'saveItemToStorage',
    'favorite:item:storage:clear': 'clearItemsInStorage',
    'favorite:item:storage:remove': 'removeItemFromStorage'
};

PortfolioStore.storeName = 'PortfolioStore';

module.exports = PortfolioStore;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(330),
    isArguments = __webpack_require__(1094),
    isArray = __webpack_require__(64);

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/* Native method references for those with the same name as other `lodash` methods. */
var nativeKeys = getNative(Object, 'keys');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function shimKeys(object) {
  var props = keysIn(object),
      propsLength = props.length,
      length = propsLength && object.length;

  var allowIndexes = !!length && isLength(length) &&
    (isArray(object) || isArguments(object));

  var index = -1,
      result = [];

  while (++index < propsLength) {
    var key = props[index];
    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
var keys = !nativeKeys ? shimKeys : function(object) {
  var Ctor = object == null ? undefined : object.constructor;
  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
      (typeof object != 'function' && isArrayLike(object))) {
    return shimKeys(object);
  }
  return isObject(object) ? nativeKeys(object) : [];
};

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keys;


/***/ }),
/* 298 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Local Vars

var isBrowser = (typeof window !== "undefined");
var assert = __webpack_require__(31);

// ---------------------------------------------------
// Dependencies

var $;
var simplyDeferred;

if (isBrowser) {
    try {
        $ = __webpack_require__(5);
    } catch (ignore) {
        // do nothing
    }
}

if (!$ || !$.Deferred) {
    try {
        simplyDeferred = __webpack_require__(29);
    } catch (ignore) {
        // do nothing
    }
}

// ---------------------------------------------------
// Module Definition

/**
 * Returns the Deferred implementations.
 * If on the browser, returns jQuery.Deferred. If
 * on a node environment or jQuery.Deferred is not
 * available, returns simply-deferred 'Deferred'.
 * @module getDeferredMethods
 * @type {function}
 * @returns {{ Deferred: function, when: function }}
 */
module.exports = function () {
    if ($ && $.Deferred) {
        return {
            Deferred: $.Deferred,
            when: $.when
        };
    }
    assert(!!simplyDeferred, 'If jQuery and jQuery.Deferred is not present, simply-deferred module is required');
    return {
        Deferred: simplyDeferred.Deferred,
        when: simplyDeferred.when
    };
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);

var CalloutStore = function (_BaseStore) {
    _inherits(CalloutStore, _BaseStore);

    function CalloutStore(dispatcher) {
        _classCallCheck(this, CalloutStore);

        var _this = _possibleConstructorReturn(this, (CalloutStore.__proto__ || Object.getPrototypeOf(CalloutStore)).call(this, dispatcher));

        _this._callouts = {};
        _this._lastCallout = '';
        return _this;
    }

    _createClass(CalloutStore, [{
        key: 'open',
        value: function open() {
            var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var type = payload.type;


            if (type) {
                this._callouts[type] = { isOpen: true };
                this._lastCallout = type;
                this.emitChange();
            }
        }
    }, {
        key: 'close',
        value: function close(_ref) {
            var type = _ref.type;

            this._callouts[type] = { isOpen: false };
            this.emitChange();
        }
    }, {
        key: 'closeAll',
        value: function closeAll() {
            this._callouts = {};
            this.emitChange();
        }
    }, {
        key: 'getCalloutData',
        value: function getCalloutData() {
            return this._callouts;
        }
    }, {
        key: 'getLastCallout',
        value: function getLastCallout() {
            return this._lastCallout;
        }
    }]);

    return CalloutStore;
}(BaseStore);

;

CalloutStore.storeName = 'CalloutStore';

CalloutStore.handlers = {
    'callout:open': 'open',
    'callout:close': 'close',
    'callout:closeAll': 'closeAll'
};

module.exports = CalloutStore;

/***/ }),
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.3.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseIsEqual = __webpack_require__(3924),
    bindCallback = __webpack_require__(123),
    isArray = __webpack_require__(64),
    pairs = __webpack_require__(3965);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` or `undefined` values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  return value == null ? '' : (value + '');
}

/**
 * The base implementation of `_.callback` which supports specifying the
 * number of arguments to provide to `func`.
 *
 * @private
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */
function baseCallback(func, thisArg, argCount) {
  var type = typeof func;
  if (type == 'function') {
    return thisArg === undefined
      ? func
      : bindCallback(func, thisArg, argCount);
  }
  if (func == null) {
    return identity;
  }
  if (type == 'object') {
    return baseMatches(func);
  }
  return thisArg === undefined
    ? property(func)
    : baseMatchesProperty(func, thisArg);
}

/**
 * The base implementation of `get` without support for string paths
 * and default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path of the property to get.
 * @param {string} [pathKey] The key representation of path.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path, pathKey) {
  if (object == null) {
    return;
  }
  if (pathKey !== undefined && pathKey in toObject(object)) {
    path = [pathKey];
  }
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[path[index++]];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isMatch` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Array} matchData The propery names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparing objects.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = toObject(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var result = customizer ? customizer(objValue, srcValue, key) : undefined;
      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.matches` which does not clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    var key = matchData[0][0],
        value = matchData[0][1];

    return function(object) {
      if (object == null) {
        return false;
      }
      return object[key] === value && (value !== undefined || (key in toObject(object)));
    };
  }
  return function(object) {
    return baseIsMatch(object, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to compare.
 * @returns {Function} Returns the new function.
 */
function baseMatchesProperty(path, srcValue) {
  var isArr = isArray(path),
      isCommon = isKey(path) && isStrictComparable(srcValue),
      pathKey = (path + '');

  path = toPath(path);
  return function(object) {
    if (object == null) {
      return false;
    }
    var key = pathKey;
    object = toObject(object);
    if ((isArr || !isCommon) && !(key in object)) {
      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
      if (object == null) {
        return false;
      }
      key = last(path);
      object = toObject(object);
    }
    return object[key] === srcValue
      ? (srcValue !== undefined || (key in object))
      : baseIsEqual(srcValue, object[key], undefined, true);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new function.
 */
function basePropertyDeep(path) {
  var pathKey = (path + '');
  path = toPath(path);
  return function(object) {
    return baseGet(object, path, pathKey);
  };
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  start = start == null ? 0 : (+start || 0);
  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = (end === undefined || end > length) ? length : (+end || 0);
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Gets the propery names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = pairs(object),
      length = result.length;

  while (length--) {
    result[length][2] = isStrictComparable(result[length][1]);
  }
  return result;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  var type = typeof value;
  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
    return true;
  }
  if (isArray(value)) {
    return false;
  }
  var result = !reIsDeepProp.test(value);
  return result || (object != null && value in toObject(object));
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

/**
 * Converts `value` to property path array if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Array} Returns the property path array.
 */
function toPath(value) {
  if (isArray(value)) {
    return value;
  }
  var result = [];
  baseToString(value).replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
}

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array ? array.length : 0;
  return length ? array[length - 1] : undefined;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the property value at `path` on a
 * given object.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': { 'c': 2 } } },
 *   { 'a': { 'b': { 'c': 1 } } }
 * ];
 *
 * _.map(objects, _.property('a.b.c'));
 * // => [2, 1]
 *
 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
}

module.exports = baseCallback;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var keys = __webpack_require__(297);

/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.forEach` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object|string} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `baseForIn` and `baseForOwn` which iterates
 * over `object` properties returned by `keysFunc` invoking `iteratee` for
 * each property. Iteratee functions may exit iteration early by explicitly
 * returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    var length = collection ? getLength(collection) : 0;
    if (!isLength(length)) {
      return eachFunc(collection, iteratee);
    }
    var index = fromRight ? length : -1,
        iterable = toObject(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for `_.forIn` or `_.forInRight`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var iterable = toObject(object),
        props = keysFunc(object),
        length = props.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      var key = props[index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = baseEach;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {/**
 * lodash 4.5.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]/g;

/** Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns). */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dateTag] = typedArrayTags[errorTag] =
typedArrayTags[funcTag] = typedArrayTags[mapTag] =
typedArrayTags[numberTag] = typedArrayTags[objectTag] =
typedArrayTags[regexpTag] = typedArrayTags[setTag] =
typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/** Used to determine if values are of the language type `Object`. */
var objectTypes = {
  'function': true,
  'object': true
};

/** Detect free variable `exports`. */
var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
  ? exports
  : undefined;

/** Detect free variable `module`. */
var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
  ? module
  : undefined;

/** Detect free variable `global` from Node.js. */
var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);

/** Detect free variable `self`. */
var freeSelf = checkGlobal(objectTypes[typeof self] && self);

/** Detect free variable `window`. */
var freeWindow = checkGlobal(objectTypes[typeof window] && window);

/** Detect `this` as the global object. */
var thisGlobal = checkGlobal(objectTypes[typeof this] && this);

/**
 * Used as a reference to the global object.
 *
 * The `this` value is used if it's the global object to avoid Greasemonkey's
 * restricted `window` object, otherwise the `window` object is used.
 */
var root = freeGlobal ||
  ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
    freeSelf || thisGlobal || Function('return this')();

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check, else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the new array of key-value pairs.
 */
function baseToPairs(object, props) {
  return arrayMap(props, function(key) {
    return [key, object[key]];
  });
}

/**
 * Checks if `value` is a global object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
 */
function checkGlobal(value) {
  return (value && value.Object === Object) ? value : null;
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Converts `map` to an array.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the converted array.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Converts `set` to an array.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the converted array.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototypeOf = Object.getPrototypeOf,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object.keys;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var mapCtorString = Map ? funcToString.call(Map) : '',
    setCtorString = Set ? funcToString.call(Set) : '',
    weakMapCtorString = WeakMap ? funcToString.call(WeakMap) : '';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates an hash object.
 *
 * @private
 * @constructor
 * @returns {Object} Returns the new hash object.
 */
function Hash() {}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(hash, key) {
  return hashHas(hash, key) && delete hash[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @param {Object} hash The hash to query.
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(hash, key) {
  if (nativeCreate) {
    var result = hash[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(hash, key) ? hash[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @param {Object} hash The hash to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(hash, key) {
  return nativeCreate ? hash[key] !== undefined : hasOwnProperty.call(hash, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 */
function hashSet(hash, key, value) {
  hash[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function MapCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.clear();
  while (++index < length) {
    var entry = values[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': Map ? new Map : [],
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapDelete(key) {
  var data = this.__data__;
  if (isKeyable(key)) {
    return hashDelete(typeof key == 'string' ? data.string : data.hash, key);
  }
  return Map ? data.map['delete'](key) : assocDelete(data.map, key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapGet(key) {
  var data = this.__data__;
  if (isKeyable(key)) {
    return hashGet(typeof key == 'string' ? data.string : data.hash, key);
  }
  return Map ? data.map.get(key) : assocGet(data.map, key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapHas(key) {
  var data = this.__data__;
  if (isKeyable(key)) {
    return hashHas(typeof key == 'string' ? data.string : data.hash, key);
  }
  return Map ? data.map.has(key) : assocHas(data.map, key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache object.
 */
function mapSet(key, value) {
  var data = this.__data__;
  if (isKeyable(key)) {
    hashSet(typeof key == 'string' ? data.string : data.hash, key, value);
  } else if (Map) {
    data.map.set(key, value);
  } else {
    assocSet(data.map, key, value);
  }
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function Stack(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.clear();
  while (++index < length) {
    var entry = values[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = { 'array': [], 'map': null };
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      array = data.array;

  return array ? assocDelete(array, key) : data.map['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  var data = this.__data__,
      array = data.array;

  return array ? assocGet(array, key) : data.map.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  var data = this.__data__,
      array = data.array;

  return array ? assocHas(array, key) : data.map.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache object.
 */
function stackSet(key, value) {
  var data = this.__data__,
      array = data.array;

  if (array) {
    if (array.length < (LARGE_ARRAY_SIZE - 1)) {
      assocSet(array, key, value);
    } else {
      data.array = null;
      data.map = new MapCache(array);
    }
  }
  var map = data.map;
  if (map) {
    map.set(key, value);
  }
  return this;
}

/**
 * Removes `key` and its value from the associative array.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function assocDelete(array, key) {
  var index = assocIndexOf(array, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = array.length - 1;
  if (index == lastIndex) {
    array.pop();
  } else {
    splice.call(array, index, 1);
  }
  return true;
}

/**
 * Gets the associative array value for `key`.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function assocGet(array, key) {
  var index = assocIndexOf(array, key);
  return index < 0 ? undefined : array[index][1];
}

/**
 * Checks if an associative array value for `key` exists.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function assocHas(array, key) {
  return assocIndexOf(array, key) > -1;
}

/**
 * Gets the index at which the first occurrence of `key` is found in `array`
 * of key-value pairs.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * Sets the associative array `key` to `value`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 */
function assocSet(array, key, value) {
  var index = assocIndexOf(array, key);
  if (index < 0) {
    array.push([key, value]);
  } else {
    array[index][1] = value;
  }
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function baseCastPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path + ''] : baseCastPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[path[index++]];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
  // that are composed entirely of index properties, return `false` for
  // `hasOwnProperty` checks of them.
  return hasOwnProperty.call(object, key) ||
    (typeof object == 'object' && key in object && getPrototypeOf(object) === null);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual` for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      stack || (stack = new Stack);
      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack,
          result = customizer ? customizer(objValue, srcValue, key, object, source, stack) : undefined;

      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  var type = typeof value;
  if (type == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (type == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  return nativeKeys(Object(object));
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    var key = matchData[0][0],
        value = matchData[0][1];

    return function(object) {
      if (object == null) {
        return false;
      }
      return object[key] === value &&
        (value !== undefined || (key in Object(object)));
    };
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new function.
 */
function baseMatchesProperty(path, srcValue) {
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual` for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var index = -1,
      isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      isUnordered = bitmask & UNORDERED_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked) {
    return stacked == other;
  }
  var result = true;
  stack.set(array, other);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (isUnordered) {
      if (!arraySome(other, function(othValue) {
            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack);
          })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual` for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
      return +object == +other;

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case numberTag:
      // Treat `NaN` vs. `NaN` as equal.
      return (object != +object) ? other != +other : object == +other;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings primitives and string
      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      // Recursively compare objects (susceptible to call stack limits).
      return equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask | UNORDERED_COMPARE_FLAG, stack.set(object, other));

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual` for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : baseHas(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  return result;
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = toPairs(object),
      length = result.length;

  while (length--) {
    result[length][2] = isStrictComparable(result[length][1]);
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function getTag(value) {
  return objectToString.call(value);
}

// Fallback for IE 11 providing `toStringTag` values for maps, sets, and weakmaps.
if ((Map && getTag(new Map) != mapTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : null,
        ctorString = typeof Ctor == 'function' ? funcToString.call(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case mapCtorString: return mapTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  if (object == null) {
    return false;
  }
  var result = hasFunc(object, path);
  if (!result && !isKey(path)) {
    path = baseCastPath(path);
    object = parent(object, path);
    if (object != null) {
      path = last(path);
      result = hasFunc(object, path);
    }
  }
  var length = object ? object.length : undefined;
  return result || (
    !!length && isLength(length) && isIndex(path, length) &&
    (isArray(object) || isString(object) || isArguments(object))
  );
}

/**
 * Creates an array of index keys for `object` values of arrays,
 * `arguments` objects, and strings, otherwise `null` is returned.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array|null} Returns index keys, else `null`.
 */
function indexKeys(object) {
  var length = object ? object.length : undefined;
  if (isLength(length) &&
      (isArray(object) || isString(object) || isArguments(object))) {
    return baseTimes(length, String);
  }
  return null;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (typeof value == 'number') {
    return true;
  }
  return !isArray(value) &&
    (reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
      (object != null && value in Object(object)));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'number' || type == 'boolean' ||
    (type == 'string' && value != '__proto__') || value == null;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length == 1 ? object : get(object, baseSlice(path, 0, -1));
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
function stringToPath(string) {
  var result = [];
  toString(string).replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
}

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array ? array.length : 0;
  return length ? array[length - 1] : undefined;
}

/**
 * Performs a [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'user': 'fred' };
 * var other = { 'user': 'fred' };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type {Function}
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object, else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(funcToString.call(value));
  }
  return isObjectLike(value) &&
    (isHostObject(value) ? reIsNative : reIsHostCtor).test(value);
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
function isTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (value == null) {
    return '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined` the `defaultValue` is used in its place.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': _.create({ 'c': 3 }) }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b.c');
 * // => true
 *
 * _.hasIn(object, ['a', 'b', 'c']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  var isProto = isPrototype(object);
  if (!(isProto || isArrayLike(object))) {
    return baseKeys(object);
  }
  var indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  for (var key in object) {
    if (baseHas(object, key) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
        !(isProto && key == 'constructor')) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of own enumerable key-value pairs for `object` which
 * can be consumed by `_.fromPairs`.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the new array of key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
function toPairs(object) {
  return baseToPairs(object, keys(object));
}

/**
 * This method returns the first argument given to it.
 *
 * @static
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': { 'c': 2 } } },
 *   { 'a': { 'b': { 'c': 1 } } }
 * ];
 *
 * _.map(objects, _.property('a.b.c'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
}

// Avoid inheriting from `Object.prototype` when possible.
Hash.prototype = nativeCreate ? nativeCreate(null) : objectProto;

// Add functions to the `MapCache`.
MapCache.prototype.clear = mapClear;
MapCache.prototype['delete'] = mapDelete;
MapCache.prototype.get = mapGet;
MapCache.prototype.has = mapHas;
MapCache.prototype.set = mapSet;

// Add functions to the `Stack` cache.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = baseIteratee;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module), __webpack_require__(4)))

/***/ }),
/* 313 */,
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArguments = __webpack_require__(1094),
    isArray = __webpack_require__(64);

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keysIn;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by matthew.prestifilippo on 11/24/14.
 */


var $ = __webpack_require__(5);
var _ = __webpack_require__(0);

var generate = function (transition, options) {
    options = options || {};
    return function (ajaxOptions) {
        var args = [].slice.call(arguments);
        var attrs;
        ajaxOptions = args.pop();
        attrs = args.shift();
        ajaxOptions = ajaxOptions || {};
        if (options.allowedOnNew || !this.isNew()) {
            ajaxOptions = $.extend(true, ajaxOptions, {
                queries: {
                    workflowAction: transition
                }
            });
        }
        return this.constructor.__super__.save.call(this, attrs, ajaxOptions);
    };
};

module.exports = {
    transition: generate('transition'),
    updateAndTransition: generate('updateAndTransition'),
    update: generate('update', { allowedOnNew: true }),
    save: function (attrs, options) {
        var workflowAction = 'update';
        var attributes = attrs || this.toJSON();
        var hasChangedAttrs = JSON.stringify(_.omit(this.lastSyncAttributes(), 'status')) !== JSON.stringify(_.omit(attributes, 'status'));
        var hasChangedStatus = this.lastSyncAttributes().status !== attributes.status;
        if (hasChangedAttrs && hasChangedStatus) {
            workflowAction = 'updateAndTransition';
        }
        else if (hasChangedStatus) {
            workflowAction = 'transition';
        }
        if (this.isNew()) {
            return this.constructor.__super__.save.call(this, attributes, options);
        }
        return this[workflowAction](attributes, options);
    }
};


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by james on 5/1/14.
 */


// ---------------------------------------------------
// Require Super PseudoClass

var SoaModel = __webpack_require__(2);

// ---------------------------------------------------
// Define Module

/**
 * @class ServiceMethod
 * @extends SoaModel
 */
var ServiceMethod = module.exports = SoaModel.extend();

// ---------------------------------------------------
// Require Dependencies

var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var DP = __webpack_require__(780);
var serviceMethodDisplayDPConfig = __webpack_require__(2628);
var Period = __webpack_require__(116);
var Region = __webpack_require__(1625);
var Backbone = __webpack_require__(3);
var Seller = __webpack_require__(105);
var SoaCollection = __webpack_require__(9);
var serviceMethodDisplay = __webpack_require__(2824);
var globalCache = __webpack_require__(1092);
var getDeferredMethods = __webpack_require__(299);

// Register the async data config
DP.addAsyncConfig(serviceMethodDisplayDPConfig);

// ---------------------------------------------------
// Local Vars

var deferred = getDeferredMethods().Deferred;
var displayInfoCacheKey = Symbol('fetching_seller_method_display_info');

// ---------------------------------------------------
// Define Module Static Properties

_.extend(ServiceMethod, {
    METHOD_STANDARD: 'STANDARD',
    METHOD_EXPRESS: 'EXPRESS',
    METHOD_MESSENGER: 'MESSENGER',
    METHOD_LOCAL_PICKUP: 'LOCAL_PICKUP',
    METHOD_FRONT_DOOR: 'FRONT_DOOR',
    SERVICE_WHITE_GLOVE: 'WHITE_GLOVE',
    SERVICE_FREIGHT: 'FREIGHT',
    SERVICE_PARCEL: 'PARCEL',

    /**
     * Returns a singleton collection that is
     * intended to be used to store display data for
     * the seller service methods.
     * @returns {SoaCollection}
     */
    getSellerMethodDisplayCollection: function getSellerMethodDisplayCollection() {
        if (!ServiceMethod._sellerMethodDisplayInfo) {
            ServiceMethod._sellerMethodDisplayInfo = new SoaCollection();
        }
        return ServiceMethod._sellerMethodDisplayInfo;
    },

    /**
     * Fetches the seller method display value reference sets from
     * the query service, unless they have already been fetched.
     * If they have already been fetched, returns the existing promise.
     * @returns {Deferred.promise}
     */
    fetchSellerMethodDisplayCollection: function fetchSellerMethodDisplayCollection() {
        var displayInfoProm = globalCache.get(displayInfoCacheKey);
        if (!displayInfoProm) {
            var self = this;
            displayInfoProm = deferred().resolve(serviceMethodDisplay).promise();
            globalCache.set(displayInfoCacheKey, displayInfoProm);
            displayInfoProm.done(function (json) {
                self.getSellerMethodDisplayCollection().reset(json);
            });
            displayInfoProm.fail(function () {
                globalCache.del(displayInfoCacheKey);
            });
        }
        return displayInfoProm;
    }

});

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(ServiceMethod.prototype, {
    url: endpoints.shipmentServiceMethod(),
    relations: SoaModel.createRelations([{
        type: Backbone.One,
        key: 'windowMax',
        relatedModel: Period
    }, {
        type: Backbone.One,
        key: 'windowMin',
        relatedModel: Period
    }, {
        type: Backbone.One,
        key: 'region',
        relatedModel: Region
    }, {
        type: Backbone.One,
        key: 'windowMinLimit',
        relatedModel: Period
    }, {
        type: Backbone.One,
        key: 'windowMaxLimit',
        relatedModel: Period
    }]),

    /**
     * @returns {boolean}
     */
    isWhiteGlove: function isWhiteGlove() {
        return ServiceMethod.SERVICE_WHITE_GLOVE === this.get("serviceType");
    },

    /**
     * @returns {boolean}
     */
    isFrontDoor: function isFrontDoor() {
        return ServiceMethod.METHOD_FRONT_DOOR === this.get("serviceMethodType");
    },

    /**
     * @returns {string}
     */
    getShipmentType: function getShipmentType() {
        var serviceMethodType = this.get('serviceMethodType');
        switch (serviceMethodType) {
            case 'LOCAL_PICKUP':
            case 'TYPE_EXTERNALLY_ARRANGED':
                return serviceMethodType;
            default:
                return 'FIRSTDIBS_FACILITATED';
        }
    },

    /**
     * @returns {boolean}
     */
    isLocalPickup: function isLocalPickup() {
        return ServiceMethod.METHOD_LOCAL_PICKUP === this.get("serviceMethodType");
    },

    /**
     * @returns {boolean}
     */
    isParcel: function isParcel() {
        return ServiceMethod.SERVICE_PARCEL === this.get('serviceType');
    },

    /**
     * Retrieves the display value for service method
     * serviceMethodType/serviceType combinations that
     * are intended for sellers.
     * @param {string} [vertical]
     *      One of 'furniture', 'art', 'fashion', or
     *      'jewelry'. Defaults to current seller
     *      vertical.
     * @param {string} [serviceMethodType]
     *      Enum string val for serviceMethodType.
     *      Defaults to model's serviceMethodType
     * @param {string} [serviceType]
     *      Enum string val for serviceType. Defaults
     *      to the model's serviceType value.
     * @returns {string}
     */
    getSellerMethodDisplayVal: function getSellerMethodDisplayVal(vertical, serviceMethodType, serviceType) {

        serviceMethodType = serviceMethodType || this.get('serviceMethodType');
        serviceType = serviceType || this.get('serviceType');

        var sellerDisplayReferences = ServiceMethod.getSellerMethodDisplayCollection();
        var i = 0;
        var referenceModel;
        var seller;

        if (!vertical) {
            seller = Seller.getCurrentSeller();
            vertical = seller ? seller.get('vertical') : null;
            if (!vertical) {
                return null;
            }
        }

        for (i; i < sellerDisplayReferences.length; i++) {
            referenceModel = sellerDisplayReferences.at(i);
            if (referenceModel.get('serviceType') === serviceType && referenceModel.get('serviceMethodType') === serviceMethodType && _.indexOf(referenceModel.get('verticals'), vertical) > -1) {
                return referenceModel.get('displayName');
            }
        }
        return null;
    }
});

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArguments = __webpack_require__(1094),
    isArray = __webpack_require__(64);

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * The base implementation of `_.flatten` with added support for restricting
 * flattening and specifying the start index.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {boolean} [isDeep] Specify a deep flatten.
 * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, isDeep, isStrict, result) {
  result || (result = []);

  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index];
    if (isObjectLike(value) && isArrayLike(value) &&
        (isStrict || isArray(value) || isArguments(value))) {
      if (isDeep) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, isDeep, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = baseFlatten;


/***/ }),
/* 318 */,
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by james on 4/30/14.
 */


// ---------------------------------------------------
// Load Super PseudoClass Module
var SoaModel = __webpack_require__(2);
var SoaCollection = __webpack_require__(9);
var endpoints = __webpack_require__(6);

// ---------------------------------------------------
// Define Module

/**
 * @class ShipmentQuotes
 * @extends SoaCollection
 */
var ShipmentQuotes = module.exports = SoaCollection.extend();

// ---------------------------------------------------
// Dependencies

var ShipmentQuote = __webpack_require__(74);
var _ = __webpack_require__(0);
var ServiceMethod = __webpack_require__(316);

// ---------------------------------------------------
// Local vars

var regionIdField = 'serviceMethod.region.id';
var serviceMethodTypeField = 'serviceMethod.serviceMethodType';
var regionCodeField = 'serviceMethod.region.code';

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(ShipmentQuotes.prototype, {

    model: ShipmentQuote,

    /**
     * Find the first ShipmentQuote with a
     * service method type for local pickup
     * @returns {ShipmentQuote}
     */
    findLocalPickupQuote: function () {
        return this._whereFieldValsIn([ServiceMethod.METHOD_LOCAL_PICKUP], serviceMethodTypeField, true);
    },

    /**
     * @returns {boolean}
     */
    hasLocalPickupQuote: function () {
        return !!this.findLocalPickupQuote();
    },

    /**
     * Returns an array of shipment quotes form
     * the collection instance with the local
     * pickup quote omitted
     * @returns {ShipmentQuote[]}
     */
    noLocalPickupQuotes: function () {
        return _.reject(this.models, function (model) {
            return model.isLocalPickup();
        });
    },

    /**
     * @returns {boolean}
     */
    hasFreeQuote: function () {
        return _.some(this.models, function (model) {
            return model.isComplimentaryShipping();
        });
    },

    /**
     * @returns {boolean}
     */
    isComplementaryEverywhere: function () {
        var hasAllFreeQuotes;
        var coversAllRegions;

        hasAllFreeQuotes = _.every(this.models, function (model) {
            if (model.regionIsWorld()) {
                coversAllRegions = true;
            }
            return model.isComplimentaryShipping();
        });

        return hasAllFreeQuotes && coversAllRegions;
    },

    /**
     * @returns {boolean}
     */
    hasOnlyGlobal: function () {
        return _.every(this.models, function (model) {
            return model.get('serviceMethod.region.code') === 'REST_OF_WORLD';
        });
    },

    /**
     * Given a serviceMethodType and a serviceType, find
     * the first shipment quote that matches both
     * @param {string} serviceMethodType
     * @param {string} serviceType
     * @returns {ShipmentQuote}
     */
    findQuoteFromMethodAttrs: function (serviceMethodType, serviceType) {
        return this.find(function (quote) {
            var serviceMethod = quote.get('serviceMethod');
            var sameMethodType;
            var sameServiceType;
            if (serviceMethod) {
                sameMethodType = serviceMethod.get('serviceMethodType') === serviceMethodType;
                sameServiceType = serviceMethod.get('serviceType') === serviceType;
            }
            return serviceMethod && sameMethodType && sameServiceType;
        });
    },

    /**
     * Find a region by code
     * @returns {ShipmentQuote}
     */
    findRegionByCode: function (code) {
        return this._whereFieldValsIn([code], regionCodeField, true);
    },

    /**
     * Find the all regions for a given id
     * Assumes serviceMethod is inflated
     * @param id
     * @returns {ShipmentQuote[]}
     */
    whereRegion: function (id) {
        return this._whereFieldValsIn([id], regionIdField, false);
    },
    /**
     * Find the first region that matches
     * an id
     * Assumes serviceMethod is inflated.
     * @param id
     * @returns {ShipmentQuote}
     */
    findWhereRegion: function (id) {
        return this._whereFieldValsIn([id], regionIdField, true);
    },
    /**
     * Find all shipment quotes a list of ids.
     * Assumes serviceMethod is inflated.
     * @param {string[]|number[]} ids
     * @returns {ShipmentQuote[]}
     */
    whereRegionIn: function (ids) {
        return this._whereFieldValsIn(ids, regionIdField, false);
    },
    /**
     * Find the first shipment quote
     * that has an id in the passed
     * array of ids.
     * Assumes serviceMethod is inflated.
     * @param {string[]|number[]} ids
     * @returns {ShipmentQuote}
     */
    findWhereRegionIn: function (ids) {
        return this._whereFieldValsIn(ids, regionIdField, true);
    },
    /**
     * Find the first models for each region in
     * the collection.
     * @returns {ShipmentQuote[]}
     */
    firstModelsForRegions: function () {
        var regIds = [];
        return this.reject(function (model) {
            var regId = model.get(regionIdField);
            if (_.indexOf(regIds, regId) > -1) {
                return true;
            }
            regIds.push(regId);
            return false;
        });
    },
    /**
     * Helper method to find models based
     * on a field (supports relational fields)
     * that have a value contained in a list
     * of passed values
     * @param {Array} vals The values to match
     * @param {string} field The field to find a match for
     * @param {boolean} returnFirstMatch
     *      Should return the first match and stop the search
     * @returns {ShipmentQuote|ShipmentQuotes[]|undefined}
     * @private
     */
    _whereFieldValsIn: function (vals, field, returnFirstMatch) {
        var matches = [];
        var i = 0;
        var fieldVal;
        var model;
        var len = this.models.length;
        for (i; i < len; i++) {
            model = this.at(i);
            fieldVal = model.get(field);
            if (_.indexOf(vals, fieldVal) > -1) {
                if (returnFirstMatch) {
                    return model;
                }
                matches.push(model);
            }
        }
        return returnFirstMatch ? undefined : matches;
    },

    /**
     * Checks the shipmentQuotes collection for fields validation
     * with logistics service
     * @returns {Object}
     */
    validateAgainstServices: function () {
        var self = this;
        var shipmentQuotesModel = new SoaModel({
            dataList: self
        }, {
            url : function () {
                return endpoints.shipmentQuotes() + '/validate';
            }
        });
        return shipmentQuotesModel.save();
    },
    /**
     * Fetches available shipping options for the passed address and item
     * @param address an address model
     * @param item an item model
     */
    fetchAvailableOptions: function (item, address, currencyConversionRateEventId) {
        var addressFields = ['zipCode', 'city', 'state', 'country'];
        var data = {};

        if (address) {
            data = _.reduce(addressFields, function (data, field) {
                var value = address.get(field);
                if (value) {
                    data['address.' + field] = value;
                }
                return data;
            }, {});
        }

        if (currencyConversionRateEventId) {
            data.currencyConversionRateEventId = currencyConversionRateEventId;
        }

        if (item.id) {
            data.itemId = item.id;
        }

        return this.fetch({
            data: data,
            url: endpoints.availableOptions()
        });
    },
    getLocalShipmentQuotes: function () {
        return this.filter(function (quote) {
            return quote.isLocalPickup();
        });
    },
    getNonLocalShipmentQuotes: function () {
        return this.reject(function (quote) {
            return quote.isLocalPickup();
        });
    },

    hasMultipleNonLocalShipmentQuotes: function () {
        var quotes = this.getNonLocalShipmentQuotes();
        return quotes && quotes.length > 1;
    },

    /**
     * Returns currency of first valid(one which has the currency) shipment
     * quotes (e.g. USD, GBP, EUR).
     * @returns {string}
     */
    getFirstValidQuoteCurrency: function () {
        var i = 0;
        var val;
        for (i; i < this.models.length; i++) {
            val = this.at(i).getFirstCostCurrency();
            if (val) {
                return val;
            }
        }
        return null;
    }

});


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {
(function (root, factory) {
    'use strict';
    var _export;

    if (true) {
        // CommonJS
        factory(module, __webpack_require__(0), __webpack_require__(3));
        _export = module.exports;
    } else {
        // browser globals
        var _m = {};

        factory(_m, root._, root.Backbone);
        _export = _m.exports;
    }

    root.bunsen = root.bunsen || {};
    root.bunsen.currency = _export;
}(typeof window === 'undefined' ? global : window, function (module, _, Backbone) {
    'use strict';

    var allCurrencies;
    var dictionary = {};
    var Currency = function (name, enumValue, symbol) {
        this.name = name;
        this.enumValue = enumValue;
        this.symbol = symbol;
    };

    /**
     * For the given Currency Name, Currency ENUM or Currency Symbol
     * try to pull up the canonical Currency instance
     * If a Currency instance is passed in, it's returned back
     * @param {String|Currency} lookupBy
     * @returns {Currency|undefined}
     */
    var lookupCurrency = function (lookupBy) {
        if (lookupBy instanceof Currency) {
            return lookupBy;
        }
        return dictionary[('' + lookupBy).toLowerCase()];
    };

    /**
     * Round the given number to the given precision
     * @param {number} what
     * @param {number} precision
     * @returns {number}
     */
    function round(what, precision) {
        precision = parseInt(precision, 10) || 0;
        return Math.round((parseFloat(what) * Math.pow(10, precision))) / Math.pow(10, precision);
    }

    function buildObj(key, value, filter) {
        var lookup = {};
        _.each(allCurrencies, function (C) {
            if (!filter || filter(C)) {
                lookup[C[key]] = C[value];
            }
        });
        return lookup;
    }

    /**
     * With the given conversion rate(s), and with the given
     * precision, convert the given amount from this currency to
     * the given currency
     * @param {String|Currency} fromAmount
     * @param {String|Currency} toCurrency
     * @param {CurrencyConversionRate|Backbone.Collection} rates
     * @param {number} precision
     * @returns {number|undefined}
     */
    Currency.prototype.convert = function (fromAmount, toCurrency, rates, precision) {
        var rate, self;
        if (!(toCurrency instanceof Currency)) {
            toCurrency = lookupCurrency(toCurrency);
        }
        if (!toCurrency) {
            return void 0;
        }
        self = this;
        if (precision === void 0) {
            precision = 2;
        }
        if (self === toCurrency) {
            return round(fromAmount, precision);
        }
        if (rates instanceof Backbone.Collection) {
            rates.each(function (oneRate) {
                if (oneRate.canConvert(self, toCurrency)) {
                    rate = oneRate;
                }
            });
        } else if (typeof rates.canConvert === 'function' && rates.canConvert(self, toCurrency)) {
            rate = rates;
        }
        if (!rate) {
            return void 0;
        }
        return rate.convert(fromAmount, self, toCurrency, precision);
    };

    allCurrencies = [
        new Currency('US Dollar', 'USD', '$'),
        new Currency('Canadian Dollar', 'CAD', 'C $'),
        new Currency('British Pound', 'GBP', '&pound;'),
        new Currency('Euro', 'EUR', '&euro;')
    ];

    /**
     * Adding canonical instances to the dictionary
     */
    _.each(allCurrencies, function (C) {
        dictionary[('' + C.name).toLowerCase()] = C;
        dictionary[('' + C.enumValue).toLowerCase()] = C;
        dictionary[('' + C.symbol).toLowerCase()] = C;
    });

    lookupCurrency.getSymbol = function (c) {
        var currencyObj = lookupCurrency(c);
        if (currencyObj) {
            return currencyObj.symbol;
        }
    };

    lookupCurrency.buildObj = buildObj;
    module.exports = lookupCurrency;
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(70)(module)))

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by devpatel on 3/28/14.
 */


var SoaModel = __webpack_require__(2);
var ReturnPolicy = module.exports = SoaModel.extend();

var Items = __webpack_require__(130);
var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var Seller = __webpack_require__(105);

_.extend(ReturnPolicy.prototype, {
    url : function () {
        var url = endpoints.returnPolicy(this.get('id'));
        return url;
    },
    defaults: {
        defaultPolicy: 'N',
        accept : 'N'
    },

    /**
     * Applies current policy to itemIds passed
     * @param itemIdsArray
     * @returns {Deferred}
     */
    saveForItems: function (itemIdsArray) {
        var dfd = new $.Deferred();
        this.saveWithQueryParameters(null, {
            url: endpoints.itemsReturnPolicy(),
            queries: {
                newReturnPolicyId: this.get('id'),
                itemId: itemIdsArray.join()
            }
        }).done(function () {
            dfd.resolve();
        }).fail(function () {
            dfd.reject('replace');
        });
        return dfd;
    },

    /**
     * Delete this return policy and replace all items with the passed in return policy
     * @param replaceWith
     */
    replaceAndDelete: function (replaceWith) {
        var dfd = new $.Deferred();
        var self = this;
        this.saveWithQueryParameters(null, {
            url: endpoints.itemsReturnPolicy(),
            queries: {
                oldReturnPolicyId: this.get('id'),
                newReturnPolicyId: replaceWith.get('id')
            }
        }).done(function () {
            //another call to actually delete policy
            self.destroy().done(function () {
                dfd.resolve();
            }).fail(function () {
                dfd.reject('delete');
            });
        }).fail(function () {
            dfd.reject('replace');
        });
        return dfd;
    },

    fetchItemsAffected: function () {
        var self = this;
        var dfd = new $.Deferred();
        var items = new Items();
        var sellerIds = Seller.getCurrentSeller().get('id');

        items.fetch({
            data: {
                sellerIds: sellerIds,
                pageSize: 0,
                returnPolicyIds: this.get('id'),
                returnTotalResults: true
            }
        }).done(function (data) {
            self.itemsAffected = data.totalResults;
            dfd.resolve();
        }).fail(function () {
            dfd.reject();
        });
        return dfd;
    },

    acceptsReturns: function () {
        // === true is for graphql response...
        return this.get('accept') === 'Y' || this.get('accept') === true;
    },

    isDefault: function () {
        return this.get('defaultPolicy') === 'Y';
    }

});


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Joe Forzano
 * Date: August 20th, 2014
 * Time: 3:15 PM
 */


// ---------------------------------------------------
// Load Module Super PseudoClass

var SoaModel = __webpack_require__(2);


// ---------------------------------------------------
// Module Definition
/**
 * @class Carrier
 * @extends SoaModel
 */
var Carrier = module.exports = SoaModel.extend();


// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var Backbone = __webpack_require__(3);
var Carriers = __webpack_require__(2205);
var ServiceMethod = __webpack_require__(316);


// ---------------------------------------------------
// Define Module Instance Properties

_.extend(Carrier.prototype, {

    url: endpoints.carrier(),

    relations: SoaModel.createRelations([
        {
            type : Backbone.Many,
            key : 'shipmentServiceMethods',
            relatedModel : ServiceMethod
        }
    ]),

    /**
     * Returns the defaults service method for the carrier. As of now, there's only one service method, but
     * if multiple service methods are attached to a carrier in the future, the logic for selecting the default
     * should be housed here.
     * @returns {object} -- ServiceMethod
     */
    getDefaultShipmentServiceMethod: function () {
        return this.get('shipmentServiceMethods').first();
    },

    /**
     * Returns the name on the carrier model, or if that isn't defined, returns the name
     * associated with the carrier's id (looked up on currently fetched carriers)
     * @returns {string}
     */
    getCarrierName: function () {
        return this.get('name') || Carriers.getCarrierName(this.get('id'));
    },

    /**
     * @returns {string}
     */
    describeCarrierName: function () {
        var name = this.getCarrierName();
        if (this.isOtherCarrier() && !this.carrierNameIsOther()) {
            return 'Other - ' + name;
        }
        return name;
    },

    /**
     * Return true if carrier name is "other". This is to avoid
     * redundancy.
     * @returns {string|boolean}
     */
    carrierNameIsOther: function () {
        var name = this.getCarrierName();
        return name && name.toLowerCase() === Carrier.CARRIER_NAME_OTHER;
    },

    /**
     * Returns true when the carrier code is OTHER
     * @returns {boolean}
     */
    isOtherCarrier: function () {
        return this.get('code') === Carrier.CARRIER_CODE_OTHER;
    }

});

_.extend(Carrier, /** @lends Carrier */{
    CARRIER_CODE_OTHER: 'OTHER',
    CARRIER_NAME_OTHER: 'other'
});


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * 1stdibs
 * User: James
 * Date: 11/7/13
 */
(function (root, factory) {
    "use strict";

    var m;
    if (true) {
        m = module;
        // CommonJS
        factory(m, __webpack_require__(3), __webpack_require__(22));
    } else {
        m = {};
        // Browser globals
        factory(m, root.Backbone, root._);
        //no need to export as it should attach itself to BaseView
    }

    // Attach to bunsen for non-CommonJS
    root.bunsen = root.bunsen || {};
    root.bunsen.marinate = m.exports;

}(typeof window !== 'undefined' ? window : global, function (module, Backbone, _) {
    // Define Module
    "use strict";

    var marinate;
    var _slice = Array.prototype.slice;
    var _randZeroPadding = 1000000000;
    var getFunc = function (obj, func) {
        if (typeof func === 'function') {
            return func;
        }
        if (typeof func === 'string') {
            return obj[func];
        }
        return undefined;
    };
    var addEventNamespace = function (eventKey, namespace) {
        var splitKey = eventKey.split(' ');
        eventKey = splitKey[0] + ('.' + namespace);
        eventKey += (splitKey[1] ? ' ' + splitKey[1] : '');
        return eventKey;
    };
    var _addEvents = function (view, name, eventsObj) {
        var key;
        var val;
        var areNamespaced = false;
        view.addedEvents = view.addedEvents || {};
        if (typeof name !== 'string') {
            eventsObj = name;
            name = false;
        }
        for (key in eventsObj) {
            if (eventsObj.hasOwnProperty(key)) {
                val = eventsObj[key];
                areNamespaced = (!_.isString(val) && !_.isFunction(val));
                break;
            }
        }
        if (areNamespaced) {
            _.extend(view.addedEvents, eventsObj);
        } else {
            view.addedEvents[name || _.size(view.addedEvents)] = eventsObj;
        }
        return view;
    };
    var _marinate = function (view, args) {
        _.each(args, function (mixin) {
            if (mixin.addedEvents) {
                _addEvents(view, mixin.addedEvents);
            }
            _.extend(view, _.omit(mixin, 'addedEvents'));
        });
        return view;
    };

    _.extend(Backbone.BaseView.prototype, {
        addEvents : function (name, events) {
            _addEvents(this, name, events);
            return this;
        },
        removeAddedEvents : function (name, undelegate) {
            delete this.addedEvents[name];
            if (undelegate) {
                this.$el.off('.' + name);
            }
            return this;
        },
        marinate: function () {
            _marinate(this, Array.prototype.slice.call(arguments));
            return this;
        }
    });


    /**
     * Overrides delegateEvents, only changing behavior if the view
     * instance has an 'addedEvents' property defined. This will
     * create an events object that has all events from the '.events'
     * property and the 'addedEvents' property. Added events
     * should be namespaced on a key (or autonamespaced).
     *
     * @override
     * @memberof Backbone.BaseView#
     * @param {object} [events]
     *      If provided, these will be used as the events instead of
     *      the events found in the events and addedEvents object
     * @param {boolean} [includeAdded]
     *      If true, and an events object is passed as a first param
     *      then instead of only using delegating events passed in
     *      as the first param, the events stored in the 'addedEvents'
     *      property are also delegated
     * @returns {Backbone.BaseView}
     */
    Backbone.BaseView.prototype.delegateEvents = function (events, includeAdded) {
        if ((!events || includeAdded) && this.addedEvents) {
            events = _.clone(_.result(this, 'events')) || {};
            var groupName;
            var eventKey;
            var callback;
            var addedEvents;
            var splitKey;

            for (groupName in this.addedEvents) {
                if (this.addedEvents.hasOwnProperty(groupName)) {
                    addedEvents = _.result(this.addedEvents, groupName);
                    for (eventKey in addedEvents) {
                        if (addedEvents.hasOwnProperty(eventKey)) {
                            if (!events[eventKey] || getFunc(this, events[eventKey]) !== getFunc(this, addedEvents[eventKey])) {
                                callback = addedEvents[eventKey];
                                if (isNaN(parseInt(groupName, 10))) {
                                    eventKey = addEventNamespace(eventKey, groupName);
                                }
                                if (!events[eventKey]) {
                                    events[eventKey] = callback;
                                } else {
                                    splitKey = eventKey.split(' ');
                                    eventKey = addEventNamespace(eventKey, ('dibs' + Math.round(Math.random() * _randZeroPadding)));
                                    events[eventKey] = callback;
                                }
                            }
                        }
                    }
                }
            }
        }
        return Backbone.BaseView.__super__.delegateEvents.call(this, events);
    };

    /**
     *
     * Slowly impart flavor into your BaseView instances. Also,
     * adds properties and methods your BaseView extension's
     * prototype like _.extend(MyView.prototype, mixin) would,
     * except that it looks for an 'addedEvents' property on
     * your mixin and adds those events to existing 'addedEvents'
     * rather than overwriting them.
     * @module {function} marinate
     * @param {...object} mixins
     *      One or more mixins to copy onto your view's prototype,
     *      with the optional 'addedEvents' object being added
     *      onto the existing addedEvents object instead of
     * @returns {function}
     */
    marinate = module.exports = function (View) {
        console.assert(View.prototype instanceof Backbone.BaseView, 'View must a Backbone.BaseView constructor');
        var mixins = _slice.call(arguments, 1);
        _marinate(View.prototype, mixins);
    };

    _.extend(marinate, {
        /**
         * Marinate only an instance of a view
         * @memberOf module:marinate
         * @param {Backbone.BaseView} viewInstance
         * @param {...object} mixins
         */
        marinateInstance: function (viewInstance) {
            console.assert(viewInstance instanceof Backbone.BaseView, 'viewInstance must be an instance of Backbone.BaseView');
            var mixins = _slice.call(arguments, 1);
            _marinate(viewInstance, mixins);
        },
        /**
         * Add DOM events to a BaseView pseudoclass
         * @memberOf module:marinate
         * @param {function} View Constructor for Backbone.BaseView
         * @param {string} name Namespace for your added events
         * @param {object} eventsObj Backbone DOM events hash
         */
        addProtoEvents: function (View, name, eventsObj) {
            console.assert(View.prototype instanceof Backbone.BaseView, 'View must a Backbone.BaseView constructor');
            _addEvents(View.prototype, name, eventsObj);
        },
        /**
         * Add DOM events to a BaseView instance
         * @memberOf module:marinate
         * @param {Backbone.BaseView} viewInstance
         * @param {string} name Namespace for your added events
         * @param {object} eventsObj Backbone DOM events hash
         */
        addEvents: function (viewInstance, name, eventsObj) {
            console.assert(viewInstance instanceof Backbone.BaseView, 'viewInstance must be an instance of Backbone.BaseView');
            _addEvents(viewInstance, name, eventsObj);
        }
    });

}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(70)(module)))

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var cookieMonster = __webpack_require__(2794);

/**
 * @ignore
 * Created by daletan on 9/13/16.
 */

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var undefined = void 0;

var keys = Object.freeze({
    USER: 'userToken', // <id>_<hash>
    SELLER: 'sellerToken', // <VERTICAL PREFIX>_<id>_<hash>
    MASQUERADE_BUYER: 'masqueradeBuyer', // U_<id>
    MASQUERADE_SELLER: 'masqueradeSeller', // S_<id>_<VERTICAL PREFIX>
    USER_TYPE: 'userType',
    USER_EMAIL: 'userEmail',
    USER_LEGACY: 'userreg',
    GUEST_ID: 'guestId',
    EVER_LOGGED_IN: 'eli',
    PASSWORD_RESET: 'passwordToken'
});

/**
 * @param {string} value
 * @returns {object|null}
 */
var getMasqueradeValues = function getMasqueradeValues() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (!value) {
        return null;
    }

    var _value$split = value.split('_'),
        _value$split2 = _slicedToArray(_value$split, 3),
        type = _value$split2[0],
        id = _value$split2[1],
        vertical = _value$split2[2];

    var parts = {
        type: type,
        id: id
    };
    if (vertical) {
        parts.vertical = vertical;
    }
    return parts;
};

/**
 * @param {string|object} cookie
 * @param {string} cookieKey
 * @returns {string|undefined}
 */
var getCookieValue = function getCookieValue(cookie, cookieKey) {
    var parsed = typeof cookie === 'string' ? cookieMonster.parse(cookie) : cookie;
    return parsed && parsed[cookieKey] || undefined;
};

/**
 * @param {string|object} cookie
 * @returns {object|null}
 */
var getMasqueradeSellerInfo = function getMasqueradeSellerInfo(cookie) {
    var token = getCookieValue(cookie, keys.MASQUERADE_SELLER);
    return getMasqueradeValues(token);
};

/**
 * @param {string|object} cookie
 * @returns {object|null}
 */
var getMasqueradeBuyerInfo = function getMasqueradeBuyerInfo(cookie) {
    var token = getCookieValue(cookie, keys.MASQUERADE_BUYER);
    return getMasqueradeValues(token);
};

/**
 * @param {string|object} cookie
 * @returns {string|null}
 */
var getMasqueradeSellerId = function getMasqueradeSellerId(cookie) {
    var parts = getMasqueradeSellerInfo(cookie);
    return parts ? parts.vertical.toLowerCase() + '_' + parts.id : null;
};

/**
 * @param {string|object} cookie
 * @returns {string|null}
 */
var getMasqueradeBuyerId = function getMasqueradeBuyerId(cookie) {
    var parts = getMasqueradeBuyerInfo(cookie);
    return parts ? parts.id : null;
};

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
var getUserTokenString = function getUserTokenString(cookie) {
    return getCookieValue(cookie, keys.USER);
};

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
var getSellerTokenString = function getSellerTokenString(cookie) {
    return getCookieValue(cookie, keys.SELLER);
};

/**
 * @param {*} token seller token
 * @returns {boolean}
 */
var isSellerToken = function isSellerToken(token) {
    return (/^[fjva]_/i.test(token)
    );
};

/**
 * @param {*} token user token
 * @returns {boolean}
 */
var isBuyerToken = function isBuyerToken(token) {
    return (/^\d+_/i.test(token)
    );
};

/**
 *
 * @param {string} token user or seller token
 * @returns {string|null}
 */
var splitToken = function splitToken() {
    var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var parts = token.split('_');
    // an empty string will still return an array length of 1
    if (parts[0] !== '') {
        if (isSellerToken(token)) {
            return parts[0] + '_' + parts[1];
        } else if (isBuyerToken(token)) {
            // need this check otherwise an invalid
            // seller token will be used
            return parts[0];
        }
    }
    return null;
};

/**
 * based off of bunsen/libraries/bunsen#getMasqueradeAsUserId
 * The bunsen version returned an `object.userId`
 * This version only returns a string or null
 * @param {string|object} cookie
 * @param {string} type
 * @returns {string|null}
 */
var getMasqueradeUserIdByType = function getMasqueradeUserIdByType(cookie, type) {
    if (type === keys.MASQUERADE_SELLER) {
        return getMasqueradeSellerId(cookie);
    } else if (type === keys.MASQUERADE_BUYER) {
        return getMasqueradeBuyerId(cookie);
    }
    return null;
};

/**
 * @param {string} cookie
 * @param {string} [userType] The type of user masquerade info to return
 * @returns {string|null}
 */
var getMasqueradeValue = function getMasqueradeValue(cookie, userType) {
    var parsed = cookieMonster.parse(cookie);
    return getMasqueradeUserIdByType(parsed, userType) || null;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var cookieJarConstants = keys;

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getPasswordReset(cookie) {
    return getCookieValue(cookie, keys.PASSWORD_RESET);
}

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getUserType(cookie) {
    return getCookieValue(cookie, keys.USER_TYPE);
}

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getGuestId(cookie) {
    return getCookieValue(cookie, keys.GUEST_ID);
}

/**
 * backwards compatibility
 * public api method will be removed in next major release, use {@link getBuyerToken}
 * @deprecated
 * @param {string} cookie
 */
var getUserToken = getUserTokenString;

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getEverLoggedIn(cookie) {
    return getCookieValue(cookie, keys.EVER_LOGGED_IN);
}

/**
 * based off of bunsen/models/identity/User#getUserId
 * The additional change here is adding the `userType` as the bunsen
 * version only assumed the buyer. The seller is also taken into account
 * @param {string} cookie document.cookie or req.cookie string
 * @param {string} [userType] The type of user masquerade info to return
 * @param {boolean} [getRealUser] returns the actual user (usually internal) if you happen to be masquerading
 * @returns {string|null}
 */
function getUserId(cookie, userType, getRealUser) {

    if (typeof cookie !== 'string') {
        throw new Error('a cookie string must be passed in. a ' + (typeof cookie === 'undefined' ? 'undefined' : _typeof(cookie)) + ' was passed passed in instead.');
    }

    var masqueradeInfo = getMasqueradeValue(cookie, userType);

    if (masqueradeInfo && !getRealUser) {
        return masqueradeInfo;
    }

    var userId = splitToken(getUserTokenString(cookie));
    return userId || null;
}

/**
 *
 * @param {string} cookie
 * @returns {string|null}
 */
function getSellerId(cookie) {
    var sellerId = splitToken(getSellerTokenString(cookie));
    return sellerId || null;
}

/**
 *
 * @param {string} cookie
 * @returns {function}
 */
function isMasqueradingByType(cookie) {
    var userId = getUserId(cookie, null, true);
    /**
     * @param {string} userType
     * @returns {boolean}
     */
    return function (userType) {
        // return `false` instead of `null`
        return (userId ? userId : false) && !!getMasqueradeUserIdByType(cookie, userType);
    };
}

/**
 * @param {string} cookie
 * @returns {boolean}
 */
function isMasqueradingAsSeller(cookie) {
    return isMasqueradingByType(cookie)(keys.MASQUERADE_SELLER);
}

/**
 * @param {string} cookie
 * @returns {boolean}
 */
function isMasqueradingAsBuyer(cookie) {
    return isMasqueradingByType(cookie)(keys.MASQUERADE_BUYER);
}

/**
 * based off of bunsen/helpers/actingUser#isMasquerading
 * The bunsen version would pull the buyer user info from server vars
 * There should be a `userToken` cookie value set for the internal
 * user if you are masquerading
 * @param {string} cookie
 * @returns {boolean}
 */
function isMasquerading(cookie) {
    var sellerId = isMasqueradingAsSeller(cookie);
    var buyerId = isMasqueradingAsBuyer(cookie);
    return !!(sellerId || buyerId);
}

/**
 * based off of bunsen#getToken, only used for admin functionality
 * @param {string} cookie
 * @returns {object}
 */
function getBuyerToken(cookie) {
    var userToken = getUserTokenString(cookie);
    if (userToken) {
        return {
            userToken: userToken
        };
    }
    return {};
}

/**
 * based off of bunsen#getToken, only used for admin functionality
 * sellerToken takes precedence over userToken (userToken case should
 * only be hit while masquerading)
 * @param {string} cookie
 * @returns {object}
 */
function getAdminToken(cookie) {
    // if seller token, return seller token
    var sellerToken = getSellerTokenString(cookie);
    if (sellerToken) {
        return {
            sellerToken: sellerToken
        };
    }

    // either a logged in admin user or masquerading as a seller
    // leveraging `getBuyerToken` logic
    // returns an object already
    // and will also return an empty object
    // for a falsey value
    return getBuyerToken(cookie);
}

exports.cookieJarConstants = cookieJarConstants;
exports.getPasswordReset = getPasswordReset;
exports.getUserType = getUserType;
exports.getGuestId = getGuestId;
exports.getUserToken = getUserToken;
exports.getEverLoggedIn = getEverLoggedIn;
exports.getUserId = getUserId;
exports.getSellerId = getSellerId;
exports.isMasqueradingByType = isMasqueradingByType;
exports.isMasqueradingAsSeller = isMasqueradingAsSeller;
exports.isMasqueradingAsBuyer = isMasqueradingAsBuyer;
exports.isMasquerading = isMasquerading;
exports.getBuyerToken = getBuyerToken;
exports.getAdminToken = getAdminToken;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by niko on 9/24/15.
 */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var RegionalInfoModel = __webpack_require__(3619);

var RegionalInfoStore = function (_BaseStore) {
    _inherits(RegionalInfoStore, _BaseStore);

    function RegionalInfoStore(dispatcher) {
        _classCallCheck(this, RegionalInfoStore);

        var _this = _possibleConstructorReturn(this, (RegionalInfoStore.__proto__ || Object.getPrototypeOf(RegionalInfoStore)).call(this, dispatcher));

        _this._error = null;
        _this._model = new RegionalInfoModel();
        return _this;
    }

    /**
     * Returns RegionalInfoModel representing regional information fetched by users IP.
     * @return {*}
     */


    _createClass(RegionalInfoStore, [{
        key: 'getRegionalInfoModel',
        value: function getRegionalInfoModel() {
            return this._model;
        }
    }, {
        key: 'getCountryCode',
        value: function getCountryCode() {
            return this._model.get('countryCode');
        }
    }, {
        key: 'getRegionalInfo',
        value: function getRegionalInfo() {
            return this._model.toJSON();
        }
    }, {
        key: 'onRegionalInfoLoaded',
        value: function onRegionalInfoLoaded() {
            this._error = null;
            this._model.trigger('regionalInfo:loaded');
            this.emitChange();
        }

        /**
         * Handler for errors when performing actions
         * @param error {object} The error object
         */

    }, {
        key: 'onRegionalInfoError',
        value: function onRegionalInfoError(error) {
            this._error = error;
            this._model.trigger('regionalInfo:error');
            this.emitChange();
        }
    }]);

    return RegionalInfoStore;
}(BaseStore);

RegionalInfoStore.storeName = 'RegionalInfoStore';

RegionalInfoStore.handlers = {
    'regionalInfo:loaded': 'onRegionalInfoLoaded',
    'regionalInfo:error': 'onRegionalInfoError'
};

module.exports = RegionalInfoStore;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: hella
 * Date: 3/30/14
 * Time: 2:54 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 *
 * merged global/utils/conversions.numbers.js and global/utils/number.js together in this file
 * moved from .com/dibs/assets/js/global/utils/commonjs/numberConversions.js
 */



var _ = __webpack_require__(0);
var strings = __webpack_require__(2044);
var currencyUtil = __webpack_require__(1626);
var intelligentFormat = __webpack_require__(2654);
var currencyToInteger = __webpack_require__(1626).currencyToInteger;
var currencies = __webpack_require__(468).currency;
var FinancialAmounts = __webpack_require__(10);
var currencySymbols = currencies.symbols;

var FEET = 12;
var measurements;


measurements = {
    inch: {
        toCm: function (x) {
            return x * 2.54;
        },
        toFeet: function (x) {
            var ret;
            var feet;
            var inches;
            var realFeet;
            if (x <= 48) {
                ret =  x + '"';
            } else {
                realFeet = x / FEET;
                ret = realFeet + "'";
                if (realFeet % 1 !== 0) {
                    feet = Math.floor(realFeet);
                    inches = Math.round((realFeet - feet) * FEET);
                    ret = feet + "' " + inches + '"';
                }
            }
            return ret;
        }
    },
    cm: {
        toInch: function (x) {
            return x * 0.3937;
        }
    },
    feet: {
        toInch: function (x) {
            var ret = 0;
            // looking for single quote
            var ftIndex = x.indexOf("'");
            // looking for double quote
            var inchIndex = x.indexOf('"');
            var ft;
            var inch;
            if (ftIndex !== -1) {
                ft = parseInt(x.substring(0, ftIndex), 10);
                ret += (ft * FEET);
            }

            if (inchIndex !== -1) {
                inch = parseInt(x.substring(ftIndex + 1, inchIndex), 10);
                ret += inch;
            }
            return ret;
        },
        toLongForm: function (x) {
            return x.replace("'", " ft. ").replace('"', " in.");
        },
        toShortForm: function (x) {
            return x.replace(" ft. ", "'").replace(" in.", '"');
        }
    }
};

/**
 * @param {number} num The number to add the commas to
 * @param {string} delim To use as thousands separator
 * @returns {string}
 */
exports.addThousandsDelim = function (num, delim) {
    delim = delim || ',';
    // only add commas if number has 4 or more digits
    return num < 1000 ? num.toString() : num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, delim);
};

exports.getCurrencySymbol = function (code) {
    return currencySymbols[code];
};

/**
 * @param {number} num The number to add the currency symbol to
 * TODO: update any `addCurrency` references to use three letter currency code
 * @param {string} type A key from the currencySymbol map
 * @returns {number|string}
 */
exports.addCurrency = function (num, type) {
    if (!(/^\d/).test(num) || !currencySymbols[type]) {
        return num;
    }
    return currencySymbols[type] + num;
};

/**
 * Removes commas from a string
 * @param {string} num A string with commas in it
 * @param {string} [delim] To use as thousands separator
 * @returns {number}
 */
exports.removeThousandsDelim = function (num, delim) {
    delim = delim || ',';
    var regex = new RegExp('\\' + delim, 'g');
    // make sure to return a true number
    // replace the delimiter:
    // 1.000.000 => 1000000
    return Number(num.toString().replace(regex, ""));
};

/**
 * @param {string} amount The currency value
 * @param {string} [type] A key from the currencySymbol map, defaults to dollar
 * @returns {string}
 */
exports.removeCurrency = function (amount, type) {
    amount += ''; // type conversion
    var symbol = currencySymbols[type] || currencySymbols.usd;
    var startPoint = amount.indexOf(symbol);
    var length = symbol.length;
    return startPoint > -1 ? amount.substring(startPoint + length) : amount;
};

/**
 * Converts a monetary value into either a number or a string with the appropriate
 * currency sign Also converts measurement values
 * @param {number|string} num The value to convert from a string -> number or number -> currency value
 * @param {string} [to] Type of value to convert x to ("number", "dollar", "euro", "gb-pounds")
 *                      Note: for measurement conversions, to field is converted to "toX" format to increase
 *                      readability of measurement object
 *                      i.e. if to arg = "cm" the key for look-up in the measurement object will
 *                      be converted to "toCm"
 * @param {string} [from] Type of value to convert x from
 *                        ("currency" to "number, dollar, etc."
 *                        | "number" to "dollar, etc."
 *                        |"inch" to "cm"
 *                        |"feet", "cm" to "inch", "feet" to "long_form").
 * @returns {Number/String}
 */
exports.convert = function convertMonetarySymbol(num, from, to) {
    if (!num && typeof num !== 'number') {
        return num;
    }

    to = to || "number";
    from  = from || "currency";

    if (from === "currency" && to === "number") {
        console.warn('This currency to number conversion is deprecated, please use dibs-currency-helpers');
        num = currencyToInteger(num);
    } else if (from === "number" && FinancialAmounts['CURRENCY_' + to.toUpperCase()]) {
        console.warn('This number to currency conversion is deprecated, please use dibs-currency-helpers');
        num = intelligentFormat(num, to);
    } else if (from !== "currency") {
        to = "to" + strings.capitalize(to);
        if (typeof measurements[from][to] === "function") {
            num = measurements[from][to](num);
            if (typeof num === "number") {
                num = Math.round(num * 100) / 100;
            }
        }
    }
    return num;
};

/**
 * Cash Format
 * @param number
 * @param {Boolean} showDecimal Defaults to True
 * @param {String} thousandsSeparator Defaults to ,
 * @param {String} decimalMark Defaults to .
 */
exports.cashFormat = function cashFormat(number, showDecimal, thousandsSeparator, decimalMark) {
    showDecimal = showDecimal === undefined || !!showDecimal;
    number = exports.format(number, showDecimal ? 2 : 0, thousandsSeparator, decimalMark);
    return currencySymbols.usd + number;
};

/**
 *
 * @param {number} number The number to format
 * @param {object} [options] Formatting options
 * @param {boolean} [options.showDecimal] Show a decimal or not. Defaults to true
 * @param {string} [options.thousandsSeparator] What separates the thousands? Defaults to comma ","
 * @param {string} [options.decimalMark] What separates decimals? Defaults to period "."
 * @param {string} [options.currencySymbol] Which currency symbol to use. Defaults to USD "$"
 * @returns {string}
 */
exports.localizedCashFormat = function (number, options) {
    // , showDecimal, thousandsSeparator, decimalMark
    options = _.extend({
        includeCurrencySymbol: true
    }, options);
    var decimalsToShow = options.showDecimal === false ?  0 : 2;
    var thousandsSeparator = options.thousandsSeparator || ',';
    var decimalMark = options.decimalMark || '.';
    var currencySymbol = options.currencySymbol || '$';

    number = exports.format(number, decimalsToShow, thousandsSeparator, decimalMark);
    currencySymbol = options.includeCurrencySymbol ? currencySymbol : '';

    // if it's negative we need to put the negative sign in front
    if (number.indexOf('-') !== -1) {
        return '- ' + currencySymbol + number.replace('-', '');
    }
    return currencySymbol + number;
};

exports.parseFloat = currencyUtil.parseFloat;

/**
 * Floating-point safe equals comparison
 * @param number
 * @param another_number
 * @returns {boolean}
 */
exports.isEqualFloat = function (number, anotherNumber) {
    return Math.abs(exports.parseFloat(number) - exports.parseFloat(anotherNumber)) < 0.000001;
};

exports.round = currencyUtil.round;

exports.format = currencyUtil.format;

exports.intelligentFormat = intelligentFormat;
/**
 * Takes a European style formatted number (periods for thousand sep., commas for decimal sep.)
 * and converts it to US style formatted number (commas for decimal sep., periods for thousands sep.)
 * @param price {string}
 */
exports.eurToUSPriceFormat = function (price) {
    var parts = (price || "").split(",");
    var cents = parts.length === 2 ? parts.pop() : "";
    //rest contains the non cents part of the price
    var rest = parts.pop();

    //replace periods with commas in non-cent section
    rest = rest.replace(/\./g, ",");

    //join cents and dollars with a period, it's the 'merican way.
    return cents ? [rest, cents].join(".") : rest;
};

/**
 * Checks if userCurrency is Euros and converts it to dollar format
 * Then parses value into number
 * @param value String
 * @param currency String
 */
exports.normalizeCurrencyFormat = function (value, currency) {
    var formatted = currency === FinancialAmounts.CURRENCY_EUR ? exports.eurToUSPriceFormat(value) : value;
    return exports.parseFloat(formatted);
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);

var StickyAlertTopStore = function (_BaseStore) {
    _inherits(StickyAlertTopStore, _BaseStore);

    function StickyAlertTopStore(dispatcher) {
        _classCallCheck(this, StickyAlertTopStore);

        var _this = _possibleConstructorReturn(this, (StickyAlertTopStore.__proto__ || Object.getPrototypeOf(StickyAlertTopStore)).call(this, dispatcher));

        _this._height = 0;
        return _this;
    }

    _createClass(StickyAlertTopStore, [{
        key: 'setHeight',
        value: function setHeight(payload) {
            var height = payload.height;

            this._height = height;
            this.emitChange();
        }
    }, {
        key: 'getHeight',
        value: function getHeight() {
            return this._height;
        }
    }]);

    return StickyAlertTopStore;
}(BaseStore);

;

StickyAlertTopStore.storeName = 'StickyAlertTopStore';

StickyAlertTopStore.handlers = {
    'StickyAlert:top:height': 'setHeight'
};

module.exports = StickyAlertTopStore;

/***/ }),
/* 328 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * A specialized version of `_.forEach` for arrays without support for callback
 * shorthands or `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 329 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * A specialized version of `_.map` for arrays without support for callback
 * shorthands or `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 330 */
/***/ (function(module, exports) {

/**
 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = getNative;


/***/ }),
/* 331 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return before(2, func);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = once;


/***/ }),
/* 332 */,
/* 333 */,
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var inherits = __webpack_require__(59);
var EventEmitter = __webpack_require__(2922);
var CHANGE_EVENT = 'change';

/**
 * @class BaseStore
 * @extends EventEmitter
 * @param dispatcher The dispatcher interface
 * @constructor
 */
function BaseStore(dispatcher) {
    this.dispatcher = dispatcher;
    this._hasChanged = false;
    if (this.initialize) {
        this.initialize();
    }
}

inherits(BaseStore, EventEmitter);

/**
 * Convenience method for getting the store context object.
 * @method getContext
 * @return {Object} Returns the store context object.
 */
BaseStore.prototype.getContext = function getContext() {
    return this.dispatcher.getContext();
};

/**
 * Add a listener for the change event
 * @method addChangeListener
 * @param {Function} callback
 */
BaseStore.prototype.addChangeListener = function addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
};

/**
 * Remove a listener for the change event
 * @method removeChangeListener
 * @param {Function} callback
 */
BaseStore.prototype.removeChangeListener = function removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
};

/**
 * Determines whether the store should dehydrate or not. By default, only dehydrates
 * if the store has emitted an update event. If no update has been emitted, it is assumed
 * that the store is in its default state and therefore does not need to dehydrate.
 * @method shouldDehydrate
 * @returns {boolean}
 */
BaseStore.prototype.shouldDehydrate = function shouldDehydrate() {
    return this._hasChanged;
};

/**
 * Emit a change event
 * @method emitChange
 * @param {*} param=this
 */
BaseStore.prototype.emitChange = function emitChange(param) {
    this._hasChanged = true;
    this.emit(CHANGE_EVENT, param || this);
};

module.exports = BaseStore;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/15/14
 * Time: 6:41 PM
 */


var _ = __webpack_require__(0);
var Anchor = __webpack_require__(12);
module.exports = __webpack_require__(9).extend();

_.extend(module.exports.prototype, {
    model: Anchor,
    getAnchorByType: function (anchorType) {
        return this.findWhere({ sourceType: anchorType });
    },
    getAnchorIdByType: function (anchorType) {
        var anchor = this.getAnchorByType(anchorType);
        return anchor ? anchor.get('sourceId') : null;
    },
    hasAnchor: function (anchorType) {
        return !!this.getAnchorIdByType(anchorType);
    },
    setAnchorId: function (anchorType, id) {
        var anchor = this.getAnchorByType(anchorType);
        if (anchor) {
            anchor.set('sourceId', id);
        }
        return this;
    }
});


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by augustocorvalan on 1/28/15.
 */


var SoaModel = __webpack_require__(2);
var AnchorList = module.exports = SoaModel.extend();
var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var Backbone = __webpack_require__(3);
var Anchor = __webpack_require__(12);

_.extend(AnchorList, {
    createAnchorList: function (sourceType, ids) {
        var anchors = _.map(ids, function (id) {
            if (_.isString(id)) {
                id = id.trim();
            }

            return new Anchor({
                sourceId: id,
                sourceType: sourceType
            });
        });

        return new AnchorList({ anchors: anchors });
    }
});

_.extend(AnchorList.prototype, {
    url: function () {
        return endpoints.anchorList(this.listType, this.listName);
    },
    relations: SoaModel.createRelations([
        {
            key: 'anchors',
            type: Backbone.Many,
            relatedModel: Anchor
        }
    ]),
    getIds: function () {
        var anchors = this.get('anchors');
        return anchors && anchors.pluck('sourceId');
    },

    initialize: function (attrs, options) {
        this.listType = options.listType;
        this.listName = options.listName;
    }
});


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 9/22/14
 * Time: 8:10 PM
 */



var SoaModel = __webpack_require__(2);
var CurrencyConversionRateEvent = module.exports = SoaModel.extend();

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var CurrencyConversionRate = __webpack_require__(2046);
var ends = __webpack_require__(6);

// for browser console debugging
if (typeof window !== 'undefined') {
    window.bunsen = window.bunsen || {};
    window.bunsen.CurrencyConversionRateEvent = CurrencyConversionRateEvent;
}

_.extend(CurrencyConversionRateEvent.prototype, {
    relations: [
        {
            key: 'conversionRates',
            type: Backbone.Many,
            // needed until MONEY-374 is resolved
            // omitFromSave: true,
            relatedModel: CurrencyConversionRate
        }
    ],
    fetchCurrentRates: function (options) {
        options = _.extend({
            url: ends.currentRates()
        }, options);

        return this.fetch(options);
    }
});



/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 6/9/14
 * Time: 2:54 PM
 */



module.exports = {
    getPeriodInDays: function (prop) {
        var period = this.get(prop);
        if (period) {
            return period.getInDays();
        }
        return 0;
    },
    getPeriodDisplayVal: function (prop) {
        var period = this.get(prop);
        if (period) {
            return period.getDisplayVal();
        }
    }
};

/***/ }),
/* 339 */
/***/ (function(module, exports) {

/**
 * lodash 3.1.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * The base implementation of `_.indexOf` without support for binary searches.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return indexOfNaN(array, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * Gets the index at which the first occurrence of `NaN` is found in `array`.
 * If `fromRight` is provided elements of `array` are iterated from right to left.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
 */
function indexOfNaN(array, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 0 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    var other = array[index];
    if (other !== other) {
      return index;
    }
  }
  return -1;
}

module.exports = baseIndexOf;


/***/ }),
/* 340 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * A specialized version of `_.pick` which picks `object` properties specified
 * by `props`.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property names to pick.
 * @returns {Object} Returns the new object.
 */
function pickByArray(object, props) {
  object = toObject(object);

  var index = -1,
      length = props.length,
      result = {};

  while (++index < length) {
    var key = props[index];
    if (key in object) {
      result[key] = object[key];
    }
  }
  return result;
}

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = pickByArray;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseFor = __webpack_require__(129),
    keysIn = __webpack_require__(314);

/**
 * The base implementation of `_.forIn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForIn(object, iteratee) {
  return baseFor(object, iteratee, keysIn);
}

/**
 * A specialized version of `_.pick` that picks `object` properties `predicate`
 * returns truthy for.
 *
 * @private
 * @param {Object} object The source object.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Object} Returns the new object.
 */
function pickByCallback(object, predicate) {
  var result = {};
  baseForIn(object, function(value, key, object) {
    if (predicate(value, key, object)) {
      result[key] = value;
    }
  });
  return result;
}

module.exports = pickByCallback;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var arrayMap = __webpack_require__(329),
    baseCallback = __webpack_require__(310),
    baseEach = __webpack_require__(311),
    isArray = __webpack_require__(64);

/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.map` without support for callback shorthands
 * and `this` binding.
 *
 * @private
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Creates an array of values by running each element in `collection` through
 * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
 * arguments: (value, index|key, collection).
 *
 * If a property name is provided for `iteratee` the created `_.property`
 * style callback returns the property value of the given element.
 *
 * If a value is also provided for `thisArg` the created `_.matchesProperty`
 * style callback returns `true` for elements that have a matching property
 * value, else `false`.
 *
 * If an object is provided for `iteratee` the created `_.matches` style
 * callback returns `true` for elements that have the properties of the given
 * object, else `false`.
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
 * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
 * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
 * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
 * `sum`, `uniq`, and `words`
 *
 * @static
 * @memberOf _
 * @alias collect
 * @category Collection
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
 *  per iteration.
 * @param {*} [thisArg] The `this` binding of `iteratee`.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function timesThree(n) {
 *   return n * 3;
 * }
 *
 * _.map([1, 2], timesThree);
 * // => [3, 6]
 *
 * _.map({ 'a': 1, 'b': 2 }, timesThree);
 * // => [3, 6] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // using the `_.property` callback shorthand
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee, thisArg) {
  var func = isArray(collection) ? arrayMap : baseMap;
  iteratee = baseCallback(iteratee, thisArg, 3);
  return func(collection, iteratee);
}

module.exports = map;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseCallback = __webpack_require__(310),
    baseEach = __webpack_require__(311),
    baseReduce = __webpack_require__(2236),
    isArray = __webpack_require__(64);

/**
 * A specialized version of `_.reduce` for arrays without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initFromArray] Specify using the first element of `array`
 *  as the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initFromArray) {
  var index = -1,
      length = array.length;

  if (initFromArray && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * Creates a function for `_.reduce` or `_.reduceRight`.
 *
 * @private
 * @param {Function} arrayFunc The function to iterate over an array.
 * @param {Function} eachFunc The function to iterate over a collection.
 * @returns {Function} Returns the new each function.
 */
function createReduce(arrayFunc, eachFunc) {
  return function(collection, iteratee, accumulator, thisArg) {
    var initFromArray = arguments.length < 3;
    return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
      ? arrayFunc(collection, iteratee, accumulator, initFromArray)
      : baseReduce(collection, baseCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
  };
}

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` through `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not provided the first element of `collection` is used as the initial
 * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `includes`, `merge`, `sortByAll`, and `sortByOrder`
 *
 * @static
 * @memberOf _
 * @alias foldl, inject
 * @category Collection
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {*} [thisArg] The `this` binding of `iteratee`.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.reduce([1, 2], function(total, n) {
 *   return total + n;
 * });
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
 *   result[key] = n * 3;
 *   return result;
 * }, {});
 * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
 */
var reduce = createReduce(arrayReduce, baseEach);

module.exports = reduce;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(4);

/***/ }),
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(20);

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(21);

/***/ }),
/* 350 */,
/* 351 */,
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 9/5/14
 * Time: 7:14 PM
 */



function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var $ = __webpack_require__(5);
var _ = __webpack_require__(22);
var get = __webpack_require__(14);
var SV = __webpack_require__(18);
var qs = __webpack_require__(42);
var endpoints = __webpack_require__(284);
var User = __webpack_require__(28);
var bunsenLib = __webpack_require__(21);
var poster = __webpack_require__(1981);
var ItemID = void 0;

__webpack_require__(677);

var redirects = module.exports = _defineProperty({
    setItemId: function setItemId(itemId) {
        ItemID = itemId;
    },
    getKountUrl: function getKountUrl(itemId, vertical) {
        var kountParams = Object.assign({ itemId: itemId, vertical: vertical }, bunsenLib.getToken());
        return bunsenLib.extendURL(endpoints.transactionKount(), kountParams);
    },
    getPathFromUrl: function getPathFromUrl(pathName) {
        var pathArray = document.location.pathname.split('/') || [];
        return pathArray.filter(function (path) {
            return path.indexOf(pathName) > -1;
        })[0] || '';
    },
    getItemIdFromUrl: function getItemIdFromUrl() {
        var idStr = 'id-';
        var idPath = redirects.getPathFromUrl(idStr);
        return idPath.replace(idStr, '') || ItemID;
    },
    getParsedQueryKeys: function getParsedQueryKeys() {
        return qs.parse(document.location.search.substr(1));
    },
    hasParamInUrl: function hasParamInUrl(param) {
        var params = redirects.getParsedQueryKeys();
        return _.has(params, param);
    },

    /**
     * get a params value from the URL or Post data (SV)
     * @param param - string property
     * @returns {String|undefined} - if param wasn't found, return undefined
     */
    getParamFromUrl: function getParamFromUrl(param) {
        var params = redirects.getParsedQueryKeys();
        return _.has(params, param) ? params[param] : undefined;
    },
    getCheckoutParam: function getCheckoutParam(param) {
        return redirects.getParamFromUrl(param) || SV.get('checkoutPostData.' + param);
    },
    getCheckoutUrl: function getCheckoutUrl() {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var baseUrl = '/checkout/id-';
        var itemId = item.id || redirects.getItemIdFromUrl();

        if (!itemId) {
            throw new Error("getCheckoutUrl method expects a Backbone model item or to have it in the url.");
        }
        return baseUrl.concat(itemId);
    },
    isBalanceDueByUrl: function isBalanceDueByUrl() {
        return !!redirects.getPathFromUrl('balanceDue');
    },
    isUserComesFromEmail: function isUserComesFromEmail() {
        return redirects.getParamFromUrl('utm_medium') === 'email' || redirects.getCheckoutParam('userComesFromEmail') === 'true';
    },
    isUserComesFromAmp: function isUserComesFromAmp() {
        return redirects.getParamFromUrl('userComesFromAmp') === 'true';
    },
    isUserComesFromAcceptedOffer: function isUserComesFromAcceptedOffer() {
        return redirects.getParamFromUrl('acceptOffer') === 'true' || redirects.getParamFromUrl('fullPrice') === 'true';
    },
    isUserNegotiating: function isUserNegotiating() {
        return !!redirects.getParamFromUrl('offerAmount');
    },
    hasAllowWireTransferInUrl: function hasAllowWireTransferInUrl() {
        // when allowWireTransfer=true is part of the uri params, allow checkout with wire transfer - MONEY-2591.
        return redirects.getParamFromUrl('allowWireTransfer') === 'true';
    },
    hasAllowCheckInUrl: function hasAllowCheckInUrl() {
        // when allowCheck=true is part of the uri params, allow checkout with check - MONEY-4358.
        return redirects.getParamFromUrl('allowCheck') === 'true';
    },


    // use wrapper for easier spying when testing
    redirect: function redirect(url) {
        // we actually want to go somewhere now, make sure
        // the warning is turned off
        $(window).off('beforeunload');
        window.location.href = url;
    },
    post: function post(url, transaction, error) {
        var data = redirects.getPostData(transaction, error);
        $(window).off('beforeunload');
        poster.post(url, data);
    },
    getPostData: function getPostData(transaction, error) {
        var offer = transaction.getMostRecentOffer();
        var promo = transaction.getActivePromo();
        var data = {
            message: offer && offer.get('notes[0].content'),
            quantity: offer && offer.get('quantity'),
            shippingAddress: transaction.get('shipment.shippingAddress.sourceId') || transaction.get('shipment.shippingAddress.id'),
            promoCode: promo && promo.get('code'),
            error: error
        };

        if (transaction.isNegotiable()) {
            data.offerAmount = offer && offer.get('amountPerItem.amount');
            data.offerCurrency = offer && offer.get('amountPerItem.currency');
        }
        return data;
    },
    goToMessageCenter: function goToMessageCenter() {
        var itemId = redirects.getItemIdFromUrl();
        var buyerId = User.getUserId();

        if (itemId && buyerId) {
            redirects.redirect('/my/conversations/buyer/' + buyerId + '/item/' + itemId);
        } else {
            redirects.redirect('/');
        }
    },
    goToPDP: function goToPDP() {
        var url = '/id-' + redirects.getItemIdFromUrl() + '/';
        redirects.redirect(url);
    },
    goToCheckout: function goToCheckout(transaction, error) {
        var url = redirects.getCheckoutUrl();
        redirects.post(url, transaction, error);
    },
    goToBalanceDue: function goToBalanceDue(transaction, error) {
        var url = '/checkout/balanceDue/' + transaction.id;
        redirects.post(url, transaction, error);
    },
    goToConfirmation: function goToConfirmation(transactionId) {
        var itemId = redirects.getItemIdFromUrl();
        var url = '/checkout/confirmation/id-' + itemId + '/' + transactionId;
        redirects.redirect(url);
    },
    goToOMT: function goToOMT(id) {
        var url = '/my/orders/';
        if (id) {
            url = url.concat('order/' + id);
        }
        redirects.redirect(url);
    },
    goToItemCategory: function goToItemCategory(item) {
        var categories = get(item, 'classification.categories', []);
        var url = get(categories[0], 'category.browseUrl', '/');
        redirects.redirect(url);
    }
}, 'hasAllowCheckInUrl', function hasAllowCheckInUrl() {
    // when allowCheck=true is part of the uri params, allow checkout with check - MONEY-4358.
    return redirects.getParamFromUrl('allowCheck') === 'true';
});

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(75);

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-arrow-right'].join(' '), 'data-tn': 'arrow-right', viewBox: '-8.5 0 32 32' },
                React.createElement('path', { d: 'M1,0c0.3,0,0.6,0.1,0.8,0.3l13,15c0.3,0.4,0.3,0.9,0,1.3l-13,15c-0.4,0.4-1,0.5-1.4,0.1 c-0.4-0.4-0.5-1-0.1-1.4L12.6,16L0.2,1.7c-0.4-0.4-0.3-1,0.1-1.4C0.5,0.1,0.8,0,1,0z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * User: daletan
	 * Date: 3/12/16
	 * Time: 8:57 PM
	 * Copyright 1stdibs.com, Inc. 2016. All Rights Reserved.
	 */

	'use strict';

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(2);
	var classnames = __webpack_require__(3);
	var styles = __webpack_require__(4);

	/**
	 * @param {object} props
	 * @param {string} [props.additionalOverlayClasses]
	 * @param {string} [props.additionalSpinnerClasses]
	 * @param {string} [props.position="isFixed"] Accepts `isAbsolute`, `isStatic`, `isRelative`, defaults to `isFixed`
	*  @param {string} [props.size] only 'small' and 'medium' for now
	 * @returns
	 * @constructor
	 */
	var Overlay = function Overlay() {
	    var _classnames2, _classnames3;

	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var additionalWrapperClasses = props.additionalWrapperClasses,
	        additionalOverlayClasses = props.additionalOverlayClasses,
	        additionalSpinnerClasses = props.additionalSpinnerClasses,
	        _props$position = props.position,
	        position = _props$position === undefined ? "isFixed" : _props$position,
	        _props$size = props.size,
	        size = _props$size === undefined ? 'medium' : _props$size;

	    var wrapperClasses = classnames(_defineProperty({
	        'overlay-spinner-wrapper': true
	    }, additionalWrapperClasses, !!additionalWrapperClasses));
	    var overlayClasses = classnames((_classnames2 = {}, _defineProperty(_classnames2, styles.spinnerWrapper, styles.spinnerWrapper), _defineProperty(_classnames2, 'ajax-overlay', true), _defineProperty(_classnames2, additionalOverlayClasses, !!additionalOverlayClasses), _classnames2));
	    var spinnerClasses = classnames((_classnames3 = {}, _defineProperty(_classnames3, styles.large, size === 'large' && styles.large), _defineProperty(_classnames3, styles.medium, size === 'medium' && styles.medium), _defineProperty(_classnames3, styles.small, size === 'small' && styles.small), _defineProperty(_classnames3, 'tn-overlaySpinner', true), _defineProperty(_classnames3, additionalSpinnerClasses, !!additionalSpinnerClasses), _defineProperty(_classnames3, styles[position], !!position), _classnames3));
	    return React.createElement(
	        'div',
	        { className: wrapperClasses },
	        React.createElement('div', { className: overlayClasses }),
	        React.createElement('div', { className: spinnerClasses, 'data-tn': 'loading-check' })
	    );
	};

	Overlay.propTypes = {
	    additionalWrapperClasses: PropTypes.string,
	    additionalOverlayClasses: PropTypes.string,
	    additionalSpinnerClasses: PropTypes.string,
	    position: PropTypes.string,
	    size: PropTypes.oneOf(['large', 'medium', 'small'])
	};

	module.exports = Overlay;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = __webpack_require__(1);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __webpack_require__(7);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __webpack_require__(2811);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"large":"_spinner__large__1nVe5","spin":"_spinner__spin__3Rf99","isFixed":"_spinner__isFixed__1TEmG","isAbsolute":"_spinner__isAbsolute__2m1Rz","isStatic":"_spinner__isStatic__1SdOj","isRelative":"_spinner__isRelative__1sFOo","medium":"_spinner__medium__2UQim","small":"_spinner__small__1DEW1"};

/***/ })
/******/ ]);

/***/ }),
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 8/11/14
 * Time: 7:21 PM
 */



var get = __webpack_require__(14);
var SV = __webpack_require__(18);
var redirects = __webpack_require__(352);
var errorsCopy = __webpack_require__(2545);

var _require = __webpack_require__(110),
    PAGES = _require.PAGES;

var checkoutType = void 0;
var _isPrivateOffer = void 0;
var _isPreAuthNegotiation = void 0;

var helpers = module.exports = {
    setPageType: function setPageType(pageType) {
        checkoutType = pageType;
    },
    setCheckoutProps: function setCheckoutProps(transaction) {
        _isPrivateOffer = get(transaction, 'isPrivateOffer');
        _isPreAuthNegotiation = get(transaction, 'isPreAuthNegotiation');
    },
    getCheckoutType: function getCheckoutType() {
        return checkoutType || PAGES.PAGE_CHECKOUT;
    },
    isCheckout: function isCheckout() {
        return helpers.getCheckoutType() === PAGES.PAGE_CHECKOUT;
    },
    isBalanceDue: function isBalanceDue() {
        return helpers.getCheckoutType() === PAGES.PAGE_BALANCE_DUE || redirects.isBalanceDueByUrl();
    },
    isConfirmation: function isConfirmation() {
        return helpers.getCheckoutType() === PAGES.PAGE_CONFIRMATION || SV.get('settings.pageSubType') === PAGES.PAGE_CONFIRMATION;
    },
    isFullPrice: function isFullPrice() {
        return redirects.getCheckoutParam('fullPrice') === 'true';
    },
    isNegotiable: function isNegotiable() {
        var amount = redirects.getCheckoutParam('offerAmount');
        return !!amount && amount !== redirects.getCheckoutParam('listPrice');
    },
    isPrivateOffer: function isPrivateOffer() {
        return _isPrivateOffer;
    },
    isPreAuthNegotiation: function isPreAuthNegotiation() {
        return _isPreAuthNegotiation;
    },
    isNetPriceBuyer: function isNetPriceBuyer(item, buyer, transaction) {
        var hasNetPrice = get(transaction, 'hasNetPrice');
        var isFurniture = get(item, 'isFurniture');
        var isTradeBuyer = get(buyer, 'isVerifiedTrade');
        return isFurniture && isTradeBuyer && hasNetPrice;
    },
    getErrorCopy: function getErrorCopy(error) {
        return errorsCopy[error] || errorsCopy.default;
    }
};

/***/ }),
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: liliana
 * Date: 4/15/15
 * Time: 4:45 PM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */



var SoaModel               = __webpack_require__(2);

/**
 * @class Favorite
 * @extends SoaModel
 * @constructs Favorite object
 * @constructor
 */
var Favorite               = module.exports = SoaModel.extend();

var _                      = __webpack_require__(0);
var Backbone               = __webpack_require__(3);
var FavoriteParameters     = __webpack_require__(2619);
var endpoints              = __webpack_require__(6);
var User                   = __webpack_require__(28);

_.extend(Favorite.prototype, {
    relations : function () {
        return [
            {
                type             : Backbone.One,
                key              : 'user',
                relatedModel     : User
            },
            {
                type             : Backbone.Many,
                key              : 'parameters',
                collectionType   : FavoriteParameters
            },
            {
                type             : Backbone.One,
                key              : 'anchor',
                relatedModel     : Backbone.AssociatedModel.extend()
            }
        ];
    },

    defaults : function () {
        return {
            user         : {},
            page         : '',
            parameters   : []
        };
    },

    /**
     * @returns {string}
     */
    url : function () {
        return endpoints.favorite(this.get('id') || '');
    },

    /**
     * @returns {boolean}
     */
    isInactive : function () {
        return this.get('anchorStatus') === Favorite.ANCHOR_STATUS_INACTIVE;
    }

});

_.extend(Favorite, {

    /* TYPES */
    TYPE_SEARCH             : 'SEARCH',
    TYPE_DEALER             : 'SELLER',
    TYPE_DESIGNER           : 'DESIGNER',
    TYPE_USER_PREFERENCE    : 'USER_PREFERENCE',

    /* EMAIL PREFERENCE ENUMS */
    EMAIL_PREFERENCE_WEEKLY : 'WEEKLY',
    EMAIL_PREFERENCE_DAILY  : 'DAILY',
    EMAIL_PREFERENCE_NEVER  : 'NEVER',

    /* STATUS ENUMS */
    ANCHOR_STATUS_ACTIVE    : 'ACTIVE',
    ANCHOR_STATUS_INACTIVE  : 'INACTIVE'
});


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var cssBreakpoints = __webpack_require__(2634);
var breakpoints;
var props;

/**
 * Create a consistent return signature
 * @type {{integer: {}, pixel: {}, catchError: boolean}}
 */
breakpoints = {
    integer: {},
    pixel: {}
};

/**
 * Create an object of pixel and integer values
 * @param {object} obj The object of values to parse
 * @returns {{pixel: {}, integer: {}}}
 */
function createCssValues(obj) {
    var pixel = {};
    var integer = {};
    var key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            pixel[key] = obj[key];
            integer[key] = parseInt(obj[key].replace(/"/, "").replace(/px/, ""), 10);
        }
    }
    return {
        pixel: pixel,
        integer: integer
    };
}

/**
 * A convenience method to grab a breakpoint type
 * @param {string} type The breakpoint type: "integer" or "pixel"
 * @returns {*}
 */
function getBreakpoints(type) {
    var bp = breakpoints[type];
    var hasProps = false;
    var prop;
    if (bp) {
        for (prop in bp) {
            // just checking if object is not empty
            if (bp.hasOwnProperty(prop)) {
                hasProps = true;
                break;
            }
        }
    }
    if (!hasProps) {
        return false;
    }
    return bp;
}

/**
 * A convenience method that returns the deviceType associated
 * with the current viewport width
 * @returns {string}
 */
function getDeviceType() {
    var viewportWidth = global.document.body.getBoundingClientRect().width;
    return viewportWidth <= breakpoints.integer['tablet-portrait'] ?
        'mobile' : viewportWidth > breakpoints.integer['tablet-landscape'] ? 'desktop' : 'tablet';
}

// parse the px css string into a integer value
props = createCssValues(cssBreakpoints);
breakpoints.pixel = props.pixel;
breakpoints.integer = props.integer;

module.exports = {
    breakpoints: breakpoints,
    getBreakpoints: getBreakpoints,
    getDeviceType: getDeviceType
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 380 */,
/* 381 */,
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var breakpoints = __webpack_require__(379).breakpoints.integer;

/**
 * Expose the queries used here so they can be used elsewhere.
 * @type {Object}
 */
// jscs:disable
// TODO: Disabling jscs because it incorrectly flags these commas as not sticking to the previous expression. Upgrade
// JSCS to re-enable it here. Version 1.6.2 when this note was written.
var queries = {
    xs: '(max-width: ' + (breakpoints['mobile-portrait'] - 1) + 'px)',
    sm: '(min-width: ' + breakpoints['mobile-portrait'] + 'px) and ' + ('(max-width: ' + (breakpoints['mobile-large-landscape'] - 1) + 'px)'),
    md: '(min-width: ' + breakpoints['mobile-large-landscape'] + 'px) and ' + ('(max-width: ' + (breakpoints['tablet-portrait'] - 1) + 'px)'),
    lg: '(min-width: ' + breakpoints['tablet-portrait'] + 'px) and ' + ('(max-width: ' + (breakpoints.desktop - 1) + 'px)'),
    xl: '(min-width: ' + breakpoints.desktop + 'px)'
};
// jscs:enable

/**
 * Check if this is a mobile device.
 * @return {Boolean}
 */
function isMobile() {
    return window.matchMedia(queries.xs + ', ' + queries.sm + ', ' + queries.md).matches;
}

/**
 * Check if the the device is a tablet.
 * @return {Boolean}
 */
function isTablet() {
    return window.matchMedia(queries.lg).matches;
}

/**
 * Check if the the device is mobile or a tablet.
 * @return {Boolean}
 */
function isMobileOrTablet() {
    return window.matchMedia(queries.xs + ', ' + queries.sm + ', ' + queries.md + ', ' + queries.lg).matches;
}

/**
 * Check if this is a desktop device.
 * @return {Boolean}
 */
function isDesktop() {
    return window.matchMedia(queries.xl).matches;
}

/**
 * Check if the the device is a tablet or desktop.
 * @return {Boolean}
 */
function isTabletOrDesktop() {
    return window.matchMedia(queries.lg + ', ' + queries.xl).matches;
}

module.exports = {
    queries: queries,
    isMobile: isMobile,
    isTablet: isTablet,
    isMobileOrTablet: isMobileOrTablet,
    isDesktop: isDesktop,
    isTabletOrDesktop: isTabletOrDesktop
};

/***/ }),
/* 383 */,
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(2286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(4152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(4151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(4150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(2285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(2287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: hella
 * Date: 3/30/14
 * Time: 1:38 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 *
 * moved from .com/dibs/assets/js/global/utils/commonjs/strings.js
 */



var $ = __webpack_require__(5);

/**
 * decode html entities
 *
 * @param {String} string input with html entities
 * @returns {String} the string with html entities decoded into characters
 */
function decodeEntities(string) {
    return $('<div/>').html(string).text();
}

/**
 * get a value from a delimited string of key value pairs
 * *** note: all params must be regex safe - escaped if necessary
 *
 * @param {String} kv_string the full string to search (ie. 'login=n|pur=y|neg=y|pship=y')
 * @param {String} key the key to search for (ie. 'pur')
 * @param {String} set_delimiter the delimiter for each key/value set (ie. '\\|')
 * @param {String} [kv_delimiter] the delimiter for each key/value (ie. '=')
 * @returns {String|Boolean} the found value, false if not found
 */

function getFromDelimitedString(kv_string, key, set_delimiter, kv_delimiter) {
    kv_delimiter = kv_delimiter || '=';
    var pattern = new RegExp('' + key + kv_delimiter + '(.+?)(' + set_delimiter + '|$)');
    var found = pattern.exec(kv_string);
    if (found instanceof Array && found[1]) {
        return found[1];
    }
    return false;
}

/**
 * set a value in a delimited string of key value pairs
 * *** note: all params must be regex safe - escaped if necessary
 *
 * @param {String} kv_string the full string to search (ie. 'login=n|pur=y|neg=y|pship=y')
 * @param {String} key the key to search for (ie. 'pur')
 * @param {String} new_value the value to set for the passed in key (ie. 'y')
 * @param {String} set_delimiter the delimiter for each key/value set (ie. '\\|')
 * @param {String} [kv_delimiter] the delimiter for each key/value (ie. '=')
 * @returns {String} the kv_string with new_value replaced for key, or original kv_string if key was not found
 */

function setInDelimitedString(kv_string, key, new_value, set_delimiter, kv_delimiter) {
    kv_delimiter = kv_delimiter || '=';
    var old_value = this.getFromDelimitedString(kv_string, key, set_delimiter, kv_delimiter);
    if (old_value) {
        return kv_string.replace(key + kv_delimiter + old_value, key + kv_delimiter + new_value);
    }
    return kv_string;
}

function normalizeSpacing(str) {
    return $.trim(str).replace(/\s+/g, ' ');
}

function capitalize(str) {
    return typeof str === 'string' && str ? str.substring(0, 1).toUpperCase() + str.substring(1) : str;
}

function ord(string) {
    //  discuss at: http://phpjs.org/functions/ord/
    // original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // bugfixed by: Onno Marsman
    // improved by: Brett Zamir (http://brett-zamir.me)
    //    input by: incidence
    //   example 1: ord('K');
    //   returns 1: 75
    //   example 2: ord('\uD800\uDC00'); // surrogate pair to create a single Unicode character
    //   returns 2: 65536

    var str = string + '';
    var code = str.charCodeAt(0);
    var hi = undefined;
    var low = undefined;

    if (code >= 0xD800 && code <= 0xDBFF) {
        // High surrogate (could change last hex to 0xDB7F to treat high private surrogates as single characters)
        hi = code;
        if (str.length === 1) {
            // This is just a high surrogate with no following low surrogate, so we return its value;
            return code;
            // we could also throw an error as it is not a complete character, but someone may want to know
        }
        low = str.charCodeAt(1);
        return (hi - 0xD800) * 0x400 + (low - 0xDC00) + 0x10000;
    }
    if (code >= 0xDC00 && code <= 0xDFFF) {
        // Low surrogate
        // This is just a low surrogate with no preceding high surrogate, so we return its value;
        return code;
        // we could also throw an error as it is not a complete character, but someone may want to know
    }
    return code;
}

/**
 * Behaves just like sprintf in C, Java, PHP, etc.
 * But only supports the string replacement (%s) functionality (i.e. no %d, %e, etc.)
 * @returns {string}
 */
function sprintf() {
    var args = Array.prototype.slice.call(arguments);
    return args.shift().replace(/%s/g, function () {
        return args.shift();
    });
}

/**
 * Clamps the string if it exceedes a given length of code units (not characters!)
 * and adds an ellipsis at the end.
 * @param  {String} str - String to clamp
 * @param  {Number} maxLength - Number of max code units, withouth ellipsis.
 * @return {String} - Clamped string with ellipsis attached
 */

function clampWithEllipsis(str, maxLength) {
    var ellipsis = String.fromCharCode(8230);
    if (str.length > maxLength) {
        return str.substring(0, maxLength - 1).trim() + ellipsis;
    }
    return str;
}
module.exports = {
    decodeEntities: decodeEntities,
    getFromDelimitedString: getFromDelimitedString,
    setInDelimitedString: setInDelimitedString,
    normalizeSpacing: normalizeSpacing,
    capitalize: capitalize,
    ord: ord,
    sprintf: sprintf,
    clampWithEllipsis: clampWithEllipsis
};

/***/ }),
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var PAGE_TYPE = Object.freeze({
    ABOUT: 'about',
    ASSOCIATION: 'association',
    ATTRIBUTE: 'attribute',
    BROWSE: 'browse',
    CHECKOUT: 'checkout',
    COLLECTION: 'collection',
    CREATOR: 'creator',
    DEALER: 'dealer',
    FAVORITES: 'favorites',
    HOME: 'home',
    INVOICE: 'invoice',
    LOCATION: 'location',
    MATERIAL: 'material',
    MESSAGE_CENTER: 'messageCenter',
    METAL: 'metal',
    ORIGIN: 'origin',
    PDP: 'pdp',
    PERIOD: 'period',
    RECOGNIZED_DEALERS: 'recognized_dealers',
    SEARCH: 'search',
    SECTION: 'section',
    STONE: 'stone',
    STYLE: 'style',
    TECHNIQUE: 'technique',
    TRADE_PROFILE: 'trade'
});

var BROWSE_TYPES = Object.freeze([PAGE_TYPE.ASSOCIATION, PAGE_TYPE.ATTRIBUTE, PAGE_TYPE.BROWSE, PAGE_TYPE.COLLECTION, PAGE_TYPE.CREATOR, PAGE_TYPE.LOCATION, PAGE_TYPE.MATERIAL, PAGE_TYPE.METAL, PAGE_TYPE.ORIGIN, PAGE_TYPE.PERIOD, PAGE_TYPE.RECOGNIZED_DEALERS, PAGE_TYPE.SECTION, PAGE_TYPE.STONE, PAGE_TYPE.STYLE, PAGE_TYPE.TECHNIQUE]);

module.exports = Object.freeze({
    PAGE_TYPE: PAGE_TYPE,
    BROWSE_TYPES: BROWSE_TYPES
});

/***/ }),
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-checkmark'].join(' '), 'data-tn': 'checkmark', viewBox: '0 0 250 250' },
                React.createElement('polygon', { points: '86.1,218.4 2.2,140.1 28.8,112 86.1,165.5 222.7,37.9 248.8,65.4 ' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: ronald
 * Date: 5/8/14
 * Time: 3:46 PM
 */



/**
 * @module {object} verticals
 * @property {string} VERTICAL_KEY          "VERTICAL_"
 * @property {string} PREFIX_KEY            "PREFIX_"
 * @property {string} VERTICAL_FURNITURE    "furniture"
 * @property {string} VERTICAL_FASHION      "fashion"
 * @property {string} VERTICAL_JEWELRY      "jewelry"
 * @property {string} VERTICAL_ART          "art"
 * @property {string} PREFIX_FURNITURE      "f_"
 * @property {string} PREFIX_FASHION        "v_"
 * @property {string} PREFIX_JEWELRY        "j_"
 * @property {string} PREFIX_ART            "a_"
 */
var verticals = {
    VERTICAL_KEY: 'VERTICAL_',
    PREFIX_KEY: 'PREFIX_',
    VERTICAL_FURNITURE: 'furniture',
    VERTICAL_FASHION: 'fashion',
    VERTICAL_JEWELRY: 'jewelry',
    VERTICAL_ART: 'art',
    PREFIX_FURNITURE: 'f_',
    PREFIX_FASHION: 'v_',
    PREFIX_JEWELRY: 'j_',
    PREFIX_ART: 'a_',
    DISPLAY_FURNITURE: 'Furniture',
    DISPLAY_FASHION: 'Fashion',
    DISPLAY_JEWELRY: 'Jewelry',
    DISPLAY_JEWELRY_WATCHES: 'Jewelry &amp; Watches',
    DISPLAY_ART: 'Fine Art'
};

/**
 * done to maintain support for the Category class
 * it was originally using `letterToVertical` method
 * and the signature was expecting the pk sans underscore
 * as its lone argument
 */
verticals.f = verticals.VERTICAL_FURNITURE;
verticals.v = verticals.VERTICAL_FASHION;
verticals.j = verticals.VERTICAL_JEWELRY;
verticals.a = verticals.VERTICAL_ART;
verticals.furniture = verticals.f;
verticals.fashion = verticals.v;
verticals.jewelry = verticals.j;
verticals.art = verticals.a;

/**
 * Verticals Prefix Map referenced on the Item Model used on the image upload page
 * Maps each prefix to its vertical and each vertical to its prefix
 * @type {{f_: string, a_: string, j_: string, v_: string, furniture: string, art: string, jewelry: string, fashion: string}}
 */
verticals.prefixMap = {};
verticals.prefixMap[verticals.PREFIX_FURNITURE] = verticals.VERTICAL_FURNITURE;
verticals.prefixMap[verticals.PREFIX_ART] = verticals.VERTICAL_ART;
verticals.prefixMap[verticals.PREFIX_JEWELRY] = verticals.VERTICAL_JEWELRY;
verticals.prefixMap[verticals.PREFIX_FASHION] = verticals.VERTICAL_FASHION;
verticals.prefixMap[verticals.VERTICAL_FURNITURE] = verticals.PREFIX_FURNITURE;
verticals.prefixMap[verticals.VERTICAL_ART] = verticals.PREFIX_ART;
verticals.prefixMap[verticals.VERTICAL_JEWELRY] = verticals.PREFIX_JEWELRY;
verticals.prefixMap[verticals.VERTICAL_FASHION] = verticals.PREFIX_FASHION;

/**
 * Verticals Display Name Map referenced in the ContactSupport helper
 * Maps each vertical to it's display name
 */
verticals.displayMap = {};
verticals.displayMap[verticals.VERTICAL_FURNITURE] = verticals.DISPLAY_FURNITURE;
verticals.displayMap[verticals.VERTICAL_ART] = verticals.DISPLAY_ART;
verticals.displayMap[verticals.VERTICAL_JEWELRY] = verticals.DISPLAY_JEWELRY;
verticals.displayMap[verticals.VERTICAL_FASHION] = verticals.DISPLAY_FASHION;

/**
 * Do some action for each vertical. Callback will be called with the following arguments :
 *      - vertical <string> - the vertical name
 *      - data <object> - a data object with info about the vertical containing :
 *          - name
 *          - pk
 *          - prefix
 * @param callback
 * @param context
 */
verticals.each = function (callback, context) {
    var self = this;
    var arr = [this.VERTICAL_FURNITURE, this.VERTICAL_FASHION, this.VERTICAL_JEWELRY, this.VERTICAL_ART];
    arr.forEach(function (vertical) {
        var caller = context ? context : null;
        var pk = self.getPrefix(vertical);
        callback.call(caller, vertical, pk);
    });
};

/**
 * @private
 * @param {string} keyPrefix The key prefix to use: VERTICAL_KEY or PREFIX_KEY
 * @param {string} vertical The vertical to use
 * @returns {string|null}
 */
function getWithKey(keyPrefix, vertical) {
    var ret;
    var prefix;
    if (keyPrefix && vertical) {
        prefix = verticals[keyPrefix] + vertical.toUpperCase();
        ret = verticals[prefix];
    }
    return ret || null;
}

/**
 * Get the vertical with a pk/prefix (ie. f_)
 * @private
 * @param value
 * @returns {string|null}
 */
function getWithPk(value) {
    if (verticals.testForPk(value)) {
        value = value[0];
    }
    return verticals[value] || null;
}

/**
 * Make sure an actual vertical is getting returned
 * @private
 * @param {string} vertical
 * @returns {string|null}
 */
function getVerticalValue(vertical) {
    var ret;
    if (vertical) {
        ret = getWithKey('VERTICAL_KEY', vertical);
    }
    return ret || null;
}

/**
 * @private
 * @param {string} vertical
 * @returns {string|null}
 */
function getPrefixValue(vertical) {
    var ret;
    if (vertical) {
        ret = getWithKey('PREFIX_KEY', vertical);
    }
    return ret || null;
}

/**
 * Is the value a pk/prefix?
 * @private
 * @param {string} value
 * @returns {boolean}
 */
verticals.testForPk = function (value) {
    return (/^[afjv]_\d*$/).test(value);
};

/**
 * This is due to the fact the Category model is was using the now
 * deleted `verticalToPrefix` method that was in this helper file.
 * In order to maintain compatibility with that class, this method
 * was created
 * @memberof module:verticals
 * @param {string} value The vertical
 * @returns {string|null}
 */
verticals.getPrefix = function (value) {
    var prefix = getPrefixValue(value);
    var vertical;
    if (!prefix && value) {
        vertical = getVerticalValue(value);
        prefix = getPrefixValue(vertical);
    }
    return prefix || null;
};

/**
 * This is due to the fact the Category model is was using the now
 * deleted `letterToVertical` method that was in this helper file.
 * In order to maintain compatibility with that class, this method
 * was created
 * @memberof module:verticals
 * @param {string} value Value to convert to a valid vertical
 * @returns {string|null}
 */
verticals.getVertical = function (value) {
    return getVerticalValue(value) ||
        getPrefixValue(value) ||
        getWithPk(value) ||
        // if no vertical is found, it shouldn't return a truthy value
        null;
};

/**
 * Gets the display name of the vertical given the vertical name
 * @param value
 * @returns {*|null}
 */
verticals.getDisplayFromVertical = function (value) {
    return verticals.displayMap[value] || null;
};

/**
 * Gets the display name of the vertical given the vertical prefix
 * @param value
 * @returns {*|null}
 */
verticals.getDisplayFromPrefix = function (value) {
    return verticals.displayMap[getWithPk(value)] || null;
};


// end "legacy" support
module.exports = Object.freeze ? Object.freeze(verticals) : verticals;


/***/ }),
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEnvironment = undefined;

var _reactRelay = __webpack_require__(17);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _dibsIsomorphicRelay = __webpack_require__(1108);

var _dibsIsomorphicRelay2 = _interopRequireDefault(_dibsIsomorphicRelay);

var _serverVars = __webpack_require__(18);

var _serverVars2 = _interopRequireDefault(_serverVars);

var _relayClientNetworkLayer = __webpack_require__(743);

var _relayClientNetworkLayer2 = _interopRequireDefault(_relayClientNetworkLayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var relayEnvironmentProvider = function relayEnvironmentProvider() {
    var environment = null;

    return {
        getEnvironment: function getEnvironment() {
            if (!environment) {
                environment = _reactRelay2.default.Store;
                environment.injectNetworkLayer((0, _relayClientNetworkLayer2.default)());

                // Todo: Put SV key in const file or pass in data?
                var preLoadedData = _serverVars2.default.get('header.preLoadedData');

                if (preLoadedData) {
                    _dibsIsomorphicRelay2.default.injectPreparedData(environment, preLoadedData);
                }
            }
            return environment;
        }
    };
};

var provider = relayEnvironmentProvider();
var getEnvironment = provider.getEnvironment;
exports.getEnvironment = getEnvironment;
exports.default = provider;

/***/ }),
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: hella
 * Date: 5/17/14
 * Time: 10:10 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 *
 * moved from .com/dibs/assets/js/global/core/commonjs/dibsConstants.js
 */



module.exports = {
    pageEventPrefix: 'page',
    // todo: use FinancialAmount model constants from bunsen (speak to rob if any questions)
    currency: {
        symbols: {
            pnd: '£',
            gbp: '£',
            eur: '€',
            usd: '$'
        },
        codes: {
            pnd: 'PND',
            gbp: 'PND',
            eur: 'EUR',
            usd: 'USD'
        }
    }
};

/***/ }),
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: hella
 * Date: 4/6/14
 * Time: 11:50 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */



var root = typeof window === 'undefined' ? global : window;
var vendor = root.navigator ? root.navigator.vendor : undefined;
var getIeDocumentMode;
var browserCheck;

getIeDocumentMode = function () {
    return root.document ? root.document.documentMode : undefined;
};

/**
 * Browser check since jQuery 1.9.x removes jQuery.browser
 * Some resources:
 * http://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
 * this checks for chrome:
 * http://stackoverflow.com/a/13348618/339698
 *
 * formerly:
 * js/global/core/dibs.js#browser
 * dibs.browser
 *
 * @module browserCheck
 */
browserCheck = module.exports = {
    /**
     * @returns {boolean}
     */
    chrome: function () {
        return !!root.chrome && vendor === 'Google Inc.' && !this.opera();
    },
    /**
     * @returns {boolean}
     */
    ie: function () {
        // global.document.body.style.msTextCombineHorizontal: 11+ (http://stackoverflow.com/questions/18907131/detecting-ie11-using-css-properties)
        // global.document.documentMode: 7-10
        return this.ie11() || (root.document ? !!root.document.documentMode : undefined);  //  formerly !!getIeDocumentMode()
    },
    /**
     * @returns {boolean}
     */
    ie8: function () {
        return this.ie() && getIeDocumentMode() === 8;
    },
    /**
     * @returns {boolean}
     */
    ie9: function () {
        return this.ie() && getIeDocumentMode() === 9;
    },
    /**
     * @returns {boolean}
     */
    ie10: function () {
        return this.ie() && !!root.navigator.msPointerEnabled;
    },
    /**
     * @returns {boolean}
     */
    ie11: function () {
        return root.document ? (typeof root.document.body.style.msTextCombineHorizontal !== 'undefined') : undefined;
    },
    /**
     * @returns {boolean}
     */
    mozilla: function () {
        return typeof root.InstallTrigger !== 'undefined';
    },
    /**
     * opera is using Blink + V8 so it mimics chrome a lot, but still differentiates the User Agent
     * @returns {boolean}
     */
    opera: function () {
        return !!root.opera || (root.navigator.userAgent && root.navigator.userAgent.indexOf(' OPR/') >= 0);
    },
    /**
     * @returns {boolean}
     */
    safari: function () {
        return vendor === 'Apple Computer, Inc.' &&
            Object.prototype.toString.call(root.HTMLElement).indexOf('Constructor') > 0;
    },
    /**
     * @returns {boolean}
     */
    webKit: function () {
        return !!root.WebKitPoint;
    }
};

// added for parity in original core/dibs.js
/**
 * @see {@link browserCheck#ie8}
 * @type {Function}
 */
browserCheck.isIE8  = browserCheck.ie8;
/**
 * @see {@link browserCheck#ie9}
 * @type {Function}
 */
browserCheck.isIE9  = browserCheck.ie9;
/**
 * @see {@link browserCheck#ie10}
 * @type {Function}
 */
browserCheck.isIE10 = browserCheck.ie10;
/**
 * @see {@link browserCheck#ie11}
 * @type {Function}
 */
browserCheck.isIE11 = browserCheck.ie11;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 491 */,
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 9/19/14
 * Time: 10:33 AM
 */



var $ = __webpack_require__(5);
var get = __webpack_require__(14);
var moment = __webpack_require__(30);
var DC = __webpack_require__(754);

var _require = __webpack_require__(282),
    localStorage = _require.localStorage,
    sessionStorage = _require.sessionStorage;

var helpers = __webpack_require__(371);
var redirects = __webpack_require__(352);

var _require2 = __webpack_require__(110),
    VARS = _require2.VARS;

var storage = module.exports = {
    setCookie: function setCookie(prop, val) {
        $.cookie(prop, val, DC.defaultCookieSettings);
    },
    setItem: function setItem(transactionId, key, value) {
        return localStorage.setItem('' + VARS.STORAGE_PREFIX + transactionId + key, value);
    },
    getItem: function getItem(transactionId, key) {
        return localStorage.getItem('' + VARS.STORAGE_PREFIX + transactionId + key);
    },
    getItemById: function getItemById(transactionId, key) {
        return localStorage.getItem('' + VARS.STORAGE_PREFIX + transactionId + key);
    },
    deleteItem: function deleteItem(transactionId, key) {
        return localStorage.deleteItem('' + VARS.STORAGE_PREFIX + transactionId + key);
    },
    deleteItemById: function deleteItemById(transactionId, key) {
        return localStorage.deleteItem('' + VARS.STORAGE_PREFIX + transactionId + key);
    },
    setSessionItem: function setSessionItem(key, value) {
        var itemId = redirects.getItemIdFromUrl();
        return sessionStorage.setItem('' + VARS.STORAGE_PREFIX + itemId + key, value);
    },
    getSessionItem: function getSessionItem(key) {
        var itemId = redirects.getItemIdFromUrl();
        return sessionStorage.getItem('' + VARS.STORAGE_PREFIX + itemId + key);
    },
    needsToTrackConfirmation: function needsToTrackConfirmation(transactionId) {
        return storage.setItem(transactionId, 'needsToTrackConfirmation', true);
    },
    hasNotTrackedConfirmation: function hasNotTrackedConfirmation(transactionId) {
        return storage.getItemById(transactionId, 'needsToTrackConfirmation');
    },
    trackedConfirmation: function trackedConfirmation(transactionId) {
        return storage.deleteItemById(transactionId, 'needsToTrackConfirmation');
    },
    hasTrackedEmail: function hasTrackedEmail() {
        return storage.getSessionItem('hasTrackedEmail');
    },
    trackedEmail: function trackedEmail() {
        return storage.setSessionItem('hasTrackedEmail', true);
    },
    setPreAuthOfferModalInfo: function setPreAuthOfferModalInfo() {
        return localStorage.setItem('checkoutPreAuthOfferModalInfo', {
            itemId: redirects.getItemIdFromUrl(),
            sellerId: redirects.getParamFromUrl('sellerId'),
            offerAmount: redirects.getParamFromUrl('offerAmount'),
            offerCurrency: redirects.getParamFromUrl('offerCurrency'),
            offerMessage: redirects.getParamFromUrl('message'),
            name: redirects.getParamFromUrl('name'),
            quantity: redirects.getParamFromUrl('quantity'),
            checkoutTime: moment().format()
        });
    },
    getPreAuthOfferModalInfo: function getPreAuthOfferModalInfo() {
        return localStorage.getItem('checkoutPreAuthOfferModalInfo');
    },
    clearPreAuthOfferModalInfo: function clearPreAuthOfferModalInfo() {
        return localStorage.deleteItem('checkoutPreAuthOfferModalInfo');
    },
    updatePreAuthOfferModalInfo: function updatePreAuthOfferModalInfo(options) {
        var preAuthOfferModalInfo = localStorage.getItem('checkoutPreAuthOfferModalInfo');
        var preAuthOfferModalPayload = Object.assign({}, preAuthOfferModalInfo, options);
        return localStorage.setItem('checkoutPreAuthOfferModalInfo', preAuthOfferModalPayload);
    },
    getHasSeenPreAuthOfferModal: function getHasSeenPreAuthOfferModal(itemId) {
        return itemId === get(localStorage.getItem('hasSeenPreAuthOfferModal'), 'itemId');
    },
    setHasSeenPreAuthOfferModal: function setHasSeenPreAuthOfferModal(itemId) {
        localStorage.setItem('hasSeenPreAuthOfferModal', { itemId: itemId });
    },
    setSurveyInfo: function setSurveyInfo() {
        var surveyInfo = storage.getSurveyInfo();
        var orderType = void 0;

        if (helpers.isPrivateOffer()) {
            orderType = "Private Offer";
        } else if (helpers.isPreAuthNegotiation()) {
            orderType = "Negotiations 2.0";
        } else if (helpers.isNegotiable()) {
            orderType = "Negotiations 1.5";
        } else {
            orderType = "Full Price";
        }
        return localStorage.setItem('checkoutSurveyInfo', {
            orderType: orderType,
            itemId: redirects.getItemIdFromUrl(),
            checkoutTime: moment().format(),
            step: surveyInfo.step
        });
    },
    updateSurveyInfo: function updateSurveyInfo(options) {
        var surveyInfo = storage.getSurveyInfo();
        var surveyPayload = Object.assign({}, surveyInfo, options);
        return localStorage.setItem('checkoutSurveyInfo', surveyPayload);
    },
    getSurveyInfo: function getSurveyInfo() {
        return localStorage.getItem('checkoutSurveyInfo');
    },
    unsetSurveyInfo: function unsetSurveyInfo() {
        return localStorage.deleteItem('checkoutSurveyInfo');
    },
    setHasSeenSurvey: function setHasSeenSurvey() {
        localStorage.setItem('hasSeenCheckoutSurvey', true);
    },
    getHasSeenSurvey: function getHasSeenSurvey() {
        return !!localStorage.getItem('hasSeenCheckoutSurvey');
    },
    incrementAppAdViews: function incrementAppAdViews() {
        var currentViews = storage.getAppAdViews();
        return localStorage.setItem('checkoutAppAdViews', currentViews++);
    },
    getAppAdViews: function getAppAdViews() {
        var value = localStorage.getItem('checkoutAppAdViews');
        return value ? parseInt(value) : 0;
    },
    itemNotAvailable: function itemNotAvailable(item) {
        var title = get(item, 'title');
        storage.setCookie(VARS.STORAGE_PREFIX + 'unavailableItem', title);
    }
};

/***/ }),
/* 493 */,
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var root = typeof window === 'undefined' ? global : window;

root.abExperiments = root.abExperiments || {};

module.exports = root.abExperiments;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var createHelper = function createHelper(func, helperName) {
  var setDisplayName = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
  var noArgs = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

  if (false) {
    var _ret = function () {
      /* eslint-disable global-require */
      var wrapDisplayName = require('./wrapDisplayName').default;
      /* eslint-enable global-require */

      if (noArgs) {
        return {
          v: function v(BaseComponent) {
            var Component = func(BaseComponent);
            Component.displayName = wrapDisplayName(BaseComponent, helperName);
            return Component;
          }
        };
      }

      return {
        v: function v() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (args.length > func.length) {
            /* eslint-disable */
            console.error(
            /* eslint-enable */
            'Too many arguments passed to ' + helperName + '(). It should called ' + ('like so: ' + helperName + '(...args)(BaseComponent).'));
          }

          return function (BaseComponent) {
            var Component = func.apply(undefined, args)(BaseComponent);
            Component.displayName = wrapDisplayName(BaseComponent, helperName);
            return Component;
          };
        }
      };
    }();

    if (typeof _ret === "object") return _ret.v;
  }

  return func;
};

exports.default = createHelper;

/***/ }),
/* 496 */,
/* 497 */,
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

__webpack_require__(2026);

var $ = __webpack_require__(5);
var Backbone = __webpack_require__(3);
var debounce = __webpack_require__(272);
var once = __webpack_require__(331);
var root = __webpack_require__(102);
var mobileCheck = __webpack_require__(283);

var _require = __webpack_require__(282),
    localStorage = _require.localStorage,
    sessionStorage = _require.sessionStorage;

var User = __webpack_require__(15);

var _require2 = __webpack_require__(135),
    provideContext = _require2.provideContext,
    connectToStores = _require2.connectToStores;

var authModalLoader = __webpack_require__(266).default;

var templates = __webpack_require__(3903);
var calloutTracking = __webpack_require__(711);
var favoritesActions = __webpack_require__(1361);
var CloseIcon = __webpack_require__(1267);

// Stores
var StickyAlertTopStore = __webpack_require__(327);
var CalloutStore = __webpack_require__(300);
var PortfolioStore = __webpack_require__(296);
var FavoritesStore = __webpack_require__(697);

var CALLOUT_LIMIT = 3;
var CALLOUT_STOPPED_KEY = 'stopped';
var STORAGE_KEY = 'favoriteCallout';

var calloutHelper = {

    CALLOUT_TYPE_SEARCH_BOX: 'searchBox',
    CALLOUT_TYPE_FOLLOW_SEARCH: 'followSearch',
    CALLOUT_TYPE_FOLLOW_DEALER: 'followDealer',
    CALLOUT_TYPE_SAVE_ITEM: 'saveItem',
    CALLOUT_TYPE_EDIT_FOLDER: 'editFolder',
    CALLOUT_TYPE_REARRANGE_ITEMS: 'rearrangeItems',
    CALLOUT_TYPE_SELECT_ITEMS: 'selectItems',
    CALLOUT_TYPE_LISTED_NET_PRICE: 'listedNetPrice',
    CALLOUT_TYPE_CHECKOUT_SURVEY: 'checkoutSurvey',
    CALLOUT_TYPE_VIEW_INVOICE: 'viewInvoice',
    CALLOUT_TYPE_SAVE_TO_FOLDER: 'saveToFolder',

    _wasShownAnyCallout: false,

    connectToStore: function connectToStore(component) {
        return provideContext(connectToStores(component, [CalloutStore], function (context) {
            var calloutStore = context.getStore(CalloutStore);

            return {
                callout: calloutStore.getCalloutData()
            };
        }));
    },


    /**
     * Checks callout shows limit,
     * was shown any type of callouts in this view.
     * Resets callout store after ajax page refresh.
     *
     * @return {Boolean}
     */
    canShowCallout: function canShowCallout(_ref) {
        var type = _ref.type;

        var wasShown = this._wasShown({ type: type }); // this type callout
        var wasShownAnyCallout = this._wasShown(); // any type of callouts
        var isStopped = this._isStopped();

        return wasShown || wasShownAnyCallout || isStopped ? false : true;
    },
    stopCallouts: function stopCallouts() {
        var sessionData = sessionStorage.getItem(STORAGE_KEY) || {};
        sessionData[CALLOUT_STOPPED_KEY] = true;
        sessionStorage.setItem(STORAGE_KEY, sessionData);
    },
    saveAndTrack: function saveAndTrack(payload) {
        this._wasShownAnyCallout = true;
        this.saveToStorage(payload);
        this.track(payload);
    },
    saveToStorage: function saveToStorage(payload) {
        var type = payload.type,
            turnOff = payload.turnOff;

        var _getSessionAndStorage = this._getSessionAndStorageData(type),
            session = _getSessionAndStorage.session,
            storage = _getSessionAndStorage.storage;

        storage[type]++;

        if (turnOff) {
            storage[type] = CALLOUT_LIMIT;
        }

        session[type] = true;
        this._setSessionAndStorageData({ session: session, storage: storage });
    },
    track: function track(payload) {
        var type = payload.type;

        var trackCallout = calloutTracking[type];

        if (trackCallout && typeof trackCallout === 'function') {
            trackCallout();
        }
    },
    resetCallout: function resetCallout() {
        this._wasShownAnyCallout = false;
    },


    /**
     * Enables Follow Search Callout after search form submit if Search Box Callout was shown
     */
    enableFollowSearchCallout: function enableFollowSearchCallout() {
        var type = this.CALLOUT_TYPE_FOLLOW_SEARCH;
        this._enableCallout(type);
    },
    subscribeSearchSubmit: function subscribeSearchSubmit() {
        $.subscribe('nav:search-performed', function () {
            calloutHelper.enableFollowSearchCallout();
        });
    },


    /**
     * Checks callout shows limit and peferred type
     * @return {Promise}
     */
    hasUserFavorites: function hasUserFavorites(payload) {
        var type = payload.type,
            favoriteType = payload.favoriteType,
            context = payload.context;

        var portfolioStore = context.getStore(PortfolioStore);
        var hasLocalSaves = portfolioStore.localItemsCount();

        if (hasLocalSaves) {
            calloutHelper.saveToStorage({ type: type, turnOff: true });
            return Promise.resolve(true);
        }

        return context.executeAction(favoritesActions.fetchFavorites).then(function () {
            var items = context.getStore(FavoritesStore).getFavoritesByType(favoriteType);
            if (items.length) {
                calloutHelper.saveToStorage({ type: type, turnOff: true });
                return true;
            }
            return false;
        });
    },
    showSaveItemCallout: function showSaveItemCallout(payload) {
        var context = payload.context,
            tooltipElement = payload.tooltipElement;

        var type = this.CALLOUT_TYPE_SAVE_ITEM;
        var productsResults = $('#productsResults');

        var closeCallback = function closeCallback() {
            productsResults.removeClass('is-favorites-visible');
        };
        productsResults.addClass('is-favorites-visible');

        this.saveAndTrack({ type: type });
        this._showSaveItemTooltip({ tooltipElement: tooltipElement, closeCallback: closeCallback, context: context });
    },
    showSaveToFolderCallout: function showSaveToFolderCallout(payload) {
        var context = payload.context,
            tooltipElement = payload.tooltipElement;

        var type = this.CALLOUT_TYPE_SAVE_TO_FOLDER;

        this.saveAndTrack({ type: type });
        this._showSaveToFolderTooltip({ tooltipElement: tooltipElement, context: context });
    },
    _getSessionAndStorageData: function _getSessionAndStorageData(type) {
        var storageData = localStorage.getItem(STORAGE_KEY);
        var sessionData = sessionStorage.getItem(STORAGE_KEY);
        var storage = _defineProperty({}, type, 0);
        var session = _defineProperty({}, type, false);

        if (storageData) {
            Object.assign(storage, storageData);
        }

        if (sessionData) {
            Object.assign(session, sessionData);
        }

        return { session: session, storage: storage };
    },
    _setSessionAndStorageData: function _setSessionAndStorageData(payload) {
        var session = payload.session,
            storage = payload.storage;

        localStorage.setItem(STORAGE_KEY, storage);
        sessionStorage.setItem(STORAGE_KEY, session);
    },
    _showSaveItemTooltip: function _showSaveItemTooltip(payload) {
        var tooltipElement = payload.tooltipElement,
            closeCallback = payload.closeCallback,
            context = payload.context;

        var position = {
            my: 'left top',
            at: 'left bottom+40'
        };
        var templateVars = {
            title: 'Save Beautiful Things',
            content: 'Save this item to create a collection of your Favorites.',
            closeIcon: CloseIcon
        };

        if (mobileCheck.any()) {
            templateVars = {
                content: 'Tap to save in your favorites.'
            };
        }

        this._showTooltip({ position: position, templateVars: templateVars, tooltipElement: tooltipElement, closeCallback: closeCallback, context: context });
    },
    _showSaveToFolderTooltip: function _showSaveToFolderTooltip(payload) {
        var tooltipElement = payload.tooltipElement,
            context = payload.context;

        var position = {
            my: 'left top',
            at: 'left bottom+40'
        };
        var templateVars = {
            title: 'Save this item in a folder',
            content: 'Click the folder icon to save items into organized folders.',
            closeIcon: CloseIcon
        };

        this._showTooltip({ position: position, templateVars: templateVars, tooltipElement: tooltipElement, closeCallback: null, context: context });
    },
    _showTooltip: function _showTooltip(payload) {
        var position = payload.position,
            templateVars = payload.templateVars,
            tooltipElement = payload.tooltipElement,
            closeCallback = payload.closeCallback,
            context = payload.context;

        var options = {
            position: {
                collision: 'fit',
                within: '#mainContent'
            },
            allwaysRepositionArrow: true
        };

        options.position = Object.assign(options.position, position);

        var tooltipView = this._getTooltip({ templateVars: templateVars }).render();

        this._createTooltip({
            tooltipElement: tooltipElement,
            closeCallback: closeCallback,
            tooltipView: tooltipView,
            options: options,
            context: context
        });
    },
    _getTooltip: function _getTooltip(payload) {
        var templateVars = payload.templateVars;


        var TooltipView = Backbone.BaseView.extend({
            template: templates.ctaMomentumTooltip,
            templateVars: templateVars,
            events: {
                'click .js-close-tooltip': '_handleCloseTooltipClick'
            },
            _handleCloseTooltipClick: function _handleCloseTooltipClick(event) {
                event.preventDefault();
                this.trigger('close');
            }
        });

        return new TooltipView();
    },
    _createTooltip: function _createTooltip(payload) {
        var _this = this;

        var tooltipElement = payload.tooltipElement,
            closeCallback = payload.closeCallback,
            tooltipView = payload.tooltipView,
            options = payload.options,
            context = payload.context;

        var stickyAlertTopStore = context.getStore(StickyAlertTopStore);
        var tooltipViewElement = tooltipView.el;
        var tooltipOptions = {
            content: function content() {
                return tooltipViewElement;
            },

            items: tooltipElement,
            tooltipClass: 'dibstooltip-momentum',
            disabled: true
        };

        tooltipElement.on('mouseout focusout mouseleave', this._stopPropagation).dibsTooltip(Object.assign(tooltipOptions, options)).dibsTooltip('disable').dibsTooltip('open');

        this._disableLinkTooltip(tooltipElement.children());

        var tooltipClose = debounce(function () {
            try {
                tooltipElement.dibsTooltip('close');
                _this._startPropagation(tooltipElement);
            } catch (e) {
                // nothing to catch
            }
        }, 500, true);

        var tooltipOpen = debounce(function () {
            try {
                tooltipElement.dibsTooltip('open');
                tooltipView.setElement(tooltipViewElement);
            } catch (e) {
                // nothing to catch
            }
        }, 500);

        root.addEventListener('resize', tooltipClose);
        root.addEventListener('resize', tooltipOpen);

        // Reposition when dfp scripts are loaded
        $.subscribe('dfp:script:loaded', function () {
            tooltipClose();
            tooltipOpen();
        });

        // Reposition when sticky alert top shows up
        stickyAlertTopStore.addChangeListener(tooltipClose);
        stickyAlertTopStore.addChangeListener(tooltipOpen);

        tooltipElement.children().one('click', function () {
            _this._handleTooltipElementClick({ tooltipElement: tooltipElement, closeCallback: closeCallback });
        });

        this._subscribeTooltipClose({ tooltipView: tooltipView, tooltipElement: tooltipElement, closeCallback: closeCallback });
    },
    _stopPropagation: function _stopPropagation(event) {
        // Stop propagation to disable auto fade out when tooltip loses focus
        event.stopImmediatePropagation();
    },
    _startPropagation: function _startPropagation(tooltipElement) {
        tooltipElement.off('mouseout focusout mouseleave', this._stopPropagation);
    },
    _disableLinkTooltip: function _disableLinkTooltip(tooltipElement) {
        try {
            tooltipElement.dibsTooltip('disable');
        } catch (e) {
            // nothing to catch
        }
    },
    _enableLinkTooltip: function _enableLinkTooltip(tooltipElement) {
        try {
            tooltipElement.dibsTooltip('enable');
        } catch (e) {
            // nothing to catch
        }
    },
    _handleTooltipElementClick: function _handleTooltipElementClick(payload) {
        var deactivateTracking = once(this._deactivateTracking);
        calloutTracking.activateTracking(true);
        this._handleTooltipClose(payload);

        if (User.loggedIn()) {
            deactivateTracking();
        } else {
            authModalLoader.getLoadPromise().then(function () {
                return deactivateTracking();
            });
        }
    },
    _deactivateTracking: function _deactivateTracking() {
        // Adding time out to make sure it gets correct save tracking object
        setTimeout(function () {
            calloutTracking.activateTracking(false);
        }, 1000);
    },
    _subscribeTooltipClose: function _subscribeTooltipClose(payload) {
        var _this2 = this;

        var tooltipView = payload.tooltipView,
            tooltipElement = payload.tooltipElement,
            closeCallback = payload.closeCallback;


        if (mobileCheck.any()) {
            var scrollToClose = 100; // scroll 100 pixels to close tooltip
            var positionToClose = $(root).scrollTop() + scrollToClose;
            root.addEventListener('scroll', function () {
                if ($(root).scrollTop() >= positionToClose) {
                    _this2._handleTooltipClose({ tooltipElement: tooltipElement, closeCallback: closeCallback });
                }
            });
        } else {
            var force = true;
            tooltipView.on('close', function () {
                return _this2._handleTooltipClose({ tooltipElement: tooltipElement, closeCallback: closeCallback, force: force });
            });

            root.addEventListener('click', function (event) {
                var isTooltip = !!$(event.target).closest('.ui-tooltip').length;
                if (isTooltip) {
                    return;
                }

                _this2._handleTooltipClose({ tooltipElement: tooltipElement, closeCallback: closeCallback });
            });
        }
    },
    _handleTooltipClose: function _handleTooltipClose(payload) {
        var tooltipElement = payload.tooltipElement,
            closeCallback = payload.closeCallback,
            force = payload.force;


        if (force) {
            calloutHelper.stopCallouts();
        }

        if (typeof closeCallback === 'function') {
            closeCallback();
        }

        try {
            tooltipElement.off('click', this._handleTooltipElementClick);
            tooltipElement.dibsTooltip('close');
            this._startPropagation(tooltipElement);

            this._enableLinkTooltip(tooltipElement.children());
        } catch (e) {
            // nothing to catch
        }
    },
    _wasShown: function _wasShown() {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var type = payload.type;


        if (type) {
            var storageData = localStorage.getItem(STORAGE_KEY);
            var sessionData = sessionStorage.getItem(STORAGE_KEY);

            return sessionData && sessionData[type] || storageData && storageData[type] >= CALLOUT_LIMIT;
        } else {
            return this._wasShownAnyCallout;
        }
    },
    _isStopped: function _isStopped() {
        var sessionData = sessionStorage.getItem(STORAGE_KEY);
        if (sessionData) {
            return sessionData[CALLOUT_STOPPED_KEY] === true;
        }
        return false;
    },
    _enableCallout: function _enableCallout(type) {
        var _getSessionAndStorage2 = this._getSessionAndStorageData(type),
            session = _getSessionAndStorage2.session,
            storage = _getSessionAndStorage2.storage;

        var showsCount = storage[type];

        if (showsCount && showsCount > 0) {
            storage[type] = showsCount - 1;
        }

        session[type] = false;
        this._setSessionAndStorageData({ session: session, storage: storage });
    }
};

module.exports = calloutHelper;

/***/ }),
/* 499 */,
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by augustocorvalan on 8/5/14.
 */


var _ = __webpack_require__(22);
var tracking = __webpack_require__(27);
var Price = __webpack_require__(66);

var getPriceType = function getPriceType(item, isTrade) {
    var hidingPrice = item.hidingPrice();
    var onHold = item.isOnHold();
    var isSold = item.isSold();
    var hasNetPrice = item.getPriceByType(Price.TYPE_NET);
    var isOnSale = item.getPriceByType(Price.TYPE_SALE);
    var priceType = "list price";
    if (onHold || isSold) {
        priceType = "N/A";
    } else if (isOnSale) {
        priceType = "saturday sale";
    } else if (hasNetPrice && isTrade) {
        priceType = "net price";
    } else if (hidingPrice) {
        priceType = "price upon request";
    }
    return priceType;
};

/**
 * @module purchaseTracking
 */
var PurchaseTracking = module.exports = function (options) {
    options = _.extend({
        item: undefined,
        namespace: undefined,
        defaultCategory: undefined
    }, options);
    this._item = options.item;
    this._pageContext = options.pageContext;
    this._category = options.category;
};
PurchaseTracking.prototype = {
    /**
     * @param {Object} adds purchase context properties to trackOptions and relays to dibs-tracking.trackEvent
     */
    trackEvent: function trackEvent(trackOptions, params) {
        params = params || {};
        return tracking.trackEvent(_.extend({
            action: trackOptions.actionPrefix + ' - ' + this._pageContext + ' ' + trackOptions.objectName,
            category: this._category,
            label: params.label || PurchaseTracking.getLabel({ item: this._item }),
            objectName: undefined // name of object related to this event
        }, trackOptions));
    },
    trackOfferEvent: function trackOfferEvent(trackOptions) {
        return this.trackEvent(_.extend({
            category: 'make offer click',
            action: this._pageContext + ' ' + trackOptions.actionSuffix
        }, trackOptions));
    },
    trackPurchaseEvent: function trackPurchaseEvent(trackOptions, params) {
        var options = _.extend({ category: 'purchase click' }, trackOptions);
        return this.trackEvent(options, params);
    },
    trackNetPriceEvent: function trackNetPriceEvent(trackOptions) {
        return tracking.trackEvent(_.extend({
            action: 'request net price ' + trackOptions.actionSuffix,
            category: 'request net price',
            label: PurchaseTracking.getLabel({ item: this._item, purchasableLabel: true, pageContext: this._pageContext })
        }, trackOptions));
    },
    /**
     * method version of PurchaseTracking.ecommerceAddToCartTracking
     */
    ecommerceAddToCartTracking: function ecommerceAddToCartTracking() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return PurchaseTracking.ecommerceAddToCartTracking(_.extend({
            id: this._item.get('id'),
            name: this._item.get('title'),
            brand: this._item.get('seller.id'),
            price: this._item.get('pricing.totalAmount.convertedAmounts.USD'),
            dimension76: getPriceType(this._item, options.isTrade),
            category: _.chain(this._item.get('classification.inflatedCategories')).last().pluck('label').value().join('/') || undefined
        }, options));
    }
};
_.extend(PurchaseTracking, { // static methods
    /**
     * @param {Object} options
     */
    getLabel: function getLabel(options) {
        options = _.extend({
            item: undefined,
            purchasableLabel: undefined,
            pageContext: undefined
        }, options);

        var item = options.item;
        var labelInfo = options.labelInfo || {};

        if (item) {
            if (options.purchasableLabel) {
                labelInfo.pur = item.canMakePurchase();
            }

            // MCPERSON-1391/1392: For request net price on the pdp, analytics wants the neg flag logic
            // to resemble the logic used for the same flag in the GA productStatus custom dimension.
            // It uses the logic in models/inventory/Item.php#canMakeOffer so PUR items are always categorized as not negotiable.
            // With this pageContext condition, PUR items will have a value of neg='n' on the pdp,
            // but can have a value of neg='y' in mc (this currently happens on the acceptOffer button for PUR items).
            // Eventually when buyers can make offers on the pdp on PUR items, this page context condition can be removed.
            labelInfo.neg = options.pageContext === 'pdp' ? item.canMakeBuyerOffer() : item.isNegotiablePrice();
            labelInfo.ship = !!_.chain(item.get('shipmentQuotes')).result('first').result('getAmountCurrencies').value();
            // if this happens to be a graphql response, 'returnPolicy.accept' is a boolean
            labelInfo.ret = item.get('returnPolicy.accept') === true || item.get('returnPolicy.accept') === 'Y';
        }

        return _.map(labelInfo, function (result, label) {
            return [label, result ? 'y' : 'n'].join('=');
        }).join('|');
    },
    /**
     * @param {Object} item
     * @param {String} category
     * @param {String} action
     */
    firePurchaseButtonTracking: function firePurchaseButtonTracking(item, category, action, params) {
        return new PurchaseTracking({ item: item }).trackPurchaseEvent({ action: action }, params);
    },

    /**
     * @param {Object} options
     * @param {String} url
     * @param {String} dealerPk
     * @param {String} price
     */
    //                                   (url, dealerPk, price) { // legacy form
    ecommerceAddToCartTracking: function ecommerceAddToCartTracking(options) {
        if ("string" === typeof options) {
            options = {
                url: arguments[0],
                brand: arguments[1],
                price: arguments[2]
            };
        } else {
            options = _.extend({
                url: undefined,
                dealerPk: undefined,
                price: undefined
            }, options);
        }
        tracking.trackEcommerce({
            type: 'addToCart',
            products: [_.pick(options, 'url', 'price', 'id', 'name', 'category', 'dimension76', 'brand')]
        });
    }
});

/***/ }),
/* 501 */,
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FavoritesStore = __webpack_require__(697);

var FavoritePageStore = function (_FavoritesStore) {
    _inherits(FavoritePageStore, _FavoritesStore);

    function FavoritePageStore(dispatcher) {
        _classCallCheck(this, FavoritePageStore);

        var _this = _possibleConstructorReturn(this, (FavoritePageStore.__proto__ || Object.getPrototypeOf(FavoritePageStore)).call(this, dispatcher));

        _this._isFetched = {};
        _this._isLoading = {};
        _this._forceSuccess = {};
        return _this;
    }

    _createClass(FavoritePageStore, [{
        key: '_onFetchStart',
        value: function _onFetchStart(_ref) {
            var type = _ref.type;

            this._error = null;
            this._isLoading[type] = true;
            this.emitChange();
        }
    }, {
        key: '_onFetchEnd',
        value: function _onFetchEnd(_ref2) {
            var type = _ref2.type;

            this._isFetched[type] = true;
            this._isLoading[type] = false;
            this.emitChange();
        }
    }, {
        key: '_onForceSuccess',
        value: function _onForceSuccess(_ref3) {
            var type = _ref3.type,
                _ref3$value = _ref3.value,
                value = _ref3$value === undefined ? false : _ref3$value;

            this._forceSuccess[type] = value;
            this.emitChange();
        }
    }, {
        key: 'getCollection',
        value: function getCollection() {
            return this._collection;
        }
    }, {
        key: 'getFavoriteId',
        value: function getFavoriteId(type) {
            var model = this._collection.findWhere({ type: type });
            var id = null;

            if (model) {
                id = model.get('id');
            }

            return id;
        }
    }, {
        key: 'isSaved',
        value: function isSaved(type) {
            var model = this._collection.findWhere({ type: type });
            return !!model && !model.isNew();
        }
    }, {
        key: 'isFetched',
        value: function isFetched(type) {
            return this._isFetched[type] || false;
        }
    }, {
        key: 'isLoading',
        value: function isLoading(type) {
            return this._isLoading[type] || false;
        }
    }, {
        key: 'getForceSuccess',
        value: function getForceSuccess(type) {
            return this._forceSuccess[type] || false;
        }
    }]);

    return FavoritePageStore;
}(FavoritesStore);

;

FavoritePageStore.storeName = 'FavoritePageStore';

FavoritePageStore.handlers = {
    'favoritePage:fetch:start': '_onFetchStart',
    'favoritePage:fetch:end': '_onFetchEnd',
    'favoritePage:error': '_onFavoriteError',

    'favorites:favorite:add': '_onFavoriteAdd',
    'favorites:favorite:remove': '_onFavoriteRemove',

    'favoritePage:forceSuccess': '_onForceSuccess',
    'favorite:canceled': '_onFavoriteCanceled'
};

module.exports = FavoritePageStore;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var calloutHelper = __webpack_require__(498);

var calloutActions = {
    openCallout: function openCallout(actionContext, payload, done) {
        calloutHelper.saveAndTrack(payload);
        actionContext.dispatch('callout:open', payload);
        done();
    },
    closeCallout: function closeCallout(actionContext, payload, done) {
        actionContext.dispatch('callout:close', payload);
        done();
    },
    closeAllCallouts: function closeAllCallouts(actionContext, payload, done) {
        calloutHelper.resetCallout();
        actionContext.dispatch('callout:closeAll', payload);
        done();
    },
    stopCallouts: function stopCallouts(actionContext, payload, done) {
        calloutHelper.stopCallouts();
        done();
    }
};

module.exports = calloutActions;

/***/ }),
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 9/24/14
 * Time: 5:43 PM
 */



var get = __webpack_require__(14);
var moment = __webpack_require__(30);
var helpers = __webpack_require__(371);
var redirects = __webpack_require__(352);
var userHelpers = __webpack_require__(543);

var _require = __webpack_require__(1058),
    GA_BOOLEANS = _require.GA_BOOLEANS,
    GA_FRAGMENT = _require.GA_FRAGMENT;

var authConstants = __webpack_require__(266).default.constants;

var getYesNoType = function getYesNoType(condition) {
    return condition ? GA_BOOLEANS.BOOLEAN_YES : GA_BOOLEANS.BOOLEAN_NO;
};
var getGAFragment = function getGAFragment(prefix, val) {
    return prefix + '=' + val;
};
var getYesNoGAFragment = function getYesNoGAFragment(prefix, condition) {
    return prefix + '=' + getYesNoType(condition);
};

var trackHelpers = module.exports = {
    _getCheckoutTriggerFromQueryParam: function _getCheckoutTriggerFromQueryParam() {
        var trigger = redirects.getParamFromUrl('checkout_trigger');

        if (redirects.isUserComesFromEmail()) {
            trigger = 'email';
        } else if (redirects.isUserComesFromAcceptedOffer()) {
            if (this.getCheckoutTriggerFromReferrer() === 'message center') {
                trigger = 'message center';
            } else {
                trigger = 'my orders';
            }
        }
        return trigger;
    },
    getGAVerificationObj: function getGAVerificationObj(interaction) {
        return {
            category: authConstants.LOGIN,
            action: 'verification ' + interaction,
            label: 'before checkout page'
        };
    },
    getGATransactionType: function getGATransactionType() {
        return helpers.isNegotiable() ? 'make offer' : 'purchase';
    },
    getCheckoutTriggerFromReferrer: function getCheckoutTriggerFromReferrer() {
        var referrer = document.referrer;
        var trigger = void 0;

        if (referrer.indexOf('favorites') > -1) {
            trigger = 'favorites';
        } else if (referrer.indexOf('conversations') > -1) {
            trigger = 'message center';
        } else if (referrer.indexOf('cart') > -1) {
            trigger = 'cart';
        } else if (referrer.indexOf('id-') > -1 && referrer.indexOf('checkout') === -1) {
            trigger = 'pdp';
        }
        return trigger;
    },
    getCheckoutTrigger: function getCheckoutTrigger() {
        return trackHelpers._getCheckoutTriggerFromQueryParam() || trackHelpers.getCheckoutTriggerFromReferrer();
    },
    getPostingLocation: function getPostingLocation(item) {
        if (get(item, 'isNewListing')) {
            return 'New Listings';
        } else if (get(item, 'isPublishedMarketplace')) {
            return 'Marketplace';
        } else if (get(item, 'isPublishedStorefront')) {
            return 'Storefront';
        }
        return '';
    },
    getPurchaseStatus: function getPurchaseStatus(item) {
        return [getYesNoGAFragment(GA_FRAGMENT.FRAGMENT_PURCHASABLE, get(item, 'isAvailable')), getYesNoGAFragment(GA_FRAGMENT.FRAGMENT_NEGOTIABLE, get(item, 'pricing.negotiable')), getYesNoGAFragment(GA_FRAGMENT.FRAGMENT_RETURNABLE, get(item, 'returnPolicy.accept'))].join('|');
    },
    getClassification: function getClassification(item) {
        var categories = get(item, 'classification.categories', []);
        return get(categories[0], 'category.name');
    },
    getClassifications: function getClassifications(item) {
        var categories = get(item, 'classification.categories', []);
        var names = [];
        categories.forEach(function (c) {
            return names.push(get(c, 'name'));
        });
        return names.join('/');
    },
    formatDate: function formatDate(unixDate) {
        var date = new Date(unixDate);
        return moment(date).format('MM-DD-YYYY');
    },
    getCallToAction: function getCallToAction() {
        if (helpers.isNegotiable()) {
            return 'make offer';
        } else if (redirects.getParamFromUrl('fullPrice') === 'true') {
            return 'purchase at full price';
        } else if (redirects.isUserComesFromAcceptedOffer()) {
            return 'accept offer';
        } else {
            return 'purchase';
        }
    },
    getAdditionalEmbeddedRegistrationGTM: function getAdditionalEmbeddedRegistrationGTM(buyer) {
        var isVIPBuyer = get(buyer, 'isVip');
        var canUseNetPrice = get(buyer, 'canUseNetPrice');
        var customerType = void 0;

        if (canUseNetPrice && isVIPBuyer) {
            customerType = 'Trade and VIP';
        } else if (canUseNetPrice) {
            customerType = 'Trade';
        } else if (isVIPBuyer) {
            customerType = 'VIP';
        } else {
            customerType = 'Consumer';
        }
        return {
            userID: userHelpers.getUserId(),
            loginStatus: 'Logged In',
            registrationStatus: 'Registered',
            customerType: customerType
        };
    },
    getItemLargePhotosCount: function getItemLargePhotosCount(item) {
        var photos = get(item, 'photos');
        var count = 0;

        photos.forEach(function (photo) {
            var versions = get(photo, 'versions');
            var hasLargeVersion = !!versions.filter(function (v) {
                return get(v, 'type.name') === 'large' && get(v, 'webPath');
            }).length;
            if (hasLargeVersion) {
                ++count;
            }
        });
        return count;
    },
    getItemDates: function getItemDates(item) {
        var releaseDate = get(item, 'releaseDate');
        var soldDate = 'none';
        var released = releaseDate && trackHelpers.formatDate(releaseDate) || 'none';
        return [getGAFragment(GA_FRAGMENT.FRAGMENT_RELEASED_DATE, released), getGAFragment(GA_FRAGMENT.FRAGMENT_SOLD_DATE, soldDate)].join('|');
    },
    getOrderType: function getOrderType() {
        if (helpers.isPrivateOffer()) {
            return 'private offer';
        } else if (helpers.isNegotiable()) {
            return 'negotiated';
        } else {
            return 'full price';
        }
    },
    getPriceType: function getPriceType(item, buyer) {
        if (get(item, 'isSaturdaySale')) {
            return "saturday sale";
        } else if (get(buyer, 'isVerifiedTrade') && get(item, 'hasNetPrice')) {
            return "net price";
        } else if (get(item, 'isPriceUponRequest') && helpers.isPrivateOffer()) {
            return "price upon request";
        } else {
            return "list price";
        }
    },
    getItemProducts: function getItemProducts(item, transaction) {
        var offer = get(transaction, 'mostRecentOffer');
        return {
            id: get(item, 'serviceId'),
            name: get(item, 'title'),
            brand: get(item, 'seller.serviceId'),
            category: get(item, 'classification.categories[0].category.browseUrl'),
            price: get(offer, 'amountPerItem.convertedAmounts.USD'),
            quantity: get(offer, 'quantity')
        };
    }
};

/***/ }),
/* 508 */,
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(1535);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 510 */,
/* 511 */,
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(8);

/***/ }),
/* 513 */,
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(16);

/***/ }),
/* 515 */,
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.l = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// identity function for calling harmory imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };

/******/ 	// define getter function for harmory exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		Object.defineProperty(exports, name, {
/******/ 			configurable: false,
/******/ 			enumerable: true,
/******/ 			get: getter
/******/ 		});
/******/ 	};

/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 163);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

module.exports = __webpack_require__(1);

/***/ },
/* 1 */
/***/ function(module, exports) {

module.exports = __webpack_require__(2788);

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var currencyUtil = __webpack_require__(44);
var tracking = __webpack_require__(71);
var SV = __webpack_require__(162);
var get = __webpack_require__(1);
var pick = __webpack_require__(32);
var qs = __webpack_require__(33);
var PRICE_TYPES = __webpack_require__(30);

var undefined = void 0;

var _getVariantTrackingValue = function _getVariantTrackingValue(variant) {
    if (!variant) {
        return '';
    }
    if (variant === 'contactDealerGuidedCopy') {
        return 'pre-populated';
    }
    if (variant === 'contactDealerSidebar') {
        return 'contextual';
    }
    return variant;
};

var actions = module.exports = {
    eventOfferEnable: function eventOfferEnable(_ref) {
        var item = _ref.item,
            purchaseStatus = _ref.purchaseStatus,
            priceType = _ref.priceType,
            seller = _ref.seller;

        var trackedPrice = {};
        var dimension76 = void 0;

        tracking.trackEvent({
            category: 'make offer click',
            action: 'contact dealer modal',
            label: purchaseStatus
        });

        if (get(item, 'isPriceUponRequest')) {
            dimension76 = "price upon request";
        } else if (get(item, 'onHold') || get(item, 'isSold')) {
            dimension76 = "N/A";
        } else if (priceType === PRICE_TYPES.TYPE_SALE) {
            dimension76 = "saturday sale";
        } else if (priceType === PRICE_TYPES.TYPE_NET) {
            dimension76 = "trade net price";
        } else if (priceType === PRICE_TYPES.TYPE_RETAIL) {
            dimension76 = 'list price';
        }

        var prices = get(item, 'pricing.prices') || [];
        var price = prices.find(function (p) {
            return p.status === 'ACTIVE' && p.type === priceType;
        }) || {};
        if (get(price, 'amount.convertedAmountList')) {
            trackedPrice = price.amount.convertedAmountList.find(function (o) {
                return o.currency === 'USD';
            });
        }

        var categories = get(item, 'classification.categories') || [];
        var category = categories.length ? get(item, 'classification.categories[' + (categories.length - 1) + '].category.browseUrl') : undefined;

        tracking.trackEcommerce({
            type: 'addToCart',
            products: [{
                id: get(item, 'serviceId'),
                name: get(item, 'title'),
                brand: get(seller, 'serviceId'),
                price: get(trackedPrice, 'amount'),
                url: undefined,
                dealerPk: undefined,
                category: category,
                dimension76: dimension76
            }]
        });
    },
    eventOfferSuccessWithLowballOptions: function eventOfferSuccessWithLowballOptions(_ref2) {
        var selectedLowballOption = _ref2.selectedLowballOption,
            priceValue = _ref2.priceValue,
            offerAmount = _ref2.offerAmount,
            value = _ref2.value;

        var isOther = false;
        var isOriginalOffer = false;
        var percentage = void 0;
        if (selectedLowballOption) {
            isOther = selectedLowballOption.isOther;
            isOriginalOffer = selectedLowballOption.isOriginalOffer;
            percentage = 100 - selectedLowballOption.percentOff;
        } else {
            var offerValue = currencyUtil.parseFloat(offerAmount);
            percentage = offerValue / priceValue * 100;
        }
        var labelPartOne = selectedLowballOption && !isOriginalOffer ? 'revised' : 'initial';
        var labelPartTwo = !selectedLowballOption || isOther ? 'custom' : 'preset';
        var bucket = void 0;
        if (percentage === 100) {
            bucket = '100%';
        } else if (percentage > 90 && percentage < 100) {
            bucket = '91-99%';
        } else if (percentage > 80 && percentage <= 90) {
            bucket = '81-90%';
        } else if (percentage > 70 && percentage <= 80) {
            bucket = '71-80%';
        } else if (percentage > 60 && percentage <= 70) {
            bucket = '61-70%';
        } else if (percentage > 50 && percentage <= 60) {
            bucket = '51-60%';
        } else if (percentage > 40 && percentage <= 50) {
            bucket = '41-50%';
        } else if (percentage > 30 && percentage <= 40) {
            bucket = '31-40%';
        } else if (percentage > 20 && percentage <= 30) {
            bucket = '21-30%';
        } else if (percentage > 10 && percentage <= 20) {
            bucket = '11-20%';
        } else {
            bucket = '1-10%';
        }
        tracking.trackEvent({
            category: 'make offer form interaction',
            action: 'continue offer',
            label: labelPartOne + '|' + labelPartTwo + '|' + bucket,
            value: value
        });
    },
    eventOfferError: function eventOfferError(_ref3) {
        var errorMessage = _ref3.errorMessage,
            source = _ref3.source;

        tracking.trackEvent({
            category: 'form error',
            action: 'make offer|' + source + ' form|offer amount',
            label: errorMessage
        });
    },
    eventHoldRequestEnabled: function eventHoldRequestEnabled(params) {
        tracking.trackEvent(actions.holdRequestBaseOptions(Object.assign({}, params, { action: 'clicked' })));
    },
    eventHoldRequestDisplayed: function eventHoldRequestDisplayed(params) {
        tracking.trackEvent(actions.holdRequestBaseOptions(Object.assign({}, params, { action: 'displayed' })));
    },
    eventHoldRequestSubmitted: function eventHoldRequestSubmitted(params) {
        var holdOptions = actions.holdRequestBaseOptions(Object.assign({}, params, { action: 'submitted' }));
        tracking.trackEvent(Object.assign(holdOptions, {
            label: '' + params.sourceModal
        }));
    },
    eventLaunch: function eventLaunch(params) {
        tracking.trackEvent(Object.assign(actions.contactDealerBaseOptions(params), {
            action: 'contact dealer clicked'
        }));
    },
    eventSend: function eventSend(params) {
        tracking.trackEvent(Object.assign(actions.contactDealerBaseOptions(params), {
            action: 'contact dealer send clicked'
        }));
    },
    eventContactSuccess: function eventContactSuccess(params) {
        tracking.trackEvent(Object.assign(actions.contactDealerBaseOptions(params), {
            action: 'contact dealer submitted',
            value: params.isOptIn ? 1 : 0
        }));
    },
    eventVariantDisplayed: function eventVariantDisplayed(optimizelyVariant) {
        var variant = _getVariantTrackingValue(optimizelyVariant);

        tracking.trackEvent(Object.assign(actions.constants.guidedCopyVariantParams, {
            label: variant + ' displayed'
        }));
    },
    eventGuidedPromptSelected: function eventGuidedPromptSelected() {
        var selection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        tracking.trackEvent(Object.assign(actions.constants.guidedCopyVariantParams, {
            label: 'pre-populated submitted|' + selection
        }));
    },
    eventPreAuthOfferModalShown: function eventPreAuthOfferModalShown(isAbandonCheckout) {
        tracking.trackEvent({
            category: 'product',
            action: 'offer inquiry entry',
            label: isAbandonCheckout ? 'abandon checkout' : 'make offer modal'
        });
    },
    eventPreAuthOfferModalSubmitted: function eventPreAuthOfferModalSubmitted(isAbandonCheckout) {
        tracking.trackEvent({
            category: 'product',
            action: 'offer inquiry submitted',
            label: isAbandonCheckout ? 'abandon checkout' : 'make offer modal'
        });
    },
    netPriceEventSubmitted: function netPriceEventSubmitted(_ref4) {
        var trackingParams = _ref4.trackingParams;

        var label = qs.stringify(pick(trackingParams.vpvParams, 'pur', 'neg', 'ship', 'ret'), { delimiter: '|' });

        tracking.trackEvent(Object.assign({
            category: 'request net price',
            action: 'request net price submitted',
            label: label
        }));
    },

    // taken from IABActions
    trackPageLoadModal: function trackPageLoadModal(_ref5) {
        var props = _ref5.props;

        var action = props.referredFromAmp ? 'pdp make offer button-amppage' : 'email make offer button - ' + props.tracking.emailTmplName;
        tracking.trackEvent({
            category: 'make offer click',
            action: action
        });
    },
    resetPage: function resetPage() {
        return tracking.addGTMMessage({
            pageType: SV.get('tracking.initialDataLayerInfo.pageType'),
            pageSubType: SV.get('tracking.initialDataLayerInfo.pageSubType')
        });
    },
    contactDealerBaseOptions: function contactDealerBaseOptions(_ref6) {
        var linkLocation = _ref6.linkLocation,
            optimizelyVariant = _ref6.optimizelyVariant,
            trackVariant = _ref6.trackVariant,
            guidedPromptSelection = _ref6.guidedPromptSelection;

        var trackingVariantLabel = trackVariant ? '|' + _getVariantTrackingValue(optimizelyVariant) : '';
        var guidedPromptLabel = guidedPromptSelection ? ': ' + guidedPromptSelection : '';
        return {
            category: 'contact dealer',
            label: '' + linkLocation + trackingVariantLabel + guidedPromptLabel
        };
    },
    holdRequestBaseOptions: function holdRequestBaseOptions(_ref7) {
        var action = _ref7.action,
            sourceModal = _ref7.sourceModal;

        return {
            category: 'product',
            action: 'request hold ' + action,
            label: sourceModal
        };
    },
    offerInquiryEntry: function offerInquiryEntry() {
        tracking.trackEvent({
            category: 'product',
            action: 'offer inquiry entry',
            label: 'make offer modal'
        });
    },
    offerInquirySubmitted: function offerInquirySubmitted() {
        tracking.trackEvent({
            category: 'product',
            action: 'offer inquiry submitted',
            label: 'make offer modal'
        });
    },
    abandonOfferEntry: function abandonOfferEntry() {
        tracking.trackEvent({
            category: 'product',
            action: 'offer inquiry entry',
            label: 'checkout abandon modal: send offer without payment info'
        });
    },
    abandonOfferSubmitted: function abandonOfferSubmitted() {
        tracking.trackEvent({
            category: 'product',
            action: 'offer inquiry submitted',
            label: 'checkout abandon modal: send offer without payment info'
        });
    },


    //confirmation modal tracking
    appInstallClicked: function appInstallClicked() {
        tracking.trackEvent({
            category: 'app promotion actions',
            action: 'click to download iphone app',
            label: 'link click from contact dealer confirmation modal - continue in app'
        });
    },
    confirmationEntry: function confirmationEntry(_ref8) {
        var _ref8$secondaryMessag = _ref8.secondaryMessage,
            secondaryMessage = _ref8$secondaryMessag === undefined ? '' : _ref8$secondaryMessag;

        tracking.trackEvent({
            category: 'contact dealer',
            action: 'contact dealer confirmation modal displayed',
            label: secondaryMessage
        });
    },
    convertedHoldRequestFromConfirmationModal: function convertedHoldRequestFromConfirmationModal() {
        tracking.trackEvent({
            category: 'product',
            action: 'request hold submitted',
            label: 'contact dealer confirmation modal'
        });
    },
    favoriteDealerClicked: function favoriteDealerClicked() {
        tracking.trackEvent({
            category: 'dealer favoriting',
            action: 'dealer added',
            label: 'contact dealer confirmation modal'
        });
    },
    holdRequestSecondaryMessageShown: function holdRequestSecondaryMessageShown() {
        tracking.trackEvent({
            category: 'product',
            action: 'request hold displayed',
            label: 'contact dealer confirmation modal'
        });
    },
    makeOfferSecondaryCtaClicked: function makeOfferSecondaryCtaClicked() {
        tracking.trackEvent({
            category: 'make offer click',
            action: 'contact dealer confirmation modal'
        });
    },
    tradeApplicationLinkClicked: function tradeApplicationLinkClicked() {
        tracking.trackEvent({
            category: 'contact dealer',
            action: 'contact dealer form interaction',
            label: 'confirmation modal - apply to trade clicked'
        });
    },


    constants: {
        contactFollowDealerParams: {
            category: 'dealer favoriting',
            action: 'dealer added',
            label: 'contact dealer confirmation modal'
        },

        netPriceFollowDealerParams: {
            category: 'dealer favoriting',
            action: 'dealer added',
            label: 'net price confirmation modal'
        },

        offerFollowDealerParams: {
            category: 'dealer favoriting',
            action: 'dealer added',
            label: 'make offer confirmation modal'
        },

        contactOmtLinkParams: {
            category: 'contact dealer',
            action: 'contact dealer form interaction',
            label: 'view offer in bomt'
        },

        netPriceOmtLinkParams: {
            category: 'net price',
            action: 'net price form interaction',
            label: 'view offer in bomt'
        },

        offerOmtLinkParams: {
            category: 'make offer form interaction',
            action: 'view offer in bomt'
        },

        guidedCopyVariantParams: {
            category: 'contact dealer',
            action: 'guided contact dealer'
        },

        authFlowParams: {
            label: 'offer inquiry'
        }
    }
};

/***/ },
/* 3 */
/***/ function(module, exports) {

module.exports = {
	"clearAuthResultAction": "CLEAR_AUTH_RESULT_ACTION",
	"clearValidationErrors": "CLEAR_VALIDATION_ERRORS",
	"closeModal": "CLOSE_MODAL",
	"contactDataLoaded": "CONTACT_DATA_LOADED",
	"failedValidation": "FAILED_VALIDATION",
	"gotoModalStep": "GOTO_MODAL_STEP",
	"hideActiveModal": "HIDE_ACTIVE_MODAL",
	"holdFromConfirmationModal": "HOLD_REQUESTED_CONFIRMATION_MODAL",
	"initLowballOptions": "INIT_LOWBALL_OPTIONS",
	"messageSuccess": "MESSAGE_SENT",
	"modalIsSending": "MODAL_IS_SENDING",
	"openModal": "OPEN_MODAL",
	"resetContactField": "RESET_CONTACT_FIELD",
	"resetContactData": "RESET_CONTACT_DATA",
	"setAuthResultAction": "SET_AUTH_RESULT_ACTION",
	"setDidEmailCheck": "SET_DID_EMAIL_CHECK",
	"setAuthWasMakeOffer": "SET_AUTH_WAS_MAKE_OFFER",
	"setGhostText": "SET_GHOST_TEXT",
	"setGuidedPromptSelection": "SET_GUIDED_PROMPT_SELECTION",
	"setHideBackLink": "SET_HIDE_BACK_BUTTON",
	"setLowballOfferDiscount": "SET_LOWBALL_OFFER_DISCOUNT",
	"setLowballOption": "SET_LOWBALL_OPTION",
	"setServiceError": "SET_SERVICE_ERROR",
	"showActiveModal": "SHOW_ACTIVE_MODAL",
	"toggleMessage": "TOGGLE_MESSAGE_FIELD",
	"updateContactFields": "UPDATE_CONTACT_FIELDS",
	"setPreAuthOfferLowball": "SET_PRE_AUTH_OFFER_LOWBALL"
};

/***/ },
/* 4 */
/***/ function(module, exports) {

module.exports = __webpack_require__(17);

/***/ },
/* 5 */
/***/ function(module, exports) {

module.exports = __webpack_require__(87);

/***/ },
/* 6 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mainFormContainer":"src-scss-form---mainFormContainer---3EgUV","offerInfo":"src-scss-form---offerInfo---20q95","priceInfo":"src-scss-form---priceInfo---1YH8z","disabledPrice":"src-scss-form---disabledPrice---1oiGY","offerSubmitLabel":"src-scss-form---offerSubmitLabel---1-FL4","form-input":"src-scss-form---form-input---1k8Xs","formInput":"src-scss-form---form-input---1k8Xs","form-radio-input":"src-scss-form---form-radio-input---3pu-Y","formRadioInput":"src-scss-form---form-radio-input---3pu-Y","form-checkbox":"src-scss-form---form-checkbox---3xBch","formCheckbox":"src-scss-form---form-checkbox---3xBch","form-select":"src-scss-form---form-select---3emXp","formSelect":"src-scss-form---form-select---3emXp","focused":"src-scss-form---focused---2EbRZ","form-radio-wrapper":"src-scss-form---form-radio-wrapper---QZYL3","formRadioWrapper":"src-scss-form---form-radio-wrapper---QZYL3","checkout-section-form-container":"src-scss-form---checkout-section-form-container---dR1tj","checkoutSectionFormContainer":"src-scss-form---checkout-section-form-container---dR1tj","checkout-saved-item":"src-scss-form---checkout-saved-item---2t8ID","checkoutSavedItem":"src-scss-form---checkout-saved-item---2t8ID","checkout-section-item":"src-scss-form---checkout-section-item---SSLC6","checkoutSectionItem":"src-scss-form---checkout-section-item---SSLC6","checkout-payment-form":"src-scss-form---checkout-payment-form---2EZD6","checkoutPaymentForm":"src-scss-form---checkout-payment-form---2EZD6","saved-address-new":"src-scss-form---saved-address-new---7xUQx","savedAddressNew":"src-scss-form---saved-address-new---7xUQx","saved-card-new":"src-scss-form---saved-card-new---11Svh","savedCardNew":"src-scss-form---saved-card-new---11Svh","expired":"src-scss-form---expired---1rHpI","disabled":"src-scss-form---disabled---2UOXZ","form-display-value":"src-scss-form---form-display-value---3XIrx","formDisplayValue":"src-scss-form---form-display-value---3XIrx","err-message":"src-scss-form---err-message---2y35v","errMessage":"src-scss-form---err-message---2y35v","active":"src-scss-form---active---2jHz5","preAuthOfferSubmitLabel":"src-scss-form---preAuthOfferSubmitLabel---dKbm4","spinnerWrapper":"src-scss-form---spinnerWrapper---2IMPv","centeredSpinner":"src-scss-form---centeredSpinner---3sulL","submitPreAuthOffer":"src-scss-form---submitPreAuthOffer---31tIE"};

/***/ },
/* 7 */
/***/ function(module, exports) {

module.exports = {
	"appInstallCta": "Install the App",
	"appInstallDescription": "Install the 1stdibs app to get notifications right to your phone when the dealer responds to your message.",
	"appInstallHeader": "Don't Miss the Dealer's Response",
	"confirmationHeader": "Thank You!",
	"favoriteItemCta": "Save Item",
	"favoriteItemDescription": "Save this piece to your favorites to get notified when it goes on sale.",
	"favoriteItemHeader": "Get Updates On This Piece",
	"followDealerCta": "FOLLOW DEALER",
	"followDealerHeader": "Stay Up-to-Date",
	"followDealerInstructions": "Follow to get weekly email alerts with new arrivals from this {dealerType}.",
	"makeOfferCta": "Make an Offer",
	"makeOfferDescription": "You can negotiate the price of this piece. Make an offer to show {dealerName} you're serious.",
	"makeOfferPrompt": "Don't let this piece get away.",
	"noThanksCta": "No, thanks",
	"placeHoldCta": "Request a Hold",
	"placeHoldDescription": "Place this item on hold while you review with your client.",
	"placeHoldRequestPrompt": "Don't let this piece get away.",
	"successMessage": "Your message has been sent to {dealerName}. <br> View all your messages in <a href='/my/conversations'>My Conversations</a>.",
	"successMessageHold": "Your message and hold request have been sent to {dealerName}. <br /> View all your requests and messages in <a href='/my/conversations'>My Conversations</a>.",
	"successMessageNetPrice": "Your request has been sent to {dealerName}. <br /> Ask questions about this piece or send additional messages in <a href='/my/conversations'>My Conversations</a>.",
	"successMessageNetPriceHold": "Requests submitted! <br /> You will be notified when the dealer responds with the net price and if the dealer places the piece on hold for you. Dealers typically respond within one day. View all your messages in <a href='/my/conversations'>My Conversations</a>.",
	"successMessagePrivateOffer": "Your offer has been sent to {dealerName}. <br /> View all your requests and messages in <a href='/my/conversations'>My Conversations</a>.",
	"tradeCta": "Apply Now",
	"tradeDescription": "Join our trade program to receive net prices and exclusive trade benefits.",
	"tradePrompt": "Sign up for 1stdibs Trade Program",
	"tradeSecondaryCta": "I'm not a member of the trade."
};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var ACTION_TYPES = __webpack_require__(3);

module.exports = {
    openModal: function openModal(modalType) {
        return {
            type: ACTION_TYPES.openModal,
            activeModal: modalType
        };
    },
    closeModal: function closeModal() {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return {
            type: ACTION_TYPES.closeModal,
            formSubmitted: payload.formSubmitted
        };
    },
    hideModal: function hideModal() {
        return {
            type: ACTION_TYPES.hideActiveModal
        };
    },
    showModal: function showModal() {
        return {
            type: ACTION_TYPES.showActiveModal
        };
    },
    goToStep: function goToStep(_ref) {
        var step = _ref.step,
            isBackLink = _ref.isBackLink,
            modalContentData = _ref.modalContentData;
        return {
            type: ACTION_TYPES.gotoModalStep,
            currentStep: step,
            isBackLink: isBackLink,
            modalContentData: modalContentData
        };
    }
};

/***/ },
/* 9 */
/***/ function(module, exports) {

module.exports = __webpack_require__(773);

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var isEmpty = __webpack_require__(158);
var contactModalTracking = __webpack_require__(2);
var ACTION_TYPES = __webpack_require__(3);
var _validateMessage = __webpack_require__(122);
var _validateOffer = __webpack_require__(123);

module.exports = {
    validateMessage: function validateMessage(_ref) {
        var validationPayload = _ref.validationPayload,
            options = _ref.options;

        var messageErrors = _validateMessage({ validationPayload: validationPayload, options: options });
        return isEmpty(messageErrors) ? Promise.resolve() : Promise.reject({ messageErrors: messageErrors });
    },
    validateOffer: function validateOffer(_ref2) {
        var validationPayload = _ref2.validationPayload,
            options = _ref2.options;

        var offerErrors = _validateOffer({ validationPayload: validationPayload, options: options });

        if (offerErrors && offerErrors.offer) {
            contactModalTracking.eventOfferError({
                source: 'offer',
                errorMessage: offerErrors.offer
            });
        }

        return isEmpty(offerErrors) ? Promise.resolve() : Promise.reject({
            isShowLowBallWarning: offerErrors.lowBall,
            offerErrors: offerErrors
        });
    },
    failedValidation: function failedValidation(_ref3) {
        var messageErrors = _ref3.messageErrors,
            offerErrors = _ref3.offerErrors,
            isShowLowBallWarning = _ref3.isShowLowBallWarning;
        return {
            type: ACTION_TYPES.failedValidation,
            messageErrors: messageErrors || {},
            offerErrors: offerErrors || {},
            isShowLowBallWarning: isShowLowBallWarning
        };
    }
};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var get = __webpack_require__(1);
var BuyerProfileMutation = __webpack_require__(60);
var ContactDealerMutation = __webpack_require__(38);
var HoldRequestMutation = __webpack_require__(39);
var MakePreAuthOfferMutation = __webpack_require__(121);
var FavoriteDealerMutation = __webpack_require__(25);
var FavoriteItemMutation = __webpack_require__(61);
var TradeStatusMutation = __webpack_require__(62);
var contactModalTracking = __webpack_require__(2);
var ACTION_TYPES = __webpack_require__(3);
var fetch = __webpack_require__(156);
var qs = __webpack_require__(33);
var modalWrapperActions = __webpack_require__(8);

module.exports = {
    updateBuyerProfile: function updateBuyerProfile(inputPayload) {
        return function (dispatch, getState) {
            var relay = inputPayload.relay,
                user = inputPayload.user,
                onSuccess = inputPayload.onSuccess,
                onFailure = inputPayload.onFailure;
            var nameFieldValue = getState().fields.nameFieldValue;

            var displayName = nameFieldValue || get(user, 'profile.displayName');

            return relay.commitUpdate(new BuyerProfileMutation({ user: user, displayName: displayName }), { onSuccess: onSuccess, onFailure: onFailure });
        };
    },
    sendPreAuthOffer: function sendPreAuthOffer(inputPayload) {
        return function () {
            var relay = inputPayload.relay,
                buyerId = inputPayload.buyerId,
                itemId = inputPayload.itemId,
                offerAmountPerItem = inputPayload.offerAmountPerItem,
                offerCurrency = inputPayload.offerCurrency,
                messageContent = inputPayload.messageContent,
                conversation = inputPayload.conversation,
                quantity = inputPayload.quantity,
                onSuccess = inputPayload.onSuccess,
                onFailure = inputPayload.onFailure;

            return relay.commitUpdate(new MakePreAuthOfferMutation({
                buyerId: buyerId,
                itemId: itemId,
                offerAmountPerItem: offerAmountPerItem,
                offerCurrency: offerCurrency,
                messageContent: messageContent,
                conversation: conversation,
                quantity: quantity
            }), { onSuccess: onSuccess, onFailure: onFailure });
        };
    },
    sendContactMessage: function sendContactMessage(inputPayload, mutationArgs) {
        return function (dispatch, getState) {
            var action = mutationArgs.action,
                context = mutationArgs.context,
                subject = mutationArgs.subject;
            var buyerItemConversation = inputPayload.buyerItemConversation,
                item = inputPayload.item,
                onFailure = inputPayload.onFailure,
                onSuccess = inputPayload.onSuccess,
                relay = inputPayload.relay,
                seller = inputPayload.seller,
                user = inputPayload.user;
            var _getState$fields = getState().fields,
                messageFieldValue = _getState$fields.messageFieldValue,
                optInFieldValue = _getState$fields.optInFieldValue;

            return relay.commitUpdate(new ContactDealerMutation({
                action: action,
                buyerItemConversation: buyerItemConversation,
                context: context,
                seller: seller,
                subject: subject,
                user: user,
                isOptIn: optInFieldValue,
                item: item || null,
                messageValue: messageFieldValue
            }), { onSuccess: onSuccess, onFailure: onFailure });
        };
    },
    sendHoldRequest: function sendHoldRequest(inputPayload) {
        return function () {
            var user = inputPayload.user,
                seller = inputPayload.seller,
                item = inputPayload.item,
                relay = inputPayload.relay,
                onSuccess = inputPayload.onSuccess,
                onFailure = inputPayload.onFailure;

            return relay.commitUpdate(new HoldRequestMutation({ user: user, seller: seller, item: item }), { onSuccess: onSuccess, onFailure: onFailure });
        };
    },
    emailCheckAndAuth: function emailCheckAndAuth() {
        return function (dispatch, getState) {
            var emailFieldValue = getState().fields.emailFieldValue;


            return fetch('/soa/identity-3/1/user?' + qs.stringify({ email: emailFieldValue }), { method: 'HEAD' }).then(function (res) {
                return res.status === 200;
            });
        };
    },
    goToSuccess: function goToSuccess(inputPayload) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return function (dispatch, getState) {
            var authResultAction = inputPayload.authResultAction,
                chatSuccessTag = inputPayload.chatSuccessTag,
                chatTracking = inputPayload.chatTracking,
                guidedPromptSelection = inputPayload.guidedPromptSelection,
                holdRequestFieldValue = inputPayload.holdRequestFieldValue,
                optimizelyVariant = inputPayload.optimizelyVariant,
                trackingModalName = inputPayload.trackingModalName;

            var trackingParams = getState().tracking;
            var optInFieldValue = getState().fields.optInFieldValue;


            dispatch({ type: ACTION_TYPES.resetContactData });

            if (authResultAction === 'register') {
                dispatch({ type: ACTION_TYPES.closeModal, formSubmitted: true });
            } else {
                dispatch(modalWrapperActions.goToStep({
                    modalContentData: {
                        copySuffix: '',
                        headerSuffix: ''
                    },
                    step: 'confirmation'
                }));
            }

            if (options.isPreAuthOffer) {
                // preAuthOffer tracking is handled in the component
                // this ensures no extra tracking events are fired
                // when successfully submitting a pre auth offer
                return;
            }
            if (options.isNetPrice) {
                contactModalTracking.netPriceEventSubmitted({ trackingParams: trackingParams });
            } else {
                var trackVariantAfterSubmission = void 0;

                if (typeof Storage !== "undefined") {
                    trackVariantAfterSubmission = sessionStorage.getItem('trackVariantAfterSubmission');
                }

                contactModalTracking.eventContactSuccess(Object.assign({}, trackingParams, {
                    isOptIn: optInFieldValue,
                    trackVariant: trackVariantAfterSubmission,
                    guidedPromptSelection: guidedPromptSelection,
                    optimizelyVariant: optimizelyVariant
                }));

                sessionStorage.removeItem('trackVariantAfterSubmission');
            }
            if (holdRequestFieldValue) {
                contactModalTracking.eventHoldRequestSubmitted({ sourceModal: trackingModalName });
            }

            var trackChatEvent = chatTracking ? chatTracking[chatSuccessTag] : false;
            if (trackChatEvent) {
                trackChatEvent();
            }
        };
    },
    favoriteDealer: function favoriteDealer(inputPayload) {
        return function () {
            var relay = inputPayload.relay,
                seller = inputPayload.seller,
                userId = inputPayload.userId;


            var favorite = seller.favoritesByUser.length > 0 ? seller.favoritesByUser[0] : null;

            //if favorite is truthy the user is already following the dealer
            if (!favorite) {
                relay.commitUpdate(new FavoriteDealerMutation({ favorite: favorite, seller: seller, userId: userId }));
            }
        };
    },
    favoriteItem: function favoriteItem(_ref) {
        var item = _ref.item,
            userId = _ref.userId,
            relay = _ref.relay;
        return function () {
            relay.commitUpdate(new FavoriteItemMutation({ action: 'ADD', item: item, userId: userId }));
        };
    },
    updateTradeStatus: function updateTradeStatus(user, tradeStatus, relay) {
        return function () {
            relay.commitUpdate(new TradeStatusMutation({ user: user, tradeStatus: tradeStatus }));
        };
    },
    errorHandler: function errorHandler() {
        return { type: ACTION_TYPES.setServiceError };
    }
};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var css = __webpack_require__(141);
var React = __webpack_require__(0);

function Submit(props) {
    var className = props.className,
        handleSubmit = props.handleSubmit,
        isDisabled = props.isDisabled,
        isBusy = props.isBusy,
        copyCtaBusy = props.copyCtaBusy,
        copyCta = props.copyCta,
        dataTn = props.dataTn;

    return React.createElement(
        'button',
        {
            className: className || 'button-primary button-large ' + css.submit,
            onClick: handleSubmit,
            disabled: isDisabled,
            'data-tn': dataTn
        },
        isBusy ? copyCtaBusy : copyCta
    );
}

Submit.propTypes = {
    handleSubmit: React.PropTypes.func,
    isDisabled: React.PropTypes.bool.isRequired,
    isBusy: React.PropTypes.bool.isRequired,
    copyCta: React.PropTypes.string.isRequired,
    copyCtaBusy: React.PropTypes.string.isRequired,
    dataTn: React.PropTypes.string
};

module.exports = Submit;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var get = __webpack_require__(1);
var ACTION_TYPES = __webpack_require__(3);
var _toggleMessage = function _toggleMessage() {
    return {
        type: ACTION_TYPES.toggleMessage
    };
};

module.exports = {
    updateContactModalFields: function updateContactModalFields(inputPayload) {
        return function (dispatch, getState) {
            var isMessageFieldOpen = get(getState(), 'fields.isMessageFieldOpen');
            dispatch(_extends({
                type: ACTION_TYPES.updateContactFields
            }, inputPayload));
            if (inputPayload.field === 'holdRequest' && inputPayload.value && !isMessageFieldOpen) {
                dispatch(_toggleMessage());
            }
        };
    },
    resetContactModalField: function resetContactModalField(fieldKey) {
        return {
            type: ACTION_TYPES.resetContactField,
            fieldKey: fieldKey
        };
    },
    toggleMessage: _toggleMessage
};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _require = __webpack_require__(10),
    validateMessage = _require.validateMessage,
    validateOffer = _require.validateOffer,
    failedValidation = _require.failedValidation;

var ACTION_TYPES = __webpack_require__(3);

var _require2 = __webpack_require__(13),
    resetContactModalField = _require2.resetContactModalField;

var postToCheckout = __webpack_require__(120);

var _require3 = __webpack_require__(8),
    hideModal = _require3.hideModal,
    goToStep = _require3.goToStep;

var get = __webpack_require__(1);
var tracking = __webpack_require__(2);
var pick = __webpack_require__(32);
var MC_ACTIONS = __webpack_require__(29);

var AUTH_ACTIONS = {
    LOGIN: 'login'
};

var initLowBallOptions = function initLowBallOptions(payload) {
    return function (dispatch) {
        dispatch(_extends({
            type: ACTION_TYPES.initLowballOptions
        }, payload));
        dispatch(resetContactModalField('offer'));
    };
};

var makeOfferActions = module.exports = {
    contactDataLoaded: function contactDataLoaded(payload) {
        return _extends({
            type: ACTION_TYPES.contactDataLoaded
        }, payload);
    },
    messageSuccess: function messageSuccess() {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return _extends({
            type: ACTION_TYPES.messageSuccess
        }, payload);
    },
    setLowBallOption: function setLowBallOption(payload) {
        return function (dispatch) {
            dispatch(_extends({
                type: ACTION_TYPES.clearValidationErrors
            }, payload));
            dispatch(_extends({
                type: ACTION_TYPES.setLowballOption
            }, payload));
            dispatch(_extends({
                type: ACTION_TYPES.updateContactFields
            }, payload));
        };
    },
    setLowBallOfferDiscount: function setLowBallOfferDiscount(payload) {
        return function (dispatch) {
            dispatch(_extends({
                type: ACTION_TYPES.clearValidationErrors
            }, payload));
            dispatch(_extends({
                type: ACTION_TYPES.setLowballOfferDiscount
            }, payload));
            dispatch(_extends({
                type: ACTION_TYPES.updateContactFields
            }, payload));
        };
    },
    setPreAuthOfferLowball: function setPreAuthOfferLowball(isPreAuthOffer) {
        return {
            type: ACTION_TYPES.setPreAuthOfferLowball,
            flag: isPreAuthOffer
        };
    },
    submitMakeOffer: function submitMakeOffer(inputPayload) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return function (dispatch, getState) {
            var copy = inputPayload.copy,
                currency = inputPayload.currency,
                priceValue = inputPayload.priceValue,
                isPricePerPiece = inputPayload.isPricePerPiece;
            var _getState$fields = getState().fields,
                messageFieldValue = _getState$fields.messageFieldValue,
                nameFieldValue = _getState$fields.nameFieldValue,
                offerFieldValue = _getState$fields.offerFieldValue;

            var messageValidation = Promise.resolve();
            if (messageFieldValue) {
                messageValidation = validateMessage({
                    validationPayload: { message: messageFieldValue },
                    options: { fields: ['message'] }
                });
            }

            var nameValidation = validateMessage({
                validationPayload: {
                    name: nameFieldValue
                },
                options: { fields: ['name'] }
            });

            return messageValidation.then(function () {
                return nameValidation;
            }).then(function () {
                return validateOffer({
                    validationPayload: {
                        offer: offerFieldValue,
                        relevantItemPrice: priceValue
                    },
                    options: options
                });
            }).then(function () {
                return postToCheckout(inputPayload);
            }).catch(function (errors) {
                dispatch(failedValidation(errors));
                if (errors.isShowLowBallWarning) {
                    var lowBallPayload = {
                        offerAmount: offerFieldValue,
                        currency: currency,
                        priceValue: priceValue,
                        isPricePerPiece: isPricePerPiece,
                        copy: copy
                    };
                    dispatch(initLowBallOptions(lowBallPayload));
                    dispatch(goToStep({ step: 'lowBall' }));
                }
            });
        };
    },
    submitPreAuthOffer: function submitPreAuthOffer(inputPayload) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return function (dispatch) {
            var copy = inputPayload.copy,
                currency = inputPayload.currency,
                priceValue = inputPayload.priceValue,
                isPricePerPiece = inputPayload.isPricePerPiece,
                isUserInitiallyLoggedIn = inputPayload.isUserInitiallyLoggedIn,
                startAuth = inputPayload.startAuth,
                seller = inputPayload.seller,
                forceEnvironmentUpdate = inputPayload.forceEnvironmentUpdate,
                emailValue = inputPayload.emailValue,
                messageValue = inputPayload.messageValue,
                nameValue = inputPayload.nameValue,
                offerValue = inputPayload.offerValue,
                userId = inputPayload.userId,
                itemId = inputPayload.itemId,
                relay = inputPayload.relay,
                conversation = inputPayload.conversation,
                quantityValue = inputPayload.quantityValue,
                isAbandonCheckout = inputPayload.isAbandonCheckout,
                goToSuccess = inputPayload.goToSuccess,
                errorHandler = inputPayload.errorHandler,
                user = inputPayload.user,
                isUserNameSet = inputPayload.isUserNameSet,
                sendPreAuthOffer = inputPayload.sendPreAuthOffer,
                _inputPayload$onSucce = inputPayload.onSuccess,
                _onSuccess = _inputPayload$onSucce === undefined ? function () {} : _inputPayload$onSucce,
                authResultAction = inputPayload.authResultAction;

            var shouldValidateName = !isUserNameSet;

            var messageValidation = Promise.resolve();
            if (!isAbandonCheckout) {
                messageValidation = validateMessage({
                    validationPayload: {
                        message: messageValue,
                        name: shouldValidateName ? nameValue : undefined
                    },
                    options: { fields: ['message'].concat(shouldValidateName ? ['name'] : []) }
                });
            }

            var offerValidation = Promise.resolve();
            if (!isAbandonCheckout) {
                offerValidation = validateOffer({
                    validationPayload: {
                        offer: offerValue,
                        relevantItemPrice: priceValue
                    },
                    options: options
                });
            }

            return messageValidation.then(function () {
                return offerValidation;
            }).then(function () {
                var updateBuyerProfile = Promise.resolve();

                if (shouldValidateName) {
                    updateBuyerProfile = function updateBuyerProfile(payloadUser) {
                        return new Promise(function (resolve) {
                            inputPayload.updateBuyerProfile({
                                relay: relay,
                                user: payloadUser || user,
                                onSuccess: resolve,
                                onFailure: errorHandler
                            });
                        });
                    };
                }

                if (!isUserInitiallyLoggedIn) {
                    dispatch(hideModal());
                    return startAuth({
                        dealerName: get(seller, 'sellerProfile.displayName'),
                        action: AUTH_ACTIONS.LOGIN,
                        email: emailValue,
                        makeOffer: true,
                        ga: {
                            label: tracking.constants.authFlowParams.label
                        }
                    }).then(function (authLoaderPayload) {
                        if (!authLoaderPayload.err) {
                            var _userId = authLoaderPayload.user.userId;

                            return updateBuyerProfile({ serviceId: _userId, displayName: nameValue }).then(function () {
                                dispatch({
                                    type: ACTION_TYPES.setAuthResultAction,
                                    actionName: authLoaderPayload.newUser ? 'register' : 'login'
                                });
                                dispatch({
                                    type: ACTION_TYPES.setAuthWasMakeOffer
                                });
                                forceEnvironmentUpdate({ shouldFetchUser: true });
                            });
                        }
                    });
                }

                dispatch({ type: ACTION_TYPES.modalIsSending });

                var preAuthOfferPayload = {
                    relay: relay,
                    buyerId: userId,
                    itemId: itemId,
                    offerAmountPerItem: offerValue,
                    offerCurrency: currency,
                    messageContent: messageValue,
                    conversation: conversation,
                    quantity: parseInt(quantityValue, 10),
                    onSuccess: function onSuccess() {
                        dispatch(makeOfferActions.messageSuccess({ messageType: MC_ACTIONS.privateOffer }));
                        tracking.eventPreAuthOfferModalSubmitted(isAbandonCheckout);
                        _onSuccess();
                        return goToSuccess(inputPayload, { isPreAuthOffer: true });
                    },
                    onFailure: function onFailure() {
                        return dispatch(errorHandler());
                    }
                };

                if (authResultAction === 'register') {
                    dispatch(hideModal());
                }

                if (shouldValidateName) {
                    return updateBuyerProfile().then(function () {
                        return sendPreAuthOffer(preAuthOfferPayload);
                    });
                }
                return sendPreAuthOffer(preAuthOfferPayload);
            }).catch(function (errors) {
                dispatch(failedValidation(errors));
                if (errors.isShowLowBallWarning) {
                    var lowBallPayload = {
                        offerAmount: offerValue,
                        currency: currency,
                        priceValue: priceValue,
                        isPricePerPiece: isPricePerPiece,
                        copy: copy
                    };
                    dispatch(initLowBallOptions(lowBallPayload));
                    dispatch(goToStep({ step: 'lowBall' }));
                }
            });
        };
    }
};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var InputWrapper = __webpack_require__(18);
var InputError = __webpack_require__(36);
var css = __webpack_require__(132);
var componentCss = __webpack_require__(131);

function MessageField(_ref) {
    var messageValue = _ref.messageValue,
        messagePlaceholder = _ref.messagePlaceholder,
        onMessageChange = _ref.onMessageChange,
        errors = _ref.errors,
        copy = _ref.copy,
        hideLabel = _ref.hideLabel,
        labelText = _ref.labelText,
        descriptionText = _ref.descriptionText;

    var inputWrapperProps = hideLabel ? { className: css.messageWrapper } : { label: labelText || copy.get('labelMessage') };
    return React.createElement(
        InputWrapper,
        inputWrapperProps,
        React.createElement('textarea', {
            className: componentCss.textarea,
            'data-tn': 'message-input',
            defaultValue: messageValue,
            onChange: function onChange(e) {
                return onMessageChange({ field: 'message', value: e.target.value });
            },
            placeholder: messagePlaceholder,
            type: 'text'
        }),
        React.createElement(InputError, { error: errors.message }),
        React.createElement(
            'div',
            { className: css.description },
            descriptionText
        )
    );
}

MessageField.propTypes = {
    messageValue: PropTypes.string,
    messagePlaceholder: PropTypes.string,
    onMessageChange: PropTypes.func,
    errors: PropTypes.object,
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    hideLabel: PropTypes.bool,
    labelText: PropTypes.string,
    descriptionText: PropTypes.string
};

module.exports = MessageField;

/***/ },
/* 16 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"src-scss-confirmation---container---1bVsM","successMessage":"src-scss-confirmation---successMessage---z7SEj","description":"src-scss-confirmation---description---BIMzR","secondaryContainer":"src-scss-confirmation---secondaryContainer---1qPdp","secondaryHeader":"src-scss-confirmation---secondaryHeader---3RDHA","primaryCta":"src-scss-confirmation---primaryCta---3DufF","secondaryCta":"src-scss-confirmation---secondaryCta---_2gny"};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var _require = __webpack_require__(149),
    Modal = _require.Modal,
    Header = _require.Header,
    Body = _require.Body;

var OverlaySpinner = __webpack_require__(70);
var composeClassNames = __webpack_require__(43);
var css = composeClassNames(__webpack_require__(134), __webpack_require__(133));
var copy = __webpack_require__(20)().extend(Object.assign({}, __webpack_require__(28)));
__webpack_require__(151);
__webpack_require__(68);

var ModalWrapper = function (_Component) {
    _inherits(ModalWrapper, _Component);

    function ModalWrapper() {
        _classCallCheck(this, ModalWrapper);

        return _possibleConstructorReturn(this, (ModalWrapper.__proto__ || Object.getPrototypeOf(ModalWrapper)).apply(this, arguments));
    }

    _createClass(ModalWrapper, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                openOnRender = _props.openOnRender,
                openModal = _props.openModal;

            if (openOnRender && openModal) {
                openModal();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                isLoading = _props2.isLoading,
                isOpened = _props2.isOpened,
                isError = _props2.isError,
                header = _props2.header,
                showHeaderBackLink = _props2.showHeaderBackLink,
                goToPrevStep = _props2.goToPrevStep,
                closeModal = _props2.closeModal,
                serviceErrorMsg = _props2.serviceErrorMsg,
                children = _props2.children;


            var backLink = showHeaderBackLink ? React.createElement(
                'span',
                { className: css.headerBackLink, onClick: goToPrevStep },
                '< Back'
            ) : null;

            var serviceError = React.createElement(
                'div',
                { className: css.serviceError },
                serviceErrorMsg ? serviceErrorMsg : copy.get('serviceError')
            );

            var bodyContent = children;
            if (isLoading) {
                bodyContent = React.createElement(OverlaySpinner, {
                    additionalWrapperClasses: css.spinnerWrapper,
                    additionalSpinnerClasses: css.centeredSpinner,
                    position: 'isAbsolute'
                });
            } else if (isError && children) {
                bodyContent = React.createElement(
                    'div',
                    null,
                    serviceError,
                    children
                );
            } else if (isError) {
                bodyContent = serviceError;
            }

            return React.createElement(
                Modal,
                {
                    isOpened: isOpened,
                    closeModal: closeModal
                },
                React.createElement(
                    Header,
                    { className: css.header },
                    backLink,
                    React.createElement(
                        'span',
                        { className: backLink ? css.headerTitle : "" },
                        isLoading ? copy.get('loading') : header
                    )
                ),
                React.createElement(
                    Body,
                    { bodyClass: css.body },
                    bodyContent
                )
            );
        }
    }]);

    return ModalWrapper;
}(Component);

ModalWrapper.propTypes = {
    modalType: PropTypes.string,
    showHeaderBackLink: PropTypes.bool,
    isOpened: PropTypes.bool,
    isLoading: PropTypes.bool,
    isError: PropTypes.bool,
    header: PropTypes.string,
    modalContent: PropTypes.node,
    modalSteps: PropTypes.array,
    currentStep: PropTypes.string,
    closeModal: PropTypes.func,
    openModal: PropTypes.func,
    openOnRender: PropTypes.bool,
    goToPrevStep: PropTypes.func,
    serviceErrorMsg: PropTypes.string,
    children: PropTypes.node
};

module.exports = ModalWrapper;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var css = __webpack_require__(129);
var React = __webpack_require__(0);
var PropTypes = React.PropTypes;


function InputWrapper(_ref) {
    var label = _ref.label,
        children = _ref.children,
        className = _ref.className;

    var labelNode = void 0;
    if (label) {
        labelNode = React.createElement(
            'label',
            { className: css.label },
            label
        );
    }
    return React.createElement(
        'div',
        { className: className },
        labelNode,
        React.createElement(
            'div',
            null,
            children
        )
    );
}

InputWrapper.propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node
};

InputWrapper.defaultProps = {
    className: css.wrapper
};

module.exports = InputWrapper;

/***/ },
/* 19 */
/***/ function(module, exports) {

module.exports = __webpack_require__(2784);

/***/ },
/* 20 */
/***/ function(module, exports) {

module.exports = __webpack_require__(38);

/***/ },
/* 21 */
/***/ function(module, exports) {

module.exports = __webpack_require__(275);

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var BasicInput = __webpack_require__(54);

function NameField(_ref) {
    var isUserNameSet = _ref.isUserNameSet,
        errors = _ref.errors,
        copy = _ref.copy,
        onNameChange = _ref.onNameChange,
        nameValue = _ref.nameValue;

    if (!isUserNameSet) {
        return React.createElement(BasicInput, {
            label: copy.get('labelName'),
            field: 'name',
            error: errors.name,
            dataTn: 'contact-dealer-name',
            onFieldChanged: onNameChange,
            value: nameValue
        });
    }
    return null;
}

NameField.propTypes = {
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    errors: PropTypes.object,
    isUserNameSet: PropTypes.bool,
    nameValue: PropTypes.string,
    onNameChange: PropTypes.func
};

module.exports = NameField;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var css = __webpack_require__(140);
var React = __webpack_require__(0);
var MinusIcon = __webpack_require__(154);
var PlusIcon = __webpack_require__(155);
var classNames = __webpack_require__(19);
var PropTypes = React.PropTypes;


function SectionToggle(props) {
    var onToggle = props.onToggle,
        isOpen = props.isOpen,
        children = props.children,
        toggleTn = props.toggleTn,
        toggleLabel = props.toggleLabel;

    return React.createElement(
        'div',
        { className: css.wrapper },
        React.createElement(
            'div',
            { className: css.toggle, onClick: onToggle, 'data-tn': toggleTn },
            React.createElement(
                'span',
                { className: css.label },
                toggleLabel
            ),
            React.createElement(MinusIcon, { className: classNames(css.icon, { 'is-hidden': !isOpen }) }),
            React.createElement(PlusIcon, { className: classNames(css.icon, { 'is-hidden': isOpen }) })
        ),
        isOpen ? children : ''
    );
}

SectionToggle.propTypes = {
    onToggle: PropTypes.func.isRequired,
    isOpen: PropTypes.bool,
    children: PropTypes.node,
    toggleTn: PropTypes.string,
    toggleLabel: PropTypes.string
};

module.exports = SectionToggle;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _reactRelay = __webpack_require__(4);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _toClass = __webpack_require__(161);

var _toClass2 = _interopRequireDefault(_toClass);

var _createHelper = __webpack_require__(160);

var _createHelper2 = _interopRequireDefault(_createHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createContainer = function createContainer(options) {
    return function (BaseComponent) {
        return _reactRelay2.default.createContainer((0, _toClass2.default)(BaseComponent), options);
    };
};

module.exports = (0, _createHelper2.default)(createContainer, 'createContainer', false);

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Relay = __webpack_require__(4);

var FavoriteDealerMutation = function (_Relay$Mutation) {
    _inherits(FavoriteDealerMutation, _Relay$Mutation);

    function FavoriteDealerMutation() {
        _classCallCheck(this, FavoriteDealerMutation);

        return _possibleConstructorReturn(this, (FavoriteDealerMutation.__proto__ || Object.getPrototypeOf(FavoriteDealerMutation)).apply(this, arguments));
    }

    _createClass(FavoriteDealerMutation, [{
        key: 'getMutation',
        value: function getMutation() {
            return function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'favoriteSeller',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'FavoriteSellerInput!'
                    },
                    name: 'FavoriteDealerMutation',
                    responseType: 'FavoriteSellerPayload'
                };
            }();
        }
    }, {
        key: 'getVariables',
        value: function getVariables() {
            return {
                userId: this.props.userId,
                sellerPk: this.props.seller.serviceId,
                favoriteId: this.props.favorite ? this.props.favorite.serviceId : null
            };
        }
    }, {
        key: 'getFatQuery',
        value: function getFatQuery() {
            return function () {
                return {
                    children: [{
                        children: [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'seller',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Seller'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'FavoriteDealerMutationRelayQL',
                    type: 'FavoriteSellerPayload'
                };
            }();
        }
    }, {
        key: 'getConfigs',
        value: function getConfigs() {
            return [{
                type: 'FIELDS_CHANGE',
                fieldIDs: { seller: this.props.seller.id }
            }];
        }
    }]);

    return FavoriteDealerMutation;
}(Relay.Mutation);

FavoriteDealerMutation.fragments = {
    seller: function seller() {
        return function () {
            return {
                children: [{
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isRequisite: true
                    },
                    type: 'ID'
                }, {
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'FavoriteDealerMutation_SellerRelayQL',
                type: 'Seller'
            };
        }();
    },
    favorite: function favorite() {
        return function () {
            return {
                children: [{
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }, {
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isGenerated: true,
                        isRequisite: true
                    },
                    type: 'ID'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'FavoriteDealerMutation_FavoriteRelayQL',
                type: 'Favorite'
            };
        }();
    }
};

module.exports = FavoriteDealerMutation;

/***/ },
/* 26 */
/***/ function(module, exports) {

module.exports = {
	"subjectItem": "1stdibs Item Inquiry",
	"subjectItemNetPrice": "1stdibs Net Price",
	"subjectDealer": "1stdibs.com Dealer Inquiry",
	"contactDealerHeader": "Contact {dealer}",
	"contactDealerHeader-placeOnHold": "Request to Hold Item",
	"contactDealerHeader-opop": "Request More Info from Seller",
	"contactDealerHeader-contact3": "Ask the Seller a Question",
	"contactDealerGuidedCopyHeader": "Contact {dealer}",
	"header": "Contact {dealer}",
	"messagePlaceholder": "Request more information about this item.",
	"messagePlaceholder-placeOnHold": " ",
	"messagePlaceholder-opop": "Request more information about this item.",
	"messagePlaceholder-contact3": "Ask the seller a question about this item.",
	"messagePlaceholderStorefront": "Ask the dealer a question.",
	"offerPerItem": "per item for",
	"labelOptIn": "Opt in to share your email address directly with {dealer}.",
	"optInInfo": "We keep your personal information private.",
	"labelEmail": "Your Email",
	"labelName": "Your Name",
	"labelMessage": "Your Message",
	"labelMessage-placeOnHold": "Include details on your hold request",
	"labelMessage-opop": "Your Message",
	"labelMessage-contact3": "Your Message",
	"descriptionText": " ",
	"descriptionText-placeOnHold": "Please indicate for how long you are requesting a hold. If approved, this piece will be placed on hold exclusively for you.",
	"descriptionText-opop": " ",
	"descriptionText-contact3": " ",
	"sendCta": "Send",
	"busyCta": "Sending...",
	"pretextPur": "I'm interested in this piece. Can you please confirm the price?",
	"errorPriceFormat": "Please enter a number in format ###,###",
	"errorPriceFormatEur": "Please enter a number in format ###.###",
	"errorPositiveNumber": "Please enter a value greater than zero",
	"errorUnderListPrice": "Please enter an offer below the list price",
	"errorSpecialCharacters": "May not contain special characters",
	"errorValidEmail": "Please enter a valid email address",
	"errorRequired": "This field is required",
	"successHeader": "Thank you!",
	"successMessageOffer": "Your offer has been submitted and the dealer has 3 days to respond. View your offer details in <a href='/my/orders/' class='bomtLink'>My Orders</a>.",
	"viewAllYourMessagesIn": "View all your messages in ",
	"myConversations": "My Conversations",
	"labelMessageToggle": "Include a Message",
	"offerLowballTitle": "Make an Offer",
	"makeOfferModalLinkPrompt": "Ready to negotiate? ",
	"makeOfferModalLinkCta": "Make an offer >",
	"holdRequestLabel": "Include a request to place this piece on hold",
	"holdRequestInfoChecked": "Please indicate for how long you are requesting a hold. If approved, this piece will be placed on hold exclusively for you."
};

/***/ },
/* 27 */
/***/ function(module, exports) {

module.exports = {
	"labelOffer": "Your offer",
	"continueCta": "Continue",
	"continueToCheckoutCta": "Continue to checkout",
	"sendMessageCta": "Send Message",
	"makeOfferHeader": "Make an Offer",
	"makeOfferHeader-placeOnHold": "Make an Offer",
	"makeOfferHeader-opop": "Make an Offer",
	"makeOfferHeader-contact3": "Make an Offer",
	"makeOfferPlaceholderPdp": "Let the dealer know why you are interested.",
	"offerSubmitLabel": "Next, you'll enter payment and shipping information, but will not be charged.",
	"lowBallHeader": "Make an Offer",
	"lowBallLabelHeading": "Warning: ",
	"lowBallLabel": "An offer significantly below the {type} price of {price} will likely be rejected. We recommend raising your offer.",
	"lowBallOtherOptionLabel": "Enter another offer",
	"lowBallOptionAmountOff": "{amountOff} off, {percentOff}% discount",
	"lowBallOriginalOffer": "(original offer)",
	"listPriceLabel": "List Price",
	"netPriceLabel": "Net Price",
	"salePriceLabel": "Sale Price",
	"perItemSuffix": " per item",
	"abandonMakeOfferHeader": "Send Offer Without Payment Info",
	"abandonMakeOfferContent": "You can still submit your offer of {offerPrice} for this piece as a message to a dealer. You will not be charged.",
	"abandonMakeOfferCta": "Submit",
	"abandonMakeOfferLeaveCta": "Cancel Offer",
	"abandonMakeOfferMessage": "Hi {dealerName},\n\nwill you consider {offerPrice} for this piece?\n\nThanks,\n{userDisplayName}"
};

/***/ },
/* 28 */
/***/ function(module, exports) {

module.exports = {
	"serviceError": "An error occurred while processing your request. Please try again later.",
	"loading": "Loading"
};

/***/ },
/* 29 */
/***/ function(module, exports) {

module.exports = {
	"contactDealer": "CONTACT_DEALER",
	"mcReply": "MC_REPLY",
	"netPrice": "NET_PRICE_REQUEST",
	"netPriceHoldRequest": "NET_PRICE_HOLD_REQUEST",
	"netPriceOffer": "NET_PRICE_OFFER",
	"privateOffer": "PRIVATE_OFFER",
	"requestHold": "HOLD_REQUEST"
};

/***/ },
/* 30 */
/***/ function(module, exports) {

module.exports = {
	"TYPE_NET": "NET",
	"TYPE_RETAIL": "RETAIL",
	"TYPE_SALE": "WEEKLY_SALE",
	"TYPE_PRE_AUTH_OFFER": "PRE_AUTH_OFFER",
	"STATUS_ACTIVE": "ACTIVE"
};

/***/ },
/* 31 */
/***/ function(module, exports) {

module.exports = __webpack_require__(1640);

/***/ },
/* 32 */
/***/ function(module, exports) {

module.exports = __webpack_require__(2790);

/***/ },
/* 33 */
/***/ function(module, exports) {

module.exports = __webpack_require__(2791);

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var classNames = __webpack_require__(19);
var css = __webpack_require__(6);
var PRICE_TYPES = __webpack_require__(30);

function DisplayPrice(_ref) {
    var formattedRetailPrice = _ref.formattedRetailPrice,
        formattedNetPrice = _ref.formattedNetPrice,
        formattedSalePrice = _ref.formattedSalePrice,
        formattedPreAuthOfferPrice = _ref.formattedPreAuthOfferPrice,
        priceType = _ref.priceType,
        className = _ref.className,
        copy = _ref.copy,
        isPricePerPiece = _ref.isPricePerPiece,
        showNetPrice = _ref.showNetPrice;

    var wrappingClass = classNames(css.priceInfo, className);
    var listPriceCopy = copy.get('listPriceLabel') + ' ' + formattedRetailPrice;
    var netPriceCopy = copy.get('netPriceLabel') + ' ' + formattedNetPrice;
    var salePriceCopy = copy.get('salePriceLabel') + ' ' + formattedSalePrice;
    var preAuthOfferPriceCopy = formattedPreAuthOfferPrice;

    if (isPricePerPiece) {
        var _map = [listPriceCopy, netPriceCopy, salePriceCopy, preAuthOfferPriceCopy].map(function (priceCopy) {
            return priceCopy + copy.get('perItemSuffix');
        });

        var _map2 = _slicedToArray(_map, 4);

        listPriceCopy = _map2[0];
        netPriceCopy = _map2[1];
        salePriceCopy = _map2[2];
        preAuthOfferPriceCopy = _map2[3];
    }

    if (priceType === PRICE_TYPES.TYPE_SALE) {
        return React.createElement(
            'p',
            { className: wrappingClass },
            salePriceCopy
        );
    }

    if (priceType === PRICE_TYPES.TYPE_NET && showNetPrice) {
        return React.createElement(
            'div',
            { className: wrappingClass },
            React.createElement(
                'p',
                null,
                netPriceCopy
            ),
            React.createElement(
                'p',
                { className: css.disabledPrice },
                listPriceCopy
            )
        );
    }

    if (priceType === PRICE_TYPES.TYPE_PRE_AUTH_OFFER) {
        return React.createElement(
            'p',
            { className: wrappingClass },
            React.createElement(
                'span',
                null,
                copy.get('preAuthOfferPriceLabel')
            ),
            React.createElement(
                'span',
                null,
                preAuthOfferPriceCopy
            )
        );
    }

    return React.createElement(
        'p',
        { className: wrappingClass },
        listPriceCopy
    );
}

DisplayPrice.propTypes = {
    className: PropTypes.string,
    copy: PropTypes.object.isRequired,
    formattedNetPrice: PropTypes.string.isRequired,
    formattedRetailPrice: PropTypes.string.isRequired,
    formattedSalePrice: PropTypes.string.isRequired,
    formattedPreAuthOfferPrice: PropTypes.string,
    priceType: PropTypes.string.isRequired,
    isPricePerPiece: PropTypes.bool,
    showNetPrice: PropTypes.bool
};

module.exports = DisplayPrice;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var css = __webpack_require__(128);

function HoldRequestInput(_ref) {
    var isChecked = _ref.isChecked,
        copyLabel = _ref.copyLabel,
        copyInfoChecked = _ref.copyInfoChecked,
        onChange = _ref.onChange;

    var checkedInfo = React.createElement(
        'p',
        { className: css.info },
        copyInfoChecked
    );
    return React.createElement(
        'div',
        { className: css.container },
        React.createElement(
            'p',
            { className: isChecked ? css.checkboxLabelChecked : css.checkboxLabel },
            React.createElement('input', {
                'data-tn': 'contact-dealer-hold-request-input',
                type: 'checkbox',
                id: 'holdRequest',
                checked: isChecked,
                onChange: onChange
            }),
            React.createElement(
                'label',
                { htmlFor: 'holdRequest' },
                copyLabel
            )
        ),
        isChecked ? checkedInfo : null
    );
}

HoldRequestInput.propTypes = {
    isChecked: PropTypes.bool,
    copyLabel: PropTypes.string,
    copyInfo: PropTypes.string,
    copyInfoChecked: PropTypes.string,
    onChange: PropTypes.func
};

module.exports = HoldRequestInput;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(0);
var classNames = __webpack_require__(19);
var formCss = __webpack_require__(6);
var PropTypes = React.PropTypes;


function InputError(_ref) {
    var error = _ref.error;

    var errorClasses = classNames(formCss['err-message'], _defineProperty({}, formCss.active, !!error));
    return React.createElement(
        'div',
        { className: errorClasses },
        error
    );
}

InputError.propTypes = {
    error: PropTypes.string
};

module.exports = InputError;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.daysSinceLastAppInstallView = daysSinceLastAppInstallView;
exports.recordAppInstallView = recordAppInstallView;
exports.persistNotTradeAnswer = persistNotTradeAnswer;
exports.userIndicatedNotTrade = userIndicatedNotTrade;

var _dibsBrowserStorage = __webpack_require__(148);

var appInstallPromptDate = 'app_install_last_prompt_date';
var userNotTradeKey = 'user_indicated_not_trade';

var millisecondsPerDay = 1000 * 60 * 60 * 24;

function daysSinceLastAppInstallView() {
    var timeStamp = Number(_dibsBrowserStorage.localStorage.getItem(appInstallPromptDate));

    if (!timeStamp) {
        return Number.MAX_SAFE_INTEGER;
    }

    var millisecondsSinceLastView = Date.now() - timeStamp;
    return Math.floor(millisecondsSinceLastView / millisecondsPerDay);
}

function recordAppInstallView() {
    _dibsBrowserStorage.localStorage.setItem(appInstallPromptDate, Date.now());
};

function persistNotTradeAnswer() {
    _dibsBrowserStorage.localStorage.setItem(userNotTradeKey, true);
};

function userIndicatedNotTrade() {
    return _dibsBrowserStorage.localStorage.getItem(userNotTradeKey);
};

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Relay = __webpack_require__(4);
var get = __webpack_require__(1);

var ContactDealerMutation = function (_Relay$Mutation) {
    _inherits(ContactDealerMutation, _Relay$Mutation);

    function ContactDealerMutation() {
        _classCallCheck(this, ContactDealerMutation);

        return _possibleConstructorReturn(this, (ContactDealerMutation.__proto__ || Object.getPrototypeOf(ContactDealerMutation)).apply(this, arguments));
    }

    _createClass(ContactDealerMutation, [{
        key: 'getMutation',
        value: function getMutation() {
            return function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'contactDealer',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'ContactDealerInput!'
                    },
                    name: 'ContactDealerMutation',
                    responseType: 'ContactDealerPayload'
                };
            }();
        }
    }, {
        key: 'getVariables',
        value: function getVariables() {
            var _props = this.props,
                item = _props.item,
                seller = _props.seller,
                user = _props.user,
                messageValue = _props.messageValue,
                subject = _props.subject,
                isOptInChecked = _props.isOptInChecked,
                action = _props.action,
                context = _props.context;

            return {
                buyerId: get(user, 'serviceId'),
                itemPk: get(item, 'serviceId'),
                sellerPk: get(seller, 'serviceId'),
                messageContent: messageValue,
                isOptIn: isOptInChecked,
                pageContext: context,
                subject: subject,
                action: action
            };
        }
    }, {
        key: 'getFatQuery',
        value: function getFatQuery() {
            return function () {
                return {
                    children: [{
                        children: [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'conversation',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Conversation'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ContactDealerMutationRelayQL',
                    type: 'ContactDealerPayload'
                };
            }();
        }
    }, {
        key: 'getConfigs',
        value: function getConfigs() {
            return [{
                type: 'FIELDS_CHANGE',
                fieldIDs: {
                    conversation: get(this.props, 'buyerItemConversation.id') }
            }];
        }
    }]);

    return ContactDealerMutation;
}(Relay.Mutation);

ContactDealerMutation.fragments = {
    seller: function seller() {
        return function () {
            return {
                children: [{
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }, {
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isGenerated: true,
                        isRequisite: true
                    },
                    type: 'ID'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'ContactDealerMutation_SellerRelayQL',
                type: 'Seller'
            };
        }();
    },
    user: function user() {
        return function () {
            return {
                children: [{
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isRequisite: true
                    },
                    type: 'ID'
                }, {
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'ContactDealerMutation_UserRelayQL',
                type: 'User'
            };
        }();
    },
    item: function item() {
        return function () {
            return {
                children: [{
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }, {
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isGenerated: true,
                        isRequisite: true
                    },
                    type: 'ID'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'ContactDealerMutation_ItemRelayQL',
                type: 'Item'
            };
        }();
    }
};

module.exports = ContactDealerMutation;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Relay = __webpack_require__(4);

var HoldRequestMutation = function (_Relay$Mutation) {
    _inherits(HoldRequestMutation, _Relay$Mutation);

    function HoldRequestMutation() {
        _classCallCheck(this, HoldRequestMutation);

        return _possibleConstructorReturn(this, (HoldRequestMutation.__proto__ || Object.getPrototypeOf(HoldRequestMutation)).apply(this, arguments));
    }

    _createClass(HoldRequestMutation, [{
        key: 'getMutation',
        value: function getMutation() {
            return function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'createHoldRequest',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'CreateHoldRequestInput!'
                    },
                    name: 'HoldRequestMutation',
                    responseType: 'CreateHoldRequestPayload'
                };
            }();
        }
    }, {
        key: 'getVariables',
        value: function getVariables() {
            var _props = this.props,
                item = _props.item,
                user = _props.user,
                seller = _props.seller;


            return {
                itemId: item.serviceId,
                userId: user.serviceId,
                sellerId: seller.serviceId,
                vertical: item.vertical
            };
        }
    }, {
        key: 'getFatQuery',
        value: function getFatQuery() {
            return function () {
                return {
                    children: [{
                        children: [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'item',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Item'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'HoldRequestMutationRelayQL',
                    type: 'CreateHoldRequestPayload'
                };
            }();
        }
    }, {
        key: 'getConfigs',
        value: function getConfigs() {
            return [{
                type: 'FIELDS_CHANGE',
                fieldIDs: { item: this.props.item.id }
            }];
        }
    }]);

    return HoldRequestMutation;
}(Relay.Mutation);

HoldRequestMutation.fragments = {
    user: function user() {
        return function () {
            return {
                children: [{
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }, {
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isGenerated: true,
                        isRequisite: true
                    },
                    type: 'ID'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'HoldRequestMutation_UserRelayQL',
                type: 'User'
            };
        }();
    },
    item: function item() {
        return function () {
            return {
                children: [{
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isRequisite: true
                    },
                    type: 'ID'
                }, {
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }, {
                    fieldName: 'vertical',
                    kind: 'Field',
                    metadata: {},
                    type: 'VerticalType'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'HoldRequestMutation_ItemRelayQL',
                type: 'Item'
            };
        }();
    },
    seller: function seller() {
        return function () {
            return {
                children: [{
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }, {
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isGenerated: true,
                        isRequisite: true
                    },
                    type: 'ID'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'HoldRequestMutation_SellerRelayQL',
                type: 'Seller'
            };
        }();
    }
};

module.exports = HoldRequestMutation;

/***/ },
/* 40 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"src-scss-lowball---container---2PcjX","lowballHeader":"src-scss-lowball---lowballHeader---2RV9r","lowballHeaderWarning":"src-scss-lowball---lowballHeaderWarning---3CsBS","info":"src-scss-lowball---info---32Jfx","buttonContainer":"src-scss-lowball---buttonContainer---eQOmy","button-large":"src-scss-lowball---button-large---2pfoM","buttonLarge":"src-scss-lowball---button-large---2pfoM","lowballOptionLabel":"src-scss-lowball---lowballOptionLabel---KsnQa","lowballOptionContent":"src-scss-lowball---lowballOptionContent---2ZXNy","lowballOptionText":"src-scss-lowball---lowballOptionText---38Yez","lowballOfferField":"src-scss-lowball---lowballOfferField---M8Hzj","lowballOptionSubtext":"src-scss-lowball---lowballOptionSubtext---P30Jw","lowballOfferInput":"src-scss-lowball---lowballOfferInput---1UgP-","lowballOption":"src-scss-lowball---lowballOption---1X61Z"};

/***/ },
/* 41 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"info":"src-scss-offer---info---3sV4i","quantityLabel":"src-scss-offer---quantityLabel---_7nGU","quantityInput":"src-scss-offer---quantityInput---LRQdH","quantityInlinelabel":"src-scss-offer---quantityInlinelabel---24MQ6","inputRow":"src-scss-offer---inputRow---3q3nL","inputWrapper":"src-scss-offer---inputWrapper---28G_V","input":"src-scss-offer---input---Hxg4H","currency":"src-scss-offer---currency---27U7o"};

/***/ },
/* 42 */
/***/ function(module, exports) {

module.exports = {
	"makePreAuthOfferHeader": "Confirm Inquiry",
	"preAuthOfferSubmitLabel": "Not ready to enter payment information? Message the dealer to see if they are open to your offer first.",
	"preAuthOfferTriggerText": "Send Inquiry",
	"preAuthOfferInfo": "A message will be sent to the dealer with your inquiry.",
	"preAuthOfferInfoAbandonCheckout": "Not ready to complete your offer for {itemTitle}? Ask if the dealer is open to your price first.",
	"preAuthOfferPriceLabel": "Your Inquiry Amount",
	"preAuthOfferPricePerPiece": "{price} per item",
	"preAuthOfferMessagePlaceholder": "e.g., Would you be willing to accept {price}?",
	"preAuthOfferCta": "send",
	"preAuthOfferMessageLabel": "Include a Message",
	"preAuthOfferServiceError": "There was an error creating your inquiry"
};

/***/ },
/* 43 */
/***/ function(module, exports) {

module.exports = __webpack_require__(106);

/***/ },
/* 44 */
/***/ function(module, exports) {

module.exports = __webpack_require__(1472);

/***/ },
/* 45 */
/***/ function(module, exports) {

module.exports = __webpack_require__(331);

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var get = __webpack_require__(1);

var _require = __webpack_require__(8),
    hideModal = _require.hideModal;

var _require2 = __webpack_require__(10),
    validateMessage = _require2.validateMessage,
    failedValidation = _require2.failedValidation;

var makeOfferActions = __webpack_require__(14);
var mutationActions = __webpack_require__(11);
var trackingHelpers = __webpack_require__(2);
var ACTION_TYPES = __webpack_require__(3);
var MC_CONTEXTS = __webpack_require__(67);
var MC_ACTIONS = __webpack_require__(29);
var AUTH_ACTIONS = {
    REGISTER: 'register',
    LOGIN: 'login'
};

var _sendMessage = function _sendMessage(inputPayload) {
    return function (dispatch, getState) {
        var item = inputPayload.item,
            copy = inputPayload.copy,
            holdRequestedFromConfirmationModal = inputPayload.holdRequestedFromConfirmationModal;
        var holdRequestFieldValue = getState().fields.holdRequestFieldValue;


        var mutationArgs = {
            action: holdRequestFieldValue ? MC_ACTIONS.requestHold : MC_ACTIONS.contactDealer,
            context: item ? MC_CONTEXTS.item : MC_CONTEXTS.seller,
            subject: item ? [copy.get('subjectItem'), item.title, item.dibsReference].join(' - ') : copy.get('subjectDealer')
        };

        if (holdRequestFieldValue) {
            dispatch(mutationActions.sendHoldRequest(_extends({
                onSuccess: function onSuccess() {
                    dispatch(mutationActions.sendContactMessage(_extends({
                        onSuccess: function onSuccess() {
                            dispatch(makeOfferActions.messageSuccess({ messageType: MC_ACTIONS.requestHold }));
                            dispatch(mutationActions.goToSuccess(inputPayload));
                        },
                        onFailure: function onFailure() {
                            return dispatch(mutationActions.errorHandler());
                        }
                    }, inputPayload), mutationArgs));

                    //this event tells tracking that the user requested a hold by clicking on "request a hold" in the confiramtion modal for a prior message
                    if (holdRequestedFromConfirmationModal) {
                        trackingHelpers.convertedHoldRequestFromConfirmationModal();
                    }
                },
                onFailure: function onFailure() {
                    return dispatch(mutationActions.errorHandler());
                }
            }, inputPayload)));
        } else {
            dispatch(mutationActions.sendContactMessage(_extends({
                onSuccess: function onSuccess() {
                    dispatch(makeOfferActions.messageSuccess({ messageType: MC_ACTIONS.contactDealer }));
                    dispatch(mutationActions.goToSuccess(inputPayload));
                },
                onFailure: function onFailure() {
                    return dispatch(mutationActions.errorHandler());
                }
            }, inputPayload), mutationArgs));
        }
    };
};

var _commitMutations = function _commitMutations(inputPayload) {
    return function (dispatch, getState) {
        var forceEnvironmentUpdate = inputPayload.forceEnvironmentUpdate,
            isUserInitiallyLoggedIn = inputPayload.isUserInitiallyLoggedIn,
            isUserNameSet = inputPayload.isUserNameSet,
            linkLocation = inputPayload.linkLocation,
            seller = inputPayload.seller,
            startAuth = inputPayload.startAuth,
            userExists = inputPayload.userExists;
        var emailFieldValue = getState().fields.emailFieldValue;


        dispatch({ type: ACTION_TYPES.modalIsSending });
        if (isUserInitiallyLoggedIn) {
            if (!isUserNameSet) {
                // logged in, profile needs update
                dispatch(mutationActions.updateBuyerProfile(_extends({
                    onSuccess: function onSuccess() {
                        return dispatch(_sendMessage(inputPayload));
                    },
                    onFailure: function onFailure() {
                        return dispatch(mutationActions.errorHandler());
                    }
                }, inputPayload)));
            } else {
                // no profile update needed, send the message right away
                dispatch(_sendMessage(inputPayload));
            }
        } else {
            dispatch(hideModal());
            startAuth({
                dealerName: get(seller, 'sellerProfile.displayName'),
                action: userExists ? AUTH_ACTIONS.LOGIN : AUTH_ACTIONS.REGISTER,
                email: emailFieldValue,
                linkLocation: linkLocation
            }).then(function (authLoaderPayload) {
                if (!authLoaderPayload.err) {
                    dispatch({
                        type: ACTION_TYPES.setAuthResultAction,
                        actionName: authLoaderPayload.newUser ? 'register' : 'login'
                    });
                    forceEnvironmentUpdate({ shouldFetchUser: true });
                }
            });
        }
    };
};

module.exports = {
    contactDataLoaded: function contactDataLoaded(payload) {
        return _extends({
            type: ACTION_TYPES.contactDataLoaded
        }, payload);
    },
    clearAuthResultAction: function clearAuthResultAction() {
        return {
            type: ACTION_TYPES.clearAuthResultAction
        };
    },
    setGuidedPromptSelection: function setGuidedPromptSelection(prompt) {
        return {
            type: ACTION_TYPES.setGuidedPromptSelection,
            prompt: prompt
        };
    },
    setGhostText: function setGhostText(ghostText) {
        return {
            type: ACTION_TYPES.setGhostText,
            ghostText: ghostText
        };
    },
    setHideBackLink: function setHideBackLink(hideBackLink) {
        return {
            type: ACTION_TYPES.setHideBackLink,
            hideBackLink: hideBackLink
        };
    },
    submitContactDealer: function submitContactDealer(inputPayload) {
        return function (dispatch, getState) {
            var user = inputPayload.user,
                isUserInitiallyLoggedIn = inputPayload.isUserInitiallyLoggedIn;
            var _getState$fields = getState().fields,
                nameFieldValue = _getState$fields.nameFieldValue,
                emailFieldValue = _getState$fields.emailFieldValue,
                messageFieldValue = _getState$fields.messageFieldValue;

            var messageValidation = validateMessage({
                validationPayload: {
                    email: emailFieldValue || get(user, 'profile.email'),
                    name: nameFieldValue || get(user, 'profile.firstName'),
                    message: messageFieldValue || undefined
                }
            });
            return messageValidation.then(function () {
                if (isUserInitiallyLoggedIn) {
                    dispatch(_commitMutations(inputPayload));
                } else {
                    dispatch(mutationActions.emailCheckAndAuth()).then(function (userExists) {
                        dispatch(_commitMutations(Object.assign({}, inputPayload, { userExists: userExists })));
                    });
                }
                return Promise.resolve();
            }).catch(function (_ref) {
                var messageErrors = _ref.messageErrors;
                return Promise.reject(dispatch(failedValidation({ messageErrors: messageErrors })));
            });
        };
    },
    holdFromConfirmationModal: function holdFromConfirmationModal() {
        return {
            type: ACTION_TYPES.holdFromConfirmationModal
        };
    }
};

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _require = __webpack_require__(10),
    validateMessage = _require.validateMessage,
    failedValidation = _require.failedValidation;

var makeOfferActions = __webpack_require__(14);
var mutationActions = __webpack_require__(11);
var get = __webpack_require__(1);
var ACTION_TYPES = __webpack_require__(3);
var MC_CONTEXTS = __webpack_require__(67);
var MC_ACTIONS = __webpack_require__(29);

var _sendMessage = function _sendMessage(inputPayload) {
    return function (dispatch, getState) {
        var item = inputPayload.item,
            copy = inputPayload.copy;
        var holdRequestFieldValue = getState().fields.holdRequestFieldValue;


        var mutationArgs = {
            action: holdRequestFieldValue ? MC_ACTIONS.netPriceHoldRequest : MC_ACTIONS.netPrice,
            context: MC_CONTEXTS.itemNetPrice,
            subject: [copy.get('netPriceSubjectItem'), item.title, item.dibsReference].join(' - ')
        };

        if (holdRequestFieldValue) {
            dispatch(mutationActions.sendHoldRequest(_extends({
                onSuccess: function onSuccess() {
                    dispatch(mutationActions.sendContactMessage(_extends({
                        onSuccess: function onSuccess() {
                            dispatch(makeOfferActions.messageSuccess({ messageType: MC_ACTIONS.netPriceHoldRequest }));
                            dispatch(mutationActions.goToSuccess(inputPayload, { isNetPrice: true }));
                        },
                        onFailure: function onFailure() {
                            return dispatch(mutationActions.errorHandler());
                        }
                    }, inputPayload), mutationArgs));
                },
                onFailure: function onFailure() {
                    return dispatch(mutationActions.errorHandler());
                }
            }, inputPayload)));
        } else {
            dispatch(mutationActions.sendContactMessage(_extends({
                onSuccess: function onSuccess() {
                    dispatch(makeOfferActions.messageSuccess({ messageType: MC_ACTIONS.netPrice }));
                    dispatch(mutationActions.goToSuccess(inputPayload, { isNetPrice: true }));
                },
                onFailure: function onFailure() {
                    return dispatch(mutationActions.errorHandler());
                }
            }, inputPayload), mutationArgs));
        }
    };
};

var _commitMutations = function _commitMutations(inputPayload) {
    return function (dispatch) {
        var isUserNameSet = inputPayload.isUserNameSet;


        dispatch({ type: ACTION_TYPES.modalIsSending });
        if (!isUserNameSet) {
            // logged in, profile needs update
            dispatch(mutationActions.updateBuyerProfile(_extends({
                onSuccess: function onSuccess() {
                    return dispatch(_sendMessage(inputPayload));
                },
                onFailure: function onFailure() {
                    return dispatch(mutationActions.errorHandler());
                }
            }, inputPayload)));
        } else {
            // no profile update needed, send the message right away
            dispatch(_sendMessage(inputPayload));
        }
    };
};

module.exports = {
    contactDataLoaded: function contactDataLoaded(payload) {
        return _extends({
            type: ACTION_TYPES.contactDataLoaded
        }, payload);
    },
    submitNetPriceRequest: function submitNetPriceRequest(inputPayload) {
        return function (dispatch, getState) {
            var isUserNameSet = inputPayload.isUserNameSet,
                user = inputPayload.user;
            var _getState$fields = getState().fields,
                messageFieldValue = _getState$fields.messageFieldValue,
                nameFieldValue = _getState$fields.nameFieldValue,
                holdRequestFieldValue = _getState$fields.holdRequestFieldValue;

            // for net price requests, a message is only required if a hold request is included
            // but if a message has been entered, we should validate it

            var skipMessageValidation = isUserNameSet && !holdRequestFieldValue && messageFieldValue === '';
            var messagePayload = {
                validationPayload: {
                    name: nameFieldValue || get(user, 'profile.displayName'),
                    message: messageFieldValue || undefined
                },
                options: {
                    fields: skipMessageValidation ? ['name'] : ['name', 'message']
                }
            };

            return validateMessage(messagePayload).then(function () {
                return dispatch(_commitMutations(inputPayload));
            }).catch(function (_ref) {
                var messageErrors = _ref.messageErrors;
                return dispatch(failedValidation({ messageErrors: messageErrors }));
            });
        };
    }
};

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _secondaryMessageComp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var get = __webpack_require__(1);
var tokenReplace = __webpack_require__(5);

var _require = __webpack_require__(37),
    daysSinceLastAppInstallView = _require.daysSinceLastAppInstallView,
    userIndicatedNotTrade = _require.userIndicatedNotTrade;

var _require2 = __webpack_require__(118),
    isAppleMobileDevice = _require2.isAppleMobileDevice;

var trackingHelpers = __webpack_require__(2);

var secondaryMessages = {
    appInstall: 'app install',
    favoriteDealer: 'follow dealer',
    holdRequest: 'place hold',
    makeOffer: 'make offer',
    tradePrompt: 'join trade'
};

var secondaryMessageComponentsKey = (_secondaryMessageComp = {}, _defineProperty(_secondaryMessageComp, secondaryMessages.appInstall, __webpack_require__(106)), _defineProperty(_secondaryMessageComp, secondaryMessages.favoriteDealer, __webpack_require__(107)), _defineProperty(_secondaryMessageComp, secondaryMessages.holdRequest, __webpack_require__(108)), _defineProperty(_secondaryMessageComp, secondaryMessages.makeOffer, __webpack_require__(112)), _defineProperty(_secondaryMessageComp, secondaryMessages.tradePrompt, __webpack_require__(114)), _secondaryMessageComp);

var MC_ACTIONS = __webpack_require__(29);
var css = __webpack_require__(16);
var copy = __webpack_require__(7);

var Confirmation = function (_Component) {
    _inherits(Confirmation, _Component);

    function Confirmation(props) {
        _classCallCheck(this, Confirmation);

        var _this = _possibleConstructorReturn(this, (Confirmation.__proto__ || Object.getPrototypeOf(Confirmation)).call(this, props));

        _this.canShowMakeOfferMessage = _this.canShowMakeOfferMessage.bind(_this);
        _this.getSecondaryMessage = _this.getSecondaryMessage.bind(_this);
        _this.successMessageSection = _this.successMessageSection.bind(_this);
        return _this;
    }

    _createClass(Confirmation, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            trackingHelpers.confirmationEntry({ secondaryMessage: this.getSecondaryMessage() });
        }
    }, {
        key: 'canShowMakeOfferMessage',
        value: function canShowMakeOfferMessage() {
            var _props = this.props,
                item = _props.item,
                messagesSent = _props.messagesSent,
                transaction = _props.transaction;

            var userCanMakeOffer = get(item, 'canBuyerMakeOffer');
            var offerMadeDuringCurrentSesssion = messagesSent.indexOf(MC_ACTIONS.privateOffer) > -1;
            var userHasActiveOffer = !!transaction && !get(transaction, 'isCanceled') && !!transaction.mostRecentOffer && get(transaction, 'mostRecentOffer.status') !== 'NEW';

            return userCanMakeOffer && !offerMadeDuringCurrentSesssion && !userHasActiveOffer;
        }
    }, {
        key: 'getSecondaryMessage',
        value: function getSecondaryMessage() {
            if (this.props.isNetPrice) {
                return secondaryMessages.favoriteDealer;
            }
            if (this.props.user.verifiedTradeStatus === 'SUSPECTED' && !userIndicatedNotTrade()) {
                return secondaryMessages.tradePrompt;
            }
            if (isAppleMobileDevice() && daysSinceLastAppInstallView() > 30) {
                return secondaryMessages.appInstall;
            }
            if (this.canShowMakeOfferMessage()) {
                return secondaryMessages.makeOffer;
            }
            if (this.props.isShowHoldRequest) {
                return secondaryMessages.holdRequest;
            }
            if (this.props.seller.favoritesByUser.length < 1 && !!this.props.favoriteDealer) {
                return secondaryMessages.favoriteDealer;
            }

            return '';
        }
    }, {
        key: 'successMessageSection',
        value: function successMessageSection() {
            var _props2 = this.props,
                messagesSent = _props2.messagesSent,
                isNetPrice = _props2.isNetPrice;


            var messageTemplate = void 0;
            if (isNetPrice) {
                messageTemplate = get(copy, 'successMessageNetPrice');
            } else {
                var mostRecentMessageType = messagesSent[0];
                switch (mostRecentMessageType) {
                    case MC_ACTIONS.requestHold:
                        messageTemplate = get(copy, 'successMessageHold');
                        break;
                    case MC_ACTIONS.privateOffer:
                        messageTemplate = get(copy, 'successMessagePrivateOffer');
                        break;
                    default:
                        messageTemplate = get(copy, 'successMessage');
                }
            }

            var dealerName = get(this.props.seller, 'sellerProfile.company');
            var message = tokenReplace(messageTemplate, { dealerName: dealerName });
            return React.createElement('p', { className: css.successMessage, dangerouslySetInnerHTML: { __html: message } });
        }
    }, {
        key: 'render',
        value: function render() {
            var SecondaryMessageComponent = secondaryMessageComponentsKey[this.getSecondaryMessage()];
            return React.createElement(
                'div',
                { className: css.container },
                this.successMessageSection(),
                SecondaryMessageComponent ? React.createElement(SecondaryMessageComponent, this.props) : false
            );
        }
    }]);

    return Confirmation;
}(Component);

Confirmation.propTypes = {
    closeModal: PropTypes.func,
    favoriteDealer: PropTypes.func,
    favoriteItem: PropTypes.func,
    isNetPrice: PropTypes.bool,
    isShowHoldRequest: PropTypes.bool,
    item: PropTypes.object,
    messagesSent: PropTypes.array,
    modalKey: PropTypes.string,
    relay: PropTypes.object,
    seller: PropTypes.shape({
        favoritesByUser: PropTypes.array,
        sellerProfile: PropTypes.shape({
            company: PropTypes.string,
            type: PropTypes.string
        })
    }),
    transaction: PropTypes.object,
    updateTradeStatus: PropTypes.func,
    user: PropTypes.object
};

Confirmation.defaultProps = {
    isNetPrice: false,
    messagesSent: [],
    modalKey: 'confirmation'
};

module.exports = Confirmation;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

/**
    This input component is meant to be used in place of the default
    React input component. Use this if the input's cursor jumps to the
    end when trying to type somewhere other than the end.

    You'll probably need this when using a controlled input (where you
    provide the `value` prop) and you're either a) transforming user input
    (i.e. stripping all non-numbers or adding spaces for credit card #s)
    or b) you're updating `value` asynchronously (which is typical if
    you're calling executeAction).
*/

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(159);

var CursorInput = function (_React$Component) {
    _inherits(CursorInput, _React$Component);

    function CursorInput() {
        _classCallCheck(this, CursorInput);

        return _possibleConstructorReturn(this, (CursorInput.__proto__ || Object.getPrototypeOf(CursorInput)).apply(this, arguments));
    }

    _createClass(CursorInput, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var node = ReactDOM.findDOMNode(this);
            if (document && document.activeElement === node) {
                var oldLength = node.value.length;
                var oldIdx = node.selectionStart;
                node.value = this.props.value || '';
                var newIdx = Math.max(0, node.value.length - oldLength + oldIdx);
                node.selectionStart = node.selectionEnd = newIdx;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement('input', this.props);
        }
    }]);

    return CursorInput;
}(React.Component);

CursorInput.propTypes = {
    value: React.PropTypes.any
};

module.exports = CursorInput;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var BasicInput = __webpack_require__(54);

function EmailField(_ref) {
    var onEmailChange = _ref.onEmailChange,
        isUserInitiallyLoggedIn = _ref.isUserInitiallyLoggedIn,
        errors = _ref.errors,
        copy = _ref.copy,
        emailValue = _ref.emailValue;

    if (!isUserInitiallyLoggedIn) {
        return React.createElement(BasicInput, {
            onFieldChanged: onEmailChange,
            label: copy.get('labelEmail'),
            field: 'email',
            error: errors.email,
            value: emailValue,
            dataTn: 'contact-dealer-email'
        });
    }
    return null;
}

EmailField.propTypes = {
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    emailValue: PropTypes.string,
    errors: PropTypes.object,
    isUserInitiallyLoggedIn: PropTypes.bool.isRequired,
    onEmailChange: PropTypes.func
};

module.exports = EmailField;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var HoldRequestInput = __webpack_require__(35);
var MessageField = __webpack_require__(15);
var NameField = __webpack_require__(22);
var Confirmation = __webpack_require__(48);
var SectionToggle = __webpack_require__(23);
var Submit = __webpack_require__(12);
var css = __webpack_require__(135);
var formCss = __webpack_require__(6);
var contactModalTracking = __webpack_require__(2);

var NetPrice = function (_Component) {
    _inherits(NetPrice, _Component);

    function NetPrice(props) {
        _classCallCheck(this, NetPrice);

        var _this = _possibleConstructorReturn(this, (NetPrice.__proto__ || Object.getPrototypeOf(NetPrice)).call(this, props));

        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onHoldRequestChange = _this.onHoldRequestChange.bind(_this);
        _this.onUpdateMessageField = _this.onUpdateTextFields.bind(_this, 'message');
        _this.onUpdateNameField = _this.onUpdateTextFields.bind(_this, 'name');
        return _this;
    }

    _createClass(NetPrice, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                isShowHoldRequest = _props.isShowHoldRequest,
                trackingModalName = _props.trackingModalName;

            if (isShowHoldRequest) {
                contactModalTracking.eventHoldRequestDisplayed({ sourceModal: trackingModalName });
            }
        }
    }, {
        key: 'onUpdateTextFields',
        value: function onUpdateTextFields(fieldKey, fieldAndValue) {
            var updateContactModalFields = this.props.updateContactModalFields;

            updateContactModalFields({
                field: fieldKey,
                value: fieldAndValue.value
            });
        }
    }, {
        key: 'onHoldRequestChange',
        value: function onHoldRequestChange(e) {
            var _props2 = this.props,
                updateContactModalFields = _props2.updateContactModalFields,
                trackingModalName = _props2.trackingModalName;

            if (e.target.checked) {
                contactModalTracking.eventHoldRequestEnabled({ sourceModal: trackingModalName });
            }
            updateContactModalFields({
                field: 'holdRequest',
                value: e.target.checked
            });
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();
            this.props.submitNetPriceRequest(this.props);
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.currentStep === 'confirmation') {
                return React.createElement(Confirmation, _extends({}, this.props, { isNetPrice: true }));
            }

            var _props3 = this.props,
                copy = _props3.copy,
                errors = _props3.errors,
                isHoldRequestChecked = _props3.isHoldRequestChecked,
                isMessageFieldOpen = _props3.isMessageFieldOpen,
                isSending = _props3.isSending,
                isShowHoldRequest = _props3.isShowHoldRequest,
                isUserNameSet = _props3.isUserNameSet,
                nameValue = _props3.nameValue,
                toggleMessage = _props3.toggleMessage;


            var messagePlaceholder = this.props.copy.get('messagePlaceholder');

            return React.createElement(
                'form',
                { onSubmit: this.onSubmit },
                React.createElement(
                    'div',
                    { className: formCss.mainFormContainer + ' ' + css.container },
                    React.createElement(
                        'p',
                        null,
                        copy.get('netPriceSubheader')
                    ),
                    React.createElement(NameField, {
                        copy: copy,
                        errors: errors,
                        isUserNameSet: isUserNameSet,
                        nameValue: nameValue,
                        onNameChange: this.onUpdateNameField
                    }),
                    isShowHoldRequest ? React.createElement(HoldRequestInput, {
                        copyInfoChecked: copy.get('netPriceHoldInfoChecked'),
                        copyLabel: copy.get('holdRequestLabel'),
                        isChecked: isHoldRequestChecked,
                        onChange: this.onHoldRequestChange
                    }) : false,
                    React.createElement(
                        SectionToggle,
                        {
                            isOpen: !!isMessageFieldOpen,
                            onToggle: toggleMessage.bind(this),
                            toggleLabel: copy.get('labelMessageToggle'),
                            toggleTn: 'send-message-toggle'
                        },
                        React.createElement(MessageField, _extends({}, this.props, {
                            hideLabel: true,
                            messagePlaceholder: messagePlaceholder,
                            onMessageChange: this.onUpdateMessageField
                        }))
                    ),
                    React.createElement(Submit, {
                        copyCta: copy.get('sendRequestCta'),
                        copyCtaBusy: copy.get('busyCta'),
                        dataTn: 'contact-dealer-submit',
                        isBusy: isSending,
                        isDisabled: isSending
                    })
                )
            );
        }
    }]);

    return NetPrice;
}(Component);

NetPrice.propTypes = {
    closeModal: PropTypes.func,
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    currentStep: PropTypes.string,
    isHoldRequestChecked: PropTypes.bool,
    isMessageFieldOpen: PropTypes.bool,
    isSending: PropTypes.bool,
    isShowHoldRequest: PropTypes.bool,
    isUserNameSet: PropTypes.bool,
    item: PropTypes.object,
    messageValue: PropTypes.string,
    seller: PropTypes.object,
    submitNetPriceRequest: PropTypes.func,
    toggleMessage: PropTypes.func,
    updateContactModalFields: PropTypes.func,
    trackingModalName: PropTypes.string,
    errors: PropTypes.object,
    nameValue: PropTypes.string
};

NetPrice.defaultProps = {
    trackingModalName: 'net price modal'
};

module.exports = NetPrice;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var InputWrapper = __webpack_require__(18);
var OfferRow = __webpack_require__(55);

function OfferField(_ref) {
    var copy = _ref.copy,
        currencySymbol = _ref.currencySymbol,
        errors = _ref.errors,
        hideQuantity = _ref.hideQuantity,
        isPricePerPiece = _ref.isPricePerPiece,
        offerValue = _ref.offerValue,
        onOfferChange = _ref.onOfferChange,
        pieces = _ref.pieces,
        quantityValue = _ref.quantityValue;

    var offerFieldLabel = copy.get('labelOffer');
    if (isPricePerPiece) {
        offerFieldLabel = '' + offerFieldLabel + copy.get('perItemSuffix');
    }
    return React.createElement(
        InputWrapper,
        { label: offerFieldLabel },
        React.createElement(OfferRow, {
            onFieldChanged: onOfferChange,
            isPricePerPiece: typeof hideQuantity === "boolean" ? !hideQuantity : isPricePerPiece,
            pieces: pieces,
            field: 'offer',
            value: offerValue,
            quantityField: 'quantity',
            quantityValue: quantityValue,
            error: errors.offer,
            currencySymbol: currencySymbol,
            copy: copy
        })
    );
}

OfferField.propTypes = {
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    currencySymbol: PropTypes.string.isRequired,
    errors: PropTypes.object,
    hideQuantity: PropTypes.bool,
    isPricePerPiece: PropTypes.bool.isRequired,
    offerValue: PropTypes.string,
    onOfferChange: PropTypes.func,
    pieces: PropTypes.number.isRequired,
    quantityValue: PropTypes.string
};

module.exports = OfferField;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var css = __webpack_require__(137);
var React = __webpack_require__(0);
var PropTypes = React.PropTypes;


function OptInInput(_ref) {
    var isChecked = _ref.isChecked,
        copyLabel = _ref.copyLabel,
        copyInfo = _ref.copyInfo,
        onChange = _ref.onChange;

    return React.createElement(
        'div',
        { className: css.container },
        React.createElement(
            'p',
            null,
            copyInfo
        ),
        React.createElement(
            'p',
            { className: css.checkboxLabel },
            React.createElement('input', {
                type: 'checkbox',
                id: 'optIn',
                checked: isChecked,
                onChange: onChange,
                dataTn: 'make-offer-opt-in'
            }),
            React.createElement(
                'label',
                { htmlFor: 'optIn' },
                copyLabel
            )
        )
    );
}

OptInInput.propTypes = {
    isChecked: PropTypes.bool,
    copyLabel: PropTypes.string,
    copyInfo: PropTypes.string,
    onChange: PropTypes.func
};

module.exports = OptInInput;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var formCss = __webpack_require__(6);
var inputCss = __webpack_require__(130);
var React = __webpack_require__(0);
var InputWrapper = __webpack_require__(18);
var InputError = __webpack_require__(36);
var PropTypes = React.PropTypes;


function BasicInput(_ref) {
    var label = _ref.label,
        field = _ref.field,
        placeholder = _ref.placeholder,
        error = _ref.error,
        dataTn = _ref.dataTn,
        onFieldChanged = _ref.onFieldChanged,
        value = _ref.value,
        css = _ref.css;

    return React.createElement(
        InputWrapper,
        { label: label },
        React.createElement('input', {
            className: formCss['form-input'] + ' ' + inputCss.input,
            onChange: function onChange(e) {
                return onFieldChanged({ field: field, value: e.target.value });
            },
            placeholder: placeholder,
            type: 'text',
            value: value,
            'data-tn': dataTn
        }),
        React.createElement(InputError, { error: error })
    );
}

BasicInput.propTypes = {
    label: PropTypes.string,
    field: PropTypes.string.isRequired,
    onFieldChanged: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    error: PropTypes.string,
    dataTn: PropTypes.string,
    value: PropTypes.string
};

module.exports = BasicInput;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var css = __webpack_require__(41);
var React = __webpack_require__(0);
var OfferInput = __webpack_require__(113);
var QuantityInput = __webpack_require__(57);
var InputError = __webpack_require__(36);
var PropTypes = React.PropTypes;


function OfferRow(props) {
    var className = props.className,
        isPricePerPiece = props.isPricePerPiece,
        error = props.error,
        copy = props.copy,
        quantityField = props.quantityField,
        quantityValue = props.quantityValue;

    var quantityLabel = void 0;
    var quantityInput = void 0;
    if (isPricePerPiece) {
        quantityLabel = React.createElement(
            'div',
            { className: css.quantityLabel },
            copy.get('offerPerItem')
        );
        quantityInput = React.createElement(QuantityInput, _extends({}, props, {
            field: quantityField,
            value: quantityValue
        }));
    }
    return React.createElement(
        'div',
        { className: className },
        React.createElement(
            'div',
            { className: css.inputRow },
            React.createElement(OfferInput, props),
            quantityLabel,
            quantityInput
        ),
        React.createElement(InputError, { error: error })
    );
}

OfferRow.propTypes = {
    className: PropTypes.string,
    isPricePerPiece: PropTypes.bool,
    pieces: PropTypes.number,
    quantityField: PropTypes.string,
    quantityValue: PropTypes.string,
    onFieldChanged: PropTypes.func.isRequired,
    error: PropTypes.string,
    currencySymbol: PropTypes.string,
    displayPrice: PropTypes.string,
    value: PropTypes.string,
    field: PropTypes.string,
    isOfferFocus: PropTypes.bool,
    copy: PropTypes.shape({
        get: PropTypes.func.isRequired
    })
};

module.exports = OfferRow;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var InputWrapper = __webpack_require__(18);
var QuantityInput = __webpack_require__(57);
var css = __webpack_require__(41);

function QuantityField(_ref) {
    var quantityValue = _ref.quantityValue,
        isPricePerPiece = _ref.isPricePerPiece,
        pieces = _ref.pieces,
        copy = _ref.copy,
        onOfferChange = _ref.onOfferChange;

    if (!isPricePerPiece || typeof quantityValue === 'undefined') {
        return null;
    }
    return React.createElement(
        InputWrapper,
        { label: copy.get('Quantity') },
        React.createElement(QuantityInput, {
            className: css.quantityInput,
            field: 'quantity',
            value: quantityValue,
            pieces: pieces,
            onFieldChanged: onOfferChange
        })
    );
}

QuantityField.propTypes = {
    quantityValue: PropTypes.string,
    isPricePerPiece: PropTypes.bool.isRequired,
    pieces: PropTypes.number.isRequired,
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    onOfferChange: PropTypes.func
};

module.exports = QuantityField;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var formCss = __webpack_require__(6);

function QuantityInput(props) {
    var className = props.className,
        value = props.value,
        pieces = props.pieces,
        field = props.field,
        onFieldChanged = props.onFieldChanged;

    var options = [];
    for (var i = 1; i <= pieces; i++) {
        options.push(React.createElement(
            'option',
            { key: i, value: i },
            i
        ));
    }
    var selectProps = {
        className: formCss['form-input'],
        onChange: function onChange(e) {
            return onFieldChanged({ field: field, value: e.target.value });
        },
        value: value
    };
    return React.createElement(
        'span',
        { className: formCss['form-select'] + ' ' + (className || '') },
        React.createElement(
            'span',
            { className: formCss['form-display-value'] },
            value
        ),
        React.createElement(
            'select',
            selectProps,
            options
        )
    );
};

QuantityInput.propTypes = {
    className: PropTypes.string,
    value: PropTypes.string.isRequired,
    pieces: PropTypes.number.isRequired,
    field: PropTypes.string.isRequired,
    onFieldChanged: PropTypes.func.isRequired
};

module.exports = QuantityInput;

/***/ },
/* 58 */
/***/ function(module, exports) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var canMakePreAuthOffer = exports.canMakePreAuthOffer = function canMakePreAuthOffer(_ref) {
    var transaction = _ref.transaction;
    return !(transaction && !transaction.isCanceled && (transaction.hasCompletedCheckout || transaction.mostRecentOffer));
};

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var get = __webpack_require__(1);
var verticals = __webpack_require__(72);

var shouldModalShowHoldRequestInput = exports.shouldModalShowHoldRequestInput = function shouldModalShowHoldRequestInput(item, user) {
    return !!item && !get(item, 'hasRequestedHoldForBuyer') && !get(item, 'isPriceUponRequest') && !get(item, 'isOnHold') && !get(item, 'isSold') && !get(item, 'attributes.customizable[0].value') && get(user, 'canUseNetPrice') && get(item, 'vertical').toLowerCase() === verticals.furniture;
};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Relay = __webpack_require__(4);

var BuyerProfileMutation = function (_Relay$Mutation) {
    _inherits(BuyerProfileMutation, _Relay$Mutation);

    function BuyerProfileMutation() {
        _classCallCheck(this, BuyerProfileMutation);

        return _possibleConstructorReturn(this, (BuyerProfileMutation.__proto__ || Object.getPrototypeOf(BuyerProfileMutation)).apply(this, arguments));
    }

    _createClass(BuyerProfileMutation, [{
        key: 'getMutation',
        value: function getMutation() {
            return function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'updateBuyerProfileName',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'UpdateBuyerProfileNameInput!'
                    },
                    name: 'BuyerProfileMutation',
                    responseType: 'UpdateBuyerProfileNamePayload'
                };
            }();
        }
    }, {
        key: 'getVariables',
        value: function getVariables() {
            var _props = this.props,
                user = _props.user,
                displayName = _props.displayName;


            return {
                userServiceId: user.serviceId,
                displayName: displayName
            };
        }
    }, {
        key: 'getFatQuery',
        value: function getFatQuery() {
            return function () {
                return {
                    children: [{
                        children: [{
                            children: [{
                                fieldName: 'displayName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'firstName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'lastName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'profile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'Profile'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'user',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'User'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'BuyerProfileMutationRelayQL',
                    type: 'UpdateBuyerProfileNamePayload'
                };
            }();
        }
    }, {
        key: 'getConfigs',
        value: function getConfigs() {
            return [{
                type: 'FIELDS_CHANGE',
                fieldIDs: { user: this.props.user.id }
            }];
        }
    }]);

    return BuyerProfileMutation;
}(Relay.Mutation);

BuyerProfileMutation.fragments = {
    user: function user() {
        return function () {
            return {
                children: [{
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isRequisite: true
                    },
                    type: 'ID'
                }, {
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }, {
                    children: [{
                        fieldName: 'displayName',
                        kind: 'Field',
                        metadata: {},
                        type: 'String'
                    }],
                    fieldName: 'profile',
                    kind: 'Field',
                    metadata: {
                        canHaveSubselections: true
                    },
                    type: 'Profile'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'BuyerProfileMutation_UserRelayQL',
                type: 'User'
            };
        }();
    }
};

module.exports = BuyerProfileMutation;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Relay = __webpack_require__(4);

var FavoriteItemMutation = function (_Relay$Mutation) {
    _inherits(FavoriteItemMutation, _Relay$Mutation);

    function FavoriteItemMutation() {
        _classCallCheck(this, FavoriteItemMutation);

        return _possibleConstructorReturn(this, (FavoriteItemMutation.__proto__ || Object.getPrototypeOf(FavoriteItemMutation)).apply(this, arguments));
    }

    _createClass(FavoriteItemMutation, [{
        key: 'getMutation',
        value: function getMutation() {
            return function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'favoriteItem',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'FavoriteItemInput!'
                    },
                    name: 'FavoriteItemMutation',
                    responseType: 'FavoriteItemPayload'
                };
            }();
        }
    }, {
        key: 'getVariables',
        value: function getVariables() {
            return {
                action: this.props.action,
                userId: this.props.userId,
                itemId: this.props.item.serviceId,
                portfolioId: this.props.portfolioId
            };
        }
    }, {
        key: 'getFatQuery',
        value: function getFatQuery() {
            return function () {
                return {
                    children: [{
                        children: [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'item',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Item'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'FavoriteItemMutationRelayQL',
                    type: 'FavoriteItemPayload'
                };
            }();
        }
    }, {
        key: 'getConfigs',
        value: function getConfigs() {
            return [{
                type: 'FIELDS_CHANGE',
                fieldIDs: { item: this.props.item.id }
            }];
        }
    }]);

    return FavoriteItemMutation;
}(Relay.Mutation);

FavoriteItemMutation.fragments = {
    item: function item() {
        return function () {
            return {
                children: [{
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isRequisite: true
                    },
                    type: 'ID'
                }, {
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'FavoriteItemMutation_ItemRelayQL',
                type: 'Item'
            };
        }();
    }
};

module.exports = FavoriteItemMutation;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Relay = __webpack_require__(4);

var TradeStatusMutation = function (_Relay$Mutation) {
    _inherits(TradeStatusMutation, _Relay$Mutation);

    function TradeStatusMutation() {
        _classCallCheck(this, TradeStatusMutation);

        return _possibleConstructorReturn(this, (TradeStatusMutation.__proto__ || Object.getPrototypeOf(TradeStatusMutation)).apply(this, arguments));
    }

    _createClass(TradeStatusMutation, [{
        key: 'getMutation',
        value: function getMutation() {
            return function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'editVerifiedTradeMutation',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'EditVerifiedTradeInput!'
                    },
                    name: 'TradeStatusMutation',
                    responseType: 'EditVerifiedTradePayload'
                };
            }();
        }
    }, {
        key: 'getVariables',
        value: function getVariables() {
            return {
                userId: this.props.user.serviceId,
                verifiedTradeStatus: this.props.tradeStatus
            };
        }
    }, {
        key: 'getFatQuery',
        value: function getFatQuery() {
            return function () {
                return {
                    children: [{
                        children: [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'user',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'User'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'TradeStatusMutationRelayQL',
                    type: 'EditVerifiedTradePayload'
                };
            }();
        }
    }, {
        key: 'getConfigs',
        value: function getConfigs() {
            return [{
                type: 'FIELDS_CHANGE',
                fieldIDs: { user: this.props.user.id }
            }];
        }
    }]);

    return TradeStatusMutation;
}(Relay.Mutation);

TradeStatusMutation.fragments = {
    user: function user() {
        return function () {
            return {
                children: [{
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isRequisite: true
                    },
                    type: 'ID'
                }, {
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }, {
                    fieldName: 'verifiedTradeStatus',
                    kind: 'Field',
                    metadata: {},
                    type: 'String'
                }],
                id: Relay.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'TradeStatusMutation_UserRelayQL',
                type: 'User'
            };
        }();
    }
};

module.exports = TradeStatusMutation;

/***/ },
/* 63 */
/***/ function(module, exports) {

"use strict";
'use strict';

module.exports = {
    getFailsMaxLengthFunc: function getFailsMaxLengthFunc(length) {
        return function (str) {
            return str.length > length;
        };
    },
    getMatchesRegexFunc: function getMatchesRegexFunc(regex) {
        return function (str) {
            return !!str.match(regex);
        };
    },
    getFailsRequiredFunc: function getFailsRequiredFunc() {
        return function (str) {
            return !str;
        };
    },
    getMaxLengthError: function getMaxLengthError(lengthLimit) {
        return 'Please enter a maximum of ' + lengthLimit + ' characters.';
    },
    sharedRegex: {
        specialChars: /[!@#$%^&*()+=><?]+/ig,
        validEmail: /^\S+@\S+\.\S+$/i
    }
};

/***/ },
/* 64 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mainFormContainer":"src-scss-abTests-modal-sidebar---mainFormContainer---w7WCf","formWrapper":"src-scss-abTests-modal-sidebar---formWrapper---33Mz7","makeOfferModalLink":"src-scss-abTests-modal-sidebar---makeOfferModalLink---1VRLD","sidebarWrapper":"src-scss-abTests-modal-sidebar---sidebarWrapper---1UtYZ","desktopPromptList":"src-scss-abTests-modal-sidebar---desktopPromptList---2H5eR","prompt":"src-scss-abTests-modal-sidebar---prompt---20slK","mobilePrompt":"src-scss-abTests-modal-sidebar---mobilePrompt---226YT"};

/***/ },
/* 65 */
/***/ function(module, exports) {

module.exports = {
	"successGenericHeader": "Success",
	"successMsg": "Your {successType} was sent successfully!",
	"viewRequest": "You can view your request at any time in ",
	"myConversations": "My Conversations"
};

/***/ },
/* 66 */
/***/ function(module, exports) {

module.exports = {
	"isRequired": "This field is required.",
	"invalidEmail": "Please enter a valid email address.",
	"specialChars": "This field may not contain special characters.",
	"positiveNumber": "Please enter a value greater than zero.",
	"underListPrice": "Please enter an offer below the list price.",
	"lowBallErrorLabel": "offer below {threshold}"
};

/***/ },
/* 67 */
/***/ function(module, exports) {

module.exports = {
	"item": "CONTACT_SELLER_PDP",
	"itemNetPrice": "CONTACT_SELLER_NET_PRICE",
	"seller": "CONTACT_SELLER_STOREFRONT"
};

/***/ },
/* 68 */
/***/ function(module, exports) {

module.exports = __webpack_require__(706);

/***/ },
/* 69 */
/***/ function(module, exports) {

module.exports = __webpack_require__(2786);

/***/ },
/* 70 */
/***/ function(module, exports) {

module.exports = __webpack_require__(358);

/***/ },
/* 71 */
/***/ function(module, exports) {

module.exports = __webpack_require__(27);

/***/ },
/* 72 */
/***/ function(module, exports) {

module.exports = __webpack_require__(416);

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var ContactDealerModal = __webpack_require__(93);

var _require = __webpack_require__(9),
    hoistStatics = _require.hoistStatics,
    compose = _require.compose;

var redux = __webpack_require__(94);
var relay = __webpack_require__(95);

module.exports = hoistStatics(compose(relay, redux))(ContactDealerModal);

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var MakeOfferModal = __webpack_require__(96);

var _require = __webpack_require__(9),
    hoistStatics = _require.hoistStatics,
    compose = _require.compose;

var redux = __webpack_require__(97);
var relay = __webpack_require__(98);

module.exports = hoistStatics(compose(relay, redux))(MakeOfferModal);

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var MakePreAuthOfferModal = __webpack_require__(99);

var _require = __webpack_require__(9),
    hoistStatics = _require.hoistStatics,
    compose = _require.compose;

var redux = __webpack_require__(100);
var relay = __webpack_require__(101);

module.exports = hoistStatics(compose(relay, redux))(MakePreAuthOfferModal);

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _require = __webpack_require__(9),
    compose = _require.compose;

var redux = __webpack_require__(102);
var ModalWrapper = __webpack_require__(17);

module.exports = compose(redux)(ModalWrapper);

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var NetPriceModal = __webpack_require__(103);

var _require = __webpack_require__(9),
    hoistStatics = _require.hoistStatics,
    compose = _require.compose;

var redux = __webpack_require__(104);
var relay = __webpack_require__(105);

module.exports = hoistStatics(compose(relay, redux))(NetPriceModal);

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__(68);

var React = __webpack_require__(0);
var tokenReplace = __webpack_require__(5);
var intelligentFormat = __webpack_require__(31);
var get = __webpack_require__(1);
var Component = React.Component,
    PropTypes = React.PropTypes;


var tracking = __webpack_require__(2);

var _require = __webpack_require__(58),
    canMakePreAuthOffer = _require.canMakePreAuthOffer;

var Submit = __webpack_require__(12);

var style = __webpack_require__(124);

var AbandonMakeOffer = function (_Component) {
    _inherits(AbandonMakeOffer, _Component);

    function AbandonMakeOffer(props) {
        _classCallCheck(this, AbandonMakeOffer);

        var _this = _possibleConstructorReturn(this, (AbandonMakeOffer.__proto__ || Object.getPrototypeOf(AbandonMakeOffer)).call(this, props));

        _this.onSubmitPreAuthOffer = _this.onSubmitPreAuthOffer.bind(_this);
        return _this;
    }

    _createClass(AbandonMakeOffer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                authResultAction = _props.authResultAction,
                authWasMakeOffer = _props.authWasMakeOffer;


            if (authResultAction && authWasMakeOffer && canMakePreAuthOffer(this.props)) {
                this.makeSubmitPreAuthOffer();
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            tracking.abandonOfferEntry();
        }
    }, {
        key: 'getOfferMessage',
        value: function getOfferMessage() {
            var _props2 = this.props,
                seller = _props2.seller,
                messageValue = _props2.messageValue,
                nameValue = _props2.nameValue,
                copy = _props2.copy;


            return messageValue || tokenReplace(copy.get('abandonMakeOfferMessage'), {
                dealerName: get(seller, 'sellerProfile.company'),
                userDisplayName: nameValue,
                offerPrice: this.getOfferPrice()
            });
        }
    }, {
        key: 'getOfferPrice',
        value: function getOfferPrice() {
            var _props3 = this.props,
                currency = _props3.currency,
                offerValue = _props3.offerValue;

            return intelligentFormat(offerValue, currency);
        }
    }, {
        key: 'makeSubmitPreAuthOffer',
        value: function makeSubmitPreAuthOffer(messageValue) {
            var _props4 = this.props,
                submitPreAuthOffer = _props4.submitPreAuthOffer,
                onAbandonMakeOfferSuccess = _props4.onAbandonMakeOfferSuccess;


            submitPreAuthOffer(_extends({}, this.props, {
                isAbandonCheckout: true,
                messageValue: messageValue,
                onSuccess: function onSuccess() {
                    onAbandonMakeOfferSuccess();
                    tracking.abandonOfferSubmitted();
                }
            }));
        }
    }, {
        key: 'onSubmitPreAuthOffer',
        value: function onSubmitPreAuthOffer(e) {
            e.preventDefault();
            this.makeSubmitPreAuthOffer(this.getOfferMessage());
        }
    }, {
        key: 'render',
        value: function render() {
            var _props5 = this.props,
                isSending = _props5.isSending,
                copy = _props5.copy,
                onLeaveAbandonMakeOffer = _props5.onLeaveAbandonMakeOffer;

            return React.createElement(
                'form',
                { onSubmit: this.onSubmitPreAuthOffer, className: style.container },
                React.createElement(
                    'p',
                    { className: style.description },
                    tokenReplace(copy.get('abandonMakeOfferContent'), {
                        offerPrice: this.getOfferPrice()
                    })
                ),
                React.createElement(Submit, {
                    className: style.cta + ' button-medium button-primary',
                    copyCta: copy.get('abandonMakeOfferCta'),
                    isDisabled: isSending,
                    copyCtaBusy: copy.get('busyCta'),
                    isBusy: isSending
                }),
                React.createElement(
                    'a',
                    { href: '/',
                        onClick: onLeaveAbandonMakeOffer,
                        className: style.cta
                    },
                    copy.get('abandonMakeOfferLeaveCta')
                )
            );
        }
    }]);

    return AbandonMakeOffer;
}(Component);

AbandonMakeOffer.defaultProps = {
    modalKey: 'abandonMakeOffer',
    onAbandonMakeOfferSuccess: function onAbandonMakeOfferSuccess() {},
    onLeaveAbandonMakeOffer: function onLeaveAbandonMakeOffer() {}
};

AbandonMakeOffer.propTypes = {
    onAbandonMakeOfferSuccess: PropTypes.func,
    onLeaveAbandonMakeOffer: PropTypes.func
};

module.exports = AbandonMakeOffer;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var ModalSidebar = __webpack_require__(116);
var EmailField = __webpack_require__(50);
var HoldRequestInput = __webpack_require__(35);
var MessageField = __webpack_require__(15);
var NameField = __webpack_require__(22);
var OptInInput = __webpack_require__(53);
var Submit = __webpack_require__(12);
var get = __webpack_require__(1);
var contactModalTracking = __webpack_require__(2);
var composeClassNames = __webpack_require__(43);
var sidebarStyles = __webpack_require__(64);
var baseStyles = composeClassNames(__webpack_require__(6), __webpack_require__(127));
var css = void 0;

var ContactDealer = function (_Component) {
    _inherits(ContactDealer, _Component);

    function ContactDealer(props) {
        _classCallCheck(this, ContactDealer);

        var _this = _possibleConstructorReturn(this, (ContactDealer.__proto__ || Object.getPrototypeOf(ContactDealer)).call(this, props));

        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onGoToMakeOffer = _this.onGoToMakeOffer.bind(_this);
        _this.onOptInChange = _this.onCheckboxChange.bind(_this, 'optIn');
        _this.onHoldRequestChange = _this.onCheckboxChange.bind(_this, 'holdRequest');

        if (get(props, 'item') && props.optimizelyVariant === 'contactDealerSidebar' && !props.userHasEverLoggedIn) {
            css = composeClassNames(baseStyles, sidebarStyles);
        } else {
            css = baseStyles;
        }
        return _this;
    }

    _createClass(ContactDealer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                authResultAction = _props.authResultAction,
                clearAuthResultAction = _props.clearAuthResultAction,
                hideModal = _props.hideModal,
                submitContactDealer = _props.submitContactDealer,
                optimizelyVariant = _props.optimizelyVariant,
                copy = _props.copy,
                setGhostText = _props.setGhostText,
                authWasMakeOffer = _props.authWasMakeOffer,
                modalContentData = _props.modalContentData;

            if (optimizelyVariant === 'contactDealerSidebar') {
                setGhostText(copy.get('modalSidebarGhostText'));
            }

            if (modalContentData && modalContentData.isHoldRequestChecked) {
                this.onHoldRequestChange({ target: { checked: true } });
            }

            if (authResultAction && !authWasMakeOffer) {
                Promise.resolve(submitContactDealer(this.props)).catch(function () {});
                if (authResultAction === 'register') {
                    hideModal();
                }
                clearAuthResultAction();
                return;
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props2 = this.props,
                isShowHoldRequest = _props2.isShowHoldRequest,
                trackingModalName = _props2.trackingModalName;

            if (isShowHoldRequest) {
                contactModalTracking.eventHoldRequestDisplayed({ sourceModal: trackingModalName });
            }
        }
    }, {
        key: 'onCheckboxChange',
        value: function onCheckboxChange(checkboxField, e) {
            var _props3 = this.props,
                trackingModalName = _props3.trackingModalName,
                updateContactModalFields = _props3.updateContactModalFields,
                holdRequestedFromConfirmationModal = _props3.holdRequestedFromConfirmationModal;

            var checkboxValue = e.target.checked;

            var sourceModal = '';
            if (holdRequestedFromConfirmationModal) {
                sourceModal = 'contact dealer confirmation modal';
            } else {
                sourceModal = trackingModalName;
            }

            if (checkboxField === 'holdRequest' && checkboxValue) {
                contactModalTracking.eventHoldRequestEnabled({ sourceModal: sourceModal });
            }
            updateContactModalFields({
                field: checkboxField,
                value: checkboxValue
            });
        }
    }, {
        key: 'onGoToMakeOffer',
        value: function onGoToMakeOffer() {
            var _props4 = this.props,
                goToStep = _props4.goToStep,
                isMessageFieldOpen = _props4.isMessageFieldOpen,
                item = _props4.item,
                messageValue = _props4.messageValue,
                priceType = _props4.priceType,
                seller = _props4.seller,
                toggleMessage = _props4.toggleMessage,
                trackingParams = _props4.trackingParams,
                user = _props4.user;


            if (messageValue && !isMessageFieldOpen) {
                toggleMessage();
            }
            contactModalTracking.eventOfferEnable(Object.assign({}, trackingParams, { user: user, seller: seller, item: item, priceType: priceType }));
            goToStep({ step: 'makeOffer' });
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();
            var _props5 = this.props,
                guidedPromptSelection = _props5.guidedPromptSelection,
                item = _props5.item,
                optimizelyVariant = _props5.optimizelyVariant,
                submitContactDealer = _props5.submitContactDealer,
                trackingParams = _props5.trackingParams,
                userHasEverLoggedIn = _props5.userHasEverLoggedIn;


            Promise.resolve(submitContactDealer(this.props)).then(function () {
                contactModalTracking.eventSend(Object.assign({}, trackingParams, {
                    trackVariant: optimizelyVariant && item && !userHasEverLoggedIn,
                    guidedPromptSelection: guidedPromptSelection,
                    optimizelyVariant: optimizelyVariant
                }));
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props6 = this.props,
                copy = _props6.copy,
                emailValue = _props6.emailValue,
                errors = _props6.errors,
                userHasEverLoggedIn = _props6.userHasEverLoggedIn,
                guidedGhostText = _props6.guidedGhostText,
                isHoldRequestChecked = _props6.isHoldRequestChecked,
                isOptInChecked = _props6.isOptInChecked,
                isSending = _props6.isSending,
                isShowHoldRequest = _props6.isShowHoldRequest,
                isShowOptIn = _props6.isShowOptIn,
                item = _props6.item,
                messageValue = _props6.messageValue,
                nameValue = _props6.nameValue,
                optInLabel = _props6.optInLabel,
                optimizelyVariant = _props6.optimizelyVariant,
                updateContactModalFields = _props6.updateContactModalFields,
                isUserNameSet = _props6.isUserNameSet,
                isUserInitiallyLoggedIn = _props6.isUserInitiallyLoggedIn,
                modalContentData = _props6.modalContentData;


            var onUpdateTextFields = updateContactModalFields.bind(this);
            var copySuffix = get(modalContentData, 'copySuffix');
            copySuffix = copySuffix ? '-' + copySuffix : '';
            var messagePlaceholder = copy.get(item ? 'messagePlaceholder' + copySuffix : 'messagePlaceholderStorefront');
            var labelText = copy.get('labelMessage' + copySuffix);
            var descriptionText = copy.get('descriptionText' + copySuffix);

            var showSidebar = !!item && !userHasEverLoggedIn && optimizelyVariant === 'contactDealerSidebar';

            var messageField = React.createElement(MessageField, {
                copy: copy,
                errors: errors,
                messagePlaceholder: guidedGhostText ? guidedGhostText : messagePlaceholder,
                messageValue: messageValue,
                onMessageChange: onUpdateTextFields,
                labelText: labelText,
                descriptionText: descriptionText
            });

            return React.createElement(
                'form',
                { onSubmit: this.onSubmit },
                React.createElement(
                    'div',
                    { className: css.mainFormContainer },
                    showSidebar ? React.createElement(ModalSidebar, { item: item, copy: copy }) : false,
                    React.createElement(
                        'div',
                        { className: showSidebar ? css.formWrapper : null },
                        guidedGhostText ? messageField : false,
                        React.createElement(NameField, {
                            isUserNameSet: isUserNameSet,
                            errors: errors,
                            copy: copy,
                            onNameChange: onUpdateTextFields,
                            nameValue: nameValue
                        }),
                        React.createElement(EmailField, {
                            copy: copy,
                            emailValue: emailValue,
                            errors: errors,
                            isUserInitiallyLoggedIn: isUserInitiallyLoggedIn,
                            onEmailChange: onUpdateTextFields
                        }),
                        guidedGhostText ? false : messageField,
                        isShowHoldRequest ? React.createElement(HoldRequestInput, {
                            isChecked: isHoldRequestChecked,
                            copyLabel: copy.get('holdRequestLabel'),
                            copyInfoChecked: copy.get('holdRequestInfoChecked'),
                            onChange: this.onHoldRequestChange
                        }) : false,
                        React.createElement(Submit, {
                            isDisabled: isSending,
                            copyCta: copy.get('sendCta'),
                            copyCtaBusy: copy.get('busyCta'),
                            isBusy: isSending,
                            dataTn: 'contact-dealer-submit'
                        }),
                        isShowOptIn ? React.createElement(OptInInput, {
                            isChecked: isOptInChecked,
                            copyLabel: optInLabel,
                            copyInfo: copy.get('optInInfo'),
                            onChange: this.onOptInChange
                        }) : false,
                        get(item, 'canBuyerMakeOffer') ? React.createElement(
                            'div',
                            {
                                'data-tn': 'contact-dealer-make-offer',
                                onClick: this.onGoToMakeOffer,
                                className: css.makeOfferModalLink
                            },
                            React.createElement(
                                'span',
                                null,
                                copy.get('makeOfferModalLinkPrompt')
                            ),
                            React.createElement(
                                'span',
                                { className: css.makeOfferModalLinkCta },
                                copy.get('makeOfferModalLinkCta')
                            )
                        ) : false
                    )
                )
            );
        }
    }]);

    return ContactDealer;
}(Component);

ContactDealer.propTypes = {
    authResultAction: PropTypes.string,
    clearAuthResultAction: PropTypes.func,
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    userHasEverLoggedIn: PropTypes.bool,
    emailValue: PropTypes.string,
    errors: PropTypes.object,
    goToStep: PropTypes.func,
    guidedGhostText: PropTypes.string,
    guidedPromptSelection: PropTypes.string,
    hideModal: PropTypes.func,
    isHoldRequestChecked: PropTypes.bool,
    isMessageFieldOpen: PropTypes.bool,
    isOptInChecked: PropTypes.bool,
    isSending: PropTypes.bool,
    isShowHoldRequest: PropTypes.bool,
    isShowOptIn: PropTypes.bool,
    item: PropTypes.object,
    messageValue: PropTypes.string,
    nameValue: PropTypes.string,
    onSubmit: PropTypes.func,
    optInLabel: PropTypes.string,
    optimizelyVariant: PropTypes.string,
    priceType: PropTypes.string,
    relay: PropTypes.object,
    seller: PropTypes.object,
    setOptIn: PropTypes.func,
    setGhostText: PropTypes.func,
    isUserInitiallyLoggedIn: PropTypes.bool,
    isUserNameSet: PropTypes.bool,
    submitContactDealer: PropTypes.func,
    toggleMessage: PropTypes.func,
    trackingModalName: PropTypes.string,
    trackingParams: PropTypes.shape({
        isItem: PropTypes.bool,
        item: PropTypes.object,
        linkLocation: PropTypes.string,
        purchaseStatus: PropTypes.string,
        vpvParams: PropTypes.object,
        vpvParamsQuery: PropTypes.string
    }),
    updateContactModalFields: PropTypes.func,
    user: PropTypes.object,
    authWasMakeOffer: PropTypes.bool,
    holdRequestedFromConfirmationModal: PropTypes.bool,
    modalContentData: PropTypes.object
};

ContactDealer.defaultProps = {
    modalKey: 'contactDealer',
    trackingModalName: 'contact dealer modal'
};

module.exports = ContactDealer;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = React.PropTypes,
    Component = React.Component;

var SectionToggle = __webpack_require__(23);
var MessageField = __webpack_require__(15);
var Submit = __webpack_require__(12);
var LowBallOptionList = __webpack_require__(111);
var css = __webpack_require__(6);

var LowBall = function (_Component) {
    _inherits(LowBall, _Component);

    function LowBall(props) {
        _classCallCheck(this, LowBall);

        var _this = _possibleConstructorReturn(this, (LowBall.__proto__ || Object.getPrototypeOf(LowBall)).call(this, props));

        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onOfferChange = _this.onOfferChange.bind(_this);
        return _this;
    }

    _createClass(LowBall, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var messageErrors = nextProps.messageErrors,
                isMessageFieldOpen = nextProps.isMessageFieldOpen,
                toggleMessage = nextProps.toggleMessage;

            if (messageErrors && Object.keys(messageErrors).length && !isMessageFieldOpen) {
                toggleMessage();
            }
        }
    }, {
        key: 'onOfferChange',
        value: function onOfferChange(fieldAndValue) {
            var _props = this.props,
                setLowBallOfferDiscount = _props.setLowBallOfferDiscount,
                copy = _props.copy,
                currency = _props.currency,
                priceValue = _props.priceValue;


            setLowBallOfferDiscount(Object.assign({}, _extends({
                priceValue: priceValue,
                copy: copy,
                currency: currency
            }, fieldAndValue)));
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();
            var _props2 = this.props,
                submitPreAuthOffer = _props2.submitPreAuthOffer,
                submitMakeOffer = _props2.submitMakeOffer,
                isPreAuthOfferLowball = _props2.isPreAuthOfferLowball;

            if (isPreAuthOfferLowball) {
                submitPreAuthOffer(this.props, { bypassLowball: true });
            } else {
                submitMakeOffer(this.props, { bypassLowball: true });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                copy = _props3.copy,
                errors = _props3.errors,
                isMessageFieldOpen = _props3.isMessageFieldOpen,
                isSending = _props3.isSending,
                lowBallOptions = _props3.lowBallOptions,
                messageValue = _props3.messageValue,
                submitDisabled = _props3.submitDisabled,
                toggleMessage = _props3.toggleMessage,
                updateContactModalFields = _props3.updateContactModalFields;

            return React.createElement(
                'form',
                { onSubmit: this.onSubmit },
                React.createElement(
                    'div',
                    { className: css.mainFormContainer },
                    React.createElement(LowBallOptionList, _extends({}, this.props, {
                        onOfferChange: this.onOfferChange,
                        onQuantityChange: updateContactModalFields.bind(this),
                        options: lowBallOptions
                    })),
                    React.createElement(
                        SectionToggle,
                        {
                            onToggle: toggleMessage.bind(this),
                            isOpen: isMessageFieldOpen,
                            toggleTn: 'send-message-toggle',
                            toggleLabel: copy.get('labelMessageToggle')
                        },
                        React.createElement(MessageField, {
                            errors: errors,
                            copy: copy,
                            onMessageChange: updateContactModalFields.bind(this),
                            messagePlaceholder: copy.get('messagePlaceholder'),
                            messageValue: messageValue,
                            hideLabel: true
                        })
                    ),
                    React.createElement(Submit, {
                        isDisabled: isSending || submitDisabled,
                        copyCta: copy.get('continueCta'),
                        copyCtaBusy: copy.get('busyCta'),
                        isBusy: isSending,
                        dataTn: 'contact-dealer-submit'
                    })
                )
            );
        }
    }]);

    return LowBall;
}(Component);

LowBall.propTypes = {
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    errors: PropTypes.object,
    isSending: PropTypes.bool,
    isMessageFieldOpen: PropTypes.bool,
    isPricePerPiece: PropTypes.bool,
    lowBallOptions: PropTypes.object,
    messageValue: PropTypes.string,
    offerValue: PropTypes.string,
    onMessageChange: PropTypes.func,
    onNameChange: PropTypes.func,
    onSubmit: PropTypes.func,
    pieces: PropTypes.number,
    quantityValue: PropTypes.string,
    setLowBallOfferDiscount: PropTypes.func,
    state: PropTypes.shape({
        priceValue: PropTypes.number.isRequired
    }),
    submitDisabled: PropTypes.bool,
    submitMakeOffer: PropTypes.func,
    toggleMessage: PropTypes.func,
    updateContactModalFields: PropTypes.func,
    currency: PropTypes.string,
    priceValue: PropTypes.number,
    submitPreAuthOffer: PropTypes.func,
    isPreAuthOfferLowball: PropTypes.bool
};

LowBall.defaultProps = {
    modalKey: 'lowBall'
};

module.exports = LowBall;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var OverlaySpinner = __webpack_require__(70);
var SectionToggle = __webpack_require__(23);
var MessageField = __webpack_require__(15);
var NameField = __webpack_require__(22);
var OfferField = __webpack_require__(52);
var QuantityField = __webpack_require__(56);
var DisplayPrice = __webpack_require__(34);
var Submit = __webpack_require__(12);
var OfferGuarantee = __webpack_require__(117);
var css = __webpack_require__(6);
var makeOfferTestHelper = __webpack_require__(119);
var tracking = __webpack_require__(2);

var _require = __webpack_require__(58),
    canMakePreAuthOffer = _require.canMakePreAuthOffer;

var pdpDisplayHelper = __webpack_require__(150).default;
var get = __webpack_require__(1);

var isTestVariant = function isTestVariant(_ref) {
    var optimizelyVariant = _ref.optimizelyVariant;
    return makeOfferTestHelper.isTestVariant(optimizelyVariant);
};
var isAutoSubmit = function isAutoSubmit(props) {
    return props.authResultAction && props.authWasMakeOffer && canMakePreAuthOffer(props);
};

var MakeOffer = function (_Component) {
    _inherits(MakeOffer, _Component);

    function MakeOffer(props) {
        _classCallCheck(this, MakeOffer);

        var _this = _possibleConstructorReturn(this, (MakeOffer.__proto__ || Object.getPrototypeOf(MakeOffer)).call(this, props));

        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onSubmitPreAuthOffer = _this.onSubmitPreAuthOffer.bind(_this);
        _this.onOfferGuaranteeChange = _this.onOfferGuaranteeChange.bind(_this);

        _this.state = {
            isOfferGuaranteeChecked: makeOfferTestHelper.isCheckboxChecked(props.optimizelyVariant),
            shouldShowMakeOfferCheckbox: isTestVariant(props) && canMakePreAuthOffer(props)
        };
        return _this;
    }

    _createClass(MakeOffer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (isAutoSubmit(this.props)) {
                this.props.submitPreAuthOffer(this.props);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                user = _props.user,
                updateContactModalFields = _props.updateContactModalFields;

            updateContactModalFields({
                field: 'name',
                value: get(user, 'profile.displayName') || ''
            });

            this.trackOfferInquiry();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var messageErrors = nextProps.messageErrors,
                isMessageFieldOpen = nextProps.isMessageFieldOpen,
                toggleMessage = nextProps.toggleMessage;

            if (messageErrors && messageErrors.message && !isMessageFieldOpen) {
                toggleMessage();
            }

            if (!this.props.transaction && nextProps.transaction) {
                this.setState({
                    shouldShowMakeOfferCheckbox: isTestVariant(nextProps) && canMakePreAuthOffer(nextProps)
                });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var isOfferGuaranteeChecked = this.state.isOfferGuaranteeChecked;

            if (prevState.isOfferGuaranteeChecked !== isOfferGuaranteeChecked) {
                this.trackOfferInquiry();
            }
        }
    }, {
        key: 'trackOfferInquiry',
        value: function trackOfferInquiry() {
            var _state = this.state,
                shouldShowMakeOfferCheckbox = _state.shouldShowMakeOfferCheckbox,
                isOfferGuaranteeChecked = _state.isOfferGuaranteeChecked;

            // Offer test is running and checkobox is not checked - dealer message will be sent

            if (shouldShowMakeOfferCheckbox && !isOfferGuaranteeChecked && !isAutoSubmit(this.props)) {
                tracking.offerInquiryEntry();
            }
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();
            var _state2 = this.state,
                shouldShowMakeOfferCheckbox = _state2.shouldShowMakeOfferCheckbox,
                isOfferGuaranteeChecked = _state2.isOfferGuaranteeChecked;


            if (!shouldShowMakeOfferCheckbox || shouldShowMakeOfferCheckbox && isOfferGuaranteeChecked) {
                var submitMakeOffer = this.props.submitMakeOffer;

                submitMakeOffer(this.props);
            } else if (shouldShowMakeOfferCheckbox) {
                this.onSubmitPreAuthOffer(e);
            }
        }
    }, {
        key: 'onSubmitPreAuthOffer',
        value: function onSubmitPreAuthOffer(e) {
            e.preventDefault();
            var _props2 = this.props,
                submitPreAuthOffer = _props2.submitPreAuthOffer,
                setPreAuthOfferLowball = _props2.setPreAuthOfferLowball;

            setPreAuthOfferLowball(true);
            submitPreAuthOffer(this.props);
        }
    }, {
        key: 'onOfferGuaranteeChange',
        value: function onOfferGuaranteeChange(isOfferGuaranteeChecked) {
            this.setState({ isOfferGuaranteeChecked: isOfferGuaranteeChecked });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                copy = _props3.copy,
                currencySymbol = _props3.currencySymbol,
                errors = _props3.errors,
                formattedNetPrice = _props3.formattedNetPrice,
                formattedRetailPrice = _props3.formattedRetailPrice,
                formattedSalePrice = _props3.formattedSalePrice,
                isMessageFieldOpen = _props3.isMessageFieldOpen,
                isPricePerPiece = _props3.isPricePerPiece,
                isSending = _props3.isSending,
                messageValue = _props3.messageValue,
                offerValue = _props3.offerValue,
                pieces = _props3.pieces,
                priceType = _props3.priceType,
                quantityValue = _props3.quantityValue,
                toggleMessage = _props3.toggleMessage,
                updateContactModalFields = _props3.updateContactModalFields,
                nameValue = _props3.nameValue,
                authResultAction = _props3.authResultAction,
                authWasMakeOffer = _props3.authWasMakeOffer,
                item = _props3.item,
                user = _props3.user;

            var displayData = pdpDisplayHelper({
                item: item,
                buyerId: get(user, 'serviceId'),
                buyerHasTradePermission: get(user, 'isVerifiedTrade')
            }).getShowPrices();
            var showNetPrice = displayData.showNetPrice;
            var _state3 = this.state,
                shouldShowMakeOfferCheckbox = _state3.shouldShowMakeOfferCheckbox,
                isOfferGuaranteeChecked = _state3.isOfferGuaranteeChecked;

            var onUpdateTextFields = updateContactModalFields.bind(this);
            var messagePlaceholder = copy.get('messagePlaceholder');
            var submitButtonCopy = copy.get('continueCta');

            return React.createElement(
                'form',
                { onSubmit: this.onSubmit },
                React.createElement(
                    'div',
                    { className: css.mainFormContainer },
                    React.createElement(DisplayPrice, {
                        className: css.offerInfo,
                        formattedNetPrice: formattedNetPrice,
                        formattedRetailPrice: formattedRetailPrice,
                        formattedSalePrice: formattedSalePrice,
                        isPricePerPiece: isPricePerPiece,
                        priceType: priceType,
                        copy: copy,
                        showNetPrice: showNetPrice
                    }),
                    React.createElement(OfferField, {
                        copy: copy,
                        currencySymbol: currencySymbol,
                        errors: errors,
                        hideQuantity: true,
                        isPricePerPiece: isPricePerPiece,
                        offerValue: offerValue,
                        onOfferChange: onUpdateTextFields,
                        pieces: pieces,
                        quantityValue: quantityValue
                    }),
                    React.createElement(QuantityField, {
                        copy: copy,
                        isPricePerPiece: isPricePerPiece,
                        onOfferChange: onUpdateTextFields,
                        pieces: pieces,
                        quantityValue: quantityValue
                    }),
                    React.createElement(NameField, {
                        errors: errors,
                        copy: copy,
                        onNameChange: onUpdateTextFields,
                        nameValue: nameValue
                    }),
                    React.createElement(
                        SectionToggle,
                        {
                            isOpen: !!isMessageFieldOpen,
                            onToggle: toggleMessage.bind(this),
                            toggleLabel: copy.get('labelMessageToggle'),
                            toggleTn: 'send-message-toggle'
                        },
                        React.createElement(MessageField, {
                            copy: copy,
                            errors: errors,
                            hideLabel: true,
                            messagePlaceholder: messagePlaceholder,
                            messageValue: messageValue,
                            onMessageChange: onUpdateTextFields
                        })
                    ),
                    shouldShowMakeOfferCheckbox && React.createElement(OfferGuarantee, {
                        onChange: this.onOfferGuaranteeChange,
                        checked: isOfferGuaranteeChecked
                    }),
                    !shouldShowMakeOfferCheckbox && React.createElement(
                        'div',
                        { className: css.offerSubmitLabel },
                        copy.get('offerSubmitLabel')
                    ),
                    React.createElement(Submit, {
                        copyCta: submitButtonCopy,
                        dataTn: 'contact-dealer-submit',
                        isDisabled: isSending,
                        copyCtaBusy: copy.get('busyCta'),
                        isBusy: isSending
                    })
                ),
                authResultAction && authWasMakeOffer && isSending && React.createElement(OverlaySpinner, {
                    additionalWrapperClasses: css.spinnerWrapper,
                    additionalSpinnerClasses: css.centeredSpinner,
                    position: 'isAbsolute'
                })
            );
        }
    }]);

    return MakeOffer;
}(Component);

;

MakeOffer.propTypes = {
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    currencySymbol: PropTypes.string,
    errors: PropTypes.object,
    formattedNetPrice: PropTypes.string,
    formattedRetailPrice: PropTypes.string,
    formattedSalePrice: PropTypes.string,
    isMessageFieldOpen: PropTypes.bool,
    isPricePerPiece: PropTypes.bool,
    isUserNameSet: PropTypes.bool,
    isSending: PropTypes.bool,
    item: PropTypes.object,
    messageValue: PropTypes.string,
    nameValue: PropTypes.string,
    offerValue: PropTypes.string,
    pieces: PropTypes.number,
    priceType: PropTypes.string,
    quantityValue: PropTypes.string,
    seller: PropTypes.object,
    submitMakeOffer: PropTypes.func,
    submitPreAuthOffer: PropTypes.func,
    setPreAuthOfferLowball: PropTypes.func,
    toggleMessage: PropTypes.func,
    updateContactModalFields: PropTypes.func,
    user: PropTypes.object,
    transaction: PropTypes.object,
    optimizelyVariant: PropTypes.string,
    authResultAction: PropTypes.bool,
    authWasMakeOffer: PropTypes.bool
};

MakeOffer.defaultProps = {
    modalKey: 'makeOffer'
};

module.exports = MakeOffer;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = React.PropTypes,
    Component = React.Component;

var MessageField = __webpack_require__(15);
var DisplayPrice = __webpack_require__(34);
var Submit = __webpack_require__(12);
var css = __webpack_require__(138);

var _require = __webpack_require__(69),
    intelligentFormat = _require.intelligentFormat;

var tokenReplace = __webpack_require__(5);
var get = __webpack_require__(1);
var tracking = __webpack_require__(2);

var MakePreAuthOffer = function (_Component) {
    _inherits(MakePreAuthOffer, _Component);

    function MakePreAuthOffer(props) {
        _classCallCheck(this, MakePreAuthOffer);

        var _this = _possibleConstructorReturn(this, (MakePreAuthOffer.__proto__ || Object.getPrototypeOf(MakePreAuthOffer)).call(this, props));

        _this.onSubmit = _this.onSubmit.bind(_this);
        return _this;
    }

    _createClass(MakePreAuthOffer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            tracking.eventPreAuthOfferModalShown(this.props.isAbandonCheckout);
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();
            this.props.submitPreAuthOffer(this.props);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                copy = _props.copy,
                errors = _props.errors,
                isSending = _props.isSending,
                messageValue = _props.messageValue,
                submitDisabled = _props.submitDisabled,
                updateContactModalFields = _props.updateContactModalFields,
                currency = _props.currency,
                offerValue = _props.offerValue,
                isAbandonCheckout = _props.isAbandonCheckout,
                item = _props.item;


            var isPricePerPiece = get(item, 'pricing.pricePerPiece');
            var formattedPreAuthOfferPrice = intelligentFormat(offerValue, currency, { showDecimal: true });

            var infoCopy = copy.get('preAuthOfferInfo');
            if (isAbandonCheckout) {
                infoCopy = tokenReplace(copy.get('preAuthOfferInfoAbandonCheckout'), {
                    itemTitle: get(item, 'title')
                });
            }

            return React.createElement(
                'form',
                { onSubmit: this.onSubmit },
                React.createElement(
                    'div',
                    { className: css.mainFormContainer },
                    React.createElement(
                        'p',
                        { className: css.preAuthOfferInfo },
                        infoCopy
                    ),
                    React.createElement(DisplayPrice, {
                        copy: copy,
                        priceType: 'PRE_AUTH_OFFER',
                        formattedPreAuthOfferPrice: formattedPreAuthOfferPrice,
                        formattedNetPrice: '',
                        formattedRetailPrice: '',
                        formattedSalePrice: '',
                        isPricePerPiece: isPricePerPiece,
                        className: css.preAuthOfferDisplayPrice
                    }),
                    React.createElement(MessageField, {
                        errors: errors,
                        copy: copy,
                        onMessageChange: updateContactModalFields,
                        messagePlaceholder: tokenReplace(copy.get('preAuthOfferMessagePlaceholder'), {
                            price: formattedPreAuthOfferPrice
                        }),
                        messageValue: messageValue,
                        labelText: copy.get('preAuthOfferMessageLabel')
                    }),
                    React.createElement(Submit, {
                        isDisabled: isSending || submitDisabled || !messageValue,
                        copyCta: copy.get('preAuthOfferCta'),
                        copyCtaBusy: copy.get('busyCta'),
                        isBusy: isSending,
                        dataTn: 'pre-auth-offer-submit'
                    })
                )
            );
        }
    }]);

    return MakePreAuthOffer;
}(Component);

MakePreAuthOffer.propTypes = {
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    currency: PropTypes.string,
    isSending: PropTypes.bool,
    isPricePerPiece: PropTypes.bool,
    messageValue: PropTypes.string,
    offerValue: PropTypes.string,
    onMessageChange: PropTypes.func,
    onSubmit: PropTypes.func,
    submitDisabled: PropTypes.bool,
    submitPreAuthOffer: PropTypes.func,
    errors: PropTypes.object,
    goToSuccess: PropTypes.func,
    goToStep: PropTypes.func,
    updateContactModalFields: PropTypes.func,
    isAbandonCheckout: PropTypes.bool,
    item: PropTypes.object
};

MakePreAuthOffer.defaultProps = {
    modalKey: 'makePreAuthOffer'
};

module.exports = MakePreAuthOffer;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var get = __webpack_require__(1);
var tracking = __webpack_require__(71);
var Component = React.Component,
    PropTypes = React.PropTypes;


var ViewInvoiceLink = __webpack_require__(115);
var style = __webpack_require__(139);

var trackCTA = function trackCTA(selection) {
    tracking.trackEvent({
        label: 'contact link in PDP - sidebar|pre-populated submitted:' + selection,
        category: 'contact dealer',
        action: 'contact dealer guided selection submitted'
    });
};

var PreContactDealer = function (_Component) {
    _inherits(PreContactDealer, _Component);

    function PreContactDealer() {
        _classCallCheck(this, PreContactDealer);

        var _this = _possibleConstructorReturn(this, (PreContactDealer.__proto__ || Object.getPrototypeOf(PreContactDealer)).call(this));

        _this.onViewInvoiceClick = _this.onViewInvoiceClick.bind(_this);
        _this.makeOffer = _this.goToStep.bind(_this, {
            step: 'makeOffer',
            selection: 'make offer'
        });
        _this.placeOnHold = _this.goToStep.bind(_this, {
            step: 'contactDealer',
            selection: 'place item on hold',
            modalContentData: {
                isShowHoldRequest: false,
                isHoldRequestChecked: true,
                copySuffix: 'placeOnHold'
            }
        });
        _this.askQuestion = _this.goToStep.bind(_this, {
            step: 'contactDealer',
            selection: 'ask a question',
            modalContentData: { isShowHoldRequest: false }
        });

        _this.openShippingQuoteModal = _this.handleCtaClick.bind(_this, {
            action: 'openShippingQuoteModal',
            selection: 'ask about shipping'
        });
        _this.openConditionReportModal = _this.handleCtaClick.bind(_this, {
            action: 'openConditionReportModal',
            selection: 'request condition report'
        });
        return _this;
    }

    _createClass(PreContactDealer, [{
        key: 'goToStep',
        value: function goToStep(payload, event) {
            event.preventDefault();
            var goToStep = this.props.goToStep;

            goToStep(payload);
            trackCTA(payload.selection);
        }
    }, {
        key: 'handleCtaClick',
        value: function handleCtaClick(payload, event) {
            event.preventDefault();
            var _props = this.props,
                hideModal = _props.hideModal,
                handleCtaClick = _props.handleCtaClick;

            hideModal();

            // Set timeout needed so that `openShippingQuoteModal` is called asynchronously from `hideModal`,
            // and `overflow: hidden` is not removed while modal is open
            setTimeout(function () {
                return handleCtaClick(payload);
            }, 0);
            trackCTA(payload.selection);
        }
    }, {
        key: 'onViewInvoiceClick',
        value: function onViewInvoiceClick(payload) {
            trackCTA('view invoice');
            this.props.onViewInvoiceClick(payload);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                isShowHoldRequest = _props2.isShowHoldRequest,
                viewer = _props2.viewer,
                item = _props2.item,
                user = _props2.user,
                copy = _props2.copy;


            return React.createElement(
                'div',
                { className: style.body },
                React.createElement(
                    'div',
                    { className: style.question },
                    copy.get('preContactDealerSubtitle')
                ),
                React.createElement(
                    'a',
                    { href: '#0', onClick: this.openShippingQuoteModal, className: style.button },
                    copy.get('requestShippingQuote')
                ),
                React.createElement(
                    'a',
                    { href: '#0', onClick: this.openConditionReportModal, className: style.button },
                    copy.get('requestConditionReport')
                ),
                isShowHoldRequest && React.createElement(
                    'a',
                    { href: '#0', onClick: this.placeOnHold, className: style.button },
                    copy.get('requestToHoldItem')
                ),
                React.createElement(ViewInvoiceLink, {
                    viewer: viewer,
                    onClick: this.onViewInvoiceClick,
                    className: style.button,
                    children: copy.get('viewInvoice')
                }),
                React.createElement(
                    'a',
                    { href: '#0', onClick: this.askQuestion, className: style.button },
                    copy.get('askAQuestionCta')
                )
            );
        }
    }]);

    return PreContactDealer;
}(Component);

PreContactDealer.defaultProps = {
    modalKey: 'preContactDealer',
    onViewInvoiceClick: function onViewInvoiceClick() {},
    handleCtaClick: function handleCtaClick() {}
};

PreContactDealer.propTypes = {
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    isShowHoldRequest: PropTypes.bool,
    viewer: PropTypes.object,
    item: PropTypes.object,
    goToStep: PropTypes.func,
    hideModal: PropTypes.func,
    onViewInvoiceClick: PropTypes.func,
    handleCtaClick: PropTypes.func
};

module.exports = PreContactDealer;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var css = __webpack_require__(142);
var tokenReplace = __webpack_require__(5);
var RightArrow = __webpack_require__(152);

var SuccessGeneric = function SuccessGeneric(_ref) {
    var copy = _ref.copy,
        successType = _ref.successType;
    return React.createElement(
        'div',
        { className: css.successContainer },
        React.createElement(
            'p',
            { className: css.message },
            tokenReplace(copy.get('successMsg'), { successType: successType })
        ),
        React.createElement(
            'p',
            { className: css.message },
            copy.get('viewRequest'),
            React.createElement(
                'a',
                { href: '/my/conversations/' },
                copy.get('myConversations'),
                React.createElement(RightArrow, { className: css.ctaArrow })
            )
        )
    );
};

SuccessGeneric.propTypes = {
    successType: PropTypes.string.isRequired,
    copy: PropTypes.object.isRequired
};

SuccessGeneric.defaultProps = {
    modalKey: 'successGeneric'
};

module.exports = SuccessGeneric;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var get = __webpack_require__(1);
var tracking = __webpack_require__(2);
var composeClassNames = __webpack_require__(43);
var css = composeClassNames(__webpack_require__(6), __webpack_require__(125));
// TODO: if this variant becomes canon, rename copy keys to be more descriptive

var GuidedCopy = function (_Component) {
    _inherits(GuidedCopy, _Component);

    function GuidedCopy() {
        _classCallCheck(this, GuidedCopy);

        return _possibleConstructorReturn(this, (GuidedCopy.__proto__ || Object.getPrototypeOf(GuidedCopy)).apply(this, arguments));
    }

    _createClass(GuidedCopy, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                guidedPromptSelection = _props.guidedPromptSelection,
                setGuidedPromptSelection = _props.setGuidedPromptSelection;

            if (guidedPromptSelection !== '') {
                setGuidedPromptSelection('');
            }
        }
    }, {
        key: 'onSelectOption',
        value: function onSelectOption(selectedOption, nextModalStep) {
            var _props2 = this.props,
                copy = _props2.copy,
                goToStep = _props2.goToStep,
                setGuidedPromptSelection = _props2.setGuidedPromptSelection,
                setGhostText = _props2.setGhostText;

            var isMakeOffer = selectedOption === 'makeAnOffer';
            var selectedOptionCopy = copy.get('' + selectedOption).toLowerCase();

            setGhostText(copy.get(isMakeOffer ? 'messagePlaceholder' : selectedOption + 'GhostText'));
            setGuidedPromptSelection(selectedOptionCopy);
            tracking.eventGuidedPromptSelected(selectedOptionCopy);
            goToStep({ step: nextModalStep });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props3 = this.props,
                copy = _props3.copy,
                item = _props3.item;


            var guidedOptions = [];

            var addGuidedOption = function addGuidedOption(optionName, modalStepName) {
                return guidedOptions.push(React.createElement(
                    'div',
                    {
                        onClick: _this2.onSelectOption.bind(_this2, optionName, modalStepName),
                        className: css.guidedOptionWrapper,
                        key: optionName
                    },
                    React.createElement(
                        'span',
                        null,
                        copy.get('' + optionName)
                    ),
                    React.createElement(
                        'span',
                        null,
                        '>'
                    )
                ));
            };

            addGuidedOption('askAboutShipping', 'contactDealer');
            addGuidedOption('requestItemDetails', 'contactDealer');
            if (get(item, 'pricing.negotiable')) {
                addGuidedOption('makeAnOffer', 'makeOffer');
            }
            addGuidedOption('askAQuestion', 'contactDealer');

            return React.createElement(
                'div',
                { className: css.mainFormContainer },
                React.createElement(
                    'div',
                    { className: css.guidedPromptsContainer },
                    React.createElement(
                        'div',
                        { className: css.guidedCopySubtitle },
                        copy.get('guidedCopySubtitle')
                    ),
                    guidedOptions
                )
            );
        }
    }]);

    return GuidedCopy;
}(Component);

GuidedCopy.propTypes = {
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    goToStep: PropTypes.func,
    item: PropTypes.object,
    setGhostText: PropTypes.func,
    guidedPromptSelection: PropTypes.string,
    setGuidedPromptSelection: PropTypes.func
};

GuidedCopy.defaultProps = {
    modalKey: 'contactDealerGuidedCopy'
};

module.exports = GuidedCopy;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var ACTION_TYPES = __webpack_require__(3);
var defaultState = {
    authWasMakeOffer: false,
    authResultAction: null,
    didEmailCheck: false,
    guidedGhostText: '',
    messagesSent: [],
    holdRequestedFromConfirmationModal: false
};

// todo: remove authResultAction functionality once we can login through graphql

module.exports = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    switch (action.type) {
        case ACTION_TYPES.setAuthResultAction:
            return Object.assign({}, state, { authResultAction: action.actionName });
        case ACTION_TYPES.clearAuthResultAction:
            return Object.assign({}, state, { authResultAction: null });
        case ACTION_TYPES.resetContactData:
            /* reset everything except messagesSent, because the confirmation modal
            needs to know what types of messages have already been sent to display
            the right secondary message (eg, if the user has submitted a hold requestHold,
            it doesn't make sense to show the hold request prompt) */
            return _extends({}, defaultState, { messagesSent: state.messagesSent });
        case ACTION_TYPES.setGhostText:
            return Object.assign({}, state, { guidedGhostText: action.ghostText });
        case ACTION_TYPES.closeModal:
            return Object.assign({}, state, {
                guidedGhostText: defaultState.guidedGhostText
            });
        case ACTION_TYPES.setAuthWasMakeOffer:
            return Object.assign({}, state, { authWasMakeOffer: true });
        case ACTION_TYPES.messageSuccess:
            var messageType = action.messageType;

            return Object.assign({}, state, { messagesSent: [messageType].concat(_toConsumableArray(state.messagesSent)) });
        case ACTION_TYPES.holdFromConfirmationModal:
            return _extends({}, state, { holdRequestedFromConfirmationModal: true });
        default:
            return state;
    }
};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ACTION_TYPES = __webpack_require__(3);
var currencyUtil = __webpack_require__(44);
var defaultState = {
    emailFieldValue: '',
    messageFieldValue: '',
    nameFieldValue: '',
    offerFieldValue: '',
    quantityFieldValue: '1',
    optInFieldValue: false,
    holdRequestFieldValue: false,
    isMessageFieldOpen: false
};

module.exports = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    switch (action.type) {
        case ACTION_TYPES.updateContactFields:
            var updatedValue = action.value;
            if (action.field === 'offer') {
                // to prevent rounding errors only allow offers < 1 quadrillion (sorry Mr. Monopoly)
                if (updatedValue.length > 15) {
                    return state;
                }
                var parsedValue = currencyUtil.parseFloat(updatedValue);
                updatedValue = parsedValue ? parsedValue + '' : '';
            }
            return Object.assign({}, state, _defineProperty({}, action.field + 'FieldValue', updatedValue));
        case ACTION_TYPES.resetContactField:
            var stateKey = action.fieldKey + 'FieldValue';
            return Object.assign({}, state, _defineProperty({}, stateKey, defaultState[stateKey]));
        case ACTION_TYPES.toggleMessage:
            return Object.assign({}, state, { isMessageFieldOpen: !state.isMessageFieldOpen });
        case ACTION_TYPES.openModal:
            return Object.assign({}, state, { isMessageFieldOpen: !!state.messageFieldValue });
        case ACTION_TYPES.resetContactData:
            return defaultState;
        default:
            return state;
    }
};

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var ACTION_TYPES = __webpack_require__(3);
var currencyUtil = __webpack_require__(44);
var intelligentFormat = __webpack_require__(31);
var tokenReplace = __webpack_require__(5);
var findKey = __webpack_require__(157);
var fivePercent = 0.05;
var tenPercent = 0.1;

var defaultState = {
    isPreAuthOfferLowball: false,
    selectedLowBallOption: '',
    fivePercent: {
        labelSubtext: undefined,
        percentOff: fivePercent * 100,
        checked: false,
        value: undefined,
        label: undefined
    },
    tenPercent: {
        labelSubtext: undefined,
        percentOff: tenPercent * 100,
        checked: false,
        value: undefined,
        label: undefined
    },
    originalOffer: {
        labelSubtext: undefined,
        percentOff: undefined,
        checked: false,
        value: undefined,
        label: undefined,
        isOriginalOffer: true
    },
    other: {
        labelSubtext: undefined,
        percentOff: undefined,
        checked: false,
        value: 'other',
        label: undefined,
        isOther: true
    }
};

module.exports = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    var newState = {};
    var newLowBallSelectionKey = void 0;
    var prevLowBallOption = void 0;
    switch (action.type) {
        case ACTION_TYPES.initLowballOptions:
            var offerAmount = action.offerAmount,
                priceValue = action.priceValue,
                currency = action.currency,
                isPricePerPiece = action.isPricePerPiece,
                copy = action.copy;


            var priceFivePercentOff = currencyUtil.round(priceValue * (1 - fivePercent), 0);
            var priceTenPercentOff = currencyUtil.round(priceValue * (1 - tenPercent), 0);
            var perItem = isPricePerPiece ? copy.get(' per item') : '';

            // Value is what gets set on the offer model and label is visually displayed
            newState.fivePercent = Object.assign({}, state.fivePercent, {
                value: '' + priceFivePercentOff,
                label: intelligentFormat(priceFivePercentOff, currency) + perItem,
                labelSubtext: tokenReplace(copy.get('lowBallOptionAmountOff'), {
                    amountOff: intelligentFormat(priceValue - priceFivePercentOff, currency),
                    percentOff: state.fivePercent.percentOff
                })
            });
            newState.tenPercent = Object.assign({}, state.tenPercent, {
                value: '' + priceTenPercentOff,
                label: intelligentFormat(priceTenPercentOff, currency) + perItem,
                labelSubtext: tokenReplace(copy.get('lowBallOptionAmountOff'), {
                    amountOff: intelligentFormat(priceValue - priceTenPercentOff, currency),
                    percentOff: state.tenPercent.percentOff
                })
            });

            if (offerAmount) {
                var _offerValue = currencyUtil.parseFloat(offerAmount);
                var _amountOffValue = priceValue - _offerValue;
                var percentOff = _amountOffValue / priceValue * 100;
                newState.originalOffer = Object.assign({}, state.originalOffer, {
                    value: offerAmount,
                    label: intelligentFormat(_offerValue, currency) + perItem + ' ' + copy.get('lowBallOriginalOffer'),
                    percentOff: percentOff,
                    labelSubtext: tokenReplace(copy.get('lowBallOptionAmountOff'), {
                        amountOff: intelligentFormat(_amountOffValue, currency),
                        percentOff: currencyUtil.format(percentOff, 0)
                    })
                });
            }
            if (!state.other.label) {
                newState.other = Object.assign({}, state.other, {
                    label: copy.get('lowBallOtherOptionLabel')
                });
            }

            // reset selected lowball option
            prevLowBallOption = state[state.selectedLowBallOption];
            if (prevLowBallOption) {
                var updatedOptionProps = { checked: false };
                if (prevLowBallOption.isOther) {
                    updatedOptionProps.labelSubtext = undefined;
                }
                newState[state.selectedLowBallOption] = Object.assign({}, prevLowBallOption, updatedOptionProps);
            }
            newState.selectedLowBallOption = '';

            return Object.assign({}, state, newState);
        case ACTION_TYPES.setLowballOption:
            newLowBallSelectionKey = findKey(state, function (opt) {
                return opt.value === action.value;
            });

            if (state[newLowBallSelectionKey].checked) {
                return state;
            }

            newState[newLowBallSelectionKey] = Object.assign({}, state[newLowBallSelectionKey], { checked: true });
            newState.selectedLowBallOption = newLowBallSelectionKey;

            prevLowBallOption = state[state.selectedLowBallOption];
            if (prevLowBallOption) {
                var _updatedOptionProps = { checked: false };
                if (prevLowBallOption.isOther) {
                    _updatedOptionProps.labelSubtext = undefined;
                }
                newState[state.selectedLowBallOption] = Object.assign({}, prevLowBallOption, _updatedOptionProps);
            }
            return Object.assign({}, state, newState);
        case ACTION_TYPES.setLowballOfferDiscount:
            var updatedOther = {};
            var offerValue = currencyUtil.parseFloat(action.value);
            var amountOffValue = action.priceValue - offerValue;
            if (amountOffValue <= 0 || amountOffValue >= action.priceValue) {
                updatedOther.percentOff = null;
                updatedOther.labelSubtext = null;
            } else {
                var _percentOff = amountOffValue / action.priceValue * 100;
                updatedOther.percentOff = _percentOff;
                updatedOther.labelSubtext = tokenReplace(action.copy.get('lowBallOptionAmountOff'), {
                    amountOff: intelligentFormat(amountOffValue, action.currency),
                    percentOff: currencyUtil.format(_percentOff, 0)
                });
            }
            updatedOther = Object.assign({}, state.other, updatedOther);
            return Object.assign({}, state, { other: updatedOther });
        case ACTION_TYPES.setPreAuthOfferLowball:
            return Object.assign({}, state, { isPreAuthOfferLowball: action.flag });
        case ACTION_TYPES.closeModal:
            return Object.assign({}, state, { isPreAuthOfferLowball: false });
        default:
            return state;
    }
};

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ACTION_TYPES = __webpack_require__(3);
var defaultState = {
    activeModal: '',
    isOpened: false,
    isError: false,
    isSending: false,
    submitDisabled: false,
    currentStep: '',
    backLinkTargets: {},
    modalContentData: null
};

module.exports = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    switch (action.type) {
        case ACTION_TYPES.setServiceError:
            return Object.assign({}, state, {
                isError: true,
                submitDisabled: false,
                isSending: false,
                isOpened: true
            });
        case ACTION_TYPES.openModal:
            return Object.assign({}, state, { isOpened: true, activeModal: action.activeModal });

        case ACTION_TYPES.closeModal:
            return defaultState;

        case ACTION_TYPES.hideActiveModal:
            return Object.assign({}, state, { isOpened: false });

        case ACTION_TYPES.showActiveModal:
            return Object.assign({}, state, {
                isOpened: true
            });

        case ACTION_TYPES.gotoModalStep:
            var updatedBackLinkTargets = Object.assign({}, state.backLinkTargets, action.isBackLink ? {} : _defineProperty({}, action.currentStep, state.currentStep));
            return Object.assign({}, state, {
                currentStep: action.currentStep,
                backLinkTargets: updatedBackLinkTargets,
                modalContentData: action.modalContentData
            });

        case ACTION_TYPES.initLowballOptions:
            return Object.assign({}, state, { submitDisabled: true, isError: false });

        case ACTION_TYPES.setLowballOption:
            return Object.assign({}, state, { submitDisabled: action.value === 'other' });
        case ACTION_TYPES.setLowballOfferDiscount:
            return Object.assign({}, state, { submitDisabled: action.value === '' });

        case ACTION_TYPES.modalIsSending:
            return Object.assign({}, state, { isSending: true, isError: false });
        case ACTION_TYPES.messageSuccess:
            return Object.assign({}, state, { isSending: false });
        default:
            return state;
    }
};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _require = __webpack_require__(69),
    constants = _require.constants,
    intelligentFormat = _require.intelligentFormat;

var verticals = __webpack_require__(72);
var get = __webpack_require__(1);
var PRICE_TYPES = __webpack_require__(30);
var ACTION_TYPES = __webpack_require__(3);

var defaultState = {
    currencySymbol: '',
    formattedNetPrice: '',
    formattedRetailPrice: '',
    formattedSalePrice: '',
    isPricePerPiece: false,
    pieces: 1,
    priceType: '',
    priceValue: ''
};

var _getPriceInCurrency = function _getPriceInCurrency(prices, type, currency) {
    var price = prices.find(function (p) {
        return p.status === PRICE_TYPES.STATUS_ACTIVE && p.type === type;
    });
    if (price && price.amount && price.amount.convertedAmountList) {
        return price.amount.convertedAmountList.find(function (o) {
            return o.currency === currency;
        });
    }
    return null;
};

var _getPriceValues = function _getPriceValues(options) {
    var showNetPrice = options.showNetPrice,
        prices = options.prices,
        currency = options.currency;

    var pricesInCurrency = [PRICE_TYPES.TYPE_RETAIL, PRICE_TYPES.TYPE_NET, PRICE_TYPES.TYPE_SALE].map(function (type) {
        return _getPriceInCurrency(prices, type, currency);
    });
    return {
        retailPrice: pricesInCurrency[0],
        netPrice: showNetPrice ? pricesInCurrency[1] : null,
        salePrice: pricesInCurrency[2]
    };
};

var _getFormattedPrices = function _getFormattedPrices(pricesObj) {
    return {
        formattedRetailPrice: pricesObj.retailPrice ? intelligentFormat(pricesObj.retailPrice.amount, pricesObj.retailPrice.currency, { showDecimal: true }) : '',
        formattedNetPrice: pricesObj.netPrice ? intelligentFormat(pricesObj.netPrice.amount, pricesObj.netPrice.currency, { showDecimal: true }) : '',
        formattedSalePrice: pricesObj.salePrice ? intelligentFormat(pricesObj.salePrice.amount, pricesObj.salePrice.currency, { showDecimal: true }) : ''
    };
};

module.exports = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (action.type === ACTION_TYPES.contactDataLoaded && action.item) {
        var item = action.item,
            user = action.user,
            pageCurrency = action.pageCurrency;

        var userIsLoggedIn = !!user;
        var userCurrency = pageCurrency || get(user, 'profile.currency') || constants.currencies.CURRENCY_USD;

        var showNetPrice = false;
        if (userIsLoggedIn) {
            showNetPrice = item.vertical === verticals.VERTICAL_FURNITURE && user.canUseNetPrice;
        }
        var prices = _getPriceValues({
            showNetPrice: showNetPrice,
            prices: get(item, 'pricing.prices'),
            currency: userCurrency
        });

        var formattedPrices = _getFormattedPrices(prices);

        var priceType = void 0;
        var priceValue = void 0;

        if (!item.isPriceUponRequest) {
            if (formattedPrices.formattedSalePrice) {
                priceType = PRICE_TYPES.TYPE_SALE;
                priceValue = prices.salePrice.amount;
            } else if (formattedPrices.formattedNetPrice) {
                priceType = PRICE_TYPES.TYPE_NET;
                priceValue = prices.netPrice.amount;
            } else {
                priceType = PRICE_TYPES.TYPE_RETAIL;
                priceValue = prices.retailPrice.amount;
            }
        }

        return Object.assign({}, state, {
            priceType: priceType,
            priceValue: priceValue,
            isPricePerPiece: item.pricing.pricePerPiece,
            pieces: item.pieces,
            currency: userCurrency,
            currencySymbol: constants.symbols[userCurrency]
        }, formattedPrices);
    };
    return state;
};

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var get = __webpack_require__(1);
var pick = __webpack_require__(32);
var qs = __webpack_require__(33);
var ACTION_TYPES = __webpack_require__(3);
var defaultState = {
    guidedPromptSelection: '',
    isItem: false,
    item: {},
    linkLocation: '',
    purchaseStatus: '',
    vpvParams: {},
    vpvParamsQuery: ''
};
var yesNo = function yesNo(predicate) {
    return predicate ? 'y' : 'n';
};

module.exports = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (action.type === ACTION_TYPES.contactDataLoaded) {
        // constructVpvParams
        var seller = action.seller,
            item = action.item,
            linkLocation = action.linkLocation;

        var isPdp = linkLocation === 'pdp';
        var newState = { linkLocation: linkLocation };

        newState.vpvParams = {
            dd: get(seller, 'serviceId'),
            dn: get(seller, 'sellerProfile.company')
        };

        newState.purchaseStatus = '';

        if (item) {
            newState.item = item;
            newState.isItem = true;

            var status = 'Available-Price';
            if (get(seller, 'isSuspended') || get(item, 'isDeleted')) {
                status = 'Suspended';
            } else if (get(item, 'isOnHold')) {
                status = 'Hold';
            } else if (get(item, 'isSold')) {
                status = 'Sold';
            } else if (get(item, 'pricing.hidePrice')) {
                status = 'Available-No Price';
            }
            Object.assign(newState.vpvParams, {
                id: get(item, 'serviceId'),
                status: 'PDP-' + status,
                pur: yesNo(get(item, 'canMakePurchase')),
                neg: yesNo(get(item, isPdp ? 'canBuyerMakeOffer' : 'pricing.negotiable')),
                ship: yesNo(!get(item, 'hasPreQuotedShipping')),
                ret: yesNo(get(item, 'returnPolicy.accept'))
            });
            newState.purchaseStatus = qs.stringify(pick(newState.vpvParams, 'neg', 'ship', 'ret'), {
                delimiter: '|'
            });
        }

        newState.vpvParamsQuery = decodeURIComponent(qs.stringify(newState.vpvParams).toLowerCase());
        return Object.assign({}, state, newState);
    } else if (action.type === ACTION_TYPES.setGuidedPromptSelection) {
        return Object.assign({}, state, { guidedPromptSelection: action.prompt });
    }
    return state;
};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var ACTION_TYPES = __webpack_require__(3);
var defaultState = {
    messageErrors: {},
    offerErrors: {}
};

module.exports = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    var newState = {};
    switch (action.type) {
        case ACTION_TYPES.failedValidation:
            return Object.assign({}, state, {
                messageErrors: action.messageErrors,
                offerErrors: action.offerErrors
            });
        case ACTION_TYPES.updateContactFields:
            if (action.field === 'holdRequest' && !action.value) {
                newState.messageErrors = {};
            }
            return Object.assign({}, state, newState);
        case ACTION_TYPES.closeModal:
        case ACTION_TYPES.clearValidationErrors:
            return defaultState;
        default:
            return state;
    }
};

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = React.PropTypes,
    Children = React.Children;

var tokenReplace = __webpack_require__(5);
var ModalWrapper = __webpack_require__(17);
var contactModalTracking = __webpack_require__(2);
var get = __webpack_require__(1);
var once = __webpack_require__(45);
var defaultCopy = __webpack_require__(20)().extend(Object.assign({}, __webpack_require__(28), __webpack_require__(147), __webpack_require__(26), __webpack_require__(7), __webpack_require__(27), __webpack_require__(42), __webpack_require__(143), __webpack_require__(144)));

var ContactDealerModal = function (_React$Component) {
    _inherits(ContactDealerModal, _React$Component);

    function ContactDealerModal() {
        _classCallCheck(this, ContactDealerModal);

        return _possibleConstructorReturn(this, (ContactDealerModal.__proto__ || Object.getPrototypeOf(ContactDealerModal)).apply(this, arguments));
    }

    _createClass(ContactDealerModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                authResultAction = _props.authResultAction,
                authWasMakeOffer = _props.authWasMakeOffer,
                contactDataLoaded = _props.contactDataLoaded,
                goToStep = _props.goToStep,
                item = _props.item,
                linkLocation = _props.linkLocation,
                openModal = _props.openModal,
                openOnRender = _props.openOnRender,
                optimizelyVariant = _props.optimizelyVariant,
                pageCurrency = _props.pageCurrency,
                seller = _props.seller,
                user = _props.user,
                userHasEverLoggedIn = _props.userHasEverLoggedIn,
                isPriceUponRequest = _props.isPriceUponRequest,
                updateContactModalFields = _props.updateContactModalFields,
                messageValue = _props.messageValue,
                copy = _props.copy;

            if (isPriceUponRequest && messageValue.length === 0) {
                updateContactModalFields({ field: 'message', value: copy.get('pretextPur') });
            }

            this.chatCloseModalOnce = once(this.chatCloseModal.bind(this));

            contactDataLoaded({ seller: seller, item: item, user: user, pageCurrency: pageCurrency, linkLocation: linkLocation });

            var displayGuidedStep = !!item && !get(item, 'pricing.hidePrice') && optimizelyVariant === 'contactDealerGuidedCopy' && !userHasEverLoggedIn && !authResultAction;

            if (item && !userHasEverLoggedIn && optimizelyVariant && !authResultAction) {
                contactModalTracking.eventVariantDisplayed(optimizelyVariant);

                // for A/B guided flow test MCPERSON-2909 & MCPERSON-2910
                // because the relay renderer and userHasEverLoggedIn are reset immediately
                // after authentication, we need to store the user's initial userHasEverLoggedIn value
                // in order to know whether to include the test variant in the
                // tracking.eventSubmitted call after successful message submission

                if (typeof Storage !== "undefined") {
                    sessionStorage.setItem('trackVariantAfterSubmission', true);
                }
            }

            var currentStep = this.props.currentStep;
            if (authResultAction && authWasMakeOffer) {
                currentStep = 'makeOffer';
            }

            goToStep({ step: displayGuidedStep ? optimizelyVariant : currentStep || 'contactDealer' });

            if (openOnRender) {
                openModal('contactDealer');
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!this.props.isOpened && nextProps.isOpened) {

                if (!this.props.authResultAction) {
                    contactModalTracking.eventLaunch(nextProps.trackingParams);
                }
            } else if (this.props.isOpened && !nextProps.isOpened) {
                contactModalTracking.resetPage();
            }
        }
    }, {
        key: 'chatCloseModal',
        value: function chatCloseModal() {
            var _props2 = this.props,
                closeModal = _props2.closeModal,
                chatAbandonTag = _props2.chatAbandonTag,
                chatTracking = _props2.chatTracking;

            var trackChatEvent = chatTracking ? chatTracking[chatAbandonTag] : false;
            if (trackChatEvent) {
                trackChatEvent();
            }
            closeModal();
        }
    }, {
        key: 'goToPrevStep',
        value: function goToPrevStep() {
            var _props3 = this.props,
                resetContactModalField = _props3.resetContactModalField,
                goToStep = _props3.goToStep,
                prevStep = _props3.prevStep,
                currentStep = _props3.currentStep;

            if (currentStep === 'makeOffer') {
                resetContactModalField('offer');
            }
            return goToStep({ step: prevStep, isBackLink: true });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props4 = this.props,
                children = _props4.children,
                copy = _props4.copy,
                currentStep = _props4.currentStep,
                guidedGhostText = _props4.guidedGhostText,
                isError = _props4.isError,
                isOpened = _props4.isOpened,
                item = _props4.item,
                seller = _props4.seller,
                state = _props4.state,
                optimizelyVariant = _props4.optimizelyVariant,
                userHasEverLoggedIn = _props4.userHasEverLoggedIn,
                modalContentData = _props4.modalContentData;

            // if one child is passed, props.children is a single component instance instead of an Array

            var CurrentModalStep = Children.toArray(children).filter(function (c) {
                return c.props.modalKey === (currentStep ? currentStep : 'contactDealer');
            })[0];
            var modalProps = Object.assign({}, this.props, {
                closeModal: this.chatCloseModalOnce,
                state: state
            });
            var copySuffix = get(modalContentData, 'copySuffix');
            var headerSuffix = copySuffix ? '-' + copySuffix : '';
            var headerText = tokenReplace(copy.get(currentStep + 'Header' + headerSuffix), {
                dealer: get(seller, 'sellerProfile.company')
            });
            var showHeaderBackLink = !!item && !userHasEverLoggedIn && currentStep !== 'contactDealerGuidedCopy' && (currentStep === 'makeOffer' || optimizelyVariant === 'contactDealerGuidedCopy');
            return React.createElement(
                ModalWrapper,
                {
                    modalType: 'contactDealer',
                    currentStep: currentStep,
                    isOpened: isOpened,
                    isError: isError,
                    header: headerText,
                    closeModal: modalProps.closeModal,
                    goToPrevStep: this.goToPrevStep.bind(this),
                    showHeaderBackLink: showHeaderBackLink,
                    guidedGhostText: guidedGhostText
                },
                React.cloneElement(CurrentModalStep, _extends({}, modalProps))
            );
        }
    }]);

    return ContactDealerModal;
}(React.Component);

;

ContactDealerModal.propTypes = {
    children: PropTypes.node.isRequired,
    closeModal: PropTypes.func.isRequired,
    contactDataLoaded: PropTypes.func,
    copy: PropTypes.object,
    currentStep: PropTypes.string,
    userHasEverLoggedIn: PropTypes.bool,
    emailValue: PropTypes.string,
    goToStep: PropTypes.func.isRequired,
    guidedGhostText: PropTypes.string,
    isError: PropTypes.bool,
    isLoading: PropTypes.bool,
    isOpened: PropTypes.bool.isRequired,
    item: PropTypes.object,
    linkLocation: PropTypes.string,
    messageValue: PropTypes.string,
    modalContentData: PropTypes.object,
    nameValue: PropTypes.string,
    offerValue: PropTypes.string,
    openModal: PropTypes.func.isRequired,
    openOnRender: PropTypes.bool,
    prevStep: PropTypes.string,
    relay: PropTypes.object,
    resetContactModalField: PropTypes.func,
    seller: PropTypes.object,
    state: PropTypes.shape({
        priceType: PropTypes.string,
        priceValue: PropTypes.number,
        isPricePerPiece: PropTypes.bool,
        pieces: PropTypes.number,
        currency: PropTypes.string,
        currencySymbol: PropTypes.string,
        formattedPrices: PropTypes.shape({
            formattedSalePrice: PropTypes.string,
            formattedNetPrice: PropTypes.string,
            formattedRetailPrice: PropTypes.string
        })
    }),
    trackingParams: PropTypes.shape({
        isItem: PropTypes.bool,
        item: PropTypes.object,
        linkLocation: PropTypes.string,
        purchaseStatus: PropTypes.string,
        vpvParams: PropTypes.object,
        vpvParamsQuery: PropTypes.string
    }),
    updateContactModalFields: PropTypes.func,
    user: PropTypes.object,
    chatAbandonTag: PropTypes.string,
    chatSuccessTag: PropTypes.string,
    chatTracking: PropTypes.object,
    authResultAction: PropTypes.string,
    optimizelyVariant: PropTypes.string,
    pageCurrency: PropTypes.string,
    isPriceUponRequest: PropTypes.bool,
    setPreAuthOfferLowball: PropTypes.func,
    holdRequestedFromConfirmationModal: PropTypes.bool.isRequired,
    authWasMakeOffer: PropTypes.bool
};

ContactDealerModal.defaultProps = {
    currentStep: 'contactDealer',
    chatAbandonTag: 'abandonContactDealer',
    chatSuccessTag: 'contactDealer',
    copy: defaultCopy,
    openOnRender: true
};

module.exports = ContactDealerModal;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var modalWrapperActions = __webpack_require__(8);
var validationActions = __webpack_require__(10);
var fieldsActions = __webpack_require__(13);
var contactDealerActions = __webpack_require__(46);
var makeOfferActions = __webpack_require__(14);
var mutationActions = __webpack_require__(11);

var _require = __webpack_require__(21),
    connect = _require.connect;

var mapStateToProps = function mapStateToProps(_ref) {
    var contactDealer = _ref.contactDealer,
        fields = _ref.fields,
        lowBall = _ref.lowBall,
        modalWrapper = _ref.modalWrapper,
        price = _ref.price,
        tracking = _ref.tracking,
        validation = _ref.validation;

    return {
        currentStep: modalWrapper.currentStep,
        prevStep: modalWrapper.backLinkTargets[modalWrapper.currentStep],
        guidedGhostText: contactDealer.guidedGhostText,
        guidedPromptSelection: tracking.guidedPromptSelection,
        isError: modalWrapper.isError,
        isOpened: modalWrapper.isOpened,
        isShowOptIn: contactDealer.isShowOptIn,
        isSending: modalWrapper.isSending,
        submitDisabled: modalWrapper.submitDisabled,
        modalContentData: modalWrapper.modalContentData,
        nameValue: fields.nameFieldValue,
        emailValue: fields.emailFieldValue,
        messagesSent: contactDealer.messagesSent,
        holdRequestedFromConfirmationModal: contactDealer.holdRequestedFromConfirmationModal,
        messageValue: fields.messageFieldValue,
        offerValue: fields.offerFieldValue,
        quantityValue: fields.quantityFieldValue,
        isOptInChecked: fields.optInFieldValue,
        isHoldRequestChecked: fields.holdRequestFieldValue,
        isMessageFieldOpen: fields.isMessageFieldOpen,
        authResultAction: contactDealer.authResultAction,
        authWasMakeOffer: contactDealer.authWasMakeOffer,
        messageErrors: validation.messageErrors,
        errors: Object.assign({}, validation.messageErrors, validation.offerErrors),
        lowBallOptions: lowBall,
        isPreAuthOfferLowball: lowBall.isPreAuthOfferLowball,
        trackingParams: tracking,

        currency: price.currency,
        currencySymbol: price.currencySymbol,
        formattedNetPrice: price.formattedNetPrice,
        formattedRetailPrice: price.formattedRetailPrice,
        formattedSalePrice: price.formattedSalePrice,
        isPricePerPiece: price.isPricePerPiece,
        pieces: price.pieces,
        priceType: price.priceType,
        priceValue: price.priceValue
    };
};

function getHoldRequestVisible(modalContentData) {
    return !modalContentData.hasOwnProperty('isShowHoldRequest') || modalContentData.isShowHoldRequest;
}

module.exports = connect(mapStateToProps, Object.assign({}, contactDealerActions, fieldsActions, makeOfferActions, modalWrapperActions, validationActions, mutationActions), function (stateProps, dispatchProps, ownProps) {
    var isHoldRequestVisible = getHoldRequestVisible(Object.assign({}, ownProps.modalContentData, stateProps.modalContentData));
    return Object.assign({}, ownProps, stateProps, dispatchProps, {
        currentStep: stateProps.currentStep || ownProps.currentStep,
        isShowHoldRequest: isHoldRequestVisible && ownProps.isShowHoldRequest,
        modalContentData: stateProps.modalContentData || ownProps.modalContentData
    });
});

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var Relay = __webpack_require__(4);
var createRelayContainer = __webpack_require__(24);

var _require = __webpack_require__(9),
    compose = _require.compose,
    hoistStatics = _require.hoistStatics,
    flattenProp = _require.flattenProp,
    withProps = _require.withProps;

var BuyerProfileMutation = __webpack_require__(60);
var ContactDealerMutation = __webpack_require__(38);
var HoldRequestMutation = __webpack_require__(39);
var FavoriteDealerMutation = __webpack_require__(25);
var FavoriteItemMutation = __webpack_require__(61);
var TradeStatusMutation = __webpack_require__(62);
var get = __webpack_require__(1);

var _require2 = __webpack_require__(59),
    shouldModalShowHoldRequestInput = _require2.shouldModalShowHoldRequestInput;

var query = {
    initialVariables: {
        sellerId: null,
        itemId: null,
        userId: null,
        emailValue: null,
        shouldFetchItem: false,
        shouldFetchImage: false,
        shouldFetchUser: false,
        shouldFetchUserAndItem: false,
        shouldFetchBuyerItemConv: false,
        shouldCheckEmailExists: false
    },
    prepareVariables: function prepareVariables(prevVariables) {
        var shouldFetchItem = prevVariables.shouldFetchItem,
            shouldFetchUser = prevVariables.shouldFetchUser;

        return Object.assign({}, prevVariables, {
            shouldFetchUserAndItem: shouldFetchItem && shouldFetchUser
        });
    },
    fragments: {
        viewer: function viewer() {
            return function (RQL_0, RQL_1, RQL_2, RQL_3, RQL_4, RQL_5, RQL_6, RQL_7, RQL_8, RQL_9, RQL_10) {
                return {
                    children: [{
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'sellerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'sellerId'
                            }
                        }],
                        children: [].concat.apply([], [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            children: [{
                                fieldName: 'displayName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'company',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'sellerProfile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'SellerProfile'
                        }, {
                            children: [{
                                fieldName: 'urlLabel',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'sellerPreferences',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'SellerPreferences'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userIds',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            children: [].concat.apply([], [{
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }, Relay.QL.__frag(RQL_0)]),
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'shouldFetchUser'
                                    }
                                }]
                            }],
                            fieldName: 'favoritesByUser',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id',
                                isPlural: true
                            },
                            type: 'Favorite'
                        }, {
                            fieldName: 'isPolicyOpop',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isSuspended',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            alias: 'isOnPreAuthOfferWhitelist',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'listName',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'ALLOW_PREAUTH_OFFERS'
                                }
                            }],
                            fieldName: 'isWhitelisted',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, Relay.QL.__frag(RQL_1), Relay.QL.__frag(RQL_2), Relay.QL.__frag(RQL_3)]),
                        fieldName: 'seller',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Seller'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'first',
                            value: {
                                kind: 'CallValue',
                                callValue: 1
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'sort',
                            value: {
                                kind: 'CallValue',
                                callValue: 'createdDate desc'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'buyerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }],
                        children: [{
                            children: [{
                                children: [{
                                    fieldName: 'isCanceled',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'Boolean'
                                }, {
                                    fieldName: 'hasCompletedCheckout',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'Boolean'
                                }, {
                                    children: [{
                                        fieldName: 'serviceId',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'ID'
                                    }, {
                                        fieldName: 'id',
                                        kind: 'Field',
                                        metadata: {
                                            isGenerated: true,
                                            isRequisite: true
                                        },
                                        type: 'ID'
                                    }],
                                    fieldName: 'mostRecentOffer',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true,
                                        inferredRootCallName: 'node',
                                        inferredPrimaryKey: 'id'
                                    },
                                    type: 'Offer'
                                }, {
                                    fieldName: 'id',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'ID'
                                }],
                                fieldName: 'node',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    inferredRootCallName: 'node',
                                    inferredPrimaryKey: 'id',
                                    isRequisite: true
                                },
                                type: 'Transaction'
                            }, {
                                fieldName: 'cursor',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'String'
                            }],
                            fieldName: 'edges',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'TransactionEdge'
                        }, {
                            children: [{
                                fieldName: 'hasNextPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }, {
                                fieldName: 'hasPreviousPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }],
                            fieldName: 'pageInfo',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'PageInfo'
                        }],
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'shouldFetchUserAndItem'
                                }
                            }]
                        }],
                        fieldName: 'transactions',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            isConnection: true
                        },
                        type: 'TransactionConnection'
                    }, {
                        alias: 'preInvoiceTransactions',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'viewName',
                            value: {
                                kind: 'CallValue',
                                callValue: 'buyer.buyerPreInvoiceFilter'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'buyerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        children: [{
                            fieldName: 'totalResults',
                            kind: 'Field',
                            metadata: {},
                            type: 'Int'
                        }],
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'shouldFetchUserAndItem'
                                }
                            }]
                        }],
                        fieldName: 'transactions',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            isConnection: true
                        },
                        type: 'TransactionConnection'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isRequisite: true
                            },
                            type: 'ID'
                        }, {
                            children: [{
                                children: [{
                                    fieldName: 'value',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }],
                                fieldName: 'customizable',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isPlural: true
                                },
                                type: 'AttributeValue'
                            }],
                            fieldName: 'attributes',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'ItemAttributes'
                        }, {
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            fieldName: 'title',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'vertical',
                            kind: 'Field',
                            metadata: {},
                            type: 'VerticalType'
                        }, {
                            fieldName: 'dibsReference',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'pieces',
                            kind: 'Field',
                            metadata: {},
                            type: 'Int'
                        }, {
                            children: [{
                                fieldName: 'hidePrice',
                                kind: 'Field',
                                metadata: {},
                                type: 'YesNo'
                            }, {
                                fieldName: 'negotiable',
                                kind: 'Field',
                                metadata: {},
                                type: 'YesNo'
                            }, {
                                fieldName: 'pricePerPiece',
                                kind: 'Field',
                                metadata: {},
                                type: 'YesNo'
                            }, {
                                children: [{
                                    children: [{
                                        children: [{
                                            fieldName: 'amount',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'Float'
                                        }, {
                                            fieldName: 'currency',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'Currency'
                                        }],
                                        fieldName: 'convertedAmountList',
                                        kind: 'Field',
                                        metadata: {
                                            canHaveSubselections: true,
                                            isPlural: true
                                        },
                                        type: 'ConvertedAmountList'
                                    }],
                                    fieldName: 'amount',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true
                                    },
                                    type: 'FinancialAmount'
                                }, {
                                    fieldName: 'status',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }, {
                                    fieldName: 'type',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'PriceType'
                                }],
                                fieldName: 'prices',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isPlural: true
                                },
                                type: 'Price'
                            }],
                            fieldName: 'pricing',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'ItemPricing'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {
                                    type: 'ImageVersionTypeName!'
                                },
                                name: 'size',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'small'
                                }
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'shouldFetchImage'
                                    }
                                }]
                            }],
                            fieldName: 'firstPhotoWebPath',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            children: [{
                                children: [{
                                    children: [{
                                        fieldName: 'browseUrl',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        fieldName: 'id',
                                        kind: 'Field',
                                        metadata: {
                                            isGenerated: true,
                                            isRequisite: true
                                        },
                                        type: 'ID'
                                    }],
                                    fieldName: 'category',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true
                                    },
                                    type: 'Category'
                                }],
                                fieldName: 'categories',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isPlural: true
                                },
                                type: 'ItemCategory'
                            }],
                            fieldName: 'classification',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'ItemClassification'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'buyerId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            fieldName: 'canBuyerMakeOffer',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'canMakePurchase',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isPriceUponRequest',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isDeleted',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isOnHold',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isSold',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'hasPreQuotedShipping',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'buyerId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'shouldFetchUser'
                                    }
                                }]
                            }],
                            fieldName: 'hasRequestedHoldForBuyer',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            children: [{
                                fieldName: 'accept',
                                kind: 'Field',
                                metadata: {},
                                type: 'YesNo'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'returnPolicy',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'ReturnPolicy'
                        }, {
                            children: [{
                                fieldName: 'serviceId',
                                kind: 'Field',
                                metadata: {},
                                type: 'ID'
                            }, {
                                children: [{
                                    fieldName: 'company',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }],
                                fieldName: 'sellerProfile',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true
                                },
                                type: 'SellerProfile'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'seller',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'Seller'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'shouldFetchUser'
                                    }
                                }]
                            }],
                            fieldName: 'isFavorite',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, Relay.QL.__frag(RQL_4), Relay.QL.__frag(RQL_5), Relay.QL.__frag(RQL_6)]),
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'shouldFetchItem'
                                }
                            }]
                        }],
                        fieldName: 'item',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Item'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'userId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }],
                        children: [].concat.apply([], [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            children: [{
                                fieldName: 'currency',
                                kind: 'Field',
                                metadata: {},
                                type: 'Currency'
                            }, {
                                calls: [{
                                    kind: 'Call',
                                    metadata: {},
                                    name: 'preventEmailFallback',
                                    value: {
                                        kind: 'CallValue',
                                        callValue: false
                                    }
                                }],
                                fieldName: 'displayName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'firstName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'lastName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'email',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'profile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'Profile'
                        }, {
                            alias: 'canSeeInvoice',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'name',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'B_INVOICE'
                                }
                            }],
                            fieldName: 'hasPermission',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            alias: 'canUseNetPrice',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'name',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'B_NET_PRICE'
                                }
                            }],
                            fieldName: 'hasPermission',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'verifiedTradeStatus',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'isVerifiedTrade',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, Relay.QL.__frag(RQL_7), Relay.QL.__frag(RQL_8), Relay.QL.__frag(RQL_9), Relay.QL.__frag(RQL_10)]),
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'shouldFetchUser'
                                }
                            }]
                        }],
                        fieldName: 'user',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'User'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'buyerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        children: [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'shouldFetchBuyerItemConv'
                                }
                            }]
                        }],
                        fieldName: 'buyerItemConversation',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Conversation'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Relay_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(FavoriteDealerMutation.getFragment('favorite'), ContactDealerMutation.getFragment('seller'), HoldRequestMutation.getFragment('seller'), FavoriteDealerMutation.getFragment('seller'), ContactDealerMutation.getFragment('item'), HoldRequestMutation.getFragment('item'), FavoriteItemMutation.getFragment('item'), BuyerProfileMutation.getFragment('user'), ContactDealerMutation.getFragment('user'), HoldRequestMutation.getFragment('user'), TradeStatusMutation.getFragment('user'));
        }
    }
};

module.exports = function (Component) {
    return hoistStatics(compose(createRelayContainer(query), flattenProp('viewer'), withProps(function (_ref) {
        var user = _ref.user,
            item = _ref.item,
            seller = _ref.seller,
            buyerItemConversation = _ref.buyerItemConversation,
            transactions = _ref.transactions;

        var isShowOptIn = !get(seller, 'isAnchorListMember') || !!user || !!item || !buyerItemConversation;

        return {
            isUserInitiallyLoggedIn: !!user,
            isUserNameSet: !!get(user, 'profile.firstName'),
            isShowOptIn: isShowOptIn,
            isShowHoldRequest: shouldModalShowHoldRequestInput(item, user),
            isPriceUponRequest: get(item, 'isPriceUponRequest'),
            transaction: get(transactions, 'edges[0].node')
        };
    })))(Component);
};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var tokenReplace = __webpack_require__(5);
var get = __webpack_require__(1);
var once = __webpack_require__(45);
var ModalWrapper = __webpack_require__(17);
var defaultCopy = __webpack_require__(20)().extend(Object.assign({}, __webpack_require__(28), __webpack_require__(26), __webpack_require__(27), __webpack_require__(7), __webpack_require__(65), __webpack_require__(42)));

var MakeOfferModal = function (_React$Component) {
    _inherits(MakeOfferModal, _React$Component);

    function MakeOfferModal() {
        _classCallCheck(this, MakeOfferModal);

        return _possibleConstructorReturn(this, (MakeOfferModal.__proto__ || Object.getPrototypeOf(MakeOfferModal)).apply(this, arguments));
    }

    _createClass(MakeOfferModal, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                contactDataLoaded = _props.contactDataLoaded,
                goToStep = _props.goToStep,
                item = _props.item,
                linkLocation = _props.linkLocation,
                openOnRender = _props.openOnRender,
                openModal = _props.openModal,
                pageCurrency = _props.pageCurrency,
                seller = _props.seller,
                user = _props.user,
                currentStep = _props.currentStep;


            this.chatCloseModalOnce = once(this.chatCloseModal.bind(this));

            contactDataLoaded({ seller: seller, item: item, user: user, pageCurrency: pageCurrency, linkLocation: linkLocation });
            goToStep({ step: currentStep || 'makeOffer' });

            if (openOnRender) {
                openModal(currentStep || 'makeOffer');
            }
        }
    }, {
        key: 'chatCloseModal',
        value: function chatCloseModal() {
            var _props2 = this.props,
                closeModal = _props2.closeModal,
                chatAbandonTag = _props2.chatAbandonTag,
                chatTracking = _props2.chatTracking;

            var trackChatEvent = chatTracking ? chatTracking[chatAbandonTag] : false;
            if (trackChatEvent) {
                trackChatEvent();
            }
            closeModal();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                children = _props3.children,
                copy = _props3.copy,
                currentStep = _props3.currentStep,
                isLoading = _props3.isLoading,
                isMC = _props3.isMC,
                isOpened = _props3.isOpened,
                seller = _props3.seller;

            // if one child is passed, props.children is a single component instance instead of an Array

            var CurrentModalStep = React.Children.toArray(children).filter(function (c) {
                return c.props.modalKey === (currentStep || 'makeOffer');
            })[0];

            var modalProps = Object.assign({}, this.props, {
                closeModal: isMC ? this.props.closeModal : this.chatCloseModalOnce
            });

            var headerText = tokenReplace(copy.get((currentStep || 'makeOffer') + 'Header'), {
                dealer: get(seller, 'sellerProfile.company')
            });

            return React.createElement(
                ModalWrapper,
                {
                    modalType: 'makeOffer',
                    currentStep: currentStep,
                    isOpened: isOpened,
                    closeModal: modalProps.closeModal,
                    header: headerText
                },
                !isLoading && React.cloneElement(CurrentModalStep, _extends({}, modalProps))
            );
        }
    }]);

    return MakeOfferModal;
}(React.Component);

;

MakeOfferModal.propTypes = {
    children: PropTypes.node.isRequired,
    closeModal: PropTypes.func.isRequired,
    contactDataLoaded: PropTypes.func,
    copy: PropTypes.object,
    currency: PropTypes.string,
    currentStep: PropTypes.string,
    emailValue: PropTypes.string,
    goToStep: PropTypes.func,
    prevStep: PropTypes.string,
    isLoading: PropTypes.bool,
    isOpened: PropTypes.bool.isRequired,
    item: PropTypes.object,
    linkLocation: PropTypes.string,
    messageValue: PropTypes.string,
    offerValue: PropTypes.string,
    openModal: PropTypes.func.isRequired,
    openOnRender: PropTypes.bool,
    relay: PropTypes.object,
    seller: PropTypes.object,
    user: PropTypes.object,
    chatAbandonTag: PropTypes.string,
    chatSuccessTag: PropTypes.string,
    chatTracking: PropTypes.object,
    pageCurrency: PropTypes.string,
    setPreAuthOfferLowball: PropTypes.func,
    isMC: PropTypes.bool
};

MakeOfferModal.defaultProps = {
    currentStep: 'makeOffer',
    chatAbandonTag: 'abandonMakeOffer',
    chatSuccessTag: 'makeOffer',
    copy: defaultCopy,
    openOnRender: true
};

module.exports = MakeOfferModal;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var modalWrapperActions = __webpack_require__(8);
var validationActions = __webpack_require__(10);
var fieldsActions = __webpack_require__(13);
var makeOfferActions = __webpack_require__(14);
var mutationActions = __webpack_require__(11);

var _require = __webpack_require__(21),
    connect = _require.connect;

var mapStateToProps = function mapStateToProps(_ref) {
    var contactDealer = _ref.contactDealer,
        modalWrapper = _ref.modalWrapper,
        fields = _ref.fields,
        lowBall = _ref.lowBall,
        validation = _ref.validation,
        tracking = _ref.tracking,
        price = _ref.price;

    return {
        currentStep: modalWrapper.currentStep,
        prevStep: modalWrapper.backLinkTargets[modalWrapper.currentStep],
        isError: modalWrapper.isError,
        isOpened: modalWrapper.isOpened,
        isSending: modalWrapper.isSending,
        submitDisabled: modalWrapper.submitDisabled,
        offerValue: fields.offerFieldValue,
        quantityValue: fields.quantityFieldValue,
        nameValue: fields.nameFieldValue,
        messageValue: fields.messageFieldValue,
        isMessageFieldOpen: fields.isMessageFieldOpen,
        messageErrors: validation.messageErrors,
        errors: Object.assign({}, validation.messageErrors, validation.offerErrors),
        lowBallOptions: lowBall,
        isPreAuthOfferLowball: lowBall.isPreAuthOfferLowball,
        trackingParams: tracking,

        authResultAction: contactDealer.authResultAction,
        authWasMakeOffer: contactDealer.authWasMakeOffer,

        currency: price.currency,
        currencySymbol: price.currencySymbol,
        formattedNetPrice: price.formattedNetPrice,
        formattedRetailPrice: price.formattedRetailPrice,
        formattedSalePrice: price.formattedSalePrice,
        isPricePerPiece: price.isPricePerPiece,
        pieces: price.pieces,
        priceType: price.priceType,
        priceValue: price.priceValue
    };
};

module.exports = connect(mapStateToProps, Object.assign({}, makeOfferActions, modalWrapperActions, fieldsActions, validationActions, mutationActions), function (stateProps, dispatchProps, ownProps) {
    return Object.assign({}, ownProps, stateProps, dispatchProps, {
        currentStep: stateProps.currentStep || ownProps.currentStep
    });
});

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var Relay = __webpack_require__(4);
var createRelayContainer = __webpack_require__(24);
var FavoriteDealerMutation = __webpack_require__(25);

var _require = __webpack_require__(9),
    compose = _require.compose,
    hoistStatics = _require.hoistStatics,
    flattenProp = _require.flattenProp,
    withProps = _require.withProps;

var get = __webpack_require__(1);

var sellerFragment = function (RQL_0, RQL_1) {
    return {
        children: [].concat.apply([], [{
            alias: 'isOnPreAuthOfferWhitelist',
            calls: [{
                kind: 'Call',
                metadata: {},
                name: 'listName',
                value: {
                    kind: 'CallValue',
                    callValue: 'ALLOW_PREAUTH_OFFERS'
                }
            }],
            fieldName: 'isWhitelisted',
            kind: 'Field',
            metadata: {},
            type: 'Boolean'
        }, {
            fieldName: 'serviceId',
            kind: 'Field',
            metadata: {},
            type: 'ID'
        }, {
            fieldName: 'isPolicyOpop',
            kind: 'Field',
            metadata: {},
            type: 'Boolean'
        }, {
            children: [{
                fieldName: 'displayName',
                kind: 'Field',
                metadata: {},
                type: 'String'
            }, {
                fieldName: 'company',
                kind: 'Field',
                metadata: {},
                type: 'String'
            }],
            fieldName: 'sellerProfile',
            kind: 'Field',
            metadata: {
                canHaveSubselections: true
            },
            type: 'SellerProfile'
        }, {
            children: [{
                fieldName: 'urlLabel',
                kind: 'Field',
                metadata: {},
                type: 'String'
            }],
            fieldName: 'sellerPreferences',
            kind: 'Field',
            metadata: {
                canHaveSubselections: true
            },
            type: 'SellerPreferences'
        }, {
            calls: [{
                kind: 'Call',
                metadata: {},
                name: 'userIds',
                value: {
                    kind: 'CallVariable',
                    callVariableName: 'userId'
                }
            }],
            children: [].concat.apply([], [{
                fieldName: 'id',
                kind: 'Field',
                metadata: {
                    isGenerated: true,
                    isRequisite: true
                },
                type: 'ID'
            }, Relay.QL.__frag(RQL_0)]),
            directives: [{
                kind: 'Directive',
                name: 'include',
                args: [{
                    name: 'if',
                    value: {
                        kind: 'CallVariable',
                        callVariableName: 'shouldFetchUser'
                    }
                }]
            }],
            fieldName: 'favoritesByUser',
            kind: 'Field',
            metadata: {
                canHaveSubselections: true,
                inferredRootCallName: 'node',
                inferredPrimaryKey: 'id',
                isPlural: true
            },
            type: 'Favorite'
        }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
                isGenerated: true,
                isRequisite: true
            },
            type: 'ID'
        }, Relay.QL.__frag(RQL_1)]),
        id: Relay.QL.__id(),
        kind: 'Fragment',
        metadata: {},
        name: 'RelayRelayQL',
        type: 'Seller'
    };
}(FavoriteDealerMutation.getFragment('favorite'), FavoriteDealerMutation.getFragment('seller'));

var itemFragment = function () {
    return {
        children: [{
            fieldName: 'title',
            kind: 'Field',
            metadata: {},
            type: 'String'
        }, {
            fieldName: 'vertical',
            kind: 'Field',
            metadata: {},
            type: 'VerticalType'
        }, {
            fieldName: 'pieces',
            kind: 'Field',
            metadata: {},
            type: 'Int'
        }, {
            fieldName: 'unavailableReasonCode',
            kind: 'Field',
            metadata: {},
            type: 'String'
        }, {
            fieldName: 'status',
            kind: 'Field',
            metadata: {},
            type: 'String'
        }, {
            children: [{
                fieldName: 'hidePrice',
                kind: 'Field',
                metadata: {},
                type: 'YesNo'
            }, {
                fieldName: 'pricePerPiece',
                kind: 'Field',
                metadata: {},
                type: 'YesNo'
            }, {
                children: [{
                    children: [{
                        children: [{
                            fieldName: 'amount',
                            kind: 'Field',
                            metadata: {},
                            type: 'Float'
                        }, {
                            fieldName: 'currency',
                            kind: 'Field',
                            metadata: {},
                            type: 'Currency'
                        }],
                        fieldName: 'convertedAmountList',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            isPlural: true
                        },
                        type: 'ConvertedAmountList'
                    }],
                    fieldName: 'amount',
                    kind: 'Field',
                    metadata: {
                        canHaveSubselections: true
                    },
                    type: 'FinancialAmount'
                }, {
                    fieldName: 'status',
                    kind: 'Field',
                    metadata: {},
                    type: 'String'
                }, {
                    fieldName: 'type',
                    kind: 'Field',
                    metadata: {},
                    type: 'PriceType'
                }, {
                    fieldName: 'hidePrice',
                    kind: 'Field',
                    metadata: {},
                    type: 'YesNo'
                }],
                fieldName: 'prices',
                kind: 'Field',
                metadata: {
                    canHaveSubselections: true,
                    isPlural: true
                },
                type: 'Price'
            }],
            fieldName: 'pricing',
            kind: 'Field',
            metadata: {
                canHaveSubselections: true
            },
            type: 'ItemPricing'
        }, {
            fieldName: 'serviceId',
            kind: 'Field',
            metadata: {},
            type: 'ID'
        }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
                isGenerated: true,
                isRequisite: true
            },
            type: 'ID'
        }],
        id: Relay.QL.__id(),
        kind: 'Fragment',
        metadata: {},
        name: 'RelayRelayQL',
        type: 'Item'
    };
}();

var transactionFragment = function () {
    return {
        children: [{
            fieldName: 'isCanceled',
            kind: 'Field',
            metadata: {},
            type: 'Boolean'
        }, {
            fieldName: 'hasCompletedCheckout',
            kind: 'Field',
            metadata: {},
            type: 'Boolean'
        }, {
            children: [{
                fieldName: 'serviceId',
                kind: 'Field',
                metadata: {},
                type: 'ID'
            }, {
                fieldName: 'id',
                kind: 'Field',
                metadata: {
                    isGenerated: true,
                    isRequisite: true
                },
                type: 'ID'
            }],
            fieldName: 'mostRecentOffer',
            kind: 'Field',
            metadata: {
                canHaveSubselections: true,
                inferredRootCallName: 'node',
                inferredPrimaryKey: 'id'
            },
            type: 'Offer'
        }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
                isGenerated: true,
                isRequisite: true
            },
            type: 'ID'
        }],
        id: Relay.QL.__id(),
        kind: 'Fragment',
        metadata: {},
        name: 'RelayRelayQL',
        type: 'Transaction'
    };
}();

var query = {
    initialVariables: {
        sellerId: null,
        itemId: null,
        userId: null,
        shouldFetchUser: false,
        shouldFetchTransaction: false,
        isMC: false
    },
    prepareVariables: function prepareVariables(prevVariables) {
        var isMC = prevVariables.isMC,
            shouldFetchUser = prevVariables.shouldFetchUser;

        return Object.assign({}, prevVariables, {
            shouldFetchTransaction: shouldFetchUser && !isMC
        });
    },
    fragments: {
        conversation: function conversation() {
            return function (RQL_0, RQL_1) {
                return {
                    children: [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isRequisite: true
                        },
                        type: 'ID'
                    }, {
                        children: [{
                            children: [].concat.apply([], [{
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }, Relay.QL.__frag(RQL_0)]),
                            fieldName: 'seller',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'Seller'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'originalSeller',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'ConversationMember'
                    }, {
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, Relay.QL.__frag(RQL_1)]),
                        fieldName: 'transaction',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Transaction'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Relay_ConversationRelayQL',
                    type: 'Conversation'
                };
            }(sellerFragment, transactionFragment);
        },
        item: function item() {
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Relay_ItemRelayQL',
                    type: 'Item'
                };
            }(itemFragment);
        },
        viewer: function viewer() {
            return function (RQL_0, RQL_1, RQL_2) {
                return {
                    children: [{
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'sellerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'sellerId'
                            }
                        }],
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, Relay.QL.__frag(RQL_0)]),
                        directives: [{
                            kind: 'Directive',
                            name: 'skip',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'isMC'
                                }
                            }]
                        }],
                        fieldName: 'seller',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Seller'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, Relay.QL.__frag(RQL_1)]),
                        directives: [{
                            kind: 'Directive',
                            name: 'skip',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'isMC'
                                }
                            }]
                        }],
                        fieldName: 'item',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Item'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'userId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }],
                        children: [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            children: [{
                                fieldName: 'currency',
                                kind: 'Field',
                                metadata: {},
                                type: 'Currency'
                            }, {
                                calls: [{
                                    kind: 'Call',
                                    metadata: {},
                                    name: 'preventEmailFallback',
                                    value: {
                                        kind: 'CallValue',
                                        callValue: true
                                    }
                                }],
                                fieldName: 'displayName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'firstName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'lastName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'email',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'profile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'Profile'
                        }, {
                            alias: 'canUseNetPrice',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'name',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'B_NET_PRICE'
                                }
                            }],
                            fieldName: 'hasPermission',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isVerifiedTrade',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'shouldFetchUser'
                                }
                            }]
                        }],
                        fieldName: 'user',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'User'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'first',
                            value: {
                                kind: 'CallValue',
                                callValue: 1
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'sort',
                            value: {
                                kind: 'CallValue',
                                callValue: 'createdDate desc'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'buyerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }],
                        children: [{
                            children: [{
                                children: [].concat.apply([], [{
                                    fieldName: 'id',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'ID'
                                }, Relay.QL.__frag(RQL_2)]),
                                fieldName: 'node',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    inferredRootCallName: 'node',
                                    inferredPrimaryKey: 'id',
                                    isRequisite: true
                                },
                                type: 'Transaction'
                            }, {
                                fieldName: 'cursor',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'String'
                            }],
                            fieldName: 'edges',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'TransactionEdge'
                        }, {
                            children: [{
                                fieldName: 'hasNextPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }, {
                                fieldName: 'hasPreviousPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }],
                            fieldName: 'pageInfo',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'PageInfo'
                        }],
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'shouldFetchTransaction'
                                }
                            }]
                        }],
                        fieldName: 'transactions',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            isConnection: true
                        },
                        type: 'TransactionConnection'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Relay_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(sellerFragment, itemFragment, transactionFragment);
        }
    }
};

module.exports = function (Component) {
    return hoistStatics(compose(createRelayContainer(query), flattenProp('viewer'), withProps(function (_ref) {
        var conversation = _ref.conversation,
            transactions = _ref.transactions,
            user = _ref.user;

        var sharedProps = {
            isUserInitiallyLoggedIn: !!user
        };

        if (conversation) {
            return Object.assign({}, sharedProps, {
                seller: get(conversation, 'originalSeller.seller'),
                transaction: get(conversation, 'transaction')
            });
        }
        return Object.assign({}, sharedProps, {
            transaction: get(transactions, 'edges[0].node')
        });
    })))(Component);
};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var ModalWrapper = __webpack_require__(17);
var defaultCopy = __webpack_require__(20)().extend(Object.assign({}, __webpack_require__(26), __webpack_require__(27), __webpack_require__(42), __webpack_require__(27), __webpack_require__(65), __webpack_require__(7)));

var PreAuthOfferModal = function (_React$Component) {
    _inherits(PreAuthOfferModal, _React$Component);

    function PreAuthOfferModal() {
        _classCallCheck(this, PreAuthOfferModal);

        return _possibleConstructorReturn(this, (PreAuthOfferModal.__proto__ || Object.getPrototypeOf(PreAuthOfferModal)).apply(this, arguments));
    }

    _createClass(PreAuthOfferModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                goToStep = _props.goToStep,
                openModal = _props.openModal,
                openOnRender = _props.openOnRender,
                defaultMessageValue = _props.defaultMessageValue,
                updateContactModalFields = _props.updateContactModalFields;


            if (defaultMessageValue) {
                updateContactModalFields({ field: 'message', value: defaultMessageValue });
            }

            goToStep({ step: 'makePreAuthOffer' });
            if (openOnRender) {
                openModal('makePreAuthOffer');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                children = _props2.children,
                copy = _props2.copy,
                isError = _props2.isError,
                isOpened = _props2.isOpened,
                currentStep = _props2.currentStep;


            var headerText = copy.get(currentStep + 'Header');

            var CurrentModalStep = React.Children.toArray(children).filter(function (c) {
                return c.props.modalKey === (currentStep ? currentStep : 'makePreAuthOffer');
            })[0];

            return React.createElement(
                ModalWrapper,
                {
                    modalType: 'makePreAuthOffer',
                    isOpened: isOpened,
                    isError: isError,
                    header: headerText,
                    closeModal: this.props.closeModal
                },
                React.cloneElement(CurrentModalStep, _extends({}, this.props))
            );
        }
    }]);

    return PreAuthOfferModal;
}(React.Component);

;

PreAuthOfferModal.propTypes = {
    relay: PropTypes.object,
    isOpened: PropTypes.bool.isRequired,
    isError: PropTypes.bool,
    closeModal: PropTypes.func.isRequired,
    openModal: PropTypes.func.isRequired,
    openOnRender: PropTypes.bool,
    goToStep: PropTypes.func.isRequired,
    currentStep: PropTypes.string,
    copy: PropTypes.object,
    children: PropTypes.node.isRequired,
    defaultMessageValue: PropTypes.string,
    updateContactModalFields: PropTypes.func
};

PreAuthOfferModal.defaultProps = {
    copy: defaultCopy,
    openOnRender: true
};

module.exports = PreAuthOfferModal;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var modalWrapperActions = __webpack_require__(8);
var validationActions = __webpack_require__(10);
var fieldsActions = __webpack_require__(13);
var mutationActions = __webpack_require__(11);
var makeOfferActions = __webpack_require__(14);

var _require = __webpack_require__(21),
    connect = _require.connect;

var mapStateToProps = function mapStateToProps(_ref, ownProps) {
    var modalWrapper = _ref.modalWrapper,
        validation = _ref.validation,
        fields = _ref.fields;

    return {
        isError: modalWrapper.isError,
        isOpened: modalWrapper.isOpened,
        isSending: modalWrapper.isSending,
        currentStep: modalWrapper.currentStep,
        messageValue: fields.messageFieldValue,
        defaultMessageValue: ownProps.messageValue,
        isMessageValidated: validation.isMessageValidated,
        errors: validation.messageErrors
    };
};

module.exports = connect(mapStateToProps, Object.assign({}, makeOfferActions, fieldsActions, modalWrapperActions, mutationActions, validationActions, makeOfferActions));

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var Relay = __webpack_require__(4);
var createRelayContainer = __webpack_require__(24);

var _require = __webpack_require__(9),
    compose = _require.compose,
    hoistStatics = _require.hoistStatics,
    flattenProp = _require.flattenProp;

var query = {
    initialVariables: {
        itemId: null
    },
    fragments: {
        viewer: function viewer() {
            return function () {
                return {
                    children: [{
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        children: [{
                            fieldName: 'title',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            children: [{
                                fieldName: 'pricePerPiece',
                                kind: 'Field',
                                metadata: {},
                                type: 'YesNo'
                            }],
                            fieldName: 'pricing',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'ItemPricing'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'item',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Item'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Relay_ViewerRelayQL',
                    type: 'Viewer'
                };
            }();
        }
    }
};

module.exports = hoistStatics(compose(createRelayContainer(query), flattenProp('viewer')));

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var modalWrapperActions = __webpack_require__(8);

var _require = __webpack_require__(21),
    connect = _require.connect;

// shell modal wrapper used for loading and error messages


var mapStateToProps = function mapStateToProps(_ref) {
    var modalWrapper = _ref.modalWrapper;

    return {
        isOpened: modalWrapper.isOpened
    };
};

module.exports = connect(mapStateToProps, Object.assign({}, modalWrapperActions));

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var ModalWrapper = __webpack_require__(17);
var NetPriceComponent = __webpack_require__(51);
var contactModalTracking = __webpack_require__(2);
var get = __webpack_require__(1);
var once = __webpack_require__(45);
var defaultCopy = __webpack_require__(20)().extend(Object.assign({}, __webpack_require__(28), __webpack_require__(26), __webpack_require__(146), __webpack_require__(7)));

var NetPriceModal = function (_React$Component) {
    _inherits(NetPriceModal, _React$Component);

    function NetPriceModal() {
        _classCallCheck(this, NetPriceModal);

        return _possibleConstructorReturn(this, (NetPriceModal.__proto__ || Object.getPrototypeOf(NetPriceModal)).apply(this, arguments));
    }

    _createClass(NetPriceModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                buyerItemConversation = _props.buyerItemConversation,
                contactDataLoaded = _props.contactDataLoaded,
                goToStep = _props.goToStep,
                item = _props.item,
                linkLocation = _props.linkLocation,
                openModal = _props.openModal,
                openOnRender = _props.openOnRender,
                redirectToMessageCenter = _props.redirectToMessageCenter,
                redirectToOrderManager = _props.redirectToOrderManager,
                transaction = _props.transaction,
                seller = _props.seller;


            this.chatCloseModalOnce = once(this.chatCloseModal.bind(this));

            var hasRelevantTransaction = transaction && !get(transaction, 'isCanceled') && get(transaction, 'mostRecentOffer') && get(transaction, 'mostRecentOffer.status') !== 'NEW';
            // a relevant transaction is
            // - active (i.e. not canceled)
            // - not a custom shipping quote request (where there is no offer)
            // - not a pre-checkout invoice (where offer has status 'NEW')

            if (redirectToMessageCenter) {
                window.location.href = '/my/conversations/' + get(buyerItemConversation, 'serviceId');
            } else if (hasRelevantTransaction) {
                window.location.href = '/my/orders/order/' + get(transaction, 'serviceId');
            }

            contactDataLoaded({ seller: seller, item: item, linkLocation: linkLocation });
            goToStep({ step: 'netPrice' });
            if (openOnRender) {
                openModal('netPrice');
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.isOpened && !nextProps.isOpened) {
                contactModalTracking.resetPage();
            }
        }
    }, {
        key: 'chatCloseModal',
        value: function chatCloseModal() {
            var _props2 = this.props,
                closeModal = _props2.closeModal,
                chatAbandonTag = _props2.chatAbandonTag,
                chatTracking = _props2.chatTracking;

            var trackChatEvent = chatTracking ? chatTracking[chatAbandonTag] : false;
            if (trackChatEvent) {
                trackChatEvent();
            }
            closeModal();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                copy = _props3.copy,
                isError = _props3.isError,
                isOpened = _props3.isOpened;


            var headerText = copy.get('netPriceHeader');

            var props = Object.assign({}, this.props, {
                closeModal: this.chatCloseModalOnce
            });

            return React.createElement(
                ModalWrapper,
                {
                    modalType: 'netPrice',
                    isOpened: isOpened,
                    isError: isError,
                    header: headerText,
                    closeModal: props.closeModal
                },
                React.createElement(NetPriceComponent, props)
            );
        }
    }]);

    return NetPriceModal;
}(React.Component);

;

NetPriceModal.propTypes = {
    relay: PropTypes.object,
    isOpened: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool,
    isError: PropTypes.bool,
    closeModal: PropTypes.func.isRequired,
    openModal: PropTypes.func.isRequired,
    openOnRender: PropTypes.bool,
    goToStep: PropTypes.func.isRequired,
    contactDataLoaded: PropTypes.func,
    messageValue: PropTypes.string,
    item: PropTypes.object,
    seller: PropTypes.object,
    user: PropTypes.object,
    copy: PropTypes.object,
    linkLocation: PropTypes.string,
    buyerItemConversation: PropTypes.object,
    redirectToMessageCenter: PropTypes.bool,
    transaction: PropTypes.shape({
        isCanceled: PropTypes.bool,
        serviceId: PropTypes.string,
        mostRecentOffer: PropTypes.shape({
            status: PropTypes.string
        })
    }),
    trackingParams: PropTypes.shape({
        isItem: PropTypes.bool,
        item: PropTypes.object,
        linkLocation: PropTypes.string,
        purchaseStatus: PropTypes.string,
        vpvParams: PropTypes.object,
        vpvParamsQuery: PropTypes.string
    }),
    chatAbandonTag: PropTypes.string,
    chatSuccessTag: PropTypes.string,
    chatTracking: PropTypes.object
};

NetPriceModal.defaultProps = {
    chatAbandonTag: 'abandonRequestNetPrice',
    chatSuccessTag: 'requestNetPrice',
    copy: defaultCopy,
    openOnRender: true
};

module.exports = NetPriceModal;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var modalWrapperActions = __webpack_require__(8);
var validationActions = __webpack_require__(10);
var netPriceActions = __webpack_require__(47);
var fieldsActions = __webpack_require__(13);
var mutationActions = __webpack_require__(11);

var _require = __webpack_require__(21),
    connect = _require.connect;

var mapStateToProps = function mapStateToProps(_ref) {
    var modalWrapper = _ref.modalWrapper,
        fields = _ref.fields,
        tracking = _ref.tracking,
        validation = _ref.validation;

    return {
        currentStep: modalWrapper.currentStep,
        isError: modalWrapper.isError,
        isOpened: modalWrapper.isOpened,
        isSending: modalWrapper.isSending,
        submitDisabled: modalWrapper.submitDisabled,
        messageValue: fields.messageFieldValue,
        nameValue: fields.nameFieldValue,
        isMessageFieldOpen: fields.isMessageFieldOpen,
        isHoldRequestChecked: fields.holdRequestFieldValue,
        isMessageValidated: validation.isMessageValidated,
        errors: validation.messageErrors,
        trackingParams: tracking
    };
};

module.exports = connect(mapStateToProps, Object.assign({}, fieldsActions, modalWrapperActions, mutationActions, netPriceActions, validationActions));

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var Relay = __webpack_require__(4);
var createRelayContainer = __webpack_require__(24);

var _require = __webpack_require__(9),
    compose = _require.compose,
    hoistStatics = _require.hoistStatics,
    flattenProp = _require.flattenProp,
    withProps = _require.withProps;

var ContactDealerMutation = __webpack_require__(38);
var HoldRequestMutation = __webpack_require__(39);
var FavoriteDealerMutation = __webpack_require__(25);
var get = __webpack_require__(1);

var _require2 = __webpack_require__(59),
    shouldModalShowHoldRequestInput = _require2.shouldModalShowHoldRequestInput;

var query = {
    initialVariables: {
        sellerId: null,
        itemId: null,
        userId: null
    },
    fragments: {
        viewer: function viewer() {
            return function (RQL_0, RQL_1, RQL_2, RQL_3, RQL_4, RQL_5, RQL_6, RQL_7) {
                return {
                    children: [{
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'sellerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'sellerId'
                            }
                        }],
                        children: [].concat.apply([], [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            children: [{
                                fieldName: 'displayName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'company',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'sellerProfile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'SellerProfile'
                        }, {
                            children: [{
                                fieldName: 'urlLabel',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'sellerPreferences',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'SellerPreferences'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userIds',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            children: [].concat.apply([], [{
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }, Relay.QL.__frag(RQL_0)]),
                            fieldName: 'favoritesByUser',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id',
                                isPlural: true
                            },
                            type: 'Favorite'
                        }, {
                            fieldName: 'isSuspended',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, Relay.QL.__frag(RQL_1), Relay.QL.__frag(RQL_2), Relay.QL.__frag(RQL_3)]),
                        fieldName: 'seller',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Seller'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isRequisite: true
                            },
                            type: 'ID'
                        }, {
                            children: [{
                                children: [{
                                    fieldName: 'value',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }],
                                fieldName: 'customizable',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isPlural: true
                                },
                                type: 'AttributeValue'
                            }],
                            fieldName: 'attributes',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'ItemAttributes'
                        }, {
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            fieldName: 'title',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'vertical',
                            kind: 'Field',
                            metadata: {},
                            type: 'VerticalType'
                        }, {
                            fieldName: 'dibsReference',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            children: [{
                                fieldName: 'negotiable',
                                kind: 'Field',
                                metadata: {},
                                type: 'YesNo'
                            }],
                            fieldName: 'pricing',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'ItemPricing'
                        }, {
                            children: [{
                                children: [{
                                    fieldName: 'amount',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'Float'
                                }],
                                fieldName: 'totalAmount',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true
                                },
                                type: 'FinancialAmount'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'shipmentQuotes',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id',
                                isPlural: true
                            },
                            type: 'ShipmentQuote'
                        }, {
                            fieldName: 'isPriceUponRequest',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isDeleted',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isOnHold',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isSold',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isNotListed',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'canMakePurchase',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'buyerId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            fieldName: 'canBuyerMakeOffer',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'hasPreQuotedShipping',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'buyerId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            fieldName: 'hasRequestedHoldForBuyer',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            children: [{
                                fieldName: 'accept',
                                kind: 'Field',
                                metadata: {},
                                type: 'YesNo'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'returnPolicy',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'ReturnPolicy'
                        }, Relay.QL.__frag(RQL_4), Relay.QL.__frag(RQL_5)]),
                        fieldName: 'item',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Item'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'userId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }],
                        children: [].concat.apply([], [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            children: [{
                                fieldName: 'currency',
                                kind: 'Field',
                                metadata: {},
                                type: 'Currency'
                            }, {
                                calls: [{
                                    kind: 'Call',
                                    metadata: {},
                                    name: 'preventEmailFallback',
                                    value: {
                                        kind: 'CallValue',
                                        callValue: true
                                    }
                                }],
                                fieldName: 'displayName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'firstName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'lastName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'email',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'profile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'Profile'
                        }, {
                            alias: 'canUseNetPrice',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'name',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'B_NET_PRICE'
                                }
                            }],
                            fieldName: 'hasPermission',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            children: [{
                                children: [{
                                    fieldName: 'company',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }, {
                                    fieldName: 'id',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'ID'
                                }],
                                fieldName: 'proAddress',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    inferredRootCallName: 'node',
                                    inferredPrimaryKey: 'id'
                                },
                                type: 'Address'
                            }],
                            fieldName: 'addressBook',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'AddressBook'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, Relay.QL.__frag(RQL_6), Relay.QL.__frag(RQL_7)]),
                        fieldName: 'user',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'User'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'first',
                            value: {
                                kind: 'CallValue',
                                callValue: 1
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'sort',
                            value: {
                                kind: 'CallValue',
                                callValue: 'createdDate desc'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'buyerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }],
                        children: [{
                            children: [{
                                children: [{
                                    fieldName: 'isCanceled',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'Boolean'
                                }, {
                                    fieldName: 'serviceId',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'ID'
                                }, {
                                    children: [{
                                        fieldName: 'status',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        fieldName: 'id',
                                        kind: 'Field',
                                        metadata: {
                                            isGenerated: true,
                                            isRequisite: true
                                        },
                                        type: 'ID'
                                    }],
                                    fieldName: 'mostRecentOffer',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true,
                                        inferredRootCallName: 'node',
                                        inferredPrimaryKey: 'id'
                                    },
                                    type: 'Offer'
                                }, {
                                    fieldName: 'id',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'ID'
                                }],
                                fieldName: 'node',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    inferredRootCallName: 'node',
                                    inferredPrimaryKey: 'id',
                                    isRequisite: true
                                },
                                type: 'Transaction'
                            }, {
                                fieldName: 'cursor',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'String'
                            }],
                            fieldName: 'edges',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'TransactionEdge'
                        }, {
                            children: [{
                                fieldName: 'hasNextPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }, {
                                fieldName: 'hasPreviousPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }],
                            fieldName: 'pageInfo',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'PageInfo'
                        }],
                        fieldName: 'transactions',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            isConnection: true
                        },
                        type: 'TransactionConnection'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'buyerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        fieldName: 'buyerRequestedItemNetPrice',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'buyerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        children: [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'buyerItemConversation',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Conversation'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Relay_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(FavoriteDealerMutation.getFragment('favorite'), ContactDealerMutation.getFragment('seller'), HoldRequestMutation.getFragment('seller'), FavoriteDealerMutation.getFragment('seller'), ContactDealerMutation.getFragment('item'), HoldRequestMutation.getFragment('item'), ContactDealerMutation.getFragment('user'), HoldRequestMutation.getFragment('user'));
        }
    }
};

module.exports = function (Component) {
    return hoistStatics(compose(createRelayContainer(query), flattenProp('viewer'), withProps(function (_ref) {
        var user = _ref.user,
            item = _ref.item,
            buyerRequestedItemNetPrice = _ref.buyerRequestedItemNetPrice,
            buyerItemConversation = _ref.buyerItemConversation,
            transactions = _ref.transactions;
        return {
            isUserNameSet: !!get(user, 'profile.firstName'),
            isShowHoldRequest: shouldModalShowHoldRequestInput(item, user),
            redirectToMessageCenter: buyerRequestedItemNetPrice && buyerItemConversation,
            transaction: get(transactions, 'edges[0].node'),
            buyerItemConversation: buyerItemConversation
        };
    })))(Component);
};

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var get = __webpack_require__(1);

var _require = __webpack_require__(37),
    recordAppInstallView = _require.recordAppInstallView;

var trackingHelpers = __webpack_require__(2);

var css = __webpack_require__(16);

var copy = __webpack_require__(7);

var appInstallHref = 'https://itunes.apple.com/us/app/1stdibs/id938157117';

var AppInstallPrompt = function (_Component) {
    _inherits(AppInstallPrompt, _Component);

    function AppInstallPrompt(props) {
        _classCallCheck(this, AppInstallPrompt);

        var _this = _possibleConstructorReturn(this, (AppInstallPrompt.__proto__ || Object.getPrototypeOf(AppInstallPrompt)).call(this, props));

        _this.handleAppInstallClick = _this.handleAppInstallClick.bind(_this);
        return _this;
    }

    _createClass(AppInstallPrompt, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            recordAppInstallView();
        }
    }, {
        key: 'handleAppInstallClick',
        value: function handleAppInstallClick() {
            this.props.closeModal();
            trackingHelpers.appInstallClicked();
            window.location.href = appInstallHref;
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement(
                'div',
                { className: css.secondaryContainer },
                React.createElement(
                    'div',
                    { className: css.secondaryHeader },
                    get(copy, 'appInstallHeader')
                ),
                React.createElement(
                    'div',
                    { className: css.description },
                    get(copy, 'appInstallDescription')
                ),
                React.createElement(
                    'div',
                    { className: css.primaryCta, onClick: this.handleAppInstallClick },
                    get(copy, 'appInstallCta')
                )
            );
        }
    }]);

    return AppInstallPrompt;
}(Component);

AppInstallPrompt.propTypes = {
    closeModal: PropTypes.func.isRequired,
    seller: PropTypes.shape({
        favoritesByUser: PropTypes.array,
        sellerProfile: PropTypes.shape({
            company: PropTypes.string,
            type: PropTypes.string
        })
    }).isRequired
};

module.exports = AppInstallPrompt;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var get = __webpack_require__(1);
var tokenReplace = __webpack_require__(5);

var trackingHelpers = __webpack_require__(2);

var css = __webpack_require__(16);

var copy = __webpack_require__(7);

var FavoriteDealerPrompt = function (_Component) {
    _inherits(FavoriteDealerPrompt, _Component);

    function FavoriteDealerPrompt(props) {
        _classCallCheck(this, FavoriteDealerPrompt);

        var _this = _possibleConstructorReturn(this, (FavoriteDealerPrompt.__proto__ || Object.getPrototypeOf(FavoriteDealerPrompt)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        _this.subtext = _this.subtext.bind(_this);
        return _this;
    }

    _createClass(FavoriteDealerPrompt, [{
        key: 'handleClick',
        value: function handleClick() {
            this.props.closeModal();
            this.props.favoriteDealer(this.props);
            trackingHelpers.favoriteDealerClicked();
        }
    }, {
        key: 'subtext',
        value: function subtext() {
            var subtextTemplate = get(copy, 'followDealerInstructions');
            var dealerType = get(this.props.seller, 'sellerProfile.type') || 'dealer';
            return tokenReplace(subtextTemplate, { dealerType: dealerType });
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement(
                'div',
                { className: css.secondaryContainer },
                React.createElement(
                    'div',
                    { className: css.secondaryHeader },
                    get(copy, 'followDealerHeader')
                ),
                React.createElement(
                    'div',
                    { className: css.description },
                    this.subtext()
                ),
                React.createElement(
                    'div',
                    { className: css.primaryCta, onClick: this.handleClick },
                    get(copy, 'followDealerCta')
                )
            );
        }
    }]);

    return FavoriteDealerPrompt;
}(Component);

FavoriteDealerPrompt.propTypes = {
    closeModal: PropTypes.func.isRequired,
    favoriteDealer: PropTypes.func.isRequired,
    seller: PropTypes.shape({
        favoritesByUser: PropTypes.array,
        sellerProfile: PropTypes.shape({
            company: PropTypes.string,
            type: PropTypes.string
        })
    })
};

module.exports = FavoriteDealerPrompt;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var get = __webpack_require__(1);

var trackingHelpers = __webpack_require__(2);

var css = __webpack_require__(16);

var copy = __webpack_require__(7);

var HoldRequestPrompt = function (_Component) {
    _inherits(HoldRequestPrompt, _Component);

    function HoldRequestPrompt(props) {
        _classCallCheck(this, HoldRequestPrompt);

        var _this = _possibleConstructorReturn(this, (HoldRequestPrompt.__proto__ || Object.getPrototypeOf(HoldRequestPrompt)).call(this, props));

        _this.goToHoldRequestModal = _this.goToHoldRequestModal.bind(_this);
        return _this;
    }

    _createClass(HoldRequestPrompt, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            trackingHelpers.holdRequestSecondaryMessageShown();
        }
    }, {
        key: 'goToHoldRequestModal',
        value: function goToHoldRequestModal() {
            this.props.goToStep({
                step: 'contactDealer',
                modalContentData: {
                    isShowHoldRequest: false,
                    isHoldRequestChecked: true,
                    copySuffix: 'placeOnHold'
                }
            });
            this.props.holdFromConfirmationModal();
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement(
                'div',
                { className: css.secondaryContainer },
                React.createElement(
                    'div',
                    { className: css.secondaryHeader },
                    get(copy, 'placeHoldRequestPrompt')
                ),
                React.createElement(
                    'div',
                    { className: css.description },
                    get(copy, 'placeHoldDescription')
                ),
                React.createElement(
                    'div',
                    { className: css.primaryCta, onClick: this.goToHoldRequestModal },
                    get(copy, 'placeHoldCta')
                )
            );
        }
    }]);

    return HoldRequestPrompt;
}(Component);

HoldRequestPrompt.propTypes = {
    goToStep: PropTypes.func.isRequired,
    holdFromConfirmationModal: PropTypes.func.isRequired
};

module.exports = HoldRequestPrompt;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var OfferRow = __webpack_require__(55);
var css = __webpack_require__(40);

function LowBallOfferField(_ref) {
    var offerValue = _ref.offerValue,
        error = _ref.error,
        currencySymbol = _ref.currencySymbol,
        labelSubtext = _ref.labelSubtext,
        onOfferChange = _ref.onOfferChange,
        isPricePerPiece = _ref.isPricePerPiece,
        copy = _ref.copy;

    return React.createElement(
        'div',
        { className: css.lowballOfferField },
        React.createElement(OfferRow, {
            className: css.lowballOfferInput
            // disable OfferRow's quantity dropdown
            , isPricePerPiece: false,
            field: 'offer',
            value: offerValue,
            error: error,
            currencySymbol: currencySymbol,
            onFieldChanged: onOfferChange
            // displayPrice prop is used as placeholder prop
            , displayPrice: isPricePerPiece ? copy.get('per item') : undefined
        }),
        React.createElement(
            'span',
            { className: css.lowballOptionSubtext },
            labelSubtext
        )
    );
}

LowBallOfferField.propTypes = {
    offerValue: PropTypes.string,
    error: PropTypes.string,
    currencySymbol: PropTypes.string,
    labelSubtext: PropTypes.string,
    onOfferChange: PropTypes.func,
    isPricePerPiece: PropTypes.bool,
    copy: PropTypes.shape({ get: PropTypes.func })
};

module.exports = LowBallOfferField;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var LowBallOfferField = __webpack_require__(109);
var intelligentFormat = __webpack_require__(31);
var classNames = __webpack_require__(19);
var css = __webpack_require__(40);
var formCss = __webpack_require__(6);

function LowBallOption(props) {
    var name = props.name,
        value = props.value,
        currency = props.currency,
        label = props.label,
        labelSubtext = props.labelSubtext,
        checked = props.checked,
        isOther = props.isOther,
        onChange = props.onChange;

    var displayLabel = label || intelligentFormat(value, currency);
    var inputId = name + '-' + value;
    var labelClasses = classNames(formCss['form-radio-wrapper'], css.lowballOptionLabel);
    var titleClasses = classNames(css.lowballOption, formCss['form-radio-input']);

    var subcomponent = void 0;
    if (checked && isOther) {
        subcomponent = React.createElement(LowBallOfferField, props);
    } else {
        subcomponent = React.createElement(
            'div',
            { className: css.lowballOptionSubtext },
            labelSubtext
        );
    }

    return React.createElement(
        'label',
        {
            htmlFor: inputId,
            className: labelClasses
        },
        React.createElement('input', {
            type: 'radio',
            id: inputId,
            name: name,
            value: value,
            checked: checked,
            onChange: onChange
        }),
        React.createElement(
            'div',
            { className: titleClasses },
            React.createElement(
                'div',
                { className: css.lowballOptionContent },
                React.createElement(
                    'div',
                    { className: css.lowballOptionText },
                    displayLabel
                ),
                subcomponent
            )
        )
    );
}

LowBallOption.propTypes = {
    checked: PropTypes.bool,
    copy: PropTypes.shape({ get: PropTypes.func }),
    currency: PropTypes.string,
    currencySymbol: PropTypes.string,
    error: PropTypes.string,
    isOther: PropTypes.bool,
    isPricePerPiece: PropTypes.bool,
    label: PropTypes.string,
    labelSubtext: PropTypes.string,
    name: PropTypes.string,
    offerValue: PropTypes.string,
    onChange: PropTypes.func,
    onOfferChange: PropTypes.func,
    value: PropTypes.string.isRequired
};

module.exports = LowBallOption;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = React.PropTypes,
    Component = React.Component;

var PRICE_TYPES = __webpack_require__(30);
var InputWrapper = __webpack_require__(18);
var QuantityField = __webpack_require__(56);
var LowBallOption = __webpack_require__(110);
var tokenReplace = __webpack_require__(5);
var intelligentFormat = __webpack_require__(31);
var css = __webpack_require__(40);

var LowBallOptionList = function (_Component) {
    _inherits(LowBallOptionList, _Component);

    function LowBallOptionList(props) {
        _classCallCheck(this, LowBallOptionList);

        var _this = _possibleConstructorReturn(this, (LowBallOptionList.__proto__ || Object.getPrototypeOf(LowBallOptionList)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }

    _createClass(LowBallOptionList, [{
        key: 'onChange',
        value: function onChange(e) {
            var setLowBallOption = this.props.setLowBallOption;


            setLowBallOption({
                field: 'offer',
                value: e.target.value
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var name = 'lowball-option-list';
            var _props = this.props,
                copy = _props.copy,
                currency = _props.currency,
                currencySymbol = _props.currencySymbol,
                errors = _props.errors,
                isPricePerPiece = _props.isPricePerPiece,
                offerValue = _props.offerValue,
                onOfferChange = _props.onOfferChange,
                onQuantityChange = _props.onQuantityChange,
                options = _props.options,
                pieces = _props.pieces,
                priceType = _props.priceType,
                priceValue = _props.priceValue,
                quantityValue = _props.quantityValue;

            var type = void 0;
            if (priceType === PRICE_TYPES.TYPE_NET) {
                type = copy.get('net');
            } else if (priceType === PRICE_TYPES.TYPE_SALE) {
                type = copy.get('sale');
            } else {
                type = copy.get('list');
            }

            var optionComponents = Object.keys(options).map(function (key) {
                var option = options[key];
                if (['selectedLowBallOption', 'isPreAuthOfferLowball'].indexOf(key) < 0) {
                    return React.createElement(LowBallOption, _extends({}, option, {
                        key: key,
                        error: errors.offer,
                        name: name,
                        currency: currency,
                        currencySymbol: currencySymbol,
                        offerValue: offerValue,
                        onChange: _this2.onChange,
                        onOfferChange: onOfferChange,
                        isPricePerPiece: isPricePerPiece,
                        copy: copy
                    }));
                }
                return false;
            });

            var lowBallLabelPrice = intelligentFormat(priceValue, currency);
            if (isPricePerPiece) {
                lowBallLabelPrice = '' + lowBallLabelPrice + copy.get('perItemSuffix');
            }
            return React.createElement(
                'div',
                null,
                React.createElement(
                    'div',
                    { className: css.lowballHeader },
                    React.createElement(
                        'span',
                        { className: css.lowballHeaderWarning },
                        copy.get('lowBallLabelHeading')
                    ),
                    tokenReplace(copy.get('lowBallLabel'), {
                        price: lowBallLabelPrice,
                        type: type
                    })
                ),
                React.createElement(
                    InputWrapper,
                    null,
                    optionComponents
                ),
                React.createElement(QuantityField, {
                    onOfferChange: onQuantityChange,
                    quantityValue: quantityValue,
                    isPricePerPiece: isPricePerPiece,
                    pieces: pieces,
                    copy: copy
                })
            );
        }
    }]);

    return LowBallOptionList;
}(Component);

LowBallOptionList.propTypes = {
    copy: PropTypes.shape({ get: PropTypes.func.isRequired }),
    currency: PropTypes.string,
    currencySymbol: PropTypes.string,
    errors: PropTypes.object,
    isPricePerPiece: PropTypes.bool,
    offerValue: PropTypes.string,
    onOfferChange: PropTypes.func,
    onQuantityChange: PropTypes.func,
    options: PropTypes.shape({
        checked: PropTypes.bool,
        isOther: PropTypes.bool,
        value: PropTypes.string,
        label: PropTypes.string,
        labelSubtext: PropTypes.string
    }),
    pieces: PropTypes.number,
    priceType: PropTypes.string,
    priceValue: PropTypes.number,
    quantityValue: PropTypes.string,
    setLowBallOption: PropTypes.func
};

module.exports = LowBallOptionList;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var get = __webpack_require__(1);
var tokenReplace = __webpack_require__(5);

var trackingHelpers = __webpack_require__(2);

var css = __webpack_require__(16);

var copy = __webpack_require__(7);

var MakeOfferPrompt = function (_Component) {
    _inherits(MakeOfferPrompt, _Component);

    function MakeOfferPrompt(props) {
        _classCallCheck(this, MakeOfferPrompt);

        var _this = _possibleConstructorReturn(this, (MakeOfferPrompt.__proto__ || Object.getPrototypeOf(MakeOfferPrompt)).call(this, props));

        _this.goToMakeOffer = _this.goToMakeOffer = _this.goToMakeOffer.bind(_this);
        return _this;
    }

    _createClass(MakeOfferPrompt, [{
        key: 'goToMakeOffer',
        value: function goToMakeOffer() {
            var _props = this.props,
                goToStep = _props.goToStep,
                item = _props.item,
                priceType = _props.priceType,
                seller = _props.seller,
                trackingParams = _props.trackingParams;

            trackingHelpers.makeOfferSecondaryCtaClicked();
            trackingHelpers.eventOfferEnable(_extends({}, trackingParams, {
                item: item,
                priceType: priceType,
                seller: seller
            }));
            goToStep({ step: 'makeOffer' });
        }
    }, {
        key: 'render',
        value: function render() {
            var dealerName = get(this.props.seller, 'sellerProfile.company');
            var descriptionTemplate = get(copy, 'makeOfferDescription');
            var description = tokenReplace(descriptionTemplate, { dealerName: dealerName });

            return React.createElement(
                'div',
                { className: css.secondaryContainer },
                React.createElement(
                    'div',
                    { className: css.secondaryHeader },
                    get(copy, 'makeOfferPrompt')
                ),
                React.createElement(
                    'div',
                    { className: css.description },
                    description
                ),
                React.createElement(
                    'div',
                    { className: css.primaryCta, onClick: this.goToMakeOffer },
                    get(copy, 'makeOfferCta')
                )
            );
        }
    }]);

    return MakeOfferPrompt;
}(Component);

MakeOfferPrompt.propTypes = {
    goToStep: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
    priceType: PropTypes.string,
    seller: PropTypes.shape({
        sellerProfile: PropTypes.shape({
            company: PropTypes.string
        })
    }),
    trackingParams: PropTypes.shape({
        isItem: PropTypes.bool,
        item: PropTypes.object,
        linkLocation: PropTypes.string,
        purchaseStatus: PropTypes.string,
        vpvParams: PropTypes.object,
        vpvParamsQuery: PropTypes.string
    })
};

module.exports = MakeOfferPrompt;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var css = __webpack_require__(41);
var componentCss = __webpack_require__(136);
var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var CursorInput = __webpack_require__(49);

function OfferInput(_ref) {
    var field = _ref.field,
        value = _ref.value,
        currencySymbol = _ref.currencySymbol,
        displayPrice = _ref.displayPrice,
        onFieldChanged = _ref.onFieldChanged;

    return React.createElement(
        'div',
        { className: css.inputWrapper },
        React.createElement(
            'span',
            { className: css.currency, 'data-tn': 'offer-input-currency' },
            currencySymbol
        ),
        React.createElement(CursorInput, { autoFocus: true,
            className: componentCss.input,
            value: value,
            onChange: function onChange(e) {
                return onFieldChanged({
                    field: field,
                    value: e.target.value.replace(/[^\d\.,]+/g, '')
                });
            },
            type: 'text',
            placeholder: displayPrice,
            'data-tn': 'offer-input'
        })
    );
};

OfferInput.propTypes = {
    value: PropTypes.string,
    field: PropTypes.string.isRequired,
    currencySymbol: PropTypes.string,
    displayPrice: PropTypes.string,
    onFieldChanged: PropTypes.func.isRequired,
    isOfferFocus: PropTypes.bool
};

module.exports = OfferInput;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component,
    PropTypes = React.PropTypes;

var get = __webpack_require__(1);

var _require = __webpack_require__(37),
    persistNotTradeAnswer = _require.persistNotTradeAnswer;

var trackingHelpers = __webpack_require__(2);

var css = __webpack_require__(16);

var copy = __webpack_require__(7);

var tradeStatuses = {
    rejected: 'APPLIED_REJECTED'
};

var TradePrompt = function (_Component) {
    _inherits(TradePrompt, _Component);

    function TradePrompt(props) {
        _classCallCheck(this, TradePrompt);

        var _this = _possibleConstructorReturn(this, (TradePrompt.__proto__ || Object.getPrototypeOf(TradePrompt)).call(this, props));

        _this.goToTradeApplication = _this.goToTradeApplication.bind(_this);
        _this.handleNotTradeClick = _this.handleNotTradeClick.bind(_this);
        return _this;
    }

    _createClass(TradePrompt, [{
        key: 'goToTradeApplication',
        value: function goToTradeApplication() {
            trackingHelpers.tradeApplicationLinkClicked();
            window.location.href = '/trade/apply/';
        }
    }, {
        key: 'handleNotTradeClick',
        value: function handleNotTradeClick() {
            var _props = this.props,
                closeModal = _props.closeModal,
                relay = _props.relay,
                updateTradeStatus = _props.updateTradeStatus,
                user = _props.user;

            closeModal();
            persistNotTradeAnswer();
            updateTradeStatus(user, tradeStatuses.rejected, relay);
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement(
                'div',
                { className: css.secondaryContainer },
                React.createElement(
                    'div',
                    { className: css.secondaryHeader },
                    get(copy, 'tradePrompt')
                ),
                React.createElement(
                    'div',
                    { className: css.description },
                    get(copy, 'tradeDescription')
                ),
                React.createElement(
                    'div',
                    { className: css.primaryCta, onClick: this.goToTradeApplication },
                    get(copy, 'tradeCta')
                ),
                React.createElement(
                    'div',
                    null,
                    React.createElement(
                        'a',
                        { className: css.secondaryCta, onClick: this.handleNotTradeClick },
                        get(copy, 'tradeSecondaryCta')
                    )
                )
            );
        }
    }]);

    return TradePrompt;
}(Component);

TradePrompt.propTypes = {
    closeModal: PropTypes.func.isRequired,
    relay: PropTypes.object,
    updateTradeStatus: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired
};

module.exports = TradePrompt;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var get = __webpack_require__(1);
var PropTypes = React.PropTypes;


function ViewInvoiceLink(_ref) {
    var viewer = _ref.viewer,
        onClick = _ref.onClick,
        children = _ref.children,
        className = _ref.className;

    var itemId = get(viewer, 'item.serviceId');
    if (!get(viewer, 'user.canSeeInvoice') || get(viewer, 'preInvoiceTransactions.totalResults')) {
        return null;
    }
    return React.createElement(
        'a',
        {
            href: '/my/orders/invoice/id-' + itemId + '/',
            target: '_blank',
            className: className,
            onClick: onClick
        },
        children
    );
};

ViewInvoiceLink.defaultProps = {
    onClick: function onClick() {}
};

ViewInvoiceLink.propTypes = {
    viewer: PropTypes.object,
    onClick: PropTypes.func,
    children: PropTypes.node,
    className: PropTypes.string
};

module.exports = ViewInvoiceLink;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var React = __webpack_require__(0);
var PropTypes = React.PropTypes;

var get = __webpack_require__(1);
var css = __webpack_require__(64);
// TODO: if this variant becomes canon, rename copy keys to be more descriptive

var suggestedTopics = ["History", "Dimensions", "Condition", "Shipping", "Customization", "Special Requests"];

function ModalSidebar(_ref) {
    var item = _ref.item,
        copy = _ref.copy;

    return React.createElement(
        'div',
        { className: css.sidebarWrapper },
        React.createElement('img', { src: get(item, 'firstPhotoWebPath') }),
        React.createElement(
            'div',
            { className: css.desktopPromptList },
            React.createElement(
                'p',
                { className: css.prompt },
                copy.get('modalSidebarDesktopPrompt')
            ),
            React.createElement(
                'ul',
                null,
                suggestedTopics.map(function (c) {
                    return React.createElement(
                        'li',
                        null,
                        c
                    );
                })
            )
        ),
        React.createElement(
            'div',
            { className: css.mobilePrompt },
            copy.get('modalSidebarMobilePrompt')
        )
    );
}

ModalSidebar.propTypes = {
    item: PropTypes.object.isRequired,
    copy: PropTypes.object
};

module.exports = ModalSidebar;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Checkmark = __webpack_require__(153);
var classnames = __webpack_require__(19);
var copy = __webpack_require__(145);
var style = __webpack_require__(126);
var Component = React.Component,
    PropTypes = React.PropTypes;

var OfferGuarantee = function (_Component) {
    _inherits(OfferGuarantee, _Component);

    function OfferGuarantee(props) {
        _classCallCheck(this, OfferGuarantee);

        var _this = _possibleConstructorReturn(this, (OfferGuarantee.__proto__ || Object.getPrototypeOf(OfferGuarantee)).call(this, props));

        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    _createClass(OfferGuarantee, [{
        key: 'onClick',
        value: function onClick() {
            var checked = this.props.checked;

            this.props.onChange(!checked);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                checked = _props.checked,
                onChange = _props.onChange;

            var checkboxClassName = classnames(style.checkbox, _defineProperty({}, style.checked, checked));

            return React.createElement(
                'div',
                { className: style.container },
                React.createElement(
                    'div',
                    { className: checkboxClassName, onClick: this.onClick },
                    checked && React.createElement(Checkmark, { className: style.icon })
                ),
                React.createElement(
                    'label',
                    { className: style.label, onClick: this.onClick },
                    copy.label
                ),
                React.createElement(
                    'p',
                    { className: style.description },
                    copy.description
                )
            );
        }
    }]);

    return OfferGuarantee;
}(Component);

OfferGuarantee.propTypes = {
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired
};

module.exports = OfferGuarantee;

/***/ },
/* 118 */
/***/ function(module, exports) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var userAgentContains = exports.userAgentContains = function userAgentContains() {
    for (var _len = arguments.length, substrings = Array(_len), _key = 0; _key < _len; _key++) {
        substrings[_key] = arguments[_key];
    }

    return function () {
        try {
            var userAgentLowerCase = navigator.userAgent.toLowerCase();
            for (var i = 0; i < substrings.length; i++) {
                var subStr = substrings[i];
                if (userAgentLowerCase.indexOf(subStr.toLowerCase()) > -1) {
                    return true;
                }
            }
            return false;
        } catch (e) {
            console.warn('User agent check on string caused error:', e, 'substings: ' + substrings);
            return false;
        }
    };
};

var isAppleMobileDevice = exports.isAppleMobileDevice = userAgentContains('iphone', 'ipad');

/***/ },
/* 119 */
/***/ function(module, exports) {

"use strict";
'use strict';

function isTestVariant(optimizelyVariant) {
    return !!['makeOfferCheckbox', 'makeOfferCheckbox-checked'].find(function (variant) {
        return variant === optimizelyVariant;
    });
}

function isCheckboxChecked(optimizelyVariant) {
    return optimizelyVariant === 'makeOfferCheckbox-checked';
}

module.exports = {
    isTestVariant: isTestVariant,
    isCheckboxChecked: isCheckboxChecked
};

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var get = __webpack_require__(1);
var qs = __webpack_require__(33);
var contactModalTracking = __webpack_require__(2);

module.exports = function (options) {
    var chatSuccessTag = options.chatSuccessTag,
        chatTracking = options.chatTracking,
        currency = options.currency,
        isContactDealer = options.isContactDealer,
        item = options.item,
        seller = options.seller,
        lowBallOptions = options.lowBallOptions,
        messageValue = options.messageValue,
        nameValue = options.nameValue,
        offerValue = options.offerValue,
        priceValue = options.priceValue,
        quantityValue = options.quantityValue,
        user = options.user;

    var trackingOptions = {
        offerAmount: offerValue,
        priceValue: priceValue,
        selectedLowballOption: lowBallOptions[lowBallOptions.selectedLowballOption]
    };
    if (isContactDealer) {
        trackingOptions.value = 1;
    }
    var trackChatEvent = chatTracking ? chatTracking[chatSuccessTag] : false;
    if (trackChatEvent) {
        trackChatEvent();
    }
    contactModalTracking.eventOfferSuccessWithLowballOptions(trackingOptions);

    var params = qs.stringify({
        chkIncludeOffer: true,
        message: messageValue,
        offerAmount: offerValue,
        offerCurrency: get(user, 'profile.currency') || currency,
        name: nameValue,
        quantity: quantityValue,
        sellerId: get(seller, 'serviceId')
    });

    window.location.href = '/checkout/id-' + get(item, 'serviceId') + '?' + params;
};

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Relay = __webpack_require__(4);
var get = __webpack_require__(1);
var pick = __webpack_require__(32);

var MakePreAuthOfferMutation = function (_Relay$Mutation) {
    _inherits(MakePreAuthOfferMutation, _Relay$Mutation);

    function MakePreAuthOfferMutation() {
        _classCallCheck(this, MakePreAuthOfferMutation);

        return _possibleConstructorReturn(this, (MakePreAuthOfferMutation.__proto__ || Object.getPrototypeOf(MakePreAuthOfferMutation)).apply(this, arguments));
    }

    _createClass(MakePreAuthOfferMutation, [{
        key: 'getMutation',
        value: function getMutation() {
            return function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'transactionCreatePrivateOffer',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'TransactionCreatePrivateOfferInput!'
                    },
                    name: 'MakePreAuthOfferMutation',
                    responseType: 'TransactionCreatePrivateOfferPayload'
                };
            }();
        }
    }, {
        key: 'getVariables',
        value: function getVariables() {
            return Object.assign({}, pick(this.props, ['buyerId', 'itemId', 'offerAmountPerItem', 'offerCurrency', 'messageContent', 'quantity']), { isBuyerInquiry: true });
        }
    }, {
        key: 'getFatQuery',
        value: function getFatQuery() {
            return function () {
                return {
                    children: [{
                        children: [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'conversation',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Conversation'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'MakePreAuthOfferMutationRelayQL',
                    type: 'TransactionCreatePrivateOfferPayload'
                };
            }();
        }
    }, {
        key: 'getConfigs',
        value: function getConfigs() {
            return [{
                type: 'FIELDS_CHANGE',
                fieldIDs: {
                    conversation: get(this.props, 'conversation.id')
                }
            }];
        }
    }]);

    return MakePreAuthOfferMutation;
}(Relay.Mutation);

module.exports = MakePreAuthOfferMutation;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _require = __webpack_require__(63),
    getFailsMaxLengthFunc = _require.getFailsMaxLengthFunc,
    getMaxLengthError = _require.getMaxLengthError,
    getMatchesRegexFunc = _require.getMatchesRegexFunc,
    getFailsRequiredFunc = _require.getFailsRequiredFunc,
    sharedRegex = _require.sharedRegex;

var validEmail = sharedRegex.validEmail,
    specialChars = sharedRegex.specialChars;

var copy = __webpack_require__(66);

var MAX_EMAIL_LENGTH = 256;
var MAX_NAME_LENGTH = 50;
var MAX_MESSAGE_LENGTH = 5000;

module.exports = function (_ref) {
    var validationPayload = _ref.validationPayload,
        _ref$options = _ref.options,
        options = _ref$options === undefined ? {} : _ref$options;

    var checkIsEmailTooLong = getFailsMaxLengthFunc(MAX_EMAIL_LENGTH);
    var checkIsNameTooLong = getFailsMaxLengthFunc(MAX_NAME_LENGTH);
    var checkIsMessageTooLong = getFailsMaxLengthFunc(MAX_MESSAGE_LENGTH);

    var checkIsMissing = getFailsRequiredFunc();

    var checkIsEmailAddressValid = getMatchesRegexFunc(validEmail);
    var checkHasSpecialChars = getMatchesRegexFunc(specialChars);

    var emailInput = validationPayload.email,
        nameInput = validationPayload.name,
        messageInput = validationPayload.message;

    var errors = {};

    if (!options.fields || options.fields.indexOf('email') >= 0) {
        if (checkIsMissing(emailInput)) {
            errors.email = copy.isRequired;
        } else if (checkIsEmailTooLong(emailInput)) {
            errors.email = getMaxLengthError(MAX_EMAIL_LENGTH);
        } else if (!checkIsEmailAddressValid(emailInput)) {
            errors.email = copy.invalidEmail;
        }
    }

    if (!options.fields || options.fields.indexOf('name') >= 0) {
        if (checkIsMissing(nameInput)) {
            errors.name = copy.isRequired;
        } else if (checkIsNameTooLong(nameInput)) {
            errors.name = getMaxLengthError(MAX_NAME_LENGTH);
        } else if (checkHasSpecialChars(nameInput)) {
            errors.name = copy.specialChars;
        }
    }

    if (!options.fields || options.fields.indexOf('message') >= 0) {
        if (checkIsMissing(messageInput)) {
            errors.message = copy.isRequired;
        } else if (checkIsMessageTooLong(messageInput)) {
            errors.message = getMaxLengthError(MAX_MESSAGE_LENGTH);
        }
    }

    return errors;
};

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var tokenReplace = __webpack_require__(5);
var copy = __webpack_require__(66);

var _require = __webpack_require__(63),
    getFailsRequiredFunc = _require.getFailsRequiredFunc;

var lowBallCoeff = 0.6;

module.exports = function (_ref) {
    var validationPayload = _ref.validationPayload,
        _ref$options = _ref.options,
        options = _ref$options === undefined ? {} : _ref$options;
    var offer = validationPayload.offer,
        relevantItemPrice = validationPayload.relevantItemPrice;

    var parsedOffer = parseInt(offer, 10);

    if (!relevantItemPrice) {
        throw new Error('You must supply a relevant item price against which to validate the offer!');
    }

    var checkIsOfferMissing = getFailsRequiredFunc();
    var errors = {};

    if (checkIsOfferMissing(offer)) {
        errors.offer = copy.isRequired;
    } else if (parsedOffer < 1) {
        errors.offer = copy.positiveNumber;
    } else if (parsedOffer >= relevantItemPrice) {
        errors.offer = copy.underListPrice;
    } else if (!options.bypassLowball && parsedOffer < relevantItemPrice * lowBallCoeff) {
        errors.offer = tokenReplace(copy.lowBallErrorLabel, { threshold: lowBallCoeff * 100 + '%' });
        errors.lowBall = true;
    }

    return errors;
};

/***/ },
/* 124 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"src-scss-abTests-abandon-make-offer-modal---container---2WVpC","description":"src-scss-abTests-abandon-make-offer-modal---description---3vYw7","cta":"src-scss-abTests-abandon-make-offer-modal---cta---eSbov"};

/***/ },
/* 125 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"guidedPromptsContainer":"src-scss-abTests-guided-copy---guidedPromptsContainer---3x5ig","guidedOptionWrapper":"src-scss-abTests-guided-copy---guidedOptionWrapper---TxDjW","guidedCopySubtitle":"src-scss-abTests-guided-copy---guidedCopySubtitle---1ZSY8"};

/***/ },
/* 126 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"src-scss-abTests-offer-guarantee---container---2RARx","checkbox":"src-scss-abTests-offer-guarantee---checkbox---31bNQ","checked":"src-scss-abTests-offer-guarantee---checked---115HW","icon":"src-scss-abTests-offer-guarantee---icon---ec8pr","label":"src-scss-abTests-offer-guarantee---label---24k83","description":"src-scss-abTests-offer-guarantee---description---1CjBg"};

/***/ },
/* 127 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"makeOfferModalLink":"src-scss-contact-dealer---makeOfferModalLink---1NSHL","makeOfferModalLinkCta":"src-scss-contact-dealer---makeOfferModalLinkCta---BIIRr"};

/***/ },
/* 128 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"src-scss-hold-request---container---1JQOj","checkboxLabel":"src-scss-hold-request---checkboxLabel---vsg2a","checkboxLabelChecked":"src-scss-hold-request---checkboxLabelChecked---1_nrg","info":"src-scss-hold-request---info---35Bu2"};

/***/ },
/* 129 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"label":"src-scss-input-wrapper---label---NZlXc","wrapper":"src-scss-input-wrapper---wrapper---jC-S5"};

/***/ },
/* 130 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"input":"src-scss-input---input---2Rzho"};

/***/ },
/* 131 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"textarea":"src-scss-message-field---textarea---KaNYM"};

/***/ },
/* 132 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"input":"src-scss-message---input---2_Kvq","messageWrapper":"src-scss-message---messageWrapper---2W1He","description":"src-scss-message---description---30ySl"};

/***/ },
/* 133 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"headerBackLink":"src-scss-modal-wrapper---headerBackLink---1VUfn","spinnerWrapper":"src-scss-modal-wrapper---spinnerWrapper---2U6vx","centeredSpinner":"src-scss-modal-wrapper---centeredSpinner---vPmw-","serviceError":"src-scss-modal-wrapper---serviceError---lGqde","body":"src-scss-modal-wrapper---body---2UOqc","modalWrapper":"src-scss-modal-wrapper---modalWrapper---1XUOz","headerTitle":"src-scss-modal-wrapper---headerTitle---28d1_"};

/***/ },
/* 134 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"body":"src-scss-modal---body---3YqHm","header":"src-scss-modal---header---2jh5K","successWrapper":"src-scss-modal---successWrapper---1Ou8v","messageWrapper":"src-scss-modal---messageWrapper---1aj_Q","message":"src-scss-modal---message---1c_3w","okButton":"src-scss-modal---okButton---3CoNB","userToUserHeader":"src-scss-modal---userToUserHeader---2S3wj","modalContent":"src-scss-modal---modalContent---2oNZ0"};

/***/ },
/* 135 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"src-scss-net-price---container---3J6rh","recipient":"src-scss-net-price---recipient---1NhTj","message":"src-scss-net-price---message---1Hi-t","info":"src-scss-net-price---info---RydMb","confirmation":"src-scss-net-price---confirmation---3e0uv"};

/***/ },
/* 136 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"input":"src-scss-offer-input---input---2cTA2"};

/***/ },
/* 137 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"src-scss-opt-in---container---3k9TY","checkboxLabel":"src-scss-opt-in---checkboxLabel---3gLmy"};

/***/ },
/* 138 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mainFormContainer":"src-scss-preAuthOffer---mainFormContainer---fZ5-p","preAuthOfferInfo":"src-scss-preAuthOffer---preAuthOfferInfo---2GO6O","preAuthOfferDisplayPrice":"src-scss-preAuthOffer---preAuthOfferDisplayPrice---jTPo9"};

/***/ },
/* 139 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"body":"src-scss-preContactDealer---body---QyAa7","question":"src-scss-preContactDealer---question---3j1sM","button":"src-scss-preContactDealer---button---1sBcb"};

/***/ },
/* 140 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-scss-section-toggle---wrapper---4gZ1P","toggle":"src-scss-section-toggle---toggle---23scp","icon":"src-scss-section-toggle---icon---3jSk4","label":"src-scss-section-toggle---label---3C3My"};

/***/ },
/* 141 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"submit":"src-scss-submit---submit---2LvYQ"};

/***/ },
/* 142 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"message":"src-scss-successGeneric---message---1vqtG","ctaArrow":"src-scss-successGeneric---ctaArrow---2Nyhr","successContainer":"src-scss-successGeneric---successContainer---2yWdJ"};

/***/ },
/* 143 */
/***/ function(module, exports) {

module.exports = {
	"guidedCopyHeader": "Contact {dealer}",
	"guidedCopySubtitle": "What would you like to do?",
	"askAboutShipping": "ASK ABOUT SHIPPING",
	"requestItemDetails": "REQUEST ITEM DETAILS",
	"makeAnOffer": "MAKE AN OFFER",
	"askAQuestion": "ASK A QUESTION",
	"askAboutShippingGhostText": "Let the dealer know your shipping destination and desired delivery date.",
	"requestItemDetailsGhostText": "Ask the dealer about condition, provenance, dimensions, sizing or any other details.",
	"askAQuestionGhostText": "Ask the dealer for details about the piece, shipping options or anything else."
};

/***/ },
/* 144 */
/***/ function(module, exports) {

module.exports = {
	"modalSidebarGhostText": "Send an inquiry to receive a personal response from the dealer.",
	"modalSidebarMobilePrompt": "Contact the dealer to learn more about the history and provenance of the piece or ask any other questions, including shipping details.",
	"modalSidebarDesktopPrompt": "What would you like to know about this piece? You may want to ask about:"
};

/***/ },
/* 145 */
/***/ function(module, exports) {

module.exports = {
	"label": "Fast-Track Your Offer",
	"description": "Dealers are more likely to accept offers that include payment and shipping information upfront. Provide your info now and you will only be charged if the dealer accepts your price."
};

/***/ },
/* 146 */
/***/ function(module, exports) {

module.exports = {
	"netPriceHeader": "Request Net Price",
	"netPriceSubjectItem": "1stdibs Net Price",
	"netPriceSubheader": "A request will be sent to the dealer to provide the net price.",
	"netPriceHoldInfoChecked": "If approved, this piece will be placed on hold exclusively for you.",
	"netPriceMessageInfo": "If approved, this piece will be placed on hold exclusively for you.",
	"sendRequestCta": "Send Request",
	"header": "Request Net Price",
	"subjectItem": "1stdibs Net Price",
	"hardcodedTextBody": "I would like to consider this piece for a client project. Could you please send me the net price?",
	"tradeInfo": "The dealer will be notified that you are a verified member of the trade."
};

/***/ },
/* 147 */
/***/ function(module, exports) {

module.exports = {
	"preContactDealerHeader": "Request More Information",
	"preContactDealerSubtitle": "What would you like to do?",
	"requestShippingQuote": "Request Shipping Quote",
	"requestConditionReport": "Request Condition Report",
	"requestToHoldItem": "Request to Hold Item",
	"viewInvoice": "View invoice",
	"askAQuestionCta": "Ask a question"
};

/***/ },
/* 148 */
/***/ function(module, exports) {

module.exports = __webpack_require__(282);

/***/ },
/* 149 */
/***/ function(module, exports) {

module.exports = __webpack_require__(574);

/***/ },
/* 150 */
/***/ function(module, exports) {

module.exports = __webpack_require__(1643);

/***/ },
/* 151 */
/***/ function(module, exports) {

module.exports = __webpack_require__(427);

/***/ },
/* 152 */
/***/ function(module, exports) {

module.exports = __webpack_require__(354);

/***/ },
/* 153 */
/***/ function(module, exports) {

module.exports = __webpack_require__(410);

/***/ },
/* 154 */
/***/ function(module, exports) {

module.exports = __webpack_require__(1128);

/***/ },
/* 155 */
/***/ function(module, exports) {

module.exports = __webpack_require__(791);

/***/ },
/* 156 */
/***/ function(module, exports) {

module.exports = __webpack_require__(724);

/***/ },
/* 157 */
/***/ function(module, exports) {

module.exports = __webpack_require__(3955);

/***/ },
/* 158 */
/***/ function(module, exports) {

module.exports = __webpack_require__(2789);

/***/ },
/* 159 */
/***/ function(module, exports) {

module.exports = __webpack_require__(39);

/***/ },
/* 160 */
/***/ function(module, exports) {

module.exports = __webpack_require__(495);

/***/ },
/* 161 */
/***/ function(module, exports) {

module.exports = __webpack_require__(2010);

/***/ },
/* 162 */
/***/ function(module, exports) {

module.exports = __webpack_require__(18);

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

module.exports = {
    CursorInput: __webpack_require__(49),
    DisplayPrice: __webpack_require__(34),
    EmailField: __webpack_require__(50),
    HoldRequestInput: __webpack_require__(35),
    MessageField: __webpack_require__(15),
    NameField: __webpack_require__(22),
    OptInInput: __webpack_require__(53),
    OfferField: __webpack_require__(52),
    SectionToggle: __webpack_require__(23),
    Submit: __webpack_require__(12),
    MakePreAuthOffer: __webpack_require__(82),
    Confirmation: __webpack_require__(48),

    PreContactDealer: __webpack_require__(83),
    ContactDealer: __webpack_require__(79),
    GuidedCopy: __webpack_require__(85),
    MakeOffer: __webpack_require__(81),
    AbandonMakeOfferModal: __webpack_require__(78),
    LowBall: __webpack_require__(80),
    NetPrice: __webpack_require__(51),

    ContactDealerModal: __webpack_require__(73),
    MakeOfferModal: __webpack_require__(74),
    MakePreAuthOfferModal: __webpack_require__(75),
    ModalWrapper: __webpack_require__(76),
    NetPriceModal: __webpack_require__(77),

    SuccessGeneric: __webpack_require__(84),

    ContactModalTracking: __webpack_require__(2),

    reducers: {
        contactDealer: __webpack_require__(86),
        fields: __webpack_require__(87),
        lowBall: __webpack_require__(88),
        modalWrapper: __webpack_require__(89),
        price: __webpack_require__(90),
        tracking: __webpack_require__(91),
        validation: __webpack_require__(92)
    },
    actions: {
        contactDealer: __webpack_require__(46),
        fields: __webpack_require__(13),
        makeOffer: __webpack_require__(14),
        modalWrapper: __webpack_require__(8),
        mutation: __webpack_require__(11),
        netPrice: __webpack_require__(47),
        validation: __webpack_require__(10)
    }
};

/***/ }
/******/ ]);

/***/ }),
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var lodashFlattenDeep = __webpack_require__(3956);
var SV = __webpack_require__(18);

/**
 * Checks is current page type in arguments list.
 * Page types are defined in global/costants/pageTypes.es.js
 *
 * isPageType('browse', 'home', ['pdp', 'attribute'], ['creator']);
 *
 * @return {boolean}
 */
var pageTypeHelper = {
    isPageType: function isPageType() {
        var pageType = SV.get('settings.pageType');

        return lodashFlattenDeep(arguments).indexOf(pageType) > -1;
    }
};

module.exports = pageTypeHelper;

/***/ }),
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 9/9/14
 * Time: 11:39 AM
 */



var _require = __webpack_require__(324),
    getBuyerToken = _require.getBuyerToken;

var FinancialAmount = __webpack_require__(10);
var User = __webpack_require__(15);

var userHelpers = module.exports = {
    isUserAuthenticationRequired: function isUserAuthenticationRequired() {
        // auth when user logged out but email stored locally
        return !userHelpers.isLoggedIn() && !!userHelpers.getUserEmail();
    },
    getUserDisplayName: function getUserDisplayName() {
        var user = User.getCurrentUser();
        var profile = user && user.get('profile');
        return profile ? profile.getDisplayName() : '';
    },
    getUserEmail: function getUserEmail() {
        return User.getEmail() !== 'undefined' ? User.getEmail() : '';
    },
    logoutUser: function logoutUser() {
        User.deleteStorage();
        User.logout(false);
    },
    isLoggedIn: function isLoggedIn() {
        return User.loggedIn();
    },
    isUserCurrent: function isUserCurrent(buyerId) {
        return Number(buyerId) === Number(userHelpers.getUserId());
    },
    getUserId: function getUserId() {
        return User.getUserId();
    },
    getUserToken: function getUserToken() {
        return (getBuyerToken(document.cookie) || {}).userToken;
    },
    getBuyerDefaults: function getBuyerDefaults() {
        return new User({
            apiType: 'user',
            profile: {
                currency: FinancialAmount.CURRENCY_USD
            },
            wallet: {
                paymentMethods: []
            }
        });
    }
};

/***/ }),
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-arrow-down'].join(' '), 'data-tn': 'arrow-down', viewBox: '0 -8.5 32 32' },
                React.createElement('path', { d: 'M32,1c0,0.3-0.1,0.6-0.3,0.8l-15,13c-0.4,0.3-0.9,0.3-1.3,0l-15-13c-0.4-0.4-0.5-1-0.1-1.4 c0.4-0.4,1-0.5,1.4-0.1L16,12.6L30.3,0.2c0.4-0.4,1-0.3,1.4,0.1C31.9,0.5,32,0.8,32,1z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 553 */,
/* 554 */,
/* 555 */
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 19);
/******/ })
/************************************************************************/
/******/ ({

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var REGISTER = exports.REGISTER = 'register';
var LOGIN = exports.LOGIN = 'login';
var FORGOT_PASSWORD = exports.FORGOT_PASSWORD = 'forgot-password';
var RESET_PASSWORD = exports.RESET_PASSWORD = 'reset-password';
var UPDATE_PASSWORD = exports.UPDATE_PASSWORD = 'update-password';
var RESET_INVALID = exports.RESET_INVALID = 'reset-invalid';

var DEFAULT_FLOW = exports.DEFAULT_FLOW = 'DEFAULT';
var PAGEVIEW_LIMIT_FLOW = exports.PAGEVIEW_LIMIT_FLOW = 'PAGEVIEW_LIMIT';
var CONTACT_DEALER_FLOW = exports.CONTACT_DEALER_FLOW = 'CONTACT_DEALER';
var CONTACT_DEALER_FORM_FLOW = exports.CONTACT_DEALER_FORM_FLOW = 'CONTACT_DEALER_FORM';
var CONTACT_DEALER_CALL_FLOW = exports.CONTACT_DEALER_CALL_FLOW = 'CONTACT_DEALER_CALL';
var EMBEDDED_CHECKOUT_FLOW = exports.EMBEDDED_CHECKOUT_FLOW = 'EMBEDDED_CHECKOUT_FLOW';
var FOLLOW_DEALER_FLOW = exports.FOLLOW_DEALER_FLOW = 'FOLLOW_DEALER';
var MAKE_OFFER_FLOW = exports.MAKE_OFFER_FLOW = 'MAKE_OFFER';
var SAVE_ITEM_FLOW = exports.SAVE_ITEM_FLOW = 'SAVE_ITEM';
var STALE_LOGIN_FLOW = exports.STALE_LOGIN_FLOW = 'STALE_LOGIN_FLOW';
var TRADE_APPLICATION_FLOW = exports.TRADE_APPLICATION_FLOW = 'TRADE_APPLICATION';
var ALT_REGISTRATION_TRADE_FLOW = exports.ALT_REGISTRATION_TRADE_FLOW = 'ALT_REGISTRATION_TRADE';
var ALT_REGISTRATION_CONSUMER_FLOW = exports.ALT_REGISTRATION_CONSUMER_FLOW = 'ALT_REGISTRATION_CONSUMER';

var CLOSE = exports.CLOSE = 'closed';

/***/ })

/******/ });

/***/ }),
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(79);

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var find = __webpack_require__(975);

var TourStore = function (_BaseStore) {
    _inherits(TourStore, _BaseStore);

    function TourStore(dispatcher) {
        var _this$_tour;

        _classCallCheck(this, TourStore);

        var _this = _possibleConstructorReturn(this, (TourStore.__proto__ || Object.getPrototypeOf(TourStore)).call(this, dispatcher));

        _this._tour = (_this$_tour = {}, _defineProperty(_this$_tour, TourStore.type.TRADE_TOUR, {
            isTourOpen: false,
            currentStep: 1,
            totalSteps: 6
        }), _defineProperty(_this$_tour, TourStore.type.NET_PRICE_TOUR, {
            isTourOpen: false,
            currentStep: 1,
            totalSteps: 1
        }), _defineProperty(_this$_tour, TourStore.type.REQUEST_ITEM_HOLD_TOUR, {
            isTourOpen: false,
            currentStep: 1,
            totalSteps: 1
        }), _this$_tour);
        return _this;
    }

    _createClass(TourStore, [{
        key: '_onStepIncrease',
        value: function _onStepIncrease(type) {
            var tour = this._tour[type];
            if (tour) {
                tour.currentStep += 1;
                this.emitChange();
            }
        }
    }, {
        key: '_onTourOpen',
        value: function _onTourOpen(type) {
            var tour = this._tour[type];
            if (tour) {
                tour.isTourOpen = true;
                this.emitChange();
            }
        }
    }, {
        key: '_onTourClose',
        value: function _onTourClose(type) {
            var tour = this._tour[type];
            if (tour) {
                tour.isTourOpen = false;
                tour.currentStep = 1;
                this.emitChange();
            }
        }
    }, {
        key: 'isTourLoaded',
        value: function isTourLoaded(type) {
            var tour = this._tour[type];
            return tour && tour.isLoaded;
        }
    }, {
        key: 'isTourOpen',
        value: function isTourOpen(type) {
            var tour = this._tour[type];
            return tour && tour.isTourOpen;
        }
    }, {
        key: 'isAnyTourOpen',
        value: function isAnyTourOpen() {
            var tour = find(this._tour, { isTourOpen: true });
            return !!tour;
        }
    }, {
        key: 'getCurrentStep',
        value: function getCurrentStep(type) {
            var tour = this._tour[type];
            return tour && tour.currentStep;
        }
    }, {
        key: 'getTotalSteps',
        value: function getTotalSteps(type) {
            var tour = this._tour[type];
            return tour && tour.totalSteps;
        }
    }]);

    return TourStore;
}(BaseStore);

;

TourStore.storeName = 'TourStore';

TourStore.handlers = {
    'tour:step:increase': '_onStepIncrease',
    'tour:open': '_onTourOpen',
    'tour:close': '_onTourClose'
};

TourStore.type = {
    TRADE_TOUR: 'tradeTour',
    NET_PRICE_TOUR: 'netPriceTour',
    REQUEST_ITEM_HOLD_TOUR: 'requestItemHoldTour'
};

module.exports = TourStore;

/***/ }),
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// ---------------------------------------------------
// Dependencies

var SoaModel = __webpack_require__(2);
var root = typeof window === 'undefined' ? global : window;
var Item = root.bunsen.Item = module.exports =  SoaModel.extend();
var SoaCollection = __webpack_require__(9);
var Backbone = __webpack_require__(3);
var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var assert = __webpack_require__(31);
var Seller = __webpack_require__(105);
var Photo = __webpack_require__(1528);
var Holds = __webpack_require__(2204);
var itemPhotosMixin = __webpack_require__(3847);
var endpoints = __webpack_require__(6);
var Listing = __webpack_require__(1465);
var ShipmentQuotes = __webpack_require__(319);
var ItemAttributesModel = __webpack_require__(2055);
var ItemAttributesCollection = __webpack_require__(1015);
var ItemCreator = __webpack_require__(1466);
var ItemCreators = __webpack_require__(1619);
var StorefrontPreferences = __webpack_require__(2058);
var ReturnPolicy = __webpack_require__(321);
var Condition = __webpack_require__(2053);
var Party = __webpack_require__(8);
var Mailer = __webpack_require__(2056);
var ItemCategories = __webpack_require__(2041);
var Category = __webpack_require__(1377);
var ItemPricing = __webpack_require__(2208);
var verticals = __webpack_require__(416);
var FinancialAmount = __webpack_require__(10);
var Measurement = __webpack_require__(656);
var transitionMixin = __webpack_require__(315);
var NotesDocumentList = __webpack_require__(1890);
var ListingDocumentList = __webpack_require__(3842);
var ReviewDocumentList = __webpack_require__(3846);
var Review = __webpack_require__(2057);
var AvailableActions = __webpack_require__(1527);
var Deferred = __webpack_require__(29);
var User = __webpack_require__(28);
var itemDisplayStatus = __webpack_require__(3832);
var currencies = __webpack_require__(1220).currencies;

// ---------------------------------------------------
// Local Vars

var HasOne = Backbone.One;
var HasMany = Backbone.Many;
var relations;
var docListShell = { metadata: {}, documents: [] };
var actionNames;

// graphql transforms all Y/N's into true/false
// make sure we can accomodate both
function isYes(prop) {
    return prop === 'Y' || prop === true;
}

root.bunsen = root.bunsen || {};

// ---------------------------------------------------
// Module Definition


relations = [
    {
        key: 'holds',
        type: HasMany,
        collectionType: Holds
    },
    {
        key: 'creators',
        relatedModel: ItemCreator,
        type: HasMany,
        collectionType: ItemCreators
    },
    {
        key: 'classification',
        type: HasOne,
        relatedModel: SoaModel.extend({
            relations: [{
                key: 'style',
                type: HasOne,
                relatedModel: SoaModel
            }, {
                key: 'categories',
                type: HasMany,
                collectionType: ItemCategories
            }]
        })
    },
    {
        key : 'attributes',
        relatedModel: ItemAttributesModel,
        type: HasOne
    },
    {
        key: 'materialsTechniques',
        collectionType: ItemAttributesCollection,
        type: HasMany,
        omitFromSave: true
    },
    {
        key: 'measurement',
        relatedModel: Measurement,
        type: HasOne
    },
    {
        key: 'shipmentQuotes',
        collectionType: ShipmentQuotes,
        type: HasMany,
        omitFromSave: true
    },
    {
        key: 'pricing',
        relatedModel: ItemPricing,
        type: HasOne
    },
    {
        key: 'condition',
        relatedModel: Condition,
        type: HasOne
    },
    {
        key: 'listings',
        relatedModel: ListingDocumentList,
        type: HasOne
    },
    {
        key: 'customMaterial',
        type: HasOne,
        relatedModel: SoaModel
    },
    {
        key: 'updateRestrictionList',
        type: HasOne,
        relatedModel: SoaModel
    },
    {
        key: 'store',
        type: HasOne,
        relatedModel: SoaModel
    },
    {
        key: 'seller',
        relatedModel: Seller,
        type: HasOne
    },
    {
        type: HasMany,
        key: 'photos',
        relatedModel: Photo
    },
    {
        key: 'reviews',
        relatedModel: ReviewDocumentList,
        type: HasOne
    },
    {
        key: 'returnPolicy',
        relatedModel: ReturnPolicy,
        type: HasOne
    },
    {
        key: 'mailer',
        type: HasOne,
        relatedModel: Mailer
    },
    {
        key: 'storefrontPreferences',
        type: HasOne,
        relatedModel: StorefrontPreferences
    },
    {
        key: 'versions',
        type: Backbone.Many,
        collectionType: SoaCollection.extend({
            model: SoaModel.extend({
                relations: [{
                    key: 'price',
                    type: HasOne,
                    relatedModel: FinancialAmount
                }]
            })
        })
    },
    {
        key : 'actions',
        type: Backbone.Many,
        collectionType: AvailableActions
    },
    {
        key: 'notes',
        type: HasOne,
        relatedModel: NotesDocumentList
    }
];

_.extend(Item.prototype, {

    relations: relations,

    // NOTE: THIS IS COPY-PASTA FROM ITEM V2
    // original comment:
    // In Backbone JS - the parse function is automatically called whenever you get model data back from the server. It
    // should return a hash map of attributes to be set on the model. In our case, we use 2 different end points for
    // fetch and save, so this function figures out which endpoint was hit, and grabs the correct data:
    parse: function (data) {
        var defaultsMap = {
            fashion: Item.getFashionDefaults,
            jewelry: Item.getJewelryDefaults,
            art: Item.getArtDefaults
        };

        data = SoaModel.prototype.parse.apply(this, arguments);

        if (data && data.vertical) {
            if (typeof defaultsMap[data.vertical] === 'function') {
                data = $.extend(true, {}, defaultsMap[data.vertical](), data);
            }
        }
        return data;
    },

    getAmountPerItem : function (currency) {
        var quantity = parseInt(this.get('pieces') || 0, 10);
        var pricing = this.get('pricing');
        var amount;

        if (!pricing) {
            return undefined;
        }

        amount = pricing.getTotalAmount(currency);
        if (this.isSoldIndividually()) {
            return amount / quantity;
        }
        return amount;
    },
    canMultipleQuantityBePurchased: function () {
        return this.get('pricing.pricePerPiece') === 'Y' && this.get('pieces') > 1;
    },
    dealerSuspended: function () {
        return this.get('seller') && this.get('seller').isStatusSuspended();
    },
    dealerClosed: function () {
        return this.get('seller') && this.get('seller').isStatusClosed();
    },
    dealerPending: function () {
        return this.get('seller') && this.get('seller').isStatusPending();
    },
    /**
     * This is subject to change since new price types (NET, WEEKLY_SALE)
     * could also have a hidden price.  Currently it only checks for the
     * active retail price.
     * @return {Boolean}
     */
    isPriceHidden: function () {
        var activePrice = this.get('pricing.prices') && this.get('pricing.prices').find(function (price) {
            return price.isActive() && price.isRetail();
        });
        return !!(activePrice && activePrice.shouldHidePrice());
    },
    /*
     * Return if a price is hidden based on the provided type
     * @param {string} type The Price type, from Price.TYPE_*
     * @retur {Boolean}
     */
    isPriceHiddenByType: function (type) {
        var activePrice = this.get('pricing.prices') && this.get('pricing.prices').find(function (price) {
            return price.isActive() && price.get('type') === type;
        });
        return !!(activePrice && activePrice.shouldHidePrice());
    },
    /*
     * Return if a price is negotiable based on the provided type
     * @param {string} type The Price type, from Price.TYPE_*
     * @retur {Boolean}
     */
    isNegotiablePriceByType: function (type) {
        var typePrice = this.get('pricing.prices') && this.get('pricing.prices').find(function (price) {
            return price.isActive() && price.get('type') === type;
        });
        return !!(typePrice && typePrice.isNegotiable());
    },
    /**
     * Returns formatted price for
     * @param {string} options.currency currency to which this item's price will be formatted.
     * @param {boolean} options.includeCurrencySymbol if false, the currency symbol will be omitted from the return value.
     * @returns {string} local-formatted price string, when options is {currency: "EUR", includeCurrencySymbol: true} and item price is 123456.78, returns "€123.456,78".
     */
    localizedAmount: function (options) {
        var totalAmount = this.get('pricing.totalAmount');
        if (totalAmount) {
            return totalAmount.localizedAmount(options);
        }
    },
    /**
     * Finds and returns pricing details on the item.
     * @returns {String}
     * @public
     */
    getDisplayPrice: function (currency) {
        var amount;
        if (this.isPriceHidden()) {
            return 'Price Upon Request';
        } else {
            amount = this.get('pricing.totalAmount');
            return amount && amount.getDisplayPrice(currency);
        }
    },
    getConvertedPriceAmount: function (currency) {
        var prop = 'pricing.totalAmount.convertedAmounts.' + currency;
        return this.get(prop);
    },
    /**
     * method that gets converted amounts based on "RETAIL", "NET", "WEEKLY_SALE" price types
     * @param {string} type
     * @returns {object|null}
     */
    getConvertedPriceAmountsByType: function (type) {
        var prices = this.getPriceByType(type);
        return prices ? prices.get('amount.convertedAmounts') : null;
    },
    getCurrency: function () {
        return this.get('pricing.totalAmount.currency');
    },
    getPrice: function () {
        return this.get('pricing.totalAmount.amount');
    },
    getPriceLocksByType: function (type) {
        var pricing = this.get('pricing');
        return pricing.getPriceLockByType(type);
    },
    getPriceLocksIn: function (type, currency) {
        var priceLock = this.getPriceLocksByType(type);
        var amount;
        currency = currency || currencies.CURRENCY_USD;
        if (priceLock) {
            // FinancialAmount model
            amount = priceLock.getOriginalPriceIn(currency);
            if (amount) {
                return amount;
            }
        }
        // return null so that it's easy
        // to detect whether or not there is a price
        return null;
    },
    getPriceByType: function (type) {
        var pricing = this.get('pricing');
        return pricing && pricing.getPriceByType(type);
    },
    getPriceIn: function (type, currency) {
        var price = this.getPriceByType(type);
        var amount;
        currency = currency || currencies.CURRENCY_USD;
        if (price) {
            // FinancialAmount model
            amount = price.get('amount');
            if (amount) {
                return amount.getAmountIn(currency);
            }
        }
        // return null so that it's easy
        // to detect whether or not there is a price
        return null;
    },
    getNumberOfPieces: function () {
        return this.get('pieces');
    },
    soldIndividually: function () {
        return this.get('pricing') && isYes(this.get('pricing.pricePerPiece'));
    },
    _isVertical: function (vertical) {
        return this.get('vertical') === vertical;
    },
    isArt: function () {
        return this._isVertical(verticals.VERTICAL_ART);
    },
    isFashion: function () {
        return this._isVertical(verticals.VERTICAL_FASHION);
    },
    isFurniture: function () {
        return this._isVertical(verticals.VERTICAL_FURNITURE);
    },
    isJewelry: function () {
        return this._isVertical(verticals.VERTICAL_JEWELRY);
    },
    getTotalAmounts: function () {
        return this.get('pricing.totalAmount.convertedAmounts');
    },
    getInitialPriceAmounts: function () {
        return this.get('pricing.initialPrice.convertedAmounts');
    },
    getAmountIn: function (currency) {
        return this.get('pricing.totalAmount').getAmountIn(currency);
    },
    isNegotiablePrice: function () {
        return isYes(this.get('pricing.negotiable'));
    },
    isBargainPrice: function () {
        return isYes(this.get('pricing.bargain'));
    },
    /**
     * Get initial price.  If the item is on sale, the "bargain" price will
     * be in the totalAmount, i.e. you can retrieve it with getDisplayPrice()
     * @param  {String} currency - optional
     * @return {String} price
     */
    getInitialPrice: function (currency) {
        return this.get('pricing.initialPrice').getDisplayPrice(currency);
    },

    hidingPrice: function () {
        var price = this.getPrice();
        return !price || price < 0.01 || this.isPriceHidden();
    },

    // PHOTOS ---------------------------------------------------------------------------------------------------------
    /**
     * Gets the number of photos on the item excluding empty photo objects (ones with no versions)
     * @returns {*}
     */
    getNumPhotos : function () {
        return this.get('photos')
            .filter(function (photo) {
                return photo && photo.get('versions') && photo.get('versions').length;
            }).length;
    },

    /**
     * Returns an array of photo URLs by size. ie. get all large or thumbnail photos
     * @param size <string> ie. "large"
     * @returns {Array}
     */
    getPhotosBySize : function (size) {
        var sizedPhoto;

        return this.getPhotos()
            .filter(function (photo) {
                sizedPhoto = photo.getVersion(size);
                return sizedPhoto && sizedPhoto.get('webPath');
            });
    },

    /**
     * @param options
     * @param [options.position=1] {number} the photo position
     * @param [options.size=small] {string} the photo size
     * @returns {string}
     */
    getPhotoUrl: function (options) {
        options = options || {};
        options.position = options.position || 1;
        options.size = options.size || 'small';

        assert((_.indexOf(itemPhotosMixin.photoTypes, options.size) !== -1), 'Invalid photo version provided');

        try {
            return this.getPhotos()
                .findWhere({ sortOrder: options.position })
                .getVersion(options.size)
                .get('webPath');
        } catch (e) {
            console.error('Photo not found', this.id, options);
        }
    },

    supports21stCenturyData: function () {
        return this.isFurniture();
    },
    getPeriod: function () {
        return this.get('attributes.period[0].value');
    },
    getCreator: function () {
        return this.get('creators[0].creator.name');
    },
    /**
     * Looks through the item's collection of creators and returns an array of creators whose 'roles' array contains roleToFind
     * @param {string} roleToFind
     * @returns {array}
     */
    getCreatorsByRole: function (roleToFind) {
        assert(roleToFind, 'A role must be passed as the argument to getCreatorsByRole');
        return this.getCreatorsCollection()
            .filter(function (creator) {
                return _.contains(creator.get('roles'), roleToFind.toUpperCase());
            });
    },
    /**
     * Returns array of creator names.
     * @return {Array} array of strings
     */
    getCreators: function () {
        var creators = this.get('creators');
        var creatorDisplayNames = [];
        var creatorIdentifierField;

        if (this.isFashion() || this.isJewelry()) {
            creatorIdentifierField = 'name';
        } else {
            creatorIdentifierField = 'displayName';
        }

        // check if the creators collection is defined, and if so,
        // send the creator display names (if any) to the template
        if (creators) {
            // iterate over the creators collection
            creators.each(function (creatorModel) {
                var displayName = creatorModel.get('creator.' + creatorIdentifierField);
                if (!_.isUndefined(displayName) && !_.contains(creatorDisplayNames, displayName)) {
                    creatorDisplayNames.push(displayName);
                }
            });
        }

        return creatorDisplayNames;
    },
    /**
     * Returns array of creator names. Each element is an object with an attribution and an array
     * of creator names for that attribution.
     * @returns {Array}
     */
    getCreatorsNamesByAttribution: function () {
        var creators = this.get('creators');
        var creatorDisplayNames = [];
        var creatorIdentifierField;

        if (this.isFashion() || this.isJewelry()) {
            creatorIdentifierField = 'name';
        } else {
            creatorIdentifierField = 'displayName';
        }

        // check if the creators collection is defined, and if so,
        // send the creator display names (if any) to the template
        if (creators) {
            // iterate over the creators collection
            creators.each(function (creatorModel) {
                var attribution;
                var attributionRecord;
                var displayName = creatorModel.get('creator.' + creatorIdentifierField);

                if (!_.isUndefined(displayName)) {
                    attribution = creatorModel.get('attribution') || 'Creator';
                    attributionRecord = _.findWhere(creatorDisplayNames, {attribution: attribution});

                    // create array of names organized by attribution
                    if (attributionRecord) {
                        attributionRecord.creator.push(displayName);
                    } else {
                        creatorDisplayNames.push({
                            attribution: attribution,
                            creator: [displayName]
                        });
                    }
                }
            });
        }

        return creatorDisplayNames;
    },
    getCreatorsCollection: function () {
        var creators = this.get('creators');

        if (creators) {
            return creators;
        }

        this.set('creators', new ItemCreators());

        return this.get('creators');
    },
    getCategory: function (level) {
        var categories = this.get('classification.categories');
        if (_.isArray(categories) && categories[0] && categories[0][level - 1]) {
            return categories[0][level - 1].label;
        }
    },

    /**
     * @returns {ItemCategories}
     */
    getItemCategories : function () {
        return this.get('classification.categories');
    },

    /**
     * Return the primary item category, if one exists
     * @returns {ItemCategory}
     */
    getPrimaryItemCategory: function () {
        var itemCategories = this.getItemCategories();
        if (itemCategories) {
            return itemCategories.getPrimary();
        }
        return null;
    },

    /**
     * @param {string} itemCategoryKey
     * @returns {ItemCategory}
     */
    findItemCategoryByKey: function (itemCategoryKey) {
        var itemCategories = this.getItemCategories();
        if (itemCategories) {
            return itemCategories.findByCategoryKey(itemCategoryKey);
        }
        return null;
    },

    _ensureHasItemCategories : function () {
        var itemCategories = this.getItemCategories();
        var classification;
        if (itemCategories) {
            return itemCategories;
        }
        classification = this.get('classification');
        if (!classification) {
            this.set('classification', { categories: [] });
        } else {
            classification.set('categories', []);
        }
        return this.getItemCategories();
    },

    /**
     * Add a new item category to the end
     * of the item categories collections.
     * @param {string} itemCategoryKey
     * @returns {Item}
     */
    addItemCategoryWithKey: function (itemCategoryKey) {
        var itemCategories = this.getItemCategories();
        if (!itemCategories) {
            itemCategories = this._ensureHasItemCategories();
        }
        itemCategories.addWithKey(itemCategoryKey);
        return this;
    },

    /**
     * Creates ItemCategories models based on the keys
     * passed in, and in the same order.
     * @param {string[]} keys
     * @returns {Item}
     */
    setItemCategoriesWithKeys: function (keys) {
        var itemCategories = this._ensureHasItemCategories();
        itemCategories.resetWithKeys(keys);
        return this;
    },

    /**
     * Searches the full vertical {@link Category} singleton
     * for the model that matches the key of the primary
     * {@link ItemCategory} for this item.
     * @returns {Category}
     */
    findPrimaryCategoryInVerticalCategory : function () {
        var primaryItemCategory = this.getPrimaryItemCategory();
        var categoryKey;
        var vertical;
        var verticalCategory;
        if (!primaryItemCategory) {
            return null;
        }
        categoryKey = primaryItemCategory.getCategoryKey();
        vertical = this.get('vertical');
        if (!vertical) {
            return null;
        }
        verticalCategory = Category.verticalCategoryInstance(vertical);
        return verticalCategory.findChildByKey(categoryKey);
    },

    getCategories: function () {
        var inflatedCategories = this.get('classification.inflatedCategories');
        return (inflatedCategories) ? inflatedCategories[0] : [];
    },

    /**
     * Category URL
     * @returns {string}
     */
    getCategoryURL: function () {
        var categories = this.getCategories();
        var parts = _.pluck(categories, 'label');
        if (parts.length) {
            return '/' + parts.join('/') + '/';
        }
        return '/';
    },

    /**
     * Get name of most specific category
     * @returns {string}
     */
    getLowestCategory: function () {
        var categories = this.getCategories();
        if (categories.length) {
            return (categories[categories.length - 1]).name;
        }
        return '';
    },

    /**
     * Add item to mailer
     * @returns {Deferred}
     */
    addMailer: function (options) {
        var mailer = new Mailer(null, { itemId: this.id });
        this.set('mailer', mailer);
        return mailer.add(options);
    },

    /**
     * Remove item from mailer
     * @returns {Deferred}
     */
    removeMailer: function (options) {
        var mailer = new Mailer(null, { itemId: this.id });
        this.set('mailer', mailer);
        return mailer.remove(options);
    },

    isInMailer: function () {
        return isYes(this.get('mailer.inMailer'));
    },

    /**
     * Indicates if item is shown on storefront after sold
     * @return {Boolean}
     */
    isOnStorefrontWhenSold: function () {
        var listings = this.getListings();
        var metadata = listings.getTypeMetadata(Listing.TYPE.STOREFRONT);
        var hasPublishedSF;
        var isSold = this.isSold();

        // is item published to storefront? check metadata first, then listing documents
        if (metadata && metadata.length) {
            hasPublishedSF = (metadata.indexOf(Listing.STATUS.PUBLISHED) >= 0);
        } else {
            hasPublishedSF = listings.filterStorefront().filterPublished().get('documents').size() > 0;
        }

        return isSold && hasPublishedSF;
    },

    url: function () {
        return endpoints.item(this.get('id'));
    },

    addStorefrontListing: function (types) {
        return this.getListings().addStorefrontListing(types);
    },
    addMarketplaceListing: function (types) {
        return this.getListings().addMarketplaceListing(types);
    },
    addFeaturedListing: function (types) {
        return this.getListings().addFeaturedListing(types);
    },
    addWeeklySaleListing: function (types) {
        return this.getListings().addWeeklySaleListing(types);
    },

    /**
     * Save an item's shipment quotes. Item is required
     * to have an id and a seller object.
     * @param {object} [saveOptions]
     * @returns {Promise}
     */
    saveShipmentQuotes: function (saveOptions) {
        var url = endpoints.itemShipmentQuotes(this.id);
        var shipmentQuotesJson;
        var sellerId = this.get('seller.id');
        saveOptions = _.extend({}, {
            url: url
        }, saveOptions);
        this.get('shipmentQuotes').each(function (quote) {
            if (!quote.get('author')) {
                quote.set('author', {
                    role: Party.ROLE_SELLER,
                    id: sellerId
                });
            }
            quote.set({
                type: 'INVENTORY_POSTING'
            });
        }, this);
        shipmentQuotesJson = this.get('shipmentQuotes').toJSON();
        saveOptions.attrs = { dataList: shipmentQuotesJson };
        return new Item(this.toJSON()).save(null, saveOptions);
    },

    /**
     * Return a PDP url path (e.g. /id-f_1234/ or /furniture/storage-case-pieces/credenzas/id-f_1234/)
     * @param {boolean} isIncludeCategories
     * @returns {string}
     */
    getPDPURL: function (isIncludeCategories) {
        return (isIncludeCategories ? this.getCategoryURL().slice(0, -1) : '') + '/id-' + this.id + '/';
    },

    getPdpUrls : function () {
        return this.get('pdpUrls') || [];
    },

    /**
     * @param {number} nth
     * @returns {string|null}
     */
    getNthPdpUrl : function (nth) {
        var urls = this.getPdpUrls();
        var url = null;
        nth = nth || 0;

        if (urls.length && urls[nth]) {
            url = urls[nth];
        }
        return url;
    },

    isSoldIndividually: function () {
        return isYes(this.get('item.pricing.pricePerPiece'));
    },
    /**
     * fetches all available options for this item. Does not take shipment address
     * into consideration
     * @returns {*}
     */
    fetchAvailableOptions: function () {
        var availableOptions = new ShipmentQuotes();

        // Cancel any outstanding requests
        if (this._availableOptionsDeferred) {
            this._availableOptionsDeferred.reject();
        }

        this._availableOptionsDeferred = new $.Deferred();
        availableOptions.fetchAvailableOptions(this).done(_.bind(function () {
            this.availableOptions = availableOptions;
            this.selectFirstAvailableOption();
            this._availableOptionsDeferred.resolve(availableOptions);
        }, this)).fail(_.bind(function () {
            this._availableOptionsDeferred.reject();
        }, this));
        return this._availableOptionsDeferred.promise();
    },
    /**
     * Returns a promise that resolves with the available options.
     * Only fetches if they have not already been fetched
     */
    getAvailableOptionsPromise: function () {
        if (this._availableOptionsDeferred && this._availableOptionsDeferred.promise()) {
            return this._availableOptionsDeferred.promise();
        } else {
            return this.fetchAvailableOptions();
        }
    },

    getReviews: function () {
        var reviews = this.get('reviews');
        if (reviews === undefined) {
            reviews = new ReviewDocumentList(docListShell);
            this.set('reviews', reviews);
        }
        return reviews;
    },


    /**
     * Returns the first Data Review that is not Deleted
     * @returns {*}
     */
    getDataReview: function () {
        return this.getReviews()
            .filter(function (review) {
                return review.get('type') === Review.TYPE.DATA_QUALITY
                    && review.get('status') !== Review.STATUS.DELETED;
            })[0];
    },

    /**
     * Returns the first Photo Review that is not Deleted
     * @returns {*}
     */
    getPhotoReview: function () {
        return this.getReviews()
            .filter(function (review) {
                return review.get('type') === Review.TYPE.IMAGE_PROCESSING
                    && review.get('status') !== Review.STATUS.DELETED;
            })[0];
    },

    getPhotos: function () {
        return this.get('photos') || new Backbone.Collection();
    },

    /////////////////
    // Status Getters
    isCompleteStatus: function () {
        return this.getStatus() === Listing.STATUS.COMPLETE;
    },
    isIncompleteStatus: function () {
        return this.getStatus() === Item.STATUS.INCOMPLETE;
    },
    isDeletedStatus: function () {
        return this.getStatus() === Item.STATUS.DELETED;
    },
    isNewStatus: function () {
        return this.getStatus() === Item.STATUS.NEW;
    },
    isUnavailableStatus: function () {
        return this.getStatus() === Item.STATUS.UNAVAILABLE;
    },
    getStatus: function () {
        return this.get('status');
    },
    isNotListed : function () {
        return this.isCompleteStatus() && !this.getListings().hasPublishedListing() && !this.isQueuedForPosting();
    },
    canMakeBuyerOffer: function () {
        return this.isNegotiablePrice() && this.isCompleteStatus() && !this.dealerSuspended() && !this.hidingPrice();
    },
    /**
     * @deprecated
     * Use `isNotListed`
     * @returns {boolean}
     */
    wasUnlisted : function () {
        // if the item has no published listings and the post date exists and is not unix time 0 it was unpublished
        var hasPostingDate = !!this.get('postDate');
        if (hasPostingDate) {
            hasPostingDate = !(new Date(this.get('postDate')).getUTCMilliseconds() === 0);
        }
        return !this.getListings().hasPublishedListing() && hasPostingDate;
    },
    /**
     * an item can be rejected by an internal expert only. So, an item is rejected if it's expert reviews are all
     * deleted. If it has no
     * @returns {boolean}
     */
    isRejected: function () {
        return this.isIncompleteStatus() && this.getReviews().filterRejected().any();
    },

    /**
     * Checks to see if this item was ever rejected
     * @return {Boolean}
     */
    wasEverRejected: function () {
        return this.getReviews().wasRejected();
    },

    /**
     * An item is queued for posting if it is in complete state and has pending (queued) listings.
     * @returns {boolean}
     */
    isQueuedForPosting : function () {
        var isQueued = false;
        if (this.isCompleteStatus()) {
            this.getListings().eachType(function (type, statuses) {
                if (statuses.indexOf(Listing.STATUS.NEW) >= 0 ||
                    statuses.indexOf(Listing.STATUS.COMPLETE) >= 0 ||
                    statuses.indexOf(Listing.STATUS.QUEUED) >= 0) {
                    isQueued = true;
                }
            });
            isQueued = isQueued ||
                this.getListings().filterQueued().any() ||
                this.getListings().filterComplete().any() ||
                this.getListings().filterNew().any();
        }
        return isQueued;
    },
    isNydc: function () {
        return this.isFurniture() && this.has('nydcInfo') && isYes(this.get('nydcInfo').isNydc);
    },
    setNydc: function (bool) {
        if (!this.isFurniture()) { return undefined; }
        this.set('nydcInfo', { apiType: "itemNydcInfo", isNydc: bool ? 'Y' : 'N' });
    },
    /**
     * @param {string} value Either 'Y' or 'N' to indicate NYDC status
     * @param {Object} options
     * @returns {Promise}
     * @private
     */
    _updateNYDCStatus: function (value, options) {
        var self = this;
        return this.save(null, _.extend({
            url: endpoints.toggleNYDCv3(this.get('id')),
            type: 'PUT',
            patch: true,
            data: {
                isNydc: value
            }
        }, options)).done(function () {
            self.setNydc(true);
        });
    },
    /**
     * Add item to NYDC
     * @param {Object} options
     * @returns {Promise}
     */
    addToNYDC: function (options) {
        this._updateNYDCStatus('Y', options);
    },
    /**
     * Remove item from NYDC
     * @param {Object} options
     * @returns {Promise}
     */
    removeFromNYDC: function (options) {
        this._updateNYDCStatus('N', options);
    },

    /////////////////
    // Status Setters
    markComplete: function () {
        this.set('status', Item.STATUS.COMPLETE);
        this.unset('unavailableReasonCode');
    },
    markIncomplete: function () {
        this.set('status', Item.STATUS.INCOMPLETE);
        this.unset('unavailableReasonCode');
    },
    markUnavailable: function () {
        this.set('status', Item.STATUS.UNAVAILABLE);
    },
    markDeleted: function () {
        this.set('status', Item.STATUS.DELETED);
        this.unset('unavailableReasonCode');
    },

    /////////////////
    // Reason Code
    markSold: function () {
        this.markUnavailable();
        this.set('unavailableReasonCode', Item.REASON_CODE.ITEM_SOLD);
    },
    markOnHold: function () {
        this.markUnavailable();
        this.set('unavailableReasonCode', Item.REASON_CODE.ON_HOLD);
    },
    isSold: function () {
        var r = Item.REASON_CODE;
        return this.isUnavailableStatus()
            && [r.ITEM_SOLD, r.SOLD_ON_PLATFORM].indexOf(this.get('unavailableReasonCode')) !== -1;
    },
    isOnHold: function () {
        var onHoldReasonCodes = [Item.REASON_CODE.ON_HOLD, Item.REASON_CODE.ON_HOLD_CUSTOM];
        return this.isUnavailableStatus() && onHoldReasonCodes.indexOf(this.get('unavailableReasonCode')) > -1;
    },
    isOnHoldForCustomer: function () {
        return this.isUnavailableStatus()
          && this.get('unavailableReasonCode') === Item.REASON_CODE.ON_HOLD_CUSTOM;
    },
    isOnHoldForEverybody: function () {
        return this.isUnavailableStatus()
          && this.get('unavailableReasonCode') === Item.REASON_CODE.ON_HOLD;
    },

    ///////////
    // Holds
    getActiveHold: function () {
        var holds = this.get('holds');
        return holds ? holds.getActiveHold() : null;
    },
    getHoldExpirationDate: function () {
        var activeHold = this.getActiveHold();
        return activeHold ? activeHold.getExpirationDate() : null;
    },
    getHoldConversationUrl: function () {
        var activeHold = this.getActiveHold();
        return activeHold ? activeHold.getConversationUrl() : null;
    },
    releaseHold: function () {
        var activeHold = this.getActiveHold();
        var dfd = new Deferred.Deferred();

        return activeHold
            ? activeHold
                .release()
                .save()
            : dfd.reject();
    },


    /**
     * Get the items note collection
     * or create a new collection and set
     * it to the notes attr
     * @returns notes
     */
    getNotes: function () {
        var notes = this.get('notes');
        if (notes === undefined) {
            notes = new NotesDocumentList(docListShell, {service: endpoints.latest.inventory});
            this.set('notes', notes);
        }
        return notes;
    },

    /////////////////
    // Listings
    getListings : function () {
        var listings = this.get('listings');
        if (listings === undefined) {
            listings = new ListingDocumentList(docListShell);
            this.set('listings', listings);
        }
        return listings;
    },
    isListed: function () {
        return this.getListings().hasListings();
    },

    hasListings: function () {
        return this.getListings().size() > 0;
    },

    isRepost: function () {
        return this.getListings().isRepost();
    },

    markUnlisted: function () {
        var listings = this.getListings().filterDeleted({ not: true });
        listings.parents = this.getListings().parents;
        listings.each(function (listing) {
            listing.markDeleted();
            listing.set('deletedReasonCode', Listing.REASON_CODE.UNLISTED);
        });
        return listings;
    },

    // Resets the listings to their previous state from the server or an empty
    resetListings : function () {
        var lastAttrs = this.lastSyncAttributes();
        var listingData = lastAttrs.listings || docListShell;
        var listings;
        this.set('listings', listingData);
        listings = this.getListings();
        listings.filterUnsaved().each(function (listing) {
            listings.remove(listing);
        });
    },

    // backbone state changes
    hasChangedListingsSinceLastSync: function () {
        return this.getListings().some(function (listing) {
            return listing.isNew() || listing.changedSinceLastSync();
        });
    },
    /**
     * Move item to storefront by updating listings
     * @param {PublicationTypes} - types - required - Publication types to add a storefront listing
     * @param {Clump} - clump - optional - pass this if you want to clump your requests
     * @return {Promise}
     */
    moveToStorefront: function (types, clump) {
        var listingDfds;
        var dfd;
        //If the item is already on the storefront, return a rejected promise
        if (itemDisplayStatus(this) === 'storefront') {
            dfd = new Deferred.Deferred();
            listingDfds = [dfd.reject()];
        } else {
            listingDfds = this.getListings().filter(function (listing) {
                return !listing.isStorefront() && !listing.isDeletedStatus();
            }).map(function (listing) {
                listing.markDeleted();
                listing.set('deletedReasonCode', Listing.REASON_CODE.UNLISTED);
                return listing.save(null, {
                    queries: {
                        indexMode: 'sync'
                    },
                    clump: clump
                });
            });
            if (!this.getListings().filterStorefront().filterPublished().any()) {
                listingDfds.push(this.addStorefrontListing(types).save(null, {
                    queries: {
                        indexMode: 'sync'
                    },
                    clump: clump
                }));
            }
        }
        return Deferred.when.apply(Deferred, listingDfds);
    },

    ////////////////////////////
    // actions (state transitions)
    canMarkIncomplete: function () {
        return !!(this.get('actions') && this.get('actions').findWhere({code : Item.ACTION_NAMES.INCOMPLETE}));
    },
    canMarkComplete: function () {
        return !!(this.get('actions') && this.get('actions').findWhere({code : Item.ACTION_NAMES.COMPLETE}));
    },
    canMarkDeleted: function () {
        return !!(this.get('actions') && this.get('actions').findWhere({code : Item.ACTION_NAMES.DELETED}));
    },
    canMarkOnHold: function () {
        //return this.get('actions') && this.get('actions').isUserAuthorizedFor(Item.ACTION_NAMES._XXX, userOrSeller);
        return this.getListings().hasPublishedListing() && this.isCompleteStatus();
    },
    canMarkSold: function () {
        //return this.get('actions') && this.get('actions').isUserAuthorizedFor(Item.ACTION_NAMES._XXX, userOrSeller);
        return (this.getListings().hasPublishedListing() && this.isCompleteStatus()) || (this.isUnavailableStatus() && !this.isSold());
    },
    // actions (other availalbe actions)
    canEditItem : function (userOrSeller) {
        return this.get('actions') && this.get('actions').isUserAuthorizedFor(Item.ACTION_NAMES.EDIT_ITEM, userOrSeller);
    },
    canMakePurchase:  function (transaction) {
        var buyerCanAcceptPrivateOffer = transaction && transaction.buyerCanAcceptPrivateOffer();
        var canPurchaseOnHoldItem = this.isOnHold() && buyerCanAcceptPrivateOffer;
        return (
            !this.isNotListed() &&
            !this.isDeletedStatus() &&
            !this.dealerSuspended() &&
            !this.dealerClosed() &&
            !this.dealerPending() &&
            !this.isSold() &&
            (!this.isOnHold() || canPurchaseOnHoldItem) &&
            (!this.isPriceHidden() || buyerCanAcceptPrivateOffer)
        );
    },
    /**
     * Returns true if the item has a data review that is assignable by the given user
     * @param {User} user
     * @returns {boolean}
     */
    canAssignDataReview: function (user) {
        var review = this.getDataReview();
        assert(user instanceof User, 'You must include a user when checking to see if a data review can be assigned');
        return !!(review && review.canAssignReview(user));
    },
    /**
     * Returns true if the item has a photo review that is assignable by the given user
     * @param {User} user
     * @returns {boolean}
     */
    canAssignPhotoReview: function (user) {
        var review = this.getPhotoReview();
        assert(user instanceof User, 'You must include a user when checking to see if a photo review can be assigned');
        return !!(review && review.canAssignReview(user));
    },
    canAttachListings : function () {
        // In the future this will be based on an available action but for now, we just look at the listings
        var allListings = this.getListings().filterCanAttachListings();
        var unsavedListingsSize = allListings.filterUnsaved().size();
        var deletedListingsSize = allListings.filterDeleted().size();

        //Returns true if the number of saved listings equals the number of deleted listings
        return (allListings.get('documents').size() - unsavedListingsSize) === deletedListingsSize;
    },
    canUnlist : function (userOrSeller) {
        return this.get('actions') && this.get('actions').isUserAuthorizedFor(Item.ACTION_NAMES.UNLIST_ITEM, userOrSeller);
    },

    isTradeReturnAvailable: function () {
        var price = this.get('pricing').getMostRelevantPrice(FinancialAmount.CURRENCY_USD, true);
        return (this.isFurniture() || this.isArt()) &&
            price <= 35000 &&
            this.get('seller.shippingAddress.country') === 'US';
    },

    getActiveSalePrice: function () {
        var priceArr = this.get('pricing.prices').toJSON() || [];
        return priceArr.filter(function (price) {
            return price.type === 'WEEKLY_SALE' && price.status === 'ACTIVE';
        })[0];
    },

    hasActiveSalePrice: function () {
        return !!this.getActiveSalePrice();
    },

    deleteSalePrice: function () {
        var salePrice;
        if (this.hasActiveSalePrice()) {
            salePrice = new FinancialAmount(this.getActiveSalePrice());
            salePrice.set('status', 'INACTIVE');
            // Need to pass { merge: true } option since we're going to overwrite the existing price with the same id
            this.get('pricing.prices').add(salePrice, { merge: true });
        }
        return this;
    },
    /**
     * Need this method for the pdp to fetch price/shipping data
     * This should be replaced with a graphql
     * implementation in the future
     * @param options
     * @returns {*|null}
     */
    fetchKeyFields: function (options) {
        var self = this;

        options = options || {};
        options.data = _.extend({}, {
            fields: 'key',
            shipmentQuotesView: 'PDP'
        }, options.data);

        /* eslint-disable camelcase */
        if (!this._fetchKeyFields_P) {
            this._fetchKeyFields_P = this.fetch(options).fail(function () {
                self._fetchKeyFields_P = null;
            });
        }
        return this._fetchKeyFields_P;
        /* eslint-disable camelcase */
    }
}, transitionMixin);


// Static functions
_.extend(Item, {
    STATUS: {
        UNAVAILABLE: 'UNAVAILABLE',
        COMPLETE: 'COMPLETE',
        INCOMPLETE: 'INCOMPLETE',
        NEW: 'NEW',
        DELETED: 'DELETED'
    },
    REASON_CODE: {
        ITEM_SOLD: 'SOLD',
        SOLD_ON_PLATFORM: 'SOLD_ON_PLATFORM',
        ON_HOLD: 'ON_HOLD',
        ON_HOLD_CUSTOM: 'ON_HOLD_CUSTOM',
        UNLISTED: 'UNLISTED'
    },
    PHOTOS_API : {
        PHOTOS_API_TYPE : 'photos',
        PHOTOS_ROTATION_API_TYPE : 'photoRotationRequest',
        PHOTOS_ROTATION_TYPE : 'ROTATION'
    },
    UPLOAD_TYPE: {
        FULL_SERVICE: '_1STDIBS',
        SELF_SERVICE: 'USER'
    }
});

actionNames = {
    EDIT_ITEM : 'EDIT_ITEM',
    UNLIST_ITEM : 'UNLIST_ITEM',
    ATTACH_LISTINGS : 'ATTACH_LISTINGS',
    _XXX : 'TODO_THIS_IS_A_PLACEHOLDER_REMOVE_IT' //todo
};
_.extend(actionNames, Item.STATUS);
Object.freeze(actionNames);
_.extend(Item, {
    ACTION_NAMES: actionNames
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var Modal = __webpack_require__(1);
	var Header = __webpack_require__(9);
	var Body = __webpack_require__(13);

	module.exports = { Modal: Modal, Header: Header, Body: Body };

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(2);
	var css = __webpack_require__(3);
	var React = __webpack_require__(7);
	var FlexModalWrapper = __webpack_require__(8);
	var PropTypes = React.PropTypes;

	__webpack_require__(2); // eslint-disable-line require-path-exists/exists

	var Modal = function Modal(_ref) {
	    var children = _ref.children,
	        closeModal = _ref.closeModal,
	        closeOnEsc = _ref.closeOnEsc,
	        closeOnOutsideClick = _ref.closeOnOutsideClick,
	        dataTn = _ref.dataTn,
	        isOpened = _ref.isOpened,
	        modalClass = _ref.modalClass,
	        wrapperClass = _ref.wrapperClass,
	        onOpen = _ref.onOpen;
	    return React.createElement(
	        FlexModalWrapper,
	        {
	            closeOnEsc: closeOnEsc,
	            closeOnOutsideClick: closeOnOutsideClick,
	            isOpened: isOpened,
	            onClose: closeModal,
	            className: wrapperClass + ' ' + css.wrapper,
	            onOpen: onOpen
	        },
	        React.createElement(
	            'div',
	            { className: modalClass || css.content },
	            React.Children.map(children, function (c) {
	                return React.cloneElement(c, { closeModal: closeModal, dataTn: dataTn });
	            })
	        )
	    );
	};

	Modal.defaultProps = {
	    closeOnEsc: true,
	    closeOnOutsideClick: true,
	    dataTn: 'default-tag',
	    modalClass: ''
	};

	Modal.propTypes = {
	    children: PropTypes.node,
	    closeModal: PropTypes.func,
	    closeOnEsc: PropTypes.bool,
	    closeOnOutsideClick: PropTypes.bool,
	    dataTn: PropTypes.string,
	    isOpened: PropTypes.bool,
	    modalClass: PropTypes.string,
	    wrapperClass: PropTypes.string,
	    onOpen: PropTypes.func
	};

	module.exports = Modal;

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(3187);

/***/ },
/* 3 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"src-Modal-style---content---3KroD","wrapper":"src-Modal-style---wrapper---16j1C"};

/***/ },
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(1);

/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(2783);

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var css = __webpack_require__(10);
	var React = __webpack_require__(7);
	var CloseIcon = __webpack_require__(12);

	var Header = function Header(_ref) {
	    var children = _ref.children,
	        closeModal = _ref.closeModal,
	        dataTn = _ref.dataTn,
	        headerClass = _ref.headerClass,
	        titleClass = _ref.titleClass;
	    return React.createElement(
	        'div',
	        { className: headerClass || css.header },
	        React.createElement(
	            'p',
	            { className: titleClass || css.title },
	            children
	        ),
	        React.createElement('div', { className: css.divider }),
	        React.createElement(
	            'div',
	            { className: css.close, onClick: closeModal, 'data-tn': dataTn + '-modal-close' },
	            React.createElement(CloseIcon, { className: css.closeButton })
	        )
	    );
	};

	Header.propTypes = {
	    children: React.PropTypes.node,
	    closeModal: React.PropTypes.func,
	    dataTn: React.PropTypes.string,
	    headerClass: React.PropTypes.string,
	    titleClass: React.PropTypes.string
	};

	module.exports = Header;

/***/ },
/* 10 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"src-Header-style---header---1e0ET","title":"src-Header-style---title---1J0CJ","close":"src-Header-style---close---3RKdj","closeButton":"src-Header-style---closeButton---20ChF","divider":"src-Header-style---divider---_OrIy"};

/***/ },
/* 11 */,
/* 12 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(278);

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(7);
	var classnames = __webpack_require__(14);
	var css = __webpack_require__(15);

	var Body = function Body(_ref) {
	    var children = _ref.children,
	        bodyClass = _ref.bodyClass,
	        dataTn = _ref.dataTn;
	    return React.createElement(
	        'div',
	        { className: classnames(bodyClass || css.body), 'data-tn': dataTn + '-modal-body' },
	        children
	    );
	};

	Body.propTypes = {
	    bodyClass: React.PropTypes.string,
	    children: React.PropTypes.node,
	    dataTn: React.PropTypes.string
	};

	module.exports = Body;

/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(2782);

/***/ },
/* 15 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"body":"src-Body-style---body---19tjB"};

/***/ }
/******/ ]);

/***/ }),
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(43);

/***/ }),
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _hoistNonReactStatics = __webpack_require__(749);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    (0, _hoistNonReactStatics2.default)(NewComponent, BaseComponent);
    return NewComponent;
  };
};

exports.default = hoistStatics;

/***/ }),
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(61);

/***/ }),
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var Measurement = module.exports = SoaModel.extend();

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);

_.extend(Measurement, {
    units: {
        IN: 'IN',
        MM: 'MM',
        CM: 'CM'
    }
});

_.extend(Measurement.prototype, {
    relations: function relations() {
        return [{
            key: 'weight',
            type: Backbone.One,
            relatedModel: SoaModel
        }, {
            key: 'size',
            type: Backbone.One,
            relatedModel: SoaModel
        }];
    }
});

/***/ }),
/* 657 */,
/* 658 */,
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by daletan on 6/29/16.
 */



var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var lodashGet = __webpack_require__(14);
var endpoints = __webpack_require__(284);
var User = __webpack_require__(15);
var currencyActions = __webpack_require__(894);
var tradeMessageActions = __webpack_require__(1082);
var chatUtils = __webpack_require__(271);

function loadUserRelationship(_ref) {
    var types = _ref.types,
        fieldsUserB = _ref.fieldsUserB;

    var url = endpoints.userRelationships() + '?' + User.COOKIE_USER + '=' + User.getUserToken() + '&usersA=' + User.getUserId() + '&types=' + types + '&fieldsUserB=' + fieldsUserB;

    return fetch(url).then(function (response) {
        return response.json();
    }).then(function (_ref2) {
        var result = _ref2.result;

        var salesRep = lodashGet(result, '0.userDataB.0', null);
        return salesRep;
    });
}

var loginActions = {

    ACTION_LOGGED_OUT_USER: 'user:loggedOut',
    ACTION_FULL_PROFILE: 'user:fullProfile:loaded',
    ACTION_NET_PRICE: 'user:netPriceStatus',
    ACTION_SOCIAL_NETWORKS: 'user:socialNetworks:load',
    ACTION_TRADE_SALES_REP: 'user:trade:salesRep:load',
    ACTION_VIP_SALES_REP: 'user:vip:salesRep:load',

    handleLoginChange: function handleLoginChange(actionContext) {
        return Promise.all([actionContext.executeAction(loginActions.loadFullUser), actionContext.executeAction(loginActions.loadTradeUserRepresentative), actionContext.executeAction(loginActions.getTradeUserCreateDate), actionContext.executeAction(loginActions.loadVipUserRepresentative), actionContext.executeAction(loginActions.checkUserTypeStatus), actionContext.executeAction(loginActions.getUserSocialNetworks), actionContext.executeAction(currencyActions.loadCurrencyForUser)]).then(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 4),
                user = _ref4[0],
                tradeSalesRep = _ref4[1],
                tradeUserCreateDate = _ref4[2],
                vipSalesRep = _ref4[3];

            chatUtils.fillUserData({ user: user, tradeSalesRep: tradeSalesRep, tradeUserCreateDate: tradeUserCreateDate, vipSalesRep: vipSalesRep });
        });
    },

    loadLoggedOutUser: function loadLoggedOutUser(actionContext) {
        return Promise.resolve(User.load()).then(function () {}).catch(function () {}).then(function (profile) {
            actionContext.dispatch(loginActions.ACTION_LOGGED_OUT_USER, { profile: profile });
        });
    },

    loadFullUser: function loadFullUser(actionContext) {
        return Promise.resolve(User.load()).then(function (profile) {
            actionContext.dispatch(loginActions.ACTION_FULL_PROFILE, { profile: profile, isLoggedIn: true });
            return profile;
        }).catch(function (profile) {
            if (profile.type && profile.type === 'NOT_LOGGED_IN') {
                actionContext.dispatch(loginActions.ACTION_LOGGED_OUT_USER, { profile: profile });
                return;
            }
            actionContext.dispatch(loginActions.ACTION_FULL_PROFILE, { profile: profile });
        });
    },

    checkUserTypeStatus: function checkUserTypeStatus(actionContext) {
        return Promise.resolve(User.load()).then(function () {
            var userCanRequestNetPrice = User.canRequestNetPrice();
            actionContext.dispatch(loginActions.ACTION_NET_PRICE, { userCanRequestNetPrice: userCanRequestNetPrice });
        }).catch(function () {
            actionContext.dispatch(loginActions.ACTION_NET_PRICE, { userCanRequestNetPrice: false });
        });
    },

    getUserSocialNetworks: function getUserSocialNetworks(actionContext) {
        return Promise.resolve(User.load()).then(function () {
            var socialNetworks = User.getCurrentUser().get('socialNetworks');
            actionContext.dispatch(loginActions.ACTION_SOCIAL_NETWORKS, { socialNetworks: socialNetworks });
        }).catch(function () {
            // User.load() rejects if user is not logged in
        });
    },

    loadTradeUserRepresentative: function loadTradeUserRepresentative(actionContext) {
        return Promise.resolve(User.load()).then(function () {
            var isVerifiedTradeBuyer = User.getCurrentUser().isVerifiedTradeBuyer();

            if (isVerifiedTradeBuyer) {
                return loadUserRelationship({
                    types: 'TRADE_SALES_REP',
                    fieldsUserB: 'TRADE_REP_PROFILE'
                }).then(function (salesRep) {
                    var tradeSalesRep = salesRep;
                    return actionContext.executeAction(tradeMessageActions.checkTradeMessage, { tradeSalesRep: tradeSalesRep }).then(function () {
                        return { tradeSalesRep: tradeSalesRep };
                    });
                }).then(function (_ref5) {
                    var tradeSalesRep = _ref5.tradeSalesRep;

                    actionContext.dispatch(loginActions.ACTION_TRADE_SALES_REP, { tradeSalesRep: tradeSalesRep });
                    return tradeSalesRep;
                });
            }

            return Promise.resolve();
        }).catch(function () {
            // User.load() rejects if user is not logged in
        });
    },

    getTradeUserCreateDate: function getTradeUserCreateDate() {
        return Promise.resolve(User.load()).then(function () {
            var user = User.getCurrentUser();

            if (user.isVerifiedTradeBuyer()) {
                var tradeRole = user.get('roles').toJSON().find(function (_ref6) {
                    var name = _ref6.name;
                    return name === User.BUYER_TRADE;
                });
                return tradeRole.createdDate;
            }

            return null;
        }).catch(function () {
            // User.load() rejects if user is not logged in
        });
    },

    loadVipUserRepresentative: function loadVipUserRepresentative(actionContext) {
        return Promise.resolve(User.load()).then(function () {
            var isVipBuyer = User.getCurrentUser().isVipBuyer();

            if (isVipBuyer) {
                return loadUserRelationship({
                    types: 'VIP_SALES_REP',
                    fieldsUserB: 'VIP_REP_PROFILE'
                }).then(function (salesRep) {
                    var vipSalesRep = salesRep;
                    actionContext.dispatch(loginActions.ACTION_VIP_SALES_REP, { vipSalesRep: vipSalesRep });
                    return vipSalesRep;
                });
            }

            return Promise.resolve();
        }).catch(function () {
            // User.load() rejects if user is not logged in
        });
    }

};

module.exports = loginActions;

/***/ }),
/* 660 */,
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _mapProps = __webpack_require__(1103);

var _mapProps2 = _interopRequireDefault(_mapProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withProps = function withProps(input) {
  return (0, _mapProps2.default)(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
};

exports.default = (0, _createHelper2.default)(withProps, 'withProps');

/***/ }),
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Modal = __webpack_require__(3641);
var Header = __webpack_require__(3640);
var Body = __webpack_require__(3639);

module.exports = { Modal: Modal, Header: Header, Body: Body };

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createEagerElementUtil = __webpack_require__(2284);

var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);

var _isReferentiallyTransparentFunctionComponent = __webpack_require__(2282);

var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createFactory = function createFactory(type) {
  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
  return function (p, c) {
    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
  };
};

exports.default = createFactory;

/***/ }),
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = compose;
function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  var last = funcs[funcs.length - 1];
  return function () {
    var result = last.apply(undefined, arguments);
    for (var i = funcs.length - 2; i >= 0; i--) {
      var f = funcs[i];
      result = f(result);
    }
    return result;
  };
}

/***/ }),
/* 673 */,
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(31);

/***/ }),
/* 675 */,
/* 676 */,
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * jQuery Cookie Plugin v1.4.0
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
	if (true) {
        // CommonJS
        factory(__webpack_require__(5));
    } else if (typeof define === 'function' && define.amd) {
		// AMD. Register as anonymous module.
		define(['jquery'], factory);
	} else {
		// Browser globals.
		factory(jQuery);
	}
}(function ($) {

	var pluses = /\+/g;

	function encode(s) {
		return config.raw ? s : encodeURIComponent(s);
	}

	function decode(s) {
		return config.raw ? s : decodeURIComponent(s);
	}

	function stringifyCookieValue(value) {
		return encode(config.json ? JSON.stringify(value) : String(value));
	}

	function parseCookieValue(s) {
		if (s.indexOf('"') === 0) {
			// This is a quoted cookie as according to RFC2068, unescape...
			s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
		}

		try {
			// Replace server-side written pluses with spaces.
			// If we can't decode the cookie, ignore it, it's unusable.
			// If we can't parse the cookie, ignore it, it's unusable.
			s = decodeURIComponent(s.replace(pluses, ' '));
			return config.json ? JSON.parse(s) : s;
		} catch(e) {}
	}

	function read(s, converter) {
		var value = config.raw ? s : parseCookieValue(s);
		return $.isFunction(converter) ? converter(value) : value;
	}

	var config = $.cookie = function (key, value, options) {

		// Write

		if (value !== undefined && !$.isFunction(value)) {
			options = $.extend({}, config.defaults, options);

			if (typeof options.expires === 'number') {
				var days = options.expires, t = options.expires = new Date();
				t.setTime(+t + days * 864e+5);
			}

			return (document.cookie = [
				encode(key), '=', stringifyCookieValue(value),
				options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
				options.path    ? '; path=' + options.path : '',
				options.domain  ? '; domain=' + options.domain : '',
				options.secure  ? '; secure' : ''
			].join(''));
		}

		// Read

		var result = key ? undefined : {};

		// To prevent the for loop in the first place assign an empty array
		// in case there are no cookies at all. Also prevents odd result when
		// calling $.cookie().
		var cookies = document.cookie ? document.cookie.split('; ') : [];

		for (var i = 0, l = cookies.length; i < l; i++) {
			var parts = cookies[i].split('=');
			var name = decode(parts.shift());
			var cookie = parts.join('=');

			if (key && key === name) {
				// If second argument (value) is a function it's a converter...
				result = read(cookie, value);
				break;
			}

			// Prevent storing a cookie that we couldn't decode.
			if (!key && (cookie = read(cookie)) !== undefined) {
				result[name] = cookie;
			}
		}

		return result;
	};

	config.defaults = {};

	$.removeCookie = function (key, options) {
		if ($.cookie(key) === undefined) {
			return false;
		}

		// Must not alter options, thus extending a fresh object...
		$.cookie(key, '', $.extend({}, options, { expires: -1 }));
		return !$.cookie(key);
	};

}));


/***/ }),
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: hella
 * Date: 4/6/14
 * Time: 1:15 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 *
 * formerly:
 * js/global/core/dibs.js#baseDomain
 * js/global/core/dibs.js#parseUri
 * js/global/core/dibs.js#URL
 * dibs.baseDomain
 * dibs.parseUri
 * dibs.URL
 */


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var bunsenUri = __webpack_require__(137);
var deprecationNotice = '[.com] global/utils/commonjs/uri module has been deprecated.';

/* develblock:start */
console.warn(deprecationNotice + ' use bunsen/helpers/uri module');
/* develblock:end */

exports.parseUri = function parseUri(str, mode) {
    var parseOptions = {};
    /* develblock:start */
    console.warn(deprecationNotice + ' use bunsen/helpers/uri module');
    /* develblock:end */

    if (typeof mode === 'string') {
        /* develblock:start */
        console.warn('`mode` argument was passed in as a string. please udpate this to `{ mode: mode }`');
        /* develblock:end */
        parseOptions.mode = mode;
    } else if ((typeof mode === 'undefined' ? 'undefined' : _typeof(mode)) === 'object' && !Array.isArray(mode)) {
        parseOptions = mode;
    }
    //console.log("str: ", str);
    return bunsenUri.parseUri(str, parseOptions);
};

// make the parsed URL of the current page available on the global dibs namespace
// handy to have around
exports.URL = bunsenUri.URL;

/***/ }),
/* 690 */,
/* 691 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FavoriteModel = __webpack_require__(378);
var FavoritesCollection = __webpack_require__(1216);
var SaveSearchModel = __webpack_require__(3620);

var BaseStore = __webpack_require__(13);

var FavoritesStore = function (_BaseStore) {
    _inherits(FavoritesStore, _BaseStore);

    function FavoritesStore(dispatcher) {
        _classCallCheck(this, FavoritesStore);

        var _this = _possibleConstructorReturn(this, (FavoritesStore.__proto__ || Object.getPrototypeOf(FavoritesStore)).call(this, dispatcher));

        _this._isFetched = false;
        _this._isLoading = false;
        _this._favoriteCanceled = false;
        _this._error = null;

        _this._collection = new FavoritesCollection([], {
            model: FavoriteModel
        });

        _this._itemsState = {
            items: {},
            isFetching: false
        };

        _this._saveSearchModel = new SaveSearchModel();
        return _this;
    }

    _createClass(FavoritesStore, [{
        key: '_onFetchStart',
        value: function _onFetchStart() {
            this._error = null;
            this._isLoading = true;
            this.emitChange();
        }
    }, {
        key: '_onFetchEnd',
        value: function _onFetchEnd() {
            this._isFetched = true;
            this._isLoading = false;
            this.emitChange();
        }
    }, {
        key: '_onFetchError',
        value: function _onFetchError(error) {
            this._isFetched = false;
            this._isLoading = false;
            this._error = error;
            this.emitChange();
        }
    }, {
        key: '_onFavoriteError',
        value: function _onFavoriteError(error) {
            this._error = error;
            this.emitChange();
        }
    }, {
        key: '_onFavoriteAdd',
        value: function _onFavoriteAdd(model) {
            this._collection.add(model);
            this.emitChange();
        }
    }, {
        key: '_onFavoriteRemove',
        value: function _onFavoriteRemove(model) {
            delete this._itemsState.items[model.id];
            this._collection.remove(model);
            this.emitChange();
        }

        // This might get called A LOT if you're fetching lots of items
        // So we don't call emitChange here, instead we hook to the isFetching fag

    }, {
        key: '_onFavoriteItemFetchSuccess',
        value: function _onFavoriteItemFetchSuccess(_ref) {
            var id = _ref.id,
                items = _ref.items;

            this._itemsState.items[id] = items;
        }
    }, {
        key: '_onFavoriteItemFetchProgress',
        value: function _onFavoriteItemFetchProgress(_ref2) {
            var isFetching = _ref2.isFetching;

            this._itemsState.isFetching = isFetching;
            this.emitChange();
        }
    }, {
        key: '_onFavoriteCanceled',
        value: function _onFavoriteCanceled() {
            this._favoriteCanceled = true;
            this.emitChange();

            this._favoriteCanceled = false;
        }
    }, {
        key: 'getFavoritesCollection',
        value: function getFavoritesCollection() {
            return this._collection;
        }
    }, {
        key: 'getFavoriteModelInstance',
        value: function getFavoriteModelInstance() {
            return this._collection.model;
        }
    }, {
        key: 'getFavoriteModel',
        value: function getFavoriteModel(id) {
            return this._collection.get(id);
        }
    }, {
        key: 'getFavoritesByType',
        value: function getFavoritesByType(type) {
            return this._collection.models.filter(function (model) {
                return model.get('type') === type;
            });
        }
    }, {
        key: 'getSaveSearchModel',
        value: function getSaveSearchModel() {
            return this._saveSearchModel;
        }
    }, {
        key: 'getFavoriteItems',
        value: function getFavoriteItems() {
            return this._itemsState.items;
        }
    }, {
        key: 'isFetchingFavoriteItems',
        value: function isFetchingFavoriteItems() {
            return this._itemsState.isFetching;
        }

        /**
         * @return {Object} - with favorites ids as keys containing an array with display params
         */

    }, {
        key: 'getDisplayParams',
        value: function getDisplayParams() {
            var _this2 = this;

            return this._collection.models.reduce(function (obj, current) {
                var id = current.id;

                obj[id] = _this2.getDisplayParamsById({ id: id });
                return obj;
            }, {});
        }

        /**
         * Return display parameters(that are flagged as not internal in the model) for a given favorite id.
         * @param  {Number} {id} - Favorite id
         * @return {Array}
         */

    }, {
        key: 'getDisplayParamsById',
        value: function getDisplayParamsById(_ref3) {
            var id = _ref3.id;

            return this.getFavoriteModel(id).get('parameters').filter(function (model) {
                return !model.isInternal();
            }).map(function (model) {
                return {
                    key: model.get('key'),
                    displayValue: model.getDisplayValue(),
                    displayKey: model.getDisplayKey()
                };
            });
        }
    }, {
        key: 'isFetched',
        value: function isFetched() {
            return this._isFetched;
        }
    }, {
        key: 'isLoading',
        value: function isLoading() {
            return this._isLoading;
        }
    }, {
        key: 'isCanceled',
        value: function isCanceled() {
            return this._favoriteCanceled;
        }
    }]);

    return FavoritesStore;
}(BaseStore);

FavoritesStore.storeName = 'FavoritesStore';

FavoritesStore.handlers = {
    'favorites:fetch:start': '_onFetchStart',
    'favorites:fetch:end': '_onFetchEnd',
    'favorites:fetch:error': '_onFetchError',

    'favorites:favorite:add': '_onFavoriteAdd',
    'favorites:favorite:remove': '_onFavoriteRemove',
    'favorites:error': '_onFavoriteError',
    'favorites:items:fetch:success': '_onFavoriteItemFetchSuccess',
    'favorites:items:fetch:progress': '_onFavoriteItemFetchProgress',

    'favorite:canceled': '_onFavoriteCanceled'
};

module.exports = FavoritesStore;

/***/ }),
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 11/25/14
 * Time: 6:06 PM
 */



var strings = __webpack_require__(2044);
var shard;

/**
 * Get an index number based on the string to be used against an array
 * @param {string} stringVal An image path
 * @returns {number}
 */
var computeChecksum = function (stringVal) {
    // check for a string otherwise default to an empty array for the return statement
    var vals = typeof stringVal === 'string' ? stringVal.split('') : [];
    return vals.reduce(function (checksum, letter) {
        return checksum + strings.ord(letter);
    }, 0);
};

/**
 * Gets the domain to prepend to an image
 * @param {string} filePath The current path to process
 * @param {array} imageHosts Array of host names
 * @returns {string}
 */
var getDomain = function (filePath, imageHosts) {
    var index;
    var checksum;
    console.assert(Array.isArray(imageHosts), 'shard.getDomain requires an array of imageHosts');

    checksum = computeChecksum(filePath);
    index = checksum % imageHosts.length;

    return imageHosts[index];
};


shard = module.exports = {
    /**
     * Get the fully qualified domain if all the required params are passed along
     * By default, the returned value is scheme-less
     * @param {string} filePath The file path to add the shard to
     * @param {array} imageHosts Array of shard domain strings
     * @param {boolean} [prependProtocol=false] Force adding the protocol
     * @returns {string|*}
     */
    getUrl: function (filePath, imageHosts, prependProtocol) {
        // FINDING-6978 ignore any further processing if https? is in the filePath
        var regexp = /^https?/i;
        if (regexp.test(filePath) || !filePath) {
            return filePath;
        }
        if (imageHosts) {
            return (prependProtocol ? 'https:' : '') + '//' + getDomain(filePath, imageHosts) + filePath;
        }
        return filePath;
    }
};


/***/ }),
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */,
/* 708 */,
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 9/17/14
 * Time: 3:56 PM
 */



var _ = __webpack_require__(22);
var get = __webpack_require__(14);
var tracking = __webpack_require__(27);

var _require = __webpack_require__(137),
    URL = _require.URL;

var PurchaseTracking = __webpack_require__(500);
var helpers = __webpack_require__(371);
var redirects = __webpack_require__(352);
var storage = __webpack_require__(492);
var trackHelpers = __webpack_require__(507);

var authConstants = __webpack_require__(266).default.constants;

var _require2 = __webpack_require__(3240),
    fireAuthModalEvent = _require2.fireAuthModalEvent,
    fireFormInteractionEvent = _require2.fireFormInteractionEvent;

var triggerCheckoutAction = function triggerCheckoutAction(actionType, trigger, section, entry) {
    var label = [];

    trigger = redirects.isUserComesFromEmail() ? 'email' : trigger;

    if (entry) {
        label.push('entry=' + entry);
    }
    if (trigger) {
        var triggers = [trigger, trackHelpers.getCallToAction()];
        if (redirects.isUserComesFromAmp()) {
            triggers.push('amppage');
        }
        label.push('trigger=' + triggers.join('-'));
    }
    if (section) {
        label.push('section=' + section);
    }
    return tracking.trackEvent({
        category: 'checkout',
        action: 'checkout ' + actionType,
        label: label.join('|')
    });
};
var triggerFormInteractionAction = function triggerFormInteractionAction(label) {
    tracking.trackEvent({
        category: 'checkout',
        action: 'checkout form interaction',
        label: label
    });
};
var triggerClickToDealerStorefrontAction = function triggerClickToDealerStorefrontAction(label) {
    tracking.trackEvent({
        category: 'dealer click',
        action: 'click to dealer storefront',
        label: label
    });
};
var trackCheckoutSurvey = function trackCheckoutSurvey(label) {
    var _ref = storage.getSurveyInfo() || {},
        step = _ref.step;

    var eventLabel = [label, step].join('|');
    triggerFormInteractionAction(eventLabel);
};
var triggerCheckoutAuthModalEvent = function triggerCheckoutAuthModalEvent(action, flowStep) {
    var label = trackHelpers.getGATransactionType();
    fireAuthModalEvent({ action: action, label: label }, flowStep);
};

var trackEvent = module.exports = {
    trackFormErrors: function trackFormErrors(step, errors, category) {
        Object.keys(errors).forEach(function (field) {
            if (errors[field]) {
                tracking.trackFormError({
                    action: [category || 'checkout', step, field.toLowerCase()].join('|'),
                    label: errors[field].toLowerCase()
                });
            }
        });
    },
    triggerStaleLoginEvent: function triggerStaleLoginEvent(interaction) {
        var gaObj = trackHelpers.getGAVerificationObj(interaction);
        tracking.trackEvent(gaObj);
    },
    triggerFormInteractionEvent: function triggerFormInteractionEvent(interaction, additional) {
        fireFormInteractionEvent(authConstants.REGISTER, interaction, {}, additional);
    },
    triggerProceedToCheckoutEvent: function triggerProceedToCheckoutEvent(action, flow) {
        action = _.isUndefined(action) || action === authConstants.STALE_LOGIN_FLOW ? authConstants.LOGIN : action;
        switch (action) {
            case authConstants.LOGIN:
                action = flow === authConstants.STALE_LOGIN_FLOW ? 'verification' : '';
                break;
            case authConstants.FORGOT_PASSWORD:
                action = 'forgot password';
        }
        tracking.trackEvent({
            category: action.replace('-', ' '),
            action: action + ' form interaction',
            label: 'click on register link - proceed to checkout'
        });
    },
    triggerEmbeddedRegistrationEvent: function triggerEmbeddedRegistrationEvent(buyer, isNewUser) {
        if (isNewUser) {
            var steps = ['two', 'user-type'];
            var additional = trackHelpers.getAdditionalEmbeddedRegistrationGTM(buyer);
            steps.forEach(function (interaction) {
                return trackEvent.triggerFormInteractionEvent(interaction, additional);
            });
            trackEvent.triggerRegistrationEvent('complete');
        } else {
            trackEvent.triggerLoginCompleteEvent();
        }
    },
    triggerAction: function triggerAction(label) {
        tracking.trackEvent({
            category: 'checkout form actions',
            action: helpers.isNegotiable() ? 'offer' : 'order',
            label: label
        });
    },
    getItemStatusEventLabel: function getItemStatusEventLabel(item) {
        return [trackHelpers.getItemNegotiable(item), trackHelpers.getPrequotedShipping(item), trackHelpers.isReturnable(item)].join('|');
    },
    triggerServiceError: function triggerServiceError(label) {
        tracking.trackFormError({
            action: ['checkout', 'review', 'ecom'].join('|'),
            label: label
        });
    },
    triggerConfirmationAction: function triggerConfirmationAction(label) {
        return tracking.trackEvent({
            category: 'checkout confirmation actions',
            action: helpers.isNegotiable() ? 'offer' : 'order',
            label: label
        });
    },
    getEmailPurchaseAction: function getEmailPurchaseAction() {
        var subAction = helpers.isPrivateOffer() ? 'accept offer' : 'purchase';
        var action = 'email ' + subAction + ' button';
        var tmpl = get(URL, 'queryKey.e_tmpl');

        if (tmpl) {
            return action + ' - ' + tmpl.replace(/\+/g, ' ');
        } else {
            return action + ' - none';
        }
    },
    triggerEmailPurchaseEntry: function triggerEmailPurchaseEntry() {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        tracking.trackEvent({
            category: 'purchase click',
            action: trackEvent.getEmailPurchaseAction(),
            label: trackEvent.getItemStatusEventLabel(item)
        });
    },
    trackSidebarElementExpanded: function trackSidebarElementExpanded(elementName) {
        switch (elementName) {
            case 'promoCode':
                trackEvent.triggerPromoCodeExpanded();
                break;
            case 'returnPolicy':
                trackEvent.triggerReturnPolicyExpanded();
        }
    },
    trackAmpPurchaseButtonClick: function trackAmpPurchaseButtonClick(item) {
        var category = '';
        var action = 'pdp purchase button-amppage';
        var params = { label: trackHelpers.getPurchaseStatus(item) };
        PurchaseTracking.firePurchaseButtonTracking(item, category, action, params);
    },
    trackChatShow: function trackChatShow(step) {
        tracking.trackEvent({
            category: 'live chat',
            action: 'docked live chat expanded',
            label: step
        });
    },
    trackChatHide: function trackChatHide() {
        tracking.trackEvent({
            category: 'live chat',
            action: 'docked live chat closed'
        });
    },
    trackChatLoad: function trackChatLoad() {
        tracking.trackEvent({
            category: 'live chat',
            action: 'docked live chat displayed'
        });
    },

    triggerRegistrationEvent: _.partial(triggerCheckoutAuthModalEvent, authConstants.REGISTER),
    triggerLoginEntryEvent: _.partial(triggerCheckoutAuthModalEvent, authConstants.LOGIN, 'entry'),
    triggerLoginCompleteEvent: _.partial(triggerCheckoutAuthModalEvent, authConstants.LOGIN, 'complete'),
    triggerCheckoutEntryAction: _.partial(triggerCheckoutAction, 'entry'),
    triggerCheckoutSaved: _.partial(triggerCheckoutAction, 'saved'),
    triggerCheckoutCompleted: _.partial(triggerCheckoutAction, 'complete'),
    triggerCheckoutInteraction: _.partial(triggerCheckoutAction, 'form initiated'),
    triggerCheckoutSurveyDisplayed: _.partial(trackCheckoutSurvey, 'abandon checkout survey displayed'),
    triggerCheckoutSurveySubmitted: _.partial(trackCheckoutSurvey, 'abandon checkout survey submitted'),
    triggerReturnPolicyExpanded: _.partial(triggerFormInteractionAction, 'dealer return policy expanded'),
    triggerPromoCodeExpanded: _.partial(triggerFormInteractionAction, 'promo code section expanded'),
    triggerEmailUsClicked: _.partial(triggerFormInteractionAction, 'email us clicked'),
    triggerMarketplaceSupportClicked: _.partial(triggerFormInteractionAction, 'marketplace support link clicked'),
    triggerShippingHover: _.partial(triggerFormInteractionAction, 'shipping - to be quoted tooltip displayed'),
    triggerCustomsHover: _.partial(triggerFormInteractionAction, 'additional customs tooltip displayed'),
    triggerCustomsDisplayed: _.once(_.partial(triggerFormInteractionAction, 'customs on review step displayed')),
    triggerCustomsChecked: _.partial(triggerFormInteractionAction, 'customs on review step selected'),
    triggerCustomsReviewHover: _.partial(triggerFormInteractionAction, 'additional customs tooltip displayed on review step'),
    triggerCustomsLearnMoreClicked: _.partial(triggerFormInteractionAction, 'additional customs learn more clicked'),
    triggerCustomsReviewLearnMoreClicked: _.partial(triggerFormInteractionAction, 'additional customs learn more clicked on review step'),
    triggerBuyerAssuranceTooltipAction: _.partial(triggerFormInteractionAction, 'buyer protection popup expanded'),
    triggerBuyerAssuranceViewDetailsAction: _.partial(triggerFormInteractionAction, 'buyer protection popup link clicked'),
    triggerConfirmationDealerLinkClicked: _.partial(triggerClickToDealerStorefrontAction, 'checkout confirmation dealer link'),
    triggerConfirmationDealerViewAllClicked: _.partial(triggerClickToDealerStorefrontAction, 'checkout confirmation dealer highlights view storefront')
};

/***/ }),
/* 710 */,
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SV = __webpack_require__(18);
var tracking = __webpack_require__(27);

var FOLLOW_SEARCH_TRACKING_POSITION = 'save search - search/browse page - callout';
var FOLLOW_SEARCH_SAVE_LABEL = 'top of results - callout';

var FOLLOW_DEALER_TRACKING_POSITION = 'favorite dealer - dealer storefront - callout';
var FOLLOW_DEALER_SAVE_LABEL = 'sellers page - callout';

var SAVE_ITEM_TRACKING_POSITION = 'save item - search/browse page - callout';
var SAVE_ITEM_LABEL = 'search/browse - callout';

var SEARCH_BOX_LABEL = 'global search - callout';

var _isActive = false;
var isActiveSearchBox = false;

var calloutTracking = {
    getTracking: function getTracking() {
        return {
            followSearch: {
                login: {
                    trackingPosition: _isActive ? FOLLOW_SEARCH_TRACKING_POSITION : false
                },
                save: {
                    label: _isActive ? FOLLOW_SEARCH_SAVE_LABEL : false
                }
            },
            followDealer: {
                login: {
                    trackingPosition: _isActive ? FOLLOW_DEALER_TRACKING_POSITION : false
                },
                save: {
                    label: _isActive ? FOLLOW_DEALER_SAVE_LABEL : false
                }
            },
            saveItem: {
                login: {
                    trackingPosition: _isActive ? SAVE_ITEM_TRACKING_POSITION : false
                },
                save: {
                    label: _isActive ? SAVE_ITEM_LABEL : false
                }
            },
            searchBox: {
                open: {
                    label: isActiveSearchBox ? SEARCH_BOX_LABEL : false
                }
            }
        };
    },
    activateTracking: function activateTracking(active) {
        _isActive = !!active;
    },
    activateSearchBoxTracking: function activateSearchBoxTracking(active) {
        isActiveSearchBox = !!active;
    },
    isActive: function isActive() {
        return _isActive;
    },
    followSearch: function followSearch() {
        var category = 'search favoriting';
        var action = 'search favoriting callout displayed';
        var label = SV.get('tracking.initialDataLayerInfo.pageSubType');

        tracking.trackEvent({ category: category, action: action, label: label });
    },
    followDealer: function followDealer() {
        var category = 'dealer favoriting';
        var action = 'dealer favoriting callout displayed';
        var label = SV.get('tracking.initialDataLayerInfo.pageSubType');

        tracking.trackEvent({ category: category, action: action, label: label });
    },
    saveItem: function saveItem() {
        var category = 'item favoriting';
        var action = 'item favoriting callout displayed';
        var label = SV.get('tracking.initialDataLayerInfo.pageSubType');

        tracking.trackEvent({ category: category, action: action, label: label });
    },
    searchBox: function searchBox() {
        var category = 'search favoriting';
        var action = 'search feature callout displayed';
        var label = SV.get('tracking.initialDataLayerInfo.pageSubType');

        tracking.trackEvent({ category: category, action: action, label: label });
    }
};

module.exports = calloutTracking;

/***/ }),
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(1389),
    getRawTag = __webpack_require__(4006),
    objectToString = __webpack_require__(4017);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 718 */,
/* 719 */,
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(4059);
exports.encode = exports.stringify = __webpack_require__(4060);


/***/ }),
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(509);

/***/ }),
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SEARCH_ADDED = {
    category: 'search favoriting',
    action: 'search added'
};

var SEARCH_REMOVED = {
    category: 'search favoriting',
    action: 'search removed'
};

var DEALER_ADDED = {
    category: 'dealer favoriting',
    action: 'dealer added'
};

var DEALER_REMOVED = {
    category: 'dealer favoriting',
    action: 'dealer removed'
};

module.exports = {
    SEARCH: {
        TOP_OF_RESULTS: {
            save: Object.assign({ label: 'top of results' }, SEARCH_ADDED),
            remove: Object.assign({ label: 'top of results' }, SEARCH_REMOVED)
        },
        BROWSE_AUTH_MODAL: {
            ga: {
                label: 'save search - search/browse page'
            }
        },
        SOLD_PDP: {
            save: Object.assign({ label: 'PDP-Sold' }, SEARCH_ADDED),
            remove: Object.assign({ label: 'PDP-Sold' }, SEARCH_REMOVED)
        },
        SOLD_PDP_AUTH_MODAL: {
            ga: {
                label: 'save search - PDP-Sold'
            }
        }
    },
    DEALER: {
        MESSAGE_CENTER: {
            save: Object.assign({ label: 'message center' }, DEALER_ADDED),
            remove: Object.assign({ label: 'message center' }, DEALER_REMOVED)
        },
        SELLERS_PAGE: {
            save: Object.assign({ label: 'sellers page' }, DEALER_ADDED),
            remove: Object.assign({ label: 'sellers page' }, DEALER_REMOVED)
        },
        DEALER_STOREFRONT_AUTH_MODAL: {
            ga: {
                label: 'favorite dealer - dealer storefront'
            }
        },
        CONTACT_MODAL: {
            save: Object.assign({ label: 'contact dealer confirmation modal' }, DEALER_ADDED),
            remove: Object.assign({ label: 'contact dealer confirmation modal' }, DEALER_REMOVED)
        },
        PDP: {
            save: Object.assign({ label: 'pdp' }, DEALER_ADDED),
            remove: Object.assign({ label: 'pdp' }, DEALER_REMOVED)
        },
        PDP_AUTH_MODAL: {
            ga: {
                label: 'favorite dealer - product page'
            }
        }
    },
    DESIGNER: {
        PROFILE: {
            save: {
                category: 'trade firm favoriting',
                action: 'trade firm added',
                label: 'trade firm profile page'
            },
            remove: {
                category: 'trade firm favoriting',
                action: 'trade firm removed',
                label: 'trade firm profile page'
            }
        },
        AUTH_MODAL: {
            ga: {
                label: "follow trade firm"
            }
        }
    }
};

/***/ }),
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var User = __webpack_require__(15);
var pinterestUtils = __webpack_require__(744);

var _require = __webpack_require__(1153),
    NAME_PINTEREST = _require.NAME_PINTEREST;

var _require2 = __webpack_require__(282),
    localStorage = _require2.localStorage;

var gaTracking = __webpack_require__(27);
var LOCAL_STORAGE_NAMESPACE = 'pinterest';
var LOCAL_STORAGE_BANNER = 'connectAccountsBanner';
var LOCAL_STORAGE_MODAL = 'connectAccountsModal';
var IMPRESSION_COUNT = 3;

// Actions
var socialNetworkActions = __webpack_require__(2173);
var userSocialNetworkActions = __webpack_require__(3824);

// Stores
var PinterestStore = __webpack_require__(1113);
var SocialNetworkStore = __webpack_require__(987);
var UserSocialNetworkStore = __webpack_require__(988);

var getPinterestLocalStorageData = function getPinterestLocalStorageData() {
    return localStorage.getItem(LOCAL_STORAGE_NAMESPACE) || {};
};

var setPinterestLocalStorageData = function setPinterestLocalStorageData(data) {
    var pinterest = getPinterestLocalStorageData();
    localStorage.setItem(LOCAL_STORAGE_NAMESPACE, Object.assign(pinterest, data));
};

var pinterestActions = {
    _canShowPinterestBanner: function _canShowPinterestBanner(actionContext) {
        return pinterestActions.canShowConnectAccountPromotion(actionContext, {
            namespace: LOCAL_STORAGE_BANNER
        });
    },
    _canShowConnectAccountsModal: function _canShowConnectAccountsModal(actionContext) {
        return pinterestActions.canShowConnectAccountPromotion(actionContext, {
            namespace: LOCAL_STORAGE_MODAL
        });
    },
    _increaseConnectAccountsModalShowCount: function _increaseConnectAccountsModalShowCount() {
        var _getPinterestLocalSto = getPinterestLocalStorageData(),
            connectAccountsModal = _getPinterestLocalSto.connectAccountsModal;

        connectAccountsModal += 1;
        setPinterestLocalStorageData({ connectAccountsModal: connectAccountsModal });
    },
    _increaseBannerShowCount: function _increaseBannerShowCount() {
        var _getPinterestLocalSto2 = getPinterestLocalStorageData(),
            connectAccountsBanner = _getPinterestLocalSto2.connectAccountsBanner;

        connectAccountsBanner += 1;
        setPinterestLocalStorageData({ connectAccountsBanner: connectAccountsBanner });
    },
    canShowConnectAccountPromotion: function canShowConnectAccountPromotion(actionContext, _ref) {
        var namespace = _ref.namespace;

        var userSocialNetworkStore = actionContext.getStore(UserSocialNetworkStore);
        var socialNetworks = userSocialNetworkStore.getSocialNetworks(NAME_PINTEREST);

        var socialNetworkStore = actionContext.getStore(SocialNetworkStore);
        var pinterest = socialNetworkStore.getSocialNetwork(NAME_PINTEREST);

        if (!User.loggedIn()) {
            return Promise.reject();
        }

        // Pinterest is not accessible
        if (!pinterest) {
            return Promise.reject();
        }

        // Was ever connected before
        if (socialNetworks.length) {
            return Promise.reject();
        }

        // If namespace was not passed, then we do not need to check
        // impression count - resolving promise.
        if (!namespace) {
            return Promise.resolve();
        }

        var impressionCount = getPinterestLocalStorageData()[namespace];

        if (!impressionCount) {
            impressionCount = 0;
            setPinterestLocalStorageData(_defineProperty({}, namespace, impressionCount));
            return Promise.resolve();
        }

        if (impressionCount < IMPRESSION_COUNT) {
            return Promise.resolve();
        } else {
            return Promise.reject();
        }
    },
    initApp: function initApp(actionContext, payload, done) {
        actionContext.executeAction(socialNetworkActions.fetch).then(function () {
            var store = actionContext.getStore(SocialNetworkStore);
            var pinterest = store.getSocialNetwork(NAME_PINTEREST);
            var promise = void 0;

            if (pinterest) {
                var appId = pinterest.parameters.clientId;

                promise = pinterestUtils.init({ appId: appId });
            } else {
                promise = Promise.reject();
            }

            return promise;
        }).then(function () {
            return actionContext.executeAction(pinterestActions.setSession);
        }).then(function () {
            return done();
        }).catch(function (error) {
            return done(error);
        });
    },
    initAppAndGetBoards: function initAppAndGetBoards(actionContext, payload, done) {
        actionContext.executeAction(pinterestActions.initApp).then(function () {
            return actionContext.executeAction(pinterestActions.getBoards);
        }).then(function () {
            return done();
        }).catch(function (error) {
            return done(error);
        });
    },
    setSessionOnLoginChange: function setSessionOnLoginChange(actionContext, payload, done) {
        User.getCurrentUser().on('login:change', function () {
            actionContext.executeAction(pinterestActions.setSession).catch(function (error) {
                return done(error);
            });
        });

        done();
    },
    setSession: function setSession(actionContext, payload, done) {
        Promise.resolve(User.load()).then(function () {
            var store = actionContext.getStore(UserSocialNetworkStore);
            var pinterest = store.getConnectedSocialNetwork(NAME_PINTEREST);
            var promise = void 0;

            if (pinterest) {
                var _pinterest$userPrefer = pinterest.userPreferences,
                    accessToken = _pinterest$userPrefer.accessToken,
                    scope = _pinterest$userPrefer.scope;

                promise = pinterestUtils.setSession({ accessToken: accessToken, scope: scope });
            } else {
                promise = Promise.reject('User is not connected with ' + NAME_PINTEREST + ' social network.');
            }

            return promise;
        }).then(function (user) {
            actionContext.dispatch('pinterest:user:loaded', user);
            done();
        }).catch(function () {
            return done();
        });
    },
    connectAccounts: function connectAccounts(actionContext, payload, done) {
        var pinterestWindow = payload.pinterestWindow,
            tracking = payload.tracking;

        var socialNetworkStore = actionContext.getStore(SocialNetworkStore);
        var pinterest = socialNetworkStore.getSocialNetwork(NAME_PINTEREST);

        actionContext.executeAction(pinterestActions.hideConnectAccountsModal).then(function () {
            var clientId = pinterest && pinterest.parameters.clientId;
            return pinterestUtils.login({ pinterestWindow: pinterestWindow, clientId: clientId });
        }).then(function (session) {
            var name = NAME_PINTEREST;
            var data = { name: name, data: session };

            return actionContext.executeAction(userSocialNetworkActions.addSocialNetwork, data);
        }).then(function () {
            return actionContext.executeAction(pinterestActions.setSession);
        }).then(function () {
            return actionContext.executeAction(pinterestActions.showConnectBoardModal);
        }).then(function () {
            actionContext.executeAction(pinterestActions.track, tracking);
            done();
        }).catch(function (error) {
            pinterestUtils.logout();
            done(error);
        });
    },
    disconnectAccounts: function disconnectAccounts(actionContext, payload, done) {
        var tracking = payload.tracking;


        pinterestUtils.logout().then(function () {
            var name = NAME_PINTEREST;
            return actionContext.executeAction(userSocialNetworkActions.removeSocialNetwork, { name: name });
        }).then(function () {
            actionContext.executeAction(pinterestActions.track, tracking);
            actionContext.dispatch('pinterest:disconnected');
            done();
        }).catch(function (error) {
            return done(error);
        });
    },
    pin: function pin(actionContext, payload, done) {
        var pinterestWindow = payload.pinterestWindow,
            url = payload.url,
            media = payload.media,
            description = payload.description;

        pinterestUtils.pin({ pinterestWindow: pinterestWindow, url: url, media: media, description: description }).then(function () {
            return done();
        });
    },
    getBoards: function getBoards(actionContext, payload, done) {
        pinterestUtils.getBoards().then(function (boards) {
            actionContext.dispatch('pinterest:boards:loaded', boards);

            actionContext.executeAction(pinterestActions.getConnectedBoard).then(function () {
                return done();
            }).catch(function (error) {
                return done(error);
            });
        }).catch(function (error) {
            return done(error);
        });
    },
    createBoard: function createBoard(actionContext, payload, done) {
        var name = payload.name;


        var pinterestStore = actionContext.getStore(PinterestStore);
        var existingBoard = pinterestStore.getBoardByName(name);

        if (existingBoard) {
            done(null, existingBoard);
        } else {
            pinterestUtils.createBoard(name).then(function (board) {
                actionContext.dispatch('pinterest:boards:created', board);
                done(null, board);
            }).catch(function (error) {
                return done(error);
            });
        }
    },
    createAndConnectBoard: function createAndConnectBoard(actionContext, payload, done) {
        var name = payload.name;


        actionContext.executeAction(pinterestActions.createBoard, { name: name }).then(function (board) {
            return actionContext.executeAction(pinterestActions.connectBoard, board);
        }).then(function () {
            return done();
        }).catch(function (error) {
            actionContext.dispatch('pinterest:connectBoardModal:error');
            done(error);
        });
    },
    getConnectedBoard: function getConnectedBoard(actionContext, payload, done) {
        var userSocialNetworkStore = actionContext.getStore(UserSocialNetworkStore);
        var pinterest = userSocialNetworkStore.getConnectedSocialNetwork(NAME_PINTEREST);

        var pinterestStore = actionContext.getStore(PinterestStore);
        var boards = pinterestStore.getBoards();

        if (pinterest && boards.length) {
            var connectedBoard = boards.find(function (board) {
                return board.urlName === pinterest.userPreferences.board;
            });

            if (connectedBoard) {
                actionContext.dispatch('pinterest:board:connected', connectedBoard);
            }
        }

        done();
    },
    connectBoard: function connectBoard(actionContext, payload, done) {
        var id = payload.id;

        var store = actionContext.getStore(PinterestStore);
        var board = store.getBoard(id);

        if (board) {
            var userSocialNetworkStore = actionContext.getStore(UserSocialNetworkStore);
            var pinterest = userSocialNetworkStore.getConnectedSocialNetwork(NAME_PINTEREST);
            var data = Object.assign({}, pinterest.userPreferences, {
                board: board.urlName
            });

            actionContext.executeAction(userSocialNetworkActions.updateSocialNetwork, {
                name: NAME_PINTEREST,
                data: data
            }).then(function () {
                actionContext.dispatch('pinterest:board:connected', board);
                actionContext.executeAction(pinterestActions.hideConnectBoardModal);
                done();
            }).catch(function (error) {
                return done(error);
            });
        } else {
            done('Board with ' + id + ' was not found');
        }
    },
    showConnectModalAfterPinAdded: function showConnectModalAfterPinAdded(actionContext, payload, done) {
        var url = payload.url,
            tracking = payload.tracking;

        var pinCount = 0;

        pinterestActions._canShowConnectAccountsModal(actionContext).then(function () {
            pinterestUtils.getPinCount({ url: url }).then(function (count) {
                pinCount = count;
                return actionContext.executeAction(pinterestActions.pin, payload);
            }).then(function () {
                return pinterestUtils.getPinCount({ url: url });
            }).then(function (count) {
                if (pinCount !== count) {
                    pinterestActions._increaseConnectAccountsModalShowCount();
                    actionContext.executeAction(pinterestActions.showConnectAccountsModal);
                    actionContext.executeAction(pinterestActions.track, tracking);
                }
                done();
            });
        }).catch(function () {
            actionContext.executeAction(pinterestActions.pin, payload);
            done();
        });
    },


    /**
     * used in newPdp/components/Favorites/FavoritesSaveWidgetWrapperView.js to show pinterest banner
     * in save to portfolio widget.
     * @param  {Object}         payload
     * @param  {Object.model}   Backbone model to change attributes
     */
    showPinterestBanner: function showPinterestBanner(actionContext, payload, done) {
        var callback = payload.callback,
            tracking = payload.tracking;


        pinterestActions._canShowPinterestBanner(actionContext).then(function () {
            if (typeof callback === 'function') {
                callback();
                pinterestActions._increaseBannerShowCount();
                actionContext.executeAction(pinterestActions.track, tracking);
            }
            done();
        }).catch(function () {
            return done();
        });
    },


    // Sometimes pinterest pin count service does not work.
    // backup function if we decide to get rid of pin count check:
    // showConnectModalAfterPinAdded(actionContext, payload, done) {
    //     pinterestUtils.isLoggedIn()
    //         .then(() => {
    //             actionContext.executeAction(pinterestActions.pin, payload);
    //             done();
    //         })
    //         .catch(() => {
    //             actionContext
    //                 .executeAction(pinterestActions.pin, payload)
    //                 .then(() => {
    //                     pinterestActions
    //                         ._canShowConnectAccountsModal()
    //                         .then(() => {
    //                             actionContext.executeAction(pinterestActions.showConnectAccountsModal);
    //                             done();
    //                         })
    //                         .catch(() => done());
    //                 });
    //         });
    // },

    track: function track(actionContext, payload, done) {
        var category = payload.category,
            action = payload.action,
            label = payload.label;


        if (category && action && label) {
            gaTracking.trackEvent({ category: category, action: action, label: label });
        }

        done();
    },
    showConnectAccountsModal: function showConnectAccountsModal(actionContext, payload, done) {
        actionContext.dispatch('pinterest:connectAccountsModal:show');
        done();
    },
    hideConnectAccountsModal: function hideConnectAccountsModal(actionContext, payload, done) {
        actionContext.dispatch('pinterest:connectAccountsModal:hide');
        done();
    },
    showConnectBoardModal: function showConnectBoardModal(actionContext, payload, done) {
        actionContext.dispatch('pinterest:connectBoardModal:show');
        actionContext.executeAction(pinterestActions.getBoards).then(function () {
            return done();
        }).catch(function () {
            return done();
        });
    },
    hideConnectBoardModal: function hideConnectBoardModal(actionContext, payload, done) {
        actionContext.dispatch('pinterest:connectBoardModal:hide');
        done();
    }
};

module.exports = pinterestActions;

/***/ }),
/* 741 */,
/* 742 */,
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Relay = __webpack_require__(17);

var _require = __webpack_require__(324),
    getBuyerToken = _require.getBuyerToken;

var qs = __webpack_require__(42);

/**
 * Custom Network Layer that rebuilds the Uri for each GraphQL call in order to append buyer token upon login
 */

var CustomNetworkLayer = function (_Relay$DefaultNetwork) {
    _inherits(CustomNetworkLayer, _Relay$DefaultNetwork);

    function CustomNetworkLayer(uri, init) {
        _classCallCheck(this, CustomNetworkLayer);

        var getUri = void 0;

        if (typeof uri === 'function') {
            getUri = uri;
            uri = getUri();
        }

        var _this = _possibleConstructorReturn(this, (CustomNetworkLayer.__proto__ || Object.getPrototypeOf(CustomNetworkLayer)).call(this, uri, init));

        _this.getUri = (getUri || _this.getUri).bind(_this);
        return _this;
    }

    _createClass(CustomNetworkLayer, [{
        key: 'getUri',
        value: function getUri() {
            return this._uri;
        }
    }, {
        key: 'sendQueries',
        value: function sendQueries() {
            var _Relay$DefaultNetwork2;

            this._uri = this.getUri();
            return (_Relay$DefaultNetwork2 = Relay.DefaultNetworkLayer.prototype.sendQueries).call.apply(_Relay$DefaultNetwork2, [this].concat(Array.prototype.slice.call(arguments)));
        }
    }, {
        key: 'sendMutation',
        value: function sendMutation() {
            var _Relay$DefaultNetwork3;

            this._uri = this.getUri();
            return (_Relay$DefaultNetwork3 = Relay.DefaultNetworkLayer.prototype.sendMutation).call.apply(_Relay$DefaultNetwork3, [this].concat(Array.prototype.slice.call(arguments)));
        }
    }]);

    return CustomNetworkLayer;
}(Relay.DefaultNetworkLayer);

module.exports = function () {
    return new CustomNetworkLayer(function () {
        var _qs$parse = qs.parse(window.location.search.replace(/(^\?)/, '')),
            debugGraphQL = _qs$parse.debugGraphQL;

        var queryParams = Object.assign(getBuyerToken(document.cookie), debugGraphQL === 'true' ? { 'debug': 'true' } : {});

        return '/soa/graphql/?' + qs.stringify(queryParams);
    }, { fetchTimeout: 120000 });
};

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);
var map = __webpack_require__(342);
var widgetLoader = __webpack_require__(2178);

var querystring = __webpack_require__(720);
var getSocialWindowPosition = __webpack_require__(969);
var tokenReplace = __webpack_require__(87);

var SV = __webpack_require__(18);

var _SV$get = SV.get('settings'),
    siteProtocol = _SV$get.siteProtocol,
    fullDomain = _SV$get.fullDomain;

var site = siteProtocol + '://' + fullDomain;

var PIN_COUNT = 'https://api.pinterest.com/v1/urls/count.json?callback=?';
var OAUTH_REDIRECT = '' + site;
var PINTEREST_SCOPE = 'read_public,write_public';

var pinterest = {
    _load: function _load() {
        return widgetLoader.load('pinterest');
    },
    _addBoardUrlName: function _addBoardUrlName(board) {
        var url = board.url;

        var split = url.split('/').reverse();
        board.urlName = split[2] + '/' + split[1];
        return board;
    },
    _listenWindowClose: function _listenWindowClose(pinterestWindow) {
        return new Promise(function (resolve) {
            var interval = setInterval(function () {
                try {
                    if (pinterestWindow === null || pinterestWindow.closed) {
                        clearInterval(interval);
                        resolve();
                    }
                } catch (e) {
                    resolve();
                }
            }, 500);
        });
    },
    openWindow: function openWindow() {
        var width = 665;
        var height = 500;
        var windowOptions = {
            scrollbars: 'yes',
            resizable: 'no',
            toolbar: 'no',
            height: height,
            width: width,
            top: 0,
            left: 0
        };

        Object.assign(windowOptions, getSocialWindowPosition(height, width));
        return window.open('', 'pinterest', querystring.stringify(windowOptions, ','));
    },
    getPinCount: function getPinCount() {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var url = payload.url;


        return new Promise(function (resolve, reject) {
            $.ajax({
                url: PIN_COUNT,
                data: { url: url },
                success: function success(data) {
                    resolve(data.count);
                },
                error: function error(err) {
                    reject(err);
                },

                dataType: 'jsonp'
            });
        });
    },
    init: function init() {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var appId = payload.appId;

        var cookie = false;

        return new Promise(function (resolve) {
            pinterest._load().then(function (PDK) {
                PDK.init({ appId: appId, cookie: cookie });
                resolve();
            });
        });
    },
    isLoggedIn: function isLoggedIn() {
        return new Promise(function (resolve, reject) {
            pinterest._load().then(function (PDK) {
                var isLoggedIn = !!PDK.getSession();

                if (isLoggedIn) {
                    resolve();
                } else {
                    reject();
                }
            });
        });
    },
    login: function login() {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var pinterestWindow = payload.pinterestWindow,
            clientId = payload.clientId;

        var loginUrl = 'https://api.pinterest.com/oauth/?client_id=' + clientId + '&redirect_uri=' + OAUTH_REDIRECT + '&scope=' + PINTEREST_SCOPE + '&redirect_type=js&response_type=token';
        pinterestWindow.location = loginUrl;

        return new Promise(function (resolve, reject) {
            var listener = function listener(event) {
                var origin = event.origin,
                    data = event.data;

                if (origin === 'https://api.pinterest.com') {
                    if (data && data.access_token) {
                        resolve({
                            accessToken: data.access_token,
                            scope: PINTEREST_SCOPE
                        });
                    } else {
                        reject();
                    }

                    window.removeEventListener('message', listener);
                    pinterestWindow.close();
                }
            };

            window.addEventListener('message', listener);

            pinterest._listenWindowClose(pinterestWindow).then(function () {
                window.removeEventListener('message', listener);
                reject();
            });
        });
    },
    logout: function logout() {
        return new Promise(function (resolve, reject) {
            pinterest._load().then(function (PDK) {
                PDK.logout(function () {
                    var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    var session = response.session;


                    if (session) {
                        reject('Logout failed.');
                    } else {
                        resolve(session);
                    }
                });
            });
        });
    },
    setSession: function setSession(session) {
        return new Promise(function (resolve, reject) {
            pinterest._load().then(function (PDK) {
                PDK.setSession(session);

                pinterest.getUser().then(function (user) {
                    return resolve(user);
                }).catch(function (error) {
                    return reject(error);
                });
            });
        });
    },
    getUser: function getUser() {
        return new Promise(function (resolve, reject) {
            pinterest._load().then(function (PDK) {
                PDK.me(function (response) {
                    var error = response.error,
                        user = response.data;


                    if (user) {
                        user.username = user.url.split('/').reverse()[1];
                        resolve(user);
                    } else if (error) {
                        reject(error);
                    }
                });
            });
        });
    },
    pin: function pin() {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var PINTEREST_URL = 'https://pinterest.com/pin/create/button/?url={url}&media={media}&description={description}';
        var pinterestWindow = payload.pinterestWindow,
            url = payload.url,
            media = payload.media,
            description = payload.description;


        pinterestWindow.location = tokenReplace(PINTEREST_URL, { url: url, media: media, description: description });
        return pinterest._listenWindowClose(pinterestWindow);
    },
    getBoards: function getBoards() {
        return new Promise(function (resolve, reject) {
            pinterest._load().then(function (PDK) {
                PDK.me('boards', function (response) {
                    var error = response.error,
                        boards = response.data;


                    if (boards) {
                        map(boards, function (board) {
                            return pinterest._addBoardUrlName(board);
                        });

                        resolve(boards);
                    } else if (error) {
                        reject(error);
                    }
                });
            });
        });
    },
    createBoard: function createBoard(name) {
        return new Promise(function (resolve, reject) {
            pinterest._load().then(function (PDK) {
                PDK.request('boards', 'POST', { name: name }, function (response) {
                    var error = response.error,
                        board = response.data;


                    if (board) {
                        resolve(pinterest._addBoardUrlName(board));
                    } else {
                        reject(error);
                    }
                });
            });
        });
    }
};

module.exports = pinterest;

/***/ }),
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * User: daletan
 * Date: 1/13/16
 * Time: 11:24 AM
 * Copyright 1stdibs.com, Inc. 2016. All Rights Reserved.
 */



__webpack_require__(3913);
__webpack_require__(3912);


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: daletan
 * Date: 7/21/14
 * Time: 1:21 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 *
 * moved from: 1stdibs.com/dibs/assets/js/global/core/commonjs/dibsCookies.js
 *
 * formerly:
 * js/global/core/dibs.js#cookieDomain
 * js/global/core/dibs.js#defaultCookieSettings
 * js/global/core/dibs.js#cookies
 *
 * dibs.cookieDomain
 * dibs.defaultCookieSettings
 * dibs.cookies
 */



var root = __webpack_require__(102);
var doc = root.document || {};
var location = doc.location || {};
var hostName = location.hostname || '';
var cookies = doc.cookie || '';
var exports = {};

/**
 * Still expose this for testing
 */
exports.cookieDomainFn = function (d) {
    var arr = d.split('.');
    var len = arr.length;
    var str = ".";

    if (len > 2) {
        str += arr[len - 2] + '.' + arr[len - 1];
    } else {
        str += arr.join('.');
    }
    return str;
};

/**
 * Still expose this for testing, though this one is tough for testing
 * since it cookies can change from env to env
 */
exports.cookiesFn = function () {
    var x = cookies.split(';');
    var len = x.length;
    var c = {};
    var value;
    var key;
    while (len--) {
        value = x[len].split('=');
        key = value.shift().replace(/(^\s+|\s+$)/g, '');
        c[key] = decodeURIComponent(value.join('='));
    }
    return c;
};

exports.TEST_COOKIE = 'testcookie';

exports.isEnabled = function () {
    var isCookiesEnabled;
    if (this.getCookie().indexOf(this.TEST_COOKIE + '=') > -1) {
        return true;
    }
    this.setCookie(this.TEST_COOKIE + "=1");
    isCookiesEnabled = this.getCookie().indexOf(this.TEST_COOKIE) > -1;
    this.setCookie(this.TEST_COOKIE + "=1; expires=Thu, 01-Jan-1970 00:00:01 GMT");
    return isCookiesEnabled;
};

// wrapper for test mocking
exports.getCookie = function () {
    return doc.cookie;
};

// wrapper for test mocking
exports.setCookie = function (cookie) {
    doc.cookie = cookie;
};

exports.cookieDomain = exports.cookieDomainFn(hostName);
exports.cookies = exports.cookiesFn();

exports.defaultCookieSettings = {
    path : '/',
    domain : exports.cookieDomain
};

module.exports = exports;


/***/ }),
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(282),
    localStorage = _require.localStorage,
    sessionStorage = _require.sessionStorage;

var tourActions = {
    increaseStep: function increaseStep(actionContext, payload, done) {
        var type = payload.type;

        actionContext.dispatch('tour:step:increase', type);
        done();
    },
    openTour: function openTour(actionContext, payload, done) {
        var type = payload.type;

        actionContext.dispatch('tour:open', type);
        done();
    },
    closeTour: function closeTour(actionContext, payload, done) {
        var type = payload.type;

        actionContext.dispatch('tour:close', type);
        done();
    },
    setSession: function setSession(actionContext, payload, done) {
        var type = payload.type;

        sessionStorage.setItem(type, true);
        done();
    },
    increaseSession: function increaseSession(actionContext, payload, done) {
        var type = payload.type;

        var storage = localStorage.getItem(type) || 0;
        localStorage.setItem(type, storage + 1);
        done();
    }
};

module.exports = tourActions;

/***/ }),
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var User = __webpack_require__(15);
var SV = __webpack_require__(18);
var FavoriteModel = __webpack_require__(378);

var _require = __webpack_require__(137),
    _require$URL = _require.URL,
    queryKey = _require$URL.queryKey,
    PAGE = _require$URL.relative;

var FAVORITE_TRACKING = __webpack_require__(734);
var favoritePageActions = __webpack_require__(839);

var alreadyForced = false;

var forceFavorite = {
    QUERY_PARAM: 'follow',
    TYPE_SEARCH: 'search',
    TYPE_DEALER: 'dealer',
    TYPE_ITEM: 'item',

    /**
     * @param {String} payload.type                 type of favorite [search|dealer|item]
     * @param {Object} payload.heartEl              dom el of save button
     * @param {Boolean} payload.isFavorited
     */
    init: function init(payload) {
        var _this = this;

        var type = payload.type,
            heartEl = payload.heartEl,
            actionContext = payload.actionContext;

        // new PDP calls this multiple times, need to make sure that we have all the data and execute it just once for visible view

        if (!this.isTypeForced(type) || alreadyForced || !actionContext && !heartEl) {
            return;
        }

        User.handleEmailToken().always(function () {
            return _this._forceFavorite(payload);
        });

        alreadyForced = true;
    },


    /**
     * Checks if query param to enforce follow type is there
     *
     * @param {String} type     type of favorite [search|dealer|item]
     * @return {Boolean}
     */
    isTypeForced: function isTypeForced(type) {
        return queryKey[this.QUERY_PARAM] === type;
    },


    /**
     * @param {String} payload.type             type of favorite [search|dealer|item]
     * @param {Object} payload.saveButtonView   Backbone.view of save button
     * @param {Object} payload.saveWidgetView   Backbone.view of save widget
     * @private
     */
    _forceFavorite: function _forceFavorite(payload) {
        var type = payload.type,
            heartEl = payload.heartEl,
            isFavorited = payload.isFavorited,
            actionContext = payload.actionContext;


        switch (type) {
            case this.TYPE_SEARCH:
                actionContext.dispatch('favoritePage:forceSuccess', {
                    type: FavoriteModel.TYPE_SEARCH,
                    value: true
                });
                actionContext.executeAction(favoritePageActions.saveToFavorites, {
                    solrQuery: SV.get('data.sq'),
                    page: PAGE,
                    type: FavoriteModel.TYPE_SEARCH,
                    tracking: FAVORITE_TRACKING.SEARCH.TOP_OF_RESULTS.save,
                    authModalOptions: FAVORITE_TRACKING.SEARCH.BROWSE_AUTH_MODAL
                }).then(function () {
                    actionContext.dispatch('favoritePage:forceSuccess', {
                        type: FavoriteModel.TYPE_SEARCH,
                        value: false
                    });
                });
                break;

            case this.TYPE_DEALER:
                actionContext.executeAction(favoritePageActions.saveToFavorites, {
                    primaryKey: SV.get('data.seller.pk'),
                    type: FavoriteModel.TYPE_DEALER,
                    tracking: FAVORITE_TRACKING.DEALER.SELLERS_PAGE.save,
                    authModalOptions: FAVORITE_TRACKING.DEALER.DEALER_STOREFRONT_AUTH_MODAL
                });
                break;

            case this.TYPE_ITEM:
                if (!User.loggedIn() || !isFavorited) {
                    this._triggerViewClick(heartEl);
                }
                break;
        }
    },


    /**
     * @param {Object} heartEl   dom node of save button
     * @private
     */
    _triggerViewClick: function _triggerViewClick(heartEl) {
        heartEl.click();
    }
};

module.exports = forceFavorite;

/***/ }),
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.setObservableConfig = exports.createEventHandler = exports.mapPropsStream = exports.componentFromStream = exports.hoistStatics = exports.nest = exports.componentFromProp = exports.createSink = exports.createEagerFactory = exports.createEagerElement = exports.isClassComponent = exports.shallowEqual = exports.wrapDisplayName = exports.getDisplayName = exports.compose = exports.setDisplayName = exports.setPropTypes = exports.setStatic = exports.toClass = exports.lifecycle = exports.getContext = exports.withContext = exports.onlyUpdateForPropTypes = exports.onlyUpdateForKeys = exports.pure = exports.shouldUpdate = exports.renderNothing = exports.renderComponent = exports.branch = exports.withReducer = exports.withState = exports.flattenProp = exports.renameProps = exports.renameProp = exports.defaultProps = exports.withHandlers = exports.withPropsOnChange = exports.withProps = exports.mapProps = undefined;

var _mapProps2 = __webpack_require__(1103);

var _mapProps3 = _interopRequireDefault(_mapProps2);

var _withProps2 = __webpack_require__(661);

var _withProps3 = _interopRequireDefault(_withProps2);

var _withPropsOnChange2 = __webpack_require__(4146);

var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);

var _withHandlers2 = __webpack_require__(4145);

var _withHandlers3 = _interopRequireDefault(_withHandlers2);

var _defaultProps2 = __webpack_require__(4130);

var _defaultProps3 = _interopRequireDefault(_defaultProps2);

var _renameProp2 = __webpack_require__(4138);

var _renameProp3 = _interopRequireDefault(_renameProp2);

var _renameProps2 = __webpack_require__(4139);

var _renameProps3 = _interopRequireDefault(_renameProps2);

var _flattenProp2 = __webpack_require__(1548);

var _flattenProp3 = _interopRequireDefault(_flattenProp2);

var _withState2 = __webpack_require__(4148);

var _withState3 = _interopRequireDefault(_withState2);

var _withReducer2 = __webpack_require__(4147);

var _withReducer3 = _interopRequireDefault(_withReducer2);

var _branch2 = __webpack_require__(4126);

var _branch3 = _interopRequireDefault(_branch2);

var _renderComponent2 = __webpack_require__(4140);

var _renderComponent3 = _interopRequireDefault(_renderComponent2);

var _renderNothing2 = __webpack_require__(4141);

var _renderNothing3 = _interopRequireDefault(_renderNothing2);

var _shouldUpdate2 = __webpack_require__(1951);

var _shouldUpdate3 = _interopRequireDefault(_shouldUpdate2);

var _pure2 = __webpack_require__(4137);

var _pure3 = _interopRequireDefault(_pure2);

var _onlyUpdateForKeys2 = __webpack_require__(2283);

var _onlyUpdateForKeys3 = _interopRequireDefault(_onlyUpdateForKeys2);

var _onlyUpdateForPropTypes2 = __webpack_require__(4136);

var _onlyUpdateForPropTypes3 = _interopRequireDefault(_onlyUpdateForPropTypes2);

var _withContext2 = __webpack_require__(4144);

var _withContext3 = _interopRequireDefault(_withContext2);

var _getContext2 = __webpack_require__(4131);

var _getContext3 = _interopRequireDefault(_getContext2);

var _lifecycle2 = __webpack_require__(4132);

var _lifecycle3 = _interopRequireDefault(_lifecycle2);

var _toClass2 = __webpack_require__(2010);

var _toClass3 = _interopRequireDefault(_toClass2);

var _setStatic2 = __webpack_require__(1950);

var _setStatic3 = _interopRequireDefault(_setStatic2);

var _setPropTypes2 = __webpack_require__(4143);

var _setPropTypes3 = _interopRequireDefault(_setPropTypes2);

var _setDisplayName2 = __webpack_require__(4142);

var _setDisplayName3 = _interopRequireDefault(_setDisplayName2);

var _compose2 = __webpack_require__(672);

var _compose3 = _interopRequireDefault(_compose2);

var _getDisplayName2 = __webpack_require__(1947);

var _getDisplayName3 = _interopRequireDefault(_getDisplayName2);

var _wrapDisplayName2 = __webpack_require__(4149);

var _wrapDisplayName3 = _interopRequireDefault(_wrapDisplayName2);

var _shallowEqual2 = __webpack_require__(1550);

var _shallowEqual3 = _interopRequireDefault(_shallowEqual2);

var _isClassComponent2 = __webpack_require__(1948);

var _isClassComponent3 = _interopRequireDefault(_isClassComponent2);

var _createEagerElement2 = __webpack_require__(2281);

var _createEagerElement3 = _interopRequireDefault(_createEagerElement2);

var _createEagerFactory2 = __webpack_require__(667);

var _createEagerFactory3 = _interopRequireDefault(_createEagerFactory2);

var _createSink2 = __webpack_require__(4129);

var _createSink3 = _interopRequireDefault(_createSink2);

var _componentFromProp2 = __webpack_require__(4127);

var _componentFromProp3 = _interopRequireDefault(_componentFromProp2);

var _nest2 = __webpack_require__(4134);

var _nest3 = _interopRequireDefault(_nest2);

var _hoistStatics2 = __webpack_require__(591);

var _hoistStatics3 = _interopRequireDefault(_hoistStatics2);

var _componentFromStream2 = __webpack_require__(2280);

var _componentFromStream3 = _interopRequireDefault(_componentFromStream2);

var _mapPropsStream2 = __webpack_require__(4133);

var _mapPropsStream3 = _interopRequireDefault(_mapPropsStream2);

var _createEventHandler2 = __webpack_require__(4128);

var _createEventHandler3 = _interopRequireDefault(_createEventHandler2);

var _setObservableConfig2 = __webpack_require__(1549);

var _setObservableConfig3 = _interopRequireDefault(_setObservableConfig2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.mapProps = _mapProps3.default; // Higher-order component helpers

exports.withProps = _withProps3.default;
exports.withPropsOnChange = _withPropsOnChange3.default;
exports.withHandlers = _withHandlers3.default;
exports.defaultProps = _defaultProps3.default;
exports.renameProp = _renameProp3.default;
exports.renameProps = _renameProps3.default;
exports.flattenProp = _flattenProp3.default;
exports.withState = _withState3.default;
exports.withReducer = _withReducer3.default;
exports.branch = _branch3.default;
exports.renderComponent = _renderComponent3.default;
exports.renderNothing = _renderNothing3.default;
exports.shouldUpdate = _shouldUpdate3.default;
exports.pure = _pure3.default;
exports.onlyUpdateForKeys = _onlyUpdateForKeys3.default;
exports.onlyUpdateForPropTypes = _onlyUpdateForPropTypes3.default;
exports.withContext = _withContext3.default;
exports.getContext = _getContext3.default;
exports.lifecycle = _lifecycle3.default;
exports.toClass = _toClass3.default;

// Static property helpers

exports.setStatic = _setStatic3.default;
exports.setPropTypes = _setPropTypes3.default;
exports.setDisplayName = _setDisplayName3.default;

// Composition function

exports.compose = _compose3.default;

// Other utils

exports.getDisplayName = _getDisplayName3.default;
exports.wrapDisplayName = _wrapDisplayName3.default;
exports.shallowEqual = _shallowEqual3.default;
exports.isClassComponent = _isClassComponent3.default;
exports.createEagerElement = _createEagerElement3.default;
exports.createEagerFactory = _createEagerFactory3.default;
exports.createSink = _createSink3.default;
exports.componentFromProp = _componentFromProp3.default;
exports.nest = _nest3.default;
exports.hoistStatics = _hoistStatics3.default;

// Observable helpers

exports.componentFromStream = _componentFromStream3.default;
exports.mapPropsStream = _mapPropsStream3.default;
exports.createEventHandler = _createEventHandler3.default;
exports.setObservableConfig = _setObservableConfig3.default;

/***/ }),
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Created by james on 6/4/14.
 */


// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);
var Clump = __webpack_require__(23);
var bunsenLib = __webpack_require__(21);
var serverVars = __webpack_require__(18);
var getDeferredMethods = __webpack_require__(299);
var requ = __webpack_require__(1159);
var assert = __webpack_require__(31);

// ---------------------------------------------------
// Local Vars

var deferred = getDeferredMethods().Deferred;
var when = getDeferredMethods().when;

// ---------------------------------------------------
// Module Definition

var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

/**
 * @class DataProviderHelper
 * @inner
 */
var DataProviderHelper = function () {
    this._clumper = new Clump();
    this._promises = {};
    this._data = _.extend({}, serverVars);
    this._configs = [];
    this.shouldUseClump = true;
    this.addTokenToRequests = true;
};

/**
 *
 * SEE THIS GIST FOR MORE DETAILED USAGE:
 * https://gist.github.com/jballant/94378c1337b225cc7aa4
 *
 * var dataProvider = require('dataProvider');
 *
 * dataProvider = dataProvider();
 * dataProvider.addAsyncConfigs([
 *  {
 *    KEY: 'FOO',
 *    url: 'soa/endpoint',
 *    queryParams: {
 *      foo: 123
 *    }
 *  },
 *  {
 *     KEY: 'KEY_NAME'
 *     makeRequest: function (clump) {
 *          return GeoData().fetch({ clump: clump });
 *     },
 *     getDataOnResolve: function () {
 *          return geoData
 *     }
 *  }])
 *
 *  dataProvider.fetchAsyncData().done(function () {
 *      view.render().appendTo('body');
 *  });;
 *
 *  View.render = function () {
 *      var str = dataProvider.get('KEY_NAME');
 *      this.$el.html(str);
 *  }
 *
 */

_.extend(DataProviderHelper.prototype, /** @lends DataProviderHelper.prototype */{

    _transport: requ,

    /**
     * @type {function(new:DataProviderHelper)}
     */
    Construct: DataProviderHelper,

    /**
     * Add configurations for async data.
     *
     * See addAsyncConfig docs for more info
     * @public
     * @param configs
     * @returns {DataProviderHelper}
     */
    addAsyncConfigs: function (configs) {
        _.each(configs, this.addAsyncConfig, this);
        return this;
    },

    /**
     * Add a configuration for async data (data
     * that needs to be retrieved from the server
     * and doesn't already exist on serverVars).
     *
     * @public
     * @param {object} config
     *
     * @param {string} config.KEY
     *      The key needed to access the data, if it
     *      already exists,
     * @param {string} [config.url]
     *      The url to retrieve the data from, if
     *      you want the dataProvider to handle fetching
     *      the data
     * @param {object} [config.queryParams]
     *      The query params you want to add to the
     *      url, if you want the dataProvider to handle
     *      fetching the data
     * @param {string} [config.resultKey]
     *      If the dataProvider is handling the data
     *      fetching, the response may have the actual
     *      object you want to use as your data in a
     *      sub-object of 'result'. Specify that key
     *      with this option.
     * @param {function} [config.makeRequest]
     *      If you want dataProvider to delegate
     *      making the request to a custom function,
     *      use this option. Your callback will be
     *      passed a clump object you can add a
     *      request to
     * @param {function} [config.getDataOnResolve]
     *      Once a request has resolved, you can have
     *      the dataProvider delegate determining
     *      what that object is with this callback,
     *      your function should return what you want
     *      to be used as the data.
     * @param {function} [config.context]
     *      For the makeRequest and getDataOnResolve
     *      functions, you can specify a context for
     *      these callbacks with this option.
     *
     * @returns {DataProviderHelper}
     */
    addAsyncConfig: function (config) {
        if (!config.KEY) {
            console.error('dataProvider: KEY is required for an async config: ', config);
        }
        if (this._data[config.KEY]) {
            console.log('dataProvider: Skipping async config. Data for key ' + config.KEY + ' already exists:', config);
            return this;
        }
        var existingConfig = this.getConfigForKey(config.KEY);
        if (existingConfig) {
            if (existingConfig !== config) {
                console.error('dataProvider: Cannot add new config. Config with key ' + existingConfig.KEY + ' already exists:', [config, existingConfig]);
            }
            return this;
        }
        this._configs.push(config);
        return this;
    },

    asyncDataMakeXHR: function (options) {
        options = _.extend({
            type: 'GET',
            dataType: 'json'
        }, options);
        if (this.shouldUseClump) {
            return this._clumper.add(options);
        }
        return this._transport(options);
    },

    /**
     * Returns data matching a key. Note that
     * you can use 'dot' notation to retrieve
     * nested objects, and if a parent object
     * is null or undefined, then null/undefined
     * will be returned.
     * @public
     * @param {string} key
     * @returns {*}
     */
    get: function (key) {
        assert(typeof key === 'string', 'key must be a string');
        var segs = key.split('.');
        var seg = segs.shift();
        var data = this._data;
        while (seg) {
            data = data[seg];
            seg = segs.shift();
            if (seg && (!data || typeof data !== 'object')) {
                return undefined;
            }
        }
        return data;
    },

    /**
     * @public
     * @param {string} key
     * @returns {object}
     */
    getConfigForKey: function (key) {
        return _.findWhere(this._configs, { KEY: key });
    },

    /**
     * @public
     * @param {string} key
     * @param {object} data
     * @param {object} options
     * @returns {DataProviderHelper}
     */
    setDataForKey: function (key, data, options) {
        options = options || {};
        var config;

        if (options.parse) {
            config = this.getConfigForKey(key);
            if (config) {
                data = this.parseResultForConfig(config, data);
            }
        }

        this._data[key] = data;
        return this;
    },

    getPromiseForKey: function (key) {
        return this._promises[key];
    },

    setPromiseForKey: function (key, promise) {
        this._promises[key] = promise;
        return this;
    },

    setClump: function (clump) {
        this._clumper = clump;
        return this;
    },

    getClump: function () {
        return this._clumper;
    },

    isFetchingAsyncData: function () {
        var proms = this._promises;
        var i = 0;
        var len = this._promises.length;
        for (i; i < len; i++) {
            if (proms[i].state() === 'pending') {
                return true;
            }
        }
        return false;
    },

    parseResultForConfig: function (config, response) {
        if (config && _.isFunction(config.getDataOnResolve)) {
            return config.getDataOnResolve.call(config.context, response);
        }
        var rawResult = response ? response.result : null;
        if (rawResult && config.resultKey) {
            return rawResult[config.resultKey];
        }
        return rawResult;
    },

    /**
     * Fetch all data that has been registered
     * as an async data dependency with
     * addAsyncConfig/addAsyncConfigs. Makes a
     * clump call automatically by default, but
     * a custom clump instance can be provided.
     * @public
     * @param {object} options
     * @param {Clump} [options.clump]
     * @param {boolean} [options.runClump=true]
     * @returns {Deferred.promise}
     */
    fetchAsyncData: function (options) {
        options = options || {};
        var dfd = deferred();
        if (options.clump) {
            this.setClump(options.clump);
        }
        _.each(this._configs, function (config) {
            this.fetchAsyncDataForKey(config.KEY);
        }, this);
        if (this.shouldUseClump && options.runClump !== false) {
            this._clumper.run();
        }
        when.apply(null, _.values(this._promises)).done(function () {
            dfd.resolve.apply(dfd, arguments);
        }).fail(function () {
            dfd.reject.apply(dfd, arguments);
        });
        return dfd.promise();
    },

    /**
     * @public
     * @param {string} key
     * @returns {Deferred.promise}
     */
    fetchAsyncDataForKey: function (key) {
        var config = this.getConfigForKey(key);
        var dfd = deferred();
        var self = this;
        var token = this.addTokenToRequests ? bunsenLib.getToken() : {};
        var xhr;
        var ajaxOpts;
        var queryParamData;
        var prom;

        if (this.get(key)) {
            return deferred().resolve(this.get(key)).promise();
        }

        if (!config) {
            return null;
        }

        // Call custom make request function if present, passing clump instance
        if (_.isFunction(config.makeRequest)) {
            xhr = config.makeRequest.call(config.context, self.shouldUseClump ? self._clumper : null);
        } else {
            // get the query params for the ajax request
            // user is allowed to make queryParams a function
            // that returns an object of query params
            queryParamData = _.isFunction(config.queryParams) ? config.queryParams.call(config.context) : config.queryParams;
            // combine them with the user token
            queryParamData = _.extend({}, token, queryParamData);
            // Otherwise use the config to make an ajax request
            ajaxOpts = {
                url: config.url,
                data: queryParamData
            };
            xhr = self.asyncDataMakeXHR(ajaxOpts);
        }

        if (xhr) {
            xhr
                .done(function (response) {
                    var result = self.parseResultForConfig(config, response);
                    self.setDataForKey(key, result);
                    dfd.resolve(result);
                })
                .fail(function () {
                    dfd.reject.apply(dfd, arguments);
                });
            prom = dfd.promise().always(function () {
                self.setPromiseForKey(key, null);
            });
            self.setPromiseForKey(key, prom);
            return prom;
        }
        return null;
    }

});

/**
 * @module dataProvider
 * @type {DataProviderHelper}
 */
module.exports = root.bunsen.DP = new DataProviderHelper();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-plus'].join(' '), 'data-tn': 'plus', viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M117,118 L7.4990045,118 C3.35670226,118 0,121.357864 0,125.5 C0,129.633707 3.35741867,133 7.4990045,133 L117,133 L117,242.500996 C117,246.643298 120.357864,250 124.5,250 C128.633707,250 132,246.642581 132,242.500996 L132,133 L242.500996,133 C246.643298,133 250,129.642136 250,125.5 C250,121.366293 246.642581,118 242.500996,118 L132,118 L132,7.4990045 C132,3.35670226 128.642136,0 124.5,0 C120.366293,0 117,3.35741867 117,7.4990045 L117,118 Z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * created function and arguments from `start` and beyond provided as
 * an array.
 *
 * **Note:** This method is based on the
 * [rest parameter](https://mdn.io/rest_parameters).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Function
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.rest(function(what, names) {
 *   return what + ' ' + _.initial(names).join(', ') +
 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
 * });
 *
 * say('hello', 'fred', 'barney', 'pebbles');
 * // => 'hello fred, barney, & pebbles'
 */
function rest(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  start = start === undefined ? start : toInteger(start);
  return baseRest(func, start);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = rest;


/***/ }),
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(124);

/***/ }),
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var User = __webpack_require__(15);
var FavoriteModel = __webpack_require__(378);

// Actions
var favoritesActions = __webpack_require__(1361);

// Store
var FavoritePageStore = __webpack_require__(502);

var favoritePageActions = {
    fetchFavoritePage: function fetchFavoritePage(actionContext, payload, done) {
        var _payload$resetCollect = payload.resetCollection,
            resetCollection = _payload$resetCollect === undefined ? false : _payload$resetCollect,
            type = payload.type,
            page = payload.page,
            solrQuery = payload.solrQuery;

        var store = actionContext.getStore(FavoritePageStore);
        var collection = store.getCollection();

        if (store.isLoading(type)) {
            done();
        } else {
            collection.setParam('userIds', User.getUserId());
            collection.setParam('queries', solrQuery);
            collection.setParam('types', type);

            if (type === FavoriteModel.TYPE_SEARCH) {
                collection.setParam('queries', solrQuery);
                collection.setParam('pages', null);
            } else {
                collection.setParam('pages', page);
            }

            actionContext.dispatch('favoritePage:fetch:start', { type: type });

            collection.fetchWithParameters({ reset: resetCollection, remove: false }).always(function () {
                var model = collection.last();
                actionContext.dispatch('favoritePage:fetch:end', { type: type });
                actionContext.dispatch('favorites:favorite:add', model);
                done();
            });
        }
    },
    saveToFavorites: function saveToFavorites(actionContext, payload, done) {
        var type = payload.type,
            page = payload.page;


        actionContext.executeAction(favoritesActions.saveToFavorites, payload).then(function (model) {
            actionContext.dispatch('favorites:favorite:add', model);
            done();
        }).catch(function (error) {
            // Already favorited
            if (error && error.status === 409) {
                actionContext.executeAction(favoritePageActions.fetchFavoritePage, { type: type, page: page }, done);
            } else {
                actionContext.dispatch('favoritePage:error', error);
                done(error);
            }
        });
    },
    removeFromFavorites: function removeFromFavorites(actionContext, payload, done) {
        actionContext.executeAction(favoritesActions.removeFromFavorites, payload).then(function (model) {
            actionContext.dispatch('favorites:favorite:remove', model);
            done();
        }).catch(function (error) {
            actionContext.dispatch('favoritePage:error', error);
            done();
        });
    }
};

module.exports = favoritePageActions;

/***/ }),
/* 840 */,
/* 841 */,
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.4.3 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var baseIndexOf = __webpack_require__(3947),
    forOwn = __webpack_require__(3959),
    isArray = __webpack_require__(3948),
    isString = __webpack_require__(3949);

/* Native method shortcuts for methods with the same name as other `lodash` methods */
var nativeMax = Math.max;

/**
 * Checks if a given value is present in a collection using strict equality
 * for comparisons, i.e. `===`. If `fromIndex` is negative, it is used as the
 * offset from the end of the collection.
 *
 * @static
 * @memberOf _
 * @alias include
 * @category Collections
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {*} target The value to check for.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {boolean} Returns `true` if the `target` element is found, else `false`.
 * @example
 *
 * _.contains([1, 2, 3], 1);
 * // => true
 *
 * _.contains([1, 2, 3], 1, 2);
 * // => false
 *
 * _.contains({ 'name': 'fred', 'age': 40 }, 'fred');
 * // => true
 *
 * _.contains('pebbles', 'eb');
 * // => true
 */
function contains(collection, target, fromIndex) {
  var index = -1,
      indexOf = baseIndexOf,
      length = collection ? collection.length : 0,
      result = false;

  fromIndex = (fromIndex < 0 ? nativeMax(0, length + fromIndex) : fromIndex) || 0;
  if (isArray(collection)) {
    result = indexOf(collection, target, fromIndex) > -1;
  } else if (typeof length == 'number') {
    result = (isString(collection) ? collection.indexOf(target, fromIndex) : indexOf(collection, target, fromIndex)) > -1;
  } else {
    forOwn(collection, function(value) {
      if (++index >= fromIndex) {
        return !(result = value === target);
      }
    });
  }
  return result;
}

module.exports = contains;


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseIndexOf = __webpack_require__(339),
    baseValues = __webpack_require__(3939),
    isIterateeCall = __webpack_require__(1908),
    isArray = __webpack_require__(64),
    isString = __webpack_require__(3962),
    keys = __webpack_require__(297);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is in `collection` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it is used as the offset
 * from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @alias contains, include
 * @category Collection
 * @param {Array|Object|string} collection The collection to search.
 * @param {*} target The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
 * @returns {boolean} Returns `true` if a matching element is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
 * // => true
 *
 * _.includes('pebbles', 'eb');
 * // => true
 */
function includes(collection, target, fromIndex, guard) {
  var length = collection ? getLength(collection) : 0;
  if (!isLength(length)) {
    collection = values(collection);
    length = collection.length;
  }
  if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
    fromIndex = 0;
  } else {
    fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
  }
  return (typeof collection == 'string' || !isArray(collection) && isString(collection))
    ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, target, fromIndex) > -1);
}

/**
 * Creates an array of the own enumerable property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return baseValues(object, keys(object));
}

module.exports = includes;


/***/ }),
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaCollection = __webpack_require__(9);
var endpoints = __webpack_require__(6);
var PortfolioModel = __webpack_require__(292);

module.exports = SoaCollection.extend({
    url : endpoints.portfolios(),
    model: PortfolioModel,
    initialize: function (options) {
        this.options = options || {};
    }
});

/***/ }),
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by john on 8/31/15.
 */



var User = __webpack_require__(15);
var RegionalInfoStore = __webpack_require__(325);
var regionalInfoActions = __webpack_require__(2172);
var FinancialAmountsConvert = __webpack_require__(2617);
var storage = __webpack_require__(282);
var localStorageHelper = storage.localStorage;
var sessionStorageHelper = storage.sessionStorage;
var currencyActionConstants = __webpack_require__(291);
var allowedCurrency = __webpack_require__(1473);

var _require = __webpack_require__(137),
    queryKey = _require.URL.queryKey;

var _require2 = __webpack_require__(280),
    CURRENCY_USD = _require2.currencies.CURRENCY_USD;

var PREFERRED_CURRENCY = 'userCurrency';

var currencyActions = {

    _updateCurrency: function _updateCurrency(actionContext, payload, done) {
        var currency = payload.currency;


        if (allowedCurrency.indexOf(currency) === -1) {
            currency = CURRENCY_USD;
        }

        if (currency) {
            actionContext.dispatch(currencyActionConstants.CURRENCY_CHANGED, { currency: currency });
        }
        done();
    },

    _updateSessionStorage: function _updateSessionStorage(actionContext, payload, done) {
        var currency = payload.currency;

        sessionStorageHelper.setItem(PREFERRED_CURRENCY, currency);
        done();
    },

    _updateLocalStorage: function _updateLocalStorage(actionContext, payload, done) {
        var currency = payload.currency;

        localStorageHelper.setItem(PREFERRED_CURRENCY, currency);
        done();
    },

    /**
     * Loads the preferred currency for logged out user.
     * From url query, if not then
     * from local storage, if no then
     * from session storage, if no then
     * from Regional Info
     * @param actionContext
     */
    _loadPreferredCurrency: function _loadPreferredCurrency(actionContext, payload, done) {
        var localStoreCurrency = localStorageHelper.getItem(PREFERRED_CURRENCY);
        var sessionStoreCurrency = sessionStorageHelper.getItem(PREFERRED_CURRENCY);
        var regionalInfoStore = actionContext.getStore(RegionalInfoStore);
        var queryCurrency = queryKey.currency && queryKey.currency.length ? queryKey.currency.toUpperCase() : null;

        if (queryCurrency && allowedCurrency.indexOf(queryCurrency) !== -1) {
            var currency = queryCurrency;

            actionContext.executeAction(currencyActions.updateUserCurrency, { currency: currency }).then(function () {
                return done();
            });
        } else if (localStoreCurrency || sessionStoreCurrency) {
            var _currency = localStoreCurrency || sessionStoreCurrency;

            actionContext.executeAction(currencyActions._updateCurrency, { currency: _currency }).then(function () {
                return done();
            });
        } else {
            actionContext.executeAction(regionalInfoActions.loadRegionalInfo).then(function () {
                var currency = regionalInfoStore.getRegionalInfo().currency;

                // If loadRegionalInfo empty, this action has to be resolved with default currency from UserStore
                if (currency) {
                    return actionContext.executeAction(currencyActions._setRegionalCurrency, { currency: currency });
                }
                return Promise.resolve();
            }).then(function () {
                return done();
            }
            // If loadRegionalInfo fails, this action has to be resolved with default currency from UserStore
            ).catch(function () {
                return done();
            });
        }
    },

    _setRegionalCurrency: function _setRegionalCurrency(actionContext, payload, done) {
        actionContext.executeAction(currencyActions._updateSessionStorage, payload);
        actionContext.executeAction(currencyActions._updateCurrency, payload);
        done();
    },

    /**
     * Convert amount(s) from one currency to another
     * @param actionContext
     * @param payload
     * @param done
     */
    convertAmountsToCurrency: function convertAmountsToCurrency(actionContext, payload, done) {
        var amounts = payload.amounts,
            toCurrency = payload.toCurrency;


        if (amounts) {
            var financialAmounts = new FinancialAmountsConvert(amounts);
            financialAmounts.sync('create', financialAmounts).then(function (response) {
                var convertedFinancialAmounts = new FinancialAmountsConvert(response.result);

                convertedFinancialAmounts.each(function (convertedFinancialAmount, key) {
                    amounts[key].converted = convertedFinancialAmount.getAmountIn(toCurrency);
                });

                done(null, amounts);
            }, function (error) {
                done(error);
            });
        }
    },

    /**
     * Loads the default currency for the current user.
     * @param actionContext
     * @param payload
     * @param payload.userLoadOptions
     */
    loadCurrencyForUser: function loadCurrencyForUser(actionContext, payload, done) {
        Promise.resolve(User.load(payload.userLoadOptions)).then(function () {
            var userModel = User.getCurrentUser();

            /*
                When the user is registering, we do an initial save on successful password entry,
                and we login the user. User.load gets triggered and we get a default
                currency(USD) from the BE. So we ignore this call, because otherwise we'll
                overwrite the users currently set currency.
            */
            if (userModel.get('newUser')) {
                userModel.set('newUser', false);
                return Promise.resolve();
            } else {
                var currency = User.getCurrency();
                return actionContext.executeAction(currencyActions._updateCurrency, { currency: currency });
            }
        }).catch(function () {
            return actionContext.executeAction(currencyActions._loadPreferredCurrency);
        }).then(function () {
            actionContext.dispatch(currencyActionConstants.CURRENCY_LOADED);
            done();
        });
    },

    updateUserCurrency: function updateUserCurrency(actionContext, payload, done) {
        var currency = payload.currency;


        if (User.loggedIn()) {
            User.updateCurrency(currency);
        }

        actionContext.executeAction(currencyActions._updateLocalStorage, payload);
        actionContext.executeAction(currencyActions._updateCurrency, payload);

        done();
    }
};

module.exports = currencyActions;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var endpoints = __webpack_require__(284);
var tracking = __webpack_require__(27);
var PortfolioItemModel = __webpack_require__(294);

var PortfolioStore = __webpack_require__(296);
var User = __webpack_require__(15);

module.exports = {
    removeItem: function removeItem(actionContext, payload) {
        var ga = payload.ga;

        actionContext.dispatch('favorite:item:storage:remove', payload);

        tracking.trackEvent({
            category: 'item favoriting',
            action: 'item removed',
            label: ga.location,
            value: 1
        });
    },
    saveItem: function saveItem(actionContext, payload) {
        var ga = payload.ga;

        actionContext.dispatch('favorite:item:storage:save', payload);

        tracking.trackEvent({
            category: 'item favoriting',
            action: 'item added',
            label: ga.location,
            value: 1
        });
    },
    syncLocal: function syncLocal(actionContext) {
        var store = actionContext.getStore(PortfolioStore);
        var localItems = store.getLocalItems();
        var pk = void 0;

        for (pk in localItems) {
            if (localItems.hasOwnProperty(pk)) {
                var _localItems$pk = localItems[pk],
                    vertical = _localItems$pk.vertical,
                    createdDate = _localItems$pk.createdDate;

                var portfolioModel = new PortfolioItemModel({
                    createdDate: new Date(createdDate).toISOString(),
                    item: {
                        id: pk,
                        apiType: vertical + 'Item'
                    }
                });

                portfolioModel.save({}, {
                    url: endpoints.portfolioAddItem(0, pk),
                    queries: {
                        userId: User.getUserId()
                    }
                });
            }
        }

        actionContext.dispatch('favorite:item:storage:clear');
    }
};

/***/ }),
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Simple shim for window.requestAnimationFrame because some older browsers (and PhantomJS) don't support it. This isn't
 * an exact replacement for requestAnimationFrame but should work for our purposes.
 * @param  {Function} callback
 */

function animationFrame(callback) {
    if (window && window.requestAnimationFrame) {
        window.requestAnimationFrame(callback);
    } else {
        setTimeout(callback, 50);
    }
}

module.exports = animationFrame;

/***/ }),
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */
/***/ (function(module, exports) {

/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var stringTag = '[object String]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	exports.post = post;
	exports.postToIframe = postToIframe;
	var uniqueId = function () {
	    var counter = 0;
	    return function (prefix) {
	        return prefix + '-' + counter++;
	    };
	}();

	function addAttributes(element) {
	    var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	    Object.keys(attributes).forEach(function (attr) {
	        var attributeValue = attributes[attr];
	        element[attr] = attributeValue;
	    });
	}

	function appendElementToDOM(element) {
	    var baseElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;

	    baseElement.appendChild(element);
	}

	function removeElementFromDOM(element) {
	    element.parentNode.removeChild(element);
	}

	function setUpForm(url) {
	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	    var form = document.createElement('form');
	    form.style.display = 'none';

	    addAttributes(form, _extends({
	        method: 'post',
	        action: url,
	        enctype: 'multipart/form-data'
	    }, attributes));

	    Object.keys(data).forEach(function (key) {
	        var keyValue = data[key];

	        var input = void 0;
	        if (keyValue instanceof window.HTMLInputElement) {
	            input = keyValue.cloneNode();
	            addAttributes(input, { name: key });
	        } else {
	            input = document.createElement('input');
	            addAttributes(input, {
	                type: 'text',
	                name: key,
	                value: keyValue
	            });
	        }

	        form.appendChild(input);
	    });

	    return form;
	}

	function setUpIframe() {
	    var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	    var iframe = document.createElement('iframe');
	    iframe.style.display = 'none';
	    addAttributes(iframe, attributes);
	    return iframe;
	}

	function post(url, data) {
	    var form = setUpForm(url, data);
	    appendElementToDOM(form);
	    form.submit();
	};

	function postToIframe(url, data) {
	    var target = uniqueId('Iframe-Post');
	    var iframe = setUpIframe({ name: target });
	    var form = setUpForm(url, data, { target: target });

	    appendElementToDOM(iframe);
	    appendElementToDOM(form);

	    var responsePromise = new Promise(function (resolve) {
	        iframe.onload = function () {
	            resolve();
	            removeElementFromDOM(iframe);
	            removeElementFromDOM(form);
	        };
	    });
	    form.submit();
	    return responsePromise;
	};

/***/ }
/******/ ]);

/***/ }),
/* 934 */,
/* 935 */,
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: hella
 * Date: 3/31/14
 * Time: 1:06 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */


var $ = __webpack_require__(5);
var priceMixins;

priceMixins = {
    _priceClasses: {
        wrapper: '.product-price',
        link: '.product-price-item',
        label: '.product-price-labels',
        visible: '.is-visible',
        invisible: '.is-invisible',
        loggedIn: '.is-logged-in',
        sold: '.is-sold',
        hold: '.is-on-hold'
    },
    _priceOptions: {},
    _currency: {
        defaultCurrency: "USD"
    },
    CONSTANTS: {
        PRICE_HIDDEN: 'Price Upon Request',
        PRICE_SOLD: 'sold'
    },
    _ensurePriceTextVisible : function () {
        var wrapperClass = this._priceClasses.wrapper;
        var invisibleClass = this._priceClasses.invisible;
        this.$el.find(wrapperClass + invisibleClass).removeClass(invisibleClass.substring(1));
    },
    setPriceOptions: function (options) {
        $.extend(this._priceClasses, options.classes);
        delete options.classes;
        $.extend(this._priceOptions, options);
    },
    hidePrices : function () {
        var linkClass = this._priceClasses.link;
        var visibleClass = this._priceClasses.visible;
        var loggedInClass = this._priceClasses.loggedIn;
        this.$el.find(linkClass + loggedInClass).each(function () {
            $(this).removeClass().addClass(linkClass.substring(1)).text('View Price')
                .parent().children('span').removeClass(visibleClass.substring(1));
        });
        return this;
    },
    showPrices : function (currencyPref) {
        var linkClass = priceMixins._priceClasses.link;
        var visibleClass = priceMixins._priceClasses.visible;

        currencyPref = currencyPref || priceMixins._currency.defaultCurrency;

        this.$el.off('click', linkClass).on('click', linkClass, function () {
            return false;
        });
        this.$el.find(linkClass).each(function (i, priceEl) {
            var $priceEl = $(priceEl);
            var priceData = $priceEl.data(currencyPref.toLowerCase());
            var isSold = $priceEl.data('sold');
            var isHidden = $priceEl.data('hide-price');
            var elClass = '';

            // jQuery data can return any JS data type, to be safe we only cast numbers to strings
            if (typeof priceData === 'number') {
                priceData = priceData.toString();
            }

            if (isSold) {
                elClass = ' ' + priceMixins._priceClasses.sold.substring(1);
                priceData = priceMixins.CONSTANTS.PRICE_SOLD;
            } else if (isHidden) {
                priceData = priceMixins.CONSTANTS.PRICE_HIDDEN;
            }

            $priceEl
                .text(priceData)
                .addClass(elClass)
                .parent()
                .children('span')
                .addClass(visibleClass.substring(1));
        });
        return this;
    },
    /**
     * Show/hide prices
     * @param {boolean} showPrices `true`: show the prices to the user, `false`: hides prices
     * @param {string} currencyPref The user's currency preference
     * @returns {boolean}
     */
    updatePrices: function (showPrices, currencyPref) {
        if (!showPrices) {
            this.hidePrices()._ensurePriceTextVisible();
            return false;
        }
        this.showPrices(currencyPref)._ensurePriceTextVisible();
        // HACK: This is for use in the new PDP and should ultimately be replaced by a Fluxible action.
        $.publish('update-currency', currencyPref);
        return true;
    },

    /**
     * Show/hide price labels. Currently only used on s/b pages.
     */
    showLabels: function () {
        var labelClass = this._priceClasses.label;
        var invisibleClass = this._priceClasses.invisible;
        var priceLabels = $(labelClass);
        if (priceLabels.length) {
            priceLabels.removeClass(invisibleClass.substring(1));
        }
    }
};

module.exports = priceMixins;


/***/ }),
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 1/17/14
 * Time: 5:44 PM
 */



var SoaModel = __webpack_require__(2);
var Permission = module.exports = SoaModel.extend();
var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var endpoints = __webpack_require__(6);
var bunsen = __webpack_require__(21);
var Roles = __webpack_require__(2040);

bunsen.Permission = Permission;


_.extend(Permission, {
    'PERMISSION_ACCOUNT_REP' : 'ACCOUNT_REP',
    'PERMISSION_ASSIGN_ROLES' : 'ASSIGN_ROLES',
    'PERMISSION_BASIC_INTERNAL' : 'BASIC_INTERNAL',
    'PERMISSION_BULK_UPDATE_ACCESS' : 'BULK_UPDATE_ACCESS',
    'PERMISSION_B_NET_PRICE' : 'B_NET_PRICE',
    'PERMISSION_B_TAX_EXEMPT' : 'B_TAX_EXEMPT',
    'PERMISSION_B_TRADE_CHECKOUT' : 'B_TRADE_CHECKOUT',
    'PERMISSION_B_VIP_CHECKOUT' : 'B_VIP_CHECKOUT',
    'PERMISSION_CMS_ACCESS' : 'CMS_ACCESS',
    'PERMISSION_CONTROL_PERMISSIONS' : 'CONTROL_PERMISSIONS',
    'PERMISSION_CREATE_ACCOUNT' : 'CREATE_ACCOUNT',
    'PERMISSION_CREATE_TEST_ITEMS' : 'CREATE_TEST_ITEMS',
    'PERMISSION_CREATORS_ACCESS' : 'CREATORS_ACCESS',
    'PERMISSION_CUSTOMER_ACCESS' : 'CUSTOMER_ACCESS',
    'PERMISSION_CUSTOMER_DISABLE_ACCOUNT' : 'CUSTOMER_DISABLE_ACCOUNT',
    'PERMISSION_DEALER_ACCESS' : 'DEALER_ACCESS',
    'PERMISSION_DEALER_ACCESS_STATEMENT' : 'DEALER_ACCESS_STATEMENT',
    'PERMISSION_DEALER_EDIT_ACCOUNT' : 'DEALER_EDIT_ACCOUNT',
    'PERMISSION_DEALER_EDIT_LOCATION' : 'DEALER_EDIT_LOCATION',
    'PERMISSION_DEALER_EDIT_STATUS' : 'DEALER_EDIT_STATUS',
    'PERMISSION_DEALER_EDIT_STOREFRONT' : 'DEALER_EDIT_STOREFRONT',
    'PERMISSION_DEVELOPER_TOOLS_ACCESS' : 'DEVELOPER_TOOLS_ACCESS',
    'PERMISSION_EDITORIAL_CMS_ACCESS' : 'EDITORIAL_CMS_ACCESS',
    'PERMISSION_ELIGIBILITY_DATE_DELAY': 'ELIGIBILITY_DATE_DELAY',
    'PERMISSION_EXPERT_REVIEW_REJECT': 'EXPERT_REVIEW_REJECT',
    'PERMISSION_DEALER_EDIT_MIN_INVENTORY': 'DEALER_EDIT_MIN_INVENTORY',
    'PERMISSION_DEALER_EDIT_POLICY_FIELDS': 'DEALER_EDIT_POLICY_FIELDS',
    'PERMISSION_FINANCE_BULK_UPDATE' : 'FINANCE_BULK_UPDATE',
    'PERMISSION_HYPERWALLET_ACCOUNT_CREATE': 'HYPERWALLET_ACCOUNT_CREATE',
    'PERMISSION_INTERNAL_ADMIN_USER' : 'INTERNAL_ADMIN_USER',
    'PERMISSION_ITEM_ACCESS' : 'ITEM_ACCESS',
    'PERMISSION_ITEM_ACTION' : 'ITEM_ACTION',
    'PERMISSION_ITEM_EDIT_LOCKED' : 'ITEM_EDIT_LOCKED',
    'PERMISSION_ITEM_IMAGE_UNLOCK' : 'ITEM_IMAGE_UNLOCK',
    'PERMISSION_MASQUERADE_AS_BUYER' : 'MASQUERADE_AS_BUYER',
    'PERMISSION_MASQUERADE_AS_DEALER' : 'MASQUERADE_AS_DEALER',
    'PERMISSION_MOBILE_PUBLISH_DISCOVER' : 'MOBILE_PUBLISH_DISCOVER',
    'PERMISSION_MOBILE_CREATE_DISCOVER' : 'MOBILE_CREATE_DISCOVER',
    'PERMISSION_MOBILE_PUBLISH_NOTIFICATION' : 'MOBILE_PUBLISH_NOTIFICATION',
    'PERMISSION_MOBILE_CREATE_NOTIFICATION' : 'MOBILE_CREATE_NOTIFICATION',
    'PERMISSION_OMT_ACCESS' : 'OMT_ACCESS',
    'PERMISSION_OMT_ACCOUNTING' : 'OMT_ACCOUNTING',
    'PERMISSION_OMT_CANCEL_ORDER' : 'OMT_CANCEL_ORDER',
    'PERMISSION_OMT_ENTER_SHIPPING_MILESTONES' : 'OMT_ENTER_SHIPPING_MILESTONES',
    'PERMISSION_OMT_ENTER_SHIPPING_QUOTE' : 'OMT_ENTER_SHIPPING_QUOTE',
    'PERMISSION_OMT_SHIPPING_EXCEPTIONS' : 'OMT_SHIPPING_EXCEPTIONS',
    'PERMISSION_OMT_FLAG_MESSAGE' : 'OMT_FLAG_MESSAGE',
    'PERMISSION_OMT_FRAUD_ACTIONS' : 'OMT_FRAUD_ACTIONS',
    'PERMISSION_OMT_MASQUERADE_AS_BUYER' : 'OMT_MASQUERADE_AS_BUYER',
    'PERMISSION_OMT_MASQUERADE_AS_DEALER' : 'OMT_MASQUERADE_AS_DEALER',
    'PERMISSION_OMT_SUPPORT_REP' : 'OMT_SUPPORT_REP',
    'PERMISSION_PHOTO_ACCESS' : 'PHOTO_ACCESS',
    'PERMISSION_PUB_ATTACH_ADDTL_LISTINGS': 'PUB_ATTACH_ADDTL_LISTINGS',
    'PERMISSION_PUB_CREATE': 'PUB_CREATE',
    'PERMISSION_PUB_CREATE_SAT_SALE': 'PUB_CREATE_SAT_SALE',
    'PERMISSION_PUB_DASHBOARD_ACCESS': 'PUB_DASHBOARD_ACCESS',
    'PERMISSION_PUB_DELETE': 'PUB_DELETE',
    'PERMISSION_PUB_DELETE_ACTIVE': 'PUB_DELETE_ACTIVE',
    'PERMISSION_PUB_EDIT_ACCESS': 'PUB_EDIT_ACCESS',
    'PERMISSION_PUB_LISTING_NOTES': 'PUB_LISTING_NOTES',
    'PERMISSION_PUB_MERCHANDISING': 'PUB_MERCHANDISING',
    'PERMISSION_PUB_PROMOTE_DEMOTE': 'PUB_PROMOTE_DEMOTE',
    'PERMISSION_PUB_PUBLISH': 'PUB_PUBLISH',
    'PERMISSION_PUB_RESCEDULE_LISTINGS': 'PUB_RESCHEDULE_LISTINGS',
    'PERMISSION_PUB_TRANSITION_PUBLICATION': 'PUB_TRANSITION_PUBLICATION',
    'PERMISSION_PUBLISH_INVENTORY' : 'PUBLISH_INVENTORY',
    'PERMISSION_REFUND_CREATE' : 'REFUND_CREATE',
    'PERMISSION_REVIEW_APPROVE_PHOTO_DOCUMENT': 'REVIEW_APPROVE_PHOTO_DOCUMENT',
    'PERMISSION_REVIEW_APPROVE_DATA_DOCUMENT': 'REVIEW_APPROVE_DATA_DOCUMENT',
    'PERMISSION_REVIEW_DATA_ASSIGN': 'REVIEW_DATA_ASSIGN',
    'PERMISSION_REVIEW_DATA_QUEUE': 'REVIEW_DATA_QUEUE',
    'PERMISSION_REVIEW_PHOTO_ASSIGN': 'REVIEW_PHOTO_ASSIGN',
    'PERMISSION_REVIEW_PHOTO_NOTES': 'REVIEW_PHOTO_NOTES',
    'PERMISSION_REVIEW_PHOTO_PROCESSING_QUEUE': 'REVIEW_PHOTO_PROCESSING_QUEUE',
    'PERMISSION_STOREFRONT_V2_MANAGER': 'STOREFRONT_V2_MANAGER',
    'PERMISSION_VERIFY_TRADE_USER' : 'VERIFY_TRADE_USER',
    'PERMISSION_VERIFY_VIP_USER' : 'VERIFY_VIP_USER',
    'PERMISSION_WIRE_CREATE' : 'WIRE_CREATE',
    'PERMISSION_WIRE_CONFIRM' : 'WIRE_CONFIRM',
    'PERMISSION_WIRE_VIEW_DETAILS' : 'WIRE_VIEW_DETAILS',
    'PERMISSION_VETTING_FILTERING' : 'VETTING_FILTERING',
    'PERMISSION_REVIEW_VETTING_IN_PROGRESS': 'REVIEW_VETTING_IN_PROGRESS',
    'PERMISSION_REVIEW_VETTING_APPROVED': 'REVIEW_VETTING_APPROVED',
    'PERMISSION_REVIEW_VETTING_VOID': 'REVIEW_VETTING_VOID'
});

_.extend(Permission.prototype, {
    relations: [
        {
            type: Backbone.Many,
            key: 'roles',
            collectionType: Roles,
            omitFromSave: true
        }
    ],
    url: function () {
        return endpoints.permission(this.get(this.idAttribute));
    },
    initialize: function () {
        _.bindAll(this, 'removePermissionFromRole', 'addPermissionToRole');
    },
    removePermissionFromRole: function (roleId, passedOptions) {
        var options = passedOptions || {};
        var url = endpoints.permissionsByRole(roleId, this.get('id'));

        // Sync here instead of destroy because event's shouldn't be triggered
        return this.sync('delete', this, _.defaults(options, {
            url: url
        }));
    },
    addPermissionToRole: function (roleId, passedOptions) {
        var options = passedOptions || {};
        var url = endpoints.permissionsByRole(roleId, this.get('id'));

        return this.sync('create', this, _.defaults(options, {
            url: url
        }));
    }
});


/***/ }),
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Get top and left positioning for centering social pop-up window
 * @param {number} windowHeight
 * @param {number} windowWidth
 * @returns {{top: number, left: number}}
 */

function getSocialWindowDimensions(windowHeight, windowWidth) {
    var screenHeight = screen.height;
    var screenWidth = screen.width;
    var left = Math.round(screenWidth / 2 - windowWidth / 2);
    var top = 0;

    if (screenHeight > windowHeight) {
        top = Math.round(screenHeight / 2 - windowHeight / 2);
    }

    return {
        top: top,
        left: left
    };
}

module.exports = getSocialWindowDimensions;

/***/ }),
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

module.exports = reInterpolate;


/***/ }),
/* 974 */,
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {/**
 * lodash 4.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseEach = __webpack_require__(3953),
    baseFind = __webpack_require__(1904),
    baseFindIndex = __webpack_require__(1905),
    baseIsEqual = __webpack_require__(1906),
    baseIsMatch = __webpack_require__(2235),
    get = __webpack_require__(3954),
    hasIn = __webpack_require__(2239),
    toPairs = __webpack_require__(2242);

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to determine if values are of the language type `Object`. */
var objectTypes = {
  'function': true,
  'object': true
};

/** Detect free variable `exports`. */
var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType) ? exports : null;

/** Detect free variable `module`. */
var freeModule = (objectTypes[typeof module] && module && !module.nodeType) ? module : null;

/** Detect free variable `global` from Node.js. */
var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);

/** Detect free variable `self`. */
var freeSelf = checkGlobal(objectTypes[typeof self] && self);

/** Detect free variable `window`. */
var freeWindow = checkGlobal(objectTypes[typeof window] && window);

/** Detect `this` as the global object. */
var thisGlobal = checkGlobal(objectTypes[typeof this] && this);

/**
 * Used as a reference to the global object.
 *
 * The `this` value is used if it's the global object to avoid Greasemonkey's
 * restricted `window` object, otherwise the `window` object is used.
 */
var root = freeGlobal || ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) || freeSelf || thisGlobal || Function('return this')();

/**
 * Checks if `value` is a global object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
 */
function checkGlobal(value) {
  return (value && value.Object === Object) ? value : null;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = Symbol ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path + ''] : baseToPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[path[index++]];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  var type = typeof value;
  if (type == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (type == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    var key = matchData[0][0],
        value = matchData[0][1];

    return function(object) {
      if (object == null) {
        return false;
      }
      return object[key] === value &&
        (value !== undefined || (key in Object(object)));
    };
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new function.
 */
function baseMatchesProperty(path, srcValue) {
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toPath` which only converts `value` to a
 * path if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Array} Returns the property path array.
 */
function baseToPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = toPairs(object),
      length = result.length;

  while (length--) {
    result[length][2] = isStrictComparable(result[length][1]);
  }
  return result;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (typeof value == 'number') {
    return true;
  }
  return !isArray(value) &&
    (reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
      (object != null && value in Object(object)));
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
function stringToPath(string) {
  var result = [];
  toString(string).replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
}

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three arguments:
 * (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @category Collection
 * @param {Array|Object} collection The collection to search.
 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
function find(collection, predicate) {
  predicate = baseIteratee(predicate, 3);
  if (isArray(collection)) {
    var index = baseFindIndex(collection, predicate);
    return index > -1 ? collection[index] : undefined;
  }
  return baseFind(collection, predicate, baseEach);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (value == null) {
    return '';
  }
  if (isSymbol(value)) {
    return Symbol ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': { 'c': 2 } } },
 *   { 'a': { 'b': { 'c': 1 } } }
 * ];
 *
 * _.map(objects, _.property('a.b.c'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
}

module.exports = find;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module), __webpack_require__(4)))

/***/ }),
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(717),
    getPrototype = __webpack_require__(4005),
    isObjectLike = __webpack_require__(691);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 982 */,
/* 983 */,
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// do not require the style file here - it generates the css
// twice - once in the foot.css and once in the [entry].css
// added into the chunks/foot in the webpack config
//require('./SimpleModal-style.scss');

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var $ = __webpack_require__(5);

var _require = __webpack_require__(3),
    BaseView = _require.BaseView,
    View = _require.View;

var _require2 = __webpack_require__(3901),
    template = _require2.simpleModalTemplate;

var _require3 = __webpack_require__(1366),
    transitionElement = _require3.transitionElement;

var mergeClassNames = __webpack_require__(3637);
var animationFrame = __webpack_require__(899);
var CloseIcon = __webpack_require__(1267);
var $body = void 0;

/**
 * Simple modal that handle hide/show, close on escape, etc. Consumers can pass in an HTML string, DOMNode, JQuery
 * object or Backbone View for the content. Consumers are expected to construct the Backbone View first and then
 * pass the created instance into the modal constructor. They are also expected to render the content view and then
 * render the modal afterwards.
 *
 * @param  {string|Backbone.View|JQuery|DOMNode} options.content The inner content of the modal.
 * @param  {object} [options.classNames] Set of class names to add to the modal for style customization. Options are
 *                                       `modal` for the outer wrapper, `overlay` for the background overlay, `close`
 *                                        for the close button, contentWrapper for the wrapper around the passed in
 *                                        content and `content` for the content itself.
 * @param  {boolean} [options.manualHideCallback] Callback to fire whenever the modal is hidden manually (close button, escape, background click).
 * @param  {boolean} [options.closeButton=true] Whether or not to automatically add a close button.
 * @param  {boolean} [options.closeOnEscape=true] Whether or not to close the modal on pressing escape.
 * @param  {boolean} [options.closeOnBackgroundClick=true] Whether or not to close the modal on clicking the background overlay.
 * @return {object}
 */

var SimpleModal = function (_BaseView) {
    _inherits(SimpleModal, _BaseView);

    function SimpleModal() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, SimpleModal);

        var _this = _possibleConstructorReturn(this, (SimpleModal.__proto__ || Object.getPrototypeOf(SimpleModal)).call(this, options));

        $body = $('body');
        var manualHideCallback = options.manualHideCallback,
            closeOnEscape = options.closeOnEscape,
            closeButton = options.closeButton,
            closeOnBackgroundClick = options.closeOnBackgroundClick,
            content = options.content,
            classNames = options.classNames;


        if (typeof content === 'undefined') {
            throw new Error('SimpleModal requires a content property.');
        }

        // The main content to be displayed in the modal.
        _this._content = content;
        _this._classNames = mergeClassNames({
            modal: '',
            overlay: '',
            close: '',
            contentWrapper: '',
            content: ''
        }, _this.classNames(), classNames);
        _this._manualHideCallback = manualHideCallback;
        _this._closeOnEscape = typeof closeOnEscape !== 'undefined' ? closeOnEscape : true;
        _this._closeButton = typeof closeButton !== 'undefined' ? closeButton : true;
        _this._closeOnBackgroundClick = typeof closeOnBackgroundClick !== 'undefined' ? closeOnBackgroundClick : true;
        _this._canManualHide = true;

        if (_this._closeOnEscape) {
            _this._handleKeydown = function (e) {
                if (e.which === 27) {
                    _this._handleManualHide(e);
                }
            };
        }
        return _this;
    }

    _createClass(SimpleModal, [{
        key: 'events',
        value: function events() {
            return {
                'click .simple-modal-close': '_handleCloseClick',
                'touchend .simple-modal-close': '_handleCloseClick',
                'click .simple-modal-overlay': '_handleBackgroundClick'
            };
        }

        /**
         * Return a JQuery selector indicating where to put the close button. If not implemented the close button will be
         * prepended to the content wrapper.
         *
         * @abstract
         * @return {string} JQuery selector.
         */

    }, {
        key: 'closeButtonLocation',
        value: function closeButtonLocation() {}

        /**
         * Additional content to insert before the main content.
         *
         * @abstract
         * @return {object|string} DOM Node, JQuery object or HTML string.
         */

    }, {
        key: 'preContent',
        value: function preContent() {}

        /**
         * Additional content to insert after the main content.
         *
         * @abstract
         * @return {object|string} DOM Node, JQuery object or HTML string.
         */

    }, {
        key: 'postContent',
        value: function postContent() {}

        /**
         * Action to take immediately after rendering
         *
         * @abstract
         */

    }, {
        key: 'afterRender',
        value: function afterRender() {}

        /**
         * Class names to set on the elements of the modal in addition to any class names that are passed into the
         * constructor.
         *
         * @abstract
         * @return {object} Class names objects.
         */

    }, {
        key: 'classNames',
        value: function classNames() {}

        /**
         * Render the modal with the content inside. If the content is a Backbone View, it should already be rendered
         * before the modal is rendered.
         *
         * @return {object}
         */

    }, {
        key: 'render',
        value: function render() {
            var preContent = this.preContent();
            var postContent = this.postContent();
            var closeButtonLocation = this.closeButtonLocation();
            var content = this.content = this._content;

            if (content && content instanceof View) {
                content = content.el;
            }

            this.setElement(template({
                classNames: this._classNames,
                closeIcon: CloseIcon
            }).trim());
            this.$closeButton = this.$('.simple-modal-close');
            this.$contentWrapper = this.$('.simple-modal-content-wrapper');
            this.$content = $(content);

            if (this._classNames.content) {
                this.$content.addClass(this._classNames.content);
            }

            if (preContent) {
                this.$contentWrapper.append(preContent);
            }

            this.$contentWrapper.append(this.$content);

            if (postContent) {
                this.$contentWrapper.append(postContent);
            }

            if (closeButtonLocation) {
                this.$closeButton.appendTo(this.$(closeButtonLocation));
            }

            if (!this._closeButton) {
                this._hideCloseButton();
            }

            $body.append(this.el);
            this.afterRender();

            return this;
        }
    }, {
        key: 'show',
        value: function show(callback) {
            var _this2 = this;

            transitionElement(this.$el, {
                startCallback: function startCallback() {
                    _this2.$el.addClass('open visible');
                    _this2.$el.css('opacity');

                    var classes = 'prevent-interaction lock-position no-scroll';

                    if (_this2.$el.hasClass('is-full-page')) {
                        classes += ' prevent-scroll-to-top';
                    }

                    $body.addClass(classes);
                },

                endCallback: function endCallback() {
                    if (_this2._closeOnEscape) {
                        $(document).on('keydown', _this2._handleKeydown);
                    }

                    $body.removeClass('prevent-interaction');

                    if (typeof callback === 'function') {
                        callback();
                    }

                    _this2.trigger('show');
                }
            });
        }
    }, {
        key: 'hide',
        value: function hide(callback) {
            var _this3 = this;

            transitionElement(this.$el, {
                startCallback: function startCallback() {
                    if (_this3._closeOnEscape) {
                        _this3._removeKeydownHandler();
                    }

                    _this3.$el.removeClass('open');
                    $body.addClass('prevent-interaction');
                },

                endCallback: function endCallback() {
                    var classes = 'prevent-interaction lock-position no-scroll';

                    if (_this3.$el.hasClass('is-full-page')) {
                        classes += ' prevent-scroll-to-top';
                    }

                    $body.removeClass(classes);
                    _this3.$el.removeClass('visible');

                    if (typeof callback === 'function') {
                        callback();
                    }

                    _this3.trigger('hide');

                    animationFrame(function () {
                        _this3.$el.removeClass('visible');
                    });
                }
            });
        }

        /**
         * Temporarily prevent the user from closing the modal through either the close button, hitting escape or clicking
         * on the background overlay. This can be reversed with `enableManualHide`.
         */

    }, {
        key: 'disableManualHide',
        value: function disableManualHide() {
            this._canManualHide = false;
            this._hideCloseButton();
        }

        /**
         * Allow the user to close the modal after previously disabling ths ability.
         */

    }, {
        key: 'enableManualHide',
        value: function enableManualHide() {
            this._canManualHide = true;

            if (this._closeButton) {
                this._showCloseButton();
            }
        }
    }, {
        key: '_handleCloseClick',
        value: function _handleCloseClick(e) {
            if (this._closeButton) {
                this._handleManualHide(e);
            }
        }
    }, {
        key: '_handleManualHide',
        value: function _handleManualHide(e) {
            e.preventDefault();

            if (this._canManualHide) {
                this.hide(this._manualHideCallback);
            }
        }
    }, {
        key: '_hideCloseButton',
        value: function _hideCloseButton() {
            this.$closeButton.hide();
        }
    }, {
        key: '_showCloseButton',
        value: function _showCloseButton() {
            this.$closeButton.show();
        }
    }, {
        key: '_removeKeydownHandler',
        value: function _removeKeydownHandler() {
            $(document).off('keydown', this._handleKeydown);
        }
    }, {
        key: '_handleBackgroundClick',
        value: function _handleBackgroundClick(e) {
            if (this._closeOnBackgroundClick) {
                this._handleManualHide(e);
            }
        }
    }]);

    return SimpleModal;
}(BaseView);

module.exports = SimpleModal;

/***/ }),
/* 985 */,
/* 986 */,
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by niko on 1/1/16.
 */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var SocialNetworks = __webpack_require__(3826);

var SocialNetworkStore = function (_BaseStore) {
    _inherits(SocialNetworkStore, _BaseStore);

    function SocialNetworkStore(dispatcher) {
        _classCallCheck(this, SocialNetworkStore);

        var _this = _possibleConstructorReturn(this, (SocialNetworkStore.__proto__ || Object.getPrototypeOf(SocialNetworkStore)).call(this, dispatcher));

        _this._collection = new SocialNetworks();
        return _this;
    }

    _createClass(SocialNetworkStore, [{
        key: '_onSocialNetworksFetch',
        value: function _onSocialNetworksFetch(payload) {
            this._collection.reset(payload);
            this.emitChange();
        }
    }, {
        key: 'getCollection',
        value: function getCollection() {
            return this._collection;
        }
    }, {
        key: 'getSocialNetworks',
        value: function getSocialNetworks() {
            return this._collection.toJSON();
        }
    }, {
        key: 'getSocialNetwork',
        value: function getSocialNetwork(name) {
            var socialNetwork = this._collection.findWhere({ name: name });
            if (socialNetwork) {
                return socialNetwork.toJSON();
            } else {
                return null;
            }
        }
    }]);

    return SocialNetworkStore;
}(BaseStore);

SocialNetworkStore.storeName = 'SocialNetworkStore';

SocialNetworkStore.handlers = {
    'socialNetworks:fetch': '_onSocialNetworksFetch'
};

module.exports = SocialNetworkStore;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by niko on 1/1/16.
 */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);

var UserSocialNetworkStore = function (_BaseStore) {
    _inherits(UserSocialNetworkStore, _BaseStore);

    function UserSocialNetworkStore(dispatcher) {
        _classCallCheck(this, UserSocialNetworkStore);

        var _this = _possibleConstructorReturn(this, (UserSocialNetworkStore.__proto__ || Object.getPrototypeOf(UserSocialNetworkStore)).call(this, dispatcher));

        _this._collection = null;
        _this._isLoaded = false;
        return _this;
    }

    _createClass(UserSocialNetworkStore, [{
        key: '_onLoad',
        value: function _onLoad(_ref) {
            var socialNetworks = _ref.socialNetworks;

            this._collection = socialNetworks;
            this._isLoaded = true;
            this.emitChange();
        }
    }, {
        key: 'getCollection',
        value: function getCollection() {
            return this._collection;
        }
    }, {
        key: 'isLoaded',
        value: function isLoaded() {
            return this._isLoaded;
        }
    }, {
        key: 'getSocialNetworks',
        value: function getSocialNetworks(name) {
            if (this._collection) {
                var socialNetworks = [];

                this._collection.toJSON().forEach(function (network) {
                    if (network.socialNetwork.name === name) {
                        socialNetworks.push(network);
                    }
                });

                return socialNetworks;
            }

            return [];
        }
    }, {
        key: 'getConnectedSocialNetwork',
        value: function getConnectedSocialNetwork(name) {
            var model = this._collection && this._collection.getConnected(name);
            return model && model.toJSON();
        }
    }]);

    return UserSocialNetworkStore;
}(BaseStore);

UserSocialNetworkStore.storeName = 'UserSocialNetworkStore';

UserSocialNetworkStore.handlers = {
    'user:socialNetworks:load': '_onLoad',
    'user:socialNetwork:connect': 'emitChange',
    'user:socialNetwork:update': 'emitChange',
    'user:socialNetwork:disconnect': 'emitChange'
};

module.exports = UserSocialNetworkStore;

/***/ }),
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Load Super Class

var SoaCollection = __webpack_require__(9);

// ---------------------------------------------------
// Module Definition

/**
 * @class ItemAttributes
 * @extends SoaCollection
 */
var ItemAttributes = module.exports = SoaCollection.extend();

// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);
var ItemAttribute = __webpack_require__(1219);

// ---------------------------------------------------
// Local Vars

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(ItemAttributes.prototype, {
    model : ItemAttribute,
    comparator: 'value'
});

// ---------------------------------------------------
// Define Module Static Properties

_.extend(ItemAttributes, {

});

/***/ }),
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by Lior Elrom
 * Date: 7/12/16
 * Time: 12:09 PM
 */



var GA_TYPES = {
    TYPE_ENTRY: 'entry',
    TYPE_SAVED: 'saved',
    TYPE_COMPLETED: 'completed'
};
var GA_BOOLEANS = {
    BOOLEAN_YES: 'y',
    BOOLEAN_NO: 'n'
};
var GA_FRAGMENT = {
    FRAGMENT_PURCHASABLE: 'pur',
    FRAGMENT_NEGOTIABLE: 'neg',
    FRAGMENT_RETURNABLE: 'ret',
    FRAGMENT_RELEASED_DATE: 'released',
    FRAGMENT_SOLD_DATE: 'sold',
    FRAGMENT_PRE_QUOTED_SHIPPING: 'ship'
};

module.exports = {
    GA_TYPES: GA_TYPES,
    GA_BOOLEANS: GA_BOOLEANS,
    GA_FRAGMENT: GA_FRAGMENT
};

/***/ }),
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(282),
    localStorage = _require.localStorage,
    sessionStorage = _require.sessionStorage;

var enabler = __webpack_require__(63);

var MAX_SESSIONS = 3;

var tradeMessageActions = {
    checkTradeMessage: function checkTradeMessage(actionContext, payload, done) {
        var tradeSalesRep = payload.tradeSalesRep;

        var isMessageDisabled = !enabler.isEnabled('trade_welcome_message');

        if (isMessageDisabled) {
            done();
        } else {
            var showCount = localStorage.getItem('tradeWelcomeMessage') || 0;
            var canShowByCount = showCount <= MAX_SESSIONS;

            if (canShowByCount && tradeSalesRep) {
                actionContext.executeAction(tradeMessageActions.showTradeMessage).then(function () {
                    return done();
                });
            } else {
                done();
            }
        }
    },
    incrementShowCount: function incrementShowCount(actionContext, payload, done) {
        var showCount = localStorage.getItem('tradeWelcomeMessage') || 0;
        var isFirstInSession = !sessionStorage.getItem('tradeWelcomeMessage');
        if (isFirstInSession) {
            localStorage.setItem('tradeWelcomeMessage', ++showCount);
            sessionStorage.setItem('tradeWelcomeMessage', true);
        }
        done();
    },
    showTradeMessage: function showTradeMessage(actionContext, payload, done) {
        actionContext.executeAction(tradeMessageActions.incrementShowCount);
        actionContext.dispatch('message:trade:toggle', true);
        done();
    },
    hideTradeMessage: function hideTradeMessage(actionContext, payload, done) {
        actionContext.dispatch('message:trade:toggle', false);
        localStorage.setItem('tradeWelcomeMessage', MAX_SESSIONS + 1);
        done();
    }
};

module.exports = tradeMessageActions;

/***/ }),
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Joe Forzano
 * Date: August 6th, 2015
 *
 * A wrapper around node-cache that creates a global singleton NodeCache instance for use
 * in both client-side and server-side Javascript.
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var NodeCache = __webpack_require__(4050);
var _ = __webpack_require__(0);
var assert = __webpack_require__(31);

var cache = new NodeCache({ checkperiod: 0 });
// NOTE: absense of checkperiod option causes mothra tests to hang
var cacheEnabled = true;

module.exports = _.extend({

    enableCaching: function enableCaching() {
        cacheEnabled = true;
    },

    disableCaching: function disableCaching() {
        cacheEnabled = false;
    },

    get: function get(key) {
        if (cacheEnabled) {
            if (_.isArray(key)) {
                return cache.get(key);
            }
            return cache.get([key])[key];
        }
    },

    set: function set(key, val) {
        assert((typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'symbol', 'Key must be of type \'symbol\' to ensure uniqueness');
        if (cacheEnabled) {
            return cache.set(key, val);
        }
    },

    del: function del(key) {
        if (_.isArray(key)) {
            return cache.del(key);
        }
        return cache.del([key]);
    },

    keys: function keys() {
        //Since keys are Symbols, we need to explicitly pull symbols from private _data
        return Object.getOwnPropertySymbols(cache.data);
    },

    flushAll: function flushAll() {
        return cache.flushAll();
    }
}, _.chain(['flushAll']).map(function (fn) {
    return [fn, cache[fn].bind(cache)];
}).object().value());

/***/ }),
/* 1093 */,
/* 1094 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isArguments;


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var createWrapper = __webpack_require__(3966),
    rest = __webpack_require__(816);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for wrapper metadata. */
var PARTIAL_RIGHT_FLAG = 64;

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

/**
 * This method is like `_.partial` except that partially applied arguments
 * are appended to the arguments it receives.
 *
 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * var greet = function(greeting, name) {
 *   return greeting + ' ' + name;
 * };
 *
 * var greetFred = _.partialRight(greet, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 *
 * // Partially applied with placeholders.
 * var sayHelloTo = _.partialRight(greet, 'hello', _);
 * sayHelloTo('fred');
 * // => 'hello fred'
 */
var partialRight = rest(function(func, partials) {
  var holders = replaceHolders(partials, getHolder(partialRight));
  return createWrapper(func, PARTIAL_RIGHT_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partialRight.placeholder = {};

module.exports = partialRight;


/***/ }),
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _createEagerFactory = __webpack_require__(667);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    return function (props) {
      return factory(propsMapper(props));
    };
  };
};

exports.default = (0, _createHelper2.default)(mapProps, 'mapProps');

/***/ }),
/* 1104 */,
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(2);

/***/ }),
/* 1106 */,
/* 1107 */,
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _injectPreparedData = __webpack_require__(2808);

var _injectPreparedData2 = _interopRequireDefault(_injectPreparedData);

var _IsomorphicRenderer = __webpack_require__(2807);

var _IsomorphicRenderer2 = _interopRequireDefault(_IsomorphicRenderer);

var _prepareData = __webpack_require__(2809);

var _prepareData2 = _interopRequireDefault(_prepareData);

var _prepareInitialRender = __webpack_require__(2810);

var _prepareInitialRender2 = _interopRequireDefault(_prepareInitialRender);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  injectPreparedData: _injectPreparedData2.default,
  prepareData: _prepareData2.default,
  prepareInitialRender: _prepareInitialRender2.default,
  Renderer: _IsomorphicRenderer2.default
};

/***/ }),
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var find = __webpack_require__(975);

var PinterestStore = function (_BaseStore) {
    _inherits(PinterestStore, _BaseStore);

    function PinterestStore(dispatcher) {
        _classCallCheck(this, PinterestStore);

        var _this = _possibleConstructorReturn(this, (PinterestStore.__proto__ || Object.getPrototypeOf(PinterestStore)).call(this, dispatcher));

        _this._user = {};
        _this._boards = [];
        _this._connectedBoard = null;

        _this._connectAccountsModal = {
            isOpen: false
        };

        _this._connectBoardModal = {
            isOpen: false,
            error: false
        };
        return _this;
    }

    _createClass(PinterestStore, [{
        key: '_showConnectAccountsModal',
        value: function _showConnectAccountsModal() {
            this._connectAccountsModal.isOpen = true;
            this.emitChange();
        }
    }, {
        key: '_hideConnectAccountsModal',
        value: function _hideConnectAccountsModal() {
            this._connectAccountsModal.isOpen = false;
            this.emitChange();
        }
    }, {
        key: '_showConnectBoardModal',
        value: function _showConnectBoardModal() {
            this._connectBoardModal.isOpen = true;
            this.emitChange();
        }
    }, {
        key: '_hideConnectBoardModal',
        value: function _hideConnectBoardModal() {
            this._connectBoardModal.isOpen = false;
            this._connectBoardModal.error = false;
            this.emitChange();
        }
    }, {
        key: '_onConnectBoardModalError',
        value: function _onConnectBoardModalError() {
            this._connectBoardModal.error = true;
            this.emitChange();
        }
    }, {
        key: '_onUserLoad',
        value: function _onUserLoad(user) {
            this._user = user;
            this.emitChange();
        }
    }, {
        key: '_onBoardsLoad',
        value: function _onBoardsLoad(boards) {
            this._boards = boards;
            this.emitChange();
        }
    }, {
        key: '_obBoardConnect',
        value: function _obBoardConnect(board) {
            this._connectedBoard = board;
            this._connectBoardModal.error = false;
            this.emitChange();
        }
    }, {
        key: '_onBoardCreated',
        value: function _onBoardCreated(board) {
            this._boards.push(board);
            this.emitChange();
        }
    }, {
        key: '_onDisconnect',
        value: function _onDisconnect() {
            this._user = {};
            this._boards = [];
            this._connectedBoard = null;
            this.emitChange();
        }
    }, {
        key: 'getConnectAccountsModal',
        value: function getConnectAccountsModal() {
            return this._connectAccountsModal;
        }
    }, {
        key: 'getConnectBoardModal',
        value: function getConnectBoardModal() {
            return this._connectBoardModal;
        }
    }, {
        key: 'getUser',
        value: function getUser() {
            return this._user;
        }
    }, {
        key: 'getBoards',
        value: function getBoards() {
            return this._boards;
        }
    }, {
        key: 'getBoard',
        value: function getBoard(id) {
            return find(this._boards, function (board) {
                return board.id === id;
            });
        }
    }, {
        key: 'getBoardByName',
        value: function getBoardByName(name) {
            return find(this._boards, function (board) {
                return board.name === name;
            });
        }
    }, {
        key: 'getConnectedBoard',
        value: function getConnectedBoard() {
            return this._connectedBoard;
        }
    }]);

    return PinterestStore;
}(BaseStore);

PinterestStore.storeName = 'PinterestStore';

PinterestStore.handlers = {
    'pinterest:connectAccountsModal:show': '_showConnectAccountsModal',
    'pinterest:connectAccountsModal:hide': '_hideConnectAccountsModal',
    'pinterest:connectBoardModal:show': '_showConnectBoardModal',
    'pinterest:connectBoardModal:hide': '_hideConnectBoardModal',
    'pinterest:connectBoardModal:error': '_onConnectBoardModalError',
    'pinterest:user:loaded': '_onUserLoad',
    'pinterest:boards:loaded': '_onBoardsLoad',
    'pinterest:boards:created': '_onBoardCreated',
    'pinterest:boards:error': '_onBoardCreated',
    'pinterest:board:connected': '_obBoardConnect',
    'pinterest:disconnected': '_onDisconnect'
};

module.exports = PinterestStore;

/***/ }),
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by augustocorvalan on 3/26/14.
 * UMD'ed by augustocorvalan on 4/16/14.
 */


var $ = __webpack_require__(5);
var User = __webpack_require__(15);
var price = __webpack_require__(936);
var currencies = __webpack_require__(280).currencies || {};
var DEFAULT_CURRENCY = currencies.DEFAULT_USD;
var findNamespaceValue = __webpack_require__(288);
var ContextProvider = __webpack_require__(293);
var UserStore = __webpack_require__(114);
var currencyActions = __webpack_require__(894);

/**
 * Initializes CurrencyLoader class
 * @param options
 * @param $el {obj} jQuery object of DOM region to be affected
 * @param userLoadOptions {obj} options to be passed in to dibs.user.load
 * @constructor
 */
function CurrencyLoader(options) {
    var self = this;
    var _defaults = {
        $el: null,
        userLoadOptions: {
            full: false,
            force: false
        }
    };

    this.options = $.extend(_defaults, options);
    if (this.options.$el) {
        this.$el = this.options.$el;
    }
    if (this.$el && !User.loggedIn()) {
        //only need to listen for this if the user is logged out
        // and there's an $el to update...
        User.getCurrentUser().on('login:change', function () {
            self.onLoginPriceUpdate();
        });
    }
}

module.exports = CurrencyLoader;

$.extend(CurrencyLoader.prototype, {

    /**
     * event handler for user login/register success via the authModal,
     * resets the currency on prices
     * @param {object} userData
     * @param {object} userData.profile
     * @param {string} userData.profile.currency
     */
    onLoginPriceUpdate : function (userData) {
        this.updatePrices(true, findNamespaceValue('profile.currency', userData, DEFAULT_CURRENCY));
    },

    /**
     * calls currencyActions.loadCurrencyForUser to grab the preferred currency and passes it along to the
     * price mixin to show the prices
     */
    loadLocalizedPrices: function () {
        var self = this;
        var deferred = $.Deferred();

        ContextProvider.getContext().then(function (context) {
            context
                .executeAction(currencyActions.loadCurrencyForUser)
                .then(function () {
                    var currency = context.getStore(UserStore).getCurrency();
                    self.updatePrices(true, currency);
                    self.showLabels();
                    deferred.resolve(currency);
                });
        });

        return deferred.promise();
    }
}, price);


/***/ }),
/* 1119 */,
/* 1120 */,
/* 1121 */
/***/ (function(module, exports) {

/*!
 * jQuery UI Widget 1.10.0
 * http://jqueryui.com
 *
 * Copyright 2013 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/jQuery.widget/
 */
(function( $, undefined ) {

var uuid = 0,
	slice = Array.prototype.slice,
	_cleanData = $.cleanData;
$.cleanData = function( elems ) {
	for ( var i = 0, elem; (elem = elems[i]) != null; i++ ) {
		try {
			$( elem ).triggerHandler( "remove" );
		// http://bugs.jquery.com/ticket/8235
		} catch( e ) {}
	}
	_cleanData( elems );
};

$.widget = function( name, base, prototype ) {
	var fullName, existingConstructor, constructor, basePrototype,
		// proxiedPrototype allows the provided prototype to remain unmodified
		// so that it can be used as a mixin for multiple widgets (#8876)
		proxiedPrototype = {},
		namespace = name.split( "." )[ 0 ];

	name = name.split( "." )[ 1 ];
	fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	// create selector for plugin
	$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
		return !!$.data( elem, fullName );
	};

	$[ namespace ] = $[ namespace ] || {};
	existingConstructor = $[ namespace ][ name ];
	constructor = $[ namespace ][ name ] = function( options, element ) {
		// allow instantiation without "new" keyword
		if ( !this._createWidget ) {
			return new constructor( options, element );
		}

		// allow instantiation without initializing for simple inheritance
		// must use "new" keyword (the code above always passes args)
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};
	// extend with the existing constructor to carry over any static properties
	$.extend( constructor, existingConstructor, {
		version: prototype.version,
		// copy the object used to create the prototype in case we need to
		// redefine the widget later
		_proto: $.extend( {}, prototype ),
		// track widgets that inherit from this widget in case this widget is
		// redefined after a widget inherits from it
		_childConstructors: []
	});

	basePrototype = new base();
	// we need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
	basePrototype.options = $.widget.extend( {}, basePrototype.options );
	$.each( prototype, function( prop, value ) {
		if ( !$.isFunction( value ) ) {
			proxiedPrototype[ prop ] = value;
			return;
		}
		proxiedPrototype[ prop ] = (function() {
			var _super = function() {
					return base.prototype[ prop ].apply( this, arguments );
				},
				_superApply = function( args ) {
					return base.prototype[ prop ].apply( this, args );
				};
			return function() {
				var __super = this._super,
					__superApply = this._superApply,
					returnValue;

				this._super = _super;
				this._superApply = _superApply;

				returnValue = value.apply( this, arguments );

				this._super = __super;
				this._superApply = __superApply;

				return returnValue;
			};
		})();
	});
	constructor.prototype = $.widget.extend( basePrototype, {
		// TODO: remove support for widgetEventPrefix
		// always use the name + a colon as the prefix, e.g., draggable:start
		// don't prefix for widgets that aren't DOM-based
		widgetEventPrefix: existingConstructor ? basePrototype.widgetEventPrefix : name
	}, proxiedPrototype, {
		constructor: constructor,
		namespace: namespace,
		widgetName: name,
		widgetFullName: fullName
	});

	// If this widget is being redefined then we need to find all widgets that
	// are inheriting from it and redefine all of them so that they inherit from
	// the new version of this widget. We're essentially trying to replace one
	// level in the prototype chain.
	if ( existingConstructor ) {
		$.each( existingConstructor._childConstructors, function( i, child ) {
			var childPrototype = child.prototype;

			// redefine the child widget using the same prototype that was
			// originally used, but inherit from the new version of the base
			$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto );
		});
		// remove the list of existing child constructors from the old constructor
		// so the old child constructors can be garbage collected
		delete existingConstructor._childConstructors;
	} else {
		base._childConstructors.push( constructor );
	}

	$.widget.bridge( name, constructor );
};

$.widget.extend = function( target ) {
	var input = slice.call( arguments, 1 ),
		inputIndex = 0,
		inputLength = input.length,
		key,
		value;
	for ( ; inputIndex < inputLength; inputIndex++ ) {
		for ( key in input[ inputIndex ] ) {
			value = input[ inputIndex ][ key ];
			if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
				// Clone objects
				if ( $.isPlainObject( value ) ) {
					target[ key ] = $.isPlainObject( target[ key ] ) ?
						$.widget.extend( {}, target[ key ], value ) :
						// Don't extend strings, arrays, etc. with objects
						$.widget.extend( {}, value );
				// Copy everything else by reference
				} else {
					target[ key ] = value;
				}
			}
		}
	}
	return target;
};

$.widget.bridge = function( name, object ) {
	var fullName = object.prototype.widgetFullName || name;
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string",
			args = slice.call( arguments, 1 ),
			returnValue = this;

		// allow multiple hashes to be passed on init
		options = !isMethodCall && args.length ?
			$.widget.extend.apply( null, [ options ].concat(args) ) :
			options;

		if ( isMethodCall ) {
			this.each(function() {
				var methodValue,
					instance = $.data( this, fullName );
				if ( !instance ) {
					return $.error( "cannot call methods on " + name + " prior to initialization; " +
						"attempted to call method '" + options + "'" );
				}
				if ( !$.isFunction( instance[options] ) || options.charAt( 0 ) === "_" ) {
					return $.error( "no such method '" + options + "' for " + name + " widget instance" );
				}
				methodValue = instance[ options ].apply( instance, args );
				if ( methodValue !== instance && methodValue !== undefined ) {
					returnValue = methodValue && methodValue.jquery ?
						returnValue.pushStack( methodValue.get() ) :
						methodValue;
					return false;
				}
			});
		} else {
			this.each(function() {
				var instance = $.data( this, fullName );
				if ( instance ) {
					instance.option( options || {} )._init();
				} else {
					$.data( this, fullName, new object( options, this ) );
				}
			});
		}

		return returnValue;
	};
};

$.Widget = function( /* options, element */ ) {};
$.Widget._childConstructors = [];

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	defaultElement: "<div>",
	options: {
		disabled: false,

		// callbacks
		create: null
	},
	_createWidget: function( options, element ) {
		element = $( element || this.defaultElement || this )[ 0 ];
		this.element = $( element );
		this.uuid = uuid++;
		this.eventNamespace = "." + this.widgetName + this.uuid;
		this.options = $.widget.extend( {},
			this.options,
			this._getCreateOptions(),
			options );

		this.bindings = $();
		this.hoverable = $();
		this.focusable = $();

		if ( element !== this ) {
			$.data( element, this.widgetFullName, this );
			this._on( true, this.element, {
				remove: function( event ) {
					if ( event.target === element ) {
						this.destroy();
					}
				}
			});
			this.document = $( element.style ?
				// element within the document
				element.ownerDocument :
				// element is window or document
				element.document || element );
			this.window = $( this.document[0].defaultView || this.document[0].parentWindow );
		}

		this._create();
		this._trigger( "create", null, this._getCreateEventData() );
		this._init();
	},
	_getCreateOptions: $.noop,
	_getCreateEventData: $.noop,
	_create: $.noop,
	_init: $.noop,

	destroy: function() {
		this._destroy();
		// we can probably remove the unbind calls in 2.0
		// all event bindings should go through this._on()
		this.element
			.unbind( this.eventNamespace )
			// 1.9 BC for #7810
			// TODO remove dual storage
			.removeData( this.widgetName )
			.removeData( this.widgetFullName )
			// support: jquery <1.6.3
			// http://bugs.jquery.com/ticket/9413
			.removeData( $.camelCase( this.widgetFullName ) );
		this.widget()
			.unbind( this.eventNamespace )
			.removeAttr( "aria-disabled" )
			.removeClass(
				this.widgetFullName + "-disabled " +
				"ui-state-disabled" );

		// clean up events and states
		this.bindings.unbind( this.eventNamespace );
		this.hoverable.removeClass( "ui-state-hover" );
		this.focusable.removeClass( "ui-state-focus" );
	},
	_destroy: $.noop,

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key,
			parts,
			curOption,
			i;

		if ( arguments.length === 0 ) {
			// don't return a reference to the internal hash
			return $.widget.extend( {}, this.options );
		}

		if ( typeof key === "string" ) {
			// handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
			options = {};
			parts = key.split( "." );
			key = parts.shift();
			if ( parts.length ) {
				curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
				for ( i = 0; i < parts.length - 1; i++ ) {
					curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
					curOption = curOption[ parts[ i ] ];
				}
				key = parts.pop();
				if ( value === undefined ) {
					return curOption[ key ] === undefined ? null : curOption[ key ];
				}
				curOption[ key ] = value;
			} else {
				if ( value === undefined ) {
					return this.options[ key ] === undefined ? null : this.options[ key ];
				}
				options[ key ] = value;
			}
		}

		this._setOptions( options );

		return this;
	},
	_setOptions: function( options ) {
		var key;

		for ( key in options ) {
			this._setOption( key, options[ key ] );
		}

		return this;
	},
	_setOption: function( key, value ) {
		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this.widget()
				.toggleClass( this.widgetFullName + "-disabled ui-state-disabled", !!value )
				.attr( "aria-disabled", value );
			this.hoverable.removeClass( "ui-state-hover" );
			this.focusable.removeClass( "ui-state-focus" );
		}

		return this;
	},

	enable: function() {
		return this._setOption( "disabled", false );
	},
	disable: function() {
		return this._setOption( "disabled", true );
	},

	_on: function( suppressDisabledCheck, element, handlers ) {
		var delegateElement,
			instance = this;

		// no suppressDisabledCheck flag, shuffle arguments
		if ( typeof suppressDisabledCheck !== "boolean" ) {
			handlers = element;
			element = suppressDisabledCheck;
			suppressDisabledCheck = false;
		}

		// no element argument, shuffle and use this.element
		if ( !handlers ) {
			handlers = element;
			element = this.element;
			delegateElement = this.widget();
		} else {
			// accept selectors, DOM elements
			element = delegateElement = $( element );
			this.bindings = this.bindings.add( element );
		}

		$.each( handlers, function( event, handler ) {
			function handlerProxy() {
				// allow widgets to customize the disabled handling
				// - disabled as an array instead of boolean
				// - disabled class as method for disabling individual parts
				if ( !suppressDisabledCheck &&
						( instance.options.disabled === true ||
							$( this ).hasClass( "ui-state-disabled" ) ) ) {
					return;
				}
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}

			// copy the guid so direct unbinding works
			if ( typeof handler !== "string" ) {
				handlerProxy.guid = handler.guid =
					handler.guid || handlerProxy.guid || $.guid++;
			}

			var match = event.match( /^(\w+)\s*(.*)$/ ),
				eventName = match[1] + instance.eventNamespace,
				selector = match[2];
			if ( selector ) {
				delegateElement.delegate( selector, eventName, handlerProxy );
			} else {
				element.bind( eventName, handlerProxy );
			}
		});
	},

	_off: function( element, eventName ) {
		eventName = (eventName || "").split( " " ).join( this.eventNamespace + " " ) + this.eventNamespace;
		element.unbind( eventName ).undelegate( eventName );
	},

	_delay: function( handler, delay ) {
		function handlerProxy() {
			return ( typeof handler === "string" ? instance[ handler ] : handler )
				.apply( instance, arguments );
		}
		var instance = this;
		return setTimeout( handlerProxy, delay || 0 );
	},

	_hoverable: function( element ) {
		this.hoverable = this.hoverable.add( element );
		this._on( element, {
			mouseenter: function( event ) {
				$( event.currentTarget ).addClass( "ui-state-hover" );
			},
			mouseleave: function( event ) {
				$( event.currentTarget ).removeClass( "ui-state-hover" );
			}
		});
	},

	_focusable: function( element ) {
		this.focusable = this.focusable.add( element );
		this._on( element, {
			focusin: function( event ) {
				$( event.currentTarget ).addClass( "ui-state-focus" );
			},
			focusout: function( event ) {
				$( event.currentTarget ).removeClass( "ui-state-focus" );
			}
		});
	},

	_trigger: function( type, event, data ) {
		var prop, orig,
			callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();
		// the original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );
		return !( $.isFunction( callback ) &&
			callback.apply( this.element[0], [ event ].concat( data ) ) === false ||
			event.isDefaultPrevented() );
	}
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
	$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
		if ( typeof options === "string" ) {
			options = { effect: options };
		}
		var hasOptions,
			effectName = !options ?
				method :
				options === true || typeof options === "number" ?
					defaultEffect :
					options.effect || defaultEffect;
		options = options || {};
		if ( typeof options === "number" ) {
			options = { duration: options };
		}
		hasOptions = !$.isEmptyObject( options );
		options.complete = callback;
		if ( options.delay ) {
			element.delay( options.delay );
		}
		if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
			element[ method ]( options );
		} else if ( effectName !== method && element[ effectName ] ) {
			element[ effectName ]( options.duration, options.easing, callback );
		} else {
			element.queue(function( next ) {
				$( this )[ method ]();
				if ( callback ) {
					callback.call( element[ 0 ] );
				}
				next();
			});
		}
	};
});

})( jQuery );


/***/ }),
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-minus'].join(' '), 'data-tn': 'minus', viewBox: '0 -120 250 250' },
                React.createElement('rect', { width: '250', height: '15', rx: '10' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(39);
var get = __webpack_require__(14);

var _require = __webpack_require__(275),
    Provider = _require.Provider;

var _require2 = __webpack_require__(384),
    combineReducers = _require2.combineReducers,
    createStore = _require2.createStore,
    applyMiddleware = _require2.applyMiddleware;

var _require3 = __webpack_require__(516),
    reducers = _require3.reducers;

var _require4 = __webpack_require__(271),
    track = _require4.track;

var MakeOfferRenderer = __webpack_require__(3425);
var authProcess = __webpack_require__(3426);

var authConstants = __webpack_require__(266).default.constants;

var modalContainer = document.createElement('div');

module.exports = function (options) {
    var item = options.item,
        linkLocation = options.linkLocation,
        currency = options.currency,
        currentStep = options.currentStep,
        _options$preloadedSta = options.preloadedState,
        preloadedState = _options$preloadedSta === undefined ? {} : _options$preloadedSta;


    var itemId = void 0;
    var sellerId = void 0;

    // If backbone model passed
    if (item && item.get) {
        itemId = item.get('id');
        sellerId = item.get('seller.id');
    } else {
        itemId = get(item, 'id');
        sellerId = get(item, 'seller.id');
    }

    var modalProps = {
        itemId: itemId,
        sellerId: sellerId,
        chatTracking: track,
        pageCurrency: currency,
        linkLocation: linkLocation,
        startAuth: function startAuth(authProps) {
            return authProcess(_extends({}, authProps, { flow: authProps.makeOffer && authConstants.CONTACT_DEALER_FORM_FLOW }));
        },
        currentStep: currentStep
    };

    var store = createStore(combineReducers(reducers), preloadedState, applyMiddleware(__webpack_require__(567).default));

    ReactDOM.render(React.createElement(
        Provider,
        { store: store },
        React.createElement(MakeOfferRenderer, { modalProps: modalProps })
    ), modalContainer);
};

/***/ }),
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setTradeStatusToApplied = exports.setTradeStatusToSuspected = exports.eligibleToApplyForTrade = exports.currentUserTradeStatus = exports.userLoggedIn = exports.currentUser = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.conditionalMarkSuspectedTrade = conditionalMarkSuspectedTrade;
exports.currentUserCreatedDate = currentUserCreatedDate;
exports.currentUserEmail = currentUserEmail;
exports.currentUserID = currentUserID;
exports.setUserName = setUserName;
exports.setUserZipCode = setUserZipCode;
exports.userJustRegistered = userJustRegistered;
exports.whenUserAuthenticated = whenUserAuthenticated;
exports.whenUserFullyLoaded = whenUserFullyLoaded;

var _lodash = __webpack_require__(843);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(65);

var _lodash4 = _interopRequireDefault(_lodash3);

var _Role = __webpack_require__(1623);

var _Role2 = _interopRequireDefault(_Role);

var _User = __webpack_require__(15);

var _User2 = _interopRequireDefault(_User);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TRADE_STATUSES = _User2.default.TRADE_STATUSES;

var tradeStatusesThatCanApplyForTrade = (0, _lodash4.default)(TRADE_STATUSES, ['N_A', 'SUSPECTED']);

var updateUserTradeStatusOptions = function updateUserTradeStatusOptions(statusName) {
    return {
        userStatus: {
            apiType: 'roleStatus',
            name: statusName
        }
    };
};

var currentUser = exports.currentUser = function currentUser() {
    return _User2.default.getCurrentUser();
};

var userLoggedIn = exports.userLoggedIn = function userLoggedIn() {
    return _User2.default.loggedIn();
};

var saveTradeStatus = function saveTradeStatus(statusName) {
    return function () {
        if (userLoggedIn()) {
            var role = new _Role2.default(_extends({ name: _User2.default.BUYER_TRADE }, updateUserTradeStatusOptions(statusName)));
            currentUser().get('roles').add(role);
            role.saveRoleForUser();
        }
    };
};

var currentUserTradeStatus = exports.currentUserTradeStatus = function currentUserTradeStatus() {
    return _User2.default.loggedIn() ? currentUser().getTradeStatus() : null;
};

var eligibleToApplyForTrade = exports.eligibleToApplyForTrade = function eligibleToApplyForTrade() {
    return (0, _lodash2.default)(tradeStatusesThatCanApplyForTrade, currentUserTradeStatus());
};

var setTradeStatusToSuspected = exports.setTradeStatusToSuspected = saveTradeStatus(_User2.default.TRADE_STATUSES.SUSPECTED);

function conditionalMarkSuspectedTrade() {
    if (userLoggedIn()) {
        _User2.default.load().then(function () {
            if (currentUserTradeStatus() === TRADE_STATUSES.N_A) {
                setTradeStatusToSuspected();
            }
        });
    }
}

function currentUserCreatedDate() {
    if (userLoggedIn()) {
        var timeStamp = currentUser().get('createdDate');
        return timeStamp ? new Date(timeStamp) : null;
    }

    return null;
}

function currentUserEmail() {
    if (userLoggedIn()) {
        return currentUser().get('profile.email');
    }

    return null;
}

function currentUserID() {
    if (userLoggedIn()) {
        return _User2.default.getUserId();
    }

    return null;
}

var setTradeStatusToApplied = exports.setTradeStatusToApplied = saveTradeStatus(_User2.default.TRADE_STATUSES.APPLIED_IN_REVIEW);

function setUserName(firstName, lastName) {
    if (userLoggedIn()) {
        var fullName = firstName + ' ' + lastName;
        currentUser().get('profile').setDisplayName(fullName).save();
    }
};

function setUserZipCode(zipCode) {
    if (userLoggedIn()) {
        var user = currentUser();
        user.set('profile.zipCode', zipCode);
        user.get('profile').save();
    }
};

function userJustRegistered() {
    return currentUser().get('newUser');
};

function whenUserAuthenticated(callback) {
    if (userLoggedIn()) {
        callback();
    } else {
        currentUser().on('login:change', function () {
            _User2.default.load().then(function () {
                if (userLoggedIn()) {
                    callback();
                }
            });
        });
    }
};

function whenUserFullyLoaded(cb) {
    _User2.default.load().then(cb);
};

/***/ }),
/* 1151 */,
/* 1152 */,
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);

var SocialNetwork = module.exports = SoaModel.extend();

Object.assign(SocialNetwork, {
    NAME_PINTEREST: 'PINTEREST'
});

Object.assign(SocialNetwork.prototype, {
    defaults: {
        apiType: "socialNetwork",
        name: null,
        authorizationImpl: "oath2",
        modifiedDate: null
    }
});

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/** Used to determine if values are of the language type Object */
var objectTypes = {
  'boolean': false,
  'function': true,
  'object': true,
  'number': false,
  'string': false,
  'undefined': false
};

module.exports = objectTypes;


/***/ }),
/* 1155 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array ? array.length : 0,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*jslint node:true, vars:true */
/**
 * requ.js v0.0.0
 */



console.assert(typeof module !== "undefined", 'Node JS or CommonJS environment required');

var isBrowser = (typeof window !== "undefined");
var root = typeof window === 'undefined' ? global : window;
if (!root._reku) {
    // ---------------------------------------------------
    // Dependencies
    var superagent = __webpack_require__(4253);
    var _ = __webpack_require__(22);
    var Qs = __webpack_require__(4154);
    var Deferred = __webpack_require__(29).Deferred;

    //Add URL params to backbone model or backbone collection URL
    var extendURL = function(url, data) {
        var urlArray = url.split('?');
        var queries;

        queries = urlArray[1] ? Qs.parse(urlArray[1]) : {};
        _.extend(queries, data);
        return urlArray[0] + '?' + Qs.stringify(queries);
    };


    // ---------------------------------------------------
    // Local vars

    // will use $.ajax if jquery is defined globally
    var jQueryAjax = (typeof $ !== "undefined") ? $.ajax : null;

    var methodsMap = {
        'GET': 'get',
        'POST': 'post',
        'PUT': 'put',
        'DELETE': 'del',
        'PATCH': 'patch',
        'HEAD': 'head'
    };

    var dataTypeAcceptsMap = {
        html: 'text/html',
        xml: 'text/xml',
        text: 'text/plain',
        json: 'application/json'
    };

    var methodsWithBody = ['POST', 'PUT', 'PATCH'];

    // ---------------------------------------------------
    // Module Definition


    /**
     * @module requ
     * @param {object} options A jQuery.ajax style options object
     * @returns {requ.Request}
     */
    var requ = root._reku = function (options) {
        return new requ.Request().send(options);
    };

    /**
     * @memberOf module:requ
     * @type {boolean}
     */
    requ.useJQueryIfBrowser = true;

    /**
     * Replace jQuery.ajax with requ, if you want to
     * force existing modules using it to use requ
     * instead.
     * @memberOf module:requ
     * @param  {boolean} shouldReplace
     *     Pass true to replace $.ajax with calls
     *     with requ, and pass false to restore it
     * @returns {function} requ module function
     */
    requ.replaceJQueryAjax = function (shouldReplace) {
        console.assert(!!$ && !!$.ajax, 'jQuery is required in order to replace jQuery.ajax');
        if (shouldReplace) {
            $.ajax = requ;
        } else {
            $.ajax = jQueryAjax;
        }
        return requ;
    };

    /**
     * Set a static callback function that
     * will be invoked before any request
     * is made with requ
     * @memberOf module:requ
     * @param {Function} callback
     */
    requ.setBeforeRequestCallback = function (callback) {
        requ.Request._onBeforeRequest = callback;
    };

    /**
     * Set a static callback function that
     * is invoked at the end of every
     * superagent request made with requ.
     * @param callback
     */
    requ.setAfterSARequestCallback = function (callback) {
        requ.Request._onAfterSARequest = callback;
    };

    /**
     * Set a static callback function that is
     * invoked when a superagent request is
     * sent.
     * @memberOf module:requ
     * @param {function} callback
     */
    requ.setOnSARequestSentEvent = function (callback) {
        requ.setSAEventListener('request', callback);
    };

    /**
     * Set a static callback function that
     * is invoked when the headers for a response
     * are received but the body of the response
     * hasn't been downloaded yet.
     * @memberOf module:requ
     * @param {function} callback
     */
    requ.setOnSAResponseEvent = function (callback) {
        requ.setSAEventListener('response', callback);
    };

    /**
     * Set a callback that will be invoked every time
     * a superagent instance emits that event
     * @memberOf module:requ
     * @param {string} event
     * @param {function} callback
     */
    requ.setSAEventListener = function (event, callback) {
        requ.Request._saEventListeners[event] = callback;
    };

    /**
     * @class Request
     * @memberOf module:requ
     */
    var Request = requ.Request = function () {};

    /**
     * @memberOf module:requ.Request
     * @type {boolean}
     * @protected
     */
    Request._isBrowser = isBrowser;

    /**
     * @memberOf module:requ.Request
     * @type {function}
     * @protected
     */
    Request._jQueryAjax = jQueryAjax;

    /**
     * @memberOf module:requ.Request
     * @type {object}
     * @protected
     */
    Request._dataTypeAcceptsMap = dataTypeAcceptsMap;

    /**
     * @memberOf module:requ.Request
     * @type {string[]}
     * @protected
     */
    Request._allowedOptions = [
        'url', 'type', 'dataType', 'contentType', 'data', 'success', 'error', 'complete', 'headers', 'context'
    ];

    /**
     * @memberOf module:requ.Request
     * @type {object}
     * @private
     */
    Request._saEventListeners = {};

    /**
     * @private
     * @type {string[]}
     * @memberOf module:requ.Request
     */
    Request._jQueryAjaxOptions = [
        'accepts', 'async', 'beforeSend', 'cache', 'complete', 'contents', 'contentType', 'context', 'converters', 'crossDomain', 'data', 'dataFilter', 'dataType', 'error', 'global', 'headers', 'ifModified', 'isLocal', 'jsonp', 'jsonpCallback', 'mimeType', 'password', 'processData', 'scriptCharset', 'statusCode', 'success', 'timeout', 'traditional', 'type', 'url', 'username', 'xhr', 'xhrFields'
    ];

    /**
     * @memberOf module:requ.Request
     * @protected
     */
    Request._statusKeyVals = [
        { status: 200, statusText: 'OK' },
        { status: 201, statusText: 'Created' },
        { status: 202, statusText: 'Accepted' },
        { status: 204, statusText: 'No Content' },
        { status: 301, statusText: 'Moved Permanently' },
        { status: 302, statusText: 'Found' },
        { status: 400, statusText: 'Bad Request' },
        { status: 401, statusText: 'Unauthorized' },
        { status: 403, statusText: 'Forbidden' },
        { status: 404, statusText: 'Not Found' },
        { status: 405, statusText: 'Method Not Allowed' },
        { status: 408, statusText: 'Request Timeout' },
        { status: 412, statusText: 'Precondition Failed' },
        { status: 500, statusText: 'Internal Server Error' },
        { status: 502, statusText: 'Bad Gateway' },
        { status: 503, statusText: 'Service Unavailable' },
        { status: 504, statusText: 'Gateway Timeout' }
    ];

    /**
     * @memberOf module:requ.Request
     * @protected
     */
    Request._defaultSettings = {
        async: true,
        accepts: {
            "*": "*/*",
            html: "text/html",
            json: "application/json, text/javascript",
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
            text: "text/plain",
            xml: "application/xml, text/xml"
        },
        type: 'GET',
        global: false,
        crossDomain: false,
        processData: true
    };

    /**
     * @lends module:requ.Request.prototype
     */
    Request.prototype = {

        /**
         * @param {object} options A jQuery.ajax style options object
         * @return {Promise}
         */
        send: function (options) {
            this._testAllowedOptions(options); // Warn user if unsupported options are used
            if (Request._isBrowser && requ.useJQueryIfBrowser) {
                console.assert(Request._jQueryAjax, 'jQuery is required if "requ.useJQueryIfBrowser" is true');
                options = this._settings = this._invokeBeforeRequestCallback(options);
                return Request._jQueryAjax(options);
            }
            return this.sendUsingSuperAgent(options);
        },

        /**
         * @param {object} options A jQuery.ajax style options object
         * @return {Promise}
         */
        sendUsingSuperAgent: function (options) {

            if (this._requXhr) {
                console.error('Request on requ.Request instance already in progress');
                return null;
            }

            options = this._invokeBeforeRequestCallback(options);

            options = this._settings = this._formatSettings(options);

            var self = this;
            var method = options.type;
            var url = options.url;
            var data = options.data;
            var dataType = options.dataType;
            var contentType = options.contentType;
            var dfd = self._deferred = self._makeDeferred();
            var requXhr = self._requXhr = dfd.promise();
            var request;

            var methodFn;

            self._context = options.context || self._settings;

            requXhr.readyState = 0;

            method = method.toUpperCase();
            methodFn = methodsMap[method];

            console.assert(methodFn, 'options.type "' + methodsMap[method] + '" not supported');
            console.assert(typeof url === 'string', 'options.url is required');
            console.assert(superagent[methodFn], 'superagent version does not support method "' + method + '"');

            self._request = request = self._makeSARequestInstance(methodFn, url);

            self._bindEventListeners(request);

            console.assert(!data || (data && contentType) || (data && !self._useRequestBodyForMethod(method)), 'options.contentType is required if options.data is provided for PUT/POST');
            console.assert(typeof dataType === 'string', 'options.dataType is required');
            console.assert(dataTypeAcceptsMap[dataType], 'options.dataType value "' + dataType + '" is not supported');

            if (data && !_.isEmpty(data)) {
                if (self._useRequestBodyForMethod(method)) {
                    request = request.send(data); // add body for methods that have a body
                } else {
                    options.url = extendURL(options.url, data); // so that success callbacks can access the url you would with jquery
                    request = request.query(data); // add query params for methods that don't have a body
                }
            }

            if (contentType) {
                request = request.set('Content-Type', contentType);
            }

            if (dataType) {
                request = request.set('Accepts', dataTypeAcceptsMap[dataType]);
            }

            // Set 'Content-Length' to 0 because 'Transfer-Encoding' is set to 'chunked' by default on Node apps and DELETEs 503
            // TODO : Remove when Node is upgraded (fixed as of Node v0.11)
            if (method === 'DELETE') {
                options.headers = options.headers || {};
                options.headers['Content-Length'] = 0;
            }

            if (options.headers) {
                request = self._setHeaders(request, options.headers);
            }

            if (!request) {
                return null;
            }

            request.end(_.bind(self._onSARequestEnd, self));

            requXhr.abort = _.bind(request.abort, request);

            self._attachCallbacks(dfd, options);

            return requXhr;
        },

        /**
         * Return the settings used for the request
         * (e.g. url, method, etc.)
         * @returns {object}
         */
        getRequestSettings: function () {
            return this._settings;
        },

        /**
         * @returns {superagent.Request}
         */
        getSARequest: function () {
            return this._request;
        },

        /**
         * Return the request url with the query string
         * @returns {string}
         */
        getSARequestFullURL: function () {
            var request = this._request;
            var settings;
            var url;
            if (request && request.url) {
                settings = this._settings;
                url = request.url;
                if (settings && settings.data && !this._useRequestBodyForMethod(settings.type)) {
                    url = extendURL(url, settings.data);
                }
                return url;
            }
            return null;
        },

        /**
         * @returns {string}
         */
        getSARequestMethod: function () {
            var request = this._request;
            return request ? request.method : null;
        },

        /**
         * @returns {object}
         */
        getSARequestPayload: function () {
            var settings = this._settings;
            if (settings && this._useRequestBodyForMethod(settings.type) && settings.data) {
                return settings.data;
            }
            return null;
        },

        _invokeBeforeRequestCallback: function (options) {
            if (typeof Request._onBeforeRequest === 'function') {
                options = Request._onBeforeRequest.call(this, options) || options;
            }
            return options;
        },

        _invokeAfterSARequestCallback: function (err, response) {
            if (typeof Request._onAfterSARequest === 'function') {
                Request._onAfterSARequest.call(this, err, response);
            }
        },

        /**
         * @param {string} method
         * @returns {boolean}
         * @protected
         */
        _useRequestBodyForMethod: function (method) {
            return _.indexOf(methodsWithBody, method) > -1;
        },

        /**
         * @returns {Deferred}
         * @protected
         */
        _makeDeferred: function () {
            return new Deferred();
        },

        /**
         * @param res
         * @returns {object}
         * @protected
         */
        _getXhrPropertiesFromRes: function (res) {
            var contentType;
            var statusInfo = this._findStatusInfo(res.statusCode);
            var props = {
                status: res.statusCode,
                statusCode: res.statusCode,
                statusText: (statusInfo ? statusInfo.statusText : ''),
                responseText: res.text,
                response: res.text
            };
            if (res.body && res.headers && res.headers['content-type']) {
                contentType = res.headers['content-type'] || '';
                if (contentType.indexOf('application/json') > -1) {
                    props.responseJSON = res.body;
                } else if (contentType.indexOf('application/xml') > -1 || contentType.indexOf('text/xml') > -1) {
                    props.responseXML = res.body;
                }
            }
            return props;
        },

        /**
         * Handles request end event for superagent.Request instances
         * @param  {Error} err
         * @param  {superagent.Response} response
         * @protected
         */
        _onSARequestEnd: function (err, response) {

            this._invokeAfterSARequestCallback(err, response);

            var self = this;
            var dfd = self._deferred;
            var requXhr = self._requXhr;
            var context = self._context;
            var xhr = (response && response.xhr) ? response.xhr : null;

            if (!xhr && response && response.res) {
                _.extend(requXhr, self._getXhrPropertiesFromRes(response.res));
            } else if (xhr) {
                _.extend(requXhr, self._getXhrPropertiesFromXhr(xhr));
            }

            requXhr.readyState = 4;
            requXhr.superagentResponse = response;

            if (err) {
                requXhr.superagentError = err;
                dfd.rejectWith(context, [requXhr, 'error', err]);
                self._requXhr = null;
                return;
            }
            if (self._resStatusIsError(requXhr.statusCode)) {
                dfd.rejectWith(context, [requXhr, 'error']);
                self._requXhr = null;
                return;
            }
            dfd.resolveWith(context, [response.body, 'success', requXhr]);
            self._requXhr = null;
        },

        /**
         * Ensure that the request options are similar
         * to the settings object that jquery uses as the
         * context for it's callbacks
         * @param ajaxOptions
         * @private
         */
        _formatSettings: function (ajaxOptions) {
            ajaxOptions = _.extend({}, Request._defaultSettings, ajaxOptions);
            ajaxOptions.type = ajaxOptions.type.toUpperCase();
            return ajaxOptions;
        },

        /**
         * @param {number} status
         * @returns {object}
         * @protected
         */
        _findStatusInfo: function (status) {
            var i = 0;
            var keyVals = Request._statusKeyVals;
            var len = keyVals.length;
            for (i; i < len; i++) {
                if (keyVals[i].status === status) {
                    return keyVals[i];
                }
            }
            return null;
        },

        /**
         * @param {number} status
         * @returns {boolean}
         * @protected
         */
        _resStatusIsError: function (status) {
            var strStatus = String(status);
            var firstNum = Number(strStatus.charAt(0));
            return (firstNum !== 2 && firstNum !== 3);
        },

        /**
         * @param {XMLHttpRequest} xhr
         * @returns {object}
         * @protected
         */
        _getXhrPropertiesFromXhr: function (xhr) {
            return _.pick(xhr, 'status', 'statusCode', 'statusText', 'response', 'responseText', 'responseJSON', 'responseXML');
        },

        /**
         * @param {Promise} promise
         * @param {object} options jQuery ajax options
         * @protected
         */
        _attachCallbacks: function (promise, options) {
            var onDone = options.success || options.done;
            var onFail = options.error || options.fail;
            var onComplete = options.complete || options.always;
            if (onDone) {
                promise.done(onDone);
            }
            if (onFail) {
                promise.fail(onFail);
            }
            if (onComplete) {
                promise.always(onComplete);
            }
        },

        /**
         * @param {string} method
         * @param {string} url
         * @returns {superagent.Request}
         * @protected
         */
        _makeSARequestInstance: function (method, url) {
            return superagent[method](url);
        },

        /**
         * @param {superagent.Request} request
         * @param {object} headers
         * @returns {superagent.Request}
         * @protected
         */
        _setHeaders: function (request, headers) {
            _.each(headers, function (headerVal, headerKey) {
                request = request.set(headerKey, headerVal);
            });
            return request;
        },

        /**
         * Shows warnings if the user passes an option that
         * is supported by $.ajax but not by requ.
         * @param {object} options [jQuery ajax options]{@link http://api.jquery.com/jquery.ajax/}
         * @returns {boolean}
         * @protected
         */
        _testAllowedOptions: function (options) {
            var key;
            var hasError = false;
            for (key in options) {
                if (options.hasOwnProperty(key)) {
                    if (_.indexOf(Request._allowedOptions, key) === -1 &&
                        _.indexOf(Request._jQueryAjaxOptions, key) > -1) {
                        console.warn('Options "' + key + '" is not supported by requ');
                        hasError = true;
                    }
                }
            }
            return !hasError;
        },

        /**
         * @param {superagent.Request} request
         * @protected
         */
        _bindEventListeners: function (request) {
            var events = Request._saEventListeners;
            _.each(events, function (callback, event) {
                request.on(event, _.bind(callback, this));
            }, this);
        }

    };
}

module.exports = root._reku;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function defaultEqualityCheck(a, b) {
  return a === b;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];

  var lastArgs = null;
  var lastResult = null;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (lastArgs === null || lastArgs.length !== args.length || !args.every(function (value, index) {
      return equalityCheck(value, lastArgs[index]);
    })) {
      lastResult = func.apply(undefined, args);
    }
    lastArgs = args;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    memoizeOptions[_key2 - 1] = arguments[_key2];
  }

  return function () {
    for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      funcs[_key3] = arguments[_key3];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      return resultFunc.apply(undefined, arguments);
    }].concat(memoizeOptions));

    var selector = function selector(state, props) {
      for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      var params = dependencies.map(function (dependency) {
        return dependency.apply(undefined, [state, props].concat(args));
      });
      return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
    };

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      values[_key5] = arguments[_key5];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by daniel.gonzalez on 6/18/15.
 */



module.exports = {
    NOTIFICATION_TYPE: 'mobileInterstitial',
    ITUNES_LINK: 'https://itunes.apple.com/us/app/1stdibs/id938157117',
    FULLSCREEN_NAME: 'fullscreen',
    MC_APP_BANNER: 'messageCenterAppBanner'
};


/***/ }),
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var url = __webpack_require__(689).URL;

/**
 * Returns the value of the utm_medium query param.
 * @returns {string}
 */
function getReferringMedium(queryKey) {
    queryKey = queryKey || url.queryKey;
    return (queryKey.utm_medium ? queryKey.utm_medium.toLowerCase() : '');
}

/**
 * Returns true if the user came to the site from clicking a PLA ad.
 * @returns {boolean}
 */
function isPlaReferrer() {
    var queryKey = url.queryKey;
    return getReferringMedium() === 'pla' || (typeof queryKey.product !== 'undefined' && typeof queryKey.gclid !== 'undefined');
}

/**
 * Returns true if we the user came to the site from clicking a link in an email.
 * @returns {boolean}
 */
function isEmailReferrer(queryKey) {
    return getReferringMedium(queryKey) === 'email';
}

/**
 * Returns true if we the user came to the site from AMP page.
 * @returns {boolean}
 */
function isAmpReferrer() {
    var referrer = document.referrer;
    return referrer.match(/\/amp\//g) !== null;
};

module.exports = {
    getReferrer: function () {
        return (document.referrer ? document.referrer.toLowerCase() : '');
    },
    /**
     * Returns true if the user came to the site from google, yahoo, or bing
     */
    isSearchEngine: function () {
        return this.getReferrer().match(/google|yahoo|bing/gi) !== null;
    },
    /**
     * Returns true if the user came to the site from 1stdibs (not first page load)
     */
    is1stdibsReferrer: function () {
        return this.getReferrer().match(/1stdibs/gi) !== null;
    },

    isPinterestReferrer: function () {
        return this.getReferrer().match(/\/\/www.pinterest.com\//) !== null;
    },

    getReferringMedium: getReferringMedium,
    isPlaReferrer: isPlaReferrer,
    isEmailReferrer: isEmailReferrer,
    isAmpReferrer: isAmpReferrer
};


/***/ }),
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 2/11/14
 * Time: 1:15 PM
 */



var _ = __webpack_require__(0);
var $ = __webpack_require__(5);
var SoaCollection = __webpack_require__(9);
var solrHelper = __webpack_require__(2627);
var assert = __webpack_require__(31);
var solrParamsSerialize = __webpack_require__(2631);
var SolrCollection;
var defaultParamOptions = {
    multiSelect : false,
    filterQuery : false,
    defaultParam : false,
    displayName : null,
    excludeFacet : false,
    excludeFromAll : false,
    min : false,
    max : false // both min and max cannot be true
};
var allFilterOptions = _.keys(defaultParamOptions);
var mustMatchOptions = ['filterQuery', 'min', 'max'];
var defaultGroupOptions = {
    name : null,
    typeOr : false,
    multiRestricted : false
};
var allGroupOptions = _.keys(defaultGroupOptions);

/**
 * @class SolrCollection
 * @extends SoaCollection
 * @property {string} filterQueryKey
 *     The key under which the filter query params are stored on this._params.
 *     Instead of a regular param object, this._params[this.filiterQueryKey] is a flushed out object that stores data
 *     about the filterQuery. It may contain "val", "excludeFacet" and/or "tagName"
 *     @example
 *     // Here is what this._params[this.filiterQueryKey] should look like :
 *     {
 *         key : {
 *             val : ['one', 'two'],
 *             excludeFacet : true,
 *             tagName : 'v',
 *             minMax : true    // in this case val[0] = min & val[1] = max
 *         },
 *         key1 : { ... }
 *     }
 *     // A note on excluding facets : when you apply a filter with the option {excludeFacet : true} -- the associated
 *     // filter query will be marked as excluded - which tells the fetchWithParameters() method to tag the filter {!tag=}
 *     // and use the !ex syntax to exclude that facet from filtering.
 */
SolrCollection = module.exports = SoaCollection.extend({

    initialize : function () {
        this._params = [];
        this._defaultParams = [];
        this._groups = [];
        return SolrCollection.__super__.initialize.call(this, arguments);
    },

    filterQueryKey: 'filterQuery',
    facetFieldKey: 'facetField',
    queryKey: 'query',
    commaDelimiter : '-COMMA-',
    _params : [],
    _defaultParams : [],
    _groups : [],

    parse : function (data) {
        data = SolrCollection.__super__.parse.call(this, data);

        this.facets = data.facets || null;

        // TODO ::: PUSH THIS LOGIC INTO THE PARENT SOA COLLECTION PARSE METHOD.
        return data.items || data;
    },

    /**
     * *** question*** Defaults {traditional : true} for SOA collection ... but why?
     * fetchWithParameters for SOLR collection uses the public method getQueryParams to generate the data to be sent
     * with the SOLR request. See notes for getgetQueryParams to see what special logic will be applied.
     *
     * @param {object} passedOptions
     * @returns {$.Deferred.promise}
     */
    fetchWithParameters : function (passedOptions) {
        var options = _.defaults(passedOptions || {}, {
            traditional: true,
            data: {}
        });
        options.data = _.extend(this.getQueryParams(), options.data);
        return SolrCollection.__super__.fetchWithParameters.call(this, options);
    },


    /**
     * HERE IS A LIST OF ALL THE THINGS THIS FUNCTION MUST DO :
     * - find all query params that are not filter queries and apply them simply using key / value-ness
     *     - they have to be grouped by their keys.
     * - do min / max logic -- so if you find a min / max then search for it's counterpart
     * -
     * @returns {{}}
     */
    getQueryParams : function () {
        var query = {};

        // First, get the regular params that are not filterQueries.
        this._getRegularParams(query);

        // Get the facets
        this._getFacetParams(query);

        // Get the filterQueries :
        this._getFQParams(query);

        return query;
    },


    /**
     * Adds the regular (non filterQuery / non facet) params to the query object.
     * Also adds a tag for the special query key.
     * @param query
     * @private
     */
    _getRegularParams : function (query) {
        _.each(this._params, function (param) {
            var key = param.key;
            var val = param.val;
            // Regular params are all the params that are not facets or filter queries.
            if (!param.options.filterQuery && param.key !== this.facetFieldKey) {
                var queryTagName = solrHelper.facetMap.searchQuery.tagName;
                var tagString = param.key === this.queryKey ? '{!tag=' + queryTagName + '}' : param.key;
                // If there is already a query by this key, then merge them, otherwise assign the val to the key.
                query[key] = query[key] ? _.flatten(_.union([query[key]], [val])) : val;
                // If this is the special "query" key, then add the tag so that it can be excluded by facets.
                if (param.key === this.queryKey) {
                    query[key] = tagString + query[key];
                }
            }
        }, this);
    },

    /**
     * Adds params for facets to the query object.
     * This does the special logic of applying exclusion tags to facets.
     * @param query
     * @private
     */
    _getFacetParams : function (query) {
        var facetKey = this.facetFieldKey;
        var exclusionMap = {};
        var excludeAllArray = [];

        // Filter the params down into facet params (
        var facetParams = _.filter(this._params, function (param) {
            var tag = solrHelper.getTagFromKey(param.key);
            var isExcludeAll = (param.options.filterQuery && param.options.excludeFromAll && !!tag);
            var isExcludeFacet = (param.options.filterQuery && param.options.excludeFacet && !!tag);
            exclusionMap[param.facetName] = exclusionMap[param.facetName] || [];

            if (isExcludeAll && excludeAllArray.indexOf(tag) === -1) {
                excludeAllArray.push(tag);
            }
            if (isExcludeFacet && !isExcludeAll && param.facetName) {
                exclusionMap[param.facetName].push(tag);
            }
            return param.key === facetKey;
        }, this);

        // If no facet params were found do nothig.
        if (!facetParams.length) {
            return;
        }

        // Else, map the facet params down into an array of strings, and add to the query :
        query[facetKey] = _.map(facetParams, function (param) {
            var excludeArray = _.uniq(_.union(excludeAllArray, (exclusionMap[param.val] || [])));
            var excludeTagString = excludeArray.length ? '{!ex=' + excludeArray.join(this.commaDelimiter) + '}' : '';
            return excludeTagString + param.val;
        }, this).join(',');
    },

    /**
     * This function creates the filter query param string based on filter query param settings.
     * The logic for filter queries takes into account the following :
     *      - taggin FQ params that are excluded
     *      - grouping params together based on groups and group type (typeOr)
     *      - syntax for range queries
     * @param query
     * @private
     */
    _getFQParams : function (query) {
        var filterQueryMap = {}; // a map of filter queries organized by groups.
        var out;

        function _organizeParam(groups, groupName, param) {
            var currGroup;
            var currParam;
            var group = _.findWhere(groups, {name : groupName});

            // First ensure that the proper place-holder for this param exists. If not then create the structure
            filterQueryMap[groupName] = filterQueryMap[groupName] || {};
            currGroup = filterQueryMap[groupName];
            currGroup.params = currGroup.params || {};

            // If a group was found for this group name, get tye typeOr data :
            currGroup.typeOr = (group && group.typeOr) ? true : false;

            // Now
            currGroup.params[param.key] = currGroup.params[param.key] || {};
            currParam = currGroup.params[param.key];
            currParam.vals = currParam.vals || [];

            // Add the key, value, range, and tag info to this entry in the map :
            currParam.key = param.key;
            currParam.vals.push(param.val);
            currParam.isMin = param.options.min;
            currParam.isMax = param.options.max;
            if (param.options.excludeFacet || param.options.excludeFromAll) {
                currParam.tag = solrHelper.getTagFromKey(param.key);
            }
        }

        // First, loop over the params, if the param is a filterquery, then organize into groups by group name or key.
        _.each(this._params, function (param) {
            if (!param.options.filterQuery) {
                return;
            }
            if (_.size(param.groups)) {
                // if there are groups, then add the param to each of the groups :
                _.each(param.groups, function (groupName) {
                    _organizeParam.apply(this, [this._groups, groupName, param]);
                }, this);
                // If there are no groups, then add this param to it's own group
            } else {
                _organizeParam.apply(this, [this._groups, param.key, param]);
            }
        }, this);

        // Now that params are all organized by group, loop through the groups and create filter queries for each param
        out = _.map(filterQueryMap, function (group) {
            var filterQueries = [];
            var delimiter = group.typeOr ? ' OR ' : ',';

            // Now for each param in this group (which may have many values) generate a filter query string :
            _.each(group.params, function (param) {
                filterQueries.push(this._makeFilterQueryString(param.key, param.vals, param.isMin, param.isMax, param.tag));
            }, this);

            if (_.size(group.params) > 1) {
                return '(' + filterQueries.join(delimiter) + ')';
            }

            return filterQueries.join('');

        // finally join the output array on the AND operator, a comma :
        }, this).join(',');

        // If we got any filter queries, return them all! ha ha ha ha ha ha ha ha!
        if (_.size(out)) {
            query[this.filterQueryKey] = out;
        }
    },

    /**
     * Generates the filter query string which is understood by services. Examples :
     *      l2_categories:(tables),vertical:(furniture)
     *      vertical:(furniture art)
     *      price:([10 TO 1000])
     *      {!tag=l2}l2_categories:(tables)
     *
     * @param key
     * @param vals
     * @param isMin
     * @param isMax
     * @param tag
     * @returns {string}
     * @private
     */
    _makeFilterQueryString : function (key, vals, isMin, isMax, tag) {
        var str = key + ':';
        var isRange = isMin || isMax;
        var bracket1 = isRange ? '([' : '(';
        var bracket2 = isRange ? '])' : ')';
        var delimiter = isRange ? ' TO ' : ' ';
        if (isRange && vals.length === 1) {
            vals = isMin ? [vals[0], '*'] : ['*', vals[0]];
        }
        str += bracket1;
        str += vals.join(delimiter);
        str += bracket2;
        if (tag) {
            return '{!tag=' + tag + '}' + str;
        }
        return str;
    },

    /**
     * Resets the params back to any params that were added as default params.
     * To take advantage of this use the option defaultParam
     */
    resetParams : function (paramsToApply) {
        this._params = [];
        _.each(this._defaultParams, function (param) {
            this.setParam(param.key, param.val, param.options);
        }, this);
        if (paramsToApply && _.isArray(paramsToApply)) {
            this.setParamsArray(paramsToApply);
        }
    },

    /**
     * Sets params just like on regular SOA collection - has added options you can use for filterQuery stuff.
     * @param {string} key
     * @param {string|number} value
     * @param {object} [passedOptions]
     * @param {boolean} [passedOptions.remove=true] alternate option to remove the passed param. You may also accomplish
     *      param removal by passing null as value.
     * @param {boolean} [passedOptions.defaultParam=true] denotes this is a default param. Will be applied on resetParams()
     * @param {boolean} [passedOptions.filterQuery=true] If you want the passed param to be a filter query (defaults false)
     * @param {boolean} [passedOptions.multiSelect=true] If the parameter being set is part of multi select (defaults false)
     * @param {boolean} [passedOptions.excludeFacet=true] Set the special flag to exclude this facet (from itself)
     * @param {boolean} [passedOptions.excludeFromAll=true] Set the special flag to exclude this facet from all facets.
     * @param {boolean} [passedOptions.min=true] If you want the variables to be formatted in min/max SOLR syntax
     * @param {boolean} [passedOptions.max=true] If you want the variables to be formatted in min/max SOLR syntax
     * @param {boolean} [passedOptions.remove=true]
     * @param {array} [passedOptions.groups] If you want to set a group
     * @param {string} [passedOptions.groups[0].name='groupName'] The group's name (defaults '')
     * @param {boolean} [passedOptions.groups[0].typeOr=true] Sets the relation between the values (defaults false)
     *      params with this group option turned on will be "OR"'d together. Params without will be "AND"'ed
     * @param {boolean} [passedOptions.groups[0].multiRestricted=true] Sets a restriction on the group that only 1
     *      param may be in the group at a time. Allows different parts of the code to clear other filters that are
     *      in the same group.
     */
    setParam : function (key, value, passedOptions) {
        var options = _.clone(passedOptions || {});

        // if value === null OR options.remove then remove all params matching this key.
        if (value === null || options.remove) {
            this._removeParams(this._findExistingParams(key, value, options)); // remove all params with this key
        // if this is not a multiSelect param, remove other filters for this key then add the param
        } else if (!options.multiSelect) {
            this._removeParams(this._findExistingParams(key, null, options)); // remove all params with this key
            this._addParam(key, value, options);
        // Otherwise rirst remove duplicate params then add the new param
        } else {
            this._removeParams(this._findExistingParams(key, value, options));
            this._addParam(key, value, options);
        }
    },

    /**
     * Helper function where we really add passed parameters from the setParam method (inverse of _removeParams)
     * Evaluates options based on special logic for multi select, facets, groups, min/max, etc.
     *
     * @param {string} key
     * @param {string|number} val
     * @param {object} options
     * @private
     */
    _addParam: function (key, val, options) {
        var addedGroups;
        var facets;
        var facetName;
        var associatedFacet;
        var filter = {
            key : key,
            val : val
        };

        if (_.isUndefined(val)) {
            throw new Error('You must pass a real value to set params on SOLR Collection');
        }

        if (options.min === true && options.max === true) {
            throw new Error('A given param may not be both min and max.');
        }

        // If groups were specified in the options, then add the groups.
        if (options.groups) {
            options.groups = addedGroups = this._addNewGroups(options.groups);
            filter.groups = _.map(addedGroups, function (group) {
                return group.name;
            });

            // If any of the groups for this param are multi-restricted, remove other params in the same group first :
            _.each(addedGroups, function (group) {
                var paramsInGroup = this.getParamsByGroup(group.name);
                if (group.multiRestricted) {
                    this._removeParams(paramsInGroup);
                }
            }, this);
        }

        // Apply defaults to the options. Only pay attention to params specified by allFilterOptions
        filter.options = _.pick(options, allFilterOptions);
        filter.options = _.defaults(options, defaultParamOptions);

        facetName = solrHelper.getNameFromKey(key);
        if (filter.options.filterQuery && this.facets && !!_.size(this.facets[facetName])) {
            facets = this.facets[facetName];
            associatedFacet = _.findWhere(facets, {name : val});
            filter.facetName = facetName;
            filter.facetKey = key;
            filter.associatedFacet = associatedFacet;
        }

        // If this is a default param, add it to the list of deftault params :
        if (options.defaultParam) {
            this._addDefaultParam(filter);
        }

        this._params.push(filter);
    },

    /**
     * Adds the default param by first removing matching default params.
     * @param filter
     * @private
     */
    _addDefaultParam : function (filter) {
        var searchOptions = _.pick(filter.options, mustMatchOptions);
        var matchingDefaultParams = this._filterParams(filter.key, filter.val, searchOptions, this._defaultParams);
        this._defaultParams = _.difference(this._defaultParams, matchingDefaultParams);
        this._defaultParams.push(filter);
    },

    /**
     * @param paramsToRemove
     * @private
     */
    _removeParams : function (paramsToRemove) {
        this._params = _.difference(this._params, paramsToRemove);
    },

    /**
     * Finds a group by it's (unique) name
     * @param groupName
     */
    getGroup : function (groupName) {
        return _.first(_.filter(this._groups, function (group) {
            return group.name === groupName;
        }));
    },

    /**
     * Returns all params that are in the specified group
     * @param groupName
     * @returns {*|Array}
     */
    getParamsByGroup : function (groupName) {
        return _.filter(this._params, function (param) {
            return param.groups && (param.groups.indexOf(groupName) !== -1);
        });
    },

    /**
     * Adds groups to the list of groups maintained by
     * When the user adds a new param (key / val pair) we call this function to add any new groups that may have been
     * passed in.
     *
     * @param groups
     * @returns Return the collection of groups that were added
     * @private
     */
    _addNewGroups : function (groups) {
        var newGroups = _.map(groups, function (group) {
            var cleanGroup = _.pick(group, allGroupOptions);
            return _.defaults(cleanGroup, defaultGroupOptions);
        });

        // Filter out duplicate groups being added :
        newGroups = _.uniq(newGroups, true, function (group) {
            return group.name;
        });

        // Remove out groups that already exist.
        this._groups = _.filter(this._groups, function (group) {
            var match = _.findWhere(newGroups, {name : group.name});
            return !match;
        }, this);

        // Combine groups with new groups :
        this._groups = _.union(this._groups, newGroups);

        return newGroups;
    },

    /**
     * Filter params on any setting including key, value, params. If you are using options, you may pass only the
     * ones you are concerned with. Other options will be ignored.
     * @param key
     * @param val
     * @param options
     * @returns {*|Array}
     */
    filterParams : function (key, val, options, params) {
        return this._filterParams(key, val, options, params);
    },

    /**
     * Private method to filter params. For public access, use "filterParams" -- this private method is here so
     * I can filter over default params AND other params.
     * This does not work for groups
     */
    _filterParams : function(key, val, options, paramsToFilter) {
        paramsToFilter = paramsToFilter || this._params;
        var _tester = function (param) {
            var hasKey = !!(key && key !== 0);
            var hasVal = !!(val && val !== 0);
            var hasOptions = !!(options && _.isObject(options));
            var optionKeys = hasOptions ? _.keys(options) : null;
            var optionsMatch = true;
            var nonMatchingParam;

            // First check the key.
            if (hasKey && key !== param.key) {
                return false;
            }

            // Reduce options via condition array to figure out if any don't match.
            // Note* This does not include group options. Only check passed options :
            if (hasOptions) {
                nonMatchingParam = _.find(optionKeys, function (option) {
                    return options[option] !== param.options[option];
                });
                optionsMatch = (nonMatchingParam === undefined);
            }

            // If any don't match return false.
            if (!optionsMatch) {
                return false;
            }

            // If value was passed, then evaluate whether it matches.
            if (hasVal) {
                return (param.val === val);
            }

            // Assuming all checks passed, return true;
            return true;
        };

        return _.filter(paramsToFilter, _tester);
    },

    /**
     * Finds existing applied paramaters by key, optional value, and passed options. For example, find params that
     * match a given key, and are filterQueries.
     *
     * This is the same as filterParams -- but it removes options from the search that don't differentiate the
     * param as distinct. For example, a param of derp=herp with option default param is the same param as derp=herp
     * with no default param option applied.
     *
     * *NOTE! This method may not be used without specifying a key to search by
     *
     * @param key
     * @param val
     * @param options <object> will be reduced to the folowing list : [ filterQuery, min, max ]
     * @returns {*|Array}
     */
    _findExistingParams : function (key, val, options) {
        var optionsToCheck = ['filterQuery', 'min', 'max'];
        options = _.pick(options, optionsToCheck);

        if (key === undefined) {
            throw new Error('You must supply a key to use _findExistingParams');
        }

        return this.filterParams(key, val, options);
    },


    /**
     * Searches the params based on key and options. Only certain options must match in order for the set params to
     * match including filterQuery, min and max. For example, you could do :
     *      collection.setParam('derp', 'nerp', {filterQuery : true});
     *      collection.getParams('derp', {filterQuery : true}); // length = 1
     *      collection.getParams('derp'); // length = 0
     * @param param
     * @param passedOptions
     * @returns {*}
     */
    getParams : function (param, passedOptions) {
        var options = passedOptions || {};
        var mustMatchDefaults = _.pick(defaultParamOptions, mustMatchOptions);
        // Apply default params to the search options so that every option will get compared.
        // NOTE* Here I ONLY apply the options that must match for the search to succeed. This included filterQuery,
        // min and max.
        options = passedOptions || {};
        options = _.pick(options, mustMatchOptions);
        options = _.defaults(options, mustMatchDefaults);
        var matchingParams = this.filterParams.apply(this, [param, null, options]);

        if (!matchingParams.length) {
            return null;
        }
        return _.map(matchingParams, function (param) {
            return param.val;
        });
    },

    /**
     * @deprecated @deprecated @deprecated @deprecated!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
     * Gets a param -- has the added benefit of being able to retrieve filterQuery params
     * This method will always return you only 1 param.
     * @deprecated!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! -- Please do not use instead please use getParams
     * @param {string} param
     * @param {object} passedOptions
     * @returns {*}
     */
    getParam : function (param, passedOptions) {
        var vals = this.getParams.apply(this, [param, passedOptions]);
        return vals && !_.isUndefined(vals[0]) ? vals[0] : undefined;
    },

    /**
     * Get an array of the current params that can be set back on the collection using setParamsArray
     */
    getCurrentParamsArray : function () {
        return _.map(this._params, function (param) {
            param = _.omit(param, 'groups');
            if (param.groups) {
                param.options.groups = [];
                _.each(param.groups, function (groupName) {
                    param.options.groups.push(this.getGroup(groupName));
                }, this);
            }
            return param;
        }, this);
    },

    /**
     * Convenience method for setting many params at once from an array. Array should be formatted like :
     * Each param in the params array should have a key, val, options (object)
     * @param paramsArray
     */
    setParamsArray : function (paramsArray) {
        assert(_.isArray(paramsArray), 'You must pass an array to use setParamsArray');
        _.each(paramsArray, function (param) {
            assert(_.has(param, 'key') && _.has(param, 'val'), 'Incorrectly configured param array.');
            var options = param.options || {};
            this.setParam(param.key, param.val, options);
        }, this);
    },

    /**
     * Find a facet based on a filterQuery key - val pair. ***Note - filter query keys are associated to their related
     * facets by the by the solrHelper utility.
     * @param {string} key filter query key
     * @param {string|number} val ilter query value
     * @returns {object}
     */
    geFacetFromFilterQuery : function (key, val) {
        // Find the facet you are specifying from the list of all facets.
        // get the name of the facet (ie. vertical) from the solr helper.
        var facetName = solrHelper.getNameFromKey(key);
        // get all the facets in this.facets with that facet name
        var associatedFacets = this.facets[facetName];

        // find the facet from the associatedFacets where the label matches the param value in this._params.filerQuery
        var currFacet = _.findWhere(associatedFacets, {
            label : val
        });

        return currFacet;
    },

    /**
     * Gets back display name stored on params
     * @param {string} key
     * @param {string|number} val
     * @param {object} options
     * @returns {string}
     */
    getDisplayName : function (key, val, options) {
        assert((!_.isUndefined(key) && !_.isUndefined(val)), 'You must pass a key and a val to use getDisplayName');

        // Only 1 param should be returned because key / val / options will get you a unique param.
        var params = this.filterParams(key, val, options);
        var param = _.first(params);
        return param ? param.options.displayName : null;
    },


    /**
     * Checks if a given parameter is applied. Options are the same as for setParam
     * @param {string} name
     * @param {string|number} val
     * @param options
     */
    checkParamApplied : function (key, val, options) {
        assert((!_.isUndefined(key) && !_.isUndefined(val)), 'You must pass a key and a val to use checkParamApplied');
        options = options || {};
        options = _.pick(options, mustMatchOptions);
        var params = this.filterParams(key, val, options);
        return !!params.length;
    },

    /**
     * Over-write the getTotalResultsForParams method from SOA Collection to work with SOLR Collection functionality.
     *
     * @param {object} passedParams
     * @param {function} callback
     * @param {object} options
     * @returns {$.Deferred}
     *
     * @example
     * // *** NOTE!! -- the structure of the params this method expects is different!!!!!!!! Please use something like :
     * {
     *      key : {
     *          val : 'string',
     *          options : { ... }
     *      },
     *      { ... }
     * }
     */
    getTotalResultsForParams: function (passedParams, callback, options) {

        if (typeof passedParams !== 'object') {
            throw new Error("You must pass a config object of param objects to use SOLR Collection's getTotalResultsForParams");
        }

        var totalCollection = new SolrCollection(null, { url: _.result(this, 'url') });

        totalCollection.setParamsArray(passedParams);

        totalCollection.setParam('pageStart', 0);
        totalCollection.setParam('pageSize', 0);
        totalCollection.setParam('returnTotalResults', true);
        // Don't pass this in since it may filter results
        totalCollection.setParam('orderBy', null, {remove : true});
        totalCollection.setParam('sort', null, {remove : true});

        var deferred = new $.Deferred();
        $.when(totalCollection.fetchWithParameters(options)).done(function () {
            if (callback) {
                callback(totalCollection.totalResults);
            }
            deferred.resolve(totalCollection.totalResults);
        }).fail(function () {
                deferred.reject();
            });
        return deferred;
    }

});


// STATIC METHODS --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
/**
 * Returns you a relative URL (for use in links) that can be deparam-ed later and fed back to the solr Collection.
 * @param paramsArray
 * @param base
 * @returns {*}
 */
SolrCollection.encodeParamsLink = function (paramsArray, base) {
    base = base || '';
    base = base.split('?')[0];
    var str = solrParamsSerialize.serializeParams(paramsArray);

    return base + '?query=' + encodeURIComponent(str);
};

/**
 * Decodes URI parameters that were encoded using the (above) encodeParamsLink method.
 * @param queryString
 * @returns {*}
 */
SolrCollection.decodeParamsLink = function (queryString) {
    var val;
    var arr;

    queryString = (queryString || window.location.search).replace(/^[^\?]*\?/, '') || '';
    val = queryString;

    arr = queryString.split('&');
    for (var i = 0; i < arr.length; i++) {
        var curr = arr[i].split('=');
        if (curr[0] === 'query') {
            val = curr[1];
        }
    }

    return solrParamsSerialize.deSerializeParams(decodeURIComponent(val));
};


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: liliana
 * Date: 4/17/15
 * Time: 11:32 AM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */



var SoaCollection = __webpack_require__(9);

var Favorites = module.exports = SoaCollection.extend();

var _            = __webpack_require__(0);
var Favorite     = __webpack_require__(378);
var endpoints    = __webpack_require__(6);

_.extend(Favorites.prototype, {
    url : endpoints.favorites,
    model : Favorite
});


/***/ }),
/* 1217 */
/***/ (function(module, exports) {

/*
 * File created for running jasmine tests in node.
 * Webpack config makes require call to _gas return window._gas.
 * However webpack is not used when running tests from node. Hence,
 * just return googletag of the window object
 */

module.exports = window.googletag;


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Shad
 * Date: 11/12/13
 */



var root = typeof window === 'undefined' ? global : window;
var SoaModel = __webpack_require__(2);
var assign = __webpack_require__(60);

/**
 * @class UserProfile
 * @extends SoaModel
 */
var UserProfile = module.exports = SoaModel.extend();

var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var currency = __webpack_require__(320);
var SoaModelLabelAndValueTransformer = __webpack_require__(1622);
var User = __webpack_require__(28);

root.bunsen.UserProfile = UserProfile;

_.extend(UserProfile.prototype, SoaModelLabelAndValueTransformer, {
    url: function () {
        // TODO: find a better way to get the user ID
        return endpoints.userProfile(this.parents[0].id);
    },
    displayLabels: {
        email: 'Primary Email',
        email2: 'Secondary Email',
        phoneNumber: '1stdibs Display Telephone',
        directPhoneNumber: 'Telephone',
        line1: 'Address 1',
        line2: 'Address 2',
        zipCode: 'ZIP',
        decorator: 'Design Professional',
        companyName: 'Company',
        companyDescription: 'Business Description',
        association: 'Trade Association (TA)',
        associationId: 'TA Member Number',
        associationPhone: 'TA Telephone Number',
        currency: 'Preferred Currency'
    },
    //Overwriting Backbone isNew in order for save to know whether it should use POST or PUT
    isNew: function () {
        var user = User.getCurrentUser();
        return user ? user.isNew() : UserProfile.__super__.isNew.call(this);
    },
    displayTransforms: {
        resaleState: function (val) {
            return (val === "-1") ? 'Non-US' : val;
        },
        associationPhone: SoaModelLabelAndValueTransformer.defaultDisplayTransforms.phoneNumber,
        currency: function (val) {
            var currencyObj = currency(val);
            return (currencyObj) ? currencyObj.name : val;
        }
    },
    /**
     * Get standard formatted display name for a user based on their profile.
     * @param  {Object} [options]
     * @param  {boolean} [options.defaultToEmail] - return user's email username if no first/last name
     * @returns {string}
     */
    getDisplayName: function (options) {
        var first = this.get('firstName') || '';
        var last = this.get('lastName') || '';
        var email = this.get('email') || '';
        options = assign({
            defaultToEmail: true
        }, options);
        if (first || last) {
            return (first + ' ' + last).trim();
        } else if (email && options.defaultToEmail) {
            return email.split('@')[0].split('.').join(' ');
        }
        return '';
    },
    // breaks displayName up by whitespace. Sets firstName to first part, and lastName to remaining parts joined by spaces
    setDisplayName: function (displayName) {
        var nameParts = displayName.split(/[\s]+/);
        return this.set({
            firstName: nameParts[0],
            lastName: nameParts.slice(1).join(' ')
        });
    }
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Load Super Class
var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);

// ---------------------------------------------------
// Module Definition

/** Model for Attribute data that is placed on Item model, e.g.:
 * {
 *     "value": Costa Rica",
 *     "option": {
 *         "id": 7595
 *     }
 * }
 * @class ItemAttribute
 * @extends SoaModel
 */
var ItemAttribute = module.exports = SoaModel.extend();

// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);
var ItemAttributes = __webpack_require__(1015);

// ---------------------------------------------------
// Local Vars

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(ItemAttribute.prototype, {
    idAttribute:'option.id',
    defaults : {
        option : {}
    },
    relations : [
        {
            type: Backbone.One,
            key: 'option',
            relatedModel: SoaModel.extend({
                relations: [
                    {
                        type: Backbone.One,
                        key: 'displayConfigs',
                        relatedModel: SoaModel.extend()
                    }
                ]
            })

        },
        {
            type: Backbone.Many,
            key: 'child',
            collectionType: ItemAttributes
        }
    ],
    /**
     * Pick only necessary information to avoid setting extraneous data on Item when getting saved Item data
     * @param response
     * @returns {{value: *, option: {id: *}, groupKey: (*|null)}}
     */
    parse : function (response) {
        return {
            value: response.value,
            option: {
                id: response.option ? response.option.id : null,
                urlLabel: response.option ? response.option.urlLabel : null,
                displayConfigs: response.option ? response.option.displayConfigs : null
            },
            groupKey: response.groupKey || null,
            text: response.text
        };
    },

    /**
     * @returns {*}
     */
    getMaterialAttribute: function () {
        return this.get(ItemAttribute.ATTRIBUTE_MATERIAL);
    },

    /**
     * @returns {*}
     */
    getTechniqueAttribute: function () {
        return this.get(ItemAttribute.ATTRIBUTE_TECHNIQUE);
    }
});

// ---------------------------------------------------
// Define Module Static Properties

_.extend(ItemAttribute, {
    ATTRIBUTE_KEY               : 'attributes',
    ATTRIBUTE_MATERIAL          : 'material',
    ATTRIBUTE_TECHNIQUE         : 'technique',
    ATTRIBUTE_METAL             : 'metal',
    ATTRIBUTE_STONE             : 'stone',
    ATTRIBUTE_STYLE             : 'style',
    ATTRIBUTE_STYLE_OF          : 'style_of',
    ATTRIBUTE_ORIGIN            : 'origin',
    ATTRIBUTE_PERIOD            : 'period',
    ATTRIBUTE_LEAD_TIME         : 'lead_time',
    ATTRIBUTE_PRODUCTION_TYPE   : 'production_type',
    ATTRIBUTE_COLOR             : 'color'
});


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var currencies = __webpack_require__(2059);
var constants = {
    currencies: {},
    symbols: {
        GBP: '£',
        EUR: '€',
        USD: '$',
        CAD: '$',
        AUD: '$',
        CHF: '', // Swiss francs don't have a currency symbol
        MXN: '$'
    },
    abbreviations: {
        CAD: 'CAD',
        AUD: 'AUD',
        MXN: 'MXN',
        CHF: 'CHF'
    }
};

currencies.forEach(function (currency) {
    constants.currencies['CURRENCY_' + currency] = currency;
});

module.exports = constants;


/***/ }),
/* 1221 */
/***/ (function(module, exports) {

/*!
 * jQuery UI Core 1.10.0
 * http://jqueryui.com
 *
 * Copyright 2013 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */
(function( $, undefined ) {

var uuid = 0,
	runiqueId = /^ui-id-\d+$/;

// prevent duplicate loading
// this is only a problem because we proxy existing functions
// and we don't want to double proxy them
$.ui = $.ui || {};
if ( $.ui.version ) {
	return;
}

$.extend( $.ui, {
	version: "1.10.0",

	keyCode: {
		BACKSPACE: 8,
		COMMA: 188,
		DELETE: 46,
		DOWN: 40,
		END: 35,
		ENTER: 13,
		ESCAPE: 27,
		HOME: 36,
		LEFT: 37,
		NUMPAD_ADD: 107,
		NUMPAD_DECIMAL: 110,
		NUMPAD_DIVIDE: 111,
		NUMPAD_ENTER: 108,
		NUMPAD_MULTIPLY: 106,
		NUMPAD_SUBTRACT: 109,
		PAGE_DOWN: 34,
		PAGE_UP: 33,
		PERIOD: 190,
		RIGHT: 39,
		SPACE: 32,
		TAB: 9,
		UP: 38
	}
});

// plugins
$.fn.extend({
	_focus: $.fn.focus,
	focus: function( delay, fn ) {
		return typeof delay === "number" ?
			this.each(function() {
				var elem = this;
				setTimeout(function() {
					$( elem ).focus();
					if ( fn ) {
						fn.call( elem );
					}
				}, delay );
			}) :
			this._focus.apply( this, arguments );
	},

	scrollParent: function() {
		var scrollParent;
		if (($.ui.ie && (/(static|relative)/).test(this.css("position"))) || (/absolute/).test(this.css("position"))) {
			scrollParent = this.parents().filter(function() {
				return (/(relative|absolute|fixed)/).test($.css(this,"position")) && (/(auto|scroll)/).test($.css(this,"overflow")+$.css(this,"overflow-y")+$.css(this,"overflow-x"));
			}).eq(0);
		} else {
			scrollParent = this.parents().filter(function() {
				return (/(auto|scroll)/).test($.css(this,"overflow")+$.css(this,"overflow-y")+$.css(this,"overflow-x"));
			}).eq(0);
		}

		return (/fixed/).test(this.css("position")) || !scrollParent.length ? $(document) : scrollParent;
	},

	zIndex: function( zIndex ) {
		if ( zIndex !== undefined ) {
			return this.css( "zIndex", zIndex );
		}

		if ( this.length ) {
			var elem = $( this[ 0 ] ), position, value;
			while ( elem.length && elem[ 0 ] !== document ) {
				// Ignore z-index if position is set to a value where z-index is ignored by the browser
				// This makes behavior of this function consistent across browsers
				// WebKit always returns auto if the element is positioned
				position = elem.css( "position" );
				if ( position === "absolute" || position === "relative" || position === "fixed" ) {
					// IE returns 0 when zIndex is not specified
					// other browsers return a string
					// we ignore the case of nested elements with an explicit value of 0
					// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
					value = parseInt( elem.css( "zIndex" ), 10 );
					if ( !isNaN( value ) && value !== 0 ) {
						return value;
					}
				}
				elem = elem.parent();
			}
		}

		return 0;
	},

	uniqueId: function() {
		return this.each(function() {
			if ( !this.id ) {
				this.id = "ui-id-" + (++uuid);
			}
		});
	},

	removeUniqueId: function() {
		return this.each(function() {
			if ( runiqueId.test( this.id ) ) {
				$( this ).removeAttr( "id" );
			}
		});
	}
});

// selectors
function focusable( element, isTabIndexNotNaN ) {
	var map, mapName, img,
		nodeName = element.nodeName.toLowerCase();
	if ( "area" === nodeName ) {
		map = element.parentNode;
		mapName = map.name;
		if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
			return false;
		}
		img = $( "img[usemap=#" + mapName + "]" )[0];
		return !!img && visible( img );
	}
	return ( /input|select|textarea|button|object/.test( nodeName ) ?
		!element.disabled :
		"a" === nodeName ?
			element.href || isTabIndexNotNaN :
			isTabIndexNotNaN) &&
		// the element and all of its ancestors must be visible
		visible( element );
}

function visible( element ) {
	return $.expr.filters.visible( element ) &&
		!$( element ).parents().addBack().filter(function() {
			return $.css( this, "visibility" ) === "hidden";
		}).length;
}

$.extend( $.expr[ ":" ], {
	data: $.expr.createPseudo ?
		$.expr.createPseudo(function( dataName ) {
			return function( elem ) {
				return !!$.data( elem, dataName );
			};
		}) :
		// support: jQuery <1.8
		function( elem, i, match ) {
			return !!$.data( elem, match[ 3 ] );
		},

	focusable: function( element ) {
		return focusable( element, !isNaN( $.attr( element, "tabindex" ) ) );
	},

	tabbable: function( element ) {
		var tabIndex = $.attr( element, "tabindex" ),
			isTabIndexNaN = isNaN( tabIndex );
		return ( isTabIndexNaN || tabIndex >= 0 ) && focusable( element, !isTabIndexNaN );
	}
});

// support: jQuery <1.8
if ( !$( "<a>" ).outerWidth( 1 ).jquery ) {
	$.each( [ "Width", "Height" ], function( i, name ) {
		var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
			type = name.toLowerCase(),
			orig = {
				innerWidth: $.fn.innerWidth,
				innerHeight: $.fn.innerHeight,
				outerWidth: $.fn.outerWidth,
				outerHeight: $.fn.outerHeight
			};

		function reduce( elem, size, border, margin ) {
			$.each( side, function() {
				size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
				if ( border ) {
					size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
				}
				if ( margin ) {
					size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
				}
			});
			return size;
		}

		$.fn[ "inner" + name ] = function( size ) {
			if ( size === undefined ) {
				return orig[ "inner" + name ].call( this );
			}

			return this.each(function() {
				$( this ).css( type, reduce( this, size ) + "px" );
			});
		};

		$.fn[ "outer" + name] = function( size, margin ) {
			if ( typeof size !== "number" ) {
				return orig[ "outer" + name ].call( this, size );
			}

			return this.each(function() {
				$( this).css( type, reduce( this, size, true, margin ) + "px" );
			});
		};
	});
}

// support: jQuery <1.8
if ( !$.fn.addBack ) {
	$.fn.addBack = function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	};
}

// support: jQuery 1.6.1, 1.6.2 (http://bugs.jquery.com/ticket/9413)
if ( $( "<a>" ).data( "a-b", "a" ).removeData( "a-b" ).data( "a-b" ) ) {
	$.fn.removeData = (function( removeData ) {
		return function( key ) {
			if ( arguments.length ) {
				return removeData.call( this, $.camelCase( key ) );
			} else {
				return removeData.call( this );
			}
		};
	})( $.fn.removeData );
}





// deprecated
$.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );

$.support.selectstart = "onselectstart" in document.createElement( "div" );
$.fn.extend({
	disableSelection: function() {
		return this.bind( ( $.support.selectstart ? "selectstart" : "mousedown" ) +
			".ui-disableSelection", function( event ) {
				event.preventDefault();
			});
	},

	enableSelection: function() {
		return this.unbind( ".ui-disableSelection" );
	}
});

$.extend( $.ui, {
	// $.ui.plugin is deprecated.  Use the proxy pattern instead.
	plugin: {
		add: function( module, option, set ) {
			var i,
				proto = $.ui[ module ].prototype;
			for ( i in set ) {
				proto.plugins[ i ] = proto.plugins[ i ] || [];
				proto.plugins[ i ].push( [ option, set[ i ] ] );
			}
		},
		call: function( instance, name, args ) {
			var i,
				set = instance.plugins[ name ];
			if ( !set || !instance.element[ 0 ].parentNode || instance.element[ 0 ].parentNode.nodeType === 11 ) {
				return;
			}

			for ( i = 0; i < set.length; i++ ) {
				if ( instance.options[ set[ i ][ 0 ] ] ) {
					set[ i ][ 1 ].apply( instance.element, args );
				}
			}
		}
	},

	// only used by resizable
	hasScroll: function( el, a ) {

		//If overflow is hidden, the element might have extra content, but the user wants to hide it
		if ( $( el ).css( "overflow" ) === "hidden") {
			return false;
		}

		var scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop",
			has = false;

		if ( el[ scroll ] > 0 ) {
			return true;
		}

		// TODO: determine which cases actually cause this to happen
		// if the element doesn't have the scroll set, see if it's possible to
		// set the scroll
		el[ scroll ] = 1;
		has = ( el[ scroll ] > 0 );
		el[ scroll ] = 0;
		return has;
	}
});

})( jQuery );


/***/ }),
/* 1222 */,
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(1428)
  , call        = __webpack_require__(4235)
  , isArrayIter = __webpack_require__(4233)
  , anObject    = __webpack_require__(1560)
  , toLength    = __webpack_require__(2311)
  , getIterFn   = __webpack_require__(2316)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;

/***/ }),
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buyerDisplayHelper;
function buyerDisplayHelper(_ref) {
    var _ref$buyerOwnsActiveH = _ref.buyerOwnsActiveHold,
        ownsActiveHold = _ref$buyerOwnsActiveH === undefined ? false : _ref$buyerOwnsActiveH,
        _ref$buyerHasTradePer = _ref.buyerHasTradePermission,
        hasTradePermission = _ref$buyerHasTradePer === undefined ? false : _ref$buyerHasTradePer,
        _ref$itemIsOnHold = _ref.itemIsOnHold,
        isOnHold = _ref$itemIsOnHold === undefined ? false : _ref$itemIsOnHold,
        _ref$itemIsSold = _ref.itemIsSold,
        isSold = _ref$itemIsSold === undefined ? false : _ref$itemIsSold,
        _ref$itemIsWip = _ref.itemIsWip,
        isWip = _ref$itemIsWip === undefined ? false : _ref$itemIsWip,
        _ref$itemIsFurniture = _ref.itemIsFurniture,
        isFurniture = _ref$itemIsFurniture === undefined ? false : _ref$itemIsFurniture,
        _ref$pricingShowSale = _ref.pricingShowSale,
        showSale = _ref$pricingShowSale === undefined ? false : _ref$pricingShowSale,
        _ref$pricingHideRetai = _ref.pricingHideRetail,
        hideRetail = _ref$pricingHideRetai === undefined ? false : _ref$pricingHideRetai,
        _ref$pricingValidNet = _ref.pricingValidNet,
        validNet = _ref$pricingValidNet === undefined ? false : _ref$pricingValidNet,
        _ref$pricingNegotiabl = _ref.pricingNegotiableSale,
        negotiableSale = _ref$pricingNegotiabl === undefined ? false : _ref$pricingNegotiabl,
        _ref$pricingNegotiabl2 = _ref.pricingNegotiableRetail,
        negotiableRetail = _ref$pricingNegotiabl2 === undefined ? false : _ref$pricingNegotiabl2,
        _ref$transactionIsBuy = _ref.transactionIsBuyerOfferWithReserve,
        isBuyerOfferWithReserve = _ref$transactionIsBuy === undefined ? false : _ref$transactionIsBuy,
        _ref$transactionIsFul = _ref.transactionIsFullPriceOrder,
        isFullPriceOrder = _ref$transactionIsFul === undefined ? false : _ref$transactionIsFul,
        _ref$transactionHasDe = _ref.transactionHasDealerSubmittedOfferAction,
        hasDealerSubmittedOfferAction = _ref$transactionHasDe === undefined ? false : _ref$transactionHasDe,
        _ref$transactionHasAc = _ref.transactionHasAcceptedBuyerOfferAction,
        hasAcceptedBuyerOfferAction = _ref$transactionHasAc === undefined ? false : _ref$transactionHasAc,
        _ref$transactionIsPre = _ref.transactionIsPreAuth,
        isPreAuth = _ref$transactionIsPre === undefined ? false : _ref$transactionIsPre,
        _ref$transactionIsInM = _ref.transactionIsInManualReview,
        isManualReview = _ref$transactionIsInM === undefined ? false : _ref$transactionIsInM,
        _ref$mostRecentOfferI = _ref.mostRecentOfferIsSubmitted,
        offerIsSubmitted = _ref$mostRecentOfferI === undefined ? false : _ref$mostRecentOfferI,
        _ref$mostRecentOfferI2 = _ref.mostRecentOfferIsAccepted,
        offerIsAccepted = _ref$mostRecentOfferI2 === undefined ? false : _ref$mostRecentOfferI2;

    var netTradeable = hasTradePermission && isFurniture;
    return {
        getShowCTAs: function getShowCTAs() {
            var unownedActiveHoldOrItemSold = isOnHold && !ownsActiveHold || isSold;
            var activeNonTradePrice = showSale || !hideRetail;
            var noCompleteTransactionOrOffer = !isBuyerOfferWithReserve && !isFullPriceOrder && !offerIsAccepted && (!offerIsSubmitted || offerIsSubmitted && isPreAuth);
            return {
                showPurchaseCTA: (activeNonTradePrice || netTradeable && (activeNonTradePrice || validNet)) && !unownedActiveHoldOrItemSold && noCompleteTransactionOrOffer && !isWip,

                showMakeOfferCTA: (showSale && negotiableSale || !hideRetail && negotiableRetail) && !unownedActiveHoldOrItemSold && noCompleteTransactionOrOffer && !isWip,

                showRequestCTA: !showSale && hideRetail && !(netTradeable && validNet) && !unownedActiveHoldOrItemSold && !isWip,
                showCheckoutOfferCTA: (hasDealerSubmittedOfferAction || hasAcceptedBuyerOfferAction || offerIsAccepted && isPreAuth && !isManualReview) && !unownedActiveHoldOrItemSold && !isWip
            };
        },

        getShowPrices: function getShowPrices() {
            var showOnHold = isOnHold && !ownsActiveHold;
            var showRetailPrice = !hideRetail && !showSale && !showOnHold;
            var showNetPrice = netTradeable && validNet && !showSale && !showOnHold;
            var showSalePrice = showSale && !showOnHold;
            return {
                showSalePrice: showSalePrice,
                showNetPrice: showNetPrice,
                showRetailPrice: showRetailPrice,
                showOnHold: showOnHold,

                showPriceUponRequest: !showNetPrice && !showRetailPrice && !showSalePrice,
                showListPriceLabel: netTradeable && showRetailPrice,
                showOnHoldCustom: isOnHold && ownsActiveHold,
                showSold: isSold
            };
        }
    };
}

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getPricingData;

var _price = __webpack_require__(2083);

var priceSelectors = _interopRequireWildcard(_price);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function getPricingData(_ref) {
    var salePrice = _ref.salePrice,
        retailPrice = _ref.retailPrice,
        netPrice = _ref.netPrice;

    var retailPriceAmountUSD = priceSelectors.getPriceAmountByCurrency(retailPrice)('USD');
    var pricingHideRetail = priceSelectors.isPriceHidden(retailPrice);
    var pricingHideNet = netPrice ? priceSelectors.isPriceHidden(netPrice) : true;

    var pricingShowSale = void 0;
    if (salePrice) {
        var salePriceAmountUSD = priceSelectors.getPriceAmountByCurrency(salePrice)('USD');
        pricingShowSale = salePriceAmountUSD > 0 && salePriceAmountUSD < retailPriceAmountUSD;
    } else {
        pricingShowSale = false;
    }

    var pricingValidNet = void 0;
    if (netPrice && !pricingHideNet) {
        var netPriceAmountUSD = priceSelectors.getPriceAmountByCurrency(netPrice)('USD');
        pricingValidNet = netPriceAmountUSD > 0;
        if (retailPriceAmountUSD) {
            pricingValidNet = pricingValidNet && netPriceAmountUSD < retailPriceAmountUSD;
        } else if (!pricingHideRetail) {
            throw new Error('Retail price must have convertedAmounts if it is not hidden');
        }
    } else {
        pricingValidNet = false;
    }

    return {
        pricingShowSale: pricingShowSale,
        pricingValidNet: pricingValidNet,
        pricingHideRetail: pricingHideRetail,
        pricingNegotiableSale: priceSelectors.isNegotiable(salePrice),
        pricingNegotiableRetail: priceSelectors.isNegotiable(retailPrice)
    };
}

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isActiveHoldByBuyerId = exports.getActiveHold = exports.isRetailPriceHidden = exports.getNetPrice = exports.getSalePrice = exports.getRetailPrice = exports.getPrices = exports.isArt = exports.isJewelry = exports.isFashion = exports.isFurniture = exports.isSold = exports.isOnHold = exports.isWip = exports.isUnavailable = exports.getDealerReference = exports.getUrl = exports.getUnavailableReasonCode = exports.getStatus = exports.getSellerId = exports.getProductName = exports.getPricing = exports.getItemId = exports.getHolds = exports.getGender = exports.getCreator = exports.getCondition = exports.getCategory = undefined;

var _lodash = __webpack_require__(1475);

var _lodash2 = _interopRequireDefault(_lodash);

var _dibsVerticalHelpers = __webpack_require__(416);

var _dibsVerticalHelpers2 = _interopRequireDefault(_dibsVerticalHelpers);

var _createSelector = __webpack_require__(1244);

var _createSelector2 = _interopRequireDefault(_createSelector);

var _makeSelectorHelpers = __webpack_require__(1474);

var _price = __webpack_require__(2083);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Base Getters
// ------------------------------------------

var getCategory = exports.getCategory = function getCategory(item) {
  return (0, _lodash2.default)(item, 'vertical');
};
var getCondition = exports.getCondition = function getCondition(item) {
  return (0, _lodash2.default)(item, 'condition.state');
};
var getCreator = exports.getCreator = function getCreator(item) {
  var creator = (0, _lodash2.default)(item, 'creators[0].creator', {});
  return creator.displayName || creator.name;
};
var getGender = exports.getGender = function getGender(item) {
  return (0, _lodash2.default)(item, 'classification.gender');
};
var getHolds = exports.getHolds = function getHolds(item) {
  return (0, _lodash2.default)(item, 'holds') || [];
};
var getItemId = exports.getItemId = function getItemId(item) {
  return (0, _lodash2.default)(item, 'id') || (0, _lodash2.default)(item, 'serviceId');
};
var getPricing = exports.getPricing = function getPricing(item) {
  return (0, _lodash2.default)(item, 'pricing', {});
};
var getProductName = exports.getProductName = function getProductName(item) {
  return (0, _lodash2.default)(item, 'title');
};
var getSellerId = exports.getSellerId = function getSellerId(item) {
  return (0, _lodash2.default)(item, 'seller.id');
};
var getStatus = exports.getStatus = function getStatus(item) {
  return (0, _lodash2.default)(item, 'status');
};
var getUnavailableReasonCode = exports.getUnavailableReasonCode = function getUnavailableReasonCode(item) {
  return (0, _lodash2.default)(item, 'unavailableReasonCode');
};
var getUrl = exports.getUrl = function getUrl(item) {
  return (0, _lodash2.default)(item, 'pdpUrls[0]') || (0, _lodash2.default)(item, 'pdpURL') || '';
};
var getDealerReference = exports.getDealerReference = function getDealerReference(item) {
  return (0, _lodash2.default)(item, 'dealerReference') || '';
};

// Selectors
// ------------------------------------------

/**
 * @param {string} status to compare to on the passed-in item
 * @returns {function} selector that checks the status with whats on the
 *                      passed-in item
 */
var itemStatusCheckSelector = (0, _makeSelectorHelpers.makeEqualityCheckSelector)(getStatus);
var isUnavailable = exports.isUnavailable = itemStatusCheckSelector('UNAVAILABLE');
var isWip = exports.isWip = itemStatusCheckSelector('INCOMPLETE');

/**
 * @param {...string} all reason codes to compare against the unavailable reason
 *                      code actually on the item
 * @returns {function} selector that checks the reason code on the item against the
 *                      given reason codes
 */
var itemUnavailabilityCheckSelector = function itemUnavailabilityCheckSelector() {
  for (var _len = arguments.length, reasonCodes = Array(_len), _key = 0; _key < _len; _key++) {
    reasonCodes[_key] = arguments[_key];
  }

  return (0, _createSelector2.default)(isUnavailable, getUnavailableReasonCode, function (itemIsUnavailable, unavailableReasonCode) {
    return itemIsUnavailable && reasonCodes.indexOf(unavailableReasonCode) > -1;
  });
};
var isOnHold = exports.isOnHold = itemUnavailabilityCheckSelector('ON_HOLD', 'ON_HOLD_CUSTOM');
var isSold = exports.isSold = itemUnavailabilityCheckSelector('SOLD', 'SOLD_ON_PLATFORM');

/**
 * @param {string} category to compare to on the passed-in item
 * @returns {function} selector that checks the vertical of the item
 */
var itemCategoryCheckSelector = (0, _makeSelectorHelpers.makeEqualityCheckSelector)(getCategory);
var isFurniture = exports.isFurniture = itemCategoryCheckSelector(_dibsVerticalHelpers2.default.VERTICAL_FURNITURE);
var isFashion = exports.isFashion = itemCategoryCheckSelector(_dibsVerticalHelpers2.default.VERTICAL_FASHION);
var isJewelry = exports.isJewelry = itemCategoryCheckSelector(_dibsVerticalHelpers2.default.VERTICAL_JEWELRY);
var isArt = exports.isArt = itemCategoryCheckSelector(_dibsVerticalHelpers2.default.VERTICAL_ART);

/**
 * @param {object} item
 * @returns {array} prices (i.e. retail, sale, etc) for the item
 */
var getPrices = exports.getPrices = (0, _createSelector2.default)(getPricing, function (pricing) {
  return pricing.prices || [];
});

/**
 * @param {string} price type to get from pricing
 * @returns {function} selector that gets the passed in price type from
 *                      pricing data
 */
var pricingPriceTypeSelector = function pricingPriceTypeSelector(typeToCheck) {
  return (0, _createSelector2.default)(getPrices, function (prices) {
    return prices.find(function (_ref) {
      var type = _ref.type,
          status = _ref.status;
      return type === typeToCheck && status === 'ACTIVE';
    });
  });
};
var getRetailPrice = exports.getRetailPrice = pricingPriceTypeSelector('RETAIL');
var getSalePrice = exports.getSalePrice = pricingPriceTypeSelector('WEEKLY_SALE');
var getNetPrice = exports.getNetPrice = pricingPriceTypeSelector('NET');

/**
 * @param {object} item
 * @returns {boolean} true if retail price is hidden
 */
var isRetailPriceHidden = exports.isRetailPriceHidden = (0, _createSelector2.default)(getRetailPrice, _price.isPriceHidden);

/**
 * @param {object} item
 * @returns {?object} the active hold if there is one, undefined otherwise
 */
var getActiveHold = exports.getActiveHold = (0, _createSelector2.default)(getHolds, function (holds) {
  return holds.find(function (hold) {
    return hold.status === 'ACTIVE';
  });
});

/**
 * @param {object} item
 * @returns {function} function that if given a buyer id will return true/false if the buyer
 *                      owns the active hold
 */
var isActiveHoldByBuyerId = exports.isActiveHoldByBuyerId = (0, _createSelector2.default)(getActiveHold, function (hold) {
  return function (buyerId) {
    if (!buyerId) {
      return false;
    }
    return (0, _lodash2.default)(hold, 'buyer.id') === buyerId || (0, _lodash2.default)(hold, 'buyer.serviceId') === buyerId;
  };
});

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reselect = __webpack_require__(1172);

/**
 * Creates a memoize-less selector. The reason of using this instead of the default
 * `createSelector` for now is that with our current codebase we cannot guarantee
 * that we're using immutable data on each input which ruins object/array equality
 * checks we can do as a comparison.
 *
 * There's still benefits of creating selectors though (i.e. increased readability),
 * and this createSelector can also be tuned for increased performance by using a
 * more efficient memoize cache. See https://github.com/medikoo/memoizee for example
 */
exports.default = (0, _reselect.createSelectorCreator)(function (func) {
  return function () {
    return func.apply(undefined, arguments);
  };
});

/***/ }),
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = "<svg version=\"1.1\" class=\"dibsvg-svg dibsvg-close\" viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <path d=\"M274.1,250L495,470.9c6.7,6.7,6.7,17.5,0,24.1s-17.5,6.7-24.1,0L250,274.1L29.1,495 c-6.7,6.7-17.5,6.7-24.1,0s-6.7-17.5,0-24.1L225.9,250L5,29.1C-1.7,22.4-1.7,11.6,5,5s17.5-6.7,24.1,0L250,225.9L470.9,5 c6.7-6.7,17.5-6.7,24.1,0s6.7,17.5,0,24.1L274.1,250z\"/>\n</svg>";

/***/ }),
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _User = __webpack_require__(15);

var _User2 = _interopRequireDefault(_User);

var _authModalLoader = __webpack_require__(266);

var _authModalLoader2 = _interopRequireDefault(_authModalLoader);

var _dibsTracking = __webpack_require__(27);

var _dibsTracking2 = _interopRequireDefault(_dibsTracking);

var _Favorite = __webpack_require__(378);

var _Favorite2 = _interopRequireDefault(_Favorite);

var _calloutTracking = __webpack_require__(711);

var _calloutTracking2 = _interopRequireDefault(_calloutTracking);

var _chat = __webpack_require__(271);

var _chat2 = _interopRequireDefault(_chat);

var _FavoritesStore = __webpack_require__(697);

var _FavoritesStore2 = _interopRequireDefault(_FavoritesStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var favoritesActions = {
    _logInUser: function _logInUser(actionContext, payload, done) {
        var authModalOptions = payload.authModalOptions;
        // Default options

        var modalOptions = {
            action: _authModalLoader2.default.constants.REGISTER,
            flow: _authModalLoader2.default.constants.FOLLOW_DEALER_FLOW,
            ga: {
                label: ''
            }
        };
        var promise = void 0;

        modalOptions = Object.assign({}, modalOptions, authModalOptions);

        if (_calloutTracking2.default.isActive()) {
            var label = modalOptions.ga.label + ' - callout';
            modalOptions = Object.assign({}, modalOptions, {
                ga: { label: label }
            });
        }

        if (_User2.default.loggedIn()) {
            promise = _User2.default.load();
        } else {
            promise = _authModalLoader2.default.show(modalOptions);
        }

        promise.then(function () {
            return done();
        }).catch(function (err) {
            return done(err);
        });
    },


    /**
     * Fetching saved collection
     * @param {Fluxible context} actionContext
     * @param {Object} payload
     * @param {String} payload.uri Url of the page which we want to follow
     */
    fetchFavorites: function fetchFavorites(actionContext, payload, done) {
        var _payload$type = payload.type,
            type = _payload$type === undefined ? '' : _payload$type,
            emailToken = payload.emailToken,
            pageSize = payload.pageSize;

        /**
         * If user is logged in - we fetch favorites collection, to get state of the CTA
         */

        if (_User2.default.loggedIn()) {
            var store = actionContext.getStore(_FavoritesStore2.default);
            var collection = store.getFavoritesCollection();

            collection.setParam('userIds', _User2.default.getUserId());
            collection.setParam('types', type);
            collection.setParam('pageSize', pageSize);

            if (emailToken) {
                collection.setParam('emailToken', emailToken);
            }

            actionContext.dispatch('favorites:fetch:start');

            collection.fetchWithParameters().always(function () {
                actionContext.dispatch('favorites:fetch:end');
                done(null, collection.toJSON());
            });
        } else {
            done();
        }
    },


    /**
     * Save favorite search
     * @param {Fluxible context} actionContext
     * @param {Object} payload
     * @param {String} payload.tracking         GA tracking object
     * @param {String} payload.query            search query
     * @param {String} payload.page             page url
     * @param {String} payload.type             favorite type: search/dealer
     * @returns {Promise} resolves with saved model
     */
    saveToFavorites: function saveToFavorites(actionContext, payload, done) {
        var type = payload.type,
            solrQuery = payload.solrQuery,
            page = payload.page;


        actionContext.executeAction(favoritesActions._logInUser, payload, function (err) {
            if (err) {
                _chat2.default.track.abandonFavorite(type);
                actionContext.dispatch('favorite:canceled');
                done();
            } else {
                var promise = Promise.resolve(payload);

                if (type === _Favorite2.default.TYPE_SEARCH && (!solrQuery || !page)) {
                    promise = actionContext.executeAction(favoritesActions.fetchDataForFavoriting, payload);
                }

                promise.then(function (response) {
                    var savePayload = Object.assign({}, payload, response);
                    actionContext.executeAction(favoritesActions._saveFavorite, savePayload, done);
                });
            }
        });
    },
    _saveFavorite: function _saveFavorite(actionContext, payload, done) {
        var solrQuery = payload.solrQuery,
            page = payload.page,
            type = payload.type,
            name = payload.name,
            primaryKey = payload.primaryKey;

        var Model = actionContext.getStore(_FavoritesStore2.default).getFavoriteModelInstance();

        var model = new Model({
            user: {
                id: _User2.default.getUserId()
            },
            type: type
        });

        switch (type) {
            case _Favorite2.default.TYPE_SEARCH:
                model.set({
                    query: solrQuery,
                    page: page
                });
                break;

            case _Favorite2.default.TYPE_DESIGNER:
                model.set({ page: page, name: name });
            case _Favorite2.default.TYPE_DEALER:
                model.set({
                    anchor: {
                        sourceId: primaryKey,
                        sourceType: type
                    }
                });
                break;
        }

        model.save().then(function () {
            var trackingPayload = payload.tracking;
            if (trackingPayload) {
                var label = trackingPayload.label;


                if (_calloutTracking2.default.isActive()) {
                    label += ' - callout';
                }

                _dibsTracking2.default.trackEvent(Object.assign({}, trackingPayload, { label: label }));
            }
            actionContext.dispatch('favorites:favorite:add', model);
            done(null, model);
        }).fail(function (error) {
            actionContext.dispatch('favorites:error', error);
            done(error);
        });
    },


    /**
     * Remove saved favorite search
     * @param {Fluxible context} actionContext
     * @param {Object} payload
     * @param {Number} payload.id           Favorite model id
     * @param {String} payload.tracking     GA tracking object
     * @returns {Promise} resolves with removed model
     */
    removeFromFavorites: function removeFromFavorites(actionContext, payload, done) {
        var id = payload.id;


        actionContext.executeAction(favoritesActions._logInUser, payload, function (err) {
            // User failed to login
            if (err) {
                done(err);
            } else {
                var model = actionContext.getStore(_FavoritesStore2.default).getFavoriteModel(id);

                if (model) {
                    model.destroy().then(function () {
                        if (payload.tracking) {
                            _dibsTracking2.default.trackEvent(payload.tracking);
                        }

                        actionContext.dispatch('favorites:favorite:remove', model);
                        done(null, model);
                    }).fail(function (error) {
                        actionContext.dispatch('favorites:error', error);
                        done(error);
                    });
                } else {
                    done('Favorite with id "' + id + '" was not found.');
                }
            }
        });
    },


    /**
     * Fetch data for favoriting/saving
     *
     * @param {Object} actionContext
     * @param {Object} payload
     * @param {function} done
     * @returns {Promise}
     */
    fetchDataForFavoriting: function fetchDataForFavoriting(actionContext, payload, done) {
        var model = actionContext.getStore(_FavoritesStore2.default).getSaveSearchModel();
        var type = payload.type;


        model.getSaveSearchData(payload).then(function (response) {
            var solrQuery = response.sq,
                page = response.uri;

            done(null, { solrQuery: solrQuery, page: page, type: type });
        });
    }
};

module.exports = favoritesActions;

/***/ }),
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: liliana
 * Date: 8/18/15
 * Time: 11:23 AM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */



var $ = __webpack_require__(5);
var _ = __webpack_require__(22);

var root = __webpack_require__(102);
var src = "//www.googletagservices.com/tag/js/gpt.js";
var gptLoadedEvent = 'gpt:loaded';
var tryCount = 0;
var retryTimeout;

/**
 * @param {object} options
 * @constructor
 */
function GptLoader(options) {
    options = options || {};
    this.maxTries = options.maxTries || 10;
    this.retryDelay = options.retryDelay || 250;
}

_.extend(GptLoader.prototype, {

    /**
     * Load GPT script
     * @returns {$.Deferred}
     */
    load: function load() {
        var _this = this;

        // getScript should only get called once to prevent multiple GPT scripts on page
        if (!GptLoader.loadedOnce) {
            GptLoader.loadedOnce = true;
            $.when($.getScript(src)).done(function () {
                _this.ensureGoogletagIsLoaded();
            });
        }
        return GptLoader.gptLoaded;
    },


    /**
     * Ensure googletag reference gets populated rather than only running once after the GPT script had been loaded
     * The DFP/GPT Api has changed so this should probably be revisited
     */
    ensureGoogletagIsLoaded: function ensureGoogletagIsLoaded() {
        if (!GptLoader.googletag && root.googletag) {
            GptLoader.googletag = root.googletag;
        }

        if (GptLoader.googletag && GptLoader.googletag.apiReady) {
            clearTimeout(retryTimeout);

            $.publish(gptLoadedEvent);
            GptLoader.gptLoaded.resolve();
        } else {
            // If googletag has not been loaded, retry check
            this.setRetryTimeout();
        }
    },


    /**
     * Set timeout to recheck whether googletag has loaded after delay
     */
    setRetryTimeout: function setRetryTimeout() {
        var _this2 = this;

        if (tryCount < this.maxTries) {
            retryTimeout = setTimeout(function () {
                _this2.ensureGoogletagIsLoaded();
            }, this.retryDelay);
        }
        tryCount++;
    }
});

_.extend(GptLoader, {
    /**
     * @param {object}
     * @static
     */
    googletag: null,
    /**
     * @param {boolean}
     * @static
     */
    loadedOnce: false,
    /**
     * @param {$.Deferred}
     * @static
     */
    gptLoaded: $.Deferred // eslint-disable-line
    () });

module.exports = GptLoader;

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);
var animationFrame = __webpack_require__(899);
var Set = __webpack_require__(2610).default;

// Keep track of currently transitioning elements here so we don't duplicate transitions.
var transitioningElements = new Set();

/**
 * Helper function for adding CSS transitions to elements. Pass in the element to transition and optional start and
 * end callbacks. The endCallback will fire when the transition has completed. To use this helper. Give your element
 * `transition-start` and `transition-active` classes. `transition-start` is added first and `transition-active` is
 * added on the next tick.
 *
 * @example
 * // This setup wil cause the element to transition from opacity 0 to 1 over 250ms.
 * .my-element {
 *     &.transition-start {
 *         opacity: 0;
 *
 *         &.transition-active {
 *             @include transition(opacity 250ms linear);
 *             opacity: 1;
 *         }
 *     }
 * }
 *
 * @param  {object} $el            JQuery object of the element you wish to transition.
 * @param  {function} [options.startCallback] Callback to fire at the beginning of the transition.
 * @param  {function} [options.endCallback] Callback to fire at the end of the transition.
 */
function transitionElement($el) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        startCallback = _ref.startCallback,
        endCallback = _ref.endCallback;

    var timer = void 0;

    if (!$el instanceof $) {
        throw new Error('Passed in element must be a JQuery object.');
    }

    if (transitioningElements.has($el)) {
        return;
    }

    // Need to add this callback on the children of the element or else transitions on the children can cut the main
    // transition short.
    var childCallback = function childCallback() {
        return false;
    };
    transitioningElements.add($el);

    if (typeof startCallback === 'function') {
        startCallback();
    }

    $el.one('transitionend', function () {
        $el.removeClass('transition-start transition-active');
        $el.children().off('transitionend', childCallback);

        if (typeof endCallback === 'function') {
            endCallback();
        }

        transitioningElements.delete($el);

        clearTimeout(timer);
    }).children().on('transitionend', childCallback);

    $el.addClass('transition-start');

    // Add the second class on the next tick so the first class has a change to register.
    animationFrame(function () {
        $el.addClass('transition-active');

        // The transitionend event doesn't fire reliably in some browsers. This timeout will fire in case transitionend
        // fails and will get cleared if it succeeds.
        timer = setTimeout(function () {
            $el.trigger('transitionend');
        }, 500);
    });
}

module.exports = {
    transitionElement: transitionElement
};

/***/ }),
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: liliana
 * Date: 4/16/15
 * Time: 5:55 PM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */



function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SoaModel = __webpack_require__(2);

/**
 * @class FavoriteParameter
 * @extends SoaModel
 * @constructs FavoriteParameter object
 * @constructor
 */
var FavoriteParameter = module.exports = SoaModel.extend();

var _ = __webpack_require__(0);
var numberConversions = __webpack_require__(326);
var FinancialAmounts = __webpack_require__(10);

_.extend(FavoriteParameter.prototype, {

    /**
     * True if parameter values should be pre-processed before display
     * @return {boolean}
     */
    shouldPreProcess: function shouldPreProcess() {
        return FavoriteParameter.PRE_PROCESS_KEYS.indexOf(this.get('key')) > -1;
    },

    /**
     * Returns array of pre-processed values
     * Current use case is to translate true/false bools to Yes/No
     * @return {string[]}
     */
    preProcessValues: function preProcessValues() {
        var values = this.get('values');
        return _.map(values, function (value) {
            return FavoriteParameter.PRE_PROCESS_DISPLAY_MAP[value] || value;
        });
    },

    /**
     * @return {boolean} True if parameter is for internal use and not display
     */
    isInternal: function isInternal() {
        return FavoriteParameter.DISPLAY_MAP[this.get('key')] ? false : true;
    },

    /**
     * @return {boolean} True if key has numerical range value
     */
    hasNumericRange: function hasNumericRange() {
        return FavoriteParameter.NUMERIC_RANGE_KEYS.indexOf(this.get('key')) > -1;
    },

    /**
     * Lookup and return display text for key; fallback to key if not in map
     * @returns {string}
     */
    getDisplayKey: function getDisplayKey() {
        var key = this.get('key');
        var model;
        // TODO: Rip this logic out after BE adds numerical_length label to tell the difference b/t height and length
        if (key === FavoriteParameter.KEY_HEIGHT) {
            model = this.collection ? this.collection.findWhere({ key: FavoriteParameter.KEY_CATEGORY_L2 }) : null;
            if (model && FavoriteParameter.SHOW_LENGTH_CATEGORIES.indexOf(model.getDisplayValue()) > -1) {
                key = FavoriteParameter.KEY_LENGTH;
            }
        }
        return FavoriteParameter.DISPLAY_MAP[key] || key;
    },

    /**
     * Format and return display value for parameter
     * @returns {string} value
     */
    getDisplayValue: function getDisplayValue() {
        var key = this.get('key');
        var values = this.get('values');
        var currency = FinancialAmounts.CURRENCY_USD;
        var amounts = [];
        var model;
        var display;

        // Only pre-process if key is in map
        if (this.shouldPreProcess()) {
            values = this.preProcessValues();
        }

        // Numeric range values are concatenated with appropriate unit and delimited by en dash
        if (this.hasNumericRange()) {
            // Price and currency
            if (key === FavoriteParameter.KEY_PRICE) {

                // Get currency from currency param model in params collection, default to USD
                model = this.collection ? this.collection.findWhere({ key: FavoriteParameter.KEY_CURRENCY }) : null;
                currency = model ? model.getDisplayValue() : currency;

                // Format price
                amounts = _.map(values, function (value) {
                    return numberConversions.intelligentFormat(value, currency);
                });
                // Measurements
            } else {
                amounts = _.map(values, function (value, index) {
                    if (value === '*') {
                        // Min / max are indicated by asterisk, replace depending on index
                        value = index > 0 ? 'Max' : 'Min';
                    } else {
                        // Otherwise, must be number and convert to feet in long form
                        value = numberConversions.convert(value, 'inch', 'feet');
                        value = numberConversions.convert(value, 'feet', 'longForm');
                    }
                    return value;
                });
            }
            display = _.unescape(amounts.join(' &ndash; '));
        } else {

            // All other filters are concatenated with comma e.g. Art-Deco, Contemporary
            display = values.join(', ');
        }
        return display;
    }
});

_.extend(FavoriteParameter, function () {
    var _DISPLAY_MAP;

    var keys;
    var displays;
    var maps;
    var lists;

    // Parameter Keys
    keys = {
        KEY_QUERY: 'query',
        KEY_CATEGORY: 'category',
        KEY_CATEGORY_L2: 'category_l2',
        KEY_PRICE: 'price',
        KEY_CURRENCY: 'currency',
        KEY_PERIOD: 'period',
        KEY_CREATOR: 'creator',
        KEY_LOCATION: 'location',
        KEY_ASSOCIATION: 'association',
        KEY_COLLECTION: 'collection',
        KEY_HEIGHT: 'height',
        KEY_WIDTH: 'width',
        KEY_LENGTH: 'length',
        KEY_SECTION_FURNITURE: 'furniture_section',
        KEY_SECTION_FASHION: 'fashion_section',
        KEY_SECTION_JEWELRY: 'jewelry_section',
        KEY_GENDER: 'gender',
        KEY_ORIGIN: 'origin',
        KEY_MATERIAL: 'material',
        KEY_METAL: 'metal',
        KEY_DEALER: 'dealer',
        KEY_SHIPPING: 'shipping',
        KEY_SOLD: 'sold',
        KEY_STONE: 'stone',
        KEY_STYLE: 'style',
        KEY_TECHNIQUE: 'technique',
        KEY_ITEM_COUNT: 'item_count',
        KEY_NEW_ITEM_COUNT: 'new_item_count',
        KEY_COLOR: 'color'
    };

    // Parameter Display Text
    displays = {
        DISPLAY_QUERY: 'Search Term',
        DISPLAY_CATEGORY: 'Category',
        DISPLAY_PRICE: 'Price',
        DISPLAY_CURRENCY: 'Currency',
        DISPLAY_PERIOD: 'Period',
        DISPLAY_CREATOR: 'Creator',
        DISPLAY_LOCATION: 'Location',
        DISPLAY_ASSOCIATION: 'Association',
        DISPLAY_COLLECTION: 'Collection',
        DISPLAY_HEIGHT: 'Height',
        DISPLAY_WIDTH: 'Width',
        DISPLAY_LENGTH: 'Length',
        DISPLAY_SECTION_FURNITURE: 'Section',
        DISPLAY_SECTION_FASHION: 'Section',
        DISPLAY_SECTION_JEWELRY: 'Section',
        DISPLAY_GENDER: 'Gender',
        DISPLAY_ORIGIN: 'Origin',
        DISPLAY_MATERIAL: 'Material',
        DISPLAY_METAL: 'Metal',
        DISPLAY_DEALER: 'Dealer',
        DISPLAY_SHIPPING: 'Shipping',
        DISPLAY_SOLD: 'Show Sold',
        DISPLAY_STONE: 'Stone',
        DISPLAY_STYLE: 'Style',
        DISPLAY_TECHNIQUE: 'Technique',
        DISPLAY_NEW_ITEMS: 'New Items',
        DISPLAY_COLOR: 'Color'
    };

    // Parameters lists
    lists = {

        // Keys whose values are numeric ranges
        NUMERIC_RANGE_KEYS: [keys.KEY_PRICE, keys.KEY_HEIGHT, keys.KEY_WIDTH],

        // TODO: Rip this logic out after BE adds numerical_length label to tell the difference b/t height and length
        // Categories that use length instead of height for dimensions
        SHOW_LENGTH_CATEGORIES: ['Rugs and Carpets', 'Rugs'],

        // Keys with values that need to be pre-processed
        PRE_PROCESS_KEYS: [keys.KEY_SOLD]
    };

    // Parameters mappings
    maps = {

        // Map key to display text
        DISPLAY_MAP: (_DISPLAY_MAP = {}, _defineProperty(_DISPLAY_MAP, keys.KEY_QUERY, displays.DISPLAY_QUERY), _defineProperty(_DISPLAY_MAP, keys.KEY_CATEGORY, displays.DISPLAY_CATEGORY), _defineProperty(_DISPLAY_MAP, keys.KEY_PRICE, displays.DISPLAY_PRICE), _defineProperty(_DISPLAY_MAP, keys.KEY_CURRENCY, displays.DISPLAY_CURRENCY), _defineProperty(_DISPLAY_MAP, keys.KEY_PERIOD, displays.DISPLAY_PERIOD), _defineProperty(_DISPLAY_MAP, keys.KEY_CREATOR, displays.DISPLAY_CREATOR), _defineProperty(_DISPLAY_MAP, keys.KEY_LOCATION, displays.DISPLAY_LOCATION), _defineProperty(_DISPLAY_MAP, keys.KEY_ASSOCIATION, displays.DISPLAY_ASSOCIATION), _defineProperty(_DISPLAY_MAP, keys.KEY_COLLECTION, displays.DISPLAY_COLLECTION), _defineProperty(_DISPLAY_MAP, keys.KEY_HEIGHT, displays.DISPLAY_HEIGHT), _defineProperty(_DISPLAY_MAP, keys.KEY_WIDTH, displays.DISPLAY_WIDTH), _defineProperty(_DISPLAY_MAP, keys.KEY_LENGTH, displays.DISPLAY_LENGTH), _defineProperty(_DISPLAY_MAP, keys.KEY_SECTION_FURNITURE, displays.DISPLAY_SECTION_FURNITURE), _defineProperty(_DISPLAY_MAP, keys.KEY_SECTION_FASHION, displays.DISPLAY_SECTION_FASHION), _defineProperty(_DISPLAY_MAP, keys.KEY_SECTION_JEWELRY, displays.DISPLAY_SECTION_JEWELRY), _defineProperty(_DISPLAY_MAP, keys.KEY_GENDER, displays.DISPLAY_GENDER), _defineProperty(_DISPLAY_MAP, keys.KEY_ORIGIN, displays.DISPLAY_ORIGIN), _defineProperty(_DISPLAY_MAP, keys.KEY_MATERIAL, displays.DISPLAY_MATERIAL), _defineProperty(_DISPLAY_MAP, keys.KEY_METAL, displays.DISPLAY_METAL), _defineProperty(_DISPLAY_MAP, keys.KEY_DEALER, displays.DISPLAY_DEALER), _defineProperty(_DISPLAY_MAP, keys.KEY_SHIPPING, displays.DISPLAY_SHIPPING), _defineProperty(_DISPLAY_MAP, keys.KEY_SOLD, displays.DISPLAY_SOLD), _defineProperty(_DISPLAY_MAP, keys.KEY_STONE, displays.DISPLAY_STONE), _defineProperty(_DISPLAY_MAP, keys.KEY_STYLE, displays.DISPLAY_STYLE), _defineProperty(_DISPLAY_MAP, keys.KEY_TECHNIQUE, displays.DISPLAY_TECHNIQUE), _defineProperty(_DISPLAY_MAP, keys.KEY_NEW_ITEM_COUNT, displays.DISPLAY_NEW_ITEMS), _defineProperty(_DISPLAY_MAP, keys.KEY_COLOR, displays.DISPLAY_COLOR), _DISPLAY_MAP),

        PRE_PROCESS_DISPLAY_MAP: {
            'true': 'Yes',
            'false': 'No'
        }
    };
    return _.extend(keys, displays, lists, maps);
}());

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 1stdibs
 * User: James
 * Date: 1/17/14
 */


var SoaModel = __webpack_require__(2);

/**
 * @class Category
 * @extends SoaModel
 */
var Category = module.exports = SoaModel.extend();

var _ = __webpack_require__(0);
var Categories = __webpack_require__(3828);
var DimensionSet = __webpack_require__(2054);
var Backbone = __webpack_require__(3);
var verticalHelper = __webpack_require__(416);
var dataProvider = __webpack_require__(780);
var endpoints = __webpack_require__(6);
var getDeferredMethods = __webpack_require__(299);
var DimensionSets = __webpack_require__(3829);
var globalCache = __webpack_require__(1092);

var deferred = getDeferredMethods().Deferred;
var VERTICAL_CATEGORY_KEYS = {};

VERTICAL_CATEGORY_KEYS[verticalHelper.VERTICAL_FURNITURE] = 'F';
VERTICAL_CATEGORY_KEYS[verticalHelper.VERTICAL_FASHION] = 'V';
VERTICAL_CATEGORY_KEYS[verticalHelper.VERTICAL_JEWELRY] = 'J';
VERTICAL_CATEGORY_KEYS[verticalHelper.VERTICAL_ART] = 'A';

_.extend(Category.prototype, /** @lends Category.prototype */{

    /**
     * Get the correct category endpoint
     * @param {string} categoryKey
     * @returns {string}
     */
    url: function url(categoryKey) {
        return endpoints.category(categoryKey || this.get('key'));
    },

    relations: [{
        key: 'parent',
        type: Backbone.One,
        relatedModel: Category
    }, {
        key: 'children',
        type: Backbone.Many,
        collectionType: Categories
    }, {
        key: 'dimensionSet',
        type: Backbone.One,
        relatedModel: DimensionSet
    }],

    /**
     * @returns {number}
     */
    getDimensionSetId: function getDimensionSetId() {
        var dimensionSet = this.get('dimensionSet');
        return dimensionSet ? dimensionSet.id : null;
    },

    /**
     * @param {string} key
     * @returns {DimensionSet}
     */
    lookupFullDimensionSetWithKey: function lookupFullDimensionSetWithKey(key) {
        var child = this.findChildByKey(key);
        var dimensionSet = void 0;
        if (!child) {
            return null;
        }
        dimensionSet = child.get('dimensionSet');
        return dimensionSet ? this.findFullDimensionSetWithId(dimensionSet.id) : null;
    },

    /**
     * @param {number} dimensionSetId
     * @returns {DimensionSet}
     */
    findFullDimensionSetWithId: function findFullDimensionSetWithId(dimensionSetId) {
        return DimensionSets.allDimensionSets().get(dimensionSetId);
    },

    /**
     * This method has been deprecated because
     * new category versions will have non-unique
     * codes
     * @deprecated
     * @param {string} code
     * @returns {Category}
     */
    findChildByCode: function findChildByCode(code) {
        var children = this.get('children');
        if (children) {
            return children.findByCode(code);
        }
    },

    /**
     * @param {string|number} key
     * @returns {Category}
     */
    findChildByKey: function findChildByKey(key) {
        var children = this.get('children');
        if (children) {
            return children.findByKey(key);
        }
    },

    /**
     * @returns {string}
     */
    getName: function getName() {
        return this.get('name');
    },

    /**
     * @returns {number}
     */
    getLevel: function getLevel() {
        return this.get('level');
    },

    /**
     * @returns {string}
     */
    getBrowseUrl: function getBrowseUrl() {
        return this.get('browseUrl');
    },

    /**
     * @returns {Category}
     */
    getParent: function getParent() {
        return this.get('parent');
    },

    /**
     * Traverses tree invoking callback on each Category
     * @param {function} callback
     */
    ascendTree: function ascendTree() {
        var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

        var parent = this.getParent();

        if (typeof callback === 'function') {
            callback(this);
        }

        if (parent) {
            parent.ascendTree(callback);
        }
    }

});

_.extend(Category, /** @lends Category */{

    _verticalCategoryInstances: {},

    VERTICAL_CATEGORY_KEYS: VERTICAL_CATEGORY_KEYS,

    /**
     * @static
     * @private
     * @param {string} vertical
     * @returns {symbol}
     */
    _getCategoryCacheKeyForVertical: function () {
        var cacheKeys = {};
        return function (vertical) {
            if (!cacheKeys[vertical]) {
                cacheKeys[vertical] = Symbol('fetching_category_' + vertical);
            }
            return cacheKeys[vertical];
        };
    }(),

    /**
     * @static
     * @public
     * @param {string} vertical
     * @returns {string}
     */
    getCategoryKeyForVertical: function getCategoryKeyForVertical(vertical) {
        return Category.VERTICAL_CATEGORY_KEYS[vertical];
    },
    /**
     * @public
     * @static
     * @returns {Category}
     */
    verticalCategoryInstance: function verticalCategoryInstance(vertical) {
        if (!Category._verticalCategoryInstances[vertical]) {
            var category = new Category({ key: Category.getCategoryKeyForVertical(vertical) });
            Category._verticalCategoryInstances[vertical] = category;
        }
        return Category._verticalCategoryInstances[vertical];
    },
    /**
     * @public
     * @static
     * @param {string} vertical
     * @param {object} [fetchOptions] Same options you would pass to SoaCollection.fetch
     * @returns {Deferred.promise}
     */
    fetchVerticalCategoryInstance: function fetchVerticalCategoryInstance(vertical, fetchOptions) {
        var categoryPromiseKey = Category._getCategoryCacheKeyForVertical(vertical);
        var categoryPromise = globalCache.get(categoryPromiseKey);

        if (!categoryPromise) {
            categoryPromise = Category.verticalCategoryInstance(vertical).fetch(fetchOptions);
            globalCache.set(categoryPromiseKey, categoryPromise);
            categoryPromise.fail(function () {
                globalCache.del(categoryPromiseKey);
            });
        }
        return categoryPromise;
    },

    /**
     * @public
     * @static
     * @memberOf Category
     * @param {string} vertical
     * @param {object} [fetchOptions] Same options you would pass to SoaCollection.fetch
     * @param {string} [dataProviderKey]
     *     Key used by dataProvider to provide data for vertical category instance
     * @returns {Deferred.promise}
     */
    requestVerticalCategoryInstanceUseDP: function requestVerticalCategoryInstanceUseDP(vertical, fetchOptions, dataProviderKey) {
        var data = dataProvider.get(dataProviderKey || vertical + '_category');
        var instance = void 0;
        if (data) {
            instance = Category.verticalCategoryInstance(vertical);
            instance.clear().set(data);
            return deferred().resolve(data).promise();
        }
        return Category.fetchVerticalCategoryInstance(vertical, fetchOptions);
    }
});

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by daletan on 7/29/16.
 */



var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var PriceLock = SoaModel.extend();
var Price = __webpack_require__(66);

_.extend(PriceLock, {
    LOCK_TYPE_ORIGINAL: 'ORIGINAL_PRICE',
    TYPE_RETAIL: 'RETAIL'
});

_.extend(PriceLock.prototype, {
    relations: [{
        key: 'price',
        relatedModel: Price,
        type: Backbone.One
    }],
    getOriginalPriceIn: function getOriginalPriceIn() {
        var currency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'USD';

        var convertedAmounts = this.get('price.amount') || {};
        if (convertedAmounts) {
            return convertedAmounts.getAmountIn(currency);
        }
        return null;
    }
});

module.exports = PriceLock;

/***/ }),
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */
/***/ (function(module, exports) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/** Used for native method references */
var objectProto = Object.prototype;

/** Used to resolve the internal [[Class]] of values */
var toString = objectProto.toString;

/** Used to detect if a method is native */
var reNative = RegExp('^' +
  String(toString)
    .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    .replace(/toString| for [^\]]+/g, '.*?') + '$'
);

/**
 * Checks if `value` is a native function.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if the `value` is a native function, else `false`.
 */
function isNative(value) {
  return typeof value == 'function' && reNative.test(value);
}

module.exports = isNative;


/***/ }),
/* 1384 */,
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 4.2.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseIteratee = __webpack_require__(312),
    baseUniq = __webpack_require__(3938);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length)
    ? baseUniq(array, baseIteratee(iteratee))
    : [];
}

module.exports = uniqBy;


/***/ }),
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(509);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule QueryBuilder
 * 
 */



var _freeze = __webpack_require__(2318);

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var RelayNodeInterface = __webpack_require__(4090);

var generateConcreteFragmentID = __webpack_require__(1946);
var warning = __webpack_require__(1962);

var EMPTY_CALLS = [];
var EMPTY_CHILDREN = [];
var EMPTY_DIRECTIVES = [];
var EMPTY_METADATA = {};

if (false) {
  (0, _freeze2['default'])(EMPTY_CALLS);
  (0, _freeze2['default'])(EMPTY_CHILDREN);
  (0, _freeze2['default'])(EMPTY_DIRECTIVES);
  (0, _freeze2['default'])(EMPTY_METADATA);
}

/**
 * @internal
 *
 * Helper methods for constructing concrete query objects.
 */
var QueryBuilder = {
  createBatchCallVariable: function createBatchCallVariable(sourceQueryID, jsonPath) {
    return {
      kind: 'BatchCallVariable',
      sourceQueryID: sourceQueryID,
      jsonPath: jsonPath
    };
  },
  createCall: function createCall(name, value, type) {
    return {
      kind: 'Call',
      name: name,
      metadata: {
        type: type || null
      },
      value: value
    };
  },
  createCallValue: function createCallValue(callValue) {
    return {
      kind: 'CallValue',
      callValue: callValue
    };
  },
  createCallVariable: function createCallVariable(callVariableName) {
    return {
      kind: 'CallVariable',
      callVariableName: callVariableName
    };
  },
  createDirective: function createDirective(name, args) {
    return {
      args: args,
      kind: 'Directive',
      name: name
    };
  },
  createDirectiveArgument: function createDirectiveArgument(name, value) {
    return {
      name: name,
      value: value
    };
  },
  createField: function createField(partialField) {
    var partialMetadata = partialField.metadata || EMPTY_METADATA;
    return {
      alias: partialField.alias,
      calls: partialField.calls || EMPTY_CALLS,
      children: partialField.children || EMPTY_CHILDREN,
      directives: partialField.directives || EMPTY_DIRECTIVES,
      fieldName: partialField.fieldName,
      kind: 'Field',
      metadata: {
        canHaveSubselections: !!partialMetadata.canHaveSubselections,
        inferredRootCallName: partialMetadata.inferredRootCallName,
        inferredPrimaryKey: partialMetadata.inferredPrimaryKey,
        isConnection: !!partialMetadata.isConnection,
        isFindable: !!partialMetadata.isFindable,
        isGenerated: !!partialMetadata.isGenerated,
        isPlural: !!partialMetadata.isPlural,
        isRequisite: !!partialMetadata.isRequisite,
        isAbstract: !!partialMetadata.isAbstract
      },
      type: partialField.type
    };
  },
  createFragment: function createFragment(partialFragment) {
    var metadata = partialFragment.metadata || EMPTY_METADATA;
    return {
      children: partialFragment.children || EMPTY_CHILDREN,
      directives: partialFragment.directives || EMPTY_DIRECTIVES,
      id: generateConcreteFragmentID(),
      kind: 'Fragment',
      metadata: {
        isAbstract: !!metadata.isAbstract,
        pattern: !!metadata.pattern,
        plural: !!metadata.plural },
      name: partialFragment.name,
      type: partialFragment.type
    };
  },
  createFragmentReference: function createFragmentReference(fragment) {
    return {
      kind: 'FragmentReference',
      fragment: fragment
    };
  },
  createMutation: function createMutation(partialMutation) {
    var metadata = partialMutation.metadata || EMPTY_METADATA;
    return {
      calls: partialMutation.calls || EMPTY_CALLS,
      children: partialMutation.children || EMPTY_CHILDREN,
      directives: partialMutation.directives || EMPTY_DIRECTIVES,
      kind: 'Mutation',
      metadata: {
        inputType: metadata.inputType
      },
      name: partialMutation.name,
      responseType: partialMutation.responseType
    };
  },
  createQuery: function createQuery(partialQuery) {
    var metadata = partialQuery.metadata || EMPTY_METADATA;
    var calls = [];
    var identifyingArgName = metadata.identifyingArgName;
    if (identifyingArgName == null && RelayNodeInterface.isNodeRootCall(partialQuery.fieldName)) {
      identifyingArgName = RelayNodeInterface.ID;
    }
    if (identifyingArgName != null) {
       false ? warning(partialQuery.identifyingArgValue != null, 'QueryBuilder.createQuery(): An argument value may be required for ' + 'query `%s(%s: ???)`.', partialQuery.fieldName, identifyingArgName) : void 0;
      calls = [QueryBuilder.createCall(identifyingArgName, partialQuery.identifyingArgValue, metadata.identifyingArgType)];
    }
    return {
      calls: calls,
      children: partialQuery.children || EMPTY_CHILDREN,
      directives: partialQuery.directives || EMPTY_DIRECTIVES,
      fieldName: partialQuery.fieldName,
      isDeferred: !!(partialQuery.isDeferred || metadata.isDeferred),
      kind: 'Query',
      metadata: {
        identifyingArgName: identifyingArgName,
        identifyingArgType: metadata.identifyingArgType,
        isAbstract: !!metadata.isAbstract,
        isPlural: !!metadata.isPlural
      },
      name: partialQuery.name,
      type: partialQuery.type
    };
  },
  createSubscription: function createSubscription(partialSubscription) {
    var metadata = partialSubscription.metadata || EMPTY_METADATA;
    return {
      calls: partialSubscription.calls || EMPTY_CALLS,
      children: partialSubscription.children || EMPTY_CHILDREN,
      directives: partialSubscription.directives || EMPTY_DIRECTIVES,
      kind: 'Subscription',
      metadata: {
        inputType: metadata.inputType
      },
      name: partialSubscription.name,
      responseType: partialSubscription.responseType
    };
  },
  getBatchCallVariable: function getBatchCallVariable(node) {
    if (isConcreteKind(node, 'BatchCallVariable')) {
      return node;
    }
  },
  getCallVariable: function getCallVariable(node) {
    if (isConcreteKind(node, 'CallVariable')) {
      return node;
    }
  },
  getField: function getField(node) {
    if (isConcreteKind(node, 'Field')) {
      return node;
    }
  },
  getFragment: function getFragment(node) {
    if (isConcreteKind(node, 'Fragment')) {
      return node;
    }
  },
  getFragmentReference: function getFragmentReference(node) {
    if (isConcreteKind(node, 'FragmentReference')) {
      return node;
    }
  },
  getFragmentSpread: function getFragmentSpread(node) {
    if (isConcreteKind(node, 'FragmentSpread')) {
      return node;
    }
  },
  getMutation: function getMutation(node) {
    if (isConcreteKind(node, 'Mutation')) {
      return node;
    }
  },
  getQuery: function getQuery(node) {
    if (isConcreteKind(node, 'Query')) {
      return node;
    }
  },
  getSubscription: function getSubscription(node) {
    if (isConcreteKind(node, 'Subscription')) {
      return node;
    }
  }
};

function isConcreteKind(node, kind) {
  return typeof node === 'object' && node !== null && node.kind === kind;
}

module.exports = QueryBuilder;

/***/ }),
/* 1426 */,
/* 1427 */,
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(150);

/***/ }),
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(60);

/***/ }),
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.1.4
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _FlexModalWrapper = __webpack_require__(1);
	
	var _FlexModalWrapper2 = _interopRequireDefault(_FlexModalWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _FlexModalWrapper2.default;

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(3);
	
	var _reactBodySubtree = __webpack_require__(4);
	
	var _reactBodySubtree2 = _interopRequireDefault(_reactBodySubtree);
	
	var _FlexModalWrapper = __webpack_require__(5);
	
	var _FlexModalWrapper2 = _interopRequireDefault(_FlexModalWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalWrapper = function (_React$Component) {
	  _inherits(ModalWrapper, _React$Component);
	
	  function ModalWrapper() {
	    _classCallCheck(this, ModalWrapper);
	
	    var _this = _possibleConstructorReturn(this, (ModalWrapper.__proto__ || Object.getPrototypeOf(ModalWrapper)).call(this));
	
	    _this.handleMouseClickOutside = _this.handleMouseClickOutside.bind(_this);
	    return _this;
	  }
	
	  _createClass(ModalWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!document) {
	        return;
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('mousedown', this.handleMouseClickOutside);
	      }
	      if (this.props.preventScrolling) {
	        this.previousOverflow = document.body.style.overflow;
	        document.body.style.overflow = 'hidden';
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!document) {
	        return;
	      }
	      document.removeEventListener('mousedown', this.handleMouseClickOutside);
	      if (this.props.preventScrolling) {
	        document.body.style.overflow = this.previousOverflow;
	      }
	    }
	  }, {
	    key: 'handleMouseClickOutside',
	    value: function handleMouseClickOutside(e) {
	      var rootNode = (0, _reactDom.findDOMNode)(this.refs.content);
	      if (rootNode.contains(e.target) || e.button !== 0) {
	        return;
	      }
	      e.stopPropagation();
	      this.props.closePortal();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          useOverlay = _props.useOverlay,
	          overlayClassName = _props.overlayClassName,
	          overlayStyle = _props.overlayStyle,
	          closeModal = _props.closePortal;
	
	      var modalwrapper = _react2.default.createElement(
	        'div',
	        { className: className ? _FlexModalWrapper2.default.flexModalWrapper + ' ' + className : _FlexModalWrapper2.default.flexModalWrapper, ref: 'content' },
	        _react2.default.Children.map(this.props.children, function (c) {
	          return _react2.default.cloneElement(c, { closeModal: closeModal });
	        })
	      );
	      var overlay = void 0;
	      if (useOverlay) {
	        if (overlayStyle) {
	          overlay = _react2.default.createElement(
	            'div',
	            { className: _FlexModalWrapper2.default.flexModalOverlay, style: overlayStyle },
	            modalwrapper
	          );
	        } else {
	          overlay = _react2.default.createElement(
	            'div',
	            { className: _FlexModalWrapper2.default.flexModalOverlay + ' ' + (overlayClassName || _FlexModalWrapper2.default.overlayStyle) },
	            modalwrapper
	          );
	        }
	      } else {
	        overlay = _react2.default.createElement(
	          'div',
	          { className: _FlexModalWrapper2.default.flexModalOverlay },
	          modalwrapper
	        );
	      }
	      return overlay;
	    }
	  }]);
	
	  return ModalWrapper;
	}(_react2.default.Component);
	
	ModalWrapper.propTypes = {
	  children: _react2.default.PropTypes.node.isRequired,
	  className: _react2.default.PropTypes.string,
	  useOverlay: _react2.default.PropTypes.bool,
	  overlayStyle: _react2.default.PropTypes.object,
	  overlayClassName: _react2.default.PropTypes.string,
	  closeOnOutsideClick: _react2.default.PropTypes.bool,
	  preventScrolling: _react2.default.PropTypes.bool,
	  // passed by Portal
	  closePortal: _react2.default.PropTypes.func
	};
	
	var FlexModalWrapper = function (_React$Component2) {
	  _inherits(FlexModalWrapper, _React$Component2);
	
	  function FlexModalWrapper() {
	    _classCallCheck(this, FlexModalWrapper);
	
	    return _possibleConstructorReturn(this, (FlexModalWrapper.__proto__ || Object.getPrototypeOf(FlexModalWrapper)).apply(this, arguments));
	  }
	
	  _createClass(FlexModalWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          other = _objectWithoutProperties(_props2, ['children']);
	
	      var closeOnOutsideClick = other.closeOnOutsideClick,
	          className = other.className,
	          useOverlay = other.useOverlay,
	          overlayStyle = other.overlayStyle,
	          overlayClassName = other.overlayClassName,
	          preventScrolling = other.preventScrolling,
	          portalOptions = _objectWithoutProperties(other, ['closeOnOutsideClick', 'className', 'useOverlay', 'overlayStyle', 'overlayClassName', 'preventScrolling']);
	
	      return _react2.default.createElement(
	        _reactBodySubtree2.default,
	        portalOptions,
	        _react2.default.createElement(
	          ModalWrapper,
	          _extends({
	            ref: function ref(_ref) {
	              return _this3.modal = _ref;
	            }
	          }, { closeOnOutsideClick: closeOnOutsideClick, className: className, useOverlay: useOverlay, overlayStyle: overlayStyle, overlayClassName: overlayClassName, preventScrolling: preventScrolling }),
	          children
	        )
	      );
	    }
	  }]);
	
	  return FlexModalWrapper;
	}(_react2.default.Component);
	
	FlexModalWrapper.propTypes = {
	  children: _react2.default.PropTypes.node.isRequired,
	  className: _react2.default.PropTypes.string,
	  useOverlay: _react2.default.PropTypes.bool,
	  overlayStyle: _react2.default.PropTypes.object,
	  overlayClassName: _react2.default.PropTypes.string,
	  // Portal props
	  isOpened: _react2.default.PropTypes.bool,
	  openByClickOn: _react2.default.PropTypes.element,
	  closeOnEsc: _react2.default.PropTypes.bool,
	  closeOnOutsideClick: _react2.default.PropTypes.bool,
	  preventScrolling: _react2.default.PropTypes.bool,
	  onClose: _react2.default.PropTypes.func
	};
	FlexModalWrapper.defaultProps = {
	  useOverlay: true,
	  preventScrolling: true
	};
	
	module.exports = FlexModalWrapper;

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(1);

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(39);

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(1587);

/***/ },
/* 5 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flexModalWrapper":"FlexModalWrapper__flexModalWrapper___GQhOs","flexModalOverlay":"FlexModalWrapper__flexModalOverlay___72E20","overlayStyle":"FlexModalWrapper__overlayStyle___aqiN6"};

/***/ }
/******/ ]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1458 */,
/* 1459 */,
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: hella
 * Date: 6/3/14
 * Time: 8:30 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */



module.exports = {
    GLOBAL_NAV_WRAP            : '#globalNav',
    GLOBAL_NAV                 : '.global-nav-content-width',
    GLOBAL_NAV_ITEM            : '.global-nav-item',
    GLOBAL_NAV_ITEM_LINK       : '.global-nav-item-link',
    GLOBAL_SEARCH              : '#globalSearchBox',
    HEADER                     : '#header',
    HEADER_DIVIDER             : '#headerDivider',
    TOGGLE_USER_NAV            : '#toggleUserNav',
    TOGGLE_NAV_SEARCH          : '#toggleNavSearch',
    TOGGLE_NAV_FAVORITES       : '#toggleNavFavorites',
    TOGGLE_NAV_CART            : '#toggleCart',
    NAV_UTILS_WRAP             : '.nav-utils-wrap',
    SEARCH_BOX_FORM            : '.search-box-form',
    SEARCH_BOX_INPUT           : '.search-box-input',
    SEARCH_BOX_BUTTON          : '.search-box-button',
    SEARCH_BOX_CALLOUT         : '.js-search-box-callout',
    SEARCH_INPUT               : '#globalSearchBox .search-box-input',
    SEARCH_CLOSE               : '.js-search-close',
    HANDLER_SEARCH             : 'a[href=#search]',
    HANDLER_REGISTER           : 'a[href=#register]',
    HANDLER_LOGIN              : 'a[href=#login]',
    HANDLER_LOGOUT             : 'a[href=#logout]',
    HANDLER_USER_NAV           : 'a[href=#user]',
    MAX_USER_NAME_LENGTH       : 10,
    MAX_MASQUERADE_NAME_LENGTH : 12,
    // anything appended with Class has no preceding period
    DOUBLE_TAP_CLASS           : 'js-double-tap',
    SCROLLED_CLASS             : 'scrolled',
    IS_FULL_CLASS              : 'is-full',
    IS_SHOWING_CLASS           : 'is-showing',
    IS_CURRENT_CLASS           : 'is-current',
    IS_HOVER_CLASS             : 'is-hover',
    SEARCH_EXPANDED_CLASS      : 'search-expanded',
    // Nav sub views
    SUB_VIEW_GLOBAL            : 'NavGlobalView',
    SUB_VIEW_GLOBAL_SUBS       : 'NavGlobalSubsView',
    SUB_VIEW_UTILS             : 'NavUtilsView',
    SUB_VIEW_SEARCH            : 'NavSearchView',
    SUB_VIEW_USER              : 'NavUserView',
    SUB_VIEW_FAVORITES         : 'NavFavoritesView',
    SUB_VIEW_CART              : 'NavCartView'
};


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);
var _ = __webpack_require__(22);
var Backbone = __webpack_require__(3);
var storage = __webpack_require__(282);

var VisitCountModel = module.exports = Backbone.Model.extend();
var VISITS_PER_SESSION_LOGIN_PROMPT = 3;

_.extend(VisitCountModel, {
    /**
     * number of (non iframe) page views per session before login/registration auto prompt
     */
    VISITS_PER_SESSION_LOGIN_PROMPT: VISITS_PER_SESSION_LOGIN_PROMPT,

    /**
     * length of time before local storage values "expire" as session values
     * 4 hrs: (4 * 60 minutes x 60 seconds * 1000 milliseconds)
     */
    PSEUDO_SESSION_EXPIRES_AT: 14400000,

    STORAGE_KEY: 'visitCount',
    SESSION_COUNT: 'sessionCount',
    SESSION_CONTINUE: 'sessionContinue',

    /**
     * data saved on this key will "expire" when past time stamp
     */
    PSEUDO_SESSION_STORAGE_KEY: 'pseudoSessionVisitCount',

    ERROR: {
        NO_LOCAL_STORAGE: 'Local storage not available.',
        NO_SESSION_STORAGE: 'Session storage not available.'
    }
});

_.extend(VisitCountModel.prototype, {
    /**
     * any of these can be overwritten via local/session/psuedoSessionStorage
     * for A/B variant (optimizely) testing, manual QA, or unit tests
     * @returns {{totalVisitCount: number, session: number, sinceRegPrompt: number, regPromptLimit: number, pseudoSessionExpiration: number}}
     */
    defaults: function () {
        return {
            totalVisitCount: 0,
            session: 0,
            sessionCount: 0,
            sinceRegPrompt: 0,
            regPromptLimit: VisitCountModel.VISITS_PER_SESSION_LOGIN_PROMPT,
            pseudoSessionExpiration: VisitCountModel.PSEUDO_SESSION_EXPIRES_AT
        };
    },

    initialize: function (atts, options) {
        VisitCountModel.__super__.initialize.call(this, atts, options);
        if (storage && storage.localStorage) {
            this.set(this.parseIntStorageData(VisitCountModel.STORAGE_KEY, 'storage'));
            this.set(this.parseIntStorageData(VisitCountModel.PSEUDO_SESSION_STORAGE_KEY, 'storage'));
            if (this.isPseudoSessionStorageExpired()) {
                this.set('session', 0);
                this.set('regPromptLimit', this.defaults().regPromptLimit);
            }
        }
    },

    /**
     * checks to see if time stamp on "session" storage has expired
     * @returns {boolean}
     */
    isPseudoSessionStorageExpired: function () {
        //set the value "pseudoSessionExpiration" on specs or in your localStorage via the console to test expiration
        /**
         * to change expiration: run the following in the console
         ob = JSON.parse(localStorage.getItem('pseudoSessionVisitCount'));
         ob.pseudoSessionExpiration = 0;
         localStorage.setItem('pseudoSessionVisitCount', JSON.stringify(ob));
         * refresh your browser
         */
        var limit = this.get('pseudoSessionExpiration');
        var now = new Date().getTime();
        // if no timestamp assume it's brand new
        return now - (this.get('timeStamp') || now) >= limit;
    },

    /**
     * fetches an object from local storage and parses its fields to integers
     * @param key {string} the key in local storage
     * @param type {string} (optional) local or session (defaults to local)
     * @returns {mixed|*|{}}
     */
    parseIntStorageData: function (key, type) {
        var source;
        var data;
        var field;
        switch (type) {
            case 'session' :
                source = storage.sessionStorage;
                break;
            default :
                source = storage.localStorage;
                break;
        }
        data = source.getItem(key) || {};
        // parseInt over all fields
        for (field in data) {
            if (data.hasOwnProperty(field)) {
                data[field] = parseInt(data[field], 10) || 0;
            }
        }
        return data;
    },

    /**
     * increments a field by 1
     * @param {string} field
     */
    increment: function (field) {
        var val = this.get(field) || 0;
        this.set(field, val + 1);
    },

    /**
     * saves visit counts to local and session storage
     * @returns {jQuery.promise}
     */
    save: function () {

        var dfd = $.Deferred();
        var totalVisitCount = this.get('totalVisitCount');
        var sessionVisitCount = this.get('session');
        var sinceRegVisitCount = this.get('sinceRegPrompt');
        var regPromptLimit = this.get('regPromptLimit');
        var localData;
        var pseudoSessionData;

        if (!storage.localStorage) {
            return dfd.reject({msg: VisitCountModel.ERROR.NO_LOCAL_STORAGE}).promise();
        }

        localData = {
            totalVisitCount: totalVisitCount,
            sinceRegPrompt: sinceRegVisitCount,
            regPromptLimit: regPromptLimit
        };
        storage.localStorage.setItem(VisitCountModel.STORAGE_KEY, window.JSON.stringify(localData));

        pseudoSessionData = {
            session: sessionVisitCount,
            timeStamp: new Date().getTime()
        };
        storage.localStorage.setItem(VisitCountModel.PSEUDO_SESSION_STORAGE_KEY, window.JSON.stringify(pseudoSessionData));

        return dfd.resolve($.extend({msg: 'ok'}, localData, pseudoSessionData));

    },

    /**
     * removes visit counts from session and local storage
     * @returns {jQuery.promise}
     */
    destroy: function () {

        var dfd = $.Deferred();

        if (!storage.localStorage) {
            return dfd.reject({msg: VisitCountModel.ERROR.NO_LOCAL_STORAGE}).promise();
        }
        storage.localStorage.deleteItem(VisitCountModel.STORAGE_KEY);
        storage.localStorage.deleteItem(VisitCountModel.PSEUDO_SESSION_STORAGE_KEY);

        return dfd.resolve({msg: 'ok'});
    }

});


/***/ }),
/* 1462 */,
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Aaron Horton
 * Date: 3/12/15
 * Time: 6:13 PM
 */



var SoaCollection = __webpack_require__(9);
var endpoints = __webpack_require__(6);

module.exports = SoaCollection.extend({
    fetchByZip: function (zipCode, country) {
        return this.fetch({
            url: endpoints.zipCode(),
            data: {
                zipCode: zipCode,
                country: country
            }
        });
    }
});

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/11/13
 */


var Backbone = __webpack_require__(3);
var _ = __webpack_require__(0);
var $ = __webpack_require__(5);
var endpoints = __webpack_require__(6);
var SoaModel = __webpack_require__(2);
var SoaCollection = __webpack_require__(9);
var CurrencyConversionRate = __webpack_require__(2046);
var CurrencyConversion = __webpack_require__(2045);

var ConversionCalculation = SoaModel.extend();
_.extend(ConversionCalculation.prototype, {

    defaults: {
        conversions: []
    },

    url: endpoints.currencyConversion(),

    relations: function () {
        return [
            {
                type: Backbone.Many,
                key: 'rates',
                relatedModel: CurrencyConversionRate,
                collectionType: SoaCollection
            },
            {
                type: Backbone.Many,
                key: 'conversions',
                relatedModel: CurrencyConversion,
                collectionType: SoaCollection
            }
        ];
    },

    parse: function (data) {
        return (!data.result) ? data : data.result;
    },

    /**
     * Get a model by its label value
     * @param {string} label The label to search for
     * @returns {object}
     */
    getModelByLabel: function (label) {
        return this.get('conversions').findWhere({
            label: label
        });
    },

    /**
     * Get a model and delete by its label value
     * @param {string} label The label to search for
     */
    deleteModelByLabel: function (label) {
        var model = this.getModelByLabel(label);
        if (model) {
            this.get('conversions').remove(model);
        }
    },

    /**
     * Add a price amount to be converted.  Usually, the amount would be
     * in a localized format (EUR, PND/GBP), but can be in USD
     * @param {string} label
     * @param {string} fromAmount
     * @param {string} fromCurrency
     * @returns {ConversionCalculation} for chaining
     */
    addAmount: function (label, fromAmount, fromCurrency) {
        // always delete model before adding to make sure
        // multiple models with the same label do not get added
        this.deleteModelByLabel(label);
        var conversion = new CurrencyConversion({
            fromAmount: fromAmount,
            fromCurrency: fromCurrency,
            label: label,
            toCurrency: null
        });
        this.get('conversions').add(conversion);

        return this;
    },

    /**
     * Look up a converted value based on the label and currency passed in
     * @param {string} label The model to search for
     * @param {string} currency The currency to use for the lookup
     * @returns {*}
     */
    getAmount: function (label, currency) {
        var model = this.getModelByLabel(label);
        if (model) {
            if (model.get('fromCurrency') === currency) {
                return model.get('fromAmount');
            } else if (model.get('toCurrency') === currency) {
                return model.get('toAmount');
            }
        }
        return null;
    },

    /**
     * Update an existing model
     * @param {string} label The model to search for
     * @param {number} amount The amount to update with
     * @param {string} currency The currency the amount is in
     * @param {string} [toOrFrom] Which direction the conversion should go - "to" or "from"
     */
    updateAmount: function (label, amount, currency, toOrFrom) {
        var model = this.getModelByLabel(label);
        var props = {};
        toOrFrom = toOrFrom || 'to';
        props[toOrFrom + 'Amount'] = amount;
        props[toOrFrom + 'Currency'] = currency;

        model.set(props);
    },

    /**
     * Convert all the models against the url endpoint (currency conversion service)
     * @param {string} toCurrency The currency to convert to (USD, PND, EUR)
     * @param {object} [options]
     * @returns {object} The object is a promise
     */
    convertTo: function (toCurrency, options) {
        var self = this;
        // removes models that have a toAmount and where
        // the toCurrency matches the model's currency
        // this is to avoid double conversions
        // they get added back on the model after the save
        var toRemove = [];
        var tmpConversion;
        var originalModel;
        var conversions = this.get('conversions');
        var dfd = new $.Deferred();
        this.get('conversions').each(function (model) {
            var modelCurrency = model.get('toCurrency');
            var modelToAmount = model.get('toAmount');
            if (toCurrency !== modelCurrency && !modelToAmount) {
                model.set('toCurrency', toCurrency);
            } else {
                toRemove.push(model);
            }
        }, this);

        // Make a new conversion to make sure we don't mutate the existing object.
        // Work around for checkout currency localization architechture to avoid
        // corrupting this model when invoking this function multiple times.
        originalModel = this.toJSON();
        tmpConversion = new ConversionCalculation(originalModel);
        tmpConversion.set('conversions', conversions.without.apply(conversions, toRemove));

        // Cancel all outstanding requests to avoid issues with out of order responses
        if (this.convertToDfd) {
            this.convertToDfd.reject();
        }
        this.convertToDfd = dfd;
        tmpConversion.save(null, options)
            .done(function () {
                // Restore to what it was when convertTo was invoked in case it was changed
                // by another call to this function.
                self.set(originalModel);
                // tmpConversion has the models that have been converted.
                // Add them back onto our model now.
                tmpConversion.get('conversions').each(function (newModel) {
                    var model = self.getModelByLabel(newModel.get('label'));
                    model.set(newModel.toJSON());
                });
                self.get('conversions').set(conversions.toJSON());
                dfd.resolve.apply(dfd, arguments);
            })
            .fail(dfd.reject);
        return dfd.promise();
    },
    // Will not need to do this after BE releases full currency conversion
    getAllRates: function () {
        this.get('conversions').reset([
            new CurrencyConversion({
                fromAmount: 1,
                fromCurrency: 'PND',
                label: 'PND',
                toCurrency: 'USD'
            }),
            new CurrencyConversion({
                fromAmount: 1,
                fromCurrency: 'EUR',
                label: 'EUR',
                toCurrency: 'USD'
            }),
            new CurrencyConversion({
                fromAmount: 1,
                fromCurrency: 'USD',
                label: 'USD',
                toCurrency: 'USD'
            })
        ]);
        return this.save();
    }
});

module.exports = ConversionCalculation;

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Dependencies
var SoaModel = __webpack_require__(2);
var Listing = module.exports = SoaModel.extend();
var Publication = __webpack_require__(3844);
var endpoints = __webpack_require__(6);
var NotesDocumentList = __webpack_require__(1890);
var Note = __webpack_require__(33);
var Anchor = __webpack_require__(12);
var Backbone = __webpack_require__(3);
var PublicationType = __webpack_require__(1893);
var transitionMixin = __webpack_require__(315);
var AvailableActions = __webpack_require__(1527);
var _ = __webpack_require__(0);
var Deferred = __webpack_require__(29);
var moment = __webpack_require__(30);

/**
 * @class Listing
 * @extends SoaModel
 */

_.extend(Listing.prototype, {
    url : function () {
        return endpoints.singleListing(this.get('id'));
    },

    /**
     * Update bookmarked setting on listing.
     * If listing has one or more bookmark notes, the listing is considered bookmarked,
     * otherwise the listing is not bookmarked.
     * @param options - should we save change and what callbacks should be passed
     */
    toggleBookmark: function (options) {
        var existingBookmarkNotes = this.get('notes') &&
            this.get('notes').where({'type' : Note.TYPE_LISTING_BOOKMARK});
        var newBookmarkNoteOptions;
        var notesDeferreds = [];
        options = options || {};

        // if bookmarked then we need to un-bookmark, so delete notes
        if (existingBookmarkNotes && existingBookmarkNotes.length) {
            _.each(existingBookmarkNotes, function (note) {
                note.service = endpoints.latest.inventoryListings;
                notesDeferreds.push(note.destroy({queries : {
                    indexMode : "sync"
                }}));
            });

            return Deferred.when.apply(Deferred, notesDeferreds).done(function () {
                if (options.success) {
                    options.success();
                }
            }).fail(function () {
                if (options.error) {
                    options.error();
                }
            });
        } else {
            // listing is not bookmarked
            // add a note to switch this listing to be bookmarked
            newBookmarkNoteOptions = {
                service: endpoints.latest.inventoryListings,
                type: Note.TYPE_LISTING_BOOKMARK,
                user: options.user,
                anchors: [
                    {
                        sourceId: this.id,
                        sourceType: Anchor.TYPE_ITEM_LISTING
                    }
                ]
            };
            return this.getNotes().addNewNote(newBookmarkNoteOptions, _.extend(options, {queries : {
                indexMode : "sync"
            }}));
        }
    },

    canPromote: function () {
        var actions = this.get('actions');
        return !!(actions && actions.find(function (_a) {
            return _a.code === Listing.ACTIONS.PROMOTE_LISTING;
        }));
    },

    canDelay: function (userOrSeller) {
        var actions = this.get('actions');
        var actionsColl;
        if (actions && actions.length) {
            actionsColl = new AvailableActions(actions);
            return !!actionsColl.isUserAuthorizedFor(Listing.ACTIONS.DELAY, userOrSeller);
        }
        return false;
    },

    getPromoteDestinations: function () {
        return this.canPromote() && this.get('actions').find(function (_a) {
            return _a.code === Listing.ACTIONS.PROMOTE_LISTING;
        }).details.promotionDestinations || [];
    },

    ///////////////////
    // Type
    isStorefront: function () {
        return this.get('type').isStorefront();
    },
    isMarketplace: function () {
        return this.get('type').isMarketplace();
    },
    isFeatured: function () {
        return this.get('type').isFeatured();
    },
    isSale: function () {
        return this.get('type').isSale();
    },
    /**
     * Update bookmarked setting on listing.
     * If listing has one or more bookmark notes, the listing is considered bookmarked,
     * otherwise the listing is not bookmarked.
     * @returns {Boolean}
     */
    isBookmarked: function () {
        return !!(this.get('notes') && this.get('notes').findWhere({'type' : Note.TYPE_LISTING_BOOKMARK}));
    },

    ///////////////////
    // Statuses
    isPublishedStatus: function () {
        return this.get('status') === Listing.STATUS.PUBLISHED;
    },
    isNewStatus: function () {
        return this.get('status') === Listing.STATUS.NEW;
    },
    isQueuedStatus: function () {
        return this.get('status') === Listing.STATUS.QUEUED;
    },
    isCompleteStatus: function () {
        return this.get('status') === Listing.STATUS.COMPLETE;
    },
    isDeletedStatus: function () {
        return this.get('status') === Listing.STATUS.DELETED;
    },
    isNotDeletedStatus: function () {
        return this.get('status') !== Listing.STATUS.DELETED;
    },
    isUnavailableStatus: function () {
        return this.get('status') === Listing.STATUS.UNAVAILABLE;
    },

    ///////////////////
    // Setters
    markDeleted : function () {
        this.set('status', Listing.STATUS.DELETED);
    },
    setPublication: function (publication) {
        return this.set('publication', publication);
    },

    ///////////////////
    // Getters
    getPublication: function () {
        return this.get('publication');
    },
    getType: function () {
        return this.get('type');
    },
    getSort: function () {
        return this.get('sort');
    },

    /**
     * Retrieve notes, set an empty collection for Notes if none returned from fetch.
     * @returns {Notes}
     */
    getNotes: function () {
        var notes = this.get('notes');

        if (_.isUndefined(notes)) {
            this.set('notes', new NotesDocumentList({
                service: endpoints.latest.inventoryListings,
                documents: []
            }));
            notes = this.get('notes');
        }
        return notes;
    },

    /**
     * "Snooze" listing by updating eligibility date.
     * @returns {*|$.Deferred.promise}
     */
    delay: function () {
        var notes = this.get('notes');
        var oldEligibilityDate = this.get('eligibilityDate');
        var newEligibilityDate = moment(oldEligibilityDate).add(7, 'days').format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        this.set('eligibilityDate', newEligibilityDate);

        if (notes) {
            notes.unset('service'); // not a valid field for BE, needs to be removed before save
        }

        return this.save(null, {
            method: 'PUT',
            queries : {
                indexMode : 'sync',
                workflowAction: 'update'
            }
        });
    },

    relations: [
        {
            key: 'item',
            type: Backbone.One,
            relatedModel: function () {
                return __webpack_require__(573);
            }
        },
        {
            key : 'type',
            type: Backbone.One,
            relatedModel : PublicationType
        },
        {
            key: 'notes',
            type: Backbone.One,
            relatedModel: NotesDocumentList
        },
        {
            key: 'publication',
            type: Backbone.One,
            relatedModel: Publication
        }
    ],
    defaults : {
        apiType : 'itemListing'
    }
}, transitionMixin);


// static props :
_.extend(Listing, {
    TYPE: {
        FEATURED: 'FEATURED',
        MARKETPLACE: 'MARKETPLACE',
        STOREFRONT: 'DEALER_STOREFRONT',
        SATURDAY_SALE: 'SATURDAY_SALE'
    },
    STATUS: {
        NEW: 'NEW',
        COMPLETE: 'COMPLETE',
        QUEUED: 'QUEUED',
        PUBLISHED: 'PUBLISHED',
        UNAVAILABLE: 'UNAVAILABLE',
        DELETED: 'DELETED'
    },
    REASON_CODE: {
        UNLISTED: 'UNLISTED',
        SOLD: 'SOLD',
        SOLD_HIDDEN_MANUALLY : 'SOLD_HIDDEN_MANUALLY',
        DEMOTED: 'DEMOTED',
        ITEM_MOVED_TO_INCOMPLETE: 'ITEM_MOVED_TO_INCOMPLETE',
        ITEM_DELETED: 'ITEM_DELETED',
        REPOSTED: 'REPOSTED',
        CLEANED_UP_AFTER_ERROR: 'CLEANED_UP_AFTER_ERROR',
        DELETED_BY_MIGRATION: 'DELETED_BY_MIGRATION',
        EXPIRED: 'EXPIRED',
        ON_HOLD: 'ON_HOLD',
        EXPIRED_SOLD: 'EXPIRED_SOLD',
        INELIGIBLE: 'INELIGIBLE'
    },
    ACTIONS: {
        PROMOTE_LISTING: 'PROMOTE_LISTING',
        DELAY: 'DELAY'
    }
});


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 1stdibs
 * User: James
 * Date: 1/25/13
 */


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var ItemCreator = module.exports = SoaModel.extend();
var Creator = __webpack_require__(2646);
var endpoints = __webpack_require__(6);
var ReferenceSets = __webpack_require__(2626);

var furnitureDefaults = {
        roles: ['DESIGNER'],
        attribution: 'BY',
        creator: {}
    };

var artDefaults = {
        attribution: 'BY',
        creator: {}
    };

_.extend(ItemCreator.prototype, {
    relations: [{
        key: 'creator',
        relatedModel: Creator,
        type: Backbone.One
    }],
    /**
     * Gets the unknown creator model.
     * @returns {*} promise
     */

    //This is throwing an error because endpoints is not defined
    //This has not been fixed in Bunsen Master https://github.com/1stdibs/bunsen/blob/master/js/src/dibslibs/models/link-models/ItemCreator.js
    //Also, there is no unknownCreator endpoint in the bunsen endpoints file

    fetchUnknownCreator: function () {
        return this.get('creator').fetch({
            url : endpoints.unknownCreator()
        });
    },
    getRolesString: function () {
        var roles = this.get('roles');
        var roleArr = [];

        if (!ItemCreator.roles) {
            console.warn('You need to call ItemCreator.fetchCreatorRoles before using getRolesString');
            return;
        }

        _.each(roles, function (roleEnum) {
            var roleModel = ItemCreator.roles.findWhere({ enum_name: roleEnum });
            if (roleModel) {
                roleArr.push(roleModel.get('display_name'));
            }
        });

        return roleArr.join(', ');
    }
});

_.extend(ItemCreator, {
    setDefaults: function (defaults) {
        ItemCreator.prototype.defaults = defaults;
    },
    useFurnitureDefaults: function () {
        ItemCreator.setDefaults(furnitureDefaults);
    },
    useArtDefaults: function () {
        ItemCreator.setDefaults(artDefaults);
    },
    fetchCreatorRoles: function (options) {
        var roles = new ReferenceSets();
        return roles.fetchByType('CREATOR_ROLE', options).done(function () {
            ItemCreator.roles = roles;
        });
    }
});


/***/ }),
/* 1467 */
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(2320);
module.exports = function(target, src, safe){
  for(var key in src){
    if(safe && target[key])target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(4207)|| !__webpack_require__(4214)(function(){
  var K = Math.random();
  // In FF throws only define methods
  __defineSetter__.call(null, K, function(){ /* empty */});
  delete __webpack_require__(2312)[K];
});

/***/ }),
/* 1470 */,
/* 1471 */,
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var constats = __webpack_require__(1639);
var currencies = constats.currencies;
var currencySymbols = constats.symbols;
var abbreviations = constats.abbreviations;

/**
 * A more forgiving parseFloat
 * This is useful when consuming user-input
 * @param {number|string} number Either a formatted string (3,000) or integer (3000)
 * @returns {Number}
 */
exports.parseFloat = function dibsParsFloat(number) {
    return parseFloat(String(number).replace(/[^\d\.e-]/ig, '')) || 0;
};

/**
 * Round to the given precision
 * @param {number|string} number @see Number.parseFloat#number
 * @param {number} digits
 * @returns {number}
 */
exports.round = function round(number, digits) {
    var powed = Math.pow(10, digits);
    return Math.round(exports.parseFloat(number) * powed) / powed;
};

/**
 * Similar to PHP's number_format
 * @param number
 * @param {number} significantDigits The decimal place to round and fix a number to, Defaults to 0
 * @param {String} thousandsSeparator Defaults to ,
 * @param {String} decimalMark Defaults to .
 */
exports.format = function format(number, significantDigits, thousandsSeparator, decimalMark) {
    var suffix = '';
    var isNegative = number < 0;
    var bits;
    var i;

    if (isNegative) {
        number = number * -1;
    }

    significantDigits = significantDigits > -1 ? significantDigits : 0;
    thousandsSeparator = thousandsSeparator === undefined ? ',' : thousandsSeparator;
    decimalMark = decimalMark === undefined ? '.' : decimalMark;
    number = exports.round(number, significantDigits).toFixed(significantDigits);
    if (thousandsSeparator && number.match(/^\d{4}/)) {
        if (significantDigits) {
            suffix = number.substr(number.indexOf('.'));
            number = number.split('.')[0];
        }
        bits = number.split('');
        i = bits.length - 3;
        while (i > 0) {
            bits.splice(i, 0, thousandsSeparator);
            i -= 3;
        }
        number = bits.concat(suffix).join('');
    }
    if (decimalMark !== '.' && significantDigits) {
        number = number.replace(/\.(\d+)$/, decimalMark + '$1');
    }

    if (isNegative) {
        number = '-' + number;
    }

    return number;
};

/**
 *
 * @param {number} number The number to format
 * @param {object} [options] Formatting options
 * @param {boolean} [options.showDecimal] Show a decimal or not. Defaults to true
 * @param {string} [options.thousandsSeparator] What separates the thousands? Defaults to comma ","
 * @param {string} [options.decimalMark] What separates decimals? Defaults to period "."
 * @param {string} [options.abbreviation] Wheter to include an abbreviation or not
 * @param {boolean} [options.includeCurrencySymbol] Wheter to include a currency symbol or not
 * @param {string} [options.currencySymbol] Which currency symbol to use. Defaults to USD "$"
 * @returns {object}
 */
exports.localizedCashFormatObj = function (number, options) {
    options = Object.assign({
        includeCurrencySymbol: true
    }, options);
    var decimalsToShow = options.showDecimal === false ?  0 : 2;
    var thousandsSeparator = options.thousandsSeparator || ',';
    var decimalMark = options.decimalMark || '.';
    var currencySymbol = options.currencySymbol || '$';
    var abbreviation = options.abbreviation || '';
    var sign = '';

    number = exports.format(number, decimalsToShow, thousandsSeparator, decimalMark);
    currencySymbol = options.includeCurrencySymbol ? currencySymbol : '';

    // if it's negative we need to put the negative sign in front
    if (number.indexOf('-') !== -1) {
        sign = '-';
        number = number.replace('-', '');
    }

    return {
        sign: sign,
        currencySymbol: currencySymbol,
        number: number,
        abbreviation: abbreviation
    };
};

/**
 *
 * @param {number} number The number to format
 * @param {object} [options] Formatting options
 * @param {boolean} [options.showDecimal] Show a decimal or not. Defaults to true
 * @param {string} [options.thousandsSeparator] What separates the thousands? Defaults to comma ","
 * @param {string} [options.decimalMark] What separates decimals? Defaults to period "."
 * @param {string} [options.abbreviation] Wheter to include an abbreviation or not
 * @param {boolean} [options.includeCurrencySymbol] Wheter to include a currency symbol or not
 * @param {string} [options.currencySymbol] Which currency symbol to use. Defaults to USD "$"
 * @returns {string}
 */
exports.localizedCashFormat = function (number, options) {
    var localizedObject = exports.localizedCashFormatObj(number, options);
    var localizedNumber = localizedObject.number;
    var currencySymbol = localizedObject.currencySymbol;
    var abbreviation = localizedObject.abbreviation;
    var sign = localizedObject.sign;

    // if it's negative we need to put the negative sign in front
    if (sign) {
        sign = sign + ' ';
    }

    if (abbreviation.length) {
        abbreviation = ' ' + abbreviation;
    }

    if (options.formatNegativeAmount && sign) {
        return '(' + currencySymbol + localizedNumber + abbreviation + ')';
    }

    return sign + currencySymbol + localizedNumber + abbreviation;
};

/**
 * Converts a string containing numbers to an integer
 * @param  {string} amount
 * @return {number}
 */
exports.currencyToInteger = function (amount) {
    // Match all numbers and - sign
    var regexp = /-?[0-9]*/g;
    if (typeof amount === 'number') {
        return amount;
    } else if (typeof amount === 'string') {
        return parseInt(amount.match(regexp).join(''), 10);
    } else {
        return NaN;
    }
};

/**
 * Used internaly for intelligentFormat
 * @param  {number} The number to format
 * @param  {string}
 * @param  {object} passedOptions
 * @return {object}
 */
exports.getFormatOptions = function (amount, currency, passedOptions) {
    var options;
    var num = exports.parseFloat(amount);
    var currencyUppercase = (currency + '').toUpperCase();
    options = {
        // Only if there are decimals do we show them
        showDecimal : Math.ceil(num) !== Math.floor(num),
        thousandsSeparator : ',',
        decimalMark : '.',
        currencySymbol : currencySymbols.USD,
        abbreviation: abbreviations[currencyUppercase],
        formatNegativeAmount: false
    };

    switch (currencyUppercase) {
        case currencies.CURRENCY_GBP:
        case currencySymbols.GBP:
            options.currencySymbol = currencySymbols.GBP;
            break;
        case currencies.CURRENCY_CHF:
        case currencySymbols.CHF:
            options.includeCurrencySymbol = false;
            break;
        case currencies.CURRENCY_EUR:
        case currencySymbols.EUR:
            options.thousandsSeparator = '.';
            options.decimalMark = ',';
            options.currencySymbol = currencySymbols.EUR;
            break;
    }

    return Object.assign(options, passedOptions);
};


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = ['USD', 'GBP', 'EUR', 'CAD', 'AUD', 'CHF', 'MXN'];


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeYesCheckSelector = exports.makeArrayCompareSelector = exports.makeEqualityCheckSelector = undefined;

var _createSelector = __webpack_require__(1244);

var _createSelector2 = _interopRequireDefault(_createSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a selector factory whose input will be checked for equality against
 * the resulting selector that gets returned
 *
 * Example:
 *
 * const item = { id: 0 };
 * const getId = item => item.id;
 * const idCompareSelector = makeEqualityCheckSelector(getId);
 * const getIsIdZero = makeIdCompareSelector(0);
 * assert(getIsIdZero(item));
 */
var makeEqualityCheckSelector = exports.makeEqualityCheckSelector = function makeEqualityCheckSelector() {
    for (var _len = arguments.length, dependencySelectors = Array(_len), _key = 0; _key < _len; _key++) {
        dependencySelectors[_key] = arguments[_key];
    }

    return function (inputToCompare) {
        return _createSelector2.default.apply(undefined, dependencySelectors.concat([function (selectorInput) {
            return selectorInput === inputToCompare;
        }]));
    };
};

/**
 * Creates a selector factory whose input will checked to see if it exists
 * in the array that the returning selector returns.
 *
 * Example:
 *
 * const item = { attributes: ['green', 'little', 'shiny'] };
 * const getAttributes = item => item.attributes;
 * const attributeCheckSelector = makeArrayCompareSelector(getAttributes);
 * const getHasGreenAttribute = makeAttributeCheckSelector('green');
 * assert(getHasGreenAttribute(item));
 */
var makeArrayCompareSelector = exports.makeArrayCompareSelector = function makeArrayCompareSelector() {
    for (var _len2 = arguments.length, dependencySelectors = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        dependencySelectors[_key2] = arguments[_key2];
    }

    return function (inputToCompare) {
        return _createSelector2.default.apply(undefined, dependencySelectors.concat([function (arrayToCheck) {
            return arrayToCheck.indexOf(inputToCompare) > -1;
        }]));
    };
};

/**
 * Creates a selector factory that will compare the result of the selector with 'Y'.
 * For data that, instead of being stored as booleans, are stored as 'Y' or 'N'
 *
 * Example:
 *
 * const item = { available: 'Y' };
 * const getAvailable = item => item.available;
 * const getIsAvailable = makeYesCheckSelector(getAvailable);
 * assert(getIsAvailable(item));
 */
var makeYesCheckSelector = exports.makeYesCheckSelector = function makeYesCheckSelector() {
    for (var _len3 = arguments.length, dependencySelectors = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        dependencySelectors[_key3] = arguments[_key3];
    }

    var selectorFunc = dependencySelectors.pop();
    var selector = function selector(input) {
        var prop = selectorFunc(input);
        return prop === 'Y' || prop === true;
    };
    return dependencySelectors.length ? _createSelector2.default.apply(undefined, dependencySelectors.concat([selector])) : selector;
};

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"Header-style__header__o-Fyi","title":"Header-style__title__UFFvM","close":"Header-style__close__3l0ks","closeButton":"Header-style__closeButton__1Cpty"};

/***/ }),
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTradeUserSV = isTradeUserSV;
exports.isTradeUserBody = isTradeUserBody;

var _serverVars = __webpack_require__(18);

var _serverVars2 = _interopRequireDefault(_serverVars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Determine if the current user is trade *only on page load* based on the nav header's values in server-vars.
 *
 * @returns {boolean}
 */
function isTradeUserSV() {
  return _serverVars2.default.get('settings.isUserTypeTrade');
}

/**
 * Determine if the current user is trade based on the body tag.
 *
 * @returns {boolean}
 */
function isTradeUserBody() {
  var els = typeof document !== 'undefined' ? document.querySelectorAll('body.is-trade') : [];
  return els.length > 0;
}

/**
 * Check the body and server-vars to see if the user has type trade.
 *
 * This should be set up to be called when listening for the logged-in event, in case the user logs in mid-session.
 *
 * @returns {boolean} Returns a true/false flag based on the user.
 */
function isTradeUser() {
  return isTradeUserSV() || isTradeUserBody();
}

exports.default = isTradeUser;

/***/ }),
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.tradeAppRegistration = exports.tradeAppLogin = exports.tradeAltRegistration = exports.consumerAltRegistration = exports.basicLogin = exports.authModalFlows = undefined;

var _authModalLoader = __webpack_require__(266);

var _authModalLoader2 = _interopRequireDefault(_authModalLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var triggerAuthModal = function triggerAuthModal(_ref) {
    var action = _ref.action,
        flow = _ref.flow;
    return function () {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var email = options.email,
            _options$fireEntryGa = options.fireEntryGa,
            fireEntryGa = _options$fireEntryGa === undefined ? true : _options$fireEntryGa,
            label = options.label;


        return _authModalLoader2.default.show({
            action: action,
            fireEntryGa: fireEntryGa,
            flow: flow,
            email: email,
            ga: {
                label: label
            }
        });
    };
};

var authModalFlows = exports.authModalFlows = _authModalLoader2.default.constants;
var basicLogin = exports.basicLogin = triggerAuthModal({ action: authModalFlows.LOGIN, flow: authModalFlows.LOGIN });
var consumerAltRegistration = exports.consumerAltRegistration = triggerAuthModal({ action: authModalFlows.REGISTER, flow: authModalFlows.ALT_REGISTRATION_CONSUMER_FLOW });
var tradeAltRegistration = exports.tradeAltRegistration = triggerAuthModal({ action: authModalFlows.REGISTER, flow: authModalFlows.ALT_REGISTRATION_TRADE_FLOW });
var tradeAppLogin = exports.tradeAppLogin = triggerAuthModal({ action: authModalFlows.LOGIN, flow: authModalFlows.TRADE_APPLICATION_FLOW });
var tradeAppRegistration = exports.tradeAppRegistration = triggerAuthModal({ action: authModalFlows.REGISTER, flow: authModalFlows.TRADE_APPLICATION_FLOW });

/***/ }),
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaCollection = __webpack_require__(9);
var AuthorizedRoles = __webpack_require__(1888);
var AvailableAction = __webpack_require__(3833);
var _types = {
    WF: "WORKFLOW_TRANSITION"
};

/**
 *
 * This collection has method related to the available actions property of a given entity. Handy for reading and
 * manipulating available actions. Require this file and add as a relation to your model.
 * Available actions tell your model what actions are available to be taken on it.
 * They also contain authorizedRoles models in some cases to state what users are allowed to take those actions.
 * Use these methods to check for certain actions or permission to take certain actions.
 * @type {{}}
 */
var AvailableActions = SoaCollection.extend({

    model: AvailableAction,

    /**
     * Get all actions that are of type workflow transition. Basically gets all the possible WF states the model
     * is able to transition to. Returns another instance of AvailableActions collection.
     * @returns {*}
     */
    getAvailableWFTransitions: function getAvailableWFTransitions() {
        return new AvailableActions(this.where({ type: _types.WF }));
    },


    /**
     * Ask for an action by name. If available this method returns true.
     * @param actionName
     */
    actionIsAvailable: function actionIsAvailable(actionName) {
        return !!this.where({ code: actionName }).length;
    },


    /**
     * Query this method to see if your user can take a given action. Accepts user/seller and checks to see if the
     * action is available AND you are permitted to do it.
     * @param actionName
     * @param userOrSeller
     * @returns {*}
     */
    isUserAuthorizedFor: function isUserAuthorizedFor(actionName, userOrSeller) {
        if (!this.actionIsAvailable(actionName)) {
            return false;
        }

        var action = this.findWhere({ code: actionName });
        var roles = action.getRoles(); // returns authorized roles collection

        // if no roles were included then anyone can perform this action unless blocked by other permission.
        if (!roles || !roles.length) {
            return true;
        }

        return roles.isUserPermitted(userOrSeller);
    }
});

module.exports = AvailableActions;

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var endpoints = __webpack_require__(6);
var assert = __webpack_require__(31);
var SD = __webpack_require__(29).Deferred;
var IMAGE_API_TYPE = 'image';

var Photo = SoaModel.extend();

_.extend(Photo, {
    UPLOAD_TYPE_DEALER: 'USER',
    UPLOAD_TYPE_1STDIBS: '_1STDIBS'
});

_.extend(Photo.prototype, {
    relations: [{
        key: 'versions',
        type: Backbone.Many,
        relatedModel: SoaModel.extend({
            relations: [{
                key: 'type',
                type: Backbone.One,
                relatedModel: SoaModel
            }]
        })
    }],

    download: function download(options) {
        var item = this.collection && this.collection.parents[0];
        if (!item || item.get('id') === undefined) {
            var message = 'Cannot download photo that does not have an item parent with an id';
            console.error(message);
            return new SD().reject(message);
        }
        options = options || {};
        var params = this.getTokenObj();
        params.version = options.version || 'original';
        var url = endpoints.downloadOriginal(item.get('id'), this.get('id'));

        location.href = url + '?' + Backbone.$.param(params);
    },

    initialize: function initialize(attributes) {
        attributes.apiType = IMAGE_API_TYPE;
        this.set('apiType', IMAGE_API_TYPE);
        return Photo.__super__.initialize.call(this, attributes);
    },


    /**
     * Determines if the photo in question is the first photo.
     * @returns {boolean}
     */
    isPhotoOne: function isPhotoOne() {
        return this.get('sortOrder').toString() === '1';
    },


    /**
     * Returns who uploaded the image
     * @returns string
     */
    getPhotoProvider: function getPhotoProvider() {
        var provider = this.get('uploadType');
        if (provider === this.UPLOAD_TYPE_DEALER) {
            return 'dealer';
        } else if (provider === this.UPLOAD_TYPE_1STDIBS) {
            return '1stdibs';
        }
        return null;
    },


    /**
     * Returns photo version by type, if exists
     * @param {string} type
     * @returns Object
     */
    getVersion: function getVersion(type) {
        if (this.get('versions')) {
            return _.first(this.get('versions').filter(function (version) {
                return version.get('type.name') === type;
            }));
        }
    },


    /**
     * Rotate a photo on the item.
     * @param newAngle - <number>
     * @returns {Deferred}
     */
    rotatePhoto: function rotatePhoto(newAngle) {
        assert(newAngle, 'You must include an angle of rotation.');
        var xhr = void 0;
        var rotateData = {
            apiType: Photo.PHOTOS_API.PHOTOS_ROTATION_API_TYPE,
            type: Photo.PHOTOS_API.PHOTOS_ROTATION_TYPE,
            degree: newAngle
        };
        var parent = this.collection && this.collection.parents ? this.collection.parents[0] : null;
        var _trigger = function (e) {
            this.trigger(e);
            if (parent && typeof parent.trigger === 'function') {
                parent.trigger(e);
            }
        }.bind(this);

        xhr = this.save(null, {
            url: endpoints.processImage(this.collection.parents[0].get('id'), this.get('id')),
            data: JSON.stringify(rotateData),
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=UTF-8',
            success: function success() {
                return _trigger('photo-model-rotation-success');
            },
            error: function error() {
                return _trigger('photo-model-rotation-fail');
            }
        });

        _trigger('photo-model-rotation-start', xhr);
        return xhr;
    }
});

// Static functions
_.extend(Photo, {
    PHOTOS_API: {
        PHOTOS_ROTATION_API_TYPE: 'imageRotationRequest',
        PHOTOS_ROTATION_TYPE: 'ROTATION'
    }
});

module.exports = Photo;

/***/ }),
/* 1529 */,
/* 1530 */
/***/ (function(module, exports) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/**
 * Slices the `collection` from the `start` index up to, but not including,
 * the `end` index.
 *
 * Note: This function is used instead of `Array#slice` to support node lists
 * in IE < 9 and to ensure dense arrays are returned.
 *
 * @private
 * @param {Array|Object|string} collection The collection to slice.
 * @param {number} start The start index.
 * @param {number} end The end index.
 * @returns {Array} Returns the new array.
 */
function slice(array, start, end) {
  start || (start = 0);
  if (typeof end == 'undefined') {
    end = array ? array.length : 0;
  }
  var index = -1,
      length = end - start || 0,
      result = Array(length < 0 ? 0 : length);

  while (++index < length) {
    result[index] = array[start + index];
  }
  return result;
}

module.exports = slice;


/***/ }),
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _createEagerFactory = __webpack_require__(667);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    return function (props) {
      return factory(_extends({}, props, props[propName]));
    };
  };
};

exports.default = (0, _createHelper2.default)(flattenProp, 'flattenProp');

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = exports.config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

exports.default = configureObservable;

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shallowEqual = __webpack_require__(1588);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shallowEqual2.default;

/***/ }),
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(4056);
var util = __webpack_require__(4206);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(720);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(231);

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(37);

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(385);

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(40);

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(76);

/***/ }),
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(39);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEYCODES = {
  ESCAPE: 27
};

var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));

    _this.state = { active: false };
    _this.handleWrapperClick = _this.handleWrapperClick.bind(_this);
    _this.closePortal = _this.closePortal.bind(_this);
    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
    _this.handleKeydown = _this.handleKeydown.bind(_this);
    _this.portal = null;
    _this.node = null;
    return _this;
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.addEventListener('mouseup', this.handleOutsideMouseClick);
        document.addEventListener('touchstart', this.handleOutsideMouseClick);
      }

      if (this.props.isOpened) {
        this.openPortal();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // portal's 'is open' state is handled through the prop isOpened
      if (typeof newProps.isOpened !== 'undefined') {
        if (newProps.isOpened) {
          if (this.state.active) {
            this.renderPortal(newProps);
          } else {
            this.openPortal(newProps);
          }
        }
        if (!newProps.isOpened && this.state.active) {
          this.closePortal();
        }
      }

      // portal handles its own 'is open' state
      if (typeof newProps.isOpened === 'undefined' && this.state.active) {
        this.renderPortal(newProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.removeEventListener('mouseup', this.handleOutsideMouseClick);
        document.removeEventListener('touchstart', this.handleOutsideMouseClick);
      }

      this.closePortal(true);
    }
  }, {
    key: 'handleWrapperClick',
    value: function handleWrapperClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.state.active) {
        return;
      }
      this.openPortal();
    }
  }, {
    key: 'openPortal',
    value: function openPortal() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      this.setState({ active: true });
      this.renderPortal(props);
      this.props.onOpen(this.node);
    }
  }, {
    key: 'closePortal',
    value: function closePortal() {
      var _this2 = this;

      var isUnmounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var resetPortalState = function resetPortalState() {
        if (_this2.node) {
          _reactDom2.default.unmountComponentAtNode(_this2.node);
          document.body.removeChild(_this2.node);
        }
        _this2.portal = null;
        _this2.node = null;
        if (isUnmounted !== true) {
          _this2.setState({ active: false });
        }
      };

      if (this.state.active) {
        if (this.props.beforeClose) {
          this.props.beforeClose(this.node, resetPortalState);
        } else {
          resetPortalState();
        }

        this.props.onClose();
      }
    }
  }, {
    key: 'handleOutsideMouseClick',
    value: function handleOutsideMouseClick(e) {
      if (!this.state.active) {
        return;
      }

      var root = (0, _reactDom.findDOMNode)(this.portal);
      if (root.contains(e.target) || e.button && e.button !== 0) {
        return;
      }

      e.stopPropagation();
      this.closePortal();
    }
  }, {
    key: 'handleKeydown',
    value: function handleKeydown(e) {
      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
        this.closePortal();
      }
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.node) {
        this.node = document.createElement('div');
        document.body.appendChild(this.node);
      }

      var children = props.children;
      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
      if (typeof props.children.type === 'function') {
        children = _react2.default.cloneElement(props.children, { closePortal: this.closePortal });
      }

      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.node, this.props.onUpdate);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.openByClickOn) {
        return _react2.default.cloneElement(this.props.openByClickOn, { onClick: this.handleWrapperClick });
      }
      return null;
    }
  }]);

  return Portal;
}(_react2.default.Component);

exports.default = Portal;


Portal.propTypes = {
  children: _react2.default.PropTypes.element.isRequired,
  openByClickOn: _react2.default.PropTypes.element,
  closeOnEsc: _react2.default.PropTypes.bool,
  closeOnOutsideClick: _react2.default.PropTypes.bool,
  isOpened: _react2.default.PropTypes.bool,
  onOpen: _react2.default.PropTypes.func,
  onClose: _react2.default.PropTypes.func,
  beforeClose: _react2.default.PropTypes.func,
  onUpdate: _react2.default.PropTypes.func
};

Portal.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onUpdate: function onUpdate() {}
};
module.exports = exports['default'];


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(182);

/***/ }),
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by daniel.gonzalez on 3/24/15.
 */



var $                = __webpack_require__(5);
var SV               = __webpack_require__(18);
var uriHelper        = __webpack_require__(689);
var referrerHelpers  = __webpack_require__(1204);
var mobileCheck      = __webpack_require__(283);
var url              = uriHelper.URL;

var DEEP_LINK_BASE = 'dibs://www.1stdibs.com';
var DEEP_LINK_BASE_MC = 'dibsmc://www.1stdibs.com';

/**
 * @param {string} key - query param in the current page's url
 * @returns {boolean} - true if the app supports the query param
 */
function querySupported(key) {
    var queries = SV.get('deepLinks.queries') || {};
    var keyLowerCased = key.toLowerCase();
    return typeof queries[keyLowerCased] !== 'undefined';
}

function wasLoginRedirected() {
    return url.queryKey && url.queryKey.ep && /login/.test(url.queryKey.modal);
}

function getDeepLinkBase(path) {
    return (/^\/my\/conversations/.test(path) ? DEEP_LINK_BASE_MC : DEEP_LINK_BASE);
}

/**
 * @param path {string} - the path for the current page
 * @param queryParams {string} - all the query params for the current page
 * @returns {string} - returns the path concatenated with the query params supported in the app
 */
function createDeepLinkPath(path, queryParams) {
    var params = queryParams.split('&');
    var supportedParams = [];
    var length = params.length;
    var key;
    var i;

    for (i = 0; i < length; i++) {
        key = params[i].split('=')[0];
        if (querySupported(key)) {
            supportedParams.push(params[i]);
        }
    }

    return path + '?' + supportedParams.join('&');
}

module.exports = {
    /**
     *
     * @returns {boolean} - true if the page is supported in the app
     */
    pageSupported: function (path) {
        path = path || url.path;
        var supported = false;
        var regexs = SV.get('deepLinks.regexs') || [];
        var length = regexs.length;
        var value;
        var regex;
        var i;

        for (i = 0; i < length; i++) {
            value = regexs[i];
            regex = new RegExp(value, 'i');
            if (regex.test(path)) {
                supported = true;
                break;
            }
        }

        if (path === '/') {
            // home page
            supported = true;
        }

        return supported;
    },

    createDeepLink: function (updatedUrl) {
        var path = updatedUrl && updatedUrl.path ? updatedUrl.path : url.path;
        var query = updatedUrl && updatedUrl.query ? updatedUrl.query : url.query;
        return getDeepLinkBase(path) + createDeepLinkPath(path, query);
    },

    /**
     * If the user is redirected and does not have the app, a safari modal pops up saying the page cannot be opened.
     * The safari modal will not pop up if the user is redirected in an iframe.
     * http://stackoverflow.com/questions/19701708/how-to-prevent-ios-safari-alert-when-trying-to-open-non-installed-native-app
     */
    openApp: function (deepLink) {
        $('<iframe />')
            .attr('src', deepLink)
            .attr('style', 'display:none;')
            .appendTo('body');
    },

    /**
     * If dibs-app param is true or false, overwrites the regular logic for redirecting to the app.
     * true -> redirects to the app.
     * false -> does not redirect to the app.
     * @returns {boolean} - true if the method should override the regular logic for redirecting to the app
     */
    forcedRedirect: function (updatedUrl) {
        var appParam;
        var deepLink;
        updatedUrl = updatedUrl || url;
        appParam = updatedUrl.queryKey['dibs-app'];

        if (appParam === 'true') {
            deepLink = this.createDeepLink();
            this.openApp(deepLink);
        }

        return (appParam === 'true' || appParam === 'false');
    },

    forwardFromEmail: function () {
        var updatedUrl = url;
        var deepLink;

        if (wasLoginRedirected()) {
            updatedUrl = uriHelper.parseUri(url.protocol + "://" + url.host + decodeURIComponent(url.queryKey.ep));
        }

        if (!this.forcedRedirect(updatedUrl) && mobileCheck.iPhone() && referrerHelpers.isEmailReferrer(updatedUrl.queryKey) && this.pageSupported(updatedUrl.path)) {
            deepLink = this.createDeepLink(updatedUrl);
            this.openApp(deepLink);
        }
    }
};


/***/ }),
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(4163);
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: liliana
 * Date: 11/10/14
 * Time: 3:53 PM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */



// ---------------------------------------------------
// Load Super Class
var SoaCollection = __webpack_require__(9);

// ---------------------------------------------------
// Module Definition

/**
 * @class Attributes
 * @extends SoaCollection
 */
var Attributes = module.exports = SoaCollection.extend();

// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);
var SV = __webpack_require__(18);
var Attribute = __webpack_require__(2645);
var ItemAttributes = __webpack_require__(1015);

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(Attributes.prototype, {
    model : Attribute,

    /**
     * Recursively flattens entire data via lookup key
     * @param {Attributes} attributeCollection
     * @param {string} [key='child']
     * @returns {Attribute[]}
     */
    flatten: function (attributeCollection, key) {
        var self = this;
        var list = [];
        attributeCollection = attributeCollection || this;
        key = key || 'child';

        if (attributeCollection.length) {

            attributeCollection.each(function (attribute) {
                attribute = attribute.clone();
                var children = attribute.get(key) || [];
                var i;

                // adds item to list with 'key' property omitted
                if (children.length) {
                    attribute.unset(key);
                }

                list.push(attribute);

                list = list.concat(self.flatten(children, key));
            });
        }
        return list;
    },

    /**
     * Goes down specified number of levels before flattening all child nodes
     * @param {number} level
     * @param {Attributes} [attributeCollection=this]
     * @param {string} [key='child']
     * @returns {Attribute[]}
     */
    flattenAtLevel: function (level, attributeCollection, key) {
        var i;
        var children;
        var list = [];

        if (arguments.length === 2) {
            if (typeof attributeCollection === 'string') {
                key = attributeCollection;
            }
        }

        attributeCollection = attributeCollection instanceof Attributes ? attributeCollection : this;
        key = key || 'child';

        level--;

        if (level < 0) {
            // I don't think this should ever happen...
            console.warn('Level is < 0. Failing gracefully by returning whatever is in data.');
            return attributeCollection;
        }

        for (i = 0; i < attributeCollection.length; i++) {
            children = attributeCollection.at(i).get(key) || [];

            if (level === 0) {

                attributeCollection.at(i).unset(key);
                list.push(attributeCollection.at(i));

                if (children.length) {
                    list = list.concat(this.flatten(children, key));
                }
            } else {
                if (children.length) {
                    attributeCollection.at(i).set(key, this.flattenAtLevel(level, children, key));
                }
            }
        }
        return list.length ? list : attributeCollection.models;
    },

    toItemAttributes: function(omitChild) {
        var attributesArr = [];
        this.each(function (attribute) {
            attributesArr.push(attribute.toItemAttribute(omitChild));
        });
        return attributesArr;
    },

    getItemAttributesCollection: function (options) {
        var attributesArr = [];
        options = options || {};

        _.each(this.flatten(), function (attribute) {
            attributesArr.push(attribute.toItemAttribute(true));
        });

        return new ItemAttributes(attributesArr, options);
    }
});

// ---------------------------------------------------
// Define Module Static Properties

_.extend(Attributes, {
    _attributesByKey: {},

    getCollectionForKey: function (key) {
        if (!Attributes._attributesByKey[key]) {
            Attributes._attributesByKey[key] = new Attributes(SV.get('attributes.'+key));
        }
        return Attributes._attributesByKey[key];
    }
});

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 1stdibs
 * User: James
 * Date: 1/25/13
 */


var SoaCollection = __webpack_require__(9);
var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var ItemCreator = __webpack_require__(1466);
var ItemCreators = module.exports = SoaCollection.extend();

_.extend(ItemCreators.prototype, {
    model: ItemCreator,
    item_id: null,
    url : endpoints.creatorList(),
    parse: function (data) {
        if (data && data.result && data.result.creatorList) {
            return data.result.creatorList;
        }
        return ItemCreators.__super__.parse.call(this, data);
    },
    initialize : function () {
        this.item_id = this.item_id || (this.options && this.options.item_id) ? this.options.item_id : null;
    },
    /**
     * Replaces native fetch. Simply just adds the item id to the url before
     * it calls and returns the native backbone fetch.
     * @param options
     * @return {*}
     */
    fetch : function (options) {
        options = options || {};
        var iid = options.item_id || this.item_id;

        this.url = this.url + '/' + iid;
        return this.constructor.__super__.fetch.call(this, options);
    }
});

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var Backbone = __webpack_require__(3);
var DocumentList;
var relayDocuments = function (method) {
    return function () {
        var docs = this.get('documents');
        return docs[method].apply(docs, arguments);
    };
};
/**
 * Generic model to represent a list and its metadata.
 *
 * Example:
 * {
 *    apiType: 'documentList',
 *    metadata: { x: 1, y: 2 },
 *    documents: [ model, model, model ]
 * }
 *
 * Uses: To use this in a relation, you have to specify the model to be used in the
 * documents attribute of the document list.  So if your documents is an array of
 * users, you would do the following:
 *
 * UserDocumentList = DocumentList.extend({
 *    model: User
 * });
 *
 * ...
 * relations: [
 *    {
 *       key: 'users',
 *       relatedModel: UserDocumentList
 *    }
 * ]
 *
 */
DocumentList = SoaModel.extend({
    model: SoaModel,
    relations: [
        {
            key: 'documents',
            relatedModel: function () {
                return this.model;
            },
            type: Backbone.Many
        },
        {
            key: 'metadata',
            relatedModel: SoaModel,
            type: Backbone.One
        }
    ],
    getAllMetadata: function () {
        return this.get('metadata');
    },
    getMetadata: function (field) {
        return this.get('metadata.' + field);
    },
    add: relayDocuments('add'),
    where: relayDocuments('where'),
    remove: relayDocuments('remove'),
    some: relayDocuments('some'),
    filter: relayDocuments('filter'),
    size: relayDocuments('size'),
    at: relayDocuments('at'),
    each: relayDocuments('each'),
    find: relayDocuments('find'),
    findWhere: relayDocuments('findWhere'),
    first: relayDocuments('first'),
    map: relayDocuments('map'),
    contains: relayDocuments('contains'),
    any: function () {
        return this.size() > 0;
    }
});

module.exports = DocumentList;


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var SoaModel = __webpack_require__(2);
var endpoints = __webpack_require__(6);
var Newsletter = SoaModel.extend();

var root = typeof window === 'undefined' ? global : window;
var bunsen = root.bunsen = root.bunsen || {};

var _ = __webpack_require__(0);

module.exports = bunsen.Newsletter = Newsletter;

    _.extend(Newsletter.prototype, {
    url: function () {
        // TODO: find a better way to get the user ID
        return endpoints.userNewsletters(this.parents[0].id);
    }
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// autoformats field labels, transform / compute display values, and parses values for transformed / computed fields
// Usage: extend your model (or it's prototype) with SoaModelLabelAndValueTransformer and then use it as the model
// for your rows any module that makes use of getLabelDisplayVal, getFieldDisplayVal, and / or parseFieldDisplayVal,
// e.g. ProfileViews.Profile in admin-v2


var _ = __webpack_require__(0);
var $ = __webpack_require__(5);
var bunsenLibs = __webpack_require__(21);
module.exports = {
    displayLabels: {},
    displayTransforms: {},
    defaultNeedsNoEscape: {
        email: true
    },
    defaultDisplayTransforms: {
        email: function (email) {
            return '<a href=\"mailto:' + _.escape(email) + '\">' + _.escape(email) + '</a>';
        },
        phoneNumber: bunsenLibs.formatPhoneNumber,
        fullName: function (name) {
            if (name) {
                return name;
            }
            name = _.filter([this.get('firstName'), this.get('lastName')], _.identity);
            if (_.isEmpty(name)) {
                return undefined;
            }
            return name.join(' ');
        }
    },
    defaultFieldParsers: {
        fullName: function (fullName) {
            if (fullName) {
                return fullName;
            }
            // todo: where does val come from? what is this supposed to do?
            fullName = $.trim(val).match(/^(((.+?)\s(.+\s)?(.+?))|(.*))$/i); // eslint-disable-line
            return {
                firstName: fullName[3],
                lastName: fullName[5] || fullName[6]
            };
        }
    },
    schemas: {},
    getSchema: function (fieldName) {
        var schema = this.schemas[fieldName];
        if (schema) {
            return schema;
        }
        return {type: 'Text'};
    },
    getLabelDisplayVal: function (label) {
        var displayLabel = this.displayLabels[label];
        if (!displayLabel) {
            return bunsenLibs.camel2spaceCase(label, true);
        }
        if ("function" === typeof displayLabel) {
            return displayLabel.call(this, label);
        }
        return displayLabel;
    },
    fieldNeedsEscaping: function (field) {
        if (this.needsNoEscape && this.needsNoEscape.hasOwnProperty(field)) {
            return !this.needsNoEscape[field];
        }
        if (this.defaultNeedsNoEscape && this.defaultNeedsNoEscape.hasOwnProperty(field)) {
            return !this.defaultNeedsNoEscape[field];
        }
        return true;
    },
    getFieldDisplayVal: function (field) {
        var val = this.get(field);
        var transform = this.displayTransforms[field] || this.defaultDisplayTransforms[field];
        if (transform) {
            return transform.call(this, val);
        }
        return val;
    },
    parseFieldDisplayVal: function (field, value) {
        var parser = this.fieldParsers[field] || this.defaultFieldParsers[field];
        if (parser) {
            return parser.call(this, value);
        }
        return _.object([field], [value]);
    }
};


/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 12/19/13
 * Time: 12:11 PM
 */



var SoaModel = __webpack_require__(2);
var Role = module.exports = SoaModel.extend();

var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var Permissions = __webpack_require__(2039);
var Permission = __webpack_require__(940);
var Backbone = __webpack_require__(3);

_.extend(Role.prototype, {
    /**
     *
     * @returns {string}
     */
    url: function () {
        return endpoints.role(this.get(this.idAttribute));
    },
    relations: [
        {
            type: Backbone.Many,
            key: 'permissions',
            collectionType: Permissions,
            omitFromSave: true
        },
        {
            type: Backbone.One,
            key: 'assignPermission',
            relatedModel: Permission.extend({
                // The default permission for assigning roles
                defaults: {
                    name: 'ASSIGN_ROLES'
                }
            })
        }
    ],
    initialize: function () {
        _.bindAll(this, 'removeRoleFromUser', 'saveRoleForUser');
    },

    _setUserRoleUrl: function () {
        var oldUrl = this.url;
        var id = this.collection.parents[0].id;

        this.url = endpoints.user(id) + '/role/' + this.get('name');

        return oldUrl;
    },
    removeRoleFromUser: function (options) {
        var oldUrl = this._setUserRoleUrl();
        var xhr;

        // collection parent MUST be the user!
        xhr = this.destroy(options);
        this.url = oldUrl;

        return xhr;
    },
    saveRoleForUser: function (passedOptions) {
        var oldUrl = this._setUserRoleUrl();
        var options = passedOptions || {};
        var xhr;

        //pick these keys of attributes and send them to service on save (some instance of Role may not have one or more of these keys)
        var payloadAttrs = ['id', 'userStatus'];
        options.attrs = _.pick(this.toJSON(), payloadAttrs);

        // collection parent MUST be the user!
        xhr = this.save(null, options);
        this.url = oldUrl;

        return xhr;
    },
    removeRoleFromPermission: function (permissionId, passedOptions) {
        var options = passedOptions || {};
        var url = endpoints.permissionsByRole(this.get('id'), permissionId);

        // Sync here instead of destroy because event's shouldn't be triggered
        return this.sync('delete', this, _.defaults(options, {
            url: url
        }));
    },
    addRoleToPermission: function (permissionId, passedOptions) {
        var options = passedOptions || {};
        var url = endpoints.permissionsByRole(this.get('id'), permissionId);

        return this.sync('create', this, _.defaults(options, {
            url: url
        }));
    }
});


/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by don on 9/15/15.
 */


var SoaModel = __webpack_require__(2);
var PublicationAttribute;

PublicationAttribute = SoaModel.extend({

}, {
    MERCHANDISE_PENDING_AUTH: 'MERCHANDISE_PENDING_AUTH',
    MERCHANDISE_PUBLISHED_AUTH: 'MERCHANDISE_PUBLISHED_AUTH',
    CATEGORY : 'CATEGORY',
    DISPLAY_PROMOTE_DEMOTE: 'DISPLAY_PROMOTE_DEMOTE'
});

module.exports = PublicationAttribute;


/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by james on 6/11/14.
 */



// ---------------------------------------------------
// Require Super PseudoClass

var SoaModel = __webpack_require__(2);

// ---------------------------------------------------
// Define Module

/**
 * @class Region
 * @extends SoaModel
 */
var Region = module.exports = SoaModel.extend();

// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(Region.prototype, /** @lends Region.prototype */{
    /**
     * True if the region code is the 'World' code
     * @returns {boolean}
     */
    isWorldRegion: function () {
        return Region.regionCodeIsWorld(this.get('code'));
    }
});

// ---------------------------------------------------
// Define Module Static Properties

/**
 * @enum {string} regionType
 * The possible types of regions you can have
 */
var regionType =
    /**
     * @lends Region
     * @lends regionType
     */
    {
        /**
         * Static Shipment Quote region type (for regions that are always available to sellers
         * @memberOf Region
         * @type regionType
         */
        TYPE_STATIC: 'SHIPMENT_QUOTE_STATIC',
        /**
         * Local shipment quote region type. For regions based on seller's store geo
         * @memberOf Region
         * @type regionType
         */
        TYPE_LOCAL: 'LOCAL'
    };

_.extend(Region, /** @lends Region */{
    WORLD_REGION_CODE: 'REST_OF_WORLD',
    US_REGION_CODE: 'CONTINENTAL_US',
    regionCodeIsWorld: function (code) {
        return code === Region.WORLD_REGION_CODE;
    }
}, regionType);

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assign = __webpack_require__(2655);
var constats = __webpack_require__(1220);
var currencies = constats.currencies;
var currencySymbols = constats.symbols;
var abbreviations = constats.abbreviations;

/**
 * A more forgiving parseFloat
 * This is useful when consuming user-input
 * @param {number|string} number Either a formatted string (3,000) or integer (3000)
 * @returns {Number}
 */
exports.parseFloat = function dibsParsFloat(number) {
    return parseFloat(String(number).replace(/[^\d\.e-]/ig, '')) || 0;
};

/**
 * Round to the given precision
 * @param {number|string} number @see Number.parseFloat#number
 * @param {number} digits
 * @returns {number}
 */
exports.round = function round(number, digits) {
    var powed = Math.pow(10, digits);
    return Math.round(exports.parseFloat(number) * powed) / powed;
};

/**
 * Similar to PHP's number_format
 * @param number
 * @param {number} significantDigits The decimal place to round and fix a number to, Defaults to 0
 * @param {String} thousandsSeparator Defaults to ,
 * @param {String} decimalMark Defaults to .
 */
exports.format = function format(number, significantDigits, thousandsSeparator, decimalMark) {
    var suffix = '';
    var isNegative = number < 0;
    var bits;
    var i;

    if (isNegative) {
        number = number * -1;
    }

    significantDigits = significantDigits > -1 ? significantDigits : 0;
    thousandsSeparator = thousandsSeparator === undefined ? ',' : thousandsSeparator;
    decimalMark = decimalMark === undefined ? '.' : decimalMark;
    number = exports.round(number, significantDigits).toFixed(significantDigits);
    if (thousandsSeparator && number.match(/^\d{4}/)) {
        if (significantDigits) {
            suffix = number.substr(number.indexOf('.'));
            number = number.split('.')[0];
        }
        bits = number.split('');
        i = bits.length - 3;
        while (i > 0) {
            bits.splice(i, 0, thousandsSeparator);
            i -= 3;
        }
        number = bits.concat(suffix).join('');
    }
    if (decimalMark !== '.' && significantDigits) {
        number = number.replace(/\.(\d+)$/, decimalMark + '$1');
    }

    if (isNegative) {
        number = '-' + number;
    }

    return number;
};

/**
 *
 * @param {number} number The number to format
 * @param {object} [options] Formatting options
 * @param {boolean} [options.showDecimal] Show a decimal or not. Defaults to true
 * @param {string} [options.thousandsSeparator] What separates the thousands? Defaults to comma ","
 * @param {string} [options.decimalMark] What separates decimals? Defaults to period "."
 * @param {string} [options.abbreviation] Wheter to include an abbreviation or not
 * @param {boolean} [options.includeCurrencySymbol] Wheter to include a currency symbol or not
 * @param {string} [options.currencySymbol] Which currency symbol to use. Defaults to USD "$"
 * @returns {object}
 */
exports.localizedCashFormatObj = function (number, options) {
    options = assign({
        includeCurrencySymbol: true
    }, options);
    var decimalsToShow = options.showDecimal === false ?  0 : 2;
    var thousandsSeparator = options.thousandsSeparator || ',';
    var decimalMark = options.decimalMark || '.';
    var currencySymbol = options.currencySymbol || '$';
    var abbreviation = options.abbreviation || '';
    var sign = '';

    number = exports.format(number, decimalsToShow, thousandsSeparator, decimalMark);
    currencySymbol = options.includeCurrencySymbol ? currencySymbol : '';

    // if it's negative we need to put the negative sign in front
    if (number.indexOf('-') !== -1) {
        sign = '-';
        number = number.replace('-', '');
    }

    return {
        sign: sign,
        currencySymbol: currencySymbol,
        number: number,
        abbreviation: abbreviation
    };
};

/**
 *
 * @param {number} number The number to format
 * @param {object} [options] Formatting options
 * @param {boolean} [options.showDecimal] Show a decimal or not. Defaults to true
 * @param {string} [options.thousandsSeparator] What separates the thousands? Defaults to comma ","
 * @param {string} [options.decimalMark] What separates decimals? Defaults to period "."
 * @param {string} [options.abbreviation] Wheter to include an abbreviation or not
 * @param {boolean} [options.includeCurrencySymbol] Wheter to include a currency symbol or not
 * @param {string} [options.currencySymbol] Which currency symbol to use. Defaults to USD "$"
 * @returns {string}
 */
exports.localizedCashFormat = function (number, options) {
    var localizedObject = exports.localizedCashFormatObj(number, options);
    var localizedNumber = localizedObject.number;
    var currencySymbol = localizedObject.currencySymbol;
    var abbreviation = localizedObject.abbreviation;
    var sign = localizedObject.sign;

    // if it's negative we need to put the negative sign in front
    if (sign) {
        sign = sign + ' ';
    }

    if (abbreviation.length) {
        abbreviation = ' ' + abbreviation;
    }

    return sign + currencySymbol + localizedNumber + abbreviation;
};

/**
 * Converts a string containing numbers to an integer
 * @param  {string} amount
 * @return {number}
 */
exports.currencyToInteger = function (amount) {
    // Match all numbers and - sign
    var regexp = /-?[0-9]*/g;
    if (typeof amount === 'number') {
        return amount;
    } else if (typeof amount === 'string') {
        return parseInt(amount.match(regexp).join(''), 10);
    } else {
        return NaN;
    }
};

/**
 * Used internaly for intelligentFormat
 * @param  {number} The number to format
 * @param  {string}
 * @param  {object} passedOptions
 * @return {object}
 */
exports.getFormatOptions = function (amount, currency, passedOptions) {
    var options;
    var num = exports.parseFloat(amount);
    var currencyUppercase = (currency + '').toUpperCase();
    options = {
        // Only if there are decimals do we show them
        showDecimal : Math.ceil(num) !== Math.floor(num),
        thousandsSeparator : ',',
        decimalMark : '.',
        currencySymbol : currencySymbols.USD,
        abbreviation: abbreviations[currencyUppercase]
    };

    switch (currencyUppercase) {
        case currencies.CURRENCY_GBP:
        case currencySymbols.GBP:
            options.currencySymbol = currencySymbols.GBP;
            break;
        case currencies.CURRENCY_CHF:
        case currencySymbols.CHF:
            options.includeCurrencySymbol = false;
            break;
        case currencies.CURRENCY_EUR:
        case currencySymbols.EUR:
            options.thousandsSeparator = '.';
            options.decimalMark = ',';
            options.currencySymbol = currencySymbols.EUR;
            break;
    }

    return assign(options, passedOptions);
};


/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx      = __webpack_require__(1428)
  , IObject  = __webpack_require__(4216)
  , toObject = __webpack_require__(829)
  , toLength = __webpack_require__(2311)
  , asc      = __webpack_require__(2679);
module.exports = function(TYPE, $create){
  var IS_MAP        = TYPE == 1
    , IS_FILTER     = TYPE == 2
    , IS_SOME       = TYPE == 3
    , IS_EVERY      = TYPE == 4
    , IS_FIND_INDEX = TYPE == 6
    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
    , create        = $create || asc;
  return function($this, callbackfn, that){
    var O      = toObject($this)
      , self   = IObject(O)
      , f      = ctx(callbackfn, that, 3)
      , length = toLength(self.length)
      , index  = 0
      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
      , val, res;
    for(;length > index; index++)if(NO_HOLES || index in self){
      val = self[index];
      res = f(val, index, O);
      if(TYPE){
        if(IS_MAP)result[index] = res;            // map
        else if(res)switch(TYPE){
          case 3: return true;                    // some
          case 5: return val;                     // find
          case 6: return index;                   // findIndex
          case 2: result.push(val);               // filter
        } else if(IS_EVERY)return false;          // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var currencies = __webpack_require__(2079);
var constants = {
    currencies: {},
    symbols: {
        GBP: '£',
        EUR: '€',
        USD: '$',
        CAD: '$',
        AUD: '$',
        CHF: '', // Swiss francs don't have a currency symbol
        MXN: '$'
    },
    abbreviations: {
        CAD: 'CAD',
        AUD: 'AUD',
        MXN: 'MXN',
        CHF: 'CHF'
    }
};

currencies.forEach(function (currency) {
    constants.currencies['CURRENCY_' + currency] = currency;
});

module.exports = constants;


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(1472);

/*
 * @param  {number} amount - The number to format.
 * @param  {string} currency - Accepts any currency from currencies file
 * @param  {object} passedOptions - Additional options for localizedCashFormat
 * @return {string} - Formatted price string
 */
module.exports = function intelligentFormat(amount, currency, passedOptions) {
    var options = util.getFormatOptions(amount, currency, passedOptions);
    return util.localizedCashFormat(amount, options);
};


/***/ }),
/* 1641 */,
/* 1642 */,
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = pdpDisplayHelper;

var _item = __webpack_require__(1243);

var itemSelectors = _interopRequireWildcard(_item);

var _buyerDisplayHelper = __webpack_require__(1241);

var _buyerDisplayHelper2 = _interopRequireDefault(_buyerDisplayHelper);

var _getPricingData2 = __webpack_require__(1242);

var _getPricingData3 = _interopRequireDefault(_getPricingData2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function pdpDisplayHelper(_ref) {
    var buyerId = _ref.buyerId,
        _ref$buyerHasTradePer = _ref.buyerHasTradePermission,
        buyerHasTradePermission = _ref$buyerHasTradePer === undefined ? false : _ref$buyerHasTradePer,
        item = _ref.item;

    if (!item) {
        throw new Error('Item is required');
    }

    var itemIsFurniture = itemSelectors.isFurniture(item);
    var itemIsSold = itemSelectors.isSold(item);
    var salePrice = itemSelectors.getSalePrice(item);
    var retailPrice = itemSelectors.getRetailPrice(item);
    var netPrice = itemSelectors.getNetPrice(item);

    var _getPricingData = (0, _getPricingData3.default)({
        salePrice: salePrice,
        netPrice: netPrice,
        retailPrice: retailPrice
    }),
        pricingShowSale = _getPricingData.pricingShowSale,
        pricingNegotiableRetail = _getPricingData.pricingNegotiableRetail,
        pricingNegotiableSale = _getPricingData.pricingNegotiableSale,
        pricingData = _objectWithoutProperties(_getPricingData, ['pricingShowSale', 'pricingNegotiableRetail', 'pricingNegotiableSale']);

    var displays = (0, _buyerDisplayHelper2.default)(_extends({
        buyerHasTradePermission: buyerHasTradePermission,
        buyerOwnsActiveHold: itemSelectors.isActiveHoldByBuyerId(item)(buyerId),

        itemIsFurniture: itemIsFurniture,
        itemIsOnHold: itemSelectors.isOnHold(item),
        itemIsSold: itemIsSold,

        pricingShowSale: pricingShowSale,
        pricingNegotiableRetail: pricingNegotiableRetail,
        pricingNegotiableSale: pricingNegotiableSale
    }, pricingData));

    return {
        getShowCTAs: function getShowCTAs() {
            var ctaDisplays = displays.getShowCTAs();

            if (itemIsSold) {
                return { showFollowing: true };
            } else if (pricingShowSale && !pricingNegotiableSale) {
                return _extends({}, ctaDisplays, { showMakeOfferCTA: false });
            }

            return ctaDisplays;
        },
        getShowPrices: function getShowPrices() {
            var priceDisplays = displays.getShowPrices();

            if (priceDisplays.showOnHold) {
                var pricingHideRetail = pricingData.pricingHideRetail,
                    pricingValidNet = pricingData.pricingValidNet;

                var netTradeable = buyerHasTradePermission && itemIsFurniture;

                var showRetailPrice = !pricingHideRetail && !itemIsSold;
                var showNetPrice = netTradeable && pricingValidNet && !itemIsSold;

                Object.assign(priceDisplays, {
                    showNetPrice: showNetPrice,
                    showRetailPrice: showRetailPrice,
                    showSalePrice: itemIsSold,
                    showListPriceLabel: netTradeable && showRetailPrice,
                    showPriceUponRequest: !showNetPrice && !showRetailPrice && !itemIsSold
                });
            }

            if (priceDisplays.showSold) {
                return { showSold: true };
            } else if (priceDisplays.showSalePrice) {
                var saleDisplay = _extends({}, priceDisplays, { showRetailPrice: true, showReducedFrom: true });
                return buyerHasTradePermission ? _extends({}, saleDisplay, { showListPriceLabel: true }) : saleDisplay;
            }

            return priceDisplays;
        }
    };
}

/***/ }),
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _calloutHelper = __webpack_require__(498);

var _calloutHelper2 = _interopRequireDefault(_calloutHelper);

var _calloutActions = __webpack_require__(503);

var _calloutActions2 = _interopRequireDefault(_calloutActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var favoritesCalloutsRules = function rearrangeItemsCalloutRule(_ref) {
    var context = _ref.context,
        type = _ref.type;

    var canShowCallout = _calloutHelper2.default.canShowCallout({ type: type });

    if (canShowCallout) {
        context.executeAction(_calloutActions2.default.openCallout, { type: type });
        return Promise.resolve({ success: true, type: type });
    }

    return Promise.resolve();
};

var editFolderRule = function editFolderRule(_ref2) {
    var context = _ref2.context;

    return favoritesCalloutsRules({ context: context, type: _calloutHelper2.default.CALLOUT_TYPE_EDIT_FOLDER });
};

var rearrangeItemsRule = function rearrangeItemsRule(_ref3) {
    var context = _ref3.context;

    return favoritesCalloutsRules({ context: context, type: _calloutHelper2.default.CALLOUT_TYPE_REARRANGE_ITEMS });
};

var selectItemsRule = function selectItemsRule(_ref4) {
    var context = _ref4.context;

    return favoritesCalloutsRules({ context: context, type: _calloutHelper2.default.CALLOUT_TYPE_SELECT_ITEMS });
};

exports.default = {
    editFolderRule: editFolderRule,
    rearrangeItemsRule: rearrangeItemsRule,
    selectItemsRule: selectItemsRule
};

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SV = __webpack_require__(18);

var _require = __webpack_require__(282),
    localStorage = _require.localStorage,
    sessionStorage = _require.sessionStorage;

var mobileCheck = __webpack_require__(283);
var User = __webpack_require__(15);
var enabler = __webpack_require__(63);

var tourActions = __webpack_require__(758);

var _require2 = __webpack_require__(568),
    TRADE_TOUR = _require2.type.TRADE_TOUR;

var checkUserForTradeBuyer = function checkTradeBuyer() {
    return Promise.resolve(User.load()).then(function () {
        var isVerifiedTradeBuyer = User.getCurrentUser().isVerifiedTradeBuyer();
        var canRequestNetPrice = User.canRequestNetPrice();

        return isVerifiedTradeBuyer && canRequestNetPrice;
    });
};

var tradeTourRule = function tradeTourRule(_ref) {
    var context = _ref.context;

    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: TRADE_TOUR, limit: 3 },
        type = _ref2.type,
        limit = _ref2.limit;

    var session = sessionStorage.getItem(type);
    var storage = localStorage.getItem(type) || 0;
    var isTradeTourDisabled = !enabler.isEnabled('trade_tour');
    var isTradeMessageDisabled = !enabler.isEnabled('trade_welcome_message');
    // A bit hackish way to check the status, but don't want to load item store/model and bloat out the foot.js bundle
    var isNotAvailablePdp = SV.get('rawResult.pricing.purchasable') !== 'Y';
    var isMobile = mobileCheck.any();

    if (isMobile || isNotAvailablePdp || session || storage >= limit || isTradeTourDisabled || isTradeMessageDisabled) {
        return Promise.resolve();
    }

    if (User.loggedIn()) {
        return checkUserForTradeBuyer().then(function (isTradeBuyer) {
            if (isTradeBuyer) {
                context.executeAction(tourActions.setSession, { type: type });
                context.executeAction(tourActions.increaseSession, { type: type });
                context.executeAction(tourActions.openTour, { type: type });
            }

            return { success: isTradeBuyer, type: type };
        });
    } else {
        return Promise.resolve();
    }
};

module.exports = tradeTourRule;

/***/ }),
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaCollection = __webpack_require__(9);
var AuthorizedRole = __webpack_require__(2207);
var User = __webpack_require__(28);
var AuthorizedRoles = void 0;

/**
 * An authorized roles collection has 1 method to tell you if your user meets the rquirement from all of the authorized
 * role models conteined therein.
 * @type {Function}
 */
AuthorizedRoles = SoaCollection.extend({

    model: AuthorizedRole,

    /**
     * Returns true if any of the authorized roles matching this user type are not for the user.
     * IE. Tests whether the user is authorized to do {whatever} according to this list of authorized roles.
     * Logic to differentiate user roles from seller roles contained in AuthorizedRole model.
     * @param userOrSeller
     * @returns {boolean}
     */
    isUserPermitted: function isUserPermitted(userOrSeller) {
        return this.any(function (role) {
            return role.isPermitted(userOrSeller);
        });
    }
});

module.exports = AuthorizedRoles;

/***/ }),
/* 1889 */,
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @class NotesDocumentList
 * @extends DocumentList
 * a document list for notes retrieved for items, listings, etc.
 */

var DocumentList = __webpack_require__(1620);
var NotesDocumentList = module.exports = DocumentList.extend();
var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var Note = __webpack_require__(33);
var User = __webpack_require__(28);
var Party = __webpack_require__(8);
var Clump = __webpack_require__(23);

Object.assign(NotesDocumentList, {
    /**
     * Create a new Note instance
     * @param {object} [options]
     * @param {string} [options.role=INTERNAL]
     * @param {string} [options.type=ADMIN]
     * @param {string} [options.level=INFO]
     * @param {string|number} [options.creatorId] Defaults to current user id
     * @param {string} [options.content] Defaults to empty string
     * @param {anchors} [options.anchors] Defaults to empty array
     * @returns {Note}
     */
    newNote: function newNote(options) {
        if (!options.user instanceof User) {
            throw "options.user must be instance of bunsen/models/identity/User";
        }
        var defaultUser = options.user;
        options = _.defaults(options || {}, {
            role: Party.ROLE_INTERNAL,
            type: Note.TYPE_ADMIN,
            level: 'INFO',
            creatorId: defaultUser.id,
            creatorProfile: defaultUser.get('profile'),
            content: '',
            service: endpoints.latest.identity
        });
        return new Note({
            type: options.type,
            content: options.content,
            level: options.level,
            anchors: options.anchors,
            createdBy: {
                role: options.role,
                id: options.creatorId,
                profile: options.creatorProfile ? options.creatorProfile.toJSON() : {}
            }
        }, {
            service: options.service
        });
    }
});

Object.assign(NotesDocumentList.prototype, {
    model: function model(attrs) {
        return new Note(attrs, { service: this.service });
    },


    url: function url() {
        return endpoints.notes(this.service);
    },

    initialize: function initialize() {
        var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { metadata: {}, documents: [] };
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        this.service = options.service || endpoints.latest.inventory;
        return NotesDocumentList.__super__.initialize.call(this, options);
    },


    /**
     * Fetch all ITEM_IMAGING and DEALER_IMAGING notes
     * based on item id
     * @param itemId
     * @param options
     * @returns promise
     */
    fetchItemNotes: function fetchItemNotes(itemId, sellerId, options) {
        options = options || {};
        options.clump = options.clump || new Clump();
        this._fetchImagingNotes(itemId, options);
        this._fetchDealerNotes(sellerId, options);
        return options.clump;
    },
    _fetchDealerNotes: function _fetchDealerNotes(dealerId, options) {
        options = options || {};
        var fetchOptions = {
            data: Object.assign({
                anchorSourceType: 'SELLER',
                anchorIds: dealerId,
                noteTypes: Note.TYPE_DEALER_IMAGING,
                fields: 'PARTY_PROFILE'
            }, options && options.data),
            remove: false
        };

        return this.fetch(Object.assign({}, options, fetchOptions));
    },
    _fetchImagingNotes: function _fetchImagingNotes(itemId, options) {
        options = options || {};
        var fetchOptions = {
            data: Object.assign({
                anchorSourceType: 'ITEM',
                anchorIds: itemId,
                noteTypes: Note.TYPE_ITEM_IMAGING,
                fields: 'PARTY_PROFILE'
            }, options && options.data),
            remove: false
        };

        return this.fetch(Object.assign({}, options, fetchOptions));
    },
    fetchRejectionNotes: function fetchRejectionNotes(itemId, options) {
        options = options || {};
        var fetchOptions = {
            data: Object.assign({
                anchorSourceType: 'ITEM',
                anchorIds: itemId,
                noteTypes: Note.TYPE_EXPERT_REVIEW_REJECTION,
                fields: 'PARTY_PROFILE'
            }, options && options.data),
            remove: false
        };

        return this.fetch(Object.assign({}, options, fetchOptions));
    },


    /**
     * Find a note by id
     * @param noteId
     * @returns Note
     */
    findById: function findById(noteId) {
        return this.findWhere({ id: noteId });
    },


    /**
     * Helper function for creating new notes on the document list.
     * Calls existing static method for not creation.
     * @param passedOptions
     * @returns Note
     */
    newNote: function newNote(passedOptions) {
        passedOptions.service = passedOptions.service || this.service;
        return NotesDocumentList.newNote(passedOptions);
    },

    /**
     * Create a new note, and add it to the document list on this model.
     * @param noteOptions
     * @param syncOptions
     * @returns deferred from saving note to server
     */
    addNewNote: function addNewNote(noteOptions, syncOptions) {
        var note = this.newNote(noteOptions);
        this.add(note);
        return note.save(null, syncOptions);
    }
});

/***/ }),
/* 1891 */,
/* 1892 */,
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var Permission = __webpack_require__(940);
var ends = __webpack_require__(6);
var PublicationGroup = __webpack_require__(3845);
var PublicationType = void 0;
var TYPES = ['FEATURED_FURNITURE', 'FEATURED_JEWELRY', 'FEATURED_FASHION', 'FEATURED_ART', 'MARKETPLACE_FURNITURE', 'MARKETPLACE_JEWELRY', 'MARKETPLACE_FASHION', 'MARKETPLACE_ART', 'DEALER_STOREFRONT_FURNITURE', 'DEALER_STOREFRONT_JEWELRY', 'DEALER_STOREFRONT_FASHION', 'DEALER_STOREFRONT_ART', 'SATURDAY_SALE'];

/**
 * Publication type is a complex object describing the type and group a publication belongs to.
 * For example, a publication that is feature in furniture would be type FEATURED_FURNITURE, and the type group would
 * be FEATURED
 * @type {Function}
 */
PublicationType = SoaModel.extend({
    relations: [{
        type: Backbone.One,
        key: 'group',
        relatedModel: PublicationGroup
    }],

    url: function url() {
        return ends.publicationType(this.get('id'));
    },
    getName: function getName() {
        return this.get('name');
    },
    isStorefront: function isStorefront() {
        return this.get('group').isStorefront();
    },
    isMarketplace: function isMarketplace() {
        return this.get('group').isMarketplace();
    },
    isFeatured: function isFeatured() {
        return this.get('group').isFeatured();
    },
    isSale: function isSale() {
        return this.get('group').isSale();
    }
});

TYPES.forEach(function (type) {
    PublicationType[type] = type;
});

// permission needed to create a publication of the specified type
PublicationType.createPermissions = {
    FEATURED_FURNITURE: Permission.PERMISSION_PUB_CREATE,
    FEATURED_JEWELRY: Permission.PERMISSION_PUB_CREATE,
    FEATURED_FASHION: Permission.PERMISSION_PUB_CREATE,
    FEATURED_ART: Permission.PERMISSION_PUB_CREATE,
    MARKETPLACE_FURNITURE: Permission.PERMISSION_PUB_CREATE,
    MARKETPLACE_JEWELRY: Permission.PERMISSION_PUB_CREATE,
    MARKETPLACE_FASHION: Permission.PERMISSION_PUB_CREATE,
    MARKETPLACE_ART: Permission.PERMISSION_PUB_CREATE,
    SATURDAY_SALE: Permission.PERMISSION_PUB_CREATE_SAT_SALE
};

PublicationType.getCombinedName = function (type, vertical) {
    type = type.toUpperCase();

    // sale pubs are for all verticals, so type is just SATURDAY_SALE
    if (type === 'SALE') {
        return PublicationType.SATURDAY_SALE;
    }

    vertical = vertical.toUpperCase();
    return PublicationType[type + '_' + vertical];
};

module.exports = PublicationType;

/***/ }),
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
 * without support for callback shorthands and `this` binding, which iterates
 * over `collection` using the provided `eachFunc`.
 *
 * @private
 * @param {Array|Object|string} collection The collection to search.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @param {boolean} [retKey] Specify returning the key of the found element
 *  instead of the element itself.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */
function baseFind(collection, predicate, eachFunc, retKey) {
  var result;
  eachFunc(collection, function(value, key, collection) {
    if (predicate(value, key, collection)) {
      result = retKey ? key : value;
      return false;
    }
  });
  return result;
}

module.exports = baseFind;


/***/ }),
/* 1905 */
/***/ (function(module, exports) {

/**
 * lodash 3.6.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for callback shorthands and `this` binding.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {Function} predicate The function invoked per iteration.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromRight) {
  var length = array.length,
      index = fromRight ? length : -1;

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 4.1.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var Stack = __webpack_require__(2238),
    keys = __webpack_require__(3935),
    root = __webpack_require__(281);

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns). */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dateTag] = typedArrayTags[errorTag] =
typedArrayTags[funcTag] = typedArrayTags[mapTag] =
typedArrayTags[numberTag] = typedArrayTags[objectTag] =
typedArrayTags[regexpTag] = typedArrayTags[setTag] =
typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check, else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to an array.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the converted array.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Converts `set` to an array.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the converted array.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototypeOf = Object.getPrototypeOf;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Used to detect maps, sets, and weakmaps. */
var mapCtorString = Map ? funcToString.call(Map) : '',
    setCtorString = Set ? funcToString.call(Set) : '',
    weakMapCtorString = WeakMap ? funcToString.call(WeakMap) : '';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = Symbol ? symbolProto.valueOf : undefined;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
  // that are composed entirely of index properties, return `false` for
  // `hasOwnProperty` checks of them.
  return hasOwnProperty.call(object, key) ||
    (typeof object == 'object' && key in object && getPrototypeOf(object) === null);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual` for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    if (objTag == argsTag) {
      objTag = objectTag;
    } else if (objTag != objectTag) {
      objIsArr = isTypedArray(object);
    }
  }
  if (!othIsArr) {
    othTag = getTag(other);
    if (othTag == argsTag) {
      othTag = objectTag;
    } else if (othTag != objectTag) {
      othIsArr = isTypedArray(other);
    }
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !(objIsArr || objIsObj)) {
    return equalByTag(object, other, objTag, equalFunc, customizer, bitmask);
  }
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
  if (!isPartial) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual` for more details.
 * @param {Object} [stack] Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var index = -1,
      isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      isUnordered = bitmask & UNORDERED_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked) {
    return stacked == other;
  }
  var result = true;
  stack.set(array, other);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (isUnordered) {
      if (!arraySome(other, function(othValue) {
            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack);
          })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual` for more details.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask) {
  switch (tag) {
    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
      return +object == +other;

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case numberTag:
      // Treat `NaN` vs. `NaN` as equal.
      return (object != +object) ? other != +other : object == +other;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings primitives and string
      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      // Recursively compare objects (susceptible to call stack limits).
      return (isPartial || object.size == other.size) &&
        equalFunc(convert(object), convert(other), customizer, bitmask | UNORDERED_COMPARE_FLAG);

    case symbolTag:
      return !!Symbol && (symbolValueOf.call(object) == symbolValueOf.call(other));
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual` for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : baseHas(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function getTag(value) {
  return objectToString.call(value);
}

// Fallback for IE 11 providing `toStringTag` values for maps, sets, and weakmaps.
if ((Map && getTag(new Map) != mapTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : null,
        ctorString = typeof Ctor == 'function' ? funcToString.call(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case mapCtorString: return mapTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array constructors, and
  // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(funcToString.call(value));
  }
  return isObjectLike(value) &&
    (isHostObject(value) ? reIsNative : reIsHostCtor).test(value);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
function isTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

module.exports = baseIsEqual;


/***/ }),
/* 1907 */,
/* 1908 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.9 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if the provided arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
      ? (isArrayLike(object) && isIndex(index, object.length))
      : (type == 'string' && index in object)) {
    var other = object[index];
    return value === value ? (value === other) : (other !== other);
  }
  return false;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isIterateeCall;


/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var isNative = __webpack_require__(1383),
    noop = __webpack_require__(2241);

/** Used as the property descriptor for `__bindData__` */
var descriptor = {
  'configurable': false,
  'enumerable': false,
  'value': null,
  'writable': false
};

/** Used to set meta data on functions */
var defineProperty = (function() {
  // IE 8 only accepts DOM elements
  try {
    var o = {},
        func = isNative(func = Object.defineProperty) && func,
        result = func(o, o, o) && func;
  } catch(e) { }
  return result;
}());

/**
 * Sets `this` binding data on a given function.
 *
 * @private
 * @param {Function} func The function to set data on.
 * @param {Array} value The data array to set.
 */
var setBindData = !defineProperty ? noop : function(func, value) {
  descriptor.value = value;
  defineProperty(func, '__bindData__', descriptor);
};

module.exports = setBindData;


/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {/**
 * lodash 4.1.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to determine if values are of the language type `Object`. */
var objectTypes = {
  'function': true,
  'object': true
};

/** Detect free variable `exports`. */
var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
  ? exports
  : undefined;

/** Detect free variable `module`. */
var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
  ? module
  : undefined;

/** Detect free variable `global` from Node.js. */
var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);

/** Detect free variable `self`. */
var freeSelf = checkGlobal(objectTypes[typeof self] && self);

/** Detect free variable `window`. */
var freeWindow = checkGlobal(objectTypes[typeof window] && window);

/** Detect `this` as the global object. */
var thisGlobal = checkGlobal(objectTypes[typeof this] && this);

/**
 * Used as a reference to the global object.
 *
 * The `this` value is used if it's the global object to avoid Greasemonkey's
 * restricted `window` object, otherwise the `window` object is used.
 */
var root = freeGlobal ||
  ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
    freeSelf || thisGlobal || Function('return this')();

/**
 * Checks if `value` is a global object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
 */
function checkGlobal(value) {
  return (value && value.Object === Object) ? value : null;
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @returns {Object} Returns the new hash object.
 */
function Hash() {}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(hash, key) {
  return hashHas(hash, key) && delete hash[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @param {Object} hash The hash to query.
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(hash, key) {
  if (nativeCreate) {
    var result = hash[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(hash, key) ? hash[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @param {Object} hash The hash to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(hash, key) {
  return nativeCreate ? hash[key] !== undefined : hasOwnProperty.call(hash, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 */
function hashSet(hash, key, value) {
  hash[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
}

// Avoid inheriting from `Object.prototype` when possible.
Hash.prototype = nativeCreate ? nativeCreate(null) : objectProto;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function MapCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.clear();
  while (++index < length) {
    var entry = values[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': Map ? new Map : [],
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapDelete(key) {
  var data = this.__data__;
  if (isKeyable(key)) {
    return hashDelete(typeof key == 'string' ? data.string : data.hash, key);
  }
  return Map ? data.map['delete'](key) : assocDelete(data.map, key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapGet(key) {
  var data = this.__data__;
  if (isKeyable(key)) {
    return hashGet(typeof key == 'string' ? data.string : data.hash, key);
  }
  return Map ? data.map.get(key) : assocGet(data.map, key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapHas(key) {
  var data = this.__data__;
  if (isKeyable(key)) {
    return hashHas(typeof key == 'string' ? data.string : data.hash, key);
  }
  return Map ? data.map.has(key) : assocHas(data.map, key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapSet(key, value) {
  var data = this.__data__;
  if (isKeyable(key)) {
    hashSet(typeof key == 'string' ? data.string : data.hash, key, value);
  } else if (Map) {
    data.map.set(key, value);
  } else {
    assocSet(data.map, key, value);
  }
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapClear;
MapCache.prototype['delete'] = mapDelete;
MapCache.prototype.get = mapGet;
MapCache.prototype.has = mapHas;
MapCache.prototype.set = mapSet;

/**
 *
 * Creates a set cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.push(values[index]);
  }
}

/**
 * Adds `value` to the set cache.
 *
 * @private
 * @name push
 * @memberOf SetCache
 * @param {*} value The value to cache.
 */
function cachePush(value) {
  var map = this.__data__;
  if (isKeyable(value)) {
    var data = map.__data__,
        hash = typeof value == 'string' ? data.string : data.hash;

    hash[value] = HASH_UNDEFINED;
  }
  else {
    map.set(value, HASH_UNDEFINED);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.push = cachePush;

/**
 * Removes `key` and its value from the associative array.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function assocDelete(array, key) {
  var index = assocIndexOf(array, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = array.length - 1;
  if (index == lastIndex) {
    array.pop();
  } else {
    splice.call(array, index, 1);
  }
  return true;
}

/**
 * Gets the associative array value for `key`.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function assocGet(array, key) {
  var index = assocIndexOf(array, key);
  return index < 0 ? undefined : array[index][1];
}

/**
 * Checks if an associative array value for `key` exists.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function assocHas(array, key) {
  return assocIndexOf(array, key) > -1;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * Sets the associative array `key` to `value`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 */
function assocSet(array, key, value) {
  var index = assocIndexOf(array, key);
  if (index < 0) {
    array.push([key, value]);
  } else {
    array[index][1] = value;
  }
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'number' || type == 'boolean' ||
    (type == 'string' && value != '__proto__') || value == null;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'user': 'fred' };
 * var other = { 'user': 'fred' };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (!isObject(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = SetCache;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module), __webpack_require__(4)))

/***/ }),
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule generateConcreteFragmentID
 * 
 */



var base62 = __webpack_require__(2119);

// Static ids always end with `:<HASH>` where HASH is an alphanumeric transform
// of an auto-incrementing index. A double-colon is used to distinguish between
// client ids and static ids that happen to hash to `:client`.
var SUFFIX = '::client';

var _nextFragmentID = 0;

/**
 * The "concrete fragment id" uniquely identifies a Relay.QL`fragment ...`
 * within the source code of an application and will remain the same across
 * runs of a particular version of an application.
 *
 * This function can be used to generate a unique id for fragments constructed
 * at runtime and is guaranteed not to conflict with statically created ids.
 */
function generateConcreteFragmentID() {
  return base62(_nextFragmentID++) + SUFFIX;
}

module.exports = generateConcreteFragmentID;

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
};

exports.default = isClassComponent;

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* global window */


module.exports = __webpack_require__(4135)(global || window || this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = (0, _createHelper2.default)(setStatic, 'setStatic', false);

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _createEagerFactory = __webpack_require__(667);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    return function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      _class.prototype.render = function render() {
        return factory(this.props);
      };

      return _class;
    }(_react.Component);
  };
};

exports.default = (0, _createHelper2.default)(shouldUpdate, 'shouldUpdate');

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var omit = function omit(obj, keys) {
  var rest = _objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

exports.default = omit;

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

exports.default = pick;

/***/ }),
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(10);

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(130);

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(238);

/***/ }),
/* 1965 */,
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(331);

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(333);

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(334);

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(335);

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(336);

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(337);

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(338);

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(339);

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(340);

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(381);

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(41);

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(58);

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(59);

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(65);

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * UMD'ed by Augusto Corvalan 4/30/2014
 * dependencies:
 * dibs.defaultCookieSettings
 * dibs.tracking
 * dibs.user
 * $.publish
 * $.subscribe
 */


var root = global;
var $ = __webpack_require__(5);
var moment = __webpack_require__(30);
var tracking = __webpack_require__(27);
var md5 = __webpack_require__(2700);
var uri = __webpack_require__(137);
var get = __webpack_require__(14);
var User = __webpack_require__(15);
var userDetails = __webpack_require__(2177);
var chatUtils = __webpack_require__(271);

var sessionTracking = module.exports = {};
var timesFired = 0;

var TRADE_PROMO_DATE_FROM = get(uri, 'URL.queryKey.tradePromoDate') || '2017-01-16';
var MS_30_DAYS = 2592000000;

/*
 Threshold being used instead of pub/sub since order of custom vars being fired
 varies.

 Currently, the custom vars being fired are:
 1. @see navCreatedListener

 firedThreshold will equal the number of custom vars being pushed.
 */
var firedThreshold = 1;
var _dibs;
var shouldTrackUserId;
var shouldTrackGuestId;
var eventNames;
var getUserId;
var getGuestId;

__webpack_require__(677);

eventNames = {
    setSessionCustomVar: 'ga:setSessionCustomVar',
    navCreated: 'nav:created',
    userCustomVarCreated: 'ga:userCustomVarCreated'
};

getUserId = function () {
    var emailToken = User.getEmailToken();

    if (User.loggedIn()) {
        return User.getUserId();
    } else if (emailToken) {
        return emailToken.substr(0, emailToken.indexOf('_'));
    }

    return undefined;
};

/**
 * helper function that returns the guest id if it is set in a cookie it returns
 * the existing guest id and if it is not, a new guest id is set and then returned
 */
getGuestId = function () {
    var guestId = User.getGuestId();
    if (!guestId) {
        User.setNewGuestId();
        guestId = User.getGuestId();
    }
    return guestId;
};

/*
 * Set one of three login/registration states
 */
sessionTracking.getLoginStatus = function () {
    var label;
    if (User.loggedIn()) {
        label = 'Registered and Logged In';
    } else {
        label = User.everLoggedIn() ? 'Registered and Logged Out' : 'Not Registered';
    }
    return label;
};

/**
 * FINDING-3669 thin wrapper around user load, for readability
 * @returns {Promise}
 */
sessionTracking.loadUserProfile = function () {
    return User.load();
};

/**
 * Retrieves currency preference from user profile.
 * Note: Should be called after loadUserProfile to ensure user has been loaded
 * @returns {string}
 */
sessionTracking.getUserCurrency = function () {
    var currency;
    var profile;

    if (User.loggedIn()) {
        if (User.getCurrency()) {
            //accessing through getUserProfile is temporary meant only to work in environments that don't support commonJS
            currency = User.getCurrency();
        } else {
            profile = User.getUserProfile();

            if (profile && profile.get('currency')) {
                currency = profile.get('currency');
            }
        }

        if (currency) {
            //currency is PND in the codebase, needs to be GBP for tracking
            return currency.replace(/PND/, 'GBP') + ' Selected';
        }
    }
    return currency;
};

shouldTrackUserId = function (userId) {
    var customVarName = tracking.getCustomVar(1) ? tracking.getCustomVar(1).name : '';
    return userId && customVarName === 'Guest Id';
};

shouldTrackGuestId = function (guestId) {
    return guestId && !User.everLoggedIn() && !tracking.getCustomVar(1);
};

sessionTracking.onNavCreated = function onNavCreated() {
    var guestId = User.getGuestId();
    var userId = User.getUserId();
    var trackUserId = shouldTrackUserId(userId);
    var trackGuestId = shouldTrackGuestId(guestId);
    var trackObj;

    //TODO JF when masquerading, which user should be tracked here?
    /*
        Analytics may refer to this tracking as:
            - "visitor tracking" not to be confused with visitor.tracking.js...
            - or "custom variable 1"
        name: "UserId", value: userId
        - User is registered and logged in OR logged out (userId is in an __utm cookie)
        name: "GuestId", value, guestId
        - User is not registered and logged out
     */
    if (trackUserId || trackGuestId) {
        trackObj = {
            slot: 1,
            name: (userId ? 'User' : 'Guest') + ' Id',
            value: userId ? userId : guestId,
            scope: 1
        };

        tracking = tracking || _dibs.tracking;
        tracking.setCustomVar(trackObj);
        if (trackUserId) {
            $.publish(eventNames.userCustomVarCreated);
        }
    }
};

/**
 * returns the buyerStatus (whether or not the user has any orders)
 */
sessionTracking.getTransactionsStatus = function getTransactionsStatus() {
    var deferred = $.Deferred();

    userDetails.fetchTransactionsStatus().then(function (response) {
        deferred.resolve(response || {});
    }, function () {
        deferred.resolve({});
    });

    return deferred.promise();
};

/**
 * grabs the first session date from the set cookie and returns the first session date
 * in the form Month_Year (i.e. December_2013)
 * @return string|undefined
 */
sessionTracking.getFirstSessionDate = function getFirstSessionDate() {
    var sessions = $.cookie('__utma');
    var firstSession;
    if (sessions) {
        sessions = sessions.split('.');
        firstSession = parseInt(sessions[2], 10) * 1000;
        return moment(firstSession).format('MMMM_YYYY');
    }
    return undefined;
};

function inLast30Days(date) {
    return new Date(date).getTime() > (new Date().getTime() - MS_30_DAYS);
}

function getGaTradeStatus(payload) {
    var tradeStatus = payload.tradeStatus;
    var buyerStatusKey = payload.transactionsStatus.buyerStatusKey;
    var isVerifiedTradeBuyer = User.getCurrentUser().isVerifiedTradeBuyer();
    var userId = User.getUserId();
    var tradeTestGroup = '';

    // check buyer status
    var noneConfirmed = ['SUBMITTED', 'INITIATED', 'NONE'].indexOf(buyerStatusKey) > -1;

    // if trade is created later than date and has no confirmed orders
    if (isVerifiedTradeBuyer && tradeStatus.date && moment(tradeStatus.date) > moment(TRADE_PROMO_DATE_FROM) && noneConfirmed) {
        var secontToLastIdNumber = Number.parseInt(userId.slice(-2, -1));
        // userId ends with 4 or 5
        if ([4, 5].indexOf(secontToLastIdNumber) > -1) {
            tradeTestGroup = '|onboarding promo: control';
        } else {
            tradeTestGroup = '|onboarding promo: variant';
        }
    } else {
        var verifiedInLast30Days = inLast30Days(tradeStatus.verifiedDate) ? 'y' : 'n';
        tradeTestGroup = '|verified_in_last_30_days=' + verifiedInLast30Days;
    }

    return tradeStatus.status && tradeStatus.status + tradeTestGroup;
}

sessionTracking.trackUserAttributes = function () {
    var isLoggedIn = User.loggedIn();
    var userEmail = User.getEmail(true);

    return $.when(sessionTracking.getTransactionsStatus(), User.handleEmailToken())
        .always(function (transactionsStatus) {
            var tradeStatus = userDetails.getTradeStatus();
            tracking.addUserAttributes({
                'loginStatus': isLoggedIn ? 'Logged In' : 'Logged Out',
                'registrationStatus': User.everLoggedIn() ? 'Registered' : 'Not Registered',
                'userID': getUserId(),
                'guestID': isLoggedIn ? undefined : getGuestId(),
                'userEmail': userEmail ? md5(userEmail).toString() : undefined,
                'userEmailAddress': isLoggedIn ? userEmail : undefined,
                'emailToken': User.getEmailToken(),
                'userZip': User.getZipCode(),
                'defaultCurrency': sessionTracking.getUserCurrency() || 'USD Default',
                'firstSessionDate': sessionTracking.getFirstSessionDate(),
                'contactDealerStatus': transactionsStatus.contactDealerStatus,
                'buyerStatus': transactionsStatus.buyerStatus,
                'firstPurchasePrice': transactionsStatus.firstPurchasePrice || 'na',
                'firstPurchaseDate': transactionsStatus.firstPurchaseDate || 'na',
                'tradeStatus': getGaTradeStatus({tradeStatus: tradeStatus, transactionsStatus: transactionsStatus}),
                'customerType': isLoggedIn ? User.getCustomerType() : User.everLoggedIn() ? undefined : 'Unknown'
            });

            chatUtils.customAttribute.transactionsStatus(transactionsStatus);
            chatUtils.customAttribute.tradeStatus(tradeStatus.status);
            if (User.getCurrentUser().isVerifiedTradeBuyer()) {
                chatUtils.customAttribute.verifiedTradeDate(tradeStatus.date);
            }
        });
};

sessionTracking.init = function sessionTrackingInit() {
    if (!root.jasmine) {
        $.subscribe(eventNames.setSessionCustomVar, function () {

            $.publish('ga:blockPageview');
            sessionTracking.loadUserProfile().always(function () {
                var trackObj = {
                    slot: 3,
                    name: sessionTracking.getLoginStatus(),
                    value: sessionTracking.getUserCurrency() || 'USD Default',
                    scope: 2
                };

                tracking = tracking || _dibs.tracking;
                tracking.setCustomVar(trackObj);
                $.publish('ga:unblockPageview');

                // Tracking Session for Google Tag Manager
                sessionTracking.trackUserAttributes();
            });

            //TRANACT-2538 if we're setting up tracking on guest Id, we can set the custom var immediately
            //rather than waiting for user info to load
            if (shouldTrackGuestId(User.getGuestId())) {
                $.publish(eventNames.navCreated);
            }
        });
    }

    /**
     * @name navCreatedListener
     */
    $.subscribe(eventNames.navCreated, function () {
        sessionTracking.onNavCreated();
    });

    $.subscribe(eventNames.userCustomVarCreated, function () {
        timesFired += 1;
        tracking = tracking || _dibs.tracking;
        if (timesFired >= firedThreshold) {
            tracking.fireDummyEvent();
        }
    });
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 9/11/14
 * Time: 4:21 PM
 */



var _ = __webpack_require__(0);
var $ = __webpack_require__(5);

var poster = module.exports = {
    _submit: function ($form) { // for easy testing
        // Firefox requires the element to be
        // in the DOM to submit it
        $form.attr('style', 'display:none');
        $('body').append($form);
        $form.submit();
    },
    setUpForm: function (url, data) {
        var $form = $('<form method="post"></form>');
        $form.attr('action', url);
        _.each(data, function (value, name) {
            var $input = $('<input>');
            $input.attr('name', name);
            $input.val(value);
            $form.append($input);
        });

        return $form;
    },
    /**
     * Posts the entire page to another url
     * @param url
     * @param data - object to convert to post data
     */
    post: function (url, data) {
        var $form = poster.setUpForm(url, data);
        poster._submit($form);
    },
    postToIframe: function (url, data) {
        var target = _.uniqueId('postToIframe');
        var $form = poster.setUpForm(url, data);
        var $iframe = $('<iframe>');
        var dfd = new $.Deferred();

        $form.attr({ target: target, style: 'display:none' });
        $iframe.attr({ name: target, style: 'display:none' });
        $('body').append($form);
        $('body').append($iframe);
        $iframe.on('load', function() {
            var response = $iframe.contents().find('body').html();
            $form.remove();
            $iframe.remove();
            dfd.resolve(response);
        });
        $form.submit();
        return dfd.promise();
    }

};


/***/ }),
/* 1982 */,
/* 1983 */
/***/ (function(module, exports) {

/**
 * @preserve Copyright 2013, Cardinal Path and DigitalInc.
 *
 * GAS - Google Analytics on Steroids
 * https://github.com/CardinalPath/gas
 *
 * @author Eduardo Cereto <eduardocereto@gmail.com>
 * Licensed under the GPLv3 license.
 *
 */

// Modified 2013-07-30 by Michael Harrison
// Added non-interaction flags to event tracking and added dc.js reference

(function (e, t) {
    if (!e) {
        // not in the client aka window
        return;
    }
    var global = e;
    try {
        if (Object.prototype.toString.call(global.process) === '[object process]') {
            return;
        }
    } catch(e) {}

    function p() {
        var e = this;
        e.version = "1.9", e._accounts = {}, e._accounts_length = 0, e._queue = r, e._default_tracker = "_gas1", e.gh = {}, e._hooks = {
            _addHook: [e._addHook]
        }, e.push(function () {
            e.gh = new n
        })
    }

    function d(e) {
        return e === _gas._default_tracker ? "" : e + "."
    }

    function v(t) {
        if (_gas.debug_mode) try {
            console.log(t)
        } catch (n) {}
        return e._gaq.push(t)
    }

    function m(e, t) {
        if (typeof e != "string") return !1;
        var n = e.split("?")[0];
        return n = n.split("."), n = n[n.length - 1], n && this.inArray(t, n) ? n : !1
    }

    function y(e) {
        while (e && e.nodeName !== "HTML") {
            if (e.nodeName === "FORM") break;
            e = e.parentNode
        }
        return e.nodeName === "FORM" ? e.name || e.id || "none" : "none"
    }

    function w(e) {
        _gas.push(["_trackEvent", this.tagName, e.type, this.currentSrc])
    }

    function N() {
        return e.innerHeight || h.clientHeight || i.body.clientHeight || 0
    }

    function C() {
        return e.pageYOffset || i.body.scrollTop || h.scrollTop || 0
    }

    function k() {
        return Math.max(i.body.scrollHeight || 0, h.scrollHeight || 0, i.body.offsetHeight || 0, h.offsetHeight || 0, i.body.clientHeight || 0, h.clientHeight || 0)
    }

    function L() {
        return (C() + N()) / k() * 100
    }

    function M(e) {
        A && clearTimeout(A);
        if (e === !0) {
            O = Math.max(L(), O);
            return
        }
        A = setTimeout(function () {
            O = Math.max(L(), O)
        }, 400)
    }

    function _() {
        M(!0), O = Math.floor(O);
        if (O <= 0 || O > 100) return;
        var e = (O > 10 ? 1 : 0) * (Math.floor((O - 1) / 10) * 10 + 1);
        e = String(e) + "-" + String(Math.ceil(O / 10) * 10), _gas.push(["_trackEvent", D.category, c, e, Math.floor(O), !0])
    }

    function P(t) {
        if ( !! this._maxScrollTracked) return;
        this._maxScrollTracked = !0, D = t || {}, D.category = D.category || "Max Scroll", this._addEventListener(e, "scroll", M), this._addEventListener(e, "beforeunload", _)
    }

    function j(e) {
        if (!this._multidomainTracked) {
            this._multidomainTracked = !0;
            var t = i.location.hostname,
                n = this,
                r, s, o, u = i.getElementsByTagName("a");
            e !== "now" && e !== "mousedown" && (e = "click");
            for (r = 0; r < u.length; r++) {
                o = u[r];
                if (l.call(o.href, "http") === 0) {
                    if (o.hostname == t || l.call(o.hostname, B) >= 0) continue;
                    for (s = 0; s < H.length; s++) l.call(o.hostname, H[s]) >= 0 && (e === "now" ? o.href = n.tracker._getLinkerUrl(o.href, _gas._allowAnchor) : e === "click" ? this._addEventListener(o, e, function (e) {
                        return _gas.push(["_link", this.href, _gas._allowAnchor]), e.preventDefault ? e.preventDefault() : e.returnValue = !1, !1
                    }) : this._addEventListener(o, e, function () {
                        this.href = n.tracker._getLinkerUrl(this.href, _gas._allowAnchor)
                    }))
                }
            }
            return !1
        }
        return
    }

    function z(e) {
        R[e.player_id] || (R[e.player_id] = {}, R[e.player_id].timeTriggers = a.call(q));
        if (R[e.player_id].timeTriggers.length > 0 && e.data.percent * 100 >= R[e.player_id].timeTriggers[0]) {
            var t = R[e.player_id].timeTriggers.shift();
            _gas.push(["_trackEvent", "Vimeo Video", t + "%", U[e.player_id], 0, true])
        }
    }

    function W(e, t, n) {
        if (!n.contentWindow || !n.contentWindow.postMessage || !JSON) return !1;
        var r = n.getAttribute("src").split("?")[0],
            i = JSON.stringify({
                method: e,
                value: t
            });
        return n.contentWindow.postMessage(i, r), !0
    }

    function $(e) {
        if (l.call(e.origin, "//player.vimeo.com") > -1) {
            var t = JSON.parse(e.data);
            t.event === "ready" ? J.call(_gas.gh) : t.method ? t.method == "getVideoUrl" && (U[t.player_id] = t.value) : t.event === "playProgress" ? z(t) : _gas.push(["_trackEvent", V.category, t.event, U[t.player_id], 0, true])
        }
    }

    function J() {
        var t = i.getElementsByTagName("iframe"),
            n = 0,
            r, s, o, u = V.force,
            a = V.percentages;
        for (var f = 0; f < t.length; f++)
            if (l.call(t[f].src, "//player.vimeo.com") > -1) {
                r = "gas_vimeo_" + f, s = t[f].src, o = "?", l.call(s, "?") > -1 && (o = "&");
                if (l.call(s, "api=1") < 0) {
                    if (!u) continue;
                    s += o + "api=1&player_id=" + r
                } else l.call(s, "player_id=") < -1 && (s += o + "player_id=" + r);
                n++, t[f].id = r;
                if (t[f].src !== s) {
                    t[f].src = s;
                    break
                }
                W("getVideoUrl", "", t[f]), W("addEventListener", "play", t[f]), W("addEventListener", "pause", t[f]), W("addEventListener", "finish", t[f]), a && (q = a, W("addEventListener", "playProgress", t[f]))
            }
        n > 0 && X === !1 && (this._addEventListener(e, "message", $, !1), X = !0)
    }

    function Z(e) {
        if (Q && Q.length) {
            var t = e.getVideoData().video_id;
            Y[t] ? tt(e) : (Y[t] = {}, Y[t].timeTriggers = a.call(Q)), Y[t].timer = setTimeout(et, 1e3, e, t)
        }
    }

    function et(e, n) {
        if (Y[n] == t || Y[n].timeTriggers.length <= 0) return !1;
        var r = e.getCurrentTime() / e.getDuration() * 100;
        if (r >= Y[n].timeTriggers[0]) {
            var i = Y[n].timeTriggers.shift();
            _gas.push(["_trackEvent", G.category, i + "%", e.getVideoUrl(), 0, true])
        }
        Y[n].timer = setTimeout(et, 1e3, e, n)
    }

    function tt(e) {
        var t = e.getVideoData().video_id;
        Y[t] && Y[t].timer && (et(e, t), clearTimeout(Y[t].timer))
    }

    function nt(e) {
        var t = "";
        switch (e.data) {
            case 0:
                t = "finish", tt(e.target);
                break;
            case 1:
                t = "play", Z(e.target);
                break;
            case 2:
                t = "pause", tt(e.target)
        }
        t && _gas.push(["_trackEvent", G.category, t, e.target.getVideoUrl(), 0, true])
    }

    function rt(e) {
        _gas.push(["_trackEvent", G.category, "error (" + e.data + ")", e.target.getVideoUrl(), true])
    }

    function it() {
        var e = i.getElementsByTagName("object"),
            t, n, r, s = /(https?:\/\/www\.youtube(-nocookie)?\.com[^/]*).*\/v\/([^&?]+)/;
        for (var o = 0; o < e.length; o++) {
            t = e[o].getElementsByTagName("param");
            for (var u = 0; u < t.length; u++)
                if (t[u].name == "movie" && t[u].value) {
                    r = t[u].value.match(s), r && r[1] && r[3] && (n = i.createElement("iframe"), n.src = r[1] + "/embed/" + r[3] + "?enablejsapi=1", n.width = e[o].width, n.height = e[o].height, n.setAttribute("frameBorder", "0"), n.setAttribute("allowfullscreen", ""), e[o].parentNode.insertBefore(n, e[o]), e[o].parentNode.removeChild(e[o]), o--);
                    break
                }
        }
    }

    function st(t) {
        var n = t.force,
            r = t.percentages;
        if (n) try {
            it()
        } catch (s) {
            _gas.push(["_trackException", s, "GAS Error on youtube.js:_ytMigrateObjectEmbed"])
        }
        var o = [],
            u = i.getElementsByTagName("iframe");
        for (var a = 0; a < u.length; a++)
            if (l.call(u[a].src, "//www.youtube.com/embed") > -1) {
                if (l.call(u[a].src, "enablejsapi=1") < 0) {
                    if (!n) continue;
                    l.call(u[a].src, "?") < 0 ? u[a].src += "?enablejsapi=1" : u[a].src += "&enablejsapi=1"
                }
                o.push(u[a])
            }
        if (o.length > 0) {
            r && r.length && (Q = r), e.onYouTubePlayerAPIReady = function () {
                var t;
                for (var n = 0; n < o.length; n++) t = new e.YT.Player(o[n]), t.addEventListener("onStateChange", nt), t.addEventListener("onError", rt)
            };
            var f = i.createElement("script"),
                c = "http:";
            i.location.protocol === "https:" && (c = "https:"), f.src = c + "//www.youtube.com/player_api", f.type = "text/javascript", f.async = !0;
            var h = i.getElementsByTagName("script")[0];
            h.parentNode.insertBefore(f, h)
        }
    }
    var n = function () {
        this._setDummyTracker()
    };
    n.prototype._setDummyTracker = function () {
        if (!this.tracker) {
            var t = e._gat._getTrackers();
            t.length > 0 && (this.tracker = t[0])
        }
    }, n.prototype.inArray = function (e, t) {
        if (e && e.length)
            for (var n = 0; n < e.length; n++)
                if (e[n] === t) return !0;
        return !1
    }, n.prototype._sanitizeString = function (e, t) {
        return e = e.toLowerCase().replace(/^\ +/, "").replace(/\ +$/, "").replace(/\s+/g, "_").replace(/[\u00e1\u00e0\u00e2\u00e3\u00e5\u00e4\u00e6\u00aa]/g, "a").replace(/[\u00e9\u00e8\u00ea\u00eb\u0404\u20ac]/g, "e").replace(/[\u00ed\u00ec\u00ee\u00ef]/g, "i").replace(/[\u00f3\u00f2\u00f4\u00f5\u00f6\u00f8\u00ba]/g, "o").replace(/[\u00fa\u00f9\u00fb\u00fc]/g, "u").replace(/[\u00e7\u00a2\u00a9]/g, "c"), t && (e = e.replace(/[^a-z0-9_-]/g, "_")), e.replace(/_+/g, "_")
    }, n.prototype._addEventListener = function (t, n, r, i) {
        var s = function (n) {
            if (!n || !n.target) n = e.event, n.target = n.srcElement;
            return r.call(t, n)
        };
        return t.addEventListener ? (t.addEventListener(n, s, !! i), !0) : t.attachEvent ? t.attachEvent("on" + n, s) : (n = "on" + n, typeof t[n] == "function" && (s = function (e, t) {
            return function () {
                e.apply(this, arguments), t.apply(this, arguments)
            }
        }(t[n], s)), t[n] = s, !0)
    }, n.prototype._liveEvent = function (e, t, n) {
        var r = this;
        e = e.toUpperCase(), e = e.split(","), r._addEventListener(i, t, function (t) {
            for (var i = t.target; i.nodeName !== "HTML"; i = i.parentNode)
                if (r.inArray(e, i.nodeName) || i.parentNode === null) break;
            i && r.inArray(e, i.nodeName) && n.call(i, t)
        }, !0)
    }, n.prototype._DOMReady = function (t) {
        function r() {
            if (r.done) return;
            r.done = !0, t.apply(n, arguments)
        }
        var n = this;
        if (/^(interactive|complete)/.test(i.readyState)) return r();
        this._addEventListener(i, "DOMContentLoaded", r, !1), this._addEventListener(e, "load", r, !1)
    }, e._gaq = e._gaq || [];
    var r = e._gas || [];
    if (r._accounts_length >= 0) return;
    var i = e.document,
        s = Object.prototype.toString,
        o = Object.prototype.hasOwnProperty,
        u = Array.prototype.push,
        a = Array.prototype.slice,
        f = String.prototype.trim,
        l = String.prototype.indexOf,
        c = i.location.href,
        h = i.documentElement;
    p.prototype._addHook = function (e, t) {
        return typeof e == "string" && typeof t == "function" && (typeof _gas._hooks[e] == "undefined" && (_gas._hooks[e] = []), _gas._hooks[e].push(t)), !1
    }, p.prototype._execute = function () {
        var e = a.call(arguments),
            n = this,
            r = e.shift(),
            i = !0,
            s, u, f, c, h, p = 0;
        if (typeof r == "function") return v(function (e, t) {
            return function () {
                e.call(t)
            }
        }(r, n.gh));
        if (typeof r == "object" && r.length > 0) {
            u = r.shift(), l.call(u, ".") >= 0 ? (c = u.split(".")[0], u = u.split(".")[1]) : c = t, f = n._hooks[u];
            if (f && f.length > 0)
                for (s = 0; s < f.length; s++) try {
                    h = f[s].apply(n.gh, r), h === !1 ? i = !1 : h && h.length > 0 && (r = h)
                } catch (m) {
                    u !== "_trackException" && n.push(["_trackException", m])
                }
            if (i === !1) return 1;
            if (u === "_setAccount") {
                for (s in n._accounts)
                    if (n._accounts[s] == r[0] && c === t) return 1;
                return c = c || "_gas" + String(n._accounts_length + 1), typeof n._accounts["_gas1"] == "undefined" && l.call(c, "_gas") != -1 && (c = "_gas1"), n._accounts[c] = r[0], n._accounts_length += 1, c = d(c), p = v([c + u, r[0]]), n.gh._setDummyTracker(), p
            }
            if (u === "_link" || u === "_linkByPost" || u === "_require" || u === "_anonymizeIp") return g = d(c) + u, e = a.call(r), e.unshift(g), v(e);
            var g;
            if (c && n._accounts[c]) return g = d(c) + u, e = a.call(r), e.unshift(g), v(e);
            if (n._accounts_length > 0) {
                for (s in n._accounts) o.call(n._accounts, s) && (g = d(s) + u, e = a.call(r), e.unshift(g), p += v(e));
                return p ? 1 : 0
            }
            return e = a.call(r), e.unshift(u), v(e)
        }
    }, p.prototype.push = function () {
        var t = this,
            n = a.call(arguments);
        for (var r = 0; r < n.length; r++)(function (t, n) {
            e._gaq.push(function () {
                n._execute.call(n, t)
            })
        })(n[r], t)
    }, e._gas = _gas = new p, _gas.push(["_addHook", "_trackException",
        function (e, t) {
            return _gas.push(["_trackEvent", "Exception " + (e.name || "Error"), t || e.message || e, c, 0, true]), !1
        }
    ]), _gas.push(["_addHook", "_setDebug",
        function (e) {
            _gas.debug_mode = !! e
        }
    ]), _gas.push(["_addHook", "_popHook",
        function (e) {
            var t = _gas._hooks[e];
            return t && t.pop && t.pop(), !1
        }
    ]), _gas.push(["_addHook", "_gasSetDefaultTracker",
        function (e) {
            return _gas._default_tracker = e, !1
        }
    ]), _gas.push(["_addHook", "_trackPageview",
        function () {
            var e = a.call(arguments);
            return e.length >= 2 && typeof e[0] == "string" && typeof e[1] == "string" ? [{
                page: e[0],
                title: e[1]
            }] : e
        }
    ]);
    var g = function (e) {
        var t = this;
        if (!t._downloadTracked) {
            t._downloadTracked = !0, e ? typeof e == "string" ? e = {
                extensions: e.split(",")
            } : e.length >= 1 && (e = {
                extensions: e
            }) : e = {
                extensions: []
            }, e.category = e.category || "Download";
            var n = "xls,xlsx,doc,docx,ppt,pptx,pdf,txt,zip";
            return n += ",rar,7z,exe,wma,mov,avi,wmv,mp3,csv,tsv", n = n.split(","), e.extensions = e.extensions.concat(n), t._liveEvent("a", "mousedown", function (n) {
                var r = this;
                if (r.href) {
                    var i = m.call(t, r.href, e.extensions);
                    i && _gas.push(["_trackEvent", e.category, i, r.href])
                }
            }), !1
        }
        return
    };
    _gas.push(["_addHook", "_trackDownloads", g]), _gas.push(["_addHook", "_trackEvent",
        function () {
            var e = a.call(arguments);
            return e[3] && (e[3] = (e[3] < 0 ? 0 : Math.round(e[3])) || 0), e
        }
    ]);
    var b = function (e) {
        if ( !! this._formTracked) return;
        this._formTracked = !0;
        var t = this;
        typeof e != "object" && (e = {}), e.category = e.category || "Form Tracking";
        var n = function (t) {
            var n = t.target,
                r = n.name || n.id || n.type || n.nodeName,
                i = y(n),
                s = "form (" + i + ")",
                o = r + " (" + t.type + ")";
            _gas.push(["_trackEvent", e.category, s, o, 0, true])
        };
        t._DOMReady(function () {
            var e = ["input", "select", "textarea", "hidden"],
                r = ["form"],
                s = [],
                o, u;
            for (o = 0; o < e.length; o++) {
                s = i.getElementsByTagName(e[o]);
                for (u = 0; u < s.length; u++) t._addEventListener(s[u], "change", n)
            }
            for (o = 0; o < r.length; o++) {
                s = i.getElementsByTagName(r[o]);
                for (u = 0; u < s.length; u++) t._addEventListener(s[u], "submit", n)
            }
        })
    };
    _gas.push(["_addHook", "_trackForms", b]);
    var E = function (e) {
        var t = this;
        t._liveEvent(e, "play", w), t._liveEvent(e, "pause", w), t._liveEvent(e, "ended", w)
    }, S = function () {
        if ( !! this._videoTracked) return;
        this._videoTracked = !0, E.call(this, "video")
    }, x = function () {
        if ( !! this._audioTracked) return;
        this._audioTracked = !0, E.call(this, "audio")
    };
    _gas.push(["_addHook", "_trackVideo", S]), _gas.push(["_addHook", "_trackAudio", x]);
    var T = function (e) {
        if (!this._mailtoTracked) return this._mailtoTracked = !0, e || (e = {}), e.category = e.category || "Mailto", this._liveEvent("a", "mousedown", function (t) {
            var n = t.target;
            n && n.href && n.href.toLowerCase && l.call(n.href.toLowerCase(), "mailto:") === 0 && _gas.push(["_trackEvent", e.category, n.href.substr(7), undefined, 0, true])
        }), !1;
        return
    };
    _gas.push(["_addHook", "_trackMailto", T]);
    var A = null,
        O = 0,
        D;
    _gas.push(["_addHook", "_trackMaxScroll", P]), _gas._allowAnchor = !1, _gas.push(["_addHook", "_setAllowAnchor",
        function (e) {
            _gas._allowAnchor = !! e
        }
    ]), _gas.push(["_addHook", "_link",
        function (e, n) {
            return n === t && (n = _gas._allowAnchor), [e, n]
        }
    ]), _gas.push(["_addHook", "_linkByPost",
        function (e, n) {
            return n === t && (n = _gas._allowAnchor), [e, n]
        }
    ]);
    var H = [],
        B = t;
    _gas.push(["_addHook", "_setDomainName",
        function (e) {
            if (l.call("." + i.location.hostname, e) < 0) return H.push(e), !1;
            B = e
        }
    ]), _gas.push(["_addHook", "_addExternalDomainName",
        function (e) {
            return H.push(e), !1
        }
    ]);
    var F = function () {
        var e = this,
            t = a.call(arguments);
        e._DOMReady(function () {
            j.apply(e, t)
        })
    };
    _gas.push(["_addHook", "_setMultiDomain", F]);
    var I = function (e) {
        if ( !! this._outboundTracked) return;
        this._outboundTracked = !0;
        var t = this;
        e || (e = {}), e.category = e.category || "Outbound", t._liveEvent("a", "mousedown", function (t) {
            var n = this;
            if ((n.protocol == "http:" || n.protocol == "https:") && l.call(n.hostname, i.location.hostname) === -1) {
                var r = n.pathname + n.search + "",
                    s = l.call(r, "__utm");
                s !== -1 && (r = r.substring(0, s)), _gas.push(["_trackEvent", e.category, n.hostname, r, 0, true])
            }
        })
    };
    _gas.push(["_addHook", "_trackOutboundLinks", I]);
    var q = [],
        R = {}, U = {}, X = !1,
        V, K = function (e) {
            var t = this;
            if (typeof e == "boolean" || e === "force") e = {
                force: !! e
            };
            return e = e || {}, e.category = e.category || "Vimeo Video", e.percentages = e.percentages || [], e.force = e.force || !1, V = e, t._DOMReady(function () {
                J.call(t)
            }), !1
        };
    _gas.push(["_addHook", "_trackVimeo", K]);
    var Q = [],
        G, Y = {}, ot = function (e) {
            var t = a.call(arguments);
            t[0] && (typeof t[0] == "boolean" || t[0] === "force") && (e = {
                force: !! t[0]
            }, t[1] && t[1].length && (e.percentages = t[1])), e = e || {}, e.force = e.force || !1, e.category = e.category || "YouTube Video", e.percentages = e.percentages || [], G = e;
            var n = this;
            return n._DOMReady(function () {
                st.call(n, e)
            }), !1
        };
    _gas.push(["_addHook", "_trackYoutube", ot]);
    while (_gas._queue.length > 0) _gas.push(_gas._queue.shift());
    global._gaq && global._gaq.length >= 0 && function () {
        var e = i.createElement("script");
        e.type = "text/javascript", e.async = !0, e.src = ("https:" == i.location.protocol ? "https://" : "http://") + "stats.g.doubleclick.net/dc.js";
        if (window.document.body) {
            // This is used by the unit test
            window.document.body.appendChild(e, t);
        } else {
            // Removing this causes a JS error since document.body may not be defined at the time it's called
            var t = i.getElementsByTagName("script")[0];
            t.parentNode.insertBefore(e, t);
        }
    }()
})(typeof window !== 'undefined' ? window : null);


/***/ }),
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _getDisplayName = __webpack_require__(1947);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

var _isClassComponent = __webpack_require__(1948);

var _isClassComponent2 = _interopRequireDefault(_isClassComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var toClass = function toClass(baseComponent) {
  if ((0, _isClassComponent2.default)(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    _inherits(ToClass, _Component);

    function ToClass() {
      _classCallCheck(this, ToClass);

      return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return _react2.default.createElement('baseComponent', this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(_react.Component);

  ToClass.displayName = (0, _getDisplayName2.default)(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

exports.default = toClass;

/***/ }),
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by daniel.gonzalez on 6/15/15.
 */



var $ = __webpack_require__(5);
var _ = __webpack_require__(22);
var deepLink = __webpack_require__(1603);
var mobileCheck = __webpack_require__(283);
var referrerHelpers = __webpack_require__(1204);
var defaultCookieSettings = __webpack_require__(754).defaultCookieSettings;

__webpack_require__(677);

module.exports = {
    checkSettings: function () {
        return mobileCheck.iPhone() && !$.cookie('dibsMobileInterstitial') && deepLink.pageSupported();
    },

    shouldShowAd: function () {
        return this.checkSettings() && !referrerHelpers.isPlaReferrer();
    },

    setCookie: function () {
        $.cookie('dibsMobileInterstitial', true, _.extend({expires: 1}, defaultCookieSettings));
    }
};


/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Tooltip Plugin
 *
 * this is a wrapper for jquery ui's tooltip plugin, it sets some default configuration options, which
 * can be overwritten, and allows tooltip's public method's to be called (ie. open, close..)
 *
 * to set tooltip content, include a 'data-content' attribute on triggering element, containing
 * html/text or a jquery selector pointing to a wrapper containing content. to set content dynamically,
 * pass a content function to the config
 *  ie. $(...).dibsTooltip({content: function() { return 'dynamically added content' }});
 *
 *  currently used here:
 *  js/checkout/subviews/CheckoutSubmitButton.js
 *  js/global/modules/commonjs/dibsTooltips.js (being required by other files)
 *
 */


var $ = __webpack_require__(5);
var mobileCheck = __webpack_require__(283);
var clickedClass = 'is-clicked';
var hoverClass = 'is-hover';
var fadeDuration = 300;
var viewportSpacer = 4;

var init;
var rePosition;
var fetchContent;
var handleClose;
var handleClick;
var checkDisabled;
var _open;
var _close;

__webpack_require__(1221);
__webpack_require__(1121);
__webpack_require__(2060);
__webpack_require__(2666);

init = function (options) {
    var $self = $(this);
    var defaults = {
        position: {
            // position horizontally-centered, above trigger
            my: 'center bottom-20',
            at: 'center top',
            // if cannot fit, display underneath trigger
            collision: 'flipfit',
            using: rePosition
        },
        content: fetchContent,
        close: handleClose,
        items: '*',
        show: fadeDuration,
        hide: fadeDuration,
        showArrow: true,
        allwaysRepositionArrow: false
    };
    if (options && options.isConfirmation) {
        $.extend(true, defaults, {
            position: {
                my: 'center bottom-15'
            },
            closeDelay: 3000,
            disabled: true,
            showArrow: false
        });
        // do not hide confirmation on mouseout of trigger
        $self.on('mouseout', function (event) {
            event.stopImmediatePropagation();
        });
    }
    options = $.extend(true, {}, defaults, options);
    handleClick($self);
    $self.tooltip(options);
    // always set tooltip class to 'dibstooltip', allow additional classes from trigger's data-tooltipclass or config
    $self.each(function () {
        var $this = $(this);
        var tooltipClass = $this.tooltip('option', 'tooltipClass');
        tooltipClass = 'dibstooltip' +
        (options.isConfirmation ? ' is-confirmation' : '') +
        ($this.data('tooltipclass') ? ' ' + $this.data('tooltipclass') : '') +
        (tooltipClass ? ' ' + tooltipClass : '');
        $this.tooltip('option', 'tooltipClass', tooltipClass);
    });
    return $self;
};

_open = function () {
    var $this = $(this);
    // for confirmation tooltips, auto close after closeDelay, unless mouseenter
    if ($this.tooltip('option', 'isConfirmation')) {
        clearTimeout($this.timeout);
        $this.timeout = setTimeout(function () {
            if ($this.length > 0) {
                // if length === 0, then it's the `document`
                // and does not have a valid element to "close"
                close.call($this);
            }
        }, $this.tooltip('option', 'closeDelay'));
        $this.one('tooltipopen', function (event, ui) {
            ui.tooltip.hover(
                function () {
                    clearTimeout($this.timeout);
                },
                function () {
                    if ($this.length > 0) {
                        // if length === 0, then it's the `document`
                        // and does not have a valid element to "close"
                        close.call($this);
                    }
                }
            );
        });
    }
    return $this.tooltip('open');
};

_close = function () {
    return $(this).removeClass(clickedClass + ' ' + hoverClass).tooltip('close');
};

rePosition = function (newPosition, info) {
    var $this = $(this);
    var triangle;
    var pointLocation;
    var allwaysRepositionArrow;
    // adjust so that tooltip is not on viewport edge
    if (info.element.left + info.element.width >= $(window).width()) {
        info.element.left -= viewportSpacer;
    } else if (info.element.left <= 0) {
        info.element.left = viewportSpacer;
    }
    // always show over modal
    if ($('.modal-bg:visible').length) {
        $this.addClass('is-modal-open');
    }
    // position tooltip
    $this.css({
        left: info.element.left + 'px',
        top: info.element.top + 'px'
    });

    if (info.target.element.tooltip('option', 'showArrow')) {
        allwaysRepositionArrow = info.target.element.tooltip('option', 'allwaysRepositionArrow');
        triangle = $("<div class='dibstooltip-triangle'></div>");
        // add above/below class to triangle depending on position
        triangle.addClass(info.element.top > info.target.top ? 'below' : 'above');
        // triangle is in the middle of tooltip by default, if tooltip has been shifted horizontally to
        // fit within viewport, need to reposition triangle to point at trigger
        pointLocation = info.element.left + info.element.width / 2;
        if (allwaysRepositionArrow || pointLocation < info.target.left || pointLocation > (info.target.left + info.target.width)) {
            triangle.css('left', (info.target.left - info.element.left + (info.target.width / 2)) + 'px');
        }
        $this.append(triangle);
    }

};

// set content from data-content attribute, allow selector or string
fetchContent = function () {
    var content = $(this).data('content') || '';
    var element;
    try {
        element = $('#' + content);
    } catch (err) {/* swallow the exception */}
    return element && element.length ? element.html() : content;
};

// keep open when hovering over tooltip
handleClose = function (e, ui) {
    ui.tooltip.hover(
        function () {
            $(this).stop(true).fadeTo(fadeDuration, 1);
        },
        function () {
            var $this = $(this);
            $this.fadeOut(fadeDuration, $this.remove);
        }
    );
};

// keep tooltip open on click, close with another click
handleClick = function (elements) {
    var toggleTooltip = function () {
        var $this = $(this);
        $this.toggleClass(clickedClass)
            .tooltip($this.hasClass(clickedClass) ? 'open' : 'close');
    };
    // ios - disable normal tooltip events, fire manually via mousedown
    if (mobileCheck.iOS()) {
        elements.bind({
            'mouseover focusin mouseleave focusout click': function (e) {
                if (!checkDisabled.apply($(this))) {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                }
            },
            mousedown: function () {
                var $tooltip = $(this);
                if (!checkDisabled.apply($tooltip)) {
                    toggleTooltip.apply($tooltip);
                }
            }
        });
    } else {
        // non-ios - keep open on click, prevent from closing on mouseleave
        // add hover classes dynamically to avoid ios :hover issues
        elements.bind({
            click: function (e) {
                var $tooltip = $(this);
                if (!checkDisabled.apply($tooltip)) {
                    e.preventDefault();
                    toggleTooltip.apply($tooltip);
                }
            },
            mouseleave: function (e) {
                if ($(this).hasClass(clickedClass)) {
                    e.stopImmediatePropagation();
                }
            }
        }).hover(
            function () {
                $(this).addClass(hoverClass);
            },
            function () {
                $(this).removeClass(hoverClass);
            }
        );
    }
};

checkDisabled = function () {
    return this.dibsTooltip('option', 'disabled');
};

$.fn.dibsTooltip = function (method) {
    // allow public methods of tooltip to be called
    if ($.inArray(method, ['destroy', 'disable', 'enable', 'option', 'widget']) > -1) {
        return this.tooltip.apply(this, arguments);
    }
    // init with config options
    if (typeof method === 'object' || !method) {
        return init.call(this, method);
    }
    if (method === 'open') {
        return _open.call(this);
    }
    if (method === 'close') {
        return _close.call(this);
    }
    $.error('Method ' + method + ' does not exist on jQuery.dibsTooltip');
    return this;
};


/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: daletan
 * Date: 12/15/14
 * Time: 2:31 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */



var SV = __webpack_require__(18);
var verticals = __webpack_require__(416);

module.exports = function baseDomain(loc) {
    var regexp;
    var pattern;
    if (SV.settings && SV.settings.domains && !loc) {
        return SV.settings.domains.base === '1stdibs.com' ? 'www.' + SV.settings.domains.base : SV.settings.domains.base;
    } else {
        loc = loc || window.location.hostname;
        pattern = [verticals.VERTICAL_ART, verticals.VERTICAL_FASHION, verticals.VERTICAL_JEWELRY, 'realestate.'].join('.|');
        regexp = new RegExp(pattern);
        return loc.replace(regexp, '', loc);
    }
};


/***/ }),
/* 2028 */,
/* 2029 */,
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: liliana
 * Date: 1/5/15
 * Time: 4:12 PM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */

/**
 * pointerevents.js - commonjs entries files for jQuery PointerEvents dependencies
 * @link https://github.com/jquery/PointerEvents
 */



var scopeName = 'PointerEventsPolyfill';
window[scopeName] = window[scopeName] || {};

// ---------------------------------------------------
// Dependencies

__webpack_require__(4054);
__webpack_require__(2600);


/***/ }),
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2062), __esModule: true };

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2674), __esModule: true };

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaCollection = __webpack_require__(9);
var PermissionList = module.exports = SoaCollection.extend();
var Permission = __webpack_require__(940);
var _ = __webpack_require__(0);

_.extend(PermissionList.prototype, {
    model: Permission,
    comparator: 'name',

    /**
     * Check permissions for a given user.
     * @param required - The required permission to complete this action.
     * @returns {*}
     */
    checkPermissions: function (required) {
        // Return true if nothing is passed in for required
        if (!required || _.isEmpty(required)) {
            return true;
        }

        // If required is a string, check if it's in the available array
        if (typeof required === 'string') {
            return !_.isUndefined(this.findWhere({name: required}));
        }
        // If required is an array, check if at least one of them is in available
        return _.some(required, function (perm) {
            return !_.isUndefined(this.findWhere({name: perm}));
        }, this);
    }
});

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 12/19/13
 * Time: 12:12 PM
 */



var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);

var SoaCollection = __webpack_require__(9);
var Roles = module.exports = SoaCollection.extend();

var Role = __webpack_require__(1623);

_.extend(Roles.prototype, {
    model: Role,
    url: endpoints.roles(),
    comparator: 'name',
    parse: function (data) {
        var roles, mapping;
        if (data.roleList) {
            roles = data.roleList;
            mapping = data.rolePermissionMappings;
        } else if (data.result && data.result.roles && data.result.roles.roleList) {
            roles = data.result.roles.roleList;
            mapping = data.result.roles.rolePermissionMappings;
        } else {
            return data;
        }

        //parse the roles - permissions mapping
        if (roles && mapping) {
            _.each(roles, function (role) {
                role.permissions = [];
                _.each(_.where(mapping, {name: role.id}), function (permission) {
                    role.permissions.push({
                        id: permission.value
                    });
                });
            });
        }

        return roles;
    }
});


/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Load Super Class

var SoaCollection = __webpack_require__(9);

// ---------------------------------------------------
// Module Definition

/**
 * Model for data about an item's categories.
 * Sorted by the 'Precedence' field.
 * Uses the {@link ItemCategory} as its model
 * @class ItemCategories
 * @extends SoaCollection
 * @property {function(new:ItemCategory)} ItemCategory
 * @property {string} comparator
 */
var ItemCategories = module.exports = SoaCollection.extend();

// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);
var ItemCategory = __webpack_require__(2648);

// ---------------------------------------------------
// Local Vars

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(ItemCategories.prototype, /** @lends ItemCategories.prototype */{
    model: ItemCategory,
    comparator: 'precedence',
    /**
     * Return an array of {@link Category} models
     * corresponding to this ItemCategories collection
     * models
     * @returns {Category[]}
     */
    getCategories: function () {
        var categories = [];
        this.each(function (itemCategory) {
            categories.push(itemCategory.getCategory());
        });
        return categories;
    },
    /**
     * Get the category ({@link Category}) at a specified
     * index.
     * @param {number} index
     * @returns {Category}
     */
    getCategoryAt: function (index) {
        var itemCategory = this.at(index);
        if (itemCategory) {
            return itemCategory.getCategory();
        }
    },
    /**
     * @param {number} index
     * @returns {string}
     */
    getCategoryKeyAt: function (index) {
        var itemCategory = this.at(index);
        if (itemCategory) {
            return itemCategory.getCategoryKey();
        }
    },
    /**
     * Return the keys for each category
     * @returns {string[]}
     */
    getCategoryKeys: function () {
        var keys = [];
        this.each(function (itemCategory) {
            keys.push(itemCategory.getCategoryKey());
        });
        return keys;
    },
    /**
     * @param {string} key
     * @returns {ItemCategories}
     */
    removeByCategoryKey: function (key) {
        var itemCategory = this.findByCategoryKey(key);
        if (itemCategory) {
            this.remove(itemCategory);
        }
        return this;
    },
    /**
     * Get the primary item category
     * @returns {ItemCategory}
     */
    getPrimary: function () {
        return this.find(function (itemCategory) {
            return itemCategory.getPrecedence() === 1;
        });
    },
    /**
     * Get the primary item category's {@link Category} key
     * @returns {string}
     */
    getPrimaryCategoryKey: function () {
        var primary = this.getPrimary();
        if (primary) {
            return primary.getCategoryKey();
        }
    },
    /**
     * @param {string} key
     * @returns {ItemCategory}
     */
    findByCategoryKey: function (key) {
        return this.find(function (itemCategory) {
            var category = itemCategory.getCategory();
            return category && category.get('key') === key;
        });
    },
    /**
     * @param {number} precedence
     * @returns {ItemCategory}
     */
    findCategoryByPrecedence : function (precedence) {
        return this.findWhere({ 'precedence' :  precedence }) || this.getPrimary();
    },
    /**
     * @param {string} keys
     * @returns {ItemCategories}
     */
    resetWithKeys: function (keys) {
        this.reset();
        _.each(keys, this.addWithKey, this);
        return this;
    },
    /**
     * Adds an ItemCategory with a category
     * key in increments the precedence of the
     * category
     * @param {string} key
     * @returns {ItemCategories}
     */
    addWithKey : function (key) {
        this.add(this.createWithKey(key));
        return this;
    },
    /**
     * Creates an ItemCategory with a precedence
     * based off of the existing max precedence in
     * the collection
     * @param {string} key
     * @returns {ItemCategory}
     */
    createWithKey: function (key) {
        var precedence = this.getMaxPrecedence() + 1;
        return ItemCategory.createWithKeyAndPrecedence(key, precedence);
    },
    /**
     * Creates an ItemCategory with a category key
     * and a precedence, and adds it to the collection
     * @param {string} key
     * @param {number} precedence
     */
    addWithKeyAndPrecedence: function (key, precedence) {
        this.add(ItemCategory.createWithKeyAndPrecedence(key, precedence));
        return this;
    },
    /**
     * Return the highest value for precedence
     * in the collection
     * @returns {number}
     */
    getMaxPrecedence : function () {
        var lastCategory;
        if (this.length) {
            lastCategory = this.max(function (itemCategory) {
                return itemCategory.getPrecedence() || 0;
            });
        }
        return lastCategory ? lastCategory.getPrecedence() : 0;
    },
    /**
     * @returns {ItemCategories}
     */
    resetPrecedence: function () {
        var precedence = 1;
        this.each(function (itemCategory) {
            itemCategory.set('precedence', precedence);
            precedence++;
        });
        return this;
    }
});



/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var _ = __webpack_require__(0);
var $ = __webpack_require__(5);
var autoFetch = function () {
    if (this._lastFetch) {
        // fetch already happened, return the last fetch attempt's promise
        return this._lastFetch;
    }
    this._discreteIds = this.invoke('get', 'id');
    this._lastFetch = this.fetchWithParameters ? this.fetchWithParameters() : this.fetch();
    return this._lastFetch;
};

/**
 *
 * @mixin FetchDiscrete
 *
 * fetchDiscrete is a static mixin for collections that offers a fetchDiscrete method that will return a deferred that will resovle to an inflated model specified by the ID passed
 *
 * Configuration:
 *  add this._discreteIds to your URL when they are present
 *      This is usually done by providing a custom URL on your collection. This function
 *      should use the values in this._discreteIds to build a URL for a request for specific
 *      models identified by this property.
 *  add fetchDiscrete as a static method on your Collection. Static properties can be
 *      specified in the second argument to Backbone.Collection.extend
 * Usage:
 *  Once your collection has been configured for makeDiscrete, you can get deferreds for
 *    specific models using calls of the following forms:
 *
 *    YourCollection.fetchDiscrete(uninflatedModel, collectionParams)
 *    YourCollection.fetchDiscrete(modelId, collectionParams)
with identical collectionParams values will be grouped into a single request. Sequential calls to fetchDiscrete with non-identical collectionParams values will cause a new request to be made.
 *
 * Notes:
 *  - Plays well with clump service.
 *  - Fetching models for anchor lists (see Anchors.js) was the original use-case for this mixin. Anchors know about models, but fetchDiscrete happens on collections. For this reason, to have getSourceModel automatically detect when a model can be fetched using fetchDiscrete, specify a defaultCollection property on your model's prototype that is the collection that getSourceModel should defer to for fetchDiscrete.
 */
module.exports = {
/**
 *   @param {Backbone.Model} uninflatedModel - an instance of Collection.prototype.model that will be inflated.
 *   @param {string|int} modelId - an id (string or int) of the model that you want Collection to fetch
 *   @param {object} collectionParams - (optional) query parameters passed during the request. Sequential calls to fetchDiscrete
 *   @return - a deferred that resolves to the item that was requested
 */
    fetchDiscrete : function (model, params) {
        var curfetcher;
        var fetched;
        var needsNewFetcher = !this._curfetcher || _.result(this._curfetcher, '_madeRequest');
        if (this._curfetcher && !needsNewFetcher) {
            if (!_.isEqual(this._curfetcher.params || {}, params || {})) {
                needsNewFetcher = true; // start anew if we need different params from the last request
            }
        }
        if (needsNewFetcher) {
            this._curfetcher = new this();
            this._curfetcher.params = params;
        }
        curfetcher = this._curfetcher;
        if ("string" === typeof model || "number" === typeof model) {
            model = {id: model};
        }
        curfetcher.add(model);
        model = curfetcher.get(model.id); // the collection may have vivified what we inserted into an actual model, so we get it back out here
        fetched = $.Deferred();
        _.defer(function () {
            curfetcher._madeRequest = true;
            autoFetch.apply(curfetcher).done(function () {
                var inflatedModel = curfetcher.get(model.id);
                console.assert(inflatedModel, "expected model for id " + model.id + " in response for collection");
                if (inflatedModel !== model) {
                    // not sure why this would ever happen, but it always does. Backbone should intelligently reuse the models in its collections upon fetch
                    model.set(inflatedModel.toJSON()); // assume the data of the inflated model
                }
                fetched.resolve(model);
            });
        });
        return fetched;
    }
};


/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * New IDs for old entities like items and sellers look like this: "f_123" - Old ones do not include vertical prefix.
 * This function will return the numeric ID whether or not the id being considered has the vertical prefix.
 * Extend module.modelHelper onto your models to get this method.
 */



function _getLegacyId(id) {
    var legacyId = id.split('_')[1];
    return legacyId || id;
}

module.exports = {
    from : function (id) {
        return _getLegacyId(id);
    },
    modelHelper : function () {
        return this.get('id') ? _getLegacyId(this.get('id')) : null;
    }
};



/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strings = __webpack_require__(394);
console.warn('strings.js is deprecated.  Use dibs-strings-helper instead');
module.exports = strings;


/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/11/13
 */


var SoaModel = __webpack_require__(2);
var CurrencyConversion = SoaModel.extend();

module.exports = CurrencyConversion;


/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * User: Shad
 * Date: 9/11/13
 */
/**
 * @mixes SoaModel
 * @class
 */

var SoaModel = __webpack_require__(2);
var CurrencyConversionRate = module.exports = SoaModel.extend();

var _ = __webpack_require__(0);
var currency = __webpack_require__(320);

_.extend(CurrencyConversionRate.prototype, {
    canConvert : function (fromCurrency, toCurrency) {
        var mFromCurrency;
        var mToCurrency;
        fromCurrency = currency(fromCurrency);
        toCurrency = currency(toCurrency);
        if (fromCurrency === toCurrency) {
            return true;
        }
        mFromCurrency = currency(this.get('fromCurrency'));
        mToCurrency = currency(this.get('toCurrency'));
        if (!mFromCurrency || !mToCurrency) {
            return false;
        }
        return (
            (mFromCurrency === fromCurrency && mToCurrency === toCurrency) ||
            (mToCurrency === fromCurrency && mFromCurrency === toCurrency)
        );
    },
    convert : function (fromAmount, fromCurrency, toCurrency, precision) {
        var rate = parseFloat(this.get('rate'));
        if (!this.canConvert(fromCurrency, toCurrency)) {
            return void 0;
        }
        precision = precision === void 0 ? 2 : precision;
        fromCurrency = currency(fromCurrency);
        toCurrency = currency(toCurrency);
        if (fromCurrency === toCurrency) {
            return fromAmount;
        }
        if (fromCurrency !== currency(this.get('fromCurrency'))) {
            rate = 1 / rate;
        }
        return Math.round(fromAmount * rate * Math.pow(10, precision)) / Math.pow(10, precision);
    }
});


/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by don on 7/27/15.
 */


var SoaModel = __webpack_require__(2);
var FeeStructure = module.exports = SoaModel.extend();
var endpoints = __webpack_require__(6);
var _ = __webpack_require__(0);

/**
 * Contains information about dealer fee structures.
 * Used to change which fee structure a dealer is associated with.
 * @class FeeStructure
 * @extends SoaModel
 *
 */
_.extend(FeeStructure.prototype, {

    url: function () {
        return endpoints.feeStructure(this.id);
    },

    initialize: function (attrs, options) {
        this.id = options.id;
    }

});

_.extend(FeeStructure, {
    TYPE: {
        TIERED: 'TIERED',
        FLAT_RATE_10: 'FLAT_RATE_10',
        FLAT_RATE_20: 'FLAT_RATE_20',
        FLAT_RATE_22: 'FLAT_RATE_22',
        FLAT_RATE_37: 'FLAT_RATE_37'
    },
    feeStructureIds: {
        TIERED: 2201,
        FLAT_RATE_10: 2202,
        FLAT_RATE_20: 2203,
        FLAT_RATE_22: 2206,
        FLAT_RATE_37: 2207
    }
});


/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 1/14/15
 * Time: 1:26 PM
 */



var SoaModel = __webpack_require__(2);
var PercentAdjustment = module.exports = SoaModel.extend();

var _ = __webpack_require__(0);
var FinancialAmount = __webpack_require__(10);
var Backbone = __webpack_require__(3);
var Period = __webpack_require__(116);
var Adjustment = __webpack_require__(131);
var Anchor = __webpack_require__(12);
var financialAmountMixin = __webpack_require__(48);
var getAdjustmentProperty;
var hasReference;

getAdjustmentProperty = function (name) {
    var adjustmentProperties = this.get('adjustmentProperties');
    var property;
    if (adjustmentProperties) {
        property = adjustmentProperties.findWhere({name: name});
    }
    return property && property.get('value');
};

hasReference = function (reference) {
    return this.get('reference') === reference;
};

_.extend(PercentAdjustment.prototype, {
    relations: [
        {
            key: 'totalAmount',
            relatedModel: FinancialAmount,
            type: Backbone.One
        },
        {
            key: 'adjustmentProperties',
            relatedModel: SoaModel,
            type: Backbone.Many
        },
        {
            key: 'eligibleAmount',
            relatedModel: FinancialAmount,
            type: Backbone.One
        },
        {
            key: 'sourceAnchor',
            relatedModel: Anchor,
            type: Backbone.One
        },
        {
            key: 'saleAdjustment',
            relatedModel: function () {
                // Adjustment requires PercentAdjustment
                // PercentAdjustment requires Adjustment
                // Seller Adjustment requires Adjustment
                // PercentAdjustment requires SellerAdjustment
                return __webpack_require__(2049);
            },
            type: Backbone.One
        }
    ],
    getReleaseDate: _.partial(getAdjustmentProperty, Adjustment.PROPERTY_RELEASE_DATE),
    getStartingDate: _.partial(getAdjustmentProperty, Adjustment.PROPERTY_STARTING_DATE),
    getNumberOfUnits: _.partial(getAdjustmentProperty, Adjustment.PROPERTY_NUMBER_OF_UNITS),
    getEligibleCreditPeriod: _.partial(getAdjustmentProperty, Adjustment.PROPERTY_ELIGIBLE_CREDIT_PERIOD),
    getCreditPeriod: function () {
        var timeUnit = getAdjustmentProperty.call(this, 'creditPeriod.timeUnit');
        var numberOfUnits = getAdjustmentProperty.call(this, 'creditPeriod.numberOfUnits');
        return new Period({
            timeUnit: timeUnit,
            numberOfUnits: parseInt(numberOfUnits, 10)
        });
    },
    getCreditAmount: function () {
        var amount = getAdjustmentProperty.call(this, 'creditAmount.amount');
        var currency = getAdjustmentProperty.call(this, 'creditAmount.currency');
        return new FinancialAmount({
            amount: amount,
            currency: currency
        });
    },
    getEligibleAmount: function (currency) {
        return this._getFinancialAmount('eligibleAmount', currency);
    },
    isPromotionAdjustment: function () {
        var anchor = this.get('sourceAnchor');
        return anchor && anchor.isPromotion();
    },
    isMerchTaxAdjustment: _.partial(hasReference, Adjustment.REFERENCE_MERCHANDISE_TAX),
    isShippingTaxAdjustment: _.partial(hasReference, Adjustment.REFERENCE_SHIPPING_TAX),
    isCommissionAdjustment: _.partial(hasReference, Adjustment.REFERENCE_COMMISSION),
    isProcessingFeeAdjustment: _.partial(hasReference, Adjustment.REFERENCE_PAYMENT_PROCESSING_FEE),
    isListingCreditAdjustment: _.partial(hasReference, Adjustment.REFERENCE_LISTING_CREDIT),
    isComplimentaryShipping: _.partial(hasReference, Adjustment.REFERENCE_COMPLIMENTARY_SHIPPING),
    isDealerCharge: _.partial(hasReference, Adjustment.REFERENCE_DEALER_CHARGE)
}, financialAmountMixin);


/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by james on 3/5/14.
 */


var Adjustment = __webpack_require__(131);
var SellerAdjustment = module.exports = Adjustment.extend();

var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);

/**
 * Empty container model - necessary to reflect the data structure where StateTaxAdjustments will have only 1
 * attribute to "adjustment"
 * @type {*}
 */
var SaleAdjustment = SoaModel.extend({
    defaults: {
        rateType: 'PERCENT'
    },
    relations: [{
        key: 'rate',
        relatedModel: SoaModel,
        type: Backbone.One
    }]
});


/**
 * Defining models of Adjustment collection
 * @property defaults.applyToShipping{string} 'N'
 * @type {*}
 */
_.extend(SellerAdjustment.prototype, {
    defaults: {
        applyToShipping: 'N'
    },
    relations: [{
        key: 'saleAdjustment',
        relatedModel : SaleAdjustment,
        type: Backbone.One
    }]
});


/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Rob Richard
 * Date: 12/20/13
 * Time: 4:49 PM
 */



var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var Address = __webpack_require__(32);
var AddressBook = SoaModel.extend();
var endpoints = __webpack_require__(6);

var root = typeof window === 'undefined' ? global : window;
var bunsen = root.bunsen = root.bunsen || {};
var filterByFn = function (fn) {
    var list = this.get('addressList');
    if (list) {
        return list.filter(function (address) {
            return address[fn]();
        });
    }
};

module.exports = bunsen.AddressBook = AddressBook;

_.extend(AddressBook.prototype, {
    /*
    TODO: define an accessor method for `this.parents[0]` -- perhaps in SoaModel

    note: this model isn't guaranteed to have a `this.parent` property

    url: function () {
        // TODO: find a better way to get the user ID
        return endpoints.addressBook(this.parents[0].id);
    },
    */

    url: endpoints.addressBook,
    idAttribute: "id",
    relations: [
        {
            key: 'addressList',
            relatedModel: Address,
            type: Backbone.Many
        }
    ],
    getAddressById: function (id) {
        return this.get('addressList').findWhere({id: id});
    },
    getPersonalAddress: function () {
        return this.getAddressById(this.get('personalAddressId'));
    },
    getProAddress: function () {
        return this.getAddressById(this.get('proAddressId'));
    },
    getFirstShippingAddress: function () {
        return _.first(this.getShippingAddresses());
    },
    getShippingAddresses: _.partial(filterByFn, 'isValidShippingAddress'),
    getBillingAddresses: _.partial(filterByFn, 'isValidBillingAddress')
});

_.extend(AddressBook, {
    getNewAddressBook: function () {
        return new AddressBook({
            addressList: []
        });
    }
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by don on 3/6/15.
 */



var _ = __webpack_require__(0);
var SoaModel = __webpack_require__(2);

var ASSOCIATIONS = ['nydc', 'aadla', 'twentiethLeague', 'adaa', 'aipad'];
var NYDC = 0;
var AADLA = 1;
var TWENTIETH = 2;
var ADAA = 3;
var AIPAD = 4;
var NAMES = {
    AADLA: 'AADLA',
    CINOA: 'CINOA',
    BADA: 'BADA',
    LAPADA: 'LAPADA',
    SLAD: 'SLAD',
    IFPDA: 'IFPDA',
    PADA: 'PADA',
    NADA: 'NADA',
    FADA: 'FADA',
    NAADAA: 'NAADAA',
    ADAA: 'ADAA',
    AAM: 'AAM',
    NYDC: 'NYDC',
    TWCS: 'TWCS',
    AIPAD: 'AIPAD'
};

/**
 * Contains information about associations to which the seller belongs.
 * @class TradeAssociation
 * @extends SoaModel
 */
var TradeAssociation = SoaModel.extend({

    /**
     * Set the URL for relevant service requests.
     * @returns {String}
     */
    url : function () {
        var url = _.result(this.parents[0], 'url') + '/tradeAssociations';

        return url;
    },

    isAntiquesAssociationLeague: function () {
        return TradeAssociation.OTHER_NAMES.indexOf(this.get('name')) > -1;
    }
}, {
    // deprecated - used in seller.associations.  Should use NAMES[association]
    ASSOCIATIONS:     ASSOCIATIONS,
    NYDC:             ASSOCIATIONS[NYDC],
    AADLA:            ASSOCIATIONS[AADLA],
    TWENTIETH_LEAGUE: ASSOCIATIONS[TWENTIETH],
    ADAA:             ASSOCIATIONS[ADAA],
    AIPAD:            ASSOCIATIONS[AIPAD],

    // new association names (used in seller.tradeAssociations)
    NAMES: NAMES,

    // Associations that are in the "Associations" dropdown. Basically not nydc,
    // 20th century, or AIPAD
    OTHER_NAMES: [
        NAMES.AADLA, NAMES.CINOA, NAMES.BADA, NAMES.LAPADA, NAMES.SLAD,
        NAMES.IFPDA, NAMES.PADA, NAMES.NADA, NAMES.FADA, NAMES.NAADAA,
        NAMES.ADAA
    ],

    /**
     *
     * @param {String} key
     * @returns {String}
     */
    getDisplayString : function (key) {
        var associationLabels = {
            nydc: 'NYDC',
            aadla: 'Antiques Association',
            twentiethLeague: '20th Century Specialists',
            adaa: 'ADAA',
            aipad: 'AIPAD'
        };

        return associationLabels[key];
    },

    getDisplayName : function (key) {
        var associationLabels = {
            nydc: 'NYDC Items',
            aadla: 'Antiques Associations Members',
            twentiethLeague: '20th Century Specialists',
            adaa: 'Art Dealers Associations',
            aipad: 'International Photography Art Dealers'
        };

        return associationLabels[key];
    }
});

module.exports = TradeAssociation;


/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var UserProfile = __webpack_require__(1218);
var UserProProfile = UserProfile.extend();

module.exports = UserProProfile;

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var endpoints = __webpack_require__(6);

_.extend(UserProProfile.prototype, {
    url: function () {
        // TODO: find a better way to get the user ID
        return endpoints.userProProfile(this.parents[0].id);
    },
    relations: function () {
        return [
            {
                key: 'trade',
                relatedModel: UserProfile,
                type: Backbone.One
            }
        ];
    }
});


/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Load Super Class

var SoaModel = __webpack_require__(2);

// ---------------------------------------------------
// Module Definition

/**
 * @class Condition
 * @extends SoaModel
 */
var Condition = module.exports = SoaModel.extend();

// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(Condition.prototype, {

    /**
     *
     * @param {string} type
     * @returns {boolean}
     */
    hasCondition: function (type) {
        return this.get(type) === 'Y';
    },

    /**
     * @returns {boolean}
     */
    hasAnyWearDamage: function () {
        var wearType;
        for (wearType in Condition.WEAR) {
            if (this.hasCondition(Condition.WEAR[wearType])) {
                return true;
            }
        }

        return false;
    }

});

// ---------------------------------------------------
// Define Module Static Properties

_.extend(Condition, {
    STATE: {
        ART_EXCELLENT: 'EXCELLENT',
        ART_GOOD: 'GOOD',
        ART_FAIR: 'FAIR',
        FURNITURE_EXCELLENT: 'EXCELLENT',
        FURNITURE_GOOD: 'GOOD',
        FURNITURE_FAIR: 'FAIR',
        FURNITURE_DISTRESSED: 'DISTRESSED',
        JEWELRY_AS_NEW_WITH_BOX: 'AS_NEW_WITH_BOX',
        JEWELRY_AS_NEW: 'AS_NEW',
        JEWELRY_EXCELLENT: 'EXCELLENT',
        JEWELRY_GOOD: 'GOOD',
        JEWELRY_FAIR: 'FAIR',
        FASHION_NEW_NEVER_WORN: 'NEW_NEVER_WORN',
        FASHION_EXCELLENT: 'EXCELLENT',
        FASHION_GOOD: 'GOOD',
        FASHION_FAIR: 'FAIR'
    },

    WEAR: {
        DAMAGE_LIGHT: 'damageLight',
        DAMAGE_DESIGNER_ALTERED: 'damageDesignerAltered',
        DAMAGE_OTHER_ALTERED: 'damageOtherAltered',
        DAMAGE_LOSSES: 'damageLosses',
        DAMAGE_SOUND: 'damageSound',
        DAMAGE_FADING: 'damageFading',
        DAMAGE_RESTORED: 'damageRestored',
        DAMAGE_SERVICED: 'damageServiced'
    }
});

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 1stdibs
 * User: James
 * Date: 1/17/14
 */


var SoaModel = __webpack_require__(2);
var SoaCollection = __webpack_require__(9);
var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);

/**
 * @class DimensionSet
 * @extends SoaModel
 */
var DimensionSet = module.exports = SoaModel.extend();

/**
 * @class Shape
 * @extends SoaModel
 */
var Shape = SoaModel.extend({
    relations: [{
        key: 'validDimensions',
        collectionType: SoaCollection,
        type: Backbone.Many
    }]
});
/**
 * @class Shapes
 * @extends Shape
 */
var Shapes = SoaCollection.extend({
    model: Shape
});

_.extend(DimensionSet.prototype, /** @lends DimensionSet.prototype */{
    relations: [{
        key: 'validShapes',
        collectionType: Shapes,
        type: Backbone.Many
    }]
});


/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Load Super Class

var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);

// ---------------------------------------------------
// Module Definition

var ItemAttributes = module.exports = SoaModel.extend();

// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);
var ItemAttributesCollection = __webpack_require__(1015);
var ItemAttributesPeriodCollection = __webpack_require__(2622);
var ItemAttributesProductionTypeCollection = __webpack_require__(2623);
var ItemAttribute = __webpack_require__(1219);

// ---------------------------------------------------
// Local Vars

var HasMany = Backbone.Many;

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(ItemAttributes.prototype, {
    relations: [
        {
            key: ItemAttribute.ATTRIBUTE_MATERIAL,
            collectionType : ItemAttributesCollection,
            type: HasMany
        },
        {
            key: ItemAttribute.ATTRIBUTE_TECHNIQUE,
            collectionType : ItemAttributesCollection,
            type: HasMany
        },
        {
            key: ItemAttribute.ATTRIBUTE_METAL,
            collectionType : ItemAttributesCollection,
            type: HasMany,
            omitFromSave : true
        },
        {
            key: ItemAttribute.ATTRIBUTE_STONE,
            collectionType : ItemAttributesCollection,
            type: HasMany,
            omitFromSave : true
        },
        {
            key: ItemAttribute.ATTRIBUTE_STYLE,
            collectionType : ItemAttributesCollection,
            type: HasMany
        },
        {
            key: ItemAttribute.ATTRIBUTE_STYLE_OF,
            collectionType : ItemAttributesCollection,
            type: HasMany
        },
        {
            key: ItemAttribute.ATTRIBUTE_ORIGIN,
            collectionType : ItemAttributesCollection,
            type: HasMany
        },
        {
            key: ItemAttribute.ATTRIBUTE_PERIOD,
            collectionType : ItemAttributesPeriodCollection,
            type: HasMany
        },
        {
            key: ItemAttribute.ATTRIBUTE_LEAD_TIME,
            collectionType : ItemAttributesCollection,
            type: HasMany
        },
        {
            key: ItemAttribute.ATTRIBUTE_PRODUCTION_TYPE,
            collectionType : ItemAttributesProductionTypeCollection,
            type: HasMany
        },
        {
            key: ItemAttribute.ATTRIBUTE_COLOR,
            collectionType : ItemAttributesCollection,
            type: HasMany
        }
    ],

    getAttributeIdsFor: function (attributeType) {
        var attributeCollection = this.get(attributeType) || [];
        return attributeCollection.map(function (attribute) {
            return attribute.get('option.id');
        });
    },

    getAttributeIdFor: function (attributeType) {
        var ids = this.getAttributeIdsFor(attributeType);
        return ids.length && ids[0];
    },

    getAttributeValuesFor: function (attributeType) {
        var attributeCollection = this.get(attributeType) || [];
        return attributeCollection.map(function (attribute) {
            return attribute.get('option.id');
        });
    },

    getAttributeValueFor: function (attributeType) {
        var vals = this.getAttributeValuesFor(attributeType);
        return vals.length && vals[0];
    },

    /**
     * @returns {*}
     */
    getStyleAttribute: function () {
        return this.get(ItemAttribute.ATTRIBUTE_STYLE);
    },

    /**
     * @returns {*}
     */
    getStyleOfAttribute: function () {
        return this.get(ItemAttribute.ATTRIBUTE_STYLE_OF);
    },

    /**
     * Get materials and techniques collection with synced attributes
     * @returns {ItemAttributesCollection}
     */
    getMaterialsTechniquesCollection: function () {
        var materials = this.get(ItemAttribute.ATTRIBUTE_MATERIAL) ? this.get(ItemAttribute.ATTRIBUTE_MATERIAL).toJSON() : [];
        var techniques = this.get(ItemAttribute.ATTRIBUTE_TECHNIQUE) ? this.get(ItemAttribute.ATTRIBUTE_TECHNIQUE).toJSON() : [];
        var collection = new ItemAttributesCollection();

        // Set materials
        _.each(materials, function (material) {
            if (material.groupKey) {
                // Find grouped technique
                _.each(techniques.slice(0), function (technique, index) {
                    if (technique.groupKey && technique.groupKey === material.groupKey) {
                        techniques.splice(index, 1);

                        collection.add({
                            material: material,
                            technique: technique
                        });
                    }
                });
            } else {
                // Just material
                collection.add({
                    material: material
                });
            }
        });

        // Set techniques (no more groups)
        _.each(techniques, function (technique) {
            collection.add({
                technique: technique
            });
        });

        return collection;
    }
});


/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var ends = __webpack_require__(6);
var _ = __webpack_require__(0);

/**
 * Mailer model is sed to add an item to the mailer or remove an item from the mailer
 * @extends SoaModel
 */
var Mailer = SoaModel.extend({
    initialize: function(attrs, options) {
        options = options || {};
        Mailer.__super__.initialize.call(this, attrs, options);
        this.itemId = options.itemId;
    },
    url: function() {
        console.assert(this.itemId, 'Mailer requires itemId to generate URL');
        return ends.mailer(this.itemId);
    },
    add: function(options) {
        return this.save({ inMailer: 'Y' }, _.extend({ type: 'PUT' }, options));
    },
    remove: function(options) {
        return this.save({ inMailer: 'N' }, _.extend({ type: 'PUT' }, options));
    }
});

module.exports = Mailer;


/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Load Super Class

var SoaModel = __webpack_require__(2);

// ---------------------------------------------------
// Module Definition

/**
 * @class Review
 * @extends SoaModel
 */
var Review = module.exports = SoaModel.extend();

// ---------------------------------------------------
// Module Constants

var assert = __webpack_require__(31);

var REVIEW_STATUSES = {
    NEW: 'NEW',
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    DELETED: 'DELETED'
};

/**
 * TODO: Describe Review Types
 */
var REVIEW_TYPES = {
    IMAGE_PROCESSING: 'IMAGE_PROCESSING',
    DATA_QUALITY: 'DATA_QUALITY',
    EXPERT_REVIEW: 'EXPERT_REVIEW',
    VETTING: 'VETTING'
};

var REVIEW_SUBJECT_TYPES = {
    ITEM: 'ITEM',
    PUBLICATION: 'PUBLICATION'
};

var REVIEW_ACTION_NAMES = {
    ASSIGN_REVIEW: 'ASSIGN_REVIEW',
    APPROVE_REVIEW: 'APPROVED'
};

var REASON_CODES = {
    VOID: 'VOID',
    ADDITIONAL_IMAGES_REQUESTED: 'ADDITIONAL_IMAGES_REQUESTED',
    ADDITIONAL_DETAILS_REQUESTED: 'ADDITIONAL_DETAILS_REQUESTED',
    ATTRIBUTION_VERIFICATION_REQUESTED: 'ATTRIBUTION_VERIFICATION_REQUESTED',
    ENHANCED_IMAGES_REQUESTED: 'ENHANCED_IMAGES_REQUESTED',
    GENERAL_RESPONSE: 'GENERAL_RESPONSE',
    PERIOD_VERIFICATION_REQUESTED: 'PERIOD_VERIFICATION_REQUESTED',
    RESTRICTED_MATERIALS: 'RESTRICTED_MATERIALS'
};

// ---------------------------------------------------
// Dependencies

var Backbone = __webpack_require__(3);
var endpoints = __webpack_require__(6);
var AvailableActions = __webpack_require__(1527);
var transitionMixin = __webpack_require__(315);
var Note = __webpack_require__(33);
var User = __webpack_require__(28);
var Permission = __webpack_require__(940);
var _ = __webpack_require__(0);

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(Review.prototype, {
    relations: [
        {
            key : 'actions',
            type: Backbone.Many,
            collectionType: AvailableActions
        }
    ],

    url: function () {
        return endpoints.inventoryReview(this.get('id'));
    },

    /**
     * Gets the subjectEntity property from the review
     */
    getSubjectId: function () {
        return this.get('subject.sourceId');
    },
    /**
     * Gets the subjectEntity property from the review
     */
    getSubjectType: function () {
        return this.get('subject.sourceType');
    },

    /**
     * Sets the subject of the review to an anchor item, based on the ID passed in
     * @param {string} itemId
     */
    setAnchorItem: function (itemId) {
        assert(itemId, 'You must pass in an itemId to setAnchorItem');
        this.set('subject', {
            apiType: 'anchor',
            sourceId: itemId,
            sourceType: 'ITEM'
        });
    },
    /**
     * Sets the status of the review to Pending
     */
    markPending: function () {
        this.set('status', Review.STATUS.PENDING);
    },

    /**
     * Sets the status of the review to Approved
     */
    markApproved: function () {
        this.set('status', Review.STATUS.APPROVED);
    },

    /**
     * Sets the status of the review to Deleted
     */
    markDeleted: function () {
        this.set('status', Review.STATUS.DELETED);
    },

    /* Review Doc Statuses */
    /**
     * Returns true if the review is in New status
     */
    isStatusNew: function () {
        return this.get('status') === Review.STATUS.NEW;
    },

    /**
     * Returns true if the review is in Pending status
     */
    isStatusPending: function () {
        return this.get('status') === Review.STATUS.PENDING;
    },

    /**
     * Returns true if the review is in Approved status
     */
    isStatusApproved: function () {
        return this.get('status') === Review.STATUS.APPROVED;
    },

    /**
     * Returns true if the review is in Deleted status
     */
    isStatusDeleted: function () {
        return this.get('status') === Review.STATUS.DELETED;
    },

    /* Review Doc Types */
    /**
     * Returns true if the review is the Image Processing type
     */
    isTypeImageProcessing: function () {
        return this.get('type') === Review.TYPE.IMAGE_PROCESSING;
    },

    /**
     * Returns true if the review is the Data Quality type
     */
    isTypeDataQuality: function () {
        return this.get('type') === Review.TYPE.DATA_QUALITY;
    },

    /**
     * Returns true if the review is the Expert Review type
     */
    isTypeExpertReview: function () {
        return this.get('type') === Review.TYPE.EXPERT_REVIEW;
    },

    /**
     * Returns true if the review is the Vetting Review type
     */
    isTypeVettingReview: function () {
        return this.get('type') === Review.TYPE.VETTING;
    },

    isRejected: function () {
        return this.has('reasonCode') &&
            this.get('reasonCode') !== Review.REASON_CODES.VOID &&
            this.isTypeExpertReview() &&
            this.isStatusDeleted();
    },

    /**
     * Returns true if the review can be assigned and the user has permission to do so
     * @param {User} user
     * @param {string} type - The type of Review
     * @returns {boolean}
     */
    canAssignReview: function (user, type) {
        var actions;
        var assignReviewAction;
        var permissionNeeded;
        assert(user instanceof User, 'You must include a user when checking to see if a review can be assigned');
        assert(type, 'You must include the review type when checking if review can be assigned');

        actions = this.get('actions');
        assignReviewAction = actions && actions.findWhere({ code: Review.ACTION_NAMES.ASSIGN_REVIEW });
        if (type === Review.TYPE.IMAGE_PROCESSING) {
            permissionNeeded = Permission.PERMISSION_REVIEW_PHOTO_ASSIGN;
        } else if (type === Review.TYPE.DATA_QUALITY) {
            permissionNeeded = Permission.PERMISSION_REVIEW_DATA_ASSIGN;
        }

        return !!(assignReviewAction && permissionNeeded && user.hasPermission(permissionNeeded));
    },

    /**
     * Returns true if the review can be approved and the user has permission to do so
     * @param {User} user
     * @param {string} type - The type of Review
     * @returns {boolean}
     */
    canApproveReview: function (user, type) {
        var actions;
        var approveReviewAction;
        var permissionNeeded;
        assert(user instanceof User, 'You must include a user when checking to see if a review can be approved');
        assert(type, 'You must include the review type when checking if review can be approved');

        actions = this.get('actions');
        approveReviewAction = actions && actions.findWhere({ code: Review.ACTION_NAMES.APPROVE_REVIEW });
        if (type === Review.TYPE.IMAGE_PROCESSING) {
            permissionNeeded = Permission.PERMISSION_REVIEW_APPROVE_PHOTO_DOCUMENT;
        } else if (type === Review.TYPE.DATA_QUALITY) {
            permissionNeeded = Permission.PERMISSION_REVIEW_APPROVE_DATA_DOCUMENT;
        }

        return !!(approveReviewAction && permissionNeeded && user.hasPermission(permissionNeeded));
    },

    /**
     * Delete expert review - indicates rejection of an item
     * @param options - contains the associated item, and the details of the rejection
     */
    rejectExpertReview: function (options) {
        var subject;
        var notes;
        options = options || {};
        assert(options.itemId, 'You must include an associated item for this rejection.');
        assert(options.rejectReason, 'You must include a reason for this rejection.');
        assert(options.rejectMessage, 'You must include a message for this rejection.');
        assert(this.isTypeExpertReview(), 'Review must be type EXPERT_REVIEW to be rejected.');

        subject = {
            apiType : 'anchor',
            sourceId : options.itemId,
            sourceType : Review.SUBJECT_TYPE.ITEM
        };
        notes = [{
            "apiType": "note",
            "type": Note.TYPE_EXPERT_REVIEW_REJECTION,
            "content": options.rejectMessage
        }];

        this.markDeleted();
        this.set({
            reasonCode : options.rejectReason,
            subject : subject,
            notes : notes
        });

        return this.save(null, {queries : {
            indexMode : "sync"
        }});
    }
}, transitionMixin);

_.extend(Review, {
    STATUS: REVIEW_STATUSES,

    TYPE: REVIEW_TYPES,

    SUBJECT_TYPE: REVIEW_SUBJECT_TYPES,

    ACTION_NAMES: REVIEW_ACTION_NAMES,

    REASON_CODES: REASON_CODES
});


/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var ends = __webpack_require__(6);
var _ = __webpack_require__(0);
var NO = 'N';
var YES = 'Y';

/**
 * Mailer model is sed to add an item to the mailer or remove an item from the mailer
 * @extends SoaModel
 */
var StorefrontPreferences = SoaModel.extend({
    initialize: function(attrs, options) {
        options = options || {};
        StorefrontPreferences.__super__.initialize.call(this, attrs, options);
        this.itemId = options.itemId;
    },
    url: function() {
        console.assert(this.itemId, 'StorefrontPreferences requires itemId to generate URL');
        return ends.itemStorefrontPreferences(this.itemId);
    },
    hideWhenSold: function(options) {
        return this.save({ showOnStorefrontWhenSold: NO }, _.extend({ type: 'PUT' }, options));
    },
    showWhenSold: function(options) {
        return this.save({ showOnStorefrontWhenSold: YES }, _.extend({ type: 'PUT' }, options));
    }
});

module.exports = StorefrontPreferences;


/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = ['USD', 'GBP', 'EUR', 'CAD', 'AUD', 'CHF', 'MXN'];


/***/ }),
/* 2060 */
/***/ (function(module, exports) {

/*!
 * jQuery UI Position 1.10.0
 * http://jqueryui.com
 *
 * Copyright 2013 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/position/
 */
(function( $, undefined ) {

$.ui = $.ui || {};

var cachedScrollbarWidth,
	max = Math.max,
	abs = Math.abs,
	round = Math.round,
	rhorizontal = /left|center|right/,
	rvertical = /top|center|bottom/,
	roffset = /[\+\-]\d+%?/,
	rposition = /^\w+/,
	rpercent = /%$/,
	_position = $.fn.position;

function getOffsets( offsets, width, height ) {
	return [
		parseInt( offsets[ 0 ], 10 ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
		parseInt( offsets[ 1 ], 10 ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
	];
}

function parseCss( element, property ) {
	return parseInt( $.css( element, property ), 10 ) || 0;
}

function getDimensions( elem ) {
	var raw = elem[0];
	if ( raw.nodeType === 9 ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: 0, left: 0 }
		};
	}
	if ( $.isWindow( raw ) ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
		};
	}
	if ( raw.preventDefault ) {
		return {
			width: 0,
			height: 0,
			offset: { top: raw.pageY, left: raw.pageX }
		};
	}
	return {
		width: elem.outerWidth(),
		height: elem.outerHeight(),
		offset: elem.offset()
	};
}

$.position = {
	scrollbarWidth: function() {
		if ( cachedScrollbarWidth !== undefined ) {
			return cachedScrollbarWidth;
		}
		var w1, w2,
			div = $( "<div style='display:block;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>" ),
			innerDiv = div.children()[0];

		$( "body" ).append( div );
		w1 = innerDiv.offsetWidth;
		div.css( "overflow", "scroll" );

		w2 = innerDiv.offsetWidth;

		if ( w1 === w2 ) {
			w2 = div[0].clientWidth;
		}

		div.remove();

		return (cachedScrollbarWidth = w1 - w2);
	},
	getScrollInfo: function( within ) {
		var overflowX = within.isWindow ? "" : within.element.css( "overflow-x" ),
			overflowY = within.isWindow ? "" : within.element.css( "overflow-y" ),
			hasOverflowX = overflowX === "scroll" ||
				( overflowX === "auto" && within.width < within.element[0].scrollWidth ),
			hasOverflowY = overflowY === "scroll" ||
				( overflowY === "auto" && within.height < within.element[0].scrollHeight );
		return {
			width: hasOverflowX ? $.position.scrollbarWidth() : 0,
			height: hasOverflowY ? $.position.scrollbarWidth() : 0
		};
	},
	getWithinInfo: function( element ) {
		var withinElement = $( element || window ),
			isWindow = $.isWindow( withinElement[0] );
		return {
			element: withinElement,
			isWindow: isWindow,
			offset: withinElement.offset() || { left: 0, top: 0 },
			scrollLeft: withinElement.scrollLeft(),
			scrollTop: withinElement.scrollTop(),
			width: isWindow ? withinElement.width() : withinElement.outerWidth(),
			height: isWindow ? withinElement.height() : withinElement.outerHeight()
		};
	}
};

$.fn.position = function( options ) {
	if ( !options || !options.of ) {
		return _position.apply( this, arguments );
	}

	// make a copy, we don't want to modify arguments
	options = $.extend( {}, options );

	var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,
		target = $( options.of ),
		within = $.position.getWithinInfo( options.within ),
		scrollInfo = $.position.getScrollInfo( within ),
		collision = ( options.collision || "flip" ).split( " " ),
		offsets = {};

	dimensions = getDimensions( target );
	if ( target[0].preventDefault ) {
		// force left top to allow flipping
		options.at = "left top";
	}
	targetWidth = dimensions.width;
	targetHeight = dimensions.height;
	targetOffset = dimensions.offset;
	// clone to reuse original targetOffset later
	basePosition = $.extend( {}, targetOffset );

	// force my and at to have valid horizontal and vertical positions
	// if a value is missing or invalid, it will be converted to center
	$.each( [ "my", "at" ], function() {
		var pos = ( options[ this ] || "" ).split( " " ),
			horizontalOffset,
			verticalOffset;

		if ( pos.length === 1) {
			pos = rhorizontal.test( pos[ 0 ] ) ?
				pos.concat( [ "center" ] ) :
				rvertical.test( pos[ 0 ] ) ?
					[ "center" ].concat( pos ) :
					[ "center", "center" ];
		}
		pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
		pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";

		// calculate offsets
		horizontalOffset = roffset.exec( pos[ 0 ] );
		verticalOffset = roffset.exec( pos[ 1 ] );
		offsets[ this ] = [
			horizontalOffset ? horizontalOffset[ 0 ] : 0,
			verticalOffset ? verticalOffset[ 0 ] : 0
		];

		// reduce to just the positions without the offsets
		options[ this ] = [
			rposition.exec( pos[ 0 ] )[ 0 ],
			rposition.exec( pos[ 1 ] )[ 0 ]
		];
	});

	// normalize collision option
	if ( collision.length === 1 ) {
		collision[ 1 ] = collision[ 0 ];
	}

	if ( options.at[ 0 ] === "right" ) {
		basePosition.left += targetWidth;
	} else if ( options.at[ 0 ] === "center" ) {
		basePosition.left += targetWidth / 2;
	}

	if ( options.at[ 1 ] === "bottom" ) {
		basePosition.top += targetHeight;
	} else if ( options.at[ 1 ] === "center" ) {
		basePosition.top += targetHeight / 2;
	}

	atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
	basePosition.left += atOffset[ 0 ];
	basePosition.top += atOffset[ 1 ];

	return this.each(function() {
		var collisionPosition, using,
			elem = $( this ),
			elemWidth = elem.outerWidth(),
			elemHeight = elem.outerHeight(),
			marginLeft = parseCss( this, "marginLeft" ),
			marginTop = parseCss( this, "marginTop" ),
			collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) + scrollInfo.width,
			collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) + scrollInfo.height,
			position = $.extend( {}, basePosition ),
			myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );

		if ( options.my[ 0 ] === "right" ) {
			position.left -= elemWidth;
		} else if ( options.my[ 0 ] === "center" ) {
			position.left -= elemWidth / 2;
		}

		if ( options.my[ 1 ] === "bottom" ) {
			position.top -= elemHeight;
		} else if ( options.my[ 1 ] === "center" ) {
			position.top -= elemHeight / 2;
		}

		position.left += myOffset[ 0 ];
		position.top += myOffset[ 1 ];

		// if the browser doesn't support fractions, then round for consistent results
		if ( !$.support.offsetFractions ) {
			position.left = round( position.left );
			position.top = round( position.top );
		}

		collisionPosition = {
			marginLeft: marginLeft,
			marginTop: marginTop
		};

		$.each( [ "left", "top" ], function( i, dir ) {
			if ( $.ui.position[ collision[ i ] ] ) {
				$.ui.position[ collision[ i ] ][ dir ]( position, {
					targetWidth: targetWidth,
					targetHeight: targetHeight,
					elemWidth: elemWidth,
					elemHeight: elemHeight,
					collisionPosition: collisionPosition,
					collisionWidth: collisionWidth,
					collisionHeight: collisionHeight,
					offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
					my: options.my,
					at: options.at,
					within: within,
					elem : elem
				});
			}
		});

		if ( options.using ) {
			// adds feedback as second argument to using callback, if present
			using = function( props ) {
				var left = targetOffset.left - position.left,
					right = left + targetWidth - elemWidth,
					top = targetOffset.top - position.top,
					bottom = top + targetHeight - elemHeight,
					feedback = {
						target: {
							element: target,
							left: targetOffset.left,
							top: targetOffset.top,
							width: targetWidth,
							height: targetHeight
						},
						element: {
							element: elem,
							left: position.left,
							top: position.top,
							width: elemWidth,
							height: elemHeight
						},
						horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
						vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
					};
				if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
					feedback.horizontal = "center";
				}
				if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
					feedback.vertical = "middle";
				}
				if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
					feedback.important = "horizontal";
				} else {
					feedback.important = "vertical";
				}
				options.using.call( this, props, feedback );
			};
		}

		elem.offset( $.extend( position, { using: using } ) );
	});
};

$.ui.position = {
	fit: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
				outerWidth = within.width,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = withinOffset - collisionPosLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
				newOverRight;

			// element is wider than within
			if ( data.collisionWidth > outerWidth ) {
				// element is initially over the left side of within
				if ( overLeft > 0 && overRight <= 0 ) {
					newOverRight = position.left + overLeft + data.collisionWidth - outerWidth - withinOffset;
					position.left += overLeft - newOverRight;
				// element is initially over right side of within
				} else if ( overRight > 0 && overLeft <= 0 ) {
					position.left = withinOffset;
				// element is initially over both left and right sides of within
				} else {
					if ( overLeft > overRight ) {
						position.left = withinOffset + outerWidth - data.collisionWidth;
					} else {
						position.left = withinOffset;
					}
				}
			// too far left -> align with left edge
			} else if ( overLeft > 0 ) {
				position.left += overLeft;
			// too far right -> align with right edge
			} else if ( overRight > 0 ) {
				position.left -= overRight;
			// adjust based on position and margin
			} else {
				position.left = max( position.left - collisionPosLeft, position.left );
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
				outerHeight = data.within.height,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = withinOffset - collisionPosTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
				newOverBottom;

			// element is taller than within
			if ( data.collisionHeight > outerHeight ) {
				// element is initially over the top of within
				if ( overTop > 0 && overBottom <= 0 ) {
					newOverBottom = position.top + overTop + data.collisionHeight - outerHeight - withinOffset;
					position.top += overTop - newOverBottom;
				// element is initially over bottom of within
				} else if ( overBottom > 0 && overTop <= 0 ) {
					position.top = withinOffset;
				// element is initially over both top and bottom of within
				} else {
					if ( overTop > overBottom ) {
						position.top = withinOffset + outerHeight - data.collisionHeight;
					} else {
						position.top = withinOffset;
					}
				}
			// too far up -> align with top
			} else if ( overTop > 0 ) {
				position.top += overTop;
			// too far down -> align with bottom edge
			} else if ( overBottom > 0 ) {
				position.top -= overBottom;
			// adjust based on position and margin
			} else {
				position.top = max( position.top - collisionPosTop, position.top );
			}
		}
	},
	flip: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.left + within.scrollLeft,
				outerWidth = within.width,
				offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = collisionPosLeft - offsetLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
				myOffset = data.my[ 0 ] === "left" ?
					-data.elemWidth :
					data.my[ 0 ] === "right" ?
						data.elemWidth :
						0,
				atOffset = data.at[ 0 ] === "left" ?
					data.targetWidth :
					data.at[ 0 ] === "right" ?
						-data.targetWidth :
						0,
				offset = -2 * data.offset[ 0 ],
				newOverRight,
				newOverLeft;

			if ( overLeft < 0 ) {
				newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth - outerWidth - withinOffset;
				if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
					position.left += myOffset + atOffset + offset;
				}
			}
			else if ( overRight > 0 ) {
				newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset + atOffset + offset - offsetLeft;
				if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
					position.left += myOffset + atOffset + offset;
				}
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.top + within.scrollTop,
				outerHeight = within.height,
				offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = collisionPosTop - offsetTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
				top = data.my[ 1 ] === "top",
				myOffset = top ?
					-data.elemHeight :
					data.my[ 1 ] === "bottom" ?
						data.elemHeight :
						0,
				atOffset = data.at[ 1 ] === "top" ?
					data.targetHeight :
					data.at[ 1 ] === "bottom" ?
						-data.targetHeight :
						0,
				offset = -2 * data.offset[ 1 ],
				newOverTop,
				newOverBottom;
			if ( overTop < 0 ) {
				newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight - outerHeight - withinOffset;
				if ( ( position.top + myOffset + atOffset + offset) > overTop && ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) ) {
					position.top += myOffset + atOffset + offset;
				}
			}
			else if ( overBottom > 0 ) {
				newOverTop = position.top -  data.collisionPosition.marginTop + myOffset + atOffset + offset - offsetTop;
				if ( ( position.top + myOffset + atOffset + offset) > overBottom && ( newOverTop > 0 || abs( newOverTop ) < overBottom ) ) {
					position.top += myOffset + atOffset + offset;
				}
			}
		}
	},
	flipfit: {
		left: function() {
			$.ui.position.flip.left.apply( this, arguments );
			$.ui.position.fit.left.apply( this, arguments );
		},
		top: function() {
			$.ui.position.flip.top.apply( this, arguments );
			$.ui.position.fit.top.apply( this, arguments );
		}
	}
};

// fraction support test
(function () {
	var testElement, testElementParent, testElementStyle, offsetLeft, i,
		body = document.getElementsByTagName( "body" )[ 0 ],
		div = document.createElement( "div" );

	//Create a "fake body" for testing based on method used in jQuery.support
	testElement = document.createElement( body ? "div" : "body" );
	testElementStyle = {
		visibility: "hidden",
		width: 0,
		height: 0,
		border: 0,
		margin: 0,
		background: "none"
	};
	if ( body ) {
		$.extend( testElementStyle, {
			position: "absolute",
			left: "-1000px",
			top: "-1000px"
		});
	}
	for ( i in testElementStyle ) {
		testElement.style[ i ] = testElementStyle[ i ];
	}
	testElement.appendChild( div );
	testElementParent = body || document.documentElement;
	testElementParent.insertBefore( testElement, testElementParent.firstChild );

	div.style.cssText = "position: absolute; left: 10.7432222px;";

	offsetLeft = $( div ).offset().left;
	$.support.offsetFractions = offsetLeft > 10 && offsetLeft < 11;

	testElement.innerHTML = "";
	testElementParent.removeChild( testElement );
})();

}( jQuery ) );


/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1558);
__webpack_require__(1964);
module.exports = __webpack_require__(2686);

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global         = __webpack_require__(1438)
  , $export        = __webpack_require__(1978)
  , meta           = __webpack_require__(1556)
  , fails          = __webpack_require__(4250)
  , hide           = __webpack_require__(2320)
  , redefineAll    = __webpack_require__(1468)
  , forOf          = __webpack_require__(1223)
  , anInstance     = __webpack_require__(1467)
  , isObject       = __webpack_require__(566)
  , setToStringTag = __webpack_require__(2309)
  , dP             = __webpack_require__(600).f
  , each           = __webpack_require__(1627)(0)
  , DESCRIPTORS    = __webpack_require__(1979);

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  if(!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function(target, iterable){
      anInstance(target, C, NAME, '_c');
      target._c = new Base;
      if(iterable != undefined)forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','),function(KEY){
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if(KEY in proto && !(IS_WEAK && KEY == 'clear'))hide(C.prototype, KEY, function(a, b){
        anInstance(this, C, KEY);
        if(!IS_ADDER && IS_WEAK && !isObject(a))return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    if('size' in proto)dP(C.prototype, 'size', {
      get: function(){
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__(1438)
  , core        = __webpack_require__(674)
  , dP          = __webpack_require__(600)
  , DESCRIPTORS = __webpack_require__(1979)
  , SPECIES     = __webpack_require__(585)('species');

module.exports = function(KEY){
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(1428)
  , invoke             = __webpack_require__(2683)
  , html               = __webpack_require__(4232)
  , cel                = __webpack_require__(4215)
  , global             = __webpack_require__(1438)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(2308)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(4251)
  , toIObject = __webpack_require__(2317)
  , isEnum    = __webpack_require__(4208).f;
module.exports = function(isEntries){
  return function(it){
    var O      = toIObject(it)
      , keys   = getKeys(O)
      , length = keys.length
      , i      = 0
      , result = []
      , key;
    while(length > i)if(isEnum.call(O, key = keys[i++])){
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};

/***/ }),
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = ['USD', 'GBP', 'EUR', 'CAD', 'AUD', 'CHF', 'MXN'];


/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};


/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

exports.arrayToObject = function (source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

exports.merge = function (target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = exports.arrayToObject(target, options);
    }

    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') {
                    target[i] = exports.merge(target[i], item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (Object.prototype.hasOwnProperty.call(acc, key)) {
            acc[key] = exports.merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

exports.decode = function (str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function (str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D || // -
            c === 0x2E || // .
            c === 0x5F || // _
            c === 0x7E || // ~
            (c >= 0x30 && c <= 0x39) || // 0-9
            (c >= 0x41 && c <= 0x5A) || // a-z
            (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)] + hexTable[0x80 | ((c >> 12) & 0x3F)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]; // eslint-disable-line max-len
    }

    return out;
};

exports.compact = function (obj, references) {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }

    var refs = references || [];
    var lookup = refs.indexOf(obj);
    if (lookup !== -1) {
        return refs[lookup];
    }

    refs.push(obj);

    if (Array.isArray(obj)) {
        var compacted = [];

        for (var i = 0; i < obj.length; ++i) {
            if (obj[i] && typeof obj[i] === 'object') {
                compacted.push(exports.compact(obj[i], refs));
            } else if (typeof obj[i] !== 'undefined') {
                compacted.push(obj[i]);
            }
        }

        return compacted;
    }

    var keys = Object.keys(obj);
    keys.forEach(function (key) {
        obj[key] = exports.compact(obj[key], refs);
    });

    return obj;
};

exports.isRegExp = function (obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

exports.isBuffer = function (obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};


/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var symbols = __webpack_require__(280).symbols;

module.exports = function getCurrencySymbol(currencyENUM) {
    return symbols[currencyENUM];
};


/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPriceAmountByCurrency = exports.isPriceHidden = exports.isNegotiable = exports.getAmount = exports.getNegotiable = exports.getHidePrice = undefined;

var _createSelector = __webpack_require__(1244);

var _createSelector2 = _interopRequireDefault(_createSelector);

var _makeSelectorHelpers = __webpack_require__(1474);

var _amount = __webpack_require__(2797);

var _lodash = __webpack_require__(1475);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Base Getters
// ------------------------------------------

var getHidePrice = exports.getHidePrice = function getHidePrice(price) {
  return (0, _lodash2.default)(price, 'hidePrice');
};
var getNegotiable = exports.getNegotiable = function getNegotiable(price) {
  return (0, _lodash2.default)(price, 'negotiable');
};
var getAmount = exports.getAmount = function getAmount(price) {
  return (0, _lodash2.default)(price, 'amount', {});
};

// Selectors
// ------------------------------------------

var isNegotiable = exports.isNegotiable = (0, _makeSelectorHelpers.makeYesCheckSelector)(getNegotiable);
var isPriceHidden = exports.isPriceHidden = (0, _makeSelectorHelpers.makeYesCheckSelector)(getHidePrice);
var getPriceAmountByCurrency = exports.getPriceAmountByCurrency = (0, _createSelector2.default)(getAmount, _amount.getAmountByCurrency);

/***/ }),
/* 2084 */
/***/ (function(module, exports) {

/*
 * File created for running jasmine tests in node.
 * Webpack config makes require call to _gas return window._gas.
 * However webpack is not used when running tests from node. Hence,
 * check if _gas exists on window (as webpack does) and return it if it exists
 * else it returns []
 */

// check for `window` since `window` is undefined if this file is run via node
module.exports = typeof window !== 'undefined' ? (window._gas || []) : [];


/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * For Google Tag Manager
 */


var root = typeof window === 'undefined' ? global : window;
root.dataLayer = root.dataLayer || [];
module.exports = root.dataLayer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-logo-trade'].join(' '), 'data-tn': 'logo-trade', viewBox: '0 0 124 44' },
                React.createElement('polygon', { className: 'dibsvg-logo-trade-fill', points: '79.4003136 43.0832419 79.4003136 35.8335867 84.3411082 35.8335867 84.3411082 36.9539315 80.6644532 36.9539315 80.6644532 38.8346212 84.2654759 38.8346212 84.2654759 39.9534143 80.6644532 39.9534143 80.6644532 41.962897 84.3411082 41.962897 84.3411082 43.0832419' }),
                React.createElement('polygon', { className: 'dibsvg-logo-trade-fill', points: '32.605077 35.8337414 32.605077 36.9540862 34.789152 36.9540862 34.789152 43.0833966 36.0548351 43.0833966 36.0548351 36.9540862 38.2389102 36.9540862 38.2389102 35.8337414' }),
                React.createElement('polygon', { className: 'dibsvg-logo-trade-bar-fill', points: '90.7078029 40.6222074 116.947574 40.6222074 116.947574 38.2946212 90.7078029 38.2946212' }),
                React.createElement('polygon', { className: 'dibsvg-logo-trade-bar-fill', points: '0 40.6222074 26.2397715 40.6222074 26.2397715 38.2946212 0 38.2946212' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M72.2931943,39.4646212 C72.2931943,38.0634143 71.4272819,36.9539315 69.8173947,36.9539315 L68.4019906,36.9539315 L68.4019906,41.962897 L69.8173947,41.962897 C71.3856069,41.962897 72.2931943,40.8332419 72.2931943,39.4646212 L72.2931943,39.4646212 Z M67.1363075,43.0832419 L67.1363075,35.8335867 L69.8173947,35.8335867 C72.067841,35.8335867 73.5912913,37.3341039 73.5912913,39.4646212 C73.5912913,41.5935867 72.067841,43.0832419 69.8173947,43.0832419 L67.1363075,43.0832419 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M58.1393074,37.1173279 L56.8412105,40.5730175 L59.4358608,40.5730175 L58.1393074,37.1173279 Z M60.321839,43.0837072 L59.792413,41.6918107 L56.4846583,41.6918107 L55.9552323,43.0837072 L54.5166754,43.0837072 L57.3490272,35.834052 L58.928044,35.834052 L61.7603958,43.0837072 L60.321839,43.0837072 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M48.1237408,38.1053108 C48.1237408,37.4101384 47.6051195,36.9539315 46.8920151,36.9539315 L45.1617337,36.9539315 L45.1617337,39.2566901 L46.8920151,39.2566901 C47.6051195,39.2566901 48.1237408,38.8004832 48.1237408,38.1053108 Z M48.0156947,43.0832419 L46.4150687,40.377035 L45.1617337,40.377035 L45.1617337,43.0832419 L43.8960506,43.0832419 L43.8960506,35.8335867 L47.0633454,35.8335867 C48.4910976,35.8335867 49.4202943,36.7692763 49.4202943,38.1053108 C49.4202943,39.3994488 48.5775345,40.0946212 47.7131656,40.2358281 L49.4743173,43.0832419 L48.0156947,43.0832419 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M119.348668,26.8801384 L120.83353,26.8801384 C121.370674,26.8801384 121.719508,27.0151384 121.932513,27.2292763 C122.113105,27.4108281 122.208803,27.642035 122.208803,27.9601384 L122.208803,27.9756557 C122.208803,28.4116901 121.980362,28.722035 121.608375,28.8973798 L122.319936,29.937035 L121.165386,29.937035 L120.581937,29.0634143 L120.564958,29.0634143 L120.367388,29.0634143 L120.367388,29.937035 L119.348668,29.937035 L119.348668,26.8801384 Z M120.80266,28.3325522 C121.048079,28.3325522 121.1978,28.2285867 121.1978,28.0392763 L121.1978,28.0237591 C121.1978,27.832897 121.038818,27.7366901 120.810377,27.7366901 L120.367388,27.7366901 L120.367388,28.3325522 L120.80266,28.3325522 Z M117.823674,28.507897 L117.823674,28.4908281 C117.823674,26.9266901 119.087814,25.5922074 120.691527,25.5922074 C122.29524,25.5922074 123.543944,26.9111729 123.543944,28.4753108 L123.543944,28.4908281 C123.543944,30.0565177 122.279805,31.3894488 120.676092,31.3894488 C119.072378,31.3894488 117.823674,30.072035 117.823674,28.507897 Z M123.212088,28.4908281 L123.212088,28.4753108 C123.212088,27.0694488 122.130084,25.9103108 120.691527,25.9103108 C119.246796,25.9103108 118.15553,27.0865177 118.15553,28.4908281 L118.15553,28.507897 C118.15553,29.9137591 119.239078,31.072897 120.676092,31.072897 C122.122366,31.072897 123.212088,29.8966901 123.212088,28.4908281 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M117.049909,10.254966 L116.117626,16.7846212 L115.327346,16.7846212 C115.216212,15.1072074 114.702222,13.7851384 113.786917,12.819966 C112.870068,11.8563453 111.888392,11.3737591 110.840345,11.3737591 C110.196699,11.3737591 109.665729,11.5630694 109.247436,11.9432419 C108.8276,12.3234143 108.617682,12.7811729 108.617682,13.314966 C108.617682,13.7665177 108.708749,14.1885867 108.890884,14.5811729 C109.073019,14.9768626 109.478964,15.5106557 110.108718,16.1872074 C112.32212,18.579966 113.666522,20.2247936 114.145012,21.1216901 C114.621959,22.0201384 114.861204,22.9806557 114.861204,24.0032419 C114.861204,25.1111729 114.580284,26.1601384 114.018444,27.1485867 C113.456604,28.137035 112.618475,28.929966 111.502513,29.5258281 C110.386551,30.1216901 109.224283,30.4196212 108.017254,30.4196212 C107.203821,30.4196212 106.200536,30.262897 105.007398,29.9525522 C104.221748,29.7353108 103.632125,29.6282419 103.238529,29.6282419 C102.88815,29.6282419 102.613405,29.677897 102.417378,29.7803108 C102.219808,29.8811729 102.002172,30.0937591 101.764471,30.4196212 L100.975734,30.4196212 L102.016064,23.3856557 L102.696754,23.3856557 C103.187593,25.1003108 103.64756,26.3230694 104.075114,27.0539315 C104.502668,27.7832419 105.073769,28.3651384 105.788417,28.7965177 C106.503065,29.2294488 107.189929,29.4451384 107.849011,29.4451384 C108.620769,29.4451384 109.258241,29.2030694 109.762971,28.7173798 C110.2677,28.2316901 110.519293,27.6513453 110.519293,26.9747936 C110.519293,26.3137591 110.354137,25.672897 110.025368,25.0537591 C109.695056,24.4346212 108.935646,23.4710005 107.744052,22.1613453 C106.103294,20.3737591 105.022833,18.9927246 104.502668,18.0166901 C104.135311,17.3106557 103.953176,16.5037591 103.953176,15.5991039 C103.953176,14.0722074 104.504212,12.7997936 105.606282,11.7818626 C106.708352,10.7639315 108.256499,10.254966 110.250722,10.254966 C111.121265,10.254966 112.189378,10.4163453 113.453517,10.7375522 C114.084815,10.8989315 114.591089,10.9780694 114.96925,10.9780694 C115.517198,10.9780694 115.958644,10.7375522 116.296674,10.254966 L117.049909,10.254966 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M93.6522139,0.55234531 L89.9277099,13.243897 C90.9850183,12.045966 91.8679095,11.2483798 92.5779268,10.8511384 C93.2864007,10.453897 94.0566151,10.2552763 94.8854832,10.2552763 C96.4922833,10.2552763 97.6931387,10.8635522 98.489593,12.0816557 C99.2860472,13.2997591 99.6842743,14.7025177 99.6842743,16.293035 C99.6842743,20.0947591 98.3398719,23.4868281 95.6526106,26.4707936 C93.2663349,29.1025177 90.5512904,30.4183798 87.5074769,30.4183798 C85.2446825,30.4183798 82.8522327,29.7402763 80.3301276,28.3840694 L86.840678,6.11062117 C87.1432071,5.05079359 87.3145374,4.31062117 87.3562123,3.88855221 C87.3562123,3.52700048 87.2049477,3.23993152 86.9024186,3.02889703 C86.4779517,2.72941428 85.8358491,2.6021729 84.9730237,2.64406945 L85.1520715,1.81389703 L92.3587476,0.55234531 L93.6522139,0.55234531 Z M85.4252738,28.5935522 C86.0550283,29.0171729 86.6245857,29.2282074 87.1324025,29.2282074 C87.8424198,29.2282074 88.438217,29.0807936 88.9213375,28.7844143 C89.6838344,28.3049315 90.4849192,27.4375177 91.3215048,26.1806212 C92.159634,24.9252763 92.8588467,23.4076901 93.4222301,21.630966 C93.9840699,19.8526901 94.2649898,18.0821729 94.2649898,16.3178626 C94.2649898,15.3170005 94.0550716,14.5535522 93.6383223,14.0321729 C93.2200295,13.5107936 92.7353655,13.2485522 92.1858738,13.2485522 C91.2705688,13.2485522 90.472571,13.7420005 89.793424,14.7257936 C89.3349998,15.3635522 88.8379876,16.7182074 88.3023876,18.7882074 L85.4252738,28.5935522 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M78.995295,10.254966 L74.3138111,25.1484143 C74.0560439,26.0003108 73.9263886,26.5589315 73.9263886,26.8242763 C73.9263886,26.9856557 73.9881292,27.1346212 74.113154,27.2742763 C74.2381788,27.4123798 74.3709212,27.4822074 74.5098376,27.4822074 C74.7459956,27.4822074 74.9821535,27.372035 75.2183114,27.1532419 C75.8434354,26.6116901 76.5935842,25.6325522 77.4687577,24.2142763 L78.1864926,24.6534143 C76.0548971,28.497035 73.7890157,30.4196212 71.3888483,30.4196212 C70.4704563,30.4196212 69.7403733,30.1635867 69.1970556,29.6515177 C68.6521945,29.1410005 68.3805357,28.4923798 68.3805357,27.7072074 C68.3805357,27.1858281 68.5117346,26.5216901 68.7756758,25.717897 L71.9985371,15.6037591 C72.3072403,14.6308281 72.4615919,13.8968626 72.4615919,13.4034143 C72.4615919,13.0930694 72.3195885,12.8184143 72.037125,12.577897 C71.7531181,12.3373798 71.3656956,12.217897 70.873314,12.217897 C70.6495042,12.217897 70.3809324,12.2241039 70.0675987,12.2396212 L70.3546926,11.4094488 L77.6956546,10.254966 L78.995295,10.254966 Z M77.2866228,0.552034966 C78.1633399,0.552034966 78.9011405,0.8561729 79.5015682,1.46444876 C80.1004524,2.07272462 80.4014381,2.80824186 80.4014381,3.67255221 C80.4014381,4.53531083 80.0973654,5.27082807 79.4907636,5.87910393 C78.8826183,6.48893152 78.1479047,6.79151772 77.2866228,6.79151772 C76.4392326,6.79151772 75.7122365,6.48893152 75.1056348,5.87910393 C74.4974895,5.27082807 74.1934168,4.53531083 74.1934168,3.67255221 C74.1934168,2.80824186 74.4944024,2.07272462 75.0948302,1.46444876 C75.6937144,0.8561729 76.4253409,0.552034966 77.2866228,0.552034966 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M69.8085967,0.551414276 L62.683727,24.1515867 C62.2299333,25.6288281 62.0045799,26.5210694 62.0045799,26.8298626 C62.0045799,26.9865867 62.058603,27.1215867 62.1712797,27.2348626 C62.2824128,27.3481384 62.4012635,27.4040005 62.5262883,27.4040005 C62.7639898,27.4040005 63.0356486,27.282966 63.3428083,27.0424488 C63.8583426,26.6467591 64.4850101,25.8972763 65.2243542,24.7924488 L65.97759,25.195897 C64.0018896,28.677966 61.8317062,30.4190005 59.4639527,30.4190005 C58.62428,30.4190005 57.9760033,30.1971039 57.5206661,29.7548626 C57.0653288,29.3126212 56.838432,28.7477936 56.838432,28.0588281 C56.838432,27.3977936 57.0205669,26.4574488 57.3848366,25.2346901 L58.0485485,23.0777936 C56.2904838,26.1874488 54.7654901,28.255897 53.4720237,29.2815867 C52.488804,30.0403798 51.5318241,30.4190005 50.6057145,30.4190005 C49.5499496,30.4190005 48.6608844,29.9891729 47.9369754,29.1310694 C47.2146099,28.272966 46.8518837,27.0207246 46.8518837,25.3727936 C46.8518837,23.2764143 47.319569,21.2064143 48.2533962,19.165897 C49.1887669,17.1238281 50.2676845,15.4215867 51.4932362,14.0560694 C52.7172444,12.6905522 53.885686,11.7160694 54.998561,11.1310694 C56.1083489,10.5476212 57.2027018,10.2543453 58.2800759,10.2543453 C58.8311111,10.2543453 59.3234927,10.3707246 59.7556772,10.6003798 C60.1878616,10.8315867 60.6786997,11.262966 61.2312784,11.8960694 L62.8766665,6.66055221 C63.2965028,5.34313841 63.506421,4.39813841 63.506421,3.82555221 C63.506421,3.48106945 63.362874,3.18779359 63.0773235,2.94572462 C62.7902296,2.70210393 62.4089811,2.58106945 61.9320347,2.58106945 C61.7082249,2.58106945 61.430392,2.60279359 61.0969926,2.64313841 L61.2760404,1.81451772 L68.4919776,0.551414276 L69.8085967,0.551414276 Z M60.368453,13.917966 C60.368453,13.0583108 60.1971227,12.4314143 59.8544622,12.0372763 C59.5118017,11.6431384 59.112031,11.4460694 58.6566938,11.4460694 C58.1998131,11.4460694 57.7074315,11.6788281 57.179549,12.1427936 C56.165459,13.0443453 55.1066071,14.8583108 53.9999061,17.5846901 C52.8947487,20.3110694 52.34217,22.6045177 52.34217,24.465035 C52.34217,25.1415867 52.4625642,25.6412419 52.7064398,25.9655522 C52.9487718,26.2898626 53.2188871,26.4512419 53.5198727,26.4512419 C54.0184283,26.4512419 54.5185275,26.2262419 55.0170832,25.7746901 C56.2302867,24.7040005 57.4249681,22.8621039 58.6026707,20.2474488 C59.7803734,17.6343453 60.368453,15.5240005 60.368453,13.917966 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M46.8691711,5.09672462 L45.1080193,10.831897 L47.4618812,10.831897 L46.7256241,13.2494832 L44.3378049,13.2494832 L40.5222334,25.6679315 C40.2783579,26.4391384 40.1564201,27.0241384 40.1564201,27.4244832 C40.1564201,27.5594832 40.2181608,27.6758626 40.3447291,27.7751729 C40.4712974,27.8729315 40.6102138,27.9225867 40.7645654,27.9225867 C41.0022669,27.9225867 41.2476859,27.8232763 41.499279,27.6262074 C42.1429252,27.1327591 42.8915304,26.2715522 43.7435512,25.0441384 L44.4983305,25.5096557 C43.5290025,27.2025867 42.462433,28.443966 41.2986219,29.2337936 C40.1332674,30.0236212 38.989522,30.4193108 37.8673859,30.4193108 C36.9119496,30.4193108 36.1726054,30.1772419 35.6462665,29.6946557 C35.1199275,29.2105177 34.8575298,28.5975867 34.8575298,27.8558626 C34.8575298,27.0365522 35.0535563,25.986035 35.4456094,24.7012074 L39.0219359,13.2494832 L36.32387,13.2494832 L36.7220971,11.6900005 C38.4276822,11.0305177 39.9110011,10.2577591 41.1720536,9.37327634 C42.4331062,8.48879359 43.9519259,7.0627591 45.7300563,5.09672462 L46.8691711,5.09672462 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M33.3110812,10.254966 L32.3787975,16.7846212 L31.5885173,16.7846212 C31.4773842,15.1072074 30.9633934,13.7851384 30.0480884,12.819966 C29.1312399,11.8563453 28.1495638,11.3737591 27.1015164,11.3737591 C26.4578703,11.3737591 25.9269008,11.5630694 25.5086079,11.9432419 C25.0887716,12.3234143 24.8788534,12.7811729 24.8788534,13.314966 C24.8788534,13.7665177 24.9699209,14.1885867 25.1520557,14.5811729 C25.3341906,14.9768626 25.7401353,15.5106557 26.3698898,16.1872074 C28.5832917,18.579966 29.9276942,20.2247936 30.4061841,21.1216901 C30.8831305,22.0201384 31.1223755,22.9806557 31.1223755,24.0032419 C31.1223755,25.1111729 30.8414556,26.1601384 30.2796158,27.1485867 C29.717776,28.137035 28.8796468,28.929966 27.7636848,29.5258281 C26.6477227,30.1216901 25.4854552,30.4196212 24.2784257,30.4196212 C23.4649928,30.4196212 22.4617074,30.262897 21.2685696,29.9525522 C20.4829199,29.7353108 19.8932968,29.6282419 19.4997003,29.6282419 C19.1493222,29.6282419 18.8745763,29.677897 18.6785498,29.7803108 C18.4809797,29.8811729 18.263344,30.0937591 18.0256425,30.4196212 L17.2369059,30.4196212 L18.2772356,23.3856557 L18.9579262,23.3856557 C19.4487642,25.1003108 19.908732,26.3230694 20.3362859,27.0539315 C20.7638399,27.7832419 21.3349408,28.3651384 22.0495887,28.7965177 C22.7642365,29.2294488 23.4511012,29.4451384 24.1101825,29.4451384 C24.8819405,29.4451384 25.5194125,29.2030694 26.0241423,28.7173798 C26.528872,28.2316901 26.7804651,27.6513453 26.7804651,26.9747936 C26.7804651,26.3137591 26.6153089,25.672897 26.28654,25.0537591 C25.9562276,24.4346212 25.1968177,23.4710005 24.0052234,22.1613453 C22.3644659,20.3737591 21.2840047,18.9927246 20.7638399,18.0166901 C20.3964831,17.3106557 20.2143482,16.5037591 20.2143482,15.5991039 C20.2143482,14.0722074 20.7653834,12.7997936 21.8674538,11.7818626 C22.9695242,10.7639315 24.5176707,10.254966 26.5118933,10.254966 C27.3824363,10.254966 28.4505494,10.4163453 29.714689,10.7375522 C30.345987,10.8989315 30.8522602,10.9780694 31.2304216,10.9780694 C31.7783698,10.9780694 32.2198154,10.7375522 32.5578454,10.254966 L33.3110812,10.254966 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M18.3369697,0.623879793 L11.2136435,24.6492246 C10.8493737,25.9076729 10.6672389,26.7083626 10.6672389,27.0466384 C10.6672389,27.386466 10.7968942,27.7371557 11.0562049,28.0971557 C11.3155156,28.4587074 11.5948919,28.6930177 11.8974211,28.798535 C12.1984067,28.9040522 13.1059941,29.0002591 14.6186397,29.0840522 L14.3886559,29.8428453 L0,29.8428453 L0.231527395,29.0840522 C1.66082318,29.0561212 2.65639098,28.9366384 3.21668728,28.7240522 C3.77698357,28.511466 4.23695133,28.1654315 4.59350352,27.684397 C4.95159922,27.2033626 5.35445689,26.1916384 5.80207652,24.6492246 L9.99117886,10.3795694 C10.6518037,8.21181083 10.9960078,7.06353497 11.0253346,6.93629359 C11.113315,6.57008669 11.1580769,6.22560393 11.1580769,5.90129359 C11.1580769,5.27284531 10.9635939,4.77319014 10.5777149,4.40232807 C10.1902924,4.031466 9.6377137,3.8452591 8.91997878,3.8452591 C8.56805714,3.8452591 7.87193144,3.9026729 6.83160167,4.01439703 L6.65101031,3.221466 L17.446361,0.623879793 L18.3369697,0.623879793 Z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2117 */,
/* 2118 */,
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var BASE62 = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

function base62(number) {
  if (!number) {
    return '0';
  }
  var string = '';
  while (number > 0) {
    string = BASE62[number % 62] + string;
    number = Math.floor(number / 62);
  }
  return string;
}

module.exports = base62;

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Executes the provided `callback` once for each enumerable own property in the
 * object. The `callback` is invoked with three arguments:
 *
 *  - the property value
 *  - the property name
 *  - the object being traversed
 *
 * Properties that are added after the call to `forEachObject` will not be
 * visited by `callback`. If the values of existing properties are changed, the
 * value passed to `callback` will be the value at the time `forEachObject`
 * visits them. Properties that are deleted before being visited are not
 * visited.
 *
 * @param {?object} object
 * @param {function} callback
 * @param {*} context
 */
function forEachObject(object, callback, context) {
  for (var name in object) {
    if (hasOwnProperty.call(object, name)) {
      callback.call(context, object[name], name, object);
    }
  }
}

module.exports = forEachObject;

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var inherits = __webpack_require__(59);

function FluxibleComponent(props, context) {
    React.Component.apply(this, arguments);
}

inherits(FluxibleComponent, React.Component);

FluxibleComponent.displayName = 'FluxibleComponent';
FluxibleComponent.propTypes = {
    context: PropTypes.object.isRequired
};
FluxibleComponent.childContextTypes = {
    executeAction: PropTypes.func.isRequired,
    getStore: PropTypes.func.isRequired
};

Object.assign(FluxibleComponent.prototype, {
    /**
     * Provides the current context as a child context
     * @method getChildContext
     */
    getChildContext: function () {
        return {
            getStore: this.props.context.getStore,
            executeAction: this.props.context.executeAction
        };
    },

    render: function () {
        return React.cloneElement(this.props.children, {
            context: this.props.context
        });
    }
});

module.exports = FluxibleComponent;


/***/ }),
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var RegionalInfoStore = __webpack_require__(325);

var _require = __webpack_require__(137),
    ipAddress = _require.URL.queryKey.ipAddress;

var promise = void 0;

var regionalInfoActions = {
    loadRegionalInfo: function loadRegionalInfo(actionContext, payload, done) {
        var regionalInfoStore = actionContext.getStore(RegionalInfoStore);
        var model = regionalInfoStore.getRegionalInfoModel();

        if (!promise) {
            promise = model.getInfo({ ipAddress: ipAddress }).then(function () {
                actionContext.dispatch('regionalInfo:loaded');
                done();
            }).catch(function (err) {
                actionContext.dispatch('regionalInfo:error', { message: err });
                done(err);
            });
        }

        return promise;
    }
};

module.exports = regionalInfoActions;

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SocialNetworkStore = __webpack_require__(987);
var isFetched = false;

var socialNetworkActions = {
    fetch: function fetch(actionContext, payload, done) {
        if (isFetched) {
            done();
        } else {
            var store = actionContext.getStore(SocialNetworkStore);
            var collection = store.getCollection();
            isFetched = true;

            Promise.resolve(collection.fetch()).then(function () {
                actionContext.dispatch('socialNetworks:fetch', collection.toJSON());
                done();
            });
        }
    }
};

module.exports = socialNetworkActions;

/***/ }),
/* 2174 */,
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classnames = __webpack_require__(16);

var styles = __webpack_require__(3058);

var DibsRadioButton = function DibsRadioButton(_ref) {
    var inputId = _ref.inputId,
        name = _ref.name,
        value = _ref.value,
        title = _ref.title,
        isSelected = _ref.isSelected,
        onSelect = _ref.onSelect,
        disabled = _ref.disabled,
        wrapperClass = _ref.wrapperClass,
        labelClass = _ref.labelClass,
        buttonClass = _ref.buttonClass,
        titleClass = _ref.titleClass,
        labelDataTn = _ref.labelDataTn,
        titleDataTn = _ref.titleDataTn,
        children = _ref.children;

    var labelClasses = classnames(styles.labelClass, labelClass);
    var buttonClasses = classnames(styles.radioButton, buttonClass);
    var titleClasses = classnames(styles.titleClass, titleClass);
    return React.createElement(
        'div',
        { className: wrapperClass },
        React.createElement(
            'label',
            {
                htmlFor: inputId,
                className: labelClasses,
                'data-id': value,
                'data-tn': labelDataTn
            },
            React.createElement('input', {
                id: inputId,
                type: 'radio',
                name: name,
                value: value,
                defaultChecked: isSelected,
                disabled: disabled,
                onChange: onSelect,
                className: styles.hiddenRadio
            }),
            React.createElement('span', { className: buttonClasses }),
            React.createElement(
                'span',
                { className: titleClasses, 'data-tn': titleDataTn },
                title
            )
        ),
        children
    );
};

DibsRadioButton.propTypes = {
    inputId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    isSelected: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    labelDataTn: PropTypes.string,
    titleDataTn: PropTypes.string,
    wrapperClass: PropTypes.string,
    buttonClass: PropTypes.string,
    labelClass: PropTypes.string,
    titleClass: PropTypes.string,
    children: PropTypes.node
};

module.exports = DibsRadioButton;

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SV = __webpack_require__(18);
var uri = __webpack_require__(689);
var User = __webpack_require__(15);
var authModalLoader = __webpack_require__(266).default;
var referrerHelpers = __webpack_require__(1204);
var pageTypeHelper = __webpack_require__(536);

var _require = __webpack_require__(398),
    PAGE_TYPE = _require.PAGE_TYPE,
    BROWSE_TYPES = _require.BROWSE_TYPES;

var VisitCountModel = __webpack_require__(1461);
var postAuthLoader = __webpack_require__(2191);
var abExperiments = __webpack_require__(494);
var type = 'loginModal';

var isAutoPromptEnabled = true;

var disableLoginPrompt = function disableLoginPrompt() {
    isAutoPromptEnabled = false;
};

/**
 * Checks page type.
 * @returns {boolean}
 */
var isAllowedPageType = function isAllowedPageType() {
    var isPdpPrintPage = SV.get('settings.isPrintPDP');
    var allowedPageTypes = [PAGE_TYPE.HOME, PAGE_TYPE.CREATOR, PAGE_TYPE.DEALER, PAGE_TYPE.PDP];

    var isAllowedPage = pageTypeHelper.isPageType(allowedPageTypes, BROWSE_TYPES);

    return isAllowedPage && !isPdpPrintPage;
};

/**
 * should visitor be prompted to login?
 * @returns {boolean}
 */
var isBlocked = function isBlocked() {
    if (User && User.loggedIn() || uri.URL.queryKey.modal || !isAllowedPageType() || referrerHelpers.isPlaReferrer()) {
        return true;
    }
    return false;
};

/**
 * Checks limit
 * @returns {boolean}
 */
var shouldPromptLoginRegistration = function shouldPromptLoginRegistration(visitCountModel) {
    return visitCountModel.get('session') === visitCountModel.get('regPromptLimit');
};

/**
 * Fix for edge case where a user continually comes to the site from a source where we want to delay
 * showing the login modal. Checks if we are allowed to show a modal. If we aren't this pushes the modal to the
 * next page view.
 */
var checkModalEligibility = function checkModalEligibility(visitCountModel) {
    if (shouldPromptLoginRegistration(visitCountModel) && isBlocked()) {
        visitCountModel.increment('regPromptLimit');
        visitCountModel.save();
    }
};

var canAutoPromptUser = function canAutoPromptUser() {
    var visitCountModel = new VisitCountModel();

    checkModalEligibility(visitCountModel);

    var isModalBlocked = isBlocked();
    var shouldOpenModal = shouldPromptLoginRegistration(visitCountModel);

    return isAutoPromptEnabled && shouldOpenModal && !isModalBlocked;
};

var getActionAndFlow = function getActionAndFlow() {
    var action = authModalLoader.constants.REGISTER;
    var flow = authModalLoader.constants.PAGEVIEW_LIMIT_FLOW;
    var ga = {};

    if (User.everLoggedIn()) {
        action = authModalLoader.constants.LOGIN;
        flow = authModalLoader.constants.PAGEVIEW_LIMIT_FLOW;
    }
    if (User.everLoggedInAsTrade()) {
        flow = authModalLoader.constants.PAGEVIEW_LIMIT_FLOW;
        ga.label = 'pageview limit reached - trade';
    }

    return { action: action, flow: flow, ga: ga };
};

/**
 * prompts visitor to register if it's due
 * @return {boolean} true if login prompted
 */
var openLoginModal = function openLoginModal() {
    var _getActionAndFlow = getActionAndFlow(),
        action = _getActionAndFlow.action,
        flow = _getActionAndFlow.flow,
        ga = _getActionAndFlow.ga;

    if (action === authModalLoader.constants.REGISTER && flow === authModalLoader.constants.PAGEVIEW_LIMIT_FLOW) {
        postAuthLoader.autoPromptRegistration({ flow: flow });
    } else {
        authModalLoader.show({
            action: action,
            flow: flow,
            ga: Object.assign({
                label: 'pageview limit reached'
            }, ga)
        });
    }
};

var noRegistrationTest = function noRegistrationTest() {
    setTimeout(function () {
        abExperiments.noRegistrationModal.reject();
    }, 800);

    return abExperiments.noRegistrationModal.then(function () {
        return Promise.resolve();
    }).catch(function () {
        openLoginModal();
        return Promise.resolve({ success: true, type: type });
    });
};

/**
 * Checks condition for auto prompt user.
 * Opens modal if condition is satisfied.
 * Condition:
 * page view - 3,
 * home / browse / creator / pdp (not print) page type,
 * User is not logged in and AuthModal is not opened.
 *
 * @return {Promise}
 */
var loginPromptRule = function loginPromptRule() {
    if (canAutoPromptUser()) {
        if (abExperiments.noRegistrationModal) {
            return noRegistrationTest();
        } else {
            openLoginModal();
            return Promise.resolve({ success: true, type: type });
        }
    }
    return Promise.resolve();
};

module.exports = {
    loginPromptRule: loginPromptRule,
    disableLoginPrompt: disableLoginPrompt
};

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _BUYER_STATUSES_MAP;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var $ = __webpack_require__(5);
var SV = __webpack_require__(18);
var Clump = __webpack_require__(23);
var Permission = __webpack_require__(940);

var _require = __webpack_require__(282),
    sessionStorage = _require.sessionStorage;

var User = __webpack_require__(15);

var contains = __webpack_require__(842);
var get = __webpack_require__(14);

var CUSTOMER_TYPE_VIP = 'VIP';
var CUSTOMER_TYPE_TRADE = 'Trade';
var CUSTOMER_TYPE_CONSUMER = 'Consumer';

var CONVERSATION_STATUS_CONTACTED = 'dealer contacted';
var CONVERSATION_STATUS_NOT_CONTACTED = 'no dealer contacted';

var STORAGE_TRANSACTIONS_STATUS = 'userTransactionsStatus';

var BUYER_STATUS_CONFIRMED_MULTIPLE = 'CONFIRMED_MULTIPLE';
var BUYER_STATUS_CONFIRMED_ONE = 'CONFIRMED_ONE';
var BUYER_STATUS_SUBMITTED = 'SUBMITTED';
var BUYER_STATUS_INITIATED = 'INITIATED';
var BUYER_STATUS_NONE = 'NONE';

var BUYER_STATUSES_MAP = (_BUYER_STATUSES_MAP = {}, _defineProperty(_BUYER_STATUSES_MAP, BUYER_STATUS_CONFIRMED_MULTIPLE, 'confirmed|multiple orders'), _defineProperty(_BUYER_STATUSES_MAP, BUYER_STATUS_CONFIRMED_ONE, 'confirmed|one order'), _defineProperty(_BUYER_STATUSES_MAP, BUYER_STATUS_SUBMITTED, 'submitted|none confirmed'), _defineProperty(_BUYER_STATUSES_MAP, BUYER_STATUS_INITIATED, 'initiated|none submitted'), _defineProperty(_BUYER_STATUSES_MAP, BUYER_STATUS_NONE, 'no orders initiated'), _BUYER_STATUSES_MAP);

var TRADE_STATUS_MAP = {
    'VERIFIED_VETTED': 'verified - vetted',
    'VERIFIED_PRE_APPROVED': 'verified - pre-approved',
    'SUSPECTED': 'suspected',
    'APPLIED_IN_REVIEW': 'applied - in review',
    'APPLIED_NOT_ENOUGH_INFORMATION': 'applied - not enough information',
    'APPLIED_REJECTED': 'applied - rejected'
};

var FIRST_PURCHASE_RANGES = {
    10000: '> $10K',
    5000: '$5K to $10K',
    3000: '$3K to $5K',
    1000: '$1K to $3K',
    0: '< $1K'
};

var detailsPromise = void 0;
var transactionsStatusPromise = void 0;

__webpack_require__(677);

/**
 * @param {string|number} dateString
 * @returns {string}
 */
function formatDate(dateString) {
    var date = new Date(dateString);

    return date.getMonth() + 1 + '-' + date.getFullYear();
}

/**
 * @returns {string} - first ga session date for user
 */
function getFirstUtmSessionDate() {
    var utmaCookie = $.cookie('__utma');
    var timestamp = utmaCookie.split('.')[2] * 1000;

    return formatDate(timestamp);
}

function getTradeStatus() {
    var roles = User.getCurrentUser().get('roles');
    var status = void 0;
    var date = void 0;
    var verifiedDate = void 0;

    if (User.loggedIn() && roles && roles.length) {
        var role = roles.toJSON().find(function (r) {
            return r.name === User.BUYER_TRADE;
        });
        var statusKey = get(role, 'userData.userStatus.name');
        status = TRADE_STATUS_MAP[statusKey];
        date = get(role, 'createdDate');
        verifiedDate = get(role, 'userData.verifiedDate');
    }

    return { status: status, date: date, verifiedDate: verifiedDate };
}

/**
 * @param {Number} userId - signed in user's id
 * @returns {object} - the base object that needs to be pushed into the dataLayer when a user registers for the site
 */
function getRegisterBaseDetails(userId) {
    return {
        loginStatus: 'Logged In',
        userID: userId,
        registrationStatus: 'Registered',
        userEmailAddress: User.getEmail(),
        emailToken: User.getEmailToken(),
        defaultCurrency: 'USD Default',
        tradeStatus: getTradeStatus().status,
        customerType: CUSTOMER_TYPE_CONSUMER
    };
}

/**
 * @param {Number} userId - signed in user's id
 * @param {string} userCurrency - signed in user's currency
 * @returns {object} - the base object that needs to be pushed into the dataLayer when a user signs into the site
 */
function getLoginBaseDetails(userId, userCurrency, userEmail) {
    return {
        loginStatus: 'Logged In',
        userID: userId,
        registrationStatus: 'Registered',
        userEmailAddress: userEmail,
        defaultCurrency: userCurrency + ' Selected',
        buyerStatus: undefined,
        buyerActivityStatus: undefined,
        tradeStatus: getTradeStatus().status,
        firstPurchasePrice: 'na',
        firstPurchaseDate: 'na',
        contactDealerStatus: undefined,
        customerType: undefined,
        firstSessionDate: getFirstUtmSessionDate()
    };
}

/**
 * @param {array} permissionsList
 * @returns {string} customerType - Consumer, VIP, Trade or VIP and Trade
 */
function getCustomerType(permissionsList) {
    var permissions = permissionsList.pluck('name');
    var customerType = [];

    if (contains(permissions, Permission.PERMISSION_B_TRADE_CHECKOUT)) {
        customerType.push(CUSTOMER_TYPE_TRADE);
    }

    if (contains(permissions, Permission.PERMISSION_B_VIP_CHECKOUT)) {
        customerType.push(CUSTOMER_TYPE_VIP);
    }

    if (!customerType.length) {
        return CUSTOMER_TYPE_CONSUMER;
    }

    return customerType.join(' and ');
}

/**
 * @param {object} clump - clump instance to handle a transactions fetch
 * @param {string} userId
 * @param {string} userToken
 */
function setupTransactions(clump, userId, userToken) {
    clump.add({
        url: '/soa/graphql/?' + User.COOKIE_USER + '=' + userToken,
        type: 'POST',
        data: {
            query: '{\n                viewer {\n                    conversations(userId: "' + userId + '", first: 0) {\n                        totalResults\n                    }\n                    allTransactions: transactions(buyerId: ["' + userId + '"], first: 0) {\n                        totalResults\n                    }\n                    initiatedTransactions: transactions(buyerId: ["' + userId + '"], viewName: "buyerTracking.initiated", first: 0) {\n                        totalResults\n                    }\n                    submittedTransactions: transactions(buyerId: ["' + userId + '"], viewName: "buyerTracking.submitted", first: 0) {\n                        totalResults\n                    }\n                    confirmedTransactions: transactions(buyerId: ["' + userId + '"], sort: "createdDate asc", viewName: "buyerTracking.confirmed", first: 1) {\n                        totalResults\n                        edges {\n                            node {\n                                mostRecentOffer {\n                                    createdDate\n                                    subTotalAmount {\n                                        convertedAmounts {\n                                            USD\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }'
        }
    });
}

/**
 * @param {object} userConfig
 * @param {object} userConfig.user
 * @param {string} userConfig.userId
 * @param {string} userConfig.userEmail
 * @param {string} [userConfig.userCurrency]
 */
function getRegisteredDetails(userConfig) {
    var details = getRegisterBaseDetails(userConfig.userId);
    return Promise.resolve(details);
}

/**
 * @param {object} conversations
 * @returns {string}
 */
function getContactDealerStatus(viewer) {
    if (viewer && viewer.conversations && viewer.conversations.totalResults) {
        return CONVERSATION_STATUS_CONTACTED;
    }
    return CONVERSATION_STATUS_NOT_CONTACTED;
}

/**
 * @param {Object} transactions
 * @returns {Object}
 */
function getBuyerStatusFromTransactions(transactions) {
    var initiatedTransactions = transactions.initiatedTransactions,
        submittedTransactions = transactions.submittedTransactions,
        confirmedTransactions = transactions.confirmedTransactions;

    var buyerStatus = void 0;

    if (confirmedTransactions && confirmedTransactions.totalResults > 1) {
        buyerStatus = BUYER_STATUS_CONFIRMED_MULTIPLE;
    } else if (confirmedTransactions && confirmedTransactions.totalResults) {
        buyerStatus = BUYER_STATUS_CONFIRMED_ONE;
    } else if (submittedTransactions && submittedTransactions.totalResults) {
        buyerStatus = BUYER_STATUS_SUBMITTED;
    } else if (initiatedTransactions && initiatedTransactions.totalResults) {
        buyerStatus = BUYER_STATUS_INITIATED;
    } else {
        buyerStatus = BUYER_STATUS_NONE;
    }

    return { buyerStatus: buyerStatus };
}

/**
 * @param {Object} transactions
 * @returns {Object}
 */
function getFirstPurchaseInfo(transactions) {
    var confirmedTransactions = transactions.confirmedTransactions;

    var firstPurchasePrice = void 0;
    var firstPurchaseDate = void 0;

    if (confirmedTransactions && confirmedTransactions.totalResults) {
        var price = get(confirmedTransactions, 'edges[0].node.mostRecentOffer.subTotalAmount.convertedAmounts.USD');
        var date = get(confirmedTransactions, 'edges[0].node.mostRecentOffer.createdDate');

        // Format date
        if (date) {
            firstPurchaseDate = formatDate(date);
        }

        // Format price range
        if (price) {
            for (var range in FIRST_PURCHASE_RANGES) {
                if (price >= range) {
                    firstPurchasePrice = FIRST_PURCHASE_RANGES[range];
                }
            }
        }
    }

    return {
        firstPurchasePrice: firstPurchasePrice,
        firstPurchaseDate: firstPurchaseDate
    };
}

/**
 * @param {Object} payload
 *      {Object} payload.transactions - transactions response with counts
 *      {Boolean} payload.gaLabel - return gaLabel instead of constant
 * @returns {Object}
 */
function getTransactionsStatus() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { gaLabel: true };
    var viewer = payload.viewer,
        gaLabel = payload.gaLabel;

    var totalTransactions = 0;
    var transactionsStatus = {
        buyerStatus: BUYER_STATUS_NONE,
        totalTransactions: totalTransactions
    };

    if (viewer) {
        totalTransactions = viewer.allTransactions.totalResults;
        transactionsStatus = getBuyerStatusFromTransactions(viewer);
        Object.assign(transactionsStatus, getFirstPurchaseInfo(viewer), { totalTransactions: totalTransactions });
        transactionsStatus.contactDealerStatus = getContactDealerStatus(viewer);
        sessionStorage.setItem(STORAGE_TRANSACTIONS_STATUS, transactionsStatus);
    } else {
        transactionsStatus = sessionStorage.getItem(STORAGE_TRANSACTIONS_STATUS) || transactionsStatus;
    }

    if (gaLabel && transactionsStatus) {
        transactionsStatus.buyerStatusKey = transactionsStatus.buyerStatus;
        transactionsStatus.buyerStatus = BUYER_STATUSES_MAP[transactionsStatus.buyerStatus];
    }

    return transactionsStatus;
}

/**
 * Some pages need fresh buyer status, so this is the place to re-validate it
 */
function checkTransactionsStatusCache() {
    if (SV.get('settings.pageType') === 'checkout' && SV.get('settings.pageSubType') === 'confirmation') {
        sessionStorage.deleteItem(STORAGE_TRANSACTIONS_STATUS);
    }
}

/**
 * @param {Boolean} gaLabel
 * @returns {Promise}
 */
function fetchTransactionsStatus() {
    var gaLabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    var clump = new Clump();
    var cachedTransactionsStatus = sessionStorage.getItem(STORAGE_TRANSACTIONS_STATUS);

    checkTransactionsStatusCache();

    if (User.loggedIn() && !cachedTransactionsStatus) {
        setupTransactions(clump, User.getUserId(), User.getUserToken());

        if (!transactionsStatusPromise) {
            transactionsStatusPromise = clump.run().then(function (response) {
                var viewer = get(response, 'result.clumpResponse.elements[0].payload.data.viewer');
                return getTransactionsStatus({ viewer: viewer, gaLabel: gaLabel });
            });
        }
        return transactionsStatusPromise;
    }

    return Promise.resolve(getTransactionsStatus({ gaLabel: gaLabel }));
}

/**
 * @param {object} userConfig
 * @param {object} userConfig.user
 * @param {string} userConfig.userId
 * @param {string} userConfig.userToken
 * @param {string} userConfig.userEmail
 * @param {string} userConfig.userCurrency
 * @param {object} currentClump, mainly used for testing
 */
function getLoggedInDetails(userConfig, currentClump) {
    var user = userConfig.user,
        userId = userConfig.userId,
        userToken = userConfig.userToken,
        userCurrency = userConfig.userCurrency;

    var clump = currentClump || new Clump();

    if (detailsPromise) {
        return detailsPromise;
    }

    setupTransactions(clump, userId, userToken);

    detailsPromise = Promise.all([clump.run(), User.load()]).then(function (response) {
        var viewer = get(response[0], 'result.clumpResponse.elements[0].payload.data.viewer');
        var details = getLoginBaseDetails(userId, userCurrency, User.getEmail());

        var contactDealerStatus = getContactDealerStatus(viewer);
        var customerType = getCustomerType(user.get('permissions.permissionList'));

        var _getTransactionsStatu = getTransactionsStatus({
            gaLabel: true,
            viewer: viewer
        }),
            buyerStatus = _getTransactionsStatu.buyerStatus,
            _getTransactionsStatu2 = _getTransactionsStatu.firstPurchasePrice,
            firstPurchasePrice = _getTransactionsStatu2 === undefined ? 'na' : _getTransactionsStatu2,
            _getTransactionsStatu3 = _getTransactionsStatu.firstPurchaseDate,
            firstPurchaseDate = _getTransactionsStatu3 === undefined ? 'na' : _getTransactionsStatu3;

        Object.assign(details, {
            customerType: customerType,
            buyerStatus: buyerStatus,
            firstPurchasePrice: firstPurchasePrice,
            firstPurchaseDate: firstPurchaseDate,
            contactDealerStatus: contactDealerStatus
        });

        return details;
    });

    return detailsPromise;
}

module.exports = {
    getTransactionsStatus: getTransactionsStatus,
    fetchTransactionsStatus: fetchTransactionsStatus,
    getLoggedInDetails: getLoggedInDetails,
    getRegisteredDetails: getRegisteredDetails,
    getTradeStatus: getTradeStatus,
    BUYER_STATUSES_MAP: BUYER_STATUSES_MAP
};

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * External widgets loader
 *
 * Created by:
 *     Nikita Svesnikov <niko@1stdibs.com>
 *
 * Description:
 *     Widget loader is used to load externals widgets dynamically within
 *     any javascript module. Adds script tags to head, and when it is ready resolves
 *     a promise, to make sure widget is loaded and ready to be used.
 *     When widget is loaded at first time, it is cached, and resolved without adding new
 *     script tags to head at any further load request.
 *
 * Usage:
 *     const widgetLoader = require('global/widgets/widgetLoader');
 *
 *     widgetLoader
 *         .load('pinterest')
 *         .then(pinterest => {
 *             // widget is loaded and ready to be used
 *             pinterest.setSession('whatever-session');
 *         })
 *         .catch(() => {});
 */



var SV = __webpack_require__(18);
var ScriptInjector = __webpack_require__(3636);

var getEnvAccount = function getEnvAccount(accounts) {
    var env = SV.get('settings.environment');
    return accounts[env] || accounts.development;
};

var scripts = {
    pinterest: function pinterest() {
        return ScriptInjector.inject('https://assets.pinterest.com/sdk/sdk.js').then(function () {
            return global.PDK;
        });
    },
    intercom: function intercom() {
        var accounts = {
            production: 'fnj80w14',
            development: 'j06umpub'
        };

        var account = getEnvAccount(accounts);

        return ScriptInjector.inject('https://widget.intercom.io/widget/' + account).then(function () {
            var intercom = global.Intercom;
            intercom('boot', {
                'app_id': account
            });

            return intercom;
        });
    }
};

var getters = {
    // At some point Intercom mutates global variable,
    // so we should always return global.Intercom
    intercom: function intercom() {
        return Promise.resolve(global.Intercom);
    }
};

/**
 * Scripts loader. Also it caches loading promise to load script once.
 * @param  {String} type script provider
 * @return {Promise}
 */
var load = function load(type) {
    var loader = load[type];
    var getter = getters[type];

    if (loader && getter) {
        return loader.then(function () {
            return getter();
        });
    } else if (loader) {
        return loader;
    }

    if (!scripts[type]) {
        throw new Error('Widget script for ' + type + ' is not provided.');
    }

    load[type] = typeof scripts[type] === 'function' ? scripts[type]() : ScriptInjector.inject(scripts[type]);

    return load[type];
};

module.exports = { load: load };
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.autoPromptRegistration = autoPromptRegistration;
exports.postLogin = postLogin;
exports.postRegistration = postRegistration;

var _authInterface = __webpack_require__(1521);

var authInterface = _interopRequireWildcard(_authInterface);

var _navigation = __webpack_require__(3731);

var navigation = _interopRequireWildcard(_navigation);

var _relayEnvironmnentProvider = __webpack_require__(463);

var _promptTracker = __webpack_require__(3732);

var promptTracker = _interopRequireWildcard(_promptTracker);

var _userHelpers = __webpack_require__(1150);

var _sendTradeAppToTfa = __webpack_require__(2192);

var _sendTradeAppToTfa2 = _interopRequireDefault(_sendTradeAppToTfa);

__webpack_require__(2116);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var authModalFlows = authInterface.authModalFlows;

//login flows that should not be followed by post-auth

var loginBlacklist = [authModalFlows.TRADE_APPLICATION_FLOW, authModalFlows.ALT_REGISTRATION_CONSUMER_FLOW, authModalFlows.ALT_REGISTRATION_TRADE_FLOW, authModalFlows.CONTACT_DEALER_FLOW, authModalFlows.CONTACT_DEALER_CALL_FLOW, authModalFlows.CONTACT_DEALER_FORM_FLOW, authModalFlows.MAKE_OFFER_FLOW];

//registration flows that should not be followed by post-auth
var registrationBlacklist = [authModalFlows.TRADE_APPLICATION_FLOW, authModalFlows.ALT_REGISTRATION_CONSUMER_FLOW, authModalFlows.ALT_REGISTRATION_TRADE_FLOW, authModalFlows.CONTACT_DEALER_CALL_FLOW, authModalFlows.MAKE_OFFER_FLOW];

var deferred = function deferred() {
    var resolveRef = void 0;

    var promise = new Promise(function (resolve) {
        resolveRef = resolve;
    });

    promise.resolve = resolveRef;
    return promise;
};

var postAuthDeferred = deferred();
var moduleLoaded = false;
var constants = void 0;

var loadPostAuthModule = function loadPostAuthModule() {
    if (!moduleLoaded) {
        __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
            var postAuth = __webpack_require__(932);
            postAuth.init((0, _relayEnvironmnentProvider.getEnvironment)());
            constants = postAuth.publicConstants;
            postAuthDeferred.resolve(postAuth);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        moduleLoaded = true;
    }

    return postAuthDeferred;
};

var handlePostAuthCompletion = function handlePostAuthCompletion(_ref) {
    var consumerZipCode = _ref.consumerZipCode,
        tradeApplicationData = _ref.tradeApplicationData,
        firstName = _ref.firstName,
        lastName = _ref.lastName;

    promptTracker.markCompletedInLocalStorage();

    if (consumerZipCode) {
        (0, _userHelpers.setUserZipCode)(consumerZipCode);
    }

    if (tradeApplicationData) {
        (0, _sendTradeAppToTfa2.default)(tradeApplicationData, constants.tfaTradeConfig).then(_userHelpers.setTradeStatusToApplied);
    }

    if (firstName && lastName) {
        (0, _userHelpers.setUserName)(firstName, lastName);
    }
};

var handleUserTypeSelection = function handleUserTypeSelection(userType) {
    if (userType === constants.userTypes.TRADE) {
        (0, _userHelpers.conditionalMarkSuspectedTrade)();
    }
};

function autoPromptRegistration() {

    if (navigation.onTradeApplicationPage()) {
        return;
    }

    loadPostAuthModule().then(function (postAuth) {
        postAuth.init((0, _relayEnvironmnentProvider.getEnvironment)());

        //open the post-auth modal
        var autoPromptRegister = postAuth.run('AUTO_PROMPT_REGISTER');

        autoPromptRegister.onUserTypeSelected(function (userType) {
            if (userType === constants.userTypes.CONSUMER) {
                postAuth.hide();
                authInterface.consumerAltRegistration({ label: 'pageview limit reached - consumer', fireEntryGa: false }).then(function (_ref2) {
                    var newUser = _ref2.newUser;

                    if (newUser) {
                        postAuth.show();
                    }
                });
            }
        });

        autoPromptRegister.onDealerApplicationClick(navigation.goToDealerApplication);

        autoPromptRegister.onLoginLinkClicked(function () {
            postAuth.hide();
            authInterface.basicLogin();
        });

        autoPromptRegister.onPostAuthCompleted(function (_ref3) {
            var consumerZipCode = _ref3.consumerZipCode,
                tradeApplicationData = _ref3.tradeApplicationData,
                tradeApplicationForced = _ref3.tradeApplicationForced,
                firstName = _ref3.firstName,
                lastName = _ref3.lastName,
                email = _ref3.email;

            promptTracker.markCompletedInLocalStorage();

            if (consumerZipCode) {
                (0, _userHelpers.setUserZipCode)(consumerZipCode);
            }

            if (tradeApplicationData) {
                postAuth.hide();

                //if user abandoned trade application, just send whatever data was provided
                if (tradeApplicationForced) {
                    (0, _sendTradeAppToTfa2.default)(tradeApplicationData, constants.tfaTradeConfig);
                } else {
                    authInterface.tradeAltRegistration({ label: 'pageview limit reached - trade', email: email, fireEntryGa: false }).then(function (authResult) {
                        //if user abandoned authentication, just send trade application data
                        if (authResult.err) {
                            (0, _sendTradeAppToTfa2.default)(tradeApplicationData, constants.tfaTradeConfig);
                        } else {
                            (0, _userHelpers.whenUserFullyLoaded)(function () {
                                if ((0, _userHelpers.eligibleToApplyForTrade)()) {
                                    (0, _sendTradeAppToTfa2.default)(tradeApplicationData, constants.tfaTradeConfig);
                                    (0, _userHelpers.setTradeStatusToApplied)();
                                    postAuth.show();
                                }

                                if (firstName && lastName) {
                                    (0, _userHelpers.setUserName)(firstName, lastName);
                                }
                            });
                        }
                    });
                }
            }
        });
    });
};

function postLogin(_ref4) {
    var environment = _ref4.environment,
        _ref4$flow = _ref4.flow,
        flow = _ref4$flow === undefined ? '' : _ref4$flow;

    if (loginBlacklist.indexOf(flow) > -1 || navigation.onTradeApplicationPage()) {
        return;
    }

    (0, _userHelpers.whenUserFullyLoaded)(function () {
        if (promptTracker.doPostAuthAtLogin((0, _userHelpers.currentUserCreatedDate)(), (0, _userHelpers.currentUserTradeStatus)())) {
            loadPostAuthModule().then(function (postAuth) {
                postAuth.init(environment);
                postAuth.run('LOGIN', flow).onUserTypeSelected(handleUserTypeSelection).onDealerApplicationClick(navigation.goToDealerApplication).onPostAuthCompleted(handlePostAuthCompletion);

                postAuth.show();
            });

            promptTracker.incrementLoginPromptCount();
        }
    });
};

function postRegistration(_ref5) {
    var environment = _ref5.environment,
        _ref5$flow = _ref5.flow,
        flow = _ref5$flow === undefined ? '' : _ref5$flow;

    if (registrationBlacklist.indexOf(flow) > -1 || navigation.onTradeApplicationPage()) {
        return;
    }

    (0, _userHelpers.whenUserFullyLoaded)(function () {
        loadPostAuthModule().then(function (postAuth) {
            postAuth.init(environment);
            postAuth.run('REGISTER', flow).onUserTypeSelected(handleUserTypeSelection).onDealerApplicationClick(navigation.goToDealerApplication).onPostAuthCompleted(handlePostAuthCompletion);

            postAuth.show();
        });
    });
};

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = sendTradeApplicationToTfa;

var _dibsXdomainPoster = __webpack_require__(933);

var _serverVars = __webpack_require__(18);

var _serverVars2 = _interopRequireDefault(_serverVars);

var _userHelpers = __webpack_require__(1150);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function sendTradeApplicationToTfa(tradeApplicationData) {
    var _extends2;

    var tfaTradeConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var leadSourceDetails = _serverVars2.default.get('tradeApplicationServerVars.leadSourceDetails') || '';
    var emailField = tfaTradeConfig.userEmailField;

    var tradeDataWithUserData = _extends({}, tradeApplicationData, (_extends2 = {}, _defineProperty(_extends2, tfaTradeConfig.userEmailField, tradeApplicationData[emailField] || (0, _userHelpers.currentUserEmail)() || ''), _defineProperty(_extends2, tfaTradeConfig.userIdField, (0, _userHelpers.currentUserID)() || ''), _defineProperty(_extends2, tfaTradeConfig.leadSourceDetailField, leadSourceDetails), _extends2));

    return (0, _dibsXdomainPoster.postToIframe)(tfaTradeConfig.url, tradeDataWithUserData).catch(function (err) {
        return console.warn('postToIframe failed', err);
    });
};

/***/ }),
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Hold = __webpack_require__(3841);
var SoaCollection = __webpack_require__(9);
var reduce = __webpack_require__(343);

var Holds = SoaCollection.extend();

Object.assign(Holds.prototype, {
    model: Hold,

    getActiveHold: function getActiveHold() {
        return this.find(function (hold) {
            return hold.isActive();
        });
    },

    getRelevantHoldByBuyer: function getRelevantHoldByBuyer(buyerId) {
        var _hierarchy;

        var buyerHolds = this.filter(function (hold) {
            return hold.get('buyer.id') === buyerId;
        });
        // only return hold if for passed in bueyrId
        if (!buyerHolds.length) {
            return null;
        }
        var hierarchy = (_hierarchy = {}, _defineProperty(_hierarchy, Hold.statuses.ACTIVE, 2), _defineProperty(_hierarchy, Hold.statuses.REQUESTED, 1), _defineProperty(_hierarchy, Hold.statuses.DELETED, 0), _hierarchy);
        return reduce(buyerHolds, function (mostRelevant, current) {
            var relevantStatus = mostRelevant.get('status');
            var currentStatus = current.get('status');
            var relevantScore = void 0;
            var currentScore = void 0;
            // for same status, use modified date to break tie
            if (relevantStatus === currentStatus) {
                relevantScore = new Date(mostRelevant.get('modifiedDate')).getTime();
                currentScore = new Date(current.get('modifiedDate')).getTime();
                // ACTIVE beats REQUESTED beats DELETED
            } else {
                relevantScore = hierarchy[relevantStatus];
                currentScore = hierarchy[currentStatus];
            }
            return relevantScore > currentScore ? mostRelevant : current;
        });
    }
});

module.exports = Holds;

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Joe Forzano
 * Date: August 20th, 2014
 * Time: 3:15 PM
 */


// ---------------------------------------------------
// Load Module Super PseudoClass

var SoaCollection = __webpack_require__(9);

// ---------------------------------------------------
// Module Definition
/**
 * @class Carriers
 * @extends SoaCollection
 */
var Carriers = module.exports = SoaCollection.extend();

// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);
var $ = __webpack_require__(5);
var endpoints = __webpack_require__(6);
var Carrier = __webpack_require__(322);
var Clump = __webpack_require__(23);
var SV = __webpack_require__(18);
var getDeferredMethods = __webpack_require__(299);
var globalCache = __webpack_require__(1092);

var deferred = getDeferredMethods().Deferred;

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(Carriers.prototype, {
    model: Carrier,

    /**
     * Builds the url to fetch carriers based on the urlOptions hash passed in during
     * collection creation
     * @returns {string} url
     */
    url: endpoints.carriersBase(),

    /**
     * @param {Carrier[]} models
     * @param {Object} options
     * @param {Object} options.urlOptions - options to pass as query params for the collection fetch
     * @param {string} options.urlOptions.view - name of view to filter carriers for
     * @param {number | number[]} options.urlOptions.ids - id/ids to filter carriers for
     * @param {string | string[]} options.urlOptions.codes - code/codes to filter carriers for
     * @param {string | string[]} options.urlOptions.fields - fields to inflate on fetched carriers
     */
    initialize: function initialize(models, options) {
        options = options || {};
        this.urlOptions = options.urlOptions;

        Carriers.__super__.initialize.call(this, models, options);
    },

    /**
     * Builds a hash mapping carrier ids to their display names
     * @returns {Object}
     */
    getIdNameMap: function getIdNameMap() {
        if (this.idNameMap && !_.isEmpty(this.idNameMap)) {
            return this.idNameMap;
        }

        this.idNameMap = this.map(function (model) {
            return {
                value: model.get('id'),
                display: model.get('name')
            };
        });

        return this.idNameMap;
    },

    /**
     * Builds an array of objects containing ids and names.
     * @returns {Array}
     */
    getIdNameArray: function getIdNameArray() {
        if (this.idNameArray && !_.isEmpty(this.idNameArray)) {
            return this.idNameArray;
        }

        var arr = [];
        this.each(function (model) {
            arr.push({
                id: model.get('id'),
                name: model.get('name')
            });
        });

        return arr;
    },

    /**
     * Looks up the carrier associated with the given id
     * and returns true if that carrier supports tracking links
     * @param {number} carrierId
     * @returns {Boolean}
     */
    canCarrierSupportTrackingLink: function canCarrierSupportTrackingLink(carrierId) {
        var carrier = this.findWhere({ id: parseInt(carrierId, 10) });
        return carrier.get('supportTrackingLink');
    }

});

// ---------------------------------------------------
// Define Module Static Properties

_.extend(Carriers, {

    VIEW_INTERNAL: 'INTERNAL',
    VIEW_SELLER: 'SELLER',

    OTHER_ID: 62,

    _carriersByView: {},
    _fetchingCarriersByView: {},

    /**
     * @static
     * @private
     * @param {string} view
     * @returns {symbol}
     */
    _getCarrierCacheKeyForView: function () {
        var cacheKeys = {};
        return function (view) {
            if (!cacheKeys[view]) {
                cacheKeys[view] = Symbol('fetching_carriers_' + view);
            }
            return cacheKeys[view];
        };
    }(),

    /**
     * Creates and/or returns the singleton promise for the carriers being fetched
     * for the given view name. If server vars have carriers defined for the view (under
     * carriers.[viewName], we'll circumvent the fetch and return a resolved promise
     * with that data.
     * @param {string} view (i.e. SELLER, INTERNAL)
     * @param {Clump} [clump] clump instance
     * @param {Object} [queryData] optional query params for the carriers fetch
     * @returns {Promise} promise for carriers collection fetch
     */
    getCarriersPromiseForView: function getCarriersPromiseForView(view, clump, queryData) {
        var models = SV.get('carriers.' + view) || [];
        var cacheKey = Carriers._getCarrierCacheKeyForView(view);
        var fetchCarriersProm = globalCache.get(cacheKey);
        var data = _.extend({
            view: view
        }, queryData);

        if (fetchCarriersProm) {
            return fetchCarriersProm;
        }

        if (!Carriers._carriersByView[view]) {
            Carriers._carriersByView[view] = new Carriers(models, {
                urlOptions: {
                    view: view
                }
            });
        }

        if (models.length) {
            fetchCarriersProm = deferred().resolve(models).promise();
        } else {
            fetchCarriersProm = Carriers._carriersByView[view].fetch({
                clump: clump,
                data: data
            });
        }

        globalCache.set(cacheKey, fetchCarriersProm);
        return fetchCarriersProm;
    },

    /**
     * Creates and/or returns the singleton promise wrapping all promises for the
     * passed list of views names.
     * @param {string[]} viewList (i.e. SELLER, INTERNAL)
     * @param {Clump} [clump] clump instance
     * * @param {Object} [queryData] optional query params for the carriers fetch
     * @returns {Promise} promise for all carriers collection fetches
     */
    getCarriersPromiseForViews: function getCarriersPromiseForViews(viewList, clump, queryData) {
        var ownClump = false;
        var viewKey = viewList.join('');
        var promises = [];
        var currentPromise;

        if (Carriers._fetchingCarriersByView[viewKey]) {
            return Carriers._fetchingCarriersByView[viewKey];
        }

        if (!clump) {
            clump = new Clump();
            ownClump = true;
        }

        _.each(viewList, function (view) {
            currentPromise = Carriers.getCarriersPromiseForView(view, clump, queryData);
            promises.push(currentPromise);
        });

        if (ownClump) {
            clump.run();
        }

        Carriers._fetchingCarriersByView[viewKey] = $.when.apply(promises);
        return Carriers._fetchingCarriersByView[viewKey];
    },

    /**
     * If the collection has not been instantiated for the requested view, a new collection
     * is created before returning the singleton collection. If carrier data is present on server
     * vars for the requested view, the collection is populated with that data.
     * @param view
     * @returns {Carriers} singleton carriers collection for the given view
     */
    getCarriersForView: function getCarriersForView(view) {
        var models = SV.get('carriers.' + view) || [];

        if (!Carriers._carriersByView[view]) {
            Carriers._carriersByView[view] = new Carriers(models, {
                urlOptions: {
                    view: view
                }
            });
        }

        return Carriers._carriersByView[view];
    },

    /**
     * @param view
     * @returns {Object} the id-name mapping for the singleton carriers collection for the given view
     */
    getIdNameMapForView: function getIdNameMapForView(view) {
        return Carriers._carriersByView[view].getIdNameMap();
    },

    /**
     * @param view
     * @returns {Object} the id-name mapping for the singleton carriers collection for the given view
     */
    getIdNameArrayForView: function getIdNameArrayForView(view) {
        return Carriers._carriersByView[view].getIdNameArray();
    },

    /**
     * Searches all fetched carriers for the model having the given id and returns the name associated with that carrier
     * @param {number|string} carrierId
     * @returns {string}
     */
    getCarrierName: function getCarrierName(carrierId) {
        var carrier = this.findCarrierForId(carrierId);
        return carrier ? carrier.get('name') : null;
    },

    /**
     * Search through the singleton carriers collection for a carrier
     * matching the given id and return their code if found
     * @param {string|number} carrierId
     * @returns {string}
     */
    getCarrierCode: function getCarrierCode(carrierId) {
        var carrier = this.findCarrierForId(carrierId);
        return carrier ? carrier.get('code') : null;
    },

    /**
     * Search through the singleton carriers collection for a carrier matching
     * the provided id.
     * @param {string|number} carrierId
     * @returns {Carrier}
     */
    findCarrierForId: function findCarrierForId(carrierId) {
        var allCarrierModelLists = _.pluck(_.values(Carriers._carriersByView), 'models');
        var allCarrierModels = _.flatten(allCarrierModelLists);
        return _.find(allCarrierModels, function (carrier) {
            return String(carrier.get('id')) === String(carrierId);
        });
    }

});

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Load Super Class

var SoaCollection = __webpack_require__(9);

// ---------------------------------------------------
// Module Definition

/**
 * @class ShippingCosts
 * @extends SoaCollection
 */
var ShippingCosts = module.exports = SoaCollection.extend();

// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);
var ShippingCost = __webpack_require__(2209);
var endpoints = __webpack_require__(6);
var dataProvider = __webpack_require__(780);
var getDeferredMethods = __webpack_require__(299);
var User = __webpack_require__(28);
var globalCache = __webpack_require__(1092);

var deferred = getDeferredMethods().Deferred;

var extendFetchData = function extendFetchData(fetchOptions, data) {
    fetchOptions = fetchOptions ? _.clone(fetchOptions) : {};
    fetchOptions.data = _.extend({}, fetchOptions.data, data);
    return fetchOptions;
};

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(ShippingCosts.prototype, /** @lends ShippingCosts.prototype */{

    url: endpoints.shippingCosts,

    model: ShippingCost,

    /**
     * @returns {ShippingCost}
     */
    findUnknownCost: function findUnknownCost() {
        return this.findByCostType(ShippingCost.COST_TYPE_UNKNOWN);
    },

    /**
     * @returns {ShippingCost}
     */
    findTransitCost: function findTransitCost() {
        return this.findByCostType(ShippingCost.COST_TYPE_TRANSIT);
    },

    /**
     * @param {string} costType
     * @returns {ShippingCost}
     */
    findByCostType: function findByCostType(costType) {
        return this.find(function (shippingCost) {
            return shippingCost.isCostType(costType);
        });
    },

    /**
     * @param {string} costType
     * @returns {FinancialAmount}
     */
    getSubTotalAmountForType: function getSubTotalAmountForType(costType) {
        var cost = this.findByCostType(costType);
        return cost ? cost.getSubTotalAmount() : null;
    },

    /**
     * @param {string} costType
     * @returns {number}
     */
    getSubTotalNumForType: function getSubTotalNumForType(costType) {
        var cost = this.findByCostType(costType);
        return cost ? cost.getSubTotalNum() : null;
    },

    /**
     * @param {string} costType
     * @returns {Party}
     */
    getBillToForType: function getBillToForType(costType) {
        var cost = this.findByCostType(costType);
        return cost ? cost.getBillTo() : null;
    },

    /**
     * @param {string} costType
     * @returns {string}
     */
    getBillToRoleForType: function getBillToRoleForType(costType) {
        var cost = this.findByCostType(costType);
        return cost ? cost.getBillToRole() : null;
    },

    /**
     * Returns the reference shipping cost. Returns the unknown
     * shipping cost if present, otherwise returns the "transit"
     * shipping cost. Finally, returns null if neither type is
     * present in the collection.
     * @returns {ShippingCost}
     */
    findDefaultCost: function findDefaultCost() {
        return this.find(function (cost) {
            return cost.isDefaultCost();
        });
    },

    /**
     * Removes a shipping cost that matches the provided cost
     * type, otherwise does nothing.
     */
    removeByCostType: function removeByCostType(costType) {
        var cost = this.findByCostType(costType);
        if (cost) {
            this.remove(cost);
        }
        return this;
    },

    /**
     * @param {string} costType
     * @returns {string}
     */
    findBillToCarrierNameForType: function findBillToCarrierNameForType(costType) {
        var cost = this.findByCostType(costType);
        return cost ? cost.findBillToCarrierName() : null;
    },

    /**
     * @param {string} costType
     * @returns {string}
     */
    findBillToCarrierCodeForType: function findBillToCarrierCodeForType(costType) {
        var cost = this.findByCostType(costType);
        return cost ? cost.findBillToCarrierCode() : null;
    },

    /**
     * Returns true if the only cost in the collection
     * is an UNKNOWN cost.
     * @returns {boolean}
     */
    hasOnlyUnknownCost: function hasOnlyUnknownCost() {
        return this.length === 1 && !!this.findUnknownCost();
    },

    /**
     * @param {string} costType
     * @param {number} subTotal
     * @param {string} [currency]
     * @returns {ShippingCosts}
     */
    setSubTotalForType: function setSubTotalForType(costType, subTotal, currency) {
        var cost = this.findByCostType(costType);
        if (!currency) {
            currency = this.getDefaultCurrency();
        }
        if (!cost) {
            this.addWithTypeAndSubTotal(costType, subTotal, currency);
            return this;
        }
        cost.setSubTotalAndCurr(subTotal, currency);
        return this;
    },

    /**
     * @param {string} costType
     * @param {string} [role]
     * @param {number} [id]
     * @returns {ShippingCosts}
     */
    setBillToForType: function setBillToForType(costType, role, id) {
        var cost = this.findByCostType(costType);
        var billTo = { role: role, id: id };
        if (!cost) {
            this._addQuoteWithConfig({
                costType: costType,
                billTo: billTo
            });
        } else {
            cost.setBillTo(billTo);
        }
        return this;
    },

    /**
     * @param {string} [costType]
     * @param {number} [subTotal]
     * @param {string} [currency]
     * @returns {ShippingCosts}
     */
    addWithTypeAndSubTotal: function addWithTypeAndSubTotal(costType, subTotal, currency) {
        if (!currency) {
            currency = this.getDefaultCurrency();
        }
        this._addQuoteWithConfig({
            subTotal: subTotal,
            costType: costType,
            currency: currency
        });
        return this;
    },

    /**
     * @param {string} defaultCurrency
     * @returns {ShippingCosts}
     */
    setDefaultCurrency: function setDefaultCurrency(defaultCurrency) {
        this._defaultCurrency = defaultCurrency;
        return this;
    },

    /**
     * @returns {string}
     */
    getDefaultCurrency: function getDefaultCurrency() {
        var defCurrency = this._defaultCurrency;
        var first;
        if (defCurrency) {
            return defCurrency;
        }
        first = this.first();
        return first ? first.getCurrency() : null;
    },

    /**
     * @param {Party} defaultAuthor
     * @returns {ShippingCosts}
     */
    setDefaultAuthor: function setDefaultAuthor(defaultAuthor) {
        this._defaultAuthor = defaultAuthor;
        return this;
    },

    /**
     * @returns {object}
     */
    getDefaultAuthor: function getDefaultAuthor() {
        return this._defaultAuthor;
    },

    _addQuoteWithConfig: function _addQuoteWithConfig(config) {
        config.currency = config.currency || this.getDefaultCurrency();
        var defaultAuthor = this.getDefaultAuthor();
        var shippingCost = ShippingCost.createWithConfig(config);
        if (defaultAuthor) {
            shippingCost.setAuthor(defaultAuthor);
        }
        this.add(shippingCost);
        return shippingCost;
    }

});

// ---------------------------------------------------
// Define Module Static Properties

_.extend(ShippingCosts, /** @lends ShippingCosts */{

    _shippingCostsInstances: {},

    VIEW_NAME_SELLER_DEFAULTS: 'SELLER_DEFAULTS',

    VIEW_NAME_ADMIN_DEFAULTS: 'ADMIN_DEFAULTS',

    /**
     * @static
     * @private
     * @param {string} userType
     * @returns {symbol}
     */
    _getCostsCacheKeyForUserType: function () {
        var cacheKeys = {};
        return function (userType) {
            if (!cacheKeys[userType]) {
                cacheKeys[userType] = Symbol('fetching_costs_' + userType);
            }
            return cacheKeys[userType];
        };
    }(),

    /**
     * The default costType is 'unknown' which is used
     * by dealers who only enter one cost. This static
     * method can be used to quickly create a ShippingCosts
     * collection with one unknown shipping cost.
     * @param {number} subTotal
     * @param {string} currency
     * @returns {ShippingCosts}
     */
    createWithUnknownCost: function createWithUnknownCost(subTotal, currency) {
        var unknownCost = ShippingCost.createUnknownCostWithSubTotal(subTotal, currency);
        return new ShippingCosts([unknownCost]);
    },

    /**
     * @public
     * @static
     * @returns {ShippingCosts}
     */
    sellerDefaultCostsInstance: function sellerDefaultCostsInstance() {
        return ShippingCosts.defaultUserTypeShippingCosts(User.TYPE_SELLER);
    },

    /**
     * @public
     * @static
     * @returns {ShippingCosts}
     */
    adminDefaultCostsInstance: function adminDefaultCostsInstance() {
        return ShippingCosts.defaultUserTypeShippingCosts(User.TYPE_INTERNAL);
    },

    /**
     * @public
     * @static
     * @returns {ShippingCosts}
     */
    defaultUserTypeShippingCosts: function defaultUserTypeShippingCosts(userType) {
        var instance = ShippingCosts._shippingCostsInstances[userType];
        if (!instance) {
            instance = ShippingCosts._shippingCostsInstances[userType] = new ShippingCosts();
        }
        return instance;
    },

    /**
     * @param {object} fetchOptions Standard Backbone Model fetch options
     * @returns {Deferred.promise}
     */
    fetchSellerDefaultCostsInstance: function fetchSellerDefaultCostsInstance(fetchOptions) {
        return ShippingCosts.fetchDefaultShippingCostsInstance(User.TYPE_SELLER, fetchOptions);
    },

    /**
     * @param {object} fetchOptions Standard Backbone Model fetch options
     * @returns {Deferred.promise}
     */
    fetchAdminDefaultCostsInstance: function fetchAdminDefaultCostsInstance(fetchOptions) {
        return ShippingCosts.fetchDefaultShippingCostsInstance(User.TYPE_INTERNAL, fetchOptions);
    },

    /**
     * @public
     * @static
     * @param {object} userType The user type to fetch defaults for
     * @param {object} [fetchOptions] Standard Backbone.fetch options
     * @returns {Deferred.promise}
     */
    fetchDefaultShippingCostsInstance: function fetchDefaultShippingCostsInstance(userType, fetchOptions) {
        var viewName = userType === User.TYPE_INTERNAL ? ShippingCosts.VIEW_NAME_ADMIN_DEFAULTS : ShippingCosts.VIEW_NAME_SELLER_DEFAULTS;
        var cacheKey = ShippingCosts._getCostsCacheKeyForUserType(userType);
        var costsProm = globalCache.get(cacheKey);

        fetchOptions = extendFetchData(fetchOptions, { view: viewName });
        if (!costsProm) {
            costsProm = ShippingCosts.defaultUserTypeShippingCosts(userType).fetch(fetchOptions);
            globalCache.set(cacheKey, costsProm);
            globalCache.get(cacheKey);
            costsProm.fail(function () {
                globalCache.del(cacheKey);
            });
        }
        return costsProm;
    },

    /**
     * For the standard ShippingCosts singleton, if there is data
     * already set on the dataProvider, resets the collection to
     * use that data. Otherwise, fetches the data from the services.
     * @static
     * @public
     * @param {string} userType
     * @param {string} dataProviderKey
     * @param {object} [fetchOptions] Standard Backbone.fetch options
     * @returns {Deferred.promise}
     */
    requestDefaultShippingCostsInstanceUseDP: function requestDefaultShippingCostsInstanceUseDP(userType, dataProviderKey, fetchOptions) {
        var data = dataProvider.get(dataProviderKey || 'default_shipping_costs');
        var instance;
        if (data) {
            instance = ShippingCosts.defaultUserTypeShippingCosts(userType);
            if (data.length !== instance.length) {
                instance.reset(data);
            }
            return deferred().resolve(data).promise();
        }
        return ShippingCosts.fetchDefaultShippingCostsInstance(fetchOptions);
    },

    /**
     * @param {string} [dataProviderKey]
     * @param {object} [fetchOptions] Standard Backbone.fetch options
     * @returns {Deferred.promise}
     */
    requestSellerDefaultCostsUseDP: function requestSellerDefaultCostsUseDP(dataProviderKey, fetchOptions) {
        return this.requestDefaultShippingCostsInstanceUseDP(User.TYPE_SELLER, dataProviderKey, fetchOptions);
    },

    /**
     * @param {string} [dataProviderKey]
     * @param {object} [fetchOptions] Standard Backbone.fetch options
     * @returns {Deferred.promise}
     */
    requestAdminDefaultCostsUseDP: function requestAdminDefaultCostsUseDP(dataProviderKey, fetchOptions) {
        return this.requestDefaultShippingCostsInstanceUseDP(User.TYPE_INTERNAL, dataProviderKey, fetchOptions);
    }

});

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ADMIN_TYPE = 'adminRole';
var USER_TYPE = 'userRole';
var AuthorizedAdminRole = __webpack_require__(3837);
var AuthorizedUserRole = __webpack_require__(3838);

/**
 * An AuthorizedRole model gives the client information about what roles are permitted to take an action.
 * The "Role" specified is not the same as a "Role" in our system (where a role is a collection of permissions that
 * can be assigned to any internal user).
 * The role can be a collection of required permissions (which may be independent of internal user Roles) or it can
 * check against a user's ID.
 * ** NOTE - there are 2 authorized Role models, this parent model just uses the constructor / apiType property to
 * correctly identify the model type.
 *
 * AuthorizedRoles are used in the available actions
 * @type {Function}
 */
var AuthorizedRole = function AuthorizedRole(data, options) {
    var type = data.apiType || USER_TYPE;
    switch (type) {
        case USER_TYPE:
            return new AuthorizedUserRole(data, options);
        case ADMIN_TYPE:
            return new AuthorizedAdminRole(data, options);
    }
};

AuthorizedRole.apiTypes = {
    admin: ADMIN_TYPE,
    user: USER_TYPE
};

module.exports = AuthorizedRole;

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 10/6/14
 * Time: 12:18 PM
 */



var SoaModel = __webpack_require__(2);
var ItemPricing = module.exports = SoaModel.extend();

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var FinancialAmount = __webpack_require__(10);
var Price = __webpack_require__(66);
var PriceLock = __webpack_require__(1378);
var financialAmountMixin = __webpack_require__(48);

_.extend(ItemPricing.prototype, {
    relations: [{
        key: 'totalAmount',
        relatedModel: FinancialAmount,
        type: Backbone.One
    }, {
        key: 'initialPrice',
        relatedModel: FinancialAmount,
        type: Backbone.One
    }, {
        key: 'lowestPrice',
        relatedModel: FinancialAmount,
        type: Backbone.One
    }, {
        key: 'prices',
        relatedModel: Price,
        type: Backbone.Many
    }, {
        key: 'priceLocks',
        relatedModel: PriceLock,
        type: Backbone.Many
    }],
    getInitialPrice: function getInitialPrice(currency) {
        return this._getFinancialAmount('initialPrice', currency);
    },
    getLowestPrice: function getLowestPrice(currency) {
        return this._getFinancialAmount('lowestPrice', currency);
    },
    getPriceByType: function getPriceByType(type) {
        var prices = this.get('prices') || [];
        return prices.find(function (price) {
            return price.get('status') === 'ACTIVE' && price.get('type') === type;
        });
    },
    getPriceLockByType: function getPriceLockByType(type) {
        var priceLocks = this.get('priceLocks') || [];
        return priceLocks.find(function (price) {
            var lockType = price.get('lockType') || {};
            return lockType.name === type;
        });
    },
    getMostRelevantPrice: function getMostRelevantPrice(currency, includeNetPrice) {
        var prices = this.get('prices');
        var price = void 0;
        var amount = void 0;
        if (!prices || !prices.length) {
            return this.get('totalAmount.convertedAmounts.' + currency);
        }

        price = this.getPriceByType(Price.TYPE_SALE);
        if (!price && includeNetPrice) {
            price = this.getPriceByType(Price.TYPE_NET);
        }

        if (!price) {
            price = this.getPriceByType(Price.TYPE_RETAIL);
        }

        amount = price.get('amount');
        if (amount) {
            return amount.getAmountIn(currency);
        }

        return 0;
    }
}, financialAmountMixin);

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Load Super Class

var SoaModel = __webpack_require__(2);

// ---------------------------------------------------
// Module Definition

/**
 * @class ShippingCost
 * @extends SoaModel
 * @property {string} COST_TYPE_UNKNOWN
 */
var ShippingCost = module.exports = SoaModel.extend();

// ---------------------------------------------------
// Dependencies

var Party = __webpack_require__(8);
var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var FinancialAmount = __webpack_require__(10);
var financialAmountMixin = __webpack_require__(48);
var Seller = __webpack_require__(105);
var User = __webpack_require__(28);
var Permission = __webpack_require__(940);
var ShippingCosts = __webpack_require__(2206);
var Carriers = __webpack_require__(2205);
var Carrier = __webpack_require__(322);
var shippingCostTypeDisplay = __webpack_require__(2823);
var getDeferredMethods = __webpack_require__(299);
var dataProvider = __webpack_require__(780);
var globalCache = __webpack_require__(1092);

// ---------------------------------------------------
// Local Vars

var deferred = getDeferredMethods().Deferred;
var displayMapCacheKey = Symbol('fetching_cost_type_display_map');

function createPartyFromCurrentUser() {
    var user = Seller.getCurrentSeller();
    if (user) {
        return new Party({ id: user.id, role: Party.ROLE_SELLER });
    } else {
        user = User.getCurrentUserSV();
        if (user && user.hasPermission(Permission.PERMISSION_BASIC_INTERNAL)) {
            return new Party({ id: user.id, role: Party.ROLE_INTERNAL });
        }
    }
    return null;
}

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(ShippingCost.prototype, /** @lends ShippingCost.prototype */{

    relations: [{ key: 'billTo', relatedModel: Party, type: Backbone.One }, { key: 'author', relatedModel: Party, type: Backbone.One }, { key: 'subTotalAmount', relatedModel: FinancialAmount, type: Backbone.One }, { key: 'totalAmount', relatedModel: FinancialAmount, type: Backbone.One }],

    /**
     * @returns {boolean}
     */
    isLegacy: function isLegacy() {
        return this.get('isLegacy');
    },

    /**
     * @returns {boolean}
     */
    isUnknownCostType: function isUnknownCostType() {
        return this.isCostType(ShippingCost.COST_TYPE_UNKNOWN);
    },

    /**
     * @returns {boolean}
     */
    isTransitCostType: function isTransitCostType() {
        return this.isCostType(ShippingCost.COST_TYPE_TRANSIT);
    },

    /**
     * @param {string} costType
     * @returns {boolean}
     */
    isCostType: function isCostType(costType) {
        return this.getCostType() === costType;
    },

    /**
     * @param {string} costType
     */
    setCostType: function setCostType(costType) {
        this.set('costType', costType);
        return this;
    },

    /**
     * @returns {string}
     */
    getCostType: function getCostType() {
        return this.get('costType');
    },

    /**
     * @returns {string|number}
     */
    getBillToId: function getBillToId() {
        return this.get('billTo.id');
    },

    /**
     * @returns {string}
     */
    getBillToRole: function getBillToRole() {
        return this.get('billTo.role');
    },

    /**
     * @returns {boolean}
     */
    billToIsLSP: function billToIsLSP() {
        return this.getBillToRole() === Party.ROLE_LSP;
    },

    /**
     * @returns {number|string}
     */
    getAuthorId: function getAuthorId() {
        return this.get('author.id');
    },

    /**
     * @returns {Party}
     */
    getAuthor: function getAuthor() {
        return this.get('author');
    },

    /**
     * @returns {Party}
     */
    getBillTo: function getBillTo() {
        return this.get('billTo');
    },

    /**
     * @returns {SoaModel}
     */
    getBillToEntity: function getBillToEntity() {
        return this.get('billTo.entity');
    },

    /**
     * @returns {Carrier}
     */
    getBillToCarrierEntity: function getBillToCarrierEntity() {
        if (this._billToCarrier && this.getBillToId() === this._billToCarrier.id) {
            return this._billToCarrier;
        }
        var entity = this.getBillToEntity();
        this._billToCarrier = entity && this.billToIsLSP() ? new Carrier(entity.toJSON()) : null;
        return this._billToCarrier;
    },

    /**
     * Looks for inflated carrier entity in the billTo
     * model, and returns it if present. Otherwise, searches
     * the Carriers singleton for a carrier matching the
     * billTo id (if billTo is LSP) and returns that if found.
     * @returns {Carrier}
     */
    findBillToCarrier: function findBillToCarrier() {
        if (!this.billToIsLSP()) {
            return null;
        }
        var entity = this.getBillToCarrierEntity();
        var id;
        if (entity) {
            return entity;
        }
        id = this.getBillToId();
        return id ? Carriers.findCarrierForId(id) : null;
    },

    /**
     * Returns true if the cost has one of the "default"
     * cost types (which at this point is TRANSIT or UNKNOWN)
     * @returns {boolean}
     */
    isDefaultCost: function isDefaultCost() {
        return this.isUnknownCostType() || this.isTransitCostType();
    },

    /**
     * First, searches the billTo object for an inflated
     * entity, and returns the entity name if found. Then,
     * searches the Carriers singleton for a carrier with
     * the matching id of the shipping cost instance's
     * billTo and returns the name.
     * @returns {string}
     */
    findBillToCarrierName: function findBillToCarrierName() {
        var carrier = this.findBillToCarrier();
        return carrier ? carrier.get('name') : null;
    },

    /**
     * Searches the billTo object for in inflated carrier
     * entity, and returns the name if found. Otherwise,
     * searches the Carriers singleton for a matching carrier
     * id and returns that match's code.
     * @returns {string}
     */
    findBillToCarrierCode: function findBillToCarrierCode() {
        var carrier = this.findBillToCarrier();
        return carrier ? carrier.get('code') : null;
    },

    /**
     * Attempts to find the bill to Carrier model. If found,
     * then returns a formatted version of the carrier name.
     * Otherwise, returns null.
     * @returns {string}
     */
    describeBillToCarrierName: function describeBillToCarrierName() {
        var carrier = this.findBillToCarrier();
        return carrier ? carrier.describeCarrierName() : null;
    },

    /**
     * Returns true if the billTo has an inflated
     * carrier entity and that carrier entity is
     * an "other" custom carrier.
     * @returns {boolean}
     */
    billToCarrierIsOther: function billToCarrierIsOther() {
        var carrier = this.findBillToCarrier();
        return carrier ? carrier.isOtherCarrier() : false;
    },

    /**
     * @returns {string}
     */
    getCostTypeDisplayVal: function getCostTypeDisplayVal() {
        return ShippingCost.getDisplayValueForCostType(this.getCostType());
    },

    /**
     * @param {Party|object} author
     */
    setAuthor: function setAuthor(author) {
        this.set('author', author instanceof Party ? author.toJSON() : author);
        return this;
    },

    /**
     * @param {Party|object} billTo
     */
    setBillTo: function setBillTo(billTo) {
        billTo = billTo instanceof Party ? billTo.toJSON() : billTo;
        var model = this.get('billTo');
        if (model) {
            model.clear({ silent: true }).set(billTo);
        } else {
            this.set('billTo', billTo);
        }
        return this;
    },

    /**
     * @returns {FinancialAmount}
     */
    getSubTotalAmount: function getSubTotalAmount() {
        return this.get('subTotalAmount');
    },

    /**
     * @returns {string|number}
     */
    getSubTotalNum: function getSubTotalNum() {
        return this.get('subTotalAmount.amount');
    },

    /**
     * @returns {string}
     */
    getCurrency: function getCurrency() {
        return this.get('subTotalAmount.currency');
    },

    /**
     * @param {number} subTotal
     * @returns {ShippingCost}
     */
    setSubTotal: function setSubTotal(subTotal) {
        var amount = this._ensureSubTotalAmount();
        amount.set('amount', subTotal);
        return this;
    },

    /**
     * @param {number} subTotal
     * @param {string} currency
     * @returns {ShippingCost}
     */
    setSubTotalAndCurr: function setSubTotalAndCurr(subTotal, currency) {
        var amount = this._ensureSubTotalAmount();
        amount.set({
            amount: subTotal,
            currency: currency
        });
        return this;
    },

    /**
     * @returns {FinancialAmount}
     * @private
     */
    _ensureSubTotalAmount: function _ensureSubTotalAmount() {
        var amount = this.getSubTotalAmount();
        if (!amount) {
            this.set('subTotalAmount', {});
            return this.getSubTotalAmount();
        }
        return amount;
    }

}, financialAmountMixin);

// ---------------------------------------------------
// Define Module Static Properties

_.extend(ShippingCost, /** @lends ShippingCost */{

    costTypeDisplayMap: null,

    COST_TYPE_UNKNOWN: 'UNKNOWN',

    COST_TYPE_TRANSIT: 'TRANSIT',

    /**
     * @public
     * @static
     * @param {string} costType
     * @param {string} authorRole
     * @returns {{role:string,id:number}}
     */
    getDefaultBillToForType: function getDefaultBillToForType(costType, authorRole) {
        if (costType && authorRole) {
            var defaultCosts = authorRole === Party.ROLE_INTERNAL ? ShippingCosts.adminDefaultCostsInstance() : ShippingCosts.sellerDefaultCostsInstance();
            var defaultBillTo = defaultCosts.getBillToForType(costType);
            return defaultBillTo ? defaultBillTo.toJSON() : null;
        }
        return _.indexOf([ShippingCost.COST_TYPE_UNKNOWN, ShippingCost.COST_TYPE_TRANSIT], costType) > -1 ? { role: Party.ROLE_LSP } : null;
    },

    /**
     * @public
     * @static
     * @memberOf ShippingCost
     * @param {string} [costType]
     * @param {number} [subTotal]
     * @param {string} [currency]
     * @returns {ShippingCost}
     */
    createWithTypeAndSubTotal: function createWithTypeAndSubTotal(costType, subTotal, currency) {
        return new ShippingCost({
            costType: costType,
            subTotalAmount: {
                amount: subTotal,
                currency: currency
            }
        });
    },

    /**
     * Creates a new ShippingCost based on a simplified
     * options parameter. Defaults author to the be based
     * on the current seller or internal user. Defaults the
     * billTo to use the billTo derived from the
     * ShippingCosts defaults instance.
     * @public
     * @static
     * @param {object} [config]
     * @param {object} [config.author]
     * @param {object} [config.billTo]
     * @param {string} [config.costType]
     * @param {boolean} [config.isLegacy]
     * @param {number} [config.subTotal]
     * @param {string} [config.currency]
     * @returns {ShippingCost}
     */
    createWithConfig: function createWithConfig(config) {
        var authorRole;
        config = config ? _.clone(config) : {};
        config.author = config.author || createPartyFromCurrentUser();
        authorRole = config.author ? config.author.role : null;
        config.billTo = config.billTo || ShippingCost.getDefaultBillToForType(config.costType, authorRole);
        return new ShippingCost({
            costType: config.costType,
            author: config.author || {},
            billTo: config.billTo || {},
            isLegacy: config.isLegacy,
            subTotalAmount: {
                amount: config.subTotal,
                currency: config.currency
            }
        });
    },

    /**
     * @public
     * @static
     * @param {number} subTotal
     * @param {string} currency
     * @returns {ShippingCost}
     */
    createUnknownCostWithSubTotal: function createUnknownCostWithSubTotal(subTotal, currency) {
        return ShippingCost.createWithConfig({
            costType: ShippingCost.COST_TYPE_UNKNOWN,
            subTotal: subTotal,
            currency: currency,
            isLegacy: true
        });
    },

    /**
     * Fetches the json map for the cost type display values.
     * Defers to the data provider value for the map, but if
     * the data provider returns an empty result, then the json
     * is fetched from a url to the static repo.
     * @public
     * @static
     * @param {string} dataProviderKey
     * @returns {Deferred.promise}
     */
    requestCostTypeDisplayMapUseDP: function requestCostTypeDisplayMapUseDP(dataProviderKey) {
        var costTypeMapProm = globalCache.get(displayMapCacheKey);
        if (costTypeMapProm) {
            return costTypeMapProm;
        }
        var data = dataProvider.get(dataProviderKey || 'shipping_cost_type_display');
        if (data) {
            costTypeMapProm = deferred().resolve(data).promise();
        } else {
            costTypeMapProm = deferred().resolve(shippingCostTypeDisplay).promise();
        }
        costTypeMapProm.done(function (data) {
            ShippingCost.costTypeDisplayMap = data;
            globalCache.set(displayMapCacheKey, costTypeMapProm);
        });

        return costTypeMapProm;
    },

    /**
     * @param {string} costType
     * @returns {string}
     */
    getDisplayValueForCostType: function getDisplayValueForCostType(costType) {
        var map = ShippingCost.costTypeDisplayMap;
        return map ? map[costType] : null;
    }

});

/***/ }),
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */,
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */,
/* 2227 */,
/* 2228 */,
/* 2229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(3920);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = Symbol;


/***/ }),
/* 2230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(3914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(3916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(3921);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = isPlainObject;


/***/ }),
/* 2231 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function arrayCopy(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = arrayCopy;


/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseCopy = __webpack_require__(2233),
    keys = __webpack_require__(297);

/**
 * The base implementation of `_.assign` without support for argument juggling,
 * multiple sources, and `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return source == null
    ? object
    : baseCopy(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 2233 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property names to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @returns {Object} Returns `object`.
 */
function baseCopy(source, props, object) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    object[key] = source[key];
  }
  return object;
}

module.exports = baseCopy;


/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var isNative = __webpack_require__(1383),
    isObject = __webpack_require__(3925),
    noop = __webpack_require__(2241);

/* Native method shortcuts for methods with the same name as other `lodash` methods */
var nativeCreate = isNative(nativeCreate = Object.create) && nativeCreate;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(prototype, properties) {
  return isObject(prototype) ? nativeCreate(prototype) : {};
}
// fallback for browsers without `Object.create`
if (!nativeCreate) {
  baseCreate = (function() {
    function Object() {}
    return function(prototype) {
      if (isObject(prototype)) {
        Object.prototype = prototype;
        var result = new Object;
        Object.prototype = null;
      }
      return result || global.Object();
    };
  }());
}

module.exports = baseCreate;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 4.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var Stack = __webpack_require__(2238),
    baseIsEqual = __webpack_require__(1906);

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack,
          result = customizer ? customizer(objValue, srcValue, key, object, source, stack) : undefined;

      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 2236 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var bindCallback = __webpack_require__(123),
    isIterateeCall = __webpack_require__(1908),
    restParam = __webpack_require__(279);

/**
 * Creates a function that assigns properties of source object(s) to a given
 * destination object.
 *
 * **Note:** This function is used to create `_.assign`, `_.defaults`, and `_.merge`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return restParam(function(object, sources) {
    var index = -1,
        length = object == null ? 0 : sources.length,
        customizer = length > 2 ? sources[length - 2] : undefined,
        guard = length > 2 ? sources[2] : undefined,
        thisArg = length > 1 ? sources[length - 1] : undefined;

    if (typeof customizer == 'function') {
      customizer = bindCallback(customizer, thisArg, 5);
      length -= 2;
    } else {
      customizer = typeof thisArg == 'function' ? thisArg : undefined;
      length -= (customizer ? 1 : 0);
    }
    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {/**
 * lodash 4.1.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to determine if values are of the language type `Object`. */
var objectTypes = {
  'function': true,
  'object': true
};

/** Detect free variable `exports`. */
var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
  ? exports
  : undefined;

/** Detect free variable `module`. */
var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
  ? module
  : undefined;

/** Detect free variable `global` from Node.js. */
var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);

/** Detect free variable `self`. */
var freeSelf = checkGlobal(objectTypes[typeof self] && self);

/** Detect free variable `window`. */
var freeWindow = checkGlobal(objectTypes[typeof window] && window);

/** Detect `this` as the global object. */
var thisGlobal = checkGlobal(objectTypes[typeof this] && this);

/**
 * Used as a reference to the global object.
 *
 * The `this` value is used if it's the global object to avoid Greasemonkey's
 * restricted `window` object, otherwise the `window` object is used.
 */
var root = freeGlobal ||
  ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
    freeSelf || thisGlobal || Function('return this')();

/**
 * Checks if `value` is a global object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
 */
function checkGlobal(value) {
  return (value && value.Object === Object) ? value : null;
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @returns {Object} Returns the new hash object.
 */
function Hash() {}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(hash, key) {
  return hashHas(hash, key) && delete hash[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @param {Object} hash The hash to query.
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(hash, key) {
  if (nativeCreate) {
    var result = hash[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(hash, key) ? hash[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @param {Object} hash The hash to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(hash, key) {
  return nativeCreate ? hash[key] !== undefined : hasOwnProperty.call(hash, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 */
function hashSet(hash, key, value) {
  hash[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
}

// Avoid inheriting from `Object.prototype` when possible.
Hash.prototype = nativeCreate ? nativeCreate(null) : objectProto;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function MapCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.clear();
  while (++index < length) {
    var entry = values[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': Map ? new Map : [],
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapDelete(key) {
  var data = this.__data__;
  if (isKeyable(key)) {
    return hashDelete(typeof key == 'string' ? data.string : data.hash, key);
  }
  return Map ? data.map['delete'](key) : assocDelete(data.map, key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapGet(key) {
  var data = this.__data__;
  if (isKeyable(key)) {
    return hashGet(typeof key == 'string' ? data.string : data.hash, key);
  }
  return Map ? data.map.get(key) : assocGet(data.map, key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapHas(key) {
  var data = this.__data__;
  if (isKeyable(key)) {
    return hashHas(typeof key == 'string' ? data.string : data.hash, key);
  }
  return Map ? data.map.has(key) : assocHas(data.map, key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapSet(key, value) {
  var data = this.__data__;
  if (isKeyable(key)) {
    hashSet(typeof key == 'string' ? data.string : data.hash, key, value);
  } else if (Map) {
    data.map.set(key, value);
  } else {
    assocSet(data.map, key, value);
  }
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapClear;
MapCache.prototype['delete'] = mapDelete;
MapCache.prototype.get = mapGet;
MapCache.prototype.has = mapHas;
MapCache.prototype.set = mapSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function Stack(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.clear();
  while (++index < length) {
    var entry = values[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = { 'array': [], 'map': null };
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      array = data.array;

  return array ? assocDelete(array, key) : data.map['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  var data = this.__data__,
      array = data.array;

  return array ? assocGet(array, key) : data.map.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  var data = this.__data__,
      array = data.array;

  return array ? assocHas(array, key) : data.map.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__,
      array = data.array;

  if (array) {
    if (array.length < (LARGE_ARRAY_SIZE - 1)) {
      assocSet(array, key, value);
    } else {
      data.array = null;
      data.map = new MapCache(array);
    }
  }
  var map = data.map;
  if (map) {
    map.set(key, value);
  }
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Removes `key` and its value from the associative array.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function assocDelete(array, key) {
  var index = assocIndexOf(array, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = array.length - 1;
  if (index == lastIndex) {
    array.pop();
  } else {
    splice.call(array, index, 1);
  }
  return true;
}

/**
 * Gets the associative array value for `key`.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function assocGet(array, key) {
  var index = assocIndexOf(array, key);
  return index < 0 ? undefined : array[index][1];
}

/**
 * Checks if an associative array value for `key` exists.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function assocHas(array, key) {
  return assocIndexOf(array, key) > -1;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * Sets the associative array `key` to `value`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 */
function assocSet(array, key, value) {
  var index = assocIndexOf(array, key);
  if (index < 0) {
    array.push([key, value]);
  } else {
    array[index][1] = value;
  }
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'number' || type == 'boolean' ||
    (type == 'string' && value != '__proto__') || value == null;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'user': 'fred' };
 * var other = { 'user': 'fred' };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (!isObject(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = Stack;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module), __webpack_require__(4)))

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2240 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.6 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
function isTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

module.exports = isTypedArray;


/***/ }),
/* 2241 */
/***/ (function(module, exports) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/**
 * A no-operation function.
 *
 * @static
 * @memberOf _
 * @category Utilities
 * @example
 *
 * var object = { 'name': 'fred' };
 * _.noop(object) === undefined;
 * // => true
 */
function noop() {
  // no operation performed
}

module.exports = noop;


/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return arrayMap(props, function(key) {
    return [key, object[key]];
  });
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = [value, value];
  });
  return result;
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function(object) {
    var tag = getTag(object);
    if (tag == mapTag) {
      return mapToArray(object);
    }
    if (tag == setTag) {
      return setToPairs(object);
    }
    return baseToPairs(object, keysFunc(object));
  };
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
var toPairs = createToPairs(keys);

module.exports = toPairs;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */,
/* 2261 */,
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hexTable = (function () {
    var array = new Array(256);
    for (var i = 0; i < 256; ++i) {
        array[i] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    }

    return array;
}());

var has = Object.prototype.hasOwnProperty;

exports.arrayToObject = function (source, options) {
    var obj = options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

exports.merge = function (target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = exports.arrayToObject(target, options);
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = exports.merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

exports.decode = function (str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function (str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D || // -
            c === 0x2E || // .
            c === 0x5F || // _
            c === 0x7E || // ~
            (c >= 0x30 && c <= 0x39) || // 0-9
            (c >= 0x41 && c <= 0x5A) || // a-z
            (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)] + hexTable[0x80 | ((c >> 12) & 0x3F)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

exports.compact = function (obj, references) {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }

    var refs = references || [];
    var lookup = refs.indexOf(obj);
    if (lookup !== -1) {
        return refs[lookup];
    }

    refs.push(obj);

    if (Array.isArray(obj)) {
        var compacted = [];

        for (var i = 0; i < obj.length; ++i) {
            if (obj[i] && typeof obj[i] === 'object') {
                compacted.push(exports.compact(obj[i], refs));
            } else if (typeof obj[i] !== 'undefined') {
                compacted.push(obj[i]);
            }
        }

        return compacted;
    }

    var keys = Object.keys(obj);
    for (var j = 0; j < keys.length; ++j) {
        var key = keys[j];
        obj[key] = exports.compact(obj[key], refs);
    }

    return obj;
};

exports.isRegExp = function (obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

exports.isBuffer = function (obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};


/***/ }),
/* 2263 */,
/* 2264 */,
/* 2265 */,
/* 2266 */,
/* 2267 */,
/* 2268 */,
/* 2269 */,
/* 2270 */,
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _propTypes2["default"].shape({
  subscribe: _propTypes2["default"].func.isRequired,
  dispatch: _propTypes2["default"].func.isRequired,
  getState: _propTypes2["default"].func.isRequired
});

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule callsToGraphQL
 * 
 */



var QueryBuilder = __webpack_require__(1425);

/**
 * @internal
 *
 * Convert from plain object `{name, value}` calls to GraphQL call nodes.
 */
function callsToGraphQL(calls) {
  return calls.map(function (_ref) {
    var name = _ref.name,
        type = _ref.type,
        value = _ref.value;

    var concreteValue = null;
    if (Array.isArray(value)) {
      concreteValue = value.map(QueryBuilder.createCallValue);
    } else if (value != null) {
      concreteValue = QueryBuilder.createCallValue(value);
    }
    return QueryBuilder.createCall(name, concreteValue, type);
  });
}

module.exports = callsToGraphQL;

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule stableStringify
 * 
 */



var _stringify = __webpack_require__(1977);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(4220);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isObject(value) {
  return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}

/**
 * Simple recursive stringifier that handles basic objects (does not handle
 * corner cases such as circular references) and produces a JSON-like
 * serialization suitable for use as a cache key or other similar internal
 * book-keeping detail.
 *
 * Sample input:
 *
 *     var object = {
 *       top2: {
 *         middle: {
 *           inner: [1, 'foo', ['bar', 2]],
 *           other: false,
 *         },
 *       },
 *       top1: [
 *         {first: true},
 *         {first: false},
 *         'random',
 *       ],
 *       misc: true,
 *       extra: null,
 *     };
 *
 * Sample output (some whitespace added for clarity):
 *
 *    {
 *      extra:null,
 *      misc:true,
 *      top1:[0:{first:true},1:{first:false},2:"random"],
 *      top2:{middle:{inner:[0:1,1:"foo",2:[0:"bar",1:2]],other:false}}
 *    }
 */
function stableStringify(input) {
  var inputIsArray = Array.isArray(input);
  var inputIsObject = isObject(input);
  if (inputIsArray || inputIsObject) {
    var keys = (0, _keys2['default'])(input);
    if (keys.length) {
      var result = [];
      keys.sort();

      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var value = input[key];
        if (isObject(value) || Array.isArray(value)) {
          value = stableStringify(value);
        } else {
          value = (0, _stringify2['default'])(value);
        }
        result.push(key + ':' + value);
      }

      if (inputIsArray) {
        return '[' + result.join(',') + ']';
      } else {
        return '{' + result.join(',') + '}';
      }
    }
  }
  return (0, _stringify2['default'])(input);
}

module.exports = stableStringify;

/***/ }),
/* 2275 */,
/* 2276 */,
/* 2277 */,
/* 2278 */,
/* 2279 */,
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.componentFromStreamWithConfig = undefined;

var _react = __webpack_require__(1);

var _changeEmitter = __webpack_require__(2061);

var _symbolObservable = __webpack_require__(1949);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

var _setObservableConfig = __webpack_require__(1549);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var componentFromStreamWithConfig = exports.componentFromStreamWithConfig = function componentFromStreamWithConfig(config) {
  return function (propsToVdom) {
    return function (_Component) {
      _inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        _classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = (0, _changeEmitter.createChangeEmitter)(), _this.props$ = config.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              return observer.next(props);
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[_symbolObservable2.default] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config.toESObservable(propsToVdom(_this.props$)), _temp), _possibleConstructorReturn(_this, _ret);
      }

      // Stream of props


      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Clean-up subscription before un-mounting
        this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(_react.Component);
  };
};

var componentFromStream = componentFromStreamWithConfig(_setObservableConfig.config);

exports.default = componentFromStream;

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createEagerElementUtil = __webpack_require__(2284);

var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);

var _isReferentiallyTransparentFunctionComponent = __webpack_require__(2282);

var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createEagerElement = function createEagerElement(type, props, children) {
  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
  /* eslint-disable */
  var hasKey = props && props.hasOwnProperty('key');
  /* eslint-enable */
  return (0, _createEagerElementUtil2.default)(hasKey, isReferentiallyTransparent, type, props, children);
};

exports.default = createEagerElement;

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isClassComponent = __webpack_require__(1948);

var _isClassComponent2 = _interopRequireDefault(_isClassComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && !Component.propTypes);
};

exports.default = isReferentiallyTransparentFunctionComponent;

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shouldUpdate = __webpack_require__(1951);

var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);

var _shallowEqual = __webpack_require__(1550);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _pick = __webpack_require__(1953);

var _pick2 = _interopRequireDefault(_pick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  return (0, _shouldUpdate2.default)(function (props, nextProps) {
    return !(0, _shallowEqual2.default)((0, _pick2.default)(nextProps, propKeys), (0, _pick2.default)(props, propKeys));
  });
};

exports.default = (0, _createHelper2.default)(onlyUpdateForKeys, 'onlyUpdateForKeys');

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
  if (!hasKey && isReferentiallyTransparent) {
    if (children) {
      return type(_extends({}, props, { children: children }));
    }
    return type(props);
  }

  var Component = type;

  if (children) {
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  }

  return _react2.default.createElement(Component, props);
};

exports.default = createEagerElementUtil;

/***/ }),
/* 2285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  var last = funcs[funcs.length - 1];
  var rest = funcs.slice(0, -1);
  return function () {
    return rest.reduceRight(function (composed, f) {
      return f(composed);
    }, last.apply(undefined, arguments));
  };
}

/***/ }),
/* 2286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(2230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(2289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'
};

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} enhancer The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/zenparsing/es-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 2287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 2288 */
/***/ (function(module, exports) {

// Load modules


// Declare internals

var internals = {};
internals.hexTable = new Array(256);
for (var h = 0; h < 256; ++h) {
    internals.hexTable[h] = '%' + ((h < 16 ? '0' : '') + h.toString(16)).toUpperCase();
}


exports.arrayToObject = function (source, options) {

    var obj = options.plainObjects ? Object.create(null) : {};
    for (var i = 0, il = source.length; i < il; ++i) {
        if (typeof source[i] !== 'undefined') {

            obj[i] = source[i];
        }
    }

    return obj;
};


exports.merge = function (target, source, options) {

    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        }
        else if (typeof target === 'object') {
            target[source] = true;
        }
        else {
            target = [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        target = [target].concat(source);
        return target;
    }

    if (Array.isArray(target) &&
        !Array.isArray(source)) {

        target = exports.arrayToObject(target, options);
    }

    var keys = Object.keys(source);
    for (var k = 0, kl = keys.length; k < kl; ++k) {
        var key = keys[k];
        var value = source[key];

        if (!Object.prototype.hasOwnProperty.call(target, key)) {
            target[key] = value;
        }
        else {
            target[key] = exports.merge(target[key], value, options);
        }
    }

    return target;
};


exports.decode = function (str) {

    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function (str) {

    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    if (typeof str !== 'string') {
        str = '' + str;
    }

    var out = '';
    for (var i = 0, il = str.length; i < il; ++i) {
        var c = str.charCodeAt(i);

        if (c === 0x2D || // -
            c === 0x2E || // .
            c === 0x5F || // _
            c === 0x7E || // ~
            (c >= 0x30 && c <= 0x39) || // 0-9
            (c >= 0x41 && c <= 0x5A) || // a-z
            (c >= 0x61 && c <= 0x7A)) { // A-Z

            out += str[i];
            continue;
        }

        if (c < 0x80) {
            out += internals.hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out += internals.hexTable[0xC0 | (c >> 6)] + internals.hexTable[0x80 | (c & 0x3F)];
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out += internals.hexTable[0xE0 | (c >> 12)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
            continue;
        }

        ++i;
        c = 0x10000 + (((c & 0x3FF) << 10) | (str.charCodeAt(i) & 0x3FF));
        out += internals.hexTable[0xF0 | (c >> 18)] + internals.hexTable[0x80 | ((c >> 12) & 0x3F)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

exports.compact = function (obj, refs) {

    if (typeof obj !== 'object' ||
        obj === null) {

        return obj;
    }

    refs = refs || [];
    var lookup = refs.indexOf(obj);
    if (lookup !== -1) {
        return refs[lookup];
    }

    refs.push(obj);

    if (Array.isArray(obj)) {
        var compacted = [];

        for (var i = 0, il = obj.length; i < il; ++i) {
            if (typeof obj[i] !== 'undefined') {
                compacted.push(obj[i]);
            }
        }

        return compacted;
    }

    var keys = Object.keys(obj);
    for (i = 0, il = keys.length; i < il; ++i) {
        var key = keys[i];
        obj[key] = exports.compact(obj[key], refs);
    }

    return obj;
};


exports.isRegExp = function (obj) {

    return Object.prototype.toString.call(obj) === '[object RegExp]';
};


exports.isBuffer = function (obj) {

    if (obj === null ||
        typeof obj === 'undefined') {

        return false;
    }

    return !!(obj.constructor &&
              obj.constructor.isBuffer &&
              obj.constructor.isBuffer(obj));
};


/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4159);


/***/ }),
/* 2290 */,
/* 2291 */,
/* 2292 */,
/* 2293 */,
/* 2294 */,
/* 2295 */,
/* 2296 */,
/* 2297 */,
/* 2298 */,
/* 2299 */,
/* 2300 */,
/* 2301 */,
/* 2302 */,
/* 2303 */,
/* 2304 */,
/* 2305 */,
/* 2306 */,
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {

    var resolveRef;
    var rejectRef;

    var promise = new Promise(function (resolve, reject) {
        resolveRef = resolve;
        rejectRef = reject;
    });

    return {
        resolve: function () {
            resolveRef.apply(this, arguments);
            return promise;
        },
        reject: function () {
            rejectRef.apply(this, arguments);
            return promise;
        },
        then: promise.then.bind(promise),
        catch: promise.catch.bind(promise)
    };
};


/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(149);

/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(156);

/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(173);

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(237);

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(24);

/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(34);

/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(351);

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(354);

/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(372);

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(39);

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(64);

/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(4252))(72);

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(78);

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(81);

/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(87);

/***/ }),
/* 2323 */,
/* 2324 */,
/* 2325 */,
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: daletan
 * Date: 7/29/14
 * Time: 5:24 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */


var $ = __webpack_require__(5);
var VisitorTracking = __webpack_require__(2568);
$(function () {
    VisitorTracking.getInstance().init();
});


/***/ }),
/* 2327 */,
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1969);
__webpack_require__(1967);
__webpack_require__(1966);
__webpack_require__(1971);
__webpack_require__(1968);
__webpack_require__(4225);
__webpack_require__(1970);
__webpack_require__(1972);
__webpack_require__(2673);
__webpack_require__(1974);
__webpack_require__(1973);
__webpack_require__(724);


/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _gas = __webpack_require__(2084);
var gtmDataLayer = __webpack_require__(2085);
var actFormRe    = /\(([^\)]*)\)/i;
var labFieldRe   = /^([^\(]*)/i;
var legacyPrefix = 'legacy ';

// TODO: figure out good way to not use actual account number while running tests
_gas.push(['_setAccount', 'UA-28839796-1']);
_gas.push(['_setDomainName', '.1stdibs.com']);
_gas.push(['_gasTrackForms']);
_gas.push(['_gasTrackOutboundLinks']);
_gas.push(['_gasTrackDownloads']);
_gas.push(['_gasTrackMailto']);

// Using gas trackEvent hook to push events to gtm dataLayer
_gas.push(['_addHook', '_trackEvent', function (cat, act, lab, val, noninteraction) {
    if (cat.toLowerCase() === 'outbound' && act.indexOf('1stdibs.com') >= 0) {
        return false;
    }

    // setting defaults
    lab = lab || undefined;
    val = val || 0;

    // noninteraction should default to 1 if undefined but falsy values should be 0
    noninteraction = (noninteraction !== undefined && !noninteraction) ? 0 : 1;

    // transform GAS form field tracking
    if (cat === 'Form Tracking') {
        cat = 'form field tracking';
        act = act.match(actFormRe)[1] + ' field change';
        lab = lab.match(labFieldRe)[0].trim();
    }

    // push to GTM dataLayer
    gtmDataLayer.push({
        'event'         : 'e_ga_event',
        'category'      : legacyPrefix + cat,
        'action'        : act,
        'label'         : lab,
        'value'         : val,
        'noninteraction': noninteraction
    });

    // Cancel _gas call since we are now using GTM
    return false;
}]);

// Using gas trackPageview hook to push pageviews to gtm dataLayer
_gas.push(['_addHook', '_trackPageview', function (optPageURL) {
    // defaults
    optPageURL = optPageURL || location.href.split(location.host)[1];

    // push to GTM dataLayer
    gtmDataLayer.push({
        'event'         : 'e_ga_pageview',
        'opt_pageURL'   : legacyPrefix + optPageURL
    });

    // Cancel _gas call since we are now using GTM
    return false;
}]);

// Using gas trackSocial hook to push socialEvents to gtm dataLayer
_gas.push(['_addHook', '_trackSocial', function (network, socialAction, optTarget, optPagePath) {
    // push to GTM dataLayer
    gtmDataLayer.push({
        'event'         : 'e_ga_social',
        'network'       : legacyPrefix + network,
        'socialAction'  : socialAction,
        'opt_target'    : optTarget     || undefined,
        'opt_pagePath'  : optPagePath   || undefined
    });

    // Cancel _gas call since we are now using GTM
    return false;
}]);


/***/ }),
/* 2330 */,
/* 2331 */,
/* 2332 */,
/* 2333 */,
/* 2334 */,
/* 2335 */,
/* 2336 */,
/* 2337 */,
/* 2338 */,
/* 2339 */,
/* 2340 */,
/* 2341 */,
/* 2342 */,
/* 2343 */,
/* 2344 */,
/* 2345 */,
/* 2346 */,
/* 2347 */,
/* 2348 */,
/* 2349 */,
/* 2350 */,
/* 2351 */,
/* 2352 */,
/* 2353 */,
/* 2354 */,
/* 2355 */,
/* 2356 */,
/* 2357 */,
/* 2358 */,
/* 2359 */,
/* 2360 */,
/* 2361 */,
/* 2362 */,
/* 2363 */,
/* 2364 */,
/* 2365 */,
/* 2366 */,
/* 2367 */,
/* 2368 */,
/* 2369 */,
/* 2370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"verticallyCentered":"SimpleModal-style__verticallyCentered__3IxZG","horizontallyRight":"SimpleModal-style__horizontallyRight__iKj-D","horizontallyCentered":"SimpleModal-style__horizontallyCentered__33pTJ","verticallyHorizontallyCentered":"SimpleModal-style__verticallyHorizontallyCentered__H-hlN"};

/***/ }),
/* 2371 */,
/* 2372 */,
/* 2373 */,
/* 2374 */,
/* 2375 */,
/* 2376 */,
/* 2377 */,
/* 2378 */,
/* 2379 */,
/* 2380 */,
/* 2381 */,
/* 2382 */,
/* 2383 */,
/* 2384 */,
/* 2385 */,
/* 2386 */,
/* 2387 */,
/* 2388 */,
/* 2389 */,
/* 2390 */,
/* 2391 */,
/* 2392 */,
/* 2393 */,
/* 2394 */,
/* 2395 */,
/* 2396 */,
/* 2397 */,
/* 2398 */,
/* 2399 */,
/* 2400 */,
/* 2401 */,
/* 2402 */,
/* 2403 */,
/* 2404 */,
/* 2405 */,
/* 2406 */,
/* 2407 */,
/* 2408 */,
/* 2409 */,
/* 2410 */,
/* 2411 */,
/* 2412 */,
/* 2413 */,
/* 2414 */,
/* 2415 */,
/* 2416 */,
/* 2417 */,
/* 2418 */,
/* 2419 */,
/* 2420 */,
/* 2421 */,
/* 2422 */,
/* 2423 */,
/* 2424 */,
/* 2425 */,
/* 2426 */,
/* 2427 */,
/* 2428 */,
/* 2429 */,
/* 2430 */,
/* 2431 */,
/* 2432 */,
/* 2433 */,
/* 2434 */,
/* 2435 */,
/* 2436 */,
/* 2437 */,
/* 2438 */,
/* 2439 */,
/* 2440 */,
/* 2441 */,
/* 2442 */,
/* 2443 */,
/* 2444 */,
/* 2445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: hella
 * Date: 4/9/14
 * Time: 2:18 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */



var $ = __webpack_require__(5);
var SV = __webpack_require__(18);
var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(39);
var User = __webpack_require__(15);
var nav = __webpack_require__(3614);
var navDfp = __webpack_require__(2570);
var footer = __webpack_require__(3613);
var tooltips = __webpack_require__(2578);
var tapEvents = __webpack_require__(2584);
var deepLink = __webpack_require__(1603);
var log = __webpack_require__(295);
var scriptLoader = __webpack_require__(2630);
var browserCheck = __webpack_require__(490);
var mobileCheck = __webpack_require__(283);
var windowCheck = __webpack_require__(102);
var userTracking = __webpack_require__(1980);
var pageViewTracking = __webpack_require__(2581);
var ContextProvider = __webpack_require__(293);
var LogoTradeIcon = __webpack_require__(2086);

// Component helpers:
var notificationHelper = __webpack_require__(3622);
var currencySelectHelper = __webpack_require__(3379);

__webpack_require__(3621);
__webpack_require__(2030);
__webpack_require__(677);

/**
 * @returns {string} classes
 */
function getBodyClass() {
    var classes = [];
    if (!mobileCheck.isTouchDevice()) {
        classes.push('no-touch');
    } else {
        classes.push('has-touch');
    }
    if (browserCheck.ie()) {
        classes.push('is-ie');
    }
    if (mobileCheck.Android() && !browserCheck.chrome()) {
        //eslint-disable-line new-cap
        classes.push('is-android');
    }
    return classes.join(' ');
}

function setBodyClass() {
    var classes = getBodyClass();
    if (classes) {
        $('body').addClass(classes);
    }
}

function setTradeHeader() {
    var bodyEl = document.querySelector('body');
    var tradeClass = 'is-trade';
    var hasTradeClass = bodyEl.className.includes(tradeClass);

    if (hasTradeClass) {
        return;
    }

    if (User.getCurrentUser().isVerifiedTradeBuyer()) {
        bodyEl.className += ' ' + tradeClass;

        var logoEls = [document.querySelector('.logo-header .logo-link'), document.querySelector('.global-nav-logo .logo-link')];

        logoEls.forEach(function (logoEl) {
            if (logoEl) {
                ReactDOM.render(React.createElement(LogoTradeIcon), logoEl);
            }
        });
    }
}

/**
 * =====================================================================================================================
 * GLOBAL jQuery ready
 * put global on ready handlers here
 * =====================================================================================================================
 */
$(function () {

    deepLink.forwardFromEmail();

    setBodyClass();

    if (User.loggedIn()) {
        User.load().done(setTradeHeader);
    } else {
        $.subscribe('login:change', setTradeHeader);
    }

    $.subscribe('user:loaded', function (e, user) {
        // configure remote logger to log user
        try {
            log.configureLogUser.apply(log, [user.id, user.getFullName(), user.getUserProfile().email]);
        } catch (err) {
            log.remote.warn(err);
        }
    });

    User.updateLoginState();
    userTracking.init();
    pageViewTracking.init();

    /*
    This server var is only set in checkout_base.twig and PDP Print, because doesn't
        use the nav bar at all, but .getContext() gets called from every entry file
        since base.js gets bundled into foot.js
    */
    var initializeNavBar = !SV.get('disableNavBar');
    var disableStickyNav = !!SV.get('settings.disableStickyNav') && !mobileCheck.any();
    var select = windowCheck.document.querySelectorAll('.js-currency-select')[0];

    ContextProvider.getContext().then(function (context) {
        if (initializeNavBar) {
            nav.init(context, { disableStickyNav: disableStickyNav });
        }

        currencySelectHelper.init({ context: context, select: select });
        notificationHelper.init({ context: context.getActionContext() });
    });

    tapEvents.init();
    navDfp.init();
    tooltips.initTooltips();

    if (initializeNavBar) {
        footer.init();
    }

    $.subscribe('modal:show backbone:viewRendered page:updated', tooltips.initTooltips);
    $.subscribe('modal:show modal:close', tooltips.closeAllTooltips);
    // similar functionality in nav.js for search box, should be consolidated at some point
    // search for 'body *'
    $('body').on('click touchstart', function (e) {
        var $target = $(e.target);
        if (!$target.hasClass('dibstooltip-trigger') && !$target.hasClass('dibstooltip') && !$target.parents('.dibstooltip').length) {
            tooltips.closeAllTooltips();
        }
    });

    User.handleEmailToken();
});

/**
 * =====================================================================================================================
 * GLOBAL WINDOW ONLOAD EVENT
 * Put global window onload handlers here
 * =====================================================================================================================
 */
$(window).load(function () {
    var thirdPartyFootImg = SV.get('thirdPartySrcs.foot.img');
    var thirdPartyFootScript = SV.get('thirdPartySrcs.foot.script');

    // hide address bar on iOS
    if (mobileCheck.iOS()) {
        setTimeout(function () {
            if ($(window).scrollTop() === 0) {
                // but only if user hasn't already scrolled away from the top
                window.scrollTo(0, 1);
            }
        }, 0);
    }
    if (thirdPartyFootImg) {
        scriptLoader.pixel.load(thirdPartyFootImg);
    }
    if (thirdPartyFootScript) {
        scriptLoader.script.load(thirdPartyFootScript, false, 'body');
    }
});

/***/ }),
/* 2446 */,
/* 2447 */,
/* 2448 */,
/* 2449 */,
/* 2450 */,
/* 2451 */,
/* 2452 */,
/* 2453 */,
/* 2454 */,
/* 2455 */,
/* 2456 */,
/* 2457 */,
/* 2458 */,
/* 2459 */,
/* 2460 */,
/* 2461 */,
/* 2462 */,
/* 2463 */,
/* 2464 */,
/* 2465 */,
/* 2466 */,
/* 2467 */,
/* 2468 */,
/* 2469 */,
/* 2470 */,
/* 2471 */,
/* 2472 */,
/* 2473 */,
/* 2474 */,
/* 2475 */,
/* 2476 */,
/* 2477 */,
/* 2478 */,
/* 2479 */,
/* 2480 */,
/* 2481 */,
/* 2482 */,
/* 2483 */,
/* 2484 */,
/* 2485 */,
/* 2486 */,
/* 2487 */,
/* 2488 */,
/* 2489 */,
/* 2490 */,
/* 2491 */,
/* 2492 */,
/* 2493 */,
/* 2494 */,
/* 2495 */,
/* 2496 */,
/* 2497 */,
/* 2498 */,
/* 2499 */,
/* 2500 */,
/* 2501 */,
/* 2502 */,
/* 2503 */,
/* 2504 */,
/* 2505 */,
/* 2506 */,
/* 2507 */,
/* 2508 */,
/* 2509 */,
/* 2510 */,
/* 2511 */,
/* 2512 */,
/* 2513 */,
/* 2514 */,
/* 2515 */,
/* 2516 */,
/* 2517 */,
/* 2518 */,
/* 2519 */,
/* 2520 */,
/* 2521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: daletan
 * Date: 11/20/14
 * Time: 4:24 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */



var $ = __webpack_require__(5);
var queryService = (function () {
    var qsType = {
        xml: '',
        json: 'json'
    };

    /**
     * @param type - String  either 'json' or 'xml'
     * @param name - String - name of query service
     * @param params - Object - key/value pairs to pass to the queryservice
     * @return {Object} property base (with no query params) or full (with all query params)
     */
    function url(type, name, params) {
        var qsFormat = qsType[type] || 'json'; // on client json is the default
        var qsBase = '/soa/queryservice/' + qsFormat + '/' + name + '.dibs';
        var parts = [];

        params = params || {};

        $.each(params, function (key, value) {
            parts.push(key + '=' + value);
        });

        return {
            base: qsBase,
            full: qsBase + (parts ? '?' + parts.join('&') : '')
        };
    }

    /**
     * @description Ensures queryservice[name].row is an array
     * @param row
     * @return Array
     */
    function normalizeRow(row) {
        row = row || [];
        return $.isArray(row) ? row : [row];
    }

    /**
     * @description Converts composed query results into one array
     * @param rows An array of arrays
     * @return Array flattened into one row
     */
    function normalizeComposedQ(rows) {
        var merge = [];
        var i;
        var item;
        var key;
        var row;

        for (i = 0; i < rows.length; i++) {
            item = rows[i];
            for (key in item) {
                if (item.hasOwnProperty(key)) {
                    row = item[key].row;
                    if ($.isArray(row)) {
                        merge = [].concat.apply(merge, row);
                    } else if (typeof row === "object") {
                        merge.push(row);
                    }
                    break;  //we're only interested in the first property
                }

            }
        }
        return merge;
    }

    /**
     *
     * @param type -- the response type, xml or json
     * @param name -- query service query name
     * @param params -- object key/value of params to pass
     * @return Object jQuery.Deferred.promise
     */
    function get(type, name, params) {
        var dfd = $.Deferred();
        var error = {
            error:      true,
            status:     500,
            statusText: ''
        };
        var xhr;

        params = params || {};

        if (window.bypassCache) {
            params.bypassCache = true;
        }

        if (!qsType[type]) {
            // log the error, but set format to json
            console.log('global.DIBS.queryService', 'Type: "' + type + '" not recognized. Using json...');
            type = 'json';
        }

        xhr = $.ajax({
            url:      url(type, name).base,
            data:     params,
            dataType: type
        });

        xhr.done(function (result) {
            if (result[name]) {
                if (params.type === 'composed') {
                    dfd.resolve(normalizeComposedQ(result[name]));
                } else {
                    dfd.resolve(normalizeRow(result[name].row));
                }
            } else {
                error.status = 500;
                error.statusText = "Malformed Queryservice result.";
                dfd.reject(error);
            }
        });

        xhr.fail(function (jqxhr) {
            error.status = jqxhr.status;
            error.statusText = jqxhr.responseText.substring(0, 128);
            dfd.reject(error);
        });

        return dfd.promise();
    }

    return {
        xmlUrl: function (name, params) {
            return url('xml', name, params);
        },

        jsonUrl: function (name, params) {
            return url('json', name, params);
        },

        xml: function (name, params) {
            return get('xml', name, params);
        },

        json: function (name, params) {
            return get('json', name, params);
        }
    };
}());

module.exports = queryService;


/***/ }),
/* 2522 */,
/* 2523 */,
/* 2524 */,
/* 2525 */,
/* 2526 */,
/* 2527 */,
/* 2528 */,
/* 2529 */,
/* 2530 */,
/* 2531 */,
/* 2532 */,
/* 2533 */,
/* 2534 */,
/* 2535 */,
/* 2536 */,
/* 2537 */,
/* 2538 */,
/* 2539 */,
/* 2540 */,
/* 2541 */,
/* 2542 */,
/* 2543 */,
/* 2544 */,
/* 2545 */
/***/ (function(module, exports) {

module.exports = {
	"401": "Your login has expired",
	"412": "We apologize, but temporary system issues prevented us from processing your payment. Please try again. If the problem persists, <a href='/email.php?t=my&m=tError' target='_blank'>contact us</a>.",
	"500": "We apologize, but temporary system issues prevented us from processing your payment. Please try again. If the problem persists, <a href='/email.php?t=my&m=tError' target='_blank'>contact us</a>.",
	"default": "There was an error processing your transaction. Please make sure all of your information is correct and try again. If the problem persists, please contact us for assistance.",
	"PRIVATE_OFFER_EXPIRED": "Your private offer has expired. <a href='#' class='reload-checkout-link'>Click here</a> to purchase this item at full price. For details of your private offer, go to <a href='#' class='my-conversation-link'>My Conversations</a>.",
	"ITEM_QUANTITY_NOT_AVAILABLE": "We apologize, but this quantity is no longer available for sale. Please update your quantity selection.",
	"ITEM_NOT_AVAILABLE": "We apologize, but this item is no longer available for sale. <a href='javascript:void(0)' id='sold-continue'>Continue shopping</a>.",
	"USER_CHANGED": "There was a problem processing your order. We have now refreshed your account credentials in accordance with your most recent successful login. Please try submitting your order again. If the problem persists, <a href='/email.php?t=my&m=tError' target='_blank'>contact us</a>.",
	"DENIED": "Unfortunately we were unable to complete your payment at this time - sometimes this happens with larger purchases. Simply contact your credit card company or banking institution by calling the number on the back of your card to verify your payment. Once verified, submit your purchase a second time.<br>If you receive an error message again, please email <a href='mailto:payments@1stdibs.com'>payments@1stdibs.com</a> or call us at <a class='visible-mobile-landscape-inline-block' href='tel:+18777213427'>+1-877-721-3427</a><span class='hidden-mobile-landscape'>+1-877-721-3427</span>. We are here to assist you with your order.",
	"VAULT": "Unfortunately we were unable to authorize your card.<br>Please check your card information and try again. If you're still unable to submit your payment, simply call the number on the back of your card for assistance.<br>For additional order assistance, please email <a href='mailto:payments@1stdibs.com'>payments@1stdibs.com</a> or call us at <a class='visible-mobile-landscape-inline-block' href='tel:+18777213427'>+1-877-721-3427</a><span class='hidden-mobile-landscape'>+1-877-721-3427</span> for help.",
	"EXPIRED": "Your card has expired. Please add a new payment method below."
};

/***/ }),
/* 2546 */,
/* 2547 */,
/* 2548 */,
/* 2549 */
/***/ (function(module, exports) {

module.exports = {
	"title": "Can you tell us why you didn't complete checkout?",
	"radioOptions": [
		"I wanted to use a shipping method that was not provided.",
		"I wanted to use a payment method that was not available.",
		"The page was too complicated and hard to use.",
		"I did not intend to go to checkout.",
		"I changed my mind based on new details I saw."
	],
	"placeholder": "Optional",
	"textAreaLabel": "If you'd like, please tell us more about your experience.",
	"submit": "Submit"
};

/***/ }),
/* 2550 */,
/* 2551 */,
/* 2552 */,
/* 2553 */,
/* 2554 */,
/* 2555 */,
/* 2556 */,
/* 2557 */,
/* 2558 */,
/* 2559 */,
/* 2560 */,
/* 2561 */,
/* 2562 */,
/* 2563 */,
/* 2564 */,
/* 2565 */,
/* 2566 */,
/* 2567 */,
/* 2568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created with JetBrains PhpStorm.
 * User: augustocorvalan
 * Date: 7/23/13
 * Time: 5:03 PM
 */



var _ = __webpack_require__(22);
var $ = __webpack_require__(5);
var DC = __webpack_require__(468);
var VisitCount = __webpack_require__(1461);

// private static instance for singleton
var _visitorTracking;

//Module to export, VisitorTracking class
var VisitorTracking = module.exports = function () {
    this.model = new VisitCount();
};

__webpack_require__(677);

// static properties/methods
_.extend(VisitorTracking, {


    /**
     * singleton implementation
     * keeps the visit count from being incremented multiple times per visit,
     * $.publish listeners registered in the constructor will only be fired once
     * @returns {VisitorTracking}
     */
    getInstance: function () {
        if (!_visitorTracking) {
            _visitorTracking = new VisitorTracking();
        }
        return _visitorTracking;
    }
});

// instance properties, methods
_.extend(VisitorTracking.prototype, {

    model: null,
    hasInit: false,

    defaults: {
        delay: 0
    },

    /**
     * init function
     *
     * @return {boolean} - true if called, false if already called
     */
    init: function visitorTrackingInit(options) {
        var self = this;
        var ajax = options && options.ajax !== undefined ? options.ajax : false;
        this.options = _.extend({}, this.defaults, options);

        if (this.hasInit && !ajax) {
            //keeps this from being called more than once
            return false;
        }

        if (!this.hasInit) {
            $.subscribe(DC.pageEventPrefix + ':updated', function () {
                self.init(Object.assign({ajax: true}, options));
            });
        }

        if (!this.isIframe()) {
            this.hasInit = true;

            this.model.increment('totalVisitCount');
            this.model.increment('session');
            this.model.increment('sinceRegPrompt');

            this.model.save();
        }

        if (!this.hasInit) {
            $.subscribe(DC.pageEventPrefix + ':updated', function () {
                self.init(Object.assign({ajax: true}, options));
            });
        }

        return this.hasInit;
    },

    /**
     * is this script currently executing inside an iframe?
     * @returns {boolean}
     */
    isIframe: function () {
        return !!window && (window.self !== window.top);
    },

    isInCheckoutPage: function () {
        return (document && (document.location.href.indexOf('checkout') > -1)) ? true : false;
    }
});


/***/ }),
/* 2569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by theodora on 6/12/14.
 */



var $ = __webpack_require__(5);
var SV = __webpack_require__(18);
var authModalLoader = __webpack_require__(266).default;
var parseUri = __webpack_require__(689).URL;
var helpers = __webpack_require__(2571);
var User = __webpack_require__(15);

var authModals = [
    authModalLoader.constants.LOGIN,
    authModalLoader.constants.REGISTER,
    authModalLoader.constants.RESET_PASSWORD,
    authModalLoader.constants.RESET_INVALID
];

/**
 *
 * @param uri
 * @returns {string}
 */
var getRedirectDestination = function (uri) {
    var queryKey = uri.queryKey;
    var dest = queryKey.ep ? decodeURIComponent(queryKey.ep) : null;
    if (dest && dest.indexOf('//') > -1) {
        // id ep contains '//' then redirect to current page
        // if phishing is happening, just redirect to the homepage (uri.path = '/')
        dest = uri.path;
    }

    return dest;
};

module.exports = {

    /**
     * Changed window object to parameter for easier testing
     * @param {object} win Mock window object
     * @param {object} uri Mock object mainly for testing
     */
    init: function checkForAuthModal(win, uri) {
        var winObj = win && win.location ? win : window;
        var uriObj = uri && uri.path ? uri : parseUri;
        var destination = getRedirectDestination(uriObj);
        var action = uriObj.queryKey.modal || '';
        var gaAction = action.replace('_', ' ');
        var authOptions;
        action = action.replace('_', '-');
        authOptions = {
            action: action,
            ga: {
                label: gaAction + ' query param - address bar',
                value: helpers.getHasScrolled() ? 1 : 0
            }
        };

        if (action) {
            if (winObj.testMode) {
                // since the authModal requires a user action in order for the
                // promise to fire, the href required for testing will never be updated
                // TODO: jasmine testing + resolving promises
                winObj.location.href = destination;

            } else if (authModals.indexOf(action) > -1) {
                // Need to make sure we have fresh user state
                // and don't get into infinite redirect loops
                User.load()
                    .then(function () {
                        if (destination) {
                            winObj.location.href = destination;
                        }
                    })
                    .fail(function () {
                        if (SV.settings.fireGaPageViewOnAuthModalClose) {
                            $.publish('ga:pageView');
                        }

                        authModalLoader.show(authOptions).then(function (authResponse) {
                            if (destination && !authResponse.err) {
                                winObj.location.href = destination;
                            }
                        });
                    });
            }
        }
    }
};


/***/ }),
/* 2570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: liliana
 * Date: 6/2/14
 * Time: 4:33 AM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */



var $ = __webpack_require__(5);
var SV = __webpack_require__(18);
var breakpoints = __webpack_require__(379).breakpoints;
var mobileCheck = __webpack_require__(283);
var Dfp = __webpack_require__(2576);

var $win = $(window);
var responsiveTargs;

module.exports = {
    init: function initNavDfp() {
        var dfp = new Dfp();
        responsiveTargs = breakpoints.integer;
        // add header shipping message copy from dfp
        $.onceEver('dfp:loaded', function () {
            var pageTarget = {
                pagetype : SV.settings.dfpPageType
            };

            if (!mobileCheck.iPhone()) {
                // FINDING-6231 : on iPad extra gray space appears after logging in
                //      changed breakpoint from 'tablet-portrait' to 'tablet-landscape'
                // on tablets (in landscape mode) this dfp iframe was being dropped on the page with a width of 1280px, but the width of the tablet is only 1024px
                // which made the page side-scrollable on tablets. To change the inline dimensions of the iframe you need to update width and height in dfpCopy.json (static repo)
                // and have someone change the dimensions in the dfp console
                // todo: figure out how to avoid not dropping the ad on desktops smaller than 1024px across.
                if ($('.doubleclick-container-nav').length && !$.cookie('dbl') && $win.width() > responsiveTargs['tablet-landscape']) {
                    dfp.addDfpCopy('1stdibsNavBanner', pageTarget);
                }
                if ($('.header-shipping-message-container').length) {
                    dfp.addDfpCopy('HeaderMessage');

                    $.subscribe('page:updated', function () {
                        dfp.refresh('HeaderMessage');
                    });
                }
            }

            dfp.fire();
        });
    }
};


/***/ }),
/* 2571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: hella
 * Date: 6/3/14
 * Time: 8:18 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */



var nonStickyPageIds = ['checkout', 'checkoutBalanceDue'];
var hasScrolled      = false;

module.exports = {

    isPageAllowed: function isPageAllowed(arr) {
        arr = arr || nonStickyPageIds;
        var i = arr.length;
        var id = document.body.id;
        while (i--) {
            if (arr[i] === id) {
                return false;
            }
        }
        return true;
    },

    scrollOffset: function scrollOffset() {
        var x = (!!typeof(window.pageXOffset)) ? window.pageXOffset : document.documentElement.scrollLeft;
        var y = (!!typeof(window.pageYOffset)) ? window.pageYOffset : document.documentElement.scrollTop;
        return { x: x, y: y };
    },

    /**
     * @returns {boolean}
     */
    getHasScrolled: function getHasScrolled() {
        return hasScrolled;
    },

    /**
     * @param scroll
     */
    setHasScrolled: function setHasScrolled(scroll) {
        hasScrolled = scroll;
    },

    /**
     * Get x digits of entropy
     * @param digits
     * @returns {number}
     */
    getEntropy: function getEntropy(digits) {
        digits = digits || 8;
        return Math.floor(Math.random() * Math.pow(10, digits));
    }
};

/***/ }),
/* 2572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by daniel.gonzalez on 6/12/15.
 */



var _ = __webpack_require__(22);

function addMATGAParams(config, link) {
    var paramsObj = config.ga;
    var params = [];

    _.each(paramsObj, function (value, key) {
        params.push(key + '=' + value);
    });

    params = params.join('&');

    if (link.indexOf('?') !== -1) {
        link += '&' + params;
    } else {
        link += '?' + params;
    }

    return link;
}

function createMATTrackingParams(config, invokeUrl) {
    var paramsObj = _.extend({invoke_url: invokeUrl}, config.params);
    var params = [];
    var link;
    var qp;

    _.each(paramsObj, function (value, key) {
        if (key === 'invoke_url') {
            link = addMATGAParams(config, value);
            link = encodeURIComponent(link);
            qp = key + '=' + link;
        } else {
            qp = key + '=' + value;
        }

        params.push(qp);
    });

    return params.join('&');
}

module.exports = {
    createMATTrackingLink: function (config, invokeUrl) {
        var protocol = config.protocol;
        var base = config.base;
        var params = createMATTrackingParams(config, invokeUrl);

        return protocol + base + '?' + params;
    }
};


/***/ }),
/* 2573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by kostas.manionis on 7/20/15.
 */



var $ = __webpack_require__(5);
var FullscreenView = __webpack_require__(2574);
var mobileAdsHelpers = __webpack_require__(2025);
var constants = __webpack_require__(1193);

module.exports = {
    showAd: function () {
        var ad = new FullscreenView({
            'adName': constants.FULLSCREEN_NAME
        });

        ad.render();
        $('body').append(ad.$el);
        mobileAdsHelpers.setCookie();
    }
};


/***/ }),
/* 2574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by daniel.gonzalez on 6/11/15.
 */



var Backbone = __webpack_require__(3);
var marinate = __webpack_require__(323);
var baseMixin = __webpack_require__(3616);
var fullscreenMixin = __webpack_require__(3617);
var trackingMixin = __webpack_require__(3618);
var templates = __webpack_require__(3905);
var LogoIcon = __webpack_require__(2902);
var CloseIcon = __webpack_require__(1267);

var FullscreenView = Backbone.BaseView.extend({
    className : 'mobile-ad-fullscreen-container',
    template : templates.fullscreen,

    initialize: function (options) {
        this._adName = options.adName;
    },

    render: function () {
        this.$el.html(this.template({
            logoIcon: LogoIcon,
            closeIcon: CloseIcon
        }));
        this.trackingOnRender();
    },

    events: {
        'click .mobile-ad-fullscreen-close-container': 'closeAd',
        'click .mobile-ad-fullscreen-deep-link-link': 'redirectToApp'
    }
});

marinate(FullscreenView, baseMixin, fullscreenMixin, trackingMixin);

module.exports = FullscreenView;


/***/ }),
/* 2575 */,
/* 2576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: daletan
 * Date: 6/23/14
 * Time: 11:08 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */



//global.dibs.createNamespace('dibs.modules.controller.dfpCopyController');
var $ = __webpack_require__(5);
var _ = __webpack_require__(22);
var SV = __webpack_require__(18);
var log = __webpack_require__(295);
var User = __webpack_require__(15);
var _googletag = __webpack_require__(1217);
var findNamespaceValue = __webpack_require__(288);
var GptLoader = __webpack_require__(1365);
var global = window;

var gptLoader = new GptLoader();
var defaults = {
    copyJSON: {}
};

/**
 * DfpCopyController:
 * The controller will read in a JSON file where data about the add slots is contained.
 * Currently, this is contained in json/dfpCopy.json. Each dfp ad slot should contain the following info:
 *      ++OrderId           The id number of the order associated with slot. Obtained through dfp interface
 *      ++slotId            The id number of the ad slot. Can actually be anything.
 *      ++width             Width of ad slot. Numeric
 *      ++height            Height of width slot. Numeric
 *      ++parentContainer   Name of class for parent container that will hold the dfp payload
 *                              and the final payload. Controller will not create ad slots
 *                              if parent container does not exist
 *
 * The controller has the following flow:
 *      1. Initializes googletag script on page
 *      2. Ad slots are added via addDfpCopy method. This will initialize slots in dfp server as well as
 *          create markup to receive the ad slots on our page.
 *      3. Once all ad slots have been added, fire method will ask dfp server to deliver ad slots onto our page.
 *          Fire method should only be called after all ad slots have been added. It should only be called once.
 *          Ad slots will be received in an iframe which will postMessage the desired copy.
 *      4. When iframe posts its message, a listener will take message,
 *          and append it to parentContainer. Iframe will then be removed.
 */

if (findNamespaceValue('settings.houseAds', SV)) {
    defaults.copyJSON = SV.settings.houseAds;
}

function DfpCopyController(options) {
    this.options = $.extend({}, defaults, options);
    this._defaults = defaults;

    this.init();
}

_.extend(DfpCopyController.prototype, {
    init: function () {
        var self = this;
        var gt = this.options.googletag || _googletag;

        //have to wait for GPT to be loaded before more can be done
        if (gt) {
            this.initController(gt);
        } else {
            this.initGoogletag();
            $.once('gpt:loaded', function () {
                // the require('googletag') shim does not get reassigned
                // properly, so need to do this check
                if (!_googletag && _googletag !== global.googletag) {
                    _googletag = global.googletag;
                }
                self.initController(_googletag);
            });
        }
    },
    /**
     * initGoogletag - initializes gpt script if not already initialized
     */
    initGoogletag: function () {
        gptLoader.load().done(function () {
            $.publish('gpt:loaded');
        });
    },
    /**
     * initController - initializes controller private variables
     */
    initController: function (gtag) {
        this.orders = {};
        this.spentKeys = {};
        this.googletag = gtag;
        this.eventType = global.addEventListener ? 'message' : 'onmessage';
        $.publish('dfp:loaded');
    },
    /**
     * addDfpCopy
     * @param key - key corresponding to order name in JSON file
     * @param targeting
     * @returns {obj} dfpController object
     */
    addDfpCopy: function (key, targeting) {
        var order = this.options.copyJSON[key];
        var self = this;
        var googletag = this.googletag;

        if (!order || !googletag) {
            return false;
        }

        if (!!targeting) {
            order.targeting = targeting;
        }

        order.key = key;
        if ($('.' + order.parentContainer).length) {
            this.orders[key] = order;
            googletag.cmd.push(function () {
                self.createSlotDiv(order);
                self.defineSlots(order);
                self.parseTargetingObj(order);
                self.setReferrerTargeting(order);
            });
        } else {
            console.log('dfpController:addDfpCopy:' +
                'The key provided did not match any order name in the JSON file currently being used.' +
                'Mayhaps add it to default JSON or provide another to constructor.');
        }

        return this;
    },
    /**
     * creates the div that will hold the slot payload (iframe) from dfp
     * @param order
     */
    createSlotDiv: function (order) {
        var span;
        //do not create new slot div if it already exists
        if ($('#' + order.slotId).length) {
            return;
        }

        span = $('<div>')
            .attr('id', order.slotId)
            .css({
                position      : 'absolute',
                visibility    : 'hidden'
            });
        if (order.hideOverflow) {
            span.css({
                overflow      : 'hidden',
                'max-width'   : '100%'
            });
        }
        $('.' + order.parentContainer).append(span);
    },
    destructSlotDiv: function (order) {
        $('#' + order.slotId).remove();
    },
    /**
     * defines the slots in gpt
     * @param order
     */
    defineSlots: function (order) {
        var unitName = '/' + order.orderId + '/' + order.key;
        var dimensions = [order.width, order.height];
        var googletag = this.googletag;
        var slot;

        try {
            if (googletag) {
                slot = googletag.defineSlot(unitName, dimensions, order.slotId);
                if (slot) {
                    order.gtId = slot.addService(googletag.pubads());
                    if (order.gtId) {
                        order.gtId.setTargeting('env', SV.settings.environment);
                        order.gtId.setTargeting('loggedin', User.loggedIn().toString());
                    }
                }
            }
        } catch (e) {
            log.remote.error(e, window.location.href);
        }
    },
    parseTargetingObj: function (order) {
        var targeting = order.targeting;
        var toReplace = '%itemStatus%';
        var delimiter = '.';
        var itemPrice = '';
        var targetKey;
        var targetValue;
        var newStr;
        var item;
        var itemStatus;

        if (!targeting) {
            return this;
        }

        for (targetKey in targeting) {
            if (targeting.hasOwnProperty(targetKey)) {
                targetValue = targeting[targetKey];
                if (targetValue.indexOf(toReplace) > -1) {
                    item = SV.data;

                    if (item.isSold) {
                        itemStatus = 'sold';
                    } else if (item.isHold) {
                        itemStatus = 'hold';
                    } else if (item.isSuspended) {
                        itemStatus = 'suspended';
                    } else {
                        itemStatus = 'available';
                        itemPrice = ((item.price) ? 'with-price' : 'request-price') + delimiter;
                    }

                    newStr = itemPrice + itemStatus;
                    targetValue = targetValue.replace(toReplace, newStr);
                }

                order.gtId.setTargeting(targetKey, targetValue);
            }
        }

        return this;
    },
    /**
     * Sets 'referrer' targeting on order based on window
     * @param order
     * @param referrer Optional
     */
    setReferrerTargeting: function (order, referrer) {
        var targetKey = 'referrer';
        var targetValue = referrer || document.referrer;
        if (targetValue) {
            targetValue = targetValue
                //get just the domain
                .split('/')[2]
                //then strip out subdomains
                .split('.')
                .slice(-2)
                //and put it back together
                .join('.');

            order.gtId.setTargeting(targetKey, targetValue);
        }
    },
    /**
     * once the ads come back from dfp, they will be wrapped in an iframe. This cannot do.
     * So the iframes will postMessage their text and the controller will listen for it and
     * create divs with their text outside of the iframe so that our domain can access it
     */
    addPostMessageListener: function (orders) {
        var self = this;
        var attachEvent = global.addEventListener || global.attachEvent;

        attachEvent(
            this.eventType,
            function (e) {
                var keys = self.spentKeys;
                var orderId;
                var order;
                var key;
                var sourceId;
                e = e || global.event;

                // this ensures that the postMessage is from our window
                // since postMessage can return any domain value
                // if it doesn't match 1stdibs.com, don't do anything
                if (!_.size(e.source) && e.origin !== global.location.origin) {
                    return false;
                }

                if (e.source && e.source.frameElement) {
                    sourceId = e.source.frameElement.id;
                    for (orderId in orders) {
                        if (orders.hasOwnProperty(orderId)) {
                            order = orders[orderId];
                            key = order.key;
                            // only continue if this is the response for our order and order has not been queried yet
                            if (keys[key] !== true && sourceId.indexOf(key) > -1) {
                                keys[key] = true;
                                order.message = e.data;
                                self.constructMessageMarkup(order);
                                //we don't need that div anymore
                                self.destructSlotDiv(order);
                            }
                        }
                    }
                }
            },
            false
        );
    },
    /**
     * Parses message into JSON and passes it off so that it can be plopped into DOM
     * @param order
     */
    constructMessageMarkup: function (order) {
        var jsonMessage;
        var fullUrl;

        try {
            jsonMessage = $.parseJSON(order.message);
        } catch (e) {
            return;     //nothing more we can do on error
        }

        if (jsonMessage) {
            fullUrl = this.constructFullUrl(jsonMessage);
            // For local development change the fullUrl to remove the environment domain and add the local domain, for
            // example if you were on the dev environment you would need to remove `https://dev` and add `https://devbox`.
            // fullUrl = 'https://devbox' + fullUrl.substr(11);
            this.injectUrl(fullUrl, order);
        }
    },
    /**
     * Expects the message to be a JSON string with at least a url field and possibly more fields
     *      representing variables to be passed in to url as query params
     * @param {Object} jsonMessage
     * @returns {string|undefined}
     */
    constructFullUrl: function (jsonMessage) {
        var params;
        var baseUrl;
        var prop;

        if (jsonMessage === undefined || jsonMessage.url === undefined) {
            return;
        }

        params = [];
        baseUrl = jsonMessage.url;

        delete jsonMessage.url;

        for (prop in jsonMessage) {
            if (jsonMessage.hasOwnProperty(prop)) {
                params.push(prop + '=' + jsonMessage[prop]);
            }
        }

        if (params.length !== 0) {
            baseUrl += '?';
        }

        baseUrl += params.join('&');
        return encodeURI(baseUrl);
    },
    /**
     * Constructs script for fullUrl and appends it as specified by order.parentContainer property
     * @param fullUrl
     * @param order
     */
    injectUrl: function (fullUrl, order) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = fullUrl;
        script.id = order.slotId;
        $('.' + order.parentContainer).show()[0].appendChild(script);
    },
    /**
     * Needs to fire after all slots have been defined
     * and addDfpCopy calls after this has fired will not do anything unless this is fired again
     */
    fire: function () {
        var googletag = this.googletag;

        this.addPostMessageListener(this.orders);

        if (googletag) {
        // Enables all gpt services that have been associated with ad slots on the page
            googletag.cmd.push(function () {
                // this doesn't play nice with ads
                // googletag.pubads().enableSingleRequest();
                googletag.enableServices();
            });

            $.each(this.orders, function (key, value) {
                googletag.cmd.push(function () {
                    googletag.display(value.slotId);
                });
            });
        }
    },
    refresh: function (key) {
        var order = this.orders[key];
        var slot;
        var googletag;
        if (_.isObject(order) && !_.isEmpty(order)) {
            slot = order.gtId;
            googletag = this.googletag;

            //clear spent keys on refresh
            delete this.spentKeys[key];

            if (slot && googletag) {
                this.createSlotDiv(order);
                googletag.cmd.push(function () {
                    googletag.enableServices();
                    googletag.pubads().refresh();
                });
            }
        }
    }
});

module.exports = DfpCopyController;


/***/ }),
/* 2577 */,
/* 2578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: daletan
 * Date: 6/24/14
 * Time: 1:34 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */



var $ = __webpack_require__(5);

__webpack_require__(2026);

/**
 * @param [event]
 * @param [params]
 */
exports.initTooltips = function (event, params) {
    var triggerSelector = ".dibstooltip-trigger";
    var triggers;
    var unbound;

    params = params || {};

    if (params.context) {
        triggers = params.context.$(triggerSelector);
    } else if (params.el) {
        triggers = $(params.el);
    } else {
        triggers = $(triggerSelector);
    }

    if (triggers.length) {
        unbound = triggers.not(':data(ui-tooltip)');
        if (unbound.length) {
            unbound.dibsTooltip();
        }
    }
};

exports.closeAllTooltips = function () {
    var triggers = $('.dibstooltip-trigger');
    var bound;

    if (triggers.length) {
        bound = triggers.filter(':data(ui-tooltip)');
        if (bound.length) {
            bound.dibsTooltip('close');
        }
    }
};


/***/ }),
/* 2579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: liliana
 * Date: 1/6/15
 * Time: 2:22 PM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */



// ---------------------------------------------------
// Module Definition

var pointerEvents = module.exports;

// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(22);

// ---------------------------------------------------
// Define Module Static Properties

_.extend(pointerEvents, {
    // TOUCH ACTION ATTRIBUTE VALUES
    // To receive pointerevents, touch-action property must be set on targeted element
    // https://github.com/jquery/PointerEvents
    TOUCH_ACTION_ATTR    : 'touch-action',
    TOUCH_ACTION_NONE    : 'none',
    TOUCH_ACTION_PAN_X   : 'pan x',
    TOUCH_ACTION_PAN_Y   : 'pan y',
    TOUCH_ACTION_PAN_X_Y : 'pan-x pan-y',
    TOUCH_ACTION_SCROLL  : 'scroll',

    // POINTER TYPE VALUES (IE11+)
    POINTER_TYPE_TOUCH   : 'touch',
    POINTER_TYPE_PEN     : 'pen',
    POINTER_TYPE_MOUSE   : 'mouse',


    /**
     * Returns true if pointer originated from touch input
     * @param {object} e
     * @returns {boolean}
     */
    isTouch: function (e) {
        return this.getPointerType(e.pointerType) === this.POINTER_TYPE_TOUCH;
    },

    /**
     * Returns true if pointer originated from pen input
     * @param {object} e
     * @returns {boolean}
     */
    isPen: function (e) {
        return this.getPointerType(e.pointerType) === this.POINTER_TYPE_PEN;
    },

    /**
     * Returns true if pointer originated from mouse input
     * @param {object} e
     * @returns {boolean}
     */
    isMouse: function (e) {
        return this.getPointerType(e.pointerType) === this.POINTER_TYPE_MOUSE;
    },

    /**
     * Gets pointerType from event object, abstracts IE10 return type of long for pointerType property
     * {@link http://msdn.microsoft.com/en-us/library/ie/hh772359(v=vs.85).aspx|MSDN pointerType property}
     * @param {string|long} pointerType
     * @returns {string|null}
     */
    getPointerType : function (pointerType) {
        var type;

        switch (pointerType) {

        case this.POINTER_TYPE_TOUCH:
        case 0x00000002:
            type = this.POINTER_TYPE_TOUCH;
            break;
        case this.POINTER_TYPE_PEN:
        case 0x00000003:
            type = this.POINTER_TYPE_PEN;
            break;
        case this.POINTER_TYPE_MOUSE:
        case 0x00000004:
            type = this.POINTER_TYPE_MOUSE;
            break;
        default:
            type = null;
        }

        return type;
    }
});


/***/ }),
/* 2580 */,
/* 2581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: daletan
 * Date: 4/10/14
 * Time: 10:25 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */


var blocked;

var $ = __webpack_require__(5);
var _gaq = __webpack_require__(2629);
var user = __webpack_require__(15);
var SV = __webpack_require__(18);
var tracking = __webpack_require__(27);
var _localStorage = __webpack_require__(282).localStorage;
var root = __webpack_require__(102);
var get = __webpack_require__(14);

/**
 * @param Array [arr] Array of objects in the style of dibs.tracking.customVars, primarily used for mocking
 */
function createCustomVar(arr) {
    var trackingData = SV.get('tracking') || {};
    var customVars;
    var recentHistoryCount;
    var i;
    var len;
    var trackObj;

    if (!trackingData) {
        trackingData = tracking;
    }
    // sets custom variables if available on page
    customVars = get(trackingData, 'customVars', arr);
    if (customVars && customVars.length) {
        recentHistoryCount = _localStorage.getItem('recent_history_count');
        for (i = 0, len = customVars.length; i < len; i++) {
            trackObj = customVars[i];
            if (trackObj.check_login) {
                trackObj.value = 'log=' + (user.loggedIn() ? 'y' : 'n') + (trackObj.value || '');
            }
            // TRANACT-1802 should only fire 'his=' with custom var 4 and only in search & browse pages
            // the `name` property of custom var 4 would read: "Homepage", or "PDP-Available-Price"
            // TODO: similar implementation in search.tracking.js, near #412, post-release optimization maybe needed
            // don't show on pages that DO NOT display the "recent history" module - TRANACT-2208
            if (trackObj.slot === 4 && !(/^(?:PDP-|Homepage|Shopper)/).test(customVars[i].name)) {
                trackObj.value += '|his=' + (recentHistoryCount ? 'y=' + recentHistoryCount : 'n');
            }
            tracking.setCustomVar(trackObj);
        }
    }

    // set custom variables for session level tracking, in: js/global/core/user.tracking.js
    $.publish('ga:setSessionCustomVar');

}

function referrerTracking() {
    //FINDING-1017
    var referrer = document.referrer;
    var r;
    var rank;
    var kw;
    var p;
    var keyWord;

    if (_gaq && referrer.match(/google\.com/gi) && referrer.match(/cd=/gi)) {
        r = referrer.match(/cd=(.*?)&/);
        rank = parseInt(r[1], 10);
        kw = referrer.match(/q=(.*?)&/);
        p = document.location.pathname;

        if (kw[1].length > 0) {
            keyWord = decodeURI(kw[1]);
        } else {
            keyWord = "(not provided)";
        }

        // can't use dibs.tracking.trackEvent here since it is using _gaq and not _gas
        _gaq.push(['_trackEvent', 'RankTracker', keyWord, p, rank, true]);
    }
}

function pageViewTrackingInit() {
    var settings = SV.get('settings');
    //FINDING-4417 implementing block/unblock of pageview to wait for custom var setting to complete
    $.subscribe('ga:blockPageview', function () {
        blocked = true;
    });

    $.subscribe('ga:unblockPageview', function () {
        blocked = false;
        if (!settings.noInitialPageView) {
            $.publish('ga:pageView');
        }
    });

    // call this privately, expose it to jasmine tests at the bottom of the page
    if (settings.blockCustomVar) {
        $.subscribe('ga:unblockCustomVar', function () {
            createCustomVar();
        });
    } else {
        createCustomVar();
    }

    // broke this out so that the gas.dibs.setup.js file will not fire this data
    // when it is included into a CommonJS module
    (function () {
        var fired;
        var virtualPageName;

        $.subscribe('ga:pageView', function () {
            fired = true;
            // FINDING-2644 - do not allow browser "previews" from firing tracking
            if (settings.allowGa) {
                virtualPageName = root.virtualPageName;

                if (Array.isArray(virtualPageName) && virtualPageName.length) {
                    virtualPageName = '/' + virtualPageName.join('/') + '/';
                } else {
                    /* develblock:start */
                    console.warn('[.com ] root.virtualPageName is a url string on the window that bots are ' +
                        'crawling and indexing. Update it to be an array of uri segments.');
                    /* develblock:end */
                }
                tracking.trackPageview(virtualPageName);
            }
        });

        // this is fired when a modal is closed
        $.subscribe('ga:pageView:once', function () {
            if (!fired) {
                $.publish('ga:pageView');
            }
        });

        // when it is known a modal is going to open on page load (ie. ?modal=register), then
        // dibs.settings.noInitialPageView = true;
        if (!settings.noInitialPageView && !settings.isLegacy && !settings.blockCustomVar && !blocked) {
            $.publish('ga:pageView');
        }
    }());

    // setting this up like this so it can be exposed for testing
    referrerTracking();
}

module.exports = {
    init: pageViewTrackingInit,
    referrer: referrerTracking,
    createCustomVar: createCustomVar
};


/***/ }),
/* 2582 */,
/* 2583 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * User: Joe Forzano
 * Date: 6/7/14
 * Time: 12:49 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

(function (root, factory) {
    'use strict';

    if (true) {
        factory(module);
    } else {
        var _module = {
            exports: {}
        };
        factory(_module);
        root.dibsGuidGenerator = _module.exports;
    }
}(typeof window === 'undefined' ? global : window, function (module) {
    'use strict';
    var getGuidSection;

    getGuidSection = function getGuidSection() {
        return Math.floor((1 + Math.random()) * 0x10000)
                   .toString(16)
                   .substring(1);
    };

    module.exports.getGuid = function getGuid() {
        return getGuidSection() + getGuidSection() + '-' +
               getGuidSection() + '-' +
               getGuidSection() + '-' +
               getGuidSection() + '-' +
               getGuidSection() + getGuidSection() + getGuidSection();
    };
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(70)(module)))

/***/ }),
/* 2584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: liliana
 * Date: 12/18/13
 * Time: 2:13 PM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */


var $              = __webpack_require__(5);
var mobileCheck    = __webpack_require__(283);
var pointerEvents  = __webpack_require__(2579);

__webpack_require__(2030);

var hasTouch            = mobileCheck.hasTouch();
var hasPointerEvents    = !!global.PointerEvent;
var doubleTapCompleted  = false;
var $body;

// no other file really consumes this stuff...
module.exports = {
    tapClass: 'js-tap-events',
    tapDropDownClass: 'js-tap-dropdown',
    events: {},
    touchEvents: {
        start  : 'touchstart.tapVsSwipe',
        move   : 'touchmove.tapVsSwipe',
        end    : 'touchend.tapVsSwipe',
        click  : 'click.tapVsSwipe'
    },
    pointerEvents: {
        start  : 'pointerdown.tapVsSwipe',
        move   : 'pointermove.tapVsSwipe',
        end    : 'pointerup.tapVsSwipe',
        click  : 'click.tapVsSwipe'
    },
    getCoords: function (e) {
        return {
            pageX: e.originalEvent.pageX,
            pageY: e.originalEvent.pageY
        };
    },
    setupEvents: function () {
        this.events = hasPointerEvents ? this.pointerEvents : this.touchEvents;
    },
    /**
     * Add a "Tap" event to an element. We define tap as a touch event that starts and end within
     * the specified threshold, a distance in pixels. (as opposed to a swipe, which goes outside of it).
     *
     * @param {jQuery} $element The jQuery element that the event should be hooked up to.
     * @param {number} [threshold=10] The threshold distance between the coordinates of the touch events. Optional.
     * @param {function} [callback] The callback function called after the end of a swipe. Optional.
     */
    addEvent: function ($element, threshold, callback) {
        var lastTouch = null;
        var firstTouch = null;
        var self = this;

        if (arguments.length === 2) {
            if (typeof threshold === 'function') {
                callback = threshold;
            }
        }

        threshold = typeof threshold === 'number' ? threshold : 10;

        // add touch action attribute to receive pointer events
        if (hasPointerEvents) {
            $element.data(pointerEvents.TOUCH_ACTION_ATTR, pointerEvents.TOUCH_ACTION_NONE);
        }

        $element
            .addClass(self.tapClass)
            .on(self.events.start, function (e) {
                firstTouch = self.getCoords(e);
            })
            .on(self.events.move, function (e) {
                lastTouch = self.getCoords(e);
            })
            .on(self.events.end, function (e) {
                if (lastTouch && firstTouch) {
                    if ((Math.abs(firstTouch.pageX - lastTouch.pageX) > threshold) ||
                        (Math.abs(firstTouch.pageY - lastTouch.pageY) > threshold)) {

                        // do stuff on swipe
                        // a swipe callback can be implemented here if we change the function signature

                        lastTouch = null;
                        firstTouch = null;
                        return;
                    }
                }

                lastTouch = null;
                firstTouch = null;

                if (callback) {
                    callback(this, e); //keep the scope jq callbacks usually have, and pass the event
                    return false;
                }

            });
    },
    /**
     * Removes the touch events added by the addTapEvents() function. Using this function ensures that only
     * the specific events are removed, and not any other touch events the elements may have.
     *
     * @param {jQuery} $element jQuery element with touch events originally added from AddTapEvents()
     */
    removeEvent: function ($element) {
        // remove touch action attribute to stop receiving pointer events
        if (hasPointerEvents) {
            $element.removeData(pointerEvents.TOUCH_ACTION_ATTR);
        }
        $element
            .off(this.events.start)
            .off(this.events.move)
            .off(this.events.end);
    },

    clearAllEvents: function ($wrapper, $element) {
        var self = this;
        var els = [
            $element,
            $wrapper,
            $body
        ];

        for (var i in els) {
            if (els.hasOwnProperty(i)) {

                self.removeEvent(els[i]);
                els[i]
                    .off(this.events.click)
                    .removeClass(self.tapClass);
            }
        }
    },
    /**
     * Binds "Tap" event to dropdown on touch devices to toggle dropdown visibility by adding and removing a
     * class instead of using the :hover psuedoclass
     *
     * @param {jQuery} $wrapper The jQuery ancestor element that wraps around all dropdowns
     * @param {string} container A class selector that contains the dropdowns
     * @param {object} [elsToIgnore=''] An object of children element(s) to ignore when binding tap events. Optional.
     * @param {string} [klass='is-tap'] The class that is toggled to show and hide dropdowns. Optional.
     */
    bindToDropDowns: function ($wrapper, container, elsToIgnore, klass) {
        var self = this;
        // the link that was just clicked. initially starts out as nothing on page load.
        var $curItem = [];
        var target = container;

        if (arguments.length === 3) {
            if (typeof elsToIgnore === 'string') {
                klass = elsToIgnore;
                elsToIgnore = [];
            }
        }
        target = target + ':not(' + elsToIgnore.selector + ')';
        klass = klass || 'is-tap';

        if (hasTouch) {
            $wrapper
                .on(self.events.click, target, function () {
                    // don't prevent click if:
                    // 1. dropdown has hover class, i.e. user is hovering with mouse, and
                    // 2. doubleTapComplete is true, otherwise navigation gets cancelled
                    if (!$(this).parent().hasClass('is-hover') && !doubleTapCompleted) {
                        return false;
                    }
                    // reset in case user clicks stop
                    if (doubleTapCompleted) {
                        doubleTapCompleted = false;
                    }
                })
                .on(self.events.start, target, function () {
                    var $this = $(this);
                    var hasTapEvents = $this.hasClass(self.tapClass); // bind tap events once!

                    // FINDING-2822 first click shows dropdown, second click navigates to vertical
                    // logic grabbed from doubleTapToGo plugin:
                    // http://osvaldas.info/examples/drop-down-navigation-touch-friendly-and-responsive/
                    if (!hasTapEvents) {

                        self.addEvent($this, function (el) {
                            if (!hasPointerEvents || !$(el).parent().hasClass('is-hover')) {
                                var $item = $(el);
                                var href = $item.attr('href');
                                // var target = $item.attr('target') === '_blank' ? '_blank' : '_self';
                                var enableDoubleTapAction = $item.hasClass('js-double-tap');
                                var isValidUrl = href && !(/^#/).test(href);

                                // FINDING-2822 add class to enable hover states instead of relying on :hover psuedoclass
                                $item.parent().addClass(klass);

                                if (!$item.is($curItem)) {
                                    // link has only been tapped once
                                    $curItem = $item;
                                } else {
                                    // second tap happens, go to link
                                    if (enableDoubleTapAction && isValidUrl) {
                                        doubleTapCompleted = true;
                                        location.assign(href);
                                    }
                                    // reset current item on second tap
                                    $curItem = [];
                                }
                                // allow links to clickthrough for slide-in global nav
                                if (!enableDoubleTapAction && isValidUrl) {
                                    location.assign(href);
                                }
                            }
                        });
                    }
                });

            if (!$body.hasClass(self.tapClass)) {
                $body.on(self.events.click + ' ' + self.events.start, function (e) {
                    if (!hasPointerEvents || (e.pointerType && !pointerEvents.isMouse(e))) {
                        var $target = $(e.target);
                        var hasTapEvents = $target.hasClass(self.tapClass);
                        var hasTapDropDown = $curItem.length ? $curItem.hasClass(self.tapDropDownClass) : false;
                        var resetItem;
                        var $parent;
                        var href;

                        $body.addClass(self.tapClass);

                        // reset current item when clicked on dropdown item that does not result in page refresh
                        if (hasTapDropDown) {
                            $curItem.removeClass(self.tapDropDownClass);
                            $curItem = [];
                        }
                        if ($curItem.length) {
                            resetItem = false;
                            $parent = $curItem.parent();

                            if ($parent.find($target).length === 0) {
                                // click occurs outside of dropdown
                                $parent.removeClass(klass);
                                resetItem = true;
                            } else {
                                // removes tap class when link is clicked in dropdown or after double tap
                                // ensures element is always hidden even when body loses focus i.e. iframes
                                setTimeout(function () {
                                    $parent.removeClass(klass);
                                }, 500);
                                // click occurs in dropdown, add dropdown tap class
                                if ($curItem.find($target).length === 0 && !$curItem.is($target)) {
                                    $curItem.addClass(self.tapDropDownClass);
                                    // capture href and force clickthrough when clicking on link in dropdown on touch
                                    href = $target.attr('href');
                                    if (href) {
                                        location.assign(href);
                                    }
                                }
                            }
                            // tap occurred outside of the current item, reset current item
                            if (resetItem) {
                                $curItem = [];
                            }
                        }
                        if (hasTapEvents) {
                            return false;
                        }
                    }
                });
            }
        }
    },
    init: function initTapEvents() {
        var self = this;
        var container = '.sub-nav-parent > a';
        var elsToIgnore;
        // [href=#search] is excluded because its visibility is toggled on click not on hover
        elsToIgnore = { selector: '[href=#search]' };
        $body = $('body');

        this.setupEvents();
        this.bindToDropDowns($body, container, elsToIgnore);

        $.subscribe('page:updated', function () {
            self.clearAllEvents($body, $(container).not(elsToIgnore.selector));
            self.bindToDropDowns($body, container, $(elsToIgnore.selector));
        });
    }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2585 */,
/* 2586 */,
/* 2587 */,
/* 2588 */,
/* 2589 */,
/* 2590 */,
/* 2591 */,
/* 2592 */,
/* 2593 */,
/* 2594 */,
/* 2595 */,
/* 2596 */,
/* 2597 */,
/* 2598 */,
/* 2599 */,
/* 2600 */
/***/ (function(module, exports) {

/*!
 * jQuery Event Hook for PointerEvents
 * {@link http://learn.jquery.com/events/event-extensions/#jquery-event-fixhooks-object|jQuery Fix Hooks Objects}
 *
 * This plugin will ensure PointerEvent properties are carried over to jQuery events.
 * https://github.com/aarongloege/jquery.pointerHooks
 *
 * Copyright (c) 2014 Aaron Gloege
 * Licensed under the MIT license
 * http://www.opensource.org/licenses/mit-license.php
 */

/**
 * Created and modified by liliana on 1/8/15
 */

(function($) {
    'use strict';

    // events to fix
    var events = [
        'pointerenter',
        'pointerover',
        'pointerdown',
        'pointermove',
        'pointerup',
        'pointerout',
        'pointerleave',
        'pointercancel'
    ];

    var fixHook = {
        // properties to copy over to jQuery Event
        props: [
            'pageX',
            'pageY',
            'clientX',
            'clientY',
            'screenX',
            'screenY',
            'relatedTarget',
            'pointerId',
            'pointerType',
            'x',
            'y',
            'isPrimary',
            'width',
            'height',
            'tiltX',
            'tiltY',
            'pressure'
        ]
    };

    var i = 0;
    var length = events.length;

    for (; i < length; i++) {
        // check if hook exists before assigning properties
        if (!$.event.fixHooks[events[i]]) {
            $.event.fixHooks[events[i]] = fixHook;
        }
    }

}(jQuery));

/***/ }),
/* 2601 */,
/* 2602 */,
/* 2603 */,
/* 2604 */,
/* 2605 */,
/* 2606 */,
/* 2607 */,
/* 2608 */,
/* 2609 */,
/* 2610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2675), __esModule: true };

/***/ }),
/* 2611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
};

/***/ }),
/* 2612 */
/***/ (function(module, exports, __webpack_require__) {

//     Backbone.BaseView 0.8.3

//     (c) 2014 James Ballantine, 1stdibs.com Inc.
//     Backbone.BaseView may be freely distributed under the MIT license.
//     For all details and documentation:
//     https://github.com/1stdibs/backbone-base-and-form-view

(function (root) {
    'use strict';

    var Backbone = root.Backbone;
    var _ = root._;

    if (true) {
        _ = __webpack_require__(2038);
        root = root || {};
        root.Backbone = Backbone = __webpack_require__(2614);
        module.exports = Backbone;
    }

    // Finds globally dot noted namespaced objects from a string
    var _stringToObj = function (str) {
        var arr = str.split('.');
        var obj = root[arr.shift()];

        while (arr.length && obj) {
            obj = obj[arr.shift()];
        }
        return obj;
    };
    var slice = Array.prototype.slice;
    var result = _.result;
    var each = _.each;
    var isFunction = _.isFunction;
    var isObject = _.isObject;
    var isArray = _.isArray;
    var View = Backbone.View;
    var BaseView;

    /**
     * Local constructor intended for use by {@link Backbone.BaseView}. Creates an object specifically
     * for manipulating subviews. Is created automatically by the BaseView instance and accessed through the
     * '.subs' property of the the instance.
     * @constructor SubViewManager
     * @class SubViewManager
     * @type {SubViewManager}
     * @param {object} subViewCfg An object with a configuration to add for subviews (see addConfig(map))
     * @param {Backbone.BaseView} parent The parent BaseView instance
     * @param [options]
     */
    var SubViewManager = function (subViewCfg, parent, options) {
        this.config = {}; // Refers to configuration (construct, options)
        this.clear(true);
        this.parent = parent; // Should refer to parent BaseView instance

        // Set the options
        this.options = options || {};
        // Auto initialize a subview when config added
        this.autoInitSingletons = !!this.options.autoInitSingletons;
        // If true, then new subview configs and types will default to being singletons
        this.defaultToSingletons = this.options.defaultToSingletons;
        // Allow dot notation in 'get' method (if your config keys have dots, then set this to false)
        this.dotNotation = (this.options.dotNotation !== undefined) ? this.options.dotNotation : true;

        if (subViewCfg) {
            this.addConfig(subViewCfg);
        }
    };

    SubViewManager.prototype = {
       /**
         * Adds a subView or subViews to the View's list of subViews. Calling
         * function must provide instances of views or configurations.
         * @memberOf SubViewManager#
         * @class SubViewManager
         * @type {SubViewManager}
         * @method add
         * @param {Object} map
         *      An object with key's to refer to subViews and values that
         *      are View instances, options to pass to the constructor, or
         *      an array of either the previous two to add multiple subViews.
         *      If you pass options or an array of options, the SubViewManager
         *      will look for a configuration matching the key for these options
         *      and will initialize subviews based on the config, passing options
         *      to the constructor.
         * @param {Boolean} [singleton]
         *      True if the instances mapped to the keys should be singletons.
         *      If you pass options, the singleton param will be ignored.
         * @return {SubViewManager}
         */
        /**
         * Adds a subView or subViews to the View's list of subViews. Calling
         * function must provide instances of views or configurations.
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @method add
         * @param {String} name
         *      A string key to refer to the subViews with. Should match
         *      a key in the subView configuration. If not, a configuration
         *      will be set up with default values based on the instance
         *      passed.
         * @param {Backbone.View[]|object[]} arr
         *      An array of View instances or options. Instances will be
         *      appropriately associated with the key, options will be
         *      used to instantiate a subView based on the configuration
         *      matching the key
         * @param {Boolean} [singleton]
         *      True if the added views should be singletons
         * @return {SubViewManager}
         */
        /**
         * Adds a subView or subViews to the View's list of subViews. Calling
         * function must provide instances of views or configurations.
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @method add
         * @param {Backbone.View[]} arr
         *      An array of View instances. These will not be accessible
         *      by a type or key
         * @return {SubViewManager}
         */
        /**
         * Adds a subView or subViews to the View's list of subViews. Calling
         * function must provide instances of views or configurations.
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @method add
         * @param {String} name
         *      A string key to refer to the subView with
         * @param {Backbone.View} instance
         *      A View instance
         * @param {Object} [singleton]
         *      If you want the view matching this key to be a singleton
         * @return {SubViewManager}
         */
        /**
         * Adds a subView or subViews to the View's list of subViews. Calling
         * function must provide instances of views or configurations.
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @method add
         * @param {String} name
         *      A string key to refer to the subView with. Without an instance
         *      as the second param, this variant requires that a configuration
         *      to have been specified matching the 'name' with a constructor to
         *      initialize.
         * @param {Object} [options]
         *      An object that will be passed as the options parameter to the
         *      view on initialization.
         * @return {SubViewManager}
         */
        /**
         * Adds a subView or subViews to the View's list of subViews. Calling
         * function must provide instances of views or configurations.
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @method add
         * @param {Backbone.View} instance
         *      A Backbone.View instance to add as the subview
         * @return {SubViewManager}
         */
        add: function (name, instance, singleton) {
            var arr = (isArray(name)) ? name : (isArray(instance)) ? instance : undefined; // If its a simple array of subviews or configs
            var map = (!arr && isObject(name) && name instanceof View === false) ? name : undefined; // If its a mapping of subviews
            var viewOptions = (!arr && instance instanceof View === false) ? instance : undefined;
            var key;
            var i;
            var len;

            if (map) {
                singleton = (typeof instance === 'boolean') ? instance : undefined;
                for (key in map) {
                    if (map.hasOwnProperty(key)) {
                        map[key] = (isArray(map[key])) ? map[key] : [map[key]];
                        len = map[key].length;
                        if (len && map[key][0] instanceof View) {
                            this._addInstance(key, map[key], singleton);
                        } else {
                            i = -1;
                            while (++i < len) {
                                this._init(key, map[key][i], singleton);
                            }
                        }
                    }
                }
                return this;
            }

            instance = (name instanceof View) ? name : instance;
            name = (typeof name === 'string' || typeof name === "number") ? name : undefined;
            singleton = (typeof singleton === 'boolean') ? singleton :
                    (!name && typeof instance === 'boolean') ? instance : undefined;

            if (viewOptions) {
                this._init(name, viewOptions, singleton);
                return this;
            }

            if (arr && (len = arr.length)) { //eslint-disable-line no-cond-assign
                if (arr[0] instanceof View) {
                    this._addInstance(name, arr, singleton);
                } else {
                    i = -1;
                    while (++i < len) {
                        this._init(name, arr[i], singleton);
                    }
                }

                return this;
            }

            if (instance) {
                this._addInstance(name, instance, singleton);
            } else if (name) {
                this._init(name, singleton);
            }
            return this;
        },
        /**
         * Add a subview instance. If is has a config,
         * the instance will be associated with that
         * config. If the config specifies that the
         * view is a singleton an a view for that
         * key already exists, it will not be added.
         * @param {string|number} key
         * @param {Backbone.View} instance
         */
        /**
         * Add a subview instance, without a key.
         * Since it doesn't have a key, it will
         * simply be added to the subViews array.
         * @param {Backbone.View} instance
         */
        addInstance: function (key, instance) {
            if (key instanceof View) {
                instance = key;
                key = undefined;
            }
            this._addInstance(key, instance);
            return this;
        },
        /**
         * Add a subview for each view instance in
         * an array for a particular key
         * @memberOf SubViewManager#
         * @param {string} key
         * @param {Backbone.View[]} instances
         * @return {SubViewManager}
         */
        /**
         * Add a subview for each view instance in
         * an array. They will not be associated
         * with a key and will be only accessible
         * through the subViews array.
         * @memberOf SubViewManager#
         * @param {Backbone.View[]} instances
         * @return {SubViewManager}
         */
        addInstances: function (key, instances) {
            if (isArray(key)) {
                instances = key;
                key = undefined;
            }
            var i = -1;
            var len = instances.length;
            while (++i < len) {
                this._addInstance(key, instances[i]);
            }
            return this;
        },
        /**
         * Add instances using an object that
         * maps subview keys to the instances
         * @param {object} map
         * @return {SubViewManager}
         */
        addInstancesWithMap: function (map) {
            var key;
            for (key in map) {
                if (map.hasOwnProperty(key)) {
                    this.addInstance(key, map[key]);
                }
            }
            return this;
        },
        /**
         * Instantiates a view from it's config
         * and adds additional options.
         * @memberOf SubViewManager#
         * @param  {String} key
         * @param  {object} options
         * @return {Backbone.View}
         *         The new view instance
         */
        create: function (key, options) {
            return this._init(key, options);
        },
        /**
         * Given an array of keys, a subview
         * will be instantiated for each key
         * based on the configuration for that
         * key. The options param will be
         * passed to each view on instantiation
         * as additional options.
         *
         * @memberOf SubViewManager#
         * @param {String[]} keys
         * @param {Object} options
         *        Additional options to pass
         *        to each view on init
         * @return {Backbone.View[]}
         *        Array of newly created subviews
         */
        createFromKeys: function (keys, options) {
            var views = [];
            var len = keys.length;
            var i = -1;
            while (++i < len) {
                views.push(this._init(keys[i], options));
            }
            return views;
        },
        /**
         * Instantiate all singletons defined in the
         * config.
         * @param  {object} options Additional options
         * @return {SubViewManager}
         */
        createSingletons: function (options) {
            var key;
            for (key in this.config) {
                if (this.config.hasOwnProperty(key) && this.config[key].singleton) {
                    this._init(key, options);
                }
            }
            return this;
        },
        /**
         * Create subviews with a map of configured
         * subview keys to additional options.
         * @param  {object} map
         * @return {SubViewManager}
         */
        createWithMap: function (map) {
            var key;
            for (key in map) {
                if (map.hasOwnProperty(key)) {
                    this._init(key, map[key]);
                }
            }
            return this;
        },
        /**
         * Set a singleton instance if a singleton
         * for that instance has not already been
         * set. Remove the singleton first if you
         * want to set a new instance.
         * @param {String} key
         * @param {Backbone.View} instance
         * @return {SubViewManager}
         */
        setSingleton: function (key, instance) {
            this._addInstance(key, instance, true);
            return this;
        },
        /**
         * Remove a singleton if it exists and then
         * set a new instnce in it's place.
         * @param  {String} key
         * @param  {Backbone.View} instance
         * @return {SubViewManager}
         */
        overrideSingleton: function (key, instance) {
            this.remove(key);
            return this.setSingleton(key, instance);
        },
        /**
         * Add an configuration for a subview to the SubViewManager.
         * It can be instantiated later with the add function.
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @class
         * @method addConfig
         * @param {String} name
         *      The name or type that you would like use to refer to subViews
         *      created with this config
         * @param {String|Function} construct
         *      The constructor function for this subView. If its a string, the
         *      string must resolve to a global name-spaced function in dot notation.
         *      (e.g. 'Backbone.imageUpload.View')
         * @param {String} [options]
         *      The options or base options you would like to pass to the constructor
         *      whenever it is initialized.
         * @param {String|HTMLElement} [location]
         *      If you want to be able to automatically place a subView's DOM element
         *      somewhere in the parent view, pass a selector or DOM element or $ instance
         *      here that can be used by jquery as a wrapper to append the subView $el
         * @param {Boolean} [singleton]
         *      If you want this view to be a singleton subView. A singleton subView
         *      will only allow one instance of it to be created.
         * @return {SubViewManager}
         */
        /**
         * Add an configuration for a subview to the SubViewManager.
         * It can be instantiated later with the add function.
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @method addConfig
         * @param {Object} map
         *      A object of key names/types to config objects, so you can add multiple configs
         * @example
         * // A config object should have the following format:
         *      {
         *          construct:  // Constructor function or string version (i.e. "Backbone.BaseView")
         *          options:    // Any options you want to pass to the initialize function
         *          singleton:  // if the object should be configured as a singleton or not
         *          location:   // A string or jQuery instance in the parent view element. Or
         *                      // a function that returns one of these. The subview el will
         *                      // be appended to that location
         *      }
         * @return {SubViewManager}
         */
        /**
         * Add an configuration for a subview to the SubViewManager.
         * It can be instantiated later with the add function.
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @method addConfig
         * @param {String} name
         *      The name or type that you would like use to refer to subViews
         *      created with this config
         * @param {Object} config
         *      The configuration object (uses the format described above)
         * @return {SubViewManager}
         */
        addConfig : function (name, config) {
            var map = (isObject(name) && !isArray(name)) ? name : false;
            if (map) {
                each(map, this._addConfig, this);
                return this;
            }

            return this._addConfig(config, name);
        },
        /**
         * Render all Subviews.
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @param {object} [options]
         *      [options.appendTo] A selector, HTMLElement, or $ instance to append the subViews to
         *      [options.useLocation=false]
         *          True if you want to append the subviews to the locations in their config if they
         *          have one.
         *      [options.clearLocations=false]
         *          True if you want to use empty on the configured locations
         *
         * @return {SubViewManager}
         */
        render: function (options) {
            options = options || {};
            var location = options.appendTo || options.useLocation;
            return this._render(this.subViews, location, options.clearLocations);
        },
        /**
         * Renders subviews and appends them to their 'locations' if they have one.
         * If you pass a appendTo param, views are appended to that location instead.
         * This is just a shortcut version of renderAppend({})
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @param {string|HTMLElement|$} [appendTo]
         *        Location to append the rendered subiews to
         * @param {object} [options]
         * @param {boolean} [options.clearLocations=false] Clear configured locations of subviews before rendering
         * @return {SubViewManager}
         */
        renderAppend: function (appendTo, options) {
            options = options || {};
            if (isObject(appendTo) && appendTo instanceof Backbone.$ === false && !_.isElement(appendTo)) {
                options = appendTo;
                appendTo = options.appendTo;
            }
            return this._render(this.subViews, appendTo || true, options.clearLocations);
        },
        /**
         * Render a subView specified by a key (from their configuration key). The key will
         * retrieve subViews by looking for a type and then looking for singletons or
         * specific instance using the Model/View cid
         *
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         *
         * @param {String|Backbone.Model|Backbone.View} key
         *      A key, type, View/Model cid, Model, or View to refer to a specific subView
         *      or subViews. For example, passing the view cid 'view4' will render only
         *      the view with that cid, and passing the type 'creatorNames' will render
         *      views matching the type 'creatorNames'.
         * @param {object} [options]
         * @param {string|$|HTMLElement} [options.appendTo] Element or selector to append subview(s) to
         * @param {boolean} [options.useLocation=false] Append subviews to locations specified in config
         * @param {boolean} [options.clearLocations=false] Clear configured locations of subviews before rendering
         *
         * @return {SubViewManager}
         */
        renderByKey: function (key, options) {
            var subViews = this.getByType(key) || this.get(key);
            if (!isArray(subViews)) { subViews = [subViews]; }
            options = options || {};
            return this._render(subViews, options.appendTo || options.useLocation, options.clearLocations);
        },
        /**
         * Returns a new SubViewManager instance with filtered list of subviews.
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @param {string|Backbone.View[]|function} key
         *      The key or type used to refer to a subview or subviews, or a list
         *      of subViews with a type found in this SubViewManager config, or a function
         *      that will iterate over the subviews and return true if a subview
         *      should be included in the filtered SubViewManager instance.
         * @return {SubViewManager}
         */
        filteredSubs: function (key) {
            var i = -1;
            var len;
            var subViews;
            var subMgr = new SubViewManager(null, this.parent, this.options);
            subMgr.config = this.config;
            subViews = (isArray(key)) ? key : (isFunction(key)) ? this.filter(key) : this.getByType(key);
            len = subViews.length;
            while (++i < len) {
                subMgr.add(subViews[i]._subviewtype, subViews[i]);
            }
            return subMgr;
        },
        /**
         * Iterate through every subView, calling a function or invoking a method on
         * each of them. If a subView has it's own subViews, then it will recursively
         * iterate over those as well. The context is switched to the subView calling
         * the function/method.
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @param {String|Function} func
         *        A string name of a method to call in the subviews or a function that
         *        will be called for each view
         * @param {Array} [args] An array of arguments to pass to the method/function
         * @return {SubViewManager}
         */
        descend: function (func, args) {
            var isFunc = isFunction(func);
            var desc = function (subViews) {
                var i = -1;
                var len = subViews.length;
                var subView;
                var _func;
                while (++i < len) {
                    subView = subViews[i];
                    _func = isFunc ? func : subView[func];
                    if (_func) {
                        if (args) { _func.apply(subView, args);
                        } else { _func.call(subViews[i]); }
                    }
                    if (subView.subViews && subView.subViews.length) {
                        desc(subView.subViews);
                    }
                }
            };
            desc(this.subViews);
            return this;
        },
        /**
         * Clears all subViews and subView data off of the SubViewManager instance
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @param {Boolean} [preserveElems] If true, view $els are left on the DOM
         * @param {Boolean} [clearConfigs] If true, resets the subView configs as well
         * @return {SubViewManager}
         */
        clear: function (preserveElems, clearConfigs) {
            if (!preserveElems) {
                this.removeElems();
            }
            this.subViews = [];
            if (this.parent && this.parent.subViews) {
                this.parent.subViews = this.subViews;
            }
            this._subViewsByType = {};
            this._subViewSingletons = {};
            this._subViewsByCid = {};
            this._subViewsByModelCid = {};
            if (clearConfigs) {
                this.config = {};
            }
            return this;
        },
        /**
         * Remove a subView
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @param {String|Backbone.View|Backbone.Model} key
         * @param {Boolean} [preserveElems] If true, the View's element will not be removed from the DOM
         * @return {SubViewManager}
         */
        remove: function (key, preserveElems) {
            var subViews = (key && (typeof key === "string" || key.cid)) ? this.get(key) : key;
            var len;
            if (!subViews) { return this; }
            if (!isArray(subViews)) {
                subViews = [subViews];
            }
            len = subViews ? subViews.length : 0;
            if (!preserveElems) {
                this.removeElems(subViews);
            }
            if (len) {
                this.trigger('remove', subViews);
            }
            while (subViews && subViews.length) {
                this._remove(subViews.shift());
            }
            return this;
        },
        /**
         * Remove's all subviews matching any
         * key in a list of keys
         * @memberOf SubViewManager#
         * @param  {String[]} keys
         * @param {Boolean} [preserveElems=false]
         *        If true, the views' elements will not
         *        be removed from the DOM
         * @return {SubViewManager}
         */
        removeByKeys: function (keys, preserveElems) {
            var i = 0;
            var len = keys ? keys.length : 0;
            for (i; i < len; i++) {
                this.remove(keys[i], preserveElems);
            }
            return this;
        },
        /**
         * Removes all subView '.el' element from the dom, or if passed a
         * list of subViews, removes only the elements in those.
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @param {Backbone.View[]} subViews
         * @return {SubViewManager}
         */
        removeElems: function (subViews) {
            subViews = subViews || this.subViews;

            var i = -1;
            var len = subViews.length;
            while (++i < len) {
                subViews[i].remove();
            }
            return this;
        },
        /**
         * Shortcut method to invoke jQuery's detach function
         * on each of the '.$el' elements for each of the
         * subviews, or if an array of subViews is passed,
         * on each of those. Useful if you want to re-render
         * a parent view and want to prevent subviews from
         * losing their events and other data that is removed
         * when jQuery 'remove' is called on that element.
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @param {Backbone.View[]} subViews
         * @return {SubViewManager}
         */
        detachElems: function (subViews) {
            subViews = subViews || this.subViews;

            var i = -1;
            var len = subViews.length;
            while (++i < len) {
                subViews[i].$el.detach();
            }
            return this;
        },
        /**
         * Get a subView instance or an array if multiple instances
         * match your key.
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @param {Object|String} [key]
         *      The key to a subView singleton, the view's cid
         *      the associated model cid, the associated model itself,
         *      or the associated view itself. If your key is a
         *      string, you can use
         * @return {Backbone.View|Backbone.View[]}
         */
        get : function (key) {
            if (key.cid) {
                return this._subViewsByCid[key.cid] || this._subViewsByModelCid[key.cid];
            }
            if (key.indexOf('.') > -1 && this.dotNotation) {
                var segs = key.split('.');
                var view = this.parent;
                while (segs.length && view) { view = view.subs.get(segs.shift()); }
                return view;
            }

            return this._subViewSingletons[key] || this._subViewsByCid[key] ||
                this._subViewsByModelCid[key] || this._subViewsByType[key];
        },
        /**
         * Returns all views that match a type key, guarantees an array.
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @param {String} type
         * @return {Backbone.View[]}
         */
        getByType : function (type) {
            if (this._subViewsByType[type]) {
                return this._subViewsByType[type];
            }
            return (this._subViewSingletons[type]) ? [this._subViewSingletons[type]] : [];
        },
        /**
         * Get the subviews type or key
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @param subview
         * @return {String|Number}
         */
        getSubViewType : function (subview) {
            subview = (subview instanceof View === true) ? subview : this.get(subview);
            return subview._subviewtype;
        },
        /**
         * Get the subview at a specific index, based on the order
         * that the subViews were added or a custom sorted order.
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @param  {Number} index The index of the sub view
         * @return {Backbone.View}
         */
        at: function (index) {
            return this.subViews[index];
        },
        /**
         * Clears the html in all locations specified in the subview configs
         * @memberOf SubViewManager#
         * @type {SubViewManager}
         * @return {SubViewManager}
         */
        clearLocations : function (type) {
            var confs = type ? _.pick(this.config, type) : this.config;
            each(confs, function (config) {
                this.parent.$(config.location).html('');
            }, this);
            return this;
        },
        /**
         * Set a location for a subview type
         * @memberOf SubViewManager#
         * @param {string} type The subview type
         * @param {$|HTMLElement|String} location
         *        A location within the parent view
         *        to place the subview in
         * @return {SubViewManager}
         */
        setLocationForType: function (type, location) {
            this._addConfig({ location: location }, type);
            return this;
        },
        /**
         * Generate a location selector for each configured
         * subview type. Each subview type will have a
         * location set based on the subview type. For
         * example,the subview type 'header' would get the
         * type '.header-container' (using the default
         * suffix).
         * @memberOf SubViewManager#
         * @param  {string} [suffix=-container]
         *         The suffix to use for each location
         *         selector.
         * @return {SubViewManager}
         */
        useDefaultLocationSelectors: function (suffix) {
            var type;
            suffix = _.isString(suffix) ? suffix : '-container';
            for (type in this.config) {
                if (this.config.hasOwnProperty(type) && !this.config[type].location) {
                    this.setLocationForType(type, '.' + type + suffix);
                }
            }
            return this;
        },
        _render : function (subViews, place, clearLocations) {
            var $appendTo;
            var i = -1;
            var location;
            var $locations = {};
            if (place !== true) {
                $appendTo = place;
            }
            if (clearLocations) {
                this.clearLocations();
            }

            while (++i < subViews.length) {
                subViews[i].render();
                if ($appendTo) {
                    subViews[i].$el.appendTo((typeof $appendTo === 'string') ? this.parent.$($appendTo).first() : $appendTo);
                } else if (place && (location = this.config[this.getSubViewType(subViews[i])].location)) { //eslint-disable-line no-cond-assign
                    if (typeof location === 'string') {
                        if (!$locations[location]) {
                            $locations[location] = this.parent.$(location).first();
                        }
                        location = $locations[location];
                    } else if (typeof location === 'function') {
                        location = location.call(subViews[i]);
                        if (!(location instanceof Backbone.$)) { throw new Error('location function must return instance of jQuery'); }
                    }
                    location.append(subViews[i].el);
                }
            }
            return this;
        },
        _addInstance : function (key, subViews, singleton) {
            var i = -1;
            var len;
            var self = this;

            key = key || '_svid_' + _.size(this.config);

            if (self._subViewSingletons[key]) { return self; }

            if (!isArray(subViews)) {
                subViews = [subViews];
            }

            len = subViews.length;

            if (!self.config[key]) {
                self.config[key] = { singleton: singleton };
            }

            if (!self.config[key].construct && subViews[0].constructor) {
                self.config[key].construct = subViews[0].constructor;
            }

            singleton = (singleton === undefined) ? self.config[key].singleton : singleton;

            while (++i < len) {
                self._setInst(key, subViews[i], singleton);
            }
            return self;
        },
        _addConfig : function (config, name) {
            if (!config || !name) {
                return this;
            }
            this.config[name] = _.extend(this.config[name] || {}, config);
            if (typeof this.config[name].singleton !== "boolean") {
                this.config[name].singleton = this.defaultToSingletons;
            }
            if (this.autoInitSingletons && this.config[name].singleton) {
                return this._init(name);
            }
            return this;
        },
        _remove : function (subView, silent) {
            var i = -1;
            var len = this.subViews.length;
            var key = this.getSubViewType(subView);
            var typeList = this.getByType(key);

            while (++i < len) {
                if (this.subViews[i].cid === subView.cid) {
                    this.subViews.splice(i, 1);
                    break;
                }
            }
            len = typeList ? typeList.length : 0;
            if (!this._subViewSingletons[key] && len) {
                for (i = 0; i < len; i++) {
                    if (typeList[i].cid === subView.cid) {
                        typeList.splice(i, 1);
                        break;
                    }
                }
            }

            delete this._subViewsByCid[subView.cid];
            if (subView.model && subView.model.cid && this._subViewsByModelCid[subView.model.cid]) {
                delete this._subViewsByModelCid[subView.model.cid];
            }

            if (this._subViewSingletons[key]) {
                delete this._subViewSingletons[key];
            }
            if (!silent) {
                this.trigger('remove:' + key, subView);
            }
        },
        _setInst: function (key, instance, singleton, silent) {
            var modCid = (instance.model) ? instance.model.cid : null;
            var viewsByModel = this._subViewsByModelCid;

            this.subViews.push(instance);
            this._subViewsByCid[instance.cid] = instance;
            if (!instance.parentView) { instance.parentView = this.parent; }
            instance._subviewtype = key;
            if (modCid) {
                if (viewsByModel[modCid]) {
                    if (!isArray(viewsByModel[modCid])) { viewsByModel[modCid] = [viewsByModel[modCid]]; }
                    viewsByModel[modCid].push(instance);
                } else {
                    this._subViewsByModelCid[modCid] = instance;
                }
            }

            singleton = (typeof singleton === 'boolean') ? singleton : this.defaultToSingletons;
            if (singleton) {
                this._subViewSingletons[key] = instance;
            } else {
                if (!this._subViewsByType[key]) { this._subViewsByType[key] = []; }
                this._subViewsByType[key].push(instance);
            }
            this.newest = instance;
            if (!silent) {
                return this.trigger('add', instance).trigger('add:' + key, instance);
            }
            return this;
        },
        _init: function (key, options, singleton) {
            var instance;
            var config = this.config[key];
            var Construct = (config && config.construct) ? config.construct : null;

            if (this._subViewSingletons[key]) {
                return undefined;
            }

            options = _.extend({}, config.options || {}, options || {});

            Construct = (typeof Construct === 'string') ? _stringToObj(Construct) : Construct;
            if (!Construct) {
                console.error('Construct for key "' + key + '" was not found:', config ? config.construct : '');
                return undefined;
            }
            instance = new Construct(options, this.parent);
            this._setInst(key, instance, (singleton !== undefined) ? singleton : config.singleton);
            return instance;
        }
    };

    // Add underscore methods to SubViewManager (e.g. myView.subs.each(function (subView) { console.log(subView.cid); });)
    each([
        'each', 'map', 'initial', 'rest', 'last', 'first', 'find', 'filter', 'sortBy',
        'groupBy', 'where', 'findWhere', 'some', 'every', 'invoke', 'contains', 'max', 'min',
        'size', 'without', 'indexOf', 'lastIndexOf', 'isEmpty', 'reject'
    ], function (funcName) {
        /**
         * Partial applications of underscore (or lodash if you use that instead) functions
         * of the same name (operates on the subViews array).
         * List of available underscore methods:
         * 'each', 'map', 'initial', 'rest', 'last', 'first', 'find', 'filter', 'sortBy',
         * 'groupBy', 'where', 'findWhere', 'some', 'every', 'invoke', 'contains', 'max', 'min',
         * 'size', 'without', 'indexOf', 'lastIndexOf', 'isEmpty', 'reject'
         * @method underscore_methods
         * @memberOf SubViewManager#
         * @see http://underscorejs.org
         * @example
         * myBaseView.subs.each(function (subView) {
         *     console.log('A subView of myBaseView', subView);
         * });
         * @example
         * var view = myBaseView.subs.findWhere({ collection : testCollection });
         * view.collection === test.collection // returns true
         */
        SubViewManager.prototype[funcName] = function () {
            return _[funcName].apply(this, [this.subViews].concat(slice.call(arguments)));
        };
    });

    // Add Backbone.Events functionality to SubView manager instances
    _.extend(SubViewManager.prototype, Backbone.Events);


    // =====================================================
    // BaseView.marinate

    var marinate;
    var _randZeroPadding = 1000000000;
    var getFunc = function (obj, func) {
        if (typeof func === 'function') {
            return func;
        }
        if (typeof func === 'string') {
            return obj[func];
        }
        return undefined;
    };
    var addEventNamespace = function (eventKey, namespace) {
        var splitKey = eventKey.split(' ');
        eventKey = splitKey[0] + ('.' + namespace);
        eventKey += (splitKey[1] ? ' ' + splitKey[1] : '');
        return eventKey;
    };
    var _addEvents = function (view, name, eventsObj) {
        var key;
        var val;
        var areNamespaced = false;
        view.addedEvents = view.addedEvents || {};
        if (typeof name !== 'string') {
            eventsObj = name;
            name = false;
        }
        for (key in eventsObj) {
            if (eventsObj.hasOwnProperty(key)) {
                val = eventsObj[key];
                areNamespaced = (!_.isString(val) && !_.isFunction(val));
                break;
            }
        }
        if (areNamespaced) {
            _.extend(view.addedEvents, eventsObj);
        } else {
            view.addedEvents[name || _.size(view.addedEvents)] = eventsObj;
        }
        return view;
    };
    var _marinate = function (view, args) {
        _.each(args, function (mixin) {
            if (mixin.addedEvents) {
                _addEvents(view, mixin.addedEvents);
            }
            _.extend(view, _.omit(mixin, 'addedEvents'));
        });
        return view;
    };


    // =====================================================
    // Backbone.BaseView

    /**
     * Adds some additional functionality to Backbone Views. Namely,
     * in the form of subView management. Access info and methods
     * to manipulate the '.subs' property.
     * @constructor Backbone.BaseView
     * @augments {Backbone.View}
     * @class Backbone.BaseView
     * @property subViews {Backbone.View[]} - Reference array of subViews generated by the '.subs' {@link SubViewManager}
     * @property subs {SubViewManager} - object specifically for manipulating subviews
     * @property subViewConfig      - A config map that can be automatically passed to the SubViewManager
     * @property autoInitSubViews   - any subviews that are singletons will be autoinitilized if true
     * @property singletonSubViews  - If subviews should default to being singletons when created
     * @property parentView         - if this is a subView of another dibLibs.BaseView, this will be a ref to that view instance
     */
    BaseView = View.extend({
        subViews: null,
        subs: null,
        // SubView Configuration Object
        // <key> : {
        //      construct: // Constructor function or string version (i.e. "Backbone.BaseView")
        //      options: // Any options you want to pass to the initialize function
        //      singleton: // if the object should be configured as a singleton or not
        //      location: // Useful for automatically placing the subviews element in it's parent
        //  }
        subViewConfig: null,
        // Any subviews that are singletons will be auto initialized if the below is true
        autoInitSubViews: false,
        // True if your subviews should default to singleton or not
        singletonSubViews: false,
        // If this is a subView of another Backbone.BaseView, this will be a ref to that view instance
        parentView: null,
        constructor: function (options, parentView) {
            var subViewCfg = (options && options.subViewConfig) ? options.subViewConfig : this.subViewConfig;
            subViewCfg = (isFunction(subViewCfg)) ? subViewCfg.call(this) : subViewCfg;
            // Assign a parentView if second param is a Backbone View
            this.parentView = (parentView instanceof View) ? parentView : null;
            this.subs = new SubViewManager(null, this, {
                autoInitSingletons: this.autoInitSubViews,
                defaultToSingletons: this.singletonSubViews
            });
            if (subViewCfg) {
                this.subs.addConfig(subViewCfg);
            }
            this.subViews = this.subs.subViews;
            // Add events that will not bubble events up app the view's ancestor tree
            this._stopPropogation = {};
            BaseView.__super__.constructor.call(this, options);
            // To maintain parity with how Backbone handles the 'events'
            // property on a view, we will overwrite the 'viewEvents'
            // property on the prototype with options.viewEvents if it
            // exists
            this.viewEvents = options && options.viewEvents ? options.viewEvents : this.viewEvents;
            if (this.viewEvents) {
                this.bindViewEvents();
            }
        },
        /**
         * A basic render function that looks for a template
         * function, calls the template with the result of
         * the 'templateVars' property, and then set the html
         * to the result. Then, subviews are rendered and then
         * appended to their locations.
         * @memberOf Backbone.BaseView#
         * @return {Backbone.BaseView}
         */
        render: function () {
            var html = '';
            var template = this.template;
            if (isFunction(template)) {
                html = template(result(this, 'templateVars')) || '';
            }
            this.$el.html(html);
            this.subs.renderAppend();
            return this;
        },
        /**
         * Place the view DOM element ('.el') in a specified location. By
         * default it is appended to the location.
         * @memberOf Backbone.BaseView#
         * @param {jQuery} $location jQuery DOM element
         * @param {boolean} [replace]
         *        True if you want to replace existing html
         *        of the location with this view
         * @return {Backbone.BaseView}
         */
        place: function ($location, replace) {
            if (typeof $location === "string") {
                var $parent = (this.parentView) ? this.parentView.$el : Backbone.$('body');
                $location = $parent.find($location);
            }

            if (replace) {
                $location.html(this.el);
                return this;
            }
            $location.append(this.el);
            return this;
        },
        /**
         * Overrides Backbone.View#remove in order
         * to remove SubViews as well, in order to
         * prevent memory leaks.
         * @memberOf Backbone.BaseView#
         * @return {Backbone.BaseView}
         */
        remove: function () {
            BaseView.__super__.remove.call(this);
            this.subs.removeElems();
            return this;
        },
        /**
         * Stops the current event from propagating up or down the
         * ancestor tree of BaseView instances. Resets immediately
         * after stopping the event, and has to be callled every
         * time you want an event to be stopped.
         * @memberOf Backbone.BaseView#
         * @param {String} event The name of the event
         * @return {Backbone.BaseView}
         */
        stopEvent: function (event) {
            console.assert(!!event, "event parameter is required");
            this._stopPropogation[event] = true;
            return this;
        },
        /**
         * Like Backbone.trigger, except that this will not only use trigger
         * on the instance this method is invoked on, but also the instance's
         * 'parentView', and the parentView's parentView, and so on.
         * Additional arguments beyond the event name will be passed
         * as arguments to the event handler functions. The view that
         * originated the bubbling event will automatically be tacked
         * on to the end of the arguments, so you can access it if needed.
         * @memberOf Backbone.BaseView#
         * @param {String} event The name of the event
         * @param {...Mixed} [arg] Argument be passed to event callbacks
         * @return {Backbone.BaseView}
         */
        triggerBubble: function (event) {
            var args = slice.call(arguments, 1);
            var stopPropogation;
            var anscestor;
            args.unshift(event);
            args.push(this);
            anscestor = this;
            while (anscestor) {
                anscestor.trigger.apply(anscestor, args);
                stopPropogation = anscestor._stopPropogation;
                if (stopPropogation && stopPropogation[event]) {
                    stopPropogation[event] = false;
                    return this;
                }
                anscestor = anscestor.parentView;
            }
            return this;
        },
        /**
         * Triggers an event that will trigger on each of the instances
         * subViews, and then if a subView has subViews, will trigger the
         * event on that subViews' subViews, and so on. If a subView
         * calls stopEvent and passes the event name, then the event
         * will not trigger on that subViews' subViews. Arguments
         * work in the same manner as they do with triggerBubble.
         * @memberOf Backbone.BaseView#
         * @param {String} event The event name
         * @param {...Mixed} [arg] Argument be passed to event callbacks
         * @return {Backbone.BaseView}
         */
        triggerDescend: function (event) {
            var args = slice.call(arguments, 1);
            var _trigger = function (subViews) {
                var i = -1;
                var len = subViews.length;
                var subSubs;
                var stopPropogation;
                var descend;
                while (++i < len) {
                    descend = true;
                    subViews[i].trigger.apply(subViews[i], args);
                    stopPropogation = subViews[i]._stopPropogation;
                    if (stopPropogation && stopPropogation[event]) {
                        stopPropogation[event] = false;
                        descend = false;
                    }
                    subSubs = subViews[i].subViews;
                    if (descend && subSubs && subSubs.length) {
                        _trigger(subSubs);
                    }
                }
            };
            args.unshift(event);
            args.push(this);
            _trigger([this]);
            return this;
        },
        /**
         * Invoke a function or method on ancestors
         * @memberOf Backbone.BaseView#
         * @param {Function|String} fnName
         * @param {mixed[]} [args]
         *        An array of arguments to pass to
         *        the invocation
         * @return {Backbone.BaseView}
         */
        ascend: function (fnName, args) {
            var func;
            var ancestor = this;
            var isFunc = isFunction(fnName);
            while (ancestor.parentView) {
                ancestor = ancestor.parentView;
                if (ancestor) {
                    func = isFunc ? fnName : ancestor[fnName];
                    func.apply(ancestor, args);
                }
            }
            return this;
        },
        /**
         * Ascends up the ancestor line until an
         * a test function returns true
         * @param  {Function} testFn
         *         A function that returns a truthy
         *         value if the current ancestor should be
         *         returned
         * @return {Backbone.BaseView|null}
         */
        findAncestor: function (testFn) {
            var ancestor = this;
            while (ancestor.parentView) {
                ancestor = ancestor.parentView;
                if (ancestor && testFn(ancestor)) {
                    return ancestor;
                }
            }
            return null;
        },
        /**
         * Returns the first ancestor to be an instance
         * of the Construct argument
         * @param  {Function} Construct
         *         A Backbone.BaseView constructor function
         * @return {Backbone.BaseView|null}
         */
        findAncestorByConstruct: function (Construct) {
            return this.findAncestor(function (ancestor) {
                return ancestor instanceof Construct;
            });
        },
        /**
         * Get the first ancestor that matches a type.
         * @memberOf Backbone.BaseView#
         * @param {String} type
         *        The subView 'type' the ancestor should match. The
         *        first ancestor with this type will be returned
         * @return {null|Backbone.BaseView}
         */
        findAncestorByType: function (type) {
            return this.findAncestor(function (ancestor) {
                return type && ancestor._subviewtype === type;
            });
        },
        /**
         * Return the subview type if this view a subview and was a assigned a
         * type.
         * @memberOf Backbone.BaseView#
         * @return {string|number} The subview type
         */
        getSubViewType: function () {
            return this._subviewtype;
        },
        /**
         * Returns the top of the subView hierarchy.
         * @memberOf Backbone.BaseView#
         * @return {Backbone.View}
         */
        getTopView : function () {
            var ancestor = this;
            while (ancestor.parentView) {
                ancestor = ancestor.parentView;
            }
            return ancestor;
        },
        /**
         * Returns true if this view has no ancestors
         * @memberOf Backbone.BaseView#
         * @return {boolean}
         */
        isTopView : function () {
            return !this.parentView;
        },
        /**
         * Like delegateEvents, except that instead of events being bound to el, the
         * events are backbone events bound to the view object itself. You can create
         * a 'viewEvents' object literal property on a View's prototype, and when it's
         * instantiated, the view will listen for events on a Backone object based on
         * the key.
         *
         * For example { 'change model': 'render' } would listen for a 'change'
         * event on the view's model property and then call view's render method.
         * If you only specify an event name and leave the property out of the key,
         * then the event will be bound to the view instance directly. For example,
         * { 'submit' : 'render' } would call the render method of the view when
         * a 'submit' event occurs on the view.
         * @memberOf Backbone.BaseView#
         * return {Backbone.BaseView}
         */
        bindViewEvents: function (events) {
            events = events || result(this, 'viewEvents');
            each(events, function (func, event) {
                var segs = event.split(' ');
                var listenTo = (segs.length > 1) ? this[segs[1]] : this;
                func = isFunction(func) ? func : this[func];
                if (listenTo) {
                    this.stopListening(listenTo, segs[0], func);
                    this.listenTo(listenTo, segs[0], func);
                }
            }, this);
            return this;
        },

        /**
         * Overrides delegateEvents, only changing behavior if the view
         * instance has an 'addedEvents' property defined. This will
         * create an events object that has all events from the '.events'
         * property and the 'addedEvents' property. Added events
         * should be namespaced on a key (or autonamespaced).
         *
         * @override
         * @memberof Backbone.BaseView#
         * @param {object} [events]
         *      If provided, these will be used as the events instead of
         *      the events found in the events and addedEvents object
         * @param {boolean} [includeAdded]
         *      If true, and an events object is passed as a first param
         *      then instead of only using delegating events passed in
         *      as the first param, the events stored in the 'addedEvents'
         *      property are also delegated
         * @returns {Backbone.BaseView}
         */
        delegateEvents: function (events, includeAdded) {
            if ((!events || includeAdded) && this.addedEvents) {
                events = _.clone(_.result(this, 'events')) || {};
                var groupName;
                var eventKey;
                var callback;
                var addedEvents;

                for (groupName in this.addedEvents) {
                    if (this.addedEvents.hasOwnProperty(groupName)) {
                        addedEvents = _.result(this.addedEvents, groupName);
                        for (eventKey in addedEvents) {
                            if (addedEvents.hasOwnProperty(eventKey)) {
                                if (!events[eventKey] || getFunc(this, events[eventKey]) !== getFunc(this, addedEvents[eventKey])) {
                                    callback = addedEvents[eventKey];
                                    if (isNaN(parseInt(groupName, 10))) {
                                        eventKey = addEventNamespace(eventKey, groupName);
                                    }
                                    if (!events[eventKey]) {
                                        events[eventKey] = callback;
                                    } else {
                                        eventKey = addEventNamespace(eventKey, ('dibs' + Math.round(Math.random() * _randZeroPadding)));
                                        events[eventKey] = callback;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return BaseView.__super__.delegateEvents.call(this, events);
        },

        addEvents: function (name, events) {
            _addEvents(this, name, events);
            return this;
        },

        removeAddedEvents: function (name, undelegate) {
            delete this.addedEvents[name];
            if (undelegate) {
                this.$el.off('.' + name);
            }
            return this;
        },

        marinate: function () {
            _marinate(this, Array.prototype.slice.call(arguments));
            return this;
        }

    });


    /**
     *
     * Slowly impart flavor into your BaseView instances. Also,
     * adds properties and methods your BaseView extension's
     * prototype like _.extend(MyView.prototype, mixin) would,
     * except that it looks for an 'addedEvents' property on
     * your mixin and adds those events to existing 'addedEvents'
     * rather than overwriting them.
     * @module {function} marinate
     * @param {...object} mixins
     *      One or more mixins to copy onto your view's prototype,
     *      with the optional 'addedEvents' object being added
     *      onto the existing addedEvents object instead of
     * @returns {function}
     */
    marinate = function (View) { //eslint-disable-line no-shadow
        console.assert(View.prototype instanceof Backbone.BaseView, 'View must a Backbone.BaseView constructor');
        var mixins = slice.call(arguments, 1);
        _marinate(View.prototype, mixins);
    };

    _.extend(marinate, {
        /**
         * Marinate only an instance of a view
         * @memberOf module:marinate
         * @param {Backbone.BaseView} viewInstance
         * @param {...object} mixins
         */
        marinateInstance: function (viewInstance) {
            console.assert(viewInstance instanceof Backbone.BaseView, 'viewInstance must be an instance of Backbone.BaseView');
            var mixins = slice.call(arguments, 1);
            _marinate(viewInstance, mixins);
        },
        /**
         * Add DOM events to a BaseView pseudoclass
         * @memberOf module:marinate
         * @param {function} View Constructor for Backbone.BaseView
         * @param {string} name Namespace for your added events
         * @param {object} eventsObj Backbone DOM events hash
         */
        addProtoEvents: function (View, name, eventsObj) { //eslint-disable-line no-shadow
            console.assert(View.prototype instanceof Backbone.BaseView, 'View must a Backbone.BaseView constructor');
            _addEvents(View.prototype, name, eventsObj);
        },
        /**
         * Add DOM events to a BaseView instance
         * @memberOf module:marinate
         * @param {Backbone.BaseView} viewInstance
         * @param {string} name Namespace for your added events
         * @param {object} eventsObj Backbone DOM events hash
         */
        addEvents: function (viewInstance, name, eventsObj) {
            console.assert(viewInstance instanceof Backbone.BaseView, 'viewInstance must be an instance of Backbone.BaseView');
            _addEvents(viewInstance, name, eventsObj);
        }
    });

    BaseView.marinate = marinate;

    Backbone.BaseView = BaseView;

}(this));


/***/ }),
/* 2613 */
/***/ (function(module, exports, __webpack_require__) {

//     Backbone.FormView 0.8.3

//     (c) 2014 James Ballantine, 1stdibs.com Inc.
//     Backbone.FormView may be freely distributed under the MIT license.
//     For all details and documentation:
//     https://github.com/1stdibs/backbone-base-and-form-view

(function (root) {
    'use strict';

    var Backbone = root.Backbone;
    var _ = root._;

    if (true) {
        _ = __webpack_require__(2038);
        Backbone = __webpack_require__(2612);
        module.exports = Backbone;
    }

    if (!Backbone || !Backbone.BaseView) {
        throw new Error('Backbone and Backbone.BaseView required');
    }

    var FieldView;
    var RadioListView;
    var SelectListView;
    var CheckListView;
    var CheckBoxView;
    var FieldSetView;
    var CollectionFieldSetView;
        // Local copies
    var Model = Backbone.Model;
    var Collection = Backbone.Collection;
    var each = _.each;
    var extend = _.extend;
    var defaults = _.defaults;
    var clone = _.clone;
    var isUndefined = _.isUndefined;
    var isFunction = _.isFunction;
    var isArray = _.isArray;
    var isString = _.isString;
    var result = _.result;
    var toStr = String;
    var defaultUpdateEvents = ['blur'];

    // Form Disable Mixin -- added to FormView prototype's
    // in order to allow disabling and enabling fields.
    var formViewDisableMixin = {
        /**
         * Disables the form by invoking the disable method
         * on all fields that implement it. If a field doesn't
         * implement this method, it will not be disabled.
         * @memberOf Backbone.FormView#
         * @return {Backbone.FormView}
         */
        disable: function () {
            this.subs.each(function (field) {
                if (isFunction(field.disable)) { field.disable(); }
            });
            return this;
        },
        /**
         * The reverse of disable, naturally. Invokes enable method
         * on all fields and field sets.
         * @memberOf Backbone.FormView#
         * @return {Backbone.FormView}
         */
        enable: function () {
            this.subs.each(function (field) {
                if (isFunction(field.enable)) { field.enable(); }
            });
            return this;
        }
    };

    /**
     * Used by the FieldSet and CollectionFieldSet function
     * @return {string} A prefix for a field name/id
     */
    var getFieldPrefix = function () {
        var prefPref = (this.parentView && this.parentView.getFieldPrefix) ? this.parentView.getFieldPrefix() : '';
        return prefPref + this.fieldSetName + '-';
    };

    /**
     * Function used by FormView, CollectionFormView, FieldSet,
     * CollectionFieldSet, and the FieldViews to generate
     * template variables in the 'render' methods
     * @return {object}
     */
    var getTemplateVars = function () {
        return extend({}, this._defaultTemplateVars, result(this, 'templateVars'));
    };

    // ------------------------
    // Local utility functions

    // Utility function to help find submodels and sub collections in _setupSubViewConfig
    var strTo = function (string, obj, instOf) {
        if (string instanceof instOf) {
            return string;
        }
        if (string === true && obj instanceof instOf) {
            return obj;
        }
        if (!obj) { return null; }
        obj = obj.get(string);
        if (obj instanceof instOf) {
            return obj;
        }
        return null;
    };
    // Utility function used by FormView to determine what model the options object should use.
    // Looks to see if options.model is already a Backbone Model, but if its a string, tries to find
    // sub model of the parent model. If that doesn't work, uses the parent model. If the options
    // doesn't specify a model to use, then we do the same thing with the schema key (the field key)
    var getSubModel = function (optionModel, key, model) {
        return optionModel ? (strTo(optionModel, model, Model) || model) : strTo(key, model, Model) || model;
    };
    // Similar to getSubModel except for collections and does not pass the parent collection if no option
    // collection is specified and the schema key cannot locate a sub collection, then null is returned
    var getSubCollection = function (optionCollection, key, model, collection) {
        if (optionCollection) {
            return strTo(optionCollection, model, Collection) || collection;
        }
        return strTo(key, model, Collection) || null;
    };


    // ======================================================================================
    // FORM VIEW
    // ======================================================================================

    /**
     * An extension of {@link Backbone.BaseView} that lets you set up a form easily by making
     * subviews automatically using a 'schema' and defining a framework to let you create elaborate
     * forms with less code. You can define a schema by extending this view and specifying a 'schema'
     * prototype property, or by passing a 'schema' option when you initialize the view.
     * @constructor Backbone.FormView
     * @class Backbone.FormView
     * @extends Backbone.BaseView
     *
     * @property {Object} [options] - Options that you can pass to init or add as properties on extended view
     * @property {Function|String} [options.template]
     *       An underscore template function or a string that serves as the source
     *       of an underscore template function. In order for the FormView's "render"
     *       method to work, the template requires a data-fields attribute to be set
     *       on an element in the template. This element will serve as a wrapper
     *       for all the subViews that will be generated on render.
     * @property {Object} [options.schema]
     *       Schema to use to create form fields automatically on render (or initialization
     *       if setupOnInit is true)
     * @property {Boolean} [options.setupOnInit]
     *      The schema will be used to set up all subView (the fields) instances by
     *      default when the FormView's render method is invoked, but unless setupOnInit
     *      is true, and instead the instances are created when initialize is called. If
     *      this is false, you can still setup the subViews anytime by invoking the
     *      setupFields method.
     * @property {String[]} [options.fieldOrder]
     *      Should represent the order that you want the fields to be rendered in,
     *      otherwise they will be rendered in the order they appear in the schema.
     *      Each index should match a key defined in your schema.
     * @property {Object} [options.templateVars]
     *      an object of variables that will be passed to the template
     * @property {Boolean} [options.autoUpdateModel]
     *      The FormView is designed to work with nested model and collection
     *      paradigms seen in frameworks like BackboneRelational. Some of
     *      these frameworks will recreate models and collections when the top
     *      level model syncs with the server or the user sets a new model
     *      on the property manually, so passing 'true' here will have the
     *      form view try to automatically change the model properties of
     *      the fields and fieldsets to use the correct model based on
     *      the top level form model.
     * @property {Boolean} [options.twoWay]
     *      If the fields support it (which the default fields do), then when
     *      a model is updated, and not by the field, then the field will
     *      automatically re-render the input to display the updated value
     *      to the user.
     *
     * @example
     * // schema object that can be a property on the view or an option passed to the form
     * schema : {
     *      // The schema key
     *      fieldname: {
     *         type: 'Text',
     *
     *         // The options object is passed to the Field View on init.
     *         // Some options are added automatically.
     *         options: {
     *             // If you don't specify a model, the parent's model (ie the form views model)
     *             // will be passed automatically, or if a submodel is found that matches
     *             // 'fieldname', that will be retrieved automatically
     *             model: subModelName
     *
     *             // Works in a similar way as the model property does, except that if
     *             // no collection string/instance is provided, and no sub collection
     *             // matching 'fieldname' attached to the parent model, then no collection
     *             // will be attached to the subView
     *             collection: subCollectionName
     *
     *             // if the 'type' is view that is an instance FormView (e.g. FieldSet)
     *             // then you can pass a schema as an option and then the formView will
     *             // recursively setup the schema for that FormView fieldset as well
     *             schema: {
     *                 // Fieldset fields
     *             }
     *
     *             ... // Other options you would like to pass to the type upon init
     *         }
     *     },
     *     ... // Other field schemas
     * }
     *
     */
    Backbone.FormView = Backbone.BaseView.extend({
        tagName: 'form',
        className: 'form-horizontal',
        fieldAlias: {
            'Text' : 'Backbone.fields.FieldView',
            'RadioList' : 'Backbone.fields.RadioListView',
            'CheckList' : 'Backbone.fields.CheckListView',
            'Select' : 'Backbone.fields.SelectListView',
            'FieldSet' : 'Backbone.FieldSetView',
            'Checkbox' : 'Backbone.fields.CheckBoxView',
            'CollectionField' : 'Backbone.CollectionFieldSetView'
        },
        template: _.template('<div data-fields=""></div>'),
        fieldsWrapper: '[data-fields]:first',
        initialize: function (options) {
            options = this.options = defaults(options || {}, this.options);
            var schema = options.schema || this.schema;
            var setUpOnInit = !isUndefined(options.setupOnInit) ? options.setupOnInit : this.setupOnInit;
            // this.subs.autoInitSingletons = true;
            extend(this, {
                templateVars : options.templateVars || this.templateVars || {},
                setupOnInit : options.setupOnInit || this.setupOnInit,
                validateOnSet : (!isUndefined(options.validateOnSet)) ? options.validateOnSet : this.validateOnSet,
                twoWay: (!isUndefined(options.twoWay)) ? options.twoWay : this.twoWay,
                autoUpdateModel: (!isUndefined(options.autoUpdateModel)) ? options.autoUpdateModel : this.autoUpdateModel,
                fieldsWrapper: options.fieldsWrapper || this.fieldsWrapper
            });
            this._defaultTemplateVars = this._defaultTemplateVars || { label: options.label };
            this.template = options.template || (isString(this.template) ? _.template(this.template) : this.template);
            this.subViewConfig = options.subViewConfig || null;
            if (schema) {
                this.setSchema(schema);
                if (setUpOnInit) { this.setupFields(); }
            }
        },
        /**
         * Set a new schema for the form.
         * @memberOf Backbone.FormView#
         * @param {Object} schema
         * @return {Backbone.FormView}
         */
        setSchema: function (schema) {
            this.schema = schema || this.schema;
            return this;
        },
        /**
         * The subViewConfig is the schema fleshed by the
         * _setupSubViewConfig method. Set the subViewConfig
         * property and register the config with the subview
         * manager. The property autoInitSingletons on the
         * SubViewManager is true by default with a FormView
         * and that will instantiate the SubViews when the
         * config is added.
         * @memberOf Backbone.FormView#
         * @param {object} config
         * @return {Backbone.FormView}
         */
        setSubViewConfig: function (config) {
            this.subViewConfig = config;
            this.subs.addConfig(config);
            return this;
        },
        /**
         * Should return true if fields have been
         * set up at least once.
         * @memberOf Backbone.FormView#
         * @return {Boolean}
         */
        hasSetupFields: function () {
            return this._hasSetupFields;
        },
        /**
         * Creates the subViewConfig property, derived from the
         * form's schema. The subViewConfig is like the schema
         * but fleshed out for the baseView's subView manager.
         * @memberOf Backbone.FormView#
         * @return {Backbone.FormView}
         */
        setupFields: function () {
            var config = this._setupSubViewConfig(result(this, 'schema'));
            this.setSubViewConfig(config);
            this.subs.createSingletons(); // Instantiate the fields from the config
            this._setHasSetupFields(true);
            return this;
        },
        /**
         * If your form is not automatically setting model
         * properties when the user exits a field, you can
         * use this method to set the values on the model
         * from the inputs all at once.
         * @memberOf Backbone.FormView#
         * @return {Backbone.FormView}
         */
        setModelAttrs: function () {
            this.subs.each(function (field) {
                if (isFunction(field.setModelAttrs)) {
                    field.setModelAttrs();
                }
            });
            return this;
        },
        /**
         * Get the wrapper for the field subView elements
         * @memberOf Backbone.FormView#
         * @return {$}
         */
        getFieldsWrapper: function () {
            var $wrapper = this.$(this.fieldsWrapper);
            if (!$wrapper.length) {
                return this.$el;
            }
            return $wrapper.first();
        },
        /**
         * If your subviews (aka the fields) set in the schema aren't setup yet, then this method
         * does that. Regardless, this method renders the shell template, and then renders all
         * subViews. If your template has an element with data-fields defined, the fields will be
         * appended to that. Otherwise they will be directly appended to the template.
         * @memberOf Backbone.FormView#
         * @return {Backbone.FormView}
         */
        render : function () {
            var order = this.options.fieldOrder || this.fieldOrder;

            this.subs.detachElems();
            if (!this.hasSetupFields()) {
                this.setupFields();
            }
            this.$el.html(this.template(this._getTemplateVars()));

            if (order && order.length) {
                order = order.slice(0);
                while (order.length) {
                    this.subs.renderByKey(order.shift(), { useLocation: true });
                }
            } else {
                this.subs.renderAppend();
            }

            return this;
        },
        _setHasSetupFields: function (hasSetupFields) {
            this._hasSetupFields = hasSetupFields;
            return this;
        },
        _setupSubViewConfig: function (baseSchema, model, collection) {
            var options;
            var collec;
            var schema;
            var self = this;
            var subViewConfig = {};

            model = model || this.model;
            collection = collection || this.collection;

            each(baseSchema, function (origSchema, key) {
                schema = subViewConfig[key] = clone(origSchema);
                schema.options = (isFunction(origSchema.options)) ? origSchema.options.call(this) : clone(origSchema.options || {});
                options = schema.options = schema.options || {};
                schema.singleton = (schema.singleton === undefined) ? true : schema.singleton;
                schema.construct = self.fieldAlias[schema.type || schema.construct] || schema.type || schema.construct;
                schema.location = schema.location || self.fieldsWrapper;
                options.model = getSubModel(options.model, key, model);
                if (this.validateOnSet) { options.setOpts = defaults(options.setOpts || {}, { validate: true }); }
                if (this.twoWay) { options.twoWay = (!isUndefined(options.twoWay)) ? options.twoWay : this.twoWay; }
                collec = getSubCollection(options.collection, key, model, collection);
                if (collec) { options.collection = collec; }
                if (options.schema) {
                    options.subViewConfig = self._setupSubViewConfig(options.schema, options.model);
                }
                options.schemaKey = key;
            }, this);
            return subViewConfig;
        },
        /**
         * A reference to the template vars function
         * @type {function}
         */
        _getTemplateVars: getTemplateVars
    }, {
        /**
         * Add a Field Alias to the list of field aliases. For example
         * You have a view constructor DateFieldView and you want to
         * make it easy to put that field in a schema, you can use this
         * static function to add an allias 'Date' for that constructor
         * @memberOf Backbone.FormView
         * @param {String} alias     Name of the alias
         * @param {String|Function} construct Constructor used for the field
         */
        addFieldAlias: function (alias, construct) {
            var aliases = {};
            var currAliases = Backbone.FormView.prototype.fieldAlias;
            if (construct) {
                aliases[alias] = construct;
            } else { aliases = alias; }
            defaults(currAliases, aliases);
        }
    });

    // Add disable/enable functionality
    extend(Backbone.FormView.prototype, formViewDisableMixin);

    // ====================================================
    // CollectionFormView

    // CollectionFormRowView - used by CollectionFormView for each row
    Backbone.CollectionFormRowView = Backbone.FormView.extend({
        className: 'form-field-row controls-row',
        tagName: 'div',
        getFieldPrefix: function () {
            var parentPref = '';
            var index = this.rowIndex();
            if (this.parentView && this.parentView.getFieldPrefix) {
                parentPref = this.parentView.getFieldPrefix(this) || '';
            }
            return parentPref + ((_.isNumber(index) && index > -1) ? index + '-' : '');
        },
        /**
         * Asks the parent collection form view to delete this row
         * @memberOf Backbone.CollectionFormRowView#
         * @return {Backbone.CollectionFormRowView}
         */
        deleteSelf: function () {
            this.parentView.deleteRow(this);
            return this;
        },
        /**
         * @memberOf Backbone.CollectionFormRowView#
         * @return {number}
         *         The index of the row
         */
        rowIndex: function () {
            if (this.parentView && this.parentView.subs) {
                var rows = this.parentView.subs.get('row');
                if (rows) {
                    return rows.indexOf(this);
                }
            }
            return null;
        }
    });


    /**
     * Similar to Backbone.FormView, except that this form view will iterate
     * over a collection and will produce a row for each model in the collection.
     * Each field in your schema will get a subView for each model in the collection.
     * @constructor Backbone.CollectionFormView
     * @extends Backbone.BaseView
     * @class Backbone.CollectionFormView
     * @property {Backbone.Collection} collection A Backbone.Collection used to create rows
     * @property {object} [options]
     *        Options that can either be set as properties on directly on the view or
     *        passed in an object to the constructor.
     * @property {function|string} [options.template]
     *        The underscore template to use that wraps the rows. Should contain an
     *        empty element that matches the selector for 'rowWrapper' property. By
     *        default, this would mean just adding a 'data-rows' attribute to that
     *        element.
     * @property {object} [options.rowOptions]
     *        Options to pass to each row when they are initialized
     * @property {object} [options.rowSchema]
     *        The form schema to use for each row
     * @property {object} [options.rowConfig]
     *        Instead of using the rowOptions and rowSchema option,
     *        you can define a rowConfig object which works like a BaseView
     *        {@link SubViewManager} config. Here you can define a constructor
     *        as well to use for the row views, in addition to the schema and
     *        options.
     * @property {object} [options.templateVars]
     *        Object to use for template variables for the template that
     *        wraps each of the collection form rows. To pass a template
     *        that is used for each row, use rowOptions.templateSrc
     * @property {boolean} [options.setupOnInit]
     *        True will initialize the row views for each model in the
     *        collection. False means the view will wait until render
     *        or setupRows is called.
     *
     */
    Backbone.CollectionFormView = Backbone.BaseView.extend({
        tagName: 'form',
        className: 'form',
        rowWrapper : '[data-rows]:first',
        template: _.template('<div data-rows=""></div>'),
        initialize: function (options) {
            var self = this;
            var rowOpts;
            options = self.options = defaults(options || {}, self.options);
            self.template = options.template || (isString(self.template) ? _.template(self.template) : self.template);
            self.setupOnInit = !isUndefined(options.setupOnInit) ? options.setupOnInit : self.setupOnInit;
            self.rowOptions = options.rowOptions || self.rowOptions;
            self.templateVars = options.templateVars || self.templateVars || {};
            self._defaultTemplateVars = { label: options.label };
            self.rowWrapper = options.rowWrapper || self.rowWrapper;
            if (options.rowConfig) {
                self.rowConfig = options.rowConfig;
                self.rowConfig = clone(result(self, 'rowConfig')) || {};
                self.rowConfig.options = self.rowConfig.options ? clone(self.rowConfig.options) : {};
            } else {
                self.rowConfig = clone(result(self, 'rowConfig')) || {
                    singleton: false,
                    construct: Backbone.CollectionFormRowView
                };
                rowOpts = clone(result(self, 'rowOptions'));
                self.rowConfig.options = rowOpts || self.rowConfig.options || {};
                self.setRowSchema(options.rowSchema || self.rowSchema || self.rowConfig.options.schema);
            }
            self.rowConfig.location = self.rowWrapper;
            self.subs.addConfig('row', self.rowConfig);
            if (self.setupOnInit) {
                self.setupRows();
            }
        },
        /**
         * Set the schema used for each row.
         * @memberOf Backbone.CollectionFormView#
         * @param {object} [schema]
         * @return {Backbone.CollectionFormView}
         */
        setRowSchema: function (schema) {
            if (!this.rowConfig.options) { this.rowConfig.options = {}; }
            this.rowConfig.options.schema = schema || this.options.rowSchema || this.rowSchema;
            return this;
        },
        /**
         * Like Backbone.FormView.render, except that each a subView will be rendered
         * for each field in the schema and for each model in the collection.
         * Each model in the collection will have a 'row' associated with it,
         * and each row will contain each of the fields in the schema.
         * @memberOf Backbone.CollectionFormView#
         * @return {Backbone.CollectionFormView}
         */
        render: function () {
            this.subs.detachElems();
            this.$el.html(this.template(this._getTemplateVars()));
            if (!this.getRows() || !this.getRows().length) {
                this.setupRows();
            }
            this.subs.renderByKey('row', { appendTo: this.getRowWrapper() });
            return this;
        },
        /**
         * Get the wrapper element that the rows will be appended to
         * @memberOf Backbone.CollectionFormView#
         * @return {$}
         */
        getRowWrapper: function () {
            var $wrapper = this.$(this.subs.config.row.location);
            if (!$wrapper.length) {
                return this.$el;
            }
            return $wrapper.first();
        },
        /**
         * Add a row to the CollectionFormView. If you do not
         * pass a model, one will be created from the collection.model
         * property constructor. The model(s) will then be tied
         * to the new row(s).
         * @memberOf Backbone.CollectionFormView#
         * @param  {Backbone.Model} model
         *         model A model to add a row for
         * @return {Backbone.CollectionFormView}
         */
        addRow: function (model) {
            var added;
            model = model || new this.collection.model(); //eslint-disable-line new-cap
            added = this.collection.add(model);
            // Backbone 1.0.0 does not return the added models,
            // so we will not set the models var to the return val
            if (!(added instanceof Backbone.Collection)) {
                model = added;
            }
            this._addRow(model).subs.newest.render().$el
                .appendTo(this.getRowWrapper());
            return this;
        },
        /**
         * Removes a row or rows from the CollectionFormView and
         * corresponding collection.
         * @memberOf Backbone.CollectionFormView#
         * @param  {Backbone.Model|Backbone.View|Backbone.View[]|Backbone.Model[]} obj
         *         Used to find models in the collection and views in the subViewManager
         *         and remove them.
         * @return {Backbone.CollectionFormView}
         */
        deleteRow : function (obj) {
            var model = (obj instanceof Model) ? obj : null;
            var view = (!model && obj instanceof Backbone.View) ? obj : null;
            var arr = (!model && !view && isArray(obj)) ? obj : null;

            if (arr) {
                each(arr, this.deleteRow, this);
                return this;
            }

            if (!view) {
                view = this.subs.get(model);
            } else if (!model) {
                model = view.model;
            }

            this.subs.remove(view);
            this.collection.remove(model);
            return this;
        },
        /**
         * Shortcut method to remove all rows and then
         * set them up again, render them, and place
         * them in the row wrapper
         * @memberOf Backbone.CollectionFormView#
         * @return {Backbone.CollectionFormView}
         */
        reset: function () {
            this.setupRows().subs.renderByKey('row', { appendTo: this.getRowWrapper() });
            return this;
        },
        /**
         * @return {Backbone.View[]} An array of the row subviews
         */
        getRows: function () {
            return this.subs.get('row');
        },
        /**
         * When you are ready to set up your rows (ie initialize
         * each Row view instance based on the collection
         * @memberOf Backbone.CollectionFormView#
         * @return {Backbone.CollectionFormView}
         */
        setupRows: function () {
            this.subs.remove('row');
            this.collection.each(this._addRow, this);
            return this;
        },
        _addRow: function (model) {
            var opts = this._getRowOptions(model);
            var row = this.subs.create('row', opts);
            row.setSchema(this.rowSchema).setupFields();
            return this;
        },
        _getRowOptions: function (model) {
            var rows = this.subs.get('row') || [];
            return { model: model, index: rows.length };
        },
        _getTemplateVars: getTemplateVars
    });

    // Add disable/enable functionality
    extend(Backbone.CollectionFormView.prototype, formViewDisableMixin);

    // =====================================================================
    // FIELD SUBVIEWS
    // =====================================================================

    // Below are field sub views that are used for common form
    // field types (e.g. text input, radio button, dropdown list)

    // ===================================================
    // Field Template

    Backbone.formTemplates = Backbone.formTemplates || {};

    // This is shell form template used for most of the standard form fields.
    // You can easily substitute your own by doing the following after loading
    // this file: Backbone.formTemplates.Field = $('#template-id').html();
    // Note that it uses bootstrap.css classes by default.
    Backbone.formTemplates.Field =
        '<% if (obj.label) { %><label class="control-label" ' +
            '<% if (obj.inputId) { %> for="<%= obj.inputId %>" <% } %> >' +
            '<%= obj.label %></label><% } %>' +
            '<div class="<%= obj.inputWrapperClass || \'controls\' %>" data-input="">' +
            '</div>' +
            '<div class="controls">' +
            '<div class="<%= obj.errorClass || \'text-error\' %>" data-error=""></div>' +
            '<% if (obj.help) { %><span class="help-block"><%= obj.help %></span><% } %>' +
            '</div>';

    Backbone.fields = Backbone.fields || {};

    // ===================================================
    // fields.FieldView

    /**
     * The base form field type, can be used to create a basic text input/textarea
     * Form field. By default it automatically set's the value of the form field
     * on the model when the blur event occurs. Use 'Text' alias in schema
     * to create fields with this contsructor.
     *
     * @constructor Backbone.fields.FieldView
     * @extends Backbone.BaseView
     * @class Backbone.fields.FieldView
     * @property {object} [options]
     *           Options that can either be set as properties on directly on the view or
     *           passed in an object to the constructor.
     * @property {string} [options.fieldName]
     *           The attribute on the model that this field is linked to. If not provided, this
     *           will default to the schemaKey.
     * @property {boolean} [options.addId]
     *           Add an id to the input element. This is taken from the inputId property or autoGenerated
     *           based on the schemaKey of this field.
     * @property {string} [options.elementType] 'input' or 'textarea' (Defaults to 'input')
     * @property {function|string} [options.template]
     *           Underscore template function or a string template source. This gets used as the
     *           wrapper around the input/control. Your template should have an empty element
     *           that matches the selector defined in the 'inputWrapper' property. By default,
     *           this would mean defining a 'data-input' attribute
     * @property {object|function} [options.templateVars] Variables to pass to the template on render
     * @property {string} [options.inputId] The id of the field to use (if undefined, one is created automatically)
     * @property {string} [options.inputClass] The class attribute you would like to set on the field input
     * @property {object} [options.inputAttrs] Object with attributes to set on the input element
     * @property {object} [options.setOpts] Options you would like to pass when model.set is called (e.g. silent, validate)
     * @property {string} [options.placeholder] Placeholder text for the input
     * @property {array<string>} [options.updateEvents] array of event names on which to call onUserUpdate (defaults to ['blur'])
     * @property {boolean} [options.twoWay]
     *      If you would like this field to re-render the input when model is updated by something other
     *      than this view, in addition to the normal behavior of the view updating the model
     */
    FieldView = Backbone.fields.FieldView = Backbone.BaseView.extend({
        tagName: 'div',
        classDefaults: 'control-group form-field',
        inputPrefix: 'field-input-',
        fieldPrefix: 'form-field-',
        template: _.template(Backbone.formTemplates.Field),
        addId: true,
        elementType: 'input',
        inputWrapper: '[data-input]:first',
        disabledDataKey: 'formViewDisabled',
        events: function () {
            return _.chain(this._updateEvents).map(function (eventName) {
                return [eventName + ' ' + this.elementType, 'onUserUpdate'];
            }.bind(this)).object().value();
        },
        initialize: function (options) {
            options = this.options = defaults(options || {}, this.options);
            extend(this, {
                _updateEvents: options.updateEvents || defaultUpdateEvents.concat(),
                templateVars : options.templateVars || this.templateVars || {},
                fieldName : options.fieldName || this.fieldName || options.schemaKey,
                elementType : options.elementType || this.elementType,
                template : options.template || this.template,
                setOpts : defaults(options.setOpts || {}, this.setOpts),
                twoWay : !isUndefined(options.twoWay) ? options.twoWay : this.twoWay,
                inputAttrs: options.inputAttrs || this.inputAttrs,
                placeholder: options.placeholder || this.placeholder,
                inputClass: options.inputClass || this.inputClass,
                addId: !isUndefined(options.addId) ? options.addId : this.addId,
                label: !isUndefined(options.label) ? options.label : this.label,
                inputWrapper: options.inputWrapper || this.inputWrapper,
                inputId: options.inputId || this.inputId
            });
            this.inputId = this.addId ? this._getInputId() : false;
            this.template = isString(this.template) ? _.template(this.template) : this.template;
            this._defaultTemplateVars = this._defaultTemplateVars || {
                inputId : this.inputId,
                help : options.help,
                fieldName : this.fieldName,
                label : this.label
            };

            // If there is no class name specified, then we create one with the 'classDefaults' property
            // and another class based on the fieldPrefix and fieldName properties
            if (isUndefined(this.className)) {
                this.$el.addClass(this.fieldPrefix + this.fieldName);
                this.$el.addClass(this.classDefaults);
            }

            // Add data attribute to view element to indicate that it's a FormView field
            this.$el.attr('data-field', '');

            // If the twoWay option is true, then setup the events to make the field/model-attribute changes twoWay
            if (this.twoWay && this.setupTwoWay) {  this.setupTwoWay(); }
        },
        /**
         * Sets up two way updating. The view updates the model by default, and this
         * function will update the view on a model change (unless it was done by the view)
         * @memberOf Backbone.fields.FieldView#
         * @return {Backbone.fields.FieldView}
         */
        setupTwoWay: function () {
            this.listenTo(this.model, 'change:' + this.fieldName, function () {
                if (!this._viewChangedModel) { this.renderInput(); }
                this._viewChangedModel = false;
            });
            return this;
        },
        /**
         * Return an object of attributes as they should appear in the model
         * @memberOf Backbone.fields.FieldView#
         * @return {Object}
         */
        getAttrs: function () {
            var attrs = {};
            attrs[this.fieldName] = this.getValueForSet();
            return attrs;
        },
        /**
         * This method should get the value or values of the form
         * field and then set that value/values on the model
         * in the corresponding attribute(s)/field name(s). If
         * there is a setOpts object on the fieldView instance,
         * then use that as the options passed to Backbone.Model's
         * 'set' method.
         * @memberOf Backbone.fields.FieldView#
         * @return {Backbone.fields.FieldView}
         */
        setModelAttrs: function () {
            this._viewChangedModel = true;
            if (!this.model.set(this.getAttrs(), this.setOpts)) { this._viewChangedModel = false; }
            return this;
        },
        /**
         * Get the value of the form field input.
         * @memberOf Backbone.fields.FieldView
         * @memberOf Backbone.fields.FieldView#
         * @return {String|Boolean|Array|Number|Object}
         */
        getValue: function () {
            return Backbone.$.trim(this.getInputEl().val());
        },
        /**
         * Override this function if additional
         * logic needs to be performed to convert
         * the value of the input into what is
         * set on the model.
         * @memberOf Backbone.fields.FieldView#
         * @return {String|Boolean|Array|Number|Object}
         */
        getValueForSet: function () {
            return this.getValue();
        },
        /**
         * Gets the value of the field as it appears in the model
         * @memberOf Backbone.fields.FieldView#
         * @return {String|Boolean|Array|Number|Object}
         */
        getModelVal: function () {
            return this.model.get(this.fieldName);
        },
        /**
         * Gets the value from the model as it should be
         * set on the input. By default it's the same
         * as produced by getModelValue. Override this
         * function if you want to convert the model
         * value to something that should be set on the
         * input.
         * @memberOf Backbone.fields.FieldView#
         * @return {String|Boolean|Array|Number|Object}
         */
        getValueForInput: function () {
            return this.getModelVal();
        },
        /**
         * Renders the basic shell template for the form field and then
         * creates the input or textarea element, which gets appended
         * to the elem in the shell template found through the
         * {@link Backbone.fields.FieldView#getInputWrapper} method
         * @memberOf Backbone.fields.FieldView#
         * @return {Backbone.fields.FieldView}
         */
        render: function () {
            return this.renderWrapper().renderInput();
        },
        /**
         * Renders the wrapper that contains the field input
         * @param {object} [vars] Variables to pass to wrapper template
         * @memberOf Backbone.fields.FieldView#
         * @return {Backbone.fields.FieldView}
         */
        renderWrapper: function (vars) {
            this.isDisabled = null;
            this.$el.html(this.template(vars || this._getTemplateVars()));
            return this;
        },
        /**
         * Renders the field input and places it in the wrapper in
         * the element with the 'data-input' attribute
         * @memberOf Backbone.fields.FieldView#
         * @return {Backbone.fields.FieldView}
         */
        renderInput: function () {
            var $input;
            var id = this.inputId;
            var attrs =  this.addId ? { id : id, name: id } : {};
            var valForInput = this.getValueForInput();
            $input = Backbone.$('<' + this.elementType + '>');
            if (this.elementType === 'input') { attrs.type = 'text'; }
            if (this.placeholder) { attrs.placeholder = this.placeholder; }
            $input.attr(extend(attrs, this.inputAttrs));
            if (this.inputClass) { $input.attr('class', this.inputClass); }
            this.getInputWrapper().html($input);
            if (this._shouldSetValueOnInput(valForInput)) { $input.val(valForInput); }
            this.isDisabled = null;
            return this;
        },
        /**
         * Get the element that wraps the input. Looks for element
         * with data-input attribute. If not found, it will return this.$el
         * @memberOf Backbone.fields.FieldView#
         * @return {$}
         */
        getInputWrapper: function () {
            var $wrapper = this.$(this.inputWrapper);
            if (!$wrapper.length) {
                return this.$el;
            }
            return $wrapper.first();
        },
        /**
         * Get the element that takes user input.
         * @memberOf Backbone.fields.FieldView#
         * @return {$}
         */
        getInputEl: function () {
            return this.$(this.elementType);
        },
        /**
         * Disable the input if not already disabled
         * @memberOf Backbone.fields.FieldView#
         * @return {Backbone.fields.FieldView}
         */
        disable: function () {
            this.getInputEl().prop('disabled', true);
            this.isDisabled = true;
            return this;
        },
        /**
         * Enable the input if disabled by the 'disable' method
         * @memberOf Backbone.fields.FieldView#
         * @return {Backbone.fields.FieldView}
         */
        enable: function () {
            this.getInputEl().prop('disabled', false);
            this.isDisabled = false;
            return this;
        },
        /**
         * Handle updates from a user interaction
         * @memberOf Backbone.fields.FieldView#
         * @protected
         */
        onUserUpdate: function () {
            this.setModelAttrs();
        },
        /**
         * Generate the string to use for the id attribute of
         * the input element.
         * @memberOf Backbone.fields.FieldView#
         * @return {string}
         * @protected
         */
        _getInputId: function () {
            return this.inputId ||
                this.inputPrefix + this._getParentPrefix() + this.fieldName;
        },
        /**
         * Get the template vars used for the wrapper template
         * @memberOf Backbone.fields.FieldView#
         * @return {object}
         * @protected
         */
        _getTemplateVars: getTemplateVars,
        /**
         * If the parent FormView/FieldSetView defines a 'getFieldPrefix'
         * function, it can be used to construct the input id, name
         * attribute, and class attributes
         * @memberOf Backbone.fields.FieldView#
         * @return {string}
         * @private
         */
        _getParentPrefix: function () {
            if (this.parentView && this.parentView.getFieldPrefix) {
                return this.parentView.getFieldPrefix(this) || '';
            }
            return '';
        },
        /**
         * @param {string|number} valueForInput
         * @returns {boolean}
         * @memberOf Backbone.fields.FieldView#
         * @private
         */
        _shouldSetValueOnInput: function (valueForInput) {
            return !!valueForInput || valueForInput === 0;
        }
    }, {
        /**
         * Set the default template for all fields that don't override
         * the 'template' property of the Backbone.fields.FieldView
         * @memberOf Backbone.fields.FieldView
         * @param {function} template An underscore template
         * @static
         */
        setDefaultFieldTemplate: function (template) {
            FieldView.prototype.template = template;
        }
    });

    // ====================================================
    // RadioListView

    /**
     * Like Backbone.fields.FieldView, except it creates a list of radio buttons. Designed to
     * work with model fields that have only one value out of a fixed set of values. Use
     * 'RadioList' alias in form schema to create a field with this constructor.
     *
     * @augments {Backbone.fields.FieldView}
     * @constructor Backbone.fields.RadioListView
     * @class Backbone.fields.RadioListView
     * @property {object} [options]
     *           Options that can either be set as properties on directly on the view or
     *           passed in an object to the constructor.
     * @property {string} [options.fieldName] inherited from Backbone.fields.FieldView
     * @property {string} [options.templateSrc] inherited from Backbone.fields.FieldView
     * @property {function} [options.template] inherited from Backbone.fields.FieldView
     * @property {object} [options.templateVars] inherited from Backbone.fields.FieldView
     * @property {string} [options.inputId] inherited from Backbone.fields.FieldView
     * @property {string} [options.inputClass] inherited from Backbone.fields.FieldView
     * @property {boolean} [options.twoWay] inherited from Backbone.fields.FieldView
     * @property {object} [options.inputAttrs] inherited from Backbone.fields.FieldView
     * @property {object} [options.labelAttrs] Attributes for the label elements that wrap radio inputs
     * @property {object|function} [options.possibleVals]
     *      An object with the set of possible choices to display to the user. Each key will be
     *      what is set in the model when the user selects the radio, and each value is what
     *      will be used as the label text to display to the user.
     *
     */
    RadioListView = Backbone.fields.RadioListView = Backbone.fields.FieldView.extend({
        tagName: 'div',
        events : function () {
            var events = {};
            events['click ' + this.elementType] = 'onUserUpdate';
            return events;
        },
        type: 'radio-list',
        initialize: function (options) {
            options = this.options = defaults(options || {}, this.options);
            this.possibleVals = options.possibleVals || this.possibleVals || {};
            this.labelAttrs = options.labelAttrs || this.labelAttrs;
            RadioListView.__super__.initialize.call(this, options);
        },
        /**
         * Get the value of the radio list. Looks for a checked radio input
         * and gets the value attribute of that input.
         * @memberOf Backbone.fields.RadioListView#
         * @return {string}
         */
        getValue: function () {
            return this.$(this.elementType + ':checked').val();
        },
        /**
         * Returns true or false if the input should be selected.
         * @param {string} key The key of the possibleVal that is being tested
         * @return {boolean}
         */
        isSelected: function (key) {
            return (toStr(this.getValueForInput()) === toStr(key));
        },
        /**
         * Renders the radio inputs and appends them to the input wrapper.
         * @memberOf Backbone.fields.RadioListView#
         * @return {Backbone.fields.RadioListView}
         */
        renderInput: function () {
            var possibleVals = result(this, 'possibleVals');
            var key;
            var i = 0;
            var possibleVal;
            var $checkbox;
            var isSelected;
            var $inputWrapper = this.getInputWrapper().empty();

            for (key in possibleVals) {
                if (possibleVals.hasOwnProperty(key)) {
                    possibleVal = this._parsePossibleVal(possibleVals, key);
                    isSelected = this.isSelected(possibleVal.value);
                    $checkbox = this._renderInput(possibleVal, isSelected, i);
                    $inputWrapper.append($checkbox);
                    i++;
                }
            }
            return this;
        },
        _renderInput: function (possibleVal, isChecked, index) {
            var $listItem;
            var $label;
            var id = this.inputId;
            var attributes = { type: 'radio' };
            var labelAttrs = defaults(this.labelAttrs || {}, { 'class': 'radio' });
            if (this.addId) { extend(attributes, { name: id, id: (id + '-' + index) }); }
            if (isChecked) { attributes.checked = 'checked'; }
            extend(attributes, this.inputAttrs, { value: possibleVal.value });
            if (this.inputClass) { attributes.class = this.inputClass; }
            $listItem = Backbone.$('<' + this.elementType + '>').attr(attributes);
            $label = Backbone.$('<label>').attr(labelAttrs);
            $label.append($listItem).append(possibleVal.display);
            return $label;
        },
        _parsePossibleVal: function (possibleVals, key) {
            var val = possibleVals[key];
            if (val && !isUndefined(val.value) && val.display) {
                return val;
            }
            if (possibleVals.slice && isArray(possibleVals)) {
                return { value: val, display: val };
            }
            if (key && !isNaN(Number(key))) {
                key = Number(key);
            }
            return { value: key, display: val };
        }
    });

    // ====================================================
    // SelectListView

    /**
     * Like Backbone.fields.RadioListView, except that it creates a select drop down. Designed to
     * work with model fields that have one or several values out of a fixed set of values.
     * If you allow multi-select, the value will be an array. For single selects, the value
     * will be whatever the value of that one option is. Use type alias 'Select' to create
     * in the form schema to create a field with the select type.
     *
     * @constructor Backbone.fields.SelectListView
     * @augments {Backbone.fields.RadioListView}
     * @class Backbone.fields.SelectListView
     * @property {object} [options]
     *           Options that can either be set as properties on directly on the view or
     *           passed in an object to the constructor.
     * @property {string} [options.fieldName] inherited from Backbone.fields.RadioListView
     * @property {string} [options.templateSrc] inherited from Backbone.fields.RadioListView
     * @property {function} [options.template] inherited from Backbone.fields.RadioListView
     * @property {object} [options.templateVars] inherited from Backbone.fields.RadioListView
     * @property {string} [options.inputId] inherited from Backbone.fields.RadioListView
     * @property {string} [options.inputClass] inherited from Backbone.fields.RadioListView
     * @property {boolean} [options.inputAttrs] inherited from Backbone.fields.RadioListView
     * @property {object} [options.twoWay] inherited from Backbone.fields.RadioListView
     * @property {string} [options.placeholder]
     *           Placeholder text for the select. If the user selects this value, the
     *           model will be set to a blank string.
     * @property {Boolean} [options.multiple] If select should have multiple attribute or not
     * @property {object|string[]} [options.possibleVals]
     *      An object with the set of possible choices to display to the user. Each key will be
     *      what is set in the model when the user selects the option, and each value is what
     *      will be used as the label text to display to the user. You can create optgroups by
     *      making a value a nested object of with the same format. You can also just pass an
     *      array of values. These values will serve as the display value and the value that
     *      is set on the model.
     *
     */
    SelectListView = Backbone.fields.SelectListView = Backbone.fields.RadioListView.extend({
        type: 'select-list',
        elementType: 'select',
        events : function () {
            var events = {};
            events['change ' + this.elementType] = 'onUserUpdate';
            return events;
        },
        initialize: function (options) {
            options = this.options = defaults(options || {}, this.options);
            this.multiple = !isUndefined(options.multiple) ? options.multiple : this.multiple;
            SelectListView.__super__.initialize.call(this, options);
        },
        getValue: function () {
            return this.getInputEl().val();
        },
        /**
         * Returns true or false if the option should be selected
         * @memberOf Backbone.fields.SelectListView#
         * @param {string} key The key of the possibleVal that is being tested
         * @return {boolean}
         */
        isSelected: function (key) {
            var modelVal = this.getModelVal();
            modelVal = this.multiple ? modelVal : [modelVal];
            return (_.indexOf(_.map(modelVal, toStr), toStr(key)) > -1);
        },
        /**
         * Renders the select element and the options
         * @memberOf Backbone.fields.SelectListView#
         * @return {Backbone.fields.SelectListView}
         */
        renderInput: function () {
            var possibleVals = result(this, 'possibleVals');
            var id = this.inputId;
            var $select = Backbone.$('<' + this.elementType + '>')
                    .attr(extend((this.addId ? { id: id, name: id } : {}), this.inputAttrs));

            this.getInputWrapper().html($select);
            if (this.multiple) { $select.attr('multiple', 'multiple'); }
            if (this.inputClass) { $select.addClass(this.inputClass); }
            if (this.placeholder) {
                $select.append('<option value="">' + this.placeholder + '</option>');
            }
            return this._renderInput($select, possibleVals);
        },
        _renderInput: function ($wrapper, vals) {
            var key;
            var val;
            var $optgroup;
            var $option;
            for (key in vals) {
                if (vals.hasOwnProperty(key)) {
                    val = this._parsePossibleVal(vals, key);
                    if (val.group) {
                        $optgroup = Backbone.$('<optgroup label="' + key + '"></optgroup>').appendTo($wrapper);
                        this._renderInput($optgroup, val.group);
                    } else {
                        $option = Backbone.$('<option>').text(val.display).attr('value', val.value);
                        if (this.isSelected(val.value)) {
                            $option.prop('selected', true);
                        }
                        $option.appendTo($wrapper);
                    }
                }
            }
            return this;
        },
        _parsePossibleVal: function (possibleVals, key) {
            var val = possibleVals[key];
            if (val && val.group && val.display) {
                return val;
            }
            if (_.isObject(val) && !isArray(possibleVals)) {
                return { group: val, display: key };
            }
            return SelectListView.__super__._parsePossibleVal.call(this, possibleVals, key);
        }
    });


    // ====================================================
    // CheckListView

    /**
     * Like Backbone.fields.SelectListView, but instead of a select, it's a list of checkboxes.
     * Additionally, instead of setting one value on the model, each checkbox represents
     * one attribute on the model assigned to it. Each of these attributes should expect
     * a boolean or one of a set of 2 possible values. You can set what these values
     * are using the 'checkedVal' and 'unCheckedVal' options. Use the 'CheckList' alias
     * in your schema to create these views.
     * @constructor Backbone.fields.CheckListView
     * @augments {Backbone.fields.FieldView}
     * @class Backbone.fields.CheckListView
     * @property {object} [options]
     *           Options that can either be set as properties on directly on the view or
     *           passed in an object to the constructor.
     * @property {string} [options.fieldName] inherited from Backbone.fields.FieldView
     * @property {string} [options.templateSrc] inherited from Backbone.fields.FieldView
     * @property {function} [options.template] inherited from Backbone.fields.FieldView
     * @property {object} [options.templateVars] inherited from Backbone.fields.FieldView
     * @property {string} [options.inputId] inherited from Backbone.fields.FieldView
     * @property {string} [options.inputClass] inherited from Backbone.fields.FieldView
     * @property {boolean} [options.twoWay] inherited from Backbone.fields.FieldView
     * @property {object} [options.inputAttrs] inherited from Backbone.fields.FieldView
     * @property {object} [options.labelAttrs] inherited from Backbone.fields.RadioListView
     * @property {object|function} [options.possibleVals]
     *      An object with the set of possible choices to display to the user. Unlike the other
     *      list views, the key should be what field the choice corresponds to on the model.
     * @property [options.checkedVal] - the value to set on the model when a checkbox is checked
     * @property [options.unCheckedVal] - the value to set on the model when a checkbox is unchecked
     */
    CheckListView = Backbone.fields.CheckListView = Backbone.fields.RadioListView.extend({
        tagName: 'div',
        type: 'check-list',
        checkedVal: true,
        unCheckedVal: false,
        initialize: function (options) {
            options = this.options = defaults(options || {}, this.options);
            this.checkedVal = !isUndefined(options.checkedVal) ? options.checkedVal : this.checkedVal;
            this.unCheckedVal = !isUndefined(options.unCheckedVal) ? options.unCheckedVal : this.unCheckedVal;
            CheckListView.__super__.initialize.call(this, options);
        },
        setupTwoWay: function () {
            var possibleVals = result(this, 'possibleVals');
            each(possibleVals, function (val, key) {
                var possibleVal = this._parsePossibleVal(possibleVals, key);
                this.listenTo(this.model, 'change:' + possibleVal.value, function () {
                    if (!this._viewChangedModel) { this.renderInput(); }
                    this._viewChangedModel = false;
                });
            }, this);
        },
        getAttrs: function () {
            var attrs = {};
            var self = this;
            this.getInputEl().each(function (index, input) {
                var $input = Backbone.$(input);
                var key = $input.val();
                var val = ($input.prop('checked')) ? self.checkedVal : self.unCheckedVal;
                if (val === self.checkedVal || self.isSelected(key)) {
                    attrs[key] = val;
                }
            });
            return attrs;
        },
        /**
         * Return the model value for a particular
         * possibleVals key.
         * @param  {string} key
         * @return {*}
         */
        getModelVal: function (key) {
            return this.model.get(key);
        },
        /**
         * Renders and returns a single checkbox in a CheckList
         * @memberOf Backbone.fields.CheckListView#
         * @param {string} possibleVal the key from possibleVals
         * @param {boolean} isChecked if the box should be checked or not
         * @param {number} index the index of the checkbox
         * @return {$}
         */
        renderSingleCheckbox: function (possibleVal, isChecked, index) {
            var $listItem;
            var $label;
            var id = this.inputId;
            var attributes = { type: 'checkbox', value: possibleVal.value};

            if (this.addId) { extend(attributes, { name: id, id: (id + '-' + index) }); }
            attributes = extend(attributes, this.inputAttrs);
            if (this.inputClass) { attributes.class = this.inputClass; }
            if (isChecked) { attributes.checked = 'checked'; }
            $listItem = Backbone.$('<input>').attr(attributes);
            $label = Backbone.$('<label>').attr(defaults(this.labelAttrs || {}, { 'class': 'checkbox' }));
            return $label.append($listItem).append(possibleVal.display);
        },
        /**
         * Returns true or false if the checkbox should be selected.
         * @memberOf Backbone.fields.CheckListView#
         * @param {string} key the key of the possibleVal that is being tested
         * @return {boolean}
         */
        isSelected: function (key) {
            return this.getModelVal(key) === this.checkedVal;
        },
        renderInput: function () {
            var key;
            var possibleVals = result(this, 'possibleVals');
            var possibleVal;
            var $checkbox;
            var isSelected;
            var i = 0;
            var $inputWrapper = this.getInputWrapper().empty();

            for (key in possibleVals) {
                if (possibleVals.hasOwnProperty(key)) {
                    possibleVal = this._parsePossibleVal(possibleVals, key);
                    isSelected = this.isSelected(possibleVal.value);
                    $checkbox = this.renderSingleCheckbox(possibleVal, isSelected, i);
                    $inputWrapper.append($checkbox);
                    i++;
                }
            }
            return this;
        }
    });

    // ====================================================
    // CheckBoxView

    /**
     * Creates a single checkbox that corresponds to one attribute in the model
     * @constructor Backbone.fields.CheckBoxView
     * @class Backbone.fields.CheckBoxView
     * @augments {Backbone.fields.FieldView}
     * @property {object} [options]
     *           Options that can either be set as properties on directly on the view or
     *           passed in an object to the constructor.
     * @property {string} [options.fieldName] inherited from Backbone.fields.FieldView
     * @property {string} [options.templateSrc] inherited from Backbone.fields.FieldView
     * @property {function} [options.template] inherited from Backbone.fields.FieldView
     * @property {object} [options.templateVars] inherited from Backbone.fields.FieldView
     * @property {string} [options.inputId] inherited from Backbone.fields.FieldView
     * @property {string} [options.inputClass] inherited from Backbone.fields.FieldView
     * @property {boolean} [options.twoWay] inherited from Backbone.fields.FieldView
     * @property {object} [options.addId] inherited from Backbone.fields.FieldView
     * @property {object} [options.labelAttrs] inherited from Backbone.fields.RadioListView
     * @property {string} [options.displayText]
     *           Templates can have a label and/or display text for checkboxes. Display text is
     *           intended for longer desciptions of the textbox's purpose.
     * @property [options.checkedVal] - the value to set on the model when a checkbox is checked
     * @property [options.unCheckedVal] - the value to set on the model when a checkbox is unchecked
     */
    CheckBoxView = Backbone.fields.CheckBoxView = Backbone.fields.FieldView.extend({
        checkedVal: true,
        unCheckedVal: false,
        events: function () {
            var events = {};
            events['click ' + this.elementType] = 'onUserUpdate';
            return events;
        },
        initialize: function (options) {
            options = this.options = defaults(options || {}, this.options);
            this.checkedVal = !isUndefined(options.checkedVal) ? options.checkedVal : this.checkedVal;
            this.unCheckedVal = !isUndefined(options.unCheckedVal) ? options.unCheckedVal : this.unCheckedVal;
            this.displayText = options.displayText || this.displayText;
            this.labelAttrs = options.labelAttrs || this.labelAttrs;
            CheckBoxView.__super__.initialize.call(this, options);
        },
        getValue: function () {
            return this.getInputEl().prop('checked');
        },
        getValueForSet: function () {
            if (this.getValue()) {
                return this.checkedVal;
            }
            return this.unCheckedVal;
        },
        /**
         * Returns true or false if the checkbox should be selected
         * @memberOf Backbone.fields.CheckBoxView#
         * @return {boolean}
         */
        isSelected: function () {
            return this.getModelVal() === this.checkedVal;
        },
        renderInput: function () {
            var $label = Backbone.$('<label>').attr(defaults(this.labelAttrs || {}, { 'class': 'checkbox' }));
            var $input = Backbone.$('<' + this.elementType + '>');
            var attributes = { type: 'checkbox' };
            var id = this.inputId;

            if (this.addId) { extend(attributes, { id: id, name: id, value: this.checkedVal }); }
            extend(attributes, this.inputAttrs);
            if (this.inputClass) { attributes.class = this.inputClass; }
            $input.attr(attributes);
            if (this.isSelected()) {
                $input.prop('checked', true);
            }
            $label.append($input);
            if (this.displayText) {
                $label.append(this.displayText);
            }
            this.getInputWrapper().html($label);

            return this;
        }
    });

    // ====================================================
    // FieldSetView

    /**
     * Essentially a subform, an extension of {@link Backbone.FormView}
     * but simply uses a 'fieldset' tag instead. Can be used an a FormView's
     * schema to group fields. FieldSets also default to setup their
     * fields on initialization so that that the top level FormView only
     * has to call setupFields once.
     * @constructor Backbone.FieldSetView
     * @extends {Backbone.FormView}
     * @class Backbone.FieldSetView
     * @property {Object} [options]
     *     Options that you can pass to init or add as properties on extended view
     * @property {String} [options.templateSrc] Inherited from Backbone.FormView
     * @property {String} [options.template] Inherited from Backbone.FormView
     * @property {Object} [options.schema] Inherited from Backbone.FormView
     * @property {Boolean} [options.setupOnInit] Inherited from Backbone.FormView
     * @property {String[]} [options.fieldOrder] Inherited from Backbone.FormView
     * @property {Object} [options.templateVars] Inherited from Backbone.FormView
     * @property {Boolean} [options.autoUpdateModel] Inherited from Backbone.FormView
     * @property {Boolean} [options.twoWay] Inherited from Backbone.FormView
     */
    FieldSetView = Backbone.FieldSetView = Backbone.FormView.extend({
        tagName: 'div',
        setupOnInit: true,
        className: '',
        initialize: function (options) {
            options = this.options = defaults(options || {}, this.options);
            this.fieldSetName = options.fieldSetName || this.fieldSetName || options.schemaKey;
            FieldSetView.__super__.initialize.call(this, options);
            this.$el.addClass(this.className || ('fieldset fieldset-' + this.fieldSetName));
        },
        /**
         * Returns a prefix that the fieldset fields can use to create
         * their unique names and ids
         * @memberOf Backbone.FieldSetView#
         * @return {string}
         */
        getFieldPrefix: getFieldPrefix,
        template: _.template('<% if(obj && obj.label) { %><label class="fieldset-label">' +
            '<strong><%= obj.label %></strong></label><% } %><fieldset data-fields=""></fieldset>')
    });

    /**
     * Like a FieldSet view, except that it's linked to a collection and will add subviews for
     * each model in the collection based on the 'schema' option provided
     * @constructor Backbone.CollectionFieldSetView
     * @extends {Backbone.CollectionFormView}
     * @class Backbone.CollectionFieldSetView
     */
    CollectionFieldSetView = Backbone.CollectionFieldSetView = Backbone.CollectionFormView.extend({
        tagName: 'div',
        template: _.template('<% if(obj && obj.label) { %><p><strong><%= obj.label %></strong></p><% } %>' +
            '<fieldset class="fieldset" data-rows=""></fieldset>'),
        setupOnInit: true,
        className: '',
        initialize: function (options) {
            options = this.options = defaults(options || {}, this.options);
            this.fieldSetName = options.fieldSetName || this.fieldSetName || options.schemaKey;
            CollectionFieldSetView.__super__.initialize.call(this, options);
            this.$el.addClass(this.className || ('fieldset fieldset-' + this.fieldSetName));
            return this;
        },
        /**
         * Returns a prefix that the fieldset fields can use to create
         * their unique names and ids
         * @memberOf Backbone.CollectionFieldSetView#
         * @return {string}
         */
        getFieldPrefix: getFieldPrefix
    });

}(this));


/***/ }),
/* 2614 */
/***/ (function(module, exports, __webpack_require__) {

//     Backbone.js 1.0.0

//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(){

  // Initial Setup
  // -------------

  // Save a reference to the global object (`window` in the browser, `exports`
  // on the server).
  var root = this;

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create local references to array methods we'll want to use later.
  var array = [];
  var push = array.push;
  var slice = array.slice;
  var splice = array.splice;

  // The top-level namespace. All public Backbone classes and modules will
  // be attached to this. Exported for both the browser and the server.
  var Backbone;
  if (true) {
    Backbone = exports;
  } else {
    Backbone = root.Backbone = {};
  }

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.0.0';

  // Require Underscore, if we're on the server, and it's not already present.
  var _ = root._;
  if (!_ && ("function" !== 'undefined')) _ = __webpack_require__(2615);

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = root.jQuery || root.Zepto || root.ender || root.$;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // custom events. You may bind with `on` or remove with `off` callback
  // functions to an event; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({callback: callback, context: context, ctx: context || this});
      return this;
    },

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function() {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = {};
        return this;
      }

      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
                  (context && context !== ev.context)) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }

      return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
      var listeners = this._listeners;
      if (!listeners) return this;
      var deleteListener = !name && !callback;
      if (typeof name === 'object') callback = this;
      if (obj) (listeners = {})[obj._listenerId] = obj;
      for (var id in listeners) {
        listeners[id].off(name, callback, this);
        if (deleteListener) delete this._listeners[id];
      }
      return this;
    }

  };

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (typeof name === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }

    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
    }
  };

  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  _.each(listenMethods, function(implementation, method) {
    Events[method] = function(obj, name, callback) {
      var listeners = this._listeners || (this._listeners = {});
      var id = obj._listenerId || (obj._listenerId = _.uniqueId('l'));
      listeners[id] = obj;
      if (typeof name === 'object') callback = this;
      obj[implementation](name, callback, this);
      return this;
    };
  });

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var defaults;
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId('c');
    this.attributes = {};
    _.extend(this, _.pick(options, modelOptions));
    if (options.parse) attrs = this.parse(attrs, options) || {};
    if (defaults = _.result(this, 'defaults')) {
      attrs = _.defaults({}, attrs, defaults);
    }
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // A list of options to be attached directly to the model, if provided.
  var modelOptions = ['url', 'urlRoot', 'collection'];

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      var attr, attrs, unset, changes, silent, changing, prev, current;
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      unset           = options.unset;
      silent          = options.silent;
      changes         = [];
      changing        = this._changing;
      this._changing  = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }
      current = this.attributes, prev = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

      // For each `set` attribute, update or delete the current value.
      for (attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          this.changed[attr] = val;
        } else {
          delete this.changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = true;
        for (var i = 0, l = changes.length; i < l; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var val, changed = false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      for (var attr in diff) {
        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
        (changed || (changed = {}))[attr] = val;
      }
      return changed;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server. If the server's representation of the
    // model differs from its current attributes, they will be overridden,
    // triggering a `"change"` event.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        if (!model.set(model.parse(resp, options), options)) return false;
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      var attrs, method, xhr, attributes = this.attributes;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      // If we're not waiting and attributes exist, save acts as `set(attr).save(null, opts)`.
      if (attrs && (!options || !options.wait) && !this.set(attrs, options)) return false;

      options = _.extend({validate: true}, options);

      // Do not persist invalid models.
      if (!this._validate(attrs, options)) return false;

      // Set temporary attributes if `{wait: true}`.
      if (attrs && options.wait) {
        this.attributes = _.extend({}, attributes, attrs);
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = model.parse(resp, options);
        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
          return false;
        }
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch') options.attrs = attrs;
      xhr = this.sync(method, this, options);

      // Restore attributes.
      if (attrs && options.wait) this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;

      var destroy = function() {
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (options.wait || model.isNew()) destroy();
        if (success) success(model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      if (this.isNew()) {
        options.success();
        return false;
      }
      wrapError(this, options);

      var xhr = this.sync('delete', this, options);
      if (!options.wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base = _.result(this, 'urlRoot') || _.result(this.collection, 'url') || urlError();
      if (this.isNew()) return base;
      return base + (base.charAt(base.length - 1) === '/' ? '' : '/') + encodeURIComponent(this.id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return this.id == null;
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend(options || {}, { validate: true }));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options || {}, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model.
  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  _.each(modelMethods, function(method) {
    Model.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.attributes);
      return _[method].apply(_, args);
    };
  });

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analagous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.url) this.url = options.url;
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, merge: false, remove: false};

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model){ return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set.
    add: function(models, options) {
      return this.set(models, _.defaults(options || {}, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      models = _.isArray(models) ? models.slice() : [models];
      options || (options = {});
      var i, l, index, model;
      for (i = 0, l = models.length; i < l; i++) {
        model = this.get(models[i]);
        if (!model) continue;
        delete this._byId[model.id];
        delete this._byId[model.cid];
        index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;
        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }
        this._removeReference(model);
      }
      return this;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      options = _.defaults(options || {}, setOptions);
      if (options.parse) models = this.parse(models, options);
      if (!_.isArray(models)) models = models ? [models] : [];
      var i, l, model, attrs, existing, sort;
      var at = options.at;
      var sortable = this.comparator && (at == null) && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
      var toAdd = [], toRemove = [], modelMap = {};

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      for (i = 0, l = models.length; i < l; i++) {
        if (!(model = this._prepareModel(models[i], options))) continue;

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        if (existing = this.get(model)) {
          if (options.remove) modelMap[existing.cid] = true;
          if (options.merge) {
            existing.set(model.attributes, options);
            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
          }

        // This is a new model, push it to the `toAdd` list.
        } else if (options.add) {
          toAdd.push(model);

          // Listen to added models' events, and index models for lookup by
          // `id` and by `cid`.
          model.on('all', this._onModelEvent, this);
          this._byId[model.cid] = model;
          if (model.id != null) this._byId[model.id] = model;
        }
      }

      // Remove nonexistent models if appropriate.
      if (options.remove) {
        for (i = 0, l = this.length; i < l; ++i) {
          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
        }
        if (toRemove.length) this.remove(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      if (toAdd.length) {
        if (sortable) sort = true;
        this.length += toAdd.length;
        if (at != null) {
          splice.apply(this.models, [at, 0].concat(toAdd));
        } else {
          push.apply(this.models, toAdd);
        }
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      if (options.silent) return this;

      // Trigger `add` events.
      for (i = 0, l = toAdd.length; i < l; i++) {
        (model = toAdd[i]).trigger('add', model, this, options);
      }

      // Trigger `sort` if the collection was sorted.
      if (sort) this.trigger('sort', this, options);
      return this;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options || (options = {});
      for (var i = 0, l = this.models.length; i < l; i++) {
        this._removeReference(this.models[i]);
      }
      options.previousModels = this.models;
      this._reset();
      this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return this;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      model = this._prepareModel(model, options);
      this.add(model, _.extend({at: this.length}, options));
      return model;
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      this.remove(model, options);
      return model;
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      model = this._prepareModel(model, options);
      this.add(model, _.extend({at: 0}, options));
      return model;
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      this.remove(model, options);
      return model;
    },

    // Slice out a sub-array of models from the collection.
    slice: function(begin, end) {
      return this.models.slice(begin, end);
    },

    // Get a model from the set by id.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj.id != null ? obj.id : obj.cid || obj];
    },

    // Get the model at the given index.
    at: function(index) {
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      if (_.isEmpty(attrs)) return first ? void 0 : [];
      return this[first ? 'find' : 'filter'](function(model) {
        for (var key in attrs) {
          if (attrs[key] !== model.get(key)) return false;
        }
        return true;
      });
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      // Run sort based on type of `comparator`.
      if (_.isString(this.comparator) || this.comparator.length === 1) {
        this.models = this.sortBy(this.comparator, this);
      } else {
        this.models.sort(_.bind(this.comparator, this));
      }

      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Figure out the smallest index at which a model should be inserted so as
    // to maintain order.
    sortedIndex: function(model, value, context) {
      value || (value = this.comparator);
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _.sortedIndex(this.models, model, iterator, context);
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return _.invoke(this.models, 'get', attr);
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success(collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      if (!(model = this._prepareModel(model, options))) return false;
      if (!options.wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(resp) {
        if (options.wait) collection.add(model, options);
        if (success) success(model, resp, options);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models);
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (attrs instanceof Model) {
        if (!attrs.collection) attrs.collection = this;
        return attrs;
      }
      options || (options = {});
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model._validate(attrs, options)) {
        this.trigger('invalid', this, attrs, options);
        return false;
      }
      return model;
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model) {
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if ((event === 'add' || event === 'remove') && collection !== this) return;
      if (event === 'destroy') this.remove(model, options);
      if (model && event === 'change:' + model.idAttribute) {
        delete this._byId[model.previous(model.idAttribute)];
        if (model.id != null) this._byId[model.id] = model;
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
    'tail', 'drop', 'last', 'without', 'indexOf', 'shuffle', 'lastIndexOf',
    'isEmpty', 'chain'];

  // Mix in each Underscore method as a proxy to `Collection#models`.
  _.each(methods, function(method) {
    Collection.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.models);
      return _[method].apply(_, args);
    };
  });

  // Underscore methods that take a property name as an argument.
  var attributeMethods = ['groupBy', 'countBy', 'sortBy'];

  // Use attributes instead of properties.
  _.each(attributeMethods, function(method) {
    Collection.prototype[method] = function(value, context) {
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _[method](this.models, iterator, context);
    };
  });

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    this._configure(options || {});
    this._ensureElement();
    this.initialize.apply(this, arguments);
    this.delegateEvents();
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be merged as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be prefered to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this.$el.remove();
      this.stopListening();
      return this;
    },

    // Change the view's element (`this.el` property), including event
    // re-delegation.
    setElement: function(element, delegate) {
      if (this.$el) this.undelegateEvents();
      this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
      this.el = this.$el[0];
      if (delegate !== false) this.delegateEvents();
      return this;
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save'
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    // This only works for delegate-able events: not `focus`, `blur`, and
    // not `change`, `submit`, and `reset` in Internet Explorer.
    delegateEvents: function(events) {
      if (!(events || (events = _.result(this, 'events')))) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[events[key]];
        if (!method) continue;

        var match = key.match(delegateEventSplitter);
        var eventName = match[1], selector = match[2];
        method = _.bind(method, this);
        eventName += '.delegateEvents' + this.cid;
        if (selector === '') {
          this.$el.on(eventName, method);
        } else {
          this.$el.on(eventName, selector, method);
        }
      }
      return this;
    },

    // Clears all callbacks previously bound to the view with `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // Performs the initial configuration of a View with a set of options.
    // Keys with special meaning *(e.g. model, collection, id, className)* are
    // attached directly to the view.  See `viewOptions` for an exhaustive
    // list.
    _configure: function(options) {
      if (this.options) options = _.extend({}, _.result(this, 'options'), options);
      _.extend(this, _.pick(options, viewOptions));
      this.options = options;
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        var $el = Backbone.$('<' + _.result(this, 'tagName') + '>').attr(attrs);
        this.setElement($el, false);
      } else {
        this.setElement(_.result(this, 'el'), false);
      }
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // If we're sending a `PATCH` request, and we're in an old Internet Explorer
    // that still has ActiveX enabled by default, override jQuery to use that
    // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
    if (params.type === 'PATCH' && window.ActiveXObject &&
          !(window.external && window.external.msActiveXFilteringEnabled)) {
      params.xhr = function() {
        return new ActiveXObject("Microsoft.XMLHTTP");
      };
    }

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch':  'PATCH',
    'delete': 'DELETE',
    'read':   'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        callback && callback.apply(router, args);
        router.trigger.apply(router, ['route:' + name].concat(args));
        router.trigger('route', name, args);
        Backbone.history.trigger('route', router, name, args);
      });
      return this;
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional){
                     return optional ? match : '([^\/]+)';
                   })
                   .replace(splatParam, '(.*?)');
      return new RegExp('^' + route + '$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param) {
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    _.bindAll(this, 'checkUrl');

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for detecting MSIE.
  var isExplorer = /msie [\w.]+/;

  // Cached regex for removing a trailing slash.
  var trailingSlash = /\/$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the cross-browser normalized URL fragment, either from the URL,
    // the hash, or the override.
    getFragment: function(fragment, forcePushState) {
      if (fragment == null) {
        if (this._hasPushState || !this._wantsHashChange || forcePushState) {
          fragment = this.location.pathname;
          var root = this.root.replace(trailingSlash, '');
          if (!fragment.indexOf(root)) fragment = fragment.substr(root.length);
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error("Backbone.history has already been started");
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({}, {root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.options.pushState && this.history && this.history.pushState);
      var fragment          = this.getFragment();
      var docMode           = document.documentMode;
      var oldIE             = (isExplorer.exec(navigator.userAgent.toLowerCase()) && (!docMode || docMode <= 7));

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      if (oldIE && this._wantsHashChange) {
        this.iframe = Backbone.$('<iframe src="javascript:0" tabindex="-1" />').hide().appendTo('body')[0].contentWindow;
        this.navigate(fragment);
      }

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._hasPushState) {
        Backbone.$(window).on('popstate', this.checkUrl);
      } else if (this._wantsHashChange && ('onhashchange' in window) && !oldIE) {
        Backbone.$(window).on('hashchange', this.checkUrl);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      // Determine if we need to change the base url, for a pushState link
      // opened by a non-pushState browser.
      this.fragment = fragment;
      var loc = this.location;
      var atRoot = loc.pathname.replace(/[^\/]$/, '$&/') === this.root;

      // If we've started off with a route from a `pushState`-enabled browser,
      // but we're currently in a browser that doesn't support it...
      if (this._wantsHashChange && this._wantsPushState && !this._hasPushState && !atRoot) {
        this.fragment = this.getFragment(null, true);
        this.location.replace(this.root + this.location.search + '#' + this.fragment);
        // Return immediately as browser will do redirect to new url
        return true;

      // Or if we've started out with a hash-based route, but we're currently
      // in a browser where it could be `pushState`-based instead...
      } else if (this._wantsPushState && this._hasPushState && atRoot && loc.hash) {
        this.fragment = this.getHash().replace(routeStripper, '');
        this.history.replaceState({}, document.title, this.root + this.fragment + loc.search);
      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      Backbone.$(window).off('popstate', this.checkUrl).off('hashchange', this.checkUrl);
      clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();
      if (current === this.fragment && this.iframe) {
        current = this.getFragment(this.getHash(this.iframe));
      }
      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl() || this.loadUrl(this.getHash());
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragmentOverride) {
      var fragment = this.fragment = this.getFragment(fragmentOverride);
      var matched = _.any(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
      return matched;
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: options};
      fragment = this.getFragment(fragment || '');
      if (this.fragment === fragment) return;
      this.fragment = fragment;
      var url = this.root + fragment;

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._hasPushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if(!options.replace) this.iframe.document.open().close();
          this._updateHash(this.iframe.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain, for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function (model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error(model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

}).call(this);


/***/ }),
/* 2615 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),
/* 2616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by stavmeidan on 3/24/16.
 */



var endpoints = __webpack_require__(6);
var FeeStructure = __webpack_require__(2047);
var SoaCollection = __webpack_require__(9);

module.exports = SoaCollection.extend({
    url: endpoints.feeStructures,
    model: FeeStructure,

    /**
     * gets rate card type
     * @returns {String} - either "TIERED" or "FLAT"
     */
    getRateType: function () {
        var first = this.first();
        return first && first.get('rateType'); // will always be first element in list
    }
});


/***/ }),
/* 2617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: liliana
 * Date: 3/26/15
 * Time: 10:13 AM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */



var SoaCollection            = __webpack_require__(9);

/**
 * Collection for getting converted Financial Amounts
 **/
var FinancialAmountsConvert  = module.exports = SoaCollection.extend();

var _                        = __webpack_require__(0);
var FinancialAmount          = __webpack_require__(10);
var endpoints                = __webpack_require__(6);

_.extend(FinancialAmountsConvert.prototype, {
    model : FinancialAmount,

    // Use Backbone.sync('create' ...) to POST models and get converted currencies
    url : endpoints.currencyConvert()
});


/***/ }),
/* 2618 */,
/* 2619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: liliana
 * Date: 3/20/15
 * Time: 6:24 PM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */



var SoaCollection        = __webpack_require__(9);

/**
 * @class FavoriteParameters
 * @extends SoaCollection
 * @constructs FavoriteParameters object
 * @constructor
 */
var FavoriteParameters   = module.exports = SoaCollection.extend();

var _                    = __webpack_require__(0);
var FavoriteParameter    = __webpack_require__(1376);

_.extend(FavoriteParameters.prototype, {
    model : FavoriteParameter,

    /**
     * @param {string} key
     * @returns {FavoriteParameter}
     */
    getParamByKey : function (key) {
        return this.findWhere({ key : key });
    },

    /**
     * @param {string} key
     * @returns {string|null}
     */
    getParamDisplayValueByKey : function (key) {
        var param = this.getParamByKey(key);
        return param ? param.getDisplayValue() : null;
    }
});



/***/ }),
/* 2620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SoaCollection = __webpack_require__(9);
var Seller = __webpack_require__(105);
var fetchDiscrete = __webpack_require__(2042);
var Sellers = module.exports = SoaCollection.extend({}, fetchDiscrete);
var endpoints = __webpack_require__(6);
var _ = __webpack_require__(0);
var $ = __webpack_require__(5);

_.extend(Sellers.prototype, {
    model: Seller,
    url: function () {
        var ret = _.result(endpoints, 'sellers');
        if (this._discreteIds) {
            ret += "?" + $.param(_.extend({sellerId: this._discreteIds.join(',')}));
        }
        return ret;
    },
    parseQuery: function (query) {
        var matches = "string" === typeof query ? query.match(/^(([a-z]_[0-9]+(\s*,\s*[a-z]_[0-9]+)*)|(.+@.+)|(.*))$/i) : [];
        return {
            sellerId: matches[2] && (matches[2].toLowerCase()).split(/\s*,\s*/).join(","),
            email: matches[4],
            company: matches[5]
        };
    }
});


/***/ }),
/* 2621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 7/15/14
 * Time: 3:37 PM
 */



var SoaCollection = __webpack_require__(9);
var TradeAssociations = module.exports = SoaCollection.extend();
var TradeAssociation = __webpack_require__(2051);
var endpoints = __webpack_require__(6);
var _ = __webpack_require__(0);

_.extend(TradeAssociations.prototype, {
    model: TradeAssociation,
    url: function () {
        return endpoints.tradeAssociations();
    },
    getAssociationByName: function (name) {
        return this.findWhere({ name: name });
    },
    isAssociationMember: function (name) {
        return !!this.getAssociationByName(name);
    },
    isNYDC: function () {
        return this.isAssociationMember(TradeAssociation.NAMES.NYDC);
    },
    isVerticalRestrictedAssociation: function (fn, association) {
        var seller = this.parents[0];
        if (!seller) {
            return null;
        }
        return seller[fn]() && this.isAssociationMember(association);
    },
    isAntiquesAssociationMember: function () {
        return this.isVerticalRestrictedAssociation('isFurnitureSeller', TradeAssociation.NAMES.AADLA);
    },
    is20thCenturySpecialist: function () {
        return this.isVerticalRestrictedAssociation('isFurnitureSeller', TradeAssociation.NAMES.TWCS);
    },
    isArtDealersAssociationMember: function () {
        return this.isVerticalRestrictedAssociation('isArtSeller', TradeAssociation.NAMES.ADAA);
    },
    isAIPADMember: function () {
        return this.isVerticalRestrictedAssociation('isArtSeller', TradeAssociation.NAMES.AIPAD);
    },
    getAntiquesAssociationLeague: function () {
        return this.filter(function (association) {
            return association.isAntiquesAssociationLeague();
        }).map(function (model) {
            return model.toJSON();
        });
    },
    save: function () {
        return this.sync('create', this, {
            url: endpoints.sellerTradeAssociations(this.parents[0].id)
        });
    }
});


/***/ }),
/* 2622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var _               = __webpack_require__(0);
var ItemAttributes  = __webpack_require__(1015);
var ItemAttribute   = __webpack_require__(1219);
var Attributes      = __webpack_require__(1618);

/**
 * @class ItemAttributesPeriod
 * @extends ItemAttributes
 */
var ItemAttributesPeriod = module.exports = ItemAttributes.extend();

//TODO Remove this logic from FE once BE has the ability to map certain attribute values to other attributes
var valid21stCenturyLabels = [
    '21st-century-and-contemporary', //21st Century
    'early-2000s', //2000-2009
    '2010s'  //2010-
];

_.extend(ItemAttributesPeriod.prototype, {

    /**
     * Returns true if this attribute is part of the 21st century group
     * Note:    Since attribute value IDs aren't constant, we're using the urlLabel (also not constant, but apparently more
     *          constant than the ID) find the appropriate id.
     *
     * @param  {Attributes} periods A collection containing groups of attribute period values to be used for reference
     * @return {Boolean}            True if this attribute is 21st century
     */
    is21stCentury: function (periods) {
        // this is used in validations, so if we have some attribute values passed from the validator then use them, otherwise create from server vars
        var attrCollection = (periods && new Attributes(periods)) || Attributes.getCollectionForKey(ItemAttribute.ATTRIBUTE_PERIOD);
        var attrs = attrCollection.getItemAttributesCollection({
            comparator: 'option.id'
        });
        var valid21stCenturyIds = attrs
            .filter(function (attr) {
                return _.contains(valid21stCenturyLabels, attr.get('option.urlLabel'));
            })
            .map(function (attr) {
                return attr.get('option.id');
            });

        var periodId = this.at(0) && this.at(0).get('option.id');
        return _.contains(valid21stCenturyIds, parseInt(periodId, 10));
    }
});


/***/ }),
/* 2623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var _               = __webpack_require__(0);
var ItemAttributes  = __webpack_require__(1015);
var ItemAttribute   = __webpack_require__(1219);
var Attributes      = __webpack_require__(1618);

/**
 * @class ItemAttributesProductionType
 * @extends ItemAttributes
 */
var ItemAttributesProductionType = module.exports = ItemAttributes.extend();

//TODO Remove this logic from FE once BE has the ability to map certain attribute values to other attributes
var LIMITED_EDITION_LABEL = 'limited-edition';

_.extend(ItemAttributesProductionType.prototype, {

    /**
     * Returns true if this attribute is the limited edition one
     * Note:    Since attribute value IDs aren't constant, we're using the urlLabel (also not constant, but apparently more
     *          constant than the ID) find the appropriate id.
     *
     * @param  {Attributes} periods A collection containing groups of attribute period values to be used for reference
     * @return {Boolean}            True if this attribute is limited edition
     */
    isLimitedEdition: function (periods) {
        var attrCollection = (periods && new Attributes(periods)) || Attributes.getCollectionForKey(ItemAttribute.ATTRIBUTE_PRODUCTION_TYPE);
        var attrs = attrCollection.getItemAttributesCollection();
        var urlLabel = attrs.find(function (attr) {
            return attr.get('option.urlLabel') === LIMITED_EDITION_LABEL;
        });
        var limitedEditionId = urlLabel && urlLabel.get('option.id');

        var prodTypeId = this.at(0) && this.at(0).get('option.id');
        return parseInt(prodTypeId, 10) === limitedEditionId;
    }
});


/***/ }),
/* 2624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by don on 9/15/15.
 */


var SoaModel = __webpack_require__(2);
var SoaCollection = __webpack_require__(9);
var Period = __webpack_require__(116);
var Category = __webpack_require__(1377);
var AuthorizedRole = __webpack_require__(2207);
var DoubleWrapper = SoaModel.extend({});
var BooleanWrapper = SoaModel.extend({});
var StringWrapper = SoaModel.extend({});
var PublicationAttributeValues;

var TransformModel = SoaModel.extend({

    constructor: function (attrs, options) {
        switch (attrs.apiType) {
            case 'adminRole':
            case 'userRole':
                return new AuthorizedRole(attrs, options);
            case 'doubleWrapper':
                return new DoubleWrapper(attrs, options);
            case 'period':
                return new Period(attrs, options);
            case 'booleanWrapper':
                return new BooleanWrapper(attrs, options);
            case 'stringWrapper':
                return new StringWrapper(attrs, options);
            case 'category':
                return new Category(attrs, options);

        }
    }

});

PublicationAttributeValues = SoaCollection.extend({

    model: TransformModel

});

// expose models unique to this collection
PublicationAttributeValues.DoubleWrapper = DoubleWrapper;
PublicationAttributeValues.BooleanWrapper = BooleanWrapper;

module.exports = PublicationAttributeValues;


/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by don on 9/14/15.
 */


var SoaCollection = __webpack_require__(9);
var PublicationAttributeValueWrapper = __webpack_require__(2650);
var PublicationAttribute = __webpack_require__(1624);
var PublicationAttributeWrappers;

/**
 * @class PublicationAttributeWrappers
 * @extends SoaCollection
 */

PublicationAttributeWrappers = module.exports = SoaCollection.extend({

    model: PublicationAttributeValueWrapper,

    /**
     * @returns {PublicationAttributeValueWrapper|undefined}
     */
    getMerchandisePending: function () {
        return this.getAttribute(PublicationAttribute.MERCHANDISE_PENDING_AUTH);
    },

    /**
     * @returns {PublicationAttributeValueWrapper|undefined}
     */
    getMerchandisePublished: function () {
        return this.getAttribute(PublicationAttribute.MERCHANDISE_PUBLISHED_AUTH);
    },

    getCategory : function () {
        return this.getAttribute(PublicationAttribute.CATEGORY);
    },

    /**
     * Returns the attribute wrapper model with the provided attribute name if found, otherwise returns undefined
     * @param name Name of the attribute we're looking for
     * @returns {PublicationAttributeValueWrapper|undefined}
     */
    getAttribute: function (name) {
        return this.find(function (model) {
            return model.get('attribute.name') === name;
        });
    }

});


/***/ }),
/* 2626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Created by lior on 12/1/14.
 */



var _ = __webpack_require__(0);
var SoaCollection = __webpack_require__(9);
var endpoints = __webpack_require__(6);
var bunsenLib = __webpack_require__(21);
var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

/**
 * @class ReferenceSets
 * @extends SoaCollection
 */
root.bunsen.ReferenceSets = module.exports = SoaCollection.extend({
    url: endpoints.referenceSet(),
    parse: function (data) {
        return data && data.reference_set && data.reference_set.row ? data.reference_set.row : null;
    },
    /**
     * @param {string[]} types
     * @param {object} options Backbone fetch options
     * @returns {Deferred.promise}
     */
    fetchByType: function (types, options) {
        var oldUrl = this.url;
        var prom;
        this.url = _.result(this, 'url') + '?' + bunsenLib.queryStringFromObj({ type: types }, true);
        prom = this.fetch(options);
        this.url = oldUrl;
        return prom;
    }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: ronald
 *
 * A mapping of facet information.
 * Exports an object with the following :
 * - map : a mapping of facet names to keys
 *      - "facetName" is the name of the facet that comes back from SOLR.
 *      - "facetKey" is the key you pass to SOLR in a filterQuery for faceting.
 *      - "filterKey" is a key used to filter a search.
 *      - "tagName" tagName is used as the value of a tag which is used by solr.  When doing a search, say on an id,
 *        the gui may need to show how many results there are for facets, but the ID search would restrict
 *        the result set to 1, leaving the facet count numbers to mostly just 0.  In order to exclude the
 *        restricting search from the facet results, you can pass a tag to prevent the search from limiting
 *        the result set.
 *        reference: https://wiki.apache.org/solr/SimpleFacetParameters#Tagging_and_excluding_Filters
 * - getNameFromKey : a function to get a facet name from a facet key
 * - getKeyFromName : a function to get a facet key from a facet name.
 * - getTagFromKey : a function to get a facet tag name from a facet key.
 *
 * If an entry in the map has a facetKey but no facetName, then it is not an available facet, but it can be used as a
 * SOLR filter query.
 * @type {object}
 */



// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);


//const FILTER_L1                 = 'vertical';
//const FILTER_L2                 = 'l2_url_label';
//const FILTER_L2_FINE_ART        = 'l2_url_label_fine_art';
//const FILTER_L3                 = 'l3_url_label';
//const FILTER_PERIOD             = 'period_url_label';
//const FILTER_CREATOR            = 'creator_id';
//const FILTER_CREATOR_LABEL      = 'creator_url_label';
//const FILTER_DEALER             = 'seller_url_label';
//const FILTER_LOCATION           = 'location_id';
//const FILTER_SHIPPING           = 'shipping_url_label';
//const FILTER_PRICE              = 'sort_price';
//const FILTER_CATEGORY_SEARCH    = 'category_search';
//const FILTER_STOREFRONT_SEARCH  = 'storefront_search';
//const FILTER_SECTION            = '%s_section_url_label';
//const FILTER_ASSOCIATION        = 'association_id';
//const FILTER_COLLECTION         = 'collection_id';
//const FILTER_SALE               = 'sale_id';
//const FILTER_SALE_LATEST        = 'sale_current_%d';
//const FILTER_GENDER             = 'gender_url_label';
//const FILTER_NEW_LISTINGS       = 'new_listing';
//const FILTER_STATUS             = 'status';
//const FILTER_HIDE_PRICE         = 'hideprice';
//const FILTER_WIDTH              = 'numeric_width';
//const FILTER_HEIGHT             = 'numeric_height';
//const FILTER_LENGTH             = 'numeric_height';
//const FILTER_PRIMARY_KEY        = 'pk';
//
//// Facets
//const FACET_L1          = 'vertical_facets';
//const FACET_L2          = 'l2_facets';
//const FACET_L2_FINE_ART = 'l2_facets_fine_art';
//const FACET_L3          = 'l3_facets';
//const FACET_PERIOD      = 'period_facets';
//const FACET_CREATOR     = 'creator_sort_facets';
//const FACET_DEALER      = 'seller_facets';
//const FACET_LOCATION    = 'location_facets';
//const FACET_SHIPPING    = 'shipping_facets';
//const FACET_SECTION     = '%s_section_facets';
//const FACET_ASSOCIATION = 'association_facets';
//const FACET_COLLECTION  = 'collection_facets';
//const FACET_SALE        = 'sale_facets';
//const FACET_GENDER      = 'gender_facets';
//
//// Stats
//const STATS_PRICE       = self::FILTER_PRICE;
//const STATS_WIDTH       = self::FILTER_WIDTH;
//const STATS_HEIGHT      = self::FILTER_HEIGHT;
//
//// Values
//const VAL_NO_SOLD       = '(-1 0 6)';
//const VAL_IGNORE_ZERO   = '[1 TO *]';


var map = {
    vertical : {
        facetName : 'vertical_facets',
        facetKey : 'vertical',
        tagName : 'v'
    },
    l2 : {
        facetName : 'l2_facets',
        facetKey : 'l2_url_label',
        tagName : 'l2'
    },
    l3 : {
        facetName : 'l3_facets',
        facetKey : 'l3_url_label',
        tagName : 'l3'
    },
    location : {
        facetName : 'location_facets',
        facetKey : 'location_id',
        tagName : 'loc'
    },
    period : {
        facetName : 'attr_opt_facet_period',
        facetKey : 'attr_opt_facet_period',
        filterKey: 'attr_opt_id_period',
        tagName: 'pr'
    },
    metal: {
        facetName: 'attr_opt_facet_metal',
        facetKey: 'attr_opt_facet_metal',
        filterKey: 'attr_opt_id_metal',
        tagName: 'met'
    },
    stone: {
        facetName: 'attr_opt_facet_stone',
        facetKey: 'attr_opt_facet_stone',
        filterKey: 'attr_opt_id_stone',
        tagName: 'st'
    },
    shipping : {
        facetName : 'shipping_facets',
        facetKey : 'shipping_url_label',
        tagName : 'shp'
    },
    fashionType: {
        facetName: 'ftype',
        facetKey: 'ftype',
        tagName: 'ftype'
    },
    creatorId : {
        facetName : 'creator_sort_facets',
        facetKey : 'creator_id',
        filterKey: 'creator',
        tagName : 'cr'
    },
    price : {
        facetKey : 'sort_price',
        tagName : 'pi'
    },
    status : {
        facetKey : 'status',
        tagName : 'st'
    },
    publishingOption: {
        facetKey: 'publishingOption',
        tagName: 'publishingOption'
    },
    itemReference : {
        facetKey : 'reference',
        tagName : 're'
    },
    // Used in OMT - via transaction endpoint
    sellerId : {
        facetKey : 'sellerId',
        tagName : 'sid'
    },
    // Used in inventory search against the item endpoint
    sellerPk : {
        facetKey : 'seller_pk',
        tagName : 'spk'
    },
    buyerId : {
        facetKey : 'buyerId',
        tagName : 'bid'
    },
    itemId : {
        facetKey : 'itemId',
        tagName : 'iid'
    },
    itemPk : {
        facetKey : 'pk',
        tagName : 'ipk'
    },
    searchQuery : {
        facetKey : 'query',
        tagName : 'query'
    },
    dealerCompany : {
        facetKey : 'seller_name',
        tagName : 'seller_name'
    },
    dealerReference : {
        facetKey : 'dealerreference',
        tagName : 'dealerreference'
    },
    dealerEmail : {
        facetKey : 'seller_email',
        tagName: 'seller_email'
    },
    onHold: {
        facetKey: 'on_hold',
        tagName: 'on_hold'
    },
    csStatus: {
        facetKey: 'csstatus',
        tagName: 'csstatus'
    },
    association: {
        facetKey: 'association_url_label',
        tagName: 'association'
    },
    collection: {
        facetKey: 'collection_url_label',
        tagName: 'collection'
    }
};

// Map all of the facet names to keys, and vice versa :
var _nameMap = {};
var _keyMap = {};
var _tagMap = {};
var _filterKeyTagMap = {};

_.each(map, function (val) {
    if (val.facetName && val.facetKey) {
        _nameMap[val.facetName] = val.facetKey;
    }
});

_.each(map, function (val) {
    if (val.facetName && val.facetKey) {
        _keyMap[val.facetKey] = val.facetName;
    }
});

_.each(map, function (val) {
    if (val.tagName && val.facetKey) {
        _tagMap[val.facetKey] = val.tagName;
        if (val.filterKey) {
            _filterKeyTagMap[val.filterKey] = val.tagName;
        }
    }
});

var _getNameFromKey = function (key) {
    return _keyMap[key];
};
var _getKeyFromName = function (name) {
    return _nameMap[name];
};
var _getTagFromKey = function (key) {
    return _tagMap[key] || _filterKeyTagMap[key];
};

var _getAssociationValue = function (key) {
    var associationValues = {
        nydc: 'itemStatus.NYDCItems',
        aadla: 'itemStatus.approvedAntiquesAssociations',
        twentiethLeague: 'itemStatus.20thCenturySpecialists',
        adaa: 'itemStatus.approvedArtDealersAssociations',
        aipad: 'itemStatus.approvedAIPAD'
    };

    return associationValues[key];
};

module.exports = {
    facetMap: map,
    getNameFromKey : _getNameFromKey,
    getKeyFromName : _getKeyFromName,
    getTagFromKey : _getTagFromKey,
    getAssociationValue: _getAssociationValue
};


/***/ }),
/* 2628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by james on 6/5/14.
 */

// ---------------------------------------------------
// Dependencies

var endpoints = __webpack_require__(6);
var ServiceMethod = __webpack_require__(316);

// ---------------------------------------------------
// Module Definition

module.exports = {
    KEY: 'SELLER_SERVICE_METHOD_DISPLAY_MAP',
    url: endpoints.referenceSet(),
    makeRequest: function () {
        return ServiceMethod.fetchSellerMethodDisplayCollection();
    },
    getDataOnResolve: function () {
        return ServiceMethod.getSellerMethodDisplayCollection();
    }
};

/***/ }),
/* 2629 */
/***/ (function(module, exports) {

/*
 * File created for running jasmine tests in node.
 * Webpack config makes require call to _gaq return window._gaq.
 * However webpack is not used when running tests from node. Hence,
 * check if _gaq exists on window (as webpack does) and return it if it exists
 * else it returns empty object
 */

module.exports = window._gaq || {};


/***/ }),
/* 2630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: daletan
 * Date: 6/24/14
 * Time: 1:01 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */


var $ = __webpack_require__(5);
var d = window.document;
var scriptLoader;
var imgPixel;
var _pageEls;

/**
 * @returns {Object} pageEls, contains document head and body(if loaded) tag
 * @returns {HTMLElement} pageEls.head
 * @returns {HTMLElement} pageEls.body
 */
var getPageEls = function () {
    if (_pageEls) {
        // qucker if both are defined
        return _pageEls;
    }
    var $head = $('head');
    var $body = $('body');
    if ($head.length && $body.length) {
        //set private var for quicker lookup if both are defined
        _pageEls = {
            head : $head[0],
            body : $body[0]
        };
    } else if ($head.length) {
        // else return head if body isn't loaded
        return {
            head : $head[0]
        };
    }
    return _pageEls;
};

scriptLoader = {
    className : 'appended-script',


    /**
     *
     * @param {Object|Array} data If Object, needs these properties:
     * @param {string} data.base full base url up to the query parameters
     * @param {object} data.props Object of key/value pair properties to convert into query params
     *                            If Array, needs to just be the full URLs of the script tag, query params included b/c
     *                            this process will just `append` the script tags and not do any string manipulation
     * @param {boolean} async
     * @param {string} appendTo The element to append to from the `pageEls` object list
     * @param callBack {function} callBack function script load, passes src of loaded script
     * @returns {boolean}
     */
    load: function (data, async, appendTo, callBack) {

        var pageEls = getPageEls();

        if (async) {
            this.async = true;
        }
        this.remove();
        // which element to append the script tags to?
        this.el = pageEls[appendTo] ? pageEls[appendTo] : pageEls.head;
        if ($.isArray(data)) {
            for (var i = 0, len = data.length; i < len; i++) {
                this.append(data[i], callBack);
            }
            return false;
        } else if (!data.base) {
            console.log('a `base` property is need');
            return false;
        }
        var url = this.createUrl(data);
        if (url) {
            this.append(url, callBack);
        }
        return true;
    },
    remove: function () {
        var $els = $('.' + this.className);
        $els.remove();
    },
    /**
     * Creates a url string and adds any query parameters
     * @param data {Object} "base" (string) and "props" (object) need to be proeprties on this object
     */
    createUrl: function (data) {
        var url = data.base;
        var propsData = data.props;
        var props = [];
        for (var p in propsData) {
            if (propsData.hasOwnProperty(p)) {
                props.push(p + '=' + propsData[p]);
            }
        }
        if (props.length) {
            props = props.join('&');
            url += '?' + props;
        }
        return url;
    },
    /**
     * create a <script> block in the <head> with the
     * @param src {string} The source url to the script file to load
     * @param callBack {function} callBack function script load, passes src of loaded script
     */
    append: function (src, callBack) {
        if (src) {
            var script = d.createElement('script');
            script.type = 'text/javascript';
            script.src = src;
            script.className =  this.className;
            if (this.async) {
                script.defer = true;
                script.async = true;
                this.addScriptLoadCallBack(script, callBack, src);
            }
            this.el.appendChild(script);
        }
    },

    /**
     * @param {string} src the url of the script to load
     * @param {HTMLElement} script tag that's loading
     * @param {function} callBack fires when script loads, passing the the script src and readyState as a params
     */
    addScriptLoadCallBack: function (script, callBack, src) {
        if (typeof callBack !== 'function') {
            return;
        }
        script.onload = function () {
            callBack(src, script.readyState);
        };
    }
};

imgPixel = {
    className: 'appended-img-pixel',
    /**
     * Wrapper to create and load methods
     * @param {Array|String} data An array of src strings or a single src string
     * @returns {boolean}
     */
    load: function (data) {
        if (!data) {
            return [];
        }
        this.remove();
        if ($.isArray(data)) {
            for (var i = 0; i < data.length; i++) {
                this.createAndAppend(data[i]);
            }
        } else {
            this.createAndAppend(data);
        }
        return true;
    },
    remove: function () {
        var $els = $('.' + this.className);
        $els.remove();
    },
    createAndAppend: function (src) {
        var img = this.createImg(src);
        this.append(img);
    },
    createImg: function (src) {
        var img = d.createElement('img');
        img.src = src;
        img.width = 1;
        img.height = 1;
        img.className = this.className;
        return img;
    },
    append: function (img) {
        var pageEls = getPageEls();
        if (img) {
            pageEls.body.appendChild(img);
        }
    }
};

module.exports = {
    getPageEls: getPageEls,
    script: scriptLoader,
    pixel: imgPixel
};


/***/ }),
/* 2631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var DELIMITER1 = '|';
var DELIMITER2 = ';';
var DELIMITER3 = '^';
var DELIMITER4 = '%';
var EQUALS = '~';
var optionsMap = {
    defaultParam : 'd',
    filterQuery : 'f',
    multiSelect : 'm',
    excludeFacet : 'e',
    excludeFromAll : 'a',
    min : 'n',
    max : 'x'
};
var groupOptionsMap = {
    typeOr : 'o',
    multiRestricted : 'r'
};
var encodingOptsMap = {
    options : 'o',
    groups : 'g',
    displayName : 'd'
};

var Serialize = module.exports = {};

Serialize.serializeParams = function (paramsArray) {
    // loop over the params, each key is key, each val is val,
    // options get compressed to 1 character
    // do something about special characters in the display name. Da-Derp?
    var out = [];
    var outStr = '';

    _.each(paramsArray, function (param) {

        var curr = {};
        var options = param.options;
        var groups = options ? options.groups : [];
        var optStr = '';
        var groupArr = [];
        var groupStr = '';
        var displayName;
        var currStr;

        curr.key = param.key;
        curr.val = param.val;

        // If the param includes any options
        if (options && _.size(options)) {

            //Loop over the options, for each one if it is set to true, add it to the options.
            // If the options is the display name it will be a string so store separately.
            _.each(options, function (val, key) {
                if (val === true) {
                    optStr += optionsMap[key];
                } else if (key === 'displayName') {
                    displayName = val;
                }
            }, this);
        }

        curr.options = optStr;

        // If the param includes any groups :
        if (groups && _.size(groups)) {

            // Loop over the groups in the optios. For each collect the name and typeOr option and store as a string.
            // Then join together all of them
            _.each(groups, function (groupObj) {
                // TODO!!! LOOP OVER GROUP OPTIONS MAP IN HERE INSTEAD OF JUST GETTIGN TYPE OR (if necessary in future)
                groupArr.push(groupObj.name + DELIMITER3 + (groupObj.typeOr ? 'o' : '') + (groupObj.multiRestricted ? (DELIMITER3 + groupOptionsMap.multiRestricted) : ''));
            }, this);
            groupStr = groupArr.join(DELIMITER4);
        }

        // Move the groups info and the display name info up to the top level :
        curr.displayName = displayName;
        curr.groups = groupStr;

        // Now that the initial current object is built, use it to create the final serialized string :
        currStr = curr.key + EQUALS + curr.val;
        _.each(encodingOptsMap, function (name, lettr) {
            if (!_.isUndefined(curr[lettr]) && _.size(curr[lettr])) {
                currStr += DELIMITER1;
                currStr += name + EQUALS + curr[lettr];
            }
        }, this);

        out.push(currStr);


    }, this);

    outStr = out.join(DELIMITER2);

    // TODO !!! Using encode uri component on the individual names?
    return outStr;
};



Serialize.deSerializeParams = function (qs) {
    var out = [];
    var arr = qs.split(DELIMITER2);
    // Since we are doing the reverse lookup, we use the inverted versions of the above maps :
    var encodingOptsInverted = _.invert(encodingOptsMap);
    var groupOptionsInverted = _.invert(groupOptionsMap);
    var optionsInverted = _.invert(optionsMap);

    // The starting array splits apart the encoded options by the main delimiter (DEL2). Loop over each getting the
    // key and val for each. The val will either be complex (like group), true / false (like "m") or a string name.
    _.each(arr, function (str1) {
        if (!str1) {
            return;
        }
        var param = {};
        var currArr = str1.split(DELIMITER1);
        var keyVal = currArr.shift().split(EQUALS);
        var optsArr;
        var groupArr;
        var groups = [];

        // Get the key and value (always occurrs at the beginning of the string) :
        param.key = keyVal[0];
        param.val = keyVal[1];

        // Loop over the option strings. For each get the property name and the value. Eg. o=em gets {options : 'em'}
        _.each(currArr, function (str2) {
            var valueArr = str2.split(EQUALS);
            var propName = encodingOptsInverted[valueArr[0]];
            param[propName] = valueArr[1];
        }, this);

        // Now for options and group options, we need to map each character to it's meaning.
        // Eg. o=em means excludeFacet, multiSelect
        if (param.options) {
            optsArr = param.options.split('');
            param.options = {};
            _.each(optsArr, function (lettr) {
                var prop = optionsInverted[lettr];
                param.options[prop] = true;
            }, this);
        }

        // Now we are going to get the groups and the displayName. For each we need the options object to be there
        // so create an empty one if there is not already one there :
        param.options = param.options || {};

        // Now if the param has groups specified, loop over each encoded one and derive a group object :
        if (param.groups) {
            groupArr = param.groups.split(DELIMITER4);
            delete param.groups;
            _.each(groupArr, function (str) {
                var group = {};
                var valArr = str.split(DELIMITER3);
                group.name = valArr.shift();
                _.each(valArr, function (letter) {
                    var prop = groupOptionsInverted[letter];
                    group[prop] = true;
                });
                groups.push(group);
            });
            param.options.groups = groups;
        }

        // The display is on the top level, nest it under the options object.
        if (param.displayName) {
            param.options.displayName = param.displayName;
            delete param.displayName;
        }

        out.push(param);

    }, this);

    return out;
};


/***/ }),
/* 2632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);
var assert = __webpack_require__(31);

// ---------------------------------------------------
// Module Definition and Static Properties

/**
 * @module stringNumHelper
 * @type {object}
 */
var stringNumHelper = module.exports = {

    /**
     * @param {string} val
     * @returns {boolean}
     */
    strValHasValidCommaSegmentLength: function (val) {
        assert(typeof val === 'string', 'val must be a string');
        val = val.replace('-', '');
        var dotIndex = val.indexOf('.');
        var segs;
        val = dotIndex > -1 ? val.substr(0, dotIndex) : val;
        segs = val.split(',');
        return _.every(segs, function (seg, index) {
            var len = seg.length;
            return (index === 0 && len < 4 && len > 0) || len === 3;
        });
    },

    /**
     * @param {string} strVal
     * @returns {string}
     */
    stripCommas: function (strVal) {
        return strVal.replace(/,/g, '');
    },

    /**
     * Same as Number(stringVal) but removes commas
     * from the string val first. This conversion
     * function will convert '' into 0. If you do
     * not want this, use safeConvertNumberVal.
     *
     * @param {string} strVal
     * @returns {number}
     */
    convertStrToNumber: function (strVal) {
        assert(typeof strVal === 'string', 'val must be a string');
        strVal = stringNumHelper.stripCommas(strVal);
        return Number(strVal);
    },

    /**
     * @param val
     * @returns {boolean}
     */
    strNumHasNoLeadingZeroes: function (val) {
        assert(typeof val === 'string', 'val must be a string');
        return (val === '0' || val.charAt(0) !== '0' || val.charAt(1) === '.');
    },

    /**
     * Like $.isNumeric, except this function
     * allows commas.
     * @param {string} val
     * @param {boolean} [strictCommas=false]
     * @returns {boolean}
     */
    strValIsNumeric: function (val, strictCommas) {
        assert(typeof val === 'string', 'val must be a string');
        if (strictCommas && val.indexOf(',') > -1 && !stringNumHelper.strValHasValidCommaSegmentLength(val)) {
            return false;
        }
        if (this.checkIsEmptyVal(val)) {
            return false;
        }
        var numVal = stringNumHelper.convertStrToNumber(val);
        return !isNaN(numVal) && isFinite(numVal) && stringNumHelper.strNumHasNoLeadingZeroes(val);
    },

    /**
     * isNaN will return true for NaN and any non-numbers.
     * This function will only return true if you have a
     * number that is actually the NaN constant.
     * @param {*} rawVal
     * @returns {boolean}
     */
    checkIsNaN: function (rawVal) {
        return typeof rawVal === 'number' && isNaN(rawVal);
    },

    /**
     * Return true if the value passed
     * is a number and not NaN
     * @param {*} numberVal
     * @returns {boolean}
     */
    checkIsNonNaNNumber: function (numberVal) {
        return typeof numberVal === 'number' && !isNaN(numberVal);
    },

    /**
     * @param {*} rawVal
     * @returns {boolean}
     */
    checkIsEmptyVal: function (rawVal) {
        return !rawVal && rawVal !== 0;
    },

    /**
     * Takes strings, numbers, and various falsey inputs and
     * returns either a number or null. This is to simplify
     * situations where you can receive numbers, string numbers,
     * or various falsey values (null, '', undefined, NaN). If
     * the value is falsey and not 0, or the parsed string is
     * NaN, then null is returned. Numbers stay the same and
     * string representations are strictly converted (empty
     * string is not converted to 0). Requires valid comma
     * segment lengths if strictCommas flag is true
     *
     * @param {*} rawVal
     * @param {boolean} [strictCommas=false]
     * @returns {number|null}
     */
    safeConvertNumberVal: function (rawVal, strictCommas) {
        if (stringNumHelper.checkIsNonNaNNumber(rawVal)) {
            return rawVal;
        }
        var strVal = String(rawVal);
        if (stringNumHelper.checkIsEmptyVal(rawVal) || !stringNumHelper.strValIsNumeric(strVal, strictCommas)) {
            return null;
        }
        return stringNumHelper.convertStrToNumber(strVal);
    }

};

/***/ }),
/* 2633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(87);


/***/ }),
/* 2634 */
/***/ (function(module, exports) {

module.exports = {
	"mobile-portrait": "320px",
	"mobile-landscape": "480px",
	"mobile-large-landscape": "568px",
	"tablet-portrait": "768px",
	"tablet-landscape": "1024px",
	"desktop": "1025px",
	"phablet-portrait": "414px",
	"phablet-landscape": "736px"
};

/***/ }),
/* 2635 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * accounting.js v0.3.2
 * Copyright 2011, Joss Crowcroft
 *
 * Freely distributable under the MIT license.
 * Portions of accounting.js are inspired or borrowed from underscore.js
 *
 * Full details and documentation:
 * http://josscrowcroft.github.com/accounting.js/
 */

(function(root, undefined) {

	/* --- Setup --- */

	// Create the local library object, to be exported or referenced globally later
	var lib = {};

	// Current version
	lib.version = '0.3.2';


	/* --- Exposed settings --- */

	// The library's settings configuration object. Contains default parameters for
	// currency and number formatting
	lib.settings = {
		currency: {
			symbol : "$",		// default currency symbol is '$'
			format : "%s%v",	// controls output: %s = symbol, %v = value (can be object, see docs)
			decimal : ".",		// decimal point separator
			thousand : ",",		// thousands separator
			precision : 2,		// decimal places
			grouping : 3		// digit grouping (not implemented yet)
		},
		number: {
			precision : 0,		// default precision on numbers is 0
			grouping : 3,		// digit grouping (not implemented yet)
			thousand : ",",
			decimal : "."
		}
	};


	/* --- Internal Helper Methods --- */

	// Store reference to possibly-available ECMAScript 5 methods for later
	var nativeMap = Array.prototype.map,
		nativeIsArray = Array.isArray,
		toString = Object.prototype.toString;

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js
	 */
	function isString(obj) {
		return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
	}

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js, delegates to ECMA5's native Array.isArray
	 */
	function isArray(obj) {
		return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
	}

	/**
	 * Tests whether supplied parameter is a true object
	 */
	function isObject(obj) {
		return obj && toString.call(obj) === '[object Object]';
	}

	/**
	 * Extends an object with a defaults object, similar to underscore's _.defaults
	 *
	 * Used for abstracting parameter handling from API methods
	 */
	function defaults(object, defs) {
		var key;
		object = object || {};
		defs = defs || {};
		// Iterate over object non-prototype properties:
		for (key in defs) {
			if (defs.hasOwnProperty(key)) {
				// Replace values with defaults only if undefined (allow empty/zero values):
				if (object[key] == null) object[key] = defs[key];
			}
		}
		return object;
	}

	/**
	 * Implementation of `Array.map()` for iteration loops
	 *
	 * Returns a new Array as a result of calling `iterator` on each array value.
	 * Defers to native Array.map if available
	 */
	function map(obj, iterator, context) {
		var results = [], i, j;

		if (!obj) return results;

		// Use native .map method if it exists:
		if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);

		// Fallback for native .map:
		for (i = 0, j = obj.length; i < j; i++ ) {
			results[i] = iterator.call(context, obj[i], i, obj);
		}
		return results;
	}

	/**
	 * Check and normalise the value of precision (must be positive integer)
	 */
	function checkPrecision(val, base) {
		val = Math.round(Math.abs(val));
		return isNaN(val)? base : val;
	}


	/**
	 * Parses a format string or object and returns format obj for use in rendering
	 *
	 * `format` is either a string with the default (positive) format, or object
	 * containing `pos` (required), `neg` and `zero` values (or a function returning
	 * either a string or object)
	 *
	 * Either string or format.pos must contain "%v" (value) to be valid
	 */
	function checkCurrencyFormat(format) {
		var defaults = lib.settings.currency.format;

		// Allow function as format parameter (should return string or object):
		if ( typeof format === "function" ) format = format();

		// Format can be a string, in which case `value` ("%v") must be present:
		if ( isString( format ) && format.match("%v") ) {

			// Create and return positive, negative and zero formats:
			return {
				pos : format,
				neg : format.replace("-", "").replace("%v", "-%v"),
				zero : format
			};

		// If no format, or object is missing valid positive value, use defaults:
		} else if ( !format || !format.pos || !format.pos.match("%v") ) {

			// If defaults is a string, casts it to an object for faster checking next time:
			return ( !isString( defaults ) ) ? defaults : lib.settings.currency.format = {
				pos : defaults,
				neg : defaults.replace("%v", "-%v"),
				zero : defaults
			};

		}
		// Otherwise, assume format was fine:
		return format;
	}


	/* --- API Methods --- */

	/**
	 * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
	 * alias: accounting.`parse(string)`
	 *
	 * Decimal must be included in the regular expression to match floats (defaults to
	 * accounting.settings.number.decimal), so if the number uses a non-standard decimal 
	 * separator, provide it as the second argument.
	 *
	 * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
	 *
	 * Doesn't throw any errors (`NaN`s become 0) but this may change in future
	 */
	var unformat = lib.unformat = lib.parse = function(value, decimal) {
		// Recursively unformat arrays:
		if (isArray(value)) {
			return map(value, function(val) {
				return unformat(val, decimal);
			});
		}

		// Fails silently (need decent errors):
		value = value || 0;

		// Return the value as-is if it's already a number:
		if (typeof value === "number") return value;

		// Default decimal point comes from settings, but could be set to eg. "," in opts:
		decimal = decimal || lib.settings.number.decimal;

		 // Build regex to strip out everything except digits, decimal point and minus sign:
		var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
			unformatted = parseFloat(
				("" + value)
				.replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
				.replace(regex, '')         // strip out any cruft
				.replace(decimal, '.')      // make sure decimal point is standard
			);

		// This will fail silently which may cause trouble, let's wait and see:
		return !isNaN(unformatted) ? unformatted : 0;
	};


	/**
	 * Implementation of toFixed() that treats floats more like decimals
	 *
	 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
	 * problems for accounting- and finance-related software.
	 */
	var toFixed = lib.toFixed = function(value, precision) {
		precision = checkPrecision(precision, lib.settings.number.precision);
		var power = Math.pow(10, precision);

		// Multiply up by precision, round accurately, then divide and use native toFixed():
		return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
	};


	/**
	 * Format a number, with comma-separated thousands and custom precision/decimal places
	 *
	 * Localise by overriding the precision and thousand / decimal separators
	 * 2nd parameter `precision` can be an object matching `settings.number`
	 */
	var formatNumber = lib.formatNumber = function(number, precision, thousand, decimal) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val) {
				return formatNumber(val, precision, thousand, decimal);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(precision) ? precision : {
					precision : precision,
					thousand : thousand,
					decimal : decimal
				}),
				lib.settings.number
			),

			// Clean up precision
			usePrecision = checkPrecision(opts.precision),

			// Do some calc:
			negative = number < 0 ? "-" : "",
			base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
			mod = base.length > 3 ? base.length % 3 : 0;

		// Format the number:
		return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
	};


	/**
	 * Format a number into currency
	 *
	 * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
	 * defaults: (0, "$", 2, ",", ".", "%s%v")
	 *
	 * Localise by overriding the symbol, precision, thousand / decimal separators and format
	 * Second param can be an object matching `settings.currency` which is the easiest way.
	 *
	 * To do: tidy up the parameters
	 */
	var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val){
				return formatMoney(val, symbol, precision, thousand, decimal, format);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero):
			formats = checkCurrencyFormat(opts.format),

			// Choose which format to use for this value:
			useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;

		// Return with currency symbol added:
		return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
	};


	/**
	 * Format a list of numbers into an accounting column, padding with whitespace
	 * to line up currency symbols, thousand separators and decimals places
	 *
	 * List should be an array of numbers
	 * Second parameter can be an object containing keys that match the params
	 *
	 * Returns array of accouting-formatted number strings of same length
	 *
	 * NB: `white-space:pre` CSS rule is required on the list container to prevent
	 * browsers from collapsing the whitespace in the output strings.
	 */
	lib.formatColumn = function(list, symbol, precision, thousand, decimal, format) {
		if (!list) return [];

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero), only need pos for now:
			formats = checkCurrencyFormat(opts.format),

			// Whether to pad at start of string or after currency symbol:
			padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,

			// Store value for the length of the longest string in the column:
			maxLength = 0,

			// Format the list according to options, store the length of the longest string:
			formatted = map(list, function(val, i) {
				if (isArray(val)) {
					// Recursively format columns if list is a multi-dimensional array:
					return lib.formatColumn(val, opts);
				} else {
					// Clean up the value
					val = unformat(val);

					// Choose which format to use for this value (pos, neg or zero):
					var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,

						// Format this value, push into formatted list and save the length:
						fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));

					if (fVal.length > maxLength) maxLength = fVal.length;
					return fVal;
				}
			});

		// Pad each number in the list and send back the column of numbers:
		return map(formatted, function(val, i) {
			// Only if this is a string (not a nested array, which would have already been padded):
			if (isString(val) && val.length < maxLength) {
				// Depending on symbol position, pad after symbol or at index 0:
				return padAfterSymbol ? val.replace(opts.symbol, opts.symbol+(new Array(maxLength - val.length + 1).join(" "))) : (new Array(maxLength - val.length + 1).join(" ")) + val;
			}
			return val;
		});
	};


	/* --- Module Definition --- */

	// Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
	// Otherwise, just add `accounting` to the global object
	if (true) {
		if (typeof module !== 'undefined' && module.exports) {
			exports = module.exports = lib;
		}
		exports.accounting = lib;
	} else if (typeof define === 'function' && define.amd) {
		// Return the library as an AMD module:
		define([], function() {
			return lib;
		});
	} else {
		// Use accounting.noConflict to restore `accounting` back to its original value.
		// Returns a reference to the library's `accounting` object;
		// e.g. `var numbers = accounting.noConflict();`
		lib.noConflict = (function(oldAccounting) {
			return function() {
				// Reset the value of the root's `accounting` variable:
				root.accounting = oldAccounting;
				// Delete the noConflict method:
				lib.noConflict = undefined;
				// Return reference to the library to re-assign it:
				return lib;
			};
		})(root.accounting);

		// Declare `fx` on the root (global/window) object:
		root['accounting'] = lib;
	}

	// Root will be `window` in browser or `global` on the server:
}(this));


/***/ }),
/* 2636 */,
/* 2637 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Created with JetBrains PhpStorm.
 * User: devpatel
 * Date: 9/30/13
 * Time: 6:00 PM
 */

(function (root, factory) {
    "use strict";
    if (true) {
        // CommonJS
        factory(module);
    }
}(typeof window === 'undefined' ? global : window, function (module) {
    "use strict";
    module.exports = {
        "US": "United States of America",
        "AF": "Afghanistan",
        "AX": "Åland",
        "AL": "Albania",
        "DZ": "Algeria",
        "AS": "American Samoa",
        "AD": "Andorra",
        "AO": "Angola",
        "AI": "Anguilla",
        "AQ": "Antarctica",
        "AG": "Antigua and Barbuda",
        "AR": "Argentina",
        "AM": "Armenia",
        "AW": "Aruba",
        "AU": "Australia",
        "AT": "Austria",
        "AZ": "Azerbaijan",
        "BS": "Bahamas",
        "BH": "Bahrain",
        "BD": "Bangladesh",
        "BB": "Barbados",
        "BY": "Belarus",
        "BE": "Belgium",
        "BZ": "Belize",
        "BJ": "Benin",
        "BM": "Bermuda",
        "BT": "Bhutan",
        "BO": "Bolivia",
        "BA": "Bosnia and Herzegovina",
        "BW": "Botswana",
        "BV": "Bouvet Island",
        "BR": "Brazil",
        "IO": "British Indian Ocean Territory",
        "BN": "Brunei Darussalam",
        "BG": "Bulgaria",
        "BF": "Burkina Faso",
        "BI": "Burundi",
        "KH": "Cambodia",
        "CM": "Cameroon",
        "CA": "Canada",
        "CV": "Cape Verde",
        "KY": "Cayman Islands",
        "CF": "Central African Republic",
        "TD": "Chad",
        "CL": "Chile",
        "CN": "China",
        "CX": "Christmas Island",
        "CC": "Cocos (Keeling) Islands",
        "CO": "Colombia",
        "KM": "Comoros",
        "CG": "Congo (Brazzaville)",
        "CD": "Congo (Kinshasa)",
        "CK": "Cook Islands",
        "CR": "Costa Rica",
        "CI": "Côte d'Ivoire",
        "HR": "Croatia",
        "CU": "Cuba",
        "CY": "Cyprus",
        "CZ": "Czech Republic",
        "DK": "Denmark",
        "DJ": "Djibouti",
        "DM": "Dominica",
        "DO": "Dominican Republic",
        "EC": "Ecuador",
        "EG": "Egypt",
        "SV": "El Salvador",
        "GQ": "Equatorial Guinea",
        "ER": "Eritrea",
        "EE": "Estonia",
        "ET": "Ethiopia",
        "FK": "Falkland Islands",
        "FO": "Faroe Islands",
        "FJ": "Fiji",
        "FI": "Finland",
        "FR": "France",
        "GF": "French Guiana",
        "PF": "French Polynesia",
        "TF": "French Southern Lands",
        "GA": "Gabon",
        "GM": "Gambia",
        "GE": "Georgia",
        "DE": "Germany",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GR": "Greece",
        "GL": "Greenland",
        "GD": "Grenada",
        "GP": "Guadeloupe",
        "GU": "Guam",
        "GT": "Guatemala",
        "GG": "Guernsey",
        "GN": "Guinea",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HT": "Haiti",
        "HM": "Heard and McDonald Islands",
        "HN": "Honduras",
        "HK": "Hong Kong",
        "HU": "Hungary",
        "IS": "Iceland",
        "IN": "India",
        "ID": "Indonesia",
        "IR": "Iran",
        "IQ": "Iraq",
        "IE": "Ireland",
        "IM": "Isle of Man",
        "IL": "Israel",
        "IT": "Italy",
        "JM": "Jamaica",
        "JP": "Japan",
        "JE": "Jersey",
        "JO": "Jordan",
        "KZ": "Kazakhstan",
        "KE": "Kenya",
        "KI": "Kiribati",
        "KP": "Korea, North",
        "KR": "Korea, South",
        "KW": "Kuwait",
        "KG": "Kyrgyzstan",
        "LA": "Laos",
        "LV": "Latvia",
        "LB": "Lebanon",
        "LS": "Lesotho",
        "LR": "Liberia",
        "LY": "Libya",
        "LI": "Liechtenstein",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "MO": "Macau",
        "MK": "Macedonia",
        "MG": "Madagascar",
        "MW": "Malawi",
        "MY": "Malaysia",
        "MV": "Maldives",
        "ML": "Mali",
        "MT": "Malta",
        "MH": "Marshall Islands",
        "MQ": "Martinique",
        "MR": "Mauritania",
        "MU": "Mauritius",
        "YT": "Mayotte",
        "MX": "Mexico",
        "FM": "Micronesia",
        "MD": "Moldova",
        "MC": "Monaco",
        "MN": "Mongolia",
        "ME": "Montenegro",
        "MS": "Montserrat",
        "MA": "Morocco",
        "MZ": "Mozambique",
        "MM": "Myanmar",
        "NA": "Namibia",
        "NR": "Nauru",
        "NP": "Nepal",
        "NL": "Netherlands",
        "AN": "Netherlands Antilles",
        "NC": "New Caledonia",
        "NZ": "New Zealand",
        "NI": "Nicaragua",
        "NE": "Niger",
        "NG": "Nigeria",
        "NU": "Niue",
        "NF": "Norfolk Island",
        "MP": "Northern Mariana Islands",
        "NO": "Norway",
        "OM": "Oman",
        "PK": "Pakistan",
        "PW": "Palau",
        "PS": "Palestine",
        "PA": "Panama",
        "PG": "Papua New Guinea",
        "PY": "Paraguay",
        "PE": "Peru",
        "PH": "Philippines",
        "PN": "Pitcairn",
        "PL": "Poland",
        "PT": "Portugal",
        "PR": "Puerto Rico",
        "QA": "Qatar",
        "RE": "Reunion",
        "RO": "Romania",
        "RU": "Russian Federation",
        "RW": "Rwanda",
        "BL": "Saint Barthélemy",
        "SH": "Saint Helena",
        "KN": "Saint Kitts and Nevis",
        "LC": "Saint Lucia",
        "MF": "Saint Martin (French part)",
        "PM": "Saint Pierre and Miquelon",
        "VC": "Saint Vincent and the Grenadines",
        "WS": "Samoa",
        "SM": "San Marino",
        "ST": "Sao Tome and Principe",
        "SA": "Saudi Arabia",
        "SN": "Senegal",
        "RS": "Serbia",
        "SC": "Seychelles",
        "SL": "Sierra Leone",
        "SG": "Singapore",
        "SK": "Slovakia",
        "SI": "Slovenia",
        "SB": "Solomon Islands",
        "SO": "Somalia",
        "ZA": "South Africa",
        "GS": "South Georgia and South Sandwich Islands",
        "ES": "Spain",
        "LK": "Sri Lanka",
        "SD": "Sudan",
        "SR": "Suriname",
        "SJ": "Svalbard and Jan Mayen Islands",
        "SZ": "Swaziland",
        "SE": "Sweden",
        "CH": "Switzerland",
        "SY": "Syria",
        "TW": "Taiwan",
        "TJ": "Tajikistan",
        "TZ": "Tanzania",
        "TH": "Thailand",
        "TL": "Timor-Leste",
        "TG": "Togo",
        "TK": "Tokelau",
        "TO": "Tonga",
        "TT": "Trinidad and Tobago",
        "TN": "Tunisia",
        "TR": "Turkey",
        "TM": "Turkmenistan",
        "TC": "Turks and Caicos Islands",
        "TV": "Tuvalu",
        "UG": "Uganda",
        "UA": "Ukraine",
        "AE": "United Arab Emirates",
        "GB": "United Kingdom",
        "UM": "United States Minor Outlying Islands",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VU": "Vanuatu",
        "VA": "Vatican City",
        "VE": "Venezuela",
        "VN": "Vietnam",
        "VG": "Virgin Islands, British",
        "VI": "Virgin Islands, U.S.",
        "WF": "Wallis and Futuna Islands",
        "EH": "Western Sahara",
        "YE": "Yemen",
        "ZM": "Zambia",
        "ZW": "Zimbabwe"
    };
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(70)(module)))

/***/ }),
/* 2638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var root = typeof window === 'undefined' ? global : window;
var bunsen = root.bunsen = root.bunsen || {};
var accounting = __webpack_require__(2635);
var currency = __webpack_require__(320);

var price = {};

bunsen.formatPrice = price.formatPrice = function (amount, currencyEnum, passedPrecision) {
    var myCurrency = currency(currencyEnum);
    var precision = passedPrecision || 0;
    var currencySymbol = myCurrency ? myCurrency.symbol : null;
    var formatOptions = {
            precision: precision,
            symbol: currencySymbol,
            format: {
                pos : "%s%v",
                neg : "- %s%v",
                zero: "%s0"
            }
        };


    if (currencyEnum && !currencySymbol) {
        throw new Error('Could not find a currency symbol for your ENUM');
    }

    if (!amount && !currencySymbol) {
        return '';
    } else if (currencySymbol && !amount) {
        return accounting.formatMoney(0, formatOptions);
    } else if (currencySymbol && amount) {
        return accounting.formatMoney(amount, formatOptions);
    } else if (!currencySymbol) {
        throw new Error('You cannot pass an amount but not a currency');
    }
};

module.exports = price;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 1/14/15
 * Time: 1:26 PM
 */



var PercentAdjustment = __webpack_require__(2048);
var FlatAdjustment = module.exports = PercentAdjustment.extend();

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var FinancialAmount = __webpack_require__(10);

_.extend(FlatAdjustment.prototype, {
    relations: PercentAdjustment.prototype.relations.concat([{
        key: 'rate',
        relatedModel: FinancialAmount,
        type: Backbone.One
    }])
});

/***/ }),
/* 2640 */,
/* 2641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 1/16/14
 * Time: 5:03 PM
 */



var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var Permissions = module.exports = SoaModel.extend();
var endpoints = __webpack_require__(6);
var PermissionList = __webpack_require__(2039);
var _ = __webpack_require__(0);

_.extend(Permissions.prototype, {
    url: endpoints.permission,
    relations : [{
        key : 'permissionList',
        collectionType: PermissionList,
        type: Backbone.Many
    }],
    parse: function (data) {
        var permissions;
        var mapping;
        if (data.permissionList) {
            permissions = data;
            mapping = data.rolePermissionMappings;
        } else if (data.result && data.result.permissions && data.result.permissions.permissionList) {
            permissions = data.result.permissions;
            mapping = data.result.permissions.rolePermissionMappings;
        } else {
            return data;
        }

        //parse the roles - permissions mapping
        if (permissions && mapping) {
            _.each(permissions.permissionList, function (permission) {
                permission.roles = [];
                _.each(_.where(mapping, {value: permission.id}), function (role) {
                    permission.roles.push({
                        id: role.name
                    });
                });
            });
        }

        return permissions;
    },
    /**
     * Check permissions for a given user. Provide the user's permission set as the second argument.
     * @param required - The required permission to complete this action.
     * @returns {*}
     */
    checkPermissions: function (required) {
        // Return true if nothing is passed in for required
        if (!required || _.isEmpty(required)) {
            return true;
        }

        // If required is a string, check if it's in the available array
        if (typeof required === 'string') {
            return !!this.get('permissionList').checkPermissions({name: required});
        }
        // If required is an array, check if at least one of them is in available
        return _.some(required, function (perm) {
            return !!this.get('permissionList').checkPermissions({name: perm});
        }, this);
    }
});


/***/ }),
/* 2642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by devpatel on 3/4/14.
 */




var SoaModel = __webpack_require__(2);
var SellerBillingProfile = SoaModel.extend();

module.exports = SellerBillingProfile; // this is where the magic happens

var Backbone = __webpack_require__(3);
var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var Seller = __webpack_require__(105);


var sellerBillingProfileURLFunction = function () {
    return _.result(this.findParent(Seller), 'url') + '/billingProfile';
};


/**
 * SellerCreditCard model is a child of Seller.billingProfile.
 * -- Note the seller's credit card number will alweays be masked when you request it from the server.
 */
var SellerCreditCard = SoaModel.extend({
    url : sellerBillingProfileURLFunction,

    initialize : function () {
        // When the combined expiration field is updated, update the fields used for actual persistence.
        this.on('change:expiration', this.updateDates);
    },

    defaults : {
        paymentMethodType : "CREDIT_CARD"
    },

    /**
     * Parse method for the credit card combines the month and date into 1 field, expiration:
     */
    parse : function (response) {
        // Get the expiration field by combining the month and year fields:
        if (response.cardExpiryMonth && response.cardExpiryYear) {
            response.expiration = response.cardExpiryMonth + ' / ' + response.cardExpiryYear;
        }

        return response;
    },

    /**
     * Splits the expiration field into 2 fields, month and year.
     * @param subView
     * @param value
     */
    updateDates : function (model, value) {
        var exp = value.split('/');
        var month =  $.trim(exp[0]);
        var year = $.trim(exp[1]);

        if (year.length === 4) {
            year = year.substr(2, 2);
        }

        this.set('cardExpiryMonth', month);
        // Force a two digit year
        this.set('cardExpiryYear', year);
    },

    relations: [
        {
            key: 'billingAddress',
            relatedModel: SoaModel,
            type: Backbone.One
        }
    ]
});


_.extend(SellerBillingProfile.prototype, {
    url : sellerBillingProfileURLFunction,

    defaults: {
        setupFee: 0,
        monthlyFee: 0,
        monthlyCycle: 1,
        payStatus : "CK"
    },

    /**
     * Over-ride the normal sync method to ignore the Credit Card's expiration field:
     */
    sync : function (method, model, options) {
        var attrs = options.attrs || this.toJSON();

        // Remove the creditCard.expiration attribute from the data representation.
        attrs = _.omit(attrs, ['feeStructure']);
        if (attrs.creditCard) {
            delete attrs.creditCard.expiration;
        }

        return SellerBillingProfile.__super__.sync.apply(this, [method, model, _.defaults({ attrs : attrs }, options)]);
    },
    relations: function () {
        return [
            {
                key: 'creditCard',
                relatedModel: SellerCreditCard,
                type: Backbone.One
            }
        ];
    }
});

_.extend(SellerBillingProfile, {
    STATUS_EXPIRED : 'EXPIRED',
    STATUS_DECLINED : 'DECLINED'
});


/***/ }),
/* 2643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var SellerPaymentProfile = SoaModel.extend();
var endpoints = __webpack_require__(6);
var _ = __webpack_require__(0);
var Seller = __webpack_require__(105);

module.exports = SellerPaymentProfile;

_.extend(SellerPaymentProfile.prototype, {
    url: function () {
        var sellerId = this.findParent(Seller).id;
        return endpoints.sellerPaymentProfile(sellerId);
    }
});


/***/ }),
/* 2644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by stavmeidan on 7/30/15.
 */



var SoaModel = __webpack_require__(2);
var Seller = __webpack_require__(105);
var _= __webpack_require__(0);
var YES = 'Y';

var SellerPreferences = module.exports = SoaModel.extend({
    url : function () {
        var url = _.result(this.findParent(Seller), 'url') + '/preferences';
        return url;
    },
    defaults: {
        currency: 'USD'
    },

    /**
     * Indicates if seller allows for items to display on store front when sold
     * @return {Boolean}
     */
    isDisplayStoreFrontSold: function() {
        return this.get('displayStoreFrontSold') === YES;
    }
});

/***/ }),
/* 2645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: liliana
 * Date: 11/10/14
 * Time: 11:07 AM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */



// ---------------------------------------------------
// Load Super Class
var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);

// ---------------------------------------------------
// Module Definition

/**
 * Model for Attribute data via Attribute Service, e.g.:
 * {
 *     "id": 7595,
 *     "name": "Costa Rica",
 *     "urlLabel": "costa-rica",
 *     "status": "ACTIVE",
 *     "properties": {
 *         "displayName": "Costa Rican"
 *     },
 *     "pageExists": "Y",
 *     "parent": {
 *        "id": 7589
 *     }
 * },
 * @class Attribute
 * @extends SoaModel
 */
var Attribute = module.exports = SoaModel.extend();

// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);
var Attributes = __webpack_require__(1618);
var ItemAttribute = __webpack_require__(1219);

// ---------------------------------------------------
// Local Vars

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(Attribute.prototype, {
    relations : [
        {
            type: Backbone.One,
            key: 'properties',
            relatedModel: SoaModel.extend()
        },
        {
            type: Backbone.Many,
            key: 'child',
            collectionType: Attributes
        }
    ],
    toItemAttribute: function (omitChild) {
        var child = this.get('child') || [];
        var data = {
            value: this.get('name'),
            option: {
                id: this.get('id'),
                urlLabel: this.get('urlLabel'),
                displayConfigs: this.get('displayConfigs') || null
            }
        };

        if (!omitChild && child.length) {
            data.child = child.toItemAttributes(omitChild);
        }

        return new ItemAttribute(data);
    }
});

// ---------------------------------------------------
// Define Module Static Properties

_.extend(Attribute, {

});

/***/ }),
/* 2646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created with JetBrains PhpStorm.
 * User: ronald
 * Date: 1/7/13
 * Time: 7:10 PM
 * To change this template use File | Settings | File Templates.
 *
 * NOTE!!!
 * creator.id === creator.get('cid');
 * creator.cid !== ceator.get('cid');
 *
 * Requires :
 * SoaModel
 * dibs.endpoints
 * ItemCreator
 * ItemCreators
 *
 */


var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);
var Creator = module.exports = SoaModel.extend();
var endpoints = __webpack_require__(6);
var ItemCreator = __webpack_require__(1466);
var ItemCreators = __webpack_require__(1619);
var Backbone = __webpack_require__(3);

_.extend(Creator.prototype, {
    url: function () {
        return this.isNew() ? endpoints.creator() : endpoints.creator() + '/' + this.get('id');
    },
    idAttribute: 'id',
    defaults: {
        pageExists: 'N',
        sortName: ''
    },
    relations: [{
            type: Backbone.HasMany || Backbone.One,
            key: 'items',
            relatedModel: ItemCreator,
            collectionType: ItemCreators,
            reverseRelation: {
                includeInJSON: 'id'
            }
        }]
});

/***/ }),
/* 2647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var SoaModel = __webpack_require__(2);

/**
 * Image model has no endpoint as of yet. In the future this may be available via image service.
 * Leave this named `ImageModel` since the html5 spec has a new `Image` global
 * @type {Object|Function}
 */
var ImageModel = SoaModel.extend();

_.extend(ImageModel, {
    UPLOAD_TYPE_DEALER: 'USER',
    UPLOAD_TYPE_1STDIBS: '_1STDIBS'
});

_.extend(ImageModel.prototype, {

    /**
     * Determines if the image in question is the first image.
     * @returns {boolean}
     */
    isImgOne : function () {
        return this.get('position').toString() === '1';
    },

    /**
     * Returns who uploaded the image
     * @returns string
     */
    getPhotoProvider: function() {
        var provider = this.get('uploadType');
        if (provider === this.UPLOAD_TYPE_DEALER) {
            return 'dealer';
        } else if (provider === this.UPLOAD_TYPE_1STDIBS) {
            return '1stdibs';
        }
        return null;
    }
});

module.exports = ImageModel;


/***/ }),
/* 2648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Load Super Class

var SoaModel = __webpack_require__(2);

// ---------------------------------------------------
// Module Definition

/**
 * This model stores data about the relationship
 * between an item and a category. It is the model
 * for the {@link ItemCategories} collection
 * @class ItemCategory
 * @extends SoaModel
 */
var ItemCategory = module.exports = SoaModel.extend();

// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);
var Category = __webpack_require__(1377);
var Backbone = __webpack_require__(3);

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(ItemCategory.prototype, /** @lends ItemCategory.prototype */{
    relations: [
        { key: 'category', type: Backbone.One, relatedModel: Category }
    ],
    /**
     * @returns {Category}
     */
    getCategory : function () {
        return this.get('category');
    },
    /**
     * @returns {string}
     */
    getCategoryKey : function () {
        return this.get('category.key');
    },
    /**
     * Get the precedence of an ItemCategory
     * @returns {number}
     */
    getPrecedence: function () {
        return this.get('precedence');
    },
    /**
     * @param {string} key
     * @returns {ItemCategory}
     */
    resetCategoryWithKey: function (key) {
        var category = this.getCategory();
        var attrs = {key: key};
        if (!category) {
            this.set('category', attrs);
            return this;
        }
        category.clear({ silent: true }).set({
            key: key
        });
        return this;
    }
});

/**
 * @static
 * @memberOf ItemCategory
 * @param {string} key
 * @param {number} precedence
 * @returns {ItemCategory}
 */
ItemCategory.createWithKeyAndPrecedence = function (key, precedence) {
    return new ItemCategory({
        precedence: precedence,
        category: {
            key: key
        }
    });
};


/***/ }),
/* 2649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Dependencies
var _ = __webpack_require__(0);
var SolrSearchModel = __webpack_require__(3835);
var Listings = __webpack_require__(3830);
var endpoints = __webpack_require__(6);
var ListingSearch;

/**
 * @class ListingSearch
 * @extends SolrSearchModel
 */

ListingSearch = module.exports = SolrSearchModel.extend({
    initialize: function (attrs, options) {
        attrs = attrs || {};
        options = options || {};
        options.collectionName = 'listings';
        options.collectionType = Listings;
        options.paramsMap = {
            bookmarked : 'qp.bookmarked',
            categoryCodeL2 : 'qp.categoryCodeL2',
            categoryCodeL3 : 'qp.categoryCodeL3',
            creator : 'qp.creatorUrlLabel',
            dealer : 'qp.sellerUrlLabel',
            locationId : 'qp.locationId',
            maxPrice : 'qp.maxPrice',
            marketplace : 'qp.marketplaceOnly',
            minPrice : 'qp.minPrice',
            notes : 'qp.notes',
            listingStatusGroup: 'qp.listingStatusGroup',
            pageStart : 'pageStart',
            periodId : 'qp.periodId',
            priceReduction: 'qp.priceReduction',
            publicationId : 'qp.publicationId',
            publicationRelation: 'qp.publicationRelation',
            publicationStatus: 'qp.publicationStatus',
            publicationType: 'qp.publicationType',
            itemReject: 'qp.itemReject',
            itemRepost: 'qp.itemRepost',
            searchTerm : 'qp.searchTerm',
            sellerPk: 'qp.sellerPk',
            shipping : 'qp.shippingUrlLabel',
            sort: 'qp.sort',
            vertical: 'qp.vertical',
            vettingStatus: 'qp.vettingStatus'
        };
        options.facetParamsMap = {
            bookmarked : 'bookmarked',
            categoryCodeL2 : 'item_cat_code_l2',
            categoryCodeL3 : 'item_cat_code_l3',
            creator : 'item_creator_facets',
            dealer : 'item_seller_facets',
            listingStatusGroup: 'listing_status_group',
            locationId : 'item_location_facets',
            marketplace: 'marketplace_only',
            notes : 'notes',
            periodId : 'item_attr_opt_facet_period',
            priceReduction : 'price_reduction_facets',
            itemReject: 'reject',
            itemRepost : 'repost',
            shipping : 'item_shipping_facets',
            vertical : 'item_vertical',
            vettingStatus: 'vetting_status'
        };
        options.queryTemplate = options.queryTemplate || 'publication.edit';
        options.baseParams = _.union(['queryTemplate', 'pageSize', 'pageStart', 'context'], options.baseParams);
        this.publicationId = options.publicationId;

        this.sellerPk = options.sellerPk;
        this.publicationType = options.publicationType;
        this.publicationStatus = options.publicationStatus;
        this.fields = options.fields;

        ListingSearch.__super__.initialize.call(this, attrs, options);
    },

    url : function () {
        return endpoints.listings();
    },

    /**
     * Get the max (i.e. last) page a number of items can be moved to.
     * @returns {Number}
     */
    getMaxMoveToPage : function () {
        var highestPage = Math.ceil(this.get('totalResults') / this.pageSize) - 1;
        return highestPage > 0 ? highestPage : 1;
    }
}, {
    FIELDS: {
        ITEM: 'ITEM',
        PUBLICATION: 'PUBLICATION',
        FULL: 'FULL',
        ITEM_LISTINGS_META_DATA : 'ITEM_LISTINGS_META_DATA'
    }
});


/***/ }),
/* 2650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var Backbone = __webpack_require__(3);
var PublicationAttribute = __webpack_require__(1624);
var PublicationAttributeValues = __webpack_require__(2624);


var PublicationAttributeValueWrapper = SoaModel.extend({

    relations: [{
        type: Backbone.One,
        key: 'attribute',
        relatedModel: PublicationAttribute
    }, {
        type: Backbone.Many,
        key: 'value',
        collectionType: PublicationAttributeValues
    }],

    getValues: function () {
        return this.get('value');
    }
});

module.exports = PublicationAttributeValueWrapper;


/***/ }),
/* 2651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/16/14
 * Time: 12:42 PM
 */


var _ = __webpack_require__(0);

var anchorFunctions = [
    'getAnchorIdByType',
    'getAnchorByType',
    'hasAnchor',
    'setAnchorId'
];

/**
 * Proxy anchor collection functions onto a model with an anchor association.
 *
 * Add this mixin to any model that has an Anchor collection on it's anchor
 * property.
 *
 * Creates an object of the above functions. Calling them will call that function
 * on the 'anchors' collection of this.
 */
module.exports = _.reduce(anchorFunctions, function (memo, anchorFunction) {
    memo[anchorFunction] = function () {
        var anchors = this.get('anchors');
        return anchors[anchorFunction].apply(anchors, arguments);
    };
    return memo;
}, {});

/***/ }),
/* 2652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

module.exports = {
    fetchRelation: function (/* relation1, relation2, ..., options */) {
        var lastArg = arguments[arguments.length - 1];
        var relations = [].slice.call(arguments);
        var options = {};

        if (_.isObject(lastArg)) {
            relations.pop();
            options = lastArg;
        }

        options.data = options.data || {};
        options.data.fields = options.data.fields || relations.join(',');

        return this.fetch(options);
    }
};

/***/ }),
/* 2653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var symbols = __webpack_require__(1220).symbols;

module.exports = function getCurrencySymbol(currencyENUM) {
    return symbols[currencyENUM];
};


/***/ }),
/* 2654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(1626);

/*
 * @param  {number} amount - The number to format.
 * @param  {string} currency - Accepts any currency from currencies file
 * @param  {object} passedOptions - Additional options for localizedCashFormat
 * @return {string} - Formatted price string
 */
module.exports = function intelligentFormat(amount, currency, passedOptions) {
    var options = util.getFormatOptions(amount, currency, passedOptions);
    return util.localizedCashFormat(amount, options);
};


/***/ }),
/* 2655 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var keys = __webpack_require__(2656),
    rest = __webpack_require__(816);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : source[key];

    assignValue(object, key, newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return rest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a
 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
 * Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'user': 'fred' };
 * var other = { 'user': 'fred' };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.c = 3;
 * }
 *
 * function Bar() {
 *   this.e = 5;
 * }
 *
 * Foo.prototype.d = 4;
 * Bar.prototype.f = 6;
 *
 * _.assign({ 'a': 1 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3, 'e': 5 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 2656 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 2657 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArguments = __webpack_require__(1094),
    isArray = __webpack_require__(64),
    isFunction = __webpack_require__(104),
    isString = __webpack_require__(2658),
    keys = __webpack_require__(297);

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is empty. A value is considered empty unless it is an
 * `arguments` object, array, string, or jQuery-like collection with a length
 * greater than `0` or an object with own enumerable properties.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {Array|Object|string} value The value to inspect.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
      (isObjectLike(value) && isFunction(value.splice)))) {
    return !value.length;
  }
  return !keys(value).length;
}

module.exports = isEmpty;


/***/ }),
/* 2658 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 2659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var latestServices = {
    messagecenter:   'mc-1',
    ecom:            'ecom-4',
    identity:        'identity-3',
    inventory:       'inventory-3',
    logistics:       'logistics-2',
    cms:             'cms-service',
    usercomm:        'usercomm',
    boss:            'boss-1',
    trade:           'trade-1',
    media:           'media-1',
    analytics:       'analytics-1'
};
module.exports = {
    latestServices: latestServices,
    latest: {
        messagecenter:       latestServices.messagecenter + '/1',   // mc-1/1
        mcFlagMessage:       latestServices.messagecenter + '/2',   // mc-1/2

        ecom:                latestServices.ecom + '/2',            // ecom-4/2',
        ecomPromotion:       latestServices.ecom + '/3',            // ecom-4/3,
        ecomTransaction:     latestServices.ecom + '/3',            //'ecom-4/3',
        ecomSummary:         latestServices.ecom + '/4',            //'ecom-4/4',
        ecomLogistics:       latestServices.ecom + '/4',            //'ecom-4/4',
        ecomCurrency:        latestServices.ecom + '/3',            //'ecom-4/3',

        identity:               latestServices.identity + '/1',     //'identity-3/1',
        identityShipping:       latestServices.identity + '/2',     //'identity-3/2',
        identityHyperwallet:    latestServices.identity + '/2',     //'identity-3/2',
        identityLogistics:      latestServices.identity + '/4',     //'identity-3/4',
        identitySocialNetworks: latestServices.identity + '/2',     //'identity-3/2',
        identityTrade:          latestServices.identity + '/2',     //'identity-3/2',
        identityOauth:          latestServices.identity + '/2',     //'identity-3/2',
        trade:                  latestServices.trade + '/2',        //'trade-1/2',
        identityConvNotes:      latestServices.identity + '/2',     //'identity-3/2',

        inventory:           latestServices.inventory + '/2',       //'inventory-3/2',
        inventoryItem:       latestServices.inventory + '/3',       //'inventory-3/3',
        inventoryAttributes: latestServices.inventory + '/1',       // inventory-3/1
        inventoryShipping:   latestServices.inventory + '/2',       // 'inventory-3/2',
        inventoryLogistics:  latestServices.inventory + '/4',       // 'inventory-3/4',
        inventoryCreators:   latestServices.inventory + '/2',       // 'inventory-3/2',
        inventoryCategories: latestServices.inventory + '/3',       // 'inventory-3/3',
        inventoryFileUpload: latestServices.inventory + '/3',       // 'inventory-3/3',
        inventoryReviews:    latestServices.inventory + '/2',       // 'inventory-3/3',
        inventoryListings:   latestServices.inventory + '/2',       // 'inventory-3/3',

        logistics:           latestServices.logistics + '/3',       //'logistics-2/3',
        logisticsShipping:   latestServices.logistics + '/4',       //'logistics-2/4'

        analytics:           latestServices.analytics + '/2',       //'analytics-1/2'

        cms:                 latestServices.cms + '/v1',

        usercomm:            latestServices.usercomm + '/2',

        boss:                latestServices.boss + '/1',

        media:               latestServices.media + '/2'
    }
};


/***/ }),
/* 2660 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.10.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var merge = __webpack_require__(2663),
    restParam = __webpack_require__(279);

/**
 * Creates a `_.defaults` or `_.defaultsDeep` function.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Function} Returns the new defaults function.
 */
function createDefaults(assigner, customizer) {
  return restParam(function(args) {
    var object = args[0];
    if (object == null) {
      return object;
    }
    args.push(customizer);
    return assigner.apply(undefined, args);
  });
}

/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use.
 *
 * @private
 * @param {*} objectValue The destination object property value.
 * @param {*} sourceValue The source object property value.
 * @returns {*} Returns the value to assign to the destination object.
 */
function mergeDefaults(objectValue, sourceValue) {
  return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
}

/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
 * // => { 'user': { 'name': 'barney', 'age': 36 } }
 *
 */
var defaultsDeep = createDefaults(merge, mergeDefaults);

module.exports = defaultsDeep;


/***/ }),
/* 2661 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 4.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var toString = __webpack_require__(3974);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function baseCastPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path + ''] : baseCastPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[path[index++]];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (typeof value == 'number') {
    return true;
  }
  return !isArray(value) &&
    (reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
      (object != null && value in Object(object)));
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
function stringToPath(string) {
  var result = [];
  toString(string).replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type {Function}
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined` the `defaultValue` is used in its place.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 2662 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseFor = __webpack_require__(129),
    isArguments = __webpack_require__(1094),
    keysIn = __webpack_require__(314);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * The base implementation of `_.forIn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForIn(object, iteratee) {
  return baseFor(object, iteratee, keysIn);
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * **Note:** This method assumes objects created by the `Object` constructor
 * have no inherited enumerable properties.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  var Ctor;

  // Exit early for non `Object` objects.
  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
    return false;
  }
  // IE < 9 iterates inherited properties before own properties. If the first
  // iterated property is an object's own property then there are no inherited
  // enumerable properties.
  var result;
  // In most environments an object's own properties are iterated before
  // its inherited properties. If the last iterated property is an object's
  // own property then there are no inherited enumerable properties.
  baseForIn(value, function(subValue, key) {
    result = key;
  });
  return result === undefined || hasOwnProperty.call(value, result);
}

module.exports = isPlainObject;


/***/ }),
/* 2663 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.3.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var arrayCopy = __webpack_require__(2231),
    arrayEach = __webpack_require__(328),
    createAssigner = __webpack_require__(2237),
    isArguments = __webpack_require__(1094),
    isArray = __webpack_require__(64),
    isPlainObject = __webpack_require__(2662),
    isTypedArray = __webpack_require__(2240),
    keys = __webpack_require__(297),
    toPlainObject = __webpack_require__(3973);

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.merge` without support for argument juggling,
 * multiple sources, and `this` binding `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Array} [stackA=[]] Tracks traversed source objects.
 * @param {Array} [stackB=[]] Associates values with source counterparts.
 * @returns {Object} Returns `object`.
 */
function baseMerge(object, source, customizer, stackA, stackB) {
  if (!isObject(object)) {
    return object;
  }
  var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
      props = isSrcArr ? undefined : keys(source);

  arrayEach(props || source, function(srcValue, key) {
    if (props) {
      key = srcValue;
      srcValue = source[key];
    }
    if (isObjectLike(srcValue)) {
      stackA || (stackA = []);
      stackB || (stackB = []);
      baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
    }
    else {
      var value = object[key],
          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
          isCommon = result === undefined;

      if (isCommon) {
        result = srcValue;
      }
      if ((result !== undefined || (isSrcArr && !(key in object))) &&
          (isCommon || (result === result ? (result !== value) : (value === value)))) {
        object[key] = result;
      }
    }
  });
  return object;
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Array} [stackA=[]] Tracks traversed source objects.
 * @param {Array} [stackB=[]] Associates values with source counterparts.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
  var length = stackA.length,
      srcValue = source[key];

  while (length--) {
    if (stackA[length] == srcValue) {
      object[key] = stackB[length];
      return;
    }
  }
  var value = object[key],
      result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
      isCommon = result === undefined;

  if (isCommon) {
    result = srcValue;
    if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
      result = isArray(value)
        ? value
        : (isArrayLike(value) ? arrayCopy(value) : []);
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      result = isArguments(value)
        ? toPlainObject(value)
        : (isPlainObject(value) ? value : {});
    }
    else {
      isCommon = false;
    }
  }
  // Add the source value to the stack of traversed objects and associate
  // it with its merged value.
  stackA.push(srcValue);
  stackB.push(result);

  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
  } else if (result === result ? (result !== value) : (value === value)) {
    object[key] = result;
  }
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Recursively merges own enumerable properties of the source object(s), that
 * don't resolve to `undefined` into the destination object. Subsequent sources
 * overwrite property assignments of previous sources. If `customizer` is
 * provided it is invoked to produce the merged values of the destination and
 * source properties. If `customizer` returns `undefined` merging is handled
 * by the method instead. The `customizer` is bound to `thisArg` and invoked
 * with five arguments: (objectValue, sourceValue, key, object, source).
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {*} [thisArg] The `this` binding of `customizer`.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var users = {
 *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
 * };
 *
 * var ages = {
 *   'data': [{ 'age': 36 }, { 'age': 40 }]
 * };
 *
 * _.merge(users, ages);
 * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
 *
 * // using a customizer callback
 * var object = {
 *   'fruits': ['apple'],
 *   'vegetables': ['beet']
 * };
 *
 * var other = {
 *   'fruits': ['banana'],
 *   'vegetables': ['carrot']
 * };
 *
 * _.merge(object, other, function(a, b) {
 *   if (_.isArray(a)) {
 *     return a.concat(b);
 *   }
 * });
 * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
 */
var merge = createAssigner(baseMerge);

module.exports = merge;


/***/ }),
/* 2664 */
/***/ (function(module, exports) {

/*!
 * jQuery UI Autocomplete 1.10.0
 * http://jqueryui.com
 *
 * Copyright 2013 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/autocomplete/
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.widget.js
 *	jquery.ui.position.js
 *	jquery.ui.menu.js
 */
(function( $, undefined ) {

// used to prevent race conditions with remote data sources
var requestIndex = 0;

$.widget( "ui.autocomplete", {
	version: "1.10.0",
	defaultElement: "<input>",
	options: {
		appendTo: null,
		autoFocus: false,
		delay: 300,
		minLength: 1,
		position: {
			my: "left top",
			at: "left bottom",
			collision: "none"
		},
		source: null,

		// callbacks
		change: null,
		close: null,
		focus: null,
		open: null,
		response: null,
		search: null,
		select: null
	},

	pending: 0,

	_create: function() {
		// Some browsers only repeat keydown events, not keypress events,
		// so we use the suppressKeyPress flag to determine if we've already
		// handled the keydown event. #7269
		// Unfortunately the code for & in keypress is the same as the up arrow,
		// so we use the suppressKeyPressRepeat flag to avoid handling keypress
		// events when we know the keydown event was used to modify the
		// search term. #7799
		var suppressKeyPress, suppressKeyPressRepeat, suppressInput;

		this.isMultiLine = this._isMultiLine();
		this.valueMethod = this.element[ this.element.is( "input,textarea" ) ? "val" : "text" ];
		this.isNewMenu = true;

		this.element
			.addClass( "ui-autocomplete-input" )
			.attr( "autocomplete", "off" );

		this._on( this.element, {
			keydown: function( event ) {
				/*jshint maxcomplexity:15*/
				if ( this.element.prop( "readOnly" ) ) {
					suppressKeyPress = true;
					suppressInput = true;
					suppressKeyPressRepeat = true;
					return;
				}

				suppressKeyPress = false;
				suppressInput = false;
				suppressKeyPressRepeat = false;
				var keyCode = $.ui.keyCode;
				switch( event.keyCode ) {
				case keyCode.PAGE_UP:
					suppressKeyPress = true;
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					suppressKeyPress = true;
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					suppressKeyPress = true;
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					suppressKeyPress = true;
					this._keyEvent( "next", event );
					break;
				case keyCode.ENTER:
				case keyCode.NUMPAD_ENTER:
					// when menu is open and has focus
					if ( this.menu.active ) {
						// #6055 - Opera still allows the keypress to occur
						// which causes forms to submit
						suppressKeyPress = true;
						event.preventDefault();
						this.menu.select( event );
					}
					break;
				case keyCode.TAB:
					if ( this.menu.active ) {
						this.menu.select( event );
					}
					break;
				case keyCode.ESCAPE:
					if ( this.menu.element.is( ":visible" ) ) {
						this._value( this.term );
						this.close( event );
						// Different browsers have different default behavior for escape
						// Single press can mean undo or clear
						// Double press in IE means clear the whole form
						event.preventDefault();
					}
					break;
				default:
					suppressKeyPressRepeat = true;
					// search timeout should be triggered before the input value is changed
					this._searchTimeout( event );
					break;
				}
			},
			keypress: function( event ) {
				if ( suppressKeyPress ) {
					suppressKeyPress = false;
					event.preventDefault();
					return;
				}
				if ( suppressKeyPressRepeat ) {
					return;
				}

				// replicate some key handlers to allow them to repeat in Firefox and Opera
				var keyCode = $.ui.keyCode;
				switch( event.keyCode ) {
				case keyCode.PAGE_UP:
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					this._keyEvent( "next", event );
					break;
				}
			},
			input: function( event ) {
				if ( suppressInput ) {
					suppressInput = false;
					event.preventDefault();
					return;
				}
				this._searchTimeout( event );
			},
			focus: function() {
				this.selectedItem = null;
				this.previous = this._value();
			},
			blur: function( event ) {
				if ( this.cancelBlur ) {
					delete this.cancelBlur;
					return;
				}

				clearTimeout( this.searching );
				this.close( event );
				this._change( event );
			}
		});

		this._initSource();
		this.menu = $( "<ul>" )
			.addClass( "ui-autocomplete" )
			.appendTo( this._appendTo() )
			.menu({
				// custom key handling for now
				input: $(),
				// disable ARIA support, the live region takes care of that
				role: null
			})
			.zIndex( this.element.zIndex() + 1 )
			.hide()
			.data( "ui-menu" );

		this._on( this.menu.element, {
			mousedown: function( event ) {
				// prevent moving focus out of the text field
				event.preventDefault();

				// IE doesn't prevent moving focus even with event.preventDefault()
				// so we set a flag to know when we should ignore the blur event
				this.cancelBlur = true;
				this._delay(function() {
					delete this.cancelBlur;
				});

				// clicking on the scrollbar causes focus to shift to the body
				// but we can't detect a mouseup or a click immediately afterward
				// so we have to track the next mousedown and close the menu if
				// the user clicks somewhere outside of the autocomplete
				var menuElement = this.menu.element[ 0 ];
				if ( !$( event.target ).closest( ".ui-menu-item" ).length ) {
					this._delay(function() {
						var that = this;
						this.document.one( "mousedown", function( event ) {
							if ( event.target !== that.element[ 0 ] &&
									event.target !== menuElement &&
									!$.contains( menuElement, event.target ) ) {
								that.close();
							}
						});
					});
				}
			},
			menufocus: function( event, ui ) {
				// #7024 - Prevent accidental activation of menu items in Firefox
				if ( this.isNewMenu ) {
					this.isNewMenu = false;
					if ( event.originalEvent && /^mouse/.test( event.originalEvent.type ) ) {
						this.menu.blur();

						this.document.one( "mousemove", function() {
							$( event.target ).trigger( event.originalEvent );
						});

						return;
					}
				}

				var item = ui.item.data( "ui-autocomplete-item" );
				if ( false !== this._trigger( "focus", event, { item: item } ) ) {
					// use value to match what will end up in the input, if it was a key event
					if ( event.originalEvent && /^key/.test( event.originalEvent.type ) ) {
						this._value( item.value );
					}
				} else {
					// Normally the input is populated with the item's value as the
					// menu is navigated, causing screen readers to notice a change and
					// announce the item. Since the focus event was canceled, this doesn't
					// happen, so we update the live region so that screen readers can
					// still notice the change and announce it.
					this.liveRegion.text( item.value );
				}
			},
			menuselect: function( event, ui ) {
				var item = ui.item.data( "ui-autocomplete-item" ),
					previous = this.previous;

				// only trigger when focus was lost (click on menu)
				if ( this.element[0] !== this.document[0].activeElement ) {
					this.element.focus();
					this.previous = previous;
					// #6109 - IE triggers two focus events and the second
					// is asynchronous, so we need to reset the previous
					// term synchronously and asynchronously :-(
					this._delay(function() {
						this.previous = previous;
						this.selectedItem = item;
					});
				}

				if ( false !== this._trigger( "select", event, { item: item } ) ) {
					this._value( item.value );
				}
				// reset the term after the select event
				// this allows custom select handling to work properly
				this.term = this._value();

				this.close( event );
				this.selectedItem = item;
			}
		});

		this.liveRegion = $( "<span>", {
				role: "status",
				"aria-live": "polite"
			})
			.addClass( "ui-helper-hidden-accessible" )
			.insertAfter( this.element );

		// turning off autocomplete prevents the browser from remembering the
		// value when navigating through history, so we re-enable autocomplete
		// if the page is unloaded before the widget is destroyed. #7790
		this._on( this.window, {
			beforeunload: function() {
				this.element.removeAttr( "autocomplete" );
			}
		});
	},

	_destroy: function() {
		clearTimeout( this.searching );
		this.element
			.removeClass( "ui-autocomplete-input" )
			.removeAttr( "autocomplete" );
		this.menu.element.remove();
		this.liveRegion.remove();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "source" ) {
			this._initSource();
		}
		if ( key === "appendTo" ) {
			this.menu.element.appendTo( this._appendTo() );
		}
		if ( key === "disabled" && value && this.xhr ) {
			this.xhr.abort();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;

		if ( element ) {
			element = element.jquery || element.nodeType ?
				$( element ) :
				this.document.find( element ).eq( 0 );
		}

		if ( !element ) {
			element = this.element.closest( ".ui-front" );
		}

		if ( !element.length ) {
			element = this.document[0].body;
		}

		return element;
	},

	_isMultiLine: function() {
		// Textareas are always multi-line
		if ( this.element.is( "textarea" ) ) {
			return true;
		}
		// Inputs are always single-line, even if inside a contentEditable element
		// IE also treats inputs as contentEditable
		if ( this.element.is( "input" ) ) {
			return false;
		}
		// All other element types are determined by whether or not they're contentEditable
		return this.element.prop( "isContentEditable" );
	},

	_initSource: function() {
		var array, url,
			that = this;
		if ( $.isArray(this.options.source) ) {
			array = this.options.source;
			this.source = function( request, response ) {
				response( $.ui.autocomplete.filter( array, request.term ) );
			};
		} else if ( typeof this.options.source === "string" ) {
			url = this.options.source;
			this.source = function( request, response ) {
				if ( that.xhr ) {
					that.xhr.abort();
				}
				that.xhr = $.ajax({
					url: url,
					data: request,
					dataType: "json",
					success: function( data ) {
						response( data );
					},
					error: function() {
						response( [] );
					}
				});
			};
		} else {
			this.source = this.options.source;
		}
	},

	_searchTimeout: function( event ) {
		clearTimeout( this.searching );
		this.searching = this._delay(function() {
			// only search if the value has changed
			if ( this.term !== this._value() ) {
				this.selectedItem = null;
				this.search( null, event );
			}
		}, this.options.delay );
	},

	search: function( value, event ) {
		value = value != null ? value : this._value();

		// always save the actual value, not the one passed as an argument
		this.term = this._value();

		if ( value.length < this.options.minLength ) {
			return this.close( event );
		}

		if ( this._trigger( "search", event ) === false ) {
			return;
		}

		return this._search( value );
	},

	_search: function( value ) {
		this.pending++;
		this.element.addClass( "ui-autocomplete-loading" );
		this.cancelSearch = false;

		this.source( { term: value }, this._response() );
	},

	_response: function() {
		var that = this,
			index = ++requestIndex;

		return function( content ) {
			if ( index === requestIndex ) {
				that.__response( content );
			}

			that.pending--;
			if ( !that.pending ) {
				that.element.removeClass( "ui-autocomplete-loading" );
			}
		};
	},

	__response: function( content ) {
		if ( content ) {
			content = this._normalize( content );
		}
		this._trigger( "response", null, { content: content } );
		if ( !this.options.disabled && content && content.length && !this.cancelSearch ) {
			this._suggest( content );
			this._trigger( "open" );
		} else {
			// use ._close() instead of .close() so we don't cancel future searches
			this._close();
		}
	},

	close: function( event ) {
		this.cancelSearch = true;
		this._close( event );
	},

	_close: function( event ) {
		if ( this.menu.element.is( ":visible" ) ) {
			this.menu.element.hide();
			this.menu.blur();
			this.isNewMenu = true;
			this._trigger( "close", event );
		}
	},

	_change: function( event ) {
		if ( this.previous !== this._value() ) {
			this._trigger( "change", event, { item: this.selectedItem } );
		}
	},

	_normalize: function( items ) {
		// assume all items have the right format when the first item is complete
		if ( items.length && items[0].label && items[0].value ) {
			return items;
		}
		return $.map( items, function( item ) {
			if ( typeof item === "string" ) {
				return {
					label: item,
					value: item
				};
			}
			return $.extend({
				label: item.label || item.value,
				value: item.value || item.label
			}, item );
		});
	},

	_suggest: function( items ) {
		var ul = this.menu.element
			.empty()
			.zIndex( this.element.zIndex() + 1 );
		this._renderMenu( ul, items );
		this.menu.refresh();

		// size and position menu
		ul.show();
		this._resizeMenu();
		ul.position( $.extend({
			of: this.element
		}, this.options.position ));

		if ( this.options.autoFocus ) {
			this.menu.next();
		}
	},

	_resizeMenu: function() {
		var ul = this.menu.element;
		ul.outerWidth( Math.max(
			// Firefox wraps long text (possibly a rounding bug)
			// so we add 1px to avoid the wrapping (#7513)
			ul.width( "" ).outerWidth() + 1,
			this.element.outerWidth()
		) );
	},

	_renderMenu: function( ul, items ) {
		var that = this;
		$.each( items, function( index, item ) {
			that._renderItemData( ul, item );
		});
	},

	_renderItemData: function( ul, item ) {
		return this._renderItem( ul, item ).data( "ui-autocomplete-item", item );
	},

	_renderItem: function( ul, item ) {
		return $( "<li>" )
			.append( $( "<a>" ).text( item.label ) )
			.appendTo( ul );
	},

	_move: function( direction, event ) {
		if ( !this.menu.element.is( ":visible" ) ) {
			this.search( null, event );
			return;
		}
		if ( this.menu.isFirstItem() && /^previous/.test( direction ) ||
				this.menu.isLastItem() && /^next/.test( direction ) ) {
			this._value( this.term );
			this.menu.blur();
			return;
		}
		this.menu[ direction ]( event );
	},

	widget: function() {
		return this.menu.element;
	},

	_value: function() {
		return this.valueMethod.apply( this.element, arguments );
	},

	_keyEvent: function( keyEvent, event ) {
		if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
			this._move( keyEvent, event );

			// prevents moving cursor to beginning/end of the text field in some browsers
			event.preventDefault();
		}
	}
});

$.extend( $.ui.autocomplete, {
	escapeRegex: function( value ) {
		return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
	},
	filter: function(array, term) {
		var matcher = new RegExp( $.ui.autocomplete.escapeRegex(term), "i" );
		return $.grep( array, function(value) {
			return matcher.test( value.label || value.value || value );
		});
	}
});


// live region extension, adding a `messages` option
// NOTE: This is an experimental API. We are still investigating
// a full solution for string manipulation and internationalization.
$.widget( "ui.autocomplete", $.ui.autocomplete, {
	options: {
		messages: {
			noResults: "No search results.",
			results: function( amount ) {
				return amount + ( amount > 1 ? " results are" : " result is" ) +
					" available, use up and down arrow keys to navigate.";
			}
		}
	},

	__response: function( content ) {
		var message;
		this._superApply( arguments );
		if ( this.options.disabled || this.cancelSearch ) {
			return;
		}
		if ( content && content.length ) {
			message = this.options.messages.results( content.length );
		} else {
			message = this.options.messages.noResults;
		}
		this.liveRegion.text( message );
	}
});

}( jQuery ));


/***/ }),
/* 2665 */
/***/ (function(module, exports) {

/*!
 * jQuery UI Menu 1.10.0
 * http://jqueryui.com
 *
 * Copyright 2013 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/menu/
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.widget.js
 *	jquery.ui.position.js
 */
(function( $, undefined ) {

$.widget( "ui.menu", {
	version: "1.10.0",
	defaultElement: "<ul>",
	delay: 300,
	options: {
		icons: {
			submenu: "ui-icon-carat-1-e"
		},
		menus: "ul",
		position: {
			my: "left top",
			at: "right top"
		},
		role: "menu",

		// callbacks
		blur: null,
		focus: null,
		select: null
	},

	_create: function() {
		this.activeMenu = this.element;
		// flag used to prevent firing of the click handler
		// as the event bubbles up through nested menus
		this.mouseHandled = false;
		this.element
			.uniqueId()
			.addClass( "ui-menu ui-widget ui-widget-content ui-corner-all" )
			.toggleClass( "ui-menu-icons", !!this.element.find( ".ui-icon" ).length )
			.attr({
				role: this.options.role,
				tabIndex: 0
			})
			// need to catch all clicks on disabled menu
			// not possible through _on
			.bind( "click" + this.eventNamespace, $.proxy(function( event ) {
				if ( this.options.disabled ) {
					event.preventDefault();
				}
			}, this ));

		if ( this.options.disabled ) {
			this.element
				.addClass( "ui-state-disabled" )
				.attr( "aria-disabled", "true" );
		}

		this._on({
			// Prevent focus from sticking to links inside menu after clicking
			// them (focus should always stay on UL during navigation).
			"mousedown .ui-menu-item > a": function( event ) {
				event.preventDefault();
			},
			"click .ui-state-disabled > a": function( event ) {
				event.preventDefault();
			},
			"click .ui-menu-item:has(a)": function( event ) {
				var target = $( event.target ).closest( ".ui-menu-item" );
				if ( !this.mouseHandled && target.not( ".ui-state-disabled" ).length ) {
					this.mouseHandled = true;

					this.select( event );
					// Open submenu on click
					if ( target.has( ".ui-menu" ).length ) {
						this.expand( event );
					} else if ( !this.element.is( ":focus" ) ) {
						// Redirect focus to the menu
						this.element.trigger( "focus", [ true ] );

						// If the active item is on the top level, let it stay active.
						// Otherwise, blur the active item since it is no longer visible.
						if ( this.active && this.active.parents( ".ui-menu" ).length === 1 ) {
							clearTimeout( this.timer );
						}
					}
				}
			},
			"mouseenter .ui-menu-item": function( event ) {
				var target = $( event.currentTarget );
				// Remove ui-state-active class from siblings of the newly focused menu item
				// to avoid a jump caused by adjacent elements both having a class with a border
				target.siblings().children( ".ui-state-active" ).removeClass( "ui-state-active" );
				this.focus( event, target );
			},
			mouseleave: "collapseAll",
			"mouseleave .ui-menu": "collapseAll",
			focus: function( event, keepActiveItem ) {
				// If there's already an active item, keep it active
				// If not, activate the first item
				var item = this.active || this.element.children( ".ui-menu-item" ).eq( 0 );

				if ( !keepActiveItem ) {
					this.focus( event, item );
				}
			},
			blur: function( event ) {
				this._delay(function() {
					if ( !$.contains( this.element[0], this.document[0].activeElement ) ) {
						this.collapseAll( event );
					}
				});
			},
			keydown: "_keydown"
		});

		this.refresh();

		// Clicks outside of a menu collapse any open menus
		this._on( this.document, {
			click: function( event ) {
				if ( !$( event.target ).closest( ".ui-menu" ).length ) {
					this.collapseAll( event );
				}

				// Reset the mouseHandled flag
				this.mouseHandled = false;
			}
		});
	},

	_destroy: function() {
		// Destroy (sub)menus
		this.element
			.removeAttr( "aria-activedescendant" )
			.find( ".ui-menu" ).addBack()
				.removeClass( "ui-menu ui-widget ui-widget-content ui-corner-all ui-menu-icons" )
				.removeAttr( "role" )
				.removeAttr( "tabIndex" )
				.removeAttr( "aria-labelledby" )
				.removeAttr( "aria-expanded" )
				.removeAttr( "aria-hidden" )
				.removeAttr( "aria-disabled" )
				.removeUniqueId()
				.show();

		// Destroy menu items
		this.element.find( ".ui-menu-item" )
			.removeClass( "ui-menu-item" )
			.removeAttr( "role" )
			.removeAttr( "aria-disabled" )
			.children( "a" )
				.removeUniqueId()
				.removeClass( "ui-corner-all ui-state-hover" )
				.removeAttr( "tabIndex" )
				.removeAttr( "role" )
				.removeAttr( "aria-haspopup" )
				.children().each( function() {
					var elem = $( this );
					if ( elem.data( "ui-menu-submenu-carat" ) ) {
						elem.remove();
					}
				});

		// Destroy menu dividers
		this.element.find( ".ui-menu-divider" ).removeClass( "ui-menu-divider ui-widget-content" );
	},

	_keydown: function( event ) {
		/*jshint maxcomplexity:20*/
		var match, prev, character, skip, regex,
			preventDefault = true;

		function escape( value ) {
			return value.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" );
		}

		switch ( event.keyCode ) {
		case $.ui.keyCode.PAGE_UP:
			this.previousPage( event );
			break;
		case $.ui.keyCode.PAGE_DOWN:
			this.nextPage( event );
			break;
		case $.ui.keyCode.HOME:
			this._move( "first", "first", event );
			break;
		case $.ui.keyCode.END:
			this._move( "last", "last", event );
			break;
		case $.ui.keyCode.UP:
			this.previous( event );
			break;
		case $.ui.keyCode.DOWN:
			this.next( event );
			break;
		case $.ui.keyCode.LEFT:
			this.collapse( event );
			break;
		case $.ui.keyCode.RIGHT:
			if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
				this.expand( event );
			}
			break;
		case $.ui.keyCode.ENTER:
		case $.ui.keyCode.SPACE:
			this._activate( event );
			break;
		case $.ui.keyCode.ESCAPE:
			this.collapse( event );
			break;
		default:
			preventDefault = false;
			prev = this.previousFilter || "";
			character = String.fromCharCode( event.keyCode );
			skip = false;

			clearTimeout( this.filterTimer );

			if ( character === prev ) {
				skip = true;
			} else {
				character = prev + character;
			}

			regex = new RegExp( "^" + escape( character ), "i" );
			match = this.activeMenu.children( ".ui-menu-item" ).filter(function() {
				return regex.test( $( this ).children( "a" ).text() );
			});
			match = skip && match.index( this.active.next() ) !== -1 ?
				this.active.nextAll( ".ui-menu-item" ) :
				match;

			// If no matches on the current filter, reset to the last character pressed
			// to move down the menu to the first item that starts with that character
			if ( !match.length ) {
				character = String.fromCharCode( event.keyCode );
				regex = new RegExp( "^" + escape( character ), "i" );
				match = this.activeMenu.children( ".ui-menu-item" ).filter(function() {
					return regex.test( $( this ).children( "a" ).text() );
				});
			}

			if ( match.length ) {
				this.focus( event, match );
				if ( match.length > 1 ) {
					this.previousFilter = character;
					this.filterTimer = this._delay(function() {
						delete this.previousFilter;
					}, 1000 );
				} else {
					delete this.previousFilter;
				}
			} else {
				delete this.previousFilter;
			}
		}

		if ( preventDefault ) {
			event.preventDefault();
		}
	},

	_activate: function( event ) {
		if ( !this.active.is( ".ui-state-disabled" ) ) {
			if ( this.active.children( "a[aria-haspopup='true']" ).length ) {
				this.expand( event );
			} else {
				this.select( event );
			}
		}
	},

	refresh: function() {
		var menus,
			icon = this.options.icons.submenu,
			submenus = this.element.find( this.options.menus );

		// Initialize nested menus
		submenus.filter( ":not(.ui-menu)" )
			.addClass( "ui-menu ui-widget ui-widget-content ui-corner-all" )
			.hide()
			.attr({
				role: this.options.role,
				"aria-hidden": "true",
				"aria-expanded": "false"
			})
			.each(function() {
				var menu = $( this ),
					item = menu.prev( "a" ),
					submenuCarat = $( "<span>" )
						.addClass( "ui-menu-icon ui-icon " + icon )
						.data( "ui-menu-submenu-carat", true );

				item
					.attr( "aria-haspopup", "true" )
					.prepend( submenuCarat );
				menu.attr( "aria-labelledby", item.attr( "id" ) );
			});

		menus = submenus.add( this.element );

		// Don't refresh list items that are already adapted
		menus.children( ":not(.ui-menu-item):has(a)" )
			.addClass( "ui-menu-item" )
			.attr( "role", "presentation" )
			.children( "a" )
				.uniqueId()
				.addClass( "ui-corner-all" )
				.attr({
					tabIndex: -1,
					role: this._itemRole()
				});

		// Initialize unlinked menu-items containing spaces and/or dashes only as dividers
		menus.children( ":not(.ui-menu-item)" ).each(function() {
			var item = $( this );
			// hyphen, em dash, en dash
			if ( !/[^\-—–\s]/.test( item.text() ) ) {
				item.addClass( "ui-widget-content ui-menu-divider" );
			}
		});

		// Add aria-disabled attribute to any disabled menu item
		menus.children( ".ui-state-disabled" ).attr( "aria-disabled", "true" );

		// If the active item has been removed, blur the menu
		if ( this.active && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
			this.blur();
		}
	},

	_itemRole: function() {
		return {
			menu: "menuitem",
			listbox: "option"
		}[ this.options.role ];
	},

	_setOption: function( key, value ) {
		if ( key === "icons" ) {
			this.element.find( ".ui-menu-icon" )
				.removeClass( this.options.icons.submenu )
				.addClass( value.submenu );
		}
		this._super( key, value );
	},

	focus: function( event, item ) {
		var nested, focused;
		this.blur( event, event && event.type === "focus" );

		this._scrollIntoView( item );

		this.active = item.first();
		focused = this.active.children( "a" ).addClass( "ui-state-focus" );
		// Only update aria-activedescendant if there's a role
		// otherwise we assume focus is managed elsewhere
		if ( this.options.role ) {
			this.element.attr( "aria-activedescendant", focused.attr( "id" ) );
		}

		// Highlight active parent menu item, if any
		this.active
			.parent()
			.closest( ".ui-menu-item" )
			.children( "a:first" )
			.addClass( "ui-state-active" );

		if ( event && event.type === "keydown" ) {
			this._close();
		} else {
			this.timer = this._delay(function() {
				this._close();
			}, this.delay );
		}

		nested = item.children( ".ui-menu" );
		if ( nested.length && ( /^mouse/.test( event.type ) ) ) {
			this._startOpening(nested);
		}
		this.activeMenu = item.parent();

		this._trigger( "focus", event, { item: item } );
	},

	_scrollIntoView: function( item ) {
		var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
		if ( this._hasScroll() ) {
			borderTop = parseFloat( $.css( this.activeMenu[0], "borderTopWidth" ) ) || 0;
			paddingTop = parseFloat( $.css( this.activeMenu[0], "paddingTop" ) ) || 0;
			offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop;
			scroll = this.activeMenu.scrollTop();
			elementHeight = this.activeMenu.height();
			itemHeight = item.height();

			if ( offset < 0 ) {
				this.activeMenu.scrollTop( scroll + offset );
			} else if ( offset + itemHeight > elementHeight ) {
				this.activeMenu.scrollTop( scroll + offset - elementHeight + itemHeight );
			}
		}
	},

	blur: function( event, fromFocus ) {
		if ( !fromFocus ) {
			clearTimeout( this.timer );
		}

		if ( !this.active ) {
			return;
		}

		this.active.children( "a" ).removeClass( "ui-state-focus" );
		this.active = null;

		this._trigger( "blur", event, { item: this.active } );
	},

	_startOpening: function( submenu ) {
		clearTimeout( this.timer );

		// Don't open if already open fixes a Firefox bug that caused a .5 pixel
		// shift in the submenu position when mousing over the carat icon
		if ( submenu.attr( "aria-hidden" ) !== "true" ) {
			return;
		}

		this.timer = this._delay(function() {
			this._close();
			this._open( submenu );
		}, this.delay );
	},

	_open: function( submenu ) {
		var position = $.extend({
			of: this.active
		}, this.options.position );

		clearTimeout( this.timer );
		this.element.find( ".ui-menu" ).not( submenu.parents( ".ui-menu" ) )
			.hide()
			.attr( "aria-hidden", "true" );

		submenu
			.show()
			.removeAttr( "aria-hidden" )
			.attr( "aria-expanded", "true" )
			.position( position );
	},

	collapseAll: function( event, all ) {
		clearTimeout( this.timer );
		this.timer = this._delay(function() {
			// If we were passed an event, look for the submenu that contains the event
			var currentMenu = all ? this.element :
				$( event && event.target ).closest( this.element.find( ".ui-menu" ) );

			// If we found no valid submenu ancestor, use the main menu to close all sub menus anyway
			if ( !currentMenu.length ) {
				currentMenu = this.element;
			}

			this._close( currentMenu );

			this.blur( event );
			this.activeMenu = currentMenu;
		}, this.delay );
	},

	// With no arguments, closes the currently active menu - if nothing is active
	// it closes all menus.  If passed an argument, it will search for menus BELOW
	_close: function( startMenu ) {
		if ( !startMenu ) {
			startMenu = this.active ? this.active.parent() : this.element;
		}

		startMenu
			.find( ".ui-menu" )
				.hide()
				.attr( "aria-hidden", "true" )
				.attr( "aria-expanded", "false" )
			.end()
			.find( "a.ui-state-active" )
				.removeClass( "ui-state-active" );
	},

	collapse: function( event ) {
		var newItem = this.active &&
			this.active.parent().closest( ".ui-menu-item", this.element );
		if ( newItem && newItem.length ) {
			this._close();
			this.focus( event, newItem );
		}
	},

	expand: function( event ) {
		var newItem = this.active &&
			this.active
				.children( ".ui-menu " )
				.children( ".ui-menu-item" )
				.first();

		if ( newItem && newItem.length ) {
			this._open( newItem.parent() );

			// Delay so Firefox will not hide activedescendant change in expanding submenu from AT
			this._delay(function() {
				this.focus( event, newItem );
			});
		}
	},

	next: function( event ) {
		this._move( "next", "first", event );
	},

	previous: function( event ) {
		this._move( "prev", "last", event );
	},

	isFirstItem: function() {
		return this.active && !this.active.prevAll( ".ui-menu-item" ).length;
	},

	isLastItem: function() {
		return this.active && !this.active.nextAll( ".ui-menu-item" ).length;
	},

	_move: function( direction, filter, event ) {
		var next;
		if ( this.active ) {
			if ( direction === "first" || direction === "last" ) {
				next = this.active
					[ direction === "first" ? "prevAll" : "nextAll" ]( ".ui-menu-item" )
					.eq( -1 );
			} else {
				next = this.active
					[ direction + "All" ]( ".ui-menu-item" )
					.eq( 0 );
			}
		}
		if ( !next || !next.length || !this.active ) {
			next = this.activeMenu.children( ".ui-menu-item" )[ filter ]();
		}

		this.focus( event, next );
	},

	nextPage: function( event ) {
		var item, base, height;

		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isLastItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.height();
			this.active.nextAll( ".ui-menu-item" ).each(function() {
				item = $( this );
				return item.offset().top - base - height < 0;
			});

			this.focus( event, item );
		} else {
			this.focus( event, this.activeMenu.children( ".ui-menu-item" )
				[ !this.active ? "first" : "last" ]() );
		}
	},

	previousPage: function( event ) {
		var item, base, height;
		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isFirstItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.height();
			this.active.prevAll( ".ui-menu-item" ).each(function() {
				item = $( this );
				return item.offset().top - base + height > 0;
			});

			this.focus( event, item );
		} else {
			this.focus( event, this.activeMenu.children( ".ui-menu-item" ).first() );
		}
	},

	_hasScroll: function() {
		return this.element.outerHeight() < this.element.prop( "scrollHeight" );
	},

	select: function( event ) {
		// TODO: It should never be possible to not have an active item at this
		// point, but the tests don't trigger mouseenter before click.
		this.active = this.active || $( event.target ).closest( ".ui-menu-item" );
		var ui = { item: this.active };
		if ( !this.active.has( ".ui-menu" ).length ) {
			this.collapseAll( event, true );
		}
		this._trigger( "select", event, ui );
	}
});

}( jQuery ));


/***/ }),
/* 2666 */
/***/ (function(module, exports) {

/*!
 * jQuery UI Tooltip 1.10.0
 * http://jqueryui.com
 *
 * Copyright 2013 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/tooltip/
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.widget.js
 *	jquery.ui.position.js
 */
(function( $ ) {

var increments = 0;

function addDescribedBy( elem, id ) {
	var describedby = (elem.attr( "aria-describedby" ) || "").split( /\s+/ );
	describedby.push( id );
	elem
		.data( "ui-tooltip-id", id )
		.attr( "aria-describedby", $.trim( describedby.join( " " ) ) );
}

function removeDescribedBy( elem ) {
	var id = elem.data( "ui-tooltip-id" ),
		describedby = (elem.attr( "aria-describedby" ) || "").split( /\s+/ ),
		index = $.inArray( id, describedby );
	if ( index !== -1 ) {
		describedby.splice( index, 1 );
	}

	elem.removeData( "ui-tooltip-id" );
	describedby = $.trim( describedby.join( " " ) );
	if ( describedby ) {
		elem.attr( "aria-describedby", describedby );
	} else {
		elem.removeAttr( "aria-describedby" );
	}
}

$.widget( "ui.tooltip", {
	version: "1.10.0",
	options: {
		content: function() {
			// support: IE<9, Opera in jQuery <1.7
			// .text() can't accept undefined, so coerce to a string
			var title = $( this ).attr( "title" ) || "";
			// Escape title, since we're going from an attribute to raw HTML
			return $( "<a>" ).text( title ).html();
		},
		hide: true,
		// Disabled elements have inconsistent behavior across browsers (#8661)
		items: "[title]:not([disabled])",
		position: {
			my: "left top+15",
			at: "left bottom",
			collision: "flipfit flip"
		},
		show: true,
		tooltipClass: null,
		track: false,

		// callbacks
		close: null,
		open: null
	},

	_create: function() {
		this._on({
			mouseover: "open",
			focusin: "open"
		});

		// IDs of generated tooltips, needed for destroy
		this.tooltips = {};
		// IDs of parent tooltips where we removed the title attribute
		this.parents = {};

		if ( this.options.disabled ) {
			this._disable();
		}
	},

	_setOption: function( key, value ) {
		var that = this;

		if ( key === "disabled" ) {
			this[ value ? "_disable" : "_enable" ]();
			this.options[ key ] = value;
			// disable element style changes
			return;
		}

		this._super( key, value );

		if ( key === "content" ) {
			$.each( this.tooltips, function( id, element ) {
				that._updateContent( element );
			});
		}
	},

	_disable: function() {
		var that = this;

		// close open tooltips
		$.each( this.tooltips, function( id, element ) {
			var event = $.Event( "blur" );
			event.target = event.currentTarget = element[0];
			that.close( event, true );
		});

		// remove title attributes to prevent native tooltips
		this.element.find( this.options.items ).addBack().each(function() {
			var element = $( this );
			if ( element.is( "[title]" ) ) {
				element
					.data( "ui-tooltip-title", element.attr( "title" ) )
					.attr( "title", "" );
			}
		});
	},

	_enable: function() {
		// restore title attributes
		this.element.find( this.options.items ).addBack().each(function() {
			var element = $( this );
			if ( element.data( "ui-tooltip-title" ) ) {
				element.attr( "title", element.data( "ui-tooltip-title" ) );
			}
		});
	},

	open: function( event ) {
		var that = this,
			target = $( event ? event.target : this.element )
				// we need closest here due to mouseover bubbling,
				// but always pointing at the same event target
				.closest( this.options.items );

		// No element to show a tooltip for or the tooltip is already open
		if ( !target.length || target.data( "ui-tooltip-id" ) ) {
			return;
		}

		if ( target.attr( "title" ) ) {
			target.data( "ui-tooltip-title", target.attr( "title" ) );
		}

		target.data( "ui-tooltip-open", true );

		// kill parent tooltips, custom or native, for hover
		if ( event && event.type === "mouseover" ) {
			target.parents().each(function() {
				var parent = $( this ),
					blurEvent;
				if ( parent.data( "ui-tooltip-open" ) ) {
					blurEvent = $.Event( "blur" );
					blurEvent.target = blurEvent.currentTarget = this;
					that.close( blurEvent, true );
				}
				if ( parent.attr( "title" ) ) {
					parent.uniqueId();
					that.parents[ this.id ] = {
						element: this,
						title: parent.attr( "title" )
					};
					parent.attr( "title", "" );
				}
			});
		}

		this._updateContent( target, event );
	},

	_updateContent: function( target, event ) {
		var content,
			contentOption = this.options.content,
			that = this,
			eventType = event ? event.type : null;

		if ( typeof contentOption === "string" ) {
			return this._open( event, target, contentOption );
		}

		content = contentOption.call( target[0], function( response ) {
			// ignore async response if tooltip was closed already
			if ( !target.data( "ui-tooltip-open" ) ) {
				return;
			}
			// IE may instantly serve a cached response for ajax requests
			// delay this call to _open so the other call to _open runs first
			that._delay(function() {
				// jQuery creates a special event for focusin when it doesn't
				// exist natively. To improve performance, the native event
				// object is reused and the type is changed. Therefore, we can't
				// rely on the type being correct after the event finished
				// bubbling, so we set it back to the previous value. (#8740)
				if ( event ) {
					event.type = eventType;
				}
				this._open( event, target, response );
			});
		});
		if ( content ) {
			this._open( event, target, content );
		}
	},

	_open: function( event, target, content ) {
		var tooltip, events, delayedShow,
			positionOption = $.extend( {}, this.options.position );

		if ( !content ) {
			return;
		}

		// Content can be updated multiple times. If the tooltip already
		// exists, then just update the content and bail.
		tooltip = this._find( target );
		if ( tooltip.length ) {
			tooltip.find( ".ui-tooltip-content" ).html( content );
			return;
		}

		// if we have a title, clear it to prevent the native tooltip
		// we have to check first to avoid defining a title if none exists
		// (we don't want to cause an element to start matching [title])
		//
		// We use removeAttr only for key events, to allow IE to export the correct
		// accessible attributes. For mouse events, set to empty string to avoid
		// native tooltip showing up (happens only when removing inside mouseover).
		if ( target.is( "[title]" ) ) {
			if ( event && event.type === "mouseover" ) {
				target.attr( "title", "" );
			} else {
				target.removeAttr( "title" );
			}
		}

		tooltip = this._tooltip( target );
		addDescribedBy( target, tooltip.attr( "id" ) );
		tooltip.find( ".ui-tooltip-content" ).html( content );

		function position( event ) {
			positionOption.of = event;
			if ( tooltip.is( ":hidden" ) ) {
				return;
			}
			tooltip.position( positionOption );
		}
		if ( this.options.track && event && /^mouse/.test( event.type ) ) {
			this._on( this.document, {
				mousemove: position
			});
			// trigger once to override element-relative positioning
			position( event );
		} else {
			tooltip.position( $.extend({
				of: target
			}, this.options.position ) );
		}

		tooltip.hide();

		this._show( tooltip, this.options.show );
		// Handle tracking tooltips that are shown with a delay (#8644). As soon
		// as the tooltip is visible, position the tooltip using the most recent
		// event.
		if ( this.options.show && this.options.show.delay ) {
			delayedShow = this.delayedShow = setInterval(function() {
				if ( tooltip.is( ":visible" ) ) {
					position( positionOption.of );
					clearInterval( delayedShow );
				}
			}, $.fx.interval );
		}

		this._trigger( "open", event, { tooltip: tooltip } );

		events = {
			keyup: function( event ) {
				if ( event.keyCode === $.ui.keyCode.ESCAPE ) {
					var fakeEvent = $.Event(event);
					fakeEvent.currentTarget = target[0];
					this.close( fakeEvent, true );
				}
			},
			remove: function() {
				this._removeTooltip( tooltip );
			}
		};
		if ( !event || event.type === "mouseover" ) {
			events.mouseleave = "close";
		}
		if ( !event || event.type === "focusin" ) {
			events.focusout = "close";
		}
		this._on( true, target, events );
	},

	close: function( event ) {
		var that = this,
			target = $( event ? event.currentTarget : this.element ),
			tooltip = this._find( target );

		// disabling closes the tooltip, so we need to track when we're closing
		// to avoid an infinite loop in case the tooltip becomes disabled on close
		if ( this.closing ) {
			return;
		}

		// Clear the interval for delayed tracking tooltips
		clearInterval( this.delayedShow );

		// only set title if we had one before (see comment in _open())
		if ( target.data( "ui-tooltip-title" ) ) {
			target.attr( "title", target.data( "ui-tooltip-title" ) );
		}

		removeDescribedBy( target );

		tooltip.stop( true );
		this._hide( tooltip, this.options.hide, function() {
			that._removeTooltip( $( this ) );
		});

		target.removeData( "ui-tooltip-open" );
		this._off( target, "mouseleave focusout keyup" );
		// Remove 'remove' binding only on delegated targets
		if ( target[0] !== this.element[0] ) {
			this._off( target, "remove" );
		}
		this._off( this.document, "mousemove" );

		if ( event && event.type === "mouseleave" ) {
			$.each( this.parents, function( id, parent ) {
				$( parent.element ).attr( "title", parent.title );
				delete that.parents[ id ];
			});
		}

		this.closing = true;
		this._trigger( "close", event, { tooltip: tooltip } );
		this.closing = false;
	},

	_tooltip: function( element ) {
		var id = "ui-tooltip-" + increments++,
			tooltip = $( "<div>" )
				.attr({
					id: id,
					role: "tooltip"
				})
				.addClass( "ui-tooltip ui-widget ui-corner-all ui-widget-content " +
					( this.options.tooltipClass || "" ) );
		$( "<div>" )
			.addClass( "ui-tooltip-content" )
			.appendTo( tooltip );
		tooltip.appendTo( this.document[0].body );
		this.tooltips[ id ] = element;
		return tooltip;
	},

	_find: function( target ) {
		var id = target.data( "ui-tooltip-id" );
		return id ? $( "#" + id ) : $();
	},

	_removeTooltip: function( tooltip ) {
		tooltip.remove();
		delete this.tooltips[ tooltip.attr( "id" ) ];
	},

	_destroy: function() {
		var that = this;

		// close open tooltips
		$.each( this.tooltips, function( id, element ) {
			// Delegate to close method to handle common cleanup
			var event = $.Event( "blur" );
			event.target = event.currentTarget = element[0];
			that.close( event, true );

			// Remove immediately; destroying an open tooltip doesn't use the
			// hide animation
			$( "#" + id ).remove();

			// Restore the title
			if ( element.data( "ui-tooltip-title" ) ) {
				element.attr( "title", element.data( "ui-tooltip-title" ) );
				element.removeData( "ui-tooltip-title" );
			}
		});
	}
});

}( jQuery ) );


/***/ }),
/* 2667 */,
/* 2668 */,
/* 2669 */,
/* 2670 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),
/* 2671 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var keys = __webpack_require__(2672),
    rest = __webpack_require__(816);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : source[key];

    assignValue(object, key, newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return rest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a
 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
 * Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'user': 'fred' };
 * var other = { 'user': 'fred' };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.c = 3;
 * }
 *
 * function Bar() {
 *   this.e = 5;
 * }
 *
 * Foo.prototype.d = 4;
 * Bar.prototype.f = 6;
 *
 * _.assign({ 'a': 1 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3, 'e': 5 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 2672 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 2673 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2695);
__webpack_require__(2698);
__webpack_require__(2694);
__webpack_require__(2692);
__webpack_require__(2693);
__webpack_require__(2696);
__webpack_require__(2697);
module.exports = __webpack_require__(4221).Object;

/***/ }),
/* 2674 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1975);
__webpack_require__(1964);
__webpack_require__(1558);
__webpack_require__(2687);
module.exports = __webpack_require__(674).Promise;

/***/ }),
/* 2675 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1975);
__webpack_require__(1964);
__webpack_require__(1558);
__webpack_require__(2688);
__webpack_require__(2690);
module.exports = __webpack_require__(674).Set;

/***/ }),
/* 2676 */,
/* 2677 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(1223);

module.exports = function(iter, ITERATOR){
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 2678 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(566)
  , isArray  = __webpack_require__(4234)
  , SPECIES  = __webpack_require__(585)('species');

module.exports = function(original){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return C === undefined ? Array : C;
};

/***/ }),
/* 2679 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(2678);

module.exports = function(original, length){
  return new (speciesConstructor(original))(length);
};

/***/ }),
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP          = __webpack_require__(600).f
  , create      = __webpack_require__(4211)
  , redefineAll = __webpack_require__(1468)
  , ctx         = __webpack_require__(1428)
  , anInstance  = __webpack_require__(1467)
  , defined     = __webpack_require__(4209)
  , forOf       = __webpack_require__(1223)
  , $iterDefine = __webpack_require__(4217)
  , step        = __webpack_require__(4237)
  , setSpecies  = __webpack_require__(2064)
  , DESCRIPTORS = __webpack_require__(1979)
  , fastKey     = __webpack_require__(1556).fastKey
  , SIZE        = DESCRIPTORS ? '_s' : 'size';

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        anInstance(this, C, 'forEach');
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)dP(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),
/* 2681 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(2315)
  , from    = __webpack_require__(2677);
module.exports = function(NAME){
  return function toJSON(){
    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

/***/ }),
/* 2682 */,
/* 2683 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),
/* 2684 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(1438)
  , macrotask = __webpack_require__(2065).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__(2308)(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};

/***/ }),
/* 2685 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__(1560)
  , aFunction = __webpack_require__(2314)
  , SPECIES   = __webpack_require__(585)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 2686 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(1560)
  , get      = __webpack_require__(2316);
module.exports = __webpack_require__(674).getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),
/* 2687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY            = __webpack_require__(4210)
  , global             = __webpack_require__(1438)
  , ctx                = __webpack_require__(1428)
  , classof            = __webpack_require__(2315)
  , $export            = __webpack_require__(1978)
  , isObject           = __webpack_require__(566)
  , aFunction          = __webpack_require__(2314)
  , anInstance         = __webpack_require__(1467)
  , forOf              = __webpack_require__(1223)
  , speciesConstructor = __webpack_require__(2685)
  , task               = __webpack_require__(2065).set
  , microtask          = __webpack_require__(2684)()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[__webpack_require__(585)('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(1468)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
__webpack_require__(2309)($Promise, PROMISE);
__webpack_require__(2064)(PROMISE);
Wrapper = __webpack_require__(674)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(4236)(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});

/***/ }),
/* 2688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(2680);

// 23.2 Set Objects
module.exports = __webpack_require__(2063)('Set', function(get){
  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value){
    return strong.def(this, value = value === 0 ? 0 : value, value);
  }
}, strong);

/***/ }),
/* 2689 */,
/* 2690 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(1978);

$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(2681)('Set')});

/***/ }),
/* 2691 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN     = __webpack_require__(4212)
  , gOPS     = __webpack_require__(4213)
  , anObject = __webpack_require__(4239)
  , Reflect  = __webpack_require__(2312).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
  var keys       = gOPN.f(anObject(it))
    , getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

/***/ }),
/* 2692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export         = __webpack_require__(1105)
  , toObject        = __webpack_require__(1559)
  , aFunction       = __webpack_require__(2321)
  , $defineProperty = __webpack_require__(2313);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(1557) && $export($export.P + __webpack_require__(1469), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter){
    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
  }
});

/***/ }),
/* 2693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export         = __webpack_require__(1105)
  , toObject        = __webpack_require__(1559)
  , aFunction       = __webpack_require__(2321)
  , $defineProperty = __webpack_require__(2313);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(1557) && $export($export.P + __webpack_require__(1469), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter){
    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
  }
});

/***/ }),
/* 2694 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export  = __webpack_require__(1105)
  , $entries = __webpack_require__(2066)(true);

$export($export.S, 'Object', {
  entries: function entries(it){
    return $entries(it);
  }
});

/***/ }),
/* 2695 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export        = __webpack_require__(1105)
  , ownKeys        = __webpack_require__(2691)
  , toIObject      = __webpack_require__(2317)
  , gOPD           = __webpack_require__(1963)
  , createProperty = __webpack_require__(4219);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
    var O       = toIObject(object)
      , getDesc = gOPD.f
      , keys    = ownKeys(O)
      , result  = {}
      , i       = 0
      , key;
    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
    return result;
  }
});

/***/ }),
/* 2696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export                  = __webpack_require__(1105)
  , toObject                 = __webpack_require__(1559)
  , toPrimitive              = __webpack_require__(2322)
  , getPrototypeOf           = __webpack_require__(2310)
  , getOwnPropertyDescriptor = __webpack_require__(1963).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(1557) && $export($export.P + __webpack_require__(1469), 'Object', {
  __lookupGetter__: function __lookupGetter__(P){
    var O = toObject(this)
      , K = toPrimitive(P, true)
      , D;
    do {
      if(D = getOwnPropertyDescriptor(O, K))return D.get;
    } while(O = getPrototypeOf(O));
  }
});

/***/ }),
/* 2697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export                  = __webpack_require__(1105)
  , toObject                 = __webpack_require__(1559)
  , toPrimitive              = __webpack_require__(2322)
  , getPrototypeOf           = __webpack_require__(2310)
  , getOwnPropertyDescriptor = __webpack_require__(1963).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(1557) && $export($export.P + __webpack_require__(1469), 'Object', {
  __lookupSetter__: function __lookupSetter__(P){
    var O = toObject(this)
      , K = toPrimitive(P, true)
      , D;
    do {
      if(D = getOwnPropertyDescriptor(O, K))return D.set;
    } while(O = getPrototypeOf(O));
  }
});

/***/ }),
/* 2698 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1105)
  , $values = __webpack_require__(2066)(false);

$export($export.S, 'Object', {
  values: function values(it){
    return $values(it);
  }
});

/***/ }),
/* 2699 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {
	        function F() {}

	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                F.prototype = this;
	                var subtype = new F();

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init')) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),
/* 2700 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2699));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));

/***/ }),
/* 2701 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {//
//  Backbone-associations.js 0.5.4
//
//  (c) 2013 Dhruva Ray, Jaynti Kanani, Persistent Systems Ltd.
//  Backbone-associations may be freely distributed under the MIT license.
//  For all details and documentation:
//  https://github.com/dhruvaray/backbone-associations/
//

// COPIED from backbone-associations, minor tweak to export as a function that takes in instance of Backbone instead
// of requiring Backbone.
// - Ron W.
// --------------
module.exports = function (Backbone) {
    "use strict";

    // Save a reference to the global object (`window` in the browser, `exports`
    // on the server).
    var root = global;

    // The top-level namespace. All public Backbone classes and modules will be attached to this.
    // Exported for the browser and CommonJS.
    var _, Backbone, BackboneModel, BackboneCollection, ModelProto,
        CollectionProto, defaultEvents, AssociatedModel, pathChecker,
        collectionEvents, delimiters, pathSeparator;

    _ = root._ || __webpack_require__(22);

    // Create local reference `Model` prototype.
    BackboneModel = Backbone.Model;
    BackboneCollection = Backbone.Collection;
    ModelProto = BackboneModel.prototype;
    CollectionProto = BackboneCollection.prototype;

    // Built-in Backbone `events`.
    defaultEvents = ["change", "add", "remove", "reset", "sort", "destroy"];
    collectionEvents = ["reset", "sort"];

    Backbone.Associations = {
        VERSION: "0.5.4"
    };

    // Define `getter` and `setter` for `separator`
    var getSeparator = function() {
        return pathSeparator;
    };
    // Define `setSeperator`
    var setSeparator = function(value) {
        if (!_.isString(value) || _.size(value) < 1) {
            value = ".";
        }
        // set private properties
        pathSeparator = value;
        pathChecker = new RegExp("[\\" + pathSeparator + "\\[\\]]+", "g");
        delimiters = new RegExp("[^\\" + pathSeparator + "\\[\\]]+", "g");
    };

    try {
        // Define `SEPERATOR` property to Backbone.Associations
        Object.defineProperty(Backbone.Associations, 'SEPARATOR', {
            enumerable: true,
            get: getSeparator,
            set: setSeparator
        });
    } catch (e) {}

    // Backbone.AssociatedModel
    // --------------

    //Add `Many` and `One` relations to Backbone Object.
    Backbone.Associations.Many = Backbone.Many = "Many";
    Backbone.Associations.One = Backbone.One = "One";
    Backbone.Associations.Self = Backbone.Self = "Self";
    // Set default separator
    Backbone.Associations.SEPARATOR = ".";
    Backbone.Associations.getSeparator = getSeparator;
    Backbone.Associations.setSeparator = setSeparator;
    setSeparator();
    // Define `AssociatedModel` (Extends Backbone.Model).
    AssociatedModel = Backbone.AssociatedModel = Backbone.Associations.AssociatedModel = BackboneModel.extend({
        // Define relations with Associated Model.
        relations:undefined,
        // Define `Model` property which can keep track of already fired `events`,
        // and prevent redundant event to be triggered in case of cyclic model graphs.
        _proxyCalls:undefined,

        // Get the value of an attribute.
        get:function (attr) {
            var obj = ModelProto.get.call(this, attr);
            return obj ? obj : this._getAttr.apply(this, arguments);
        },

        // Set a hash of model attributes on the Backbone Model.
        set:function (key, value, options) {
            var attributes, result;
            // Duplicate backbone's behavior to allow separate key/value parameters,
            // instead of a single 'attributes' object.
            if (_.isObject(key) || key == null) {
                attributes = key;
                options = value;
            } else {
                attributes = {};
                attributes[key] = value;
            }
            result = this._set(attributes, options);
            // Trigger events which have been blocked until the entire object graph is updated.
            this._processPendingEvents();
            return result;

        },

        // Works with an attribute hash and options + fully qualified paths
        _set:function (attributes, options) {
            var attr, modelMap, modelId, obj, result = this;
            if (!attributes) return this;
            for (attr in attributes) {
                //Create a map for each unique object whose attributes we want to set
                modelMap || (modelMap = {});
                if (attr.match(pathChecker)) {
                    var pathTokens = getPathArray(attr), initials = _.initial(pathTokens),
                        last = pathTokens[pathTokens.length - 1],
                        parentModel = this.get(initials);
                    if (parentModel instanceof AssociatedModel) {
                        obj = modelMap[parentModel.cid] || (modelMap[parentModel.cid] = {'model':parentModel, 'data':{}});
                        obj.data[last] = attributes[attr];
                    }
                } else {
                    obj = modelMap[this.cid] || (modelMap[this.cid] = {'model':this, 'data':{}});
                    obj.data[attr] = attributes[attr];
                }
            }

            if (modelMap) {
                for (modelId in modelMap) {
                    obj = modelMap[modelId];
                    this._setAttr.call(obj.model, obj.data, options) || (result = false);

                }
            } else {
                result = this._setAttr.call(this, attributes, options);
            }
            return result;

        },

        // Set a hash of model attributes on the object,
        // fire Backbone `event` with options.
        // It maintains relations between models during the set operation.
        // It also bubbles up child events to the parent.
        _setAttr:function (attributes, options) {
            var attr;
            // Extract attributes and options.
            options || (options = {});
            if (options.unset) for (attr in attributes) attributes[attr] = void 0;
            this.parents = this.parents || [];

            if (this.relations) {
                // Iterate over `this.relations` and `set` model and collection values
                // if `relations` are available.
                _.each(this.relations, function (relation) {
                    var relationKey = relation.key,
                        relatedModel = relation.relatedModel,
                        collectionType = relation.collectionType,
                        map = relation.map,
                        currVal = this.attributes[relationKey],
                        idKey = currVal && currVal.idAttribute,
                        val, relationOptions, data, relationValue, newCtx = false;

                    // Call function if relatedModel is implemented as a function
                    if (relatedModel && !(relatedModel.prototype instanceof BackboneModel))
                        relatedModel = _.isFunction(relatedModel) ?
                            relatedModel.call(this, relation, attributes) :
                            relatedModel;

                    // Get class if relation and map is stored as a string.
                    if (relatedModel && _.isString(relatedModel)) {
                        relatedModel = (relatedModel === Backbone.Self) ? this.constructor : map2Scope(relatedModel);
                    }
                    collectionType && _.isString(collectionType) && (collectionType = map2Scope(collectionType));
                    map && _.isString(map) && (map = map2Scope(map));
                    // Merge in `options` specific to this relation.
                    relationOptions = relation.options ? _.extend({}, relation.options, options) : options;

                    if ((!relatedModel) && (!collectionType))
                        throw new Error('specify either a relatedModel or collectionType');

                    if (attributes[relationKey]) {
                        // Get value of attribute with relation key in `val`.
                        val = _.result(attributes, relationKey);
                        // Map `val` if a transformation function is provided.
                        val = map ? map.call(this, val, collectionType ? collectionType : relatedModel) : val;

                        // If `relation.type` is `Backbone.Many`,
                        // Create `Backbone.Collection` with passed data and perform Backbone `set`.
                        if (relation.type === Backbone.Many) {
                            // `collectionType` of defined `relation` should be instance of `Backbone.Collection`.
                            if (collectionType && !collectionType.prototype instanceof BackboneCollection) {
                                throw new Error('collectionType must inherit from Backbone.Collection');
                            }

                            if (currVal) {
                                // Setting this flag will prevent events from firing immediately. That way clients
                                // will not get events until the entire object graph is updated.
                                currVal._deferEvents = true;

                                // Use Backbone.Collection's `reset` or smart `set` method
                                currVal[relationOptions.reset ? 'reset' : 'set'](
                                    val instanceof BackboneCollection ? val.models : val, relationOptions);

                                data = currVal;

                            } else {
                                newCtx = true;

                                if (val instanceof BackboneCollection) {
                                    data = val;
                                } else {
                                    data = collectionType ? new collectionType() : this._createCollection(relatedModel);
                                    data[relationOptions.reset ? 'reset' : 'set'](val, relationOptions);
                                }
                            }

                        } else if (relation.type === Backbone.One) {

                            if (!relatedModel)
                                throw new Error('specify a relatedModel for Backbone.One type');

                            if (!(relatedModel.prototype instanceof Backbone.AssociatedModel))
                                throw new Error('specify an AssociatedModel for Backbone.One type');

                            data = val instanceof AssociatedModel ? val : new relatedModel(val, relationOptions);
                            //Is the passed in data for the same key?
                            if (currVal && data.attributes[idKey] &&
                                currVal.attributes[idKey] === data.attributes[idKey]) {
                                // Setting this flag will prevent events from firing immediately. That way clients
                                // will not get events until the entire object graph is updated.
                                currVal._deferEvents = true;
                                // Perform the traditional `set` operation
                                currVal._set(val instanceof AssociatedModel ? val.attributes : val, relationOptions);
                                data = currVal;
                            } else {
                                newCtx = true;
                            }

                        } else {
                            throw new Error('type attribute must be specified and have the values Backbone.One or Backbone.Many');
                        }


                        attributes[relationKey] = data;
                        relationValue = data;

                        // Add proxy events to respective parents.
                        // Only add callback if not defined or new Ctx has been identified.
                        if (newCtx || (relationValue && !relationValue._proxyCallback)) {
                            relationValue._proxyCallback = function () {
                                return this._bubbleEvent.call(this, relationKey, relationValue, arguments);
                            };
                            relationValue.on("all", relationValue._proxyCallback, this);
                        }

                    }
                    //Distinguish between the value of undefined versus a set no-op
                    if (attributes.hasOwnProperty(relationKey)) {
                        //Maintain reverse pointers - a.k.a parents
                        var updated = attributes[relationKey];
                        var original = this.attributes[relationKey];
                        if (updated) {
                            updated.parents = updated.parents || [];
                            (_.indexOf(updated.parents, this) == -1) && updated.parents.push(this);
                        } else if (original && original.parents.length > 0) { // New value is undefined
                            original.parents = _.difference(original.parents, [this]);
                            // Don't bubble to this parent anymore
                            original._proxyCallback && original.off("all", original._proxyCallback, this);
                        }
                    }
                }, this);
            }
            // Return results for `BackboneModel.set`.
            return  ModelProto.set.call(this, attributes, options);
        },
        // Bubble-up event to `parent` Model
        _bubbleEvent:function (relationKey, relationValue, eventArguments) {
            var args = eventArguments,
                opt = args[0].split(":"),
                eventType = opt[0],
                catch_all = args[0] == "nested-change",
                eventObject = args[1],
                colObject = args[2],
                indexEventObject = -1,
                _proxyCalls = relationValue._proxyCalls,
                cargs,
                eventPath,
                basecolEventPath,
                isDefaultEvent = _.indexOf(defaultEvents, eventType) !== -1;

            //Short circuit the listen in to the nested-graph event
            if (catch_all) return;

            // Change the event name to a fully qualified path.
            _.size(opt) > 1 && (eventPath = opt[1]);

            if (_.indexOf(collectionEvents, eventType) !== -1) {
                colObject = eventObject;
            }

            // Find the specific object in the collection which has changed.
            if (relationValue instanceof BackboneCollection && isDefaultEvent && eventObject) {
                var pathTokens = getPathArray(eventPath),
                    initialTokens = _.initial(pathTokens), colModel;

                colModel = relationValue.find(function (model) {
                    if (eventObject === model) return true;
                    if (!model) return false;
                    var changedModel = model.get(initialTokens);

                    if ((changedModel instanceof AssociatedModel || changedModel instanceof BackboneCollection)
                        && eventObject === changedModel)
                        return true;

                    changedModel = model.get(pathTokens);

                    if ((changedModel instanceof AssociatedModel || changedModel instanceof BackboneCollection)
                        && eventObject === changedModel)
                        return true;

                    if (changedModel instanceof BackboneCollection && colObject
                        && colObject === changedModel)
                        return true;
                });
                colModel && (indexEventObject = relationValue.indexOf(colModel));
            }

            // Manipulate `eventPath`.
            eventPath = relationKey + ((indexEventObject !== -1 && (eventType === "change" || eventPath)) ?
                "[" + indexEventObject + "]" : "") + (eventPath ? pathSeparator + eventPath : "");

            // Short circuit collection * events
            if (/\[\*\]/g.test(eventPath)) return this;
            basecolEventPath = eventPath.replace(/\[\d+\]/g, '[*]');

            cargs = [];
            cargs.push.apply(cargs, args);
            cargs[0] = eventType + ":" + eventPath;

            // If event has been already triggered as result of same source `eventPath`,
            // no need to re-trigger event to prevent cycle.
            _proxyCalls = relationValue._proxyCalls = (_proxyCalls || {});
            if (this._isEventAvailable.call(this, _proxyCalls, eventPath)) return this;

            // Add `eventPath` in `_proxyCalls` to keep track of already triggered `event`.
            _proxyCalls[eventPath] = true;

            // Set up previous attributes correctly.
            if ("change" === eventType) {
                this._previousAttributes[relationKey] = relationValue._previousAttributes;
                this.changed[relationKey] = relationValue;
            }

            // Bubble up event to parent `model` with new changed arguments.
            this.trigger.apply(this, cargs);

            //Only fire for change. Not change:attribute
            if ("change" === eventType && this.get(eventPath) != args[2]) {
                var ncargs = ["nested-change", eventPath, args[1]];
                args[2] && ncargs.push(args[2]); //args[2] will be options if present
                this.trigger.apply(this, ncargs);
            }

            // Remove `eventPath` from `_proxyCalls`,
            // if `eventPath` and `_proxyCalls` are available,
            // which allow event to be triggered on for next operation of `set`.
            if (_proxyCalls && eventPath) delete _proxyCalls[eventPath];

            // Create a collection modified event with wild-card
            if (eventPath !== basecolEventPath) {
                cargs[0] = eventType + ":" + basecolEventPath;
                this.trigger.apply(this, cargs);
            }

            return this;
        },

        // Has event been fired from this source. Used to prevent event recursion in cyclic graphs
        _isEventAvailable:function (_proxyCalls, path) {
            return _.find(_proxyCalls, function (value, eventKey) {
                return path.indexOf(eventKey, path.length - eventKey.length) !== -1;
            });
        },

        // Returns New `collection` of type `relation.relatedModel`.
        _createCollection:function (type) {
            var collection, relatedModel = type;
            _.isString(relatedModel) && (relatedModel = map2Scope(relatedModel));
            // Creates new `Backbone.Collection` and defines model class.
            if (relatedModel && (relatedModel.prototype instanceof AssociatedModel) || _.isFunction(relatedModel)) {
                collection = new BackboneCollection();
                collection.model = relatedModel;
            } else {
                throw new Error('type must inherit from Backbone.AssociatedModel');
            }
            return collection;
        },

        // Process all pending events after the entire object graph has been updated
        _processPendingEvents:function () {
            if (!this._processedEvents) {
                this._processedEvents = true;

                this._deferEvents = false;

                // Trigger all pending events
                _.each(this._pendingEvents, function (e) {
                    e.c.trigger.apply(e.c, e.a);
                });

                this._pendingEvents = [];

                // Traverse down the object graph and call process pending events on sub-trees
                _.each(this.relations, function (relation) {
                    var val = this.attributes[relation.key];
                    val && val._processPendingEvents();
                }, this);

                delete this._processedEvents;
            }
        },

        // Override trigger to defer events in the object graph.
        trigger:function (name) {
            // Defer event processing
            if (this._deferEvents) {
                this._pendingEvents = this._pendingEvents || [];
                // Maintain a queue of pending events to trigger after the entire object graph is updated.
                this._pendingEvents.push({c:this, a:arguments});
            } else {
                ModelProto.trigger.apply(this, arguments);
            }
        },

        // The JSON representation of the model.
        toJSON:function (options) {
            var json = {}, aJson;
            json[this.idAttribute] = this.id;
            if (!this.visited) {
                this.visited = true;
                // Get json representation from `BackboneModel.toJSON`.
                json = ModelProto.toJSON.apply(this, arguments);
                // If `this.relations` is defined, iterate through each `relation`
                // and added it's json representation to parents' json representation.
                if (this.relations) {
                    _.each(this.relations, function (relation) {
                        var attr = this.attributes[relation.key];
                        if (attr) {
                            aJson = attr.toJSON ? attr.toJSON(options) : attr;
                            json[relation.key] = _.isArray(aJson) ? _.compact(aJson) : aJson;
                        }
                    }, this);
                }
                delete this.visited;
            }
            return json;
        },

        // Create a new model with identical attributes to this one.
        clone:function () {
            return new this.constructor(this.toJSON());
        },

        // Call this if you want to set an `AssociatedModel` to a falsy value like undefined/null directly.
        // Not calling this will leak memory and have wrong parents.
        // See test case "parent relations"
        cleanup:function () {
            _.each(this.relations, function (relation) {
                var val = this.attributes[relation.key];
                val && (val.parents = _.difference(val.parents, [this]));
            }, this);
            this.off();
        },

        // Navigate the path to the leaf object in the path to query for the attribute value
        _getAttr:function (path) {

            var result = this,
            //Tokenize the path
                attrs = getPathArray(path),
                key,
                i;
            if (_.size(attrs) < 1) return;
            for (i = 0; i < attrs.length; i++) {
                key = attrs[i];
                if (!result) break;
                //Navigate the path to get to the result
                result = result instanceof BackboneCollection
                    ? (isNaN(key) ? undefined : result.at(key))
                    : result.attributes[key];
            }
            return result;
        }
    });

    // Tokenize the fully qualified event path
    var getPathArray = function (path) {
        if (path === '') return [''];
        return _.isString(path) ? (path.match(delimiters)) : path || [];
    };

    var map2Scope = function (path) {
        return _.reduce(path.split(pathSeparator), function (memo, elem) {
            return memo[elem];
        }, root);
    };

    //Infer the relation from the collection's parents and find the appropriate map for the passed in `models`
    var map2models = function (parents, target, models) {
        var relation, surrogate;
        //Iterate over collection's parents
        _.find(parents, function (parent) {
            //Iterate over relations
            relation = _.find(parent.relations, function (rel) {
                return parent.get(rel.key) === target;
            }, this);
            if (relation) {
                surrogate = parent;//surrogate for transformation
                return true;//break;
            }
        }, this);

        //If we found a relation and it has a mapping function
        if (relation && relation.map) {
            return relation.map.call(surrogate, models, target);
        }
        return models;
    };

    var proxies = {};
    // Proxy Backbone collection methods
    _.each(['set', 'remove', 'reset'], function (method) {
        proxies[method] = BackboneCollection.prototype[method];

        CollectionProto[method] = function (models, options) {
            //Short-circuit if this collection doesn't hold `AssociatedModels`
            if (this.model.prototype instanceof AssociatedModel && this.parents) {
                //Find a map function if available and perform a transformation
                arguments[0] = map2models(this.parents, this, models);
            }
            return proxies[method].apply(this, arguments);
        }
    });

    // Override trigger to defer events in the object graph.
    proxies['trigger'] = CollectionProto['trigger'];
    CollectionProto['trigger'] = function (name) {
        if (this._deferEvents) {
            this._pendingEvents = this._pendingEvents || [];
            // Maintain a queue of pending events to trigger after the entire object graph is updated.
            this._pendingEvents.push({c:this, a:arguments});
        } else {
            proxies['trigger'].apply(this, arguments);
        }
    };

    // Attach process pending event functionality on collections as well. Re-use from `AssociatedModel`
    CollectionProto._processPendingEvents = AssociatedModel.prototype._processPendingEvents;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * 1stdibs
 * User: James
 * Date: 11/19/13
 */



var root = typeof window === 'undefined' ? global : window;
var checkVals = { checkedVal: 'Y', unCheckedVal: 'N' };
var _ = __webpack_require__(22);
var Backbone;
var $;

// do not load twice
if (root._dibsBackbone) {
	module.exports = root._dibsBackbone;
} else {
	Backbone = __webpack_require__(2613);
	var bbAss = __webpack_require__(2701);
	bbAss(Backbone);
	
	$ = __webpack_require__(5);

	Backbone.$ = $;
	Backbone.FormView.prototype.className = 'form-horizontal form-horizontal-default';
	Backbone.fields.FieldView.prototype.classDefaults = 'form-group form-field';
	Backbone.fields.FieldView.prototype.template = _.template(
	    '<% if (obj.label) { %><label class="control-label" ' +
	        '<% if (obj.inputId) { %> for="<%= obj.inputId %>" <% } %> >' +
	        '<%= obj.label %></label><% } %>' +
	        '<div class="controls-wrapper">' +
	        '   <div class="controls" data-input=""></div>' +
	        '<div class="controls">' +
	        '<div class="text-error" data-error=""></div>' +
	        '<% if (obj.help) { %><span class="help-block"><%= obj.help %></span><% } %>' +
	        '</div>'
	);

	_.extend(Backbone.fields.CheckListView.prototype, checkVals);
	_.extend(Backbone.fields.CheckBoxView.prototype, checkVals);

	module.exports = root._dibsBackbone = Backbone;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2703 */,
/* 2704 */,
/* 2705 */,
/* 2706 */,
/* 2707 */,
/* 2708 */,
/* 2709 */,
/* 2710 */,
/* 2711 */,
/* 2712 */,
/* 2713 */,
/* 2714 */,
/* 2715 */,
/* 2716 */,
/* 2717 */,
/* 2718 */,
/* 2719 */,
/* 2720 */,
/* 2721 */,
/* 2722 */,
/* 2723 */,
/* 2724 */,
/* 2725 */,
/* 2726 */,
/* 2727 */,
/* 2728 */,
/* 2729 */,
/* 2730 */,
/* 2731 */,
/* 2732 */,
/* 2733 */,
/* 2734 */,
/* 2735 */,
/* 2736 */,
/* 2737 */,
/* 2738 */,
/* 2739 */,
/* 2740 */,
/* 2741 */,
/* 2742 */,
/* 2743 */,
/* 2744 */,
/* 2745 */,
/* 2746 */,
/* 2747 */,
/* 2748 */,
/* 2749 */,
/* 2750 */,
/* 2751 */,
/* 2752 */,
/* 2753 */,
/* 2754 */,
/* 2755 */,
/* 2756 */,
/* 2757 */,
/* 2758 */,
/* 2759 */,
/* 2760 */,
/* 2761 */,
/* 2762 */,
/* 2763 */,
/* 2764 */,
/* 2765 */,
/* 2766 */,
/* 2767 */,
/* 2768 */,
/* 2769 */,
/* 2770 */,
/* 2771 */,
/* 2772 */,
/* 2773 */,
/* 2774 */,
/* 2775 */,
/* 2776 */,
/* 2777 */,
/* 2778 */,
/* 2779 */,
/* 2780 */,
/* 2781 */,
/* 2782 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 2783 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _FlexModalWrapper = __webpack_require__(1);
	
	var _FlexModalWrapper2 = _interopRequireDefault(_FlexModalWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _FlexModalWrapper2.default;

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(3);
	
	var _reactBodySubtree = __webpack_require__(4);
	
	var _reactBodySubtree2 = _interopRequireDefault(_reactBodySubtree);
	
	var _FlexModalWrapper = __webpack_require__(5);
	
	var _FlexModalWrapper2 = _interopRequireDefault(_FlexModalWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalWrapper = function (_React$Component) {
	  _inherits(ModalWrapper, _React$Component);
	
	  function ModalWrapper() {
	    _classCallCheck(this, ModalWrapper);
	
	    var _this = _possibleConstructorReturn(this, (ModalWrapper.__proto__ || Object.getPrototypeOf(ModalWrapper)).call(this));
	
	    _this.handleMouseClickOutside = _this.handleMouseClickOutside.bind(_this);
	    return _this;
	  }
	
	  _createClass(ModalWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!document) {
	        return;
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('mousedown', this.handleMouseClickOutside, { capture: true });
	      }
	      if (this.props.preventScrolling) {
	        this.previousOverflow = document.body.style.overflow;
	        document.body.style.overflow = 'hidden';
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!document) {
	        return;
	      }
	      document.removeEventListener('mousedown', this.handleMouseClickOutside, { capture: true });
	      if (this.props.preventScrolling) {
	        document.body.style.overflow = this.previousOverflow;
	      }
	    }
	  }, {
	    key: 'handleMouseClickOutside',
	    value: function handleMouseClickOutside(e) {
	      var rootNode = (0, _reactDom.findDOMNode)(this.refs.content);
	      if (rootNode.contains(e.target) || e.button !== 0) {
	        return;
	      }
	      e.stopPropagation();
	      this.props.closePortal();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          useOverlay = _props.useOverlay,
	          overlayClassName = _props.overlayClassName,
	          overlayStyle = _props.overlayStyle,
	          closeModal = _props.closePortal;
	
	      var modalwrapper = _react2.default.createElement(
	        'div',
	        { className: className ? _FlexModalWrapper2.default.flexModalWrapper + ' ' + className : _FlexModalWrapper2.default.flexModalWrapper, ref: 'content' },
	        _react2.default.Children.map(this.props.children, function (c) {
	          return _react2.default.cloneElement(c, { closeModal: closeModal });
	        })
	      );
	      var overlay = void 0;
	      if (useOverlay) {
	        if (overlayStyle) {
	          overlay = _react2.default.createElement(
	            'div',
	            { className: _FlexModalWrapper2.default.flexModalOverlay, style: overlayStyle },
	            modalwrapper
	          );
	        } else {
	          overlay = _react2.default.createElement(
	            'div',
	            { className: _FlexModalWrapper2.default.flexModalOverlay + ' ' + (overlayClassName || _FlexModalWrapper2.default.overlayStyle) },
	            modalwrapper
	          );
	        }
	      } else {
	        overlay = _react2.default.createElement(
	          'div',
	          { className: _FlexModalWrapper2.default.flexModalOverlay },
	          modalwrapper
	        );
	      }
	      return overlay;
	    }
	  }]);
	
	  return ModalWrapper;
	}(_react2.default.Component);
	
	ModalWrapper.propTypes = {
	  children: _react2.default.PropTypes.node.isRequired,
	  className: _react2.default.PropTypes.string,
	  useOverlay: _react2.default.PropTypes.bool,
	  overlayStyle: _react2.default.PropTypes.object,
	  overlayClassName: _react2.default.PropTypes.string,
	  closeOnOutsideClick: _react2.default.PropTypes.bool,
	  preventScrolling: _react2.default.PropTypes.bool,
	  // passed by Portal
	  closePortal: _react2.default.PropTypes.func
	};
	
	var FlexModalWrapper = function (_React$Component2) {
	  _inherits(FlexModalWrapper, _React$Component2);
	
	  function FlexModalWrapper() {
	    _classCallCheck(this, FlexModalWrapper);
	
	    return _possibleConstructorReturn(this, (FlexModalWrapper.__proto__ || Object.getPrototypeOf(FlexModalWrapper)).apply(this, arguments));
	  }
	
	  _createClass(FlexModalWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          other = _objectWithoutProperties(_props2, ['children']);
	
	      var closeOnOutsideClick = other.closeOnOutsideClick,
	          className = other.className,
	          useOverlay = other.useOverlay,
	          overlayStyle = other.overlayStyle,
	          overlayClassName = other.overlayClassName,
	          preventScrolling = other.preventScrolling,
	          portalOptions = _objectWithoutProperties(other, ['closeOnOutsideClick', 'className', 'useOverlay', 'overlayStyle', 'overlayClassName', 'preventScrolling']);
	
	      return _react2.default.createElement(
	        _reactBodySubtree2.default,
	        portalOptions,
	        _react2.default.createElement(
	          ModalWrapper,
	          _extends({
	            ref: function ref(_ref) {
	              return _this3.modal = _ref;
	            }
	          }, { closeOnOutsideClick: closeOnOutsideClick, className: className, useOverlay: useOverlay, overlayStyle: overlayStyle, overlayClassName: overlayClassName, preventScrolling: preventScrolling }),
	          children
	        )
	      );
	    }
	  }]);
	
	  return FlexModalWrapper;
	}(_react2.default.Component);
	
	FlexModalWrapper.propTypes = {
	  children: _react2.default.PropTypes.node.isRequired,
	  className: _react2.default.PropTypes.string,
	  useOverlay: _react2.default.PropTypes.bool,
	  overlayStyle: _react2.default.PropTypes.object,
	  overlayClassName: _react2.default.PropTypes.string,
	  // Portal props
	  isOpened: _react2.default.PropTypes.bool,
	  openByClickOn: _react2.default.PropTypes.element,
	  closeOnEsc: _react2.default.PropTypes.bool,
	  closeOnOutsideClick: _react2.default.PropTypes.bool,
	  preventScrolling: _react2.default.PropTypes.bool,
	  onClose: _react2.default.PropTypes.func
	};
	FlexModalWrapper.defaultProps = {
	  useOverlay: true,
	  preventScrolling: true
	};
	
	module.exports = FlexModalWrapper;

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(1);

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(39);

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(1587);

/***/ },
/* 5 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flexModalWrapper":"FlexModalWrapper__flexModalWrapper___GQhOs","flexModalOverlay":"FlexModalWrapper__flexModalOverlay___72E20","overlayStyle":"FlexModalWrapper__overlayStyle___aqiN6"};

/***/ }
/******/ ]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2784 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 2785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isFunction = __webpack_require__(104);
var isString = __webpack_require__(922);
var intelligentFormat = __webpack_require__(1640);
var constants = __webpack_require__(1639).currencies;
var currencyFormat;

currencyFormat = module.exports = {

    format: function (currency, model, financialAmount, options) {
        var isNegative = false;
        var amount;
        var result;
        var fn;
        if (financialAmount && isFunction(financialAmount.getAmountIn)) {
            amount = financialAmount.getAmountIn(currency);
        } else if (isString(financialAmount)) {
            fn = financialAmount;
            amount = model[fn](currency);
        }

        if (amount < 0) {
            isNegative = true;
            amount = amount * -1;
        }

        result = intelligentFormat(amount, currency, Object.assign(options || {}, {
            thousandsSeparator: ',',
            decimalMark: '.'
        }));

        return isNegative ? '- ' + result : result;
    },

    domtFormat: function (transaction, financialAmount) {
        var currency = transaction.getItemCurrency();
        return currencyFormat.format(currency, transaction, financialAmount, {});
    },

    iomtFormat: function (transaction, financialAmount) {
        var usdCurrency = '';
        var secCurrency = '';
        var itemCurrency = transaction.getItemCurrency();

        usdCurrency = currencyFormat.format(constants.CURRENCY_USD, transaction, financialAmount, {});

        if (itemCurrency !== constants.CURRENCY_USD) {
            secCurrency = ' (' + currencyFormat.domtFormat(transaction, financialAmount) + ')';
        }

        return usdCurrency + secCurrency;
    }

};


/***/ }),
/* 2786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    constants: __webpack_require__(1639),
    currencies: __webpack_require__(2079),
    currencyFormat: __webpack_require__(2785),
    intelligentFormat: __webpack_require__(1640),
    intelligentFormatObj: __webpack_require__(2787),
    util: __webpack_require__(1472)
};


/***/ }),
/* 2787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(1472);

/**
 * @param  {number} amount - The number to format.
 * @param  {string} currency - Accepts any currency from currencies file
 * @param  {object} passedOptions - Additional options for localizedCashFormatObj
 * @return {object} - An object containing the price, currency symbol, abbreviation and a negative sign
 */
module.exports = function intelligentFormatObj(amount, currency, passedOptions) {
    var options = util.getFormatOptions(amount, currency, passedOptions);
    return util.localizedCashFormatObj(amount, options);
};


/***/ }),
/* 2788 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2789 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' ||
        typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (nonEnumShadows || isPrototype(value)) {
    return !nativeKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEmpty;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(70)(module)))

/***/ }),
/* 2790 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, props) {
  object = Object(object);
  return basePickBy(object, props, function(value, key) {
    return key in object;
  });
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick from.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, props, predicate) {
  var index = -1,
      length = props.length,
      result = {};

  while (++index < length) {
    var key = props[index],
        value = object[key];

    if (predicate(value, key)) {
      result[key] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [props] The property identifiers to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = baseRest(function(object, props) {
  return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
});

module.exports = pick;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(2793);
var parse = __webpack_require__(2792);
var formats = __webpack_require__(2080);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 2792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2081);

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    parameterLimit: 1000,
    plainObjects: false,
    strictNullHandling: false
};

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);

    for (var i = 0; i < parts.length; ++i) {
        var part = parts[i];
        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos));
            val = options.decoder(part.slice(pos + 1));
        }
        if (has.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function parseObjectRecursive(chain, val, options) {
    if (!chain.length) {
        return val;
    }

    var root = chain.shift();

    var obj;
    if (root === '[]') {
        obj = [];
        obj = obj.concat(parseObject(chain, val, options));
    } else {
        obj = options.plainObjects ? Object.create(null) : {};
        var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
        var index = parseInt(cleanRoot, 10);
        if (
            !isNaN(index) &&
            root !== cleanRoot &&
            String(index) === cleanRoot &&
            index >= 0 &&
            (options.parseArrays && index <= options.arrayLimit)
        ) {
            obj = [];
            obj[index] = parseObject(chain, val, options);
        } else {
            obj[cleanRoot] = parseObject(chain, val, options);
        }
    }

    return obj;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts || {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),
/* 2793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(2081);
var formats = __webpack_require__(2080);

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var toISO = Date.prototype.toISOString;

var defaults = {
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (obj === null) {
        if (strictNullHandling) {
            return encoder ? encoder(prefix) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            return [formatter(encoder(prefix)) + '=' + formatter(encoder(obj))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(stringify(
                obj[key],
                generateArrayPrefix(prefix, key),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter
            ));
        } else {
            values = values.concat(stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter
            ));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts || {};

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
    var encoder = encode ? (typeof options.encoder === 'function' ? options.encoder : defaults.encoder) : null;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
    if (typeof options.format === 'undefined') {
        options.format = formats.default;
    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
        throw new TypeError('Unknown format option provided.');
    }
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        keys = keys.concat(stringify(
            obj[key],
            key,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter
        ));
    }

    return keys.join(delimiter);
};


/***/ }),
/* 2794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),
/* 2795 */,
/* 2796 */,
/* 2797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAmountByCurrency = exports.getConvertedAmountList = exports.getConvertedAmounts = exports.getBaseAmount = undefined;

var _createSelector = __webpack_require__(1244);

var _createSelector2 = _interopRequireDefault(_createSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Base Getters
// ------------------------------------------

var getBaseAmount = exports.getBaseAmount = function getBaseAmount(amount) {
    return amount ? amount.amount : undefined;
};
var getConvertedAmounts = exports.getConvertedAmounts = function getConvertedAmounts(amount) {
    return amount ? amount.convertedAmounts : undefined;
};
var getConvertedAmountList = exports.getConvertedAmountList = function getConvertedAmountList(amount) {
    return amount ? amount.convertedAmountList : undefined;
};

// Selectors
// ------------------------------------------

/**
 * @param {object} Item
 * @returns {function} A function that can take a currency and return the value amount as long as
 *                      amount is inflated (so amount and convertedAmounts are present)
 */
var getAmountByCurrency = exports.getAmountByCurrency = (0, _createSelector2.default)(getBaseAmount, getConvertedAmounts, getConvertedAmountList, function (baseAmount, convertedAmounts, convertedAmountList) {
    return function (currency) {
        if (baseAmount === 0) {
            return 0;
        } else if (convertedAmounts) {
            return convertedAmounts[currency];
        } else if (convertedAmountList) {
            return getBaseAmount(convertedAmountList.find(function (amount) {
                return amount.currency === currency;
            }));
        } else {
            return undefined;
        }
    };
});

/***/ }),
/* 2798 */,
/* 2799 */,
/* 2800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var latestServices = {
    messagecenter:   'mc-1',
    ecom:            'ecom-4',
    identity:        'identity-3',
    inventory:       'inventory-3',
    logistics:       'logistics-2',
    cms:             'cms-service',
    usercomm:        'usercomm',
    boss:            'boss-1',
    trade:           'trade-1',
    media:           'media-1',
    analytics:       'analytics-1'
};
module.exports = {
    latestServices: latestServices,
    latest: {
        messagecenter:       latestServices.messagecenter + '/1',   // mc-1/1
        mcFlagMessage:       latestServices.messagecenter + '/2',   // mc-1/2

        ecom:                latestServices.ecom + '/2',            // ecom-4/2',
        ecomPromotion:       latestServices.ecom + '/3',            // ecom-4/3,
        ecomTransaction:     latestServices.ecom + '/3',            //'ecom-4/3',
        ecomSummary:         latestServices.ecom + '/4',            //'ecom-4/4',
        ecomLogistics:       latestServices.ecom + '/4',            //'ecom-4/4',
        ecomCurrency:        latestServices.ecom + '/3',            //'ecom-4/3',

        identity:               latestServices.identity + '/1',     //'identity-3/1',
        identityShipping:       latestServices.identity + '/2',     //'identity-3/2',
        identityHyperwallet:    latestServices.identity + '/2',     //'identity-3/2',
        identityLogistics:      latestServices.identity + '/4',     //'identity-3/4',
        identitySocialNetworks: latestServices.identity + '/2',     //'identity-3/2',
        identityTrade:          latestServices.identity + '/2',     //'identity-3/2',
        identityOauth:          latestServices.identity + '/2',     //'identity-3/2',
        trade:                  latestServices.trade + '/2',        //'trade-1/2',
        identityConvNotes:      latestServices.identity + '/2',     //'identity-3/2',

        inventory:           latestServices.inventory + '/2',       //'inventory-3/2',
        inventoryItem:       latestServices.inventory + '/3',       //'inventory-3/3',
        inventoryAttributes: latestServices.inventory + '/1',       // inventory-3/1
        inventoryShipping:   latestServices.inventory + '/2',       // 'inventory-3/2',
        inventoryLogistics:  latestServices.inventory + '/4',       // 'inventory-3/4',
        inventoryCreators:   latestServices.inventory + '/2',       // 'inventory-3/2',
        inventoryCategories: latestServices.inventory + '/3',       // 'inventory-3/3',
        inventoryFileUpload: latestServices.inventory + '/3',       // 'inventory-3/3',
        inventoryReviews:    latestServices.inventory + '/2',       // 'inventory-3/3',
        inventoryListings:   latestServices.inventory + '/2',       // 'inventory-3/3',

        logistics:           latestServices.logistics + '/3',       //'logistics-2/3',
        logisticsShipping:   latestServices.logistics + '/4',       //'logistics-2/4'

        analytics:           latestServices.analytics + '/2',       //'analytics-1/2'

        cms:                 latestServices.cms + '/v1',

        usercomm:            latestServices.usercomm + '/2',

        boss:                latestServices.boss + '/1',

        media:               latestServices.media + '/2'
    }
};


/***/ }),
/* 2801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function formatPhoneNumber(inputStr) {
    if (!inputStr) {
        inputStr = "";
    }
    inputStr = inputStr.toString();
    if (inputStr.length === 10) {
        return [
            inputStr.slice(0, 3),
            inputStr.slice(3, 6),
            inputStr.slice(6)
        ].join('-');
    } else {
        return inputStr;
    }
};



/***/ }),
/* 2802 */,
/* 2803 */,
/* 2804 */,
/* 2805 */,
/* 2806 */,
/* 2807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectDestructuringEmpty2 = __webpack_require__(2611);

var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);

var _extends2 = __webpack_require__(514);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(344);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(349);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(348);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(17);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INACTIVE_READY_STATE = {
  aborted: false,
  done: false,
  error: null,
  ready: false,
  stale: false
};

var IsomorphicRenderer = function (_React$Component) {
  (0, _inherits3.default)(IsomorphicRenderer, _React$Component);

  function IsomorphicRenderer(props, context) {
    (0, _classCallCheck3.default)(this, IsomorphicRenderer);

    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));

    _this.mounted = true;
    _this.pendingRequest = null;
    _this.state = {
      active: !!props.initialReadyState,
      readyState: props.initialReadyState || INACTIVE_READY_STATE,
      retry: _this._retry.bind(_this)
    };
    return _this;
  }

  IsomorphicRenderer.prototype.componentDidMount = function componentDidMount() {
    var readyState = this.state.readyState;

    if (!readyState || !readyState.done) {
      this._runQueries(this.props);
    }
  };

  IsomorphicRenderer.prototype._runQueries = function _runQueries(_ref) {
    var _this2 = this;

    var Container = _ref.Container,
        forceFetch = _ref.forceFetch,
        queryConfig = _ref.queryConfig,
        environment = _ref.environment,
        shouldFetch = _ref.shouldFetch;

    if (!shouldFetch) {
      return;
    }

    var onReadyStateChange = function onReadyStateChange(readyState) {
      if (!_this2.mounted) {
        _this2._handleReadyStateChange((0, _extends3.default)({}, readyState, { mounted: false }));
        return;
      }

      if (request !== _this2.pendingRequest) {
        return;
      }

      if (readyState.aborted || readyState.done || readyState.error) {
        _this2.pendingRequest = null;
      }

      _this2.setState({
        active: true,
        readyState: readyState
      });
    };

    if (this.pendingRequest) {
      this.pendingRequest.abort();
    }

    var querySet = _reactRelay2.default.getQueries(Container, queryConfig);
    var request = this.pendingRequest = environment[forceFetch ? 'forceFetch' : 'primeCache'](querySet, onReadyStateChange);
  };

  IsomorphicRenderer.prototype._retry = function _retry() {
    var readyState = this.state.readyState;

    if (readyState && readyState.error) {
      this._runQueries(this.props);
      this.setState({ readyState: null });
    }
  };

  IsomorphicRenderer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.Container !== this.props.Container || nextProps.environment !== this.props.environment || nextProps.queryConfig !== this.props.queryConfig || nextProps.shouldFetch && !this.props.shouldFetch || nextProps.forceFetch && !this.props.forceFetch) {
      this._runQueries(nextProps);
      this.setState({ readyState: null });
    }
  };

  IsomorphicRenderer.prototype.componentDidUpdate = function componentDidUpdate(_ref2, prevState) {
    (0, _objectDestructuringEmpty3.default)(_ref2);
    var readyState = this.state.readyState;

    if (readyState && readyState !== prevState.readyState) {
      this._handleReadyStateChange((0, _extends3.default)({}, readyState, { mounted: true }));
    }
  };

  IsomorphicRenderer.prototype._handleReadyStateChange = function _handleReadyStateChange(readyState) {
    if (this.props.onReadyStateChange) {
      this.props.onReadyStateChange(readyState);
    }
  };

  IsomorphicRenderer.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.pendingRequest) {
      this.pendingRequest.abort();
    }

    this.mounted = false;
  };

  IsomorphicRenderer.prototype.render = function render() {
    var readyState = this.state.active ? this.state.readyState : INACTIVE_READY_STATE;

    return _react2.default.createElement(_reactRelay2.default.ReadyStateRenderer, {
      Container: this.props.Container,
      environment: this.props.environment,
      queryConfig: this.props.queryConfig,
      readyState: readyState,
      render: this.props.render,
      retry: this.state.retry
    });
  };

  return IsomorphicRenderer;
}(_react2.default.Component);

exports.default = IsomorphicRenderer;


IsomorphicRenderer.propTypes = {
  Container: _reactRelay2.default.PropTypes.Container,
  forceFetch: _react2.default.PropTypes.bool,
  initialReadyState: _react2.default.PropTypes.shape({
    aborted: _react2.default.PropTypes.bool.isRequired,
    done: _react2.default.PropTypes.bool.isRequired,
    error: _react2.default.PropTypes.any,
    ready: _react2.default.PropTypes.bool.isRequired,
    stale: _react2.default.PropTypes.bool.isRequired
  }),
  onReadyStateChange: _react2.default.PropTypes.func,
  queryConfig: _reactRelay2.default.PropTypes.QueryConfig.isRequired,
  environment: _reactRelay2.default.PropTypes.Environment,
  render: _react2.default.PropTypes.func,
  shouldFetch: _react2.default.PropTypes.bool
};

IsomorphicRenderer.defaultProps = {
  shouldFetch: true
};

/***/ }),
/* 2808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(2036);

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = injectPreparedData;

var _fromGraphQL = __webpack_require__(4243);

var _fromGraphQL2 = _interopRequireDefault(_fromGraphQL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function injectPreparedData(environment, data) {
  var storeData = environment.getStoreData();

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref2 = _step.value;
      var concreteQuery = _ref2.query,
          response = _ref2.response;

      var query = _fromGraphQL2.default.Query(concreteQuery);
      storeData.handleQueryPayload(query, response);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

/***/ }),
/* 2809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(2036);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(2037);

var _promise2 = _interopRequireDefault(_promise);

exports.default = prepareData;

var _reactRelay = __webpack_require__(17);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _toGraphQL = __webpack_require__(4103);

var _toGraphQL2 = _interopRequireDefault(_toGraphQL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prepareData(_ref, networkLayer) {
  var Container = _ref.Container,
      queryConfig = _ref.queryConfig;
  var preloadedRequests = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return new _promise2.default(function (resolve, reject) {
    var environment = new _reactRelay2.default.Environment();
    var data = [];

    var storeData = environment.getStoreData();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(preloadedRequests), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref4 = _step.value;
        var query = _ref4.query,
            response = _ref4.response;

        storeData.handleQueryPayload(query, response);
        data.push({ query: _toGraphQL2.default.Query(query), response: response });
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    environment.injectNetworkLayer({
      sendMutation: networkLayer.sendMutation.bind(networkLayer),
      supports: networkLayer.supports.bind(networkLayer),

      sendQueries: function sendQueries(requests) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          var _loop = function _loop() {
            var request = _step2.value;

            request.then(function (_ref3) {
              var response = _ref3.response;

              data.push({ query: _toGraphQL2.default.Query(request.getQuery()), response: response });
            });
          };

          for (var _iterator2 = (0, _getIterator3.default)(requests), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            _loop();
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        return networkLayer.sendQueries(requests);
      }
    });

    var querySet = _reactRelay2.default.getQueries(Container, queryConfig);
    environment.primeCache(querySet, onReadyStateChange);

    function onReadyStateChange(readyState) {
      if (readyState.error) {
        reject(readyState.error);
      } else if (readyState.aborted) {
        reject(new Error('Aborted'));
      } else if (readyState.done) {
        var props = {
          Container: Container,
          environment: environment,
          queryConfig: queryConfig,
          initialReadyState: readyState
        };
        resolve({ data: data, props: props });
      }
    }
  });
}

/***/ }),
/* 2810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(514);

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__(2037);

var _promise2 = _interopRequireDefault(_promise);

exports.default = prepareInitialRender;

var _reactRelay = __webpack_require__(17);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prepareInitialRender(props) {
  return new _promise2.default(function (resolve) {
    var querySet = _reactRelay2.default.getQueries(props.Container, props.queryConfig);
    var fetchMethod = props.forceFetch ? 'forceFetch' : 'primeCache';
    var request = props.environment[fetchMethod](querySet, onReadyStateChange);

    function onReadyStateChange(readyState) {
      if (readyState.aborted || readyState.error || readyState.ready) {
        request.abort();

        resolve((0, _extends3.default)({}, props, {
          initialReadyState: readyState
        }));
      }
    }
  });
}

/***/ }),
/* 2811 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 2812 */,
/* 2813 */,
/* 2814 */,
/* 2815 */,
/* 2816 */,
/* 2817 */,
/* 2818 */,
/* 2819 */,
/* 2820 */,
/* 2821 */,
/* 2822 */,
/* 2823 */
/***/ (function(module, exports) {

module.exports = {
	"UNKNOWN": "Unknown",
	"PACKING": "Packing",
	"FINAL_MILE": "Final Mile Transport",
	"DUTY": "Duty/Tax",
	"TRANSIT": "Transit"
};

/***/ }),
/* 2824 */
/***/ (function(module, exports) {

module.exports = [
	{
		"displayName": "Express Parcel",
		"serviceMethodType": "EXPRESS",
		"serviceType": "PARCEL",
		"verticals": [
			"furniture",
			"art"
		],
		"dealerShortExplanation": "Expedited mail or package delivery",
		"dealerSuggestedDays": "1 to 3 days"
	},
	{
		"displayName": "Front Door Freight",
		"serviceMethodType": "FRONT_DOOR",
		"serviceType": "FREIGHT",
		"verticals": [
			"furniture",
			"art"
		],
		"dealerShortExplanation": "Scheduled delivery to customer's front door",
		"dealerSuggestedDays": "4+ days"
	},
	{
		"displayName": "Messenger",
		"serviceMethodType": "MESSENGER",
		"serviceType": "PARCEL",
		"verticals": [
			"furniture",
			"art"
		],
		"dealerShortExplanation": "Fast, hand delivered",
		"dealerSuggestedDays": "1 to 2 days"
	},
	{
		"displayName": "Standard Parcel",
		"serviceMethodType": "STANDARD",
		"serviceType": "PARCEL",
		"verticals": [
			"furniture",
			"art"
		],
		"dealerShortExplanation": "Mail or package delivery",
		"dealerSuggestedDays": "4+ days"
	},
	{
		"displayName": "White Glove",
		"serviceMethodType": "STANDARD",
		"serviceType": "WHITE_GLOVE",
		"verticals": [
			"furniture",
			"art"
		],
		"dealerShortExplanation": "Scheduled delivery to customer's room of choice",
		"dealerSuggestedDays": "4+ days"
	},
	{
		"displayName": "Expedited White Glove",
		"serviceMethodType": "EXPRESS",
		"serviceType": "WHITE_GLOVE",
		"verticals": [
			"furniture",
			"art"
		],
		"dealerShortExplanation": "Expedited scheduled delivery to customer's room of choice",
		"dealerSuggestedDays": "4+ days"
	},
	{
		"displayName": "Express",
		"serviceMethodType": "EXPRESS",
		"serviceType": "PARCEL",
		"verticals": [
			"jewelry",
			"fashion"
		],
		"dealerShortExplanation": "Expedited mail or package delivery",
		"dealerSuggestedDays": "1 to 3 days"
	},
	{
		"displayName": "Messenger",
		"serviceMethodType": "MESSENGER",
		"serviceType": "PARCEL",
		"verticals": [
			"jewelry",
			"fashion"
		],
		"dealerShortExplanation": "Fast, hand delivered",
		"dealerSuggestedDays": "1 to 2 days"
	},
	{
		"displayName": "Standard",
		"serviceMethodType": "STANDARD",
		"serviceType": "PARCEL",
		"verticals": [
			"jewelry",
			"fashion"
		],
		"dealerShortExplanation": "Mail or package delivery",
		"dealerSuggestedDays": "4+ days"
	}
];

/***/ }),
/* 2825 */,
/* 2826 */,
/* 2827 */,
/* 2828 */,
/* 2829 */,
/* 2830 */,
/* 2831 */,
/* 2832 */,
/* 2833 */,
/* 2834 */,
/* 2835 */,
/* 2836 */,
/* 2837 */,
/* 2838 */,
/* 2839 */,
/* 2840 */,
/* 2841 */,
/* 2842 */,
/* 2843 */,
/* 2844 */,
/* 2845 */,
/* 2846 */,
/* 2847 */,
/* 2848 */,
/* 2849 */,
/* 2850 */,
/* 2851 */,
/* 2852 */,
/* 2853 */,
/* 2854 */,
/* 2855 */,
/* 2856 */,
/* 2857 */,
/* 2858 */,
/* 2859 */,
/* 2860 */,
/* 2861 */,
/* 2862 */,
/* 2863 */,
/* 2864 */,
/* 2865 */,
/* 2866 */,
/* 2867 */,
/* 2868 */,
/* 2869 */,
/* 2870 */,
/* 2871 */,
/* 2872 */,
/* 2873 */,
/* 2874 */,
/* 2875 */,
/* 2876 */,
/* 2877 */,
/* 2878 */,
/* 2879 */,
/* 2880 */,
/* 2881 */,
/* 2882 */,
/* 2883 */,
/* 2884 */,
/* 2885 */,
/* 2886 */,
/* 2887 */,
/* 2888 */,
/* 2889 */,
/* 2890 */,
/* 2891 */,
/* 2892 */,
/* 2893 */,
/* 2894 */,
/* 2895 */,
/* 2896 */,
/* 2897 */,
/* 2898 */,
/* 2899 */,
/* 2900 */,
/* 2901 */,
/* 2902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = "<svg version=\"1.1\" class=\"dibsvg-svg dibsvg-logo-no-reg\" viewBox=\"0 0 100 25\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <path d=\"M15.7,0L9.6,20.2c-0.3,1.1-0.5,1.7-0.5,2c0,0.3,0.1,0.6,0.3,0.9c0.2,0.3,0.5,0.5,0.7,0.6c0.3,0.1,1,0.2,2.3,0.2l-0.2,0.6H0l0.2-0.6c1.2,0,2.1-0.1,2.6-0.3c0.5-0.2,0.9-0.5,1.2-0.9c0.3-0.4,0.6-1.2,1-2.5L8.5,8.2c0.6-1.8,0.9-2.8,0.9-2.9C9.5,5,9.5,4.7,9.5,4.5C9.5,4,9.4,3.5,9,3.2C8.7,2.9,8.2,2.8,7.6,2.8c-0.3,0-0.9,0-1.8,0.1L5.7,2.2L14.9,0H15.7z\"/>\n    <path d=\"M28.5,8.1l-0.8,5.5H27c-0.1-1.4-0.5-2.5-1.3-3.3c-0.8-0.8-1.6-1.2-2.5-1.2c-0.5,0-1,0.2-1.4,0.5c-0.4,0.3-0.5,0.7-0.5,1.1c0,0.4,0.1,0.7,0.2,1.1c0.2,0.3,0.5,0.8,1,1.3c1.9,2,3,3.4,3.4,4.1c0.4,0.8,0.6,1.6,0.6,2.4c0,0.9-0.2,1.8-0.7,2.6c-0.5,0.8-1.2,1.5-2.1,2c-1,0.5-1.9,0.7-3,0.7c-0.7,0-1.6-0.1-2.6-0.4c-0.7-0.2-1.2-0.3-1.5-0.3c-0.3,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.3-0.6,0.5h-0.7l0.9-5.9h0.6c0.4,1.4,0.8,2.5,1.2,3.1c0.4,0.6,0.9,1.1,1.5,1.5c0.6,0.4,1.2,0.5,1.8,0.5c0.7,0,1.2-0.2,1.6-0.6c0.4-0.4,0.6-0.9,0.6-1.5c0-0.6-0.1-1.1-0.4-1.6c-0.3-0.5-0.9-1.3-1.9-2.4c-1.4-1.5-2.3-2.7-2.8-3.5c-0.3-0.6-0.5-1.3-0.5-2c0-1.3,0.5-2.3,1.4-3.2c0.9-0.9,2.3-1.3,4-1.3c0.7,0,1.7,0.1,2.7,0.4c0.5,0.1,1,0.2,1.3,0.2c0.5,0,0.8-0.2,1.1-0.6H28.5z\"/>\n    <path d=\"M40,3.8l-1.5,4.8h2l-0.6,2h-2L34.6,21c-0.2,0.6-0.3,1.1-0.3,1.5c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.1,0.4,0.1c0.2,0,0.4-0.1,0.6-0.2c0.5-0.4,1.2-1.1,1.9-2.2l0.6,0.4c-0.8,1.4-1.7,2.5-2.7,3.1c-1,0.7-2,1-2.9,1c-0.8,0-1.4-0.2-1.9-0.6c-0.4-0.4-0.7-0.9-0.7-1.5c0-0.7,0.2-1.6,0.5-2.6l3.1-9.6H31l0.3-1.3c1.5-0.6,2.7-1.2,3.8-1.9c1.1-0.7,2.4-1.9,3.9-3.6H40z\"/>\n    <path d=\"M59.6,0l-6.1,19.8C53.2,21,53,21.7,53,22c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1c0.2,0,0.4-0.1,0.7-0.3c0.4-0.3,1-1,1.6-1.9l0.6,0.3c-1.7,2.9-3.5,4.4-5.6,4.4c-0.7,0-1.3-0.2-1.7-0.6c-0.4-0.4-0.6-0.8-0.6-1.4c0-0.6,0.2-1.3,0.5-2.4l0.6-1.8c-1.5,2.6-2.8,4.3-3.9,5.2c-0.8,0.6-1.7,1-2.4,1c-0.9,0-1.7-0.4-2.3-1.1S40,22.2,40,20.8c0-1.8,0.4-3.5,1.2-5.2c0.8-1.7,1.7-3.1,2.8-4.3c1-1.1,2-2,3-2.4c0.9-0.5,1.9-0.7,2.8-0.7c0.5,0,0.9,0.1,1.3,0.3c0.4,0.2,0.8,0.6,1.3,1.1l1.4-4.4c0.4-1.1,0.5-1.9,0.5-2.4c0-0.3-0.1-0.5-0.4-0.7c-0.2-0.2-0.6-0.3-1-0.3c-0.2,0-0.4,0-0.7,0.1l0.2-0.7L58.5,0H59.6z M51.6,11.2c0-0.7-0.1-1.2-0.4-1.6c-0.3-0.3-0.6-0.5-1-0.5c-0.4,0-0.8,0.2-1.3,0.6c-0.9,0.8-1.8,2.3-2.7,4.6c-0.9,2.3-1.4,4.2-1.4,5.8c0,0.6,0.1,1,0.3,1.3c0.2,0.3,0.4,0.4,0.7,0.4c0.4,0,0.9-0.2,1.3-0.6c1-0.9,2.1-2.4,3.1-4.6C51.1,14.3,51.6,12.5,51.6,11.2z\"/>\n    <path d=\"M66,0c0.7,0,1.4,0.3,1.9,0.8c0.5,0.5,0.8,1.1,0.8,1.8c0,0.7-0.3,1.3-0.8,1.8C67.4,5,66.8,5.2,66,5.2c-0.7,0-1.3-0.3-1.9-0.8c-0.5-0.5-0.8-1.1-0.8-1.8c0-0.7,0.3-1.3,0.8-1.8C64.7,0.3,65.3,0,66,0z M67.5,8.1l-4,12.5c-0.2,0.7-0.3,1.2-0.3,1.4c0,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.3,0.2c0.2,0,0.4-0.1,0.6-0.3c0.5-0.5,1.2-1.3,1.9-2.5l0.6,0.4C65,23.4,63,25,61,25c-0.8,0-1.4-0.2-1.9-0.6c-0.5-0.4-0.7-1-0.7-1.6c0-0.4,0.1-1,0.3-1.7l2.8-8.5c0.3-0.8,0.4-1.4,0.4-1.8c0-0.3-0.1-0.5-0.4-0.7c-0.2-0.2-0.6-0.3-1-0.3c-0.2,0-0.4,0-0.7,0l0.2-0.7l6.3-1H67.5z\"/>\n    <path d=\"M80,0l-3.2,10.6c0.9-1,1.7-1.7,2.3-2c0.6-0.3,1.3-0.5,2-0.5c1.4,0,2.4,0.5,3.1,1.5c0.7,1,1,2.2,1,3.5c0,3.2-1.1,6-3.4,8.5c-2,2.2-4.4,3.3-7,3.3c-1.9,0-4-0.6-6.1-1.7l5.6-18.6c0.3-0.9,0.4-1.5,0.4-1.9c0-0.3-0.1-0.5-0.4-0.7c-0.4-0.3-0.9-0.4-1.6-0.3l0.2-0.7L78.9,0H80z M73,23.5c0.5,0.4,1,0.5,1.5,0.5c0.6,0,1.1-0.1,1.5-0.4c0.7-0.4,1.3-1.1,2.1-2.2c0.7-1.1,1.3-2.3,1.8-3.8c0.5-1.5,0.7-3,0.7-4.4c0-0.8-0.2-1.5-0.5-1.9c-0.4-0.4-0.8-0.7-1.2-0.7c-0.8,0-1.5,0.4-2,1.2c-0.4,0.5-0.8,1.7-1.3,3.4L73,23.5z\"/>\n    <path d=\"M100,8.1l-0.8,5.5h-0.7c-0.1-1.4-0.5-2.5-1.3-3.3c-0.8-0.8-1.6-1.2-2.5-1.2c-0.5,0-1,0.2-1.4,0.5c-0.4,0.3-0.5,0.7-0.5,1.1c0,0.4,0.1,0.7,0.2,1.1c0.2,0.3,0.5,0.8,1,1.3c1.9,2,3,3.4,3.4,4.1c0.4,0.8,0.6,1.6,0.6,2.4c0,0.9-0.2,1.8-0.7,2.6c-0.5,0.8-1.2,1.5-2.1,2c-1,0.5-1.9,0.7-3,0.7c-0.7,0-1.6-0.1-2.6-0.4c-0.7-0.2-1.2-0.3-1.5-0.3c-0.3,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.3-0.6,0.5h-0.7l0.9-5.9h0.6c0.4,1.4,0.8,2.5,1.2,3.1c0.4,0.6,0.9,1.1,1.5,1.5c0.6,0.4,1.2,0.5,1.8,0.5c0.7,0,1.2-0.2,1.6-0.6c0.4-0.4,0.6-0.9,0.6-1.5c0-0.6-0.1-1.1-0.4-1.6c-0.3-0.5-0.9-1.3-1.9-2.4c-1.4-1.5-2.3-2.7-2.8-3.5c-0.3-0.6-0.5-1.3-0.5-2c0-1.3,0.5-2.3,1.4-3.2c0.9-0.9,2.3-1.3,4-1.3c0.7,0,1.7,0.1,2.7,0.4c0.5,0.1,1,0.2,1.3,0.2c0.5,0,0.8-0.2,1.1-0.6H100z\"/>\n</svg>\n";

/***/ }),
/* 2903 */,
/* 2904 */,
/* 2905 */,
/* 2906 */,
/* 2907 */,
/* 2908 */,
/* 2909 */,
/* 2910 */,
/* 2911 */,
/* 2912 */,
/* 2913 */,
/* 2914 */,
/* 2915 */,
/* 2916 */,
/* 2917 */,
/* 2918 */,
/* 2919 */,
/* 2920 */,
/* 2921 */,
/* 2922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

//
// We store our EE objects in a plain object whose properties are event names.
// If `Object.create(null)` is not supported we prefix the event names with a
// `~` to make sure that the built-in object properties are not overridden or
// used as an attack vector.
// We also assume that `Object.create(null)` is available when the event name
// is an ES6 Symbol.
//
var prefix = typeof Object.create !== 'function' ? '~' : false;

/**
 * Representation of a single EventEmitter function.
 *
 * @param {Function} fn Event handler to be called.
 * @param {Mixed} context Context for function execution.
 * @param {Boolean} [once=false] Only emit once
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal EventEmitter interface that is molded against the Node.js
 * EventEmitter interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() { /* Nothing to set */ }

/**
 * Hold the assigned EventEmitters by name.
 *
 * @type {Object}
 * @private
 */
EventEmitter.prototype._events = undefined;

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var events = this._events
    , names = []
    , name;

  if (!events) return names;

  for (name in events) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return a list of assigned event listeners.
 *
 * @param {String} event The events that should be listed.
 * @param {Boolean} exists We only need to know if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events && this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Emit an event to all registered event listeners.
 *
 * @param {String} event The name of the event.
 * @returns {Boolean} Indication if we've emitted an event.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if ('function' === typeof listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Register a new EventListener for the given event.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Add an EventListener that's only called once.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Remove event listeners.
 *
 * @param {String} event The event we want to remove.
 * @param {Function} fn The listener that we need to find.
 * @param {Mixed} context Only remove listeners matching this context.
 * @param {Boolean} once Only remove once listeners.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return this;

  var listeners = this._events[evt]
    , events = [];

  if (fn) {
    if (listeners.fn) {
      if (
           listeners.fn !== fn
        || (once && !listeners.once)
        || (context && listeners.context !== context)
      ) {
        events.push(listeners);
      }
    } else {
      for (var i = 0, length = listeners.length; i < length; i++) {
        if (
             listeners[i].fn !== fn
          || (once && !listeners[i].once)
          || (context && listeners[i].context !== context)
        ) {
          events.push(listeners[i]);
        }
      }
    }
  }

  //
  // Reset the array, or remove it completely if we have no more listeners.
  //
  if (events.length) {
    this._events[evt] = events.length === 1 ? events[0] : events;
  } else {
    delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners or only the listeners for the specified event.
 *
 * @param {String} event The event want to remove all listeners for.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  if (!this._events) return this;

  if (event) delete this._events[prefix ? prefix + event : event];
  else this._events = prefix ? {} : Object.create(null);

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),
/* 2923 */,
/* 2924 */,
/* 2925 */,
/* 2926 */,
/* 2927 */,
/* 2928 */,
/* 2929 */,
/* 2930 */,
/* 2931 */,
/* 2932 */,
/* 2933 */,
/* 2934 */,
/* 2935 */,
/* 2936 */,
/* 2937 */,
/* 2938 */,
/* 2939 */,
/* 2940 */,
/* 2941 */,
/* 2942 */,
/* 2943 */,
/* 2944 */,
/* 2945 */,
/* 2946 */,
/* 2947 */,
/* 2948 */,
/* 2949 */,
/* 2950 */,
/* 2951 */,
/* 2952 */,
/* 2953 */,
/* 2954 */,
/* 2955 */,
/* 2956 */,
/* 2957 */,
/* 2958 */,
/* 2959 */,
/* 2960 */,
/* 2961 */,
/* 2962 */,
/* 2963 */,
/* 2964 */,
/* 2965 */,
/* 2966 */,
/* 2967 */,
/* 2968 */,
/* 2969 */,
/* 2970 */,
/* 2971 */,
/* 2972 */,
/* 2973 */,
/* 2974 */,
/* 2975 */,
/* 2976 */,
/* 2977 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"currency":"CurrencySelect-style__currency__3tdTW","currencyLink":"CurrencySelect-style__currencyLink__2Ku2B","currencyWrap":"CurrencySelect-style__currencyWrap__39nQO","currencySymbol":"CurrencySelect-style__currencySymbol__1KUcB","currencyList":"CurrencySelect-style__currencyList__1mdLq","checkmark":"CurrencySelect-style__checkmark__2KE4J","isActive":"CurrencySelect-style__isActive__1qw5I","arrowDown":"CurrencySelect-style__arrowDown__23wsM","dropdownWrapper":"CurrencySelect-style__dropdownWrapper__35fb3"};

/***/ }),
/* 2978 */,
/* 2979 */,
/* 2980 */,
/* 2981 */,
/* 2982 */,
/* 2983 */,
/* 2984 */,
/* 2985 */,
/* 2986 */,
/* 2987 */,
/* 2988 */,
/* 2989 */,
/* 2990 */,
/* 2991 */,
/* 2992 */,
/* 2993 */,
/* 2994 */,
/* 2995 */,
/* 2996 */,
/* 2997 */,
/* 2998 */,
/* 2999 */,
/* 3000 */,
/* 3001 */,
/* 3002 */,
/* 3003 */,
/* 3004 */,
/* 3005 */,
/* 3006 */,
/* 3007 */,
/* 3008 */,
/* 3009 */,
/* 3010 */,
/* 3011 */,
/* 3012 */,
/* 3013 */,
/* 3014 */,
/* 3015 */,
/* 3016 */,
/* 3017 */,
/* 3018 */,
/* 3019 */,
/* 3020 */,
/* 3021 */,
/* 3022 */,
/* 3023 */,
/* 3024 */,
/* 3025 */,
/* 3026 */,
/* 3027 */,
/* 3028 */,
/* 3029 */,
/* 3030 */,
/* 3031 */,
/* 3032 */,
/* 3033 */,
/* 3034 */,
/* 3035 */,
/* 3036 */,
/* 3037 */,
/* 3038 */,
/* 3039 */,
/* 3040 */,
/* 3041 */,
/* 3042 */,
/* 3043 */,
/* 3044 */,
/* 3045 */,
/* 3046 */,
/* 3047 */,
/* 3048 */,
/* 3049 */,
/* 3050 */,
/* 3051 */,
/* 3052 */,
/* 3053 */,
/* 3054 */,
/* 3055 */,
/* 3056 */,
/* 3057 */,
/* 3058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"hiddenRadio":"DibsRadioButtonInput-style__hiddenRadio__33viD","radioButton":"DibsRadioButtonInput-style__radioButton__3A8M9","labelClass":"DibsRadioButtonInput-style__labelClass__1sUp5","titleWrapper":"DibsRadioButtonInput-style__titleWrapper__3srtN","titleClass":"DibsRadioButtonInput-style__titleClass__3fodP"};

/***/ }),
/* 3059 */,
/* 3060 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3061 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"body":"Body-style__body__utg_x"};

/***/ }),
/* 3062 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"Modal-style__content__25Iuq"};

/***/ }),
/* 3063 */,
/* 3064 */,
/* 3065 */,
/* 3066 */,
/* 3067 */,
/* 3068 */,
/* 3069 */,
/* 3070 */,
/* 3071 */,
/* 3072 */,
/* 3073 */,
/* 3074 */,
/* 3075 */,
/* 3076 */,
/* 3077 */,
/* 3078 */,
/* 3079 */,
/* 3080 */,
/* 3081 */,
/* 3082 */,
/* 3083 */,
/* 3084 */,
/* 3085 */,
/* 3086 */,
/* 3087 */,
/* 3088 */,
/* 3089 */,
/* 3090 */,
/* 3091 */,
/* 3092 */,
/* 3093 */,
/* 3094 */,
/* 3095 */,
/* 3096 */,
/* 3097 */,
/* 3098 */,
/* 3099 */,
/* 3100 */,
/* 3101 */,
/* 3102 */,
/* 3103 */,
/* 3104 */,
/* 3105 */,
/* 3106 */,
/* 3107 */,
/* 3108 */,
/* 3109 */,
/* 3110 */,
/* 3111 */,
/* 3112 */,
/* 3113 */,
/* 3114 */,
/* 3115 */,
/* 3116 */,
/* 3117 */,
/* 3118 */,
/* 3119 */,
/* 3120 */,
/* 3121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_checkout-survey__container__1Nbod","modalHeader":"_checkout-survey__modalHeader__2lvlN","buttonWrapper":"_checkout-survey__buttonWrapper__2xxz5","formClass":"_checkout-survey__formClass__2YW24","labelClass":"_checkout-survey__labelClass__3tGAb","textAreaLabel":"_checkout-survey__textAreaLabel__2INCk","desktopHidden":"_checkout-survey__desktopHidden__hdAym","textarea":"_checkout-survey__textarea__1JKyT"};

/***/ }),
/* 3122 */,
/* 3123 */,
/* 3124 */,
/* 3125 */,
/* 3126 */,
/* 3127 */,
/* 3128 */,
/* 3129 */,
/* 3130 */,
/* 3131 */,
/* 3132 */,
/* 3133 */,
/* 3134 */,
/* 3135 */,
/* 3136 */,
/* 3137 */,
/* 3138 */,
/* 3139 */,
/* 3140 */,
/* 3141 */,
/* 3142 */,
/* 3143 */,
/* 3144 */,
/* 3145 */,
/* 3146 */,
/* 3147 */,
/* 3148 */,
/* 3149 */,
/* 3150 */,
/* 3151 */,
/* 3152 */,
/* 3153 */,
/* 3154 */,
/* 3155 */,
/* 3156 */,
/* 3157 */,
/* 3158 */,
/* 3159 */,
/* 3160 */,
/* 3161 */,
/* 3162 */,
/* 3163 */,
/* 3164 */,
/* 3165 */,
/* 3166 */,
/* 3167 */,
/* 3168 */,
/* 3169 */,
/* 3170 */,
/* 3171 */,
/* 3172 */,
/* 3173 */,
/* 3174 */,
/* 3175 */,
/* 3176 */,
/* 3177 */,
/* 3178 */,
/* 3179 */,
/* 3180 */,
/* 3181 */,
/* 3182 */,
/* 3183 */,
/* 3184 */,
/* 3185 */,
/* 3186 */,
/* 3187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3188 */,
/* 3189 */,
/* 3190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3191 */,
/* 3192 */,
/* 3193 */,
/* 3194 */,
/* 3195 */,
/* 3196 */,
/* 3197 */,
/* 3198 */,
/* 3199 */,
/* 3200 */,
/* 3201 */,
/* 3202 */,
/* 3203 */,
/* 3204 */,
/* 3205 */,
/* 3206 */,
/* 3207 */,
/* 3208 */,
/* 3209 */,
/* 3210 */,
/* 3211 */,
/* 3212 */,
/* 3213 */,
/* 3214 */,
/* 3215 */,
/* 3216 */,
/* 3217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var aStackPool = [];
var bStackPool = [];

/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */
function areEqual(a, b) {
  var aStack = aStackPool.length ? aStackPool.pop() : [];
  var bStack = bStackPool.length ? bStackPool.pop() : [];
  var result = eq(a, b, aStack, bStack);
  aStack.length = 0;
  bStack.length = 0;
  aStackPool.push(aStack);
  bStackPool.push(bStack);
  return result;
}

function eq(a, b, aStack, bStack) {
  if (a === b) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
  }
  if (a == null || b == null) {
    // a or b can be `null` or `undefined`
    return false;
  }
  if (typeof a != 'object' || typeof b != 'object') {
    return false;
  }
  var objToStr = Object.prototype.toString;
  var className = objToStr.call(a);
  if (className != objToStr.call(b)) {
    return false;
  }
  switch (className) {
    case '[object String]':
      return a == String(b);
    case '[object Number]':
      return isNaN(a) || isNaN(b) ? false : a == Number(b);
    case '[object Date]':
    case '[object Boolean]':
      return +a == +b;
    case '[object RegExp]':
      return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
  }
  // Assume equality for cyclic structures.
  var length = aStack.length;
  while (length--) {
    if (aStack[length] == a) {
      return bStack[length] == b;
    }
  }
  aStack.push(a);
  bStack.push(b);
  var size = 0;
  // Recursively compare objects and arrays.
  if (className === '[object Array]') {
    size = a.length;
    if (size !== b.length) {
      return false;
    }
    // Deep compare the contents, ignoring non-numeric properties.
    while (size--) {
      if (!eq(a[size], b[size], aStack, bStack)) {
        return false;
      }
    }
  } else {
    if (a.constructor !== b.constructor) {
      return false;
    }
    if (a.hasOwnProperty('valueOf') && b.hasOwnProperty('valueOf')) {
      return a.valueOf() == b.valueOf();
    }
    var keys = Object.keys(a);
    if (keys.length != Object.keys(b).length) {
      return false;
    }
    for (var i = 0; i < keys.length; i++) {
      if (!eq(a[keys[i]], b[keys[i]], aStack, bStack)) {
        return false;
      }
    }
  }
  aStack.pop();
  bStack.pop();
  return true;
}

module.exports = areEqual;

/***/ }),
/* 3218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function crc32(str) {
  /* jslint bitwise: true */
  var crc = -1;
  for (var i = 0, len = str.length; i < len; i++) {
    crc = crc >>> 8 ^ table[(crc ^ str.charCodeAt(i)) & 0xFF];
  }
  return ~crc;
}

var table = [0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA, 0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3, 0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988, 0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91, 0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE, 0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7, 0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC, 0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5, 0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172, 0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B, 0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940, 0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59, 0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116, 0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F, 0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924, 0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D, 0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A, 0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433, 0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818, 0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01, 0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E, 0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457, 0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C, 0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65, 0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2, 0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB, 0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0, 0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9, 0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086, 0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F, 0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4, 0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD, 0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A, 0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683, 0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8, 0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1, 0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE, 0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7, 0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC, 0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5, 0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252, 0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B, 0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60, 0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79, 0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236, 0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F, 0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04, 0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D, 0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A, 0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713, 0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38, 0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21, 0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E, 0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777, 0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C, 0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45, 0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2, 0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB, 0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0, 0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9, 0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6, 0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF, 0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94, 0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D];

if (global.Int32Array !== undefined) {
  table = new Int32Array(table);
}

module.exports = crc32;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 3219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/**
 * Returns a flattened array that represents the DFS traversal of the supplied
 * input array. For example:
 *
 *   var deep = ["a", ["b", "c"], "d", {"e": [1, 2]}, [["f"], "g"]];
 *   var flat = flattenArray(deep);
 *   console.log(flat);
 *   > ["a", "b", "c", "d", {"e": [1, 2]}, "f", "g"];
 *
 * @see https://github.com/jonschlinkert/arr-flatten
 * @copyright 2014-2015 Jon Schlinkert
 * @license MIT
 */
function flattenArray(array) {
  var result = [];
  flatten(array, result);
  return result;
}

function flatten(array, result) {
  var length = array.length;
  var ii = 0;

  while (length--) {
    var current = array[ii++];
    if (Array.isArray(current)) {
      flatten(current, result);
    } else {
      result.push(current);
    }
  }
}

module.exports = flattenArray;

/***/ }),
/* 3220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var nullthrows = function nullthrows(x) {
  if (x != null) {
    return x;
  }
  throw new Error("Got unexpected null or undefined");
};

module.exports = nullthrows;

/***/ }),
/* 3221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/**
 * Removes an element from an array.
 */
function removeFromArray(array, element) {
  var index = array.indexOf(element);
  if (index !== -1) {
    array.splice(index, 1);
  }
}

module.exports = removeFromArray;

/***/ }),
/* 3222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


/**
 * React mixin for staticly declaring and add/remove-ing listeners for Store events.
 * @class FluxibleMixin
 * @example
 * // Register listener default handler function name
 * var Component = React.createClass({
 *     mixins: [FluxibleMixin],
 *     statics: {
 *         storeListeners: [FooStore]
 *     },
 *     onChange: function () {
 *         this.setState(this.context.getStore(FooStore).getState());
 *     },
 *     ...
 * });
 * @example
 * // Register listener with custom named handler
 * var Component = React.createClass({
 *     mixins: [FluxibleMixin],
 *     statics: {
 *         storeListeners: {
 *             'onChange2': [FooStore]
 *         }
 *     },
 *     onChange2: function () {
 *         this.setState(this.context.getStore(FooStore).getState());
 *     },
 *     ...
 * });
 */
var DEFAULT_CHANGE_HANDLER = 'onChange';
var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);

var FluxibleMixin = {

    _isMounted: false,

    contextTypes: {
        executeAction: PropTypes.func,
        getStore: PropTypes.func
    },

    /**
     * Registers staticly declared listeners
     * @method componentDidMount
     */
    componentDidMount: function componentDidMount() {
        this._isMounted = true;
        this._fluxible_listeners = [];
        var self = this;

        // Register static listeners
        this.getListeners().forEach(function(listener) {
            self._attachStoreListener(listener);
        });
    },

    /**
     * Calls an action
     * @method executeAction
     */
    executeAction: function executeAction() {
        var context = this.props.context || this.context;
        if (!context || !context.executeAction) {
            throw new Error('executeAction was called but no context was provided. Pass the fluxible' +
            'context via a `context` prop or via React\'s context.');
        }
        return context.executeAction.apply(context, arguments);
    },

    /**
     * Gets a store instance from the context
     * @param {Function|String} store The store to get
     * @returns {Object}
     * @method getStore
     */
    getStore: function (store) {
        var storeInstance = store;
        if ('object' !== typeof storeInstance) {
            var context = this.props.context || this.context;
            if (!context) {
                throw new Error('storeListener mixin was called but no context was provided for getting the store.' +
                'Pass the fluxible context via a `context` prop or via React\'s context.');
            }
            storeInstance = context.getStore(store);
        }
        return storeInstance;
    },

    /**
     * Gets from the context all store instances required by this component
     * @returns {Object}
     * @method getStores
     */
    getStores: function() {
        var storesByName = this.getListeners().reduce(function (accum, listener) {
            accum[listener.store.constructor.storeName] = listener.store;
            return accum;
        }, {});
        return Object.keys(storesByName).map(function(storeName) {
            return storesByName[storeName];
        });
    },

    /**
     * Gets a store-change handler from the component
     * @param {Function|String} handler The handler to get
     * @returns {Function}
     * @method getHandler
     */
    getHandler: function (handler) {
        if ('string' === typeof handler) {
            handler = this[handler];
        }

        if (!handler) {
            throw new Error('storeListener attempted to add undefined handler. Make sure handlers actually exist.');
        }

        return handler;
    },

    /**
     * Gets a listener descriptor for a store and store-change handler
     * @param {Function|String} store Store
     * @param {Function|String} handler The handler function or method name
     * @returns {Object}
     * @method getListener
     */
    getListener: function(store, handler) {
        handler = this.getHandler(handler);
        var storeInstance = this.getStore(store);

        return {
            store: storeInstance,
            handler: handler
        };
    },

    /**
     * Gets all store-change listener descriptors from the component
     * @returns {Object}
     * @method getListeners
     */
    getListeners: function() {
        var self = this;
        var storeListeners = self.constructor.storeListeners; // Static property on component

        // get static listeners
        if (storeListeners) {
            if (Array.isArray(storeListeners)) {
                return storeListeners.map(function(store) {
                    return self.getListener(store, DEFAULT_CHANGE_HANDLER);
                });
            } else {
                return Object.keys(storeListeners).reduce(function (accum, handlerName) {
                    var stores = storeListeners[handlerName];
                    if (!Array.isArray(stores)) {
                        stores = [stores];
                    }
                    return accum.concat(stores.map(function (store) {
                        return self.getListener(store, handlerName);
                    }));
                }, []);
            }
        }

        return [];
    },

    /**
     * If provided with events, will attach listeners to events on EventEmitter objects(i.e. Stores)
     * If the component isn't mounted, events aren't attached.
     * @param {Object} listener
     * @param {Object} listener.store Store instance
     * @param {Object} listener.handler Handler function or method name
     * @method _attachStoreListener
     * @private
     */
    _attachStoreListener: function _attachStoreListener(listener) {
        if (!this._isMounted) {
            throw new Error('storeListener mixin called listen when component wasn\'t mounted.');
        }

        listener.store.on('change', listener.handler);
        this._fluxible_listeners.push(listener);
    },

    /**
     * Removes all listeners
     * @method componentWillUnmount
     */
    componentWillUnmount: function componentWillUnmount() {
        if (Array.isArray(this._fluxible_listeners)) {
            this._fluxible_listeners.forEach(function (listener) {
                listener.store.removeListener('change', listener.handler);
            });
        }
        this._isMounted = false;
        this._fluxible_listeners = [];
    }
};

module.exports = FluxibleMixin;


/***/ }),
/* 3223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var batchedUpdates = __webpack_require__(39).unstable_batchedUpdates;

module.exports = function createBatchedUpdatePlugin(options) {
    /**
     * @class BatchedUpdatePlugin
     */
    return {
        name: 'BatchedUpdatePlugin',
        /**
         * Called to plug the FluxContext
         * @method plugContext
         * @returns {Object}
         */
        plugContext: function plugContext() {
            return {
                /**
                 * Provides full access to the router in the action context
                 * @param {Object} actionContext
                 */
                plugActionContext: function plugActionContext(actionContext) {
                    var oldDispatch = actionContext.dispatch;
                    actionContext.dispatch = function () {
                        var args = arguments;
                        batchedUpdates(function () {
                            oldDispatch.apply(actionContext, args);
                        });
                    };
                }
            };
        }
    };
};


/***/ }),
/* 3224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var React = __webpack_require__(1);
var FluxibleComponent = __webpack_require__(2121);

/**
 * Creates an instance of the app level component with given props and a proper component
 * context.
 * @param {FluxibleContext} fluxibleContext
 * @param {Object} props
 * @return {ReactElement}
 */
module.exports = function createElement(fluxibleContext, props) {
    var Component = fluxibleContext.getComponent();
    if (!Component) {
        throw new Error('A top-level component was not passed to the Fluxible' +
            ' constructor.');
    }
    if (Component.displayName && -1 !== Component.displayName.indexOf('contextProvider')) {
        return React.createElement(Component, Object.assign({}, {
            context: fluxibleContext.getComponentContext()
        }, props));
    }
    var componentInstance = React.createElement(Component, props);
    return React.createElement(FluxibleComponent, {
        context: fluxibleContext.getComponentContext()
    }, componentInstance);
};


/***/ }),
/* 3225 */,
/* 3226 */,
/* 3227 */,
/* 3228 */,
/* 3229 */,
/* 3230 */,
/* 3231 */,
/* 3232 */,
/* 3233 */,
/* 3234 */,
/* 3235 */,
/* 3236 */,
/* 3237 */,
/* 3238 */,
/* 3239 */,
/* 3240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fireAuthModalEvent = fireAuthModalEvent;
exports.fireFormInteractionEvent = fireFormInteractionEvent;

var _dibsTracking = __webpack_require__(27);

var _dibsTracking2 = _interopRequireDefault(_dibsTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gaActions = {
    'register': 'registration',
    'password-only': 'login',
    'reset-password': 'reset password',
    'forgot-password': 'forgot password',
    'reset-invalid': 'reset invalid',
    'update-password': 'update password',
    '/about/privacy-policy/': 'legal text',
    '/about/useragreement/': 'legal text',
    'confirm': 'verification'
};

function getGaAction(action) {
    return gaActions[action] || action || "";
}

function getGaCategory(action) {
    return getGaAction(action).replace(' verification', '');
}

function getFormInteractionLabel(interaction) {
    switch (interaction) {
        case 'two':
            return 'registration step 1 completed (email)';

        case 'user-type':
            return 'registration step 2 completed (password)';

        case 'checkout embedded login':
            return 'log in on embedded checkout registration form';
    }
    return '';
}

function fireAuthModalEvent(gaObj, flowStep) {
    var action = getGaAction(gaObj.action);
    var category = getGaCategory(action);
    _dibsTracking2.default.trackEvent({
        category: category,
        action: action + ' ' + flowStep,
        label: gaObj.label,
        value: gaObj.value
    });
}

function fireFormInteractionEvent(action, interaction, other, additional) {
    var formattedAction = getGaAction(action);
    var category = getGaCategory(action);
    var label = getFormInteractionLabel(interaction, other);
    if (formattedAction && label) {
        _dibsTracking2.default.trackEvent({
            action: formattedAction + ' form interaction',
            additional: additional || {},
            category: category,
            label: label
        });
    }
};

/***/ }),
/* 3241 */,
/* 3242 */,
/* 3243 */,
/* 3244 */,
/* 3245 */,
/* 3246 */,
/* 3247 */,
/* 3248 */,
/* 3249 */,
/* 3250 */,
/* 3251 */,
/* 3252 */,
/* 3253 */,
/* 3254 */,
/* 3255 */,
/* 3256 */,
/* 3257 */,
/* 3258 */,
/* 3259 */,
/* 3260 */,
/* 3261 */,
/* 3262 */,
/* 3263 */,
/* 3264 */,
/* 3265 */,
/* 3266 */,
/* 3267 */,
/* 3268 */,
/* 3269 */,
/* 3270 */,
/* 3271 */,
/* 3272 */,
/* 3273 */,
/* 3274 */,
/* 3275 */,
/* 3276 */,
/* 3277 */,
/* 3278 */,
/* 3279 */,
/* 3280 */,
/* 3281 */,
/* 3282 */,
/* 3283 */,
/* 3284 */,
/* 3285 */,
/* 3286 */,
/* 3287 */,
/* 3288 */,
/* 3289 */,
/* 3290 */,
/* 3291 */,
/* 3292 */,
/* 3293 */,
/* 3294 */,
/* 3295 */,
/* 3296 */,
/* 3297 */,
/* 3298 */,
/* 3299 */,
/* 3300 */,
/* 3301 */,
/* 3302 */,
/* 3303 */,
/* 3304 */,
/* 3305 */,
/* 3306 */,
/* 3307 */,
/* 3308 */,
/* 3309 */,
/* 3310 */,
/* 3311 */,
/* 3312 */,
/* 3313 */,
/* 3314 */,
/* 3315 */,
/* 3316 */,
/* 3317 */,
/* 3318 */,
/* 3319 */,
/* 3320 */,
/* 3321 */,
/* 3322 */,
/* 3323 */,
/* 3324 */,
/* 3325 */,
/* 3326 */,
/* 3327 */,
/* 3328 */,
/* 3329 */,
/* 3330 */,
/* 3331 */,
/* 3332 */,
/* 3333 */,
/* 3334 */,
/* 3335 */,
/* 3336 */,
/* 3337 */,
/* 3338 */,
/* 3339 */,
/* 3340 */,
/* 3341 */,
/* 3342 */,
/* 3343 */,
/* 3344 */,
/* 3345 */,
/* 3346 */,
/* 3347 */,
/* 3348 */,
/* 3349 */,
/* 3350 */,
/* 3351 */,
/* 3352 */,
/* 3353 */,
/* 3354 */,
/* 3355 */,
/* 3356 */,
/* 3357 */,
/* 3358 */,
/* 3359 */,
/* 3360 */,
/* 3361 */,
/* 3362 */,
/* 3363 */,
/* 3364 */,
/* 3365 */,
/* 3366 */,
/* 3367 */,
/* 3368 */,
/* 3369 */,
/* 3370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Lior Elrom
 * Date: 4/12/16
 * Time: 5:47 PM
 */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ = __webpack_require__(22);
var React = __webpack_require__(1);
var classNames = __webpack_require__(16);

var _require = __webpack_require__(137),
    URL = _require.URL;

var User = __webpack_require__(28);
var chatUtils = __webpack_require__(271);
var storage = __webpack_require__(492);
var trackEvent = __webpack_require__(709);
var surveyCopy = __webpack_require__(2549);
var styles = __webpack_require__(3121);

// components

var _require2 = __webpack_require__(666),
    Modal = _require2.Modal,
    Header = _require2.Header;

var DibsRadioButtonInput = __webpack_require__(2175);

var getUserId = function getUserId() {
    var loggedIn = User.loggedIn();
    return loggedIn ? User.getCurrentUser().id : "Not logged in";
};

var CheckoutSurvey = function (_React$Component) {
    _inherits(CheckoutSurvey, _React$Component);

    function CheckoutSurvey(props) {
        _classCallCheck(this, CheckoutSurvey);

        var _this = _possibleConstructorReturn(this, (CheckoutSurvey.__proto__ || Object.getPrototypeOf(CheckoutSurvey)).call(this, props));

        _this.onRadioClick = _this.onRadioClick.bind(_this);
        _this.closeModal = _this.closeModal.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.state = {
            isOpened: true,
            isDisabled: false,
            selected: '',
            additionalInfo: ''
        };
        return _this;
    }

    _createClass(CheckoutSurvey, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.radioOptions = _.shuffle(surveyCopy.radioOptions);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            storage.setHasSeenSurvey();
            trackEvent.triggerCheckoutSurveyDisplayed();
        }
    }, {
        key: 'onRadioClick',
        value: function onRadioClick(value) {
            this.setState({ selected: value });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.setState({ isOpened: false });
        }
    }, {
        key: 'onChange',
        value: function onChange(event) {
            this.setState({ additionalInfo: event.target.value });
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit() {
            var _state = this.state,
                reason = _state.selected,
                additionalInfo = _state.additionalInfo;

            trackEvent.triggerCheckoutSurveySubmitted();
            chatUtils.track.checkoutSurveySubmitted({ reason: reason, additionalInfo: additionalInfo });
            this.setState({ isDisabled: true });
        }
    }, {
        key: 'getRadioOptions',
        value: function getRadioOptions() {
            var _this2 = this;

            var shuffledOptions = this.radioOptions;
            var RadioOptions = shuffledOptions.map(function (option) {
                return _this2.renderRadio(option);
            });
            RadioOptions.push(this.renderRadio('Other'));
            return RadioOptions;
        }
    }, {
        key: 'renderRadio',
        value: function renderRadio(value) {
            var selected = this.state.selected;

            var isSelected = selected === value;
            var radioDataTag = value.replace(/\s/g, '-').replace('.', '').toLowerCase();

            return React.createElement(DibsRadioButtonInput, {
                inputId: value,
                name: 'reason',
                value: value,
                title: value,
                titleClass: styles.labelClass,
                labelDataTn: radioDataTag,
                isSelected: isSelected,
                onSelect: this.onRadioClick.bind(this, value),
                key: value
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state2 = this.state,
                selected = _state2.selected,
                isOpened = _state2.isOpened,
                isDisabled = _state2.isDisabled;

            var surveyInfo = storage.getSurveyInfo();
            var itemId = surveyInfo.itemId,
                orderType = surveyInfo.orderType;

            var radioOptions = this.getRadioOptions();
            var baseDataTn = 'checkout-survey';

            var textareaContainerClass = classNames(_defineProperty({}, styles.desktopHidden, !selected));
            var buttonClass = classNames('button-large', 'button-primary', 'mobile-full-width', {
                'disabled': isDisabled
            });

            return React.createElement(
                Modal,
                { modalClass: styles.container, dataTn: baseDataTn, isOpened: isOpened, closeModal: this.closeModal },
                React.createElement(
                    Header,
                    null,
                    React.createElement(
                        'span',
                        { className: styles.modalHeader, 'data-tn': baseDataTn + '-header' },
                        surveyCopy.title
                    )
                ),
                React.createElement(
                    'form',
                    {
                        id: 'tfa_0',
                        method: 'post',
                        action: 'https://www.tfaforms.com/responses/processor',
                        'data-tn': baseDataTn + '-form',
                        ref: 'form',
                        onSubmit: this.onSubmit,
                        className: styles.formClass
                    },
                    radioOptions,
                    React.createElement(
                        'div',
                        { className: textareaContainerClass },
                        React.createElement(
                            'p',
                            { className: styles.textAreaLabel },
                            surveyCopy.textAreaLabel
                        ),
                        React.createElement('textarea', {
                            className: styles.textarea,
                            name: 'tfa_6',
                            maxLength: '1000',
                            placeholder: surveyCopy.placeholder,
                            'data-tn': baseDataTn + '-text-input',
                            onChange: this.onChange
                        }),
                        React.createElement(
                            'div',
                            { className: styles.buttonWrapper },
                            React.createElement(
                                'button',
                                { type: 'submit', className: buttonClass, disabled: isDisabled, 'data-tn': baseDataTn + '-submit' },
                                surveyCopy.submit
                            )
                        )
                    ),
                    React.createElement('input', { type: 'hidden', id: 'tfa_9', name: 'tfa_9', value: navigator.userAgent }),
                    React.createElement('input', { type: 'hidden', id: 'tfa_8', name: 'tfa_8', value: getUserId() }),
                    React.createElement('input', { type: 'hidden', id: 'tfa_10', name: 'tfa_10', value: itemId }),
                    React.createElement('input', { type: 'hidden', id: 'tfa_11', name: 'tfa_11', value: orderType }),
                    React.createElement('input', { type: 'hidden', id: 'tfa_13', name: 'tfa_13', value: URL.source }),
                    React.createElement('input', { type: 'hidden', id: 'tfa_12', name: 'tfa_12', value: selected }),
                    React.createElement('input', { type: 'hidden', id: 'tfa_dbFormId', name: 'tfa_dbFormId', value: '413075' }),
                    React.createElement('input', { type: 'hidden', id: 'tfa_dbControl', name: 'tfa_dbControl', value: 'c6cdf45727af0ab1bbf30b6ec6c49e33' }),
                    React.createElement('input', { type: 'hidden', id: 'tfa_dbVersionId', name: 'tfa_dbVersionId', value: '5' }),
                    React.createElement('input', { type: 'hidden', id: 'tfa_switchedoff', name: 'tfa_switchedoff', value: '' }),
                    React.createElement('input', { type: 'hidden', id: 'tfa_dbResponseId', name: 'tfa_dbResponseId', value: '' })
                )
            );
        }
    }]);

    return CheckoutSurvey;
}(React.Component);

module.exports = CheckoutSurvey;

/***/ }),
/* 3371 */,
/* 3372 */,
/* 3373 */,
/* 3374 */,
/* 3375 */,
/* 3376 */,
/* 3377 */,
/* 3378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var $ = __webpack_require__(5);
var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classNames = __webpack_require__(16);
var CheckmarkIcon = __webpack_require__(410);
var ArrowDownIcon = __webpack_require__(552);
var ContextComponent = __webpack_require__(61);

var _require = __webpack_require__(135),
    connectToStores = _require.connectToStores;

var currencies = __webpack_require__(1473);
var getCurrencySymbol = __webpack_require__(2082);
var root = __webpack_require__(102);

var UserStore = __webpack_require__(114);
var currencyActions = __webpack_require__(894);
var CurrencyLocalization = __webpack_require__(1118);
var currencyLocalizer = new CurrencyLocalization({ $el: $(document.body) });

var currencySelectTracking = __webpack_require__(3380);

var style = __webpack_require__(2977);

var CurrencySelect = function (_ContextComponent) {
    _inherits(CurrencySelect, _ContextComponent);

    function CurrencySelect(props) {
        _classCallCheck(this, CurrencySelect);

        var _this = _possibleConstructorReturn(this, (CurrencySelect.__proto__ || Object.getPrototypeOf(CurrencySelect)).call(this, props));

        _this.state = {
            showTooltip: false
        };

        _this._onClick = _this._onClick.bind(_this);
        _this._handleOpen = _this._handleOpen.bind(_this);
        _this._handleClose = _this._handleClose.bind(_this);
        return _this;
    }

    _createClass(CurrencySelect, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            root.addEventListener('click', this._handleClose);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            root.removeEventListener('click', this._handleClose);
        }
    }, {
        key: '_onClick',
        value: function _onClick(event) {
            var currency = event.currentTarget.dataset.value;


            event.preventDefault();
            this.context.executeAction(currencyActions.updateUserCurrency, { currency: currency });
            this.context.executeAction(currencySelectTracking.fireCurrencyUpdateTracking, { currency: currency });
            currencyLocalizer.updatePrices(true, currency);

            this._handleClose();
        }
    }, {
        key: '_handleOpen',
        value: function _handleOpen(event) {
            event.stopPropagation();
            this.setState({ showTooltip: true });
        }
    }, {
        key: '_handleClose',
        value: function _handleClose() {
            this.setState({ showTooltip: false });
        }
    }, {
        key: '_getDropdown',
        value: function _getDropdown() {
            var _this2 = this;

            var _props = this.props,
                currentCurrency = _props.currentCurrency,
                dataTn = _props.dataTn;


            return React.createElement(
                'div',
                { className: style.currencyList },
                currencies.map(function (currency) {
                    var symbol = getCurrencySymbol(currency);
                    var checkmarkClass = classNames(style.checkmark, _defineProperty({}, style.isActive, currentCurrency === currency));

                    return React.createElement(
                        'a',
                        { className: style.currencyLink,
                            href: '#',
                            onClick: _this2._onClick,
                            'data-value': currency,
                            'data-tn': dataTn + '-link-' + currency.toLowerCase(),
                            key: currency },
                        React.createElement(CheckmarkIcon, { className: checkmarkClass }),
                        React.createElement(
                            'span',
                            { className: style.currencySymbol },
                            symbol
                        ),
                        currency
                    );
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var currentCurrency = this.props.currentCurrency;

            var symbol = getCurrencySymbol(currentCurrency);
            var dropdownClass = classNames(style.dropdownWrapper, {
                'is-hidden': !this.state.showTooltip
            });

            return React.createElement(
                'div',
                { className: style.currencyWrap },
                React.createElement(
                    'div',
                    { className: style.currency, ref: 'currency', onClick: this._handleOpen, 'data-tn': 'selected-currency' },
                    React.createElement(
                        'span',
                        { className: style.currencySymbol },
                        symbol
                    ),
                    currentCurrency,
                    React.createElement(ArrowDownIcon, { className: style.arrowDown })
                ),
                React.createElement(
                    'div',
                    { className: dropdownClass },
                    this._getDropdown()
                )
            );
        }
    }]);

    return CurrencySelect;
}(ContextComponent);

CurrencySelect.propTypes = {
    currentCurrency: PropTypes.string.isRequired,
    dataTn: PropTypes.string
};

CurrencySelect = connectToStores(CurrencySelect, [UserStore], function (context) {
    var userStore = context.getStore(UserStore);

    return {
        currentCurrency: userStore.getCurrency()
    };
});

module.exports = CurrencySelect;

/***/ }),
/* 3379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(39);
var provideContext = __webpack_require__(287);
var CurrencySelect = provideContext(__webpack_require__(3378));

var currencySelectHelper = {
    init: function init() {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var context = payload.context,
            select = payload.select;

        var dataTn = select && select.dataset.tn;

        // make sure currency selector exist in the page
        if (select) {
            ReactDOM.render(React.createElement(CurrencySelect, {
                context: context.getComponentContext(),
                dataTn: dataTn
            }), select);
        }
    }
};

module.exports = currencySelectHelper;

/***/ }),
/* 3380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);
var NC = __webpack_require__(1460);
var tracking = __webpack_require__(27);

var currencySelectTracking = {
    fireCurrencyUpdateTracking: function fireCurrencyUpdateTracking(actionContext, payload, done) {
        var currency = payload.currency;
        // Currency select is currently visible in footer

        var value = $(NC.HEADER).hasClass(NC.SCROLLED_CLASS) ? 1 : 0;
        var additional = { defaultCurrency: currency + ' Selected' };

        tracking.trackEvent({
            category: 'navigation',
            action: 'footer navigation click',
            label: 'change currency|' + currency.toLowerCase(),
            value: value,
            additional: additional
        });

        done();
    }
};

module.exports = currencySelectTracking;

/***/ }),
/* 3381 */,
/* 3382 */,
/* 3383 */,
/* 3384 */,
/* 3385 */,
/* 3386 */,
/* 3387 */,
/* 3388 */,
/* 3389 */,
/* 3390 */,
/* 3391 */,
/* 3392 */,
/* 3393 */,
/* 3394 */,
/* 3395 */,
/* 3396 */,
/* 3397 */,
/* 3398 */,
/* 3399 */,
/* 3400 */,
/* 3401 */,
/* 3402 */,
/* 3403 */,
/* 3404 */,
/* 3405 */,
/* 3406 */,
/* 3407 */,
/* 3408 */,
/* 3409 */,
/* 3410 */,
/* 3411 */,
/* 3412 */,
/* 3413 */,
/* 3414 */,
/* 3415 */,
/* 3416 */,
/* 3417 */,
/* 3418 */,
/* 3419 */,
/* 3420 */,
/* 3421 */,
/* 3422 */,
/* 3423 */,
/* 3424 */,
/* 3425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Component = React.Component;

var Relay = __webpack_require__(17);

var _require = __webpack_require__(516),
    MakeOfferModal = _require.MakeOfferModal,
    LowBall = _require.LowBall,
    MakeOffer = _require.MakeOffer,
    AbandonMakeOfferModal = _require.AbandonMakeOfferModal,
    ModalWrapper = _require.ModalWrapper,
    Confirmation = _require.Confirmation;

var getNetworkLayer = __webpack_require__(743);
var abExperiments = __webpack_require__(494);

var _require2 = __webpack_require__(324),
    getUserId = _require2.getUserId,
    cookieJarConstants = _require2.cookieJarConstants;

var checkoutStorage = __webpack_require__(492);

function getNewEnvironment() {
    var e = new Relay.Environment();
    e.injectNetworkLayer(getNetworkLayer());
    return e;
}

var optimizelyVariant = 'control';
if (abExperiments.makeOfferCheckbox) {
    Promise.resolve(abExperiments.makeOfferCheckbox).then(function (res) {
        optimizelyVariant = res;
    });
}

var MakeOfferRenderer = function (_Component) {
    _inherits(MakeOfferRenderer, _Component);

    function MakeOfferRenderer() {
        _classCallCheck(this, MakeOfferRenderer);

        return _possibleConstructorReturn(this, (MakeOfferRenderer.__proto__ || Object.getPrototypeOf(MakeOfferRenderer)).apply(this, arguments));
    }

    _createClass(MakeOfferRenderer, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var modalProps = this.props.modalProps;
            var itemId = modalProps.itemId,
                sellerId = modalProps.sellerId;

            var userId = getUserId(document.cookie, cookieJarConstants.MASQUERADE_BUYER);

            var queryConfig = {
                queries: {
                    viewer: function viewer(component, params) {
                        return function (RQL_0) {
                            return {
                                children: [].concat.apply([], [{
                                    fieldName: 'id',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'ID'
                                }, Relay.QL.__frag(RQL_0)]),
                                fieldName: 'viewer',
                                kind: 'Query',
                                metadata: {},
                                name: 'MakeOfferRenderer',
                                type: 'Viewer'
                            };
                        }(component.getFragment('viewer', params));
                    }
                },
                name: 'MakeOfferModalRoute',
                params: {
                    shouldFetchUser: !!userId,
                    itemId: itemId,
                    sellerId: sellerId,
                    userId: userId
                }
            };

            var forceEnvironmentUpdate = function forceEnvironmentUpdate(variablesToSet) {
                // manually set variables in the queryConfig because relay.setVariables
                // causes a re-render, and we're already forcing a re-render with forceUpdate
                queryConfig.params = Object.assign({}, queryConfig.params, variablesToSet);
                _this2.forceUpdate();
            };

            return React.createElement(Relay.Renderer, {
                Container: MakeOfferModal,
                environment: getNewEnvironment(),
                queryConfig: queryConfig,
                render: function render(_ref) {
                    var done = _ref.done,
                        error = _ref.error,
                        props = _ref.props;

                    if (error) {
                        return React.createElement(ModalWrapper, {
                            openOnRender: true,
                            isError: true
                        });
                    } else if (done && props) {
                        var makeOfferProps = Object.assign({}, modalProps, props, {
                            forceEnvironmentUpdate: forceEnvironmentUpdate,
                            optimizelyVariant: optimizelyVariant
                        });
                        return React.createElement(
                            MakeOfferModal,
                            makeOfferProps,
                            React.createElement(MakeOffer, null),
                            React.createElement(LowBall, null),
                            React.createElement(AbandonMakeOfferModal, {
                                onAbandonMakeOfferSuccess: function onAbandonMakeOfferSuccess() {
                                    checkoutStorage.clearPreAuthOfferModalInfo();
                                    checkoutStorage.unsetSurveyInfo();
                                },
                                onLeaveAbandonMakeOffer: checkoutStorage.clearPreAuthOfferModalInfo
                            }),
                            React.createElement(Confirmation, null)
                        );
                    } else {
                        return React.createElement(ModalWrapper, {
                            openOnRender: true,
                            isLoading: true
                        });
                    }
                }
            });
        }
    }]);

    return MakeOfferRenderer;
}(Component);

MakeOfferRenderer.propTypes = {
    queryProps: PropTypes.object,
    modalProps: PropTypes.object
};

module.exports = MakeOfferRenderer;

/***/ }),
/* 3426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var authModalLoader = __webpack_require__(266).default;

// pass off authentication process to the Auth modal
module.exports = function (authProps) {
    var action = authProps.action,
        email = authProps.email,
        flow = authProps.flow,
        ga = authProps.ga;

    return authModalLoader.show({
        action: action,
        email: email,
        flow: flow || authModalLoader.constants.CONTACT_DEALER_FLOW,
        ga: ga
    });
};

/***/ }),
/* 3427 */,
/* 3428 */,
/* 3429 */,
/* 3430 */,
/* 3431 */,
/* 3432 */,
/* 3433 */,
/* 3434 */,
/* 3435 */,
/* 3436 */,
/* 3437 */,
/* 3438 */,
/* 3439 */,
/* 3440 */,
/* 3441 */,
/* 3442 */,
/* 3443 */,
/* 3444 */,
/* 3445 */,
/* 3446 */,
/* 3447 */,
/* 3448 */,
/* 3449 */,
/* 3450 */,
/* 3451 */,
/* 3452 */,
/* 3453 */,
/* 3454 */,
/* 3455 */,
/* 3456 */,
/* 3457 */,
/* 3458 */,
/* 3459 */,
/* 3460 */,
/* 3461 */,
/* 3462 */,
/* 3463 */,
/* 3464 */,
/* 3465 */,
/* 3466 */,
/* 3467 */,
/* 3468 */,
/* 3469 */,
/* 3470 */,
/* 3471 */,
/* 3472 */,
/* 3473 */,
/* 3474 */,
/* 3475 */,
/* 3476 */,
/* 3477 */,
/* 3478 */,
/* 3479 */,
/* 3480 */,
/* 3481 */,
/* 3482 */,
/* 3483 */,
/* 3484 */,
/* 3485 */,
/* 3486 */,
/* 3487 */,
/* 3488 */,
/* 3489 */,
/* 3490 */,
/* 3491 */,
/* 3492 */,
/* 3493 */,
/* 3494 */,
/* 3495 */,
/* 3496 */,
/* 3497 */,
/* 3498 */,
/* 3499 */,
/* 3500 */,
/* 3501 */,
/* 3502 */,
/* 3503 */,
/* 3504 */,
/* 3505 */,
/* 3506 */,
/* 3507 */,
/* 3508 */,
/* 3509 */,
/* 3510 */,
/* 3511 */,
/* 3512 */,
/* 3513 */,
/* 3514 */,
/* 3515 */,
/* 3516 */,
/* 3517 */,
/* 3518 */,
/* 3519 */,
/* 3520 */,
/* 3521 */,
/* 3522 */,
/* 3523 */,
/* 3524 */,
/* 3525 */,
/* 3526 */,
/* 3527 */,
/* 3528 */,
/* 3529 */,
/* 3530 */,
/* 3531 */,
/* 3532 */,
/* 3533 */,
/* 3534 */,
/* 3535 */,
/* 3536 */,
/* 3537 */,
/* 3538 */,
/* 3539 */,
/* 3540 */,
/* 3541 */,
/* 3542 */,
/* 3543 */,
/* 3544 */,
/* 3545 */,
/* 3546 */,
/* 3547 */,
/* 3548 */,
/* 3549 */,
/* 3550 */,
/* 3551 */,
/* 3552 */,
/* 3553 */,
/* 3554 */,
/* 3555 */,
/* 3556 */,
/* 3557 */,
/* 3558 */,
/* 3559 */,
/* 3560 */,
/* 3561 */,
/* 3562 */,
/* 3563 */,
/* 3564 */,
/* 3565 */,
/* 3566 */,
/* 3567 */,
/* 3568 */,
/* 3569 */,
/* 3570 */,
/* 3571 */,
/* 3572 */,
/* 3573 */,
/* 3574 */,
/* 3575 */,
/* 3576 */,
/* 3577 */,
/* 3578 */,
/* 3579 */,
/* 3580 */,
/* 3581 */,
/* 3582 */,
/* 3583 */,
/* 3584 */,
/* 3585 */,
/* 3586 */,
/* 3587 */,
/* 3588 */,
/* 3589 */,
/* 3590 */,
/* 3591 */,
/* 3592 */,
/* 3593 */,
/* 3594 */,
/* 3595 */,
/* 3596 */,
/* 3597 */,
/* 3598 */,
/* 3599 */,
/* 3600 */,
/* 3601 */,
/* 3602 */,
/* 3603 */,
/* 3604 */,
/* 3605 */,
/* 3606 */,
/* 3607 */,
/* 3608 */,
/* 3609 */,
/* 3610 */,
/* 3611 */,
/* 3612 */,
/* 3613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.init = undefined;

var _index = __webpack_require__(2319);

var _relayEnvironmnentProvider = __webpack_require__(463);

var _dibsTracking = __webpack_require__(27);

var $ = __webpack_require__(5);

var init = exports.init = function init() {
    var domNode = document.getElementById('js-footer');

    if (domNode) {
        var _getBuyerFooterClient = (0, _index.getBuyerFooterClient)((0, _relayEnvironmnentProvider.getEnvironment)(), domNode, {
            footer: { trackEvent: _dibsTracking.trackEvent, trackSocial: _dibsTracking.trackSocial }
        }),
            updateUserState = _getBuyerFooterClient.updateUserState;

        $.subscribe('login:change', updateUserState);
    }
};

/***/ }),
/* 3614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.init = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(39);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _dibsJqueryShim = __webpack_require__(5);

var _dibsJqueryShim2 = _interopRequireDefault(_dibsJqueryShim);

var _serverVars = __webpack_require__(18);

var _serverVars2 = _interopRequireDefault(_serverVars);

var _lodash = __webpack_require__(14);

var _lodash2 = _interopRequireDefault(_lodash);

var _dibsTracking = __webpack_require__(27);

var _index = __webpack_require__(2319);

var _chat = __webpack_require__(271);

var _chat2 = _interopRequireDefault(_chat);

var _relayEnvironmnentProvider = __webpack_require__(463);

var _authModalLoader = __webpack_require__(266);

var _authModalLoader2 = _interopRequireDefault(_authModalLoader);

var _User = __webpack_require__(15);

var _User2 = _interopRequireDefault(_User);

var _screenSize = __webpack_require__(382);

var _authModalCheck = __webpack_require__(2569);

var _authModalCheck2 = _interopRequireDefault(_authModalCheck);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavMobileRenderer = void 0;

function initializeMobileNav() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        context = _ref.context,
        store = _ref.store;

    _reactDom2.default.render(
    // Using a Renderer to not make another call to get Nav Data to pass down to Backbone View
    // Can't use `preLoadedData` because keys for data comes back with hash suffix e.g. '_navigation2R0KfN'
    _react2.default.createElement(NavMobileRenderer, { context: context, store: store }), document.createElement('div'));

    store.subscribe(function () {
        var _store$getState = store.getState(),
            header = _store$getState.header;

        var isUserTypeTrade = header.isUserTypeTrade;


        if (isUserTypeTrade) {
            var mastheadEl = (0, _lodash2.default)(document.getElementsByClassName('masthead'), '[0]', null);
            var messageContainerEl = (0, _lodash2.default)(document.getElementsByClassName('messageBannerContainer'), '[0]', null);

            if (mastheadEl && !mastheadEl.classList.contains('is-trade')) {
                mastheadEl.className += ' is-trade';
            }
            if (messageContainerEl && !messageContainerEl.classList.contains('is-trade')) {
                messageContainerEl.className += ' is-trade';
            }
        }
    });
}

function initializeNav() {

    // Show login/registration modal if special query param is present
    _authModalCheck2.default.init();

    var _getBuyerHeaderClient = (0, _index.getBuyerHeaderClient)((0, _relayEnvironmnentProvider.getEnvironment)(), document.getElementById('js-header'), {
        state: {
            header: _extends({}, _serverVars2.default.get('header.preLoadedState.header') || {}, {
                showAuthModal: _authModalLoader2.default.show.bind(_authModalLoader2.default),
                showChatUtils: _chat2.default.show.bind(_chat2.default),
                logoutUser: _User2.default.logout.bind(_User2.default, true),
                trackEvent: _dibsTracking.trackEvent
            })
        }
    }),
        updateBuyerHeaderUserState = _getBuyerHeaderClient.updateBuyerHeaderUserState,
        store = _getBuyerHeaderClient.store;

    _dibsJqueryShim2.default.subscribe('login:change', updateBuyerHeaderUserState);
    return { store: store };
}

var init = exports.init = function init(context) {
    var _initializeNav = initializeNav(),
        store = _initializeNav.store;

    var loadMobileNav = function loadMobileNav() {
        __webpack_require__.e/* require.ensure */(2).then((function () {
            NavMobileRenderer = __webpack_require__(2525);
            initializeMobileNav({ context: context, store: store });
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    };

    if ((0, _screenSize.isMobile)()) {
        loadMobileNav();
    } else {
        window.addEventListener('resize', function () {

            if ((0, _screenSize.isMobile)() && !NavMobileRenderer) {
                loadMobileNav();
            }
        });
    }
};

exports.default = { init: init };

/***/ }),
/* 3615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by daniel.gonzalez on 6/15/15.
 */



/*eslint-disable */

var _module$exports;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var constants = __webpack_require__(1193);
var base = '142876.measurementapi.com/serve';
var siteId = '90624';
var publisherId = '142876';
var destinationId = '171508';

module.exports = (_module$exports = {}, _defineProperty(_module$exports, constants.FULLSCREEN_NAME, {
    'production': {
        protocol: 'https://',
        base: base,
        ga: {
            utm_medium: 'internal-ad',
            utm_source: '1stdibs-mobile-web',
            utm_campaign: 'full-page-ad',
            utm_content: 'v10-full-screen-on-page-2'
        },
        params: {
            action: 'click',
            publisher_id: publisherId,
            site_id: siteId,
            destination_id: destinationId,
            my_campaign: '1stdibs-mobile-web',
            my_adgroup: 'full-page-ad',
            my_ad: 'v10-full-screen-on-page-2'
        }
    },
    'nonProduction': {
        protocol: 'https://',
        base: base,
        params: {
            action: 'click',
            publisher_id: publisherId,
            site_id: siteId,
            destination_id: destinationId,
            my_campaign: 'tes1',
            my_publisher: 'test1',
            my_ad: 'v10-full-screen-on-page-2',
            my_adgroup: 'test1',
            my_placement: 'test1'
        }
    }
}), _defineProperty(_module$exports, constants.MC_APP_BANNER, {
    'production': {
        //TODO: add google analytics, if desired
        protocol: 'https://',
        base: base,
        params: {
            action: 'click',
            publisher_id: publisherId,
            site_id: siteId,
            my_campaign: '1stdibs-website',
            my_adgroup: 'message-center',
            my_ad: 'respond-with-app'
        }
    },
    'nonProduction': {
        protocol: 'https://',
        base: base,
        params: {
            action: 'click',
            publisher_id: publisherId,
            site_id: siteId,
            my_campaign: '1stdibs-website',
            my_adgroup: 'message-center',
            my_ad: 'respond-with-app'
        }
    }
}), _module$exports);

/*eslint-enable */

/***/ }),
/* 3616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by daniel.gonzalez on 6/15/15.
 */



var $ = __webpack_require__(5);
var SV = __webpack_require__(18);
var matConfigs = __webpack_require__(3615);

module.exports = {
    getAdName: function getAdName() {
        return this._adName;
    },
    getMATConfig: function getMATConfig() {
        var adName = this.getAdName();
        var env = SV.get('settings.environment');
        return matConfigs[adName][env] || matConfigs[adName].nonProduction;
    },


    /**
     * @param srcLink - A Mobile App Tracking link we need to open in an iframe to start a tracking session.
     *                  We open it in an iframe to hide the Mobile App Tracking bridge page. Normally, this bridge page
     *                  would redirect you to the itunes store or the app, but you cannot redirect to the itunes store
     *                  (or to an app in chrome) from an iframe. As a fallback, we are forcing a redirect after the
     *                  iframe has been loaded. We are also forcing an optional redirect in case the timeoutLink is an
     *                  app the user does not have and we want to redirect them to the app store to get that app.
     * @param timeoutLink - first fallback link
     * @param optionalLink - second (and optional) fallback link
     */
    redirectInIframe: function redirectInIframe(srcLink, timeoutLink, optionalLink) {
        $('<iframe />').attr('src', srcLink).attr('style', 'display:none;').appendTo('body');
        window.setTimeout(function () {
            window.location.href = timeoutLink;
        }, 300);

        if (optionalLink) {
            window.setTimeout(function () {
                window.location.href = optionalLink;
            }, 600);
        }
    }
};

/***/ }),
/* 3617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by daniel.gonzalez on 6/12/15.
 */



var deepLink = __webpack_require__(1603);
var matLink = __webpack_require__(2572);
var constants = __webpack_require__(1193);

module.exports = {
    closeAd: function closeAd(e) {
        e.preventDefault();
        this.trackingOnClose();
        this.remove();
    },
    redirectToApp: function redirectToApp(e) {
        var config = this.getMATConfig();
        var link = deepLink.createDeepLink();
        var srcLink = matLink.createMATTrackingLink(config, link);
        var optionalLink = constants.ITUNES_LINK;

        e.preventDefault();

        this.redirectInIframe(srcLink, link, optionalLink);
        this.trackingOnContinueToApp();
        this.remove();
    }
};

/***/ }),
/* 3618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by daniel.gonzalez on 6/12/15.
 */



function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var tracking = __webpack_require__(27);
var constants = __webpack_require__(1193);

var trackingObjRender = {
    category: 'app promotion actions',
    label: 'initial load'
};

var trackingObjDownload = {
    category: 'app promotion actions',
    label: 'link click - get the free app',
    noninteraction: 0
};

var trackingObjClose = {
    category: 'app promotion actions',
    label: 'link click - close button'
};

var trackingObjContinueApp = {
    category: 'app promotion actions',
    label: 'link click - continue in app',
    noninteraction: 0
};

var _trackingObjMobileSite = {
    category: 'app promotion actions',
    label: 'link click - go to mobile site'
};

var gaActions = _defineProperty({}, constants.FULLSCREEN_NAME, 'app interstitial - full screen on second page');

function getGaAction(adName) {
    return gaActions[adName];
}

module.exports = {
    /**
     * Clones an obj constant, adds a ga action to the clone based on the ad, and passes the clone to the gtm dataLayer
     * @param trackingObjConstant - the tracking obj constant to be cloned
     */
    trackObj: function trackObj(trackingObjConstant) {
        var adName = this.getAdName();
        var action = getGaAction(adName);
        var trackingObj = Object.assign({ action: action }, trackingObjConstant);

        tracking.trackEvent(trackingObj);
    },


    /**
     * tracking that fires when a mobile ad appears
     */
    trackingOnRender: function trackingOnRender() {
        this.trackObj(trackingObjRender);
    },


    /**
     * tracking that fires when user clicks on the button to download the app in the app store
     */
    trackingOnDownload: function trackingOnDownload() {
        this.trackObj(trackingObjDownload);
    },


    /**
     * tracking that fires when user clicks on the button to close the ad
     */
    trackingOnClose: function trackingOnClose() {
        this.trackObj(trackingObjClose);
    },


    /**
     * tracking that fires when user clicks on the button to open up the app
     */
    trackingOnContinueToApp: function trackingOnContinueToApp() {
        this.trackObj(trackingObjContinueApp);
    },


    /**
     * tracking that fires when user clicks on the button to continue to the mobile site
     */
    trackingObjMobileSite: function trackingObjMobileSite() {
        this.trackObj(_trackingObjMobileSite);
    }
};

/***/ }),
/* 3619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);

var _require = __webpack_require__(282),
    sessionStorage = _require.sessionStorage;

var endpoints = __webpack_require__(284);

var SESSION_STORAGE_NAMESPACE = 'userRegionalInfo';

var RegionalInfo = SoaModel.extend({
    url: function url() {
        return endpoints.userRegionalInfo();
    },
    initialize: function initialize() {
        var regionalInfo = sessionStorage.getItem(SESSION_STORAGE_NAMESPACE);
        if (regionalInfo) {
            this.set(regionalInfo);
        }
    },
    getInfo: function getInfo() {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var ipAddress = payload.ipAddress;


        if (this.get('cached')) {
            return Promise.resolve();
        } else {
            return Promise.resolve(this.fetch({ data: { ipAddress: ipAddress } })).catch(function () {
                var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                console.log('unable to fetch ip address: ' + err.status + ' - ' + err.responseText);
            });
        }
    },
    parse: function parse(response, options) {
        response = SoaModel.prototype.parse.call(this, response, options);

        if (response && response.dataList) {
            var result = response.dataList[0];
            Object.assign(result, { cached: true });
            sessionStorage.setItem(SESSION_STORAGE_NAMESPACE, result);
            return result;
        }

        return {};
    }
});

module.exports = RegionalInfo;

/***/ }),
/* 3620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var tokenReplace = __webpack_require__(87);
var verticals = __webpack_require__(416);
var priceMixin = __webpack_require__(936);

// URL's
var URI_SEARCH_QUERY = '/search/?q={query}&rt=save';
var URI_SEARCH_QUERY_PRICE = '/search/?q={query}&price=[1 TO {price}]&currency={currency}&rt=save';
var URI_ATTRIBUTE = '/{vertical}/{attributeType}/{attributeValue}/?rt=save';

var SaveSearchModel = SoaModel.extend({
    /**
     * @param {Object} payload
     * @returns {Promise}
     */
    getSaveSearchData: function getSaveSearchData() {
        var _this = this;

        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new Promise(function (resolve, reject) {
            _this.fetch({
                url: _this.getSaveSearchUrl(payload)
            }).then(function () {
                return resolve(_this.toJSON());
            }).fail(function () {
                return reject();
            });
        });
    },


    /**
     * @param {Object} payload
     * @returns {String}
     */
    getSearchQueryUrl: function getSearchQueryUrl() {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var query = payload.query,
            price = payload.price;
        var currency = payload.currency;

        var uri = price ? URI_SEARCH_QUERY_PRICE : URI_SEARCH_QUERY;
        currency = currency || priceMixin._currency.defaultCurrency;

        return tokenReplace(uri, { query: query, price: price, currency: currency });
    },


    /**
     * @param {Object} payload
     * @returns {String}
     */
    getAttributeUrl: function getAttributeUrl() {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var attributeType = payload.attributeType,
            attributeValue = payload.attributeValue;
        var vertical = payload.vertical;

        vertical = vertical || verticals.VERTICAL_FURNITURE;

        return tokenReplace(URI_ATTRIBUTE, { attributeType: attributeType, attributeValue: attributeValue, vertical: vertical });
    },


    /**
     * @param {Object} payload
     * @returns {String}
     */
    getSaveSearchUrl: function getSaveSearchUrl() {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (payload.attributeType) {
            return this.getAttributeUrl(payload);
        }

        return this.getSearchQueryUrl(payload);
    }
});

module.exports = SaveSearchModel;

/***/ }),
/* 3621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * autocomplete
 *  - initial implementation: global search box
 */



var result = __webpack_require__(69);
var uniqBy = __webpack_require__(1385);
var $ = __webpack_require__(5);
var SV = __webpack_require__(18);
var verticals = __webpack_require__(416);
var $headerSearch = $('#globalSearchBox');
var $toggleNavLink = $('.toggle-nav-link');
var baseDomain = __webpack_require__(2027);
var mobileCheck = __webpack_require__(283);
var queryService = __webpack_require__(2521);
var tracking = __webpack_require__(27);
var calloutHelper = __webpack_require__(498);

// todo: server should expose this to client -- get from global_nav model
var $headerSearchHeight = $headerSearch.height();
var autoCompleteCache = {};
var hilightRegExpCache = {};
var dibsAutoCompleteWidget = void 0;
var autoCompleteOptions = void 0;
var DAC = void 0;

var trimRows = void 0;
var processTerm = void 0;
var hilight = void 0;
var mungeCreators = void 0;
var munge = void 0;
var getUrl = void 0;

__webpack_require__(1221);
__webpack_require__(1121);
__webpack_require__(2060);
__webpack_require__(2665);
__webpack_require__(2664);
__webpack_require__(748);

/**
 * @description Returns all 'top search' results (only 6 are returned). Returns only top 6 dealer vertical results.
 * @param {Array} rows
 * @return {Array}
 */
trimRows = function trimRows(rows) {
    var max = 3;
    var count = 0;

    return rows.filter(function (item) {
        if (item.vert === 'top') {
            return true;
        } else if (count < max) {
            count++;
            return true;
        }
        return false;
    });
};

/**
 * @description Returns term stripped of
 * @param {String} term
 * @return {String}
 */
processTerm = function processTerm(term) {
    /**
     * Matches characters other than
     *      1. alpha-numeric
     *      2. spaces
     *      3. &
     *      5. '
     *      6. -
     *      7. +
     * @type {RegExp}
     */
    var regex = /[^a-zA-Z\d\s&'\-\+:]/gi;

    term = (term + '').trim().replace(regex, '');
    return term.replace(/\s{2,}/g, ' ');
};

/**
 * Handles the munge-ing for creator rows
 * @param item the object containing the creator match returned from the server
 * @param search the searched term
 * @returns {*}
 */
mungeCreators = function mungeCreators(item, search) {
    var first = void 0;
    var last = void 0;
    var literal = void 0;
    if (item.vert === 'furniture') {
        item.value = item.n;
    } else if (item.vert === 'art') {
        //the query checks for last and first, so we can assume they exist
        item.value = item.fn + ' ' + item.ln;
    } else if (item.vert === 'jewelry' || item.vert === 'fashion') {
        first = item.fn;
        last = item.ln;
        literal = item.n;
        if (first && last) {
            item.value = first + ' ' + last;
        } else if (literal) {
            item.value = literal;
        }
    }
    item.category = 'creator';
    item.label = hilight(item, search);
    return item;
};

/**
 *
 * @param {Object} item Search suggestion item
 * @param {String} search The searched term
 * @return {String}
 * @private
 */
hilight = function hilight(item, search) {
    var specialCharacters = $('<div>').html(item.value); //convert html special characters
    var regex = void 0;

    item.value = specialCharacters.text();

    if (search in hilightRegExpCache) {
        regex = hilightRegExpCache[search];
    } else {
        hilightRegExpCache[search] = regex = search.split('').map(function (character) {
            return '(' + character + '\\W?)';
        }).join('');
    }

    return (item.value + '').replace(new RegExp(regex, 'gi'), function (match) {
        return '<em>' + match + '</em>';
    });
};

/**
 * @description Processes query service result into a form jquery.ui.autocomplete likes
 * @param {Array} rows query service rows returned from server
 * @param {String} search The searched term
 * @return {Array}
 * @private
 */
munge = function munge(rows, search) {
    var abbreviationMap = Object.assign({}, { top: 'top' }, verticals);

    // remove duplicates based on n
    rows = uniqBy(rows, 'n');
    rows = trimRows(rows);

    return rows.map(function (item) {
        item.vert = abbreviationMap[item.vert];
        if (item.cat === 'c') {
            item = mungeCreators(item, search);
        } else {
            item.value = item.n;
            item.category = item.vert === 'top' ? item.vert : 'dealer';
            item.label = hilight(item, search);
        }
        return item;
    });
};

/**
 *
 * @param item
 * @returns {*}
 */
getUrl = function getUrl(item) {

    function handleCategory(category) {
        var trackingValue = '/?search=' + ('' + item.key).replace(/-/g, '+');
        var url = '/' + category + '/' + item.key;
        if (category !== 'dealers') {
            url += '/' + item.vert;
        }
        return url + trackingValue;
    }

    var fn = {
        dealer: function dealer() {
            // keep as `dealers` since that is apart of the url
            return handleCategory('dealers');
        },
        creator: function creator() {
            // keep as `creators` since that is apart of the url
            return handleCategory('creators');
        },


        // 'top' as in 'top searches'
        top: function top() {
            return '/search/?q=' + ('' + item.value).replace(/ /g, '+');
        }
    };

    // return 'top' URL if there is an empty 'key' value, which is required for the other factories
    // top defaults to searching for the item value`
    return item.key !== '' && typeof fn[item.category] === 'function' ? fn[item.category]() : fn.top();
};

/**
 *
 * CREATE CUSTOM dac (DIBS AUTO-COMPLETE) WIDGET
 *
 */
dibsAutoCompleteWidget = {
    // used for redirecting FINDING-871
    baseUrl: function baseUrl() {
        return SV.get('settings.siteProtocol') + '://' + baseDomain();
    },
    menuHeight: function menuHeight() {
        return this.menu.element.height() + $headerSearchHeight + 20;
    },
    _categoryItem: function _categoryItem(category, extraClass) {
        var klass = 'suggestion-category-item' + (extraClass ? ' ' + extraClass : '');
        var label = void 0;

        switch (category) {
            case 'top':
                label = 'Popular Searches';
                break;
            case 'creator':
                label = 'Creators';
                break;
            default:
                label = 'Dealers';
                break;
        }

        return $('<li/>').addClass(klass).text(label);
    },
    showTriangle: function showTriangle() {
        var menuZindex = parseInt(this.menu.element.css('z-index'), 10);

        if (this.options.triangle) {
            this.options.triangle.css('z-index', menuZindex + 1).addClass('is-showing');
        }
    },
    hideTriangle: function hideTriangle() {
        if (this.options.triangle) {
            this.options.triangle.removeClass('is-showing');
        }
    },
    inFlyout: function inFlyout() {
        return $toggleNavLink.css('display') === 'block';
    },
    _cleanStr: function _cleanStr(str) {
        return $('<div>' + str + '</div>').text();
    },
    _textLabel: function _textLabel(item) {
        return this._cleanStr(this._getLabel(item));
    },


    _getLabel: function _getLabel(item) {
        return '<span class="suggest-label">' + item.label + '</span>';
    },

    _renderMenu: function _renderMenu(ul, items) {
        var _this = this;

        var currentCategory = '';

        this.menu.element.addClass('dibs-autocomplete');

        if (!this.inFlyout()) {
            this.showTriangle();
        }

        items.forEach(function (item) {
            var klass = currentCategory === '' ? 'is-first' : null;

            if (item.category !== currentCategory) {
                ul.append(_this._categoryItem(item.category, klass));
                currentCategory = item.category;
            }
            _this._renderItemData(ul, item);
        });
    },
    _renderItem: function _renderItem(ul, item) {
        var url = getUrl(item);
        var fullUrl = result(this, 'baseUrl') + url;
        var li = void 0;
        var a = void 0;

        li = $('<li>').addClass('search-suggest-item');
        a = $('<a>').addClass('search-suggest-link').attr('href', fullUrl).html(this._getLabel(item));

        return li.append(a).appendTo(ul);
    }
};

$.widget('custom.dac', $.ui.autocomplete, dibsAutoCompleteWidget);

/**
 * DAC OPTIONS OBJECT
 * @type {{triangle: (*|HTMLElement), context: (*|HTMLElement), appendTo: (*|HTMLElement), minLength: number, select: Function, close: Function, open: Function, source: Function}}
 */
autoCompleteOptions = {
    triangle: $('.triangle', $headerSearch),
    context: $headerSearch,
    appendTo: $('.search-suggest', $headerSearch),
    minLength: 2,

    select: function select(e, ui) {
        var dac = $(this).data('customDac');
        var creator = ui.item.category === 'creator';
        var dealer = !creator && ui.item.key !== 'search';
        var label = dac._textLabel(ui.item);
        var trackObj = void 0;
        var action = void 0;
        var url = void 0;

        if (dealer) {
            action = 'dealer selected';
        } else if (creator) {
            action = 'creator selected';
        } else {
            action = ui.item.key;
        }

        trackObj = {
            category: 'search auto-complete selected',
            action: action,
            label: dac._cleanStr(label.toLowerCase())
        };

        url = getUrl(ui.item);

        $(e.target).val(ui.item.value);
        tracking.trackEvent(trackObj);
        calloutHelper.enableFollowSearchCallout();

        // the following set of lines taken from now removed method:
        // tracking.handleTrackingEventInfo
        e.preventDefault();
        e.stopImmediatePropagation();
        setTimeout(function () {
            global.location.href = url;
        }, 100);
        return false;
    },


    /**
     * Set position in the response event handler, it's the event that happens just before the menu shows
     * http://api.jqueryui.com/autocomplete/#event-response
     */
    response: function response() {
        var dac = $(this).data('customDac');
        var pos = {
            my: 'right top',
            at: 'right bottom+8',
            of: $headerSearch
        };
        var flyoutPos = {
            my: 'left top',
            at: 'left bottom',
            of: $(this).parents('.search-box')
        };

        $(this).dac('option', 'position', dac.inFlyout() ? flyoutPos : pos);
    },
    close: function close() {
        $headerSearch.css({ height: 'auto' });
        $(this).data('customDac').hideTriangle();

        if (mobileCheck.iPad()) {
            $('#searchSuggestions').off('touchstart.iPadSelectSearchResult');
        }

        // dibs.__dacStatus = 'closed';
        // dacStatus = 'closed';
    },
    open: function open() {
        var dac = $(this).data('customDac');

        if (dac.inFlyout()) {
            $headerSearch.css({ height: dac.menuHeight() + 'px' });
        }

        // FINDING-6034 : Can't click on Popular Search Result in Search Suggestions
        // jquery.ui.menu listens only for clicks on menu items (not touchevents) so manually
        // triggering a click event here (And turning it off when the search suggestion are closed)
        if (mobileCheck.iPad()) {
            $('#searchSuggestions').on('touchstart.iPadSelectSearchResult', function (e) {
                $(e.target).closest('.ui-menu-item > a').click();
                return false;
            });
        }

        // dibs.__dacStatus = 'open';
        // dacStatus = 'open';
    },
    source: function source(request, response) {
        var search = processTerm(request.term);
        var query = {
            qs: '% ' + search + '%',
            q: search + '%',
            type: 'composed'
        };

        if (search in autoCompleteCache) {
            response(autoCompleteCache[search]);
            return;
        }

        queryService.json('search_suggestions_all', query).done(function (rows) {
            rows = munge(rows, search);
            autoCompleteCache[search] = rows;
            response(rows);
        }).fail(function () {
            response([]);
        });
    }
};

/**
 * Create instance of the dac on search-box-input (not on iphone or ipod touch)...
 */

// FINDING-1767 - turn on autocomplete for legacy pages
// if (dibs.settings && dibs.settings.isLegacy) {
// return false;
// }

if (mobileCheck.iPad() || !mobileCheck.iOS()) {
    DAC = $('.search-box-input', $headerSearch).dac(autoCompleteOptions).on('focus', function () {
        // http://stackoverflow.com/questions/11168446/jquery-autocomplete-trigger-dropdown-on-inputfocus
        $(this).dac('search');
    });
}

$.subscribe('nav:search-toggled', function (e, focus) {
    if (!SV.settings.isLegacy && DAC && focus !== false) {
        DAC.focus();
    }
});

$.subscribe('nav:state-changed', function (e, state) {
    if (!SV.settings.isLegacy && DAC && state === 'full') {
        // close the autocomplete when nav state changes from persistent to full
        DAC.dac('close');
    }
});

$(window).on('resize orientationchange', function (e) {
    if (!SV.settings.isLegacy && DAC) {
        // close the autocomplete when resize occurs (resets position, hides triangle, etc)
        DAC.dac('close');

        // ONLY BLUR ON ORIENTATION CHANGES
        // FIXES ISSUE WITH SCREEN NOT REDRAWING PROPERLY WHEN THE TEXT FIELD IS FOCUSED.
        if (e.type === 'orientationchange') {
            DAC.blur();
        }
    }
});

module.exports = {
    trimRows: trimRows,
    processTerm: processTerm,
    munge: munge,
    hilight: hilight,
    getUrl: getUrl
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 3622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);
var DC = __webpack_require__(468);

var _require = __webpack_require__(282),
    sessionStorage = _require.sessionStorage;

var uri = __webpack_require__(137);

var notificationPromise = void 0;

/**
 * Helper for notification queue
 */
var notificationHelper = {
    notificationQueue: [__webpack_require__(3634), __webpack_require__(3629), __webpack_require__(1835), __webpack_require__(3628), __webpack_require__(3630), __webpack_require__(3635), __webpack_require__(3631), __webpack_require__(3632), __webpack_require__(2176).loginPromptRule, __webpack_require__(3624), __webpack_require__(3626), __webpack_require__(3625), __webpack_require__(3627), __webpack_require__(3623), __webpack_require__(1834).default.selectItemsRule, __webpack_require__(1834).default.rearrangeItemsRule, __webpack_require__(1834).default.editFolderRule, __webpack_require__(3633)],

    firstInit: true,

    init: function init(payload) {
        var _this = this;

        if (!this._isEnabled()) {
            return;
        }

        this.getPreferredType(payload).catch(function (error) {
            console.error('[notificationHelper#init]: ' + (error || 'promise fell through'));
        });

        if (this.firstInit) {
            $.subscribe(DC.pageEventPrefix + ':updated', function () {
                return _this.init(Object.assign({ ajax: true }, payload));
            });
            this.firstInit = false;
        }
    },


    /**
     * Gets preferred nofitication type
     * @return {promise}
     */
    getPreferredType: function getPreferredType(payload) {
        var ajax = payload.ajax;


        if (!notificationPromise || ajax) {
            notificationPromise = this._getPreferredType(Object.assign({ index: 0 }, payload));
        }

        return notificationPromise;
    },


    /**
     * Calls notification's rule.
     * Checks next notification if rule promise resolved with success being falsy.
     */
    _getPreferredType: function _getPreferredType(payload) {
        var _this2 = this;

        var index = payload.index;

        var rule = this.notificationQueue[index];

        if (!rule || typeof rule !== 'function') {
            return this._checkNextNotification(payload);
        }

        return rule(payload).then(function () {
            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                success = _ref.success,
                type = _ref.type;

            if (success && type) {
                return type;
            } else if (success && !type) {
                throw new Error('No notification type found. Rule index: ' + index);
            }

            return _this2._checkNextNotification(payload);
        });
    },


    /**
     * Checks next notification (increase index).
     */
    _checkNextNotification: function _checkNextNotification(payload) {
        var index = payload.index;

        var isLastNotification = this._isLastNotification(index);

        if (isLastNotification) {
            return Promise.resolve('');
        } else {
            payload.index++;
            return this._getPreferredType(payload);
        }
    },


    /**
     * @return {boolean}
     */
    _isLastNotification: function _isLastNotification(index) {
        return this.notificationQueue.length === index + 1;
    },


    /**
     * @return {boolean}
     */
    _isEnabled: function _isEnabled() {
        var queryKey = uri.parseUri(window.location.href).queryKey;
        var NO_NOTIF_KEY = 'no-notif';

        if (sessionStorage.getItem(NO_NOTIF_KEY) === true) {
            return false;
        }

        if (queryKey[NO_NOTIF_KEY] === 'true') {
            sessionStorage.setItem(NO_NOTIF_KEY, true);
            return false;
        }

        return true;
    }
};

module.exports = notificationHelper;

/***/ }),
/* 3623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by Lior Elrom
 * Date: 8/16/16
 * Time: 10:04 AM
 */



var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(39);
var moment = __webpack_require__(30);
var windowCheck = __webpack_require__(102);

var _require = __webpack_require__(282),
    localStorage = _require.localStorage;

var enabler = __webpack_require__(63);
var pageTypeHelper = __webpack_require__(536);

var _require2 = __webpack_require__(398),
    PAGE_TYPE = _require2.PAGE_TYPE;

var checkoutStorage = __webpack_require__(492);
var makeOfferLauncher = __webpack_require__(1145);

// components
var CheckoutSurvey = __webpack_require__(3370);

var abandonCheckoutRule = function abandonCheckoutRule() {
    var isBlacklistedPage = pageTypeHelper.isPageType([PAGE_TYPE.CHECKOUT, PAGE_TYPE.ABOUT]);
    if (isBlacklistedPage || !windowCheck.document) {
        return Promise.resolve();
    }

    var timeUnit = 'minutes';
    var timeValue = 30;
    var checkoutTime = void 0;
    var timer = void 0;
    var isAfterTimer = void 0;

    // checkoutPreAuthOfferModal display logic
    // if checkoutPreAuthOfferModalInfo is present, it overrides checkoutSurveyInfo
    var preAuthOfferModalInfo = localStorage.getItem('checkoutPreAuthOfferModalInfo');
    if (preAuthOfferModalInfo) {
        var itemId = preAuthOfferModalInfo.itemId,
            offerAmount = preAuthOfferModalInfo.offerAmount,
            offerCurrency = preAuthOfferModalInfo.offerCurrency,
            offerMessage = preAuthOfferModalInfo.offerMessage,
            sellerId = preAuthOfferModalInfo.sellerId,
            quantity = preAuthOfferModalInfo.quantity,
            name = preAuthOfferModalInfo.name;


        checkoutTime = moment(preAuthOfferModalInfo.checkoutTime);
        timer = checkoutTime.clone().add(timeValue, timeUnit);
        isAfterTimer = moment().isAfter(timer);

        if (!isAfterTimer && !checkoutStorage.getHasSeenPreAuthOfferModal(itemId)) {
            makeOfferLauncher({
                item: {
                    id: itemId,
                    seller: {
                        id: sellerId
                    }
                },
                currency: offerCurrency,
                currentStep: 'abandonMakeOffer',
                preloadedState: {
                    fields: {
                        offerFieldValue: offerAmount,
                        messageFieldValue: offerMessage,
                        nameFieldValue: name,
                        quantityFieldValue: quantity
                    }
                }
            });
            checkoutStorage.setHasSeenPreAuthOfferModal(itemId);
            return Promise.resolve({ success: true, type: 'checkoutPreAuthOfferModal' });
        }
    }

    // Old checkout survey
    var isSurveyEnabled = enabler.isEnabled('checkout_survey');
    var surveyInfo = localStorage.getItem('checkoutSurveyInfo');

    if (isSurveyEnabled && surveyInfo && !checkoutStorage.getHasSeenSurvey()) {
        checkoutTime = moment(surveyInfo.checkoutTime);
        timer = checkoutTime.clone().add(timeValue, timeUnit);
        isAfterTimer = moment().isAfter(timer);

        if (!isAfterTimer) {
            var el = windowCheck.document.createElement('div');
            windowCheck.document.body.appendChild(el);
            ReactDOM.render(React.createElement(CheckoutSurvey, {}), el);
            return Promise.resolve({ success: true, type: 'checkoutSurvey' });
        }
    }

    return Promise.resolve();
};

module.exports = abandonCheckoutRule;

/***/ }),
/* 3624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var chatUtils = __webpack_require__(271);

/**
 * Rule to start chat
 */
var outboundRule = function outboundRule() {
  chatUtils.start();
  return Promise.resolve();
};

module.exports = outboundRule;

/***/ }),
/* 3625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var FavoriteModel = __webpack_require__(378);
var pageTypeHelper = __webpack_require__(536);

var _require = __webpack_require__(398),
    PAGE_TYPE = _require.PAGE_TYPE;

var calloutHelper = __webpack_require__(498);
var forceFavorite = __webpack_require__(766);
var calloutActions = __webpack_require__(503);

/**
 * Checks condition for follow dealer callout.
 * Opens callout if condition is satisfied.
 * Condition - dealer page.
 *
 * @return {Promise}
 */
var followDealerCalloutRule = function followDealerCalloutRule(_ref) {
    var context = _ref.context;
    var TYPE_DEALER = FavoriteModel.TYPE_DEALER;

    var type = calloutHelper.CALLOUT_TYPE_FOLLOW_DEALER;
    var isDealerPage = pageTypeHelper.isPageType(PAGE_TYPE.DEALER);
    var favoriteForced = forceFavorite.isTypeForced(forceFavorite.TYPE_DEALER);
    var canShowCallout = calloutHelper.canShowCallout({ type: type });

    if (!canShowCallout || favoriteForced || !isDealerPage) {
        return Promise.resolve();
    }

    return calloutHelper.hasUserFavorites({ type: type, context: context, favoriteType: TYPE_DEALER }).then(function (hasFavorites) {
        if (!hasFavorites) {
            context.executeAction(calloutActions.openCallout, { type: type });
            return { success: true, type: type };
        }

        return { success: false, type: type };
    });
};

module.exports = followDealerCalloutRule;

/***/ }),
/* 3626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SV = __webpack_require__(18);
var FavoriteModel = __webpack_require__(378);
var calloutHelper = __webpack_require__(498);
var calloutActions = __webpack_require__(503);
var forceFavorite = __webpack_require__(766);

/**
 * Checks condition for follow search callout.
 * Opens callout if condition is satisfied.
 * Condition: "Save search" button is active and it is not thin page.
 *
 * @return {Promise}
 */
var followSearchCalloutRule = function followSearchCalloutRule(_ref) {
    var context = _ref.context;
    var TYPE_SEARCH = FavoriteModel.TYPE_SEARCH;

    var type = calloutHelper.CALLOUT_TYPE_FOLLOW_SEARCH;
    var favoriteForced = forceFavorite.isTypeForced(forceFavorite.TYPE_SEARCH);
    var isSaveSearchButton = SV.get('data.saveSearch') === true;
    var thinPage = SV.get('data.thinPage');
    var canShowCallout = calloutHelper.canShowCallout({ type: type });

    if (!canShowCallout || favoriteForced || !isSaveSearchButton || thinPage) {
        return Promise.resolve();
    }

    return calloutHelper.hasUserFavorites({ type: type, context: context, favoriteType: TYPE_SEARCH }).then(function (hasFavorites) {
        if (!hasFavorites) {
            context.executeAction(calloutActions.openCallout, { type: type });
            return { success: true, type: type };
        }

        return { success: false, type: type };
    });
};

module.exports = followSearchCalloutRule;

/***/ }),
/* 3627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(137),
    URL = _require.URL;

var User = __webpack_require__(15);
var referrerHelpers = __webpack_require__(1204);
var mobileAdsHelpers = __webpack_require__(2025);
var mobileAdsBase = __webpack_require__(2573);
var mobileAdsConstants = __webpack_require__(1193);
var pageTypeHelper = __webpack_require__(536);

var _require2 = __webpack_require__(398),
    PAGE_TYPE = _require2.PAGE_TYPE;

var VisitCountModel = __webpack_require__(1461);

var isAllowedPageType = function isAllowedPageType() {
    return !pageTypeHelper.isPageType(PAGE_TYPE.CHECKOUT);
};

var checkPageViewCount = function checkPageViewCount() {
    var visitCountModel = new VisitCountModel();
    return visitCountModel.get('session') >= 2;
};

var shouldSeeInterstitial = function shouldSeeInterstitial() {
    var emailToken = URL.queryKey.emailToken;
    var emailReferrer = sessionStorage.getItem('emailReferrer');

    if (referrerHelpers.isEmailReferrer() || emailToken) {
        sessionStorage.setItem('emailReferrer', true);
        emailReferrer = true;
    }

    return User.loggedIn() && mobileAdsHelpers.shouldShowAd() && !emailReferrer && isAllowedPageType() && !referrerHelpers.isAmpReferrer() && checkPageViewCount();
};

/**
 * Condition:
 * second page view,
 * logged in user,
 * no cookie "dibsMobileInterstitial",
 * not PlaReferrer, not email referrer,
 * not checkout
 * iphone
 *
 * @return {Promise}
 */
var mobileAdsRule = function loginPromptRule() {
    var NOTIFICATION_TYPE = mobileAdsConstants.NOTIFICATION_TYPE;


    if (shouldSeeInterstitial()) {
        mobileAdsBase.showAd();
        Promise.resolve({ type: NOTIFICATION_TYPE });
    }

    return Promise.resolve();
};

module.exports = mobileAdsRule;

/***/ }),
/* 3628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var lodashPartialRight = __webpack_require__(1095);
var tradeTourRule = __webpack_require__(1835);

var _require = __webpack_require__(568),
    NET_PRICE_TOUR = _require.type.NET_PRICE_TOUR;

var netPriceRule = lodashPartialRight(tradeTourRule, {
    type: NET_PRICE_TOUR,
    limit: 3
});

module.exports = netPriceRule;

/***/ }),
/* 3629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(536),
    isPageType = _require.isPageType;

var _require2 = __webpack_require__(398),
    PDP = _require2.PAGE_TYPE.PDP;

var referrerHelpers = __webpack_require__(1204);

var pinterestActions = __webpack_require__(740);

var pinterestConnectAccountsModalRule = function pinterestConnectAccountsModalRule(payload) {
    var context = payload.context;

    var successResponse = {
        success: true,
        type: 'pinterestReferrer'
    };

    if (!isPageType(PDP) || !referrerHelpers.isPinterestReferrer()) {
        return Promise.resolve({ success: false });
    }

    return context.executeAction(pinterestActions.initApp).then(function () {
        return context.executeAction(pinterestActions.canShowConnectAccountPromotion);
    }).then(function () {
        return context.executeAction(pinterestActions.showConnectAccountsModal);
    }).then(function () {
        return successResponse;
    });
};

module.exports = pinterestConnectAccountsModalRule;

/***/ }),
/* 3630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var lodashPartialRight = __webpack_require__(1095);
var tradeTourRule = __webpack_require__(1835);

var _require = __webpack_require__(568),
    REQUEST_ITEM_HOLD_TOUR = _require.type.REQUEST_ITEM_HOLD_TOUR;

var netPriceRule = lodashPartialRight(tradeTourRule, {
    type: REQUEST_ITEM_HOLD_TOUR,
    limit: 1
});

module.exports = netPriceRule;

/***/ }),
/* 3631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);
var User = __webpack_require__(15);
var calloutHelper = __webpack_require__(498);
var calloutActions = __webpack_require__(503);
var pageTypeHelper = __webpack_require__(536);
var forceFavorite = __webpack_require__(766);

var _require = __webpack_require__(398),
    PAGE_TYPE = _require.PAGE_TYPE;

/**
 * Opens save item callout.
 * React callout for PDP page,
 * backbone tooltip for browse pages.
 */


var openSaveItemCallout = function openSaveItemCallout(_ref) {
    var context = _ref.context,
        type = _ref.type;

    var isPdpPage = pageTypeHelper.isPageType(PAGE_TYPE.PDP);

    if (isPdpPage) {
        context.executeAction(calloutActions.openCallout, { type: type });
    } else {
        var wrap = function wrap(element) {
            if (element) {
                element = element.wrap('<div>').parent();
            }
            return element;
        };

        var tooltipElement = $('#productsResults').children().first().find('.js-favorite-icon');
        calloutHelper.showSaveItemCallout({ context: context, tooltipElement: wrap(tooltipElement) });
    }
};

/**
 * Checks user saved items.
 * Turns off Save Item callout if user has saved items.
 *
 * Returns resolved promise if user hasn't saved items,
 * returns rejected promise if user has saved items
 * @return {Promise}
 */
var hasUserSavedItems = function hasUserSavedItems() {
    var type = calloutHelper.CALLOUT_TYPE_SAVE_ITEM;
    var userModelClone = User.getCurrentUser().clone();
    var promise = Promise.resolve();

    if (User.loggedIn()) {
        promise = Promise.resolve(userModelClone.fetch({
            data: { fields: 'portfolio' }
        }));
    }

    return promise.then(function () {
        if (userModelClone.get('portfolio.itemCount')) {
            //turn off save item callout if user has saved items
            calloutHelper.saveToStorage({ type: type, turnOff: true });
            return true;
        }

        return false;
    });
};

/**
 * Checks is page type PDP/browse/search/attribute.
 * @return {boolean}
 */
var allowedPageType = function allowedPageType() {
    var allowedPages = [PAGE_TYPE.PDP, PAGE_TYPE.BROWSE, PAGE_TYPE.SEARCH, PAGE_TYPE.ATTRIBUTE];

    return pageTypeHelper.isPageType(allowedPages);
};

/**
 * Checks condition for save item callout.
 * Opens callout if condition is satisfied.
 * Condition - it is browse, or search, or attribute or PDP page.
 *
 * @return {Promise}
 */
var saveItemCalloutRule = function saveItemCalloutRule(_ref2) {
    var context = _ref2.context;

    var type = calloutHelper.CALLOUT_TYPE_SAVE_ITEM;
    var isAllowedPageType = allowedPageType();
    var canShowCallout = calloutHelper.canShowCallout({ type: type });
    var favoriteForced = forceFavorite.isTypeForced(forceFavorite.TYPE_ITEM);

    if (!favoriteForced && canShowCallout && isAllowedPageType) {
        return hasUserSavedItems().then(function (hasItems) {
            if (!hasItems) {
                openSaveItemCallout({ context: context, type: type });
            }

            return { success: !hasItems, type: type };
        });
    }

    return Promise.resolve();
};

module.exports = saveItemCalloutRule;

/***/ }),
/* 3632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);
var pageTypeHelper = __webpack_require__(536);

var _require = __webpack_require__(398),
    PAGE_TYPE = _require.PAGE_TYPE;

var calloutHelper = __webpack_require__(498);
var calloutActions = __webpack_require__(503);

/**
 * Checks condition for folder icon callout.
 * Opens callout if condition is satisfied.
 *
 * @return {Promise}
 */
var saveToFolderCalloutRule = function saveToFolderCalloutRule(_ref) {
    var context = _ref.context;

    var type = calloutHelper.CALLOUT_TYPE_SAVE_TO_FOLDER;
    var canShowCallout = calloutHelper.canShowCallout({ type: type });
    var wrap = function wrap(element) {
        if (element) {
            element = element.wrap('<div>').parent();
        }
        return element;
    };

    if (!canShowCallout) {
        return Promise.resolve();
    } else if (pageTypeHelper.isPageType(PAGE_TYPE.PDP)) {
        context.executeAction(calloutActions.openCallout, { type: type });
        return Promise.resolve({ success: true, type: type });
    }

    var tooltipElement = $('#productsResults').children().first().find('.js-folder-icon');
    calloutHelper.showSaveToFolderCallout({ context: context, tooltipElement: wrap(tooltipElement) });

    return Promise.resolve({ success: true, type: type });
};

module.exports = saveToFolderCalloutRule;

/***/ }),
/* 3633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var calloutHelper = __webpack_require__(498);
var pageTypeHelper = __webpack_require__(536);

var _require = __webpack_require__(398),
    PAGE_TYPE = _require.PAGE_TYPE;

var calloutActions = __webpack_require__(503);

/**
 * Checks condition for search box callout.
 * Opens callout if condition is satisfied.
 * Condition - not search page.
 *
 * @return {Promise}
 */
var searchBoxCalloutRule = function searchBoxCalloutRule(_ref) {
    var context = _ref.context;

    var type = calloutHelper.CALLOUT_TYPE_SEARCH_BOX;
    var isSearchPage = pageTypeHelper.isPageType(PAGE_TYPE.SEARCH);
    var canShowCallout = calloutHelper.canShowCallout({ type: type });

    if (!canShowCallout || isSearchPage) {
        return Promise.resolve();
    }

    context.executeAction(calloutActions.openCallout, { type: type });
    return Promise.resolve({ success: true, type: type });
};

module.exports = searchBoxCalloutRule;

/***/ }),
/* 3634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(39);

var _require = __webpack_require__(282),
    localStorage = _require.localStorage;

var deffered = __webpack_require__(2307);
__webpack_require__(3190);

var abExperiments = __webpack_require__(494);
var isTradeUser = __webpack_require__(1513).default;
var User = __webpack_require__(15);

var LAST_SHOWN_TOKEN = 'last_shown_trade_onboarding_modal';
var type = 'tradeOnboardingModal';

var loadOnboardingModule = function loadOnboardingModule() {
    var onboardingDeferred = deffered();
    __webpack_require__.e/* require.ensure */(3).then((function () {
        var _require2 = __webpack_require__(2522),
            onboardingModal = _require2.onboardingModal;

        onboardingDeferred.resolve(onboardingModal);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

    return onboardingDeferred;
};

var getContainerElement = function getContainerElement() {
    if (window && window.document) {
        var containerElement = document.createElement('div');
        containerElement.classList.add('tradeOnboardingModalContainer');
        document.body.appendChild(containerElement);
        return containerElement;
    } else {
        return null;
    }
};

var hasSeenOnboardingModal = function hasSeenOnboardingModal() {
    return !!localStorage.getItem(LAST_SHOWN_TOKEN);
};

var markModalShown = function markModalShown() {
    localStorage.setItem(LAST_SHOWN_TOKEN, Date.now());
};

var showTradeOnboardingVariant = function showTradeOnboardingVariant() {
    if (abExperiments.showTradeOnboarding) {
        setTimeout(function () {
            return abExperiments.showTradeOnboarding.resolve(false);
        }, 1500);
        return abExperiments.showTradeOnboarding;
    } else {
        return Promise.resolve(false);
    }
};

module.exports = function tradeOnboardingRule() {
    var containerElement = getContainerElement();
    if (containerElement && User.loggedIn() && isTradeUser() && !hasSeenOnboardingModal()) {
        return showTradeOnboardingVariant().then(function (showTradeOnboarding) {
            if (showTradeOnboarding) {
                return loadOnboardingModule().then(function (onboardingModal) {
                    var _onboardingModal = onboardingModal({
                        buyerEmail: User.getEmail()
                    }),
                        Modal = _onboardingModal.Modal;

                    ReactDOM.render(React.createElement(Modal, null), containerElement);
                    markModalShown();
                    return { success: true, type: type };
                });
            } else {
                return Promise.resolve();
            }
        });
    } else {
        return Promise.resolve();
    }
};

/***/ }),
/* 3635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mobileCheck = __webpack_require__(283);
var SV = __webpack_require__(18);
var get = __webpack_require__(14);
var User = __webpack_require__(15);
var pageTypeHelper = __webpack_require__(536);

var _require = __webpack_require__(398),
    PAGE_TYPE = _require.PAGE_TYPE;

var calloutHelper = __webpack_require__(498);
var calloutActions = __webpack_require__(503);

function hasUserPermission() {
    return Promise.resolve(User.load()).then(function () {
        return User.getCurrentUser().hasPermission('B_INVOICE');
    });
};

function makeGraphQLRequest(_ref) {
    var userToken = _ref.userToken,
        userId = _ref.userId,
        itemId = _ref.itemId;

    return fetch('/soa/graphql/?userToken=' + userToken, {
        json: true,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            query: '\n                {\n                    viewer {\n                        transactions(viewName: "buyer.buyerPreInvoiceFilter", buyerId: "' + userId + '", itemId: "' + itemId + '") {\n                            totalResults\n                        }\n                    }\n                }\n        ' })
    }).then(function (response) {
        if (response.ok) {
            return response.json();
        }

        console.warn('Can\'t get graphql data for view invoice callout rule!');
        return { error: true };
    });
}

/**
 * Checks condition for view invoice callout.
 * Opens callout if condition is satisfied.
 * Condition:
 * is PDP page
 * is trade user
 * not mobile
 *
 * @return {Promise}
 */
var viewInvoiceCalloutRule = function viewInvoiceCalloutRule(_ref2) {
    var context = _ref2.context;

    var type = calloutHelper.CALLOUT_TYPE_VIEW_INVOICE;
    var canShowCallout = calloutHelper.canShowCallout({ type: type });
    var isPDP = pageTypeHelper.isPageType(PAGE_TYPE.PDP);
    var isMobile = mobileCheck.any();

    if (!canShowCallout || !isPDP || isMobile || !User.loggedIn()) {
        return Promise.resolve({ success: false });
    }

    return hasUserPermission().then(function (userCanSeeInvoice) {
        if (userCanSeeInvoice) {
            return makeGraphQLRequest({
                userToken: User.getUserToken(),
                userId: User.getUserId(),
                itemId: SV.get('data.pk')
            }).then(function (response) {
                if (get(response, 'data.viewer.transactions.totalResults') || response.error) {
                    return { success: false };
                }

                context.executeAction(calloutActions.openCallout, { type: type });
                return { success: true, type: type };
            });
        }

        return { success: false };
    });
};

module.exports = viewInvoiceCalloutRule;

/***/ }),
/* 3636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ScriptInjector = {

    /**
     * [inject description]
     * @param  {String} url     Url of the script
     * @param  {Object} params  Parameters passed to script loading url
     * @return {Promise}
     */
    inject: function inject(url) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { async: true };

        return new Promise(function (resolve) {
            var script = void 0;
            var prop = void 0;
            var scriptTag = void 0;

            script = document.createElement('script');
            script.src = url;

            for (prop in params) {
                if (params.hasOwnProperty(prop)) {
                    script[prop] = params[prop];
                }
            }

            if (script.readyState) {
                // IE
                script.onreadystatechange = function () {
                    if (script.readyState === 'loaded' || script.readyState === 'complete') {
                        script.onreadystatechange = null;
                        resolve();
                    }
                };
            } else {
                // Others
                script.onload = function () {
                    resolve();
                };
            }

            scriptTag = document.getElementsByTagName('script')[0];
            scriptTag.parentNode.insertBefore(script, scriptTag);
        });
    }
};

module.exports = ScriptInjector;

/***/ }),
/* 3637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Takes any number of objects with all string values and returns an object with the strings "merged". For every common
 * key among the passed in objects, the returned object will concatenate the values with a space in between.
 * @param  {object} ...classNameConfigs Objects to merge.
 * @return {object}
 */

function mergeClassNames() {
    for (var _len = arguments.length, classNameConfigs = Array(_len), _key = 0; _key < _len; _key++) {
        classNameConfigs[_key] = arguments[_key];
    }

    return classNameConfigs.reduce(function (acc, classNameConfig) {
        if (!classNameConfig) {
            return acc;
        }

        Object.keys(classNameConfig).forEach(function (className) {
            var value = classNameConfig[className];

            if (!acc[className]) {
                acc[className] = value;
            } else {
                acc[className] += ' ' + value;
            }
        });

        return acc;
    }, {});
}

module.exports = mergeClassNames;

/***/ }),
/* 3638 */,
/* 3639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classnames = __webpack_require__(16);
var css = __webpack_require__(3061);

var Body = function Body(_ref) {
    var children = _ref.children,
        bodyClass = _ref.bodyClass,
        dataTn = _ref.dataTn;
    return React.createElement(
        'div',
        { className: classnames(bodyClass || css.body), 'data-tn': dataTn + '-modal-body' },
        children
    );
};

Body.propTypes = {
    bodyClass: PropTypes.string,
    children: PropTypes.node,
    dataTn: PropTypes.string
};

module.exports = Body;

/***/ }),
/* 3640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var css = __webpack_require__(1485);
var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var CloseIcon = __webpack_require__(278);

var Header = function Header(_ref) {
    var children = _ref.children,
        closeModal = _ref.closeModal,
        dataTn = _ref.dataTn,
        headerClass = _ref.headerClass,
        closeIconClass = _ref.closeIconClass;
    return React.createElement(
        'div',
        { className: headerClass || css.header },
        React.createElement(
            'div',
            { className: css.title },
            children
        ),
        React.createElement(
            'div',
            { className: css.close, onClick: closeModal, 'data-tn': dataTn + '-modal-close' },
            React.createElement(CloseIcon, { className: closeIconClass || css.closeButton })
        )
    );
};

Header.propTypes = {
    children: PropTypes.node,
    closeModal: PropTypes.func,
    dataTn: PropTypes.string,
    headerClass: PropTypes.string,
    closeIconClass: PropTypes.string
};

module.exports = Header;

/***/ }),
/* 3641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var css = __webpack_require__(3062);
var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var FlexModalWrapper = __webpack_require__(1457);
__webpack_require__(1171);

var Modal = function Modal(_ref) {
    var children = _ref.children,
        closeModal = _ref.closeModal,
        closeOnEsc = _ref.closeOnEsc,
        closeOnOutsideClick = _ref.closeOnOutsideClick,
        dataTn = _ref.dataTn,
        isOpened = _ref.isOpened,
        modalClass = _ref.modalClass,
        wrapperClass = _ref.wrapperClass;
    return React.createElement(
        FlexModalWrapper,
        { closeOnEsc: closeOnEsc, closeOnOutsideClick: closeOnOutsideClick, isOpened: isOpened, onClose: closeModal, className: wrapperClass },
        React.createElement(
            'div',
            { className: modalClass || css.content },
            React.Children.map(children, function (c) {
                return React.cloneElement(c, { closeModal: closeModal, dataTn: dataTn });
            })
        )
    );
};

Modal.defaultProps = {
    closeOnEsc: true,
    closeOnOutsideClick: true,
    dataTn: 'default-tag',
    modalClass: ''
};

Modal.propTypes = {
    children: PropTypes.node,
    closeModal: PropTypes.func,
    closeOnEsc: PropTypes.bool,
    closeOnOutsideClick: PropTypes.bool,
    dataTn: PropTypes.string,
    isOpened: PropTypes.bool,
    modalClass: PropTypes.string,
    wrapperClass: PropTypes.string
};

module.exports = Modal;

/***/ }),
/* 3642 */,
/* 3643 */,
/* 3644 */,
/* 3645 */,
/* 3646 */,
/* 3647 */,
/* 3648 */,
/* 3649 */,
/* 3650 */,
/* 3651 */,
/* 3652 */,
/* 3653 */,
/* 3654 */,
/* 3655 */,
/* 3656 */,
/* 3657 */,
/* 3658 */,
/* 3659 */,
/* 3660 */,
/* 3661 */,
/* 3662 */,
/* 3663 */,
/* 3664 */,
/* 3665 */,
/* 3666 */,
/* 3667 */,
/* 3668 */,
/* 3669 */,
/* 3670 */,
/* 3671 */,
/* 3672 */,
/* 3673 */,
/* 3674 */,
/* 3675 */,
/* 3676 */,
/* 3677 */,
/* 3678 */,
/* 3679 */,
/* 3680 */,
/* 3681 */,
/* 3682 */,
/* 3683 */,
/* 3684 */,
/* 3685 */,
/* 3686 */,
/* 3687 */,
/* 3688 */,
/* 3689 */,
/* 3690 */,
/* 3691 */,
/* 3692 */,
/* 3693 */,
/* 3694 */,
/* 3695 */,
/* 3696 */,
/* 3697 */,
/* 3698 */,
/* 3699 */,
/* 3700 */,
/* 3701 */,
/* 3702 */,
/* 3703 */,
/* 3704 */,
/* 3705 */,
/* 3706 */,
/* 3707 */,
/* 3708 */,
/* 3709 */,
/* 3710 */,
/* 3711 */,
/* 3712 */,
/* 3713 */,
/* 3714 */,
/* 3715 */,
/* 3716 */,
/* 3717 */,
/* 3718 */,
/* 3719 */,
/* 3720 */,
/* 3721 */,
/* 3722 */,
/* 3723 */,
/* 3724 */,
/* 3725 */,
/* 3726 */,
/* 3727 */,
/* 3728 */,
/* 3729 */,
/* 3730 */,
/* 3731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.goToDealerApplication = goToDealerApplication;
exports.onTradeApplicationPage = onTradeApplicationPage;

var _windowCheck = __webpack_require__(102);

var _windowCheck2 = _interopRequireDefault(_windowCheck);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function goToDealerApplication() {
    _windowCheck2.default.location.href = '/dealer/application-form';
} //node modules
;

function onTradeApplicationPage() {
    var path = _windowCheck2.default.location.pathname;
    return path.split('/trade/apply').length > 1;
};

/***/ }),
/* 3732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.doPostAuthAtLogin = doPostAuthAtLogin;
exports.incrementLoginPromptCount = incrementLoginPromptCount;
exports.markCompletedInLocalStorage = markCompletedInLocalStorage;

var _dibsBrowserStorage = __webpack_require__(282);

var _lodash = __webpack_require__(843);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(65);

var _lodash4 = _interopRequireDefault(_lodash3);

var _User = __webpack_require__(15);

var _User2 = _interopRequireDefault(_User);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_PROMPT_INFO_COUNT = 2; //max number of times an extant user should be prompted to provide information on login
var COUNT_TOKEN = 'info_prompt_count'; //key to local storage itemm that stores the number of times the user has been prompted to provide user info upon login
var COMPLETED_TOKEN = 'info_prompt_completed'; //key to local storage item that is set to true if user completes user info flow
var CUTOFF_DATE = new Date('07/21/16'); //user that registered before this date need not be prompted to complete user info modal

var SUSPECTED_TRADE_STATUS = 'SUSPECTED';

var canApplyForTrade = function canApplyForTrade(tradeStatus) {
    var TRADE_STATUSES = _User2.default.TRADE_STATUSES;

    var canApplyStatuses = (0, _lodash4.default)(TRADE_STATUSES, ['N_A', SUSPECTED_TRADE_STATUS]);

    return (0, _lodash2.default)(canApplyStatuses, tradeStatus);
};

var getPromptCount = function getPromptCount() {
    return _dibsBrowserStorage.localStorage.getItem(COUNT_TOKEN) || 0;
};

function doPostAuthAtLogin(dateRegistered, tradeStatus) {
    if (dateRegistered > CUTOFF_DATE && tradeStatus !== SUSPECTED_TRADE_STATUS) {
        return false;
    }

    if (_dibsBrowserStorage.localStorage.getItem(COMPLETED_TOKEN) === true) {
        return false;
    }

    if (!canApplyForTrade(tradeStatus)) {
        return false;
    }

    return getPromptCount() < MAX_PROMPT_INFO_COUNT;
};

function incrementLoginPromptCount() {
    var currentCount = getPromptCount();
    var newCount = currentCount + 1;
    _dibsBrowserStorage.localStorage.setItem(COUNT_TOKEN, newCount);
};

function markCompletedInLocalStorage() {
    _dibsBrowserStorage.localStorage.setItem(COMPLETED_TOKEN, true);
}

/***/ }),
/* 3733 */,
/* 3734 */,
/* 3735 */,
/* 3736 */,
/* 3737 */,
/* 3738 */,
/* 3739 */,
/* 3740 */,
/* 3741 */,
/* 3742 */,
/* 3743 */,
/* 3744 */,
/* 3745 */,
/* 3746 */,
/* 3747 */,
/* 3748 */,
/* 3749 */,
/* 3750 */,
/* 3751 */,
/* 3752 */,
/* 3753 */,
/* 3754 */,
/* 3755 */,
/* 3756 */,
/* 3757 */,
/* 3758 */,
/* 3759 */,
/* 3760 */,
/* 3761 */,
/* 3762 */,
/* 3763 */,
/* 3764 */,
/* 3765 */,
/* 3766 */,
/* 3767 */,
/* 3768 */,
/* 3769 */,
/* 3770 */,
/* 3771 */,
/* 3772 */,
/* 3773 */,
/* 3774 */,
/* 3775 */,
/* 3776 */,
/* 3777 */,
/* 3778 */,
/* 3779 */,
/* 3780 */,
/* 3781 */,
/* 3782 */,
/* 3783 */,
/* 3784 */,
/* 3785 */,
/* 3786 */,
/* 3787 */,
/* 3788 */,
/* 3789 */,
/* 3790 */,
/* 3791 */,
/* 3792 */,
/* 3793 */,
/* 3794 */,
/* 3795 */,
/* 3796 */,
/* 3797 */,
/* 3798 */,
/* 3799 */,
/* 3800 */,
/* 3801 */,
/* 3802 */,
/* 3803 */,
/* 3804 */,
/* 3805 */,
/* 3806 */,
/* 3807 */,
/* 3808 */,
/* 3809 */,
/* 3810 */,
/* 3811 */,
/* 3812 */,
/* 3813 */,
/* 3814 */,
/* 3815 */,
/* 3816 */,
/* 3817 */,
/* 3818 */,
/* 3819 */,
/* 3820 */,
/* 3821 */,
/* 3822 */,
/* 3823 */,
/* 3824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Stores

var SocialNetworkStore = __webpack_require__(987);
var UserSocialNetworkStore = __webpack_require__(988);

var userSocialNetworkActions = {
    addSocialNetwork: function addSocialNetwork(actionContext, payload, done) {
        var name = payload.name,
            userPreferences = payload.data;


        var socialNetworkStore = actionContext.getStore(SocialNetworkStore);
        var socialNetwork = socialNetworkStore.getSocialNetwork(name);

        var userSocialNetworkStore = actionContext.getStore(UserSocialNetworkStore);
        var collection = userSocialNetworkStore.getCollection();

        collection.addNetwork({ socialNetwork: socialNetwork, userPreferences: userPreferences }).then(function (response) {
            actionContext.dispatch('user:socialNetwork:connect', {
                socialNetwork: response
            });
            done();
        }).catch(function (error) {
            return done(error);
        });
    },
    updateSocialNetwork: function updateSocialNetwork(actionContext, payload, done) {
        var name = payload.name,
            userPreferences = payload.data;


        var userSocialNetworkStore = actionContext.getStore(UserSocialNetworkStore);
        var collection = userSocialNetworkStore.getCollection();

        collection.updateNetwork({ name: name, userPreferences: userPreferences }).then(function (response) {
            actionContext.dispatch('user:socialNetwork:update', {
                socialNetwork: response
            });
            done();
        }).catch(function (error) {
            return done(error);
        });
    },
    removeSocialNetwork: function removeSocialNetwork(actionContext, payload, done) {
        var name = payload.name;


        var userSocialNetworkStore = actionContext.getStore(UserSocialNetworkStore);
        var collection = userSocialNetworkStore.getCollection();

        collection.removeNetwork(name).then(function (response) {
            actionContext.dispatch('user:socialNetwork:disconnect', {
                socialNetwork: response
            });
            done();
        }).catch(function (error) {
            done(error);
        });
    }
};

module.exports = userSocialNetworkActions;

/***/ }),
/* 3825 */,
/* 3826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaCollection = __webpack_require__(9);
var endpoints = __webpack_require__(6);

var SocialNetwork = __webpack_require__(1153);

var SocialNetworks = SoaCollection.extend({
    url: function url() {
        return endpoints.socialNetworks();
    },


    model: SocialNetwork
});

module.exports = SocialNetworks;

/***/ }),
/* 3827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaCollection = __webpack_require__(9);
var endpoints = __webpack_require__(6);

var UserSocialNetwork = __webpack_require__(3840);
var STATUS_CONNECTED = UserSocialNetwork.STATUS_CONNECTED,
    STATUS_DELETED = UserSocialNetwork.STATUS_DELETED;


var UserSocialNetworks = SoaCollection.extend({
    model: UserSocialNetwork,

    getUserId: function getUserId() {
        return this.parents && this.parents[0].id;
    },
    url: function url() {
        var userId = this.getUserId();
        return endpoints.userSocialNetworks(userId);
    },
    _save: function _save(socialNetworkModel) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var remove = options.remove;


        return new Promise(function (resolve, reject) {
            socialNetworkModel.save(data, {
                success: function success(model) {
                    resolve(model.toJSON());
                },
                error: function error(model, response) {
                    if (remove) {
                        model.collection.remove(model);
                    }
                    reject(response.statusText + ': ' + response.responseJSON.message);
                }
            });
        });
    },
    getConnected: function getConnected(name) {
        var connected = this.find(function (model) {
            var sameName = model.get('socialNetwork.name') === name;
            var isConnected = model.get('status') === STATUS_CONNECTED;
            return sameName && isConnected;
        });

        return connected;
    },
    addNetwork: function addNetwork(payload) {
        var socialNetwork = payload.socialNetwork,
            userPreferences = payload.userPreferences;

        var socialNetworkModel = this.add({ socialNetwork: socialNetwork, userPreferences: userPreferences }).last();

        return this._save(socialNetworkModel, null, { remove: true });
    },
    updateNetwork: function updateNetwork() {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var name = payload.name,
            userPreferences = payload.userPreferences;

        var socialNetworkModel = this.getConnected(name);

        if (socialNetworkModel) {
            return this._save(socialNetworkModel, { userPreferences: userPreferences });
        }

        return Promise.reject();
    },
    removeNetwork: function removeNetwork(name) {
        var socialNetworkModel = this.getConnected(name);

        if (socialNetworkModel) {
            return new Promise(function (resolve, reject) {
                socialNetworkModel.sync('delete', socialNetworkModel, {
                    url: socialNetworkModel.url(),
                    success: function success() {
                        socialNetworkModel.set({ status: STATUS_DELETED });
                        resolve(socialNetworkModel.toJSON());
                    },
                    error: function error(model, response) {
                        reject(response.statusText + ': ' + response.responseJSON.message);
                    }
                });
            });
        }

        return Promise.resolve();
    }
});

module.exports = UserSocialNetworks;

/***/ }),
/* 3828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 1stdibs
 * User: James
 * Date: 1/17/14
 */


var SoaCollection = __webpack_require__(9);

/**
 * @class Categories
 * @extends SoaCollection
 */
var Categories = module.exports = SoaCollection.extend();

var Category = __webpack_require__(1377);
var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var dataProvider = __webpack_require__(780);
var getDeferredMethods = __webpack_require__(299);
var globalCache = __webpack_require__(1092);

var deferred = getDeferredMethods().Deferred;

var cacheKey = Symbol('fetching_categories');

var find = function findBy(coll, field, value) {
    var i = -1;
    var len = coll.length;
    var children;
    var res;

    while (++i < len) {
        res = coll.models[i].get(field);
        if (value === res) {
            return coll.models[i];
        }
        children = coll.models[i].get('children');
        if (children) {
            res = find(children, field, value);
            if (res) {
                return res;
            }
        }
    }
    return undefined;
};

_.extend(Categories.prototype, /** @lends Categories.prototype */{
    model: Category,
    url: endpoints.categories,
    comparator: 'name',
    defaultParams: {
        hideInactive: 'Y'
    },
    /**
     * @deprecated
     * @public
     * @param {string} code A category's 'code' attribute'
     * @returns {Category}
     */
    findByCode: function findByCode(code) {
        return find(this, 'code', code);
    },
    /**
     * @public
     * @param {string} key A category's 'key' attribute'
     * @returns {Category}
     */
    findByKey: function findByKey(key) {
        return find(this, 'key', key);
    }

});

Categories.setDefaultComparator = function (comparator) {
    Categories.prototype.comparator = comparator;
};

/**
 * @public
 * @static
 * @memberOf Categories
 * @returns {Categories}
 */
Categories.allCategoriesInstance = function () {
    if (!Categories._allCategoriesInstance) {
        Categories._allCategoriesInstance = new Categories();
    }
    return Categories._allCategoriesInstance;
};

/**
 * @public
 * @static
 * @memberOf Categories
 * @param {object} [fetchOptions] Same options you would pass to SoaCollection.fetch
 * @returns {Deferred.promise}
 */
Categories.fetchAllCategoriesInstance = function (fetchOptions) {
    var allCategoriesPromise = globalCache.get(cacheKey);
    if (!allCategoriesPromise) {
        fetchOptions = fetchOptions ? _.clone(fetchOptions) : {};
        fetchOptions.data = fetchOptions.data || { fields: 'descendants,dimensionSet' };
        allCategoriesPromise = Categories.allCategoriesInstance().fetch(fetchOptions);
        globalCache.set(cacheKey, allCategoriesPromise);
        allCategoriesPromise.fail(function () {
            globalCache.del(cacheKey);
        });
    }
    return allCategoriesPromise;
};

/**
 * @public
 * @static
 * @memberOf Categories
 * @param {object} [fetchOptions] Same options you would pass to SoaCollection.fetch
 * @param {string} [dataProviderKey]
 *     Key used to retrieve data from the dataProvider for the 'all' Categories singleton
 * @returns {Deferred.promise}
 */
Categories.requestAllCategoriesUseDP = function (fetchOptions, dataProviderKey) {
    var data = dataProvider.get(dataProviderKey || 'categories');
    if (data) {
        Categories.allCategoriesInstance().reset(data);
        return deferred().resolve(data).promise();
    }
    return Categories.fetchAllCategoriesInstance(fetchOptions);
};

/***/ }),
/* 3829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 1stdibs
 * User: James
 * Date: 1/17/14
 */


var SoaCollection = __webpack_require__(9);
var DimensionSet = __webpack_require__(2054);
var endpoints = __webpack_require__(6);
var _ = __webpack_require__(0);
var getDeferredMethods = __webpack_require__(299);
var dataProvider = __webpack_require__(780);
var globalCache = __webpack_require__(1092);

var Deferred = getDeferredMethods().Deferred;

var cacheKey = Symbol('fetching_dimension_sets_all');

/**
 * @class DimensionSets
 * @extends SoaCollection
 */
var DimensionSets = module.exports = SoaCollection.extend();

_.extend(DimensionSets.prototype, /** @lends DimensionSets.prototype */{
    url: endpoints.dimensionSets,
    model: DimensionSet
});

/**
 * @public
 * @memberOf DimensionSets
 * @returns {DimensionSets}
 */
DimensionSets.allDimensionSets = function () {
    if (!DimensionSets._allDimensionSets) {
        DimensionSets._allDimensionSets = new DimensionSets();
    }
    return DimensionSets._allDimensionSets;
};

/**
 * @public
 * @memberOf DimensionSets
 * @param {object} [fetchOptions] Same options you would pass to SoaCollection.fetch 
 * @returns {Deferred.promise}
 */
DimensionSets.fetchAllDimensionSets = function (fetchOptions) {
    var allDimSetsProm = globalCache.get(cacheKey);
    if (!allDimSetsProm) {
        allDimSetsProm = DimensionSets.allDimensionSets().fetch(fetchOptions);
        globalCache.set(cacheKey, allDimSetsProm);
        allDimSetsProm.fail(function () {
            globalCache.del(cacheKey);
        });
    }
    return allDimSetsProm;
};

/**
 * Returns a promise of the completed 'allDimensionSets' singleton
 * instance. If the dataProvider has data for the dimension sets
 * available, that data is used for the collection. Otherwise,
 * the collection is fetched from the service.
 * @public
 * @memberOf DimensionSets
 * @param {object} [fetchOptions] Same options you would pass to SoaCollection.fetch 
 * @param {string} [dataProviderKey] Key param used to retrieve data from dataProvider
 * @returns {Deferred.promise}
 */
DimensionSets.requestAllDimensionSetsUseDP = function (fetchOptions, dataProviderKey) {
    var data = dataProvider.get(dataProviderKey || 'dimension_sets');
    if (data) {
        DimensionSets.allDimensionSets().reset(data);
        return new Deferred().resolve(data).promise();
    }
    return DimensionSets.fetchAllDimensionSets(fetchOptions);
};

/***/ }),
/* 3830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaCollection = __webpack_require__(9);
module.exports = SoaCollection.extend({});

Object.assign(module.exports.prototype, {
    model: __webpack_require__(1465)
});

/***/ }),
/* 3831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * User: daletan
 * Date: 3/21/16
 * Time: 12:35 PM
 * Copyright 1stdibs.com, Inc. 2016. All Rights Reserved.
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var uri = __webpack_require__(137);

/**
 * @param {string} url
 * @private
 */
function throwError(url) {
    throw new Error('options.url required. `' + url + '` with typeof `' + (typeof url === 'undefined' ? 'undefined' : _typeof(url)) + '` was passed in');
}

/**
 * Having a separate method the actual redirects
 * gives the ability to mock/spy on it
 * @param url
 * @private
 */
exports._doRedirect = function (url) {
    if (typeof url === 'string') {
        window.location.href = url;
    }
};

/**
 * @param {object} options
 * @param {string} options.url The url to redirect
 * @param {Array} [options.blacklistParams] An array of blacklisted query params to strip
 * @covers throwError
 */
exports.redirect = function (options) {
    options = options || {};
    var _options = options,
        url = _options.url;

    if (!url || typeof url !== 'string') {
        throwError(url);
    }
    if (Array.isArray(options.blacklistParams) && options.blacklistParams.length) {
        url = uri.createCleanUrl(options);
    }
    exports._doRedirect(url);
};

/***/ }),
/* 3832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Listing = __webpack_require__(1465);

/**
 * Extract statuses from a list of listings.
 * @returns {Array}
 */
var getListingStatuses = function getListingStatuses(listings) {
    var collection = listings.get('documents');

    if (collection) {
        return collection.map(function (listing) {
            return listing.get('status');
        });
    } else {
        return [];
    }
};

/**
 * Using a priority of statuses and an item's listing statuses (there could be multiple),
 * determine one status we want to use for display.
 * @param statuses - List of statuses based on item's metadata or listings document list.
 * @returns {string}
 */
var combinedListingStatus = function combinedListingStatus(statuses) {
    var status = void 0;
    if (statuses.indexOf(Listing.STATUS.NEW) >= 0 || statuses.indexOf(Listing.STATUS.COMPLETE) >= 0) {
        status = Listing.STATUS.COMPLETE;
    } else if (statuses.indexOf(Listing.STATUS.QUEUED) >= 0) {
        status = Listing.STATUS.QUEUED;
    } else if (statuses.indexOf(Listing.STATUS.PUBLISHED) >= 0) {
        status = Listing.STATUS.PUBLISHED;
    }
    return status;
};

var isSubmitted = function isSubmitted(code) {
    return [Listing.STATUS.NEW, Listing.STATUS.COMPLETE].indexOf(code) > -1;
};
var isQueued = function isQueued(code) {
    return Listing.STATUS.QUEUED === code;
};
var isPublished = function isPublished(code) {
    return Listing.STATUS.PUBLISHED === code;
};
/**
 * A method to get a display name key for your item. Display names tell you the general state of the item, like sold
 * or published, but they are not to be used for persistence. Basically they are read-only values describing your
 * item's state.
 * @param itemModel - the item model to get a status off of. The item model must have item listings metadata inflated
 *      Use the ITEM_LISTINGS_META_DATA field to get from listings core.
 * @param options - options for output
 *      pretty <boolean> pretty print output vs. camel-case values.
 * @returns {string}
 */
var getStatus = function getStatus(itemModel, options) {
    options = options || {};
    var listings = itemModel.getListings();
    if (itemModel.isSold()) {
        return 'sold';
    } else if (itemModel.isOnHoldForEverybody()) {
        return 'hold';
    } else if (itemModel.isOnHoldForCustomer()) {
        return 'holdForCustomer';
    } else if (itemModel.isRejected()) {
        return 'rejected';
    } else if (itemModel.isIncompleteStatus()) {
        return 'wip';
    } else if (itemModel.isCompleteStatus()) {
        var featuredMetadata = listings.getTypeMetadata(Listing.TYPE.FEATURED);
        var marketplaceMetadata = listings.getTypeMetadata(Listing.TYPE.MARKETPLACE);
        var storefrontMetadata = listings.getTypeMetadata(Listing.TYPE.STOREFRONT);

        var featured = combinedListingStatus(featuredMetadata.length ? featuredMetadata : getListingStatuses(listings.filterFeatured()));
        var marketplace = combinedListingStatus(marketplaceMetadata.length ? marketplaceMetadata : getListingStatuses(listings.filterMarketplace()));
        var storefront = combinedListingStatus(storefrontMetadata.length ? storefrontMetadata : getListingStatuses(listings.filterStorefront()));

        // order is important.  submitted || queued || published || featured || marketplace || storefront
        if (isSubmitted(featured)) {
            return 'submitted-featured';
        } else if (isQueued(featured)) {
            return 'queued-featured';
        } else if (isSubmitted(marketplace)) {
            return 'submitted-marketplace';
        } else if (isQueued(marketplace)) {
            return 'queued-marketplace';
        } else if (isPublished(featured)) {
            return 'featured';
        } else if (isPublished(marketplace)) {
            return 'marketplace';
        } else if (isPublished(storefront)) {
            return 'storefront';
        } else if (itemModel.isNotListed()) {
            return 'notListed';
        }
    } else if (itemModel.isDeletedStatus()) {
        return 'deleted';
    }
};

var pretty = function pretty(str) {
    if (str === 'wip') {
        return 'Work In Progress';
    }
    str = str.replace(/([A-Z])/g, ' $1');
    return str.charAt(0).toUpperCase() + str.slice(1);
};

var output = function output(itemModel, options) {
    var itemStatus = getStatus(itemModel, options);
    return itemStatus && options && options.pretty === true ? pretty(itemStatus) : itemStatus;
};

module.exports = output;

/***/ }),
/* 3833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var AuthorizedRoles = __webpack_require__(1888);

var AvailableAction = SoaModel.extend({
    relations: [{
        key: 'authorizedRoles',
        type: Backbone.Many,
        collectionType: AuthorizedRoles
    }],

    // ----------------------------------------------------------------------
    // getters :
    getRoles: function getRoles() {
        return this.get('authorizedRoles');
    }
});

module.exports = AvailableAction;

/***/ }),
/* 3834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Dependencies

var SoaModel = __webpack_require__(2);
var SoaCollection = __webpack_require__(9);
var _ = __webpack_require__(0);
var assert = __webpack_require__(31);
var DataListModel = void 0;

/**
 * @class DataListModel
 * @extends SoaModel
 */

DataListModel = module.exports = SoaModel.extend({
    initialize: function initialize(options) {
        assert(options.apiType, 'You must include an apiType for a data list.');
        options.dataList = options.dataList || new SoaCollection([]);
        DataListModel.__super__.initialize.call(this, options);
    }
});

/***/ }),
/* 3835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Dependencies

var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);
var assert = __webpack_require__(31);
var SolrSearchModel = void 0;

/**
 * @class SolrSearchModel
 * @extends SoaModel
 */

SolrSearchModel = module.exports = SoaModel.extend({
    initialize: function initialize(attrs, options) {
        assert(options.collectionName, 'You must include a name for the collection we are going to fetch.');
        assert(options.collectionType, 'You must include the type for the collection we are going to fetch.');
        assert(options.paramsMap, 'You must include a map for converting parameters.');
        assert(options.queryTemplate, 'You must include a query template name for us to fetch data.');
        this.collectionName = options.collectionName;
        this.CollectionType = options.collectionType;
        this.queryTemplate = options.queryTemplate;
        this.paramsMap = options.paramsMap || {};
        this.facetParamsMap = options.facetParamsMap || {};
        this.pageSize = _.isNumber(options.pageSize) ? options.pageSize : 48;
        this.pageStart = options.pageStart || 0;
        this.context = options.context || 'ADMIN';
        this.availableActions = options.availableActions;
        this.baseParams = options.baseParams || ['queryTemplate', 'pageSize', 'pageStart', 'context'];
        this.set(this.collectionName, options[this.collectionName] || new this.CollectionType());
        this.query = new Backbone.Model();
        this.resetParams();
    },

    fetch: function fetch(options) {
        // pass query params as part of fetch
        options = _.extend({ data: this.query.toJSON() }, options, { traditional: true });
        return SolrSearchModel.__super__.fetch.call(this, options);
    },

    parse: function parse(data) {
        var collection = this.getCollection();
        if (collection) {
            this.getCollection().reset(data.result[this.collectionName], { parse: true });
        }

        // Total size of paginated list.
        // We are adding as a property AND attribute for backwards compatibility
        if (_.isNumber(data.totalResults)) {
            this.totalResults = data.totalResults;
        }

        return {
            facets: data.result.facets,
            totalResults: data.totalResults,
            pageSize: data.pageSize,
            pageStart: data.pageStart
        };
    },

    /**
     * Helper function to get collection data.
     * @public
     */
    getCollection: function getCollection() {
        return this.get(this.collectionName);
    },

    /**
     * Add parameters to this.query.
     * @param key - name of parameter
     * @param val - value of parameter
     * @param options - extra options, for params with multiple values
     * @public
     */
    setParam: function setParam(key, val, options) {
        var convertedKey = this.paramsMap[key] || key;
        var currentVal = this.query.get(convertedKey);

        options = options || {};

        if (options.append && currentVal && !_.contains(this.baseParams, key)) {
            return this.query.set(convertedKey, _.uniq(_.flatten([currentVal, val])));
        } else if (val !== undefined) {
            return this.query.set(convertedKey, val);
        }
    },

    /**
     * Remove param/key pair from this.query.
     * @param key - name of parameter
     * @param val - value of parameter. If omitted, just remove param.
     * @public
     */
    removeParam: function removeParam(key, val) {
        var currentVal = void 0;
        var convertedKey = this.paramsMap[key] || key;

        if (val) {
            currentVal = this.query.get(convertedKey);

            // if not array and val is there, remove param entirely
            if (!_.isArray(currentVal)) {
                if (currentVal === val) {
                    this.query.unset(convertedKey);
                }
            } else {
                // if array and val is there, take out of array
                currentVal = _.filter(currentVal, function (indexVal) {
                    return indexVal !== val;
                });

                // remove if array now empty
                if (!currentVal.length) {
                    this.query.unset(convertedKey);
                } else {
                    this.query.set(convertedKey, currentVal);
                }
            }
        } else {
            // if val is undefined, remove param entirely
            this.query.unset(convertedKey);
        }
    },

    /**
     * Convenience method for setting many params at once from an object.
     * @param params
     * @param options
     */
    setParams: function setParams(params, options) {
        var _this = this;

        _.each(params, function (vals, key) {
            // if array of values, add each
            if (_.isArray(vals)) {
                _.each(vals, function (val) {
                    _this.setParam(key, val, options);
                });
            } else {
                // not array, just add value
                _this.setParam(key, vals, options);
            }
        });
    },

    /**
     * Convenience method for getting a param from the query object.
     * @param key
     */
    getParam: function getParam(key) {
        var convertedKey = this.paramsMap[key] || key;
        return this.query.get(convertedKey);
    },

    /**
     * Get all params with keys converted.
     */
    getCurrentParams: function getCurrentParams() {
        var results = {};
        var invertedMap = _.invert(this.paramsMap);

        _.each(this.query.toJSON(), function (val, key) {
            results[invertedMap[key] || key] = val; // push values to return object
        });

        return results;
    },

    /**
     * Convenience method for clearing (most) params and (optionally) setting new ones.
     * @param params
     * @param options
     */
    resetParams: function resetParams(newParams, options) {
        var _this2 = this;

        // clear all params
        this.query.clear();

        // set baseline params, which should all be singletons
        _.each(this.baseParams, function (param) {
            _this2.setParam(param, _this2[param]);
        });

        // add possible new params
        this.setParams(newParams, options);
    },

    /**
     * Filter params by key and value.
     * @param key
     * @param val
     * @returns boolean
     */
    filterParam: function filterParam(key, val) {
        var storedVal = this.getParam(key);

        if (!_.isArray(storedVal)) {
            return storedVal === val;
        } else {
            return _.contains(storedVal, val);
        }
    },

    getFacets: function getFacets() {
        return this.get('facets');
    }
});

/***/ }),
/* 3836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Joe Forzano
 * Date: October 19th, 2015
 */



var SoaModel = __webpack_require__(2);

module.exports = SoaModel.extend({
    isAccepted: function isAccepted() {
        return this.get('accepted') === 'Y';
    },
    canSnooze: function canSnooze() {
        return this.get('snoozeSecs') !== -1;
    }
});

/***/ }),
/* 3837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var SoaModel = __webpack_require__(2);
var User = __webpack_require__(28);
var Seller = __webpack_require__(105);
var assert = __webpack_require__(31);

/**
 * This version of the authorized role model only applies to users (not sellers). isPermitted checks happen based
 * on user permissions.
 * @type {Function}
 */
var AuthorizedAdminRole = SoaModel.extend({

    /**
     * Determines whether or not a given user has any of the permissions present in the authorized role. If a user
     * has one of the defined permissions, then they are authorized to take that action.
     * @param userOrSeller
     * @returns {*}
     */
    isPermitted: function isPermitted(user) {
        var isUser = user instanceof User;
        var isSeller = user instanceof Seller;
        var permissions = this.get('permissions');
        permissions = _.flatten([permissions]);

        if (isSeller) {
            return false;
        }

        assert(isUser, 'isPermitted requires a real instance of a user model');

        return user.hasPermission(permissions);
    }
});

module.exports = AuthorizedAdminRole;

/***/ }),
/* 3838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var Seller = __webpack_require__(105);
var User = __webpack_require__(28);
var assert = __webpack_require__(31);
var _userTypes = {
    user: 'USER',
    seller: 'SELLER'
};

/**
 * This version of the authorized role checks against a user or seller's ID.
 * @type {Function}
 */
var AuthorizedUserRole = SoaModel.extend({

    /**
     * Determines whether or not a given user has all the permissions present in the authorized role.
     * @param userOrSeller
     * @returns {*}
     */
    isPermitted: function isPermitted(userOrSeller) {
        var errMsg = 'isPermitted requires a real instance of a user or seller model';
        assert(userOrSeller instanceof User || userOrSeller instanceof Seller, errMsg);
        return this.get('id') === userOrSeller.get('id');
    },


    // determines if the auth role matches gainst a seller
    isRoleSeller: function isRoleSeller() {
        return this.get('userType') === _userTypes.seller;
    },


    // determines whether the auth role is for a user (as opposed to seller)
    isRoleAdmin: function isRoleAdmin() {
        return this.get('userType') === _userTypes.user;
    }
});

module.exports = AuthorizedUserRole;

AuthorizedUserRole.userTypes = _userTypes;

/***/ }),
/* 3839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var TwentyFirstCenturyStatus = module.exports = SoaModel.extend();
var ends = __webpack_require__(6);
var _ = __webpack_require__(0);

_.extend(TwentyFirstCenturyStatus.prototype, {
    url: function url() {
        return ends.sellerTwentyFirstCenturyStatus(this.id);
    }
});

/***/ }),
/* 3840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var endpoints = __webpack_require__(6);

var SocialNetwork = __webpack_require__(1153);

var UserSocialNetwork = module.exports = SoaModel.extend();

Object.assign(UserSocialNetwork, {
    STATUS_CONNECTED: 'CONNECTED',
    STATUS_DELETED: 'DELETED'
});

Object.assign(UserSocialNetwork.prototype, {
    defaults: {
        socialNetwork: {},
        userPreferences: {},
        status: null
    },

    relations: [{
        key: 'socialNetwork',
        relatedModel: SocialNetwork,
        type: Backbone.One
    }],

    getUserId: function getUserId() {
        return this.collection && this.collection.getUserId();
    },
    url: function url() {
        if (this.isNew()) {
            var userId = this.getUserId();
            return endpoints.addUserSocialNetwork(userId);
        } else {
            return endpoints.userSocialNetwork(this.id);
        }
    }
});

/***/ }),
/* 3841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var endpoints = __webpack_require__(6);
var Seller = __webpack_require__(105);
var SoaModel = __webpack_require__(2);
var User = __webpack_require__(28);

var Hold = SoaModel.extend();

_.extend(Hold.prototype, {
    url: function url() {
        return endpoints.inventoryHoldById(this.get('id'));
    },
    relations: function relations() {
        return [{
            type: Backbone.One,
            key: 'buyer',
            relatedModel: User
        }, {
            type: Backbone.One,
            key: 'item',
            // to avoid circular dependency
            relatedModel: __webpack_require__(573)
        }, {
            type: Backbone.One,
            key: 'seller',
            relatedModel: Seller
        }];
    },
    isActive: function isActive() {
        return this.get('status') === 'ACTIVE';
    },
    getExpirationDate: function getExpirationDate() {
        return this.get('expirationDate');
    },
    getConversationUrl: function getConversationUrl() {
        var buyerId = this.get('buyer.id');
        var itemId = this.get('item.id');
        return buyerId && itemId ? ['/dealers/conversations/buyer', buyerId, 'item', itemId].join('/') : null;
    },
    release: function release() {
        return this.set({
            status: 'DELETED',
            deletedReasonCode: 'CANCELLED'
        });
    }
});

_.extend(Hold, {
    statuses: {
        NEW: 'NEW',
        REQUESTED: 'REQUESTED',
        ACTIVE: 'ACTIVE',
        DELETED: 'DELETED'
    },
    deletedReasonCodes: {
        DECLINED: 'DECLINED',
        EXPIRED: 'EXPIRED',
        ITEM_SOLD: 'ITEM_SOLD',
        CANCELLED: 'CANCELLED',
        ITEM_DELETED: 'ITEM_DELETED'
    }
});

module.exports = Hold;

/***/ }),
/* 3842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var DocumentList = __webpack_require__(1620);
var ListingDocumentList = module.exports = DocumentList.extend();
var PublicationType = __webpack_require__(1893);
var Listing = __webpack_require__(1465);
var endpoints = __webpack_require__(6);
var defaultsDeep = __webpack_require__(2660);

// NOTE* for jewelry items, regardless of seller vertical, COSTUME is fashion listing, FINE is jewelry listing
var getMarketplacePublicationTypeName = function getMarketplacePublicationTypeName(item) {
    var group = void 0;
    var jewelryType = void 0;
    if (item.isArt()) {
        group = PublicationType.MARKETPLACE_ART;
    } else if (item.isFurniture()) {
        group = PublicationType.MARKETPLACE_FURNITURE;
    } else if (item.isJewelry()) {
        jewelryType = item.get('classification.type');
        group = jewelryType === 'COSTUME' ? PublicationType.MARKETPLACE_FASHION : PublicationType.MARKETPLACE_JEWELRY;
    } else if (item.isFashion()) {
        group = PublicationType.MARKETPLACE_FASHION;
    } else {
        throw new Error('Item vertical not defined');
    }
    return group;
};

// NOTE* regards COSTUME and FINE same as marketplace.
var getFeaturedPublicationTypeName = function getFeaturedPublicationTypeName(item) {
    var group = void 0;
    var jewelryType = void 0;
    if (item.isArt()) {
        group = PublicationType.FEATURED_ART;
    } else if (item.isFurniture()) {
        group = PublicationType.FEATURED_FURNITURE;
    } else if (item.isJewelry()) {
        jewelryType = item.get('classification.type');
        group = jewelryType === 'COSTUME' ? PublicationType.FEATURED_FASHION : PublicationType.FEATURED_JEWELRY;
    } else if (item.isFashion()) {
        group = PublicationType.FEATURED_FASHION;
    } else {
        throw new Error('Item vertical not defined');
    }
    return group;
};

/**
 * determine the type of storefront listing to add for a given item.
 * NOTE : the storefront publication and listing types are determined by the seller's vertical not the items
 * which is especially relevant in the case of fashion-jewelry.
 * @param item
 * @returns {*}
 */
var getStorefrontPublicationTypeName = function getStorefrontPublicationTypeName(item) {
    var seller = item.get('seller');
    var group = void 0;
    if (seller.isArtSeller()) {
        group = PublicationType.DEALER_STOREFRONT_ART;
    } else if (seller.isFurnitureSeller()) {
        group = PublicationType.DEALER_STOREFRONT_FURNITURE;
    } else if (seller.isJewelrySeller()) {
        group = PublicationType.DEALER_STOREFRONT_JEWELRY;
    } else if (seller.isFashionSeller()) {
        group = PublicationType.DEALER_STOREFRONT_FASHION;
    } else {
        throw new Error('Seller vertical not defined');
    }
    return group;
};
var addListing = function addListing(typeGetter) {
    return function (types) {
        var item = this.parents[0];
        var typeName = typeGetter(item);
        var type = types.getType(typeName);
        var listing = new Listing({
            type: type,
            item: {
                id: item.get('id')
            }
        });
        this.add(listing);
        return listing;
    };
};

var filterListing = function filterListing() {
    for (var _len = arguments.length, filters = Array(_len), _key = 0; _key < _len; _key++) {
        filters[_key] = arguments[_key];
    }

    return function (options) {
        options = options || {};
        var listings = this.filter(function (listing) {
            return filters.reduce(function (isFiltered, next) {
                var bool = listing[next]();
                if (options.not) {
                    bool = !bool;
                }
                return isFiltered || bool;
            }, false);
        });
        return new ListingDocumentList({ documents: listings });
    };
};

_.extend(ListingDocumentList.prototype, {
    model: Listing,
    url: function url() {
        var item = this.parents[0];
        return endpoints.itemListings(item.id);
    },
    save: function save(attrs, options) {
        var item = this.parents[0];
        options = defaultsDeep(options || {}, {
            queries: {
                indexMode: 'sync'
            },
            patch: true
        });
        return ListingDocumentList.__super__.save.call(this, {
            id: item.id,
            apiType: 'item',
            listings: {
                apiType: 'documentList',
                documents: this.toJSON().documents
            }
        }, options);
    },
    addFeaturedListing: addListing(getFeaturedPublicationTypeName),
    addMarketplaceListing: addListing(getMarketplacePublicationTypeName),
    addStorefrontListing: addListing(getStorefrontPublicationTypeName),
    addWeeklySaleListing: addListing(function () {
        return PublicationType.SATURDAY_SALE;
    }),
    filterMarketplace: filterListing('isMarketplace'),
    filterFeatured: filterListing('isFeatured'),
    filterStorefront: filterListing('isStorefront'),
    filterNew: filterListing('isNewStatus'),
    filterComplete: filterListing('isCompleteStatus'),
    filterPublished: filterListing('isPublishedStatus'),
    filterQueued: filterListing('isQueuedStatus'),
    filterUnavailable: filterListing('isUnavailableStatus'),
    filterDeleted: filterListing('isDeletedStatus'),
    filterNotDeleted: filterListing('isNotDeletedStatus'),
    filterUnsaved: filterListing('isNew'),
    filterSale: filterListing('isSale'),
    filterCanAttachListings: filterListing('isMarketplace', 'isFeatured', 'isStorefront'),
    getTypeMetadata: function getTypeMetadata(type) {
        var groupedListingStatuses = this.get('metadata.groupedListingStatuses');
        var typeMetadata = groupedListingStatuses && groupedListingStatuses[type];
        return typeMetadata ? Array.isArray(typeMetadata) ? typeMetadata : [typeMetadata] : [];
    },
    hasPublishedListing: function hasPublishedListing() {
        var hasPublishedListings = false;
        this.eachType(function (type, statuses) {
            if (statuses.indexOf(Listing.STATUS.PUBLISHED) >= 0) {
                hasPublishedListings = true;
            }
        });
        return hasPublishedListings || this.filterPublished().any();
    },

    /**
     * synonym to is listed (opposite of unlisted or not listed).  Checks metadata and listings
     * @return {Boolean}
     */
    hasListings: function hasListings() {
        var hasListings = false;
        this.eachType(function (type, statuses) {
            if (statuses.indexOf(Listing.STATUS.DELETED) === -1) {
                hasListings = true;
            }
        });
        return hasListings || this.filterDeleted({ not: true }).any();
    },
    isRepost: function isRepost() {
        return this.getMetadata('itemRepost') === true;
    },
    eachType: function eachType(fn) {
        var type = void 0;
        for (type in Listing.TYPE) {
            if (Listing.TYPE.hasOwnProperty(type)) {
                fn.call(this, type, this.getTypeMetadata(Listing.TYPE[type]));
            }
        }
    }
});

/***/ }),
/* 3843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Dependencies

var Backbone = __webpack_require__(3);
var HasMany = Backbone.Many;
var DataListModel = __webpack_require__(3834);
var Photo = __webpack_require__(1528);
var endpoints = __webpack_require__(6);
var assert = __webpack_require__(31);
var PHOTOS_API_TYPE = "photos";
var PhotosDataList = void 0;

var _DataListModel = DataListModel.extend({
    relations: [{
        type: HasMany,
        key: 'dataList',
        relatedModel: Photo
    }]
});

/**
 * @class PhotosDataList
 * @extends SolrSearchModel
 */
PhotosDataList = module.exports = _DataListModel.extend({
    initialize: function initialize(attributes) {
        // we only need to set the dataList from the DataListModel, enforce that the apiType be "photos"
        return PhotosDataList.__super__.initialize.call(this, {
            dataList: attributes.dataList,
            apiType: PHOTOS_API_TYPE
        });
    },
    url: function url() {
        return endpoints.photos(this.itemId);
    },
    setItemId: function setItemId(itemId) {
        this.itemId = itemId;
    },
    save: function save(attributes, options) {
        assert(this.itemId, 'You must set an itemId for these photos in order to save.');
        return PhotosDataList.__super__.save.call(this, attributes, options);
    },


    /**
     * Remove photo models that do not have any versions. These are sometimes duds created by the image upload page
     * or they could just be photos with bad data that we do not want to save.
     */
    removeInvalidPhotos: function removeInvalidPhotos() {
        var duds = this.get('dataList').filter(function (photo) {
            return !photo.get('versions') || !photo.get('versions').length;
        });
        if (duds.length) {
            this.get('dataList').remove(duds);
        }
    }
});

/***/ }),
/* 3844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Dependencies

var $ = __webpack_require__(5);
var SoaModel = __webpack_require__(2);
var Publication = module.exports = SoaModel.extend();
var Backbone = __webpack_require__(3);
var PublicationType = __webpack_require__(1893);
var NotesDocumentList = __webpack_require__(1890);
var ListingSearch = __webpack_require__(2649);
var endpoints = __webpack_require__(6);
var PublicationAttributeWrappers = __webpack_require__(2625);
var PublicationAttribute = __webpack_require__(1624);
var ends = __webpack_require__(6);
var AvailableActions = __webpack_require__(1527);
var moment = __webpack_require__(30);
var AuthorizedRoles = __webpack_require__(1888);
var assert = __webpack_require__(31);
var _ = __webpack_require__(0);
var requ = __webpack_require__(1159);
var transitionMixin = __webpack_require__(315);
var YES = 'Y';
var bulkType = 'ATTACH_ELIGIBLE_LISTINGS';
var actionNames = void 0;
var listingRelations = void 0;
var STATUS = {
    NEW: 'NEW',
    PENDING: 'PENDING',
    COMPLETE: 'COMPLETE',
    PUBLISHED: 'PUBLISHED',
    DELETED: 'DELETED',
    UNAVAILABLE: 'UNAVAILABLE'
};
var REASON_CODE = {
    MANUALLY_DELETED: 'MANUALLY_DELETED'
};
var markStatus = function markStatus(status) {
    return function () {
        return this.set('status', status);
    };
};

/**
 * @class Publication
 * @extends SoaModel
 */

_.extend(Publication.prototype, {

    url: function url() {
        return ends.publication(this.get('id'));
    },

    relations: [{
        type: Backbone.One,
        key: 'notes',
        relatedModel: NotesDocumentList
    }, {
        type: Backbone.One,
        key: 'type',
        relatedModel: PublicationType
    }, {
        type: Backbone.Many,
        key: 'attributeValues',
        collectionType: PublicationAttributeWrappers
    }, {
        type: Backbone.Many,
        key: 'actions',
        collectionType: AvailableActions
    }],

    /**
     * Returns true if publication's status is new, false otherwise.
     * @returns {boolean}
     */
    isNewStatus: function isNewStatus() {
        return this.get('status') === Publication.STATUS.NEW;
    },

    /**
     * Returns true if the publication's status is pending, false otherwise.
     * @returns {boolean}
     */
    isPendingStatus: function isPendingStatus() {
        return this.get('status') === Publication.STATUS.PENDING;
    },

    /**
     * Returns true if the publication's status is completed, false otherwise.
     * @returns {boolean}
     */
    isCompleteStatus: function isCompleteStatus() {
        return this.get('status') === Publication.STATUS.COMPLETE;
    },

    /**
     * Returns true if the publication's status is published, false otherwise.
     * @returns {boolean}
     */
    isPublishedStatus: function isPublishedStatus() {
        return this.get('status') === Publication.STATUS.PUBLISHED;
    },

    /**
     * Returns true if the publication's status is deleted, false otherwise.
     * @returns {boolean}
     */
    isDeletedStatus: function isDeletedStatus() {
        return this.get('status') === Publication.STATUS.DELETED;
    },

    /**
     * Returns true if submissions deadline has passed, false otherwise.
     * @returns {boolean}
     */
    isPassedDeadline: function isPassedDeadline() {
        return moment().isAfter(this.get('submissionsDate'));
    },

    /**
     * Returns true if all listings in the publication have completed all required reviews, false otherwise.
     * @returns {boolean}
     */
    hasCompletedReviews: function hasCompletedReviews() {
        return this.get('reviewsCompleted') === YES;
    },

    /**
     * Returns true if the user has permission to merchandise the publication, false otherwise.
     * @param user User
     * @returns {boolean}
     */
    canBeMadeMerchandiseable: function canBeMadeMerchandiseable(user) {
        var merchandiseWrapper = void 0;
        var roles = void 0;

        // if this publication is pending or published, retrieve the corresponding merchandise attribute, if any
        if (this.canMarkPending(user)) {
            merchandiseWrapper = this.get('attributeValues').getMerchandisePending();
        } else if (this.canMarkPublished(user)) {
            merchandiseWrapper = this.get('attributeValues').getMerchandisePublished();
        }

        // return true if the current user has any of the provided permissions OR if the current user matches
        // any of the whitelisted user id's
        if (merchandiseWrapper) {
            roles = new AuthorizedRoles(merchandiseWrapper.getValues().models);
            return roles.isUserPermitted(user);
        }

        return false;
    },

    getAttributeValues: function getAttributeValues() {
        return this.get('attributeValues');
    },

    canPromoteOrDemote: function canPromoteOrDemote() {
        var attr = this.getAttributeValues().getAttribute(PublicationAttribute.DISPLAY_PROMOTE_DEMOTE);
        if (attr) {
            return attr.getValues().at(0).get('data');
        }
        return false;
    },

    /**
     * Returns true if the publication is currently merchandisable by the current user, false otherwise.
     * @param {User} user
     * @returns {boolean}
     */
    isMerchandisable: function isMerchandisable(user) {
        return !!(this.get('actions') && this.get('actions').isUserAuthorizedFor(Publication.ACTION_NAMES.MERCHANDISE_PUBLICATION, user));
    },

    ////////////////////////////
    // actions (state transitions)
    /**
     * Returns true if the user has permission to move the publication to pending, false otherwise.
     * @param {User} user
     * @returns {boolean}
     */
    canMarkPending: function canMarkPending(user) {
        return !!(this.get('actions') && this.get('actions').isUserAuthorizedFor(Publication.ACTION_NAMES.PENDING, user));
    },
    /**
     * Returns true if the user has permission to move the publication to published, false otherwise.
     * @param {User} user
     * @returns {boolean}
     */
    canMarkPublished: function canMarkPublished(user) {
        return !!(this.get('actions') && this.get('actions').isUserAuthorizedFor(Publication.ACTION_NAMES.PUBLISHED, user));
    },
    /**
     * Returns true if the user has permission to move the publication to complete, false otherwise.
     * @param {User} user
     * @returns {boolean}
     */
    canMarkComplete: function canMarkComplete(user) {
        return !!(this.get('actions') && this.get('actions').isUserAuthorizedFor(Publication.ACTION_NAMES.COMPLETE, user));
    },
    /**
     * Returns true if the user has permission to delete the publication, false otherwise.
     * @param {User} user
     * @returns {boolean}
     */
    canMarkDeleted: function canMarkDeleted(user) {
        return !!(this.get('actions') && this.get('actions').isUserAuthorizedFor(Publication.ACTION_NAMES.DELETED, user));
    },

    /**
     * Returns true if the publication can be deleted (independent of user), false otherwise.
     * @returns {boolean}
     */
    isDeletable: function isDeletable() {
        return !!(this.get('actions') && this.get('actions').findWhere({ code: Publication.ACTION_NAMES.DELETED }));
    },

    /**
     * Get the verticals of this publication from the attributes
     * @returns {String|Array} Array of verticals or empty array if none found
     */
    getVerticals: function getVerticals() {
        var category = void 0;
        if (this.get('attributeValues')) {
            category = this.get('attributeValues').getCategory();
            return category && category.getValues().pluck('label') || [];
        }

        return [];
    },

    getNotes: function getNotes() {
        var notes = this.get('notes');

        if (_.isUndefined(notes)) {
            this.set('notes', new NotesDocumentList({ documents: [] }));
            notes = this.get('notes');
        }
        return notes;
    },

    /**
     * Returns true if all listings in the publication have completed all required reviews, false otherwise.
     * @returns undefined
     */
    markPendingStatus: markStatus(STATUS.PENDING),
    markNewStatus: markStatus(STATUS.NEW),
    markCompleteStatus: markStatus(STATUS.COMPLETE),
    markPublishedStatus: markStatus(STATUS.PUBLISHED),
    markDeletedStatus: markStatus(STATUS.DELETED),

    /**
     * Returns the count of additional listings that were submitted before the deadline
     * that can be attached to the current publication.
     * @param options
     *   - relations: {Array} - specify if you want attached, eligible, or attachable listings (or some combination)
     *     - attached listings means status QUEUED, pubId set to current pub
     *     - eligible listings means status NEW OR COMPLETE, no pubId or pubId set to current pub
     *     - attachable listings means status COMPLETED, no pubId
     * @returns {SolrSearchModel}
     */
    getNumListingsSearch: function getNumListingsSearch(options) {
        var relations = void 0;
        var listingSearch = void 0;
        options = options || {};
        relations = _.isArray(options.relations) ? options.relations : [];

        listingSearch = new ListingSearch(null, {
            publicationId: this.get('id'),
            availableActions: '',
            baseParams: ['publicationId', 'availableActions']
        });

        listingSearch.setParam('pageSize', 0); // we don't want listings, just count (comes back as totalResults)
        listingSearch.setParam('facets', false); // for performance - don't need facets calculated

        // set relations passed in
        _.each(relations, function (relation) {
            listingSearch.setParam('publicationRelation', relation, { append: true });
        });

        return listingSearch;
    },

    /**
     * Bulk attach listings to the publication.
     * @param options Save options
     * @returns {$.Deferred.promise}
     */
    bulkAttachListings: function bulkAttachListings(options) {
        var request = new requ.Request();
        var params = this.getTokenObj();
        var data = void 0;
        params.indexMode = 'sync';
        data = {
            "apiType": "publicationProcessingRequest",
            "type": bulkType
        };
        options = options || {};

        return request.send(_.extend({
            type: 'POST',
            url: endpoints.bulkAttachListings(this.get('id')) + "?" + $.param(params),
            contentType: 'application/json; charset=UTF-8',
            data: JSON.stringify(data)
        }, options));
    },

    /**
     * Attach listing to a publication (or move to a different publication)
     * @param listingId - the listing being moved
     * @param options - what callbacks should be passed
     */
    attachListing: function attachListing(listingId, options) {
        assert(listingId, 'You must include a listingId to assign to this publication.');
        options = options || {};

        return this.save({
            apiType: 'itemPublication',
            id: this.get('id')
        }, _.extend(options, {
            url: ends.listingAttach(listingId),
            type: 'PUT'
        }));
    },

    getEditLink: function getEditLink() {
        return '/internal/publication/' + this.get('id');
    },

    setType: function setType(type) {
        return this.set('type', type);
    },
    getType: function getType() {
        return this.get('type');
    },

    setName: function setName(name) {
        return this.set('name', name);
    },

    /**
     * Returns true if the publication has the TEST_PUBLICATION attribute and the value of that attribute is true
     */
    isTestPublication: function isTestPublication() {
        var testPubAttr = this.get('attributeValues').getAttribute('TEST_PUBLICATION');
        return testPubAttr && testPubAttr.getValues().findWhere({ data: true });
    }
}, transitionMixin, {
    /**
     * Adds a check to the transitionMixin#save method to see if the publication should be made into a Test Publication
     * If so, SoaModel#save is called on an empty model (no unnecessary attrs) using the makeTestPublication endpoint
     */
    save: function save(attrs, options) {
        var _this = this;

        var makeTestPub = this.get('testPublication');
        if (makeTestPub) {
            this.unset('testPublication');
        }
        return transitionMixin.save.call(this, attrs, options).done(function () {
            if (makeTestPub) {
                return new SoaModel().save({
                    type: 'MAKE_TEST_PUBLICATION'
                }, {
                    url: endpoints.makeTestPublication(_this.get('id')),
                    type: 'POST'
                });
            }
        });
    }
});

actionNames = {
    ATTACH_ELIGIBLE_LISTINGS: 'ATTACH_ELIGIBLE_LISTINGS',
    COPY_SORT_ORDER: 'COPY_SORT_ORDER',
    REMOVE_LISTINGS: 'REMOVE_LISTINGS',
    MERCHANDISE_PUBLICATION: 'MERCHANDISE_PUBLICATION'
};
listingRelations = {
    ATTACHED: 'attached',
    ELIGIBLE: 'eligible',
    ATTACHABLE: 'attachable'
};

_.extend(actionNames, STATUS);
Object.freeze(actionNames);
_.extend(Publication, {
    ACTION_NAMES: actionNames,
    LISTING_RELATIONS: listingRelations,
    STATUS: STATUS,
    REASON_CODE: REASON_CODE
});

/***/ }),
/* 3845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var PublicationGroup = void 0;

PublicationGroup = SoaModel.extend({
    getName: function getName() {
        return this.get('name');
    },
    isStorefront: function isStorefront() {
        return this.getName() === PublicationGroup.STOREFRONT;
    },
    isMarketplace: function isMarketplace() {
        return this.getName() === PublicationGroup.MARKETPLACE;
    },
    isFeatured: function isFeatured() {
        return this.getName() === PublicationGroup.FEATURED;
    },
    isSale: function isSale() {
        return this.getName() === PublicationGroup.SALE;
    }
}, {
    STOREFRONT: 'DEALER_STOREFRONT',
    MARKETPLACE: 'MARKETPLACE',
    FEATURED: 'FEATURED',
    SALE: 'SALE'
});

module.exports = PublicationGroup;

/***/ }),
/* 3846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DocumentList = __webpack_require__(1620);
var Review = __webpack_require__(2057);
var ReviewDocumentList = void 0;
var filterReviews = function filterReviews(filter) {
    return function () {
        var reviews = this.filter(function (review) {
            return review[filter]();
        });
        return new ReviewDocumentList({ documents: reviews });
    };
};
ReviewDocumentList = DocumentList.extend({
    model: Review,
    filterNew: filterReviews('isStatusNew'),
    filterPending: filterReviews('isStatusPending'),
    filterApproved: filterReviews('isStatusApproved'),
    filterDeleted: filterReviews('isStatusDeleted'),
    filterExpert: filterReviews('isTypeExpertReview'),
    filterRejected: filterReviews('isRejected'),
    filterDataQuality: filterReviews('isTypeDataQuality'),
    filterImageProcessing: filterReviews('isTypeImageProcessing'),
    wasRejected: function wasRejected() {
        return this.getMetadata('itemReject') === 'true';
    }
});

module.exports = ReviewDocumentList;

/***/ }),
/* 3847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Mix into the item model to get functions for image manipulation.
 * This is only helpful if you are saving item photo data. Not necessary for most item models since saving item
 * information does not save image data as well. Image data saves to a separate endpoint.
 */

var _ = __webpack_require__(0);
var assert = __webpack_require__(31);
var PhotosDataList = __webpack_require__(3843);
var Photo = __webpack_require__(1528);
var photoTypes = ['thumb', 'small', 'medium', 'large', 'original', 'master', 'zoom'];
var lastFetchImgData = void 0;

module.exports = {

    photoTypes: photoTypes,

    /**
     * Send save request to image (photos) endpoint. Uses the PhotosDataList object to do this saving logic.
     * @returns {*}
     */
    savePhotos: function savePhotos() {
        var _this = this;

        var dfd = void 0;
        var dataList = new PhotosDataList({
            dataList: this.get('photos').toJSON()
        });

        dataList.setItemId(this.get('id'));
        dataList.removeInvalidPhotos();

        dfd = dataList.save({}, {
            type: 'PUT'
        });

        dfd.promise().then(function () {
            lastFetchImgData = _this.get('photos').toJSON();
        });
        return dfd;
    },


    /**
    * Force the item model to update it's last fetched image data to the current state of the model.
     * This is a work-around for getting accurate data. Using the SOA Model's "lastSyncAttributes" may not be accurate
     * due to the order callbacks occur after sync. Similarly, Backbone's "changedAttributes" only takes into
     * consideration attributes that were changed since last set.
     * Invoke this method in your success callback before checkPhotosModified is called so that your data is being
     * compared against the correct version.
    */
    updateLastFetchImgData: function updateLastFetchImgData() {
        lastFetchImgData = this.toJSON().photos;
    },


    /**
     * Adds photo data to the item model based on a file upload.
     * Used for single and multi file uploads.
     * @param data <object|array> - returned photo data from image upload endpoint - or - an array of such objects.
     * @returns {boolean}
     */
    addPhotos: function addPhotos(data) {
        var _this2 = this;

        var success = true;
        var photoCounter = void 0;
        var photos = this.get('photos');

        // normalize data
        if (!_.isArray(data)) {
            data = [data];
        }

        // fix current data on the item if there are any problems :
        this.removeInvalidPhotos();
        this.fixPhotoOrder();

        photoCounter = photos.length;

        data.forEach(function (photo) {
            if (!_.isObject(photo)) {
                _this2.triggerBubble('imageupload-multi-fail', _this2._messages.FAIL);
                success = false;
            }

            var photoData = _.pick(photo, ['format', 'status', 'workflowState', 'source', 'versions']);
            var newPhoto = new Photo(photoData);
            newPhoto.set('sortOrder', ++photoCounter);
            photos.add(newPhoto);
        });

        this.responseData = [];

        return success;
    },


    /**
     * Iterate over all photos and compare against the data from the last save. If any of the values are different
     * from what came back from the server on the last save or fetch then this will return true, else false.
     *
     * - Useful for the image upload page :
     * If these conditions are not met then we don't want to save the item. This is useful for distinguishing false
     * drop events on the thumbnail container view. ie. When the user clicks a thumbnail our 3rd party lib sometimes
     * misinterprets this as a drop event.
     * @returns {boolean}
     */
    checkPhotosModified: function checkPhotosModified() {
        var _this3 = this;

        var newPhotos = this.get('photos').toJSON();
        var modified = false;
        var atLeastOneValue = false;

        _.each(newPhotos, function (newPhoto) {
            var lastPhoto = _.findWhere(lastFetchImgData, { sortOrder: newPhoto.sortOrder });

            _.each(photoTypes, function (type) {
                // will return a list of matches but we just want first one
                var oldValList = lastPhoto ? _.filter(lastPhoto.versions, _this3._versionTypeFilter, { "type": type }) : [];
                var newValList = newPhoto ? _.filter(newPhoto.versions, _this3._versionTypeFilter, { "type": type }) : [];
                var oldVal = oldValList.length ? oldValList[0] : undefined;
                var newVal = newValList.length ? newValList[0] : undefined;

                if (newVal) {
                    atLeastOneValue = true;
                }

                if (newVal !== oldVal) {
                    modified = true;
                }
            });
        });

        // If there isn't at least 1 photo value, then don't save. This would happen in a case where no photos
        // had yet been added to the item.
        if (!atLeastOneValue) {
            return false;
        }

        return modified;
    },


    /**
     * Search JSON version data for version of specific type.
     * @param version - a single version object in JSON
     * @returns {boolean} - will be used as a predicate function with _.filter
     * @private
     */
    _versionTypeFilter: function _versionTypeFilter(version) {
        if (version && version.type) {
            return version.type.name === this.type; // type passed in via context argument to _.filter
        }
    },


    /**
     * Fixes the order of the photos by removing models that do not have photos, applying the correct 'position' to
     * those that do (iteratively). Then add back all the photo models up to 10 and re-render this view.
     */
    fixPhotoOrder: function fixPhotoOrder() {
        var photos = this.get('photos');
        var i = void 0;
        this.removeInvalidPhotos();
        var arr = [];

        // for any photos that have a sortOrder over 10, assign it to 10
        photos.each(function (photo) {
            if (parseInt(photo.get('sortOrder'), 10) > 10) {
                photo.set('sortOrder', 10);
            }
        });

        // iteratively find photos of incrementing indexes. Place them in order in the array "arr"
        for (i = 1; i <= 10; i++) {
            var photo = photos.where({ 'sortOrder': i });
            if (photo.length) {
                arr = arr.concat(photo);
            }
        }

        // loop over "arr" assigning incrementing sortOrders to each.
        arr.forEach(function (val, idx) {
            val.set('sortOrder', ++idx);
        });
    },


    /**
     * Adds in place-holder photo models for up to 10 spots on the item.
     */
    addPlaceHolderPhotos: function addPlaceHolderPhotos() {
        var photos = this.get('photos');
        var photo = void 0;
        var i = void 0;

        // Now loop up to 10, for any photos that are missing in this range, init an empty photo model :
        for (i = 1; i <= 10; i++) {
            photo = photos.findWhere({ sortOrder: i });
            if (!photo) {
                photos.add(new Photo({
                    sortOrder: i
                }));
            }
        }
    },


    /**
     * Removes photos from the item that have no versions.
     */
    removeInvalidPhotos: function removeInvalidPhotos() {
        var photos = this.get('photos');
        var duds = [];

        photos.each(function (p) {
            if (!(p.get('versions') && p.get('versions').length)) {
                duds.push(p);
            }
        });
        photos.remove(duds);
    },


    /**
    * @deprecated - use item.getPhotos().at(0).download(options);
     * Retrieve a download link for a photo on the item.
     * @returns {Deferred}
     */
    downloadPhoto: function downloadPhoto(options) {
        assert(options.photo, 'You must include the photo being downloaded.');
        return options.photo.download(options);
    }
};

/***/ }),
/* 3848 */,
/* 3849 */,
/* 3850 */,
/* 3851 */,
/* 3852 */,
/* 3853 */,
/* 3854 */,
/* 3855 */,
/* 3856 */,
/* 3857 */,
/* 3858 */,
/* 3859 */,
/* 3860 */,
/* 3861 */,
/* 3862 */,
/* 3863 */,
/* 3864 */,
/* 3865 */,
/* 3866 */,
/* 3867 */,
/* 3868 */,
/* 3869 */,
/* 3870 */,
/* 3871 */,
/* 3872 */,
/* 3873 */,
/* 3874 */,
/* 3875 */,
/* 3876 */,
/* 3877 */,
/* 3878 */,
/* 3879 */,
/* 3880 */,
/* 3881 */,
/* 3882 */,
/* 3883 */,
/* 3884 */,
/* 3885 */,
/* 3886 */,
/* 3887 */,
/* 3888 */,
/* 3889 */,
/* 3890 */,
/* 3891 */,
/* 3892 */,
/* 3893 */,
/* 3894 */,
/* 3895 */,
/* 3896 */,
/* 3897 */,
/* 3898 */,
/* 3899 */,
/* 3900 */,
/* 3901 */
/***/ (function(module, exports, __webpack_require__) {

_ = __webpack_require__(22);
module.exports = {
    "simpleModalTemplate": function(obj) {
var __t, __p = '';
__p += '\n    <div class="simple-modal ' +
((__t = ( obj.classNames.modal )) == null ? '' : __t) +
'">\n        <div class="simple-modal-overlay ' +
((__t = ( obj.classNames.overlay )) == null ? '' : __t) +
'"></div>\n        <div class="simple-modal-content-wrapper ' +
((__t = ( obj.classNames.contentWrapper )) == null ? '' : __t) +
'">\n            <div class="simple-modal-close ' +
((__t = ( obj.classNames.close )) == null ? '' : __t) +
'" aria-label="Close">\n                ' +
((__t = ( obj.closeIcon )) == null ? '' : __t) +
'\n            </div>\n        </div>\n    </div>\n';
return __p
}
};

/***/ }),
/* 3902 */,
/* 3903 */
/***/ (function(module, exports, __webpack_require__) {

_ = __webpack_require__(22);
module.exports = {
    "filter": function(obj) {
var __t, __p = '';
__p += '\n    <div class="favorite-search-filter-label" data-tn="favorite-search-filter-label">' +
((__t = ( obj.label )) == null ? '' : __t) +
'</div>\n    <div class="favorite-search-filter-value" data-tn="favorite-search-filter-value">' +
((__t = ( obj.value )) == null ? '' : __t) +
'</div>\n';
return __p
},
    "confirmationTooltip": function(obj) {
var __t, __p = '';
__p += '\n    <div class="favorite-confirmation-content" data-tn="favorite-confirmation-tooltip">' +
((__t = ( obj.copy )) == null ? '' : __t) +
'</div>\n';
return __p
},
    "ctaTooltip": function(obj) {
var __t, __p = '';
__p +=
((__t = ( obj.copy )) == null ? '' : __t);
return __p
},
    "ctaMomentumTooltip": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="dibstooltip-momentum-title" data-tn="cta-momentum-tooltip-title">' +
((__t = ( obj.title )) == null ? '' : __t) +
'</div>\n    <div class="dibstooltip-momentum-content" data-tn="cta-momentum-tooltip-content">' +
((__t = ( obj.content )) == null ? '' : __t) +
'</div>\n\n    ';
 if (obj.closeIcon) { ;
__p += '\n        <a class="js-close-tooltip dibstooltip-momentum-close" href="#" data-tn="cta-momentum-tooltip-close">\n            ' +
((__t = ( obj.closeIcon )) == null ? '' : __t) +
'\n        </a>\n    ';
 } ;
__p += '\n';
return __p
}
};

/***/ }),
/* 3904 */,
/* 3905 */
/***/ (function(module, exports, __webpack_require__) {

_ = __webpack_require__(22);
module.exports = {
    "fullscreen": function(obj) {
var __t, __p = '';
__p += '\n    <div class="mobile-ad-fullscreen-close-container">\n        ' +
((__t = ( obj.closeIcon )) == null ? '' : __t) +
'\n    </div>\n    <div class="mobile-ad-fullscreen-subcontainer">\n        <div class="mobile-ad-fullscreen-header">\n            ' +
((__t = ( obj.logoIcon )) == null ? '' : __t) +
'\n            <p class="mobile-ad-fullscreen-header-copy">Browse Faster in the App</p>\n        </div>\n        <div class="mobile-ad-fullscreen-content">\n            <div class="mobile-ad-fullscreen-button">\n                <a href="#" class="mobile-ad-fullscreen-deep-link-link">Continue in App</a>\n            </div>\n        </div>\n    </div>\n';
return __p
}
};

/***/ }),
/* 3906 */,
/* 3907 */,
/* 3908 */,
/* 3909 */,
/* 3910 */,
/* 3911 */,
/* 3912 */
/***/ (function(module, exports) {

(function($){
    "use strict";
    // shim for pre-existing pub/subs
    if ($.operator) {
    	$.each({
	        "subscribe" : "on",
	        "ever" : "on",
	        "once" : "one",
	        "onceEver" : "one",
	        "unsubscribe" : "off",
	        "publish" : "trigger"
	    }, function (fn, api) {
	        $[fn] = function () {
	            $.operator[fn].apply($.operator, arguments);
	        };
	    });
	    $.subWhen = $.operator.subWhen;
        $.getSubscribers = $.operator.getSubscribers;
    }
    
}(jQuery));

/***/ }),
/* 3913 */
/***/ (function(module, exports) {

/*!
 * Dual licensed under the MIT and GPL licenses.
 *
 * Inspired by Ben Alman's original gist - https://gist.github.com/661855
 * Contributors:
 *      - shad downey, github: @andromedado
 *      - dale tan, github: @hellatan
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */

(function($){
    "use strict";
    var slice = Array.prototype.slice;
    var o = $({});
    var fired = {};
    var originalOperator = $.operator;
    var privateOps = {};
    /** @namespace */
    var operator = {};
    var subscribers = {};

    /**
     * Creates an array of event names
     * @param {string} events A space-delimited string of event names
     * @returns {Array}
     */
    privateOps.getEventNames = function (events) {
        if (typeof events === 'string') {
            return events.split(' ');
        }
        return [];
    };

    /**
     * Returns all the arguments passed into the events
     * @returns {{args: (*|Function), eventNames: *}}
     */
    privateOps.getAllArguments = function () {
        var args = slice.call(arguments), //this.returnArgs(arguments),
            events = args[0];
        return {
            args: args,
            eventNames: events
        };
    };

    /**
     * Checks to see if an event was ever fired,
     * if it was, it will then invoke the callback
     * (assuming a callback was the second argument to the function above)
     * If @onceEver is `true`, it will remove the event listener after-if firing
     * @param {boolean} onceEver
     * @param {mixed} args 
     */
    privateOps.fired = function (onceEver, args) {
        var args = slice.call(args),
            // space delimited events
            eventNames = this.getEventNames(args[0]);
        if (typeof args[1] === 'function') {
            $.each(eventNames, function (i, eventName) {
                if (fired[eventName]) {
                    //Release thread so that event binder can
                    // return before callback is invoked
                    setTimeout(function () {
                        args[1].apply(o, fired[eventName]);
                    }, 15);
                    if (onceEver) {
                        //If this was a onceEver, we need to take it back off now
                        o.off(eventName, args[1]);
                    }
                }
            });
        }
    };

    /**
     * Typical no-conflict mode
     * @returns {{}}
     */
    operator.noConflict = function () {
        $.operator = originalOperator;
        return operator;
    };

    /**
     * Add methods to listen to custom events that have been published
     * @param {string}      event   The event to subscribe to
     * @param {function}    fn      The method that will be triggered when the {event} is published
     */
    operator.subscribe = function (event, fn) {
        if (!subscribers[event]) {
            subscribers[event] = 1;
        } else {
            subscribers[event] = subscribers[event] + 1;
        }
        o.on.apply(o, arguments);
    };

    /**
     * Remove the method that was listening to the event.  Anonymous functions cannot be unsubscribed
     * @param {string}      event   The event to be removed
     * @param {function}    fn      The method that was originally subscribed to the {event}
     */
    operator.unsubscribe = function (event, fn) {
        o.off.apply(o, arguments);
    };

    /**
     * The event to trigger
     * @param {string}  event   The event to trigger
     * @param {array}   args    Array of arguments that will be passed along to the subscribers
     */
    operator.publish = function (/* event, args */) {
        var args = arguments,
            eventNames = privateOps.getEventNames(args[0]);
        o.trigger.apply(o, args);
        // We need to keep a record of fired events for `ever`'s sake
        $.each(eventNames, function (i, eventName) {
            fired[eventName] = args;
        });
    };

    /**
     * A versions of subscribe that can look into the past.
     * If the event being subscribed to has fired in the past,
     * invoke the callback with the most recent occurrence
     * Useful when you don't want to care about the order of script loading
     * NOTE: This function will always return before invoking the callback [15 millisecond timeout]
     */
    operator.ever = function () {
        o.on.apply(o, arguments);
        privateOps.fired(false, arguments);
    };

    /**
     * Same as `subscribe` except that the callback is invoked at most once
     */
    operator.once = function () {
        o.one.apply(o, arguments);
    };

    /**
     * Same as `ever` except that the callback is invoked at most once
     * NOTE: This function will always return before invoking the callback [15 millisecond timeout]
     */
    operator.onceEver = function () {
        o.on.apply(o, arguments);
        privateOps.fired(true, arguments);
    };

    /**
     * Takes list of publish event names, and returns a promise for
     * when all of them have ever occurred
     * e.g.
     *      $.operator.subWhen('foo', 'bar').then(function () {
     *          console.log('STUFF GETS DONE!');
     *      });
     *      $.operator.publish('foo');
     *      // subscribers to 'foo' do something
     *      $.operator.publish('bar');
     *      // subscribers to 'bar' do something
     *      // then
     *      // STUFF GETS DONE!
     * @returns jQuery.Promise
     */
    operator.subWhen = function (/* eventName, ... */) {
        var promises = [];
        $.each(arguments, function (i, eventName) {
            var def = $.Deferred();
            $.operator.onceEver(eventName, function () {
                def.resolve.apply(def, arguments);
            });
            promises.push(def.promise());
        });
        return $.when.apply($, promises);
    };

    /**
     * @param {string} [name] subscriber name
     * @returns {object|number} Returns a count if `name` is present, otherwise entire list
     */
    operator.getSubscribers = function (name) {
        return subscribers[name] ? subscribers[name] : subscribers;
    };

    // expose this ish
    // don't attach via $.fn since a jQuery object is being used as the switchboard
    $.operator = operator;

})(jQuery);

/***/ }),
/* 3914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(2229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(3917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(3918);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = baseGetTag;


/***/ }),
/* 3915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 3916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(3919);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = getPrototype;


/***/ }),
/* 3917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(2229);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = getRawTag;


/***/ }),
/* 3918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = objectToString;


/***/ }),
/* 3919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = overArg;


/***/ }),
/* 3920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(3915);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = root;


/***/ }),
/* 3921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = isObjectLike;


/***/ }),
/* 3922 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var baseCreate = __webpack_require__(2234),
    isObject = __webpack_require__(3923),
    setBindData = __webpack_require__(1909),
    slice = __webpack_require__(1530);

/**
 * Used for `Array` method references.
 *
 * Normally `Array.prototype` would suffice, however, using an array literal
 * avoids issues in Narwhal.
 */
var arrayRef = [];

/** Native method shortcuts */
var push = arrayRef.push;

/**
 * The base implementation of `_.bind` that creates the bound function and
 * sets its meta data.
 *
 * @private
 * @param {Array} bindData The bind data array.
 * @returns {Function} Returns the new bound function.
 */
function baseBind(bindData) {
  var func = bindData[0],
      partialArgs = bindData[2],
      thisArg = bindData[4];

  function bound() {
    // `Function#bind` spec
    // http://es5.github.io/#x15.3.4.5
    if (partialArgs) {
      // avoid `arguments` object deoptimizations by using `slice` instead
      // of `Array.prototype.slice.call` and not assigning `arguments` to a
      // variable as a ternary expression
      var args = slice(partialArgs);
      push.apply(args, arguments);
    }
    // mimic the constructor's `return` behavior
    // http://es5.github.io/#x13.2.2
    if (this instanceof bound) {
      // ensure `new bound` is an instance of `func`
      var thisBinding = baseCreate(func.prototype),
          result = func.apply(thisBinding, args || arguments);
      return isObject(result) ? result : thisBinding;
    }
    return func.apply(thisArg, args || arguments);
  }
  setBindData(bound, bindData);
  return bound;
}

module.exports = baseBind;


/***/ }),
/* 3923 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var objectTypes = __webpack_require__(1154);

/**
 * Checks if `value` is the language type of Object.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Objects
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if the `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // check if the value is the ECMAScript language type of Object
  // http://es5.github.io/#x8
  // and avoid a V8 bug
  // http://code.google.com/p/v8/issues/detail?id=2291
  return !!(value && objectTypes[typeof value]);
}

module.exports = isObject;


/***/ }),
/* 3924 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.7 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArray = __webpack_require__(64),
    isTypedArray = __webpack_require__(2240),
    keys = __webpack_require__(297);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    stringTag = '[object String]';

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * A specialized version of `_.some` for arrays without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.isEqual` without support for `this` binding
 * `customizer` functions.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparing values.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing objects.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = objToString.call(object);
    if (objTag == argsTag) {
      objTag = objectTag;
    } else if (objTag != objectTag) {
      objIsArr = isTypedArray(object);
    }
  }
  if (!othIsArr) {
    othTag = objToString.call(other);
    if (othTag == argsTag) {
      othTag = objectTag;
    } else if (othTag != objectTag) {
      othIsArr = isTypedArray(other);
    }
  }
  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && !(objIsArr || objIsObj)) {
    return equalByTag(object, other, objTag);
  }
  if (!isLoose) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
    }
  }
  if (!isSameTag) {
    return false;
  }
  // Assume cyclic values are equal.
  // For more information on detecting circular references see https://es5.github.io/#JO.
  stackA || (stackA = []);
  stackB || (stackB = []);

  var length = stackA.length;
  while (length--) {
    if (stackA[length] == object) {
      return stackB[length] == other;
    }
  }
  // Add `object` and `other` to the stack of traversed objects.
  stackA.push(object);
  stackB.push(other);

  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

  stackA.pop();
  stackB.pop();

  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing arrays.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
  var index = -1,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
    return false;
  }
  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index],
        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

    if (result !== undefined) {
      if (result) {
        continue;
      }
      return false;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (isLoose) {
      if (!arraySome(other, function(othValue) {
            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
          })) {
        return false;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
      return false;
    }
  }
  return true;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} value The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag) {
  switch (tag) {
    case boolTag:
    case dateTag:
      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
      return +object == +other;

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case numberTag:
      // Treat `NaN` vs. `NaN` as equal.
      return (object != +object)
        ? other != +other
        : object == +other;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings primitives and string
      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
      return object == (other + '');
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing values.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
  var objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isLoose) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  var skipCtor = isLoose;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key],
        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

    // Recursively compare objects (susceptible to call stack limits).
    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
      return false;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (!skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      return false;
    }
  }
  return true;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = baseIsEqual;


/***/ }),
/* 3925 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var objectTypes = __webpack_require__(1154);

/**
 * Checks if `value` is the language type of Object.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Objects
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if the `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // check if the value is the ECMAScript language type of Object
  // http://es5.github.io/#x8
  // and avoid a V8 bug
  // http://code.google.com/p/v8/issues/detail?id=2291
  return !!(value && objectTypes[typeof value]);
}

module.exports = isObject;


/***/ }),
/* 3926 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var bind = __webpack_require__(3928),
    identity = __webpack_require__(3929),
    setBindData = __webpack_require__(1909),
    support = __webpack_require__(3969);

/** Used to detected named functions */
var reFuncName = /^\s*function[ \n\r\t]+\w/;

/** Used to detect functions containing a `this` reference */
var reThis = /\bthis\b/;

/** Native method shortcuts */
var fnToString = Function.prototype.toString;

/**
 * The base implementation of `_.createCallback` without support for creating
 * "_.pluck" or "_.where" style callbacks.
 *
 * @private
 * @param {*} [func=identity] The value to convert to a callback.
 * @param {*} [thisArg] The `this` binding of the created callback.
 * @param {number} [argCount] The number of arguments the callback accepts.
 * @returns {Function} Returns a callback function.
 */
function baseCreateCallback(func, thisArg, argCount) {
  if (typeof func != 'function') {
    return identity;
  }
  // exit early for no `thisArg` or already bound by `Function#bind`
  if (typeof thisArg == 'undefined' || !('prototype' in func)) {
    return func;
  }
  var bindData = func.__bindData__;
  if (typeof bindData == 'undefined') {
    if (support.funcNames) {
      bindData = !func.name;
    }
    bindData = bindData || !support.funcDecomp;
    if (!bindData) {
      var source = fnToString.call(func);
      if (!support.funcNames) {
        bindData = !reFuncName.test(source);
      }
      if (!bindData) {
        // checks if `func` references the `this` keyword and stores the result
        bindData = reThis.test(source);
        setBindData(func, bindData);
      }
    }
  }
  // exit early if there are no `this` references or `func` is bound
  if (bindData === false || (bindData !== true && bindData[1] & 1)) {
    return func;
  }
  switch (argCount) {
    case 1: return function(value) {
      return func.call(thisArg, value);
    };
    case 2: return function(a, b) {
      return func.call(thisArg, a, b);
    };
    case 3: return function(value, index, collection) {
      return func.call(thisArg, value, index, collection);
    };
    case 4: return function(accumulator, value, index, collection) {
      return func.call(thisArg, accumulator, value, index, collection);
    };
  }
  return bind(func, thisArg);
}

module.exports = baseCreateCallback;


/***/ }),
/* 3927 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var baseBind = __webpack_require__(3922),
    baseCreateWrapper = __webpack_require__(3931),
    isFunction = __webpack_require__(3930),
    slice = __webpack_require__(1530);

/**
 * Used for `Array` method references.
 *
 * Normally `Array.prototype` would suffice, however, using an array literal
 * avoids issues in Narwhal.
 */
var arrayRef = [];

/** Native method shortcuts */
var push = arrayRef.push,
    unshift = arrayRef.unshift;

/**
 * Creates a function that, when called, either curries or invokes `func`
 * with an optional `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to reference.
 * @param {number} bitmask The bitmask of method flags to compose.
 *  The bitmask may be composed of the following flags:
 *  1 - `_.bind`
 *  2 - `_.bindKey`
 *  4 - `_.curry`
 *  8 - `_.curry` (bound)
 *  16 - `_.partial`
 *  32 - `_.partialRight`
 * @param {Array} [partialArgs] An array of arguments to prepend to those
 *  provided to the new function.
 * @param {Array} [partialRightArgs] An array of arguments to append to those
 *  provided to the new function.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new function.
 */
function createWrapper(func, bitmask, partialArgs, partialRightArgs, thisArg, arity) {
  var isBind = bitmask & 1,
      isBindKey = bitmask & 2,
      isCurry = bitmask & 4,
      isCurryBound = bitmask & 8,
      isPartial = bitmask & 16,
      isPartialRight = bitmask & 32;

  if (!isBindKey && !isFunction(func)) {
    throw new TypeError;
  }
  if (isPartial && !partialArgs.length) {
    bitmask &= ~16;
    isPartial = partialArgs = false;
  }
  if (isPartialRight && !partialRightArgs.length) {
    bitmask &= ~32;
    isPartialRight = partialRightArgs = false;
  }
  var bindData = func && func.__bindData__;
  if (bindData && bindData !== true) {
    // clone `bindData`
    bindData = slice(bindData);
    if (bindData[2]) {
      bindData[2] = slice(bindData[2]);
    }
    if (bindData[3]) {
      bindData[3] = slice(bindData[3]);
    }
    // set `thisBinding` is not previously bound
    if (isBind && !(bindData[1] & 1)) {
      bindData[4] = thisArg;
    }
    // set if previously bound but not currently (subsequent curried functions)
    if (!isBind && bindData[1] & 1) {
      bitmask |= 8;
    }
    // set curried arity if not yet set
    if (isCurry && !(bindData[1] & 4)) {
      bindData[5] = arity;
    }
    // append partial left arguments
    if (isPartial) {
      push.apply(bindData[2] || (bindData[2] = []), partialArgs);
    }
    // append partial right arguments
    if (isPartialRight) {
      unshift.apply(bindData[3] || (bindData[3] = []), partialRightArgs);
    }
    // merge flags
    bindData[1] |= bitmask;
    return createWrapper.apply(null, bindData);
  }
  // fast path for `_.bind`
  var creater = (bitmask == 1 || bitmask === 17) ? baseBind : baseCreateWrapper;
  return creater([func, bitmask, partialArgs, partialRightArgs, thisArg, arity]);
}

module.exports = createWrapper;


/***/ }),
/* 3928 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var createWrapper = __webpack_require__(3927),
    slice = __webpack_require__(1530);

/**
 * Creates a function that, when called, invokes `func` with the `this`
 * binding of `thisArg` and prepends any additional `bind` arguments to those
 * provided to the bound function.
 *
 * @static
 * @memberOf _
 * @category Functions
 * @param {Function} func The function to bind.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {...*} [arg] Arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * var func = function(greeting) {
 *   return greeting + ' ' + this.name;
 * };
 *
 * func = _.bind(func, { 'name': 'fred' }, 'hi');
 * func();
 * // => 'hi fred'
 */
function bind(func, thisArg) {
  return arguments.length > 2
    ? createWrapper(func, 17, slice(arguments, 2), null, thisArg)
    : createWrapper(func, 1, null, null, thisArg);
}

module.exports = bind;


/***/ }),
/* 3929 */
/***/ (function(module, exports) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utilities
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'name': 'fred' };
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 3930 */
/***/ (function(module, exports) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/**
 * Checks if `value` is a function.
 *
 * @static
 * @memberOf _
 * @category Objects
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if the `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 */
function isFunction(value) {
  return typeof value == 'function';
}

module.exports = isFunction;


/***/ }),
/* 3931 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var baseCreate = __webpack_require__(2234),
    isObject = __webpack_require__(3932),
    setBindData = __webpack_require__(1909),
    slice = __webpack_require__(1530);

/**
 * Used for `Array` method references.
 *
 * Normally `Array.prototype` would suffice, however, using an array literal
 * avoids issues in Narwhal.
 */
var arrayRef = [];

/** Native method shortcuts */
var push = arrayRef.push;

/**
 * The base implementation of `createWrapper` that creates the wrapper and
 * sets its meta data.
 *
 * @private
 * @param {Array} bindData The bind data array.
 * @returns {Function} Returns the new function.
 */
function baseCreateWrapper(bindData) {
  var func = bindData[0],
      bitmask = bindData[1],
      partialArgs = bindData[2],
      partialRightArgs = bindData[3],
      thisArg = bindData[4],
      arity = bindData[5];

  var isBind = bitmask & 1,
      isBindKey = bitmask & 2,
      isCurry = bitmask & 4,
      isCurryBound = bitmask & 8,
      key = func;

  function bound() {
    var thisBinding = isBind ? thisArg : this;
    if (partialArgs) {
      var args = slice(partialArgs);
      push.apply(args, arguments);
    }
    if (partialRightArgs || isCurry) {
      args || (args = slice(arguments));
      if (partialRightArgs) {
        push.apply(args, partialRightArgs);
      }
      if (isCurry && args.length < arity) {
        bitmask |= 16 & ~32;
        return baseCreateWrapper([func, (isCurryBound ? bitmask : bitmask & ~3), args, null, thisArg, arity]);
      }
    }
    args || (args = arguments);
    if (isBindKey) {
      func = thisBinding[key];
    }
    if (this instanceof bound) {
      thisBinding = baseCreate(func.prototype);
      var result = func.apply(thisBinding, args);
      return isObject(result) ? result : thisBinding;
    }
    return func.apply(thisBinding, args);
  }
  setBindData(bound, bindData);
  return bound;
}

module.exports = baseCreateWrapper;


/***/ }),
/* 3932 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var objectTypes = __webpack_require__(1154);

/**
 * Checks if `value` is the language type of Object.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Objects
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if the `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // check if the value is the ECMAScript language type of Object
  // http://es5.github.io/#x8
  // and avoid a V8 bug
  // http://code.google.com/p/v8/issues/detail?id=2291
  return !!(value && objectTypes[typeof value]);
}

module.exports = isObject;


/***/ }),
/* 3933 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    stringTag = '[object String]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetPrototype = Object.getPrototypeOf,
    nativeKeys = Object.keys;

/**
 * The base implementation of `_.forEachRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEachRight = createBaseEach(baseForOwnRight, true);

/**
 * This function is like `baseFor` except that it iterates over properties
 * in the opposite order.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseForRight = createBaseFor(true);

/**
 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwnRight(object, iteratee) {
  return object && baseForRight(object, iteratee, keys);
}

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
  // that are composed entirely of index properties, return `false` for
  // `hasOwnProperty` checks of them.
  return hasOwnProperty.call(object, key) ||
    (typeof object == 'object' && key in object && getPrototype(object) === null);
}

/**
 * The base implementation of `_.keys` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  return nativeKeys(Object(object));
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a
 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
 * Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Gets the `[[Prototype]]` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {null|Object} Returns the `[[Prototype]]`.
 */
function getPrototype(value) {
  return nativeGetPrototype(Object(value));
}

/**
 * Creates an array of index keys for `object` values of arrays,
 * `arguments` objects, and strings, otherwise `null` is returned.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array|null} Returns index keys, else `null`.
 */
function indexKeys(object) {
  var length = object ? object.length : undefined;
  if (isLength(length) &&
      (isArray(object) || isString(object) || isArguments(object))) {
    return baseTimes(length, String);
  }
  return null;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @type {Function}
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  var isProto = isPrototype(object);
  if (!(isProto || isArrayLike(object))) {
    return baseKeys(object);
  }
  var indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  for (var key in object) {
    if (baseHas(object, key) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
        !(isProto && key == 'constructor')) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseEachRight;


/***/ }),
/* 3934 */
/***/ (function(module, exports) {

/**
 * lodash 3.7.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * The base implementation of `get` without support for string paths
 * and default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path of the property to get.
 * @param {string} [pathKey] The key representation of path.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path, pathKey) {
  if (object == null) {
    return;
  }
  if (pathKey !== undefined && pathKey in toObject(object)) {
    path = [pathKey];
  }
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[path[index++]];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = baseGet;


/***/ }),
/* 3935 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 3936 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  start = start == null ? 0 : (+start || 0);
  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = (end === undefined || end > length) ? length : (+end || 0);
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 3937 */,
/* 3938 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 4.5.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var SetCache = __webpack_require__(1910),
    createSet = __webpack_require__(3940);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  return !!array.length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return indexOfNaN(array, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * Gets the index at which the first occurrence of `NaN` is found in `array`.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
 */
function indexOfNaN(array, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 0 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    var other = array[index];
    if (other !== other) {
      return index;
    }
  }
  return -1;
}

/**
 * Converts `set` to an array.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the converted array.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/**
 * Checks if `value` is in `cache`.
 *
 * @private
 * @param {Object} cache The set cache to search.
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function cacheHas(cache, value) {
  var map = cache.__data__;
  if (isKeyable(value)) {
    var data = map.__data__,
        hash = typeof value == 'string' ? data.string : data.hash;

    return hash[value] === HASH_UNDEFINED;
  }
  return map.has(value);
}

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'number' || type == 'boolean' ||
    (type == 'string' && value != '__proto__') || value == null;
}

module.exports = baseUniq;


/***/ }),
/* 3939 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * returned by `keysFunc`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  var index = -1,
      length = props.length,
      result = Array(length);

  while (++index < length) {
    result[index] = object[props[index]];
  }
  return result;
}

module.exports = baseValues;


/***/ }),
/* 3940 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to determine if values are of the language type `Object`. */
var objectTypes = {
  'function': true,
  'object': true
};

/** Detect free variable `exports`. */
var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
  ? exports
  : undefined;

/** Detect free variable `module`. */
var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
  ? module
  : undefined;

/** Detect free variable `global` from Node.js. */
var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);

/** Detect free variable `self`. */
var freeSelf = checkGlobal(objectTypes[typeof self] && self);

/** Detect free variable `window`. */
var freeWindow = checkGlobal(objectTypes[typeof window] && window);

/** Detect `this` as the global object. */
var thisGlobal = checkGlobal(objectTypes[typeof this] && this);

/**
 * Used as a reference to the global object.
 *
 * The `this` value is used if it's the global object to avoid Greasemonkey's
 * restricted `window` object, otherwise the `window` object is used.
 */
var root = freeGlobal ||
  ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
    freeSelf || thisGlobal || Function('return this')();

/**
 * Checks if `value` is a global object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
 */
function checkGlobal(value) {
  return (value && value.Object === Object) ? value : null;
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

/**
 * Creates a set of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (!isObject(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */
function noop() {
  // No operation performed.
}

module.exports = createSet;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module), __webpack_require__(4)))

/***/ }),
/* 3941 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var objectTypes = __webpack_require__(1154);

/** Used for native method references */
var objectProto = Object.prototype;

/** Native method shortcuts */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A fallback implementation of `Object.keys` which produces an array of the
 * given object's own enumerable property names.
 *
 * @private
 * @type Function
 * @param {Object} object The object to inspect.
 * @returns {Array} Returns an array of property names.
 */
var shimKeys = function(object) {
  var index, iterable = object, result = [];
  if (!iterable) return result;
  if (!(objectTypes[typeof object])) return result;
    for (index in iterable) {
      if (hasOwnProperty.call(iterable, index)) {
        result.push(index);
      }
    }
  return result
};

module.exports = shimKeys;


/***/ }),
/* 3942 */,
/* 3943 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.8.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArray = __webpack_require__(64);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` or `undefined` values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  return value == null ? '' : (value + '');
}

/**
 * Converts `value` to property path array if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Array} Returns the property path array.
 */
function toPath(value) {
  if (isArray(value)) {
    return value;
  }
  var result = [];
  baseToString(value).replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
}

module.exports = toPath;


/***/ }),
/* 3944 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
  copyObject(source, keysIn(source), object, customizer);
});

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = assignInWith;


/***/ }),
/* 3945 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseClone = __webpack_require__(3946),
    bindCallback = __webpack_require__(123),
    isIterateeCall = __webpack_require__(1908);

/**
 * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
 * otherwise they are assigned by reference. If `customizer` is provided it's
 * invoked to produce the cloned values. If `customizer` returns `undefined`
 * cloning is handled by the method instead. The `customizer` is bound to
 * `thisArg` and invoked with up to three argument; (value [, index|key, object]).
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
 * The enumerable properties of `arguments` objects and objects created by
 * constructors other than `Object` are cloned to plain `Object` objects. An
 * empty object is returned for uncloneable values such as functions, DOM nodes,
 * Maps, Sets, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {Function} [customizer] The function to customize cloning values.
 * @param {*} [thisArg] The `this` binding of `customizer`.
 * @returns {*} Returns the cloned value.
 * @example
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * var shallow = _.clone(users);
 * shallow[0] === users[0];
 * // => true
 *
 * var deep = _.clone(users, true);
 * deep[0] === users[0];
 * // => false
 *
 * // using a customizer callback
 * var el = _.clone(document.body, function(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(false);
 *   }
 * });
 *
 * el === document.body
 * // => false
 * el.nodeName
 * // => BODY
 * el.childNodes.length;
 * // => 0
 */
function clone(value, isDeep, customizer, thisArg) {
  if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
    isDeep = false;
  }
  else if (typeof isDeep == 'function') {
    thisArg = customizer;
    customizer = isDeep;
    isDeep = false;
  }
  return typeof customizer == 'function'
    ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 3))
    : baseClone(value, isDeep);
}

module.exports = clone;


/***/ }),
/* 3946 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash 3.3.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var arrayCopy = __webpack_require__(2231),
    arrayEach = __webpack_require__(328),
    baseAssign = __webpack_require__(2232),
    baseFor = __webpack_require__(129),
    isArray = __webpack_require__(64),
    keys = __webpack_require__(297);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
cloneableTags[dateTag] = cloneableTags[float32Tag] =
cloneableTags[float64Tag] = cloneableTags[int8Tag] =
cloneableTags[int16Tag] = cloneableTags[int32Tag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[stringTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[mapTag] = cloneableTags[setTag] =
cloneableTags[weakMapTag] = false;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Native method references. */
var ArrayBuffer = global.ArrayBuffer,
    Uint8Array = global.Uint8Array;

/**
 * The base implementation of `_.clone` without support for argument juggling
 * and `this` binding `customizer` functions.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {Function} [customizer] The function to customize cloning values.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The object `value` belongs to.
 * @param {Array} [stackA=[]] Tracks traversed source objects.
 * @param {Array} [stackB=[]] Associates clones with source counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return arrayCopy(value, result);
    }
  } else {
    var tag = objToString.call(value),
        isFunc = tag == funcTag;

    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return baseAssign(result, value);
      }
    } else {
      return cloneableTags[tag]
        ? initCloneByTag(value, tag, isDeep)
        : (object ? value : {});
    }
  }
  // Check for circular references and return its corresponding clone.
  stackA || (stackA = []);
  stackB || (stackB = []);

  var length = stackA.length;
  while (length--) {
    if (stackA[length] == value) {
      return stackB[length];
    }
  }
  // Add the source value to the stack of traversed objects and associate it with its clone.
  stackA.push(value);
  stackB.push(result);

  // Recursively populate clone (susceptible to call stack limits).
  (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
    result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
  });
  return result;
}

/**
 * The base implementation of `_.forOwn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return baseFor(object, iteratee, keys);
}

/**
 * Creates a clone of the given array buffer.
 *
 * @private
 * @param {ArrayBuffer} buffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function bufferClone(buffer) {
  var result = new ArrayBuffer(buffer.byteLength),
      view = new Uint8Array(result);

  view.set(new Uint8Array(buffer));
  return result;
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add array properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  var Ctor = object.constructor;
  if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
    Ctor = Object;
  }
  return new Ctor;
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return bufferClone(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      var buffer = object.buffer;
      return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      var result = new Ctor(object.source, reFlags.exec(object));
      result.lastIndex = object.lastIndex;
  }
  return result;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = baseClone;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 3947 */
/***/ (function(module, exports) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/**
 * The base implementation of `_.indexOf` without support for binary searches
 * or `fromIndex` constraints.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the matched value or `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  var index = (fromIndex || 0) - 1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = baseIndexOf;


/***/ }),
/* 3948 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var isNative = __webpack_require__(1383);

/** `Object#toString` result shortcuts */
var arrayClass = '[object Array]';

/** Used for native method references */
var objectProto = Object.prototype;

/** Used to resolve the internal [[Class]] of values */
var toString = objectProto.toString;

/* Native method shortcuts for methods with the same name as other `lodash` methods */
var nativeIsArray = isNative(nativeIsArray = Array.isArray) && nativeIsArray;

/**
 * Checks if `value` is an array.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Objects
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if the `value` is an array, else `false`.
 * @example
 *
 * (function() { return _.isArray(arguments); })();
 * // => false
 *
 * _.isArray([1, 2, 3]);
 * // => true
 */
var isArray = nativeIsArray || function(value) {
  return value && typeof value == 'object' && typeof value.length == 'number' &&
    toString.call(value) == arrayClass || false;
};

module.exports = isArray;


/***/ }),
/* 3949 */
/***/ (function(module, exports) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/** `Object#toString` result shortcuts */
var stringClass = '[object String]';

/** Used for native method references */
var objectProto = Object.prototype;

/** Used to resolve the internal [[Class]] of values */
var toString = objectProto.toString;

/**
 * Checks if `value` is a string.
 *
 * @static
 * @memberOf _
 * @category Objects
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if the `value` is a string, else `false`.
 * @example
 *
 * _.isString('fred');
 * // => true
 */
function isString(value) {
  return typeof value == 'string' ||
    value && typeof value == 'object' && toString.call(value) == stringClass || false;
}

module.exports = isString;


/***/ }),
/* 3950 */,
/* 3951 */,
/* 3952 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var root = __webpack_require__(281);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"'`]/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
function escapeHtmlChar(chr) {
  return htmlEscapes[chr];
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = Symbol ? symbolProto.toString : undefined;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (value == null) {
    return '';
  }
  if (isSymbol(value)) {
    return Symbol ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
 * their corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value.
 * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * Backticks are escaped because in IE < 9, they can break out of
 * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
 * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
 * for more details.
 *
 * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
 * to reduce XSS vectors.
 *
 * @static
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape(string) {
  string = toString(string);
  return (string && reHasUnescapedHtml.test(string))
    ? string.replace(reUnescapedHtml, escapeHtmlChar)
    : string;
}

module.exports = escape;


/***/ }),
/* 3953 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    stringTag = '[object String]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetPrototype = Object.getPrototypeOf,
    nativeKeys = Object.keys;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
  // that are composed entirely of index properties, return `false` for
  // `hasOwnProperty` checks of them.
  return hasOwnProperty.call(object, key) ||
    (typeof object == 'object' && key in object && getPrototype(object) === null);
}

/**
 * The base implementation of `_.keys` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  return nativeKeys(Object(object));
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a
 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
 * Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Gets the `[[Prototype]]` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {null|Object} Returns the `[[Prototype]]`.
 */
function getPrototype(value) {
  return nativeGetPrototype(Object(value));
}

/**
 * Creates an array of index keys for `object` values of arrays,
 * `arguments` objects, and strings, otherwise `null` is returned.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array|null} Returns index keys, else `null`.
 */
function indexKeys(object) {
  var length = object ? object.length : undefined;
  if (isLength(length) &&
      (isArray(object) || isString(object) || isArguments(object))) {
    return baseTimes(length, String);
  }
  return null;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @type {Function}
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  var isProto = isPrototype(object);
  if (!(isProto || isArrayLike(object))) {
    return baseKeys(object);
  }
  var indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  for (var key in object) {
    if (baseHas(object, key) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
        !(isProto && key == 'constructor')) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseEach;


/***/ }),
/* 3954 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 3955 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */
function baseFindKey(collection, predicate, eachFunc) {
  var result;
  eachFunc(collection, function(value, key, collection) {
    if (predicate(value, key, collection)) {
      result = key;
      return false;
    }
  });
  return result;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */
function findKey(object, predicate) {
  return baseFindKey(object, baseIteratee(predicate, 3), baseForOwn);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = findKey;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(70)(module)))

/***/ }),
/* 3956 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */
function flattenDeep(array) {
  var length = array ? array.length : 0;
  return length ? baseFlatten(array, INFINITY) : [];
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = flattenDeep;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 3957 */,
/* 3958 */,
/* 3959 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var baseCreateCallback = __webpack_require__(3926),
    keys = __webpack_require__(3961),
    objectTypes = __webpack_require__(1154);

/**
 * Iterates over own enumerable properties of an object, executing the callback
 * for each property. The callback is bound to `thisArg` and invoked with three
 * arguments; (value, key, object). Callbacks may exit iteration early by
 * explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Objects
 * @param {Object} object The object to iterate over.
 * @param {Function} [callback=identity] The function called per iteration.
 * @param {*} [thisArg] The `this` binding of `callback`.
 * @returns {Object} Returns `object`.
 * @example
 *
 * _.forOwn({ '0': 'zero', '1': 'one', 'length': 2 }, function(num, key) {
 *   console.log(key);
 * });
 * // => logs '0', '1', and 'length' (property order is not guaranteed across environments)
 */
var forOwn = function(collection, callback, thisArg) {
  var index, iterable = collection, result = iterable;
  if (!iterable) return result;
  if (!objectTypes[typeof iterable]) return result;
  callback = callback && typeof thisArg == 'undefined' ? callback : baseCreateCallback(callback, thisArg, 3);
    var ownIndex = -1,
        ownProps = objectTypes[typeof iterable] && keys(iterable),
        length = ownProps ? ownProps.length : 0;

    while (++ownIndex < length) {
      index = ownProps[ownIndex];
      if (callback(iterable[index], index, collection) === false) return result;
    }
  return result
};

module.exports = forOwn;


/***/ }),
/* 3960 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var objectTypes = __webpack_require__(1154);

/**
 * Checks if `value` is the language type of Object.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Objects
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if the `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // check if the value is the ECMAScript language type of Object
  // http://es5.github.io/#x8
  // and avoid a V8 bug
  // http://code.google.com/p/v8/issues/detail?id=2291
  return !!(value && objectTypes[typeof value]);
}

module.exports = isObject;


/***/ }),
/* 3961 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var isNative = __webpack_require__(1383),
    isObject = __webpack_require__(3960),
    shimKeys = __webpack_require__(3941);

/* Native method shortcuts for methods with the same name as other `lodash` methods */
var nativeKeys = isNative(nativeKeys = Object.keys) && nativeKeys;

/**
 * Creates an array composed of the own enumerable property names of an object.
 *
 * @static
 * @memberOf _
 * @category Objects
 * @param {Object} object The object to inspect.
 * @returns {Array} Returns an array of property names.
 * @example
 *
 * _.keys({ 'one': 1, 'two': 2, 'three': 3 });
 * // => ['one', 'two', 'three'] (property order is not guaranteed across environments)
 */
var keys = !nativeKeys ? shimKeys : function(object) {
  if (!isObject(object)) {
    return [];
  }
  return nativeKeys(object);
};

module.exports = keys;


/***/ }),
/* 3962 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 3963 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 3964 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (typeof key == 'number' && value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  if (!(isArray(source) || isTypedArray(source))) {
    var props = baseKeysIn(source);
  }
  arrayEach(props || source, function(srcValue, key) {
    if (props) {
      key = srcValue;
      srcValue = source[key];
    }
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  });
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = object[key],
      srcValue = source[key],
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    newValue = srcValue;
    if (isArray(srcValue) || isTypedArray(srcValue)) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      }
      else {
        newValue = objValue;
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) ||
      objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return (typeof Ctor == 'function' &&
    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = merge;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(70)(module)))

/***/ }),
/* 3965 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var keys = __webpack_require__(297);

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates a two dimensional array of the key-value pairs for `object`,
 * e.g. `[[key1, value1], [key2, value2]]`.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the new array of key-value pairs.
 * @example
 *
 * _.pairs({ 'barney': 36, 'fred': 40 });
 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
 */
function pairs(object) {
  object = toObject(object);

  var index = -1,
      props = keys(object),
      length = props.length,
      result = Array(length);

  while (++index < length) {
    var key = props[index];
    result[index] = [key, object[key]];
  }
  return result;
}

module.exports = pairs;


/***/ }),
/* 3966 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for wrapper metadata. */
var BIND_FLAG = 1,
    BIND_KEY_FLAG = 2,
    CURRY_BOUND_FLAG = 4,
    CURRY_FLAG = 8,
    CURRY_RIGHT_FLAG = 16,
    PARTIAL_FLAG = 32,
    PARTIAL_RIGHT_FLAG = 64,
    ARY_FLAG = 128,
    FLIP_FLAG = 512;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to determine if values are of the language type `Object`. */
var objectTypes = {
  'function': true,
  'object': true
};

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `exports`. */
var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
  ? exports
  : undefined;

/** Detect free variable `module`. */
var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
  ? module
  : undefined;

/** Detect free variable `global` from Node.js. */
var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);

/** Detect free variable `self`. */
var freeSelf = checkGlobal(objectTypes[typeof self] && self);

/** Detect free variable `window`. */
var freeWindow = checkGlobal(objectTypes[typeof window] && window);

/** Detect `this` as the global object. */
var thisGlobal = checkGlobal(objectTypes[typeof this] && this);

/**
 * Used as a reference to the global object.
 *
 * The `this` value is used if it's the global object to avoid Greasemonkey's
 * restricted `window` object, otherwise the `window` object is used.
 */
var root = freeGlobal ||
  ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
    freeSelf || thisGlobal || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  var length = args.length;
  switch (length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * Checks if `value` is a global object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
 */
function checkGlobal(value) {
  return (value && value.Object === Object) ? value : null;
}

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      result++;
    }
  }
  return result;
}

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var objectCreate = Object.create;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
 *  for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBaseWrapper(func, bitmask, thisArg) {
  var isBind = bitmask & BIND_FLAG,
      Ctor = createCtorWrapper(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtorWrapper(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
 *  for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurryWrapper(func, bitmask, arity) {
  var Ctor = createCtorWrapper(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurryWrapper(
        func, bitmask, createHybridWrapper, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
 *  for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & ARY_FLAG,
      isBind = bitmask & BIND_FLAG,
      isBindKey = bitmask & BIND_KEY_FLAG,
      isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
      isFlip = bitmask & FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtorWrapper(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurryWrapper(
        func, bitmask, createHybridWrapper, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtorWrapper(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
 *  for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartialWrapper(func, bitmask, thisArg, partials) {
  var isBind = bitmask & BIND_FLAG,
      Ctor = createCtorWrapper(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
 *  for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurryWrapper(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

  if (!(bitmask & CURRY_BOUND_FLAG)) {
    bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
  }

  var result = wrapFunc(func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity);
  result.placeholder = placeholder;
  return result;
}

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask of wrapper flags.
 *  The bitmask may be composed of the following flags:
 *     1 - `_.bind`
 *     2 - `_.bindKey`
 *     4 - `_.curry` or `_.curryRight` of a bound function
 *     8 - `_.curry`
 *    16 - `_.curryRight`
 *    32 - `_.partial`
 *    64 - `_.partialRight`
 *   128 - `_.rearg`
 *   256 - `_.ary`
 *   512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] == null
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
    bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == BIND_FLAG) {
    var result = createBaseWrapper(func, bitmask, thisArg);
  } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
    result = createCurryWrapper(func, bitmask, arity);
  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
    result = createPartialWrapper(func, bitmask, thisArg, partials);
  } else {
    result = createHybridWrapper.apply(undefined, newData);
  }
  return result;
}

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This function is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = isFunction(value.valueOf) ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = createWrapper;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module), __webpack_require__(4)))

/***/ }),
/* 3967 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {/**
 * lodash 4.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseEachRight = __webpack_require__(3933),
    baseIsEqual = __webpack_require__(1906),
    baseIsMatch = __webpack_require__(2235),
    baseReduce = __webpack_require__(2236),
    get = __webpack_require__(3968),
    hasIn = __webpack_require__(2239),
    toPairs = __webpack_require__(2242);

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to determine if values are of the language type `Object`. */
var objectTypes = {
  'function': true,
  'object': true
};

/** Detect free variable `exports`. */
var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType) ? exports : null;

/** Detect free variable `module`. */
var freeModule = (objectTypes[typeof module] && module && !module.nodeType) ? module : null;

/** Detect free variable `global` from Node.js. */
var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);

/** Detect free variable `self`. */
var freeSelf = checkGlobal(objectTypes[typeof self] && self);

/** Detect free variable `window`. */
var freeWindow = checkGlobal(objectTypes[typeof window] && window);

/** Detect `this` as the global object. */
var thisGlobal = checkGlobal(objectTypes[typeof this] && this);

/**
 * Used as a reference to the global object.
 *
 * The `this` value is used if it's the global object to avoid Greasemonkey's
 * restricted `window` object, otherwise the `window` object is used.
 */
var root = freeGlobal || ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) || freeSelf || thisGlobal || Function('return this')();

/**
 * A specialized version of `_.reduceRight` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the last element of `array` as the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduceRight(array, iteratee, accumulator, initAccum) {
  var length = array.length;
  if (initAccum && length) {
    accumulator = array[--length];
  }
  while (length--) {
    accumulator = iteratee(accumulator, array[length], length, array);
  }
  return accumulator;
}

/**
 * Checks if `value` is a global object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
 */
function checkGlobal(value) {
  return (value && value.Object === Object) ? value : null;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = Symbol ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path + ''] : baseToPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[path[index++]];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  var type = typeof value;
  if (type == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (type == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    var key = matchData[0][0],
        value = matchData[0][1];

    return function(object) {
      if (object == null) {
        return false;
      }
      return object[key] === value &&
        (value !== undefined || (key in Object(object)));
    };
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new function.
 */
function baseMatchesProperty(path, srcValue) {
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toPath` which only converts `value` to a
 * path if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Array} Returns the property path array.
 */
function baseToPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = toPairs(object),
      length = result.length;

  while (length--) {
    result[length][2] = isStrictComparable(result[length][1]);
  }
  return result;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (typeof value == 'number') {
    return true;
  }
  return !isArray(value) &&
    (reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
      (object != null && value in Object(object)));
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
function stringToPath(string) {
  var result = [];
  toString(string).replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
}

/**
 * This method is like `_.reduce` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * var array = [[0, 1], [2, 3], [4, 5]];
 *
 * _.reduceRight(array, function(flattened, other) {
 *   return flattened.concat(other);
 * }, []);
 * // => [4, 5, 2, 3, 0, 1]
 */
function reduceRight(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduceRight : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (value == null) {
    return '';
  }
  if (isSymbol(value)) {
    return Symbol ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': { 'c': 2 } } },
 *   { 'a': { 'b': { 'c': 1 } } }
 * ];
 *
 * _.map(objects, _.property('a.b.c'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
}

module.exports = reduceRight;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module), __webpack_require__(4)))

/***/ }),
/* 3968 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 3969 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var isNative = __webpack_require__(1383);

/** Used to detect functions containing a `this` reference */
var reThis = /\bthis\b/;

/**
 * An object used to flag environments features.
 *
 * @static
 * @memberOf _
 * @type Object
 */
var support = {};

/**
 * Detect if functions can be decompiled by `Function#toString`
 * (all but PS3 and older Opera mobile browsers & avoided in Windows 8 apps).
 *
 * @memberOf _.support
 * @type boolean
 */
support.funcDecomp = !isNative(global.WinRTError) && reThis.test(function() { return this; });

/**
 * Detect if `Function#name` is supported (all but IE).
 *
 * @memberOf _.support
 * @type boolean
 */
support.funcNames = typeof Function.name == 'string';

module.exports = support;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 3970 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {/**
 * lodash 4.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var arrayMap = __webpack_require__(329),
    assignInWith = __webpack_require__(3944),
    keys = __webpack_require__(3971),
    reInterpolate = __webpack_require__(973),
    rest = __webpack_require__(816),
    templateSettings = __webpack_require__(3972);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match empty string literals in compiled template source. */
var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

/** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to ensure capturing order of template delimiters. */
var reNoMatch = /($^)/;

/** Used to match unescaped characters in compiled string literals. */
var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

/** Used to determine if values are of the language type `Object`. */
var objectTypes = {
  'function': true,
  'object': true
};

/** Used to escape characters for inclusion in compiled string literals. */
var stringEscapes = {
  '\\': '\\',
  "'": "'",
  '\n': 'n',
  '\r': 'r',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

/** Detect free variable `exports`. */
var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType) ? exports : null;

/** Detect free variable `module`. */
var freeModule = (objectTypes[typeof module] && module && !module.nodeType) ? module : null;

/** Detect free variable `global` from Node.js. */
var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);

/** Detect free variable `self`. */
var freeSelf = checkGlobal(objectTypes[typeof self] && self);

/** Detect free variable `window`. */
var freeWindow = checkGlobal(objectTypes[typeof window] && window);

/** Detect `this` as the global object. */
var thisGlobal = checkGlobal(objectTypes[typeof this] && this);

/**
 * Used as a reference to the global object.
 *
 * The `this` value is used if it's the global object to avoid Greasemonkey's
 * restricted `window` object, otherwise the `window` object is used.
 */
var root = freeGlobal || ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) || freeSelf || thisGlobal || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  var length = args.length;
  switch (length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

/**
 * Checks if `value` is a global object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
 */
function checkGlobal(value) {
  return (value && value.Object === Object) ? value : null;
}

/**
 * Used by `_.template` to escape characters for inclusion in compiled string literals.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
function escapeStringChar(chr) {
  return '\\' + stringEscapes[chr];
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = Symbol ? symbolProto.toString : undefined;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function assignInDefaults(objValue, srcValue, key, object) {
  if (objValue === undefined ||
      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
    return srcValue;
  }
  return objValue;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if the provided arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
      ? (isArrayLike(object) && isIndex(index, object.length))
      : (type == 'string' && index in object)) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Performs a [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'user': 'fred' };
 * var other = { 'user': 'fred' };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null &&
    !(typeof value == 'function' && isFunction(value)) && isLength(getLength(value));
}

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  return isObjectLike(value) &&
    typeof value.message == 'string' && objectToString.call(value) == errorTag;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array constructors, and
  // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (value == null) {
    return '';
  }
  if (isSymbol(value)) {
    return Symbol ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Creates a compiled template function that can interpolate data properties
 * in "interpolate" delimiters, HTML-escape interpolated data properties in
 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
 * properties may be accessed as free variables in the template. If a setting
 * object is provided it takes precedence over `_.templateSettings` values.
 *
 * **Note:** In the development build `_.template` utilizes
 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
 * for easier debugging.
 *
 * For more information on precompiling templates see
 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
 *
 * For more information on Chrome extension sandboxes see
 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
 *
 * @static
 * @memberOf _
 * @category String
 * @param {string} [string=''] The template string.
 * @param {Object} [options] The options object.
 * @param {RegExp} [options.escape] The HTML "escape" delimiter.
 * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
 * @param {Object} [options.imports] An object to import into the template as free variables.
 * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
 * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
 * @param {string} [options.variable] The data object variable name.
 * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
 * @returns {Function} Returns the compiled template function.
 * @example
 *
 * // Use the "interpolate" delimiter to create a compiled template.
 * var compiled = _.template('hello <%= user %>!');
 * compiled({ 'user': 'fred' });
 * // => 'hello fred!'
 *
 * // Use the HTML "escape" delimiter to escape data property values.
 * var compiled = _.template('<b><%- value %></b>');
 * compiled({ 'value': '<script>' });
 * // => '<b>&lt;script&gt;</b>'
 *
 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the internal `print` function in "evaluate" delimiters.
 * var compiled = _.template('<% print("hello " + user); %>!');
 * compiled({ 'user': 'barney' });
 * // => 'hello barney!'
 *
 * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
 * var compiled = _.template('hello ${ user }!');
 * compiled({ 'user': 'pebbles' });
 * // => 'hello pebbles!'
 *
 * // Use custom template delimiters.
 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
 * var compiled = _.template('hello {{ user }}!');
 * compiled({ 'user': 'mustache' });
 * // => 'hello mustache!'
 *
 * // Use backslashes to treat delimiters as plain text.
 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
 * compiled({ 'value': 'ignored' });
 * // => '<%- value %>'
 *
 * // Use the `imports` option to import `jQuery` as `jq`.
 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
 * compiled(data);
 * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
 *
 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
 * compiled.source;
 * // => function(data) {
 * //   var __t, __p = '';
 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
 * //   return __p;
 * // }
 *
 * // Use the `source` property to inline compiled templates for meaningful
 * // line numbers in error messages and stack traces.
 * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
 *   var JST = {\
 *     "main": ' + _.template(mainText).source + '\
 *   };\
 * ');
 */
function template(string, options, guard) {
  // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
  var settings = templateSettings.imports._.templateSettings || templateSettings;

  if (guard && isIterateeCall(string, options, guard)) {
    options = undefined;
  }
  string = toString(string);
  options = assignInWith({}, options, settings, assignInDefaults);

  var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
      importsKeys = keys(imports),
      importsValues = baseValues(imports, importsKeys);

  var isEscaping,
      isEvaluating,
      index = 0,
      interpolate = options.interpolate || reNoMatch,
      source = "__p += '";

  // Compile the regexp to match each delimiter.
  var reDelimiters = RegExp(
    (options.escape || reNoMatch).source + '|' +
    interpolate.source + '|' +
    (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
    (options.evaluate || reNoMatch).source + '|$'
  , 'g');

  // Use a sourceURL for easier debugging.
  var sourceURL = 'sourceURL' in options ? '//# sourceURL=' + options.sourceURL + '\n' : '';

  string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
    interpolateValue || (interpolateValue = esTemplateValue);

    // Escape characters that can't be included in string literals.
    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

    // Replace delimiters with snippets.
    if (escapeValue) {
      isEscaping = true;
      source += "' +\n__e(" + escapeValue + ") +\n'";
    }
    if (evaluateValue) {
      isEvaluating = true;
      source += "';\n" + evaluateValue + ";\n__p += '";
    }
    if (interpolateValue) {
      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
    }
    index = offset + match.length;

    // The JS engine embedded in Adobe products needs `match` returned in
    // order to produce the correct `offset` value.
    return match;
  });

  source += "';\n";

  // If `variable` is not specified wrap a with-statement around the generated
  // code to add the data object to the top of the scope chain.
  var variable = options.variable;
  if (!variable) {
    source = 'with (obj) {\n' + source + '\n}\n';
  }
  // Cleanup code by stripping empty strings.
  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
    .replace(reEmptyStringMiddle, '$1')
    .replace(reEmptyStringTrailing, '$1;');

  // Frame code as the function body.
  source = 'function(' + (variable || 'obj') + ') {\n' +
    (variable
      ? ''
      : 'obj || (obj = {});\n'
    ) +
    "var __t, __p = ''" +
    (isEscaping
       ? ', __e = _.escape'
       : ''
    ) +
    (isEvaluating
      ? ', __j = Array.prototype.join;\n' +
        "function print() { __p += __j.call(arguments, '') }\n"
      : ';\n'
    ) +
    source +
    'return __p\n}';

  var result = attempt(function() {
    return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
  });

  // Provide the compiled function's source by its `toString` method or
  // the `source` property as a convenience for inlining compiled templates.
  result.source = source;
  if (isError(result)) {
    throw result;
  }
  return result;
}

/**
 * Attempts to invoke `func`, returning either the result or the caught error
 * object. Any additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @category Util
 * @param {Function} func The function to attempt.
 * @returns {*} Returns the `func` result or error object.
 * @example
 *
 * // Avoid throwing errors for invalid selectors.
 * var elements = _.attempt(function(selector) {
 *   return document.querySelectorAll(selector);
 * }, '>_>');
 *
 * if (_.isError(elements)) {
 *   elements = [];
 * }
 */
var attempt = rest(function(func, args) {
  try {
    return apply(func, undefined, args);
  } catch (e) {
    return isObject(e) ? e : new Error(e);
  }
});

module.exports = template;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module), __webpack_require__(4)))

/***/ }),
/* 3971 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 3972 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var escape = __webpack_require__(3952),
    reInterpolate = __webpack_require__(973);

/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g,
    reEvaluate = /<%([\s\S]+?)%>/g;

/**
 * By default, the template delimiters used by lodash are like those in
 * embedded Ruby (ERB). Change the following template settings to use
 * alternative delimiters.
 *
 * @static
 * @memberOf _
 * @type Object
 */
var templateSettings = {

  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type RegExp
   */
  'escape': reEscape,

  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type RegExp
   */
  'evaluate': reEvaluate,

  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type RegExp
   */
  'interpolate': reInterpolate,

  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type string
   */
  'variable': '',

  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type Object
   */
  'imports': {

    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type Function
     */
    '_': { 'escape': escape }
  }
};

module.exports = templateSettings;


/***/ }),
/* 3973 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseCopy = __webpack_require__(2233),
    keysIn = __webpack_require__(314);

/**
 * Converts `value` to a plain object flattening inherited enumerable
 * properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return baseCopy(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 3974 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 3975 */,
/* 3976 */,
/* 3977 */,
/* 3978 */,
/* 3979 */,
/* 3980 */,
/* 3981 */,
/* 3982 */,
/* 3983 */,
/* 3984 */,
/* 3985 */,
/* 3986 */,
/* 3987 */,
/* 3988 */,
/* 3989 */,
/* 3990 */,
/* 3991 */,
/* 3992 */,
/* 3993 */,
/* 3994 */,
/* 3995 */,
/* 3996 */,
/* 3997 */,
/* 3998 */,
/* 3999 */,
/* 4000 */,
/* 4001 */,
/* 4002 */,
/* 4003 */,
/* 4004 */,
/* 4005 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1937);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 4006 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(1389);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 4007 */,
/* 4008 */,
/* 4009 */,
/* 4010 */,
/* 4011 */,
/* 4012 */,
/* 4013 */,
/* 4014 */,
/* 4015 */,
/* 4016 */,
/* 4017 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 4018 */,
/* 4019 */,
/* 4020 */,
/* 4021 */,
/* 4022 */,
/* 4023 */,
/* 4024 */,
/* 4025 */,
/* 4026 */,
/* 4027 */,
/* 4028 */,
/* 4029 */,
/* 4030 */,
/* 4031 */,
/* 4032 */,
/* 4033 */,
/* 4034 */,
/* 4035 */,
/* 4036 */,
/* 4037 */,
/* 4038 */,
/* 4039 */,
/* 4040 */,
/* 4041 */,
/* 4042 */,
/* 4043 */,
/* 4044 */,
/* 4045 */,
/* 4046 */,
/* 4047 */,
/* 4048 */,
/* 4049 */
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 4049;


/***/ }),
/* 4050 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4051);

/***/ }),
/* 4051 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.6.3
(function() {
  var EventEmitter, NodeCache, _,
    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    __slice = [].slice;

  _ = __webpack_require__(4052);

  EventEmitter = __webpack_require__(298).EventEmitter;

  module.exports = NodeCache = (function(_super) {
    __extends(NodeCache, _super);

    function NodeCache(options) {
      this.options = options != null ? options : {};
      this._error = __bind(this._error, this);
      this._getValLength = __bind(this._getValLength, this);
      this._getKeyLength = __bind(this._getKeyLength, this);
      this._unwrap = __bind(this._unwrap, this);
      this._wrap = __bind(this._wrap, this);
      this._check = __bind(this._check, this);
      this._checkData = __bind(this._checkData, this);
      this.flushAll = __bind(this.flushAll, this);
      this.getStats = __bind(this.getStats, this);
      this.keys = __bind(this.keys, this);
      this.ttl = __bind(this.ttl, this);
      this.del = __bind(this.del, this);
      this.set = __bind(this.set, this);
      this.get = __bind(this.get, this);
      this.data = {};
      this.options = _.extend({
        forceString: false,
        objectValueSize: 80,
        arrayValueSize: 40,
        stdTTL: 0,
        checkperiod: 600
      }, this.options);
      this.stats = {
        hits: 0,
        misses: 0,
        keys: 0,
        ksize: 0,
        vsize: 0
      };
      this._checkData();
    }

    NodeCache.prototype.get = function(keys, cb) {
      var key, oRet, _i, _len;
      if (_.isString(keys)) {
        keys = [keys];
      }
      oRet = {};
      for (_i = 0, _len = keys.length; _i < _len; _i++) {
        key = keys[_i];
        if ((this.data[key] != null) && this._check(key, this.data[key])) {
          this.stats.hits++;
          oRet[key] = this._unwrap(this.data[key]);
        } else {
          this.stats.misses++;
        }
      }
      if (cb != null) {
        cb(null, oRet);
      }
      return oRet;
    };

    NodeCache.prototype.set = function(key, value, ttl, cb) {
      var existend;
      existend = false;
      if (this.options.forceString && !_.isString(value)) {
        value = JSON.stringify(value);
      }
      if (arguments.length === 3 && _.isFunction(ttl)) {
        cb = ttl;
        ttl = this.options.stdTTL;
      }
      if (this.data[key]) {
        existend = true;
        this.stats.vsize -= this._getValLength(this._unwrap(this.data[key]));
      }
      this.data[key] = this._wrap(value, ttl);
      this.stats.vsize += this._getValLength(value);
      if (!existend) {
        this.stats.ksize += this._getKeyLength(key);
        this.stats.keys++;
      }
      this.emit("set", key, value);
      if (cb != null) {
        cb(null, true);
      }
      return true;
    };

    NodeCache.prototype.del = function(keys, cb) {
      var delCount, key, _i, _len;
      if (_.isString(keys)) {
        keys = [keys];
      }
      delCount = 0;
      for (_i = 0, _len = keys.length; _i < _len; _i++) {
        key = keys[_i];
        if (this.data[key] != null) {
          this.stats.vsize -= this._getValLength(this._unwrap(this.data[key]));
          this.stats.ksize -= this._getKeyLength(key);
          this.stats.keys--;
          delCount++;
          delete this.data[key];
          this.emit("del", key);
        } else {
          this.stats.misses++;
        }
      }
      if (cb != null) {
        cb(null, delCount);
      }
      return delCount;
    };

    NodeCache.prototype.ttl = function() {
      var arg, args, cb, key, ttl, _i, _len;
      key = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      for (_i = 0, _len = args.length; _i < _len; _i++) {
        arg = args[_i];
        switch (typeof arg) {
          case "number":
            ttl = arg;
            break;
          case "function":
            cb = arg;
        }
      }
      ttl || (ttl = this.options.stdTTL);
      if (!key) {
        if (cb != null) {
          cb(null, false);
        }
        return false;
      }
      if ((this.data[key] != null) && this._check(key, this.data[key])) {
        if (ttl > 0) {
          this.data[key] = this._wrap(this.data[key].v, ttl);
        } else {
          this.del(key);
        }
        if (cb != null) {
          cb(null, true);
        }
        return true;
      } else {
        if (cb != null) {
          cb(null, false);
        }
        return false;
      }
    };

    NodeCache.prototype.keys = function(cb) {
      var _keys;
      _keys = Object.keys(this.data);
      if (cb != null) {
        cb(null, _keys);
      }
      return _keys;
    };

    NodeCache.prototype.getStats = function() {
      return this.stats;
    };

    NodeCache.prototype.flushAll = function(_startPeriod) {
      if (_startPeriod == null) {
        _startPeriod = true;
      }
      this.data = {};
      this.stats = {
        hits: 0,
        misses: 0,
        keys: 0,
        ksize: 0,
        vsize: 0
      };
      this._killCheckPeriod();
      this._checkData(_startPeriod);
      this.emit("flush");
    };

    NodeCache.prototype._checkData = function(startPeriod) {
      var key, value, _ref;
      if (startPeriod == null) {
        startPeriod = true;
      }
      _ref = this.data;
      for (key in _ref) {
        value = _ref[key];
        this._check(key, value);
      }
      if (startPeriod && this.options.checkperiod > 0) {
        this.checkTimeout = setTimeout(this._checkData, this.options.checkperiod * 1000);
      }
    };

    NodeCache.prototype._killCheckPeriod = function() {
      if (this.checkTimeout != null) {
        return clearTimeout(this.checkTimeout);
      }
    };

    NodeCache.prototype._check = function(key, data) {
      if (data.t !== 0 && data.t < Date.now()) {
        this.del(key);
        this.emit("expired", key, this._unwrap(data));
        return false;
      } else {
        return true;
      }
    };

    NodeCache.prototype._wrap = function(value, ttl) {
      var livetime, now, oReturn, ttlMultiplicator;
      now = Date.now();
      livetime = 0;
      ttlMultiplicator = 1000;
      if (ttl === 0) {
        livetime = 0;
      } else if (ttl) {
        livetime = now + (ttl * ttlMultiplicator);
      } else {
        if (this.options.stdTTL === 0) {
          livetime = this.options.stdTTL;
        } else {
          livetime = now + (this.options.stdTTL * ttlMultiplicator);
        }
      }
      return oReturn = {
        t: livetime,
        v: value
      };
    };

    NodeCache.prototype._unwrap = function(value) {
      if (value.v != null) {
        return value.v;
      }
      return null;
    };

    NodeCache.prototype._getKeyLength = function(key) {
      return key.length;
    };

    NodeCache.prototype._getValLength = function(value) {
      if (_.isString(value)) {
        return value.length;
      } else if (this.options.forceString) {
        return JSON.stringify(value).length;
      } else if (_.isArray(value)) {
        return this.options.arrayValueSize * value.length;
      } else if (_.isNumber(value)) {
        return 8;
      } else if (_.isObject(value)) {
        return this.options.objectValueSize * _.size(value);
      } else {
        return 0;
      }
    };

    NodeCache.prototype._error = function(type, data, cb) {
      var error;
      if (data == null) {
        data = {};
      }
      error = new Error();
      error.name = type;
      error.errorcode = type;
      error.msg = "-";
      error.data = data;
      if (cb && _.isFunction(cb)) {
        cb(error, null);
      } else {
        return error;
      }
    };

    return NodeCache;

  })(EventEmitter);

}).call(this);


/***/ }),
/* 4052 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),
/* 4053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * parseurl
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2014 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module dependencies.
 */

var url = __webpack_require__(1555)
var parse = url.parse
var Url = url.Url

/**
 * Pattern for a simple path case.
 * See: https://github.com/joyent/node/pull/7878
 */

var simplePathRegExp = /^(\/\/?(?!\/)[^\?#\s]*)(\?[^#\s]*)?$/

/**
 * Exports.
 */

module.exports = parseurl
module.exports.original = originalurl

/**
 * Parse the `req` url with memoization.
 *
 * @param {ServerRequest} req
 * @return {Object}
 * @api public
 */

function parseurl(req) {
  var url = req.url

  if (url === undefined) {
    // URL is undefined
    return undefined
  }

  var parsed = req._parsedUrl

  if (fresh(url, parsed)) {
    // Return cached URL parse
    return parsed
  }

  // Parse the URL
  parsed = fastparse(url)
  parsed._raw = url

  return req._parsedUrl = parsed
};

/**
 * Parse the `req` original url with fallback and memoization.
 *
 * @param {ServerRequest} req
 * @return {Object}
 * @api public
 */

function originalurl(req) {
  var url = req.originalUrl

  if (typeof url !== 'string') {
    // Fallback
    return parseurl(req)
  }

  var parsed = req._parsedOriginalUrl

  if (fresh(url, parsed)) {
    // Return cached URL parse
    return parsed
  }

  // Parse the URL
  parsed = fastparse(url)
  parsed._raw = url

  return req._parsedOriginalUrl = parsed
};

/**
 * Parse the `str` url with fast-path short-cut.
 *
 * @param {string} str
 * @return {Object}
 * @api private
 */

function fastparse(str) {
  // Try fast path regexp
  // See: https://github.com/joyent/node/pull/7878
  var simplePath = typeof str === 'string' && simplePathRegExp.exec(str)

  // Construct simple URL
  if (simplePath) {
    var pathname = simplePath[1]
    var search = simplePath[2] || null
    var url = Url !== undefined
      ? new Url()
      : {}
    url.path = str
    url.href = str
    url.pathname = pathname
    url.search = search
    url.query = search && search.substr(1)

    return url
  }

  return parse(str)
}

/**
 * Determine if parsed is still fresh for url.
 *
 * @param {string} url
 * @param {object} parsedUrl
 * @return {boolean}
 * @api private
 */

function fresh(url, parsedUrl) {
  return typeof parsedUrl === 'object'
    && parsedUrl !== null
    && (Url === undefined || parsedUrl instanceof Url)
    && parsedUrl._raw === url
}


/***/ }),
/* 4054 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * PEP v0.4.3 | https://github.com/jquery/PEP
 * Copyright jQuery Foundation and other contributors | http://jquery.org/license
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.PointerEventsPolyfill = factory());
}(this, function () { 'use strict';

  /**
   * This is the constructor for new PointerEvents.
   *
   * New Pointer Events must be given a type, and an optional dictionary of
   * initialization properties.
   *
   * Due to certain platform requirements, events returned from the constructor
   * identify as MouseEvents.
   *
   * @constructor
   * @param {String} inType The type of the event to create.
   * @param {Object} [inDict] An optional dictionary of initial event properties.
   * @return {Event} A new PointerEvent of type `inType`, initialized with properties from `inDict`.
   */
  var MOUSE_PROPS = [
    'bubbles',
    'cancelable',
    'view',
    'detail',
    'screenX',
    'screenY',
    'clientX',
    'clientY',
    'ctrlKey',
    'altKey',
    'shiftKey',
    'metaKey',
    'button',
    'relatedTarget',
    'pageX',
    'pageY'
  ];

  var MOUSE_DEFAULTS = [
    false,
    false,
    null,
    null,
    0,
    0,
    0,
    0,
    false,
    false,
    false,
    false,
    0,
    null,
    0,
    0
  ];

  function PointerEvent(inType, inDict) {
    inDict = inDict || Object.create(null);

    var e = document.createEvent('Event');
    e.initEvent(inType, inDict.bubbles || false, inDict.cancelable || false);

    // define inherited MouseEvent properties
    // skip bubbles and cancelable since they're set above in initEvent()
    for (var i = 2, p; i < MOUSE_PROPS.length; i++) {
      p = MOUSE_PROPS[i];
      e[p] = inDict[p] || MOUSE_DEFAULTS[i];
    }
    e.buttons = inDict.buttons || 0;

    // Spec requires that pointers without pressure specified use 0.5 for down
    // state and 0 for up state.
    var pressure = 0;

    if (inDict.pressure && e.buttons) {
      pressure = inDict.pressure;
    } else {
      pressure = e.buttons ? 0.5 : 0;
    }

    // add x/y properties aliased to clientX/Y
    e.x = e.clientX;
    e.y = e.clientY;

    // define the properties of the PointerEvent interface
    e.pointerId = inDict.pointerId || 0;
    e.width = inDict.width || 0;
    e.height = inDict.height || 0;
    e.pressure = pressure;
    e.tiltX = inDict.tiltX || 0;
    e.tiltY = inDict.tiltY || 0;
    e.twist = inDict.twist || 0;
    e.tangentialPressure = inDict.tangentialPressure || 0;
    e.pointerType = inDict.pointerType || '';
    e.hwTimestamp = inDict.hwTimestamp || 0;
    e.isPrimary = inDict.isPrimary || false;
    return e;
  }

  /**
   * This module implements a map of pointer states
   */
  var USE_MAP = window.Map && window.Map.prototype.forEach;
  var PointerMap = USE_MAP ? Map : SparseArrayMap;

  function SparseArrayMap() {
    this.array = [];
    this.size = 0;
  }

  SparseArrayMap.prototype = {
    set: function(k, v) {
      if (v === undefined) {
        return this.delete(k);
      }
      if (!this.has(k)) {
        this.size++;
      }
      this.array[k] = v;
    },
    has: function(k) {
      return this.array[k] !== undefined;
    },
    delete: function(k) {
      if (this.has(k)) {
        delete this.array[k];
        this.size--;
      }
    },
    get: function(k) {
      return this.array[k];
    },
    clear: function() {
      this.array.length = 0;
      this.size = 0;
    },

    // return value, key, map
    forEach: function(callback, thisArg) {
      return this.array.forEach(function(v, k) {
        callback.call(thisArg, v, k, this);
      }, this);
    }
  };

  var CLONE_PROPS = [

    // MouseEvent
    'bubbles',
    'cancelable',
    'view',
    'detail',
    'screenX',
    'screenY',
    'clientX',
    'clientY',
    'ctrlKey',
    'altKey',
    'shiftKey',
    'metaKey',
    'button',
    'relatedTarget',

    // DOM Level 3
    'buttons',

    // PointerEvent
    'pointerId',
    'width',
    'height',
    'pressure',
    'tiltX',
    'tiltY',
    'pointerType',
    'hwTimestamp',
    'isPrimary',

    // event instance
    'type',
    'target',
    'currentTarget',
    'which',
    'pageX',
    'pageY',
    'timeStamp'
  ];

  var CLONE_DEFAULTS = [

    // MouseEvent
    false,
    false,
    null,
    null,
    0,
    0,
    0,
    0,
    false,
    false,
    false,
    false,
    0,
    null,

    // DOM Level 3
    0,

    // PointerEvent
    0,
    0,
    0,
    0,
    0,
    0,
    '',
    0,
    false,

    // event instance
    '',
    null,
    null,
    0,
    0,
    0,
    0
  ];

  var BOUNDARY_EVENTS = {
    'pointerover': 1,
    'pointerout': 1,
    'pointerenter': 1,
    'pointerleave': 1
  };

  var HAS_SVG_INSTANCE = (typeof SVGElementInstance !== 'undefined');

  /**
   * This module is for normalizing events. Mouse and Touch events will be
   * collected here, and fire PointerEvents that have the same semantics, no
   * matter the source.
   * Events fired:
   *   - pointerdown: a pointing is added
   *   - pointerup: a pointer is removed
   *   - pointermove: a pointer is moved
   *   - pointerover: a pointer crosses into an element
   *   - pointerout: a pointer leaves an element
   *   - pointercancel: a pointer will no longer generate events
   */
  var dispatcher = {
    pointermap: new PointerMap(),
    eventMap: Object.create(null),
    captureInfo: Object.create(null),

    // Scope objects for native events.
    // This exists for ease of testing.
    eventSources: Object.create(null),
    eventSourceList: [],
    /**
     * Add a new event source that will generate pointer events.
     *
     * `inSource` must contain an array of event names named `events`, and
     * functions with the names specified in the `events` array.
     * @param {string} name A name for the event source
     * @param {Object} source A new source of platform events.
     */
    registerSource: function(name, source) {
      var s = source;
      var newEvents = s.events;
      if (newEvents) {
        newEvents.forEach(function(e) {
          if (s[e]) {
            this.eventMap[e] = s[e].bind(s);
          }
        }, this);
        this.eventSources[name] = s;
        this.eventSourceList.push(s);
      }
    },
    register: function(element) {
      var l = this.eventSourceList.length;
      for (var i = 0, es; (i < l) && (es = this.eventSourceList[i]); i++) {

        // call eventsource register
        es.register.call(es, element);
      }
    },
    unregister: function(element) {
      var l = this.eventSourceList.length;
      for (var i = 0, es; (i < l) && (es = this.eventSourceList[i]); i++) {

        // call eventsource register
        es.unregister.call(es, element);
      }
    },
    contains: /*scope.external.contains || */function(container, contained) {
      try {
        return container.contains(contained);
      } catch (ex) {

        // most likely: https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        return false;
      }
    },

    // EVENTS
    down: function(inEvent) {
      inEvent.bubbles = true;
      this.fireEvent('pointerdown', inEvent);
    },
    move: function(inEvent) {
      inEvent.bubbles = true;
      this.fireEvent('pointermove', inEvent);
    },
    up: function(inEvent) {
      inEvent.bubbles = true;
      this.fireEvent('pointerup', inEvent);
    },
    enter: function(inEvent) {
      inEvent.bubbles = false;
      this.fireEvent('pointerenter', inEvent);
    },
    leave: function(inEvent) {
      inEvent.bubbles = false;
      this.fireEvent('pointerleave', inEvent);
    },
    over: function(inEvent) {
      inEvent.bubbles = true;
      this.fireEvent('pointerover', inEvent);
    },
    out: function(inEvent) {
      inEvent.bubbles = true;
      this.fireEvent('pointerout', inEvent);
    },
    cancel: function(inEvent) {
      inEvent.bubbles = true;
      this.fireEvent('pointercancel', inEvent);
    },
    leaveOut: function(event) {
      this.out(event);
      this.propagate(event, this.leave, false);
    },
    enterOver: function(event) {
      this.over(event);
      this.propagate(event, this.enter, true);
    },

    // LISTENER LOGIC
    eventHandler: function(inEvent) {

      // This is used to prevent multiple dispatch of pointerevents from
      // platform events. This can happen when two elements in different scopes
      // are set up to create pointer events, which is relevant to Shadow DOM.
      if (inEvent._handledByPE) {
        return;
      }
      var type = inEvent.type;
      var fn = this.eventMap && this.eventMap[type];
      if (fn) {
        fn(inEvent);
      }
      inEvent._handledByPE = true;
    },

    // set up event listeners
    listen: function(target, events) {
      events.forEach(function(e) {
        this.addEvent(target, e);
      }, this);
    },

    // remove event listeners
    unlisten: function(target, events) {
      events.forEach(function(e) {
        this.removeEvent(target, e);
      }, this);
    },
    addEvent: /*scope.external.addEvent || */function(target, eventName) {
      target.addEventListener(eventName, this.boundHandler);
    },
    removeEvent: /*scope.external.removeEvent || */function(target, eventName) {
      target.removeEventListener(eventName, this.boundHandler);
    },

    // EVENT CREATION AND TRACKING
    /**
     * Creates a new Event of type `inType`, based on the information in
     * `inEvent`.
     *
     * @param {string} inType A string representing the type of event to create
     * @param {Event} inEvent A platform event with a target
     * @return {Event} A PointerEvent of type `inType`
     */
    makeEvent: function(inType, inEvent) {

      // relatedTarget must be null if pointer is captured
      if (this.captureInfo[inEvent.pointerId]) {
        inEvent.relatedTarget = null;
      }
      var e = new PointerEvent(inType, inEvent);
      if (inEvent.preventDefault) {
        e.preventDefault = inEvent.preventDefault;
      }
      e._target = e._target || inEvent.target;
      return e;
    },

    // make and dispatch an event in one call
    fireEvent: function(inType, inEvent) {
      var e = this.makeEvent(inType, inEvent);
      return this.dispatchEvent(e);
    },
    /**
     * Returns a snapshot of inEvent, with writable properties.
     *
     * @param {Event} inEvent An event that contains properties to copy.
     * @return {Object} An object containing shallow copies of `inEvent`'s
     *    properties.
     */
    cloneEvent: function(inEvent) {
      var eventCopy = Object.create(null);
      var p;
      for (var i = 0; i < CLONE_PROPS.length; i++) {
        p = CLONE_PROPS[i];
        eventCopy[p] = inEvent[p] || CLONE_DEFAULTS[i];

        // Work around SVGInstanceElement shadow tree
        // Return the <use> element that is represented by the instance for Safari, Chrome, IE.
        // This is the behavior implemented by Firefox.
        if (HAS_SVG_INSTANCE && (p === 'target' || p === 'relatedTarget')) {
          if (eventCopy[p] instanceof SVGElementInstance) {
            eventCopy[p] = eventCopy[p].correspondingUseElement;
          }
        }
      }

      // keep the semantics of preventDefault
      if (inEvent.preventDefault) {
        eventCopy.preventDefault = function() {
          inEvent.preventDefault();
        };
      }
      return eventCopy;
    },
    getTarget: function(inEvent) {
      var capture = this.captureInfo[inEvent.pointerId];
      if (!capture) {
        return inEvent._target;
      }
      if (inEvent._target === capture || !(inEvent.type in BOUNDARY_EVENTS)) {
        return capture;
      }
    },
    propagate: function(event, fn, propagateDown) {
      var target = event.target;
      var targets = [];

      // Order of conditions due to document.contains() missing in IE.
      while (target !== document && !target.contains(event.relatedTarget)) {
        targets.push(target);
        target = target.parentNode;

        // Touch: Do not propagate if node is detached.
        if (!target) {
          return;
        }
      }
      if (propagateDown) {
        targets.reverse();
      }
      targets.forEach(function(target) {
        event.target = target;
        fn.call(this, event);
      }, this);
    },
    setCapture: function(inPointerId, inTarget, skipDispatch) {
      if (this.captureInfo[inPointerId]) {
        this.releaseCapture(inPointerId, skipDispatch);
      }

      this.captureInfo[inPointerId] = inTarget;
      this.implicitRelease = this.releaseCapture.bind(this, inPointerId, skipDispatch);
      document.addEventListener('pointerup', this.implicitRelease);
      document.addEventListener('pointercancel', this.implicitRelease);

      var e = new PointerEvent('gotpointercapture');
      e.pointerId = inPointerId;
      e._target = inTarget;

      if (!skipDispatch) {
        this.asyncDispatchEvent(e);
      }
    },
    releaseCapture: function(inPointerId, skipDispatch) {
      var t = this.captureInfo[inPointerId];
      if (!t) {
        return;
      }

      this.captureInfo[inPointerId] = undefined;
      document.removeEventListener('pointerup', this.implicitRelease);
      document.removeEventListener('pointercancel', this.implicitRelease);

      var e = new PointerEvent('lostpointercapture');
      e.pointerId = inPointerId;
      e._target = t;

      if (!skipDispatch) {
        this.asyncDispatchEvent(e);
      }
    },
    /**
     * Dispatches the event to its target.
     *
     * @param {Event} inEvent The event to be dispatched.
     * @return {Boolean} True if an event handler returns true, false otherwise.
     */
    dispatchEvent: /*scope.external.dispatchEvent || */function(inEvent) {
      var t = this.getTarget(inEvent);
      if (t) {
        return t.dispatchEvent(inEvent);
      }
    },
    asyncDispatchEvent: function(inEvent) {
      requestAnimationFrame(this.dispatchEvent.bind(this, inEvent));
    }
  };
  dispatcher.boundHandler = dispatcher.eventHandler.bind(dispatcher);

  var targeting = {
    shadow: function(inEl) {
      if (inEl) {
        return inEl.shadowRoot || inEl.webkitShadowRoot;
      }
    },
    canTarget: function(shadow) {
      return shadow && Boolean(shadow.elementFromPoint);
    },
    targetingShadow: function(inEl) {
      var s = this.shadow(inEl);
      if (this.canTarget(s)) {
        return s;
      }
    },
    olderShadow: function(shadow) {
      var os = shadow.olderShadowRoot;
      if (!os) {
        var se = shadow.querySelector('shadow');
        if (se) {
          os = se.olderShadowRoot;
        }
      }
      return os;
    },
    allShadows: function(element) {
      var shadows = [];
      var s = this.shadow(element);
      while (s) {
        shadows.push(s);
        s = this.olderShadow(s);
      }
      return shadows;
    },
    searchRoot: function(inRoot, x, y) {
      if (inRoot) {
        var t = inRoot.elementFromPoint(x, y);
        var st, sr;

        // is element a shadow host?
        sr = this.targetingShadow(t);
        while (sr) {

          // find the the element inside the shadow root
          st = sr.elementFromPoint(x, y);
          if (!st) {

            // check for older shadows
            sr = this.olderShadow(sr);
          } else {

            // shadowed element may contain a shadow root
            var ssr = this.targetingShadow(st);
            return this.searchRoot(ssr, x, y) || st;
          }
        }

        // light dom element is the target
        return t;
      }
    },
    owner: function(element) {
      var s = element;

      // walk up until you hit the shadow root or document
      while (s.parentNode) {
        s = s.parentNode;
      }

      // the owner element is expected to be a Document or ShadowRoot
      if (s.nodeType !== Node.DOCUMENT_NODE && s.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
        s = document;
      }
      return s;
    },
    findTarget: function(inEvent) {
      var x = inEvent.clientX;
      var y = inEvent.clientY;

      // if the listener is in the shadow root, it is much faster to start there
      var s = this.owner(inEvent.target);

      // if x, y is not in this root, fall back to document search
      if (!s.elementFromPoint(x, y)) {
        s = document;
      }
      return this.searchRoot(s, x, y);
    }
  };

  var forEach = Array.prototype.forEach.call.bind(Array.prototype.forEach);
  var map = Array.prototype.map.call.bind(Array.prototype.map);
  var toArray = Array.prototype.slice.call.bind(Array.prototype.slice);
  var filter = Array.prototype.filter.call.bind(Array.prototype.filter);
  var MO = window.MutationObserver || window.WebKitMutationObserver;
  var SELECTOR = '[touch-action]';
  var OBSERVER_INIT = {
    subtree: true,
    childList: true,
    attributes: true,
    attributeOldValue: true,
    attributeFilter: ['touch-action']
  };

  function Installer(add, remove, changed, binder) {
    this.addCallback = add.bind(binder);
    this.removeCallback = remove.bind(binder);
    this.changedCallback = changed.bind(binder);
    if (MO) {
      this.observer = new MO(this.mutationWatcher.bind(this));
    }
  }

  Installer.prototype = {
    watchSubtree: function(target) {

      // Only watch scopes that can target find, as these are top-level.
      // Otherwise we can see duplicate additions and removals that add noise.
      //
      // TODO(dfreedman): For some instances with ShadowDOMPolyfill, we can see
      // a removal without an insertion when a node is redistributed among
      // shadows. Since it all ends up correct in the document, watching only
      // the document will yield the correct mutations to watch.
      if (this.observer && targeting.canTarget(target)) {
        this.observer.observe(target, OBSERVER_INIT);
      }
    },
    enableOnSubtree: function(target) {
      this.watchSubtree(target);
      if (target === document && document.readyState !== 'complete') {
        this.installOnLoad();
      } else {
        this.installNewSubtree(target);
      }
    },
    installNewSubtree: function(target) {
      forEach(this.findElements(target), this.addElement, this);
    },
    findElements: function(target) {
      if (target.querySelectorAll) {
        return target.querySelectorAll(SELECTOR);
      }
      return [];
    },
    removeElement: function(el) {
      this.removeCallback(el);
    },
    addElement: function(el) {
      this.addCallback(el);
    },
    elementChanged: function(el, oldValue) {
      this.changedCallback(el, oldValue);
    },
    concatLists: function(accum, list) {
      return accum.concat(toArray(list));
    },

    // register all touch-action = none nodes on document load
    installOnLoad: function() {
      document.addEventListener('readystatechange', function() {
        if (document.readyState === 'complete') {
          this.installNewSubtree(document);
        }
      }.bind(this));
    },
    isElement: function(n) {
      return n.nodeType === Node.ELEMENT_NODE;
    },
    flattenMutationTree: function(inNodes) {

      // find children with touch-action
      var tree = map(inNodes, this.findElements, this);

      // make sure the added nodes are accounted for
      tree.push(filter(inNodes, this.isElement));

      // flatten the list
      return tree.reduce(this.concatLists, []);
    },
    mutationWatcher: function(mutations) {
      mutations.forEach(this.mutationHandler, this);
    },
    mutationHandler: function(m) {
      if (m.type === 'childList') {
        var added = this.flattenMutationTree(m.addedNodes);
        added.forEach(this.addElement, this);
        var removed = this.flattenMutationTree(m.removedNodes);
        removed.forEach(this.removeElement, this);
      } else if (m.type === 'attributes') {
        this.elementChanged(m.target, m.oldValue);
      }
    }
  };

  function shadowSelector(v) {
    return 'body /shadow-deep/ ' + selector(v);
  }
  function selector(v) {
    return '[touch-action="' + v + '"]';
  }
  function rule(v) {
    return '{ -ms-touch-action: ' + v + '; touch-action: ' + v + '; }';
  }
  var attrib2css = [
    'none',
    'auto',
    'pan-x',
    'pan-y',
    {
      rule: 'pan-x pan-y',
      selectors: [
        'pan-x pan-y',
        'pan-y pan-x'
      ]
    }
  ];
  var styles = '';

  // only install stylesheet if the browser has touch action support
  var hasNativePE = window.PointerEvent || window.MSPointerEvent;

  // only add shadow selectors if shadowdom is supported
  var hasShadowRoot = !window.ShadowDOMPolyfill && document.head.createShadowRoot;

  function applyAttributeStyles() {
    if (hasNativePE) {
      attrib2css.forEach(function(r) {
        if (String(r) === r) {
          styles += selector(r) + rule(r) + '\n';
          if (hasShadowRoot) {
            styles += shadowSelector(r) + rule(r) + '\n';
          }
        } else {
          styles += r.selectors.map(selector) + rule(r.rule) + '\n';
          if (hasShadowRoot) {
            styles += r.selectors.map(shadowSelector) + rule(r.rule) + '\n';
          }
        }
      });

      var el = document.createElement('style');
      el.textContent = styles;
      document.head.appendChild(el);
    }
  }

  var pointermap = dispatcher.pointermap;

  // radius around touchend that swallows mouse events
  var DEDUP_DIST = 25;

  // left, middle, right, back, forward
  var BUTTON_TO_BUTTONS = [1, 4, 2, 8, 16];

  var HAS_BUTTONS = false;
  try {
    HAS_BUTTONS = new MouseEvent('test', { buttons: 1 }).buttons === 1;
  } catch (e) {}

  // handler block for native mouse events
  var mouseEvents = {
    POINTER_ID: 1,
    POINTER_TYPE: 'mouse',
    events: [
      'mousedown',
      'mousemove',
      'mouseup',
      'mouseover',
      'mouseout'
    ],
    register: function(target) {
      dispatcher.listen(target, this.events);
    },
    unregister: function(target) {
      dispatcher.unlisten(target, this.events);
    },
    lastTouches: [],

    // collide with the global mouse listener
    isEventSimulatedFromTouch: function(inEvent) {
      var lts = this.lastTouches;
      var x = inEvent.clientX;
      var y = inEvent.clientY;
      for (var i = 0, l = lts.length, t; i < l && (t = lts[i]); i++) {

        // simulated mouse events will be swallowed near a primary touchend
        var dx = Math.abs(x - t.x);
        var dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DIST && dy <= DEDUP_DIST) {
          return true;
        }
      }
    },
    prepareEvent: function(inEvent) {
      var e = dispatcher.cloneEvent(inEvent);

      // forward mouse preventDefault
      var pd = e.preventDefault;
      e.preventDefault = function() {
        inEvent.preventDefault();
        pd();
      };
      e.pointerId = this.POINTER_ID;
      e.isPrimary = true;
      e.pointerType = this.POINTER_TYPE;
      return e;
    },
    prepareButtonsForMove: function(e, inEvent) {
      var p = pointermap.get(this.POINTER_ID);

      // Update buttons state after possible out-of-document mouseup.
      if (inEvent.which === 0 || !p) {
        e.buttons = 0;
      } else {
        e.buttons = p.buttons;
      }
      inEvent.buttons = e.buttons;
    },
    mousedown: function(inEvent) {
      if (!this.isEventSimulatedFromTouch(inEvent)) {
        var p = pointermap.get(this.POINTER_ID);
        var e = this.prepareEvent(inEvent);
        if (!HAS_BUTTONS) {
          e.buttons = BUTTON_TO_BUTTONS[e.button];
          if (p) { e.buttons |= p.buttons; }
          inEvent.buttons = e.buttons;
        }
        pointermap.set(this.POINTER_ID, inEvent);
        if (!p || p.buttons === 0) {
          dispatcher.down(e);
        } else {
          dispatcher.move(e);
        }
      }
    },
    mousemove: function(inEvent) {
      if (!this.isEventSimulatedFromTouch(inEvent)) {
        var e = this.prepareEvent(inEvent);
        if (!HAS_BUTTONS) { this.prepareButtonsForMove(e, inEvent); }
        e.button = -1;
        pointermap.set(this.POINTER_ID, inEvent);
        dispatcher.move(e);
      }
    },
    mouseup: function(inEvent) {
      if (!this.isEventSimulatedFromTouch(inEvent)) {
        var p = pointermap.get(this.POINTER_ID);
        var e = this.prepareEvent(inEvent);
        if (!HAS_BUTTONS) {
          var up = BUTTON_TO_BUTTONS[e.button];

          // Produces wrong state of buttons in Browsers without `buttons` support
          // when a mouse button that was pressed outside the document is released
          // inside and other buttons are still pressed down.
          e.buttons = p ? p.buttons & ~up : 0;
          inEvent.buttons = e.buttons;
        }
        pointermap.set(this.POINTER_ID, inEvent);

        // Support: Firefox <=44 only
        // FF Ubuntu includes the lifted button in the `buttons` property on
        // mouseup.
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1223366
        e.buttons &= ~BUTTON_TO_BUTTONS[e.button];
        if (e.buttons === 0) {
          dispatcher.up(e);
        } else {
          dispatcher.move(e);
        }
      }
    },
    mouseover: function(inEvent) {
      if (!this.isEventSimulatedFromTouch(inEvent)) {
        var e = this.prepareEvent(inEvent);
        if (!HAS_BUTTONS) { this.prepareButtonsForMove(e, inEvent); }
        e.button = -1;
        pointermap.set(this.POINTER_ID, inEvent);
        dispatcher.enterOver(e);
      }
    },
    mouseout: function(inEvent) {
      if (!this.isEventSimulatedFromTouch(inEvent)) {
        var e = this.prepareEvent(inEvent);
        if (!HAS_BUTTONS) { this.prepareButtonsForMove(e, inEvent); }
        e.button = -1;
        dispatcher.leaveOut(e);
      }
    },
    cancel: function(inEvent) {
      var e = this.prepareEvent(inEvent);
      dispatcher.cancel(e);
      this.deactivateMouse();
    },
    deactivateMouse: function() {
      pointermap.delete(this.POINTER_ID);
    }
  };

  var captureInfo = dispatcher.captureInfo;
  var findTarget = targeting.findTarget.bind(targeting);
  var allShadows = targeting.allShadows.bind(targeting);
  var pointermap$1 = dispatcher.pointermap;

  // This should be long enough to ignore compat mouse events made by touch
  var DEDUP_TIMEOUT = 2500;
  var CLICK_COUNT_TIMEOUT = 200;
  var ATTRIB = 'touch-action';
  var INSTALLER;

  // handler block for native touch events
  var touchEvents = {
    events: [
      'touchstart',
      'touchmove',
      'touchend',
      'touchcancel'
    ],
    register: function(target) {
      INSTALLER.enableOnSubtree(target);
    },
    unregister: function() {

      // TODO(dfreedman): is it worth it to disconnect the MO?
    },
    elementAdded: function(el) {
      var a = el.getAttribute(ATTRIB);
      var st = this.touchActionToScrollType(a);
      if (st) {
        el._scrollType = st;
        dispatcher.listen(el, this.events);

        // set touch-action on shadows as well
        allShadows(el).forEach(function(s) {
          s._scrollType = st;
          dispatcher.listen(s, this.events);
        }, this);
      }
    },
    elementRemoved: function(el) {
      el._scrollType = undefined;
      dispatcher.unlisten(el, this.events);

      // remove touch-action from shadow
      allShadows(el).forEach(function(s) {
        s._scrollType = undefined;
        dispatcher.unlisten(s, this.events);
      }, this);
    },
    elementChanged: function(el, oldValue) {
      var a = el.getAttribute(ATTRIB);
      var st = this.touchActionToScrollType(a);
      var oldSt = this.touchActionToScrollType(oldValue);

      // simply update scrollType if listeners are already established
      if (st && oldSt) {
        el._scrollType = st;
        allShadows(el).forEach(function(s) {
          s._scrollType = st;
        }, this);
      } else if (oldSt) {
        this.elementRemoved(el);
      } else if (st) {
        this.elementAdded(el);
      }
    },
    scrollTypes: {
      EMITTER: 'none',
      XSCROLLER: 'pan-x',
      YSCROLLER: 'pan-y',
      SCROLLER: /^(?:pan-x pan-y)|(?:pan-y pan-x)|auto$/
    },
    touchActionToScrollType: function(touchAction) {
      var t = touchAction;
      var st = this.scrollTypes;
      if (t === 'none') {
        return 'none';
      } else if (t === st.XSCROLLER) {
        return 'X';
      } else if (t === st.YSCROLLER) {
        return 'Y';
      } else if (st.SCROLLER.exec(t)) {
        return 'XY';
      }
    },
    POINTER_TYPE: 'touch',
    firstTouch: null,
    isPrimaryTouch: function(inTouch) {
      return this.firstTouch === inTouch.identifier;
    },
    setPrimaryTouch: function(inTouch) {

      // set primary touch if there no pointers, or the only pointer is the mouse
      if (pointermap$1.size === 0 || (pointermap$1.size === 1 && pointermap$1.has(1))) {
        this.firstTouch = inTouch.identifier;
        this.firstXY = { X: inTouch.clientX, Y: inTouch.clientY };
        this.scrolling = false;
        this.cancelResetClickCount();
      }
    },
    removePrimaryPointer: function(inPointer) {
      if (inPointer.isPrimary) {
        this.firstTouch = null;
        this.firstXY = null;
        this.resetClickCount();
      }
    },
    clickCount: 0,
    resetId: null,
    resetClickCount: function() {
      var fn = function() {
        this.clickCount = 0;
        this.resetId = null;
      }.bind(this);
      this.resetId = setTimeout(fn, CLICK_COUNT_TIMEOUT);
    },
    cancelResetClickCount: function() {
      if (this.resetId) {
        clearTimeout(this.resetId);
      }
    },
    typeToButtons: function(type) {
      var ret = 0;
      if (type === 'touchstart' || type === 'touchmove') {
        ret = 1;
      }
      return ret;
    },
    touchToPointer: function(inTouch) {
      var cte = this.currentTouchEvent;
      var e = dispatcher.cloneEvent(inTouch);

      // We reserve pointerId 1 for Mouse.
      // Touch identifiers can start at 0.
      // Add 2 to the touch identifier for compatibility.
      var id = e.pointerId = inTouch.identifier + 2;
      e.target = captureInfo[id] || findTarget(e);
      e.bubbles = true;
      e.cancelable = true;
      e.detail = this.clickCount;
      e.button = 0;
      e.buttons = this.typeToButtons(cte.type);
      e.width = (inTouch.radiusX || inTouch.webkitRadiusX || 0) * 2;
      e.height = (inTouch.radiusY || inTouch.webkitRadiusY || 0) * 2;
      e.pressure = inTouch.force || inTouch.webkitForce || 0.5;
      e.isPrimary = this.isPrimaryTouch(inTouch);
      e.pointerType = this.POINTER_TYPE;

      // forward modifier keys
      e.altKey = cte.altKey;
      e.ctrlKey = cte.ctrlKey;
      e.metaKey = cte.metaKey;
      e.shiftKey = cte.shiftKey;

      // forward touch preventDefaults
      var self = this;
      e.preventDefault = function() {
        self.scrolling = false;
        self.firstXY = null;
        cte.preventDefault();
      };
      return e;
    },
    processTouches: function(inEvent, inFunction) {
      var tl = inEvent.changedTouches;
      this.currentTouchEvent = inEvent;
      for (var i = 0, t; i < tl.length; i++) {
        t = tl[i];
        inFunction.call(this, this.touchToPointer(t));
      }
    },

    // For single axis scrollers, determines whether the element should emit
    // pointer events or behave as a scroller
    shouldScroll: function(inEvent) {
      if (this.firstXY) {
        var ret;
        var scrollAxis = inEvent.currentTarget._scrollType;
        if (scrollAxis === 'none') {

          // this element is a touch-action: none, should never scroll
          ret = false;
        } else if (scrollAxis === 'XY') {

          // this element should always scroll
          ret = true;
        } else {
          var t = inEvent.changedTouches[0];

          // check the intended scroll axis, and other axis
          var a = scrollAxis;
          var oa = scrollAxis === 'Y' ? 'X' : 'Y';
          var da = Math.abs(t['client' + a] - this.firstXY[a]);
          var doa = Math.abs(t['client' + oa] - this.firstXY[oa]);

          // if delta in the scroll axis > delta other axis, scroll instead of
          // making events
          ret = da >= doa;
        }
        this.firstXY = null;
        return ret;
      }
    },
    findTouch: function(inTL, inId) {
      for (var i = 0, l = inTL.length, t; i < l && (t = inTL[i]); i++) {
        if (t.identifier === inId) {
          return true;
        }
      }
    },

    // In some instances, a touchstart can happen without a touchend. This
    // leaves the pointermap in a broken state.
    // Therefore, on every touchstart, we remove the touches that did not fire a
    // touchend event.
    // To keep state globally consistent, we fire a
    // pointercancel for this "abandoned" touch
    vacuumTouches: function(inEvent) {
      var tl = inEvent.touches;

      // pointermap.size should be < tl.length here, as the touchstart has not
      // been processed yet.
      if (pointermap$1.size >= tl.length) {
        var d = [];
        pointermap$1.forEach(function(value, key) {

          // Never remove pointerId == 1, which is mouse.
          // Touch identifiers are 2 smaller than their pointerId, which is the
          // index in pointermap.
          if (key !== 1 && !this.findTouch(tl, key - 2)) {
            var p = value.out;
            d.push(p);
          }
        }, this);
        d.forEach(this.cancelOut, this);
      }
    },
    touchstart: function(inEvent) {
      this.vacuumTouches(inEvent);
      this.setPrimaryTouch(inEvent.changedTouches[0]);
      this.dedupSynthMouse(inEvent);
      if (!this.scrolling) {
        this.clickCount++;
        this.processTouches(inEvent, this.overDown);
      }
    },
    overDown: function(inPointer) {
      pointermap$1.set(inPointer.pointerId, {
        target: inPointer.target,
        out: inPointer,
        outTarget: inPointer.target
      });
      dispatcher.enterOver(inPointer);
      dispatcher.down(inPointer);
    },
    touchmove: function(inEvent) {
      if (!this.scrolling) {
        if (this.shouldScroll(inEvent)) {
          this.scrolling = true;
          this.touchcancel(inEvent);
        } else {
          inEvent.preventDefault();
          this.processTouches(inEvent, this.moveOverOut);
        }
      }
    },
    moveOverOut: function(inPointer) {
      var event = inPointer;
      var pointer = pointermap$1.get(event.pointerId);

      // a finger drifted off the screen, ignore it
      if (!pointer) {
        return;
      }
      var outEvent = pointer.out;
      var outTarget = pointer.outTarget;
      dispatcher.move(event);
      if (outEvent && outTarget !== event.target) {
        outEvent.relatedTarget = event.target;
        event.relatedTarget = outTarget;

        // recover from retargeting by shadow
        outEvent.target = outTarget;
        if (event.target) {
          dispatcher.leaveOut(outEvent);
          dispatcher.enterOver(event);
        } else {

          // clean up case when finger leaves the screen
          event.target = outTarget;
          event.relatedTarget = null;
          this.cancelOut(event);
        }
      }
      pointer.out = event;
      pointer.outTarget = event.target;
    },
    touchend: function(inEvent) {
      this.dedupSynthMouse(inEvent);
      this.processTouches(inEvent, this.upOut);
    },
    upOut: function(inPointer) {
      if (!this.scrolling) {
        dispatcher.up(inPointer);
        dispatcher.leaveOut(inPointer);
      }
      this.cleanUpPointer(inPointer);
    },
    touchcancel: function(inEvent) {
      this.processTouches(inEvent, this.cancelOut);
    },
    cancelOut: function(inPointer) {
      dispatcher.cancel(inPointer);
      dispatcher.leaveOut(inPointer);
      this.cleanUpPointer(inPointer);
    },
    cleanUpPointer: function(inPointer) {
      pointermap$1.delete(inPointer.pointerId);
      this.removePrimaryPointer(inPointer);
    },

    // prevent synth mouse events from creating pointer events
    dedupSynthMouse: function(inEvent) {
      var lts = mouseEvents.lastTouches;
      var t = inEvent.changedTouches[0];

      // only the primary finger will synth mouse events
      if (this.isPrimaryTouch(t)) {

        // remember x/y of last touch
        var lt = { x: t.clientX, y: t.clientY };
        lts.push(lt);
        var fn = (function(lts, lt) {
          var i = lts.indexOf(lt);
          if (i > -1) {
            lts.splice(i, 1);
          }
        }).bind(null, lts, lt);
        setTimeout(fn, DEDUP_TIMEOUT);
      }
    }
  };

  INSTALLER = new Installer(touchEvents.elementAdded, touchEvents.elementRemoved,
    touchEvents.elementChanged, touchEvents);

  var pointermap$2 = dispatcher.pointermap;
  var HAS_BITMAP_TYPE = window.MSPointerEvent &&
    typeof window.MSPointerEvent.MSPOINTER_TYPE_MOUSE === 'number';
  var msEvents = {
    events: [
      'MSPointerDown',
      'MSPointerMove',
      'MSPointerUp',
      'MSPointerOut',
      'MSPointerOver',
      'MSPointerCancel',
      'MSGotPointerCapture',
      'MSLostPointerCapture'
    ],
    register: function(target) {
      dispatcher.listen(target, this.events);
    },
    unregister: function(target) {
      dispatcher.unlisten(target, this.events);
    },
    POINTER_TYPES: [
      '',
      'unavailable',
      'touch',
      'pen',
      'mouse'
    ],
    prepareEvent: function(inEvent) {
      var e = inEvent;
      if (HAS_BITMAP_TYPE) {
        e = dispatcher.cloneEvent(inEvent);
        e.pointerType = this.POINTER_TYPES[inEvent.pointerType];
      }
      return e;
    },
    cleanup: function(id) {
      pointermap$2.delete(id);
    },
    MSPointerDown: function(inEvent) {
      pointermap$2.set(inEvent.pointerId, inEvent);
      var e = this.prepareEvent(inEvent);
      dispatcher.down(e);
    },
    MSPointerMove: function(inEvent) {
      var e = this.prepareEvent(inEvent);
      dispatcher.move(e);
    },
    MSPointerUp: function(inEvent) {
      var e = this.prepareEvent(inEvent);
      dispatcher.up(e);
      this.cleanup(inEvent.pointerId);
    },
    MSPointerOut: function(inEvent) {
      var e = this.prepareEvent(inEvent);
      dispatcher.leaveOut(e);
    },
    MSPointerOver: function(inEvent) {
      var e = this.prepareEvent(inEvent);
      dispatcher.enterOver(e);
    },
    MSPointerCancel: function(inEvent) {
      var e = this.prepareEvent(inEvent);
      dispatcher.cancel(e);
      this.cleanup(inEvent.pointerId);
    },
    MSLostPointerCapture: function(inEvent) {
      var e = dispatcher.makeEvent('lostpointercapture', inEvent);
      dispatcher.dispatchEvent(e);
    },
    MSGotPointerCapture: function(inEvent) {
      var e = dispatcher.makeEvent('gotpointercapture', inEvent);
      dispatcher.dispatchEvent(e);
    }
  };

  function applyPolyfill() {

    // only activate if this platform does not have pointer events
    if (!window.PointerEvent) {
      window.PointerEvent = PointerEvent;

      if (window.navigator.msPointerEnabled) {
        var tp = window.navigator.msMaxTouchPoints;
        Object.defineProperty(window.navigator, 'maxTouchPoints', {
          value: tp,
          enumerable: true
        });
        dispatcher.registerSource('ms', msEvents);
      } else {
        Object.defineProperty(window.navigator, 'maxTouchPoints', {
          value: 0,
          enumerable: true
        });
        dispatcher.registerSource('mouse', mouseEvents);
        if (window.ontouchstart !== undefined) {
          dispatcher.registerSource('touch', touchEvents);
        }
      }

      dispatcher.register(document);
    }
  }

  var n = window.navigator;
  var s;
  var r;
  var h;
  function assertActive(id) {
    if (!dispatcher.pointermap.has(id)) {
      var error = new Error('InvalidPointerId');
      error.name = 'InvalidPointerId';
      throw error;
    }
  }
  function assertConnected(elem) {
    var parent = elem.parentNode;
    while (parent && parent !== elem.ownerDocument) {
      parent = parent.parentNode;
    }
    if (!parent) {
      var error = new Error('InvalidStateError');
      error.name = 'InvalidStateError';
      throw error;
    }
  }
  function inActiveButtonState(id) {
    var p = dispatcher.pointermap.get(id);
    return p.buttons !== 0;
  }
  if (n.msPointerEnabled) {
    s = function(pointerId) {
      assertActive(pointerId);
      assertConnected(this);
      if (inActiveButtonState(pointerId)) {
        dispatcher.setCapture(pointerId, this, true);
        this.msSetPointerCapture(pointerId);
      }
    };
    r = function(pointerId) {
      assertActive(pointerId);
      dispatcher.releaseCapture(pointerId, true);
      this.msReleasePointerCapture(pointerId);
    };
  } else {
    s = function setPointerCapture(pointerId) {
      assertActive(pointerId);
      assertConnected(this);
      if (inActiveButtonState(pointerId)) {
        dispatcher.setCapture(pointerId, this);
      }
    };
    r = function releasePointerCapture(pointerId) {
      assertActive(pointerId);
      dispatcher.releaseCapture(pointerId);
    };
  }
  h = function hasPointerCapture(pointerId) {
    return !!dispatcher.captureInfo[pointerId];
  };

  function applyPolyfill$1() {
    if (window.Element && !Element.prototype.setPointerCapture) {
      Object.defineProperties(Element.prototype, {
        'setPointerCapture': {
          value: s
        },
        'releasePointerCapture': {
          value: r
        },
        'hasPointerCapture': {
          value: h
        }
      });
    }
  }

  applyAttributeStyles();
  applyPolyfill();
  applyPolyfill$1();

  var pointerevents = {
    dispatcher: dispatcher,
    Installer: Installer,
    PointerEvent: PointerEvent,
    PointerMap: PointerMap,
    targetFinding: targeting
  };

  return pointerevents;

}));

/***/ }),
/* 4055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(1976);
var invariant = __webpack_require__(512);
var ReactPropTypesSecret = __webpack_require__(4240);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 4056 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module), __webpack_require__(4)))

/***/ }),
/* 4057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Utils = __webpack_require__(2262);

var has = Object.prototype.hasOwnProperty;

var defaults = {
    delimiter: '&',
    depth: 5,
    arrayLimit: 20,
    parameterLimit: 1000,
    strictNullHandling: false,
    plainObjects: false,
    allowPrototypes: false,
    allowDots: false,
    decoder: Utils.decode
};

var parseValues = function parseValues(str, options) {
    var obj = {};
    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);

    for (var i = 0; i < parts.length; ++i) {
        var part = parts[i];
        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos));
            val = options.decoder(part.slice(pos + 1));
        }
        if (has.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function parseObject(chain, val, options) {
    if (!chain.length) {
        return val;
    }

    var root = chain.shift();

    var obj;
    if (root === '[]') {
        obj = [];
        obj = obj.concat(parseObject(chain, val, options));
    } else {
        obj = options.plainObjects ? Object.create(null) : {};
        var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
        var index = parseInt(cleanRoot, 10);
        if (
            !isNaN(index) &&
            root !== cleanRoot &&
            String(index) === cleanRoot &&
            index >= 0 &&
            (options.parseArrays && index <= options.arrayLimit)
        ) {
            obj = [];
            obj[index] = parseObject(chain, val, options);
        } else {
            obj[cleanRoot] = parseObject(chain, val, options);
        }
    }

    return obj;
};

var parseKeys = function parseKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts || {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = Utils.merge(obj, newObj, options);
    }

    return Utils.compact(obj);
};


/***/ }),
/* 4058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Utils = __webpack_require__(2262);

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var defaults = {
    delimiter: '&',
    strictNullHandling: false,
    skipNulls: false,
    encode: true,
    encoder: Utils.encode
};

var stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = obj.toISOString();
    } else if (obj === null) {
        if (strictNullHandling) {
            return encoder ? encoder(prefix) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || Utils.isBuffer(obj)) {
        if (encoder) {
            return [encoder(prefix) + '=' + encoder(obj)];
        }
        return [prefix + '=' + String(obj)];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots));
        } else {
            values = values.concat(stringify(obj[key], prefix + (allowDots ? '.' + key : '[' + key + ']'), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts || {};
    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
    var encoder = encode ? (typeof options.encoder === 'function' ? options.encoder : defaults.encoder) : null;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
    var objKeys;
    var filter;

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        objKeys = filter = options.filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        keys = keys.concat(stringify(obj[key], key, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots));
    }

    return keys.join(delimiter);
};


/***/ }),
/* 4059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 4060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 4061 */,
/* 4062 */,
/* 4063 */,
/* 4064 */,
/* 4065 */,
/* 4066 */,
/* 4067 */,
/* 4068 */,
/* 4069 */,
/* 4070 */,
/* 4071 */,
/* 4072 */,
/* 4073 */,
/* 4074 */,
/* 4075 */,
/* 4076 */,
/* 4077 */,
/* 4078 */,
/* 4079 */,
/* 4080 */,
/* 4081 */,
/* 4082 */,
/* 4083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = undefined;

var _react = __webpack_require__(1);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _storeShape = __webpack_require__(2271);

var _storeShape2 = _interopRequireDefault(_storeShape);

var _warning = __webpack_require__(2272);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  Provider.prototype.getChildContext = function getChildContext() {
    return { store: this.store };
  };

  function Provider(props, context) {
    _classCallCheck(this, Provider);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.store = props.store;
    return _this;
  }

  Provider.prototype.render = function render() {
    return _react.Children.only(this.props.children);
  };

  return Provider;
}(_react.Component);

exports["default"] = Provider;


if (false) {
  Provider.prototype.componentWillReceiveProps = function (nextProps) {
    var store = this.store;
    var nextStore = nextProps.store;


    if (store !== nextStore) {
      warnAboutReceivingStore();
    }
  };
}

Provider.propTypes = {
  store: _storeShape2["default"].isRequired,
  children: _propTypes2["default"].element.isRequired
};
Provider.childContextTypes = {
  store: _storeShape2["default"].isRequired
};

/***/ }),
/* 4084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = connect;

var _react = __webpack_require__(1);

var _storeShape = __webpack_require__(2271);

var _storeShape2 = _interopRequireDefault(_storeShape);

var _shallowEqual = __webpack_require__(4085);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _wrapActionCreators = __webpack_require__(4086);

var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);

var _warning = __webpack_require__(2272);

var _warning2 = _interopRequireDefault(_warning);

var _isPlainObject = __webpack_require__(981);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _hoistNonReactStatics = __webpack_require__(749);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _invariant = __webpack_require__(404);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultMapStateToProps = function defaultMapStateToProps(state) {
  return {};
}; // eslint-disable-line no-unused-vars
var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
};
var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
  return _extends({}, parentProps, stateProps, dispatchProps);
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var errorObject = { value: null };
function tryCatch(fn, ctx) {
  try {
    return fn.apply(ctx);
  } catch (e) {
    errorObject.value = e;
    return errorObject;
  }
}

// Helps track hot reloading.
var nextVersion = 0;

function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var shouldSubscribe = Boolean(mapStateToProps);
  var mapState = mapStateToProps || defaultMapStateToProps;

  var mapDispatch = void 0;
  if (typeof mapDispatchToProps === 'function') {
    mapDispatch = mapDispatchToProps;
  } else if (!mapDispatchToProps) {
    mapDispatch = defaultMapDispatchToProps;
  } else {
    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
  }

  var finalMergeProps = mergeProps || defaultMergeProps;
  var _options$pure = options.pure,
      pure = _options$pure === undefined ? true : _options$pure,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;

  // Helps track hot reloading.
  var version = nextVersion++;

  return function wrapWithConnect(WrappedComponent) {
    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';

    function checkStateShape(props, methodName) {
      if (!(0, _isPlainObject2["default"])(props)) {
        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
      }
    }

    function computeMergedProps(stateProps, dispatchProps, parentProps) {
      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
      if (false) {
        checkStateShape(mergedProps, 'mergeProps');
      }
      return mergedProps;
    }

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
      };

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.store = props.store || context.store;

        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));

        var storeState = _this.store.getState();
        _this.state = { storeState: storeState };
        _this.clearCache();
        return _this;
      }

      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
        if (!this.finalMapStateToProps) {
          return this.configureFinalMapState(store, props);
        }

        var state = store.getState();
        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);

        if (false) {
          checkStateShape(stateProps, 'mapStateToProps');
        }
        return stateProps;
      };

      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
        var mappedState = mapState(store.getState(), props);
        var isFactory = typeof mappedState === 'function';

        this.finalMapStateToProps = isFactory ? mappedState : mapState;
        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;

        if (isFactory) {
          return this.computeStateProps(store, props);
        }

        if (false) {
          checkStateShape(mappedState, 'mapStateToProps');
        }
        return mappedState;
      };

      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
        if (!this.finalMapDispatchToProps) {
          return this.configureFinalMapDispatch(store, props);
        }

        var dispatch = store.dispatch;

        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);

        if (false) {
          checkStateShape(dispatchProps, 'mapDispatchToProps');
        }
        return dispatchProps;
      };

      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
        var mappedDispatch = mapDispatch(store.dispatch, props);
        var isFactory = typeof mappedDispatch === 'function';

        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;

        if (isFactory) {
          return this.computeDispatchProps(store, props);
        }

        if (false) {
          checkStateShape(mappedDispatch, 'mapDispatchToProps');
        }
        return mappedDispatch;
      };

      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
        var nextStateProps = this.computeStateProps(this.store, this.props);
        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
          return false;
        }

        this.stateProps = nextStateProps;
        return true;
      };

      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
          return false;
        }

        this.dispatchProps = nextDispatchProps;
        return true;
      };

      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
          return false;
        }

        this.mergedProps = nextMergedProps;
        return true;
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return typeof this.unsubscribe === 'function';
      };

      Connect.prototype.trySubscribe = function trySubscribe() {
        if (shouldSubscribe && !this.unsubscribe) {
          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
          this.handleChange();
        }
      };

      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
        if (this.unsubscribe) {
          this.unsubscribe();
          this.unsubscribe = null;
        }
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        this.trySubscribe();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
          this.haveOwnPropsChanged = true;
        }
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        this.tryUnsubscribe();
        this.clearCache();
      };

      Connect.prototype.clearCache = function clearCache() {
        this.dispatchProps = null;
        this.stateProps = null;
        this.mergedProps = null;
        this.haveOwnPropsChanged = true;
        this.hasStoreStateChanged = true;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;
        this.renderedElement = null;
        this.finalMapDispatchToProps = null;
        this.finalMapStateToProps = null;
      };

      Connect.prototype.handleChange = function handleChange() {
        if (!this.unsubscribe) {
          return;
        }

        var storeState = this.store.getState();
        var prevStoreState = this.state.storeState;
        if (pure && prevStoreState === storeState) {
          return;
        }

        if (pure && !this.doStatePropsDependOnOwnProps) {
          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
          if (!haveStatePropsChanged) {
            return;
          }
          if (haveStatePropsChanged === errorObject) {
            this.statePropsPrecalculationError = errorObject.value;
          }
          this.haveStatePropsBeenPrecalculated = true;
        }

        this.hasStoreStateChanged = true;
        this.setState({ storeState: storeState });
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');

        return this.refs.wrappedInstance;
      };

      Connect.prototype.render = function render() {
        var haveOwnPropsChanged = this.haveOwnPropsChanged,
            hasStoreStateChanged = this.hasStoreStateChanged,
            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
            statePropsPrecalculationError = this.statePropsPrecalculationError,
            renderedElement = this.renderedElement;


        this.haveOwnPropsChanged = false;
        this.hasStoreStateChanged = false;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;

        if (statePropsPrecalculationError) {
          throw statePropsPrecalculationError;
        }

        var shouldUpdateStateProps = true;
        var shouldUpdateDispatchProps = true;
        if (pure && renderedElement) {
          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
        }

        var haveStatePropsChanged = false;
        var haveDispatchPropsChanged = false;
        if (haveStatePropsBeenPrecalculated) {
          haveStatePropsChanged = true;
        } else if (shouldUpdateStateProps) {
          haveStatePropsChanged = this.updateStatePropsIfNeeded();
        }
        if (shouldUpdateDispatchProps) {
          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
        }

        var haveMergedPropsChanged = true;
        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
        } else {
          haveMergedPropsChanged = false;
        }

        if (!haveMergedPropsChanged && renderedElement) {
          return renderedElement;
        }

        if (withRef) {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
            ref: 'wrappedInstance'
          }));
        } else {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
        }

        return this.renderedElement;
      };

      return Connect;
    }(_react.Component);

    Connect.displayName = connectDisplayName;
    Connect.WrappedComponent = WrappedComponent;
    Connect.contextTypes = {
      store: _storeShape2["default"]
    };
    Connect.propTypes = {
      store: _storeShape2["default"]
    };

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        if (this.version === version) {
          return;
        }

        // We are hot reloading!
        this.version = version;
        this.trySubscribe();
        this.clearCache();
      };
    }

    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
  };
}

/***/ }),
/* 4085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = shallowEqual;
function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var hasOwn = Object.prototype.hasOwnProperty;
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 4086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = wrapActionCreators;

var _redux = __webpack_require__(384);

function wrapActionCreators(actionCreators) {
  return function (dispatch) {
    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
  };
}

/***/ }),
/* 4087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RelayConnectionInterface
 */



module.exports = __webpack_require__(4091);

/***/ }),
/* 4088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RelayFragmentReference
 * 
 */



var _extends2 = __webpack_require__(514);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(344);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var QueryBuilder = __webpack_require__(1425);

var forEachObject = __webpack_require__(2120);
var invariant = __webpack_require__(512);
var warning = __webpack_require__(1962);

/**
 * @internal
 *
 * RelayFragmentReference is the return type of fragment composition:
 *
 *   fragment on Foo {
 *     ${Child.getFragment('bar', {baz: variables.qux})}
 *   }
 *
 * Whereas a fragment defines a sub-query's structure, a fragment reference is
 * a particular instantiation of the fragment as it is composed within a query
 * or another fragment. It encodes the source fragment, initial variables, and
 * a mapping from variables in the composing query's (or fragment's) scope to
 * variables in the fragment's scope.
 *
 * The variable mapping is represented by `variableMapping`, a dictionary that
 * maps from names of variables in the parent scope to variables that exist in
 * the fragment. Example:
 *
 * ```
 * // Fragment:
 * var Container = Relay.createContainer(..., {
 *   initialVariables: {
 *     private: 'foo',
 *     public: 'bar',
 *     variable: null,
 *   },
 *   fragments: {
 *     foo: ...
 *   }
 * });
 *
 * // Reference:
 * ${Container.getQuery(
 *   'foo',
 *   // Variable Mapping:
 *   {
 *     public: 'BAR',
 *     variable: variables.source,
 *   }
 * )}
 * ```
 *
 * When evaluating the referenced fragment, `$public` will be overridden with
 * `'Bar'`. The value of `$variable` will become the value of `$source` in the
 * outer scope. This is analagous to:
 *
 * ```
 * function inner(private = 'foo', public = 'bar', variable) {}
 * function outer(source) {
 *   inner(public = 'BAR', variable = source);
 * }
 * ```
 *
 * Where the value of the inner `variable` depends on how `outer` is called.
 *
 * The `prepareVariables` function allows for variables to be modified based on
 * the runtime environment or route name.
 */
var RelayFragmentReference = function () {
  RelayFragmentReference.createForContainer = function createForContainer(fragmentGetter, initialVariables, variableMapping, prepareVariables) {
    var reference = new RelayFragmentReference(fragmentGetter, initialVariables, variableMapping, prepareVariables);
    reference._isContainerFragment = true;
    return reference;
  };

  function RelayFragmentReference(fragmentGetter, initialVariables, variableMapping, prepareVariables) {
    (0, _classCallCheck3['default'])(this, RelayFragmentReference);

    this._conditions = null;
    this._initialVariables = initialVariables || {};
    this._fragment = undefined;
    this._fragmentGetter = fragmentGetter;
    this._isContainerFragment = false;
    this._isDeferred = false;
    this._isTypeConditional = false;
    this._variableMapping = variableMapping;
    this._prepareVariables = prepareVariables;
  }

  RelayFragmentReference.prototype.conditionOnType = function conditionOnType() {
    this._isTypeConditional = true;
    return this;
  };

  RelayFragmentReference.prototype.getConditions = function getConditions() {
    return this._conditions;
  };

  RelayFragmentReference.prototype.getFragmentUnconditional = function getFragmentUnconditional() {
    var fragment = this._fragment;
    if (fragment == null) {
      fragment = this._fragmentGetter();
      this._fragment = fragment;
    }
    return fragment;
  };

  RelayFragmentReference.prototype.getInitialVariables = function getInitialVariables() {
    return this._initialVariables;
  };

  RelayFragmentReference.prototype.getVariableMapping = function getVariableMapping() {
    return this._variableMapping;
  };

  /**
   * Mark this usage of the fragment as deferred.
   */


  RelayFragmentReference.prototype.defer = function defer() {
    this._isDeferred = true;
    return this;
  };

  /**
   * Mark this fragment for inclusion only if the given variable is truthy.
   */


  RelayFragmentReference.prototype['if'] = function _if(value) {
    var callVariable = QueryBuilder.getCallVariable(value);
    !callVariable ?  false ? invariant(false, 'RelayFragmentReference: Invalid value `%s` supplied to `if()`. ' + 'Expected a variable.', callVariable) : invariant(false) : void 0;
    this._addCondition({
      passingValue: true,
      variable: callVariable.callVariableName
    });
    return this;
  };

  /**
   * Mark this fragment for inclusion only if the given variable is falsy.
   */


  RelayFragmentReference.prototype.unless = function unless(value) {
    var callVariable = QueryBuilder.getCallVariable(value);
    !callVariable ?  false ? invariant(false, 'RelayFragmentReference: Invalid value `%s` supplied to `unless()`. ' + 'Expected a variable.', callVariable) : invariant(false) : void 0;
    this._addCondition({
      passingValue: false,
      variable: callVariable.callVariableName
    });
    return this;
  };

  /**
   * Get the referenced fragment if all conditions are met.
   */


  RelayFragmentReference.prototype.getFragment = function getFragment(variables) {
    // determine if the variables match the supplied if/unless conditions
    var conditions = this._conditions;
    if (conditions && !conditions.every(function (_ref) {
      var variable = _ref.variable,
          passingValue = _ref.passingValue;

      return !!variables[variable] === passingValue;
    })) {
      return null;
    }
    return this.getFragmentUnconditional();
  };

  /**
   * Get the variables to pass to the referenced fragment, accounting for
   * initial values, overrides, and route-specific variables.
   */


  RelayFragmentReference.prototype.getVariables = function getVariables(route, variables) {
    var _this = this;

    var innerVariables = (0, _extends3['default'])({}, this._initialVariables);

    // map variables from outer -> inner scope
    var variableMapping = this._variableMapping;
    if (variableMapping) {
      forEachObject(variableMapping, function (value, name) {
        var callVariable = QueryBuilder.getCallVariable(value);
        if (callVariable) {
          value = variables[callVariable.callVariableName];
        }
        if (value === undefined) {
           false ? warning(false, 'RelayFragmentReference: Variable `%s` is undefined in fragment ' + '`%s`.', name, _this.getFragmentUnconditional().name) : void 0;
        } else {
          innerVariables[name] = value;
        }
      });
    }

    var prepareVariables = this._prepareVariables;
    if (prepareVariables) {
      innerVariables = prepareVariables(innerVariables, route);
    }

    return innerVariables;
  };

  RelayFragmentReference.prototype.isContainerFragment = function isContainerFragment() {
    return this._isContainerFragment;
  };

  RelayFragmentReference.prototype.isDeferred = function isDeferred() {
    return this._isDeferred;
  };

  RelayFragmentReference.prototype.isTypeConditional = function isTypeConditional() {
    return this._isTypeConditional;
  };

  RelayFragmentReference.prototype._addCondition = function _addCondition(condition) {
    var conditions = this._conditions;
    if (!conditions) {
      conditions = [];
      this._conditions = conditions;
    }
    conditions.push(condition);
  };

  return RelayFragmentReference;
}();

module.exports = RelayFragmentReference;

/***/ }),
/* 4089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RelayMetaRoute
 * 
 */



/**
 * Meta route based on the real route; provides access to the route name in
 * queries.
 */

var _classCallCheck2 = __webpack_require__(344);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var RelayMetaRoute = function () {
  function RelayMetaRoute(name) {
    (0, _classCallCheck3['default'])(this, RelayMetaRoute);

    Object.defineProperty(this, 'name', {
      enumerable: true,
      value: name,
      writable: false
    });
  }

  RelayMetaRoute.get = function get(name) {
    return cache[name] || (cache[name] = new RelayMetaRoute(name));
  };

  return RelayMetaRoute;
}();

var cache = {};

module.exports = RelayMetaRoute;

/***/ }),
/* 4090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RelayNodeInterface
 */



module.exports = __webpack_require__(4092);

/***/ }),
/* 4091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RelayOSSConnectionInterface
 * 
 */



var _defineProperty2 = __webpack_require__(353);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CLIENT_MUTATION_ID = 'clientMutationId';
var CONNECTION_CALLS = {
  'after': true,
  'before': true,
  'find': true,
  'first': true,
  'last': true,
  'surrounds': true
};
var CURSOR = 'cursor';
var EDGES = 'edges';
var END_CURSOR = 'endCursor';
var HAS_NEXT_PAGE = 'hasNextPage';
var HAS_PREV_PAGE = 'hasPreviousPage';
var NODE = 'node';
var PAGE_INFO = 'pageInfo';
var PAGE_INFO_TYPE = 'PageInfo';
var REQUIRED_RANGE_CALLS = {
  'find': true,
  'first': true,
  'last': true
};
var START_CURSOR = 'startCursor';

/**
 * @internal
 *
 * Defines logic relevant to the informal "Connection" GraphQL interface.
 */
var RelayOSSConnectionInterface = {
  CLIENT_MUTATION_ID: CLIENT_MUTATION_ID,
  CURSOR: CURSOR,
  EDGES: EDGES,
  END_CURSOR: END_CURSOR,
  HAS_NEXT_PAGE: HAS_NEXT_PAGE,
  HAS_PREV_PAGE: HAS_PREV_PAGE,
  NODE: NODE,
  PAGE_INFO: PAGE_INFO,
  PAGE_INFO_TYPE: PAGE_INFO_TYPE,
  START_CURSOR: START_CURSOR,

  /**
   * Whether `edges` fields are expected to have `source` fields.
   */
  EDGES_HAVE_SOURCE_FIELD: false,

  /**
   * Checks whether a call exists strictly to encode which parts of a connection
   * to fetch. Fields that only differ by connection call values should have the
   * same identity.
   */
  isConnectionCall: function isConnectionCall(call) {
    return CONNECTION_CALLS.hasOwnProperty(call.name);
  },


  /**
   * Checks whether a set of calls on a connection supply enough information to
   * fetch the range fields (i.e. `edges` and `page_info`).
   */
  hasRangeCalls: function hasRangeCalls(calls) {
    return calls.some(function (call) {
      return REQUIRED_RANGE_CALLS.hasOwnProperty(call.name);
    });
  },


  /**
   * Gets a default record representing a connection's `PAGE_INFO`.
   */
  getDefaultPageInfo: function getDefaultPageInfo() {
    var _ref;

    return _ref = {}, (0, _defineProperty3['default'])(_ref, END_CURSOR, undefined), (0, _defineProperty3['default'])(_ref, HAS_NEXT_PAGE, false), (0, _defineProperty3['default'])(_ref, HAS_PREV_PAGE, false), (0, _defineProperty3['default'])(_ref, START_CURSOR, undefined), _ref;
  }
};

module.exports = RelayOSSConnectionInterface;

/***/ }),
/* 4092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RelayOSSNodeInterface
 * 
 */



var forEachRootCallArg = __webpack_require__(4100);
var invariant = __webpack_require__(512);

/**
 * @internal
 *
 * Defines logic relevant to the informal "Node" GraphQL interface.
 */
var RelayOSSNodeInterface = {
  ANY_TYPE: '__any',
  ID: 'id',
  ID_TYPE: 'ID!',
  NODE: 'node',
  NODE_TYPE: 'Node',
  NODES: 'nodes',
  TYPENAME: '__typename',

  isNodeRootCall: function isNodeRootCall(fieldName) {
    return fieldName === RelayOSSNodeInterface.NODE || fieldName === RelayOSSNodeInterface.NODES;
  },
  getResultsFromPayload: function getResultsFromPayload(query, payload) {
    var results = [];

    var rootBatchCall = query.getBatchCall();
    if (rootBatchCall) {
      getPayloadRecords(query, payload).forEach(function (result) {
        if (typeof result !== 'object' || !result) {
          return;
        }
        var dataID = result[RelayOSSNodeInterface.ID];
        !(typeof dataID === 'string') ?  false ? invariant(false, 'RelayOSSNodeInterface.getResultsFromPayload(): Unable to write ' + 'result with no `%s` field for query, `%s`.', RelayOSSNodeInterface.ID, query.getName()) : invariant(false) : void 0;
        results.push({
          result: result,
          rootCallInfo: {
            storageKey: RelayOSSNodeInterface.NODE,
            identifyingArgKey: dataID,
            identifyingArgValue: dataID
          }
        });
      });
    } else {
      var records = getPayloadRecords(query, payload);
      var ii = 0;
      var _storageKey = query.getStorageKey();
      forEachRootCallArg(query, function (_ref) {
        var identifyingArgKey = _ref.identifyingArgKey,
            identifyingArgValue = _ref.identifyingArgValue;

        var result = records[ii++];
        results.push({
          result: result,
          rootCallInfo: { storageKey: _storageKey, identifyingArgKey: identifyingArgKey, identifyingArgValue: identifyingArgValue }
        });
      });
    }

    return results;
  }
};

function getPayloadRecords(query, payload) {
  var fieldName = query.getFieldName();
  var identifyingArg = query.getIdentifyingArg();
  var identifyingArgValue = identifyingArg && identifyingArg.value || null;
  var records = payload[fieldName];
  if (!query.getBatchCall()) {
    if (Array.isArray(identifyingArgValue)) {
      !Array.isArray(records) ?  false ? invariant(false, 'RelayOSSNodeInterface: Expected payload for root field `%s` to be ' + 'an array with %s results, instead received a single non-array result.', fieldName, identifyingArgValue.length) : invariant(false) : void 0;
      !(records.length === identifyingArgValue.length) ?  false ? invariant(false, 'RelayOSSNodeInterface: Expected payload for root field `%s` to be ' + 'an array with %s results, instead received an array with %s results.', fieldName, identifyingArgValue.length, records.length) : invariant(false) : void 0;
    } else if (Array.isArray(records)) {
       true ?  false ? invariant(false, 'RelayOSSNodeInterface: Expected payload for root field `%s` to be ' + 'a single non-array result, instead received an array with %s results.', fieldName, records.length) : invariant(false) : void 0;
    }
  }
  return Array.isArray(records) ? records : [records || null];
}

module.exports = RelayOSSNodeInterface;

/***/ }),
/* 4093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RelayProfiler
 * 
 */



var emptyFunction = __webpack_require__(1976);
var forEachObject = __webpack_require__(2120);
var removeFromArray = __webpack_require__(3221);

var aggregateHandlersByName = {
  '*': []
};
var profileHandlersByName = {
  '*': []
};

var NOT_INVOKED = {};
var defaultProfiler = { stop: emptyFunction };
var shouldInstrument = function shouldInstrument(name) {
  if (false) {
    return true;
  }
  return name.charAt(0) !== '@';
};

/**
 * @public
 *
 * Instruments methods to allow profiling various parts of Relay. Profiling code
 * in Relay consists of three steps:
 *
 *  - Instrument the function to be profiled.
 *  - Attach handlers to the instrumented function.
 *  - Run the code which triggers the handlers.
 *
 * Handlers attached to instrumented methods are called with an instrumentation
 * name and a callback that must be synchronously executed:
 *
 *   instrumentedMethod.attachHandler(function(name, callback) {
 *     const start = performance.now();
 *     callback();
 *     console.log('Duration', performance.now() - start);
 *   });
 *
 * Handlers for profiles are callbacks that return a stop method:
 *
 *   RelayProfiler.attachProfileHandler('profileName', (name, state) => {
 *     const start = performance.now();
 *     return function stop(name, state) {
 *       console.log(`Duration (${name})`, performance.now() - start);
 *     }
 *   });
 *
 * In order to reduce the impact on performance in production, instrumented
 * methods and profilers with names that begin with `@` will only be measured
 * if `__DEV__` is true. This should be used for very hot functions.
 */
var RelayProfiler = {

  /**
   * Instruments methods on a class or object. This re-assigns the method in
   * order to preserve function names in stack traces (which are detected by
   * modern debuggers via heuristics). Example usage:
   *
   *   const RelayStore = { primeCache: function() {...} };
   *   RelayProfiler.instrumentMethods(RelayStore, {
   *     primeCache: 'RelayStore.primeCache'
   *   });
   *
   *   RelayStore.primeCache.attachHandler(...);
   *
   * As a result, the methods will be replaced by wrappers that provide the
   * `attachHandler` and `detachHandler` methods.
   */
  instrumentMethods: function instrumentMethods(object, names) {
    forEachObject(names, function (name, key) {
      object[key] = RelayProfiler.instrument(name, object[key]);
    });
  },


  /**
   * Wraps the supplied function with one that provides the `attachHandler` and
   * `detachHandler` methods. Example usage:
   *
   *   const printRelayQuery =
   *     RelayProfiler.instrument('printRelayQuery', printRelayQuery);
   *
   *   printRelayQuery.attachHandler(...);
   *
   * NOTE: The instrumentation assumes that no handlers are attached or detached
   * in the course of executing another handler.
   */
  instrument: function instrument(name, originalFunction) {
    if (!shouldInstrument(name)) {
      originalFunction.attachHandler = emptyFunction;
      originalFunction.detachHandler = emptyFunction;
      return originalFunction;
    }
    if (!aggregateHandlersByName.hasOwnProperty(name)) {
      aggregateHandlersByName[name] = [];
    }
    var catchallHandlers = aggregateHandlersByName['*'];
    var aggregateHandlers = aggregateHandlersByName[name];
    var handlers = [];
    var contexts = [];
    var invokeHandlers = function invokeHandlers() {
      var context = contexts[contexts.length - 1];
      if (context[0]) {
        context[0]--;
        catchallHandlers[context[0]](name, invokeHandlers);
      } else if (context[1]) {
        context[1]--;
        aggregateHandlers[context[1]](name, invokeHandlers);
      } else if (context[2]) {
        context[2]--;
        handlers[context[2]](name, invokeHandlers);
      } else {
        context[5] = originalFunction.apply(context[3], context[4]);
      }
    };
    var instrumentedCallback = function instrumentedCallback() {
      var returnValue = void 0;
      if (aggregateHandlers.length === 0 && handlers.length === 0 && catchallHandlers.length === 0) {
        returnValue = originalFunction.apply(this, arguments);
      } else {
        contexts.push([catchallHandlers.length, aggregateHandlers.length, handlers.length, this, arguments, NOT_INVOKED]);
        invokeHandlers();
        var context = contexts.pop();
        returnValue = context[5];
        if (returnValue === NOT_INVOKED) {
          throw new Error('RelayProfiler: Handler did not invoke original function.');
        }
      }
      return returnValue;
    };
    instrumentedCallback.attachHandler = function (handler) {
      handlers.push(handler);
    };
    instrumentedCallback.detachHandler = function (handler) {
      removeFromArray(handlers, handler);
    };
    instrumentedCallback.displayName = '(instrumented ' + name + ')';
    return instrumentedCallback;
  },


  /**
   * Attaches a handler to all methods instrumented with the supplied name.
   *
   *   function createRenderer() {
   *     return RelayProfiler.instrument('render', function() {...});
   *   }
   *   const renderA = createRenderer();
   *   const renderB = createRenderer();
   *
   *   // Only profiles `renderA`.
   *   renderA.attachHandler(...);
   *
   *   // Profiles both `renderA` and `renderB`.
   *   RelayProfiler.attachAggregateHandler('render', ...);
   *
   */
  attachAggregateHandler: function attachAggregateHandler(name, handler) {
    if (shouldInstrument(name)) {
      if (!aggregateHandlersByName.hasOwnProperty(name)) {
        aggregateHandlersByName[name] = [];
      }
      aggregateHandlersByName[name].push(handler);
    }
  },


  /**
   * Detaches a handler attached via `attachAggregateHandler`.
   */
  detachAggregateHandler: function detachAggregateHandler(name, handler) {
    if (shouldInstrument(name)) {
      if (aggregateHandlersByName.hasOwnProperty(name)) {
        removeFromArray(aggregateHandlersByName[name], handler);
      }
    }
  },


  /**
   * Instruments profiling for arbitrarily asynchronous code by a name.
   *
   *   const timerProfiler = RelayProfiler.profile('timeout');
   *   setTimeout(function() {
   *     timerProfiler.stop();
   *   }, 1000);
   *
   *   RelayProfiler.attachProfileHandler('timeout', ...);
   *
   * Arbitrary state can also be passed into `profile` as a second argument. The
   * attached profile handlers will receive this as the second argument.
   */
  profile: function profile(name, state) {
    var hasCatchAllHandlers = profileHandlersByName['*'].length > 0;
    var hasNamedHandlers = profileHandlersByName.hasOwnProperty(name);
    if (hasNamedHandlers || hasCatchAllHandlers) {
      var profileHandlers = hasNamedHandlers && hasCatchAllHandlers ? profileHandlersByName[name].concat(profileHandlersByName['*']) : hasNamedHandlers ? profileHandlersByName[name] : profileHandlersByName['*'];
      var stopHandlers = void 0;
      for (var ii = profileHandlers.length - 1; ii >= 0; ii--) {
        var profileHandler = profileHandlers[ii];
        var stopHandler = profileHandler(name, state);
        stopHandlers = stopHandlers || [];
        stopHandlers.unshift(stopHandler);
      }
      return {
        stop: function stop() {
          if (stopHandlers) {
            stopHandlers.forEach(function (stopHandler) {
              return stopHandler();
            });
          }
        }
      };
    }
    return defaultProfiler;
  },


  /**
   * Attaches a handler to profiles with the supplied name. You can also
   * attach to the special name '*' which is a catch all.
   */
  attachProfileHandler: function attachProfileHandler(name, handler) {
    if (shouldInstrument(name)) {
      if (!profileHandlersByName.hasOwnProperty(name)) {
        profileHandlersByName[name] = [];
      }
      profileHandlersByName[name].push(handler);
    }
  },


  /**
   * Detaches a handler attached via `attachProfileHandler`.
   */
  detachProfileHandler: function detachProfileHandler(name, handler) {
    if (shouldInstrument(name)) {
      if (profileHandlersByName.hasOwnProperty(name)) {
        removeFromArray(profileHandlersByName[name], handler);
      }
    }
  }
};

module.exports = RelayProfiler;

/***/ }),
/* 4094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RelayQuery
 * 
 */



/* eslint-disable consistent-this */

var _extends2 = __webpack_require__(514);

var _extends3 = _interopRequireDefault(_extends2);

var _possibleConstructorReturn2 = __webpack_require__(349);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(348);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classCallCheck2 = __webpack_require__(344);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _freeze = __webpack_require__(2318);

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var QueryBuilder = __webpack_require__(1425);
var RelayConnectionInterface = __webpack_require__(4087);
var RelayFragmentReference = __webpack_require__(4088);
var RelayMetaRoute = __webpack_require__(4089);
var RelayProfiler = __webpack_require__(4093);
var RelayRouteFragment = __webpack_require__(4095);
var RelayVariable = __webpack_require__(4096);
var RelayVariables = __webpack_require__(4097);

var areEqual = __webpack_require__(3217);
var callsFromGraphQL = __webpack_require__(4098);
var callsToGraphQL = __webpack_require__(2273);
var directivesToGraphQL = __webpack_require__(4099);
var generateConcreteFragmentID = __webpack_require__(1946);
var generateRQLFieldAlias = __webpack_require__(4101);
var invariant = __webpack_require__(512);
var nullthrows = __webpack_require__(3220);
var serializeRelayQueryCall = __webpack_require__(4102);
var shallowEqual = __webpack_require__(1588);
var stableStringify = __webpack_require__(2274);
// TODO: replace once #6525923 is resolved


// conditional field calls/values
var IF = 'if';
var UNLESS = 'unless';
var TRUE = 'true';
var FALSE = 'false';
var SKIP = 'skip';
var INCLUDE = 'include';

var _nextQueryID = 0;

var DEFAULT_FRAGMENT_METADATA = {
  isDeferred: false,
  isContainerFragment: false,
  isTypeConditional: false
};
var EMPTY_DIRECTIVES = [];
var EMPTY_CALLS = [];

if (false) {
  (0, _freeze2['default'])(EMPTY_CALLS);
  (0, _freeze2['default'])(EMPTY_DIRECTIVES);
}

/**
 * A type representing information about the root node:
 * - routeName: The name of the route
 * - variables: The variables in scope at the root.
 *
 * This allows route variables to passed down the tree and accessed by arbitrary
 * fragments.
 */

/**
 * @internal
 *
 * Queries in Relay are represented as trees. Possible nodes include the root,
 * fields, and fragments. Fields can have children, or they can be leaf nodes.
 * Root and fragment nodes must always have children.
 *
 * `RelayQueryNode` provides access to information such as the field name,
 * generated alias, sub-fields, and call values.
 *
 * Nodes are immutable; query modification is supported via `clone`:
 *
 * ```
 * var next = prev.clone(prev.getChildren().filter(f => ...));
 * ```
 *
 * Note: Mediating access to actual query nodes is necessary so that we can
 * replace the current mutable GraphQL nodes with an immutable query
 * representation. This class *must not* mutate the underlying `concreteNode`.
 * Instead, use an instance variable (see `clone()`).
 *
 * TODO (#6937314): RelayQueryNode support for toJSON/fromJSON
 */
var RelayQueryNode = function () {
  // for flow
  RelayQueryNode.create = function create(concreteNode, metaRoute, variables) {
    var rootContext = createRootContext(metaRoute, variables);
    var node = createNode(concreteNode, rootContext, variables);
    !(node instanceof RelayQueryNode) ?  false ? invariant(false, 'RelayQueryNode.create(): ' + 'Expected a GraphQL fragment, mutation, or query.') : invariant(false) : void 0;
    return node;
  };

  /**
   * @private
   *
   * Base class for all node types, must not be directly instantiated.
   */


  function RelayQueryNode(concreteNode, rootContext, variables) {
    (0, _classCallCheck3['default'])(this, RelayQueryNode);

    !(this.constructor.name !== 'RelayQueryNode') ?  false ? invariant(false, 'RelayQueryNode: Abstract class cannot be instantiated.') : invariant(false) : void 0;
    this.__concreteNode__ = concreteNode;
    this.__root__ = rootContext;
    this.__variables__ = variables;

    // lazily computed properties
    this.__calls__ = null;
    this.__children__ = null;
    this.__fieldMap__ = null;
    this.__hasDeferredDescendant__ = null;
    this.__hasValidatedConnectionCalls__ = null;
    this.__serializationKey__ = null;
    this.__storageKey__ = null;
  }

  RelayQueryNode.prototype.canHaveSubselections = function canHaveSubselections() {
    return true;
  };

  RelayQueryNode.prototype.isGenerated = function isGenerated() {
    return false;
  };

  RelayQueryNode.prototype.isRefQueryDependency = function isRefQueryDependency() {
    return false;
  };

  RelayQueryNode.prototype.clone = function clone(children) {
    if (!this.canHaveSubselections()) {
      // Compact new children *after* this check, for consistency.
      !(children.length === 0) ?  false ? invariant(false, 'RelayQueryNode: Cannot add children to field `%s` because it does ' + 'not support sub-selections (sub-fields).', this instanceof RelayQueryField ? this.getSchemaName() : null) : invariant(false) : void 0;
      return this;
    }

    var prevChildren = this.getChildren();
    var nextChildren = cloneChildren(prevChildren, children);

    if (!nextChildren.length) {
      return null;
    } else if (nextChildren === prevChildren) {
      return this;
    }

    var clone = RelayQueryNode.create(this.__concreteNode__, RelayMetaRoute.get(this.__root__.routeName), this.__variables__);
    clone.__children__ = nextChildren;
    clone.__calls__ = this.__calls__;
    clone.__serializationKey__ = this.__serializationKey__;
    clone.__storageKey__ = this.__storageKey__;

    return clone;
  };

  RelayQueryNode.prototype.getChildren = function getChildren() {
    var _this = this;

    var children = this.__children__;
    if (!children) {
      var nextChildren = [];
      var concreteChildren = this.__concreteNode__.children;
      if (concreteChildren) {
        concreteChildren.forEach(function (concreteChild) {
          if (concreteChild == null) {
            return;
          }
          var nodeOrNodes = createNode(concreteChild, _this.__root__, _this.__variables__);
          if (Array.isArray(nodeOrNodes)) {
            nodeOrNodes.forEach(function (node) {
              if (node && node.isIncluded()) {
                nextChildren.push(node);
              }
            });
          } else if (nodeOrNodes && nodeOrNodes.isIncluded()) {
            nextChildren.push(nodeOrNodes);
          }
        });
      }
      this.__children__ = nextChildren;
      children = nextChildren;
    }
    return children;
  };

  RelayQueryNode.prototype.isIncluded = function isIncluded() {
    // Bail out early since most nodes won't have directives
    if (!this.__concreteNode__.directives) {
      return true;
    }
    return this.getDirectives().every(function (directive) {
      if (directive.name === SKIP) {
        return !directive.args.some(function (arg) {
          return arg.name === IF && !!arg.value;
        });
      } else if (directive.name === INCLUDE) {
        return !directive.args.some(function (arg) {
          return arg.name === IF && !arg.value;
        });
      }
      return true;
    });
  };

  RelayQueryNode.prototype.getDirectives = function getDirectives() {
    var _this2 = this;

    var concreteDirectives = this.__concreteNode__.directives;
    if (concreteDirectives) {
      return this.__concreteNode__.directives.map(function (directive) {
        return {
          args: callsFromGraphQL(directive.args, _this2.__variables__),
          name: directive.name
        };
      });
    }
    return EMPTY_DIRECTIVES;
  };

  RelayQueryNode.prototype.getField = function getField(field) {
    return this.getFieldByStorageKey(field.getStorageKey());
  };

  RelayQueryNode.prototype.getFieldByStorageKey = function getFieldByStorageKey(storageKey) {
    var fieldMap = this.__fieldMap__;
    if (!fieldMap) {
      fieldMap = {};
      var children = this.getChildren();
      for (var ii = 0; ii < children.length; ii++) {
        var child = children[ii];
        if (child instanceof RelayQueryField) {
          fieldMap[child.getStorageKey()] = child;
        }
      }
      this.__fieldMap__ = fieldMap;
    }
    return fieldMap[storageKey];
  };

  RelayQueryNode.prototype.getType = function getType() {
    return this.__concreteNode__.type;
  };

  RelayQueryNode.prototype.getRoute = function getRoute() {
    return RelayMetaRoute.get(this.__root__.routeName);
  };

  RelayQueryNode.prototype.getVariables = function getVariables() {
    return this.__variables__;
  };

  RelayQueryNode.prototype.hasDeferredDescendant = function hasDeferredDescendant() {
    var hasDeferredDescendant = this.__hasDeferredDescendant__;
    if (hasDeferredDescendant == null) {
      hasDeferredDescendant = this.canHaveSubselections() && this.getChildren().some(function (child) {
        return child.hasDeferredDescendant();
      });
      this.__hasDeferredDescendant__ = hasDeferredDescendant;
    }
    return hasDeferredDescendant;
  };

  RelayQueryNode.prototype.isAbstract = function isAbstract() {
    throw new Error('RelayQueryNode: Abstract function cannot be called.');
  };

  RelayQueryNode.prototype.isRequisite = function isRequisite() {
    return false;
  };

  /**
   * Determine if `this` and `that` are deeply equal.
   */


  RelayQueryNode.prototype.equals = function equals(that) {
    var thisChildren = this.getChildren();
    var thatChildren = that.getChildren();

    return thisChildren === thatChildren || thisChildren.length === thatChildren.length && thisChildren.every(function (c, ii) {
      return c.equals(thatChildren[ii]);
    });
  };

  /**
   * Performs a fast comparison of whether `this` and `that` represent identical
   * query nodes. Returns true only if the concrete nodes, routes, and variables
   * are all the same.
   *
   * Note that it is possible that this method can return false in cases where
   * `equals` would return true. This can happen when the concrete nodes are
   * different but structurally identical, or when the route/variables are
   * different but do not have an effect on the structure of the query.
   */


  RelayQueryNode.prototype.isEquivalent = function isEquivalent(that) {
    return this.__concreteNode__ === that.__concreteNode__ && this.__root__.routeName === that.__root__.routeName && shallowEqual(this.__root__.variables, that.__root__.variables) && shallowEqual(this.__variables__, that.__variables__);
  };

  RelayQueryNode.prototype.createNode = function createNode(concreteNode) {
    return RelayQueryNode.create(concreteNode, RelayMetaRoute.get(this.__root__.routeName), this.__variables__);
  };

  RelayQueryNode.prototype.getConcreteQueryNode = function getConcreteQueryNode() {
    return this.__concreteNode__;
  };

  return RelayQueryNode;
}();

/**
 * @internal
 *
 * Wraps access to query root nodes.
 */


var RelayQueryRoot = function (_RelayQueryNode) {
  (0, _inherits3['default'])(RelayQueryRoot, _RelayQueryNode);

  /**
   * Helper to construct a new root query with the given attributes and 'empty'
   * route/variables.
   */
  RelayQueryRoot.build = function build(name, fieldName, value, children, metadata, type, routeName) {
    var nextChildren = children ? children.filter(function (child) {
      return !!child;
    }) : [];
    var batchCallVariable = QueryBuilder.getBatchCallVariable(value);
    var identifyingArgValue = void 0;
    if (batchCallVariable) {
      identifyingArgValue = batchCallVariable;
    } else if (Array.isArray(value)) {
      identifyingArgValue = value.map(QueryBuilder.createCallValue);
    } else if (value) {
      identifyingArgValue = QueryBuilder.createCallValue(value);
    }
    var concreteRoot = QueryBuilder.createQuery({
      fieldName: fieldName,
      identifyingArgValue: identifyingArgValue,
      metadata: metadata,
      name: name,
      type: type
    });
    var variables = {};
    var metaRoute = RelayMetaRoute.get(routeName || '$RelayQuery');
    var rootContext = createRootContext(metaRoute, variables);
    var root = new RelayQueryRoot(concreteRoot, rootContext, variables);
    root.__children__ = nextChildren;
    return root;
  };

  RelayQueryRoot.create = function create(concreteNode, metaRoute, variables) {
    var query = QueryBuilder.getQuery(concreteNode);
    !query ?  false ? invariant(false, 'RelayQueryRoot.create(): Expected a GraphQL `query { ... }`, got: %s', concreteNode) : invariant(false) : void 0;
    var rootContext = createRootContext(metaRoute, variables);
    return new RelayQueryRoot(query, rootContext, variables);
  };

  function RelayQueryRoot(concreteNode, rootContext, variables) {
    (0, _classCallCheck3['default'])(this, RelayQueryRoot);

    var _this3 = (0, _possibleConstructorReturn3['default'])(this, _RelayQueryNode.call(this, concreteNode, rootContext, variables));

    _this3.__batchCall__ = undefined;
    _this3.__id__ = undefined;
    _this3.__identifyingArg__ = undefined;
    _this3.__storageKey__ = undefined;

    // Ensure IDs are generated in the order that queries are created
    _this3.getID();
    return _this3;
  }

  RelayQueryRoot.prototype.canHaveSubselections = function canHaveSubselections() {
    return true;
  };

  RelayQueryRoot.prototype.getName = function getName() {
    var name = this.__concreteNode__.name;
    if (!name) {
      name = this.getID();
      this.__concreteNode__.name = name;
    }
    return name;
  };

  RelayQueryRoot.prototype.getID = function getID() {
    var id = this.__id__;
    if (id == null) {
      id = 'q' + _nextQueryID++;
      this.__id__ = id;
    }
    return id;
  };

  RelayQueryRoot.prototype.getBatchCall = function getBatchCall() {
    var batchCall = this.__batchCall__;
    if (batchCall === undefined) {
      var concreteCalls = this.__concreteNode__.calls;
      if (concreteCalls) {
        var callArg = concreteCalls[0] && concreteCalls[0].value;
        if (callArg != null && !Array.isArray(callArg) && callArg.kind === 'BatchCallVariable') {
          batchCall = {
            refParamName: 'ref_' + callArg.sourceQueryID,
            sourceQueryID: callArg.sourceQueryID,
            sourceQueryPath: callArg.jsonPath
          };
        }
      }
      batchCall = batchCall || null;
      this.__batchCall__ = batchCall;
    }
    return batchCall;
  };

  RelayQueryRoot.prototype.getCallsWithValues = function getCallsWithValues() {
    var calls = this.__calls__;
    if (!calls) {
      var concreteCalls = this.__concreteNode__.calls;
      if (concreteCalls) {
        calls = callsFromGraphQL(concreteCalls, this.__variables__);
      } else {
        calls = EMPTY_CALLS;
      }
      this.__calls__ = calls;
    }
    return calls;
  };

  RelayQueryRoot.prototype.getFieldName = function getFieldName() {
    return this.__concreteNode__.fieldName;
  };

  RelayQueryRoot.prototype.getIdentifyingArg = function getIdentifyingArg() {
    var identifyingArg = this.__identifyingArg__;
    if (!identifyingArg) {
      var metadata = this.__concreteNode__.metadata;
      var identifyingArgName = metadata.identifyingArgName;
      if (identifyingArgName != null) {
        identifyingArg = this.getCallsWithValues().find(function (c) {
          return c.name === identifyingArgName;
        });
        if (identifyingArg && metadata.identifyingArgType != null) {
          identifyingArg.type = metadata.identifyingArgType;
        }
        this.__identifyingArg__ = identifyingArg;
      }
    }
    return identifyingArg;
  };

  RelayQueryRoot.prototype.getStorageKey = function getStorageKey() {
    var storageKey = this.__storageKey__;
    if (!storageKey) {
      var args = this.getCallsWithValues();
      var identifyingArg = this.getIdentifyingArg();
      if (identifyingArg) {
        args = args.filter(function (arg) {
          return arg !== identifyingArg;
        });
      }
      var field = RelayQueryField.build({
        fieldName: this.getFieldName(),
        calls: args,
        type: this.getType()
      });
      storageKey = field.getStorageKey();
      this.__storageKey__ = storageKey;
    }
    return storageKey;
  };

  RelayQueryRoot.prototype.hasDeferredDescendant = function hasDeferredDescendant() {
    return this.isDeferred() || _RelayQueryNode.prototype.hasDeferredDescendant.call(this);
  };

  RelayQueryRoot.prototype.isAbstract = function isAbstract() {
    return !!this.__concreteNode__.metadata.isAbstract;
  };

  RelayQueryRoot.prototype.isDeferred = function isDeferred() {
    return !!this.__concreteNode__.isDeferred;
  };

  RelayQueryRoot.prototype.isPlural = function isPlural() {
    return !!this.__concreteNode__.metadata.isPlural;
  };

  RelayQueryRoot.prototype.cloneWithRoute = function cloneWithRoute(children, metaRoute) {
    if (this.__root__.routeName === metaRoute.name) {
      return this.clone(children);
    }
    var clone = RelayQueryNode.create((0, _extends3['default'])({}, this.__concreteNode__, {
      name: metaRoute.name
    }), metaRoute, this.__variables__);
    clone.__children__ = children;
    return clone;
  };

  RelayQueryRoot.prototype.equals = function equals(that) {
    if (this === that) {
      return true;
    }
    if (!(that instanceof RelayQueryRoot)) {
      return false;
    }
    if (!areEqual(this.getBatchCall(), that.getBatchCall())) {
      return false;
    }
    if (this.getFieldName() !== that.getFieldName() || !areCallValuesEqual(this.getCallsWithValues(), that.getCallsWithValues())) {
      return false;
    }
    return _RelayQueryNode.prototype.equals.call(this, that);
  };

  return RelayQueryRoot;
}(RelayQueryNode);

/**
 * @internal
 *
 * Abstract base class for mutations and subscriptions.
 */


var RelayQueryOperation = function (_RelayQueryNode2) {
  (0, _inherits3['default'])(RelayQueryOperation, _RelayQueryNode2);

  function RelayQueryOperation(concreteNode, rootContext, variables) {
    (0, _classCallCheck3['default'])(this, RelayQueryOperation);

    var _this4 = (0, _possibleConstructorReturn3['default'])(this, _RelayQueryNode2.call(this, concreteNode, rootContext, variables));

    !(_this4.constructor.name !== 'RelayQueryOperation') ?  false ? invariant(false, 'RelayQueryOperation: Abstract class cannot be instantiated.') : invariant(false) : void 0;
    return _this4;
  }

  RelayQueryOperation.prototype.canHaveSubselections = function canHaveSubselections() {
    return true;
  };

  RelayQueryOperation.prototype.getName = function getName() {
    return this.__concreteNode__.name;
  };

  RelayQueryOperation.prototype.getResponseType = function getResponseType() {
    return this.__concreteNode__.responseType;
  };

  RelayQueryOperation.prototype.getType = function getType() {
    return this.getResponseType();
  };

  RelayQueryOperation.prototype.getInputType = function getInputType() {
    var inputType = this.__concreteNode__.metadata.inputType;
    !inputType ?  false ? invariant(false, 'RelayQuery: Expected operation `%s` to be annotated with the type of ' + 'its argument. Either the babel transform was configured incorrectly, ' + 'or the schema failed to define an argument for this mutation.', this.getCall().name) : invariant(false) : void 0;
    return inputType;
  };

  RelayQueryOperation.prototype.getCall = function getCall() {
    var calls = this.__calls__;
    if (!calls) {
      var concreteCalls = this.__concreteNode__.calls;
      if (concreteCalls) {
        calls = callsFromGraphQL(concreteCalls, this.__variables__);
      } else {
        calls = EMPTY_CALLS;
      }
      this.__calls__ = calls;
    }
    return calls[0];
  };

  RelayQueryOperation.prototype.getCallVariableName = function getCallVariableName() {
    if (!this.__callVariableName__) {
      var concreteCalls = this.__concreteNode__.calls;
      var callVariable = concreteCalls && QueryBuilder.getCallVariable(concreteCalls[0].value);
      !callVariable ?  false ? invariant(false, 'RelayQuery: Expected mutation to have a single argument.') : invariant(false) : void 0;
      this.__callVariableName__ = callVariable.callVariableName;
    }
    return this.__callVariableName__;
  };

  /**
   * Mutations and subscriptions must have a concrete type due to the need for
   * requisite top-level fields.
   */


  RelayQueryOperation.prototype.isAbstract = function isAbstract() {
    return false;
  };

  return RelayQueryOperation;
}(RelayQueryNode);

/**
 * @internal
 *
 * Represents a GraphQL mutation.
 */


var RelayQueryMutation = function (_RelayQueryOperation) {
  (0, _inherits3['default'])(RelayQueryMutation, _RelayQueryOperation);

  function RelayQueryMutation() {
    (0, _classCallCheck3['default'])(this, RelayQueryMutation);
    return (0, _possibleConstructorReturn3['default'])(this, _RelayQueryOperation.apply(this, arguments));
  }

  /**
   * Helper to construct a new mutation with the given attributes and 'empty'
   * route/variables.
   */
  RelayQueryMutation.build = function build(name, responseType, callName, callValue, children, metadata, routeName) {
    var nextChildren = children ? children.filter(function (child) {
      return !!child;
    }) : [];
    var concreteMutation = QueryBuilder.createMutation({
      calls: [QueryBuilder.createCall(callName, QueryBuilder.createCallVariable('input'))],
      metadata: metadata,
      name: name,
      responseType: responseType
    });
    var variables = { input: callValue || '' };
    var metaRoute = RelayMetaRoute.get(routeName || '$RelayQuery');
    var rootContext = createRootContext(metaRoute, variables);
    var mutation = new RelayQueryMutation(concreteMutation, rootContext, variables);
    mutation.__children__ = nextChildren;
    return mutation;
  };

  RelayQueryMutation.prototype.equals = function equals(that) {
    if (this === that) {
      return true;
    }
    if (!(that instanceof RelayQueryMutation)) {
      return false;
    }
    if (!areEqual(this.getResponseType(), that.getResponseType())) {
      return false;
    }
    if (!areEqual(this.getCall(), that.getCall())) {
      return false;
    }
    return _RelayQueryOperation.prototype.equals.call(this, that);
  };

  return RelayQueryMutation;
}(RelayQueryOperation);

/**
 * @internal
 *
 * Represents a GraphQL subscription.
 */


var RelayQuerySubscription = function (_RelayQueryOperation2) {
  (0, _inherits3['default'])(RelayQuerySubscription, _RelayQueryOperation2);

  function RelayQuerySubscription() {
    (0, _classCallCheck3['default'])(this, RelayQuerySubscription);
    return (0, _possibleConstructorReturn3['default'])(this, _RelayQueryOperation2.apply(this, arguments));
  }

  RelayQuerySubscription.create = function create(concreteNode, metaRoute, variables) {
    var subscription = QueryBuilder.getSubscription(concreteNode);
    !subscription ?  false ? invariant(false, 'RelayQuerySubscription.create(): ' + 'Expected a GraphQL `subscription { ... }`, got: %s', concreteNode) : invariant(false) : void 0;
    var rootContext = createRootContext(metaRoute, variables);
    return new RelayQuerySubscription(concreteNode, rootContext, variables);
  };

  RelayQuerySubscription.prototype.getPublishedPayloadType = function getPublishedPayloadType() {
    return this.getResponseType();
  };

  RelayQuerySubscription.prototype.equals = function equals(that) {
    if (this === that) {
      return true;
    }
    if (!(that instanceof RelayQuerySubscription)) {
      return false;
    }
    if (!areEqual(this.getPublishedPayloadType(), that.getPublishedPayloadType())) {
      return false;
    }
    if (!areEqual(this.getCall(), that.getCall())) {
      return false;
    }
    return _RelayQueryOperation2.prototype.equals.call(this, that);
  };

  return RelayQuerySubscription;
}(RelayQueryOperation);

/**
 * @internal
 *
 * Wraps access to query fragments.
 */


var RelayQueryFragment = function (_RelayQueryNode3) {
  (0, _inherits3['default'])(RelayQueryFragment, _RelayQueryNode3);

  /**
   * Helper to construct a new fragment with the given attributes and 'empty'
   * route/variables.
   */
  RelayQueryFragment.build = function build(name, type,
  /* $FlowIssue: #11220887
     `Array<Subclass-of-RelayQueryNode>` should be compatible here. */
  children, metadata, routeName) {
    var nextChildren = children ? children.filter(function (child) {
      return !!child;
    }) : [];
    // $FlowFixMe(>=0.34.0)
    var concreteFragment = QueryBuilder.createFragment({
      name: name,
      type: type,
      metadata: metadata
    });
    var variables = {};
    var metaRoute = RelayMetaRoute.get(routeName || '$RelayQuery');
    var rootContext = createRootContext(metaRoute, variables);
    var fragment = new RelayQueryFragment(concreteFragment, rootContext, variables, {
      isDeferred: !!(metadata && metadata.isDeferred),
      isContainerFragment: !!(metadata && metadata.isContainerFragment),
      isTypeConditional: !!(metadata && metadata.isTypeConditional)
    });
    fragment.__children__ = nextChildren;
    return fragment;
  };

  RelayQueryFragment.create = function create(concreteNode, metaRoute, variables, metadata) {
    var fragment = QueryBuilder.getFragment(concreteNode);
    !fragment ?  false ? invariant(false, 'RelayQueryFragment.create(): ' + 'Expected a GraphQL `fragment { ... }`, got: %s', concreteNode) : invariant(false) : void 0;
    var rootContext = createRootContext(metaRoute, variables);
    return createMemoizedFragment(fragment, rootContext, variables, metadata || DEFAULT_FRAGMENT_METADATA);
  };

  function RelayQueryFragment(concreteNode, rootContext, variables, metadata) {
    (0, _classCallCheck3['default'])(this, RelayQueryFragment);

    var _this7 = (0, _possibleConstructorReturn3['default'])(this, _RelayQueryNode3.call(this, concreteNode, rootContext, variables));

    _this7.__compositeHash__ = null;
    _this7.__metadata__ = metadata || DEFAULT_FRAGMENT_METADATA;
    _this7.__sourceCompositeHash__ = null;
    return _this7;
  }

  RelayQueryFragment.prototype.canHaveSubselections = function canHaveSubselections() {
    return true;
  };

  RelayQueryFragment.prototype.getDebugName = function getDebugName() {
    return this.__concreteNode__.name;
  };

  /**
   * The "concrete fragment id" uniquely identifies a Relay.QL`fragment ...`
   * within the source code of an application and will remain the same across
   * runs of a particular version of an application.
   */


  RelayQueryFragment.prototype.getConcreteFragmentID = function getConcreteFragmentID() {
    return this.__concreteNode__.id;
  };

  /**
   * The "composite hash" is similar to the concrete instance hash, but it also
   * differentiates between varying variable values or route names.
   *
   * The composite hash is used to:
   * - Avoid printing the same fragment twice, in order to reduce upload size.
   * - Remember which deferred fragment/data pairs have been fetched.
   */


  RelayQueryFragment.prototype.getCompositeHash = function getCompositeHash() {
    var compositeHash = this.__compositeHash__;
    if (!compositeHash) {
      // TODO: Simplify this hash function, #9599170.
      compositeHash = generateRQLFieldAlias(this.getConcreteFragmentID() + '.' + this.__root__.routeName + '.' + stableStringify(this.__variables__));
      this.__compositeHash__ = compositeHash;
    }
    return compositeHash;
  };

  RelayQueryFragment.prototype.getSourceCompositeHash = function getSourceCompositeHash() {
    return this.__sourceCompositeHash__;
  };

  RelayQueryFragment.prototype.isAbstract = function isAbstract() {
    return !!this.__concreteNode__.metadata.isAbstract;
  };

  RelayQueryFragment.prototype.isDeferred = function isDeferred() {
    return this.__metadata__.isDeferred;
  };

  RelayQueryFragment.prototype.isPattern = function isPattern() {
    return !!this.__concreteNode__.metadata.pattern;
  };

  RelayQueryFragment.prototype.isPlural = function isPlural() {
    var metadata = this.__concreteNode__.metadata;
    return !!( // FB Printer
    metadata.isPlural || metadata.plural);
  };

  RelayQueryFragment.prototype.isTrackingEnabled = function isTrackingEnabled() {
    var metadata = this.__concreteNode__.metadata;
    return !!metadata.isTrackingEnabled;
  };

  RelayQueryFragment.prototype.cloneAsPlainFragment = function cloneAsPlainFragment() {
    return createMemoizedFragment(this.__concreteNode__, this.__root__, this.__variables__, DEFAULT_FRAGMENT_METADATA);
  };

  RelayQueryFragment.prototype.isContainerFragment = function isContainerFragment() {
    return this.__metadata__.isContainerFragment;
  };

  RelayQueryFragment.prototype.isTypeConditional = function isTypeConditional() {
    return this.__metadata__.isTypeConditional;
  };

  RelayQueryFragment.prototype.hasDeferredDescendant = function hasDeferredDescendant() {
    return this.isDeferred() || _RelayQueryNode3.prototype.hasDeferredDescendant.call(this);
  };

  RelayQueryFragment.prototype.clone = function clone(children) {
    var clone = _RelayQueryNode3.prototype.clone.call(this, children);
    if (clone !== this && clone instanceof RelayQueryFragment) {
      clone.__concreteNode__ = (0, _extends3['default'])({}, clone.__concreteNode__, {
        id: generateConcreteFragmentID()
      });
      clone.__metadata__ = (0, _extends3['default'])({}, this.__metadata__);

      // The container checks on the status of a deferred fragment using its
      // composite hash. We need to cache this hash in this cloned fragment
      // so it can be updated in the store with the correct hash when fetched.
      clone.__sourceCompositeHash__ = this.getCompositeHash();
    }
    return clone;
  };

  RelayQueryFragment.prototype.equals = function equals(that) {
    if (this === that) {
      return true;
    }
    if (!(that instanceof RelayQueryFragment)) {
      return false;
    }
    if (this.getType() !== that.getType()) {
      return false;
    }
    return _RelayQueryNode3.prototype.equals.call(this, that);
  };

  return RelayQueryFragment;
}(RelayQueryNode);

/**
 * @internal
 *
 * Wraps access to query fields.
 */


var RelayQueryField = function (_RelayQueryNode4) {
  (0, _inherits3['default'])(RelayQueryField, _RelayQueryNode4);

  RelayQueryField.create = function create(concreteNode, metaRoute, variables) {
    var field = QueryBuilder.getField(concreteNode);
    !field ?  false ? invariant(false, 'RelayQueryField.create(): Expected a GraphQL field, got: %s', concreteNode) : invariant(false) : void 0;
    var rootContext = createRootContext(metaRoute, variables);
    return new RelayQueryField(field, rootContext, variables);
  };

  /**
   * Helper to construct a new field with the given attributes and 'empty'
   * route/variables.
   */


  RelayQueryField.build = function build(_ref) {
    var alias = _ref.alias,
        directives = _ref.directives,
        calls = _ref.calls,
        children = _ref.children,
        fieldName = _ref.fieldName,
        metadata = _ref.metadata,
        routeName = _ref.routeName,
        type = _ref.type;

    var nextChildren = children ? children.filter(function (child) {
      return !!child;
    }) : [];
    var concreteField = QueryBuilder.createField({
      alias: alias,
      calls: calls ? callsToGraphQL(calls) : null,
      directives: directives ? directivesToGraphQL(directives) : null,
      fieldName: fieldName,
      metadata: metadata,
      type: type
    });
    var variables = {};
    var metaRoute = RelayMetaRoute.get(routeName || '$RelayQuery');
    var rootContext = createRootContext(metaRoute, variables);
    var field = new RelayQueryField(concreteField, rootContext, variables);
    field.__children__ = nextChildren;
    return field;
  };

  function RelayQueryField(concreteNode, rootContext, variables) {
    (0, _classCallCheck3['default'])(this, RelayQueryField);

    var _this8 = (0, _possibleConstructorReturn3['default'])(this, _RelayQueryNode4.call(this, concreteNode, rootContext, variables));

    _this8.__debugName__ = undefined;
    _this8.__isRefQueryDependency__ = false;
    _this8.__rangeBehaviorCalls__ = undefined;
    _this8.__shallowHash__ = undefined;
    return _this8;
  }

  RelayQueryField.prototype.canHaveSubselections = function canHaveSubselections() {
    return !!this.__concreteNode__.metadata.canHaveSubselections;
  };

  RelayQueryField.prototype.isAbstract = function isAbstract() {
    return !!this.__concreteNode__.metadata.isAbstract;
  };

  RelayQueryField.prototype.isFindable = function isFindable() {
    return !!this.__concreteNode__.metadata.isFindable;
  };

  RelayQueryField.prototype.isGenerated = function isGenerated() {
    return !!this.__concreteNode__.metadata.isGenerated;
  };

  RelayQueryField.prototype.isConnection = function isConnection() {
    return !!this.__concreteNode__.metadata.isConnection;
  };

  RelayQueryField.prototype.isConnectionWithoutNodeID = function isConnectionWithoutNodeID() {
    return !!this.__concreteNode__.metadata.isConnectionWithoutNodeID;
  };

  RelayQueryField.prototype.isPlural = function isPlural() {
    return !!this.__concreteNode__.metadata.isPlural;
  };

  RelayQueryField.prototype.isRefQueryDependency = function isRefQueryDependency() {
    return this.__isRefQueryDependency__;
  };

  RelayQueryField.prototype.isRequisite = function isRequisite() {
    return !!this.__concreteNode__.metadata.isRequisite;
  };

  RelayQueryField.prototype.getDebugName = function getDebugName() {
    var _this9 = this;

    var debugName = this.__debugName__;
    if (!debugName) {
      debugName = this.getSchemaName();
      var printedCoreArgs = void 0;
      this.getCallsWithValues().forEach(function (arg) {
        if (_this9._isCoreArg(arg)) {
          printedCoreArgs = printedCoreArgs || [];
          printedCoreArgs.push(serializeRelayQueryCall(arg));
        }
      });
      if (printedCoreArgs) {
        debugName += printedCoreArgs.sort().join('');
      }
      this.__debugName__ = debugName;
    }
    return debugName;
  };

  /**
   * The canonical name for the referenced field in the schema.
   */


  RelayQueryField.prototype.getSchemaName = function getSchemaName() {
    return this.__concreteNode__.fieldName;
  };

  /**
  * An Array of Calls to be used with rangeBehavior config functions.
  *
  * Non-core arguments (like connection and identifying arguments) are dropped.
  *   `field(first: 10, foo: "bar", baz: "bat")` => `'baz(bat).foo(bar)'`
  *   `username(name: "steve")`                  => `''`
  */


  RelayQueryField.prototype.getRangeBehaviorCalls = function getRangeBehaviorCalls() {
    var _this10 = this;

    !this.isConnection() ?  false ? invariant(false, 'RelayQueryField: Range behavior keys are associated exclusively with ' + 'connection fields. `getRangeBehaviorCalls()` was called on the ' + 'non-connection field `%s`.', this.getSchemaName()) : invariant(false) : void 0;

    var rangeBehaviorCalls = this.__rangeBehaviorCalls__;
    if (!rangeBehaviorCalls) {
      rangeBehaviorCalls = this.getCallsWithValues().filter(function (arg) {
        return _this10._isCoreArg(arg);
      });
      this.__rangeBehaviorCalls__ = rangeBehaviorCalls;
    }
    return rangeBehaviorCalls;
  };

  /**
   * The name for the field when serializing the query or interpreting query
   * responses from the server. The serialization key is derived from
   * all calls/values and hashed for compactness.
   *
   * Given the GraphQL
   *   `field(first: 10, foo: "bar", baz: "bat")`, or
   *   `field(baz: "bat", foo: "bar", first: 10)`
   *
   * ...the following serialization key will be produced:
   *   `generateRQLFieldAlias('field.bar(bat).first(10).foo(bar)')`
   */


  RelayQueryField.prototype.getSerializationKey = function getSerializationKey() {
    var serializationKey = this.__serializationKey__;
    if (!serializationKey) {
      var _key = this.getSchemaName();
      var calls = this.getCallsWithValues();
      if (calls.length) {
        var alias = this.__concreteNode__.alias;
        if (alias != null) {
          _key += '.' + alias;
        }
        _key += calls.map(serializeRelayQueryCall).sort().join('');
      }
      serializationKey = generateRQLFieldAlias(_key);
      this.__serializationKey__ = serializationKey;
    }
    return serializationKey;
  };

  /**
   * Returns a hash of the field name and all argument values.
   */


  RelayQueryField.prototype.getShallowHash = function getShallowHash() {
    var shallowHash = this.__shallowHash__;
    if (!shallowHash) {
      this.__shallowHash__ = shallowHash = this.getSchemaName() + serializeCalls(this.getCallsWithValues());
    }
    return shallowHash;
  };

  /**
   * The name which Relay internals can use to reference this field, without
   * collisions.
   *
   * Given the GraphQL
   *   `field(first: 10, foo: "bar", baz: "bat")`, or
   *   `field(baz: "bat", foo: "bar", first: 10)`
   *
   * ...the following storage key will be produced:
   *   `'field{bar:"bat",foo:"bar"}'`
   */


  RelayQueryField.prototype.getStorageKey = function getStorageKey() {
    var _this11 = this;

    var storageKey = this.__storageKey__;
    if (!storageKey) {
      this.__storageKey__ = storageKey = this.getSchemaName() + serializeCalls(this.getCallsWithValues().filter(function (call) {
        return _this11._isCoreArg(call);
      }));
    }
    return storageKey;
  };

  /**
   * The name by which this field's results should be made available to the
   * application.
   */


  RelayQueryField.prototype.getApplicationName = function getApplicationName() {
    var concreteNode = this.__concreteNode__;
    return concreteNode.alias || concreteNode.fieldName;
  };

  RelayQueryField.prototype.getInferredRootCallName = function getInferredRootCallName() {
    return this.__concreteNode__.metadata.inferredRootCallName;
  };

  RelayQueryField.prototype.getInferredPrimaryKey = function getInferredPrimaryKey() {
    return this.__concreteNode__.metadata.inferredPrimaryKey;
  };

  RelayQueryField.prototype.getCallsWithValues = function getCallsWithValues() {
    var calls = this.__calls__;
    if (!calls) {
      var concreteCalls = this.__concreteNode__.calls;
      if (concreteCalls) {
        calls = callsFromGraphQL(concreteCalls, this.__variables__);
      } else {
        calls = EMPTY_CALLS;
      }
      this.__calls__ = calls;
    }
    return calls;
  };

  RelayQueryField.prototype.getCallType = function getCallType(callName) {
    var concreteCalls = this.__concreteNode__.calls;
    var concreteCall = concreteCalls && concreteCalls.filter(function (call) {
      return call.name === callName;
    })[0];
    if (concreteCall) {
      return concreteCall.metadata.type;
    }
  };

  RelayQueryField.prototype.equals = function equals(that) {
    if (this === that) {
      return true;
    }
    if (!(that instanceof RelayQueryField)) {
      return false;
    }
    if (this.getSchemaName() !== that.getSchemaName() || this.getApplicationName() !== that.getApplicationName() || !areCallValuesEqual(this.getCallsWithValues(), that.getCallsWithValues())) {
      return false;
    }
    return _RelayQueryNode4.prototype.equals.call(this, that);
  };

  RelayQueryField.prototype.cloneAsRefQueryDependency = function cloneAsRefQueryDependency() {
    var field = new RelayQueryField(this.__concreteNode__, this.__root__, this.__variables__);
    field.__children__ = [];
    field.__isRefQueryDependency__ = true;
    return field;
  };

  RelayQueryField.prototype.cloneFieldWithCalls = function cloneFieldWithCalls(children, calls) {
    if (!this.canHaveSubselections()) {
      // Compact new children *after* this check, for consistency.
      !(children.length === 0) ?  false ? invariant(false, 'RelayQueryNode: Cannot add children to field `%s` because it does ' + 'not support sub-selections (sub-fields).', this.getSchemaName()) : invariant(false) : void 0;
    }

    // use `clone()` if call values do not change
    if (areEqual(this.getCallsWithValues(), calls)) {
      var clone = this.clone(children);
      return clone;
    }

    var nextChildren = cloneChildren(this.getChildren(), children);
    if (!nextChildren.length) {
      return null;
    }

    var field = new RelayQueryField(this.__concreteNode__, this.__root__, this.__variables__);
    field.__children__ = nextChildren;
    field.__calls__ = calls;

    return field;
  };

  /**
   * The following types of arguments are non-core:
   * - Range calls such as `first` or `find` on connections.
   * - Conditionals when the field is present.
   */


  RelayQueryField.prototype._isCoreArg = function _isCoreArg(arg) {
    return (
      // `name(if:true)`, `name(unless:false)`, and `name` are equivalent.
      !(arg.name === IF && String(arg.value) === TRUE) && !(arg.name === UNLESS && String(arg.value) === FALSE) &&
      // Connection arguments can be stripped out.
      !(this.isConnection() && RelayConnectionInterface.isConnectionCall(arg))
    );
  };

  return RelayQueryField;
}(RelayQueryNode);

function createNode(concreteNode, rootContext, variables) {
  !(typeof concreteNode === 'object' && concreteNode !== null) ?  false ? invariant(false, 'RelayQueryNode: Expected a GraphQL object created with `Relay.QL`, got' + '`%s`.', concreteNode) : invariant(false) : void 0;
  var kind = concreteNode.kind;
  var type = RelayQueryNode;
  if (kind === 'Field') {
    type = RelayQueryField;
  } else if (kind === 'Fragment') {
    type = RelayQueryFragment;
  } else if (kind === 'FragmentReference') {
    // DEPRECATED in favor of ConcreteFragmentSpread
    // TODO #14985090: delete ConcreteFragmentReference and callers
    var fragment = QueryBuilder.getFragment(concreteNode.fragment);
    if (fragment) {
      return createMemoizedFragment(fragment, rootContext, {}, {
        isDeferred: false,
        isContainerFragment: true,
        isTypeConditional: false
      });
    }
    return null;
  } else if (kind === 'FragmentSpread') {
    var spread = nullthrows(QueryBuilder.getFragmentSpread(concreteNode));
    var argumentVariables = spread.args;
    var rootVariables = rootContext.variables;
    var fragmentVariables = RelayVariables.getFragmentVariables(spread.fragment, rootVariables, argumentVariables);
    return createMemoizedFragment(spread.fragment.node, rootContext, fragmentVariables, {
      isDeferred: false,
      isContainerFragment: true,
      isTypeConditional: false
    });
  } else if (kind === 'Query') {
    type = RelayQueryRoot;
  } else if (kind === 'Mutation') {
    type = RelayQueryMutation;
  } else if (kind === 'Subscription') {
    type = RelayQuerySubscription;
  } else if (concreteNode instanceof RelayRouteFragment) {
    var metaRoute = RelayMetaRoute.get(rootContext.routeName);
    var _fragment = concreteNode.getFragmentForRoute(metaRoute);
    // May be null if no value was defined for this route.
    if (Array.isArray(_fragment)) {
      // A route-conditional function may return a single fragment reference
      // or an array of fragment references.
      return _fragment.map(function (frag) {
        return createNode(frag, rootContext, variables);
      });
    } else if (_fragment) {
      return createNode(_fragment, rootContext, variables);
    }
    return null;
  } else if (concreteNode instanceof RelayFragmentReference) {
    var _fragment2 = concreteNode.getFragment(variables);
    var _metaRoute = RelayMetaRoute.get(rootContext.routeName);
    var _fragmentVariables = concreteNode.getVariables(_metaRoute, variables);
    if (_fragment2) {
      // the fragment may be null when `if` or `unless` conditions are not met.
      return createMemoizedFragment(_fragment2, rootContext, _fragmentVariables, {
        isDeferred: concreteNode.isDeferred(),
        isContainerFragment: concreteNode.isContainerFragment(),
        isTypeConditional: concreteNode.isTypeConditional()
      });
    }
    return null;
  } else {}
  return new type(concreteNode, rootContext, variables);
}

/**
 * Memoizes the `RelayQueryFragment` equivalent of a given GraphQL fragment
 * for the given route, variables, and deferred status.
 */
function createMemoizedFragment(concreteFragment, rootContext, variables, metadata) {
  var cacheKey = rootContext.routeName + ':' + stableStringify(variables) + ':' + stableStringify(metadata);
  var fragment = concreteFragment.__cachedFragment__;
  var fragmentCacheKey = concreteFragment.__cacheKey__;
  if (!fragment || fragmentCacheKey !== cacheKey) {
    fragment = new RelayQueryFragment(concreteFragment, rootContext, variables, metadata);
    concreteFragment.__cachedFragment__ = fragment;
    concreteFragment.__cacheKey__ = cacheKey;
  }
  return fragment;
}

/**
 * Compacts new children and compares them to the previous children.
 * - If all items are equal, returns previous array
 * - If any items differ, returns new array
 */
function cloneChildren(prevChildren, nextChildren) {
  var children = [];
  var isSameChildren = true;

  var prevIndex = 0;
  for (var ii = 0; ii < nextChildren.length; ii++) {
    var child = nextChildren[ii];
    if (child) {
      children.push(child);
      isSameChildren = isSameChildren && child === prevChildren[prevIndex++];
    }
  }

  if (isSameChildren && children.length === prevChildren.length) {
    return prevChildren;
  } else {
    return children;
  }
}

/**
 * Creates an opaque serialization of calls.
 */
function serializeCalls(calls) {
  if (calls.length) {
    var callMap = {};
    calls.forEach(function (call) {
      callMap[call.name] = call.value;
    });
    return stableStringify(callMap);
  } else {
    return '';
  }
}

/**
 * Checks if two sets of calls have equal names and values. This skips testing
 * argument types because type metadata for scalar arguments may be omitted by
 * the Babel plugin.
 */
function areCallValuesEqual(thisCalls, thatCalls) {
  if (thisCalls.length !== thatCalls.length) {
    return false;
  }
  return thisCalls.every(function (_ref2, ii) {
    var thisName = _ref2.name,
        thisValue = _ref2.value;
    var _thatCalls$ii = thatCalls[ii],
        thatName = _thatCalls$ii.name,
        thatValue = _thatCalls$ii.value;

    if (thisName !== thatName) {
      return false;
    }
    if (thisValue instanceof RelayVariable) {
      return thisValue.equals(thatValue);
    }
    return areEqual(thisValue, thatValue);
  });
}

function createRootContext(metaRoute, variables) {
  return {
    routeName: metaRoute.name,
    variables: variables
  };
}

RelayProfiler.instrumentMethods(RelayQueryNode.prototype, {
  clone: '@RelayQueryNode.prototype.clone',
  equals: '@RelayQueryNode.prototype.equals',
  getChildren: '@RelayQueryNode.prototype.getChildren',
  getDirectives: '@RelayQueryNode.prototype.getDirectives',
  hasDeferredDescendant: '@RelayQueryNode.prototype.hasDeferredDescendant',
  getFieldByStorageKey: '@RelayQueryNode.prototype.getFieldByStorageKey'
});

RelayProfiler.instrumentMethods(RelayQueryField.prototype, {
  getStorageKey: '@RelayQueryField.prototype.getStorageKey',
  getSerializationKey: '@RelayQueryField.prototype.getSerializationKey'
});

module.exports = {
  Field: RelayQueryField,
  Fragment: RelayQueryFragment,
  Mutation: RelayQueryMutation,
  Node: RelayQueryNode,
  Operation: RelayQueryOperation,
  Root: RelayQueryRoot,
  Subscription: RelayQuerySubscription
};

/***/ }),
/* 4095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RelayRouteFragment
 * 
 */



var _classCallCheck2 = __webpack_require__(344);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Represents a query fragment that is conditional upon the active route as a
 * function that returns either a literal fragment or a fragment reference.
 *
 * Example GraphQL:
 *
 * ```
 * Node {
 *   ${(route) => matchRoute(route, ...)}
 * }
 * ```
 */
var RelayRouteFragment = function () {
  function RelayRouteFragment(builder) {
    (0, _classCallCheck3['default'])(this, RelayRouteFragment);

    this._builder = builder;
  }

  /**
   * Returns the query fragment that matches the given route, if any.
   */


  RelayRouteFragment.prototype.getFragmentForRoute = function getFragmentForRoute(route) {
    return this._builder(route);
  };

  return RelayRouteFragment;
}();

module.exports = RelayRouteFragment;

/***/ }),
/* 4096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RelayVariable
 * 
 */



var _classCallCheck2 = __webpack_require__(344);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var RelayVariable = function () {
  function RelayVariable(name) {
    (0, _classCallCheck3['default'])(this, RelayVariable);

    this.name = name;
  }

  RelayVariable.prototype.equals = function equals(other) {
    return other instanceof RelayVariable && other.getName() === this.name;
  };

  RelayVariable.prototype.getName = function getName() {
    return this.name;
  };

  return RelayVariable;
}();

module.exports = RelayVariable;

/***/ }),
/* 4097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RelayVariables
 * 
 */



var _extends2 = __webpack_require__(514);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var invariant = __webpack_require__(512);

/**
 * Determines the variables that are in scope for a fragment given the variables
 * in scope at the root query as well as any arguments applied at the fragment
 * spread via `@arguments`.
 *
 * Note that this is analagous to determining function arguments given a function call.
 */
function getFragmentVariables(fragment, rootVariables, argumentVariables) {
  var variables = void 0;
  fragment.argumentDefinitions.forEach(function (definition) {
    if (argumentVariables.hasOwnProperty(definition.name)) {
      return;
    }
    variables = variables || (0, _extends3['default'])({}, argumentVariables);
    switch (definition.kind) {
      case 'LocalArgument':
        variables[definition.name] = definition.defaultValue;
        break;
      case 'RootArgument':
        !rootVariables.hasOwnProperty(definition.name) ?  false ? invariant(false, 'RelaySelector: Expected a defined query variable for `$%s` ' + 'in fragment `%s`.', definition.name, fragment.node.name) : invariant(false) : void 0;
        variables[definition.name] = rootVariables[definition.name];
        break;
      default:
         true ?  false ? invariant(false, 'RelaySelector: Unexpected node kind `%s` in fragment `%s`.', definition.kind, fragment.node.name) : invariant(false) : void 0;
    }
  });
  return variables || argumentVariables;
}

/**
 * Determines the variables that are in scope for a given operation given values
 * for some/all of its arguments. Extraneous input variables are filtered from
 * the output, and missing variables are set to default values (if given in the
 * operation's definition).
 */
function getOperationVariables(operation, variables) {
  var operationVariables = {};
  operation.argumentDefinitions.forEach(function (def) {
    var value = def.defaultValue;
    if (variables[def.name] != null) {
      value = variables[def.name];
    }
    operationVariables[def.name] = value;
  });
  return operationVariables;
}

module.exports = {
  getFragmentVariables: getFragmentVariables,
  getOperationVariables: getOperationVariables
};

/***/ }),
/* 4098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule callsFromGraphQL
 * 
 */



var _stringify = __webpack_require__(1977);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var invariant = __webpack_require__(512);

/**
 * @internal
 *
 * Convert from GraphQL call nodes to plain object `{name,value}` calls.
 */
function callsFromGraphQL(concreteCalls, variables) {
  // $FlowIssue: ConcreteCall should flow into CallOrDirective
  var callsOrDirectives = concreteCalls;
  var orderedCalls = [];
  for (var ii = 0; ii < callsOrDirectives.length; ii++) {
    var callOrDirective = callsOrDirectives[ii];
    var _value = callOrDirective.value;

    if (_value != null) {
      if (Array.isArray(_value)) {
        _value = _value.map(function (arg) {
          return getCallValue(arg, variables);
        });
      } else if (_value.kind === 'BatchCallVariable') {
        // Batch calls are handled separately
        _value = null;
      } else {
        _value = getCallValue(_value, variables);
      }
    }
    var _metadata = callOrDirective.metadata,
        _name = callOrDirective.name;

    var orderedCall = { name: _name, value: _value };
    if (_metadata && _metadata.type) {
      orderedCall.type = _metadata.type;
    }
    orderedCalls.push(orderedCall);
  }
  return orderedCalls;
}

function getCallValue(concreteValue, variables) {
  var callValue = void 0;
  if (concreteValue.kind === 'CallValue') {
    callValue = concreteValue.callValue;
  } else {
    var variableName = concreteValue.callVariableName;
    !variables.hasOwnProperty(variableName) ?  false ? invariant(false, 'callsFromGraphQL(): Expected a declared value for variable, `$%s`.', variableName) : invariant(false) : void 0;
    callValue = variables[variableName];
  }
  // Perform a shallow check to ensure the value conforms to `CallValue` type:
  // For performance reasons, skip recursively testing array/object values.
  var valueType = typeof callValue;
  !(callValue == null || valueType === 'boolean' || valueType === 'number' || valueType === 'string' || valueType === 'object') ?  false ? invariant(false, 'callsFromGraphQL(): Expected argument value `%s` to either be null or a ' + 'boolean, number, string, or array/object.', (0, _stringify2['default'])(callValue)) : invariant(false) : void 0;
  return callValue;
}

module.exports = callsFromGraphQL;

/***/ }),
/* 4099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule directivesToGraphQL
 * 
 */



var QueryBuilder = __webpack_require__(1425);

/**
 * @internal
 *
 * Convert plain object `{name, arguments}` directives to GraphQL directive
 * nodes.
 */
function directivesToGraphQL(directives) {
  return directives.map(function (_ref) {
    var directiveName = _ref.name,
        args = _ref.args;

    var concreteArguments = args.map(function (_ref2) {
      var argName = _ref2.name,
          value = _ref2.value;

      var concreteArgument = null;
      if (Array.isArray(value)) {
        concreteArgument = value.map(QueryBuilder.createCallValue);
      } else if (value != null) {
        concreteArgument = QueryBuilder.createCallValue(value);
      }
      return QueryBuilder.createDirectiveArgument(argName, concreteArgument);
    });
    return QueryBuilder.createDirective(directiveName, concreteArguments);
  });
}

module.exports = directivesToGraphQL;

/***/ }),
/* 4100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule forEachRootCallArg
 * 
 */



var invariant = __webpack_require__(512);
var stableStringify = __webpack_require__(2274);

/**
 * @internal
 *
 * Iterates over the identifying arguments in the supplied root call.
 * If the identifying value is null or undefined, the supplied callback will be
 * invoked once.
 */
function forEachRootCallArg(query, callback) {
  !!query.getBatchCall() ?  false ? invariant(false, 'forEachRootCallArg(): Cannot iterate over batch call variables.') : invariant(false) : void 0;
  function each(identifyingArgValue, fn) {
    if (Array.isArray(identifyingArgValue)) {
      identifyingArgValue.forEach(function (value) {
        return each(value, fn);
      });
    } else {
      fn({
        identifyingArgValue: identifyingArgValue,
        identifyingArgKey: identifyingArgValue == null ? null : typeof identifyingArgValue === 'string' ? identifyingArgValue : stableStringify(identifyingArgValue)
      });
    }
  }
  var identifyingArg = query.getIdentifyingArg();
  var identifyingArgValue = identifyingArg && identifyingArg.value || null;
  each(identifyingArgValue, callback);
}

module.exports = forEachRootCallArg;

/***/ }),
/* 4101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule generateRQLFieldAlias
 * 
 */



/* eslint-disable no-bitwise */

var base62 = __webpack_require__(2119);
var crc32 = __webpack_require__(3218);

var PREFIX = '_';

/**
 * @internal
 *
 * Sanitizes a stringified GraphQL field (including any calls and their values)
 * to produce a valid alias.
 *
 * This is used to auto-alias fields in generated queries, so that developers
 * composing multiple components together don't have to worry about collisions
 * between components requesting the same fields. (Explicit aliases are only
 * needed within a single component when it uses the same field multiple times,
 * in order to differentiate these fields in the props).
 */
function generateRQLFieldAlias(input) {
  // Field names with no calls can be used as aliases without encoding
  var index = input.indexOf('.');
  if (index === -1) {
    return input;
  }
  // Unsign crc32 hash so we do not base62 encode a negative number.
  return PREFIX + input.substr(0, index) + base62(crc32(input) >>> 0);
}

module.exports = generateRQLFieldAlias;

/***/ }),
/* 4102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule serializeRelayQueryCall
 * 
 */



var _stringify = __webpack_require__(1977);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var flattenArray = __webpack_require__(3219);

/**
 * @internal
 *
 * Serializes a query "call" (a legacy combination of field and argument value).
 */
function serializeRelayQueryCall(call) {
  var value = call.value;

  var valueString = void 0;
  if (Array.isArray(value)) {
    valueString = flattenArray(value).map(function (value) {
      return serializeCallValue(value);
    }).join(',');
  } else {
    valueString = serializeCallValue(value);
  }
  return '.' + call.name + '(' + valueString + ')';
}

function serializeCallValue(value) {
  if (value == null) {
    return '';
  } else if (typeof value !== 'string') {
    return (0, _stringify2['default'])(value);
  } else {
    return value;
  }
}

module.exports = serializeRelayQueryCall;

/***/ }),
/* 4103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule toGraphQL
 * 
 */



var QueryBuilder = __webpack_require__(1425);
var RelayQuery = __webpack_require__(4094);

var callsToGraphQL = __webpack_require__(2273);
var generateConcreteFragmentID = __webpack_require__(1946);
var invariant = __webpack_require__(512);

/**
 * @internal
 *
 * Converts a RelayQuery.Node into a plain object representation. This is
 * equivalent to the AST produced by `babel-relay-plugin` and is intended for
 * use in serializing RelayQuery nodes.
 *
 * NOTE: This is used by external open source projects.
 */
var toGraphQL = {
  Query: function Query(node) {
    var batchCall = node.getBatchCall();
    var identifyingArgValue = void 0;
    if (batchCall) {
      identifyingArgValue = QueryBuilder.createBatchCallVariable(batchCall.sourceQueryID, batchCall.sourceQueryPath);
    } else {
      var identifyingArg = node.getIdentifyingArg();
      if (identifyingArg) {
        if (Array.isArray(identifyingArg.value)) {
          identifyingArgValue = identifyingArg.value.map(QueryBuilder.createCallValue);
        } else {
          identifyingArgValue = QueryBuilder.createCallValue(identifyingArg.value);
        }
      }
    }

    var children = node.getChildren().map(toGraphQLSelection);
    // Use `QueryBuilder` to generate the correct calls from the
    // identifying argument & metadata.
    return QueryBuilder.createQuery({
      children: children,
      fieldName: node.getFieldName(),
      identifyingArgValue: identifyingArgValue,
      isDeferred: node.isDeferred(),
      metadata: node.getConcreteQueryNode().metadata,
      name: node.getName(),
      type: node.getType()
    });
  },
  Fragment: function (_Fragment) {
    function Fragment(_x) {
      return _Fragment.apply(this, arguments);
    }

    Fragment.toString = function () {
      return _Fragment.toString();
    };

    return Fragment;
  }(function (node) {
    var children = node.getChildren().map(toGraphQLSelection);
    var fragment = {
      children: children,
      id: generateConcreteFragmentID(),
      kind: 'Fragment',
      metadata: {
        isAbstract: node.isAbstract(),
        plural: node.isPlural()
      },
      name: node.getDebugName(),
      type: node.getType()
    };
    return fragment;
  }),
  Field: function (_Field) {
    function Field(_x2) {
      return _Field.apply(this, arguments);
    }

    Field.toString = function () {
      return _Field.toString();
    };

    return Field;
  }(function (node) {
    var calls = callsToGraphQL(node.getCallsWithValues());
    var children = node.getChildren().map(toGraphQLSelection);
    var field = {
      alias: node.getConcreteQueryNode().alias,
      calls: calls,
      children: children,
      fieldName: node.getSchemaName(),
      kind: 'Field',
      metadata: node.getConcreteQueryNode().metadata,
      type: node.getType()
    };
    return field;
  })
};

function toGraphQLSelection(node) {
  if (node instanceof RelayQuery.Fragment) {
    return toGraphQL.Fragment(node);
  } else {
    !(node instanceof RelayQuery.Field) ?  false ? invariant(false, 'toGraphQL: Invalid node.') : invariant(false) : void 0;
    return toGraphQL.Field(node);
  }
}

module.exports = toGraphQL;

/***/ }),
/* 4104 */,
/* 4105 */,
/* 4106 */,
/* 4107 */,
/* 4108 */,
/* 4109 */,
/* 4110 */,
/* 4111 */,
/* 4112 */,
/* 4113 */,
/* 4114 */,
/* 4115 */,
/* 4116 */,
/* 4117 */,
/* 4118 */,
/* 4119 */,
/* 4120 */,
/* 4121 */,
/* 4122 */,
/* 4123 */,
/* 4124 */,
/* 4125 */,
/* 4126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _createEagerFactory = __webpack_require__(667);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var branch = function branch(test, left, right) {
  return function (BaseComponent) {
    return function (_React$Component) {
      _inherits(_class2, _React$Component);

      function _class2(props, context) {
        _classCallCheck(this, _class2);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

        _this.LeftComponent = null;
        _this.RightComponent = null;

        _this.computeChildComponent(_this.props);
        return _this;
      }

      _class2.prototype.computeChildComponent = function computeChildComponent(props) {
        if (test(props)) {
          this.leftFactory = this.leftFactory || (0, _createEagerFactory2.default)(left(BaseComponent));
          this.factory = this.leftFactory;
        } else {
          this.rightFactory = this.rightFactory || (0, _createEagerFactory2.default)(right(BaseComponent));
          this.factory = this.rightFactory;
        }
      };

      _class2.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.computeChildComponent(nextProps);
      };

      _class2.prototype.render = function render() {
        return this.factory(this.props);
      };

      return _class2;
    }(_react2.default.Component);
  };
};

exports.default = (0, _createHelper2.default)(branch, 'branch');

/***/ }),
/* 4127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _omit = __webpack_require__(1952);

var _omit2 = _interopRequireDefault(_omit);

var _createEagerElement = __webpack_require__(2281);

var _createEagerElement2 = _interopRequireDefault(_createEagerElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var componentFromProp = function componentFromProp(propName) {
  var Component = function Component(props) {
    return (0, _createEagerElement2.default)(props[propName], (0, _omit2.default)(props, [propName]));
  };
  Component.displayName = 'componentFromProp(' + propName + ')';
  return Component;
};

exports.default = componentFromProp;

/***/ }),
/* 4128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createEventHandlerWithConfig = undefined;

var _symbolObservable = __webpack_require__(1949);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

var _changeEmitter = __webpack_require__(2061);

var _setObservableConfig = __webpack_require__(1549);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createEventHandlerWithConfig = exports.createEventHandlerWithConfig = function createEventHandlerWithConfig(config) {
  return function () {
    var _config$fromESObserva;

    var emitter = (0, _changeEmitter.createChangeEmitter)();
    var stream = config.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[_symbolObservable2.default] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(_setObservableConfig.config);

exports.default = createEventHandler;

/***/ }),
/* 4129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createSink = function createSink(callback) {
  return function (_Component) {
    _inherits(Sink, _Component);

    function Sink() {
      _classCallCheck(this, Sink);

      return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(_react.Component);
};

exports.default = createSink;

/***/ }),
/* 4130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _createEagerFactory = __webpack_require__(667);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    return DefaultProps;
  };
};

exports.default = (0, _createHelper2.default)(defaultProps, 'defaultProps');

/***/ }),
/* 4131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _createEagerFactory = __webpack_require__(667);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    return GetContext;
  };
};

exports.default = (0, _createHelper2.default)(getContext, 'getContext');

/***/ }),
/* 4132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _createEagerFactory = __webpack_require__(667);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    /* eslint-disable react/prefer-es6-class */
    return (0, _react.createClass)(_extends({}, spec, {
      render: function render() {
        return factory(_extends({}, this.props, this.state));
      }
    }));
    /* eslint-enable react/prefer-es6-class */
  };
};

exports.default = (0, _createHelper2.default)(lifecycle, 'lifecycle');

/***/ }),
/* 4133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.mapPropsStreamWithConfig = undefined;

var _symbolObservable = __webpack_require__(1949);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

var _createEagerFactory = __webpack_require__(667);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _componentFromStream = __webpack_require__(2280);

var _setObservableConfig = __webpack_require__(1549);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var identity = function identity(t) {
  return t;
};
var componentFromStream = (0, _componentFromStream.componentFromStreamWithConfig)({
  fromESObservable: identity,
  toESObservable: identity
});

var mapPropsStreamWithConfig = exports.mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config) {
  return function (transform) {
    return function (BaseComponent) {
      var factory = (0, _createEagerFactory2.default)(BaseComponent);
      var fromESObservable = config.fromESObservable;
      var toESObservable = config.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[_symbolObservable2.default] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = mapPropsStreamWithConfig(_setObservableConfig.config);

exports.default = (0, _createHelper2.default)(mapPropsStream, 'mapPropsStream');

/***/ }),
/* 4134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createEagerFactory = __webpack_require__(667);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(_createEagerFactory2.default);
  var Nest = function Nest(_ref) {
    var props = _objectWithoutProperties(_ref, []);

    var children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    /* eslint-disable global-require */
    var getDisplayName = require('./getDisplayName').default;
    /* eslint-enable global-require */
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

exports.default = nest;

/***/ }),
/* 4135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 4136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _onlyUpdateForKeys = __webpack_require__(2283);

var _onlyUpdateForKeys2 = _interopRequireDefault(_onlyUpdateForKeys);

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    /* eslint-disable global-require */
    var getDisplayName = require('./getDisplayName').default;
    /* eslint-enable global-require */
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = (0, _onlyUpdateForKeys2.default)(propKeys)(BaseComponent);

  return OnlyUpdateForPropTypes;
};

exports.default = (0, _createHelper2.default)(onlyUpdateForPropTypes, 'onlyUpdateForPropTypes', true, true);

/***/ }),
/* 4137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shouldUpdate = __webpack_require__(1951);

var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);

var _shallowEqual = __webpack_require__(1550);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pure = (0, _shouldUpdate2.default)(function (props, nextProps) {
  return !(0, _shallowEqual2.default)(props, nextProps);
});

exports.default = (0, _createHelper2.default)(pure, 'pure', true, true);

/***/ }),
/* 4138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _omit = __webpack_require__(1952);

var _omit2 = _interopRequireDefault(_omit);

var _mapProps = __webpack_require__(1103);

var _mapProps2 = _interopRequireDefault(_mapProps);

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renameProp = function renameProp(oldName, newName) {
  return (0, _mapProps2.default)(function (props) {
    var _extends2;

    return _extends({}, (0, _omit2.default)(props, [oldName]), (_extends2 = {}, _extends2[newName] = props[oldName], _extends2));
  });
};

exports.default = (0, _createHelper2.default)(renameProp, 'renameProp');

/***/ }),
/* 4139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _omit = __webpack_require__(1952);

var _omit2 = _interopRequireDefault(_omit);

var _pick = __webpack_require__(1953);

var _pick2 = _interopRequireDefault(_pick);

var _mapProps = __webpack_require__(1103);

var _mapProps2 = _interopRequireDefault(_mapProps);

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  return (0, _mapProps2.default)(function (props) {
    return _extends({}, (0, _omit2.default)(props, keys(nameMap)), mapKeys((0, _pick2.default)(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
};

exports.default = (0, _createHelper2.default)(renameProps, 'renameProps');

/***/ }),
/* 4140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _createEagerFactory = __webpack_require__(667);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import React from 'react'


var renderComponent = function renderComponent(Component) {
  return function (_) {
    var factory = (0, _createEagerFactory2.default)(Component);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    // const RenderComponent = props => <Component {...props} />
    if (false) {
      /* eslint-disable global-require */
      var wrapDisplayName = require('./wrapDisplayName').default;
      /* eslint-enable global-require */
      RenderComponent.displayName = wrapDisplayName(Component, 'renderComponent');
    }
    return RenderComponent;
  };
};

exports.default = (0, _createHelper2.default)(renderComponent, 'renderComponent', false);

/***/ }),
/* 4141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderNothing = function renderNothing(_) {
  var Nothing = function Nothing() {
    return null;
  };
  Nothing.displayName = 'Nothing';
  return Nothing;
};

exports.default = (0, _createHelper2.default)(renderNothing, 'renderNothing', false, true);

/***/ }),
/* 4142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__(1950);

var _setStatic2 = _interopRequireDefault(_setStatic);

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = (0, _createHelper2.default)(setDisplayName, 'setDisplayName', false);

/***/ }),
/* 4143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__(1950);

var _setStatic2 = _interopRequireDefault(_setStatic);

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setPropTypes = function setPropTypes(propTypes) {
  return (0, _setStatic2.default)('propTypes', propTypes);
};

exports.default = (0, _createHelper2.default)(setPropTypes, 'setPropTypes', false);

/***/ }),
/* 4144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _createEagerFactory = __webpack_require__(667);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);

    var WithContext = function (_Component) {
      _inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        _classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(_react.Component);

    WithContext.childContextTypes = childContextTypes;

    return WithContext;
  };
};

exports.default = (0, _createHelper2.default)(withContext, 'withContext');

/***/ }),
/* 4145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _createEagerFactory = __webpack_require__(667);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapValues = function mapValues(obj, func) {
  var result = [];
  var i = 0;
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      i += 1;
      result[key] = func(obj[key], key, i);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var _class, _temp2, _initialiseProps;

    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    return _temp2 = _class = function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        var _temp, _this, _ret;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
      }

      _class.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      _class.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return _class;
    }(_react.Component), _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error('withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    }, _temp2;
  };
};

exports.default = (0, _createHelper2.default)(withHandlers, 'withHandlers');

/***/ }),
/* 4146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _pick = __webpack_require__(1953);

var _pick2 = _interopRequireDefault(_pick);

var _shallowEqual = __webpack_require__(1550);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _createEagerFactory = __webpack_require__(667);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !(0, _shallowEqual2.default)((0, _pick2.default)(props, shouldMapOrKeys), (0, _pick2.default)(nextProps, shouldMapOrKeys));
    };

    return function (_Component) {
      _inherits(_class2, _Component);

      function _class2() {
        var _temp, _this, _ret;

        _classCallCheck(this, _class2);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
      }

      _class2.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      _class2.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return _class2;
    }(_react.Component);
  };
};

exports.default = (0, _createHelper2.default)(withPropsOnChange, 'withPropsOnChange');

/***/ }),
/* 4147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _createEagerFactory = __webpack_require__(667);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    return function (_Component) {
      _inherits(_class2, _Component);

      function _class2() {
        var _temp, _this, _ret;

        _classCallCheck(this, _class2);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _class2.prototype.render = function render() {
        var _extends2;

        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[dispatchName] = this.dispatch, _extends2)));
      };

      return _class2;
    }(_react.Component);
  };
};

exports.default = (0, _createHelper2.default)(withReducer, 'withReducer');

/***/ }),
/* 4148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _createHelper = __webpack_require__(495);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _createEagerFactory = __webpack_require__(667);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    return function (_Component) {
      _inherits(_class2, _Component);

      function _class2() {
        var _temp, _this, _ret;

        _classCallCheck(this, _class2);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _class2.prototype.render = function render() {
        var _extends2;

        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
      };

      return _class2;
    }(_react.Component);
  };
};

exports.default = (0, _createHelper2.default)(withState, 'withState');

/***/ }),
/* 4149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getDisplayName = __webpack_require__(1947);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),
/* 4150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(2285);
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 4151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 4152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(2286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(2230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(2287);
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerSanity(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  if (false) {
    var unexpectedKeyCache = {};
  }

  var sanityError;
  try {
    assertReducerSanity(finalReducers);
  } catch (e) {
    sanityError = e;
  }

  return function combination() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    var action = arguments[1];

    if (sanityError) {
      throw sanityError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var i = 0; i < finalReducerKeys.length; i++) {
      var key = finalReducerKeys[i];
      var reducer = finalReducers[key];
      var previousStateForKey = state[key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(key, action);
        throw new Error(errorMessage);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 4153 */,
/* 4154 */
/***/ (function(module, exports, __webpack_require__) {

// Load modules

var Stringify = __webpack_require__(4156);
var Parse = __webpack_require__(4155);


// Declare internals

var internals = {};


module.exports = {
    stringify: Stringify,
    parse: Parse
};


/***/ }),
/* 4155 */
/***/ (function(module, exports, __webpack_require__) {

// Load modules

var Utils = __webpack_require__(2288);


// Declare internals

var internals = {
    delimiter: '&',
    depth: 5,
    arrayLimit: 20,
    parameterLimit: 1000,
    strictNullHandling: false,
    plainObjects: false,
    allowPrototypes: false,
    allowDots: false
};


internals.parseValues = function (str, options) {

    var obj = {};
    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);

    for (var i = 0, il = parts.length; i < il; ++i) {
        var part = parts[i];
        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;

        var key, val;
        if (pos === -1) {
            key = Utils.decode(part);
            val = options.strictNullHandling ? null : '';
        } else {
            key = Utils.decode(part.slice(0, pos));
            val = Utils.decode(part.slice(pos + 1));
        }
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};


internals.parseObject = function (chain, val, options) {

    if (!chain.length) {
        return val;
    }

    var root = chain.shift();

    var obj;
    if (root === '[]') {
        obj = [];
        obj = obj.concat(internals.parseObject(chain, val, options));
    }
    else {
        obj = options.plainObjects ? Object.create(null) : {};
        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
        var index = parseInt(cleanRoot, 10);
        var indexString = '' + index;
        if (!isNaN(index) &&
            root !== cleanRoot &&
            indexString === cleanRoot &&
            index >= 0 &&
            (options.parseArrays &&
             index <= options.arrayLimit)) {

            obj = [];
            obj[index] = internals.parseObject(chain, val, options);
        }
        else {
            obj[cleanRoot] = internals.parseObject(chain, val, options);
        }
    }

    return obj;
};


internals.parseKeys = function (key, val, options) {

    if (!key) {
        return;
    }

    // Transform dot notation to bracket notation

    if (options.allowDots) {
        key = key.replace(/\.([^\.\[]+)/g, '[$1]');
    }

    // The regex chunks

    var parent = /^([^\[\]]*)/;
    var child = /(\[[^\[\]]*\])/g;

    // Get the parent

    var segment = parent.exec(key);

    // Stash the parent if it exists

    var keys = [];
    if (segment[1]) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects &&
            Object.prototype.hasOwnProperty(segment[1])) {

            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(segment[1]);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {

        ++i;
        if (!options.plainObjects &&
            Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {

            if (!options.allowPrototypes) {
                continue;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return internals.parseObject(keys, val, options);
};


module.exports = function (str, options) {

    options = options || {};
    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : internals.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : internals.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : internals.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;

    if (str === '' ||
        str === null ||
        typeof str === 'undefined') {

        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0, il = keys.length; i < il; ++i) {
        var key = keys[i];
        var newObj = internals.parseKeys(key, tempObj[key], options);
        obj = Utils.merge(obj, newObj, options);
    }

    return Utils.compact(obj);
};


/***/ }),
/* 4156 */
/***/ (function(module, exports, __webpack_require__) {

// Load modules

var Utils = __webpack_require__(2288);


// Declare internals

var internals = {
    delimiter: '&',
    arrayPrefixGenerators: {
        brackets: function (prefix, key) {

            return prefix + '[]';
        },
        indices: function (prefix, key) {

            return prefix + '[' + key + ']';
        },
        repeat: function (prefix, key) {

            return prefix;
        }
    },
    strictNullHandling: false,
    skipNulls: false,
    encode: true
};


internals.stringify = function (obj, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort) {

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    }
    else if (Utils.isBuffer(obj)) {
        obj = obj.toString();
    }
    else if (obj instanceof Date) {
        obj = obj.toISOString();
    }
    else if (obj === null) {
        if (strictNullHandling) {
            return encode ? Utils.encode(prefix) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' ||
        typeof obj === 'number' ||
        typeof obj === 'boolean') {

        if (encode) {
            return [Utils.encode(prefix) + '=' + Utils.encode(obj)];
        }
        return [prefix + '=' + obj];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0, il = objKeys.length; i < il; ++i) {
        var key = objKeys[i];

        if (skipNulls &&
            obj[key] === null) {

            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, skipNulls, encode, filter));
        }
        else {
            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix, strictNullHandling, skipNulls, encode, filter));
        }
    }

    return values;
};


module.exports = function (obj, options) {

    options = options || {};
    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : internals.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : internals.encode;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    }
    else if (Array.isArray(options.filter)) {
        objKeys = filter = options.filter;
    }

    var keys = [];

    if (typeof obj !== 'object' ||
        obj === null) {

        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in internals.arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    }
    else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    }
    else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0, il = objKeys.length; i < il; ++i) {
        var key = objKeys[i];

        if (skipNulls &&
            obj[key] === null) {

            continue;
        }

        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort));
    }

    return keys.join(delimiter);
};


/***/ }),
/* 4157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var get = __webpack_require__(4158);
var Container = module.exports = function (store) {
    this.store = store || {};
};
var mockDataNotFound = '__mock_data_not_found__';

function result(obj, prop) {
    if (!obj) {
        return
    } else if (typeof obj[prop] === 'function') {
        return obj[prop]();
    }
    return obj[prop];
}

Container.prototype = {
    get: function(key) {
        if (key) {
            return get(this.store, key);
        }
        return Object.assign({}, this.store);
    },

    // buildLayer returns a function suitable for passing to spyOn(fooo, 'bar').and.callFake that defers initially to a fake layer of serverVars on top of the existing serverVars
    //   var getWithMyData = serverVars.buildLayer({thomas: 45});
    //   spyOn(serverVars, 'get').and.callFake(getWithMyData);
    //   expect(serverVars.get('thomas')).toEqual(45);
    // caveat – this will not work:
    //   spyOn(serverVars, 'get').and.callFake(serverVars.buildLayer({thomas: 45}));
    // because the call to buildLayer is invoked after serverVars.get is repalced with the spy.
    buildLayer: function (dataLayer, options) {
        var thisGet = this.get;
        var passthrough;
        options = Object.assign({
            passthrough: false
        }, options);
        return function (key) {
            var mockValue;
            mockValue = get(dataLayer, key, mockDataNotFound);
            if (mockDataNotFound !== mockValue) {
                return mockValue;
            }
            if (!options.passthrough) {
                return;
            }
            if ("function" === typeof options.passthrough) {
                passthrough = options.passthrough;
            } else {
                passthrough = thisGet;
            }
            return passthrough.apply(this, arguments);
        }.bind(this);
    },
    // installs a fake get method on server vars if serverVars.get.isSpy is falsy
    // proxies the spy through to this.get._spyTarget
    // sets this.get_spyTarget to new fake getter with buildLayer that passes through to the prior version of this.get._spyTarget
    // This method is useful for building up layers of fake data for serverVars.get in jasmine specs
    jasmineFakeGet: function (dataLayer, options) {
        options = Object.assign({
            passthrough: this.get._spyTarget || result(options, 'passthrough')
        }, options);
        var thisSV = this;
        if (undefined === global.spyOn) {
            console.error('jasmineFakeGet requires jasmine globals');
        }
        if (!this.get.isSpy) {
            spyOn(this, 'get').and.callFake(function () {
                return thisSV.get._spyTarget.apply(this, arguments);
            });
            thisSV.get.isSpy = true;
        }
        this.get._spyTarget = this.buildLayer(dataLayer, options);
        return this;
    },
    getInjector: function () {
        return '<script type="text/javascript">' +
            'window.__SERVER_VARS__ = ' +
                // safely embed JSON within HTML
                // see http://stackoverflow.com/a/4180424/266795
            JSON.stringify(this.get())
                .replace(/</g, '\\u003c')
                .replace(/-->/g, '--\\>')
                .replace(/\u2028/g, '\\u2028')
                .replace(/\u2029/g, '\\u2029') +
            ';</script>';
    }
};
Container.prototype.inject = Container.prototype.getInjector; // for use inside of twig templates: https://github.com/1stdibs/serverVars/pull/2#issuecomment-140472031

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 4158 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 4159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(4160);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(70)(module)))

/***/ }),
/* 4160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 4161 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 4162 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 4163 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = __webpack_require__.i({"NODE_ENV":'production'}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(4162);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(4161);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(47)))

/***/ }),
/* 4164 */,
/* 4165 */,
/* 4166 */,
/* 4167 */,
/* 4168 */,
/* 4169 */,
/* 4170 */,
/* 4171 */,
/* 4172 */,
/* 4173 */,
/* 4174 */,
/* 4175 */,
/* 4176 */,
/* 4177 */,
/* 4178 */,
/* 4179 */,
/* 4180 */,
/* 4181 */,
/* 4182 */,
/* 4183 */,
/* 4184 */,
/* 4185 */,
/* 4186 */,
/* 4187 */,
/* 4188 */,
/* 4189 */,
/* 4190 */,
/* 4191 */,
/* 4192 */,
/* 4193 */,
/* 4194 */,
/* 4195 */,
/* 4196 */,
/* 4197 */,
/* 4198 */,
/* 4199 */,
/* 4200 */,
/* 4201 */,
/* 4202 */,
/* 4203 */,
/* 4204 */,
/* 4205 */,
/* 4206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 4207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(127);

/***/ }),
/* 4208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(131);

/***/ }),
/* 4209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(151);

/***/ }),
/* 4210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(153);

/***/ }),
/* 4211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(154);

/***/ }),
/* 4212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(171);

/***/ }),
/* 4213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(172);

/***/ }),
/* 4214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(22);

/***/ }),
/* 4215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(227);

/***/ }),
/* 4216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(229);

/***/ }),
/* 4217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(230);

/***/ }),
/* 4218 */,
/* 4219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(241);

/***/ }),
/* 4220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(25);

/***/ }),
/* 4221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(27);

/***/ }),
/* 4222 */,
/* 4223 */,
/* 4224 */,
/* 4225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(332);

/***/ }),
/* 4226 */,
/* 4227 */,
/* 4228 */,
/* 4229 */,
/* 4230 */,
/* 4231 */,
/* 4232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(357);

/***/ }),
/* 4233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(358);

/***/ }),
/* 4234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(359);

/***/ }),
/* 4235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(360);

/***/ }),
/* 4236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(362);

/***/ }),
/* 4237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(363);

/***/ }),
/* 4238 */,
/* 4239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(44);

/***/ }),
/* 4240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(519);

/***/ }),
/* 4241 */,
/* 4242 */,
/* 4243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(620);

/***/ }),
/* 4244 */,
/* 4245 */,
/* 4246 */,
/* 4247 */,
/* 4248 */,
/* 4249 */,
/* 4250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(77);

/***/ }),
/* 4251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(45))(83);

/***/ }),
/* 4252 */
/***/ (function(module, exports) {

module.exports = dibs_buyer_layout;

/***/ }),
/* 4253 */
/***/ (function(module, exports) {

module.exports = window;

/***/ }),
/* 4254 */,
/* 4255 */,
/* 4256 */,
/* 4257 */,
/* 4258 */,
/* 4259 */,
/* 4260 */,
/* 4261 */,
/* 4262 */,
/* 4263 */,
/* 4264 */,
/* 4265 */,
/* 4266 */,
/* 4267 */,
/* 4268 */,
/* 4269 */,
/* 4270 */,
/* 4271 */,
/* 4272 */,
/* 4273 */,
/* 4274 */,
/* 4275 */,
/* 4276 */,
/* 4277 */,
/* 4278 */,
/* 4279 */,
/* 4280 */,
/* 4281 */,
/* 4282 */,
/* 4283 */,
/* 4284 */,
/* 4285 */,
/* 4286 */,
/* 4287 */,
/* 4288 */,
/* 4289 */,
/* 4290 */,
/* 4291 */,
/* 4292 */,
/* 4293 */,
/* 4294 */,
/* 4295 */,
/* 4296 */,
/* 4297 */,
/* 4298 */,
/* 4299 */,
/* 4300 */,
/* 4301 */,
/* 4302 */,
/* 4303 */,
/* 4304 */,
/* 4305 */,
/* 4306 */,
/* 4307 */,
/* 4308 */,
/* 4309 */,
/* 4310 */,
/* 4311 */,
/* 4312 */,
/* 4313 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(748);
__webpack_require__(1983);
__webpack_require__(2329);
__webpack_require__(2328);
__webpack_require__(15);
__webpack_require__(1980);
__webpack_require__(2326);
__webpack_require__(2445);
__webpack_require__(28);
__webpack_require__(2370);
module.exports = __webpack_require__(984);


/***/ }),
/* 4314 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 4315 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// chunks/foot.4947583f36e5fa564960.js